import "./style.css";
import * as React from "react";
import React__default, { useState, useRef, useEffect, Fragment, createContext, useReducer, useContext, Children, Component } from "react";
import { createPortal } from "react-dom";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f2 = React__default, k3 = Symbol.for("react.element"), l4 = Symbol.for("react.fragment"), m3 = Object.prototype.hasOwnProperty, n4 = f2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p2 = { key: true, ref: true, __self: true, __source: true };
  function q2(c4, a2, g2) {
    var b5, d3 = {}, e5 = null, h2 = null;
    void 0 !== g2 && (e5 = "" + g2);
    void 0 !== a2.key && (e5 = "" + a2.key);
    void 0 !== a2.ref && (h2 = a2.ref);
    for (b5 in a2) m3.call(a2, b5) && !p2.hasOwnProperty(b5) && (d3[b5] = a2[b5]);
    if (c4 && c4.defaultProps) for (b5 in a2 = c4.defaultProps, a2) void 0 === d3[b5] && (d3[b5] = a2[b5]);
    return { $$typeof: k3, type: c4, key: e5, ref: h2, props: d3, _owner: n4.current };
  }
  reactJsxRuntime_production_min.Fragment = l4;
  reactJsxRuntime_production_min.jsx = q2;
  reactJsxRuntime_production_min.jsxs = q2;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React2 = React__default;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x2) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x2) {
              var match = x2.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }
          return "\n" + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn2, construct2) {
        if (!fn2 || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn2);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct2) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x2) {
                control = x2;
              }
              Reflect.construct(fn2, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x2) {
                control = x2;
              }
              fn2.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x2) {
              control = x2;
            }
            fn2();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s2 = sampleLines.length - 1;
            var c4 = controlLines.length - 1;
            while (s2 >= 1 && c4 >= 0 && sampleLines[s2] !== controlLines[c4]) {
              c4--;
            }
            for (; s2 >= 1 && c4 >= 0; s2--, c4--) {
              if (sampleLines[s2] !== controlLines[c4]) {
                if (s2 !== 1 || c4 !== 1) {
                  do {
                    s2--;
                    c4--;
                    if (c4 < 0 || sampleLines[s2] !== controlLines[c4]) {
                      var _frame = "\n" + sampleLines[s2].replace(" at new ", " at ");
                      if (fn2.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn2.displayName);
                      }
                      {
                        if (typeof fn2 === "function") {
                          componentFrameCache.set(fn2, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s2 >= 1 && c4 >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn2 ? fn2.displayName || fn2.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn2 === "function") {
            componentFrameCache.set(fn2, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn2, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn2, false);
        }
      }
      function shouldConstruct(Component2) {
        var prototype = Component2.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x2) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty2 = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values2, location, componentName, element) {
        {
          var has2 = Function.call.bind(hasOwnProperty2);
          for (var typeSpecName in typeSpecs) {
            if (has2(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray2(a2) {
        return isArrayImpl(a2);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e5) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }
      function hasValidRef(config) {
        {
          if (hasOwnProperty2.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty2.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self2) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self2 && ReactCurrentOwner.current.stateNode !== self2) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self2, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self2
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config, maybeKey, source, self2) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self2);
          }
          for (propName in config) {
            if (hasOwnProperty2.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray2(node)) {
            for (var i5 = 0; i5 < node.length; i5++) {
              var child = node[i5];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes2;
          if (typeof type === "function") {
            propTypes2 = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes2 = type.propTypes;
          } else {
            return;
          }
          if (propTypes2) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes2, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys2 = Object.keys(fragment.props);
          for (var i5 = 0; i5 < keys2.length; i5++) {
            var key = keys2[i5];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      var didWarnAboutKeySpread = {};
      function jsxWithValidation(type, props, key, isStaticChildren, source, self2) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray2(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self2);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray2(children)) {
                  for (var i5 = 0; i5 < children.length; i5++) {
                    validateChildKeys(children[i5], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          {
            if (hasOwnProperty2.call(props, "key")) {
              var componentName = getComponentNameFromType(type);
              var keys2 = Object.keys(props).filter(function(k3) {
                return k3 !== "key";
              });
              var beforeExample = keys2.length > 0 ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
              if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys2.length > 0 ? "{" + keys2.join(": ..., ") + ": ...}" : "{}";
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx = jsxWithValidationDynamic;
      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
var classnames$1 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module2) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = "";
      for (var i5 = 0; i5 < arguments.length; i5++) {
        var arg = arguments[i5];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === "string" || typeof arg === "number") {
        return arg;
      }
      if (typeof arg !== "object") {
        return "";
      }
      if (Array.isArray(arg)) {
        return classNames.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
        return arg.toString();
      }
      var classes = "";
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + " " + newClass;
      }
      return value + newClass;
    }
    if (module2.exports) {
      classNames.default = classNames;
      module2.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames$1);
var classnamesExports = classnames$1.exports;
const classnames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
const Button = ({
  handleClick,
  disabled,
  primary,
  secondary,
  tertiary,
  children,
  className,
  slim,
  id
}) => {
  const buttonClassName = classnames(
    className,
    {
      "primary": primary
    },
    {
      "secondary": secondary
    },
    {
      "tertiary": tertiary
    },
    {
      "slim": slim
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "button",
    {
      className: `ii-button ${buttonClassName}`,
      onClick: handleClick,
      disabled,
      id,
      children
    }
  );
};
const Button$1 = Button;
const ChevronDown = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "chevron-down" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M17.85,8.9a.48.48,0,0,0-.7,0L12,14,6.85,8.9a.49.49,0,0,0-.7.7l5.5,5.5a.48.48,0,0,0,.7,0l5.5-5.5A.48.48,0,0,0,17.85,8.9Z" })
    ]
  }
);
const Accordion = ({
  children,
  title,
  showCaret,
  alwaysOpen,
  addDivider
}) => {
  const [expanded, toggleExpand] = useState(alwaysOpen || false);
  const caretClassname = classnames(
    "accordion-chevron",
    { "chevron-open": expanded }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "accordion-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        handleClick: children && !alwaysOpen ? () => toggleExpand(!expanded) : null,
        className: "accordion-button",
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "accordion-title", children: [
          title,
          showCaret && /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronDown, { className: caretClassname })
        ] })
      }
    ),
    expanded && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "children-expanded", children }),
    addDivider && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "divider" })
  ] });
};
const Accordion$1 = Accordion;
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b5 = "function" === typeof Symbol && Symbol.for, c4 = b5 ? Symbol.for("react.element") : 60103, d3 = b5 ? Symbol.for("react.portal") : 60106, e5 = b5 ? Symbol.for("react.fragment") : 60107, f2 = b5 ? Symbol.for("react.strict_mode") : 60108, g2 = b5 ? Symbol.for("react.profiler") : 60114, h2 = b5 ? Symbol.for("react.provider") : 60109, k3 = b5 ? Symbol.for("react.context") : 60110, l4 = b5 ? Symbol.for("react.async_mode") : 60111, m3 = b5 ? Symbol.for("react.concurrent_mode") : 60111, n4 = b5 ? Symbol.for("react.forward_ref") : 60112, p2 = b5 ? Symbol.for("react.suspense") : 60113, q2 = b5 ? Symbol.for("react.suspense_list") : 60120, r3 = b5 ? Symbol.for("react.memo") : 60115, t3 = b5 ? Symbol.for("react.lazy") : 60116, v3 = b5 ? Symbol.for("react.block") : 60121, w2 = b5 ? Symbol.for("react.fundamental") : 60117, x2 = b5 ? Symbol.for("react.responder") : 60118, y2 = b5 ? Symbol.for("react.scope") : 60119;
  function z2(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u2 = a2.$$typeof;
      switch (u2) {
        case c4:
          switch (a2 = a2.type, a2) {
            case l4:
            case m3:
            case e5:
            case g2:
            case f2:
            case p2:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k3:
                case n4:
                case t3:
                case r3:
                case h2:
                  return a2;
                default:
                  return u2;
              }
          }
        case d3:
          return u2;
      }
    }
  }
  function A3(a2) {
    return z2(a2) === m3;
  }
  reactIs_production_min.AsyncMode = l4;
  reactIs_production_min.ConcurrentMode = m3;
  reactIs_production_min.ContextConsumer = k3;
  reactIs_production_min.ContextProvider = h2;
  reactIs_production_min.Element = c4;
  reactIs_production_min.ForwardRef = n4;
  reactIs_production_min.Fragment = e5;
  reactIs_production_min.Lazy = t3;
  reactIs_production_min.Memo = r3;
  reactIs_production_min.Portal = d3;
  reactIs_production_min.Profiler = g2;
  reactIs_production_min.StrictMode = f2;
  reactIs_production_min.Suspense = p2;
  reactIs_production_min.isAsyncMode = function(a2) {
    return A3(a2) || z2(a2) === l4;
  };
  reactIs_production_min.isConcurrentMode = A3;
  reactIs_production_min.isContextConsumer = function(a2) {
    return z2(a2) === k3;
  };
  reactIs_production_min.isContextProvider = function(a2) {
    return z2(a2) === h2;
  };
  reactIs_production_min.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c4;
  };
  reactIs_production_min.isForwardRef = function(a2) {
    return z2(a2) === n4;
  };
  reactIs_production_min.isFragment = function(a2) {
    return z2(a2) === e5;
  };
  reactIs_production_min.isLazy = function(a2) {
    return z2(a2) === t3;
  };
  reactIs_production_min.isMemo = function(a2) {
    return z2(a2) === r3;
  };
  reactIs_production_min.isPortal = function(a2) {
    return z2(a2) === d3;
  };
  reactIs_production_min.isProfiler = function(a2) {
    return z2(a2) === g2;
  };
  reactIs_production_min.isStrictMode = function(a2) {
    return z2(a2) === f2;
  };
  reactIs_production_min.isSuspense = function(a2) {
    return z2(a2) === p2;
  };
  reactIs_production_min.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e5 || a2 === m3 || a2 === g2 || a2 === f2 || a2 === p2 || a2 === q2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t3 || a2.$$typeof === r3 || a2.$$typeof === h2 || a2.$$typeof === k3 || a2.$$typeof === n4 || a2.$$typeof === w2 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v3);
  };
  reactIs_production_min.typeOf = z2;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i5 = 0; i5 < 10; i5++) {
        test2["_" + String.fromCharCode(i5)] = i5;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n4) {
        return test2[n4];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to2 = toObject(target);
    var symbols;
    for (var s2 = 1; s2 < arguments.length; s2++) {
      from = Object(arguments[s2]);
      for (var key in from) {
        if (hasOwnProperty2.call(from, key)) {
          to2[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i5 = 0; i5 < symbols.length; i5++) {
          if (propIsEnumerable.call(from, symbols[i5])) {
            to2[symbols[i5]] = from[symbols[i5]];
          }
        }
      }
    }
    return to2;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text2) {
      var message = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x2) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values2, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text2) {
      var message = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x2) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is2(x2, y2) {
      if (x2 === y2) {
        return x2 !== 0 || 1 / x2 === 1 / y2;
      } else {
        return x2 !== x2 && y2 !== y2;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i5 = 0; i5 < propValue.length; i5++) {
          var error = typeChecker(propValue, i5, componentName, location, propFullName + "[" + i5 + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i5 = 0; i5 < expectedValues.length; i5++) {
          if (is2(propValue, expectedValues[i5])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i5 = 0; i5 < arrayOfTypeCheckers.length; i5++) {
        var checker = arrayOfTypeCheckers[i5];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i5 + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i6 = 0; i6 < arrayOfTypeCheckers.length; i6++) {
          var checker2 = arrayOfTypeCheckers[i6];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol2(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol2(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const ze$1 = /* @__PURE__ */ new Set(["children", "localName", "ref", "style", "className"]), re$3 = /* @__PURE__ */ new WeakMap(), se$2 = (t3, e5, n4, r3, s2) => {
  const o2 = s2 == null ? void 0 : s2[e5];
  o2 === void 0 ? (t3[e5] = n4, n4 == null && e5 in HTMLElement.prototype && t3.removeAttribute(e5)) : n4 !== r3 && ((i5, a2, c4) => {
    let l4 = re$3.get(i5);
    l4 === void 0 && re$3.set(i5, l4 = /* @__PURE__ */ new Map());
    let d3 = l4.get(a2);
    c4 !== void 0 ? d3 === void 0 ? (l4.set(a2, d3 = { handleEvent: c4 }), i5.addEventListener(a2, d3)) : d3.handleEvent = c4 : d3 !== void 0 && (l4.delete(a2), i5.removeEventListener(a2, d3));
  })(t3, o2, n4);
}, Dt$3 = ({ react: t3, tagName: e5, elementClass: n4, events: r3, displayName: s2 }) => {
  const o2 = new Set(Object.keys(r3 != null ? r3 : {})), i5 = t3.forwardRef((a2, c4) => {
    const l4 = t3.useRef(/* @__PURE__ */ new Map()), d3 = t3.useRef(null), p2 = {}, f2 = {};
    for (const [u2, m3] of Object.entries(a2)) ze$1.has(u2) ? p2[u2 === "className" ? "class" : u2] = m3 : o2.has(u2) || u2 in n4.prototype ? f2[u2] = m3 : p2[u2] = m3;
    return t3.useLayoutEffect(() => {
      if (d3.current === null) return;
      const u2 = /* @__PURE__ */ new Map();
      for (const m3 in f2) se$2(d3.current, m3, a2[m3], l4.current.get(m3), r3), l4.current.delete(m3), u2.set(m3, a2[m3]);
      for (const [m3, Ve2] of l4.current) se$2(d3.current, m3, void 0, Ve2, r3);
      l4.current = u2;
    }), t3.useLayoutEffect(() => {
      var u2;
      (u2 = d3.current) == null || u2.removeAttribute("defer-hydration");
    }, []), p2.suppressHydrationWarning = true, t3.createElement(e5, { ...p2, ref: t3.useCallback((u2) => {
      d3.current = u2, typeof c4 == "function" ? c4(u2) : c4 !== null && (c4.current = u2);
    }, [c4]) });
  });
  return i5.displayName = s2 != null ? s2 : n4.name, i5;
};
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const V$3 = globalThis, X$1 = V$3.ShadowRoot && (V$3.ShadyCSS === void 0 || V$3.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, J$2 = Symbol(), ie$4 = /* @__PURE__ */ new WeakMap();
let Ce$2 = class Ce {
  constructor(e5, n4, r3) {
    if (this._$cssResult$ = true, r3 !== J$2) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = e5, this.t = n4;
  }
  get styleSheet() {
    let e5 = this.o;
    const n4 = this.t;
    if (X$1 && e5 === void 0) {
      const r3 = n4 !== void 0 && n4.length === 1;
      r3 && (e5 = ie$4.get(n4)), e5 === void 0 && ((this.o = e5 = new CSSStyleSheet()).replaceSync(this.cssText), r3 && ie$4.set(n4, e5));
    }
    return e5;
  }
  toString() {
    return this.cssText;
  }
};
const Ke$2 = (t3) => new Ce$2(typeof t3 == "string" ? t3 : t3 + "", void 0, J$2), T$7 = (t3, ...e5) => {
  const n4 = t3.length === 1 ? t3[0] : e5.reduce((r3, s2, o2) => r3 + ((i5) => {
    if (i5._$cssResult$ === true) return i5.cssText;
    if (typeof i5 == "number") return i5;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + i5 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(s2) + t3[o2 + 1], t3[0]);
  return new Ce$2(n4, t3, J$2);
}, We = (t3, e5) => {
  if (X$1) t3.adoptedStyleSheets = e5.map((n4) => n4 instanceof CSSStyleSheet ? n4 : n4.styleSheet);
  else for (const n4 of e5) {
    const r3 = document.createElement("style"), s2 = V$3.litNonce;
    s2 !== void 0 && r3.setAttribute("nonce", s2), r3.textContent = n4.cssText, t3.appendChild(r3);
  }
}, oe$3 = X$1 ? (t3) => t3 : (t3) => t3 instanceof CSSStyleSheet ? ((e5) => {
  let n4 = "";
  for (const r3 of e5.cssRules) n4 += r3.cssText;
  return Ke$2(n4);
})(t3) : t3;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: Ge$3, defineProperty: qe$2, getOwnPropertyDescriptor: Fe$3, getOwnPropertyNames: Ye$2, getOwnPropertySymbols: Ze$2, getPrototypeOf: Xe$2 } = Object, D$4 = globalThis, ae$2 = D$4.trustedTypes, Je$2 = ae$2 ? ae$2.emptyScript : "", ce$1 = D$4.reactiveElementPolyfillSupport, M$7 = (t3, e5) => t3, K$2 = { toAttribute(t3, e5) {
  switch (e5) {
    case Boolean:
      t3 = t3 ? Je$2 : null;
      break;
    case Object:
    case Array:
      t3 = t3 == null ? t3 : JSON.stringify(t3);
  }
  return t3;
}, fromAttribute(t3, e5) {
  let n4 = t3;
  switch (e5) {
    case Boolean:
      n4 = t3 !== null;
      break;
    case Number:
      n4 = t3 === null ? null : Number(t3);
      break;
    case Object:
    case Array:
      try {
        n4 = JSON.parse(t3);
      } catch {
        n4 = null;
      }
  }
  return n4;
} }, Q$2 = (t3, e5) => !Ge$3(t3, e5), le$2 = { attribute: true, type: String, converter: K$2, reflect: false, hasChanged: Q$2 };
Symbol.metadata != null || (Symbol.metadata = Symbol("metadata")), D$4.litPropertyMetadata != null || (D$4.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
let j$6 = class j extends HTMLElement {
  static addInitializer(e5) {
    var n4;
    this._$Ei(), ((n4 = this.l) != null ? n4 : this.l = []).push(e5);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(e5, n4 = le$2) {
    if (n4.state && (n4.attribute = false), this._$Ei(), this.elementProperties.set(e5, n4), !n4.noAccessor) {
      const r3 = Symbol(), s2 = this.getPropertyDescriptor(e5, r3, n4);
      s2 !== void 0 && qe$2(this.prototype, e5, s2);
    }
  }
  static getPropertyDescriptor(e5, n4, r3) {
    var s2;
    const { get: o2, set: i5 } = (s2 = Fe$3(this.prototype, e5)) != null ? s2 : { get() {
      return this[n4];
    }, set(a2) {
      this[n4] = a2;
    } };
    return { get() {
      return o2 == null ? void 0 : o2.call(this);
    }, set(a2) {
      const c4 = o2 == null ? void 0 : o2.call(this);
      i5.call(this, a2), this.requestUpdate(e5, c4, r3);
    }, configurable: true, enumerable: true };
  }
  static getPropertyOptions(e5) {
    var n4;
    return (n4 = this.elementProperties.get(e5)) != null ? n4 : le$2;
  }
  static _$Ei() {
    if (this.hasOwnProperty(M$7("elementProperties"))) return;
    const e5 = Xe$2(this);
    e5.finalize(), e5.l !== void 0 && (this.l = [...e5.l]), this.elementProperties = new Map(e5.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(M$7("finalized"))) return;
    if (this.finalized = true, this._$Ei(), this.hasOwnProperty(M$7("properties"))) {
      const n4 = this.properties, r3 = [...Ye$2(n4), ...Ze$2(n4)];
      for (const s2 of r3) this.createProperty(s2, n4[s2]);
    }
    const e5 = this[Symbol.metadata];
    if (e5 !== null) {
      const n4 = litPropertyMetadata.get(e5);
      if (n4 !== void 0) for (const [r3, s2] of n4) this.elementProperties.set(r3, s2);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [n4, r3] of this.elementProperties) {
      const s2 = this._$Eu(n4, r3);
      s2 !== void 0 && this._$Eh.set(s2, n4);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(e5) {
    const n4 = [];
    if (Array.isArray(e5)) {
      const r3 = new Set(e5.flat(1 / 0).reverse());
      for (const s2 of r3) n4.unshift(oe$3(s2));
    } else e5 !== void 0 && n4.push(oe$3(e5));
    return n4;
  }
  static _$Eu(e5, n4) {
    const r3 = n4.attribute;
    return r3 === false ? void 0 : typeof r3 == "string" ? r3 : typeof e5 == "string" ? e5.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = false, this.hasUpdated = false, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var e5;
    this._$ES = new Promise((n4) => this.enableUpdating = n4), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (e5 = this.constructor.l) == null || e5.forEach((n4) => n4(this));
  }
  addController(e5) {
    var n4, r3;
    ((n4 = this._$EO) != null ? n4 : this._$EO = /* @__PURE__ */ new Set()).add(e5), this.renderRoot !== void 0 && this.isConnected && ((r3 = e5.hostConnected) == null || r3.call(e5));
  }
  removeController(e5) {
    var n4;
    (n4 = this._$EO) == null || n4.delete(e5);
  }
  _$E_() {
    const e5 = /* @__PURE__ */ new Map(), n4 = this.constructor.elementProperties;
    for (const r3 of n4.keys()) this.hasOwnProperty(r3) && (e5.set(r3, this[r3]), delete this[r3]);
    e5.size > 0 && (this._$Ep = e5);
  }
  createRenderRoot() {
    var e5;
    const n4 = (e5 = this.shadowRoot) != null ? e5 : this.attachShadow(this.constructor.shadowRootOptions);
    return We(n4, this.constructor.elementStyles), n4;
  }
  connectedCallback() {
    var e5;
    this.renderRoot != null || (this.renderRoot = this.createRenderRoot()), this.enableUpdating(true), (e5 = this._$EO) == null || e5.forEach((n4) => {
      var r3;
      return (r3 = n4.hostConnected) == null ? void 0 : r3.call(n4);
    });
  }
  enableUpdating(e5) {
  }
  disconnectedCallback() {
    var e5;
    (e5 = this._$EO) == null || e5.forEach((n4) => {
      var r3;
      return (r3 = n4.hostDisconnected) == null ? void 0 : r3.call(n4);
    });
  }
  attributeChangedCallback(e5, n4, r3) {
    this._$AK(e5, r3);
  }
  _$EC(e5, n4) {
    var r3;
    const s2 = this.constructor.elementProperties.get(e5), o2 = this.constructor._$Eu(e5, s2);
    if (o2 !== void 0 && s2.reflect === true) {
      const i5 = (((r3 = s2.converter) == null ? void 0 : r3.toAttribute) !== void 0 ? s2.converter : K$2).toAttribute(n4, s2.type);
      this._$Em = e5, i5 == null ? this.removeAttribute(o2) : this.setAttribute(o2, i5), this._$Em = null;
    }
  }
  _$AK(e5, n4) {
    var r3;
    const s2 = this.constructor, o2 = s2._$Eh.get(e5);
    if (o2 !== void 0 && this._$Em !== o2) {
      const i5 = s2.getPropertyOptions(o2), a2 = typeof i5.converter == "function" ? { fromAttribute: i5.converter } : ((r3 = i5.converter) == null ? void 0 : r3.fromAttribute) !== void 0 ? i5.converter : K$2;
      this._$Em = o2, this[o2] = a2.fromAttribute(n4, i5.type), this._$Em = null;
    }
  }
  requestUpdate(e5, n4, r3) {
    var s2;
    if (e5 !== void 0) {
      if (r3 != null || (r3 = this.constructor.getPropertyOptions(e5)), !((s2 = r3.hasChanged) != null ? s2 : Q$2)(this[e5], n4)) return;
      this.P(e5, n4, r3);
    }
    this.isUpdatePending === false && (this._$ES = this._$ET());
  }
  P(e5, n4, r3) {
    var s2;
    this._$AL.has(e5) || this._$AL.set(e5, n4), r3.reflect === true && this._$Em !== e5 && ((s2 = this._$Ej) != null ? s2 : this._$Ej = /* @__PURE__ */ new Set()).add(e5);
  }
  async _$ET() {
    this.isUpdatePending = true;
    try {
      await this._$ES;
    } catch (n4) {
      Promise.reject(n4);
    }
    const e5 = this.scheduleUpdate();
    return e5 != null && await e5, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var e5;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot != null || (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [o2, i5] of this._$Ep) this[o2] = i5;
        this._$Ep = void 0;
      }
      const s2 = this.constructor.elementProperties;
      if (s2.size > 0) for (const [o2, i5] of s2) i5.wrapped !== true || this._$AL.has(o2) || this[o2] === void 0 || this.P(o2, this[o2], i5);
    }
    let n4 = false;
    const r3 = this._$AL;
    try {
      n4 = this.shouldUpdate(r3), n4 ? (this.willUpdate(r3), (e5 = this._$EO) == null || e5.forEach((s2) => {
        var o2;
        return (o2 = s2.hostUpdate) == null ? void 0 : o2.call(s2);
      }), this.update(r3)) : this._$EU();
    } catch (s2) {
      throw n4 = false, this._$EU(), s2;
    }
    n4 && this._$AE(r3);
  }
  willUpdate(e5) {
  }
  _$AE(e5) {
    var n4;
    (n4 = this._$EO) == null || n4.forEach((r3) => {
      var s2;
      return (s2 = r3.hostUpdated) == null ? void 0 : s2.call(r3);
    }), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(e5)), this.updated(e5);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = false;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(e5) {
    return true;
  }
  update(e5) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((n4) => this._$EC(n4, this[n4]))), this._$EU();
  }
  updated(e5) {
  }
  firstUpdated(e5) {
  }
};
var de$3;
j$6.elementStyles = [], j$6.shadowRootOptions = { mode: "open" }, j$6[M$7("elementProperties")] = /* @__PURE__ */ new Map(), j$6[M$7("finalized")] = /* @__PURE__ */ new Map(), ce$1 == null || ce$1({ ReactiveElement: j$6 }), ((de$3 = D$4.reactiveElementVersions) != null ? de$3 : D$4.reactiveElementVersions = []).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const W$2 = globalThis, G$4 = W$2.trustedTypes, pe$2 = G$4 ? G$4.createPolicy("lit-html", { createHTML: (t3) => t3 }) : void 0, ee$4 = "$lit$", $$6 = `lit$${Math.random().toFixed(9).slice(2)}$`, te$3 = "?" + $$6, Qe$2 = `<${te$3}>`, S$b = document, I$6 = () => S$b.createComment(""), H$2 = (t3) => t3 === null || typeof t3 != "object" && typeof t3 != "function", ne$3 = Array.isArray, je$3 = (t3) => ne$3(t3) || typeof (t3 == null ? void 0 : t3[Symbol.iterator]) == "function", F$4 = `[ 	
\f\r]`, R$2 = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, ue$4 = /-->/g, he$3 = />/g, x$9 = RegExp(`>|${F$4}(?:([^\\s"'>=/]+)(${F$4}*=${F$4}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), me$2 = /'/g, fe = /"/g, Oe$1 = /^(?:script|style|textarea|title)$/i, et$1 = (t3) => (e5, ...n4) => ({ _$litType$: t3, strings: e5, values: n4 }), tt$1 = et$1(1), N$8 = Symbol.for("lit-noChange"), h$c = Symbol.for("lit-nothing"), be$3 = /* @__PURE__ */ new WeakMap(), w$7 = S$b.createTreeWalker(S$b, 129);
function Pe$2(t3, e5) {
  if (!ne$3(t3) || !t3.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return pe$2 !== void 0 ? pe$2.createHTML(e5) : e5;
}
const De$2 = (t3, e5) => {
  const n4 = t3.length - 1, r3 = [];
  let s2, o2 = e5 === 2 ? "<svg>" : e5 === 3 ? "<math>" : "", i5 = R$2;
  for (let a2 = 0; a2 < n4; a2++) {
    const c4 = t3[a2];
    let l4, d3, p2 = -1, f2 = 0;
    for (; f2 < c4.length && (i5.lastIndex = f2, d3 = i5.exec(c4), d3 !== null); ) f2 = i5.lastIndex, i5 === R$2 ? d3[1] === "!--" ? i5 = ue$4 : d3[1] !== void 0 ? i5 = he$3 : d3[2] !== void 0 ? (Oe$1.test(d3[2]) && (s2 = RegExp("</" + d3[2], "g")), i5 = x$9) : d3[3] !== void 0 && (i5 = x$9) : i5 === x$9 ? d3[0] === ">" ? (i5 = s2 != null ? s2 : R$2, p2 = -1) : d3[1] === void 0 ? p2 = -2 : (p2 = i5.lastIndex - d3[2].length, l4 = d3[1], i5 = d3[3] === void 0 ? x$9 : d3[3] === '"' ? fe : me$2) : i5 === fe || i5 === me$2 ? i5 = x$9 : i5 === ue$4 || i5 === he$3 ? i5 = R$2 : (i5 = x$9, s2 = void 0);
    const u2 = i5 === x$9 && t3[a2 + 1].startsWith("/>") ? " " : "";
    o2 += i5 === R$2 ? c4 + Qe$2 : p2 >= 0 ? (r3.push(l4), c4.slice(0, p2) + ee$4 + c4.slice(p2) + $$6 + u2) : c4 + $$6 + (p2 === -2 ? a2 : u2);
  }
  return [Pe$2(t3, o2 + (t3[n4] || "<?>") + (e5 === 2 ? "</svg>" : e5 === 3 ? "</math>" : "")), r3];
};
let Z$1 = class Ne {
  constructor({ strings: e5, _$litType$: n4 }, r3) {
    let s2;
    this.parts = [];
    let o2 = 0, i5 = 0;
    const a2 = e5.length - 1, c4 = this.parts, [l4, d3] = De$2(e5, n4);
    if (this.el = Ne.createElement(l4, r3), w$7.currentNode = this.el.content, n4 === 2 || n4 === 3) {
      const p2 = this.el.content.firstChild;
      p2.replaceWith(...p2.childNodes);
    }
    for (; (s2 = w$7.nextNode()) !== null && c4.length < a2; ) {
      if (s2.nodeType === 1) {
        if (s2.hasAttributes()) for (const p2 of s2.getAttributeNames()) if (p2.endsWith(ee$4)) {
          const f2 = d3[i5++], u2 = s2.getAttribute(p2).split($$6), m3 = /([.?@])?(.*)/.exec(f2);
          c4.push({ type: 1, index: o2, name: m3[2], strings: u2, ctor: m3[1] === "." ? Le$2 : m3[1] === "?" ? Ue$2 : m3[1] === "@" ? ke$3 : B$6 }), s2.removeAttribute(p2);
        } else p2.startsWith($$6) && (c4.push({ type: 6, index: o2 }), s2.removeAttribute(p2));
        if (Oe$1.test(s2.tagName)) {
          const p2 = s2.textContent.split($$6), f2 = p2.length - 1;
          if (f2 > 0) {
            s2.textContent = G$4 ? G$4.emptyScript : "";
            for (let u2 = 0; u2 < f2; u2++) s2.append(p2[u2], I$6()), w$7.nextNode(), c4.push({ type: 2, index: ++o2 });
            s2.append(p2[f2], I$6());
          }
        }
      } else if (s2.nodeType === 8) if (s2.data === te$3) c4.push({ type: 2, index: o2 });
      else {
        let p2 = -1;
        for (; (p2 = s2.data.indexOf($$6, p2 + 1)) !== -1; ) c4.push({ type: 7, index: o2 }), p2 += $$6.length - 1;
      }
      o2++;
    }
  }
  static createElement(e5, n4) {
    const r3 = S$b.createElement("template");
    return r3.innerHTML = e5, r3;
  }
};
function C$9(t3, e5, n4 = t3, r3) {
  var s2, o2, i5;
  if (e5 === N$8) return e5;
  let a2 = r3 !== void 0 ? (s2 = n4._$Co) == null ? void 0 : s2[r3] : n4._$Cl;
  const c4 = H$2(e5) ? void 0 : e5._$litDirective$;
  return (a2 == null ? void 0 : a2.constructor) !== c4 && ((o2 = a2 == null ? void 0 : a2._$AO) == null || o2.call(a2, false), c4 === void 0 ? a2 = void 0 : (a2 = new c4(t3), a2._$AT(t3, n4, r3)), r3 !== void 0 ? ((i5 = n4._$Co) != null ? i5 : n4._$Co = [])[r3] = a2 : n4._$Cl = a2), a2 !== void 0 && (e5 = C$9(t3, a2._$AS(t3, e5.values), a2, r3)), e5;
}
let Te$2 = class Te {
  constructor(e5, n4) {
    this._$AV = [], this._$AN = void 0, this._$AD = e5, this._$AM = n4;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(e5) {
    var n4;
    const { el: { content: r3 }, parts: s2 } = this._$AD, o2 = ((n4 = e5 == null ? void 0 : e5.creationScope) != null ? n4 : S$b).importNode(r3, true);
    w$7.currentNode = o2;
    let i5 = w$7.nextNode(), a2 = 0, c4 = 0, l4 = s2[0];
    for (; l4 !== void 0; ) {
      if (a2 === l4.index) {
        let d3;
        l4.type === 2 ? d3 = new q$3(i5, i5.nextSibling, this, e5) : l4.type === 1 ? d3 = new l4.ctor(i5, l4.name, l4.strings, this, e5) : l4.type === 6 && (d3 = new Me(i5, this, e5)), this._$AV.push(d3), l4 = s2[++c4];
      }
      a2 !== (l4 == null ? void 0 : l4.index) && (i5 = w$7.nextNode(), a2++);
    }
    return w$7.currentNode = S$b, o2;
  }
  p(e5) {
    let n4 = 0;
    for (const r3 of this._$AV) r3 !== void 0 && (r3.strings !== void 0 ? (r3._$AI(e5, r3, n4), n4 += r3.strings.length - 2) : r3._$AI(e5[n4])), n4++;
  }
};
let q$3 = class Re {
  get _$AU() {
    var e5, n4;
    return (n4 = (e5 = this._$AM) == null ? void 0 : e5._$AU) != null ? n4 : this._$Cv;
  }
  constructor(e5, n4, r3, s2) {
    var o2;
    this.type = 2, this._$AH = h$c, this._$AN = void 0, this._$AA = e5, this._$AB = n4, this._$AM = r3, this.options = s2, this._$Cv = (o2 = s2 == null ? void 0 : s2.isConnected) != null ? o2 : true;
  }
  get parentNode() {
    let e5 = this._$AA.parentNode;
    const n4 = this._$AM;
    return n4 !== void 0 && (e5 == null ? void 0 : e5.nodeType) === 11 && (e5 = n4.parentNode), e5;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(e5, n4 = this) {
    e5 = C$9(this, e5, n4), H$2(e5) ? e5 === h$c || e5 == null || e5 === "" ? (this._$AH !== h$c && this._$AR(), this._$AH = h$c) : e5 !== this._$AH && e5 !== N$8 && this._(e5) : e5._$litType$ !== void 0 ? this.$(e5) : e5.nodeType !== void 0 ? this.T(e5) : je$3(e5) ? this.k(e5) : this._(e5);
  }
  O(e5) {
    return this._$AA.parentNode.insertBefore(e5, this._$AB);
  }
  T(e5) {
    this._$AH !== e5 && (this._$AR(), this._$AH = this.O(e5));
  }
  _(e5) {
    this._$AH !== h$c && H$2(this._$AH) ? this._$AA.nextSibling.data = e5 : this.T(S$b.createTextNode(e5)), this._$AH = e5;
  }
  $(e5) {
    var n4;
    const { values: r3, _$litType$: s2 } = e5, o2 = typeof s2 == "number" ? this._$AC(e5) : (s2.el === void 0 && (s2.el = Z$1.createElement(Pe$2(s2.h, s2.h[0]), this.options)), s2);
    if (((n4 = this._$AH) == null ? void 0 : n4._$AD) === o2) this._$AH.p(r3);
    else {
      const i5 = new Te$2(o2, this), a2 = i5.u(this.options);
      i5.p(r3), this.T(a2), this._$AH = i5;
    }
  }
  _$AC(e5) {
    let n4 = be$3.get(e5.strings);
    return n4 === void 0 && be$3.set(e5.strings, n4 = new Z$1(e5)), n4;
  }
  k(e5) {
    ne$3(this._$AH) || (this._$AH = [], this._$AR());
    const n4 = this._$AH;
    let r3, s2 = 0;
    for (const o2 of e5) s2 === n4.length ? n4.push(r3 = new Re(this.O(I$6()), this.O(I$6()), this, this.options)) : r3 = n4[s2], r3._$AI(o2), s2++;
    s2 < n4.length && (this._$AR(r3 && r3._$AB.nextSibling, s2), n4.length = s2);
  }
  _$AR(e5 = this._$AA.nextSibling, n4) {
    var r3;
    for ((r3 = this._$AP) == null ? void 0 : r3.call(this, false, true, n4); e5 && e5 !== this._$AB; ) {
      const s2 = e5.nextSibling;
      e5.remove(), e5 = s2;
    }
  }
  setConnected(e5) {
    var n4;
    this._$AM === void 0 && (this._$Cv = e5, (n4 = this._$AP) == null || n4.call(this, e5));
  }
}, B$6 = class B {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(e5, n4, r3, s2, o2) {
    this.type = 1, this._$AH = h$c, this._$AN = void 0, this.element = e5, this.name = n4, this._$AM = s2, this.options = o2, r3.length > 2 || r3[0] !== "" || r3[1] !== "" ? (this._$AH = Array(r3.length - 1).fill(new String()), this.strings = r3) : this._$AH = h$c;
  }
  _$AI(e5, n4 = this, r3, s2) {
    const o2 = this.strings;
    let i5 = false;
    if (o2 === void 0) e5 = C$9(this, e5, n4, 0), i5 = !H$2(e5) || e5 !== this._$AH && e5 !== N$8, i5 && (this._$AH = e5);
    else {
      const a2 = e5;
      let c4, l4;
      for (e5 = o2[0], c4 = 0; c4 < o2.length - 1; c4++) l4 = C$9(this, a2[r3 + c4], n4, c4), l4 === N$8 && (l4 = this._$AH[c4]), i5 || (i5 = !H$2(l4) || l4 !== this._$AH[c4]), l4 === h$c ? e5 = h$c : e5 !== h$c && (e5 += (l4 != null ? l4 : "") + o2[c4 + 1]), this._$AH[c4] = l4;
    }
    i5 && !s2 && this.j(e5);
  }
  j(e5) {
    e5 === h$c ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e5 != null ? e5 : "");
  }
};
let Le$2 = class Le extends B$6 {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(e5) {
    this.element[this.name] = e5 === h$c ? void 0 : e5;
  }
};
let Ue$2 = class Ue extends B$6 {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(e5) {
    this.element.toggleAttribute(this.name, !!e5 && e5 !== h$c);
  }
};
let ke$3 = class ke extends B$6 {
  constructor(e5, n4, r3, s2, o2) {
    super(e5, n4, r3, s2, o2), this.type = 5;
  }
  _$AI(e5, n4 = this) {
    var r3;
    if ((e5 = (r3 = C$9(this, e5, n4, 0)) != null ? r3 : h$c) === N$8) return;
    const s2 = this._$AH, o2 = e5 === h$c && s2 !== h$c || e5.capture !== s2.capture || e5.once !== s2.once || e5.passive !== s2.passive, i5 = e5 !== h$c && (s2 === h$c || o2);
    o2 && this.element.removeEventListener(this.name, this, s2), i5 && this.element.addEventListener(this.name, this, e5), this._$AH = e5;
  }
  handleEvent(e5) {
    var n4, r3;
    typeof this._$AH == "function" ? this._$AH.call((r3 = (n4 = this.options) == null ? void 0 : n4.host) != null ? r3 : this.element, e5) : this._$AH.handleEvent(e5);
  }
};
class Me {
  constructor(e5, n4, r3) {
    this.element = e5, this.type = 6, this._$AN = void 0, this._$AM = n4, this.options = r3;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(e5) {
    C$9(this, e5);
  }
}
const Lt$2 = { M: ee$4, P: $$6, A: te$3, C: 1, L: De$2, R: Te$2, D: je$3, V: C$9, I: q$3, H: B$6, N: Ue$2, U: ke$3, B: Le$2, F: Me }, _e$2 = W$2.litHtmlPolyfillSupport;
var ge$1;
_e$2 == null || _e$2(Z$1, q$3), ((ge$1 = W$2.litHtmlVersions) != null ? ge$1 : W$2.litHtmlVersions = []).push("3.2.1");
const nt$1 = (t3, e5, n4) => {
  var r3, s2;
  const o2 = (r3 = n4 == null ? void 0 : n4.renderBefore) != null ? r3 : e5;
  let i5 = o2._$litPart$;
  if (i5 === void 0) {
    const a2 = (s2 = n4 == null ? void 0 : n4.renderBefore) != null ? s2 : null;
    o2._$litPart$ = i5 = new q$3(e5.insertBefore(I$6(), a2), a2, void 0, n4 != null ? n4 : {});
  }
  return i5._$AI(t3), i5;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let O$4 = class O extends j$6 {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var e5;
    const n4 = super.createRenderRoot();
    return (e5 = this.renderOptions).renderBefore != null || (e5.renderBefore = n4.firstChild), n4;
  }
  update(e5) {
    const n4 = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e5), this._$Do = nt$1(n4, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var e5;
    super.connectedCallback(), (e5 = this._$Do) == null || e5.setConnected(true);
  }
  disconnectedCallback() {
    var e5;
    super.disconnectedCallback(), (e5 = this._$Do) == null || e5.setConnected(false);
  }
  render() {
    return N$8;
  }
};
var $e$1;
O$4._$litElement$ = true, O$4.finalized = true, ($e$1 = globalThis.litElementHydrateSupport) == null || $e$1.call(globalThis, { LitElement: O$4 });
const ye$3 = globalThis.litElementPolyfillSupport;
ye$3 == null || ye$3({ LitElement: O$4 });
var ve$2;
((ve$2 = globalThis.litElementVersions) != null ? ve$2 : globalThis.litElementVersions = []).push("4.1.1");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const rt = { attribute: true, type: String, converter: K$2, reflect: false, hasChanged: Q$2 }, st = (t3 = rt, e5, n4) => {
  const { kind: r3, metadata: s2 } = n4;
  let o2 = globalThis.litPropertyMetadata.get(s2);
  if (o2 === void 0 && globalThis.litPropertyMetadata.set(s2, o2 = /* @__PURE__ */ new Map()), o2.set(n4.name, t3), r3 === "accessor") {
    const { name: i5 } = n4;
    return { set(a2) {
      const c4 = e5.get.call(this);
      e5.set.call(this, a2), this.requestUpdate(i5, c4, t3);
    }, init(a2) {
      return a2 !== void 0 && this.P(i5, void 0, t3), a2;
    } };
  }
  if (r3 === "setter") {
    const { name: i5 } = n4;
    return function(a2) {
      const c4 = this[i5];
      e5.call(this, a2), this.requestUpdate(i5, c4, t3);
    };
  }
  throw Error("Unsupported decorator location: " + r3);
};
function v$c(t3) {
  return (e5, n4) => typeof n4 == "object" ? st(t3, e5, n4) : ((r3, s2, o2) => {
    const i5 = s2.hasOwnProperty(o2);
    return s2.constructor.createProperty(o2, i5 ? { ...r3, wrapped: true } : r3), i5 ? Object.getOwnPropertyDescriptor(s2, o2) : void 0;
  })(t3, e5, n4);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function it(t3) {
  return v$c({ ...t3, state: true, attribute: false });
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ie$3 = Symbol.for(""), ot$1 = (t3) => {
  if ((t3 == null ? void 0 : t3.r) === Ie$3) return t3 == null ? void 0 : t3._$litStatic$;
}, at = (t3) => ({ _$litStatic$: t3, r: Ie$3 }), Ee$1 = /* @__PURE__ */ new Map(), ct = (t3) => (e5, ...n4) => {
  const r3 = n4.length;
  let s2, o2;
  const i5 = [], a2 = [];
  let c4, l4 = 0, d3 = false;
  for (; l4 < r3; ) {
    for (c4 = e5[l4]; l4 < r3 && (o2 = n4[l4], (s2 = ot$1(o2)) !== void 0); ) c4 += s2 + e5[++l4], d3 = true;
    l4 !== r3 && a2.push(o2), i5.push(c4), l4++;
  }
  if (l4 === r3 && i5.push(e5[r3]), d3) {
    const p2 = i5.join("$$lit$$");
    (e5 = Ee$1.get(p2)) === void 0 && (i5.raw = i5, Ee$1.set(p2, e5 = i5)), n4 = a2;
  }
  return t3(e5, ...n4);
}, kt$1 = ct(tt$1);
var z$3 = /* @__PURE__ */ ((t3) => (t3.NO_SYNC = "no-sync", t3))(z$3 || {}), P$6 = /* @__PURE__ */ ((t3) => (t3.VISIBLE = "visible", t3.IDLE = "idle", t3.INTERACTION = "interaction", t3.MEDIA = "media", t3.DEFINED = "defined", t3))(P$6 || {}), g$a = /* @__PURE__ */ ((t3) => (t3.BLUR = "beacon-event-blur", t3.CHANGE = "beacon-event-change", t3.CLICK = "beacon-event-click", t3.FOCUS = "beacon-event-focus", t3.HIDE = "beacon-event-hide", t3.INPUT = "beacon-event-input", t3.KEYDOWN = "beacon-event-keydown", t3.MOUSEDOWN = "beacon-event-mousedown", t3.MOUSEENTER = "beacon-event-mouseenter", t3.MOUSELEAVE = "beacon-event-mouseleave", t3.RENDER = "beacon-event-render", t3.SORT = "beacon-event-sort", t3.DEFERRED_CHILD = "beacon-event-deferred-child", t3.RENDER_ACTION_ZONE = "beacon-event-render-action-zone", t3.RENDER_TABLE_CARDS = "beacon-event-render-table-cards", t3.LANGUAGE_SELECT = "beacon-event-language-select", t3.CLOSE = "beacon-event-close", t3.OPEN = "beacon-event-open", t3.NAV_LANGUAGE_SELECT = "beacon-event-language-selected", t3.CLOSE_ACTIVE_NAV_ITEM = "beacon-event-close-active-nav-item", t3.ELEMENT_READY = "beacon-event-element-ready", t3.ACTIVE_NAV_ITEM = "beacon-event-active-nav-item-change", t3.DRILLDOWN = "beacon-event-drilldown", t3.DRILLUP = "beacon-event-drillup", t3.HEADER_ZONE_CLICK = "beacon-event-navigation-header-zone-click", t3.COUNTRY_SELECTOR_CLOSE = "beacon-event-country-selector-close", t3.COUNTRY_SELECTOR_OPEN = "beacon-event-country-selector-open", t3.COUNTRY_FLAG_CHANGE = "beacon-event-country-flag-change", t3.HAS_CURRENT_LINK = "beacon-event-has-current-link", t3.REGISTER = "beacon-event-register", t3.SKIP_LINK_CLICK = "beacon-event-skip-link-click", t3.METRICS_SECTION_CHANGE = "beacon-event-metrics-section-change", t3.METRICS_LOCATION_CHANGE = "beacon-event-metrics-location-change", t3.METRICS_ID_CHANGE = "beacon-event-metrics-id-change", t3.NAVIGATION_LINK_CLICK = "beacon-event-navigation-link-click", t3.DISMISS = "beacon-event-dismiss", t3.TOGGLE = "beacon-event-toggle", t3.CONTROL_SET = "beacon-event-control-set", t3.PAGINATE = "beacon-event-paginate", t3.VIDEO_BRIGHTCOVE_READY = "beacon-event-video-brightcove-ready", t3))(g$a || {}), lt$1 = /* @__PURE__ */ ((t3) => (t3.CLOSE = "close", t3.KEYDOWN = "keydown", t3.SCROLL = "scroll", t3.CLICK = "click", t3.FOCUSOUT = "focusout", t3))(lt$1 || {});
const dt = T$7`[beacon-tag-name]:not([focus-override]) *:focus-visible:not(.beacon-control__field,.skip-focus-override,a:not([focus-override])){box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;position:relative;z-index:1}[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}`, pt = T$7`:host(:not([focus-override],.skip-focus-override)) *:not(.skip-focus-override,a:not([focus-override])):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;position:relative;z-index:1}:host(:not([focus-override],.skip-focus-override)) a:not([focus-override]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:not([focus-override],.skip-focus-override)) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}`, ut$1 = T$7`:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-small);--motion-translate-intro-micro: 3rem}@media (width >= 640px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-medium);--motion-translate-intro-micro: 4rem}}@media (width >= 960px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-large);--motion-translate-intro-micro: 5rem}}@media (width >= 1280px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-x-large);--motion-translate-intro-micro: 6rem}}@media (width >= 1600px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-xx-large);--motion-translate-intro-micro: 8rem}}@media (width >= 1920px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-xxx-large);--motion-translate-intro-micro: 9rem}}`, ht = T$7`[beacon-tag-name]:where([reset-spacing]) *{margin:0;padding:0}`, mt$2 = T$7`:host{border:initial;box-sizing:border-box;display:block;font-size:initial;font-style:initial;font-variant:initial;font-weight:initial;line-height:initial;white-space:initial;word-break:break-word;word-spacing:initial;text-align:initial;text-indent:initial;text-transform:initial}:host *,:host *:before,:host *:after{box-sizing:inherit}input,button,textarea,select{font:inherit;letter-spacing:inherit}button{color:inherit;cursor:pointer}ul,ol{list-style-position:initial;list-style-type:revert}::slotted(:is(ul,ol)[role=list]){list-style:none;padding:0}table{caption-side:initial;empty-cells:initial;border-collapse:initial;border-spacing:initial}`, ft$1 = T$7`.has-cell-padding,.has-component-padding{padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-3)}:host{color:var(--beacon-system-color-text-standard);font-family:var(--beacon-system-font-family-body);-webkit-font-smoothing:antialiased;font-weight:var(--beacon-system-font-weight-light)}a,::slotted(a){color:var(--beacon-system-color-text-link)}a:not(:is(:hover,:focus)){text-decoration:none}:host(:not([motion-state=enabled])),:host(:not([motion-state=enabled])) :is(*,*:before,*:after),:host(:not([motion-state=enabled])) ::slotted(*:not([motion-state=enabled])){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}@media (prefers-reduced-motion: reduce){:host([motion-state=enabled]),:host([motion-state=enabled]) :is(*,*:before,*:after),:host([motion-state]),:host([motion-state]) :is(*,*:before,*:after){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}}`;
var k$b = /* @__PURE__ */ ((t3) => (t3.CLICKABLE = "data-metrics-clickable", t3.TYPE = "data-metrics-type", t3.TEXT = "data-metrics-link-text", t3.LOCATION = "data-metrics-location", t3))(k$b || {});
const A$7 = class A {
};
A$7.setPropertyOnEvent = (t3, e5, n4, r3) => {
  try {
    Object.defineProperty(t3, n4, {
      value: r3 || e5[`${n4}`],
      writable: false
    });
  } catch (s2) {
    console.warn(s2);
  }
}, A$7.getAnalyticsEvents = () => {
  const t3 = ["gesture", "click", "touch", "change"];
  return Object.keys(window).filter((e5) => /^on/.test(e5) && new RegExp(t3.join("|")).test(e5) && e5 !== "onscrollsnapchange");
}, A$7.setHostEventHandlerForAnalytics = (t3, e5) => {
  var n4;
  const r3 = A$7.getAnalyticsEvents(), s2 = "beaconVersion";
  for (const o2 of r3) {
    const i5 = o2.slice(2);
    (n4 = t3.shadowRoot) == null || n4.addEventListener(
      i5,
      (a2) => {
        var c4;
        const l4 = new a2.constructor(
          i5,
          a2
        );
        A$7.setPropertyOnEvent(
          l4,
          null,
          s2,
          e5
        );
        for (const d3 in a2)
          d3 !== "isTrusted" && A$7.setPropertyOnEvent(l4, a2, d3);
        (c4 = t3.shadowRoot) != null && c4.contains(a2.target) && t3.dispatchEvent(l4);
      },
      true
    );
  }
};
let bt$1 = A$7;
function It$1(t3, e5) {
  !t3 || !e5 || t3 instanceof SVGElement && (t3.setAttribute(k$b.CLICKABLE, "true"), t3.setAttribute(k$b.TYPE, "BTN"), t3.getAttribute(k$b.TEXT) || t3.setAttribute(k$b.TEXT, e5));
}
function Ht$3(t3) {
  return !!t3.updateAnalytics;
}
function L$6(t3, e5, n4, r3) {
  const s2 = new CustomEvent(e5, {
    bubbles: true,
    cancelable: false,
    composed: true,
    detail: {},
    ...n4
  });
  return t3.dispatchEvent(s2), r3 && r3(), s2;
}
const xe$3 = (t3) => !!t3.deferrable, _t$3 = (t3) => {
  var e5, n4;
  return (!!((e5 = t3.deferList) != null && e5.includes(P$6.VISIBLE)) || !!((n4 = t3.getAttribute("defer-until")) != null && n4.includes(P$6.VISIBLE))) && t3.isDeferUntilParent;
}, Ae$2 = (t3) => !!navigator.vendor && navigator.vendor.indexOf(t3) > -1;
function gt$3(t3) {
  return `${t3}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(
    new RegExp(/\s+(.)(\w*)/, "g"),
    (e5, n4, r3) => `${n4.toUpperCase() + r3}`
  ).replace(new RegExp(/\w/), (e5) => e5.toUpperCase());
}
const $t$3 = "4.2.2", yt = {
  rootMargin: "1500px",
  threshold: 0
}, _$5 = {
  version: $t$3,
  hidden: "hidden",
  safari: "Apple",
  divTagName: "div",
  deprecatedPropertyKeys: ["alternateAttributes", "sync", "alternateSlot"],
  defaultDeferOptions: yt
}, Y$3 = (t3) => {
  for (const e5 of t3)
    if (e5 !== void 0) return e5;
};
var He$2 = (t3) => {
  throw TypeError(t3);
}, Be$2 = (t3, e5, n4) => e5.has(t3) || He$2("Cannot " + n4), vt$2 = (t3, e5, n4) => (Be$2(t3, e5, "read from private field"), e5.get(t3)), Et$2 = (t3, e5, n4) => e5.has(t3) ? He$2("Cannot add the same private member more than once") : e5 instanceof WeakSet ? e5.add(t3) : e5.set(t3, n4), we$2 = (t3, e5, n4, r3) => (Be$2(t3, e5, "write to private field"), e5.set(t3, n4), n4), xt$1 = Object.defineProperty, E$9 = (t3, e5, n4, r3) => {
  for (var s2 = void 0, o2 = t3.length - 1, i5; o2 >= 0; o2--)
    (i5 = t3[o2]) && (s2 = i5(e5, n4, s2) || s2);
  return s2 && xt$1(e5, n4, s2), s2;
}, U$1, b$e;
const y$9 = (b$e = class extends O$4 {
  constructor() {
    super(...arguments), Et$2(this, U$1), we$2(this, U$1, false), this.isDeferUntilParent = false, this.deferrable = true, this.focusOverride = false, this.resetSpacing = false, this.beaconTagName = "", this.version = _$5.version, this.motionState = "disabled", this.prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches, this.alternateSlots = /* @__PURE__ */ new Map(), this.onslotchange = (t3) => {
      const { target: e5 } = t3, n4 = e5.name;
      this.slotDeprecationWarn(n4);
    }, this.resolvedDeferOptions = {
      root: document,
      rootMargin: _$5.defaultDeferOptions.rootMargin,
      threshold: _$5.defaultDeferOptions.threshold
    }, this.deferUntilVisible = () => new Promise((t3) => {
      if (!("IntersectionObserver" in window))
        t3();
      else {
        const e5 = new IntersectionObserver((n4) => {
          const [r3] = n4;
          r3.isIntersecting && (e5.disconnect(), t3());
        }, this.getResolvedDeferOptions() || null);
        e5.observe(this);
      }
    }), this.deferUntilIdle = () => {
      const t3 = new Promise((e5) => {
        document.readyState !== "complete" ? window.addEventListener("load", () => e5(), { once: true }) : e5();
      });
      return "requestIdleCallback" in window ? Promise.all([
        new Promise((e5) => {
          requestIdleCallback(() => {
            e5();
          });
        }),
        t3
      ]) : t3;
    }, this.deferredChildEventHandler = (t3) => new Promise((e5) => {
      var n4;
      t3 instanceof CustomEvent && (n4 = t3.detail) != null && n4.type ? (this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(t3.detail.type).then(() => e5())) : e5();
    }), this.renderStyles = (t3, e5) => {
      const n4 = [], r3 = new Set(
        this.constructor[t3].flat(1 / 0)
      );
      for (const s2 of r3)
        n4.push(s2);
      n4.reverse().forEach((s2, o2) => {
        var i5;
        const a2 = document.createElement("style");
        a2.setAttribute("slot", "lightDOM");
        let c4 = false;
        if (a2.textContent = s2.toString(), e5) {
          const l4 = Math.abs(o2 - n4.length), d3 = `${e5}-${l4}`, p2 = this.getClosestHost();
          a2.id = d3, (p2 && (i5 = p2 == null ? void 0 : p2.shadowRoot) != null && i5.querySelector(`#${d3}`) || !p2 && document.querySelector(`#${d3}`)) && (c4 = true);
        }
        c4 || this.prepend(a2);
      });
    }, this.renderComponentModeStyles = (t3 = `${this.beaconTagName}-mode-styles`) => {
      var e5;
      (e5 = this.componentModeStyles) == null || e5.forEach((n4, r3) => {
        const s2 = document.createElement("style");
        s2.textContent = n4.toString();
        const o2 = `${t3}-${r3}`;
        s2.id = o2, !document.querySelector(`#${o2}`) && document.head.append(s2);
      });
    }, this.getScopedTag = (t3) => {
      if (!t3) return null;
      const e5 = this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${t3}` : t3;
      return at(e5);
    };
  }
  /**
   * Extends Lit's definition of `observedAttributes`.
   *
   * Returns a list of attributes corresponding to the registered properties.
   * @nocollapse
   * @category attributes
   */
  static get observedAttributes() {
    const t3 = [];
    return this.hasDeprecatedProperties && this.alternateAttributesMap.forEach((e5, n4) => {
      this.elementProperties.has(e5) && t3.push(n4);
    }), t3.push(...super.observedAttributes), t3;
  }
  /**
   * Extends Lit's default attributeChangedCallback to support deprecated properties.
   *
   * @param name Attribute name
   * @param _old Old value
   * @param value New value
   */
  attributeChangedCallback(t3, e5, n4) {
    const {
      alternateAttributesMap: r3,
      hasDeprecatedProperties: s2,
      elementProperties: o2
    } = this.constructor;
    if (s2 && r3.size > 0) {
      const i5 = r3.get(t3), a2 = this.getPropertyOptions(t3).alternateSlot;
      if (i5) {
        const c4 = o2.get(i5);
        if (i5 !== z$3.NO_SYNC && (n4 === null ? this.removeAttribute(
          (c4 == null ? void 0 : c4.attribute) || i5
        ) : this.setAttribute(
          (c4 == null ? void 0 : c4.attribute) || i5,
          n4 || ""
        )), a2) {
          const l4 = this.createPropertyDeprecationForSlotMessage(t3, a2);
          console.warn(l4);
        } else
          console.warn(
            this.createPropertyDeprecationMessage(
              t3,
              i5,
              c4 == null ? void 0 : c4.attribute
            )
          );
      }
    }
    super.attributeChangedCallback(t3, e5, n4);
  }
  /**
   * Generates a console message to log when deprecated properties were used.
   *
   * @param name attribute that triggered the message
   * @param prop property that the attribute aligns to
   * @param attribute correct attribute to use
   */
  createPropertyDeprecationMessage(t3, e5, n4) {
    let r3 = `Beacon Warning: [${t3}] will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release.`;
    return e5 !== z$3.NO_SYNC && (r3 += ` Start using [${n4 || e5}] instead to avoid future disruptions.`), r3;
  }
  /**
   * Generates a console message to log when a deprecated property is used
   * and should instead use the designated slot
   * @param property the name of the property being deprecated
   * @param slot the designated slot to use instead
   */
  createPropertyDeprecationForSlotMessage(t3, e5) {
    return `Beacon Warning: '${t3}' will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release. Start using the slot: '${e5}' instead to avoid future disruptions`;
  }
  /**
   * Extend's Lit's `createProperty` method for our own uses.
   * @param name Property Name
   * @param options Options for the property
   */
  static createProperty(t3, e5) {
    if (e5) {
      const { alternateAttributes: n4, attribute: r3 } = e5, s2 = Object.prototype.hasOwnProperty.call(
        e5,
        "sync"
      );
      if (_$5.deprecatedPropertyKeys.forEach((o2) => {
        Object.prototype.hasOwnProperty.call(e5, o2) && (this.hasDeprecatedProperties = true);
      }), n4 && n4.forEach((o2) => {
        this.alternateAttributesMap.set(o2, t3);
      }), s2 && !e5.sync) {
        const o2 = r3 != null ? r3 : t3;
        this.alternateAttributesMap.set(
          o2,
          z$3.NO_SYNC
        );
      }
    }
    super.createProperty(t3, e5);
  }
  /**
   * This is used to return the property options of a property when given only its attribute name,
   * e.g. the property pageTitle with an attribute name of 'page-title' will have no way of accessing its options
   * directly when attempting to grab the options with 'page-title' and elementProperties.get().
   * @param name the resolved attribute name of a `@property()` decorated property
   * @returns the options passed in `@property()` e.g. `{attribute: 'attribute-name', reflect: true}`
   */
  getPropertyOptions(t3) {
    var e5;
    const { elementProperties: n4 } = this.constructor;
    return (e5 = n4.get(t3)) != null ? e5 : [...n4.values()].find(
      (r3) => r3.attribute === t3
    );
  }
  /**
   * Getter that returns private resolvedDeferOptions
   * @returns resolvedDeferOptions that are passed to an IntersectionObserver
   */
  getResolvedDeferOptions() {
    return this.resolvedDeferOptions;
  }
  /** callback method for the beacon-on-click event*/
  onBeaconClick() {
  }
  /** callback method for the beacon-on-keydown event*/
  onBeaconKeydown() {
  }
  /** callback method for the beacon-on-toggle event*/
  onBeaconToggle() {
  }
  /**
   * Converts space separated list prop of `defer-until` to a DeferUntil enum array
   */
  get deferList() {
    var t3, e5;
    return (e5 = (t3 = this.deferUntil) == null ? void 0 : t3.split(" ").map((n4) => n4).filter((n4) => !!n4)) != null ? e5 : [];
  }
  /**
   * Logs a warning based on the slot name provided and details from the alternate slots map
   *
   * @param slotName name of the slot that has changed
   */
  slotDeprecationWarn(t3) {
    const e5 = this.alternateSlots.get(t3);
    if (e5 !== void 0) {
      let n4;
      const r3 = `The '${t3}' for for '${this.beaconTagName}'`;
      Object.keys(e5).some((s2) => s2.match("alternate")) ? e5.alternateAttribute ? n4 = `will be replaced by the element property '${e5.alternateAttribute}'` : n4 = `will be replaced by the '${e5.alternateSlots}' slot` : n4 = "will be removed", console.warn(
        `Beacon Deprecation Warning: ${r3} ${n4} in foundation@${e5.version}`
      );
    }
  }
  /**
   * A setter that takes user input deferOptions and resolves them compared to existing deferOptions. Enables the setting
   * of isolated deferOptions and leaves unchanged options previously set intact.
   * @param options the defer-options object used in IntersectionObserver.
   */
  setDeferOptions(t3) {
    if (!t3) return;
    const e5 = { ...this.resolvedDeferOptions }, n4 = Y$3([
      t3 == null ? void 0 : t3.root,
      e5 == null ? void 0 : e5.root
    ]), r3 = Y$3([
      t3 == null ? void 0 : t3.rootMargin,
      e5 == null ? void 0 : e5.rootMargin
    ]), s2 = Y$3([
      t3 == null ? void 0 : t3.threshold,
      e5 == null ? void 0 : e5.threshold
    ]);
    this.resolvedDeferOptions = {
      root: n4 instanceof Document || n4 instanceof Element ? n4 : document,
      rootMargin: typeof r3 == "string" ? r3 : _$5.defaultDeferOptions.rootMargin,
      threshold: Array.isArray(s2) || typeof s2 == "number" ? s2 : _$5.defaultDeferOptions.threshold
    };
  }
  /**
   * Hides the visibility of the component. Used when component is deferred until specified condition.
   * @returns void
   */
  setDeferVisibilityStyles() {
    Ae$2(_$5.safari) || (this.style.visibility = _$5.hidden);
  }
  /**
   * Sets the component styles to visibile. Used when component meets condition specified to defer until.
   * @returns void
   */
  removeDeferVisibilityStyles() {
    Ae$2(_$5.safari) || this.style.removeProperty("visibility");
  }
  /**
   * Searches for a parent of component with defer-until attribute that is not solely defer-until="defined".
   * @returns closest lightDOM parent with [defer-until] attribute or null
   */
  getClosestDeferredParent() {
    const t3 = '[defer-until]:not([defer-until="defined"])', e5 = this.closest(
      t3
    );
    if (e5 && xe$3(e5))
      return e5;
    const n4 = this.getClosestHost();
    if (n4) {
      const r3 = n4.closest(
        t3
      );
      if (r3 && xe$3(r3))
        return r3;
    }
    return null;
  }
  /**
   * Runs in shadowDOM context. This method searches for the ShadowRoot then returns host of ShadowRoot.
   * @returns host element of this component of the shadowDOM
   */
  getClosestHost() {
    let t3 = this && this.parentNode;
    for (; t3; ) {
      if (t3 instanceof ShadowRoot)
        return t3.host;
      t3 = t3.parentNode;
    }
    return null;
  }
  /**
   * Selects which deferUntil handler method to run on component.
   * @param deferUntilCriteria DeferUntil option that determines how component should defer.
   */
  selectDeferUntilHandler(t3) {
    return new Promise((e5) => {
      t3.includes(P$6.VISIBLE) ? (this.setDeferVisibilityStyles(), this.deferUntilVisible().then(() => {
        this.removeDeferVisibilityStyles(), e5();
      })) : t3.includes(P$6.IDLE) ? (this.setDeferVisibilityStyles(), this.deferUntilIdle().then(() => {
        this.removeDeferVisibilityStyles(), e5();
      })) : e5();
    });
  }
  /**
   * Method that handles setup of deferUntil handler when deferUntil is configured locally via deferUntil prop on the component.
   */
  handleLocalDeferUntil() {
    return new Promise((t3) => {
      this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(this.deferList).then(() => t3());
    });
  }
  /**
   * Method that looks for the closest element to the component with 'defer-until' attribute and either
   * applies the parent's deferUntil logic to the component immediately, if the parent is already registered as `isDeferUntilParent`,
   * or adds an eventListener to toggle parent's deferUntil logic on component once parent has emitted the beacon-event-deferred-child Event.
   * @param closestDeferredParent is the closest element to the component that has the 'defer-until' attribute set.
   */
  handleParentalDeferUntil(t3) {
    return new Promise((e5) => {
      if (t3 === null)
        e5();
      else if (_t$3(t3))
        this.selectDeferUntilHandler(t3.deferList).then(
          () => e5()
        );
      else {
        const n4 = (r3) => {
          this.deferredChildEventHandler(r3).then(() => {
            t3.removeEventListener(
              g$a.DEFERRED_CHILD,
              n4
            ), e5();
          });
        };
        t3.addEventListener(
          g$a.DEFERRED_CHILD,
          n4
        );
      }
    });
  }
  /**
   * This method handles defer logic. If component has deferUntil prop set, it calls method to handle deferUntil logic locally.
   * Else if component has a closest element with 'defer-until' attribute set, it handles deferUntil based on closestDeferredParent's deferUntil settings.
   * If neither of the above criteria match, it completes connectedCallback.
   */
  handleDefer() {
    return new Promise((t3) => {
      if (!this.deferrable || this.motionState === "enabled")
        t3();
      else if (this.deferUntil)
        this.registerAsDeferUntilParent(), this.handleLocalDeferUntil().then(() => t3());
      else {
        const e5 = this.getClosestDeferredParent();
        e5 ? this.handleParentalDeferUntil(e5).then(
          () => t3()
        ) : t3();
      }
    });
  }
  /**
   * Method that registers a component as parental component that can trigger deferUntil logic in child components. It should be placed in connectedCallback
   * of all components that need to trigger deferUntil logic in child components.
   */
  registerAsDeferUntilParent() {
    if (this.deferOptions && this.setDeferOptions(this.deferOptions), this.deferList.includes(P$6.VISIBLE)) {
      const t3 = new IntersectionObserver((e5) => {
        for (const n4 of e5)
          n4.target && (this.isDeferUntilParent = true, this.emitDeferredChild(), t3.disconnect());
      }, this.getResolvedDeferOptions() || null);
      t3.observe(this);
    }
  }
  /**
   * @returns the scope prefix from the beginning of the tagName.
   */
  getScopedTagPrefix() {
    const t3 = this.tagName.toLowerCase().split("-beacon")[0];
    return t3.startsWith("beacon") ? "" : t3;
  }
  /**
   * Defines this web component in the CustomElementRegistry.
   * @param tagNamePrefix lowercase string that prefixes default component tag names for scoping purposes
   */
  static registerComponent(t3) {
    if (this.tagName) {
      const e5 = `${t3 ? `${t3}-` : ""}${this.tagName}`;
      if (!customElements.get(e5)) {
        const n4 = class extends this {
        };
        Object.defineProperty(n4, "name", {
          value: gt$3(e5)
        }), customElements.define(e5, n4), customElements.whenDefined(e5).then(() => {
          const r3 = new CustomEvent(g$a.REGISTER, {
            detail: e5
          });
          document.dispatchEvent(r3);
        }).catch((r3) => {
          console.error(
            `Error defining Beacon Component ${e5} in CustomElementsRegistry: `,
            r3
          );
        });
      }
    }
  }
  static renderGlobalRootStyles() {
    this.globalRootStyles.forEach((t3, e5) => {
      if (document.getElementById(`beacon-global-root-styles-${e5}`)) return;
      const n4 = document.createElement("template");
      n4.innerHTML = `
        <style id="beacon-global-root-styles-${e5}">
          ${t3.toString()}
        </style>
      `;
      const r3 = n4.content.cloneNode(true);
      document.head.append(r3);
    });
  }
  /**
   * This will return beacon tag name to scoped tag Name
   * @param tag beaconTagName
   * @returns Scoped tagName
   */
  getScopedTagName(t3) {
    return t3 ? this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${t3}` : t3 : "";
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-click - emits when clicked
   */
  emitClick() {
    L$6(this, g$a.CLICK, void 0, this.onBeaconClick);
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
   */
  emitKeydown() {
    L$6(this, g$a.KEYDOWN, void 0, this.onBeaconKeydown);
  }
  emitToggle() {
    L$6(this, g$a.TOGGLE, void 0, this.onBeaconToggle);
  }
  /**
   * Emitter of beacon-event-deferred-child event used by components registered as deferUntilParents.
   * @param event
   * @event {BeaconEvents} beacon-event-deferred-child - signals to children of a deferUntil parent that they should behave as deferUntil components
   */
  emitDeferredChild() {
    L$6(this, g$a.DEFERRED_CHILD, {
      detail: {
        element: this,
        type: this.deferList
      }
    });
  }
  /**
   * Emits a beacon-event-keydown event as a default to mousedown handling
   * @param event
   */
  handleKeydown(t3) {
    this.emitKeydown();
  }
  /**
   * Check if the component has a specific mixin applied.
   * @param name Name of the mixin to look for.
   * @returns True if the class contains that mixin.
   */
  hasMixin(t3) {
    var e5;
    try {
      if (!((e5 = this.constructor().mixins) != null && e5.includes(t3))) throw new Error(`This class does not implement ${t3}.`);
      return true;
    } catch (n4) {
      return console.error(n4), false;
    }
  }
  /**
   * Check for a field with a specific value on the class.
   *
   * Useful when a mixin relies on the existance of another mixin.
   *
   * @param field Class property to check for on the mixin.
   * @param value Value of the given class field to check for.
   * @returns True if the value of the field is the same.
   */
  hasFieldAndValue(t3, e5) {
    try {
      if (!(t3 in this))
        throw new Error(`${t3} does not exist on this: ${this}`);
      return this[t3] === e5;
    } catch (n4) {
      return console.error(n4), false;
    }
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @prerender
   * and is called in connectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of connectedCallback in subclasses
   */
  prerender(...t3) {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @postrender
   * and is called in firstUpdated. This method should not be overridden directly.
   * The goal is to prevent direct overrides of firstUpdated in subclasses
   */
  postrender(...t3) {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @destroy
   * and is called in disconnectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of disconnectedCallback in subclasses
   */
  destroy(...t3) {
  }
  /**
   * Enables or disables motion on this component.
   *
   * Looks for the closest element with `[motion-state]` to find its value and set the motion state of the component equal to that.
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest Element.closest() will return the element itself if it matches the selector.
   */
  setMotionState() {
    if (this.motionState === "enabled")
      return;
    const t3 = this.closest("[motion-state]"), e5 = t3 == null ? void 0 : t3.getAttribute("motion-state");
    e5 && (e5 === "enabled" || e5 === "disabled") && (this.motionState = e5);
  }
  /**
   * Removes the "defined" string value from defer-until attribute while leaving in place any other subString in the attribute.
   * This is a clean-up function called in connectedCallback that enables usage of applitools UltraFastGrid with defer-until="defined"
   * components.
   */
  removeDeferUntilDefined() {
    const t3 = this.getAttribute("defer-until");
    if (t3) {
      const e5 = t3.split(" ").filter((r3) => r3), n4 = e5.length;
      if (n4 === 1 && e5.includes("defined") || n4 === 0)
        this.removeAttribute("defer-until");
      else {
        const r3 = e5.filter((s2) => s2 !== "defined").join(" ");
        this.setAttribute("defer-until", r3);
      }
    } else this.hasAttribute("defer-until") && !t3 && this.removeAttribute("defer-until");
  }
  renderLightDOMStyles() {
    this.renderStyles(
      "lightDOMStyles",
      `${this.beaconTagName}-light-DOM-styles`
    ), this.renderStyles("globalLightDOMStyles", "beacon-global-light-DOM-styles");
  }
  connectedCallback() {
    this.setMotionState(), this.removeDeferUntilDefined(), this.handleDefer().then(() => {
      super.connectedCallback(), vt$2(this, U$1) || (bt$1.setHostEventHandlerForAnalytics(this, this.version), we$2(this, U$1, true)), b$e.renderGlobalRootStyles(), this.renderLightDOMStyles(), this.prerender();
    });
  }
  firstUpdated() {
    this.postrender(), L$6(this, g$a.ELEMENT_READY);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.destroy();
  }
}, U$1 = /* @__PURE__ */ new WeakMap(), b$e.styles = [mt$2, ft$1, pt], b$e.tagName = "", b$e.shadowRootOptions = {
  ...O$4.shadowRootOptions,
  delegatesFocus: true
}, b$e.alternateAttributesMap = /* @__PURE__ */ new Map(), b$e.hasDeprecatedProperties = false, b$e.mixins = [], b$e.lightDOMStyles = [], b$e.globalLightDOMStyles = [
  ht,
  dt
], b$e.globalRootStyles = [ut$1], b$e);
E$9([
  v$c({ attribute: "focus-override", type: Boolean, reflect: true })
], y$9.prototype, "focusOverride");
E$9([
  v$c({ attribute: "reset-spacing", type: Boolean, reflect: true })
], y$9.prototype, "resetSpacing");
E$9([
  v$c({ attribute: "beacon-tag-name", type: String, reflect: true })
], y$9.prototype, "beaconTagName");
E$9([
  v$c({ attribute: "beacon-version", reflect: true })
], y$9.prototype, "version");
E$9([
  v$c({ attribute: "defer-until" })
], y$9.prototype, "deferUntil");
E$9([
  v$c({ attribute: "defer-options" })
], y$9.prototype, "deferOptions");
E$9([
  v$c({ attribute: "motion-state", reflect: true })
], y$9.prototype, "motionState");
E$9([
  it()
], y$9.prototype, "prefersReducedMotion");
let Bt$3 = y$9;
const At$2 = (t3) => t3.replace(
  /[A-Z]+(?![a-z])|[A-Z]/g,
  (e5, n4) => (n4 ? "-" : "") + e5.toLowerCase()
), wt$3 = (t3) => /^([a-z](?![\d])|[\d](?![a-z]))+(-?([a-z](?![\d])|[\d](?![a-z])))*$|^$/.test(
  t3
);
function St$1(t3) {
  return `${t3}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(
    new RegExp(/\s+(.)(\w*)/, "g"),
    (e5, n4, r3) => `${n4.toUpperCase() + r3}`
  ).replace(new RegExp(/\w/), (e5) => e5.toUpperCase());
}
typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
function Ct$1(t3) {
  switch (t3) {
    case "./__temp-separated/beacon-accordion/index.js":
      return import("./index-yf8GK7Th-BYd_a0D5-RdWWI2dw.js");
    case "./__temp-separated/beacon-accordion-item/index.js":
      return import("./index-BXRA-e49-EyHTVgf2-BSu5oAJ0.js");
    case "./__temp-separated/beacon-action-bar/index.js":
      return import("./index-BHVN6jRo-dT4FBbda-BRT2fRe2.js");
    case "./__temp-separated/beacon-anchor-navigation/index.js":
      return import("./index-u68TXH75-CjkJWnPP-CXbyWQ7F.js");
    case "./__temp-separated/beacon-area-chart/index.js":
      return import("./index-bMohN88S-Br3PuWOs-nQ8Tt8wg.js");
    case "./__temp-separated/beacon-article-tile/index.js":
      return import("./index-Bg8noQdm-CsxrA40H-DqagEkn3.js");
    case "./__temp-separated/beacon-async-append.d/index.js":
      return import("./index-DWDsxv8E-HvyJD61X-CsA-WxiO.js");
    case "./__temp-separated/beacon-async-directive.d/index.js":
      return import("./index-CcruWZKi-ISxGjIlj-BSx4prBk.js");
    case "./__temp-separated/beacon-async-replace.d/index.js":
      return import("./index-cqwqN7RP-BNiZdhUR-rXA-nAlq.js");
    case "./__temp-separated/beacon-audio/index.js":
      return import("./index-C6CrxQ3H-DfLUm50d-C5Hi8exE.js");
    case "./__temp-separated/beacon-bar-chart/index.js":
      return import("./index-vPnjGkvX-75dfWuU8-C5JUrIzE.js");
    case "./__temp-separated/beacon-bio-card/index.js":
      return import("./index-CiuA4Lmq-C50mk3mK-DP3v_fXu.js");
    case "./__temp-separated/beacon-breadcrumbs/index.js":
      return import("./index-BNKzwlsM-DZmUhWqu-BbHblQ9n.js");
    case "./__temp-separated/beacon-button/index.js":
      return import("./index-CSz7ljnF-C_owU7bA-QbQO37Q1.js");
    case "./__temp-separated/beacon-byline/index.js":
      return import("./index-yb6p0Y_W-FzYpL024-B38kDVlK.js");
    case "./__temp-separated/beacon-cache.d/index.js":
      return import("./index-C49I_nL_-9gbBf6E0-B7B5Mxmh.js");
    case "./__temp-separated/beacon-carousel/index.js":
      return import("./index-BjjPj_bL-C0o0U0vE-DeYRP9er.js");
    case "./__temp-separated/beacon-choose.d/index.js":
      return import("./index-Bgx6SscZ-BvDxkGxn-COec4VjV.js");
    case "./__temp-separated/beacon-class-map.d/index.js":
      return import("./index-sl1_h-2--CZKxsp0Y-BwpfUZBi.js");
    case "./__temp-separated/beacon-collection-tile/index.js":
      return import("./index-BNGj4i5p-BUv0rsvN-DYmPgsAx.js");
    case "./__temp-separated/beacon-contact-tile/index.js":
      return import("./index-XRo2jp98-C3jq_hax-CcRSsPQP.js");
    case "./__temp-separated/beacon-control/index.js":
      return import("./index-Bw27YOvZ-BDRx1q6p-Kp2zW9Qh.js");
    case "./__temp-separated/beacon-control-group/index.js":
      return import("./index-CAykRV0q-DjscjMWh-CtqiPSPK.js");
    case "./__temp-separated/beacon-country/index.js":
      return import("./index-Bry-l637-BwMXIR1o-9ns3Ey6K.js");
    case "./__temp-separated/beacon-country-selector/index.js":
      return import("./index-CkZCdHj9-BRITj9PG-COo6OLMt.js");
    case "./__temp-separated/beacon-custom-element.d/index.js":
      return import("./index-3Ky_KbTn-BYAVYlym-CVcVvAcD.js");
    case "./__temp-separated/beacon-data-list/index.js":
      return import("./index-DvYSnaOZ-j4m5kakQ-BBAEo5DB.js").then((e5) => e5.index);
    case "./__temp-separated/beacon-decorators.d/index.js":
      return import("./index-DjxEPQib-Dsk6QPE9-COP7Qt-q.js");
    case "./__temp-separated/beacon-directive-helpers.d/index.js":
      return import("./index-Cg6PELoU-ZyMPvnZn-BxzTh1mH.js");
    case "./__temp-separated/beacon-directive.d/index.js":
      return import("./index-DUPC5men-DaO0oGZM-DikaOSB0.js");
    case "./__temp-separated/beacon-divider/index.js":
      return import("./index-DmZovyZY-DNQBWqk4-DS-KyhaK.js");
    case "./__temp-separated/beacon-donut-chart/index.js":
      return import("./index-DMLaj7QB-DCUNGES--CMuAB8iD.js");
    case "./__temp-separated/beacon-drawer/index.js":
      return import("./index-BBWF6BEv-KNAxxx3y-DHUloM3w.js");
    case "./__temp-separated/beacon-error/index.js":
      return import("./index-CZ8sBWcs-CnXhkCVR-mEt25cPj.js");
    case "./__temp-separated/beacon-event-options.d/index.js":
      return import("./index-DPRe0aaE-Dm_fRTyp-CkRBdQ7V.js");
    case "./__temp-separated/beacon-filter-chip/index.js":
      return import("./index-BbmVuU25-BNf2HZ2D-aTnuhAJp.js");
    case "./__temp-separated/beacon-footer/index.js":
      return import("./index-CAsRNM9L-BrDk6P1m-BegzJ4Ex.js");
    case "./__temp-separated/beacon-gauge-chart/index.js":
      return import("./index-J7u2cpww-BZkb92S1-avsrtrfm.js");
    case "./__temp-separated/beacon-guard.d/index.js":
      return import("./index-BIsqFChh-BnRis4Oi-BAVcMB3D.js");
    case "./__temp-separated/beacon-hero/index.js":
      return import("./index-B-T3PHZP-CEr7NsHy-DiJwXxzg.js");
    case "./__temp-separated/beacon-html.d/index.js":
      return import("./index-CYA3oVVY-hqmzhX60-DijabQOP.js");
    case "./__temp-separated/beacon-icon/index.js":
      return import("./index-DQIzg92N-Dud4Boud-BMbS6w_H.js");
    case "./__temp-separated/beacon-icon-button/index.js":
      return import("./index-BAXV4Tb7-BlXMxJ8u-CBS1R_sZ.js");
    case "./__temp-separated/beacon-id-card/index.js":
      return import("./index-DWLV56nz-wmBTUkFp-C5fo6Vag.js");
    case "./__temp-separated/beacon-if-defined.d/index.js":
      return import("./index-CyV8n-JU-hc7Iq8tb-Bdf2Z8aY.js");
    case "./__temp-separated/beacon-index.all.d/index.js":
      return import("./index-CIUpExT0-X0WBRZ8a-vzZXEu9M.js");
    case "./__temp-separated/beacon-index.d/index.js":
      return import("./index-CUehEOy9-BQK1huLI-yUpeizxr.js");
    case "./__temp-separated/beacon-index.test-components/index.js":
      return import("./index-WzEPNEoJ-Bv5payS6-C6-3q5tV.js");
    case "./__temp-separated/beacon-input-chip/index.js":
      return import("./index-lnkkmPJl-DzaxoiIV-BVE8LVeU.js");
    case "./__temp-separated/beacon-join.d/index.js":
      return import("./index-DeJaZgXv-CZS-BhPm-DLJ6IN4j.js");
    case "./__temp-separated/beacon-key-facts/index.js":
      return import("./index-B2dzFvQb-yD2rV1dW-DUHMRLn0.js");
    case "./__temp-separated/beacon-keyed.d/index.js":
      return import("./index-BdRjMG-L-Bo75I2rv-CUMPQbF7.js");
    case "./__temp-separated/beacon-line-chart/index.js":
      return import("./index-aKS1hQy0-DqXIysMi-B-81NqF-.js");
    case "./__temp-separated/beacon-live.d/index.js":
      return import("./index-BGAZPIBx-BjLXRDPt-DtYNvfd2.js");
    case "./__temp-separated/beacon-loading-spinner/index.js":
      return import("./index-CbI2hCcO-SU7NeVeC-D-DVjFAw.js");
    case "./__temp-separated/beacon-map.d/index.js":
      return import("./index-CSPViVrn-qlGozkNP-DvXCEfLV.js");
    case "./__temp-separated/beacon-menu/index.js":
      return import("./index-CBwxGJg8-ZTXCrC9p-7-wif40k.js");
    case "./__temp-separated/beacon-meter-chart/index.js":
      return import("./index-4awEUpGQ-CARNhiRx-C4_37qb1.js");
    case "./__temp-separated/beacon-modal/index.js":
      return import("./index-CinX9Bqd-0VoZ760p-CKt9ggfA.js");
    case "./__temp-separated/beacon-multi-select/index.js":
      return import("./index-soSdqt1k-Dx-aRjbl-CV1y6tZS.js");
    case "./__temp-separated/beacon-multi-select-optgroup/index.js":
      return import("./index-DfJHULfM-CivtZk9I-BSwx7Ydb.js").then((e5) => e5.index);
    case "./__temp-separated/beacon-multi-select-option/index.js":
      return import("./index-Bo8XBgZ9-DjRA4PXP-CM0UuwcB.js");
    case "./__temp-separated/beacon-navigation/index.js":
      return import("./index-CObmVDwJ-fwNpSa9s-C-5d33es.js").then((e5) => e5.index);
    case "./__temp-separated/beacon-navigation-button/index.js":
      return import("./index-CObmVDwJ-fwNpSa9s-C-5d33es.js").then((e5) => e5.index$1);
    case "./__temp-separated/beacon-navigation-expanded/index.js":
      return import("./index-CObmVDwJ-fwNpSa9s-C-5d33es.js").then((e5) => e5.index$2);
    case "./__temp-separated/beacon-navigation-footer/index.js":
      return import("./index-fTKxaZ2P-AzFR_pxF-t-26FKkT.js");
    case "./__temp-separated/beacon-navigation-popover/index.js":
      return import("./index-CObmVDwJ-fwNpSa9s-C-5d33es.js").then((e5) => e5.index$3);
    case "./__temp-separated/beacon-navigation-toolbelt/index.js":
      return import("./index-CObmVDwJ-fwNpSa9s-C-5d33es.js").then((e5) => e5.index$4);
    case "./__temp-separated/beacon-notification/index.js":
      return import("./index-CAbjT1p4-BUnSCM8i-DXsGtf80.js");
    case "./__temp-separated/beacon-notification-group/index.js":
      return import("./index-D681fsMa-CMF6VmCm-CUBW2FbL.js");
    case "./__temp-separated/beacon-pagination/index.js":
      return import("./index-BMf0nIcR-DEf3TaIC-CdnTILlS.js");
    case "./__temp-separated/beacon-pagination-button/index.js":
      return import("./index-DG-0buG5-DJHeyHIP-BYstl7Au.js");
    case "./__temp-separated/beacon-polyfill-support.d/index.js":
      return import("./index-CjVQj10L-CuqGAGAv-Bbbu96-Z.js");
    case "./__temp-separated/beacon-popover/index.js":
      return import("./index-Bg98nB2Z-AJZR1z-d-DvMLmLUA.js");
    case "./__temp-separated/beacon-progress-indicator/index.js":
      return import("./index-DuzaX_tC-htF4HO7D-DPP-1NQu.js");
    case "./__temp-separated/beacon-promo-tile/index.js":
      return import("./index-D7BTWqeI-D3kpYEJq-DBXZL_O3.js");
    case "./__temp-separated/beacon-property.d/index.js":
      return import("./index-s3jJ0xl5-CowEOooj-Bsetjq7R.js");
    case "./__temp-separated/beacon-query-all.d/index.js":
      return import("./index-BcU27z8q-BBgMqy8S-B_Ywf_8L.js");
    case "./__temp-separated/beacon-query-assigned-elements.d/index.js":
      return import("./index-Cy9drcVL-BliU_Vre-CHtyY95h.js");
    case "./__temp-separated/beacon-query-assigned-nodes.d/index.js":
      return import("./index-Cnb0xbru-KXklajCR-8wq0ttuB.js");
    case "./__temp-separated/beacon-query-async.d/index.js":
      return import("./index-H41p79h--CNuIPjCN-07hv4_7E.js");
    case "./__temp-separated/beacon-query.d/index.js":
      return import("./index-DkrD1O-0-BhoO1gJQ-MvFrwQhi.js");
    case "./__temp-separated/beacon-quote-block/index.js":
      return import("./index-puKDf555-CvP4imKP-DXlIlQEE.js");
    case "./__temp-separated/beacon-range.d/index.js":
      return import("./index-hWPuSLH0-9dYjAG53-BET6Hpc-.js");
    case "./__temp-separated/beacon-ref.d/index.js":
      return import("./index-BdSkduYd-DYkGeBe1-CLMBa7tX.js");
    case "./__temp-separated/beacon-region-selector/index.js":
      return import("./index-Z1eTh57t-CyfwELNQ-C974o6gw.js");
    case "./__temp-separated/beacon-repeat.d/index.js":
      return import("./index-C0jQhwVZ-CYAKcxak-DVH-6bmm.js");
    case "./__temp-separated/beacon-scatter-chart/index.js":
      return import("./index-CYfRMZgd-D70N7HVb-Blr9KcV_.js");
    case "./__temp-separated/beacon-segmented-control/index.js":
      return import("./index-D-FRRbN7-b5-UnIMV-DuSGDCnn.js");
    case "./__temp-separated/beacon-segmented-controls/index.js":
      return import("./index-DsqS1r9C-CoDX2MVB-VBP8yg0J.js");
    case "./__temp-separated/beacon-selection-tile/index.js":
      return import("./index-yqnSBPmv-BcCEQnL4-C5zUauvt.js");
    case "./__temp-separated/beacon-social-link/index.js":
      return import("./index-DDVqrDc8-CNcBl9PT-OeDDoQ74.js");
    case "./__temp-separated/beacon-social-link-container/index.js":
      return import("./index-CFjOw0QQ-DVZ7ZYzG-C1eXDdIc.js");
    case "./__temp-separated/beacon-state.d/index.js":
      return import("./index-uiGwYmGU-B4gTdfzL-u5nzwjdz.js");
    case "./__temp-separated/beacon-static-html.d/index.js":
      return import("./index-CGDM5ynt-D47qz_-a-au4Mixsr.js");
    case "./__temp-separated/beacon-style-map.d/index.js":
      return import("./index-BKlvytSw-M6pNz2k--BMHHlU_a.js");
    case "./__temp-separated/beacon-tab/index.js":
      return import("./index-QM_6N1Iw-N6G6wmkd-DHrX3xg8.js").then((e5) => e5.index);
    case "./__temp-separated/beacon-tab-panel/index.js":
      return import("./index-jm3vhE_Z-CNhX1xWQ-D-WQ8nfm.js");
    case "./__temp-separated/beacon-table/index.js":
      return import("./index-CHvrci0j-C39pJ9xg-D5dADLkE.js");
    case "./__temp-separated/beacon-table-header/index.js":
      return import("./index-Dc5IVl1D-CqOsliWT-BtNKLP_o.js").then((e5) => e5.index);
    case "./__temp-separated/beacon-table-record/index.js":
      return import("./index-e1bYYYyL-DF8I9dNo-Dkqjh0Yg.js").then((e5) => e5.index);
    case "./__temp-separated/beacon-table-stub/index.js":
      return import("./index-Dkv99wmd-BkVwFZyn-Caa3rfMw.js").then((e5) => e5.index);
    case "./__temp-separated/beacon-tabs/index.js":
      return import("./index-Vmg6jL7a-DmG3ccjZ-Cem2S9x6.js");
    case "./__temp-separated/beacon-template-content.d/index.js":
      return import("./index-ChrPO7RG-CA71tpK4-7-J6t32Q.js");
    case "./__temp-separated/beacon-tooltip/index.js":
      return import("./index-CYCEOFPi-C10MTeZE-CpNCuX6b.js");
    case "./__temp-separated/beacon-unsafe-html.d/index.js":
      return import("./index-K3rW__Pr-Dq70wvfy-Cnwjc6Nk.js");
    case "./__temp-separated/beacon-unsafe-svg.d/index.js":
      return import("./index-Cdbsxh_c-omwbRAqr-BdxapMRp.js");
    case "./__temp-separated/beacon-until.d/index.js":
      return import("./index-CxHdYFJS-JjEINVML-DeYpXlJO.js");
    case "./__temp-separated/beacon-video/index.js":
      return import("./index-ClwyfjgF-BVoLLiB2-DfIM14p7.js");
    case "./__temp-separated/beacon-video-playlist/index.js":
      return import("./index-elFb0sI0-B9BHSXvK-y0uLCYUZ.js");
    case "./__temp-separated/beacon-video-tag/index.js":
      return import("./index-CsBlkzB5-Vqz7VuE7-DoL3q9UT.js");
    case "./__temp-separated/beacon-video-tile/index.js":
      return import("./index-kdHJdI1h-Bsdtq41y-DNZKZcbK.js");
    case "./__temp-separated/beacon-video-transcript/index.js":
      return import("./index-DYH27qoI-C62FzTNF-o4OfFub1.js");
    case "./__temp-separated/beacon-when.d/index.js":
      return import("./index-CfbsfIe0-BDCkMiLR-D3GBG5eA.js");
    default:
      return new Promise(function(e5, n4) {
        (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
          n4.bind(null, new Error("Unknown variable dynamic import: " + t3))
        );
      });
  }
}
const jt$4 = (t3) => !!t3.registerComponent, Ot$1 = (t3) => {
  const e5 = At$2(t3);
  return wt$3(t3) || console.warn(
    `Beacon Warning: '${t3}' is not a valid Beacon component tag name. Class name casing will be deprecated soon. Update to tag name "${e5}".`
  ), e5;
}, Pt$3 = (t3) => {
  const e5 = Ot$1(t3);
  return {
    tagName: e5,
    className: St$1(e5)
  };
}, Se$3 = async (t3, e5, n4) => new Promise((r3, s2) => {
  var o2;
  if (typeof e5 == "string") {
    const { tagName: i5, className: a2 } = Pt$3(
      e5
    ), c4 = t3 ? `${t3}-${i5}` : i5;
    customElements.get(c4) ? r3(customElements.get(c4)) : Ct$1(`./__temp-separated/${i5}/index.js`).then((l4) => {
      var d3;
      const p2 = l4[`${a2}`];
      p2.registerComponent(t3), (d3 = p2.nestedComponents) != null && d3.length && Promise.all(
        p2.nestedComponents.map(
          (f2) => Se$3(
            t3,
            f2
          )
        )
      ), r3(p2);
    }).catch(() => {
      const l4 = `Beacon Registration Error: Unable to import ${e5}`;
      r3(l4);
    });
  } else if (jt$4(e5)) {
    const i5 = e5;
    i5.registerComponent(t3), (o2 = i5.nestedComponents) != null && o2.length && Promise.all(
      i5.nestedComponents.map(
        (a2) => Se$3(
          t3,
          a2
        )
      )
    ), r3(i5);
  }
});
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const e$6 = (o2) => o2 != null ? o2 : h$c;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function r$b(n4, o2, u2) {
  return n4 ? o2(n4) : u2 == null ? void 0 : u2(n4);
}
var d$f = (t3) => {
  throw TypeError(t3);
}, r$a = (t3, e5, s2) => e5.has(t3) || d$f("Cannot " + s2), v$b = (t3, e5, s2) => (r$a(t3, e5, "read from private field"), s2 ? s2.call(t3) : e5.get(t3)), n$a = (t3, e5, s2) => e5.has(t3) ? d$f("Cannot add the same private member more than once") : e5 instanceof WeakSet ? e5.add(t3) : e5.set(t3, s2), b$d = (t3, e5, s2, o2) => (r$a(t3, e5, "write to private field"), e5.set(t3, s2), s2), h$b = (t3, e5, s2) => (r$a(t3, e5, "access private method"), s2);
const p$c = ["id"], c$9 = [...p$c];
var a$d, i$7, l$b, u$3;
let m$e = class m {
  constructor(e5, s2) {
    n$a(this, i$7), n$a(this, a$d), this.attributes = /* @__PURE__ */ new Map(), (this.host = e5).addController(this), b$d(this, a$d, s2);
  }
  hostConnected() {
    h$b(this, i$7, l$b).call(this), h$b(this, i$7, u$3).call(this);
  }
};
a$d = /* @__PURE__ */ new WeakMap(), i$7 = /* @__PURE__ */ new WeakSet(), l$b = function() {
  var t3, e5;
  if (this.host instanceof HTMLElement) {
    for (const s2 of c$9)
      this.attributes.set(
        s2,
        (e5 = this.host.getAttribute(s2)) != null ? e5 : (t3 = v$b(this, a$d)) == null ? void 0 : t3[s2]
      );
    this.host.requestUpdate();
  }
}, u$3 = function() {
  const t3 = new MutationObserver(
    (e5, s2) => {
      for (const { attributeName: o2, target: f2 } of e5)
        o2 === "id" && this.attributes.set("id", f2.id);
      this.host.requestUpdate();
    }
  );
  this.host instanceof HTMLElement && t3.observe(this.host, {
    attributes: true,
    attributeFilter: c$9
  });
};
var a$c = /* @__PURE__ */ ((r3) => (r3.PRIMARY = "primary", r3.SECONDARY = "secondary", r3.TERTIARY = "tertiary", r3.POSITIVE = "positive", r3.NEGATIVE = "negative", r3))(a$c || {});
const l$a = "__mixwith_appliedMixin", o$a = "__mixwith_wrappedMixin", x$8 = "__mixwith_cachedApplications", y$8 = "__mixwith_instanceOf", m$d = (s2, e5) => {
  const n4 = e5(s2);
  return n4.prototype[l$a] = j$5(e5), n4;
}, M$6 = (s2, e5) => Object.hasOwn(s2, l$a) && s2[l$a] === j$5(e5), b$c = (s2, e5) => {
  for (; s2 != null; ) {
    if (M$6(s2, e5)) return true;
    s2 = Object.getPrototypeOf(s2);
  }
  return false;
}, h$a = (s2, e5) => (Object.setPrototypeOf(e5, s2), s2[o$a] || (s2[o$a] = s2), e5), j$5 = (s2) => s2[o$a] || s2, P$5 = (s2) => h$a(s2, (e5) => {
  let n4 = e5[x$8];
  n4 || (n4 = e5[x$8] = /* @__PURE__ */ new Map());
  let u2 = n4.get(s2);
  return u2 || (u2 = s2(e5), n4.set(s2, u2)), u2;
}), g$9 = (s2) => h$a(s2, (e5) => b$c(e5.prototype, s2) ? e5 : s2(e5)), v$a = (s2) => (s2[y$8] || (s2[y$8] = true, Object.defineProperty(s2, Symbol.hasInstance, {
  value(e5) {
    return b$c(e5, s2);
  }
})), s2), A$6 = (s2) => h$a(s2, (e5) => m$d(e5, s2)), p$b = (s2) => g$9(P$5(A$6(v$a(s2)))), B$5 = (s2) => new I$5(s2);
let I$5 = class I {
  constructor(e5) {
    this.superclass = e5;
  }
  /**
   * Applies a chain of mixins to a base class. The method supports up to six mixins.
   * The mixins are applied in reverse sequence (e.g. the right most mixin is applied first, etc.)
   *
   * @param {mixin<Base, A>} a - A mixin to apply.
   * @param {mixin<A, B>} [b] - A mixin to apply (optional).
   * @param {mixin<B, C>} [c] - A mixin to apply (optional).
   * @param {mixin<C, D>} [d] - A mixin to apply (optional).
   * @param {mixin<D, E>} [e] - A mixin to apply (optional).
   * @param {mixin<E, F>} [f] - A mixin to apply (optional).
   *
   * @returns {Base & A & B & C & D & E & F} - A new class constructor that includes the functionalities
   *                                           of all mixins and the base class.
   */
  with(e5, n4, u2, d3, f2, _2) {
    var w2;
    this.superclass = (w2 = this.superclass) != null ? w2 : class {
    };
    const r3 = p$b(e5), i5 = n4 ? p$b(n4) : void 0, t3 = u2 ? p$b(u2) : void 0, c4 = d3 ? p$b(d3) : void 0, a2 = f2 ? p$b(f2) : void 0, O3 = _2 ? p$b(_2) : void 0;
    return O3 && a2 && c4 && t3 && i5 && r3 ? O3(a2(c4(t3(i5(r3(this.superclass)))))) : a2 && c4 && t3 && i5 && r3 ? a2(c4(t3(i5(r3(this.superclass))))) : c4 && t3 && i5 && r3 ? c4(t3(i5(r3(this.superclass)))) : t3 && i5 && r3 ? t3(i5(r3(this.superclass))) : i5 && r3 ? i5(r3(this.superclass)) : r3(this.superclass);
  }
};
function u$2(t3, s2, r3) {
  const i5 = t3.prerender;
  t3.prerender = function(...n4) {
    r3.value.apply(this, n4), i5.apply(this, n4);
  };
}
function d$e(t3, s2, r3) {
  const i5 = t3.postrender;
  t3.postrender = function(...n4) {
    r3.value.apply(this, n4), i5.apply(this, n4);
  };
}
function y$7(t3, s2, r3) {
  const i5 = t3.destroy;
  t3.destroy = function(...n4) {
    r3.value.apply(this, n4), i5.apply(this, n4);
  };
}
const f$8 = (t3) => (s2) => {
  s2.mixins && Array.isArray(s2.mixins) && (s2.mixins = [...s2.mixins, t3]);
};
function x$7(t3, s2) {
  const r3 = {
    waitUntilFirstUpdate: false,
    ...s2
  };
  return (i5, n4) => {
    const { update: c4 } = i5, l4 = Array.isArray(t3) ? t3 : [t3];
    i5.update = function(a2) {
      l4.forEach((h2) => {
        const e5 = h2;
        if (a2.has(e5)) {
          const o2 = a2.get(e5), p2 = this[e5];
          o2 !== p2 && (!r3.waitUntilFirstUpdate || this.hasUpdated) && this[n4](
            o2,
            p2
          );
        }
      }), c4.call(this, a2);
    };
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const r$9 = (o2, t3, e5) => (e5.configurable = true, e5.enumerable = true, Reflect.decorate && typeof t3 != "object" && Object.defineProperty(o2, t3, e5), e5);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function h$9(n4, i5) {
  return (t3, u2, c4) => {
    const o2 = (l4) => {
      var r3, e5;
      return (e5 = (r3 = l4.renderRoot) == null ? void 0 : r3.querySelector(n4)) != null ? e5 : null;
    };
    return r$9(t3, u2, { get() {
      return o2(this);
    } });
  };
}
const d$d = ({
  finisher: e5,
  descriptor: l4
}) => (t3, o2) => {
  var n4;
  if (o2 !== void 0) {
    const u2 = t3.constructor;
    l4 !== void 0 && Object.defineProperty(t3, o2, l4(o2)), e5 == null || e5(u2, o2);
  } else {
    const u2 = (n4 = t3.originalKey) != null ? n4 : t3.key, r3 = l4 !== void 0 ? {
      kind: "method",
      placement: "prototype",
      key: u2,
      descriptor: l4(t3.key)
    } : { ...t3, key: u2 };
    return e5 && (r3.finisher = function(s2) {
      e5(s2, u2);
    }), r3;
  }
};
function a$b(e5, l4, t3 = {}, o2 = false) {
  var n4;
  const u2 = `slot${l4 ? `[name=${l4}]` : ":not([name])"}`, r3 = (n4 = e5.renderRoot) == null ? void 0 : n4.querySelector(u2);
  return r3 ? o2 ? r3.assignedNodes(t3).filter((s2) => s2.nodeType !== Node.COMMENT_NODE) : r3.assignedElements(t3) : [];
}
function m$c(e5) {
  return typeof e5 == "string" ? { version: e5 } : e5.alternateSlot !== void 0 && e5.alternateSlot !== null ? {
    alternateSlot: e5.alternateSlot,
    version: e5.version
  } : {
    alternateAttribute: e5.alternateAttribute,
    version: e5.version
  };
}
function v$9(e5, l4 = false) {
  const { slot: t3, selector: o2, deprecated: n4, flatten: u2 } = e5 != null ? e5 : {};
  let r3;
  return n4 && (r3 = m$c(n4)), d$d({
    descriptor: (s2) => ({
      get() {
        let i5 = a$b(this, t3, { flatten: u2 });
        return i5.length === 0 && n4 && r3 && r3.alternateSlot && (i5 = a$b(this, r3.alternateSlot, {
          flatten: u2
        })), o2 ? i5 == null ? void 0 : i5.filter((f2) => {
          var c4;
          return l4 ? ((c4 = f2 == null ? void 0 : f2.nodeName) == null ? void 0 : c4.toLowerCase()) === this.getScopedTagName(o2) : f2.matches(o2);
        }) : i5;
      },
      set() {
        if (n4) {
          const i5 = t3 != null ? t3 : "";
          this.alternateSlots.set(i5, r3);
        }
      },
      enumerable: true,
      configurable: true
    })
  });
}
function y$6(e5) {
  return function(l4, t3) {
    return h$9(e5)(l4, t3);
  };
}
function k$a(e5, l4) {
  return d$d({
    descriptor: (t3) => ({
      get() {
        var n4;
        return (n4 = this.querySelector(e5)) != null ? n4 : null;
      },
      enumerable: true,
      configurable: true
    })
  });
}
function E$8(e5) {
  const { slot: l4, deprecated: t3, flatten: o2 } = e5 != null ? e5 : {};
  let n4;
  return t3 && (n4 = m$c(t3)), d$d({
    descriptor: (u2) => ({
      get() {
        let r3 = a$b(this, l4, { flatten: o2 }, true);
        return r3.length === 0 && t3 && n4 && n4.alternateSlot && (r3 = a$b(
          this,
          n4.alternateSlot,
          { flatten: o2 },
          true
        )), r3;
      },
      set() {
        if (t3) {
          const r3 = l4 != null ? l4 : "";
          this.alternateSlots.set(r3, n4);
        }
      },
      enumerable: true,
      configurable: true
    })
  });
}
var S$a = Object.defineProperty, p$a = Object.getOwnPropertyDescriptor, a$a = (n4, o2, e5, l4) => {
  for (var t3 = l4 > 1 ? void 0 : l4 ? p$a(o2, e5) : o2, r3 = n4.length - 1, u2; r3 >= 0; r3--)
    (u2 = n4[r3]) && (t3 = (l4 ? u2(o2, e5, t3) : u2(t3)) || t3);
  return l4 && t3 && S$a(o2, e5, t3), t3;
};
function m$b(n4 = { clean: false }) {
  return function(o2) {
    let e5 = class extends o2 {
      /**
       * Removes any whitespace from the default slot.
       *
       * Default slots can see whitespace or new line characters as node slotted in, which can cause presentational issues when there's fallback content in the slot's position.
       *
       * This issue is commonly seen in AEM applications but can be a result of any templating syntax that doesn't trim whitespace from HTML nodes the whole way.
       */
      cleanDefaultSlot() {
        this.defaultSlotNodes.forEach((l4) => {
          var t3;
          !l4.slot && !((t3 = l4.textContent) != null && t3.trim()) && l4.remove();
        });
      }
      /** Sets internal state for slot text and existance of slot content */
      setDefaultSlotText() {
        this.defaultSlotText = this.getDefaultSlotText(), n4.clean && this.cleanDefaultSlot();
      }
      /** Grabs slotted text and sets the state defaultSlotText property. */
      getDefaultSlotText() {
        if (this.defaultSlotNodes.length > 0)
          return this.defaultSlotNodes.map((l4) => {
            var t3, r3;
            return (r3 = (t3 = l4.textContent) == null ? void 0 : t3.trim()) != null ? r3 : "";
          }).join("");
      }
      postrenderSetDefaultSlotText() {
        this.setDefaultSlotText();
      }
    };
    return a$a([
      it()
    ], e5.prototype, "defaultSlotText", 2), a$a([
      E$8({ flatten: true })
    ], e5.prototype, "defaultSlotNodes", 2), a$a([
      d$e
    ], e5.prototype, "postrenderSetDefaultSlotText", 1), e5 = a$a([
      f$8("TracksDefaultSlot")
    ], e5), e5;
  };
}
(function() {
  (function(a2) {
    const l4 = /* @__PURE__ */ new WeakMap(), u2 = /* @__PURE__ */ new WeakMap(), w2 = /* @__PURE__ */ new WeakMap(), c4 = /* @__PURE__ */ new WeakMap(), b5 = /* @__PURE__ */ new WeakMap(), E2 = /* @__PURE__ */ new WeakMap(), D2 = /* @__PURE__ */ new WeakMap(), y2 = /* @__PURE__ */ new WeakMap(), q2 = /* @__PURE__ */ new WeakMap(), S2 = /* @__PURE__ */ new WeakMap(), G2 = /* @__PURE__ */ new WeakMap(), X2 = /* @__PURE__ */ new WeakMap(), K2 = /* @__PURE__ */ new WeakMap(), Y2 = /* @__PURE__ */ new WeakMap(), A3 = /* @__PURE__ */ new WeakMap(), O3 = {
      ariaAtomic: "aria-atomic",
      ariaAutoComplete: "aria-autocomplete",
      ariaBusy: "aria-busy",
      ariaChecked: "aria-checked",
      ariaColCount: "aria-colcount",
      ariaColIndex: "aria-colindex",
      ariaColIndexText: "aria-colindextext",
      ariaColSpan: "aria-colspan",
      ariaCurrent: "aria-current",
      ariaDescription: "aria-description",
      ariaDisabled: "aria-disabled",
      ariaExpanded: "aria-expanded",
      ariaHasPopup: "aria-haspopup",
      ariaHidden: "aria-hidden",
      ariaInvalid: "aria-invalid",
      ariaKeyShortcuts: "aria-keyshortcuts",
      ariaLabel: "aria-label",
      ariaLevel: "aria-level",
      ariaLive: "aria-live",
      ariaModal: "aria-modal",
      ariaMultiLine: "aria-multiline",
      ariaMultiSelectable: "aria-multiselectable",
      ariaOrientation: "aria-orientation",
      ariaPlaceholder: "aria-placeholder",
      ariaPosInSet: "aria-posinset",
      ariaPressed: "aria-pressed",
      ariaReadOnly: "aria-readonly",
      ariaRelevant: "aria-relevant",
      ariaRequired: "aria-required",
      ariaRoleDescription: "aria-roledescription",
      ariaRowCount: "aria-rowcount",
      ariaRowIndex: "aria-rowindex",
      ariaRowIndexText: "aria-rowindextext",
      ariaRowSpan: "aria-rowspan",
      ariaSelected: "aria-selected",
      ariaSetSize: "aria-setsize",
      ariaSort: "aria-sort",
      ariaValueMax: "aria-valuemax",
      ariaValueMin: "aria-valuemin",
      ariaValueNow: "aria-valuenow",
      ariaValueText: "aria-valuetext",
      role: "role"
    }, ht2 = (e5, t3) => {
      for (let o2 in O3) {
        t3[o2] = null;
        let n4 = null;
        const i5 = O3[o2];
        Object.defineProperty(t3, o2, {
          get() {
            return n4;
          },
          set(r3) {
            n4 = r3, e5.isConnected ? v3(e5, i5, r3) : S2.set(e5, t3);
          }
        });
      }
    };
    function J2(e5) {
      const t3 = c4.get(e5), { form: o2 } = t3;
      nt2(e5, o2, t3), ot2(e5, t3.labels);
    }
    const Q2 = (e5, t3 = false) => {
      const o2 = document.createTreeWalker(e5, NodeFilter.SHOW_ELEMENT, {
        acceptNode(r3) {
          return c4.has(r3) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      let n4 = o2.nextNode();
      const i5 = !t3 || e5.disabled;
      for (; n4; )
        n4.formDisabledCallback && i5 && $2(n4, e5.disabled), n4 = o2.nextNode();
    }, Z2 = { attributes: true, attributeFilter: ["disabled", "name"] }, C3 = L2() ? new MutationObserver((e5) => {
      for (const t3 of e5) {
        const o2 = t3.target;
        if (t3.attributeName === "disabled" && (o2.constructor.formAssociated ? $2(o2, o2.hasAttribute("disabled")) : o2.localName === "fieldset" && Q2(o2)), t3.attributeName === "name" && o2.constructor.formAssociated) {
          const n4 = c4.get(o2), i5 = q2.get(o2);
          n4.setFormValue(i5);
        }
      }
    }) : {};
    function R2(e5) {
      e5.forEach((t3) => {
        const { addedNodes: o2, removedNodes: n4 } = t3, i5 = Array.from(o2), r3 = Array.from(n4);
        i5.forEach((s2) => {
          var f2;
          if (c4.has(s2) && s2.constructor.formAssociated && J2(s2), S2.has(s2)) {
            const d3 = S2.get(s2);
            Object.keys(O3).filter((m3) => d3[m3] !== null).forEach((m3) => {
              v3(s2, O3[m3], d3[m3]);
            }), S2.delete(s2);
          }
          if (A3.has(s2)) {
            const d3 = A3.get(s2);
            v3(s2, "internals-valid", d3.validity.valid.toString()), v3(s2, "internals-invalid", (!d3.validity.valid).toString()), v3(s2, "aria-invalid", (!d3.validity.valid).toString()), A3.delete(s2);
          }
          if (s2.localName === "form") {
            const d3 = y2.get(s2), m3 = document.createTreeWalker(s2, NodeFilter.SHOW_ELEMENT, {
              acceptNode(j3) {
                return c4.has(j3) && j3.constructor.formAssociated && !(d3 && d3.has(j3)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
              }
            });
            let I3 = m3.nextNode();
            for (; I3; )
              J2(I3), I3 = m3.nextNode();
          }
          s2.localName === "fieldset" && ((f2 = C3.observe) === null || f2 === void 0 || f2.call(C3, s2, Z2), Q2(s2, true));
        }), r3.forEach((s2) => {
          const f2 = c4.get(s2);
          f2 && w2.get(f2) && tt2(f2), D2.has(s2) && D2.get(s2).disconnect();
        });
      });
    }
    function pt2(e5) {
      e5.forEach((t3) => {
        const { removedNodes: o2 } = t3;
        o2.forEach((n4) => {
          const i5 = K2.get(t3.target);
          c4.has(n4) && it2(n4), i5.disconnect();
        });
      });
    }
    const bt2 = (e5) => {
      var t3, o2;
      const n4 = new MutationObserver(pt2);
      !((t3 = window == null ? void 0 : window.ShadyDOM) === null || t3 === void 0) && t3.inUse && e5.mode && e5.host && (e5 = e5.host), (o2 = n4.observe) === null || o2 === void 0 || o2.call(n4, e5, { childList: true }), K2.set(e5, n4);
    };
    L2() && new MutationObserver(R2);
    const P2 = {
      childList: true,
      subtree: true
    }, v3 = (e5, t3, o2) => {
      e5.getAttribute(t3) !== o2 && e5.setAttribute(t3, o2);
    }, $2 = (e5, t3) => {
      e5.toggleAttribute("internals-disabled", t3), t3 ? v3(e5, "aria-disabled", "true") : e5.removeAttribute("aria-disabled"), e5.formDisabledCallback && e5.formDisabledCallback.apply(e5, [t3]);
    }, tt2 = (e5) => {
      w2.get(e5).forEach((t3) => {
        t3.remove();
      }), w2.set(e5, []);
    }, et2 = (e5, t3) => {
      const o2 = document.createElement("input");
      return o2.type = "hidden", o2.name = e5.getAttribute("name"), e5.after(o2), w2.get(t3).push(o2), o2;
    }, gt2 = (e5, t3) => {
      var o2;
      w2.set(t3, []), (o2 = C3.observe) === null || o2 === void 0 || o2.call(C3, e5, Z2);
    }, ot2 = (e5, t3) => {
      if (t3.length) {
        Array.from(t3).forEach((n4) => n4.addEventListener("click", e5.click.bind(e5)));
        let o2 = t3[0].id;
        t3[0].id || (o2 = `${t3[0].htmlFor}_Label`, t3[0].id = o2), v3(e5, "aria-labelledby", o2);
      }
    }, N2 = (e5) => {
      const t3 = Array.from(e5.elements).filter((r3) => !r3.tagName.includes("-") && r3.validity).map((r3) => r3.validity.valid), o2 = y2.get(e5) || [], n4 = Array.from(o2).filter((r3) => r3.isConnected).map((r3) => c4.get(r3).validity.valid), i5 = [...t3, ...n4].includes(false);
      e5.toggleAttribute("internals-invalid", i5), e5.toggleAttribute("internals-valid", !i5);
    }, yt2 = (e5) => {
      N2(F2(e5.target));
    }, vt2 = (e5) => {
      N2(F2(e5.target));
    }, wt2 = (e5) => {
      const t3 = ["button[type=submit]", "input[type=submit]", "button:not([type])"].map((o2) => `${o2}:not([disabled])`).map((o2) => `${o2}:not([form])${e5.id ? `,${o2}[form='${e5.id}']` : ""}`).join(",");
      e5.addEventListener("click", (o2) => {
        if (o2.target.closest(t3)) {
          const n4 = y2.get(e5);
          if (e5.noValidate)
            return;
          n4.size && Array.from(n4).reverse().map((i5) => c4.get(i5).reportValidity()).includes(false) && o2.preventDefault();
        }
      });
    }, Et2 = (e5) => {
      const t3 = y2.get(e5.target);
      t3 && t3.size && t3.forEach((o2) => {
        o2.constructor.formAssociated && o2.formResetCallback && o2.formResetCallback.apply(o2);
      });
    }, nt2 = (e5, t3, o2) => {
      if (t3) {
        const n4 = y2.get(t3);
        if (n4)
          n4.add(e5);
        else {
          const i5 = /* @__PURE__ */ new Set();
          i5.add(e5), y2.set(t3, i5), wt2(t3), t3.addEventListener("reset", Et2), t3.addEventListener("input", yt2), t3.addEventListener("change", vt2);
        }
        E2.set(t3, { ref: e5, internals: o2 }), e5.constructor.formAssociated && e5.formAssociatedCallback && setTimeout(() => {
          e5.formAssociatedCallback.apply(e5, [t3]);
        }, 0), N2(t3);
      }
    }, F2 = (e5) => {
      let t3 = e5.parentNode;
      return t3 && t3.tagName !== "FORM" && (t3 = F2(t3)), t3;
    }, g2 = (e5, t3, o2 = DOMException) => {
      if (!e5.constructor.formAssociated)
        throw new o2(t3);
    }, at2 = (e5, t3, o2) => {
      const n4 = y2.get(e5);
      return n4 && n4.size && n4.forEach((i5) => {
        c4.get(i5)[o2]() || (t3 = false);
      }), t3;
    }, it2 = (e5) => {
      if (e5.constructor.formAssociated) {
        const t3 = c4.get(e5), { labels: o2, form: n4 } = t3;
        ot2(e5, o2), nt2(e5, n4, t3);
      }
    };
    function L2() {
      return typeof MutationObserver < "u";
    }
    class Mt2 {
      constructor() {
        this.badInput = false, this.customError = false, this.patternMismatch = false, this.rangeOverflow = false, this.rangeUnderflow = false, this.stepMismatch = false, this.tooLong = false, this.tooShort = false, this.typeMismatch = false, this.valid = true, this.valueMissing = false, Object.seal(this);
      }
    }
    const xt2 = (e5) => (e5.badInput = false, e5.customError = false, e5.patternMismatch = false, e5.rangeOverflow = false, e5.rangeUnderflow = false, e5.stepMismatch = false, e5.tooLong = false, e5.tooShort = false, e5.typeMismatch = false, e5.valid = true, e5.valueMissing = false, e5), Tt2 = (e5, t3, o2) => (e5.valid = It2(t3), Object.keys(t3).forEach((n4) => e5[n4] = t3[n4]), o2 && N2(o2), e5), It2 = (e5) => {
      let t3 = true;
      for (let o2 in e5)
        o2 !== "valid" && e5[o2] !== false && (t3 = false);
      return t3;
    }, H2 = /* @__PURE__ */ new WeakMap();
    function rt2(e5, t3) {
      e5.toggleAttribute(t3, true), e5.part && e5.part.add(t3);
    }
    class W2 extends Set {
      static get isPolyfilled() {
        return true;
      }
      constructor(t3) {
        if (super(), !t3 || !t3.tagName || t3.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        H2.set(this, t3);
      }
      add(t3) {
        if (!/^--/.test(t3) || typeof t3 != "string")
          throw new DOMException(`Failed to execute 'add' on 'CustomStateSet': The specified value ${t3} must start with '--'.`);
        const o2 = super.add(t3), n4 = H2.get(this), i5 = `state${t3}`;
        return n4.isConnected ? rt2(n4, i5) : setTimeout(() => {
          rt2(n4, i5);
        }), o2;
      }
      clear() {
        for (let [t3] of this.entries())
          this.delete(t3);
        super.clear();
      }
      delete(t3) {
        const o2 = super.delete(t3), n4 = H2.get(this);
        return n4.isConnected ? (n4.toggleAttribute(`state${t3}`, false), n4.part && n4.part.remove(`state${t3}`)) : setTimeout(() => {
          n4.toggleAttribute(`state${t3}`, false), n4.part && n4.part.remove(`state${t3}`);
        }), o2;
      }
    }
    function st2(e5, t3, o2, n4) {
      if (o2 === "a" && !n4) throw new TypeError("Private accessor was defined without a getter");
      if (typeof t3 == "function" ? e5 !== t3 || !n4 : !t3.has(e5)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
      return o2 === "m" ? n4 : o2 === "a" ? n4.call(e5) : n4 ? n4.value : t3.get(e5);
    }
    function kt2(e5, t3, o2, n4, i5) {
      if (typeof t3 == "function" ? e5 !== t3 || true : !t3.has(e5)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
      return t3.set(e5, o2), o2;
    }
    var T2;
    class St2 {
      constructor(t3) {
        T2.set(this, void 0), kt2(this, T2, t3);
        for (let o2 = 0; o2 < t3.length; o2++) {
          let n4 = t3[o2];
          this[o2] = n4, n4.hasAttribute("name") && (this[n4.getAttribute("name")] = n4);
        }
        Object.freeze(this);
      }
      get length() {
        return st2(this, T2, "f").length;
      }
      [(T2 = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
        return st2(this, T2, "f")[Symbol.iterator]();
      }
      item(t3) {
        return this[t3] == null ? null : this[t3];
      }
      namedItem(t3) {
        return this[t3] == null ? null : this[t3];
      }
    }
    function At2() {
      const e5 = HTMLFormElement.prototype.checkValidity;
      HTMLFormElement.prototype.checkValidity = o2;
      const t3 = HTMLFormElement.prototype.reportValidity;
      HTMLFormElement.prototype.reportValidity = n4;
      function o2(...r3) {
        let s2 = e5.apply(this, r3);
        return at2(this, s2, "checkValidity");
      }
      function n4(...r3) {
        let s2 = t3.apply(this, r3);
        return at2(this, s2, "reportValidity");
      }
      const { get: i5 } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
      Object.defineProperty(HTMLFormElement.prototype, "elements", {
        get(...r3) {
          const s2 = i5.call(this, ...r3), f2 = Array.from(y2.get(this) || []);
          if (f2.length === 0)
            return s2;
          const d3 = Array.from(s2).concat(f2).sort((m3, I3) => m3.compareDocumentPosition ? m3.compareDocumentPosition(I3) & 2 ? 1 : -1 : 0);
          return new St2(d3);
        }
      });
    }
    class lt2 {
      static get isPolyfilled() {
        return true;
      }
      constructor(t3) {
        if (!t3 || !t3.tagName || t3.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        const o2 = t3.getRootNode(), n4 = new Mt2();
        this.states = new W2(t3), l4.set(this, t3), u2.set(this, n4), c4.set(t3, this), ht2(t3, this), gt2(t3, this), Object.seal(this), o2 instanceof DocumentFragment && bt2(o2);
      }
      checkValidity() {
        const t3 = l4.get(this);
        if (g2(t3, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return true;
        const o2 = u2.get(this);
        if (!o2.valid) {
          const n4 = new Event("invalid", {
            bubbles: false,
            cancelable: true,
            composed: false
          });
          t3.dispatchEvent(n4);
        }
        return o2.valid;
      }
      get form() {
        const t3 = l4.get(this);
        g2(t3, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
        let o2;
        return t3.constructor.formAssociated === true && (o2 = F2(t3)), o2;
      }
      get labels() {
        const t3 = l4.get(this);
        g2(t3, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
        const o2 = t3.getAttribute("id"), n4 = t3.getRootNode();
        return n4 && o2 ? n4.querySelectorAll(`[for="${o2}"]`) : [];
      }
      reportValidity() {
        const t3 = l4.get(this);
        if (g2(t3, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return true;
        const o2 = this.checkValidity(), n4 = X2.get(this);
        if (n4 && !t3.constructor.formAssociated)
          throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
        return !o2 && n4 && (t3.focus(), n4.focus()), o2;
      }
      setFormValue(t3) {
        const o2 = l4.get(this);
        if (g2(o2, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), tt2(this), t3 != null && !(t3 instanceof FormData)) {
          if (o2.getAttribute("name")) {
            const n4 = et2(o2, this);
            n4.value = t3;
          }
        } else t3 != null && t3 instanceof FormData && Array.from(t3).reverse().forEach(([n4, i5]) => {
          if (typeof i5 == "string") {
            const r3 = et2(o2, this);
            r3.name = n4, r3.value = i5;
          }
        });
        q2.set(o2, t3);
      }
      setValidity(t3, o2, n4) {
        const i5 = l4.get(this);
        if (g2(i5, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !t3)
          throw new TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
        X2.set(this, n4);
        const r3 = u2.get(this), s2 = {};
        for (const m3 in t3)
          s2[m3] = t3[m3];
        Object.keys(s2).length === 0 && xt2(r3);
        const f2 = Object.assign(Object.assign({}, r3), s2);
        delete f2.valid;
        const { valid: d3 } = Tt2(r3, f2, this.form);
        if (!d3 && !o2)
          throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
        b5.set(this, d3 ? "" : o2), i5.isConnected ? (i5.toggleAttribute("internals-invalid", !d3), i5.toggleAttribute("internals-valid", d3), v3(i5, "aria-invalid", `${!d3}`)) : A3.set(i5, this);
      }
      get shadowRoot() {
        const t3 = l4.get(this);
        return G2.get(t3) || null;
      }
      get validationMessage() {
        const t3 = l4.get(this);
        return g2(t3, "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), b5.get(this);
      }
      get validity() {
        const t3 = l4.get(this);
        return g2(t3, "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), u2.get(this);
      }
      get willValidate() {
        const t3 = l4.get(this);
        return g2(t3, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(t3.disabled || t3.hasAttribute("disabled") || t3.hasAttribute("readonly"));
      }
    }
    function Ot2() {
      if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals)
        return false;
      class e5 extends HTMLElement {
        constructor() {
          super(), this.internals = this.attachInternals();
        }
      }
      const t3 = `element-internals-feature-detection-${Math.random().toString(36).replace(/[^a-z]+/g, "")}`;
      customElements.define(t3, e5);
      const o2 = new e5();
      return [
        "shadowRoot",
        "form",
        "willValidate",
        "validity",
        "validationMessage",
        "labels",
        "setFormValue",
        "setValidity",
        "checkValidity",
        "reportValidity"
      ].every((n4) => n4 in o2.internals);
    }
    let ct2 = false, dt2 = false;
    function _2(e5) {
      dt2 || (dt2 = true, window.CustomStateSet = W2, e5 && (HTMLElement.prototype.attachInternals = function(...t3) {
        const o2 = e5.call(this, t3);
        return o2.states = new W2(this), o2;
      }));
    }
    function ut2(e5 = true) {
      if (!ct2) {
        if (ct2 = true, typeof window < "u" && (window.ElementInternals = lt2), typeof CustomElementRegistry < "u") {
          const t3 = CustomElementRegistry.prototype.define;
          CustomElementRegistry.prototype.define = function(o2, n4, i5) {
            if (n4.formAssociated) {
              const r3 = n4.prototype.connectedCallback;
              n4.prototype.connectedCallback = function() {
                Y2.has(this) || (Y2.set(this, true), this.hasAttribute("disabled") && $2(this, true)), r3 != null && r3.apply(this), it2(this);
              };
            }
            t3.call(this, o2, n4, i5);
          };
        }
        if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
          if (this.tagName) {
            if (this.tagName.indexOf("-") === -1)
              throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
          } else return {};
          if (c4.has(this))
            throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
          return new lt2(this);
        }), typeof Element < "u") {
          let t3 = function(...n4) {
            const i5 = o2.apply(this, n4);
            if (G2.set(this, i5), L2()) {
              const r3 = new MutationObserver(R2);
              window.ShadyDOM ? r3.observe(this, P2) : r3.observe(i5, P2), D2.set(this, r3);
            }
            return i5;
          };
          const o2 = Element.prototype.attachShadow;
          Element.prototype.attachShadow = t3;
        }
        L2() && typeof document < "u" && new MutationObserver(R2).observe(document.documentElement, P2), typeof HTMLFormElement < "u" && At2(), (e5 || typeof window < "u" && !window.CustomStateSet) && _2();
      }
    }
    return customElements.polyfillWrapFlushCallback || (Ot2() ? typeof window < "u" && !window.CustomStateSet && _2(HTMLElement.prototype.attachInternals) : ut2(false)), a2.forceCustomStateSetPolyfill = _2, a2.forceElementInternalsPolyfill = ut2, Object.defineProperty(a2, "__esModule", { value: true }), a2;
  })({});
})();
var mt$1 = /* @__PURE__ */ ((a2) => (a2.LOADING = "loading", a2.PROGRESS = "progress", a2.SUCCESS = "success", a2.RESULT = "result", a2.NONE = "", a2))(mt$1 || {}), V$2 = /* @__PURE__ */ ((a2) => (a2.SUBMIT = "submit", a2.BUTTON = "button", a2.RESET = "reset", a2.MENU = "menu", a2))(V$2 || {});
const Rt$2 = T$7`.beacon-button-icon{align-self:var(--beacon-button-icon-align, center);block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5)}.beacon-button-icon .beacon-button-icon--icon{fill:currentcolor}.beacon-button-icon .beacon-button-icon--stroke{stroke:currentcolor}.close-button-wrapper .beacon-button-icon{block-size:unset;inline-size:unset}[beacon-tag-name=beacon-icon-button] .beacon-button-icon{block-size:var(--override-icon-button-block-size, var(--beacon-reference-space-7));inline-size:var(--override-icon-button-inline-size, var(--beacon-reference-space-7))}`, Pt$2 = T$7`:host([motion-state=enabled]) a,:host([motion-state=enabled]) button,:host([motion-state=enabled]) .icon-button{--button-base-transition-property: background-color;transition-duration:var(--button-base-transition-duration, 0s);transition-property:var(--button-base-transition-property);transition-timing-function:var(--button-base-transition-timing-function, var(--beacon-system-motion-easing-decelerate-emphasize-1))}:host([motion-state=enabled]) a .contents,:host([motion-state=enabled]) button .contents,:host([motion-state=enabled]) .icon-button .contents{transition-duration:inherit;transition-property:transform;transition-timing-function:inherit}`;
var $t$2 = (a2, l4, u2, w2) => {
  for (var c4 = l4, b5 = a2.length - 1, E2; b5 >= 0; b5--)
    (E2 = a2[b5]) && (c4 = E2(c4) || c4);
  return c4;
};
function Ht$2(a2) {
  let l4 = class extends a2 {
    static get ButtonBaseMotionStyles() {
      return [Pt$2];
    }
  };
  return l4 = $t$2([
    f$8("ButtonBaseMotion")
  ], l4), l4;
}
const Wt$2 = T$7`:host(:not(.skip-focus-override)) :is(button,a):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;position:relative;z-index:1}:host(:not(.skip-focus-override)) :is(button,a).tertiary:focus-visible{--second-ring-width: calc(var(--beacon-system-width-border-jumbo) + var(--beacon-system-width-border-normal));box-shadow:0 0 0 var(--second-ring-width) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:0;position:relative;z-index:1}`;
var _t$2 = Object.defineProperty, p$9 = (a2, l4, u2, w2) => {
  for (var c4 = void 0, b5 = a2.length - 1, E2; b5 >= 0; b5--)
    (E2 = a2[b5]) && (c4 = E2(l4, u2, c4) || c4);
  return c4 && _t$2(l4, u2, c4), c4;
};
const k$9 = {
  icon: "beacon-button-icon",
  strokeFill: "beacon-button-icon--stroke",
  iconFill: "beacon-button-icon--icon"
}, jt$3 = "stroke";
var x$6;
const h$8 = (x$6 = class extends B$5(Bt$3).with(
  Ht$2,
  m$b({ clean: true })
) {
  constructor() {
    super(), this._passthroughs = new m$e(this), this.focusOverride = true, this.SLOTTED_ICON_INDEX = 0, this.type = V$2.BUTTON, this.variant = a$c.PRIMARY, this.state = mt$1.NONE, this.disabled = false, this.linkHref = "", this.internals = this.attachInternals ? this.attachInternals() : null;
  }
  static get styles() {
    return [super.styles, Wt$2, this.ButtonBaseMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, Rt$2];
  }
  /**
   * Implement `ElementInternals.setValidity()` with default values.
   * @param flags Custom validation flags.
   * @param message Error message used in validation.
   * @param anchor Validation target to receive focus, typically the form control element used in the shadow DOM.
   */
  setValidity(a2, l4, u2 = this.formAnchor) {
    this.internals && this.internals.setValidity(a2, l4, u2);
  }
  get prefixIcon() {
    return this.prefixIconElements[this.SLOTTED_ICON_INDEX];
  }
  get suffixIcon() {
    return this.suffixIconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Returns the first element in the icon slot
   */
  get icon() {
    return this.iconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Event listener for internal HTML button that
   * determines click behavior depending on its disabled state
   * and button type.
   * @param event click event
   * @event {BeaconEvents} beacon-event-click - Emits when clicked
   */
  handleClick(a2) {
    if (this.disabled)
      a2.preventDefault(), a2.stopPropagation(), a2.stopImmediatePropagation();
    else if (this.emitClick(), this.internals)
      switch (this.type) {
        case V$2.SUBMIT:
          this.internals.form.requestSubmit();
          break;
        case V$2.RESET:
          this.internals.form.reset();
          break;
      }
  }
  /**
   * Applies proper CSS class to slotted SVG such that it renders correctly
   * @param element reference to the slotted SVG
   */
  static applySVGClass(a2) {
    a2 && Array.from(a2.children).forEach((l4) => {
      if (l4) {
        const u2 = l4.getAttribute(jt$3) ? k$9.strokeFill : k$9.iconFill;
        l4.classList.add(u2);
      }
    });
  }
  handleIconSlotchange() {
    if (this.iconElements.length > 0)
      for (const a2 of this.iconElements) {
        a2.classList.add(k$9.icon);
        const l4 = this.defaultSlotText;
        It$1(a2, l4), x$6.applySVGClass(a2);
      }
  }
  handleAffixSlotChanges({ target: a2 }) {
    if (a2 instanceof HTMLSlotElement) {
      const l4 = a2.name;
      if (l4 === "suffix" && this.suffixIcon) {
        this.suffixIcon.classList.add(k$9.icon);
        const u2 = this.defaultSlotText;
        It$1(this.suffixIcon, u2), x$6.applySVGClass(this.suffixIcon);
      } else if (l4 === "prefix" && this.prefixIcon) {
        this.prefixIcon.classList.add(k$9.icon);
        const u2 = this.defaultSlotText;
        It$1(this.prefixIcon, u2), x$6.applySVGClass(this.prefixIcon);
      }
    }
  }
}, x$6.formAssociated = true, x$6);
p$9([
  y$6(".form-anchor")
], h$8.prototype, "formAnchor");
p$9([
  v$c({ reflect: true })
], h$8.prototype, "type");
p$9([
  v$c()
], h$8.prototype, "variant");
p$9([
  v$c()
], h$8.prototype, "state");
p$9([
  v$c({ type: Boolean })
], h$8.prototype, "disabled");
p$9([
  v$c({ attribute: "link-href" })
], h$8.prototype, "linkHref");
p$9([
  v$c({ attribute: "link-download" })
], h$8.prototype, "linkDownload");
p$9([
  v$c({ attribute: "link-target" })
], h$8.prototype, "linkTarget");
p$9([
  v$9({ flatten: true, slot: "icon", selector: "svg" })
], h$8.prototype, "iconElements");
p$9([
  v$9({
    flatten: true,
    slot: "prefix",
    selector: "svg"
  })
], h$8.prototype, "prefixIconElements");
p$9([
  v$9({
    flatten: true,
    slot: "suffix",
    selector: "svg"
  })
], h$8.prototype, "suffixIconElements");
p$9([
  y$6("button, a")
], h$8.prototype, "button");
let Yt$2 = h$8;
var o$9 = /* @__PURE__ */ ((M2) => (M2.NORMAL = "normal", M2.MINI = "mini", M2.JUMBO = "jumbo", M2.MAXI = "maxi", M2))(o$9 || {}), i$6 = /* @__PURE__ */ ((M2) => (M2.NORMAL = "normal", M2.MINI = "mini", M2.JUMBO = "jumbo", M2))(i$6 || {});
const i$5 = {
  beaconTagName: "beacon-button",
  nestedComponents: ["beacon-icon"]
}, T$6 = T$7`:host([motion-state=enabled]) :is(a,button){--button-base-transition-duration: var(--beacon-reference-motion-duration-3);--scale-x-value: 1.05;--scale-y-value: 1.1;transition-property:var(--button-base-transition-property),transform}:host([motion-state=enabled]) :is(a,button):is(:active,:hover):not(.tertiary){transform:scale(var(--scale-x-value),var(--scale-y-value))}:host([motion-state=enabled]) :is(a,button):is(:active,:hover):not(.tertiary) .contents{transform:scale(calc(1 / var(--scale-x-value)),calc(1 / var(--scale-y-value)))}:host([state=success]){--button-flex-direction: row}:host([state=success]) button{background-color:var(--beacon-system-color-background-positive);border-color:var(--beacon-system-color-background-positive);overflow:hidden}:host([state=success]) button ::slotted([slot=icon]){display:none}:host([state=success]) button .contents{margin-inline-start:-1rem;padding-inline-start:1rem;transition:padding-inline-start var(--beacon-reference-motion-duration-2) ease-in}:host([state=success]) button .checkmark{opacity:1;position:relative;transform:translate(0);transition:opacity var(--beacon-reference-motion-duration-3) ease-in var(--beacon-reference-motion-duration-3),transform var(--beacon-reference-motion-duration-5) ease-in var(--beacon-reference-motion-duration-3);visibility:visible}:host([state=success]) button:hover{--scale-x-value: 1;--scale-y-value: 1;background-color:var(--beacon-system-color-background-positive-hover);border-color:var(--beacon-system-color-background-positive)}:host(:not([state=success])) button .checkmark{max-inline-size:0;opacity:0;position:absolute;transform:translate(-40%);visibility:hidden}`;
var C$8 = (o2, e5, s2, h2) => {
  for (var r3 = e5, t3 = o2.length - 1, n4; t3 >= 0; t3--)
    (n4 = o2[t3]) && (r3 = n4(r3) || r3);
  return r3;
};
function E$7(o2) {
  let e5 = class extends o2 {
    static get ButtonMotionStyles() {
      return [T$6];
    }
  };
  return e5 = C$8([
    f$8("ButtonMotion")
  ], e5), e5;
}
const S$9 = T$7`:host{display:inline-block;inline-size:var(--override-button-inline-size)}a,button{--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--bg-color);--text-color: var(--beacon-system-color-text-primary);--hover-bg-color: var(--beacon-system-color-background-primary-hover);--hover-text-color: var(--hover-bg-color);--disabled-bg-color: var(--beacon-system-color-background-primary-inactive);--disabled-text-color: var(--beacon-system-color-text-primary-inactive);--disabled-border-color: var(--disabled-bg-color);--active-bg-color: var(--beacon-system-color-background-primary-pressed);--active-text-color: var(--beacon-system-color-text-secondary-pressed);--active-border-color: var(--active-bg-color);--border-inline-start-width: var(--beacon-system-width-border-mini);--border-radius: var(--beacon-system-radius-corner-standard);--border-width: var(--beacon-system-width-border-mini);--default-gap: var(--beacon-reference-space-3);--font-weight: var(--beacon-system-font-weight-bold);--font-size: var(--beacon-reference-font-scale-4);--line-height: var(--beacon-reference-font-scale-4);background-color:var(--override-button-bg-color, var(--bg-color));border-color:var(--border-color);border-end-end-radius:var(--override-button-border-radius, var(--border-radius));border-end-start-radius:var(--override-button-border-radius, var(--border-radius));border-inline-start-width:var(--override-button-border-size-inline, var(--border-inline-start-width));border-start-end-radius:var(--override-button-border-radius, var(--border-radius));border-start-start-radius:var(--override-button-border-radius, var(--border-radius));border-style:solid;border-width:var(--override-button-border-width, var(--border-width));color:var(--text-color);display:inline-flex;flex-direction:var(--button-flex-direction, row);font:var(--font-weight) var(--beacon-component-button-normal-font-size-sans-serif-standard);gap:var(--override-button-icon-space-margin, var(--default-gap));inline-size:inherit;justify-content:center;outline-offset:1px;padding-block:var(--beacon-reference-space-4) var(--beacon-reference-space-4);padding-inline:var(--beacon-reference-space-5);text-align:start;word-break:initial}a .contents,button .contents{display:inherit;flex-direction:inherit;gap:inherit;justify-content:inherit}a[aria-disabled=true],button[aria-disabled=true]{background-color:var(--disabled-bg-color);border-color:var(--disabled-border-color);color:var(--disabled-text-color);cursor:not-allowed;text-decoration:none}a:is(:hover,:focus-visible):not([aria-disabled=true]),button:is(:hover,:focus-visible):not([aria-disabled=true]){background-color:var(--hover-bg-color);color:var(--hover-text-color);text-decoration:underline}a:active:not([aria-disabled=true]),button:active:not([aria-disabled=true]){background-color:var(--active-bg-color);color:var(--active-text-color);text-decoration:none}.mini{--default-gap: var(--override-button-default-gap, var(--beacon-reference-space-2));--default-font-size: var(--beacon-component-button-mini-font-size-sans-serif-standard);--default-line-height: var(--beacon-component-button-mini-line-height-sans-serif-standard);--font-size: var(--override-button-font-size-mini, var(--default-font-size));--line-height: var(--override-button-font-line-height-mini, var(--default-line-height));font:var(--font-weight) var(--beacon-component-button-mini-font-size-sans-serif-standard);margin-block:var(--beacon-reference-space-2);padding-block:var(--beacon-reference-space-3) var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}.normal{--default-padding-block-start: var(--beacon-reference-space-4);--default-padding-block-end: var(--beacon-reference-space-4);--default-padding-inline: var(--beacon-reference-space-5);--normal-font-size: var(--override-button-font-size-normal, var(--font-size));--normal-font-weight: var(--override-button-font-weight-normal, var(--font-weight));--component-font-size: var(--override-button-font-size, var(--beacon-component-button-normal-font-size-sans-serif-standard));font:var(--normal-font-weight) var(--component-font-size, var(--normal-font-size)/var(--line-height) var(--beacon-system-font-family-body));padding-block:var(--override-button-space-padding-block-start-normal, var(--default-padding-block-start)) var(--override-button-space-padding-block-end-normal, var(--default-padding-block-end));padding-inline:var(--override-button-space-padding-inline-normal, var(--default-padding-inline))}.jumbo{--font-size: var(--beacon-component-button-jumbo-font-size-sans-serif-standard);--line-height: var(--beacon-component-button-jumbo-line-height-sans-serif-standard);font:var(--font-weight) var(--beacon-component-button-jumbo-font-size-sans-serif-standard);padding-block:var(--beacon-reference-space-5) var(--beacon-reference-space-5);padding-inline:var(--beacon-reference-space-7)}.primary{--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--override-button-color-border-error, var(--bg-color));--text-color: var(--beacon-system-color-text-primary);--hover-bg-color: var(--beacon-system-color-background-primary-hover);--hover-text-color: var(--text-color);--disabled-bg-color: var(--beacon-system-color-background-primary-inactive);--disabled-text-color: var(--beacon-system-color-text-primary-inactive);--disabled-border-color: var(--disabled-bg-color);--active-bg-color: var(--beacon-system-color-background-primary-pressed);--active-text-color: var(--text-color)}.secondary{--bg-color: transparent;--border-color: var(--beacon-system-color-border-secondary);--text-color: var(--beacon-system-color-text-secondary);--hover-bg-color: var(--beacon-system-color-background-secondary-hover);--hover-border-color: var(--beacon-system-color-border-secondary-hover);--hover-text-color: var(--beacon-system-color-text-secondary-hover);--disabled-bg-color: var(--bg-color);--disabled-text-color: var(--beacon-system-color-text-secondary-inactive);--disabled-border-color: var(--beacon-system-color-border-secondary-inactive);--active-bg-color: var(--beacon-system-color-background-secondary-pressed);--active-text-color: var(--beacon-system-color-text-secondary-pressed)}.tertiary{--standard-default-color: var(--beacon-system-color-text-tertiary);--standard-hover-color: var(--beacon-system-color-text-tertiary-hover);--standard-active-color: var(--beacon-system-color-text-tertiary-pressed);--standard-disabled-color: var(--beacon-system-color-text-tertiary-inactive);--bg-color: var(--override-button-color-background-tertiary-default, transparent);--border-color: var(--override-button-color-border-error, var(--override-button-color-border-tertiary-default, var(--bg-color)));--text-color: var(--override-button-color-text-tertiary-default, var(--standard-default-color));--hover-bg-color: var(--bg-color);--disabled-border-color: var(--bg-color);--hover-text-color: var(--override-button-color-text-tertiary-default, var(--standard-hover-color));--disabled-bg-color: var(--bg-color);--disabled-text-color: var(--override-button-color-text-tertiary-inactive, var(--standard-disabled-color));--active-bg-color: var(--bg-color);--active-text-color: var(--override-button-color-text-tertiary-default, var(--standard-active-color));padding-inline:var(--override-button-space-padding-tertiary, 0)}.positive{--bg-color: var(--beacon-system-color-background-positive);--border-color: var(--bg-color);--text-color: var(--beacon-system-color-text-set-white);--hover-bg-color: var(--beacon-system-color-background-positive-hover);--hover-text-color: var(--text-color);--active-bg-color: var(--beacon-system-color-background-positive-pressed);--active-text-color: var(--text-color)}.negative{--bg-color: var(--beacon-system-color-background-negative);--border-color: var(--bg-color);--text-color: var(--beacon-system-color-text-set-white);--hover-bg-color: var(--beacon-system-color-background-negative-hover);--hover-text-color: var(--text-color);--active-bg-color: var(--beacon-system-color-background-negative-pressed);--active-text-color: var(--text-color)}`;
var N$7 = Object.defineProperty, g$8 = (o2, e5, s2, h2) => {
  for (var r3 = void 0, t3 = o2.length - 1, n4; t3 >= 0; t3--)
    (n4 = o2[t3]) && (r3 = n4(e5, s2, r3) || r3);
  return r3 && N$7(e5, s2, r3), r3;
};
const l$9 = class l extends B$5(Yt$2).with(E$7) {
  constructor() {
    super(...arguments), this.beaconTagName = i$5.beaconTagName, this.scale = o$9.NORMAL, this.state = mt$1.NONE;
  }
  static get styles() {
    return [super.styles, S$9, this.ButtonMotionStyles];
  }
  /**
   * Render function for beacon-button if link-href propety is passed in to support links as buttons
   *
   * @returns {TemplateResult} returns an `<a>` tag styled as a button
   */
  renderAnchorTag() {
    var e5;
    return tt$1`<a
      id="${e$6(this._passthroughs.attributes.get("id"))}"
      @click=${this.handleClick}
      href="${this.linkHref}"
      download="${e$6(this.linkDownload)}"
      target="${e$6(this.linkTarget)}"
      class="${this.variant} ${this.scale}"
      aria-disabled="${this.disabled}"
      data-metrics-link-text="${(e5 = this.defaultSlotText) != null ? e5 : h$c}">
      <span class="contents">
        <slot name="prefix" @slotchange=${this.handleAffixSlotChanges}></slot>
        <slot @slotchange=${this.setDefaultSlotText}>
          ${this.defaultSlotText}
        </slot>
        <slot name="suffix" @slotchange=${this.handleAffixSlotChanges}></slot>
      </span>
    </a>`;
  }
  /**
   * Render function for beacon-button as a `<button>` element
   *
   * @returns {TemplateResult} returns a `<button>` tag as the template
   */
  renderButtonTag() {
    var e5;
    return kt$1`<button
      id="${e$6(this._passthroughs.attributes.get("id"))}"
      part="standard-button"
      @click=${this.handleClick}
      class="${this.variant} ${this.scale}"
      aria-disabled="${this.disabled}"
      type="${this.type}"
      data-metrics-link-text="${(e5 = this.defaultSlotText) != null ? e5 : h$c}">
      <span class="contents">
        <${this.getScopedTag("beacon-icon")} name='correct' class="checkmark"></${this.getScopedTag("beacon-icon")}>
        <slot name="prefix" @slotchange=${this.handleAffixSlotChanges}></slot>
        <slot @slotchange=${this.setDefaultSlotText}></slot>
        <slot name="suffix" @slotchange=${this.handleAffixSlotChanges}></slot>
      </span>
    </button>`;
  }
  render() {
    return tt$1` ${r$b(
      this.linkHref,
      () => this.renderAnchorTag(),
      () => this.renderButtonTag()
    )}`;
  }
};
l$9.tagName = i$5.beaconTagName, l$9.nestedComponents = i$5.nestedComponents;
let a$9 = l$9;
g$8([
  v$c({ reflect: true })
], a$9.prototype, "scale");
g$8([
  v$c({ reflect: true })
], a$9.prototype, "state");
const F$3 = (o2) => (Se$3(o2, a$9), Dt$3({
  tagName: o2 ? o2 + "-" + a$9.tagName : a$9.tagName,
  elementClass: a$9,
  react: React,
  events: {
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function a$8(n4) {
  return (s2, d3) => {
    const { slot: e5, selector: t3 } = n4 != null ? n4 : {}, i5 = "slot" + (e5 ? `[name=${e5}]` : ":not([name])");
    return r$9(s2, d3, { get() {
      var r3, o2;
      const l4 = (r3 = this.renderRoot) == null ? void 0 : r3.querySelector(i5), u2 = (o2 = l4 == null ? void 0 : l4.assignedElements(n4)) != null ? o2 : [];
      return t3 === void 0 ? u2 : u2.filter((c4) => c4.matches(t3));
    } });
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const T$5 = { ATTRIBUTE: 1, CHILD: 2, PROPERTY: 3, BOOLEAN_ATTRIBUTE: 4, EVENT: 5, ELEMENT: 6 }, _$4 = (r3) => (...t3) => ({ _$litDirective$: r3, values: t3 });
let i$4 = class i {
  constructor(t3) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t3, e5, s2) {
    this._$Ct = t3, this._$AM = e5, this._$Ci = s2;
  }
  _$AS(t3, e5) {
    return this.update(t3, e5);
  }
  update(t3, e5) {
    return this.render(...e5);
  }
};
function t$7() {
  return `${Math.floor(Math.random() * 1e10)}`.padStart(4, "0");
}
const o$8 = class l2 extends i$4 {
  constructor() {
    super(...arguments), this.uuid = t$7(), this.slotHasEvent = false, this.usingParentElement = false, this.containerSelector = "", this.totalSlottedElements = 0, this.handleSlotchange = (t3) => {
      if (t3.eventPhase !== 2)
        return;
      const s2 = t3.target, a2 = s2 == null ? void 0 : s2.assignedElements();
      let e5;
      this.totalSlottedElements = a2.length, this.containerSelector ? e5 = this.findContainerElement(s2) : e5 = this.usingParentElement ? s2.parentElement : s2, this.totalSlottedElements < 1 ? (e5 == null || e5.classList.add(l2.defaultClassName), e5 == null || e5.classList.remove(this.hasSlottedClassName)) : (e5 == null || e5.classList.remove(l2.defaultClassName), e5 == null || e5.classList.add(this.hasSlottedClassName));
    };
  }
  get hasSlottedClassName() {
    return `has-slotted-${this.uuid}`;
  }
  findContainerElement(t3) {
    if (this.containerSelector)
      return t3.closest(this.containerSelector);
  }
  /** Create and append a small set of styles when the directive is used. */
  static createStyleElement(t3) {
    const s2 = document.createElement("style");
    s2.innerHTML = `.${l2.defaultClassName}:not([class*='has-slotted-']) {display: none !important;}`, s2.id = l2.stylesID, t3.appendChild(s2);
  }
  update(t3, [s2 = { useParent: false }]) {
    const { useParent: a2, container: e5 } = s2, n4 = t3.element, r3 = n4.getRootNode(), { parentElement: d3 } = n4;
    a2 && (this.usingParentElement = true), e5 && (this.containerSelector = e5);
    const i5 = {};
    return this.containerSelector ? i5.element = this.findContainerElement(n4) : a2 && d3 ? i5.element = d3 : i5.element = n4, r3.querySelector(`#${l2.stylesID}`) || l2.createStyleElement(r3), this.slotHasEvent || (n4.addEventListener("slotchange", this.handleSlotchange), this.slotHasEvent = true), this.render(i5);
  }
  /**
   * The directive takes a single object parameter. If your slot has a parent that dictates styling, then set `useParent` to true. The element to be updated will be handled automatically as either the parent element or the slot directly, but if you have a case where the element you need to hide is higher up, you can pass an HTML element reference into the object.
   *
   * ```ts
   * html`<div class="slot-wrapper">
   *    <slot ${showIfUsed({useParent: true})}></slot>
   * </div>`
   *
   * html`<slot ${showIfUsed()}></slot>`
   * ```
   */
  render({ element: t3 } = { useParent: false }) {
    t3 && this.totalSlottedElements < 1 && (t3.classList.add(l2.defaultClassName), t3.classList.remove(this.hasSlottedClassName)), t3 && this.totalSlottedElements >= 1 && t3.classList.add(this.hasSlottedClassName);
  }
};
o$8.defaultClassName = "hide-slot-area", o$8.stylesID = "show-if-used-directive-styles";
let u$1 = o$8;
const f$7 = _$4(u$1);
var b$b = Object.defineProperty, E$6 = Object.getOwnPropertyDescriptor, o$7 = (n4, e5, t3, i5) => {
  for (var r3 = i5 > 1 ? void 0 : i5 ? E$6(e5, t3) : e5, s2 = n4.length - 1, a2; s2 >= 0; s2--)
    (a2 = n4[s2]) && (r3 = (i5 ? a2(e5, t3, r3) : a2(r3)) || r3);
  return i5 && r3 && b$b(e5, t3, r3), r3;
};
function j$4(n4) {
  let e5 = class extends n4 {
    constructor() {
      super(...arguments), this.disabled = false, this.allowableInteractiveKeys = ["Shift", "Tab"], this.preventDisabledEvents = (t3) => {
        if (this.disabled)
          if (t3 instanceof KeyboardEvent) {
            const { key: i5 } = t3;
            this.allowableInteractiveKeys.includes(i5) || t3.preventDefault();
          } else
            t3.preventDefault();
      };
    }
    preventDisabledEventsOnElement(t3, i5 = ["click", "keydown"]) {
      for (const r3 of i5)
        t3 == null || t3.addEventListener(r3, this.preventDisabledEvents);
    }
  };
  return o$7([
    v$c({ type: Boolean, reflect: true })
  ], e5.prototype, "disabled", 2), e5 = o$7([
    f$8("Disablable")
  ], e5), e5;
}
var y$5 = Object.defineProperty, g$7 = Object.getOwnPropertyDescriptor, d$c = (n4) => {
  throw TypeError(n4);
}, l$8 = (n4, e5, t3, i5) => {
  for (var r3 = i5 > 1 ? void 0 : i5 ? g$7(e5, t3) : e5, s2 = n4.length - 1, a2; s2 >= 0; s2--)
    (a2 = n4[s2]) && (r3 = (i5 ? a2(e5, t3, r3) : a2(r3)) || r3);
  return i5 && r3 && y$5(e5, t3, r3), r3;
}, p$8 = (n4, e5, t3) => e5.has(n4) || d$c("Cannot " + t3), w$6 = (n4, e5, t3) => (p$8(n4, e5, "read from private field"), t3 ? t3.call(n4) : e5.get(n4)), D$3 = (n4, e5, t3) => e5.has(n4) ? d$c("Cannot add the same private member more than once") : e5 instanceof WeakSet ? e5.add(n4) : e5.set(n4, t3), O$3 = (n4, e5, t3, i5) => (p$8(n4, e5, "write to private field"), e5.set(n4, t3), t3);
function x$5(n4) {
  var e5;
  let t3 = class extends n4 {
    constructor() {
      super(...arguments), D$3(this, e5);
    }
    get hintElement() {
      return w$6(this, e5);
    }
    set hintElement(i5) {
      O$3(this, e5, i5), this.hintElement && !this.hintElement.id && (this.hintElement.id = t$7()), this.postSetHintElement();
    }
    postSetHintElement() {
    }
    handleHintSlotchange() {
      this.hintElement = this.hintElements[0];
    }
    renderHintTemplate() {
      return tt$1`
        <div id="hint" class="hint">
          <slot
            name="hint"
            @slotchange=${this.handleHintSlotchange}
            ${f$7({ useParent: true })}></slot>
        </div>
      `;
    }
  };
  return e5 = /* @__PURE__ */ new WeakMap(), l$8([
    a$8({ flatten: true, slot: "hint" })
  ], t3.prototype, "hintElements", 2), t3 = l$8([
    f$8("Hintable")
  ], t3), t3;
}
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const f$6 = _$4(class extends i$4 {
  constructor(s2) {
    var e5;
    if (super(s2), s2.type !== T$5.ATTRIBUTE || s2.name !== "class" || ((e5 = s2.strings) == null ? void 0 : e5.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(s2) {
    return " " + Object.keys(s2).filter((e5) => s2[e5]).join(" ") + " ";
  }
  update(s2, [e5]) {
    var r3, i5;
    if (this.st === void 0) {
      this.st = /* @__PURE__ */ new Set(), s2.strings !== void 0 && (this.nt = new Set(s2.strings.join(" ").split(/\s/).filter((t3) => t3 !== "")));
      for (const t3 in e5) e5[t3] && !((r3 = this.nt) != null && r3.has(t3)) && this.st.add(t3);
      return this.render(e5);
    }
    const n4 = s2.element.classList;
    for (const t3 of this.st) t3 in e5 || (n4.remove(t3), this.st.delete(t3));
    for (const t3 in e5) {
      const o2 = !!e5[t3];
      o2 === this.st.has(t3) || (i5 = this.nt) != null && i5.has(t3) || (o2 ? (n4.add(t3), this.st.add(t3)) : (n4.remove(t3), this.st.delete(t3)));
    }
    return N$8;
  }
});
var g$6 = Object.defineProperty, v$8 = Object.getOwnPropertyDescriptor, l$7 = (e5) => {
  throw TypeError(e5);
}, s$9 = (e5, r3, t3, o2) => {
  for (var n4 = o2 > 1 ? void 0 : o2 ? v$8(r3, t3) : r3, a2 = e5.length - 1, i5; a2 >= 0; a2--)
    (i5 = e5[a2]) && (n4 = (o2 ? i5(r3, t3, n4) : i5(n4)) || n4);
  return o2 && n4 && g$6(r3, t3, n4), n4;
}, m$a = (e5, r3, t3) => r3.has(e5) || l$7("Cannot " + t3), $$5 = (e5, r3, t3) => (m$a(e5, r3, "read from private field"), t3 ? t3.call(e5) : r3.get(e5)), S$8 = (e5, r3, t3) => r3.has(e5) ? l$7("Cannot add the same private member more than once") : r3 instanceof WeakSet ? r3.add(e5) : r3.set(e5, t3), b$a = (e5, r3, t3, o2) => (m$a(e5, r3, "write to private field"), r3.set(e5, t3), t3);
function k$8(e5) {
  var r3;
  let t3 = class extends e5 {
    constructor() {
      super(...arguments), this.invalid = false, S$8(this, r3);
    }
    get errorElement() {
      return $$5(this, r3);
    }
    set errorElement(o2) {
      b$a(this, r3, o2), this.errorElement && !this.errorElement.id && (this.errorElement.id = t$7()), this.postSetErrorElement();
    }
    postSetErrorElement() {
    }
    handleErrorSlotchange() {
      this.errorElement = this.errorElements[0];
    }
    renderErrorTemplate() {
      const o2 = {
        error: true,
        visible: this.invalid
      };
      return kt$1`
        <${this.getScopedTag("beacon-error")} id="error" class="${f$6(o2)}" role="alert">
          <slot name="error" @slotchange=${this.handleErrorSlotchange} ${f$7({ useParent: true })}></slot>
        </${this.getScopedTag("beacon-error")}>
      `;
    }
  };
  return r3 = /* @__PURE__ */ new WeakMap(), s$9([
    a$8({ flatten: true, slot: "error" })
  ], t3.prototype, "errorElements", 2), s$9([
    v$c({ type: Boolean, reflect: true })
  ], t3.prototype, "invalid", 2), t3 = s$9([
    f$8("Errorable")
  ], t3), t3;
}
const p$7 = {
  beaconTagName: "beacon-control-group"
}, q$2 = T$7`[beacon-tag-name=beacon-control-group] [slot=label]:not(label){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-50)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control] label{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control]:has(input)[toggle-switch] label{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control]:has(input[aria-disabled=true],:disabled) label{color:var(--beacon-system-color-text-inactive)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control]:has([type=radio],[type=checkbox]){padding-block:var(--beacon-reference-space-3);padding-inline-end:var(--beacon-reference-space-3)}`, C$7 = T$7`fieldset{border:0;margin:0;padding:0}legend{margin-block-end:var(--beacon-reference-space-3);padding:0}.error:not(.visible){display:none}.hint{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.hint,.error{margin-block-start:var(--beacon-reference-space-3)}`;
var y$4 = (n4) => {
  throw TypeError(n4);
}, E$5 = (n4, e5, t3) => e5.has(n4) || y$4("Cannot " + t3), m$9 = (n4, e5, t3) => (E$5(n4, e5, "read from private field"), t3 ? t3.call(n4) : e5.get(n4)), v$7 = (n4, e5, t3) => e5.has(n4) ? y$4("Cannot add the same private member more than once") : e5 instanceof WeakSet ? e5.add(n4) : e5.set(n4, t3), l$6 = (n4, e5, t3, a2) => (E$5(n4, e5, "write to private field"), e5.set(n4, t3), t3), N$6 = Object.defineProperty, M$5 = Object.getOwnPropertyDescriptor, d$b = (n4, e5, t3, a2) => {
  for (var r3 = M$5(e5, t3), c4 = n4.length - 1, h2; c4 >= 0; c4--)
    (h2 = n4[c4]) && (r3 = h2(e5, t3, r3) || r3);
  return r3 && N$6(e5, t3, r3), r3;
}, i$3, s$8;
const b$9 = class b extends B$5(Bt$3).with(
  x$5,
  k$8,
  j$4
) {
  constructor() {
    super(...arguments), v$7(this, i$3), v$7(this, s$8), this.beaconTagName = p$7.beaconTagName, this.resetSpacing = true, this.focusOverride = true, l$6(this, i$3, false), l$6(this, s$8, "false");
  }
  static get styles() {
    return [super.styles, C$7];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, q$2];
  }
  get required() {
    return m$9(this, i$3);
  }
  set required(e5) {
    l$6(this, i$3, e5), this.controls.length > 0 && this.controls.forEach((t3) => this.setRequiredToField(t3));
  }
  _postSetDisabled() {
    this.controls.length > 0 && this.controls.forEach((e5) => this.setDisabledToField(e5));
  }
  get isAriaDisabled() {
    return m$9(this, s$8);
  }
  set isAriaDisabled(e5) {
    l$6(this, s$8, e5), this.controls.length > 0 && this.controls.forEach((t3) => this.setDisabledToField(t3, "aria"));
  }
  _postSetInvalid() {
    this.controls.length > 0 && this.controls.forEach((e5) => this.setInvalidToField(e5));
  }
  get controls() {
    return Array.from(
      this.querySelectorAll('[beacon-tag-name="beacon-control"]')
    );
  }
  getAriaDescribedByIds() {
    var e5, t3;
    const a2 = [(e5 = this.hintElement) == null ? void 0 : e5.id];
    return this.invalid && a2.push((t3 = this.errorElement) == null ? void 0 : t3.id), a2;
  }
  handleSlottedControlFieldSet(e5) {
    const { target: t3 } = e5;
    t3 && (this.disabled && this.setDisabledToField(t3), this.isAriaDisabled && this.setDisabledToField(t3, "aria"), this.invalid && this.setInvalidToField(t3), this.required && this.setRequiredToField(t3), this.setHintDataId(t3), t3.setFieldAriaDescribedBy(
      this.getAriaDescribedByIds()
    ));
  }
  setRequiredToField(e5) {
    e5.fieldElement && (e5.fieldElement.required = this.required);
  }
  setDisabledToField(e5, t3 = "boolean") {
    e5.fieldElement && (t3 === "boolean" && (e5.fieldElement.disabled = this.disabled), t3 === "aria" && e5.fieldElement.setAttribute(
      "aria-disabled",
      String(this.isAriaDisabled)
    ));
  }
  setInvalidToField(e5) {
    var t3;
    e5.fieldElement && (e5.dataset.errorId = (t3 = this.errorElement) == null ? void 0 : t3.id, e5.fieldElement.setAttribute("aria-invalid", String(this.invalid)));
  }
  setHintDataId(e5) {
    var t3, a2;
    e5.fieldElement && (t3 = this.hintElement) != null && t3.id && (e5.dataset.hintId = (a2 = this.hintElement) == null ? void 0 : a2.id);
  }
  render() {
    return tt$1`
      <fieldset>
        <legend>
          <slot name="label" ${f$7({ useParent: true })}></slot>
        </legend>
        <div class="controls">
          <slot
            @beacon-event-control-set=${this.handleSlottedControlFieldSet}></slot>
        </div>
        ${this.renderHintTemplate()} ${this.renderErrorTemplate()}
      </fieldset>
    `;
  }
};
i$3 = /* @__PURE__ */ new WeakMap(), s$8 = /* @__PURE__ */ new WeakMap(), b$9.tagName = p$7.beaconTagName, b$9.nestedComponents = ["beacon-error"];
let o$6 = b$9;
d$b([
  v$c({ type: Boolean, reflect: true })
], o$6.prototype, "required");
d$b([
  x$7("disabled")
], o$6.prototype, "_postSetDisabled");
d$b([
  v$c({ attribute: "aria-disabled" })
], o$6.prototype, "isAriaDisabled");
d$b([
  x$7("invalid")
], o$6.prototype, "_postSetInvalid");
const W$1 = (n4) => (Se$3(n4, o$6), Dt$3({
  tagName: n4 ? n4 + "-" + o$6.tagName : o$6.tagName,
  elementClass: o$6,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const e$5 = "0.5rem", r$8 = "#0C2A4DCC", m$8 = "0.25rem", p$6 = "0.5rem", t$6 = "320px", C$6 = "640px", c$8 = "960px", n$9 = "1280px", s$7 = "0.5rem";
var L$5 = ((r3) => (r3[r3.DEFAULT = parseInt(t$6, 10)] = "DEFAULT", r3[r3.MEDIUM = parseInt(C$6, 10)] = "MEDIUM", r3[r3.LARGE = parseInt(c$8, 10)] = "LARGE", r3[r3.XLARGE = parseInt(n$9, 10)] = "XLARGE", r3))(L$5 || {});
var c$7 = Object.defineProperty, u = Object.getOwnPropertyDescriptor, a$7 = (t3) => {
  throw TypeError(t3);
}, s$6 = (t3, e5, r3, n4) => {
  for (var o2 = n4 > 1 ? void 0 : n4 ? u(e5, r3) : e5, l4 = t3.length - 1, i5; l4 >= 0; l4--)
    (i5 = t3[l4]) && (o2 = (n4 ? i5(e5, r3, o2) : i5(o2)) || o2);
  return n4 && o2 && c$7(e5, r3, o2), o2;
}, p$5 = (t3, e5, r3) => e5.has(t3) || a$7("Cannot " + r3), E$4 = (t3, e5, r3) => (p$5(t3, e5, "read from private field"), r3 ? r3.call(t3) : e5.get(t3)), y$3 = (t3, e5, r3) => e5.has(t3) ? a$7("Cannot add the same private member more than once") : e5 instanceof WeakSet ? e5.add(t3) : e5.set(t3, r3), g$5 = (t3, e5, r3, n4) => (p$5(t3, e5, "write to private field"), e5.set(t3, r3), r3);
function v$6(t3) {
  var e5;
  let r3 = class extends t3 {
    constructor() {
      super(...arguments), y$3(this, e5);
    }
    get fieldElement() {
      return E$4(this, e5);
    }
    set fieldElement(n4) {
      g$5(this, e5, n4), this.postSetFormControlElement();
    }
    get currentInputType() {
      if (this.fieldElement)
        return this.fieldElement.type;
    }
    postSetFormControlElement() {
    }
    postFormControlSlotchange() {
    }
    handleFormControlSlotchange() {
      this.fieldElement = this.fieldElements[0], this.postFormControlSlotchange();
    }
    setInputType() {
      this.fieldElement instanceof HTMLInputElement ? this._inputType = this.fieldElement.type : this._inputType = this.fieldElement.localName;
    }
    renderFormControlTemplate() {
      return tt$1`<slot
        @slotchange=${this.handleFormControlSlotchange}></slot>`;
    }
  };
  return e5 = /* @__PURE__ */ new WeakMap(), s$6([
    a$8({ flatten: true })
  ], r3.prototype, "fieldElements", 2), s$6([
    it()
  ], r3.prototype, "_inputType", 2), r3 = s$6([
    f$8("FormControl")
  ], r3), r3;
}
function e$4(n4, t3, c4) {
  const r3 = n4[t3];
  if (r3 !== void 0) return r3;
  const u2 = c4();
  return n4[t3] = u2, u2;
}
var _$3 = /* @__PURE__ */ ((e5) => (e5.PRIMARY = "primary", e5.SECONDARY = "secondary", e5))(_$3 || {});
const y$2 = {
  beaconTagName: "beacon-control",
  beaconNestedComponents: [
    "beacon-error",
    "beacon-button",
    "beacon-icon",
    "beacon-icon-button"
  ]
}, j$3 = T$7`[beacon-tag-name=beacon-control]:has([type=hidden]){display:none}[beacon-tag-name=beacon-control] input:is(:-webkit-autofill,:autofill){border-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-control]:has(input:checked)::part(field){--hover-outline-color: var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control]:has(input:checked)[invalid]::part(field){border-color:var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control]:has(input:checked)[disabled]:not([invalid])::part(field){border-color:transparent}[beacon-tag-name=beacon-control]:has(input:checked) label{font-weight:var(--beacon-system-font-weight-bold)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard);gap:var(--beacon-reference-space-4);inline-size:36px;min-block-size:var(--beacon-reference-space-10);padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input::-webkit-inner-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input.invalid{outline:var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input:hover{outline:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input:focus-visible{outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:var(--beacon-system-width-border-normal);position:relative;z-index:1}[beacon-tag-name=beacon-control] .option-label{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch] [type=checkbox].beacon-control__field{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;background-image:none;block-size:100%;border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-round);cursor:pointer;inline-size:100%;inset-block-start:0;inset-inline-start:0;position:absolute}[beacon-tag-name=beacon-control]:has(input)[toggle-switch] [type=checkbox].beacon-control__field[aria-disabled=true],[beacon-tag-name=beacon-control]:has(input)[toggle-switch] [type=checkbox].beacon-control__field[disabled]{border:0}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]::part(field){block-size:var(--beacon-reference-space-8);border-radius:var(--beacon-system-radius-corner-round);inline-size:var(--beacon-reference-space-12);position:relative}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]::part(field):before{background-color:var(--beacon-system-color-background-2);block-size:var(--beacon-reference-space-5);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:50%;content:"";inline-size:var(--beacon-reference-space-5);inset-block-start:50%;inset-inline-start:var(--beacon-reference-space-2);pointer-events:none;position:absolute;transform:translateY(-50%)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)::part(field){background-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)::part(field):hover{--hover-outline-color: transparent;background-color:var(--beacon-system-color-background-primary-hover)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)::part(field):before{block-size:var(--beacon-reference-space-6);border:0;inline-size:var(--beacon-reference-space-6);inset-inline-start:calc(100% - var(--beacon-reference-space-6) - var(--beacon-reference-space-2))}[beacon-tag-name=beacon-control]:has(input)[toggle-switch][disabled] label{color:var(--beacon-system-color-text-inactive)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch][disabled]::part(field):before{border-color:var(--beacon-component-form-color-foreground-inactive)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)[aria-disabled=true]::part(field),[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)[disabled]::part(field){background-color:var(--beacon-component-form-color-foreground-inactive);cursor:not-allowed}[beacon-tag-name=beacon-control]:has(textarea){--control-overflow: hidden}[beacon-tag-name=beacon-control]:has(textarea):not([non-resizable]){--control-resize: both}[beacon-tag-name=beacon-control]:has(textarea) textarea{block-size:100%;inline-size:100%;resize:none}[beacon-tag-name=beacon-control]:has([slot=prefix]){--control-padding-inline-start: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-control]:has([slot=suffix]),[beacon-tag-name=beacon-control]:has([type=password]):not([disable-password-toggle]){--control-padding-inline-end: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-control]:has([aria-disabled=true]) label{pointer-events:none}[beacon-tag-name=beacon-control] label{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-50)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]) .beacon-control__field:is([type=number]){background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-reference-space-8)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]) .beacon-control__field:is([type=number]):is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-background-inactive);border:0}[beacon-tag-name=beacon-control]:not([stepper-variant=none]) .beacon-control__field:is([type=number]):is([aria-invalid=true],:invalid){border:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control] .beacon-control__field{background-color:transparent;border:0;color:var(--beacon-system-color-text-standard);inline-size:100%;outline:0}[beacon-tag-name=beacon-control] .beacon-control__field:not([type=checkbox],[type=radio],select){padding-block:var(--beacon-reference-space-3);padding-inline:var(--control-padding-inline-start, var(--beacon-reference-space-4)) var(--control-padding-inline-end, var(--beacon-reference-space-4))}[beacon-tag-name=beacon-control] .beacon-control__field[aria-disabled=true],[beacon-tag-name=beacon-control] .beacon-control__field:disabled{caret-color:transparent;color:var(--beacon-system-color-text-inactive);cursor:not-allowed}[beacon-tag-name=beacon-control] .beacon-control__field:is([type=checkbox],[type=radio]){-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-reference-space-8);cursor:pointer;inline-size:var(--beacon-reference-space-8)}[beacon-tag-name=beacon-control] .beacon-control__field:is([type=checkbox],[type=radio]):is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-background-inactive);border:0}@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none){[beacon-tag-name=beacon-control] .beacon-control__field[type=date]{block-size:var(--beacon-reference-space-10)}}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]{border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked{accent-color:var(--beacon-system-color-background-primary);-webkit-appearance:revert;-moz-appearance:revert;appearance:revert}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-disabled=true],:disabled){accent-color:var(--beacon-component-form-color-foreground-inactive)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-invalid=true],:invalid){accent-color:var(--beacon-system-color-icon-error)}@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none){[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-primary);background-image:url("data:image/svg+xml,%3Csvg width='15' height='13' viewBox='0 0 15 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 7.51852L5.78947 12L14 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");background-position:center;background-repeat:no-repeat;border-radius:unset}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-foreground-inactive);border:0}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-invalid=true],:invalid){background-color:var(--beacon-system-color-icon-error);border:0}}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:is([aria-invalid=true]){border:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:is([aria-invalid=true]):hover{border-color:var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:focus-within{border-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:hover{border:2px solid var(--beacon-component-form-color-border-standard)}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]{border-radius:50%;padding:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]:checked{background-clip:content-box;background-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]:checked:is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-foreground-inactive);border:0}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]:checked:is([aria-invalid=true],:invalid){background-color:var(--beacon-system-color-icon-error);border:0}[beacon-tag-name=beacon-control] .beacon-control__field:is(select){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;padding-block:var(--beacon-reference-space-3);padding-inline:var(--control-padding-inline-start, var(--beacon-reference-space-4)) var(--control-padding-inline-end, var(--beacon-reference-space-9))}[beacon-tag-name=beacon-control] .beacon-control__field:is(select) option{color:var(--beacon-reference-palette-grayscale-dark-gray-3)}[beacon-tag-name=beacon-control] .beacon-control__field:is(select)[disabled],[beacon-tag-name=beacon-control] .beacon-control__field:is(select)[aria-disabled=true]{opacity:.7}[beacon-tag-name=beacon-control][data-mode=dark] :is(input,textarea,select){color-scheme:dark}`, Y$2 = T$7`:host{display:flex;flex-direction:column}.group{align-items:var(--control-alignment, start);display:flex;flex-direction:var(--beacon-custom-control-flex-direction, var(--control-direction, column));gap:var(--beacon-reference-space-3);inline-size:var(--control-group-inline-size, 100%);justify-content:start}.group.inline{--control-direction: row-reverse}.group.inline .field{flex-shrink:0}.group:has(.radio,.checkbox){--control-alignment: center;gap:var(--beacon-reference-space-4)}.group:has(.date){--control-group-inline-size: fit-content}.field{align-items:center;background-color:var(--beacon-system-color-background-1);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard);display:flex;font:var(--beacon-system-font-weight-light) var(--beacon-component-form-font-size-sans-serif-standard);overflow:var(--control-overflow, initial);resize:var(--control-resize, none)}.field:not(.radio,.checkbox){inline-size:var(--beacon-custom-control-inline-size, var(--control-inline-size, 100%))}.field.select{position:relative}.field.select .dropdown-icon{color:var(--beacon-system-color-icon-link);inset-inline-end:var(--beacon-reference-space-3);position:absolute}.field.disabled{background-color:var(--beacon-component-form-color-background-inactive);border-color:transparent;pointer-events:none}.field.disabled .dropdown-icon{color:var(--beacon-reference-palette-grayscale-light-gray-2)}.field.readonly{background-color:var(--beacon-system-color-background-0);border-color:var(--beacon-system-color-border-0)}.field.invalid{border-color:var(--beacon-system-color-border-error)}.field.invalid:not(.checkbox){outline:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-error)}.field.invalid:where(.number.stepper){outline:none}.field:hover:not(.invalid,:focus-within,.checkbox){outline:var(--beacon-system-width-border-mini) solid var(--hover-outline-color, var(--beacon-component-form-color-border-standard))}.field:focus-within{border-color:var(--beacon-system-color-border-primary)}.field:focus-within:not(:has([name=prefix]:focus-within)){outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:var(--beacon-system-width-border-normal);position:relative;z-index:1}.field:focus-within.invalid{border-color:var(--beacon-system-color-border-error)}.field:focus-within.disabled{border-color:var(--beacon-system-color-border-primary)}.field:focus-within.readonly{border-color:var(--beacon-system-color-border-0)}.field:where(.date){--control-inline-size: 100%}.field:where(.select){--control-inline-size: 100%}@media (width >= 640px){.field:where(.select){--control-inline-size: fit-content}}.field:where(.radio){border-radius:50%}.field.number.stepper{background:transparent;border:0;gap:var(--beacon-reference-space-3)}.field.number.stepper:is(:hover,:focus-within){outline:none}.field.checkbox{border:0}.prefix,.suffix{flex-shrink:0}.prefix{margin-inline-start:var(--beacon-reference-space-4)}.suffix{margin-inline-end:var(--beacon-reference-space-4)}.suffix.password:not(.password-visible) .hide-password{display:none}.suffix.password.password-visible .show-password{display:none}.suffix.password ::part(standard-button){margin:0;padding:0;position:relative}.suffix.password ::part(standard-button):before{block-size:var(--beacon-reference-space-10);content:"";inline-size:var(--beacon-reference-space-10);inset-block-start:calc(-1 * var(--beacon-reference-space-4));position:absolute}.toggle-switch-label:not(.checkbox-checked) .switch-on-label{display:none}.toggle-switch-label.checkbox-checked .switch-off-label{display:none}.stepper{margin-inline:0}.hint{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.error:not(.visible){display:none}.hint,.error{margin-block-start:var(--beacon-reference-space-2)}.beacon-stepper-button{--override-icon-button-wrapper-block-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-9);align-items:flex-start;display:flex;padding:var(--beacon-reference-space-2)}`;
var z$2 = (e5) => {
  throw TypeError(e5);
}, $$4 = (e5, t3, n4) => t3.has(e5) || z$2("Cannot " + n4), k$7 = (e5, t3, n4) => ($$4(e5, t3, "read from private field"), n4 ? n4.call(e5) : t3.get(e5)), E$3 = (e5, t3, n4) => t3.has(e5) ? z$2("Cannot add the same private member more than once") : t3 instanceof WeakSet ? t3.add(e5) : t3.set(e5, n4), w$5 = (e5, t3, n4, r3) => ($$4(e5, t3, "write to private field"), t3.set(e5, n4), n4), G$3 = Object.defineProperty, Q$1 = Object.getOwnPropertyDescriptor, a$6 = (e5, t3, n4, r3) => {
  for (var i5 = r3 > 1 ? void 0 : r3 ? Q$1(t3, n4) : t3, f2 = e5.length - 1, v3; f2 >= 0; f2--)
    (v3 = e5[f2]) && (i5 = (r3 ? v3(t3, n4, i5) : v3(i5)) || i5);
  return r3 && i5 && G$3(t3, n4, i5), i5;
}, l$5, h$7, d$a;
const o$5 = (d$a = class extends B$5(Bt$3).with(
  x$5,
  k$8,
  v$6,
  j$4
) {
  constructor() {
    super(), E$3(this, l$5), E$3(this, h$7), this.beaconTagName = y$2.beaconTagName, this.resetSpacing = true, this.focusOverride = true, this.inline = false, this.disablePasswordToggle = false, this.disableToggleSwitchLabel = false, this.nonResizable = false, this.toggleSwitch = false, this.readOnly = false, this.stepperVariant = _$3.PRIMARY, this.passwordVisible = false, this.isCheckboxChecked = false, w$5(this, l$5, void 0), this.handleFieldElementInvalid = this.handleFieldElementInvalid.bind(this), this.handleFieldElementOnChange = this.handleFieldElementOnChange.bind(this);
  }
  static get styles() {
    return [super.styles, Y$2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, j$3];
  }
  get labelElement() {
    return k$7(this, h$7);
  }
  set labelElement(e5) {
    w$5(this, h$7, e5);
  }
  postSetFormControlElement() {
    this.fieldElement && (d$a.applyClassNameToField(this.fieldElement), L$6(this, g$a.CONTROL_SET), this.setInputType(), this.setupSlottedFieldEventListeners(), this.setDisabledState(), this.setInvalidState(), this.setReadOnlyState(), this.setSwitchRole(), this.applyFieldElementObserver(), this.initializeIsCheckboxChecked());
  }
  get isStepper() {
    return this._inputType === "number" && this.stepperVariant !== "none";
  }
  get controlGroup() {
    return e$4(
      this,
      "_controlGroup",
      () => this.closest(this.getScopedTagName("beacon-control-group"))
    );
  }
  getAriaDescribedByIds() {
    var e5, t3;
    const n4 = [this.dataset.hintId || ((e5 = this.hintElement) == null ? void 0 : e5.id)];
    return this.invalid && n4.push(this.dataset.errorId || ((t3 = this.errorElement) == null ? void 0 : t3.id)), n4;
  }
  postSetHintElement() {
    this.setFieldAriaDescribedBy();
  }
  postSetErrorElement() {
    this.associateErrorWithField();
  }
  setFieldAriaDescribedBy(e5 = this.getAriaDescribedByIds()) {
    if (!this.fieldElement) return;
    const t3 = e5.filter((r3) => r3);
    if (t3.length === 0) {
      this.fieldElement.removeAttribute("aria-describedby");
      return;
    }
    const n4 = t3.join(" ");
    this.fieldElement.setAttribute("aria-describedby", n4);
  }
  associateErrorWithField(e5 = ((t3) => (t3 = this.errorElement) == null ? void 0 : t3.id)()) {
    if (!this.fieldElement) return;
    const t3 = this.dataset.errorId || e5;
    this.invalid ? t3 && this.fieldElement.setAttribute("aria-errormessage", t3) : this.fieldElement.removeAttribute("aria-errormessage"), this.setFieldAriaDescribedBy();
  }
  handleLabelSlotchange() {
    this.labelElement = d$a.setElementFromQuery(
      this.labelElements
    );
  }
  setupSlottedFieldEventListeners() {
    var e5, t3;
    this.preventDisabledEventsOnElement(this.fieldElement), (e5 = this.fieldElement) == null || e5.addEventListener(
      "invalid",
      this.handleFieldElementInvalid
    ), (t3 = this.fieldElement) == null || t3.addEventListener(
      "change",
      this.handleFieldElementOnChange
    );
  }
  postFormControlSlotchange() {
    this.isStepper && this.fieldElement instanceof HTMLInputElement && (this.updateStepperSlottedInputValue(), this.fieldElement.value || (this.fieldElement.value = this.fieldElement.min || "1"), this.disabledMinusValue = this.setMinusButtonState(), this.disabledPlusValue = this.setPlusButtonState());
  }
  handleFieldElementInvalid(e5) {
    var t3;
    (t3 = this.fieldElement) == null || t3.setAttribute("aria-invalid", "true");
  }
  handleFieldElementOnChange(e5) {
    const t3 = e5 == null ? void 0 : e5.target;
    t3 && (t3 == null ? void 0 : t3.type) === "checkbox" && (this.isCheckboxChecked = t3 == null ? void 0 : t3.checked);
  }
  applyFieldElementObserver() {
    this.fieldElement && !k$7(this, l$5) && (w$5(this, l$5, new MutationObserver(
      (e5) => {
        e5.find(
          (t3) => t3.attributeName === "aria-disabled" || t3.attributeName === "disabled"
        ) && this.setDisabledState(), e5.find(
          (t3) => t3.attributeName === "aria-invalid"
        ) && this.setInvalidState(), e5.find(
          (t3) => t3.attributeName === "readonly"
        ) && this.setReadOnlyState();
      }
    )), k$7(this, l$5).observe(this.fieldElement, {
      attributes: true
    }));
  }
  updateStepperSlottedInputValue() {
    this.fieldElement instanceof HTMLInputElement && this.fieldElement.addEventListener("input", (e5) => {
      const t3 = e5.target;
      t3 && (this.fieldElement.value = t3.value, this.validatedStepper());
    });
  }
  validatedStepper() {
    var e5, t3;
    if (this.isStepper && this.fieldElement instanceof HTMLInputElement) {
      const n4 = this.fieldElement.value, r3 = new CustomEvent("change", {
        bubbles: true,
        cancelable: true,
        detail: {
          value: n4
        }
      });
      this.fieldElement.dispatchEvent(r3), n4.length > 1 ? this.fieldElement.style.inlineSize = n4.length + 3 + "ch" : this.fieldElement.style.inlineSize = "36px", (e5 = this.fieldElement.parentElement) != null && e5.clientWidth && ((t3 = this.fieldElement.parentElement) == null ? void 0 : t3.clientWidth) <= L$5.DEFAULT && (this.fieldElement.style.inlineSize = n4.length + 3.5 + "ch"), this.fieldElement.setAttribute(
        "aria-invalid",
        String(this.setStepperValidity())
      ), this.disabledMinusValue = this.setMinusButtonState(), this.disabledPlusValue = this.setPlusButtonState();
    }
  }
  setStepperValidity() {
    if (this.fieldElement instanceof HTMLInputElement) {
      const { min: e5, max: t3, value: n4 } = this.fieldElement;
      return !!(e5 && Number(n4) < Number(e5) || t3 && Number(n4) > Number(t3));
    }
    return false;
  }
  setMinusButtonState() {
    if (this.fieldElement instanceof HTMLInputElement) {
      if (this.fieldElement.min)
        return Number(this.fieldElement.min) >= Number(this.fieldElement.value);
      if (this.fieldElement.value === "0")
        return true;
    }
    return false;
  }
  setPlusButtonState() {
    return this.fieldElement instanceof HTMLInputElement && this.fieldElement.max ? Number(this.fieldElement.max) <= Number(this.fieldElement.value) : false;
  }
  incrementStepper(e5) {
    var t3;
    if (this.fieldElement) {
      ((t3 = this.fieldElement) == null ? void 0 : t3.value) === "" && (this.fieldElement.value = "0");
      const n4 = String(this.fieldElement.value), r3 = Number(n4 != null ? n4 : 0) + 1;
      this.fieldElement.value = String(r3), this.fieldElement.defaultValue = this.fieldElement.value, this.validatedStepper();
    }
  }
  decrementStepper(e5) {
    var t3;
    if (this.fieldElement) {
      ((t3 = this.fieldElement) == null ? void 0 : t3.value) === "" && (this.fieldElement.value = "0");
      const n4 = String(this.fieldElement.value), r3 = Number(n4 != null ? n4 : 0) - 1;
      this.fieldElement.value = String(r3), this.fieldElement.defaultValue = this.fieldElement.value, this.validatedStepper();
    }
  }
  setDisabledState() {
    if (this.fieldElement) {
      if (this.fieldElement.disabled) {
        this.disabled = this.fieldElement.disabled;
        return;
      }
      const e5 = this.fieldElement.getAttribute("aria-disabled");
      e5 === null ? this.disabled = this.fieldElement.disabled : this.disabled = e5 === "true";
    }
  }
  setInvalidState() {
    if (this.fieldElement) {
      const e5 = this.fieldElement.getAttribute("aria-invalid");
      this.invalid = e5 === "true", this.associateErrorWithField(), this.controlGroup && (this.controlGroup.invalid = this.invalid);
    }
  }
  setReadOnlyState() {
    (this.fieldElement instanceof HTMLInputElement || this.fieldElement instanceof HTMLTextAreaElement) && (this.readOnly = this.fieldElement.readOnly);
  }
  // Initialize `isCheckboxChecked` to match the actual checked state
  initializeIsCheckboxChecked() {
    this.fieldElement instanceof HTMLInputElement && this.fieldElement.type === "checkbox" && (this.isCheckboxChecked = this.fieldElement.checked);
  }
  setSwitchRole() {
    this.fieldElement instanceof HTMLInputElement && this.fieldElement.type === "checkbox" && (this.toggleSwitch ? this.fieldElement.setAttribute("role", "switch") : this.fieldElement.removeAttribute("role"));
  }
  static setElementFromQuery(e5) {
    return e5[0];
  }
  static applyClassNameToField(e5) {
    e5 && e5.classList.add("beacon-control__field");
  }
  renderLabelSlot() {
    if (this.toggleSwitch) {
      const e5 = {
        "checkbox-checked": this.isCheckboxChecked,
        "toggle-switch-label": true,
        label: true
      };
      return tt$1`
        <span class=${f$6(e5)}>
          <slot name="label">
            <span class="switch-on-label">
              <slot name="switch-on-label"></slot>
            </span>
            <span class="switch-off-label">
              <slot name="switch-off-label"></slot>
            </span>
          </slot>
        </span>
      `;
    }
    return tt$1`
      <div class="label" part="label">
        <slot
          name="label"
          @slotchange=${this.handleLabelSlotchange}
          ${f$7({ useParent: true })}></slot>
      </div>
    `;
  }
  renderIcon(e5) {
    return e5 && e5 === "select" ? kt$1`<${this.getScopedTag("beacon-icon")} name="sorted_down" size="m" class="dropdown-icon"></${this.getScopedTag("beacon-icon")}>` : h$c;
  }
  renderPrefix() {
    return this.isStepper ? kt$1`
      <div class="${f$6({
      stepper: true,
      prefix: true
    })}">
        <slot name="prefix">
          <${this.getScopedTag("beacon-icon-button")} 
          class="beacon-stepper-button" 
          variant="${this.stepperVariant}" 
          id="decrement"
          @beacon-event-click=${this.decrementStepper}
          ?disabled=${this.disabled || this.disabledMinusValue}>
          <${this.getScopedTag("beacon-icon")} name="remove" size="s" slot="icon"></${this.getScopedTag("beacon-icon")}> decrement button
          </${this.getScopedTag("beacon-icon-button")}>
        </slot>
      </div>
      ` : tt$1`
        <div class="prefix">
          <slot name="prefix" ${f$7({ useParent: true })}></slot>
        </div>
      `;
  }
  renderSuffix() {
    const e5 = this.disablePasswordToggle || this.disabled || this.readOnly;
    if (this._inputType === "password" && !e5) {
      const t3 = {
        password: true,
        "password-visible": this.passwordVisible,
        suffix: true
      };
      return kt$1`
        <div class="${f$6(t3)}">
          <slot name="suffix">
            <${this.getScopedTag("beacon-button")} class="password-toggle" variant="tertiary" scale="mini" @beacon-event-click=${this.handleTogglePassword}>
              <span class="show-password">
                <slot name="show-password">Show</slot>
              </span>
              <span class="hide-password">
                <slot name="hide-password">Hide</slot>
              </span>
            </${this.getScopedTag("beacon-button")}>
          </slot>
        </div>
      `;
    }
    return this.isStepper ? kt$1`
      <div class="${f$6({
      stepper: true,
      suffix: true
    })}">
        <slot name="suffix">
          <${this.getScopedTag("beacon-icon-button")} 
          class="beacon-stepper-button" 
          variant="${this.stepperVariant}"
          id="increment" 
          @beacon-event-click=${this.incrementStepper}
          ?disabled=${this.disabled || this.disabledPlusValue}>
          <${this.getScopedTag("beacon-icon")} name="add" size="s" slot="icon"></${this.getScopedTag("beacon-icon")}> increment button
          </${this.getScopedTag("beacon-icon-button")}>
        </slot>
      </div>
      ` : tt$1`
        <div class="suffix">
          <slot name="suffix" ${f$7({ useParent: true })}></slot>
        </div>
      `;
  }
  handleTogglePassword(e5) {
    var t3, n4;
    this.passwordVisible = !this.passwordVisible, this.passwordVisible ? (t3 = this.fieldElement) == null || t3.setAttribute("type", "text") : (n4 = this.fieldElement) == null || n4.setAttribute("type", "password");
  }
  // helps with syncing the browser UI with our modes
  setColorSchemeCSS() {
    const e5 = this.closest('[class*="beacon-on"]');
    if (e5) {
      const t3 = Array.from(
        e5.classList
      ).find((n4) => n4.startsWith("beacon-on"));
      t3 != null && t3.includes("dark") && (this.dataset.mode = "dark");
    }
  }
  render() {
    const e5 = {
      group: true,
      inline: this.inline
    }, t3 = {
      disabled: this.disabled,
      field: true,
      readonly: this.readOnly,
      invalid: this.invalid,
      stepper: this.isStepper
    };
    return this._inputType && (t3[this._inputType] = true), tt$1`
      <div class="${f$6(e5)}">
        ${this.renderLabelSlot()}
        <!-- prettier-ignore -->
        <div class="${f$6(t3)}" part="field">
          ${this.renderPrefix()}
          ${this.renderFormControlTemplate()}
          ${this.renderIcon(this._inputType)}
          ${this.renderSuffix()}
        </div>
      </div>
      ${this.renderHintTemplate()} ${this.renderErrorTemplate()}
    `;
  }
}, l$5 = /* @__PURE__ */ new WeakMap(), h$7 = /* @__PURE__ */ new WeakMap(), d$a.tagName = y$2.beaconTagName, d$a.nestedComponents = y$2.beaconNestedComponents, d$a);
a$6([
  v$c({ type: Boolean })
], o$5.prototype, "inline", 2);
a$6([
  v$c({ type: Boolean, attribute: "disable-password-toggle" })
], o$5.prototype, "disablePasswordToggle", 2);
a$6([
  v$c({ type: Boolean, attribute: "disable-toggle-switch-label" })
], o$5.prototype, "disableToggleSwitchLabel", 2);
a$6([
  v$c({ type: Boolean, reflect: true, attribute: "non-resizable" })
], o$5.prototype, "nonResizable", 2);
a$6([
  v$c({ type: Boolean, reflect: true, attribute: "toggle-switch" })
], o$5.prototype, "toggleSwitch", 2);
a$6([
  v$c({ type: Boolean, reflect: true })
], o$5.prototype, "readOnly", 2);
a$6([
  v$c({ type: String, reflect: true, attribute: "stepper-variant" })
], o$5.prototype, "stepperVariant", 2);
a$6([
  it()
], o$5.prototype, "disabledMinusValue", 2);
a$6([
  it()
], o$5.prototype, "disabledPlusValue", 2);
a$6([
  it()
], o$5.prototype, "passwordVisible", 2);
a$6([
  it()
], o$5.prototype, "isCheckboxChecked", 2);
a$6([
  h$9("[toggle-password]")
], o$5.prototype, "passwordToggleButton", 2);
a$6([
  a$8({ flatten: true, slot: "label" })
], o$5.prototype, "labelElements", 2);
a$6([
  a$8({
    flatten: true,
    slot: "suffix",
    selector: "[toggle-password]"
  })
], o$5.prototype, "togglePasswordButtons", 2);
a$6([
  d$e
], o$5.prototype, "setColorSchemeCSS", 1);
let m$7 = o$5;
const ie$3 = (e5) => (Se$3(e5, m$7), Dt$3({
  tagName: e5 ? e5 + "-" + m$7.tagName : m$7.tagName,
  elementClass: m$7,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let t$5 = class t extends i$4 {
  constructor(e5) {
    if (super(e5), this.it = h$c, e5.type !== T$5.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(e5) {
    if (e5 === h$c || e5 == null) return this._t = void 0, this.it = e5;
    if (e5 === N$8) return e5;
    if (typeof e5 != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (e5 === this.it) return this._t;
    this.it = e5;
    const r3 = [e5];
    return r3.raw = r3, this._t = { _$litType$: this.constructor.resultType, strings: r3, values: [] };
  }
};
t$5.directiveName = "unsafeHTML", t$5.resultType = 1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let i$2 = class i2 extends t$5 {
};
i$2.directiveName = "unsafeSVG", i$2.resultType = 2;
const d$9 = _$4(i$2);
function o$4(t3, e5) {
  return t3.has(e5) && typeof t3.get(e5) < "u";
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { I: s$5 } = Lt$2, B$4 = (n4, t3) => (n4 == null ? void 0 : n4._$litType$) !== void 0, m$6 = (n4) => {
  var t3;
  return ((t3 = n4 == null ? void 0 : n4._$litType$) == null ? void 0 : t3.h) != null;
}, d$8 = () => document.createComment(""), p$4 = (n4, t3, e5) => {
  var r3;
  const $2 = n4._$AA.parentNode, A3 = n4._$AB;
  if (e5 === void 0) {
    const _2 = $2.insertBefore(d$8(), A3), o2 = $2.insertBefore(d$8(), A3);
    e5 = new s$5(_2, o2, n4, n4.options);
  } else {
    const _2 = e5._$AB.nextSibling, o2 = e5._$AM, u2 = o2 !== n4;
    if (u2) {
      let l4;
      (r3 = e5._$AQ) == null || r3.call(e5, n4), e5._$AM = n4, e5._$AP !== void 0 && (l4 = n4._$AU) !== o2._$AU && e5._$AP(l4);
    }
    if (_2 !== A3 || u2) {
      let l4 = e5._$AA;
      for (; l4 !== _2; ) {
        const f2 = l4.nextSibling;
        $2.insertBefore(l4, A3), l4 = f2;
      }
    }
  }
  return e5;
}, c$6 = {}, g$4 = (n4, t3 = c$6) => n4._$AH = t3, v$5 = (n4) => n4._$AH, S$7 = (n4) => {
  n4._$AR();
};
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const o$3 = "important", f$5 = " !" + o$3, p$3 = _$4(class extends i$4 {
  constructor(s2) {
    var t3;
    if (super(s2), s2.type !== T$5.ATTRIBUTE || s2.name !== "style" || ((t3 = s2.strings) == null ? void 0 : t3.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
  }
  render(s2) {
    return Object.keys(s2).reduce((t3, r3) => {
      const e5 = s2[r3];
      return e5 == null ? t3 : t3 + `${r3 = r3.includes("-") ? r3 : r3.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${e5};`;
    }, "");
  }
  update(s2, [t3]) {
    const { style: r3 } = s2.element;
    if (this.ft === void 0) return this.ft = new Set(Object.keys(t3)), this.render(t3);
    for (const e5 of this.ft) t3[e5] == null && (this.ft.delete(e5), e5.includes("-") ? r3.removeProperty(e5) : r3[e5] = null);
    for (const e5 in t3) {
      const n4 = t3[e5];
      if (n4 != null) {
        this.ft.add(e5);
        const i5 = typeof n4 == "string" && n4.endsWith(f$5);
        e5.includes("-") || i5 ? r3.setProperty(e5, i5 ? n4.slice(0, -11) : n4, i5 ? o$3 : "") : r3[e5] = n4;
      }
    }
    return N$8;
  }
});
const f$4 = {
  header: "HDR",
  siteNav: "TN",
  footer: "FTR"
}, m$5 = {
  0: "Hdr_lvl0",
  1: "Hdr_lvl1"
}, h$6 = {
  level_1: "TN_lvl1",
  level_2: "TN_lvl2",
  level_3: "TN_lvl3",
  level_4: "TN_lvl4"
}, C$5 = {
  prefix: "data-metrics",
  get location() {
    return `${this.prefix}-location`;
  },
  get section() {
    return `${this.prefix}-section`;
  }
}, L$4 = {
  selectedLink: "Site_lvl0",
  links: "Site_lvl1_SiteSelector",
  level1LangSelector: "Site_lvl1_LocLangSelector",
  level2LangSelector: "Site_lvl2_LocLangSelector"
};
function I$4(i5) {
  switch (i5) {
    case 1:
      return h$6.level_2;
    case 2:
      return h$6.level_3;
    case 3:
      return h$6.level_4;
    default:
      return null;
  }
}
var _$2 = Object.defineProperty, S$6 = Object.getOwnPropertyDescriptor, n$8 = (i5, o2, a2, t3) => {
  for (var e5 = t3 > 1 ? void 0 : t3 ? S$6(o2, a2) : o2, r3 = i5.length - 1, l4; r3 >= 0; r3--)
    (l4 = i5[r3]) && (e5 = (t3 ? l4(o2, a2, e5) : l4(e5)) || e5);
  return t3 && e5 && _$2(o2, a2, e5), e5;
};
const v$4 = {
  skipFirstUpdated: false,
  runOnSlotchange: false
};
function N$5({
  skipFirstUpdated: i5,
  runOnSlotchange: o2
} = v$4) {
  return function(a2) {
    let t3 = class extends a2 {
      /**
       * @abstract
       */
      updateAnalytics() {
      }
      prerenderAnalyticsSetup() {
        o2 && this.addEventListener("slotchange", this.updateAnalytics);
      }
      postrenderAnalyticsSetup() {
        i5 || this.updateAnalytics();
      }
      willUpdate(e5) {
        super.willUpdate(e5), e5.has("metricsSection") && this.metricsSection && L$6(
          this,
          g$a.METRICS_SECTION_CHANGE,
          !!this.onBeaconAnalyticsSectionChange && this.onBeaconAnalyticsSectionChange()
        ), e5.has("metricsLocation") && this.metricsLocation && L$6(
          this,
          g$a.METRICS_LOCATION_CHANGE,
          !!this.onBeaconAnalyticsLocationChange && this.onBeaconAnalyticsLocationChange()
        ), e5.has("metricsID") && this.metricsID && L$6(
          this,
          g$a.METRICS_ID_CHANGE,
          !!this.onBeaconAnalyticsIdChange && this.onBeaconAnalyticsIdChange()
        );
      }
    };
    return n$8([
      v$c({ attribute: "data-metrics-section", reflect: true })
    ], t3.prototype, "metricsSection", 2), n$8([
      v$c({ attribute: "data-metrics-location" })
    ], t3.prototype, "metricsLocation", 2), n$8([
      v$c({ attribute: "data-id" })
    ], t3.prototype, "metricsID", 2), n$8([
      v$c({ type: Function })
    ], t3.prototype, "onBeaconAnalyticsSectionChange", 2), n$8([
      v$c({ type: Function })
    ], t3.prototype, "onBeaconAnalyticsIdChange", 2), n$8([
      v$c({ type: Function })
    ], t3.prototype, "onBeaconAnalyticsLocationChange", 2), n$8([
      u$2
    ], t3.prototype, "prerenderAnalyticsSetup", 1), n$8([
      d$e
    ], t3.prototype, "postrenderAnalyticsSetup", 1), t3 = n$8([
      f$8("Analytics")
    ], t3), t3;
  };
}
var o$2 = /* @__PURE__ */ ((E2) => (E2.ESCAPE = "Escape", E2.TAB = "Tab", E2.ENTER = "Enter", E2.SPACE = " ", E2))(o$2 || {});
const p$2 = T$7`[class*=b-motion]{--b-motion-delay-default: 0ms;--b-motion-duration-default: var(--beacon-reference-motion-duration-9);--b-motion-fill-mode-default: both;--b-motion-iteration-count-default: 1;--b-motion-timing-function-default: var(--beacon-system-motion-easing-decelerate-emphasize-1);animation-delay:var(--b-motion-delay, var(--b-motion-delay-default));animation-duration:var(--b-motion-duration, var(--b-motion-duration-default));animation-fill-mode:var(--b-motion-fill-mode, var(--b-motion-fill-mode-default));animation-iteration-count:var(--b-motion-iteration-count, var(--b-motion-iteration-count-default));animation-timing-function:var(--b-motion-timing-function, var(--b-motion-timing-function-default))}.b-motion-duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}.b-motion-duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}.b-motion-duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}.b-motion-duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}.b-motion-duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}.b-motion-duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}.b-motion-duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}.b-motion-duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}.b-motion-duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}.b-motion-duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}.b-motion-duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}.b-motion-duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}.b-motion-delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}.b-motion-delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}.b-motion-delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}.b-motion-delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}.b-motion-delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}.b-motion-delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}.b-motion-delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}.b-motion-delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}.b-motion-delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}.b-motion-delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}.b-motion-delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}.b-motion-delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}.b-motion-ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}.b-motion-ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}.b-motion-ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}.b-motion-ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}.b-motion-ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}.b-motion-ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}.b-motion-ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}.b-motion-iteration--1{--b-motion-iteration-count: 1}.b-motion-iteration--2{--b-motion-iteration-count: 2}.b-motion-iteration--3{--b-motion-iteration-count: 3}.b-motion-iteration--4{--b-motion-iteration-count: 4}.b-motion-iteration--5{--b-motion-iteration-count: 5}@media (width >= 320px){[class*=b-motion-duration--].b-sm\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-sm\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-sm\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-sm\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-sm\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-sm\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-sm\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-sm\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-sm\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-sm\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-sm\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-sm\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-sm\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-sm\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-sm\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-sm\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-sm\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-sm\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-sm\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-sm\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-sm\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-sm\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-sm\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-sm\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-sm\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-sm\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-sm\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-sm\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-sm\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-sm\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-sm\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 640px){[class*=b-motion-duration--].b-md\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-md\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-md\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-md\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-md\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-md\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-md\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-md\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-md\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-md\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-md\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-md\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-md\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-md\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-md\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-md\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-md\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-md\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-md\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-md\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-md\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-md\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-md\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-md\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-md\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-md\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-md\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-md\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-md\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-md\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-md\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 960px){[class*=b-motion-duration--].b-lg\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-lg\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-lg\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-lg\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-lg\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-lg\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-lg\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-lg\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-lg\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-lg\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-lg\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-lg\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-lg\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-lg\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-lg\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-lg\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-lg\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-lg\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-lg\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-lg\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-lg\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-lg\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-lg\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-lg\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-lg\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-lg\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-lg\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-lg\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-lg\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-lg\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-lg\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 1280px){[class*=b-motion-duration--].b-xl\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-xl\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-xl\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-xl\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-xl\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-xl\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-xl\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-xl\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-xl\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-xl\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-xl\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-xl\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-xl\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-xl\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-xl\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-xl\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-xl\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-xl\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-xl\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-xl\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-xl\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-xl\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-xl\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-xl\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-xl\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-xl\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-xl\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-xl\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-xl\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-xl\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-xl\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 1600px){[class*=b-motion-duration--].b-xxl\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-xxl\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-xxl\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-xxl\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-xxl\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-xxl\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-xxl\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-xxl\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-xxl\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-xxl\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-xxl\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-xxl\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-xxl\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-xxl\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-xxl\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-xxl\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-xxl\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-xxl\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-xxl\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-xxl\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-xxl\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-xxl\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-xxl\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-xxl\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-xxl\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-xxl\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-xxl\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-xxl\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-xxl\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-xxl\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-xxl\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 1920px){[class*=b-motion-duration--].b-xxxl\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-xxxl\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-xxxl\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-xxxl\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-xxxl\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-xxxl\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-xxxl\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-xxxl\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-xxxl\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-xxxl\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-xxxl\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-xxxl\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-xxxl\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-xxxl\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-xxxl\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-xxxl\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-xxxl\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-xxxl\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-xxxl\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-xxxl\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-xxxl\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-xxxl\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-xxxl\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-xxxl\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-xxxl\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-xxxl\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-xxxl\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-xxxl\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-xxxl\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-xxxl\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-xxxl\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}[class*=b-motion--intro-from-]{--b-motion-duration-default: var(--beacon-reference-motion-duration-9);--b-motion-timing-function-default: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion--intro-from-offscreen]{--b-motion-duration-default: var(--beacon-reference-motion-duration-12);--b-motion-timing-function-default: var(--beacon-system-motion-easing-decelerate-emphasize-1)}@media screen and (prefers-reduced-motion: reduce){.b-motion--intro-from-left{animation:none}}@keyframes intro-from-left{0%{opacity:0;transform:translate(calc(-1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translate(0)}}.b-motion--intro-from-left{animation-name:intro-from-left}@media screen and (prefers-reduced-motion: reduce){.b-motion--intro-from-right{animation:none}}@keyframes intro-from-right{0%{opacity:0;transform:translate(calc(1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translate(0)}}.b-motion--intro-from-right{animation-name:intro-from-right}@media screen and (prefers-reduced-motion: reduce){.b-motion--intro-from-top{animation:none}}@keyframes intro-from-top{0%{opacity:0;transform:translateY(calc(-1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translateY(0)}}.b-motion--intro-from-top{animation-name:intro-from-top}@media screen and (prefers-reduced-motion: reduce){.b-motion--intro-from-bottom{animation:none}}@keyframes intro-from-bottom{0%{opacity:0;transform:translateY(calc(1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translateY(0)}}.b-motion--intro-from-bottom{animation-name:intro-from-bottom}@keyframes intro-from-offscreen-left{0%{opacity:0;transform:translate(calc(-1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translate(0)}}.b-motion--intro-from-offscreen-left{animation-name:intro-from-offscreen-left}@keyframes intro-from-offscreen-right{0%{opacity:0;transform:translate(calc(1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translate(0)}}.b-motion--intro-from-offscreen-right{animation-name:intro-from-offscreen-right}@keyframes intro-from-offscreen-top{0%{opacity:0;transform:translateY(calc(-1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translateY(0)}}.b-motion--intro-from-offscreen-top{animation-name:intro-from-offscreen-top}@keyframes intro-from-offscreen-bottom{0%{opacity:0;transform:translateY(calc(1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translateY(0)}}.b-motion--intro-from-offscreen-bottom{animation-name:intro-from-offscreen-bottom}@media (prefers-reduced-motion: reduce){*,*:before,*:after{animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}html{scroll-behavior:auto}}`;
var z$1 = Object.defineProperty, M$4 = Object.getOwnPropertyDescriptor, g$3 = (e5) => {
  throw TypeError(e5);
}, r$7 = (e5, a2, t3, n4) => {
  for (var o2 = n4 > 1 ? void 0 : n4 ? M$4(a2, t3) : a2, i5 = e5.length - 1, m3; i5 >= 0; i5--)
    (m3 = e5[i5]) && (o2 = (n4 ? m3(a2, t3, o2) : m3(o2)) || o2);
  return n4 && o2 && z$1(a2, t3, o2), o2;
}, E$2 = (e5, a2, t3) => a2.has(e5) || g$3("Cannot " + t3), s$4 = (e5, a2, t3) => (E$2(e5, a2, "read from private field"), t3 ? t3.call(e5) : a2.get(e5)), w$4 = (e5, a2, t3) => a2.has(e5) ? g$3("Cannot add the same private member more than once") : a2 instanceof WeakSet ? a2.add(e5) : a2.set(e5, t3);
function L$3(e5 = { autoRemoveMotionClasses: true }) {
  return function(a2) {
    var t3;
    let n4 = class extends a2 {
      constructor() {
        super(...arguments), this.inMotion = false, this.motionMap = /* @__PURE__ */ new Map(), w$4(this, t3, ({ type: o2, target: i5 }) => {
          if (!this.prefersReducedMotion) {
            if (this !== i5 && this.contains(i5))
              return;
            (o2 === "animationstart" || o2 === "transitionstart") && this.motionMap.set(i5, true), (o2 === "animationend" || o2 === "transitionend") && this.motionMap.set(i5, false), Array.from(this.motionMap.values()).includes(true) ? this.inMotion = true : this.inMotion = false;
          }
        });
      }
      /**
       * Imports motion utility class stylesheet to enable usage of utility classes in shadowDOM
       */
      static get motionStyles() {
        return [p$2];
      }
      /**
       * Empty function used to apply component-specific motion logic
       */
      applyMotionStyles() {
      }
      /**
       * Empty function used to handle animationstart events when listened from the root node.
       *
       * @abstract
       * @param e animationstart event object
       */
      hostAnimationStart(o2) {
      }
      /**
       * Empty function used to handle animationend events when listened from the root node.
       *
       * @abstract
       * @param e animationend event object
       */
      hostAnimationEnd(o2) {
      }
      /**
       * Empty function used to handle animationstart events when listened from the shadow root.
       *
       * @abstract
       * @param e animationstart event object
       */
      shadowRootAnimationStart(o2) {
      }
      /**
       * Empty function used to handle animationend events when listened from the shadow root.
       *
       * @abstract
       * @param e animationend event object
       */
      shadowRootAnimationEnd(o2) {
      }
      /**
       * Filter an element's classList property for all classes that use `b-motion`.
       *
       * @param element HTML element that finished an animation
       * @returns All class names with `b-motion` in the name
       */
      static findMotionClassesOnElement(o2) {
        return Array.from(o2.classList).filter(
          (i5) => i5.includes("b-motion")
        );
      }
      /**
       * Remove all `b-motion` classes from a given element.
       *
       * @param element HTML element that finished an animation
       */
      static removeMotionClassesFromElement(o2) {
        o2.classList.remove(
          ...n4.findMotionClassesOnElement(o2)
        );
      }
      /**
       * Called on host Animation End or ShadowRootAnimationEnd if this.
       * Motion class auto removal is enabled
       */
      cleanupClasses(o2) {
        o2.target instanceof HTMLElement && n4.removeMotionClassesFromElement(o2.target);
      }
      /*
       * Sets the animationEnd events to instead cleanupClasses if autoRemoval is enabled
       */
      autoRemoveClasses(o2) {
        o2 && (this.hostAnimationEnd = this.cleanupClasses, this.shadowRootAnimationEnd = this.cleanupClasses);
      }
      bindMethods() {
        e5 && e5 != null && e5.autoRemoveMotionClasses && this.autoRemoveClasses(e5.autoRemoveMotionClasses), this.hostAnimationStart = this.hostAnimationStart.bind(this), this.hostAnimationEnd = this.hostAnimationEnd.bind(this), this.shadowRootAnimationStart = this.shadowRootAnimationStart.bind(this), this.shadowRootAnimationEnd = this.shadowRootAnimationEnd.bind(this);
      }
      prerenderAddHostEventListeners() {
        this.bindMethods(), this.addEventListener("animationstart", this.hostAnimationStart), this.addEventListener("animationstart", s$4(this, t3)), this.addEventListener("animationend", this.hostAnimationEnd), this.addEventListener("animationend", s$4(this, t3)), this.addEventListener("transitionstart", s$4(this, t3)), this.addEventListener("transitionend", s$4(this, t3));
      }
      postrenderAddShadowRootListeners() {
        var o2, i5, m3, d3, b5, c4;
        (o2 = this.shadowRoot) == null || o2.addEventListener(
          "animationstart",
          this.shadowRootAnimationStart
        ), (i5 = this.shadowRoot) == null || i5.addEventListener(
          "animationstart",
          s$4(this, t3)
        ), (m3 = this.shadowRoot) == null || m3.addEventListener(
          "animationend",
          this.shadowRootAnimationEnd
        ), (d3 = this.shadowRoot) == null || d3.addEventListener("animationend", s$4(this, t3)), (b5 = this.shadowRoot) == null || b5.addEventListener(
          "transitionstart",
          s$4(this, t3)
        ), (c4 = this.shadowRoot) == null || c4.addEventListener(
          "transitionend",
          s$4(this, t3)
        );
      }
    };
    return t3 = /* @__PURE__ */ new WeakMap(), r$7([
      v$c({
        reflect: true,
        attribute: "in-motion",
        type: Boolean
      })
    ], n4.prototype, "inMotion", 2), r$7([
      it()
    ], n4.prototype, "motionMap", 2), r$7([
      u$2
    ], n4.prototype, "prerenderAddHostEventListeners", 1), r$7([
      d$e
    ], n4.prototype, "postrenderAddShadowRootListeners", 1), n4 = r$7([
      f$8("Motionable")
    ], n4), n4;
  };
}
var B$3 = Object.defineProperty, M$3 = Object.getOwnPropertyDescriptor, g$2 = (t3) => {
  throw TypeError(t3);
}, h$5 = (t3, e5, r3, n4) => {
  for (var i5 = n4 > 1 ? void 0 : n4 ? M$3(e5, r3) : e5, a2 = t3.length - 1, o2; a2 >= 0; a2--)
    (o2 = t3[a2]) && (i5 = (n4 ? o2(e5, r3, i5) : o2(i5)) || i5);
  return n4 && i5 && B$3(e5, r3, i5), i5;
}, l$4 = (t3, e5, r3) => e5.has(t3) || g$2("Cannot " + r3), d$7 = (t3, e5, r3) => (l$4(t3, e5, "read from private field"), r3 ? r3.call(t3) : e5.get(t3)), m$4 = (t3, e5, r3) => e5.has(t3) ? g$2("Cannot add the same private member more than once") : e5 instanceof WeakSet ? e5.add(t3) : e5.set(t3, r3);
function f$3(t3) {
  var e5, r3, n4, i5;
  let a2 = class extends t3 {
    constructor() {
      super(...arguments), this.smallBreakpointWatcher = window.matchMedia(
        a2.createMediaQueryString(L$5.DEFAULT)
      ), this.mediumBreakpointWatcher = window.matchMedia(
        a2.createMediaQueryString(L$5.MEDIUM)
      ), this.largeBreakpointWatcher = window.matchMedia(
        a2.createMediaQueryString(L$5.LARGE)
      ), this.xLargeBreakpointWatcher = window.matchMedia(
        a2.createMediaQueryString(L$5.XLARGE)
      ), this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.isSmallBreakpoint = this.smallBreakpointWatcher.matches, this.isMediumBreakpoint = this.mediumBreakpointWatcher.matches, this.isLargeBreakpoint = this.largeBreakpointWatcher.matches, this.isXLargeBreakpoint = this.xLargeBreakpointWatcher.matches, m$4(this, e5, ({ matches: s2 }) => {
        this.isSmallBreakpoint = s2;
      }), m$4(this, r3, ({ matches: s2 }) => {
        this.isMediumBreakpoint = s2;
      }), m$4(this, n4, ({ matches: s2 }) => {
        this.isLargeBreakpoint = s2;
      }), m$4(this, i5, ({ matches: s2 }) => {
        this.isXLargeBreakpoint = s2;
      });
    }
    static createMediaQueryString(s2) {
      return `(min-width: ${s2}px)`;
    }
    /** Matches small but doesn't match medium. */
    get matchesUpToSmall() {
      return !this.isMediumBreakpoint;
    }
    /** Matches small and medium but doesn't match large. */
    get matchesUpToMedium() {
      return !this.isLargeBreakpoint;
    }
    /** Matches small, medium, and large but doesn't match x-large. */
    get matchesUpToLarge() {
      return !this.isXLargeBreakpoint;
    }
    /** Matches all breakpoints up to x-large. */
    get matchesUpToXLarge() {
      return this.isXLargeBreakpoint;
    }
    /** Alias for matching small and medium breakpoints. */
    get isMobile() {
      return this.matchesUpToMedium;
    }
    /** Alias for matching the large (desktop) breakpoint. */
    get isDesktop() {
      return this.isLargeBreakpoint;
    }
    prerenderWatchMediaSetup() {
      this.smallBreakpointWatcher.addEventListener(
        "change",
        d$7(this, e5)
      ), this.mediumBreakpointWatcher.addEventListener(
        "change",
        d$7(this, r3)
      ), this.largeBreakpointWatcher.addEventListener(
        "change",
        d$7(this, n4)
      ), this.xLargeBreakpointWatcher.addEventListener(
        "change",
        d$7(this, i5)
      );
    }
  };
  return e5 = /* @__PURE__ */ new WeakMap(), r3 = /* @__PURE__ */ new WeakMap(), n4 = /* @__PURE__ */ new WeakMap(), i5 = /* @__PURE__ */ new WeakMap(), h$5([
    it()
  ], a2.prototype, "isSmallBreakpoint", 2), h$5([
    it()
  ], a2.prototype, "isMediumBreakpoint", 2), h$5([
    it()
  ], a2.prototype, "isLargeBreakpoint", 2), h$5([
    it()
  ], a2.prototype, "isXLargeBreakpoint", 2), h$5([
    u$2
  ], a2.prototype, "prerenderWatchMediaSetup", 1), a2 = h$5([
    f$8("WatchMedia")
  ], a2), a2;
}
const e$3 = "beacon-scroll-block";
function n$7() {
  var o2;
  if (!document.getElementById(e$3)) {
    const t3 = document.createElement("style");
    t3.setAttribute("id", e$3), t3.innerHTML = `.${e$3}{
      block-size: 100dvh !important;
      overflow: hidden !important;
    }`, (o2 = document.querySelector("head")) == null || o2.appendChild(t3);
  }
  document.body.classList.add(e$3);
}
function c$5() {
  document.body.classList.remove(e$3);
}
let n$6 = class n extends i$4 {
  constructor(t3) {
    if (super(t3), t3.type !== T$5.EVENT || t3.name !== "slotchange" || t3.tagName !== "SLOT")
      throw new Error(
        "The `addListRole` directive must be used on a `<slot>` and the `slotchange` event"
      );
    this.part = t3;
  }
  /**
   * Adds the list role to any <ul> or <ol> elements slotted into this slot
   * @param part
   */
  static addListRoleToSlotted(t3) {
    if (t3) {
      const e5 = (t3 == null ? void 0 : t3.element).assignedElements();
      e5 == null || e5.forEach((a2) => {
        (a2.tagName === "UL" || a2.tagName === "OL") && (a2.role = "list");
      });
    }
  }
  /**
   * Takes in a secondary function to be executed on slotchange. This is so that the user can still listen for slotchange
   * events when using this directive.
   * @param otherSlotChangeFunction Secondary slot change function to be called alongside this directive
   * @returns Empty string. When there is no return value, the event listeners are never properly attached.
   */
  render(t3 = void 0) {
    return this.part && (this.part.handleEvent = (e5) => {
      this.part && n.addListRoleToSlotted(this.part), t3 && t3(e5);
    }), "";
  }
};
const i$1 = _$4(n$6);
const N$4 = T$7`:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) :is(h1,h2,h3,h4,h5,h6,p){margin:0;padding:0}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) ::part(button){text-align:inherit}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) ul{margin-block:0}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) ul>li{display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating)}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer])>:is(a,[beacon-tag-name=beacon-navigation-button]){display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating)}`, x$4 = T$7`:host{color:var(--beacon-system-color-text-standard);inline-size:100%}[beacon-tag-name=beacon-navigation-button]{display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating)}::slotted([slot=title]){color:var(--beacon-system-color-text-title);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-300)}::slotted([slot=description]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);color:var(--beacon-system-color-text-standard)}.title-area{padding-block:var(--beacon-system-space-cell-free-floating)}.title-area>*+*{margin-block-start:var(--navigation-expanded-title-area-gap)}.slot-container{display:grid;gap:var(--beacon-reference-space-2)}@media (width >= 960px){.level-2 .slot-container{columns:var(--expanded-nav-grid-template);display:block}.level-2,.level-3{padding-inline-end:var(--beacon-reference-space-7)}}`;
var S$5 = Object.defineProperty, C$4 = Object.getOwnPropertyDescriptor, s$3 = (c4, e5, t3, o2) => {
  for (var n4 = o2 > 1 ? void 0 : o2 ? C$4(e5, t3) : e5, l4 = c4.length - 1, r3; l4 >= 0; l4--)
    (r3 = c4[l4]) && (n4 = (o2 ? r3(e5, t3, n4) : r3(n4)) || n4);
  return o2 && n4 && S$5(e5, t3, n4), n4;
};
const a$5 = class i3 extends Bt$3 {
  constructor() {
    super(...arguments), this.level = 1, this.splitColumns = "true", this.hasNestedExpandedNavigations = false, this.handleCurrentLink = () => {
      this.currentLink && L$6(
        this,
        g$a.HAS_CURRENT_LINK,
        void 0,
        this.onBeaconCurrentLink
      );
    };
  }
  static get styles() {
    return [super.styles, x$4];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, N$4];
  }
  /** Callback for on beacon-event-has-current-link */
  onBeaconCurrentLink() {
  }
  /** Anchor link representing the current page. */
  get currentLink() {
    return this.querySelector('a[aria-current="page"]');
  }
  get hasValidNestedItems() {
    return this.links.filter(
      (e5) => (e5 instanceof i3 || e5 instanceof HTMLAnchorElement) && !(e5 instanceof HTMLStyleElement)
    );
  }
  postrenderHandleCurrentLink() {
    this.handleCurrentLink();
  }
  /** Set the level property. Runs on slotchange as it is dependent on nested menus. */
  setLevel() {
    this.level = 1 + (this.parentElement instanceof i3 ? this.parentElement.level : 0);
  }
  /** Updates based on this component having nested expanded navigations. */
  setNestedState() {
    this.hasValidNestedItems.length > 0 ? this.hasNestedExpandedNavigations = true : this.hasNestedExpandedNavigations = false;
  }
  /** Calculate a number of CSS columns based on how many links are to be shown. */
  static calculateCSSColumns(e5) {
    let t3 = "";
    return e5 < 6 ? t3 = "1" : e5 < 11 ? t3 = "2" : e5 < 22 ? t3 = "3" : t3 = "4", t3;
  }
  /** Calculate the grid template based on how many sections are shown. */
  static calculateGridColumnTemplate(e5) {
    let t3 = "";
    return e5 === 1 ? t3 = "1fr" : e5 === 2 ? t3 = "1fr 1fr" : e5 === 3 ? t3 = "1fr 1fr 1fr" : e5 >= 4 && (t3 = "1fr 1fr 1fr 1fr"), t3;
  }
  setColumnsCSSProperty(e5) {
    this.style.setProperty("--expanded-nav-grid-template", e5);
  }
  setNestedGridTemplates(e5) {
    const t3 = i3.calculateCSSColumns(e5);
    this.setColumnsCSSProperty(t3);
  }
  setLevel1GridTemplate(e5) {
    const t3 = i3.calculateGridColumnTemplate(e5);
    this.setColumnsCSSProperty(t3);
  }
  setLevel2GridTemplate(e5) {
    this.setNestedGridTemplates(e5);
  }
  setGridTemplates() {
    let e5 = this.links.length;
    this.splitColumns === "false" && (e5 = 1), this.level === 1 ? this.setLevel1GridTemplate(e5) : this.level === 2 ? this.setLevel2GridTemplate(e5) : this.level === 3 && this.setNestedGridTemplates(e5);
  }
  handleTitleSlotchange() {
    var e5;
    this.titleSlotVal = (e5 = this.titleNodes) != null && e5.length && this.titleNodes[0] instanceof HTMLElement ? this.titleNodes[0].innerText : "";
  }
  handleDefaultSlotchange() {
    this.setNestedState(), this.setLevel(), this.setGridTemplates();
  }
  renderExpanded() {
    return tt$1`
      <section class="header-zone">
        <div class="title-area">
          <div class="title-container">
            <slot
              name="title"
              part="title"
              @slotchange=${this.handleTitleSlotchange}></slot>
          </div>
        </div>
      </section>
      <section class="slot-container">
        <slot
          @slotchange=${i$1(
      this.handleDefaultSlotchange.bind(this)
    )}></slot>
      </section>
    `;
  }
  render() {
    return tt$1`<div class="level-${this.level}">
      ${this.renderExpanded()}
    </div> `;
  }
};
s$3([
  v$c({ reflect: true })
], a$5.prototype, "level", 2);
s$3([
  v$c({ attribute: "split-columns", reflect: true })
], a$5.prototype, "splitColumns", 2);
s$3([
  it()
], a$5.prototype, "titleSlotVal", 2);
s$3([
  it()
], a$5.prototype, "hasNestedExpandedNavigations", 2);
s$3([
  v$9({ slot: "", flatten: true })
], a$5.prototype, "links", 2);
s$3([
  v$9({ slot: "title", flatten: true })
], a$5.prototype, "titleNodes", 2);
s$3([
  d$e
], a$5.prototype, "postrenderHandleCurrentLink", 1);
let G$2 = a$5;
const $$3 = {
  beaconTagName: "beacon-navigation-expanded",
  beaconFooterNavTagName: "beacon-navigation-footer",
  navItemTagName: "beacon-navigation-button",
  maxLevel: 4
};
const r$6 = (o2, s2) => {
  let e5;
  return function(...t3) {
    const c4 = () => {
      clearTimeout(e5), o2(...t3);
    };
    clearTimeout(e5), e5 = setTimeout(c4, s2);
  };
};
typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
function Ge$2(e5) {
  if (!e5)
    return [];
  const t3 = [e5];
  return e5.children.length === 0 || Array.from(e5.children).forEach((o2) => {
    const n4 = Ge$2(o2);
    n4 && t3.push(...n4);
  }), t3;
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ie$2 = (e5) => m$6(e5) ? e5._$litType$.h : e5.strings, ft = _$4(class extends i$4 {
  constructor(e5) {
    super(e5), this.et = /* @__PURE__ */ new WeakMap();
  }
  render(e5) {
    return [e5];
  }
  update(e5, [t3]) {
    const o2 = B$4(this.it) ? Ie$2(this.it) : null, n4 = B$4(t3) ? Ie$2(t3) : null;
    if (o2 !== null && (n4 === null || o2 !== n4)) {
      const a2 = v$5(e5).pop();
      let r3 = this.et.get(o2);
      if (r3 === void 0) {
        const i5 = document.createDocumentFragment();
        r3 = nt$1(h$c, i5), r3.setConnected(false), this.et.set(o2, r3);
      }
      g$4(r3, [a2]), p$4(r3, void 0, a2);
    }
    if (n4 !== null) {
      if (o2 === null || o2 !== n4) {
        const a2 = this.et.get(n4);
        if (a2 !== void 0) {
          const r3 = v$5(a2).pop();
          S$7(e5), p$4(e5, void 0, r3), g$4(e5, [r3]);
        }
      }
      this.it = t3;
    } else this.it = void 0;
    return this.render(t3);
  }
}), wt$2 = T$7`:root,.beacon-on-light{--beacon-system-color-background-tertiary-pressed: #0063AD1F;--beacon-system-color-background-tertiary-hover: #0063AD14;--beacon-system-color-background-secondary-pressed: #0063AD1F;--beacon-system-color-background-secondary-hover: #0063AD14;--beacon-system-color-background-blanket: #061937A3;--beacon-component-table-color-background-selected: #8ff1ff29;--beacon-component-form-color-background-inactive: #FFFFFFE0;--beacon-system-color-text-title: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-tertiary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-text-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-tertiary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-text-tertiary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-text-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-text-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-primary-inactive: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-text-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-link-active: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-shadow-low: 0rem 0rem var(--beacon-reference-space-2) 0rem var(--beacon-reference-palette-grayscale-shadow-1);--beacon-system-color-shadow-high: 0rem 0rem var(--beacon-reference-space-7) 0rem var(--beacon-reference-palette-grayscale-shadow-3);--beacon-system-color-shadow-medium: 0rem 0rem var(--beacon-reference-space-4) 0rem var(--beacon-reference-palette-grayscale-shadow-2);--beacon-system-color-icon-tertiary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-icon-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-icon-tertiary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-icon-tertiary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-icon-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-icon-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-icon-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-primary-inactive: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-icon-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-icon-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-link-active: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-highlight: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-icon-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-data-viz-11: var(--beacon-reference-palette-charts-gray-lt-5);--beacon-system-color-data-viz-10: var(--beacon-reference-palette-charts-gray-lt-3);--beacon-system-color-data-viz-9: var(--beacon-reference-palette-charts-orange-lt-5);--beacon-system-color-data-viz-8: var(--beacon-reference-palette-charts-orange-lt-3);--beacon-system-color-data-viz-7: var(--beacon-reference-palette-charts-berry-lt-5);--beacon-system-color-data-viz-6: var(--beacon-reference-palette-charts-berry-lt-2);--beacon-system-color-border-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-border-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-border-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-border-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-primary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-border-link-focus: var(--beacon-reference-palette-grayscale-black);--beacon-system-color-border-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-focus-outer: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-border-focus-middle: var(--beacon-reference-palette-grayscale-black);--beacon-system-color-border-focus-inner: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-system-color-border-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-border-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-border-active: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-2: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-border-1: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-system-color-border-0: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-background-primary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-background-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-background-primary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-background-primary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-background-positive-pressed: var(--beacon-reference-palette-functional-green-1);--beacon-system-color-background-positive-hover: var(--beacon-reference-palette-functional-green-2);--beacon-system-color-background-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-background-negative-pressed: var(--beacon-reference-palette-functional-red-1);--beacon-system-color-background-negative-hover: var(--beacon-reference-palette-functional-red-2);--beacon-system-color-background-negative: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-background-link-focus: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-background-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-background-2: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-system-color-background-1: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-background-0: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-component-tile-collection-color-border-green: var(--beacon-reference-palette-secondary-green-3);--beacon-component-tile-collection-color-border-gold: var(--beacon-reference-palette-secondary-gold-3);--beacon-component-tile-collection-color-border-blue: var(--beacon-reference-palette-secondary-ocean-3);--beacon-component-tile-collection-color-border-berry: var(--beacon-reference-palette-secondary-berry-3);--beacon-component-tile-collection-color-background-green: var(--beacon-reference-palette-secondary-green-1);--beacon-component-tile-collection-color-background-gold: var(--beacon-reference-palette-secondary-gold-1);--beacon-component-tile-collection-color-background-blue: var(--beacon-reference-palette-functional-blue-2);--beacon-component-tile-collection-color-background-berry: var(--beacon-reference-palette-secondary-berry-1);--beacon-component-table-color-border: var(--beacon-reference-palette-grayscale-light-gray-1);--beacon-component-tab-menu-color-background-primary-active: var(--beacon-reference-palette-functional-blue-6);--beacon-component-scrollbar-color-background-track: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-scrollbar-color-background-thumb-pressed: var(--beacon-reference-palette-grayscale-dark-gray-1);--beacon-component-scrollbar-color-background-thumb-hover: var(--beacon-reference-palette-grayscale-dark-gray-2);--beacon-component-scrollbar-color-background-thumb: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-progress-indicator-color-background-incomplete: var(--beacon-reference-palette-functional-blue-9);--beacon-component-progress-indicator-color-background-complete: var(--beacon-reference-palette-functional-blue-1);--beacon-component-notification-color-border-informational: var(--beacon-reference-palette-functional-blue-3);--beacon-component-notification-color-background-standard: var(--beacon-reference-palette-grayscale-white);--beacon-component-primary-navigation-site-menu-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-component-primary-navigation-header-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-component-form-color-foreground-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-component-form-color-border-standard: var(--beacon-reference-palette-grayscale-medium-gray-2);--beacon-component-divider-color-neutral: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-data-viz-color-border-minor: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-component-data-viz-color-border-major: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-control-chip-color-background-default: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-avatar-icon-color-background: var(--beacon-reference-palette-grayscale-light-gray-5);--beacon-component-avatar-icon-color-avatar: var(--beacon-reference-palette-grayscale-light-gray-2)}.beacon-on-lighter{--beacon-system-color-background-tertiary-pressed: #0063AD1F;--beacon-system-color-background-tertiary-hover: #0063AD14;--beacon-system-color-background-secondary-pressed: #0063AD1F;--beacon-system-color-background-secondary-hover: #0063AD14;--beacon-system-color-background-blanket: #061937A3;--beacon-component-table-color-background-selected: #8ff1ff33;--beacon-component-form-color-background-inactive: #F4F5F6B8;--beacon-system-color-text-title: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-tertiary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-text-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-tertiary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-text-tertiary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-text-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-text-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-primary-inactive: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-text-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-link-active: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-shadow-low: 0rem 0rem var(--beacon-reference-space-2) 0rem var(--beacon-reference-palette-grayscale-shadow-1);--beacon-system-color-shadow-high: 0rem 0rem var(--beacon-reference-space-7) 0rem var(--beacon-reference-palette-grayscale-shadow-3);--beacon-system-color-shadow-medium: 0rem 0rem var(--beacon-reference-space-4) 0rem var(--beacon-reference-palette-grayscale-shadow-2);--beacon-system-color-icon-tertiary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-icon-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-icon-tertiary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-icon-tertiary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-icon-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-icon-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-icon-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-primary-inactive: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-icon-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-icon-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-link-active: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-highlight: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-icon-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-data-viz-11: var(--beacon-reference-palette-charts-gray-lt-5);--beacon-system-color-data-viz-10: var(--beacon-reference-palette-charts-gray-lt-3);--beacon-system-color-data-viz-9: var(--beacon-reference-palette-charts-orange-lt-5);--beacon-system-color-data-viz-8: var(--beacon-reference-palette-charts-orange-lt-3);--beacon-system-color-data-viz-7: var(--beacon-reference-palette-charts-berry-lt-5);--beacon-system-color-data-viz-6: var(--beacon-reference-palette-charts-berry-lt-2);--beacon-system-color-border-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-border-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-border-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-border-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-primary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-border-link-focus: var(--beacon-reference-palette-grayscale-black);--beacon-system-color-border-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-focus-outer: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-border-focus-middle: var(--beacon-reference-palette-grayscale-black);--beacon-system-color-border-focus-inner: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-border-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-border-active: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-2: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-system-color-border-1: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-border-0: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-system-color-background-primary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-background-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-background-primary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-background-primary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-background-positive-pressed: var(--beacon-reference-palette-functional-green-1);--beacon-system-color-background-positive-hover: var(--beacon-reference-palette-functional-green-2);--beacon-system-color-background-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-background-negative-pressed: var(--beacon-reference-palette-functional-red-1);--beacon-system-color-background-negative-hover: var(--beacon-reference-palette-functional-red-2);--beacon-system-color-background-negative: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-background-link-focus: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-background-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-background-2: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-background-1: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-system-color-background-0: var(--beacon-reference-palette-grayscale-white);--beacon-component-tile-collection-color-border-green: var(--beacon-reference-palette-secondary-green-3);--beacon-component-tile-collection-color-border-gold: var(--beacon-reference-palette-secondary-gold-3);--beacon-component-tile-collection-color-border-blue: var(--beacon-reference-palette-secondary-ocean-3);--beacon-component-tile-collection-color-border-berry: var(--beacon-reference-palette-secondary-berry-3);--beacon-component-tile-collection-color-background-green: var(--beacon-reference-palette-secondary-green-1);--beacon-component-tile-collection-color-background-gold: var(--beacon-reference-palette-secondary-gold-1);--beacon-component-tile-collection-color-background-blue: var(--beacon-reference-palette-functional-blue-2);--beacon-component-tile-collection-color-background-berry: var(--beacon-reference-palette-secondary-berry-1);--beacon-component-table-color-border: var(--beacon-reference-palette-grayscale-light-gray-1);--beacon-component-tab-menu-color-background-primary-active: var(--beacon-reference-palette-functional-blue-6);--beacon-component-scrollbar-color-background-track: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-scrollbar-color-background-thumb-pressed: var(--beacon-reference-palette-grayscale-dark-gray-1);--beacon-component-scrollbar-color-background-thumb-hover: var(--beacon-reference-palette-grayscale-dark-gray-2);--beacon-component-scrollbar-color-background-thumb: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-progress-indicator-color-background-incomplete: var(--beacon-reference-palette-functional-blue-9);--beacon-component-progress-indicator-color-background-complete: var(--beacon-reference-palette-functional-blue-1);--beacon-component-notification-color-border-informational: var(--beacon-reference-palette-functional-blue-3);--beacon-component-notification-color-background-standard: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-component-primary-navigation-site-menu-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-component-primary-navigation-header-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-component-form-color-foreground-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-component-form-color-border-standard: var(--beacon-reference-palette-grayscale-medium-gray-2);--beacon-component-divider-color-neutral: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-data-viz-color-border-minor: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-component-data-viz-color-border-major: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-control-chip-color-background-default: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-avatar-icon-color-background: var(--beacon-reference-palette-grayscale-light-gray-5);--beacon-component-avatar-icon-color-avatar: var(--beacon-reference-palette-grayscale-light-gray-2)}.beacon-on-dark{--beacon-system-color-background-tertiary-pressed: #FFFFFF1F;--beacon-system-color-background-tertiary-hover: #FFFFFF14;--beacon-system-color-background-secondary-pressed: #FFFFFF1F;--beacon-system-color-background-secondary-hover: #FFFFFF14;--beacon-system-color-background-blanket: #061937A3;--beacon-component-table-color-background-selected: #8ff1ff29;--beacon-component-form-color-background-inactive: #061937B8;--beacon-system-color-text-title: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-tertiary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-standard: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-system-color-text-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-text-link-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-shadow-low: 0rem 0rem var(--beacon-reference-space-2) 0rem var(--beacon-reference-palette-primary-shadow-1);--beacon-system-color-shadow-high: 0rem 0rem var(--beacon-reference-space-7) 0rem var(--beacon-reference-palette-primary-shadow-3);--beacon-system-color-shadow-medium: 0rem 0rem var(--beacon-reference-space-4) 0rem var(--beacon-reference-palette-primary-shadow-2);--beacon-system-color-icon-tertiary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-icon-tertiary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-tertiary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-standard: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-icon-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-system-color-icon-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-icon-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-icon-link-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-highlight: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-icon-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-data-viz-11: var(--beacon-reference-palette-charts-gray-dt-4);--beacon-system-color-data-viz-10: var(--beacon-reference-palette-charts-gray-dt-1);--beacon-system-color-data-viz-9: var(--beacon-reference-palette-charts-orange-dt-4);--beacon-system-color-data-viz-8: var(--beacon-reference-palette-charts-orange-dt-1);--beacon-system-color-data-viz-7: var(--beacon-reference-palette-charts-berry-dt-4);--beacon-system-color-data-viz-6: var(--beacon-reference-palette-charts-berry-dt-1);--beacon-system-color-border-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-border-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-primary: var(--beacon-reference-palette-functional-blue-6);--beacon-system-color-border-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-border-link-focus: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-border-focus-outer: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-border-focus-middle: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-focus-inner: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-border-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-border-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-border-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-2: #FFFFFF33;--beacon-system-color-border-1: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-border-0: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-background-primary-pressed: var(--beacon-reference-palette-functional-blue-4);--beacon-system-color-background-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-background-primary-hover: var(--beacon-reference-palette-functional-blue-5);--beacon-system-color-background-primary: var(--beacon-reference-palette-functional-blue-6);--beacon-system-color-background-positive-pressed: var(--beacon-reference-palette-functional-green-1);--beacon-system-color-background-positive-hover: var(--beacon-reference-palette-functional-green-2);--beacon-system-color-background-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-background-negative-pressed: var(--beacon-reference-palette-functional-red-1);--beacon-system-color-background-negative-hover: var(--beacon-reference-palette-functional-red-2);--beacon-system-color-background-negative: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-background-link-focus: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-background-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-background-2: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-background-1: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-background-0: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-component-tile-collection-color-border-green: var(--beacon-reference-palette-secondary-green-3);--beacon-component-tile-collection-color-border-gold: var(--beacon-reference-palette-secondary-gold-3);--beacon-component-tile-collection-color-border-blue: var(--beacon-reference-palette-secondary-ocean-3);--beacon-component-tile-collection-color-border-berry: var(--beacon-reference-palette-secondary-berry-3);--beacon-component-tile-collection-color-background-green: var(--beacon-reference-palette-secondary-green-1);--beacon-component-tile-collection-color-background-gold: var(--beacon-reference-palette-secondary-gold-1);--beacon-component-tile-collection-color-background-blue: var(--beacon-reference-palette-functional-blue-2);--beacon-component-tile-collection-color-background-berry: var(--beacon-reference-palette-secondary-berry-1);--beacon-component-table-color-border: var(--beacon-reference-palette-grayscale-dark-gray-4);--beacon-component-tab-menu-color-background-primary-active: var(--beacon-reference-palette-functional-blue-3);--beacon-component-scrollbar-color-background-track: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-scrollbar-color-background-thumb-pressed: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-component-scrollbar-color-background-thumb-hover: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-scrollbar-color-background-thumb: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-progress-indicator-color-background-incomplete: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-progress-indicator-color-background-complete: var(--beacon-reference-palette-functional-blue-9);--beacon-component-notification-color-border-informational: var(--beacon-reference-palette-functional-blue-6);--beacon-component-notification-color-background-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-component-primary-navigation-site-menu-color-text-link: var(--beacon-reference-palette-grayscale-white);--beacon-component-primary-navigation-header-color-text-link: var(--beacon-reference-palette-grayscale-white);--beacon-component-form-color-foreground-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-form-color-border-standard: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-component-divider-color-neutral: #FFFFFF33;--beacon-component-data-viz-color-border-minor: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-data-viz-color-border-major: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-component-control-chip-color-background-default: var(--beacon-reference-palette-grayscale-dark-gray-4);--beacon-component-avatar-icon-color-background: var(--beacon-reference-palette-grayscale-light-gray-1);--beacon-component-avatar-icon-color-avatar: var(--beacon-reference-palette-grayscale-medium-gray-3)}.beacon-on-darker{--beacon-system-color-background-tertiary-pressed: #FFFFFF1F;--beacon-system-color-background-tertiary-hover: #FFFFFF14;--beacon-system-color-background-secondary-pressed: #FFFFFF1F;--beacon-system-color-background-secondary-hover: #FFFFFF14;--beacon-system-color-background-blanket: #061937A3;--beacon-component-table-color-background-selected: #8ff1ff14;--beacon-component-form-color-background-inactive: #0C2A4DB8;--beacon-system-color-text-title: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-tertiary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-standard: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-system-color-text-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-text-link-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-shadow-low: 0rem 0rem var(--beacon-reference-space-2) 0rem var(--beacon-reference-palette-primary-shadow-1);--beacon-system-color-shadow-high: 0rem 0rem var(--beacon-reference-space-7) 0rem var(--beacon-reference-palette-primary-shadow-3);--beacon-system-color-shadow-medium: 0rem 0rem var(--beacon-reference-space-4) 0rem var(--beacon-reference-palette-primary-shadow-2);--beacon-system-color-icon-tertiary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-icon-tertiary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-tertiary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-standard: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-icon-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-system-color-icon-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-icon-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-icon-link-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-highlight: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-icon-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-data-viz-11: var(--beacon-reference-palette-charts-gray-dt-4);--beacon-system-color-data-viz-10: var(--beacon-reference-palette-charts-gray-dt-1);--beacon-system-color-data-viz-9: var(--beacon-reference-palette-charts-orange-dt-4);--beacon-system-color-data-viz-8: var(--beacon-reference-palette-charts-orange-dt-1);--beacon-system-color-data-viz-7: var(--beacon-reference-palette-charts-berry-dt-4);--beacon-system-color-data-viz-6: var(--beacon-reference-palette-charts-berry-dt-1);--beacon-system-color-border-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-border-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-primary: var(--beacon-reference-palette-functional-blue-6);--beacon-system-color-border-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-border-link-focus: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-border-focus-outer: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-border-focus-middle: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-focus-inner: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-border-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-border-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-border-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-2: #FFFFFF33;--beacon-system-color-border-1: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-border-0: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-background-primary-pressed: var(--beacon-reference-palette-functional-blue-4);--beacon-system-color-background-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-background-primary-hover: var(--beacon-reference-palette-functional-blue-5);--beacon-system-color-background-primary: var(--beacon-reference-palette-functional-blue-6);--beacon-system-color-background-positive-pressed: var(--beacon-reference-palette-functional-green-1);--beacon-system-color-background-positive-hover: var(--beacon-reference-palette-functional-green-2);--beacon-system-color-background-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-background-negative-pressed: var(--beacon-reference-palette-functional-red-1);--beacon-system-color-background-negative-hover: var(--beacon-reference-palette-functional-red-2);--beacon-system-color-background-negative: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-background-link-focus: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-background-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-background-2: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-background-1: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-background-0: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-component-tile-collection-color-border-green: var(--beacon-reference-palette-secondary-green-3);--beacon-component-tile-collection-color-border-gold: var(--beacon-reference-palette-secondary-gold-3);--beacon-component-tile-collection-color-border-blue: var(--beacon-reference-palette-secondary-ocean-3);--beacon-component-tile-collection-color-border-berry: var(--beacon-reference-palette-secondary-berry-3);--beacon-component-tile-collection-color-background-green: var(--beacon-reference-palette-secondary-green-1);--beacon-component-tile-collection-color-background-gold: var(--beacon-reference-palette-secondary-gold-1);--beacon-component-tile-collection-color-background-blue: var(--beacon-reference-palette-functional-blue-2);--beacon-component-tile-collection-color-background-berry: var(--beacon-reference-palette-secondary-berry-1);--beacon-component-table-color-border: var(--beacon-reference-palette-grayscale-dark-gray-4);--beacon-component-tab-menu-color-background-primary-active: var(--beacon-reference-palette-functional-blue-3);--beacon-component-scrollbar-color-background-track: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-scrollbar-color-background-thumb-pressed: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-component-scrollbar-color-background-thumb-hover: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-scrollbar-color-background-thumb: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-progress-indicator-color-background-incomplete: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-progress-indicator-color-background-complete: var(--beacon-reference-palette-functional-blue-9);--beacon-component-notification-color-border-informational: var(--beacon-reference-palette-functional-blue-6);--beacon-component-notification-color-background-standard: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-component-primary-navigation-site-menu-color-text-link: var(--beacon-reference-palette-grayscale-white);--beacon-component-primary-navigation-header-color-text-link: var(--beacon-reference-palette-grayscale-white);--beacon-component-form-color-foreground-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-form-color-border-standard: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-component-divider-color-neutral: #FFFFFF33;--beacon-component-data-viz-color-border-minor: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-data-viz-color-border-major: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-component-control-chip-color-background-default: var(--beacon-reference-palette-grayscale-dark-gray-4);--beacon-component-avatar-icon-color-background: var(--beacon-reference-palette-grayscale-light-gray-1);--beacon-component-avatar-icon-color-avatar: var(--beacon-reference-palette-grayscale-medium-gray-3)}`;
var kt = Object.defineProperty, xt = Object.getOwnPropertyDescriptor, Ke$1 = (e5) => {
  throw TypeError(e5);
}, de$2 = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? xt(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && kt(t3, o2, a2), a2;
}, Ct = (e5, t3, o2) => t3.has(e5) || Ke$1("Cannot " + o2), oe$2 = (e5, t3, o2) => (Ct(e5, t3, "read from private field"), o2 ? o2.call(e5) : t3.get(e5)), be$2 = (e5, t3, o2) => t3.has(e5) ? Ke$1("Cannot add the same private member more than once") : t3 instanceof WeakSet ? t3.add(e5) : t3.set(e5, o2);
const Ue$1 = '[beacon-tag-name="beacon-navigation"]', De$1 = () => {
  throw new Error(
    "Component does not implement WatchMedia. Please use the WatchMedia mixin to correctly apply this method."
  );
}, Et$1 = {
  onReady: true,
  removeLargeEvent: false,
  selector: Ue$1
};
function St(e5) {
  return !!(e5 && e5.currentMode);
}
function Se$2({
  onReady: e5,
  removeLargeEvent: t3,
  selector: o2
} = Et$1) {
  const n4 = o2 != null ? o2 : Ue$1;
  return function(a2) {
    var r3, i5, E2, h2;
    let S2 = class extends a2 {
      constructor() {
        super(...arguments), this.innerModeClass = "beacon-on-light", this.modeClasses = {
          "beacon-on-light": "beacon-on-darker",
          "beacon-on-lighter": "beacon-on-dark",
          "beacon-on-dark": "beacon-on-lighter",
          "beacon-on-darker": "beacon-on-light"
        }, this.setInverseModeState = () => {
          if (this.modeStoreComponent instanceof HTMLElement && "currentMode" in this.modeStoreComponent) {
            const { currentMode: m3 } = this.modeStoreComponent;
            this.innerModeClass = this.determineModeClass(m3);
          }
        }, be$2(this, r3, () => {
          this.innerModeClass && this.classList.add(this.innerModeClass);
        }), be$2(this, i5, () => {
          this.innerModeClass && this.classList.remove(this.innerModeClass);
        }), be$2(this, E2, ({ target: m3 }) => {
          m3 instanceof HTMLElement && this === m3 && (this.modeStoreComponent = this.findModeStore(this), this.setInverseModeState(), "isDesktop" in this ? this.isDesktop && e5 && oe$2(this, r3).call(this) : De$1());
        }), be$2(this, h2, ({ matches: m3 }) => {
          "isDesktop" in this && (m3 ? oe$2(this, r3).call(this) : oe$2(this, i5).call(this));
        });
      }
      static get inverseStyles() {
        return [wt$2];
      }
      /** Recursive method for finding the parent `<beacon-navigation>` component. */
      findModeStore(m3) {
        var $2;
        const D2 = m3.closest(n4) || (($2 = this.getClosestHost()) == null ? void 0 : $2.closest(n4));
        return St(D2) ? D2 : null;
      }
      /** Return the opposite mode based on the current mode. */
      determineModeClass(m3) {
        return this.modeClasses[m3] || "beacon-on-light";
      }
      /** Returns only light mode opposites of the innerModeClass */
      determineModeClassOfOnlyLightModeOpposites() {
        return this.innerModeClass === "beacon-on-light" ? "beacon-on-light" : this.innerModeClass === "beacon-on-lighter" ? "beacon-on-lighter" : this.innerModeClass === "beacon-on-dark" ? "beacon-on-light" : "beacon-on-lighter";
      }
      prerenderInverseModeSetup() {
        this.addEventListener(
          g$a.ELEMENT_READY,
          oe$2(this, E2)
        ), "largeBreakpointWatcher" in this ? t3 || this.largeBreakpointWatcher.addEventListener(
          "change",
          oe$2(this, h2)
        ) : De$1();
      }
    };
    return r3 = /* @__PURE__ */ new WeakMap(), i5 = /* @__PURE__ */ new WeakMap(), E2 = /* @__PURE__ */ new WeakMap(), h2 = /* @__PURE__ */ new WeakMap(), de$2([
      it()
    ], S2.prototype, "innerModeClass", 2), de$2([
      it()
    ], S2.prototype, "modeStoreComponent", 2), de$2([
      u$2
    ], S2.prototype, "prerenderInverseModeSetup", 1), S2 = de$2([
      f$8("InverseMode")
    ], S2), S2;
  };
}
const Lt$1 = [
  "beacon-on-light",
  "beacon-on-lighter",
  "beacon-on-dark",
  "beacon-on-darker"
];
function zt$1(e5) {
  return Lt$1.includes(e5);
}
var Ot = Object.defineProperty, $t$1 = Object.getOwnPropertyDescriptor, ye$2 = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? $t$1(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && Ot(t3, o2, a2), a2;
};
function At$1(e5) {
  let t3 = class extends e5 {
    constructor() {
      super(...arguments), this.currentMode = "beacon-on-light";
    }
    setCurrentMode() {
      const o2 = '[class*="beacon-on-"]', n4 = this.getClosestHost();
      let a2 = null, r3;
      return n4 ? a2 = n4.closest(o2) : a2 = this.closest(o2), a2 && (r3 = Array.from(a2.classList).find(
        (i5) => i5.startsWith("beacon-on-")
      )), r3 && zt$1(r3) ? r3 : "beacon-on-light";
    }
    setCurrentContext({ target: o2 }) {
      o2 instanceof HTMLElement && this === o2 && (this.currentMode = this.setCurrentMode());
    }
    modeStoreInit() {
      this.setCurrentContext = this.setCurrentContext.bind(this), this.addEventListener(g$a.ELEMENT_READY, this.setCurrentContext);
    }
  };
  return ye$2([
    it()
  ], t3.prototype, "currentMode", 2), ye$2([
    u$2
  ], t3.prototype, "modeStoreInit", 1), t3 = ye$2([
    f$8("ModeStore")
  ], t3), t3;
}
const qe$1 = `<svg xmlns="http://www.w3.org/2000/svg" slot="prefix" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M14 16L10 12L14 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, Mt$2 = `<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg" slot="icon">
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.4697 23.5303C22.7626 23.8232 23.2374 23.8232 23.5303 23.5303C23.8232 23.2374 23.8232 22.7626 23.5303 22.4697L17.0607 16L23.5303 9.53033C23.8232 9.23744 23.8232 8.76256 23.5303 8.46967C23.2374 8.17678 22.7626 8.17678 22.4697 8.46967L16 14.9393L9.53033 8.46967C9.23744 8.17678 8.76256 8.17678 8.46967 8.46967C8.17678 8.76256 8.17678 9.23744 8.46967 9.53033L14.9393 16L8.46967 22.4697C8.17678 22.7626 8.17678 23.2374 8.46967 23.5303C8.76256 23.8232 9.23744 23.8232 9.53033 23.5303L16 17.0607L22.4697 23.5303Z" fill="currentColor"/>
</svg>
`, Nt = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="32" height="32" viewBox="0 0 32 32" fill="currentColor" class="hamburger-menu">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 9.25C7.58579 9.25 7.25 9.58579 7.25 10C7.25 10.4142 7.58579 10.75 8 10.75L24 10.75C24.4142 10.75 24.75 10.4142 24.75 10C24.75 9.58579 24.4142 9.25 24 9.25H8ZM7.25 16C7.25 15.5858 7.58579 15.25 8 15.25L24 15.25C24.4142 15.25 24.75 15.5858 24.75 16C24.75 16.4142 24.4142 16.75 24 16.75L8 16.75C7.58579 16.75 7.25 16.4142 7.25 16ZM7.25 22C7.25 21.5858 7.58579 21.25 8 21.25H24C24.4142 21.25 24.75 21.5858 24.75 22C24.75 22.4142 24.4142 22.75 24 22.75H8C7.58579 22.75 7.25 22.4142 7.25 22Z"/>
</svg>`, Tt$1 = `<svg class="trusty" width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation" style="background-color: var(--beacon-system-color-icon-primary)">
<g clip-path="url(#clip0_136_2653)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V72H18.9547C19.6146 64.85 20.4143 61.99 24.1933 54.57C28.4921 46.13 29.8117 39.71 29.8117 31.39C29.8117 31.2927 29.8125 31.1864 29.8133 31.0731C29.8198 30.1968 29.8294 28.905 29.5018 28.17C27.8023 28.34 25.373 27.59 23.9334 25.86C22.7137 24.38 21.8839 22.49 21.8839 21.3C21.8839 21.04 21.9139 20.85 22.0739 20.69C23.6634 20.25 26.7826 20.96 28.902 21.95C29.7717 20.53 30.5315 19.61 32.421 18.57C30.7015 14.92 27.5823 12.48 22.8836 12.48C17.4552 12.48 13.8961 15.53 12.7365 18.48C12.3866 19.38 12.8664 19.57 13.4463 18.99C15.7856 16.61 18.2649 15.43 21.504 15.43C25.4829 15.43 27.8223 17.93 27.8223 18.99C27.8223 19.34 27.5623 19.34 27.2124 19.21L27.1642 19.1942C25.9042 18.7805 24.7757 18.41 22.6237 18.41C16.6254 18.41 13.8661 24.03 13.8661 28.81C13.8661 31.44 14.7959 33.37 16.6254 33.37C18.035 33.37 18.8448 32.47 19.5446 31.03C19.7645 30.58 20.1244 30.58 20.4143 31.06C20.8042 31.7 20.8942 32.79 20.8942 33.63C20.8942 37.42 18.105 39.41 14.8959 39.41C8.89753 39.41 5.23854 34.08 5.23854 27.15C5.23854 17.78 11.1469 7.92 23.1436 7.92C31.7812 7.92 36.2699 12.53 38.6593 17.1H39.9289C41.6584 12.99 44.7776 10.55 49.4263 10.55C55.6245 10.55 58.1838 15.37 58.1838 21.11C58.1838 22.6809 58.0188 24.1895 57.8605 25.6374C57.7144 26.973 57.574 28.2568 57.574 29.49C57.574 31.38 58.3738 33.5 60.5232 33.5C61.9028 33.5 63.0625 32.6 63.6323 30.45C63.7923 29.87 64.1422 29.78 64.632 30.39C64.952 30.78 65.4018 31.71 65.4018 32.8C65.4018 35.82 63.4424 39 59.5235 39.03C56.1844 39.06 54.165 37.23 53.7451 34.92C53.6851 34.53 54.035 34.34 54.2549 34.66C55.4746 36.27 57.0442 37.13 59.2635 37.13C60.5132 37.13 61.7628 36.58 62.1827 35.65C62.3127 35.36 62.2127 35.2 61.9928 35.3C61.223 35.65 60.5532 35.78 59.8134 35.78C54.6748 35.78 54.035 30.55 53.6851 25.25C53.2052 26.63 52.2755 27.82 49.8662 28.04C50.0861 27.69 50.256 27.11 50.256 26.69C50.256 26.27 50.0361 25.98 49.5162 25.98C48.7465 25.98 48.0766 26.56 48.0766 27.49C48.0766 28.4238 48.7643 29.4058 49.4753 30.4212C50.0588 31.2544 50.658 32.1101 50.9059 32.98C51.0658 33.56 51.0658 34.07 51.0658 34.71C51.0658 35.83 50.9359 36.93 50.7759 37.47C50.6459 37.89 50.356 38.02 49.5262 38.02C48.9464 38.02 48.7565 37.83 48.6265 37.35C48.5665 37.09 48.4665 36.77 48.2766 36.77C48.067 36.77 47.9936 37.0062 47.9006 37.3054L47.8867 37.35C47.6968 38.02 47.1169 38.15 45.7373 38.15C45.1996 38.15 44.8471 38.1229 44.6162 38.1051H44.6161H44.6161L44.616 38.1051C44.5035 38.0964 44.4199 38.09 44.3577 38.09C44.0078 38.09 43.8778 38.22 43.8778 38.41C43.8778 38.67 43.9078 38.92 43.9778 39.15C44.0378 39.34 44.1677 39.41 44.5576 39.34C45.8373 39.15 46.967 39.12 47.8267 39.12C50.1661 39.12 50.296 39.34 50.1061 40.15C49.9461 40.86 49.6862 41.79 49.3063 42.62C49.0464 43.17 48.8564 43.23 48.4765 43.26C47.7068 43.32 46.677 43.36 45.9072 43.32C44.5099 43.2542 43.2844 42.8113 42.119 42.3902C40.9831 41.9798 39.9043 41.59 38.7792 41.59C38.1699 41.59 37.6128 41.6732 37.0419 41.7585C36.4421 41.8481 35.8271 41.94 35.1202 41.94C33.7406 41.94 32.7609 41.65 31.8212 40.98C30.4615 46.18 29.9617 52.53 29.9617 55.45C29.9617 57.47 30.5415 59.66 31.5712 60.49C31.9211 60.78 32.241 60.78 32.501 60.3C35.0084 55.6355 37.7216 54.0276 40.2896 52.5059C42.6874 51.0849 44.9585 49.7391 46.817 46.05C47.0069 45.7 47.3968 45.76 47.4568 46.18C48.0966 49.97 47.6768 54.56 46.847 58.96C46.747 59.47 47.1069 59.67 47.4568 59.22C48.5165 57.87 49.8961 55.43 50.406 53.47C50.536 52.99 50.9159 52.96 51.1158 53.44C52.3655 56.49 53.7751 62.27 54.195 66.44C54.2249 66.89 54.6448 66.92 54.8048 66.5C55.7045 64 56.2844 59.85 55.6046 56.8C55.5446 56.45 55.7345 56.25 56.1144 56.45C61.6929 59.16 67.1214 64.14 72 71.98V0H0ZM23.1341 65.1C22.1641 67.2 21.4341 69.52 21.2541 72H24.3941C23.9041 69.53 23.8441 67.14 23.8441 65.1C23.8441 64.43 23.5241 64.23 23.1341 65.1ZM45.7273 35.31C44.9875 35.37 44.6676 35.08 44.6676 34.12H44.6776C44.6776 33.8 44.9375 33.38 45.4174 33.38C45.6454 33.38 45.912 33.4104 46.2316 33.4469C46.7107 33.5017 47.3092 33.57 48.0766 33.57C48.3261 33.57 48.5664 33.5332 48.8162 33.4948L48.8164 33.4948L48.8165 33.4948C49.0872 33.4533 49.3691 33.41 49.6862 33.41C50.0361 33.41 50.1961 33.64 50.1961 34.15C50.1961 34.86 50.1261 35.28 49.6462 35.31C48.9064 35.34 48.7465 35.47 48.5865 36.08C48.4865 36.37 48.1666 36.43 48.0067 36.11C47.6168 35.31 46.947 35.21 45.7273 35.31ZM38.4393 26C37.8895 25.2 36.3199 24.2 34.7503 24.23C33.3107 24.2 32.411 25.16 32.411 25.93C32.411 26.12 32.541 26.25 32.7309 26.12C33.0208 25.96 33.2108 25.9 33.4407 25.9C33.7006 26.73 34.4404 27.79 35.88 27.79C36.9697 27.79 37.8395 27.28 37.6795 26.12C37.9395 26.12 38.0994 26.15 38.3194 26.22C38.4493 26.25 38.5093 26.09 38.4493 26H38.4393ZM49.1963 18.45C51.3457 18.45 52.7254 20.18 53.3652 22.27C51.6257 21.98 50.6659 21.98 49.5762 23.23C48.9664 21.47 47.5568 20.09 46.3371 19.51C46.727 19.06 47.5868 18.45 49.1963 18.45Z" fill="#00CFEC"/>
</g>
<defs>
<clipPath id="clip0_136_2653">
<rect width="72" height="72" fill="white"/>
</clipPath>
</defs>
</svg>
`, It = `<svg xmlns="http://www.w3.org/2000/svg" width="2" height="16" viewBox="0 0 1 16" class="vertical-divider-brand" fill="none">
<rect width="2" height="16" fill="var(--beacon-system-color-border-brand)"/>
</svg>`, Dt$2 = `<svg xmlns="http://www.w3.org/2000/svg" width="1" height="16" viewBox="0 0 1 16" class="vertical-divider" fill="none">
<rect width="1" height="16" fill="var(--beacon-system-color-border-0)"/>
</svg>`, Re$2 = `<svg width="132" height="24" viewBox="0 0 132 24" fill="currentcolor" xmlns="http://www.w3.org/2000/svg">
  <title>T. Rowe Price</title>
  <path d="M30.0123 1C33.5023 1 35.1214 2.61256 35.1214 5.21501C35.1214 8.95902 32.3506 9.95762 30.9819 10.3299C32.1888 11.5767 36.6237 19.1932 36.6237 19.1932C37.0076 19.8703 37.5432 20.4915 38.6695 20.4915L38.766 21.2317C38.4053 21.3138 37.9227 21.4894 36.8349 21.4894C34.5525 21.4894 33.236 20.9727 31.0073 17.3252C29.3664 14.6385 28.3439 12.3634 26.6624 9.79288H27.3634C29.6625 9.79288 31.2381 8.55624 31.2381 5.83695C31.2381 3.64672 30.6357 2.30195 27.9346 2.30195H26.2248C25.9171 2.30195 25.8184 2.43766 25.8184 2.75408V18.3216C25.8184 18.9406 26.5006 18.9559 27.4846 19.1417L27.7829 19.998H20.1069L20.4052 19.1417C21.3922 18.9559 22.0715 18.9406 22.0715 18.3216V2.68295C22.0715 2.06101 21.3922 2.04577 20.4052 1.85708L20.1069 1H30.0123ZM125.807 7.0344C130.506 7.0344 131.292 11.2857 131.39 12.7234L130.67 13.3917H123.341C123.341 16.5138 124.785 18.8202 127.503 18.8202C128.753 18.8202 129.777 18.2033 130.101 17.9994L130.199 18.8956C129.724 19.3093 128.393 20.4545 125.815 20.4545C121.567 20.4545 119.851 17.2519 119.851 13.743C119.851 11.5295 120.504 7.0344 125.807 7.0344ZM72.5122 7.0344C77.2149 7.0344 78.0067 11.2857 78.101 12.7234L77.3847 13.3917H70.0527C70.0527 16.5138 71.4948 18.8202 74.2162 18.8202C75.4645 18.8202 76.4834 18.2033 76.8158 17.9994L76.9108 18.8956C76.4362 19.3093 75.1023 20.4545 72.5296 20.4545C68.2791 20.4545 66.5598 17.2519 66.5598 13.743C66.5598 11.5295 67.2108 7.0344 72.5122 7.0344ZM43.3178 7.0344C47.3905 7.0344 49.5742 9.84876 49.5742 13.7372C49.5742 17.4631 47.5183 20.4545 43.3178 20.4545C39.1187 20.4545 37.0671 17.4957 37.0671 13.7372C37.0344 10.0984 39.0752 7.0344 43.3178 7.0344ZM115 7.0344C117.29 7.0344 118.76 7.57434 118.917 7.62078L118.274 11.6471H117.382C117.076 9.39954 116.397 8.25071 114.786 8.25071C112.671 8.25071 111.989 10.7385 111.989 13.2444C111.989 16.3542 113.669 18.8202 116.477 18.8202C117.591 18.8202 118.745 18.2352 119.119 17.9994L119.215 18.8956C118.797 19.2324 117.334 20.4509 114.977 20.4509C110.454 20.4509 108.485 17.1212 108.485 13.5507C108.485 9.15061 111.161 7.0344 115 7.0344ZM16 16.6024C16.9761 16.6024 17.7744 17.3934 17.7744 18.3746C17.7744 19.3565 16.9761 20.149 16 20.149C15.0116 20.149 14.2206 19.3565 14.2206 18.3746C14.2206 17.3934 15.0116 16.6024 16 16.6024ZM106.583 7.10044L106.578 18.5074C106.75 19.0263 107.57 18.9936 108.082 19.1417C108.269 19.4813 108.251 19.4174 108.446 19.998H101.612C101.882 19.5517 101.868 19.4682 102.048 19.1417C102.537 18.9087 103.2 18.9276 103.306 18.294V7.60119C104.356 7.40452 105.488 7.29276 106.583 7.10044ZM15.4957 1L15.7047 5.89574H14.7823C14.3403 3.82525 14.2481 2.70981 12.8802 2.70981H9.72616V18.3216C9.72616 18.9406 10.4054 18.9559 11.3888 19.1417L11.6907 19.998H4.01326L4.31298 19.1417C5.29344 18.9559 5.97852 18.9406 5.97852 18.3216V2.70981H2.81871C1.45217 2.70981 1.35856 3.82525 0.918041 5.89574H0L0.206831 1H15.4957ZM55.7487 7.48798L55.4454 8.34433C54.5542 8.50181 54.3277 8.74638 54.3277 9.17746C54.3277 9.47211 54.4431 9.92351 54.5505 10.3887L54.5823 10.5217C54.8805 11.7744 54.9399 12.1122 55.5832 14.6981L57.8199 7.48798H59.9485L62.1177 14.7496C62.1177 14.7496 62.9203 11.4657 63.3855 9.53597C63.4494 9.28415 63.4871 9.08094 63.4871 8.90241C63.4871 8.55624 63.1424 8.47787 62.4428 8.34433L62.1423 7.48798H67.2892L66.9909 8.34433C66.2013 8.48367 65.5743 8.52867 65.2884 9.47719L62.5067 19.998H60.3861L58.0115 12.5412L55.7342 19.998H53.6949L50.6694 9.0091C50.5462 8.59062 49.9835 8.48553 49.3897 8.38703L49.1345 8.34433L48.8318 7.48798H55.7487ZM90.0182 1C93.5706 1 95.1251 2.64739 95.1251 5.31588C95.1251 6.37762 94.8145 7.30219 94.5568 7.72529L97.3066 6.96546V9.37704C98.2 8.20935 99.7719 6.95094 101.849 7.03367L101.114 11.6471H100.225C100.043 10.3829 99.6681 9.67168 98.8821 9.67168C98.0127 9.67168 97.5657 10.343 97.3095 10.7131L97.311 18.3216C97.311 18.9406 97.9939 18.9559 98.9765 19.1417L99.2755 19.998H92.0705L92.3709 19.1417C93.355 18.9559 94.0401 18.9406 94.0401 18.3216V9.98447C94.0401 9.41115 93.8122 9.16876 93.4748 9.09183C92.9189 9.60274 90.7918 10.9881 88.6509 10.9881C88.0565 10.9881 87.5231 10.9105 87.3555 10.8887L86.6653 9.79288H87.4295C89.8411 9.79288 91.2388 8.36102 91.2388 5.81881C91.2388 3.63293 90.6292 2.30195 87.8461 2.30195H86.2313C85.9062 2.30195 85.8235 2.45725 85.8235 2.76206V18.3216C85.8235 18.9406 86.5027 18.9559 87.4897 19.1417L87.7865 19.998H80.1069L80.4103 19.1417C81.3922 18.9559 82.0715 18.9406 82.0715 18.3216V2.68295C82.0715 2.06101 81.3922 2.04577 80.4103 1.85708L80.1069 1H90.0182ZM43.3178 8.25071C41.0513 8.25071 40.7284 10.835 40.7284 13.7372C40.7284 17.6801 41.4831 19.236 43.3178 19.236C45.1916 19.236 45.913 17.5683 45.913 13.7372C45.913 10.0215 45.2605 8.25071 43.3178 8.25071ZM125.751 8.25071C123.689 8.25071 123.407 10.8648 123.407 12.2074H128.098C128.098 10.7247 127.736 8.25071 125.751 8.25071ZM72.4643 8.25071C70.4062 8.25071 70.121 10.8648 70.121 12.2074H74.8062C74.8062 10.7247 74.4514 8.25071 72.4643 8.25071ZM105 2.51459C105.991 2.51459 106.791 3.31796 106.791 4.3064C106.791 5.29266 105.991 6.09604 105 6.09604C104.011 6.09604 103.207 5.29266 103.207 4.3064C103.207 3.31796 104.011 2.51459 105 2.51459Z"/>
</svg>`, Be$1 = (e5, t3, o2) => !o2 || e5 < o2.left || e5 > o2.right || t3 < o2.top || t3 > o2.bottom;
function ke$2(e5, t3 = 50) {
  e5 instanceof HTMLElement && setTimeout(() => {
    e5.focus();
  }, t3);
}
var Rt$1 = Object.defineProperty, Bt$2 = Object.getOwnPropertyDescriptor, K$1 = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? Bt$2(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && Rt$1(t3, o2, a2), a2;
};
function Ye$1(e5) {
  let t3 = class extends e5 {
    constructor() {
      super(...arguments), this.isOpen = false, this.handleActiveNavItemChange = ({ target: o2 }) => {
        this.associatedNavTrigger instanceof B$2 && o2 instanceof B$2 && this.associatedNavTrigger.isEqualNode(o2) && (this.isOpen = !!this.associatedNavTrigger.active);
      }, this.updateNavItemOnEscape = ({ key: o2 }) => {
        o2 === o$2.ESCAPE && this.associatedNavTrigger instanceof B$2 && this.associatedNavTrigger.active && this.handleMenuClose(true);
      }, this.handleMenuCloseButton = ({ target: o2 }) => {
        o2 instanceof HTMLElement && this.isEqualNode(o2) && this.associatedNavTrigger instanceof B$2 && this.handleMenuClose(true);
      };
    }
    /** The outermost parent element to look for the associated navigation item. */
    get navItemRoot() {
      return this.closest('[beacon-tag-name="beacon-navigation"]');
    }
    /** The navigation button that triggers this popover. */
    get associatedNavTrigger() {
      var o2;
      return (o2 = this.navItemRoot) == null ? void 0 : o2.querySelector(`[opens="${this.opensBy}"]`);
    }
    /** Return a given expanded nav by its index in the slotted elements. */
    findExpandedNav(o2 = 0) {
      return this.slottedExpandedNavItems[o2];
    }
    /** Handles closing of components that inherit this class. */
    handleMenuClose(o2 = false) {
      this.associatedNavTrigger instanceof B$2 && (this.associatedNavTrigger.active = false, o2 && this.associatedNavTrigger.button.focus());
    }
    /** Sets the nav item active state when focusing out of the popover. */
    handleFocusOut({ relatedTarget: o2 }) {
      o2 instanceof HTMLElement && this.associatedNavTrigger instanceof B$2 && !this.associatedNavTrigger.isEqualNode(o2) && !this.contains(o2) && this.associatedNavTrigger.isDesktop && this.associatedNavTrigger.active && this.handleMenuClose();
    }
    prerenderNavigationButtonTriggeredSetup() {
      document.addEventListener(
        g$a.ACTIVE_NAV_ITEM,
        this.handleActiveNavItemChange
      ), document.addEventListener(lt$1.KEYDOWN, this.updateNavItemOnEscape), this.addEventListener(
        g$a.CLOSE_ACTIVE_NAV_ITEM,
        this.handleMenuCloseButton
      ), this.addEventListener(lt$1.FOCUSOUT, this.handleFocusOut);
    }
    teardownNavibationButtonTriggered() {
      document.removeEventListener(
        g$a.ACTIVE_NAV_ITEM,
        this.handleActiveNavItemChange
      ), document.removeEventListener(lt$1.KEYDOWN, this.updateNavItemOnEscape);
    }
  };
  return K$1([
    v$c({ attribute: "opens-by", reflect: true })
  ], t3.prototype, "opensBy", 2), K$1([
    v$c({ type: Boolean, reflect: true, attribute: "is-open" })
  ], t3.prototype, "isOpen", 2), K$1([
    v$9(
      { flatten: true, selector: "beacon-navigation-expanded" },
      true
    )
  ], t3.prototype, "slottedExpandedNavItems", 2), K$1([
    u$2
  ], t3.prototype, "prerenderNavigationButtonTriggeredSetup", 1), K$1([
    y$7
  ], t3.prototype, "teardownNavibationButtonTriggered", 1), t3 = K$1([
    f$8("NavigationButtonTriggered")
  ], t3), t3;
}
const Ft$1 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" slot="suffix"
    xmlns="http://www.w3.org/2000/svg">
    <g id="Icon">
        <path id="icon" fill-rule="evenodd" clip-rule="evenodd"
            d="M16.4697 17.5303C16.7626 17.8232 17.2374 17.8232 17.5303 17.5303C17.8232 17.2374 17.8232 16.7626 17.5303 16.4697L13.0607 12L17.5303 7.53033C17.8232 7.23744 17.8232 6.76256 17.5303 6.46967C17.2374 6.17678 16.7626 6.17678 16.4697 6.46967L12 10.9393L7.53033 6.46967C7.23744 6.17678 6.76256 6.17678 6.46967 6.46967C6.17678 6.76256 6.17678 7.23744 6.46967 7.53033L10.9393 12L6.46967 16.4697C6.17678 16.7626 6.17678 17.2374 6.46967 17.5303C6.76256 17.8232 7.23744 17.8232 7.53033 17.5303L12 13.0607L16.4697 17.5303Z"
            fill="currentColor" />
    </g>
</svg>
    `;
var P$4 = /* @__PURE__ */ ((e5) => (e5.CLICK = "click", e5.HOVER = "hover", e5.MANUAL = "manual", e5))(P$4 || {}), k$6 = /* @__PURE__ */ ((e5) => (e5.START = "start", e5.CENTER = "center", e5.END = "end", e5))(k$6 || {}), W = /* @__PURE__ */ ((e5) => (e5.HORIZONTAL = "horizontal", e5.VERTICAL = "vertical", e5))(W || {}), p$1 = /* @__PURE__ */ ((e5) => (e5.BlockStart = "block-start", e5.InlineStart = "inline-start", e5.BlockEnd = "block-end", e5.InlineEnd = "inline-end", e5))(p$1 || {});
const Qe$1 = {
  DOWN: tt$1`<svg
    class="tooltip-arrow arrow--down"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(180deg);">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`,
  LEFT: tt$1`<svg
    class="tooltip-arrow arrow--left"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(270deg) scale(2);">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`,
  RIGHT: tt$1`<svg
    class="tooltip-arrow arrow--right"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(90deg) scale(2);">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`,
  UP: tt$1`<svg
    class="tooltip-arrow arrow--up"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`
};
var Zt$2 = Object.defineProperty, Ht$1 = Object.getOwnPropertyDescriptor, g$1 = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? Ht$1(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && Zt$2(t3, o2, a2), a2;
};
function Pt$1(e5 = { disableDebounceOpen: false }) {
  return function(t3) {
    let o2 = class extends t3 {
      constructor() {
        super(...arguments), this.orientation = W.VERTICAL, this.trigger = P$4.HOVER, this.isOpen = false, this.content = "", this.alignment = k$6.CENTER, this.direction = p$1.InlineStart, this.topOffset = 0, this.leftOffset = 0, this.RTL = false, this.marginAdjust = 0, this.targetSelectorString = ".overlay-target", this.overlaySelector = ".overlay-wrapper", this.overlayName = "overlay", this.debouncedCalculateOffset = r$6(this.calculateOffset.bind(this), 100), this.toggleClick = (n4) => {
          n4 && n4.isTrusted && (this.isOpen ? this.close() : this.open());
        }, this.intersectionObserver = new IntersectionObserver(
          this.debouncedCalculateOffset,
          { threshold: 1 }
        ), this.resizeObserver = new ResizeObserver(this.debouncedCalculateOffset), this.open = e5 && !e5.disableDebounceOpen ? r$6(async () => {
          this.calculateOffset(), this.isOpen = true, this.attachOpenEventListeners(), await this.updateComplete, this.emitOpen();
        }, 100) : async () => {
          this.calculateOffset(), this.isOpen = true, this.attachOpenEventListeners(), await this.updateComplete, this.emitOpen();
        }, this.handleKeydown = (n4) => {
          n4.isTrusted && this.isOpen && (super.handleKeydown(), this.closeOnEscape(n4));
        }, this.handleExternalClick = (n4) => {
          n4.isTrusted && !n4.composedPath().includes(this.overlayEl) && this.isOpen && this.close();
        };
      }
      /** Callback for on beacon-event-close */
      onBeaconClose() {
      }
      /** Callback for on beacon-event-open */
      onBeaconOpen() {
      }
      get targetSelector() {
        return this.targetSelectorString;
      }
      set targetSelector(n4) {
        this.targetSelectorString = n4;
      }
      get viewportRect() {
        return {
          width: window.innerWidth || document.documentElement.clientWidth,
          height: window.innerHeight || document.documentElement.clientHeight
        };
      }
      set targetRect(n4) {
        this.targetRectObj = n4;
      }
      get scrollListeningContainer() {
        var n4;
        return (n4 = this.scrollListeningContainerObj) != null ? n4 : window;
      }
      set scrollListeningContainer(n4) {
        this.scrollListeningContainerObj = n4;
      }
      get externalClickNode() {
        return this.getRootNode();
      }
      /**
       * Calculates margin adjustment for when the overlay component is visible
       * @param marginToken token representing the margin of the overlay component
       * @param arrowSizeToken token representing the size of the arrow on the overlay
       */
      computeMarginAdjustment(n4, a2) {
        this.marginAdjust = parseInt(n4, 10) + parseInt(a2, 10) / 2;
      }
      /**
       * Used to determine if the preferred direction and orientation are compatible,
       * when dynamically calculating the direction of the overlay with the preferred direction
       * @param direction The current direction of the overlay
       * @returns
       */
      static computeDirectionOrientation(n4) {
        return n4 === p$1.BlockStart || n4 === p$1.BlockEnd ? W.VERTICAL : W.HORIZONTAL;
      }
      /**
       * Evaluate Alignment and Direction based on the Target and Overlay DOMRect.
       * @param target DOMRect of the target element
       * @param overlay DOMRect of the overlay element
       */
      computeDirection(n4, a2) {
        this.orientation === W.VERTICAL ? (this.computeVerticalDirection(n4), this.computeAlignment(n4)) : this.computeHorizontalDirection(n4, a2);
      }
      /**
       * Computes the vertical direction based on available space,
       * and a user provided preferred direction.
       * @param target DOMRect of the target element
       */
      computeVerticalDirection(n4) {
        const a2 = this.viewportRect.height / 4, r3 = this.viewportRect, i5 = n4.top < a2, E2 = n4.bottom > r3.height - a2, h2 = i5 ? p$1.BlockStart : p$1.BlockEnd;
        this.preferredDirection && o2.computeDirectionOrientation(this.preferredDirection) === W.VERTICAL ? !i5 && this.preferredDirection == p$1.BlockEnd ? this.direction = p$1.BlockEnd : !E2 && this.preferredDirection == p$1.BlockStart ? this.direction = p$1.BlockStart : this.direction = h2 : this.direction = h2;
      }
      /**
       * Computes the horizontal direction based on available space,
       * prioritizing the preferred-direction over default dynamic calculations
       * if it exists
       * @param target
       * @param overlay
       */
      computeHorizontalDirection(n4, a2) {
        this.alignment = k$6.CENTER;
        const r3 = n4.x + n4.width + a2.width < this.viewportRect.width, i5 = n4.x - a2.width > 0, E2 = this.viewportRect.width < n4.x, h2 = r3 ? p$1.InlineStart : p$1.InlineEnd;
        this.RTL ? E2 ? this.direction = p$1.InlineEnd : this.direction = p$1.InlineStart : this.preferredDirection && o2.computeDirectionOrientation(
          this.preferredDirection
        ) === W.HORIZONTAL ? (r3 && this.preferredDirection === p$1.InlineStart && (this.direction = p$1.InlineStart), i5 && this.preferredDirection === p$1.InlineEnd ? this.direction = p$1.InlineEnd : this.direction = h2) : this.direction = h2;
      }
      /**
       * Aligns the arrow of the popover when vertically oriented, to ensure most
       * of the popover is visible in the viewport.
       * @param target
       */
      computeAlignment(n4) {
        const a2 = n4.x < this.viewportRect.width / 4, r3 = n4.x > this.viewportRect.width * 3 / 4;
        a2 ? this.alignment = k$6.START : r3 ? this.alignment = k$6.END : this.alignment = k$6.CENTER;
      }
      /**
       * @param overlayWidth Width of the Overlay element
       * @param targetWidth Width of the Target Element
       * @returns Based on Alignment, will return leftOffset as number.
       */
      calculateHorizontalOffset(n4, a2) {
        const r3 = a2 - n4, i5 = n4 / 2 - this.marginAdjust;
        switch (this.alignment) {
          case k$6.START:
            return r3 / 2 + i5;
          case k$6.CENTER:
            return r3 / 2;
          case k$6.END:
            return r3 / 2 - i5;
          default:
            return 0;
        }
      }
      /**
       * Evaluate the Overlay Leftoffset and topOffset based on targetSelector and Overlay Selector.
       * @abstract
       */
      calculateOffset() {
        var n4, a2, r3;
        const i5 = (n4 = this.shadowRoot) == null ? void 0 : n4.querySelector(this.targetSelector), E2 = (a2 = this.shadowRoot) == null ? void 0 : a2.querySelector(this.overlaySelector);
        if (E2 && (i5 || this.targetRectObj)) {
          const h2 = (r3 = this.targetRectObj) != null ? r3 : i5 == null ? void 0 : i5.getBoundingClientRect(), S2 = E2.getBoundingClientRect();
          this.computeDirection(h2, S2);
          const { height: m3, width: $2 } = h2, { height: D2, width: te2 } = S2;
          switch (this.topOffset = 0, this.leftOffset = $2, this.direction) {
            case p$1.BlockEnd:
              this.topOffset = -1 * (m3 + D2), this.leftOffset = this.calculateHorizontalOffset(
                te2,
                $2
              );
              break;
            case p$1.BlockStart:
              this.leftOffset = this.calculateHorizontalOffset(
                te2,
                $2
              );
              break;
            case p$1.InlineEnd:
              this.leftOffset = -1 * te2, this.topOffset = -1 * (D2 + (m3 - D2) / 2);
              break;
            case p$1.InlineStart:
              this.topOffset = -1 * (D2 + (m3 - D2) / 2);
              break;
          }
        }
      }
      /**
       * Enables overlay surface to reposition and reorient based on:
       * 1. When overlayWrapper is intersecting with viewport border
       * 2. When document body is resized
       * 3. When user scrolls
       */
      engageDynamicOverlayPositioning() {
        this.intersectionObserver.observe(this.overlayWrapper), this.resizeObserver.observe(document.body), this.scrollListeningContainer.addEventListener(
          "scroll",
          this.debouncedCalculateOffset
        );
      }
      /**
       * Disengages dynamic overlay positioning by unobserving by:
       * 1. Unobserving overlayWrapper intersections with viewport
       * 2. Unobserving resize of the document body
       * 3. Removing scroll event listener from scrollListeningContainer
       */
      disengageDynamicOverlayPositioning() {
        this.intersectionObserver.unobserve(this.overlayWrapper), this.resizeObserver.unobserve(document.body), this.scrollListeningContainer.removeEventListener(
          "scroll",
          this.debouncedCalculateOffset
        );
      }
      /**
       * Destroys dynamic overlay positioning by:
       * 1. Disconnecting intersection observer
       * 2. Disconnecting resize observer
       * 3. Removing scroll event listener from scrollListeningContainer
       * This method is intended for use when disconnecting component.
       */
      destroyDynamicOverlayPositioning() {
        this.intersectionObserver.disconnect(), this.resizeObserver.disconnect(), this.scrollListeningContainer.removeEventListener(
          "scroll",
          this.debouncedCalculateOffset
        );
      }
      /**
       * Adds event listener to the document to close the overlay when clicked outside
       */
      attachOpenEventListeners() {
        setTimeout(() => {
          this.trigger === P$4.CLICK && document.addEventListener(lt$1.CLICK, this.handleExternalClick);
        }, 100);
      }
      /**
       * Makes the overlay hidden.
       */
      close() {
        this.isOpen = false, this.removeOpenEventListeners(), this.trigger === P$4.MANUAL && this.focusOnTrigger();
      }
      /**
       * Focuses on the element that opened the overlay,
       * used when the overlay is closed and the trigger is manual.
       */
      focusOnTrigger() {
        var n4, a2;
        const r3 = document.querySelector(this.targetSelector) || ((a2 = (n4 = this.getClosestHost()) == null ? void 0 : n4.shadowRoot) == null ? void 0 : a2.querySelector(this.targetSelector));
        r3 && r3.focus();
      }
      removeOpenEventListeners() {
        this.trigger === P$4.CLICK && document.removeEventListener(lt$1.CLICK, this.handleExternalClick);
      }
      /** Closes the popover when the key pressed is the escape key. */
      closeOnEscape(n4) {
        n4.key === o$2.ESCAPE && this.close();
      }
      /**
       * @event {BeaconEvents} beacon-events-close - emits when the overlay is closed with the close() method.
       */
      emitClose() {
        L$6(this, g$a.CLOSE, void 0, this.onBeaconClose);
      }
      /**
       * @event {BeaconEvents} beacon-events-open - emits when the overlay is closed with the open() method.
       */
      emitOpen() {
        L$6(this, g$a.OPEN, void 0, this.onBeaconOpen);
      }
      /**
       * Lit lifecycle hook to handle changing of properties
       */
      updated(n4) {
        o$4(n4, "isOpen") && (this.isOpen ? (this.open(), this.emitOpen()) : (this.close(), this.emitClose()));
      }
      overlayPrerender() {
        this.isOpen && this.open(), this.externalClickNode.addEventListener(
          lt$1.KEYDOWN,
          this.handleKeydown
        );
      }
      overlayPostrender() {
        this.calculateOffset();
      }
      overlayDestroy() {
        this.destroyDynamicOverlayPositioning(), this.externalClickNode.removeEventListener(
          lt$1.KEYDOWN,
          this.handleKeydown
        ), this.externalClickNode.removeEventListener(
          lt$1.CLICK,
          this.handleExternalClick
        );
      }
      /**
       * Render template: slotted element
       */
      renderSlot() {
        return this.trigger === P$4.HOVER ? tt$1`<slot
            @mouseover=${this.open}
            @mouseout=${this.close}
            @focusin=${this.open}
            @focusout=${this.close}></slot>` : this.trigger === P$4.CLICK ? tt$1`<slot @click=${this.toggleClick}></slot>` : tt$1`<slot></slot>`;
      }
      /**
       * Render template: overlay content
       */
      renderOverlayContent() {
        return tt$1`<p>${this.content}</p>`;
      }
      /**
       * Render template: overlay content skeleton
       */
      renderContentWrapper() {
        return tt$1`<div class="tooltip-content">
          ${this.renderOverlayContent()}
        </div>`;
      }
      /**
       * Render template: arrow
       * @todo align the arrow implementation with the navigation popover arrow
       */
      renderArrow() {
        return tt$1`<span
          class="overlay-arrow ${this.alignment}"
          aria-hidden="true"
          >${Qe$1.UP}</span
        >`;
      }
      /**
       * Render template: entire overlay skeleton
       */
      renderOverlayWrapper() {
        return this.style.setProperty("--left-offset", `${this.leftOffset}px`), this.style.setProperty("--top-offset", `${this.topOffset}px`), this.topScreenOffset && this.style.setProperty(
          "--screen-offset-top",
          `${this.topScreenOffset}px`
        ), this.leftScreenOffset && this.style.setProperty(
          "--screen-offset-left",
          `${this.leftScreenOffset}px`
        ), tt$1`<div
          id="${this.overlayName}"
          aria-hidden="${e$6(this.isOpen ? void 0 : "true")}"
          class="overlay-wrapper 
            ${this.direction}">
          ${this.renderArrow()} ${this.renderContentWrapper()}
        </div>`;
      }
      /**
       * Render template: overlay and target
       */
      render() {
        return tt$1`${this.trigger === P$4.MANUAL ? h$c : tt$1`<div
              class="overlay-target"
              aria-describedBy="${this.overlayName}">
              ${this.renderSlot()}
            </div>`}
        ${this.renderOverlayWrapper()}`;
      }
    };
    return g$1([
      v$c()
    ], o2.prototype, "orientation", 2), g$1([
      v$c({ attribute: "preferred-direction" })
    ], o2.prototype, "preferredDirection", 2), g$1([
      v$c({ reflect: true })
    ], o2.prototype, "trigger", 2), g$1([
      v$c({ type: Boolean, reflect: true, attribute: "is-open" })
    ], o2.prototype, "isOpen", 2), g$1([
      v$c()
    ], o2.prototype, "content", 2), g$1([
      it()
    ], o2.prototype, "alignment", 2), g$1([
      it()
    ], o2.prototype, "direction", 2), g$1([
      it()
    ], o2.prototype, "topOffset", 2), g$1([
      it()
    ], o2.prototype, "leftOffset", 2), g$1([
      it()
    ], o2.prototype, "topScreenOffset", 2), g$1([
      it()
    ], o2.prototype, "leftScreenOffset", 2), g$1([
      it()
    ], o2.prototype, "RTL", 2), g$1([
      y$6("div#tooltip")
    ], o2.prototype, "overlayEl", 2), g$1([
      h$9(".overlay-wrapper")
    ], o2.prototype, "overlayWrapper", 2), g$1([
      u$2
    ], o2.prototype, "overlayPrerender", 1), g$1([
      d$e
    ], o2.prototype, "overlayPostrender", 1), g$1([
      y$7
    ], o2.prototype, "overlayDestroy", 1), o2 = g$1([
      f$8("Overlay")
    ], o2), o2;
  };
}
function _t$1(e5 = { disableDebounceOpen: false }) {
  return function(t3) {
    const o2 = Pt$1(e5)(t3);
    let n4 = class extends o2 {
      constructor() {
        super(...arguments), this.open = e5 && !e5.disableDebounceOpen ? r$6(async () => {
          this.calculateOffset(), this.engageDynamicOverlayPositioning(), this.activeElement = document.activeElement, await this.updateComplete, this.isOpen = true, this.attachOpenEventListeners();
        }, 100) : async () => {
          this.calculateOffset(), this.engageDynamicOverlayPositioning(), this.activeElement = document.activeElement, await this.updateComplete, this.isOpen = true, this.attachOpenEventListeners();
        };
      }
      /**
       * Handle close and return focus to active element.
       * Also removes listener and observer logic when overlay closed for better performance.
       */
      close() {
        super.close(), this.disengageDynamicOverlayPositioning(), this.focusOnActiveElement();
      }
      /**
       * Handle dark mode theming in action zone
       */
      setActionZoneDarkMode() {
        this.slottedActionzone && this.slottedActionzone.length && this.slottedActionzone.forEach((a2) => {
          a2.classList.contains("beacon-on-dark") || a2.classList.add("beacon-on-dark");
        });
      }
      /**
       * Focuses on the previously active element
       */
      focusOnActiveElement() {
        var a2;
        (a2 = this.activeElement) == null || a2.focus();
      }
      /**
       * Render template: close icon button
       */
      renderCloseButton() {
        return kt$1`<${this.getScopedTag("beacon-icon-button")}
                        variant="tertiary"
                        class="beacon-popover-close-button beacon-on-dark"
                        @beacon-event-click="${this.close}"
                        >
                        Close Button
                        <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z"/>
                        </svg>
                        </${this.getScopedTag("beacon-icon-button")}>
                        `;
      }
      /**
       * Render template: adjusts content wrapper
       */
      renderContentWrapper() {
        return tt$1`<div class="beacon-popover-surface">
          ${this.renderCloseButton()}
          <div class="beacon-popover-zones-wrapper">
            ${this.renderOverlayContent()}
          </div>
        </div>`;
      }
      /**
       * Render template: slot with only click event
       */
      renderSlot() {
        return tt$1`<slot @click=${this.toggleClick}></slot>`;
      }
    };
    return g$1([
      y$6("div#overlay")
    ], n4.prototype, "overlayEl", 2), g$1([
      it()
    ], n4.prototype, "activeElement", 2), g$1([
      v$9({ flatten: true, slot: "actionzone" })
    ], n4.prototype, "slottedActionzone", 2), n4 = g$1([
      f$8("OverlayInteractive")
    ], n4), n4;
  };
}
const pe$1 = {
  beaconTagName: "beacon-navigation-popover",
  arrowSpaceMargin: "24px",
  arrowSizeInline: "12px"
}, jt$2 = T$7`[beacon-tag-name=beacon-navigation-popover]{--navigation-popover-link-color: var(--beacon-system-color-text-link-active)}@media (width >= 960px){[beacon-tag-name=beacon-navigation-popover]{--navigation-popover-link-color: var(--beacon-system-color-text-link-active)}[beacon-tag-name=beacon-navigation-popover] [beacon-tag-name=beacon-navigation-expanded][level="1"] [beacon-tag-name=beacon-navigation-expanded]:not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-end:var(--beacon-system-space-micro-jumbo)}}[beacon-tag-name=beacon-navigation-popover][slot=site-selector] [beacon-tag-name=beacon-navigation-expanded] [selected-site]{align-items:center;color:var(--beacon-system-color-text-link-active);display:inline-flex;font-weight:var(--beacon-system-font-weight-bold);gap:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-navigation-popover][slot=site-selector] [beacon-tag-name=beacon-navigation-expanded] [selected-site]:after{block-size:1em;content:url('data:image/svg+xml,<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 9.01852L6.78947 13.5L15 2.5" stroke="%23248647" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');inline-size:1em}`, Vt$1 = T$7`@media (width >= 960px){:host([motion-state=enabled]){--popover-motion-easing: var(--beacon-system-motion-easing-decelerate-emphasize-1);--popover-motion-duration: var(--beacon-reference-motion-duration-7);display:grid;transition-duration:var(--popover-motion-duration);transition-property:grid-template-rows;transition-timing-function:var(--popover-motion-easing)}:host([motion-state=enabled]) .overlay-wrapper{overflow:hidden;visibility:visible}:host([motion-state=enabled]) .beacon-popover-zones-wrapper{opacity:0;transition:opacity var(--popover-motion-duration) var(--popover-motion-easing) var(--popover-motion-duration)}}@media (width >= 960px) and (prefers-reduced-motion: reduce){:host([motion-state=enabled]) .beacon-popover-zones-wrapper{opacity:1}}@media (width >= 960px){:host([motion-state=enabled]:not([is-open])){display:grid;grid-template-rows:0fr}:host([is-open][motion-state=enabled]){grid-template-rows:1fr}:host([is-open][motion-state=enabled]) .beacon-popover-zones-wrapper{opacity:1}}`, Wt$1 = T$7`:host{--popover-color: var(--beacon-system-color-text-standard);--popover-visibility: hidden;color:var(--popover-color);inline-size:100%}@media (width >= 960px){:host{inline-size:unset;inset-block-start:var(--top-offset);inset-inline-start:var(--left-offset);position:absolute;z-index:var(--beacon-custom-popover-z-index, 1000)}}:host(:not([is-open])){display:none}::part(icon-button){--icon-color: var(--popover-color);--hover-icon: var(--popover-color);--active-icon: var(--popover-color)}:host([is-open]){--popover-visibility: visible}.overlay-wrapper{display:flex;flex-direction:var(--direction);visibility:var(--popover-visibility)}@media (width >= 960px){.overlay-wrapper{--arrow-block-size: 6px;--arrow-inline-size: var(--beacon-reference-space-4);--direction: column;inline-size:fit-content;max-inline-size:var(--navigation-popover-size-inline)}}.overlay-wrapper.block-start{--direction: column}.overlay-wrapper.block-end{--direction: column-reverse}.overlay-wrapper .overlay-arrow{--arrow-margin: var(--beacon-reference-space-7);display:flex}.overlay-wrapper .overlay-arrow.start{align-self:start;margin-inline-start:var(--arrow-margin)}.overlay-wrapper .overlay-arrow.center{align-self:center;margin:0}.overlay-wrapper .overlay-arrow.end{align-self:end;margin-inline-end:var(--arrow-margin)}.overlay-wrapper .overlay-arrow .tooltip-arrow{block-size:var(--arrow-block-size);fill:var(--beacon-system-color-background-1);inline-size:var(--arrow-inline-size)}@media (width >= 960px){.overlay-wrapper .beacon-popover-surface{background-color:var(--beacon-system-color-background-1);border-radius:var(--beacon-system-radius-corner-standard);box-shadow:var(--beacon-elevation-block-end-level-1);inline-size:var(--navigation-popover-content-size-inline);max-inline-size:var(--navigation-popover-content-size-inline);padding:var(--beacon-reference-space-7);position:relative}}.overlay-wrapper .beacon-popover-surface .beacon-popover-close-button{display:none}.overlay-wrapper .beacon-popover-surface .beacon-popover-zones-wrapper{display:flex;flex-direction:column}.beacon-popover-content-wrapper{max-inline-size:var(--navigation-popover-content-size-inline);padding-block:var(--beacon-reference-space-3) var(--beacon-reference-space-5);padding-inline:var(--beacon-reference-space-3)}.beacon-popover-content-wrapper p{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);overflow-wrap:break-word}`;
var Gt = Object.defineProperty, Kt$2 = Object.getOwnPropertyDescriptor, he$2 = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? Kt$2(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && Gt(t3, o2, a2), a2;
};
const Xe$1 = class Xe extends B$5(Bt$3).with(
  _t$1({ disableDebounceOpen: true }),
  Ye$1,
  Se$2(),
  f$3,
  L$3(),
  N$5({ skipFirstUpdated: true })
) {
  constructor() {
    super(...arguments), this.beaconTagName = pe$1.beaconTagName, this.trigger = P$4.MANUAL, this.direction = p$1.BlockStart, this.overflowOffset = 0;
  }
  static get styles() {
    return [super.styles, Wt$1, Vt$1];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, jt$2];
  }
  /** @override Only set Alignment in direction computation. */
  computeDirection(t3, o2) {
    if (this.slot === Le$1.ACTION) {
      this.alignment = k$6.END;
      return;
    }
    const n4 = (t3.left + t3.right) / 2, a2 = o2.width / 2;
    n4 + a2 > this.viewportRect.width ? this.alignment = k$6.END : n4 - a2 < 0 ? this.alignment = k$6.START : this.alignment = k$6.CENTER;
  }
  /**
   * @override Sets a different targetRectObj from the primitive.
   * @override Changes calculation to take into account the popover not being a wrapper of the target.
   */
  calculateOffset() {
    var t3;
    this.associatedNavTrigger instanceof B$2 && (this.targetRectObj = this.associatedNavTrigger.getBoundingClientRect());
    const o2 = this.associatedNavTrigger, n4 = (t3 = this.shadowRoot) == null ? void 0 : t3.querySelector(".overlay-arrow");
    if (o2 && n4) {
      const a2 = o2.getBoundingClientRect(), r3 = this.getBoundingClientRect(), i5 = n4.getBoundingClientRect(), E2 = document.body.getBoundingClientRect();
      this.computeDirection(a2, r3), this.topOffset = a2.y + a2.height;
      const h2 = a2.x - r3.width / 2 + a2.width / 2, S2 = i5.x - (r3.x + r3.width / 2) + i5.width / 2, { width: m3 } = E2, $2 = m3 > 1920 ? (m3 - 1920) / 2 : 0;
      switch (this.alignment) {
        case k$6.END:
        case k$6.START:
          this.leftOffset = h2 - S2 - $2;
          break;
        case k$6.CENTER:
        default:
          this.leftOffset = h2 - $2;
          break;
      }
    }
  }
  /** @override Focus returning is handled externally from this popover. */
  focusOnActiveElement() {
  }
  /** @override Includes SVG arrow in the markup instead of styling using CSS backgrounds. */
  renderArrow() {
    return tt$1`<span class="overlay-arrow ${this.alignment}" aria-hidden="true"
      >${Qe$1.UP}</span
    >`;
  }
  /** @override Close buttons don't exist here. */
  renderCloseButton() {
    return tt$1``;
  }
  /** @override Only a default slot is available. */
  renderOverlayContent() {
    return tt$1`<slot></slot>`;
  }
  prerenderNavigationPopoverSetup() {
    this.computeMarginAdjustment(
      pe$1.arrowSpaceMargin,
      pe$1.arrowSizeInline
    );
  }
  willUpdate(t3) {
    if (t3.has("motionState") && this.motionState === "enabled" && !this.prefersReducedMotion && this.setAttribute("inert", ""), o$4(t3, "isOpen")) {
      const o2 = t3.get("isOpen");
      this.motionState === "enabled" && !this.prefersReducedMotion && (o2 ? this.setAttribute("inert", "") : this.removeAttribute("inert"));
    }
    super.willUpdate(t3);
  }
};
Xe$1.tagName = pe$1.beaconTagName;
let ee$3 = Xe$1;
he$2([
  v$c()
], ee$3.prototype, "trigger", 2);
he$2([
  v$c()
], ee$3.prototype, "direction", 2);
he$2([
  it()
], ee$3.prototype, "overflowOffset", 2);
he$2([
  u$2
], ee$3.prototype, "prerenderNavigationPopoverSetup", 1);
const Ut = T$7`:root[beacon-tag-name=beacon-navigation-expanded],:root [beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-navigation-expanded],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-navigation-expanded],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.2.2"][beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.2.2"] [beacon-tag-name=beacon-navigation-expanded]{--navigation-expanded-title-area-gap: var(--beacon-system-space-micro-normal);--navigation-expanded-header-zone-spacing: var(--beacon-reference-space-5);--navigation-expanded-popover-header-zone-spacing: var(--beacon-system-space-micro-jumbo)}@media (width >= 960px){:root[beacon-tag-name=beacon-navigation-expanded],:root [beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-navigation-expanded],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-navigation-expanded],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.2.2"][beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.2.2"] [beacon-tag-name=beacon-navigation-expanded]{--navigation-expanded-header-zone-spacing: var(--beacon-reference-space-9)}}`, qt$1 = T$7`[beacon-tag-name=beacon-navigation-expanded] a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-navigation-expanded] .expanded__search{align-items:baseline;display:flex;flex-direction:column;gap:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-navigation-expanded] .expanded__search :first-child{flex:1;inline-size:100%}@media (width >= 1280px){[beacon-tag-name=beacon-navigation-expanded] .expanded__search :first-child{flex:unset;inline-size:calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi),var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 7)}}@media (width >= 640px){[beacon-tag-name=beacon-navigation-expanded] .expanded__search{align-items:end;flex-direction:row}}[beacon-tag-name=beacon-navigation-expanded]>[slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-300)}[beacon-tag-name=beacon-navigation-expanded]>[slot=description]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-navigation-expanded]>[slot=promo]{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-start:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-navigation-expanded][show-drilldown]>:is([beacon-tag-name=beacon-navigation-expanded]:not([is-active],[show-drilldown]),[beacon-tag-name=beacon-navigation-button],a){display:none}@media (width >= 960px){[beacon-tag-name=beacon-navigation-expanded]:is([level="2"],[level="3"])>[slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}[beacon-tag-name=beacon-navigation-expanded]>[slot=promo]{border:0;padding-block-start:0}}`, Yt$1 = T$7`:host([show-drilldown]) .promo-slot{display:none}.hide{display:none}.default-slot{display:contents}.header-zone.has-nested-expanded{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);margin-block-end:var(--navigation-expanded-header-zone-spacing);padding-block-end:var(--navigation-expanded-header-zone-spacing)}.header-zone.no-content{display:none}:host([show-drilldown]) .header-zone{display:none}.popover{color:var(--beacon-system-color-text-standard)}@media (width >= 960px){:host([level="2"]){grid-column:span var(--expanded-nav-grid-span)}.expanded ::slotted([beacon-tag-name=beacon-navigation-button]),.expanded ::slotted(a){--font-weight: var(--beacon-system-font-weight-normal)}.expanded:is(.level-1,.level-2,.level-3) .slot-container{--grid-layout-gap: var(--beacon-system-space-micro-jumbo);--grid-column-count: 4;--gap-count: calc(var(--grid-column-count) - 1);--total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));--grid-item-max-width: calc((100% - var(--total-gap-width)) / var(--grid-column-count));display:grid;gap:calc(var(--navigation-expanded-header-zone-spacing) * 2) var(--grid-layout-gap);grid-template-columns:repeat(auto-fit,minmax(var(--grid-item-max-width),1fr))}.expanded:not(.level-1) .header-zone{border:0;margin:0;padding:0}.expanded.level-2 .default-slot{columns:var(--expanded-nav-grid-template)}.expanded:is(.level-2,.level-3) .default-slot{columns:var(--expanded-nav-grid-template);display:block}.popover{color:var(--beacon-system-color-text-standard)}.popover.level-1 .header-zone.has-nested-expanded{margin-block-end:var(--navigation-expanded-popover-header-zone-spacing);padding-block-end:var(--navigation-expanded-popover-header-zone-spacing)}.popover.level-1 .title-area .primary-link-container{margin-block-start:var(--beacon-system-space-micro-mini)}.popover.level-1 .slot-container{gap:var(--beacon-system-space-micro-jumbo)}.popover:not(.level-1) ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}.popover:not(.level-1) .header-zone{border:0;margin:0;padding:0}.collapsed-title-button{all:unset}}`;
var Qt$2 = Object.defineProperty, Xt$1 = Object.getOwnPropertyDescriptor, I$3 = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? Xt$1(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && Qt$2(t3, o2, a2), a2;
};
const Jt$2 = ["title", "description", "primary-link"];
function eo$1(e5) {
  const t3 = e5, o2 = Jt$2.find(
    (n4) => n4 === t3
  );
  if (o2)
    return o2;
  throw new Error(`${e5} is not a valid slot name in Expanded Navigation.`);
}
var H$1;
const N$3 = (H$1 = class extends B$5(
  G$2
).with(f$3, N$5({ skipFirstUpdated: true })) {
  constructor() {
    super(...arguments), this.beaconTagName = $$3.beaconTagName, this.showDrilldown = false, this.isActive = false, this.hasPrimaryLink = false, this.hasDescription = false, this.hasTitle = false, this.hasPromo = false, this.handleDrillup = (e5) => {
      var t3;
      if (e5.target instanceof re$2 && this.activeExpandedNav instanceof H$1) {
        this.activeExpandedNav.drillup(true), (t3 = this.toolbelt) == null || t3.handleDrillup();
        return;
      }
      this.showDrilldown && this.drillup();
    }, this.handleCloseEvents = ({ target: e5 }) => {
      e5 instanceof re$2 && this.parentExpanded && (this.parentExpanded.titleSlotVal ? (this.parentExpanded.isActive = true, this.parentExpanded.showDrilldown = false) : this.parentExpanded.drillup());
    }, this.handleAnalyticsChange = ({ target: e5 }) => {
      e5 === this.menuContext && this.updateAnalytics();
    };
  }
  static get styles() {
    return [super.styles, Yt$1];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, qt$1, Ut];
  }
  get hasOnlyLinks() {
    return !this.hasPrimaryLink && !this.hasDescription && !this.titleSlotVal;
  }
  get parentExpanded() {
    return this.parentElement instanceof H$1 ? this.parentElement : null;
  }
  /** The level value of whichever expanded navigation is currently active. */
  get activeLevel() {
    return this.isActive ? this.level : this.parentElement instanceof H$1 ? this.parentElement.activeLevel : 1;
  }
  /** True when an expanded navigation is somewhere inside a Navigation Popover. */
  get isInPopover() {
    return this.parentElement instanceof ee$3 ? true : this.parentElement instanceof H$1 ? this.parentElement.isInPopover : false;
  }
  get navPopover() {
    return this.closest('[beacon-tag-name="beacon-navigation-popover"]');
  }
  get toolbelt() {
    return this.closest('[beacon-tag-name="beacon-navigation-toolbelt"]');
  }
  get menuContext() {
    return this.navPopover ? this.navPopover : this.toolbelt ? this.toolbelt : null;
  }
  /** Collapsed expanded navigations are only true when it can be drilled into. */
  get isCollapsed() {
    if (this.isMobile && !this.isActive && !this.showDrilldown) {
      if (this.level > this.activeLevel)
        return true;
    } else if (!this.isMobile && this.level > 2 && !this.isActive)
      return true;
    return false;
  }
  get activeExpandedNav() {
    return this.querySelector(
      '[beacon-tag-name="beacon-navigation-expanded"][is-active]'
    );
  }
  /** Runs when nested expanded navigations fire dirlldown events. */
  handleInternalDrilldown(e5) {
    this.showDrilldown = true, this.isActive = false, this.setGridTemplates(), L$6(this, g$a.DRILLDOWN, e5);
  }
  /** Runs when the navigation is requested to drilldown. */
  drilldown(e5) {
    this.isActive = true, L$6(this, g$a.DRILLDOWN, e5);
  }
  /** Runs when the navigation is requested to drill up. */
  drillup(e5 = false) {
    var t3;
    e5 && this.parentExpanded && (this.parentExpanded.titleSlotVal ? (this.parentExpanded.isActive = true, this.parentExpanded.showDrilldown = false) : this.parentExpanded.hasOnlyLinks ? (this.parentExpanded.showDrilldown = false, (t3 = this.parentExpanded.parentExpanded) == null || t3.drillup()) : this.parentExpanded.drillup()), this.showDrilldown = false, this.isActive = false, this.links.filter((o2) => o2 instanceof H$1).forEach(
      (o2) => o2 instanceof H$1 && (o2.showDrilldown || o2.isActive) && o2.drillup(e5)
    ), this.setGridTemplates();
  }
  /** Maps the name of the slot that changes to a state property for if it has nodes. */
  checkSlotForContent({ target: e5 }) {
    if (e5 instanceof HTMLSlotElement) {
      const t3 = e5.assignedNodes().length > 0;
      switch (eo$1(e5.name)) {
        case "title":
          this.hasTitle = t3;
          break;
        case "description":
          this.hasDescription = t3;
          break;
        case "primary-link":
          this.hasPrimaryLink = t3;
          break;
      }
    }
  }
  handlePromoSlotchange() {
    this.hasPromo = !!this.promo.length;
  }
  updateAnalytics() {
    var e5, t3, o2, n4, a2;
    if (super.updateAnalytics(), ((e5 = this.menuContext) == null ? void 0 : e5.metricsLocation) === f$4.header && ((t3 = this.menuContext) == null ? void 0 : t3.metricsSection) !== L$4.links) {
      ((o2 = this.menuContext) == null ? void 0 : o2.metricsSection) === L$4.level1LangSelector ? this.metricsSection = L$4.level2LangSelector : this.metricsSection = m$5[1];
      return;
    }
    if (((n4 = this.menuContext) == null ? void 0 : n4.metricsSection) === L$4.links && !this.hasAttribute("country-selector")) {
      this.metricsSection = L$4.links;
      return;
    }
    if (this.hasAttribute("country-selector")) {
      this.metricsSection = L$4.level1LangSelector;
      return;
    }
    if (((a2 = this.menuContext) == null ? void 0 : a2.metricsLocation) === f$4.siteNav) {
      this.metricsSection = I$4(this.level);
      return;
    }
  }
  expandedNavPrerender() {
    document.addEventListener(g$a.DRILLUP, this.handleDrillup), document.addEventListener(g$a.CLOSE, this.handleCloseEvents), document.addEventListener(
      g$a.METRICS_LOCATION_CHANGE,
      this.handleAnalyticsChange
    ), document.addEventListener(
      g$a.METRICS_SECTION_CHANGE,
      this.handleAnalyticsChange
    ), document.addEventListener(
      g$a.METRICS_ID_CHANGE,
      this.handleAnalyticsChange
    );
  }
  expandedNavDestroy() {
    document.removeEventListener(g$a.DRILLUP, this.handleDrillup), document.removeEventListener(g$a.CLOSE, this.handleCloseEvents), document.removeEventListener(
      g$a.METRICS_LOCATION_CHANGE,
      this.handleAnalyticsChange
    ), document.removeEventListener(
      g$a.METRICS_SECTION_CHANGE,
      this.handleAnalyticsChange
    ), document.removeEventListener(
      g$a.METRICS_ID_CHANGE,
      this.handleAnalyticsChange
    );
  }
  /** Collapsed view differs based on the existence of content in the title slot. */
  renderCollapsed() {
    return this.titleSlotVal ? tt$1`
          ${kt$1`
          <${this.getScopedTag($$3.navItemTagName)}
            @beacon-event-click=${this.drilldown}
            data-metrics-section="${e$6(I$4(this.level - 1))}"
            expanded-anchor>
            <button class="collapsed-title-button">
              <slot name="collapsed-title">${this.titleSlotVal}</slot>
            </button>
          </${this.getScopedTag($$3.navItemTagName)}>`}
          <div class="hide">
            <slot name="title" @slotchange=${this.handleTitleSlotchange}></slot>
            <!-- this slot holds any links and other expanded navs, but it is hidden and so it doesn't need to listen for drilldown events -->
            <slot></slot>
          </div>
        ` : tt$1`
          <slot
            class="hide"
            name="title"
            @slotchange=${this.handleTitleSlotchange}></slot>
          <section class="slot-container">
            <slot
              @beacon-event-drilldown=${this.handleInternalDrilldown}></slot>
          </section>
        `;
  }
  setGridSpanForPromoTiles() {
    this.style.setProperty(
      "--expanded-nav-grid-span",
      `calc(${String(this.promo.length)} + var(--expanded-nav-grid-template))`
    );
  }
  setLevel1GridTemplate() {
  }
  setLevel2GridTemplate(e5) {
    this.showDrilldown ? this.setColumnsCSSProperty("1") : (super.setLevel2GridTemplate(e5), this.setGridSpanForPromoTiles());
  }
  renderExpanded() {
    const e5 = {
      "has-nested-expanded": this.hasNestedExpandedNavigations,
      "header-zone": true,
      "no-content": !this.hasPrimaryLink && !this.hasDescription && !this.hasTitle
    };
    return tt$1` <section class=${f$6(e5)}>
        <div class="title-area">
          <div class="title-container">
            <slot
              name="title"
              part="title"
              ${f$7({ useParent: true })}
              @slotchange=${this.checkSlotForContent}></slot>
          </div>
          <div class="description-container">
            <slot
              name="description"
              ${f$7({ useParent: true })}
              @slotchange=${this.checkSlotForContent}></slot>
          </div>
          <div class="primary-link-container">
            <slot
              name="primary-link"
              role="list"
              ${f$7({ useParent: true })}
              @slotchange=${this.checkSlotForContent}></slot>
          </div>
        </div>
      </section>
      <section class="slot-container">
        <div class="default-slot">
          <slot
            @beacon-event-drilldown=${this.handleInternalDrilldown}
            @slotchange="${i$1(
      this.handleDefaultSlotchange.bind(this)
    )}"></slot>
        </div>
        <slot
          class="promo-slot"
          name="promo"
          @slotchange=${this.handlePromoSlotchange}></slot>
      </section>`;
  }
  render() {
    const e5 = {
      popover: this.isInPopover,
      expanded: !this.isInPopover
    };
    return e5[`level-${this.level}`] = true, tt$1`<div class=${f$6(e5)}>
      ${this.isCollapsed ? this.renderCollapsed() : this.renderExpanded()}
    </div> `;
  }
}, H$1.tagName = $$3.beaconTagName, H$1);
I$3([
  v$c({ type: Boolean, reflect: true, attribute: "show-drilldown" })
], N$3.prototype, "showDrilldown", 2);
I$3([
  v$c({ type: Boolean, reflect: true, attribute: "is-active" })
], N$3.prototype, "isActive", 2);
I$3([
  it()
], N$3.prototype, "hasPrimaryLink", 2);
I$3([
  it()
], N$3.prototype, "hasDescription", 2);
I$3([
  it()
], N$3.prototype, "hasTitle", 2);
I$3([
  it()
], N$3.prototype, "hasPromo", 2);
I$3([
  v$9({ slot: "description", flatten: true })
], N$3.prototype, "descriptionNodes", 2);
I$3([
  v$9({ slot: "primary-link", flatten: true })
], N$3.prototype, "primaryLinkNodes", 2);
I$3([
  v$9({ slot: "promo", flatten: true })
], N$3.prototype, "promo", 2);
I$3([
  u$2
], N$3.prototype, "expandedNavPrerender", 1);
I$3([
  y$7
], N$3.prototype, "expandedNavDestroy", 1);
let Je$1 = N$3;
const Y$1 = {
  beaconTagName: "beacon-navigation-toolbelt",
  buttonTagName: "beacon-button",
  get lightDOMStyleID() {
    return `${this.beaconTagName}-styles`;
  }
}, to$1 = T$7`@media (width >= 960px){:host([motion-state=enabled]){display:grid;transition-duration:var(--beacon-reference-motion-duration-9);transition-property:grid-template-rows;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .content-wrapper{overflow:hidden}:host([motion-state=enabled]:not([is-open])){display:grid;grid-template-rows:0fr}:host([is-open][motion-state=enabled]){grid-template-rows:1fr}:host([is-open][motion-state=enabled]) .content-wrapper:focus-within{overflow:visible}}`;
var oo$1 = (e5, t3, o2, n4) => {
  for (var a2 = t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = i5(a2) || a2);
  return a2;
};
function no$1(e5) {
  let t3 = class extends e5 {
    static get navigationToolbeltMotionStyles() {
      return [to$1];
    }
    willUpdate(o2) {
      if (o2.has("motionState") && this.motionState === "enabled" && !this.prefersReducedMotion && this.setAttribute("inert", ""), o$4(o2, "isOpen")) {
        const n4 = o2.get("isOpen");
        this.motionState === "enabled" && !this.prefersReducedMotion && (n4 ? this.setAttribute("inert", "") : this.removeAttribute("inert"));
      }
      super.willUpdate(o2);
    }
  };
  return t3 = oo$1([
    f$8("NavigationToolbeltMotion")
  ], t3), t3;
}
const ao$1 = T$7`:host{inline-size:100%}:host(:not([is-open])){display:none}.container{background-color:var(--beacon-system-color-background-1)}.container :first-child{position:relative}@media (width >= 960px){.container{box-shadow:0 16px 24px -16px #002f48;margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);padding-block:var(--beacon-reference-space-10) var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-maxi)}.container.is-drilldown{background-color:var(--beacon-system-color-background-2)}}@media (width >= 1280px){.container{padding-block-start:var(--beacon-reference-space-12)}}.close-button-wrapper{display:none}@media (width >= 960px){.close-button-wrapper{display:block}.close-button-wrapper:not(.action-wrapper){inset-inline-end:0;position:absolute}.close-button-wrapper.action-wrapper{align-items:center;border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);display:flex;justify-content:space-between;margin-block-end:var(--beacon-reference-space-9);padding-block-end:var(--beacon-reference-space-9)}}::part(standard-button){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);align-items:center;color:var(--beacon-system-color-text-link);gap:0}@media (width >= 960px){:host{inset-block-start:100%;inset-inline-start:0;position:absolute;z-index:1001}:host([site-navigation]){z-index:0}}`;
var ro$1 = Object.defineProperty, io$1 = Object.getOwnPropertyDescriptor, et = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? io$1(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && ro$1(t3, o2, a2), a2;
};
const xe$2 = class xe extends B$5(Bt$3).with(
  Ye$1,
  f$3,
  Se$2(),
  N$5({ skipFirstUpdated: true }),
  no$1,
  L$3()
) {
  constructor() {
    super(...arguments), this.beaconTagName = Y$1.beaconTagName, this.isDrilldown = false;
  }
  static get styles() {
    return [super.styles, ao$1, this.navigationToolbeltMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles];
  }
  /** Drills up from nested menus. */
  get backButton() {
    var t3;
    return (t3 = this.shadowRoot) == null ? void 0 : t3.querySelector("#menu");
  }
  /** Closes the menu entirely while maintaining the current drilldown state when re-opening. */
  get closeButton() {
    var t3;
    return (t3 = this.shadowRoot) == null ? void 0 : t3.querySelector("#close");
  }
  prerenderNavigationToolbeltSetup() {
    this.addEventListener(g$a.DRILLDOWN, this.handleDrilldown), this.addEventListener(g$a.DRILLUP, this.handleDrillup);
  }
  updated(t3) {
    o$4(t3, "isOpen") && !this.isOpen && this.opensBy === "country-selector" && L$6(this, g$a.COUNTRY_SELECTOR_CLOSE);
  }
  /** Handles drilldown events from child navigations. */
  handleDrilldown({ target: t3 }) {
    t3 instanceof Je$1 && (this.isDesktop ? (t3.level === 2 && (this.isDrilldown = true), ke$2(this.backButton)) : t3.level === 3 && (this.isDrilldown = true));
  }
  /** Handles drillup events when pressing the back button. */
  handleDrillup() {
    this.isDrilldown = false, ke$2(this.closeButton);
  }
  // In the case of the toolbelt there's only one level to drill down so the drill up occurs at the highest level
  handleBack() {
    this.backButton instanceof HTMLElement && L$6(this.backButton, g$a.DRILLUP);
  }
  /**
   * Fires an event dedicated to closing the active nav item that is separate from toggling its state.
   *
   * This event helps issues in the popover that was capturing duplicate close events.
   *
   * @event beacon-event-close-active-nav-item
   */
  handleClose() {
    L$6(this, g$a.CLOSE_ACTIVE_NAV_ITEM);
  }
  renderBackButton() {
    return this.isDrilldown ? kt$1`
        <${this.getScopedTag(Y$1.buttonTagName)} 
          variant="tertiary" 
          id="menu"
          class="back-button"
          data-metrics-section="${h$6.level_4}"
          @beacon-event-click=${this.handleBack}>
          Back ${d$9(qe$1)}
        </${this.getScopedTag(Y$1.buttonTagName)}>` : tt$1``;
  }
  renderCloseButton() {
    return kt$1`
      <${this.getScopedTag(Y$1.buttonTagName)} 
        variant="tertiary" 
        id="close"
        class="close-button"
        @beacon-event-click=${this.handleClose}>
        Close ${d$9(Ft$1)}
      </${this.getScopedTag(Y$1.buttonTagName)}>
    `;
  }
  render() {
    const t3 = {
      "action-wrapper": this.isDrilldown,
      "close-button-wrapper": true
    }, o2 = {
      container: true,
      "is-drilldown": this.isDrilldown
    };
    return tt$1`
      <div class="content-wrapper">
        <div class=${f$6(o2)} part="toolbelt-container">
          <div class="content-wrapper">
            <div class=${f$6(t3)}>
              ${this.renderBackButton()} ${this.renderCloseButton()}
            </div>
            <slot></slot>
          </div>
        </div>
      </div>
    `;
  }
};
xe$2.tagName = Y$1.beaconTagName, xe$2.nestedComponents = ["beacon-button"];
let ue$3 = xe$2;
et([
  v$c()
], ue$3.prototype, "isDrilldown", 2);
et([
  u$2
], ue$3.prototype, "prerenderNavigationToolbeltSetup", 1);
const co$1 = T$7`:root[beacon-tag-name=beacon-navigation],:root [beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"][beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"] [beacon-tag-name=beacon-navigation]{--navigation-action-zone-size: var(--beacon-reference-space-12);--navigation-wrapper-block-size: var(--beacon-reference-space-13);--navigation-brand-zone-padding-inline-start: var(--beacon-reference-space-7);--navigation-brand-zone-padding-inline-end: var(--beacon-reference-space-5);--navigation-header-zone-padding-inline: 0;--navigation-wordmark-inline-size: 118px;--navigation-skip-link-outline: none;--navigation-popover-size-inline: calc(18 * var(--beacon-reference-space-5));--navigation-popover-content-size-inline: calc(17 * var(--beacon-reference-space-5))}@media (width >= 640px){:root[beacon-tag-name=beacon-navigation],:root [beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"][beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"] [beacon-tag-name=beacon-navigation]{--navigation-brand-zone-padding-inline-start: var(--beacon-reference-space-9);--navigation-brand-zone-padding-inline-end: var(--beacon-reference-space-7);--navigation-popover-size-inline: calc(21.25 * var(--beacon-reference-space-5));--navigation-popover-content-size-inline: calc(18.25 * var(--beacon-reference-space-5))}}@media (width >= 960px){:root[beacon-tag-name=beacon-navigation],:root [beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"][beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"] [beacon-tag-name=beacon-navigation]{--navigation-wrapper-block-size: var(--beacon-reference-space-14);--navigation-brand-zone-padding-inline-start: 0;--navigation-brand-zone-padding-inline-end: 0;--navigation-popover-size-inline: calc(18 * var(--beacon-reference-space-5))}}@media (width >= 1280px){:root[beacon-tag-name=beacon-navigation],:root [beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"][beacon-tag-name=beacon-navigation],[beacon-version="4.2.2"] [beacon-tag-name=beacon-navigation]{--navigation-wordmark-inline-size: 132px;--navigation-popover-size-inline: calc(24.75 * var(--beacon-reference-space-5));--navigation-popover-content-size-inline: calc(21.75 * var(--beacon-reference-space-5))}}`, f$2 = {
  nestedComponents: ["beacon-button", "beacon-icon-button"],
  // Tag Names
  beaconTagName: "beacon-navigation",
  navItemTagName: "beacon-navigation-button",
  buttonTagName: "beacon-button",
  iconButtonTagName: "beacon-icon-button",
  // Slot Name
  localSlot: "local-zone",
  globalSlot: "global-zone",
  actionSlot: "action-zone",
  brandMarkSlot: "brandmark",
  wordMarkSlot: "wordmark",
  // Attributes
  expandedAttribute: "menu-expanded",
  // Class
  onLight: "beacon-on-light",
  wordMarkAriaLabel: "T. Rowe Price - Home"
};
function U(e5) {
  const t3 = [
    "beacon-navigation-popover",
    "beacon-navigation-toolbelt"
  ];
  return e5.hasAttribute("beacon-tag-name") && t3.includes(e5.getAttribute("beacon-tag-name"));
}
const so$1 = T$7`[beacon-tag-name=beacon-navigation][menu-expanded] ::part(icon-button){color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-navigation] a{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);color:var(--beacon-component-primary-navigation-header-color-text-link)}[beacon-tag-name=beacon-navigation] a:not(:hover,:focus){text-decoration:none}@media (width < 960px){[beacon-tag-name=beacon-navigation] a:not([slot=skip-link]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}}@media (width < 960px) and (forced-colors: active){[beacon-tag-name=beacon-navigation] a:not([slot=skip-link]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}@media (width >= 960px){[beacon-tag-name=beacon-navigation] a:not([slot=skip-link]):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;position:relative;z-index:1}}@media (width >= 960px){[beacon-tag-name=beacon-navigation] a[aria-current=page]{border-block-end:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-brand)}}[beacon-tag-name=beacon-navigation] a[slot=wordmark]{color:inherit}[beacon-tag-name=beacon-navigation] a[slot=skip-link]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px;color:var(--beacon-system-color-text-set-navy);display:inline-block;text-decoration:none;z-index:-1}[beacon-tag-name=beacon-navigation] a[slot=skip-link]:focus-visible{border:revert;clip:revert;block-size:revert;margin:revert;overflow:revert;padding:revert;position:revert;inline-size:revert;border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus);margin:var(--beacon-system-space-cell-contained);outline:var(--navigation-skip-link-outline, revert);z-index:auto}[beacon-tag-name=beacon-navigation] [slot=header-zone] svg{color:var(--beacon-system-color-icon-link, currentColor)}[beacon-tag-name=beacon-navigation] [slot=media]{max-inline-size:100%}[beacon-tag-name=beacon-navigation] [slot=media]>*{max-inline-size:100%}[beacon-tag-name=beacon-navigation][drilldown-expanded] :is([slot=local-zone],[slot=global-zone],[slot=header-zone],[slot=site-selector],[slot=action-zone],[site-navigation]):not([beacon-tag-name=beacon-navigation-popover],[beacon-tag-name=beacon-navigation-toolbelt],div),[beacon-tag-name=beacon-navigation][drilldown-expanded] div:is([slot=local-zone],[slot=global-zone],[slot=header-zone],[slot=site-selector],[slot=action-zone],[site-navigation])>:is([beacon-tag-name=beacon-navigation-button],a):not([active]),[beacon-tag-name=beacon-navigation][drilldown-expanded] div:is([slot],[site-navigation]) [active],[beacon-tag-name=beacon-navigation][drilldown-expanded] [country-selector]{display:none}[beacon-tag-name=beacon-navigation] div[slot=action-zone]>*{inline-size:100%}@media (width >= 960px){[beacon-tag-name=beacon-navigation] div[site-navigation]>[beacon-tag-name=beacon-navigation-button]{block-size:100%;display:grid}[beacon-tag-name=beacon-navigation] div[site-navigation]>[beacon-tag-name=beacon-navigation-toolbelt]{z-index:0}[beacon-tag-name=beacon-navigation] a[slot=local-zone],[beacon-tag-name=beacon-navigation] [slot=local-zone]>a{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}[beacon-tag-name=beacon-navigation] :is([slot=local-zone],[slot=global-zone]):not([beacon-tag-name=beacon-navigation-toolbelt],[beacon-tag-name=beacon-navigation-popover]){inline-size:max-content}[beacon-tag-name=beacon-navigation] div:is([slot=local-zone],[slot=global-zone])>*:not([beacon-tag-name=beacon-navigation-toolbelt]){inline-size:inherit}[beacon-tag-name=beacon-navigation] :is(a,[beacon-tag-name=beacon-icon-button]):is([slot=local-zone],[slot=global-zone]),[beacon-tag-name=beacon-navigation] :is([slot=local-zone],[slot=global-zone]) a{padding-block-end:var(--beacon-system-space-cell-free-floating);padding-block-start:var(--beacon-system-space-cell-free-floating)}[beacon-tag-name=beacon-navigation]>a:not([slot],[data-has-beacon-language-event],[selected-language]){align-items:center;block-size:100%;color:var(--beacon-component-primary-navigation-header-color-text-link);display:grid;font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);padding-block-end:var(--beacon-system-space-cell-free-floating);padding-block-start:var(--beacon-system-space-cell-free-floating)}}div[site-navigation].aem-edit-mode{display:flex;flex-direction:row;gap:var(--beacon-reference-space-9)}`, lo$1 = T$7`@media (width >= 960px){:host{z-index:2000}.primary-wrapper{position:relative}:host([in-motion]) .primary-wrapper{z-index:-1}.sitenav-ul-wrapper{background-color:inherit}}`;
var bo$1 = Object.defineProperty, po$1 = Object.getOwnPropertyDescriptor, Fe$2 = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? po$1(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && bo$1(t3, o2, a2), a2;
};
function vo$1(e5) {
  let t3 = class extends e5 {
    static get navigationMotionStyles() {
      return [lo$1];
    }
    get siteNavWrapper() {
      var o2;
      return (o2 = this.shadowRoot) == null ? void 0 : o2.querySelector(".primary-wrapper");
    }
    get headerWrapper() {
      var o2;
      return (o2 = this.shadowRoot) == null ? void 0 : o2.querySelector(".header-wrapper");
    }
    /**
     * Applies custom motion classes to the header and site nav wrappers.
     *
     * @param layer The layer order this element should appear where higher numbers are higher `z-index` values.
     * @param additionalClasses Arbitrary number of extra classes to apply to the class set.
     */
    generateMotionClasses(...o2) {
      const n4 = [];
      return this.hasFieldAndValue("isMobile", false) && n4.push(
        "b-motion--intro-from-top",
        "b-motion-ease--decelerate--emphasize-1",
        "b-motion-duration--extra-long-2",
        ...o2
      ), n4;
    }
    applyNavigationMotionStyles({ target: o2 }) {
      var n4, a2;
      o2 === this && !this.prefersReducedMotion && ((n4 = this.headerWrapper) == null || n4.classList.add(...this.generateMotionClasses()), (a2 = this.siteNavWrapper) == null || a2.classList.add(
        ...this.generateMotionClasses("b-motion-delay--medium-2")
      ));
    }
    /**
     * Removes custom motion classes from the header and site nav wrappers.
     *
     * It gets triggered from site nav because these classes add `z-index` styles and prematurely removing those classes from the header - since it finishes animating first - cause visual overlap as the site nav fades in.
     *
     * To avoid that, site nav finishes animating first so the two elements remove their classes together.
     *
     * @param target Event target.
     */
    static removeNavigationMotionClasses({ target: o2 }) {
      o2 instanceof HTMLElement && o2.previousElementSibling instanceof HTMLElement && [o2, o2.previousElementSibling].forEach(
        (n4) => n4.classList.remove(
          ...Array.from(n4.classList).filter(
            (a2) => a2.includes("b-motion")
          )
        )
      );
    }
    attachAnimationendListener({ target: o2 }) {
      this.siteNavWrapper && o2 === this && this.siteNavWrapper.addEventListener(
        "animationend",
        t3.removeNavigationMotionClasses
      );
    }
    prerenderNavigationMotionSetup() {
      this.addEventListener(
        g$a.ELEMENT_READY,
        this.applyNavigationMotionStyles
      ), this.addEventListener(
        g$a.ELEMENT_READY,
        this.attachAnimationendListener
      );
    }
  };
  return Fe$2([
    u$2
  ], t3.prototype, "prerenderNavigationMotionSetup", 1), t3 = Fe$2([
    f$8("NavigationMotion")
  ], t3), t3;
}
const go$1 = T$7`:host{--bg: var(--beacon-system-color-background-0);background-color:var(--bg);position:relative;z-index:2000}.trusty{background-color:var(--beacon-system-color-icon-set-white)}.skip-link-wrapper{background-color:var(--beacon-system-color-background-link-focus);inline-size:100%}.skip-link-wrapper .skip-link-container{margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}ul{margin:0;padding:0}.wordmark-container{color:var(--beacon-system-color-text-title);display:flex;padding-block:var(--beacon-system-space-cell-free-floating)}.wordmark-container a{color:inherit;display:inherit}@media (width < 960px){.wordmark-container a:focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}}@media (width < 960px) and (forced-colors: active){.wordmark-container a:focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}@media (width >= 960px){.wordmark-container a:focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;position:relative;z-index:1}}.wordmark-container svg,.wordmark-container ::slotted(svg){max-inline-size:var(--navigation-wordmark-inline-size)}.brand-zone-container{align-items:center;background-color:var(--beacon-system-color-background-0, );display:flex;justify-content:space-between;min-block-size:var(--navigation-wrapper-block-size);padding-inline-end:var(--navigation-brand-zone-padding-inline-end);padding-inline-start:var(--navigation-brand-zone-padding-inline-start)}.brand-zone-container ::slotted(svg),.brand-zone-container .trusty{flex-shrink:0}.local-header-global-container{inline-size:100%}.action-zone-wrapper{align-items:center;background-color:var(--beacon-system-color-background-2);display:flex;gap:var(--beacon-reference-space-5);inline-size:100%;inset-block-end:0;inset-inline-start:0;padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--beacon-system-space-organism-jumbo);position:fixed;z-index:var(--navigation-action-zone-z-index, 2)}::slotted([slot=action-zone]){inline-size:100%}.menu{background-color:var(--beacon-system-color-background-1);block-size:calc(100dvh - var(--navigation-wrapper-block-size) - var(--action-zone-size, 0))}.menu .action-zone-wrapper{min-block-size:var(--action-zone-size, auto)}.vertical-divider{display:none;inline-size:var(--beacon-system-width-border-mini)}.header-zone-wrapper{align-items:center;display:flex;gap:var(--beacon-reference-space-3);padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--navigation-header-zone-padding-inline)}.local-zone-container,.global-zone-container,.sitenav-ul-wrapper{align-items:start;border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);display:flex;flex-direction:column;gap:var(--beacon-reference-space-5);padding-block:var(--beacon-reference-space-5)}.partner-logo-wrapper{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);margin-block-end:var(--beacon-system-space-micro-jumbo);padding-block-end:var(--beacon-system-space-micro-jumbo)}.partner-logo{--partner-logo-max-inline-size: 92px;max-inline-size:var(--beacon-custom-navigation-partner-logo-max-inline-size, var(--partner-logo-max-inline-size))}.site-selector-slot{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-end:var(--beacon-reference-space-5)}.country-selector-slot{padding-block-start:var(--beacon-reference-space-5)}::part(icon-button){color:var(--beacon-system-color-icon-link)}.drill-up::part(standard-button){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);--beacon-button-icon-align: center;align-items:center;color:var(--beacon-component-primary-navigation-header-color-text-link);gap:0}.drill-up svg{color:var(--beacon-system-color-icon-link)}:host([drilldown-expanded]) .local-zone-container,:host([drilldown-expanded]) .global-zone-container,:host([drilldown-expanded]) .sitenav-ul-wrapper,:host([drilldown-expanded]) .site-selector-slot{border:0}:host([drilldown-expanded]) .site-selector-slot{padding-block-start:var(--beacon-reference-space-5)}:host([menu-expanded]){--navigation-menu-expanded-navigation-button-color: var(--beacon-system-color-text-link)}:host([menu-expanded]) ::part(icon-button){color:var(--beacon-system-color-icon-link)}:host([menu-expanded]) .menu-zone-container{overflow-y:auto;padding-block:var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-maxi)}:host([menu-expanded]) .menu-zone-container::-webkit-scrollbar{block-size:calc(var(--beacon-reference-space-3) * .75);inline-size:calc(var(--beacon-reference-space-3) * .75)}:host([menu-expanded]) .menu-zone-container::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);border-radius:calc(.875 * var(--beacon-reference-space-5))}:host([menu-expanded]) .menu-zone-container::-webkit-scrollbar-track{background:var(--beacon-reference-palette-grayscale-light-gray-1)}:host([menu-expanded]) .menu-zone-container::-webkit-scrollbar-corner{background:var(--beacon-reference-palette-grayscale-light-gray-1)}:host([menu-expanded]) .action .action-zone-wrapper{background-color:transparent;padding-block:var(--beacon-reference-space-5);padding-inline:0;position:static}.hide{display:none}::slotted(div[site-navigation]),::slotted(div[slot]){display:contents}.menu-closed.header-zone-only{display:none}.nav-dialog-overlay{block-size:100%;border:0;inline-size:100%;max-block-size:none;max-inline-size:none;padding:0;position:fixed}@media (width >= 960px){.header-wrapper{background-color:var(--bg);display:flex;justify-content:space-between;margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);min-block-size:var(--navigation-wrapper-block-size);position:relative}.brand-zone-container{block-size:fit-content;gap:var(--beacon-reference-space-7)}.menu-zone-container:not(.hide){align-items:center;display:flex;min-block-size:inherit;padding-inline-end:var(--beacon-system-space-cell-contained)}.wordmark-container{padding:var(--beacon-system-space-cell-contained)}.action-zone-wrapper{background-color:inherit;margin-inline-start:var(--beacon-reference-space-5);padding:var(--beacon-system-space-cell-contained);padding-inline-end:0;position:static;z-index:auto}.global-zone-container,.local-zone-container{align-items:center;border:0;flex-direction:row;padding-block:var(--beacon-system-space-cell-contained);padding-inline:var(--beacon-system-space-cell-contained)}.site-selector-slot{display:contents}.ul-wrapper{align-items:center;display:flex;gap:var(--beacon-reference-space-5)}::slotted([slot=action-zone]){inline-size:initial}::slotted([beacon-tag-name=beacon-button]){min-inline-size:max-content;word-break:keep-all}.primary-wrapper{background-color:var(--beacon-system-color-background-0);display:grid;gap:var(--beacon-reference-space-9);grid-template-columns:1fr auto 1fr;margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.partner-logo-wrapper{border:0;grid-column:3/4;margin:0;padding-block:0;padding-inline-end:var(--beacon-reference-space-5);place-self:center end}.sitenav-ul-wrapper{align-items:center;block-size:var(--beacon-reference-space-13);border-block-end:0;flex-direction:row;gap:var(--beacon-reference-space-9);grid-column:2/3;justify-content:center;padding:0}.sitenav-ul-wrapper ::slotted([beacon-tag-name=beacon-navigation-button]){block-size:100%;display:grid}.vertical-divider{display:block}}@media (width >= 1280px){.partner-logo{--partner-logo-max-inline-size: 115px}}`;
var mo$1 = Object.defineProperty, ho$1 = Object.getOwnPropertyDescriptor, b$8 = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? ho$1(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && mo$1(t3, o2, a2), a2;
};
const uo$1 = (e5) => !!e5 && e5.level === 2, yo$1 = (e5) => "isDrilldown" in e5;
var A$5;
const d$6 = (A$5 = class extends B$5(Bt$3).with(
  At$1,
  L$3({ autoRemoveMotionClasses: false }),
  vo$1,
  f$3,
  Se$2({ onReady: false, removeLargeEvent: true }),
  N$5({ skipFirstUpdated: false, runOnSlotchange: true })
) {
  constructor() {
    super(...arguments), this.beaconTagName = f$2.beaconTagName, this.focusOverride = true, this.deferrable = false, this.isDrilldownExpanded = false, this.wordmarkUrl = "", this.isMenuExpanded = false, this.currentOpenSlot = w$3.DEFAULT, this.isCustomWordmark = false, this.isActionZone = false, this.isGlobalZone = false, this.isLocalZone = false, this.isSiteNav = false, this.isSiteSelector = false, this.activeNavItem = null, this.activeNavItemClickAwayHandler = ({ x: e5, y: t3, target: o2 }) => {
      var n4, a2, r3, i5, E2, h2, S2, m3, $2;
      if (this.activeNavItem) {
        const D2 = this.activeNavItem.getBoundingClientRect(), te2 = (a2 = (n4 = this.activeNavItem) == null ? void 0 : n4.expandingElement) == null ? void 0 : a2.getBoundingClientRect(), at2 = Be$1(e5, t3, D2) && Be$1(e5, t3, te2), rt2 = this.activeNavItem.contains(o2) || ((i5 = (r3 = this.activeNavItem) == null ? void 0 : r3.expandingElement) == null ? void 0 : i5.contains(o2)) || ((h2 = (E2 = this.activeNavItem) == null ? void 0 : E2.shadowRoot) == null ? void 0 : h2.contains(o2)) || (($2 = (m3 = (S2 = this.activeNavItem) == null ? void 0 : S2.expandingElement) == null ? void 0 : m3.shadowRoot) == null ? void 0 : $2.contains(
          o2
        ));
        at2 && !rt2 && L$6(this, g$a.CLOSE_ACTIVE_NAV_ITEM);
      }
    }, this.handleBreakpointChanges = ({ matches: e5 }) => {
      var t3, o2, n4, a2;
      if (!e5)
        this.setHeaderZoneElement("header-zone"), this.currentOpenSlot === w$3.COUNTRY && A$5.resetOpenCountrySelector();
      else {
        this.isMenuExpanded = false, this.isDrilldownExpanded = false, c$5(), this.setHeaderZoneElement("global-zone"), this.removeOnLightClasses(), this.invertOpenMenuMode(), (o2 = Array.from((t3 = this.renderRoot) == null ? void 0 : t3.children)) != null && o2.find(
          (i5) => i5 === this.headerEl
        ) || this.appendHeaderToRoot(), ke$2(this.activeNavItem);
        const r3 = this.querySelector("[is-active]");
        if (uo$1(r3)) {
          const i5 = r3.closest(
            '[beacon-tag-name="beacon-navigation-toolbelt"]'
          );
          yo$1(i5) && (i5.isDrilldown = false), (n4 = r3.parentExpanded) == null || n4.drillup(), (a2 = r3.parentExpanded) == null || a2.setGridTemplates();
        }
      }
      this.updateActionZoneScale();
    }, this.handleActiveNavItemChange = ({ target: e5 }) => {
      e5 instanceof B$2 && (this.activeNavItem = this.querySelector(
        '[beacon-tag-name="beacon-navigation-button"][active]'
      ), this.isMobile && this.updateDrilldownExpanded(e5.active), this.currentOpenSlot = this.activeNavItem instanceof B$2 ? this.activeNavItem.navType : w$3.DEFAULT);
    }, this.addEventToSkipLink = () => {
      var e5, t3;
      const o2 = ((e5 = this.skipLink[0]) == null ? void 0 : e5.matches("a")) && this.skipLink[0] || ((t3 = this.skipLink[0]) == null ? void 0 : t3.querySelector("a"));
      o2 == null || o2.addEventListener("click", () => {
        L$6(o2, g$a.SKIP_LINK_CLICK);
      });
    }, this.handleSkipLinkClick = () => {
      this.isMenuExpanded && this.updateMenuExpanded();
    }, this.handleClickFromAnyLink = () => {
      this.isMenuExpanded && this.updateMenuExpanded(), L$6(this, g$a.CLOSE_ACTIVE_NAV_ITEM);
    }, this.onNavKeyDown = (e5) => {
      e5.key === o$2.ESCAPE && this.isMobile && this.isMenuExpanded && this.updateMenuExpanded();
    };
  }
  static get styles() {
    return [
      super.styles,
      this.motionStyles,
      this.inverseStyles,
      go$1,
      this.navigationMotionStyles
    ];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, so$1, co$1];
  }
  // Excludes skip link and wordmark
  get allSlottedContent() {
    return [...this.slottedZoneContent, ...this.slottedSiteNavigation].filter(
      (e5) => e5.localName !== "style"
    );
  }
  get slottedZoneContent() {
    return [
      ...this.slottedActionZone,
      ...this.slottedLocalZone,
      ...this.slottedGlobalZone,
      ...this.slottedHeaderZone
    ].filter((e5) => e5.localName !== "style");
  }
  /** Text to use as the ARIA label for the mobile menu button. */
  get menuAriaLabel() {
    return this.isMenuExpanded ? "Close Menu" : "Open Menu";
  }
  /** The header maintains some views as light-only, and this getter returns the correct light mode to use based on the current mode of the parent. */
  get lightModeClass() {
    var e5;
    return ((e5 = this.modeStoreComponent) == null ? void 0 : e5.currentMode) === "beacon-on-lighter" ? "beacon-on-lighter" : "beacon-on-light";
  }
  /** Query for the brand zone section. */
  get brandZoneContainer() {
    var e5;
    return (e5 = this.shadowRoot) == null ? void 0 : e5.querySelector(".brand-zone-container");
  }
  /** Query for the TRP Wordmark. */
  get defaultWordmark() {
    var e5;
    return (e5 = this.shadowRoot) == null ? void 0 : e5.querySelector(".wordmark");
  }
  get allLinks() {
    return Array.from(this.querySelectorAll("a"));
  }
  setCustomWordmarkState() {
    var e5;
    this.isCustomWordmark = !!((e5 = this.slottedWordmark) != null && e5.length);
  }
  setActionZoneState() {
    var e5;
    this.isActionZone = !!((e5 = this.slottedActionZone) != null && e5.length);
  }
  setGlobalZoneState() {
    const e5 = this.slottedGlobalZone.find(
      (t3) => t3.getAttribute("beacon-tag-name") !== "beacon-navigation-toolbelt" || t3.getAttribute("beacon-tag-name") !== "beacon-navigation-popover"
    );
    this.isGlobalZone = !!e5;
  }
  setLocalZoneState() {
    var e5;
    this.isLocalZone = !!((e5 = this.slottedLocalZone) != null && e5.length);
  }
  setSiteNavigationState() {
    var e5, t3;
    this.isSiteNav = !!((e5 = this.slottedSiteNavigation) != null && e5.length), (t3 = this.slottedSiteNavigation) == null || t3.forEach(
      (o2) => o2.setAttribute("site-navigation", "")
    );
  }
  setSiteSelectorState() {
    var e5;
    this.isSiteSelector = !!((e5 = this.slottedSiteSelector) != null && e5.length);
  }
  /**
   * Actions taken when pressing the back button.
   *
   * @fires BeaconEvents beacon-event-drillup
   */
  handleBackButton() {
    L$6(this, g$a.DRILLUP);
  }
  /** Updates header state when the header zone item is clicked. */
  handleHeaderZoneClick() {
    this.updateMenuExpanded(), this.updateDrilldownExpanded(true), this.invertOpenMenuMode();
  }
  /**
   * Appends the header to the dialog.
   */
  appendHeaderToDialog() {
    this.navigationDialogElement.appendChild(this.headerEl), this.navigationDialogElement.showModal();
  }
  /**
   * Appends the header to the root.
   */
  appendHeaderToRoot() {
    var e5, t3;
    (e5 = this.skipLinWrapperEl) == null || e5.insertAdjacentElement("afterend", this.headerEl), (t3 = this.navigationDialogElement) == null || t3.close();
  }
  /** Performed when the menu icon is interacted with. */
  handleMenuClick() {
    this.isMenuExpanded && this.handleBackButton(), this.updateMenuExpanded(), this.toggleActionZoneLightMode(), this.invertOpenMenuMode();
  }
  /**
   * Handles changes when the expanded menu opens or closes.
   *
   * @todo implement focus trapping when opening the menu so you can't tab into other elements on the page. could look at a dialog.showModal solution, adding `inert` to all non-this elements, maybe our focus-trap mixin, etc.
   */
  updateMenuExpanded() {
    if (this.isMenuExpanded = !this.isMenuExpanded, this.isMenuExpanded) {
      L$6(this, g$a.OPEN), n$7(), this.activeNavItem && this.updateDrilldownExpanded(true);
      return;
    }
    L$6(this, g$a.CLOSE), c$5(), this.updateDrilldownExpanded();
  }
  /** Sets the drilldown expanded state based on a supplied condition. */
  updateDrilldownExpanded(e5 = false) {
    this.isDrilldownExpanded = e5;
  }
  /** Forces slotted action zone elements into light mode when the menu opens. */
  toggleActionZoneLightMode() {
    this.slottedActionZone.length > 0 && this.slottedActionZone.forEach((e5) => {
      this.isMenuExpanded ? e5.classList.add(this.lightModeClass) : e5.classList.remove(this.lightModeClass);
    });
  }
  /** Applies a light theme to the expanded menu. The menu is always light theme. */
  invertOpenMenuMode() {
    var e5, t3, o2, n4;
    let a2;
    ((e5 = this.modeStoreComponent) == null ? void 0 : e5.currentMode) === "beacon-on-darker" || ((t3 = this.modeStoreComponent) == null ? void 0 : t3.currentMode) === "beacon-on-lighter" ? a2 = "beacon-on-lighter" : a2 = "beacon-on-light", this.isMenuExpanded && this.modeStoreComponent ? ((o2 = this.brandZoneContainer) == null || o2.classList.add(
      this.modeStoreComponent.currentMode
    ), this.classList.add(a2)) : this.modeStoreComponent && ((n4 = this.brandZoneContainer) == null || n4.classList.remove(
      this.modeStoreComponent.currentMode
    ), this.classList.remove(a2));
  }
  /** Sets the location of the header zone element. */
  setHeaderZoneElement(e5) {
    const t3 = e5 === "header-zone" ? this.slottedGlobalZone.find((o2) => o2.hasAttribute("header-zone")) : this.slottedHeaderZone.find((o2) => o2.hasAttribute("header-zone"));
    t3 == null || t3.setAttribute("slot", e5);
  }
  /**
   * Due to the nature of cloning country components, we want to force the country selector closed when going from a desktop view to mobile view with the country selector active.
   */
  static resetOpenCountrySelector() {
    const e5 = document.querySelector(
      '[beacon-tag-name="beacon-navigation-toolbelt"][is-open]'
    ), t3 = document.querySelector(
      '[beacon-tag-name="beacon-navigation-button"][active]'
    );
    e5 instanceof ue$3 && t3 instanceof B$2 && (e5.isOpen = false, t3.active = false);
  }
  /**
   * Remove onLight Classes
   */
  removeOnLightClasses() {
    var e5, t3;
    this.slottedHeaderZone && (e5 = this.slottedHeaderZone) != null && e5.length && this.slottedHeaderZone.forEach(
      (o2) => o2.classList.remove(this.lightModeClass)
    ), this.slottedActionZone && (t3 = this.slottedActionZone) != null && t3.length && this.slottedActionZone.forEach(
      (o2) => o2.classList.remove(this.lightModeClass)
    );
  }
  /**
   * Update slottedActionZone Button scales based on breakpoint.
   */
  updateActionZoneScale() {
    var e5;
    this.isMobile && (e5 = this.slottedActionZone) != null && e5.length ? this.slottedActionZone.forEach((t3) => t3.setAttribute("scale", "mini")) : this.slottedActionZone.forEach((t3) => t3.setAttribute("scale", "normal"));
  }
  updateAnalytics() {
    super.updateAnalytics(), this.defaultWordmark && this.defaultWordmark.setAttribute(
      C$5.location,
      f$4.header
    ), this.isCustomWordmark && this.slottedWordmark.forEach((e5) => {
      e5.setAttribute(
        C$5.location,
        f$4.header
      );
    }), this.isLocalZone && this.slottedLocalZone.forEach((e5) => {
      e5.setAttribute(
        C$5.location,
        f$4.header
      ), U(e5) ? e5.setAttribute(
        C$5.section,
        m$5[1]
      ) : e5.setAttribute(
        C$5.section,
        m$5[0]
      );
    }), this.isGlobalZone && this.slottedGlobalZone.forEach((e5) => {
      e5.setAttribute(
        C$5.location,
        f$4.header
      ), U(e5) ? e5.setAttribute(
        C$5.section,
        m$5[1]
      ) : e5.setAttribute(
        C$5.section,
        m$5[0]
      );
    }), this.isActionZone && this.slottedActionZone.forEach((e5) => {
      e5.setAttribute(
        C$5.location,
        f$4.header
      ), U(e5) ? e5.setAttribute(
        C$5.section,
        m$5[1]
      ) : e5.setAttribute(
        C$5.section,
        m$5[0]
      );
    }), this.isSiteSelector && this.slottedSiteSelector.forEach((e5) => {
      e5.setAttribute(
        C$5.location,
        f$4.header
      ), U(e5) ? e5.setAttribute(
        C$5.section,
        e5.getAttribute("opens-by") === "country-selector" ? L$4.level1LangSelector : L$4.links
      ) : e5.setAttribute(
        C$5.section,
        L$4.selectedLink
      );
    }), this.isSiteNav && this.slottedSiteNavigation.forEach((e5) => {
      e5.setAttribute(
        C$5.location,
        f$4.siteNav
      ), U(e5) ? e5.setAttribute(
        C$5.section,
        h$6.level_2
      ) : e5.setAttribute(
        C$5.section,
        h$6.level_1
      );
    }), this.allSlottedContent.forEach((e5) => {
      U(e5) && Ht$3(e5) && e5.updateAnalytics();
    });
  }
  /**
   * Appends aria role to be listitem
   */
  appendAriaRole() {
    this.allSlottedContent.forEach(
      (e5) => A$5.setListItemRole(e5)
    ), this.slottedSiteSelector.forEach(
      (e5) => A$5.setListItemRole(e5)
    );
  }
  /** Shorthand method for setting the listitem role on elements. */
  static setListItemRole(e5) {
    e5.setAttribute("role", "listitem");
  }
  calculateActionZoneSize() {
    return this.isActionZone ? this.isDrilldownExpanded ? "0px" : "var(--header-action-zone-size, 56px)" : "0px";
  }
  addClickEventsToAllLinks() {
    this.allLinks.length > 0 && this.allLinks.forEach((e5) => {
      e5.addEventListener("click", (t3) => {
        L$6(e5, g$a.NAVIGATION_LINK_CLICK, t3);
      });
    });
  }
  updated(e5) {
    var t3, o2;
    e5.has("isMenuExpanded") && this.isMobile && (this.isMenuExpanded ? (this.appendHeaderToDialog(), (t3 = this.hamburgerIconButton) == null || t3.button.focus()) : (this.appendHeaderToRoot(), (o2 = this.hamburgerIconButton) == null || o2.button.focus()));
  }
  navigationPrerender() {
    this.addEventListener(
      g$a.ACTIVE_NAV_ITEM,
      this.handleActiveNavItemChange
    ), this.addEventListener(
      g$a.HEADER_ZONE_CLICK,
      this.handleHeaderZoneClick
    ), this.largeBreakpointWatcher.addEventListener(
      "change",
      this.handleBreakpointChanges
    ), window.addEventListener("click", this.activeNavItemClickAwayHandler), document.addEventListener(
      g$a.SKIP_LINK_CLICK,
      this.handleSkipLinkClick
    ), document.addEventListener(
      g$a.NAVIGATION_LINK_CLICK,
      this.handleClickFromAnyLink
    ), document.addEventListener(lt$1.KEYDOWN, this.onNavKeyDown);
  }
  navigationPostRender() {
    this.appendAriaRole(), this.isMobile && this.setHeaderZoneElement("header-zone"), this.updateActionZoneScale(), this.addEventToSkipLink(), this.addClickEventsToAllLinks();
  }
  navigationDestroy() {
    window.removeEventListener("click", this.activeNavItemClickAwayHandler), document.removeEventListener(
      g$a.SKIP_LINK_CLICK,
      this.handleSkipLinkClick
    ), document.removeEventListener(
      g$a.NAVIGATION_LINK_CLICK,
      this.handleClickFromAnyLink
    ), document.removeEventListener(lt$1.KEYDOWN, this.onNavKeyDown);
  }
  /**
   * Renders the brandmark slot with the appropriate default logo.
   */
  renderBrandMarkSlot() {
    const e5 = d$9(Tt$1), t3 = {
      "brandmark-slot": true,
      hide: this.isMobile
    };
    return tt$1`<slot
      class=${f$6(t3)}
      name="${f$2.brandMarkSlot}"
      >${e5}</slot
    >`;
  }
  /**
   * Render the wordmark Slot or drill-up button.
   */
  renderWordMarkSlot() {
    return this.isMobile && this.isDrilldownExpanded && this.currentOpenSlot !== w$3.HEADER ? kt$1`
      <${this.getScopedTag(f$2.buttonTagName)} variant="tertiary" class="drill-up" @beacon-event-click=${this.handleBackButton}>
      ${d$9(qe$1)}Back
      </${this.getScopedTag(f$2.buttonTagName)}>` : tt$1`
      <slot
        name="${f$2.wordMarkSlot}"
        class="wordmark-container"
        @slotchange=${this.setCustomWordmarkState}>
        ${this.wordmarkUrl ? tt$1`<a
              class="wordmark"
              href="${this.wordmarkUrl}"
              aria-label="${f$2.wordMarkAriaLabel}"
              >${d$9(Re$2)}</a
            >` : tt$1`${d$9(Re$2)}`}
      </slot>
    `;
  }
  /** Render the brand-colored vertical divider. */
  renderVerticalDividerBrand(e5) {
    return this.isDesktop && e5 ? tt$1`<span aria-hidden="true"
        >${d$9(It)}</span
      >` : tt$1``;
  }
  /**
   * Render Vertical Divider based on any boolean condition.
   */
  static renderVerticalDivider(e5) {
    return e5 ? tt$1`${d$9(Dt$2)}` : tt$1``;
  }
  /** Render the site selector slot. */
  renderSiteSelectorSlot() {
    let e5 = false;
    this.currentOpenSlot === w$3.SITE_SELECTOR && (e5 = true), this.currentOpenSlot === w$3.COUNTRY && (e5 = true);
    const t3 = {
      hide: this.isDrilldownExpanded && !e5,
      "site-selector-slot": true
    };
    return tt$1`
      <div class=${f$6(t3)} role="list">
        <slot
          name="site-selector"
          @slotchange=${this.setSiteSelectorState}
          ${f$7({ useParent: true })}></slot>
      </div>
    `;
  }
  /**
   * Render the menu button area which also includes the header zone.
   */
  renderMenuButtonArea() {
    const e5 = this.slottedHeaderZone.length === 1 && this.slottedZoneContent.length <= 2, t3 = this.allSlottedContent.length > 0 || this.isSiteSelector, o2 = {
      hide: this.slottedHeaderZone.length === 0 || this.isMenuExpanded
    }, n4 = {
      "header-zone-wrapper": true,
      hide: this.isDesktop
    };
    return tt$1`
      <div class=${f$6(n4)}>
        <div role="list" class=${f$6(o2)}>
          <slot name="header-zone"></slot>
        </div>
        ${t3 ? this.renderMenuButton(this.isMenuExpanded, e5) : tt$1``}
      </div>
    `;
  }
  /**
   * Renders a cached version of the appropriate icon for the menu button.
   */
  static renderMenuButtonIcon(e5) {
    return tt$1`${ft(
      e5 ? tt$1`${d$9(Mt$2)} Close Menu` : tt$1`${d$9(Nt)} Open Menu`
    )}`;
  }
  /** Renders the Icon Button component used to trigger the opening or closing of the mobile menu. */
  renderMenuButton(e5, t3) {
    const o2 = `${e5 ? "menu-open" : "menu-closed"} ${t3 ? "header-zone-only" : ""}`;
    return kt$1`
      <${this.getScopedTag(f$2.iconButtonTagName)}
        class="${o2}"
        variant="tertiary" 
        id="menu"
        data-metrics-section="${m$5[0]}"
        data-metrics-location="${f$4.header}" 
        @beacon-event-click=${this.handleMenuClick}>
          ${A$5.renderMenuButtonIcon(e5)};
      </${this.getScopedTag(f$2.iconButtonTagName)}>
    `;
  }
  // prettier-ignore
  renderMenuZone() {
    return tt$1`
      ${this.isMobile ? A$5.renderPartnerLogoSlot() : tt$1``}
      ${this.isMobile ? this.renderSiteSelectorSlot() : tt$1``}
      ${this.isMobile ? tt$1`<div class="sitenav-wrapper">${this.renderSiteNav()}</div>` : tt$1``}
      ${this.renderLocalHeaderGlobalSlots()}
      ${this.isMobile ? this.renderCountrySelector() : tt$1``}
      ${this.renderActionZone()}
    `;
  }
  /** Render the site navigation. */
  renderSiteNav() {
    const e5 = {
      "sitenav-ul-wrapper": true,
      hide: this.isDrilldownExpanded && this.currentOpenSlot !== w$3.PRIMARY
    };
    return tt$1`
      <nav class="primary-wrapper">
        <ul class=${f$6(e5)}>
          <slot
            @slotchange=${this.setSiteNavigationState}
            ${f$7({ useParent: true })}></slot>
        </ul>
        ${this.isDesktop ? A$5.renderPartnerLogoSlot() : tt$1``}
      </nav>
    `;
  }
  static renderPartnerLogoSlot() {
    return tt$1`
      <div class="partner-logo-wrapper">
        <div class="partner-logo">
          <slot
            name="media"
            ${f$7({ container: ".partner-logo-wrapper" })}></slot>
        </div>
      </div>
    `;
  }
  setGlobalZoneVisibility() {
    return this.isMobile && this.isDrilldownExpanded ? this.currentOpenSlot === w$3.HEADER || this.currentOpenSlot === w$3.GLOBAL : this.isGlobalZone;
  }
  /**
   * Render slots for the local, header, and global zones.
   *
   * Users should not interact with the header-zone directly.
   */
  renderLocalHeaderGlobalSlots() {
    const e5 = {
      "local-zone-container": true,
      hide: !this.isLocalZone || this.isDrilldownExpanded && this.currentOpenSlot !== w$3.LOCAL
    }, t3 = {
      "global-zone-container": true,
      hide: !this.setGlobalZoneVisibility()
    }, o2 = {
      "header-zone-container": true,
      hide: this.isDrilldownExpanded && this.currentOpenSlot !== w$3.HEADER
    }, n4 = this.isLocalZone && this.isGlobalZone, a2 = this.isLocalZone && this.isActionZone && !this.isGlobalZone || this.isActionZone && this.isGlobalZone;
    return tt$1`
      <nav class="local-header-global-container">
        <div class="ul-wrapper" role="list">
          <slot
            name="${f$2.localSlot}"
            class=${f$6(e5)}
            @slotchange=${this.setLocalZoneState}></slot>
          ${A$5.renderVerticalDivider(n4)}
          <slot name="header-zone" class=${f$6(o2)}></slot>
          <slot
            name="${f$2.globalSlot}"
            class=${f$6(t3)}
            @slotchange=${this.setGlobalZoneState}></slot>
          ${A$5.renderVerticalDivider(a2)}
        </div>
      </nav>
    `;
  }
  /**
   * Render action-zone slot.
   */
  renderActionZone() {
    const e5 = {
      "action-zone-wrapper": true,
      hide: !this.isActionZone || this.isDrilldownExpanded && this.currentOpenSlot !== w$3.ACTION
    };
    return tt$1`
      <div role="list" class="${f$6(e5)}">
        <slot
          name="${f$2.actionSlot}"
          @slotchange=${this.setActionZoneState}></slot>
      </div>
    `;
  }
  /**
   * Renders the mobile country selector.
   *
   * Users should not interact with this slot directly.
   */
  renderCountrySelector() {
    const e5 = {
      "country-selector-slot": true,
      hide: this.isDrilldownExpanded
    };
    return tt$1`
      <div class=${f$6(e5)}>
        <slot name="country-selector"></slot>
      </div>
    `;
  }
  render() {
    const e5 = {
      hide: this.slottedZoneContent.length === 0 && !this.slottedSiteSelector || !this.isMenuExpanded && this.isMobile,
      menu: this.isMenuExpanded && this.isMobile,
      "menu-zone-container": true
    }, t3 = {
      "header-wrapper": true
    };
    t3[this.currentOpenSlot] = true;
    const o2 = {
      "--action-zone-size": this.calculateActionZoneSize()
    };
    return tt$1`
      <div class="skip-link-wrapper">
        <div class="skip-link-container">
          <slot name="skip-link"></slot>
        </div>
      </div>
      <header class=${f$6(t3)}>
        <section class="brand-zone-container">
          ${this.renderBrandMarkSlot()}
          ${this.renderWordMarkSlot()}
          ${this.renderVerticalDividerBrand(this.isSiteSelector)}
          ${this.isDesktop ? this.renderSiteSelectorSlot() : tt$1``}
          ${this.renderMenuButtonArea()}
        </section>
        <section class=${f$6(e5)} style=${p$3(o2)}>
          ${this.renderMenuZone()}
        </section>
      </header>
      ${this.isDesktop ? this.renderSiteNav() : tt$1``}
      <dialog id="nav-dialog" class="nav-dialog-overlay" aria-modal="true" aria-labelledby="header-wrapper"></dialog>
    `;
  }
}, A$5.tagName = f$2.beaconTagName, A$5.nestedComponents = f$2.nestedComponents, A$5);
b$8([
  v$c({ type: Boolean, reflect: true, attribute: "drilldown-expanded" })
], d$6.prototype, "isDrilldownExpanded", 2);
b$8([
  v$c({ attribute: "wordmark-href" })
], d$6.prototype, "wordmarkUrl", 2);
b$8([
  v$c({ type: Boolean, reflect: true, attribute: "menu-expanded" })
], d$6.prototype, "isMenuExpanded", 2);
b$8([
  it()
], d$6.prototype, "currentOpenSlot", 2);
b$8([
  it()
], d$6.prototype, "isCustomWordmark", 2);
b$8([
  it()
], d$6.prototype, "isActionZone", 2);
b$8([
  it()
], d$6.prototype, "isGlobalZone", 2);
b$8([
  it()
], d$6.prototype, "isLocalZone", 2);
b$8([
  it()
], d$6.prototype, "isSiteNav", 2);
b$8([
  it()
], d$6.prototype, "isSiteSelector", 2);
b$8([
  it()
], d$6.prototype, "activeNavItem", 2);
b$8([
  v$9({ flatten: true, slot: "wordmark" })
], d$6.prototype, "slottedWordmark", 2);
b$8([
  v$9({ flatten: true, slot: f$2.localSlot })
], d$6.prototype, "slottedLocalZone", 2);
b$8([
  v$9({ flatten: true, slot: f$2.globalSlot })
], d$6.prototype, "slottedGlobalZone", 2);
b$8([
  v$9({ flatten: true, slot: f$2.actionSlot })
], d$6.prototype, "slottedActionZone", 2);
b$8([
  v$9({ flatten: true, slot: "header-zone" })
], d$6.prototype, "slottedHeaderZone", 2);
b$8([
  v$9({ flatten: true })
], d$6.prototype, "slottedSiteNavigation", 2);
b$8([
  v$9({ flatten: true, slot: "site-selector" })
], d$6.prototype, "slottedSiteSelector", 2);
b$8([
  v$9({ flatten: true, slot: "skip-link" })
], d$6.prototype, "skipLink", 2);
b$8([
  y$6("dialog#nav-dialog")
], d$6.prototype, "navigationDialogElement", 2);
b$8([
  y$6(".skip-link-wrapper")
], d$6.prototype, "skipLinWrapperEl", 2);
b$8([
  y$6("[beacon-tag-name='beacon-icon-button']#menu")
], d$6.prototype, "hamburgerIconButton", 2);
b$8([
  y$6("header")
], d$6.prototype, "headerEl", 2);
b$8([
  u$2
], d$6.prototype, "navigationPrerender", 1);
b$8([
  d$e
], d$6.prototype, "navigationPostRender", 1);
b$8([
  y$7
], d$6.prototype, "navigationDestroy", 1);
let re$2 = d$6;
var fo$1 = Object.defineProperty, wo$1 = Object.getOwnPropertyDescriptor, tt = (e5) => {
  throw TypeError(e5);
}, j$2 = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? wo$1(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && fo$1(t3, o2, a2), a2;
}, ko$1 = (e5, t3, o2) => t3.has(e5) || tt("Cannot " + o2), Ze$1 = (e5, t3, o2) => (ko$1(e5, t3, "read from private field"), o2 ? o2.call(e5) : t3.get(e5)), xo$1 = (e5, t3, o2) => t3.has(e5) ? tt("Cannot add the same private member more than once") : t3 instanceof WeakSet ? t3.add(e5) : t3.set(e5, o2), w$3 = /* @__PURE__ */ ((e5) => (e5.GLOBAL = "global", e5.PRIMARY = "site-nav", e5.LOCAL = "local", e5.DEFAULT = "default", e5.HEADER = "header", e5.ACTION = "action", e5.SITE_SELECTOR = "site-selector", e5.COUNTRY = "country-selector", e5))(w$3 || {}), Le$1 = /* @__PURE__ */ ((e5) => (e5.GLOBAL = "global-zone", e5.PRIMARY = "site-navigation", e5.LOCAL = "local-zone", e5.HEADER = "header-zone", e5.ACTION = "action-zone", e5.SITE_SELECTOR = "site-selector", e5.COUNTRY_SELECTOR = "country-navigation-button", e5))(Le$1 || {});
const Co$1 = /* @__PURE__ */ new Map([
  [
    "global-zone",
    "global"
    /* GLOBAL */
  ],
  [
    "local-zone",
    "local"
    /* LOCAL */
  ],
  [
    "site-navigation",
    "site-nav"
    /* PRIMARY */
  ],
  [
    "header-zone",
    "header"
    /* HEADER */
  ],
  [
    "site-selector",
    "site-selector"
    /* SITE_SELECTOR */
  ],
  [
    "country-navigation-button",
    "country-selector"
    /* COUNTRY */
  ],
  [
    "action-zone",
    "action"
    /* ACTION */
  ]
]);
function Eo$1(e5) {
  var t3;
  let o2 = class extends e5 {
    constructor() {
      super(...arguments), this.active = false, this.hasExpandedAnchor = false, this.activeInStyleOnly = false, this.toggleActive = ({ target: n4 }) => {
        n4 instanceof Element && (this.active = !this.active);
      }, this.handleFocusOut = ({ relatedTarget: n4 }) => {
        n4 instanceof HTMLElement && (this.expandingElement instanceof ee$3 || this.expandingElement instanceof ue$3) && !this.expandingElement.contains(n4) && !this.isEqualNode(n4) && this.hasFieldAndValue("isDesktop", true) && this.active && (this.active = false);
      }, this.handleDrillupEvent = ({ target: n4 }) => {
        n4 instanceof re$2 && this.expandingElement instanceof HTMLElement && Ge$2(
          this.expandingElement
        ).filter((a2) => a2 instanceof Je$1 && a2.isActive).length < 1 && this.active && (this.active = false);
      }, this.handleHeaderClose = ({ target: n4 }) => {
        n4 instanceof re$2 && (this.active = false);
      }, this.closeOnActiveChange = ({ target: n4 }) => {
        n4 && "active" in n4 && n4.active && this !== n4 && this.active && (this.active = false);
      }, this.handleClickAway = ({ target: n4 }) => {
        n4 instanceof re$2 && this.hasFieldAndValue("isDesktop", true) && (this.active = false);
      }, xo$1(this, t3, /* @__PURE__ */ new Map([
        [g$a.DRILLUP, this.handleDrillupEvent],
        [g$a.CLOSE, this.handleHeaderClose],
        [g$a.ACTIVE_NAV_ITEM, this.closeOnActiveChange],
        [g$a.CLOSE_ACTIVE_NAV_ITEM, this.handleClickAway]
      ]));
    }
    /** Callback for on beacon-event-active-nav-item-change */
    onBeaconActiveNavItemChange() {
    }
    /** Reference to the internal button element. */
    get button() {
      var n4;
      return (n4 = this.shadowRoot) == null ? void 0 : n4.querySelector(".button");
    }
    get expandingElementRoot() {
      return this.closest('[beacon-tag-name="beacon-navigation"]');
    }
    /** The Popover or Toolbelt that this navigation button triggers. */
    get expandingElement() {
      return (this.expandingElementRoot ? this.expandingElementRoot : document).querySelector(`[opens-by="${this.opens}"]`);
    }
    get closestSlot() {
      var n4, a2;
      return (a2 = (n4 = this.closest("[slot]")) == null ? void 0 : n4.slot) != null ? a2 : "";
    }
    /** Sets a type to the component based on what slot it is in. */
    get navType() {
      var n4;
      return this.hasExpandedAnchor && this.closestSlot !== "country-navigation-button" ? "default" : (n4 = Co$1.get(this.closestSlot)) != null ? n4 : "site-nav";
    }
    prerenderNavigationMenuTriggerSetup() {
      this.addEventListener(g$a.CLICK, this.toggleActive), Ze$1(this, t3).forEach((n4, a2) => {
        document.addEventListener(a2, n4);
      });
    }
    postrenderAddFocusOutListener() {
      var n4;
      (n4 = this.button) == null || n4.addEventListener(
        "focusout",
        this.handleFocusOut
      );
    }
    updated(n4) {
      o$4(n4, "active") && L$6(
        this,
        g$a.ACTIVE_NAV_ITEM,
        void 0,
        this.onBeaconActiveNavItemChange
      );
    }
    tearDownNavigationMenuTrigger() {
      Ze$1(this, t3).forEach((n4, a2) => {
        document.removeEventListener(a2, n4);
      });
    }
  };
  return t3 = /* @__PURE__ */ new WeakMap(), j$2([
    v$c({ type: Boolean, reflect: true })
  ], o2.prototype, "active", 2), j$2([
    v$c({ type: Boolean, attribute: "expanded-anchor", reflect: true })
  ], o2.prototype, "hasExpandedAnchor", 2), j$2([
    v$c({ reflect: true })
  ], o2.prototype, "opens", 2), j$2([
    it()
  ], o2.prototype, "activeInStyleOnly", 2), j$2([
    u$2
  ], o2.prototype, "prerenderNavigationMenuTriggerSetup", 1), j$2([
    d$e
  ], o2.prototype, "postrenderAddFocusOutListener", 1), j$2([
    y$7
  ], o2.prototype, "tearDownNavigationMenuTrigger", 1), o2 = j$2([
    f$8("NavigationMenuTrigger")
  ], o2), o2;
}
const So$1 = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M10 8L14 12L10 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, Lo$1 = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
    slot="icon" class="chevron">
    <path d="M4 10L8 6L12 10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, zo$1 = `<svg width="12" height="13" viewBox="0 0 12 13" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.89255 4.84171V3.60553C2.89255 1.89039 4.28294 0.5 5.99808 0.5C7.71321 0.5 9.1036 1.89039 9.1036 3.60553V4.84171H9.37496C10.0244 4.84171 10.5508 5.36817 10.5508 6.01759V11.3241C10.5508 11.9735 10.0244 12.5 9.37496 12.5H2.62119C1.97177 12.5 1.44531 11.9735 1.44531 11.3241V6.01759C1.44531 5.36817 1.97177 4.84171 2.62119 4.84171H2.89255ZM3.79707 3.60553C3.79707 2.38995 4.7825 1.40452 5.99808 1.40452C7.21366 1.40452 8.19908 2.38995 8.19908 3.60553V4.84171H3.79707V3.60553ZM5.99808 7.01257C5.48187 7.01257 5.0634 7.43103 5.0634 7.94724C5.0634 8.29938 5.25814 8.60604 5.5458 8.7654V9.87687C5.5458 10.1267 5.74829 10.3291 5.99806 10.3291C6.24784 10.3291 6.45033 10.1267 6.45033 9.87687V8.76541C6.738 8.60606 6.93275 8.29939 6.93275 7.94724C6.93275 7.43103 6.51428 7.01257 5.99808 7.01257Z"/>
</svg>`;
var Oo$1 = Object.defineProperty, $o$1 = Object.getOwnPropertyDescriptor, He$1 = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? $o$1(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && Oo$1(t3, o2, a2), a2;
};
function Ao$1(e5) {
  let t3 = class extends e5 {
  };
  return He$1([
    v$c({ attribute: "beacon-aria-label", reflect: true })
  ], t3.prototype, "beaconAriaLabel", 2), t3 = He$1([
    f$8("Aria")
  ], t3), t3;
}
const Pe$1 = {
  // Tag Names
  beaconTagName: "beacon-navigation-button",
  expandedNavTagName: "beacon-navigation-expanded",
  iconButtonTagName: "beacon-icon-button",
  buttonTagName: "beacon-button",
  popoverTagName: "beacon-navigation-popover",
  toolbeltTagName: "beacon-navigation-toolbelt",
  // Slot Name
  expandedSlot: "nav-expanded",
  iconSlot: "icon",
  // Class Name
  hideClass: "hide"
}, Mo$1 = T$7`[beacon-tag-name=beacon-navigation-button] [slot=flag]{margin-inline-end:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-navigation-button] svg{pointer-events:none}@media (width >= 960px){[beacon-tag-name=beacon-navigation-button] .button:not(.beacon-button):is(.global,.site-nav) *{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}}`, No$1 = T$7`@media (width >= 960px){:host([motion-state=enabled]) .motion-underline--grow-out{--border-color: var(--beacon-system-color-border-secondary);--link-transform: scaleX(0);position:relative}:host([motion-state=enabled]) .motion-underline--grow-out:after,:host([motion-state=enabled]) .motion-underline--grow-out:before{--underline-opacity: 0;--underline-size: 50%;background-color:var(--border-color);block-size:var(--beacon-system-width-border-normal);content:"";inline-size:var(--underline-size);inset-block-end:0;opacity:var(--underline-opacity);position:absolute;transform:var(--link-transform);transform-origin:var(--link-transform-origin);transition-duration:var(--beacon-reference-motion-duration-5);transition-property:transform,opacity;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .motion-underline--grow-out:before{--link-transform-origin: right;inset-inline-end:var(--underline-size)}:host([motion-state=enabled]) .motion-underline--grow-out:after{--link-transform-origin: left;inset-inline-start:var(--underline-size)}:host([motion-state=enabled]) .motion-underline--grow-out:hover,:host([motion-state=enabled]) .motion-underline--grow-out:focus-visible,:host([motion-state=enabled]) .motion-underline--grow-out.active,:host([motion-state=enabled]) .motion-underline--grow-out.current{--link-transform: scaleX(1);text-decoration:none}:host([motion-state=enabled]) .motion-underline--grow-out:hover:after,:host([motion-state=enabled]) .motion-underline--grow-out:hover:before,:host([motion-state=enabled]) .motion-underline--grow-out:focus-visible:after,:host([motion-state=enabled]) .motion-underline--grow-out:focus-visible:before,:host([motion-state=enabled]) .motion-underline--grow-out.active:after,:host([motion-state=enabled]) .motion-underline--grow-out.active:before,:host([motion-state=enabled]) .motion-underline--grow-out.current:after,:host([motion-state=enabled]) .motion-underline--grow-out.current:before{--underline-opacity: 1}:host([motion-state=enabled]) .motion-underline--grow-out.current:not(.active){--border-color: var(--beacon-system-color-border-brand)}}`;
var To$1 = Object.defineProperty, Io$1 = Object.getOwnPropertyDescriptor, _e$1 = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? Io$1(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && To$1(t3, o2, a2), a2;
};
function Do$1(e5) {
  let t3 = class extends e5 {
    static get navigationButtonMotionStyles() {
      return [No$1];
    }
    /** Sets the motion class on the button element if it meets the condition of being a primary nav item. */
    static activeItemMotionClasses({ target: o2 }) {
      var n4;
      if (o2 instanceof HTMLElement) {
        const a2 = (n4 = o2.shadowRoot) == null ? void 0 : n4.querySelector(
          t3.activeElementQuery
        );
        if (a2 instanceof HTMLButtonElement) {
          const { classList: r3 } = a2;
          Array.from(r3).includes(w$3.PRIMARY) && a2.classList.add("motion-underline--grow-out");
        }
      }
    }
    prerenderNavigationButtonMotionSetup() {
      this.addEventListener(
        g$a.ELEMENT_READY,
        t3.activeItemMotionClasses
      );
    }
  };
  return t3.activeElementQuery = ".button", _e$1([
    u$2
  ], t3.prototype, "prerenderNavigationButtonMotionSetup", 1), t3 = _e$1([
    f$8("NavigationButtonMotion")
  ], t3), t3;
}
const Ro$1 = T$7`:host{inline-size:fit-content}@media (width < 960px){:host(:not([expanded-anchor])) :not(a):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}}@media (width < 960px) and (forced-colors: active){:host(:not([expanded-anchor])) :not(a):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}@media (width >= 960px){:host(:not([expanded-anchor])) :not(a):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;position:relative;z-index:1}}:host([expanded-anchor]) :not(a):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){:host([expanded-anchor]) :not(a):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}:host([show-popover]){position:relative}.flag{display:none}::slotted([slot=flag]){margin-inline-end:var(--beacon-reference-space-2)}.mobile-site-selector-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50);color:var(--beacon-system-color-text-title);padding-block:var(--beacon-system-space-cell-free-floating)}.plain-text{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);align-items:center;color:var(--beacon-system-color-text-standard);cursor:not-allowed;display:flex;gap:var(--beacon-reference-space-2)}.plain-text .icon--default{display:flex}.plain-text svg{fill:var(--beacon-system-color-text-standard)}.chevron{--chevron-transform: 90deg;transform:rotate(var(--chevron-transform))}.button.beacon-button{--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--bg-color);--text-color: var(--beacon-system-color-text-primary);--hover-bg-color: var(--beacon-system-color-background-primary-hover);--hover-text-color: var(--hover-bg-color);--disabled-bg-color: var(--beacon-system-color-background-primary-inactive);--disabled-text-color: var(--beacon-system-color-text-primary-inactive);--disabled-border-color: var(--disabled-bg-color);--active-bg-color: var(--beacon-system-color-background-primary-pressed);--active-text-color: var(--beacon-system-color-text-secondary-pressed);--active-border-color: var(--active-bg-color);--border-inline-start-width: var(--beacon-system-width-border-mini);--border-radius: var(--beacon-system-radius-corner-standard);--border-width: var(--beacon-system-width-border-mini);--default-gap: var(--beacon-reference-space-3);--font-weight: var(--beacon-system-font-weight-bold);--font-size: var(--beacon-reference-font-scale-4);--line-height: var(--beacon-reference-font-scale-4);background-color:var(--override-button-bg-color, var(--bg-color));border-color:var(--border-color);border-end-end-radius:var(--override-button-border-radius, var(--border-radius));border-end-start-radius:var(--override-button-border-radius, var(--border-radius));border-inline-start-width:var(--override-button-border-size-inline, var(--border-inline-start-width));border-start-end-radius:var(--override-button-border-radius, var(--border-radius));border-start-start-radius:var(--override-button-border-radius, var(--border-radius));border-style:solid;border-width:var(--override-button-border-width, var(--border-width));color:var(--text-color);display:inline-flex;flex-direction:var(--button-flex-direction, row);font:var(--font-weight) var(--beacon-component-button-normal-font-size-sans-serif-standard);gap:var(--override-button-icon-space-margin, var(--default-gap));inline-size:inherit;justify-content:center;outline-offset:1px;padding-block:var(--beacon-reference-space-4) var(--beacon-reference-space-4);padding-inline:var(--beacon-reference-space-5);text-align:start;word-break:initial;align-items:center}.button.beacon-button .contents{display:inherit;flex-direction:inherit;gap:inherit;justify-content:inherit}.button.beacon-button[aria-disabled=true]{background-color:var(--disabled-bg-color);border-color:var(--disabled-border-color);color:var(--disabled-text-color);cursor:not-allowed;text-decoration:none}.button.beacon-button:is(:hover,:focus-visible):not([aria-disabled=true]){background-color:var(--hover-bg-color);color:var(--hover-text-color);text-decoration:underline}.button.beacon-button:active:not([aria-disabled=true]){background-color:var(--active-bg-color);color:var(--active-text-color);text-decoration:none}.button.beacon-button.primary{--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--override-button-color-border-error, var(--bg-color));--text-color: var(--beacon-system-color-text-primary);--hover-bg-color: var(--beacon-system-color-background-primary-hover);--hover-text-color: var(--text-color);--disabled-bg-color: var(--beacon-system-color-background-primary-inactive);--disabled-text-color: var(--beacon-system-color-text-primary-inactive);--disabled-border-color: var(--disabled-bg-color);--active-bg-color: var(--beacon-system-color-background-primary-pressed);--active-text-color: var(--text-color)}.button.beacon-button.secondary{--bg-color: transparent;--border-color: var(--beacon-system-color-border-secondary);--text-color: var(--beacon-system-color-text-secondary);--hover-bg-color: var(--beacon-system-color-background-secondary-hover);--hover-border-color: var(--beacon-system-color-border-secondary-hover);--hover-text-color: var(--beacon-system-color-text-secondary-hover);--disabled-bg-color: var(--bg-color);--disabled-text-color: var(--beacon-system-color-text-secondary-inactive);--disabled-border-color: var(--beacon-system-color-border-secondary-inactive);--active-bg-color: var(--beacon-system-color-background-secondary-pressed);--active-text-color: var(--beacon-system-color-text-secondary-pressed)}.button.beacon-button.mini{--default-gap: var(--override-button-default-gap, var(--beacon-reference-space-2));--default-font-size: var(--beacon-component-button-mini-font-size-sans-serif-standard);--default-line-height: var(--beacon-component-button-mini-line-height-sans-serif-standard);--font-size: var(--override-button-font-size-mini, var(--default-font-size));--line-height: var(--override-button-font-line-height-mini, var(--default-line-height));font:var(--font-weight) var(--beacon-component-button-mini-font-size-sans-serif-standard);margin-block:var(--beacon-reference-space-2);padding-block:var(--beacon-reference-space-3) var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}.button.beacon-button.normal{--default-padding-block-start: var(--beacon-reference-space-4);--default-padding-block-end: var(--beacon-reference-space-4);--default-padding-inline: var(--beacon-reference-space-5);--normal-font-size: var(--override-button-font-size-normal, var(--font-size));--normal-font-weight: var(--override-button-font-weight-normal, var(--font-weight));--component-font-size: var(--override-button-font-size, var(--beacon-component-button-normal-font-size-sans-serif-standard));font:var(--normal-font-weight) var(--component-font-size, var(--normal-font-size)/var(--line-height) var(--beacon-system-font-family-body));padding-block:var(--override-button-space-padding-block-start-normal, var(--default-padding-block-start)) var(--override-button-space-padding-block-end-normal, var(--default-padding-block-end));padding-inline:var(--override-button-space-padding-inline-normal, var(--default-padding-inline))}.button.beacon-button.jumbo{--font-size: var(--beacon-component-button-jumbo-font-size-sans-serif-standard);--line-height: var(--beacon-component-button-jumbo-line-height-sans-serif-standard);font:var(--font-weight) var(--beacon-component-button-jumbo-font-size-sans-serif-standard);padding-block:var(--beacon-reference-space-5) var(--beacon-reference-space-5);padding-inline:var(--beacon-reference-space-7)}.button.beacon-button .site-selector-slot{display:none}:host([is-icon-button]) .icon--default{display:none}.button:not(.beacon-button){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);align-items:center;background-color:transparent;border:0;color:var(--beacon-system-color-text-link);display:flex;gap:var(--beacon-reference-space-2);padding:0;text-align:start}.button:not(.beacon-button) .icon--default svg{color:var(--chevron-fill-color, var(--beacon-system-color-icon-link))}.button:not(.beacon-button):is(.global,.site-nav,.local,.site-selector){color:var(--header-menu-expanded-navigation-button-color, var(--beacon-component-primary-navigation-header-color-text-link))}.button:not(.beacon-button):is(.local,.site-nav){--chevron-fill-color: var(--beacon-system-color-icon-link)}.button:not(.beacon-button).beacon-icon-button{--active-bg: var(--beacon-system-color-background-primary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--beacon-system-color-border-secondary);--border-width: var(--beacon-system-width-border-mini);--default-size: var(--beacon-reference-space-9);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--beacon-system-color-background-primary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-primary);align-items:center;background-color:var(--override-icon-button-bg-color, var(--bg-color));block-size:var(--override-icon-button-wrapper-block-size, var(--beacon-reference-space-10));border:var(--border-width) solid var(--border-color);border-radius:var(--override-icon-button-border-radius, var(--beacon-system-radius-corner-circle));box-shadow:var(--override-icon-button-box-shadow, initial);color:var(--override-icon-button-color, var(--beacon-host-override-icon-button-color, var(--icon-color)));cursor:pointer;display:inline-flex;inline-size:var(--override-icon-button-wrapper-inline-size, var(--beacon-reference-space-10));justify-content:center;outline-offset:var(--override-icon-button-outline-offset);position:relative}.button:not(.beacon-button).beacon-icon-button .contents{align-items:inherit;display:inherit;justify-content:inherit;position:inherit}.button:not(.beacon-button).beacon-icon-button[aria-disabled=true]{--icon-color: var(--disabled-icon);background-color:var(--disabled-bg);border-color:var(--disabled-border);color:var(--disabled-icon);cursor:not-allowed}.button:not(.beacon-button).beacon-icon-button svg,.button:not(.beacon-button).beacon-icon-button [beacon-tag-name=beacon-icon]{position:absolute}.button:not(.beacon-button).beacon-icon-button:-webkit-direct-focus{outline:-webkit-focus-ring-color auto 0}.button:not(.beacon-button).beacon-icon-button:hover:not([aria-disabled=true]){--icon-color: var(--hover-icon);background-color:var(--hover-bg);border-color:var(--hover-border);color:var(--hover-icon)}.button:not(.beacon-button).beacon-icon-button:active:not([aria-disabled=true]){--icon-color: var(--active-icon);background-color:var(--active-bg);border-color:var(--active-border);color:var(--active-icon)}.button:not(.beacon-button).beacon-icon-button svg{position:static}.button:not(.beacon-button).beacon-icon-button.tertiary{--active-bg: var(--beacon-system-color-background-tertiary-pressed);--active-icon: var(--beacon-system-color-icon-tertiary-pressed);--bg-color: transparent;--default-hover-bg: var(--beacon-system-color-background-tertiary-hover);--default-hover-icon: var(--beacon-system-color-icon-tertiary-hover);--default-icon-color: var(--beacon-system-color-icon-tertiary);--disabled-bg: transparent;--disabled-icon: var(--beacon-system-color-icon-tertiary-inactive);--hover-bg: var(--override-icon-button-hover-bg, var(--default-hover-bg));--hover-icon: var(--override-icon-button-icon-color, var(--default-hover-icon));--icon-color: var(--override-icon-button-icon-color, var(--default-icon-color));border:0}.button:not(.beacon-button).site-selector .default-slot{display:none}.button:not(.beacon-button).header .default-slot{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px;display:block}.button:not(.beacon-button).header .icon--default{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}.button:not(.beacon-button):not(.site-selector) .site-selector-slot{display:none}.button:not(.beacon-button):is(:hover,:focus){text-decoration:underline}:host(:not([is-icon-button])) .button:not(.beacon-button) .icon--default{display:flex}:host(:not([slot=header-zone])) .button:not(.beacon-button).active{display:flex}:host(:not([slot=header-zone])) .active .chevron{--chevron-transform: 0deg}@media (width >= 960px){:host([is-icon-button]){padding-block:var(--beacon-system-space-cell-free-floating) var(--beacon-system-space-cell-free-floating)}.mobile-site-selector-title{display:none}.flag{display:contents}.plain-text{gap:var(--beacon-reference-space-3)}.button:not(.beacon-button){gap:var(--beacon-reference-space-3);word-break:keep-all}.button:not(.beacon-button):is(.global,.site-nav,.local){padding-block:var(--beacon-system-space-cell-free-floating) var(--beacon-system-space-cell-free-floating)}.button:not(.beacon-button):is(.local,.site-selector){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);color:var(--beacon-component-primary-navigation-header-color-text-link);gap:var(--beacon-reference-space-2)}.button:not(.beacon-button).site-selector{padding:var(--beacon-system-space-cell-contained)}.button:not(.beacon-button).site-selector .default-slot{display:contents}.button:not(.beacon-button).site-selector .site-selector-slot{display:none}.button:not(.beacon-button):is(.global,.site-nav),.button:not(.beacon-button):is(.global,.site-nav) ::slotted(*){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.button:not(.beacon-button).site-nav{border:0;color:var(--beacon-component-primary-navigation-header-color-text-link);gap:var(--beacon-reference-space-2)}.button:not(.beacon-button).global{color:var(--beacon-component-primary-navigation-header-color-text-link);font-weight:var(--beacon-system-font-weight-bold)}.button:not(.beacon-button).active{color:var(--beacon-system-color-text-link-active);font-weight:var(--beacon-system-font-weight-bold)}:host([motion-state=disabled]) .button:not(.beacon-button).site-nav{border-block-end:var(--beacon-system-width-border-normal) solid var(--navigation-button-border-color)}:host([motion-state=disabled]) .button:not(.beacon-button).site-nav.current{--navigation-button-border-color: var(--beacon-system-color-border-brand)}:host([motion-state=disabled]) .button:not(.beacon-button).site-nav.active{--navigation-button-border-color: var(--beacon-system-color-border-secondary)}.chevron{--chevron-transform: 180deg}:host([site-navigation]) .plain-text{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}}`;
var ot = (e5) => {
  throw TypeError(e5);
}, nt = (e5, t3, o2) => t3.has(e5) || ot("Cannot " + o2), je$2 = (e5, t3, o2) => (nt(e5, t3, "read from private field"), o2 ? o2.call(e5) : t3.get(e5)), Bo$1 = (e5, t3, o2) => t3.has(e5) ? ot("Cannot add the same private member more than once") : t3 instanceof WeakSet ? t3.add(e5) : t3.set(e5, o2), Fo$1 = (e5, t3, o2, n4) => (nt(e5, t3, "write to private field"), t3.set(e5, o2), o2), Zo$1 = Object.defineProperty, Ho$1 = Object.getOwnPropertyDescriptor, T$4 = (e5, t3, o2, n4) => {
  for (var a2 = n4 > 1 ? void 0 : n4 ? Ho$1(t3, o2) : t3, r3 = e5.length - 1, i5; r3 >= 0; r3--)
    (i5 = e5[r3]) && (a2 = (n4 ? i5(t3, o2, a2) : i5(a2)) || a2);
  return n4 && a2 && Zo$1(t3, o2, a2), a2;
}, ne$2, q$1;
const O$2 = (q$1 = class extends B$5(Bt$3).with(
  Ao$1,
  Do$1,
  L$3(),
  f$3,
  Eo$1,
  m$b({ clean: true })
) {
  constructor() {
    super(...arguments), Bo$1(this, ne$2), this.beaconTagName = Pe$1.beaconTagName, this.focusOverride = true, this.restricted = false, this.variant = "standard", this.scale = i$6.NORMAL, this.hasIcon = false, this.hasCountryFlag = false, this.current = false, this.handleCountrySelector = ({ type: e5 }) => {
      e5 === g$a.COUNTRY_SELECTOR_OPEN && this.closestSlot === Le$1.SITE_SELECTOR && (this.activeInStyleOnly = true), e5 === g$a.COUNTRY_SELECTOR_CLOSE && this.activeInStyleOnly && (this.activeInStyleOnly = false);
    }, this.applyCurrentStyling = ({ target: e5 }) => {
      var t3;
      (t3 = this.expandingElement) != null && t3.contains(e5) && (this.current = true);
    }, Fo$1(this, ne$2, /* @__PURE__ */ new Map([
      [g$a.COUNTRY_SELECTOR_OPEN, this.handleCountrySelector],
      [g$a.COUNTRY_SELECTOR_CLOSE, this.handleCountrySelector],
      [g$a.HAS_CURRENT_LINK, this.applyCurrentStyling]
    ]));
  }
  static get styles() {
    return [super.styles, this.navigationButtonMotionStyles, Ro$1];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, Mo$1];
  }
  get icon() {
    return this.iconSlotNodes[0];
  }
  get flag() {
    return this.flagSlotNodes[0];
  }
  /** Reference to the built-in icon element. */
  get builtInIcon() {
    var e5;
    return (e5 = this.shadowRoot) == null ? void 0 : e5.querySelector(".icon--default");
  }
  /**
   * onClick handler to maintain active state
   * @param event
   */
  toggleOnClick() {
    this.emitClick(), this.navType === w$3.HEADER && L$6(this, g$a.HEADER_ZONE_CLICK);
  }
  /** Applies a specific class for nav items that are only an icon to account for changes in CSS. */
  setIconSlotState() {
    this.iconSlotNodes.length > 0 && (this.hasIcon = true);
  }
  handleIconSlotchange() {
    var e5;
    this.setIconSlotState();
    const t3 = (e5 = this.beaconAriaLabel) != null ? e5 : this.defaultSlotText;
    It$1(this.icon, t3);
  }
  /** Adds attribute to the flag slot to enable analytics tracking by attaching a data-metrics-text attribute */
  handleFlagSlotchange() {
    var e5;
    const t3 = (e5 = this.beaconAriaLabel) != null ? e5 : this.defaultSlotText;
    It$1(this.flag, t3);
  }
  /**
   * Selects an internal icon based on the context the nav item is in.
   *
   * Could be a lock for restricted items, or chevrons based on expanded state.
   */
  buildIcon() {
    return this.restricted ? q$1.renderBuiltInIcon(
      d$9(zo$1),
      "restricted"
    ) : this.hasExpandedAnchor ? q$1.renderBuiltInIcon(
      d$9(So$1),
      "expanded"
    ) : q$1.renderBuiltInIcon(
      d$9(Lo$1),
      "standard"
    );
  }
  static renderBuiltInIcon(e5, t3) {
    return tt$1`<span
      class="icon--default icon--${t3}"
      aria-hidden="true"
      >${e5}</span
    >`;
  }
  navItemPrerender() {
    je$2(this, ne$2).forEach((e5, t3) => {
      document.addEventListener(t3, e5);
    });
  }
  navItemDestroy() {
    je$2(this, ne$2).forEach((e5, t3) => {
      document.removeEventListener(t3, e5);
    });
  }
  renderSiteSelectorContent() {
    return this.navType === w$3.SITE_SELECTOR ? tt$1`<div class="mobile-site-selector-title">
        ${this.defaultSlotText}
      </div>` : tt$1``;
  }
  render() {
    var e5;
    const t3 = this.hasIcon && !this.defaultSlotText, o2 = {
      active: this.active || this.activeInStyleOnly,
      button: true,
      "beacon-icon-button": t3,
      "beacon-button": !t3 && this.variant !== "standard",
      current: this.current,
      tertiary: t3,
      restricted: this.restricted
    };
    return o2[this.navType] = true, o2[this.variant] = true, o2[this.scale] = true, t3 ? this.setAttribute("is-icon-button", "") : this.removeAttribute("is-icon-button"), tt$1`
      ${this.renderSiteSelectorContent()}
      ${this.restricted ? tt$1`
            <div class="plain-text">
              <slot class="default-slot"></slot>
              ${this.buildIcon()}
            </div>
          ` : tt$1`
            <button
              aria-expanded="${this.active.toString()}"
              aria-label="${e$6(this.beaconAriaLabel)}"
              data-metrics-link-text="${e$6(
      (e5 = this.beaconAriaLabel) != null ? e5 : this.defaultSlotText
    )}"
              aria-haspopup="true"
              class="${f$6(o2)}"
              id="${e$6(this.metricsID)}"
              part="button"
              @click=${this.toggleOnClick}>
              <slot name="icon" @slotchange=${this.handleIconSlotchange}></slot>
              <slot
                class="flag"
                name="flag"
                @slotchange=${this.handleFlagSlotchange}
                aria-hidden="true"></slot>
              <slot
                class="default-slot"
                @slotchange=${this.setDefaultSlotText}></slot>
              <slot name="site-selector-text" class="site-selector-slot"
                >Change Site</slot
              >
              ${this.buildIcon()}
            </button>
          `}
    `;
  }
}, ne$2 = /* @__PURE__ */ new WeakMap(), q$1.tagName = Pe$1.beaconTagName, q$1);
T$4([
  v$c({ type: Boolean, reflect: true })
], O$2.prototype, "restricted", 2);
T$4([
  v$c({ reflect: true })
], O$2.prototype, "variant", 2);
T$4([
  v$c({ reflect: true })
], O$2.prototype, "scale", 2);
T$4([
  it()
], O$2.prototype, "hasIcon", 2);
T$4([
  it()
], O$2.prototype, "hasCountryFlag", 2);
T$4([
  it()
], O$2.prototype, "current", 2);
T$4([
  E$8({ flatten: true, slot: "icon" })
], O$2.prototype, "iconSlotNodes", 2);
T$4([
  E$8({ flatten: true, slot: "flag" })
], O$2.prototype, "flagSlotNodes", 2);
T$4([
  y$6("button")
], O$2.prototype, "button", 2);
T$4([
  v$c({ attribute: "data-id" })
], O$2.prototype, "metricsID", 2);
T$4([
  u$2
], O$2.prototype, "navItemPrerender", 1);
T$4([
  y$7
], O$2.prototype, "navItemDestroy", 1);
let B$2 = O$2;
const r$5 = (n4) => (Se$3(n4, re$2), Dt$3({
  tagName: n4 ? n4 + "-" + re$2.tagName : re$2.tagName,
  elementClass: re$2,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const s$2 = (t3) => (Se$3(t3, Je$1), Dt$3({
  tagName: t3 ? t3 + "-" + Je$1.tagName : Je$1.tagName,
  elementClass: Je$1,
  react: React,
  events: {}
}));
const h$4 = T$7`:root[beacon-tag-name=beacon-footer],:root [beacon-tag-name=beacon-footer],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-footer],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-footer],[beacon-version="4.2.2"][beacon-tag-name=beacon-footer],[beacon-version="4.2.2"] [beacon-tag-name=beacon-footer]{--footer-disclaimer-content-padding-inline-end: 0;--footer-links-padding-block: 0;--footer-links-gap: var(--beacon-system-space-micro-jumbo);--footer-mission-padding-block-end: var(--beacon-reference-space-5);--footer-mission-padding-block-start: 0;--footer-mission-zone-grid-gap: var(--beacon-system-space-micro-jumbo);--footer-socials-padding-block-start: var(--beacon-reference-space-5)}@media (width >= 960px){:root[beacon-tag-name=beacon-footer],:root [beacon-tag-name=beacon-footer],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-footer],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-footer],[beacon-version="4.2.2"][beacon-tag-name=beacon-footer],[beacon-version="4.2.2"] [beacon-tag-name=beacon-footer]{--footer-disclaimer-content-padding-inline-end: var(--beacon-reference-space-7);--footer-mission-padding-block-end: var(--beacon-reference-space-9);--footer-mission-zone-grid-gap: var(--beacon-reference-space-9);--footer-socials-padding-block-start: var(--beacon-reference-space-9)}}@media (width >= 1920px){:root[beacon-tag-name=beacon-footer],:root [beacon-tag-name=beacon-footer],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-footer],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-footer],[beacon-version="4.2.2"][beacon-tag-name=beacon-footer],[beacon-version="4.2.2"] [beacon-tag-name=beacon-footer]{--footer-links-gap: var(--beacon-reference-space-9)}}`, a$4 = {
  beaconTagName: "beacon-footer",
  metricsLocationFooter: "FTR",
  get lightDOMStyleID() {
    return `${this.beaconTagName}-styles`;
  }
}, k$5 = T$7`[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) p{margin-block:var(--beacon-system-font-paragraph-spacing-loose)}[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) :first-child{margin-block-start:0}[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) :last-child{margin-block-end:0}[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-footer] sup{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);vertical-align:super}`, w$2 = T$7`.b-grid{--b-default-auto-layout: calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns));--b-default-grid-gap: var(--b-grid-gap, var(--beacon-system-space-gutter));--b-default-column-count: var(--b-grid-columns, var(--beacon-system-grid-columns));display:grid;gap:var(--b-default-grid-gap);grid-template-columns:var(--b-grid-template-col, repeat(var(--b-default-column-count), minmax(0, 1fr)));grid-template-rows:var(--b-grid-template-row, repeat(var(--b-grid-rows, 1), 1fr));inline-size:100%;margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xx-large)}.b-grid.b-full-bleed{max-inline-size:none}.b-grid.b-auto-fill{--b-grid-template-col: repeat(auto-fill, minmax(min(var(--b-grid-auto-fill, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-auto-fit{--b-grid-template-col: repeat(auto-fit, minmax(min(var(--b-grid-auto-fit, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-vertical-fill [class*=b-grid-item] :first-child:not([class*=b-grid-item] [beacon-tag-name] *){block-size:100%}@media (width >= 320px){[class*=b-grid-item].b-sm\\:order-1{order:1}[class*=b-grid-item].b-sm\\:order-2{order:2}[class*=b-grid-item].b-sm\\:order-3{order:3}[class*=b-grid-item].b-sm\\:order-4{order:4}[class*=b-grid-item].b-sm\\:order-5{order:5}[class*=b-grid-item].b-sm\\:order-6{order:6}[class*=b-grid-item].b-sm\\:order-7{order:7}[class*=b-grid-item].b-sm\\:order-8{order:8}[class*=b-grid-item].b-sm\\:order-9{order:9}[class*=b-grid-item].b-sm\\:order-10{order:10}[class*=b-grid-item].b-sm\\:order-11{order:11}[class*=b-grid-item].b-sm\\:order-12{order:12}[class*=b-grid-item].b-sm\\:order-13{order:13}[class*=b-grid-item].b-sm\\:order-14{order:14}[class*=b-grid-item].b-sm\\:order-15{order:15}[class*=b-grid-item].b-sm\\:order-16{order:16}[class*=b-grid-item].b-sm\\:order-17{order:17}[class*=b-grid-item].b-sm\\:order-18{order:18}[class*=b-grid-item].b-sm\\:order-19{order:19}[class*=b-grid-item].b-sm\\:order-20{order:20}}@media (width >= 640px){[class*=b-grid-item].b-md\\:order-1{order:1}[class*=b-grid-item].b-md\\:order-2{order:2}[class*=b-grid-item].b-md\\:order-3{order:3}[class*=b-grid-item].b-md\\:order-4{order:4}[class*=b-grid-item].b-md\\:order-5{order:5}[class*=b-grid-item].b-md\\:order-6{order:6}[class*=b-grid-item].b-md\\:order-7{order:7}[class*=b-grid-item].b-md\\:order-8{order:8}[class*=b-grid-item].b-md\\:order-9{order:9}[class*=b-grid-item].b-md\\:order-10{order:10}[class*=b-grid-item].b-md\\:order-11{order:11}[class*=b-grid-item].b-md\\:order-12{order:12}[class*=b-grid-item].b-md\\:order-13{order:13}[class*=b-grid-item].b-md\\:order-14{order:14}[class*=b-grid-item].b-md\\:order-15{order:15}[class*=b-grid-item].b-md\\:order-16{order:16}[class*=b-grid-item].b-md\\:order-17{order:17}[class*=b-grid-item].b-md\\:order-18{order:18}[class*=b-grid-item].b-md\\:order-19{order:19}[class*=b-grid-item].b-md\\:order-20{order:20}}@media (width >= 960px){[class*=b-grid-item].b-lg\\:order-1{order:1}[class*=b-grid-item].b-lg\\:order-2{order:2}[class*=b-grid-item].b-lg\\:order-3{order:3}[class*=b-grid-item].b-lg\\:order-4{order:4}[class*=b-grid-item].b-lg\\:order-5{order:5}[class*=b-grid-item].b-lg\\:order-6{order:6}[class*=b-grid-item].b-lg\\:order-7{order:7}[class*=b-grid-item].b-lg\\:order-8{order:8}[class*=b-grid-item].b-lg\\:order-9{order:9}[class*=b-grid-item].b-lg\\:order-10{order:10}[class*=b-grid-item].b-lg\\:order-11{order:11}[class*=b-grid-item].b-lg\\:order-12{order:12}[class*=b-grid-item].b-lg\\:order-13{order:13}[class*=b-grid-item].b-lg\\:order-14{order:14}[class*=b-grid-item].b-lg\\:order-15{order:15}[class*=b-grid-item].b-lg\\:order-16{order:16}[class*=b-grid-item].b-lg\\:order-17{order:17}[class*=b-grid-item].b-lg\\:order-18{order:18}[class*=b-grid-item].b-lg\\:order-19{order:19}[class*=b-grid-item].b-lg\\:order-20{order:20}}@media (width >= 1280px){[class*=b-grid-item].b-xl\\:order-1{order:1}[class*=b-grid-item].b-xl\\:order-2{order:2}[class*=b-grid-item].b-xl\\:order-3{order:3}[class*=b-grid-item].b-xl\\:order-4{order:4}[class*=b-grid-item].b-xl\\:order-5{order:5}[class*=b-grid-item].b-xl\\:order-6{order:6}[class*=b-grid-item].b-xl\\:order-7{order:7}[class*=b-grid-item].b-xl\\:order-8{order:8}[class*=b-grid-item].b-xl\\:order-9{order:9}[class*=b-grid-item].b-xl\\:order-10{order:10}[class*=b-grid-item].b-xl\\:order-11{order:11}[class*=b-grid-item].b-xl\\:order-12{order:12}[class*=b-grid-item].b-xl\\:order-13{order:13}[class*=b-grid-item].b-xl\\:order-14{order:14}[class*=b-grid-item].b-xl\\:order-15{order:15}[class*=b-grid-item].b-xl\\:order-16{order:16}[class*=b-grid-item].b-xl\\:order-17{order:17}[class*=b-grid-item].b-xl\\:order-18{order:18}[class*=b-grid-item].b-xl\\:order-19{order:19}[class*=b-grid-item].b-xl\\:order-20{order:20}}@media (width >= 1600px){[class*=b-grid-item].b-xxl\\:order-1{order:1}[class*=b-grid-item].b-xxl\\:order-2{order:2}[class*=b-grid-item].b-xxl\\:order-3{order:3}[class*=b-grid-item].b-xxl\\:order-4{order:4}[class*=b-grid-item].b-xxl\\:order-5{order:5}[class*=b-grid-item].b-xxl\\:order-6{order:6}[class*=b-grid-item].b-xxl\\:order-7{order:7}[class*=b-grid-item].b-xxl\\:order-8{order:8}[class*=b-grid-item].b-xxl\\:order-9{order:9}[class*=b-grid-item].b-xxl\\:order-10{order:10}[class*=b-grid-item].b-xxl\\:order-11{order:11}[class*=b-grid-item].b-xxl\\:order-12{order:12}[class*=b-grid-item].b-xxl\\:order-13{order:13}[class*=b-grid-item].b-xxl\\:order-14{order:14}[class*=b-grid-item].b-xxl\\:order-15{order:15}[class*=b-grid-item].b-xxl\\:order-16{order:16}[class*=b-grid-item].b-xxl\\:order-17{order:17}[class*=b-grid-item].b-xxl\\:order-18{order:18}[class*=b-grid-item].b-xxl\\:order-19{order:19}[class*=b-grid-item].b-xxl\\:order-20{order:20}}@media (width >= 1920px){[class*=b-grid-item].b-xxxl\\:order-1{order:1}[class*=b-grid-item].b-xxxl\\:order-2{order:2}[class*=b-grid-item].b-xxxl\\:order-3{order:3}[class*=b-grid-item].b-xxxl\\:order-4{order:4}[class*=b-grid-item].b-xxxl\\:order-5{order:5}[class*=b-grid-item].b-xxxl\\:order-6{order:6}[class*=b-grid-item].b-xxxl\\:order-7{order:7}[class*=b-grid-item].b-xxxl\\:order-8{order:8}[class*=b-grid-item].b-xxxl\\:order-9{order:9}[class*=b-grid-item].b-xxxl\\:order-10{order:10}[class*=b-grid-item].b-xxxl\\:order-11{order:11}[class*=b-grid-item].b-xxxl\\:order-12{order:12}[class*=b-grid-item].b-xxxl\\:order-13{order:13}[class*=b-grid-item].b-xxxl\\:order-14{order:14}[class*=b-grid-item].b-xxxl\\:order-15{order:15}[class*=b-grid-item].b-xxxl\\:order-16{order:16}[class*=b-grid-item].b-xxxl\\:order-17{order:17}[class*=b-grid-item].b-xxxl\\:order-18{order:18}[class*=b-grid-item].b-xxxl\\:order-19{order:19}[class*=b-grid-item].b-xxxl\\:order-20{order:20}}@media (width < 640px){[class*=b-grid-item].b-sm-only\\:order-1{order:1}[class*=b-grid-item].b-sm-only\\:order-2{order:2}[class*=b-grid-item].b-sm-only\\:order-3{order:3}[class*=b-grid-item].b-sm-only\\:order-4{order:4}[class*=b-grid-item].b-sm-only\\:order-5{order:5}[class*=b-grid-item].b-sm-only\\:order-6{order:6}[class*=b-grid-item].b-sm-only\\:order-7{order:7}[class*=b-grid-item].b-sm-only\\:order-8{order:8}[class*=b-grid-item].b-sm-only\\:order-9{order:9}[class*=b-grid-item].b-sm-only\\:order-10{order:10}[class*=b-grid-item].b-sm-only\\:order-11{order:11}[class*=b-grid-item].b-sm-only\\:order-12{order:12}[class*=b-grid-item].b-sm-only\\:order-13{order:13}[class*=b-grid-item].b-sm-only\\:order-14{order:14}[class*=b-grid-item].b-sm-only\\:order-15{order:15}[class*=b-grid-item].b-sm-only\\:order-16{order:16}[class*=b-grid-item].b-sm-only\\:order-17{order:17}[class*=b-grid-item].b-sm-only\\:order-18{order:18}[class*=b-grid-item].b-sm-only\\:order-19{order:19}[class*=b-grid-item].b-sm-only\\:order-20{order:20}}@media (640px <= width < 960px){[class*=b-grid-item].b-md-only\\:order-1{order:1}[class*=b-grid-item].b-md-only\\:order-2{order:2}[class*=b-grid-item].b-md-only\\:order-3{order:3}[class*=b-grid-item].b-md-only\\:order-4{order:4}[class*=b-grid-item].b-md-only\\:order-5{order:5}[class*=b-grid-item].b-md-only\\:order-6{order:6}[class*=b-grid-item].b-md-only\\:order-7{order:7}[class*=b-grid-item].b-md-only\\:order-8{order:8}[class*=b-grid-item].b-md-only\\:order-9{order:9}[class*=b-grid-item].b-md-only\\:order-10{order:10}[class*=b-grid-item].b-md-only\\:order-11{order:11}[class*=b-grid-item].b-md-only\\:order-12{order:12}[class*=b-grid-item].b-md-only\\:order-13{order:13}[class*=b-grid-item].b-md-only\\:order-14{order:14}[class*=b-grid-item].b-md-only\\:order-15{order:15}[class*=b-grid-item].b-md-only\\:order-16{order:16}[class*=b-grid-item].b-md-only\\:order-17{order:17}[class*=b-grid-item].b-md-only\\:order-18{order:18}[class*=b-grid-item].b-md-only\\:order-19{order:19}[class*=b-grid-item].b-md-only\\:order-20{order:20}}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item]{grid-column:var(--b-grid-start, auto)/span var(--b-grid-offset-column, var(--b-grid-span, 1))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--full-col{--b-grid-span: var(--b-default-column-count)}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item--offset]{--b-grid-offset-column: calc(var(--b-grid-offset) + var(--b-grid-offset-span));margin-inline-start:calc((100% + var(--b-default-grid-gap)) / (var(--b-grid-offset-span) + var(--b-grid-offset)) * var(--b-grid-offset))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--1-col{--b-grid-offset-span: 1;--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-1:not([class*=b-grid-item--offset]){--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--2-col{--b-grid-offset-span: 2;--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-2:not([class*=b-grid-item--offset]){--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--3-col{--b-grid-offset-span: 3;--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-3:not([class*=b-grid-item--offset]){--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--4-col{--b-grid-offset-span: 4;--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-4:not([class*=b-grid-item--offset]){--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--5-col{--b-grid-offset-span: 5;--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-5:not([class*=b-grid-item--offset]){--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--6-col{--b-grid-offset-span: 6;--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-6:not([class*=b-grid-item--offset]){--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--7-col{--b-grid-offset-span: 7;--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-7:not([class*=b-grid-item--offset]){--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--8-col{--b-grid-offset-span: 8;--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-8:not([class*=b-grid-item--offset]){--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--9-col{--b-grid-offset-span: 9;--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-9:not([class*=b-grid-item--offset]){--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--10-col{--b-grid-offset-span: 10;--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-10:not([class*=b-grid-item--offset]){--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--11-col{--b-grid-offset-span: 11;--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-11:not([class*=b-grid-item--offset]){--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--12-col{--b-grid-offset-span: 12;--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-12:not([class*=b-grid-item--offset]){--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-12{--b-grid-offset: 12}@media (width >= 320px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-12{--b-grid-offset: 12}}@media (width >= 640px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-12{--b-grid-offset: 12}}@media (width >= 960px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-12{--b-grid-offset: 12}}@media (width >= 1280px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1600px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1920px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1600px){:root{--beacon-grid-layout-space-margin: 10rem;--beacon-grid-gutter-size-inline: 2rem}}*,::slotted(*){margin:0}.zone{--fallback-grid-gap: var(--beacon-system-space-gutter);background-color:var(--zone-bg-color);padding-block:var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-maxi)}.zone--mission-and-links{--b-grid-gap: var(--footer-mission-zone-grid-gap);--zone-bg-color: var(--beacon-system-color-background-0)}.zone--disclaimer{--zone-bg-color: var(--beacon-system-color-background-1);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-100)}.brand-wrapper,.socials{--container-border: var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0)}.brand-wrapper{border-block-end:var(--container-border)}.brand,.disclaimer,.copyright{padding-block:var(--beacon-system-space-cell-free-floating)}.disclaimer,.copyright{padding-inline-end:var(--footer-disclaimer-content-padding-inline-end)}.trademark{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);letter-spacing:var(--beacon-reference-font-letter-spacing-trademark);text-transform:uppercase}.keyline{background-color:var(--beacon-system-color-border-brand);block-size:var(--beacon-system-width-border-normal);border:0;inline-size:var(--beacon-reference-space-7);margin-block:var(--beacon-reference-space-5)}.mission{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-300);color:var(--beacon-system-color-text-title);padding-block:var(--footer-mission-padding-block-start) var(--footer-mission-padding-block-end)}.links{display:flex;flex-direction:var(--links-flex-direction, column);gap:var(--footer-links-gap, 0);padding-block:var(--footer-links-padding-block)}.socials{border-block-start:var(--container-border);padding-block-start:var(--footer-socials-padding-block-start)}.hide{display:none}@media (width >= 960px){.links{--links-flex-direction: row}}`;
var z = Object.defineProperty, r$4 = (o2, e5, l4, B3) => {
  for (var i5 = void 0, b5 = o2.length - 1, d3; b5 >= 0; b5--)
    (d3 = o2[b5]) && (i5 = d3(e5, l4, i5) || i5);
  return i5 && z(e5, l4, i5), i5;
};
const c$4 = class c extends Bt$3 {
  constructor() {
    super(...arguments), this.beaconTagName = a$4.beaconTagName, this.showKeyline = false, this.hideBrandWrapper = true, this.dataMetricsLocation = a$4.metricsLocationFooter;
  }
  static get styles() {
    return [super.styles, w$2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, k$5, h$4];
  }
  checkForSlot() {
    this.showKeyline = !!this.slottedMissionContent.length && !!this.slottedTrademark.length, this.hideBrandWrapper = !this.slottedMissionContent.length && !this.slottedTrademark.length;
  }
  render() {
    return tt$1`<div class="zone zone--mission-and-links">
        <div class="b-grid">
          <div
            class="brand-wrapper b-grid b-grid-item--full-col ${this.hideBrandWrapper ? "hide" : ""}">
            <div class="brand b-grid-item--full-col b-md:10-col b-lg:8-col">
              <div class="trademark">
                <slot name="trademark" @slotchange=${this.checkForSlot}></slot>
              </div>
              <hr
                class=${this.showKeyline ? "keyline" : "hide"}
                aria-hidden="true" />
              <div class="mission">
                <slot name="mission" @slotchange=${this.checkForSlot}></slot>
              </div>
            </div>
          </div>
          <div class="links b-grid-item--full-col">
            <slot name="links" ${f$7({ useParent: true })}></slot>
          </div>
          <div class="socials b-grid-item--full-col">
            <slot name="socials" ${f$7({ useParent: true })}></slot>
          </div>
        </div>
      </div>
      <div class="zone zone--disclaimer">
        <div class="b-grid">
          <div class="disclaimer b-grid-item--full-col b-md:10-col b-lg:6-col">
            <slot name="disclaimer"></slot>
          </div>
          <div
            class="copyright b-grid-item--full-col b-md:10-col b-lg:5-col b-lg:start-8">
            <slot name="copyright"></slot>
          </div>
        </div>
      </div>`;
  }
};
c$4.tagName = a$4.beaconTagName;
let t$4 = c$4;
r$4([
  v$9({ flatten: true, slot: "mission" })
], t$4.prototype, "slottedMissionContent");
r$4([
  v$9({ flatten: true, slot: "trademark" })
], t$4.prototype, "slottedTrademark");
r$4([
  it()
], t$4.prototype, "showKeyline");
r$4([
  it()
], t$4.prototype, "hideBrandWrapper");
r$4([
  v$c({ attribute: "data-metrics-location", reflect: true })
], t$4.prototype, "dataMetricsLocation");
const T$3 = (o2) => (Se$3(o2, t$4), Dt$3({
  tagName: o2 ? o2 + "-" + t$4.tagName : t$4.tagName,
  elementClass: t$4,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const l$3 = T$7`[beacon-tag-name=beacon-navigation-footer] a,[beacon-tag-name=beacon-navigation-footer] li{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-navigation-footer] a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-navigation-footer] a:not(:hover,:focus){text-decoration:none}[beacon-tag-name=beacon-navigation-footer]:not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-block-end:var(--beacon-system-space-micro-jumbo)}@media (width >= 960px){[beacon-tag-name=beacon-navigation-footer]:not(:last-of-type){border-block-end:0;padding-block-end:0}}[beacon-tag-name=beacon-navigation-footer] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}`, b$7 = T$7`::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}`, n$5 = class n2 extends G$2 {
  constructor() {
    super(...arguments), this.beaconTagName = $$3.beaconFooterNavTagName;
  }
  static get styles() {
    return [super.styles, b$7];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, l$3];
  }
  setLevel() {
    this.level = 2;
  }
  setLevel2GridTemplate() {
    this.style.setProperty("--expanded-nav-grid-template", "1");
  }
};
n$5.tagName = $$3.beaconFooterNavTagName;
let t$3 = n$5;
const v$3 = (e5) => (Se$3(e5, t$3), Dt$3({
  tagName: e5 ? e5 + "-" + t$3.tagName : t$3.tagName,
  elementClass: t$3,
  react: React,
  events: {}
}));
const v$2 = T$7`:root[beacon-tag-name=beacon-social-link-container],:root [beacon-tag-name=beacon-social-link-container],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-social-link-container],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-social-link-container],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link-container],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-social-link-container],[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link-container],[beacon-version="4.2.2"] [beacon-tag-name=beacon-social-link-container]{--social-link-container-flex-gap: var(--beacon-reference-space-2);--social-link-container-links-gap: var(--beacon-reference-space-2)}@media (width >= 960px){:root[beacon-tag-name=beacon-social-link-container],:root [beacon-tag-name=beacon-social-link-container],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-social-link-container],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-social-link-container],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link-container],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-social-link-container],[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link-container],[beacon-version="4.2.2"] [beacon-tag-name=beacon-social-link-container]{--social-link-container-flex-gap: var(--beacon-reference-space-6);--social-link-container-links-gap: var(--beacon-reference-space-7)}}`, o$1 = {
  beaconTagName: "beacon-social-link-container"
}, m$3 = T$7`:host,.links,.links ::slotted(ul){display:flex;flex-direction:var(--container-flex-direction, column);gap:var(--container-flex-gap)}:host{--container-flex-gap: var(--social-link-container-flex-gap)}.links{--container-flex-gap: var(--social-link-container-links-gap)}::slotted(*){margin:0}.text ::slotted([slot=text]){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)!important;margin-block:var(--social-link-container-text-margin-block-start, 0) var(--social-link-container-text-margin-block-end, 0)!important;padding-block:var(--beacon-system-space-cell-free-floating)!important}@media (width >= 960px){:host,.links{--container-flex-direction: row;align-items:center}}`, c$3 = class c2 extends Bt$3 {
  constructor() {
    super(...arguments), this.beaconTagName = o$1.beaconTagName;
  }
  static get styles() {
    return [super.styles, m$3];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, v$2];
  }
  render() {
    return tt$1`<div class="text">
        <slot name="text"></slot>
      </div>
      <div class="links">
        <slot @slotchange=${i$1()}></slot>
      </div>`;
  }
};
c$3.tagName = o$1.beaconTagName;
let n$4 = c$3;
const p = (e5) => (Se$3(e5, n$4), Dt$3({
  tagName: e5 ? e5 + "-" + n$4.tagName : n$4.tagName,
  elementClass: n$4,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const R$1 = T$7`:root[beacon-tag-name=beacon-social-link],:root [beacon-tag-name=beacon-social-link],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-social-link],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-social-link],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-social-link],[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[beacon-version="4.2.2"] [beacon-tag-name=beacon-social-link]{--social-link-flex-gap: var(--beacon-reference-space-3);--social-link-icon-container-size: var(--beacon-reference-space-5)}@media (width >= 960px){:root[beacon-tag-name=beacon-social-link],:root [beacon-tag-name=beacon-social-link],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-social-link],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-social-link],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-social-link],[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[beacon-version="4.2.2"] [beacon-tag-name=beacon-social-link]{--social-link-flex-gap: var(--beacon-reference-space-2);--social-link-icon-container-size: var(--beacon-reference-space-7)}}[beacon-tag-name=beacon-social-link]{--social-link-icon-instagram-pattern-url-heritage: url(#pattern0)}`, B$1 = {
  beaconTagName: "beacon-social-link",
  iconMap: /* @__PURE__ */ new Map([
    [
      "facebook",
      tt$1`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <g clip-path="url(#clip0_2188_14217)">
          <path
            d="M16 8C16 3.58172 12.4183 -9.53674e-07 8 -9.53674e-07C3.58172 -9.53674e-07 0 3.58172 0 8C0 11.993 2.92548 15.3027 6.75 15.9028V10.3125H4.71875V8H6.75V6.2375C6.75 4.2325 7.94434 3.125 9.77172 3.125C10.647 3.125 11.5625 3.28125 11.5625 3.28125V5.25H10.5537C9.55992 5.25 9.25 5.86667 9.25 6.49933V8H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.993 16 8Z"
            fill="var(--social-link-facebook-color-fill-outside)" />
          <path
            d="M11.1141 10.3125L11.4688 8H9.25V6.49933C9.25 5.86667 9.55992 5.25 10.5537 5.25H11.5625V3.28125C11.5625 3.28125 10.647 3.125 9.77172 3.125C7.94434 3.125 6.75 4.2325 6.75 6.2375V8H4.71875V10.3125H6.75V15.9028C7.1573 15.9667 7.57475 16 8 16C8.42525 16 8.8427 15.9667 9.25 15.9028V10.3125H11.1141Z"
            fill="var(--social-link-facebook-color-fill-inside)" />
        </g>
        <defs>
          <clipPath id="clip0_2188_14217">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>`
    ],
    [
      "twitter",
      tt$1`<svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <g clip-path="url(#clip0_2188_14227)">
          <path
            d="M14.3193 3.72903C14.329 3.86903 14.329 4.00903 14.329 4.15032C14.329 8.45548 11.0515 13.4206 5.05865 13.4206V13.4181C3.28832 13.4206 1.55478 12.9135 0.0644531 11.9574C0.321872 11.9884 0.580582 12.0039 0.839937 12.0045C2.30703 12.0058 3.73219 11.5135 4.88639 10.6071C3.49219 10.5806 2.26961 9.67161 1.84252 8.34451C2.3309 8.43871 2.83413 8.41935 3.31349 8.28838C1.79349 7.98129 0.699937 6.6458 0.699937 5.09484C0.699937 5.08064 0.699937 5.06709 0.699937 5.05354C1.15284 5.3058 1.65994 5.4458 2.17865 5.46129C0.747034 4.50451 0.305743 2.6 1.17026 1.11096C2.82445 3.14645 5.2651 4.38387 7.8851 4.51484C7.62252 3.38322 7.98123 2.19742 8.82768 1.40193C10.1399 0.168384 12.2038 0.23161 13.4374 1.54322C14.167 1.39935 14.8664 1.13161 15.5064 0.752255C15.2632 1.50645 14.7541 2.14709 14.0741 2.55419C14.7199 2.47806 15.3509 2.30516 15.9451 2.04129C15.5077 2.69677 14.9567 3.26774 14.3193 3.72903Z"
            fill="var(--social-link-twitter-color-fill)" />
        </g>
        <defs>
          <clipPath id="clip0_2188_14227">
            <rect
              width="16"
              height="13.1613"
              fill="white"
              transform="translate(0 0.419998)" />
          </clipPath>
        </defs>
      </svg>`
    ],
    [
      "linkedin",
      tt$1`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <path
          d="M14.8189 0H1.18111C0.867861 0 0.567441 0.124438 0.34594 0.34594C0.124438 0.567441 0 0.867861 0 1.18111V14.8189C0 15.1321 0.124438 15.4326 0.34594 15.6541C0.567441 15.8756 0.867861 16 1.18111 16H14.8189C15.1321 16 15.4326 15.8756 15.6541 15.6541C15.8756 15.4326 16 15.1321 16 14.8189V1.18111C16 0.867861 15.8756 0.567441 15.6541 0.34594C15.4326 0.124438 15.1321 0 14.8189 0ZM4.76889 13.63H2.36333V5.98889H4.76889V13.63ZM3.56445 4.93C3.29158 4.92846 3.02528 4.84613 2.79916 4.69339C2.57304 4.54065 2.39723 4.32435 2.29392 4.07179C2.19061 3.81923 2.16443 3.54173 2.21869 3.2743C2.27294 3.00688 2.4052 2.76152 2.59877 2.56919C2.79234 2.37686 3.03854 2.24618 3.30631 2.19364C3.57408 2.1411 3.85141 2.16906 4.1033 2.27399C4.35519 2.37892 4.57036 2.55611 4.72164 2.78321C4.87293 3.01031 4.95355 3.27713 4.95333 3.55C4.95591 3.73269 4.92167 3.91403 4.85267 4.0832C4.78368 4.25238 4.68132 4.40593 4.55171 4.53471C4.42211 4.66349 4.2679 4.76486 4.09828 4.83277C3.92867 4.90068 3.74711 4.93375 3.56445 4.93ZM13.6356 13.6367H11.2311V9.46222C11.2311 8.23111 10.7078 7.85111 10.0322 7.85111C9.31889 7.85111 8.61889 8.38889 8.61889 9.49333V13.6367H6.21333V5.99445H8.52667V7.05333H8.55778C8.79 6.58333 9.60333 5.78 10.8444 5.78C12.1867 5.78 13.6367 6.57667 13.6367 8.91L13.6356 13.6367Z"
          fill="var(--social-link-linkedin-color-fill)" />
      </svg>`
    ],
    [
      "youtube",
      tt$1`<svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <path
          d="M15.6656 2.14892C15.4816 1.46055 14.9395 0.918356 14.2511 0.73438C13.0033 0.400024 7.99996 0.400023 7.99996 0.400023C7.99996 0.400023 2.99666 0.400024 1.74888 0.73438C1.06052 0.918356 0.518326 1.46055 0.334352 2.14892C0 3.3967 0 6 0 6C0 6 0 8.60341 0.334352 9.85115C0.518326 10.5395 1.06052 11.0817 1.74888 11.2656C2.99666 11.6001 7.99996 11.6001 7.99996 11.6001C7.99996 11.6001 13.0033 11.6001 14.2511 11.2656C14.9395 11.0817 15.4816 10.5395 15.6656 9.85115C16 8.60341 16 6 16 6C16 6 16 3.3967 15.6656 2.14892Z"
          fill="var(--social-link-youtube-color-fill-outside)" />
        <path
          d="M6.40039 8.40002L10.5572 6.00004L6.40039 3.6V8.40002Z"
          fill="var(--social-link-youtube-color-fill-inside)" />
      </svg>`
    ],
    [
      "x",
      tt$1`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <g clip-path="url(#clip0_1286_254)">
          <path
            d="M9.48734 6.77491L15.3156 0H13.9345L8.87381 5.88256L4.83185 0H0.169922L6.28217 8.89547L0.169922 16H1.55112L6.89534 9.78782L11.164 16H15.8259L9.48701 6.77491H9.48734ZM7.59561 8.97384L6.97631 8.08805L2.04878 1.03974H4.17022L8.14679 6.72795L8.76609 7.61374L13.9352 15.0075H11.8137L7.59561 8.97418V8.97384Z"
            fill="var(--social-link-x-color-fill)" />
        </g>
        <defs>
          <clipPath id="clip0_1286_254">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>`
    ],
    [
      "instagram",
      tt$1`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        aria-hidden="true">
        <g clip-path="url(#clip0_2188_14249)">
          <mask
            id="mask0_2188_14249"
            style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="16"
            height="16">
            <path
              d="M4.70349 0.0949238C3.85651 0.1349 3.27802 0.270564 2.77251 0.468642C2.24921 0.672648 1.80561 0.946046 1.36433 1.38914C0.922524 1.83249 0.651202 2.27688 0.448748 2.8007C0.252733 3.3075 0.119906 3.88627 0.0825045 4.73377C0.0453702 5.58283 0.0368544 5.85363 0.0409937 8.01522C0.045117 10.1765 0.0546566 10.4479 0.0951453 11.2972C0.135632 12.1439 0.27079 12.7222 0.468867 13.2279C0.673131 13.7512 0.946248 14.1946 1.38959 14.6361C1.83269 15.0777 2.27733 15.3488 2.8014 15.5515C3.30768 15.7472 3.88669 15.8806 4.73393 15.9177C5.58298 15.9551 5.85403 15.9634 8.01507 15.9592C10.1771 15.9551 10.4482 15.9456 11.2972 15.9053C12.1442 15.8648 12.7222 15.7292 13.2282 15.5316C13.7515 15.3268 14.1951 15.0542 14.6364 14.6109C15.0777 14.1678 15.349 13.7231 15.5515 13.199C15.7475 12.6927 15.8808 12.1137 15.9177 11.267C15.9549 10.4174 15.9636 10.1461 15.9595 7.98478C15.9554 5.8232 15.9456 5.55239 15.9053 4.7036C15.8651 3.85609 15.7294 3.27811 15.5316 2.77208C15.3271 2.24877 15.0542 1.80567 14.6111 1.36387C14.1681 0.922574 13.7234 0.650729 13.1993 0.448785C12.6928 0.252768 12.1141 0.119166 11.2668 0.0825425C10.4178 0.0448876 10.1467 0.0366393 7.9849 0.0407642C5.8236 0.0448892 5.55255 0.0541772 4.70349 0.0949238ZM4.79635 14.485C4.02029 14.4512 3.59887 14.3222 3.31801 14.2142C2.94609 14.0703 2.68071 13.8977 2.40139 13.6205C2.12259 13.3422 1.94952 13.0776 1.80432 12.7064C1.69522 12.4255 1.56395 12.0046 1.52758 11.2286C1.48812 10.3896 1.4791 10.1378 1.47523 8.01237C1.4711 5.88742 1.47883 5.63569 1.51546 4.79593C1.54873 4.02038 1.67847 3.59843 1.78627 3.31782C1.93017 2.94539 2.1022 2.68051 2.37998 2.4012C2.65826 2.12187 2.92287 1.94933 3.29427 1.80412C3.57488 1.6945 3.99579 1.56426 4.77159 1.52738C5.61109 1.48766 5.86255 1.47915 7.98747 1.47502C10.1129 1.47089 10.3646 1.47838 11.2044 1.51526C11.9799 1.54904 12.4019 1.67749 12.6822 1.78607C13.0544 1.92998 13.3198 2.1015 13.5988 2.37979C13.8779 2.65808 14.051 2.92218 14.1962 3.29435C14.3058 3.57418 14.436 3.99562 14.4726 4.77117C14.5126 5.61068 14.5217 5.8624 14.5255 7.98736C14.5296 10.1128 14.5219 10.3646 14.485 11.2038C14.4512 11.9799 14.3225 12.4016 14.2142 12.6827C14.0703 13.0543 13.8983 13.3197 13.6202 13.5991C13.3422 13.8773 13.0776 14.0509 12.706 14.1961C12.4259 14.3055 12.0044 14.436 11.2292 14.4729C10.3897 14.5123 10.1382 14.5214 8.01249 14.5252C5.88756 14.5294 5.6361 14.5214 4.79635 14.485ZM11.2856 3.74493C11.2867 4.27211 11.7153 4.69896 12.2425 4.69792C12.7699 4.69689 13.1968 4.2685 13.196 3.74132C13.195 3.21414 12.7663 2.78704 12.2389 2.78807C11.7115 2.7891 11.2846 3.21775 11.2856 3.74493ZM3.91301 8.00773C3.91739 10.2653 5.75088 12.0913 8.00785 12.0869C10.2651 12.0825 12.0921 10.2495 12.0877 7.99201C12.0834 5.73526 10.2496 3.90819 7.99212 3.91257C5.73513 3.91696 3.90862 5.75073 3.91301 8.00773ZM5.34673 8.0049C5.34414 6.53969 6.53002 5.34942 7.99496 5.34683C9.46015 5.344 10.6507 6.52937 10.6535 7.99484C10.6563 9.46031 9.47047 10.6503 8.00501 10.6532C6.54008 10.656 5.34956 9.47037 5.34673 8.0049Z"
              fill="white" />
          </mask>
          <g mask="url(#mask0_2188_14249)">
            <mask
              id="mask1_2188_14249"
              style="mask-type:luminance"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="18"
              height="18">
              <path
                d="M16.5905 -0.583628H-0.603516V16.6106H16.5905V-0.583628Z"
                fill="white" />
            </mask>
            <g mask="url(#mask1_2188_14249)">
              <mask
                id="mask2_2188_14249"
                style="mask-type:luminance"
                maskUnits="userSpaceOnUse"
                x="-1"
                y="-1"
                width="18"
                height="18">
                <path
                  d="M16.6696 -0.663237H-0.683594V16.6902H16.6696V-0.663237Z"
                  fill="white" />
              </mask>
              <g mask="url(#mask2_2188_14249)">
                <mask
                  id="mask3_2188_14249"
                  style="mask-type:luminance"
                  maskUnits="userSpaceOnUse"
                  x="-1"
                  y="-1"
                  width="18"
                  height="18">
                  <path
                    d="M16.6696 -0.663237H-0.683594V16.6902H16.6696V-0.663237Z"
                    fill="white" />
                </mask>
                <g mask="url(#mask3_2188_14249)">
                  <rect
                    x="-0.689453"
                    y="-0.665792"
                    width="17.3622"
                    height="17.3622"
                    fill="var(--social-link-instagram-color-fill)" />
                </g>
              </g>
            </g>
          </g>
        </g>
        <defs>
          <pattern
            id="pattern0"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1">
            <use
              xlink:href="#image0_2188_14249"
              transform="scale(0.000439947)" />
          </pattern>
          <clipPath id="clip0_2188_14249">
            <rect width="16" height="16" fill="white" />
          </clipPath>
          <image
            id="image0_2188_14249"
            width="2273"
            height="2275"
            xlink:href="data:image/jpeg;base64,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" />
        </defs>
      </svg>`
    ]
  ])
}, r$3 = T$7`[beacon-tag-name=beacon-social-link]{padding-block:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-social-link] a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-social-link] a:not(:hover,:focus){text-decoration:none}`, L$2 = T$7`:root,.beacon-on-light,.beacon-on-light [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],.beacon-on-light[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-light [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-light[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link]{--social-link-facebook-color-fill-inside: #fff;--social-link-facebook-color-fill-outside: #1877f2;--social-link-instagram-color-fill: url(#pattern0);--social-link-linkedin-color-fill: #0a66c2;--social-link-twitter-color-fill: #1d9bf0;--social-link-x-color-fill: #000;--social-link-youtube-color-fill-inside: #fff;--social-link-youtube-color-fill-outside: #ed1d24}.beacon-on-lighter,.beacon-on-lighter [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],.beacon-on-lighter[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-lighter [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-lighter[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link]{--social-link-facebook-color-fill-inside: #fff;--social-link-facebook-color-fill-outside: #1877f2;--social-link-instagram-color-fill: url(#pattern0);--social-link-linkedin-color-fill: #0a66c2;--social-link-twitter-color-fill: #1d9bf0;--social-link-x-color-fill: #000;--social-link-youtube-color-fill-inside: #fff;--social-link-youtube-color-fill-outside: #ed1d24}.beacon-on-dark,.beacon-on-dark [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],.beacon-on-dark[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-dark [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-dark[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],.beacon-on-darker,.beacon-on-darker [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],.beacon-on-darker[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-darker [beacon-version="4.2.2"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-darker[beacon-version="4.2.2"][beacon-tag-name=beacon-social-link]{--social-link-facebook-color-fill-inside: none;--social-link-facebook-color-fill-outside: #fff;--social-link-instagram-color-fill: #fff;--social-link-linkedin-color-fill: #fff;--social-link-twitter-color-fill: #fff;--social-link-x-color-fill: #fff;--social-link-youtube-color-fill-inside: #253746;--social-link-youtube-color-fill-outside: #fff}`, S$4 = T$7`:host{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);align-items:center;display:flex;gap:var(--social-link-flex-gap)}.icon-slot{--icon-container-size: var(--social-link-icon-container-size);block-size:var(--icon-container-size);display:flex;inline-size:var(--icon-container-size)}.icon-slot svg{--icon-size: var(--beacon-reference-space-5);block-size:var(--icon-size);inline-size:var(--icon-size);margin:auto}`;
var k$4 = Object.defineProperty, h$3 = Object.getOwnPropertyDescriptor, l$2 = (s2, A3, a2, c4) => {
  for (var i5 = c4 > 1 ? void 0 : c4 ? h$3(A3, a2) : A3, K2 = s2.length - 1, g2; K2 >= 0; K2--)
    (g2 = s2[K2]) && (i5 = (c4 ? g2(A3, a2, i5) : g2(i5)) || i5);
  return c4 && i5 && k$4(A3, a2, i5), i5;
};
const C$3 = class C extends Bt$3 {
  constructor() {
    super(...arguments), this.beaconTagName = B$1.beaconTagName, this.componentModeStyles = [L$2], this.icon = tt$1``;
  }
  static get styles() {
    return [super.styles, S$4];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, R$1, r$3];
  }
  /** The textContent of the first element in the title nodes. */
  get nameElementText() {
    var A3;
    if (this.nameNodes.length < 1)
      return console.warn("No text found in the default slot."), "";
    const a2 = Array.from(this.nameNodes).find(
      (c4) => c4.nodeName === "A"
    );
    return (A3 = a2 == null ? void 0 : a2.textContent) != null ? A3 : "";
  }
  /**
   * Renders the appropriate icon based on the text passed into the name slot.
   *
   * If the name can't be matched, no icon is rendered.
   */
  renderIcon() {
    const A3 = this.nameElementText.toLowerCase(), a2 = B$1.iconMap.get(A3);
    this.icon = a2 || tt$1``;
  }
  postrenderMethods() {
    this.renderIcon(), this.renderComponentModeStyles();
  }
  render() {
    return tt$1` <div class="icon-slot">
        <slot name="icon">${this.icon}</slot>
      </div>
      <div class="name">
        <slot></slot>
      </div>`;
  }
};
C$3.tagName = B$1.beaconTagName;
let n$3 = C$3;
l$2([
  it()
], n$3.prototype, "icon", 2);
l$2([
  a$8()
], n$3.prototype, "nameNodes", 2);
l$2([
  h$9(".icon-slot")
], n$3.prototype, "iconSlot", 2);
l$2([
  d$e
], n$3.prototype, "postrenderMethods", 1);
const V$1 = (s2) => (Se$3(s2, n$3), Dt$3({
  tagName: s2 ? s2 + "-" + n$3.tagName : n$3.tagName,
  elementClass: n$3,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const d$5 = {
  beaconTagName: "beacon-country-selector"
}, S$3 = T$7`[beacon-tag-name=beacon-country-selector] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}[beacon-tag-name=beacon-country-selector] [slot=title] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}[beacon-tag-name=beacon-country-selector] [beacon-tag-name=beacon-region-selector]{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-start:var(--beacon-system-space-micro-jumbo)}@media (width >= 960px){[beacon-tag-name=beacon-country-selector] [beacon-tag-name=beacon-region-selector]{padding-block-start:var(--beacon-reference-space-9)}}`, k$3 = T$7`:host{display:grid;gap:var(--beacon-system-space-micro-jumbo);inline-size:100%}@media (width >= 960px){:host{gap:var(--beacon-reference-space-9)}}.current-selection{display:grid;gap:var(--beacon-system-space-micro-normal)}.current{padding-block:var(--beacon-system-space-cell-free-floating)}.current :is(h1,h2,h3,h4,h5,h6),.current ::slotted(*){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50);color:var(--beacon-system-color-text-title);margin:0}@media (width >= 960px){a,::slotted(a){color:var(--beacon-system-color-text-link)}}`;
var x$3 = Object.defineProperty, A$4 = Object.getOwnPropertyDescriptor, c$2 = (t3, o2, r3, a2) => {
  for (var n4 = a2 > 1 ? void 0 : a2 ? A$4(o2, r3) : o2, s2 = t3.length - 1, i5; s2 >= 0; s2--)
    (i5 = t3[s2]) && (n4 = (a2 ? i5(o2, r3, n4) : i5(n4)) || n4);
  return a2 && n4 && x$3(o2, r3, n4), n4;
};
const b$6 = class b2 extends B$5(Bt$3).with(
  N$5({ skipFirstUpdated: false })
) {
  constructor() {
    super(...arguments), this.beaconTagName = d$5.beaconTagName, this.expanded = false, this.setSelectedCountry = ({ detail: o2 }) => {
      if (!this.selectedCountry) {
        const r3 = o2.country.cloneNode(true);
        this.selectedCountry = r3, this.selectedCountry.isExpanded = true, this.selectedCountry.setAttribute("slot", "current-country"), this.appendChild(this.selectedCountry);
      }
    };
  }
  static get styles() {
    return [super.styles, k$3];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, S$3];
  }
  countrySelectorPrerender() {
    this.addEventListener(
      g$a.NAV_LANGUAGE_SELECT,
      this.setSelectedCountry
    );
  }
  updateAnalytics() {
    super.updateAnalytics(), this.metricsSection = L$4.level2LangSelector;
  }
  render() {
    return tt$1`
      <div class="current-selection">
        <div class="current">
          <slot name="title"><h3>Current selection</h3></slot>
        </div>
        <slot name="current-country"></slot>
      </div>
      <slot class="regions"></slot>
    `;
  }
};
b$6.tagName = d$5.beaconTagName;
let e$2 = b$6;
c$2([
  v$9(
    { selector: "beacon-region-selector", flatten: true },
    true
  )
], e$2.prototype, "regions", 2);
c$2([
  v$c({ type: Boolean, reflect: true })
], e$2.prototype, "expanded", 2);
c$2([
  it()
], e$2.prototype, "selectedCountry", 2);
c$2([
  u$2
], e$2.prototype, "countrySelectorPrerender", 1);
const D$2 = (t3) => (Se$3(t3, e$2), Dt$3({
  tagName: t3 ? t3 + "-" + e$2.tagName : e$2.tagName,
  elementClass: e$2,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const b$5 = {
  beaconTagName: "beacon-region-selector"
}, f$1 = T$7`[beacon-tag-name=beacon-region-selector]{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-start:var(--beacon-system-space-micro-jumbo)}[beacon-tag-name=beacon-region-selector] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}[beacon-tag-name=beacon-region-selector] [slot=title] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}@media (width >= 960px){[beacon-tag-name=beacon-region-selector]{padding-block-start:var(--beacon-reference-space-9)}}`, g = T$7`.b-grid{--b-default-auto-layout: calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns));--b-default-grid-gap: var(--b-grid-gap, var(--beacon-system-space-gutter));--b-default-column-count: var(--b-grid-columns, var(--beacon-system-grid-columns));display:grid;gap:var(--b-default-grid-gap);grid-template-columns:var(--b-grid-template-col, repeat(var(--b-default-column-count), minmax(0, 1fr)));grid-template-rows:var(--b-grid-template-row, repeat(var(--b-grid-rows, 1), 1fr));inline-size:100%;margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xx-large)}.b-grid.b-full-bleed{max-inline-size:none}.b-grid.b-auto-fill{--b-grid-template-col: repeat(auto-fill, minmax(min(var(--b-grid-auto-fill, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-auto-fit{--b-grid-template-col: repeat(auto-fit, minmax(min(var(--b-grid-auto-fit, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-vertical-fill [class*=b-grid-item] :first-child:not([class*=b-grid-item] [beacon-tag-name] *){block-size:100%}@media (width >= 320px){[class*=b-grid-item].b-sm\\:order-1{order:1}[class*=b-grid-item].b-sm\\:order-2{order:2}[class*=b-grid-item].b-sm\\:order-3{order:3}[class*=b-grid-item].b-sm\\:order-4{order:4}[class*=b-grid-item].b-sm\\:order-5{order:5}[class*=b-grid-item].b-sm\\:order-6{order:6}[class*=b-grid-item].b-sm\\:order-7{order:7}[class*=b-grid-item].b-sm\\:order-8{order:8}[class*=b-grid-item].b-sm\\:order-9{order:9}[class*=b-grid-item].b-sm\\:order-10{order:10}[class*=b-grid-item].b-sm\\:order-11{order:11}[class*=b-grid-item].b-sm\\:order-12{order:12}[class*=b-grid-item].b-sm\\:order-13{order:13}[class*=b-grid-item].b-sm\\:order-14{order:14}[class*=b-grid-item].b-sm\\:order-15{order:15}[class*=b-grid-item].b-sm\\:order-16{order:16}[class*=b-grid-item].b-sm\\:order-17{order:17}[class*=b-grid-item].b-sm\\:order-18{order:18}[class*=b-grid-item].b-sm\\:order-19{order:19}[class*=b-grid-item].b-sm\\:order-20{order:20}}@media (width >= 640px){[class*=b-grid-item].b-md\\:order-1{order:1}[class*=b-grid-item].b-md\\:order-2{order:2}[class*=b-grid-item].b-md\\:order-3{order:3}[class*=b-grid-item].b-md\\:order-4{order:4}[class*=b-grid-item].b-md\\:order-5{order:5}[class*=b-grid-item].b-md\\:order-6{order:6}[class*=b-grid-item].b-md\\:order-7{order:7}[class*=b-grid-item].b-md\\:order-8{order:8}[class*=b-grid-item].b-md\\:order-9{order:9}[class*=b-grid-item].b-md\\:order-10{order:10}[class*=b-grid-item].b-md\\:order-11{order:11}[class*=b-grid-item].b-md\\:order-12{order:12}[class*=b-grid-item].b-md\\:order-13{order:13}[class*=b-grid-item].b-md\\:order-14{order:14}[class*=b-grid-item].b-md\\:order-15{order:15}[class*=b-grid-item].b-md\\:order-16{order:16}[class*=b-grid-item].b-md\\:order-17{order:17}[class*=b-grid-item].b-md\\:order-18{order:18}[class*=b-grid-item].b-md\\:order-19{order:19}[class*=b-grid-item].b-md\\:order-20{order:20}}@media (width >= 960px){[class*=b-grid-item].b-lg\\:order-1{order:1}[class*=b-grid-item].b-lg\\:order-2{order:2}[class*=b-grid-item].b-lg\\:order-3{order:3}[class*=b-grid-item].b-lg\\:order-4{order:4}[class*=b-grid-item].b-lg\\:order-5{order:5}[class*=b-grid-item].b-lg\\:order-6{order:6}[class*=b-grid-item].b-lg\\:order-7{order:7}[class*=b-grid-item].b-lg\\:order-8{order:8}[class*=b-grid-item].b-lg\\:order-9{order:9}[class*=b-grid-item].b-lg\\:order-10{order:10}[class*=b-grid-item].b-lg\\:order-11{order:11}[class*=b-grid-item].b-lg\\:order-12{order:12}[class*=b-grid-item].b-lg\\:order-13{order:13}[class*=b-grid-item].b-lg\\:order-14{order:14}[class*=b-grid-item].b-lg\\:order-15{order:15}[class*=b-grid-item].b-lg\\:order-16{order:16}[class*=b-grid-item].b-lg\\:order-17{order:17}[class*=b-grid-item].b-lg\\:order-18{order:18}[class*=b-grid-item].b-lg\\:order-19{order:19}[class*=b-grid-item].b-lg\\:order-20{order:20}}@media (width >= 1280px){[class*=b-grid-item].b-xl\\:order-1{order:1}[class*=b-grid-item].b-xl\\:order-2{order:2}[class*=b-grid-item].b-xl\\:order-3{order:3}[class*=b-grid-item].b-xl\\:order-4{order:4}[class*=b-grid-item].b-xl\\:order-5{order:5}[class*=b-grid-item].b-xl\\:order-6{order:6}[class*=b-grid-item].b-xl\\:order-7{order:7}[class*=b-grid-item].b-xl\\:order-8{order:8}[class*=b-grid-item].b-xl\\:order-9{order:9}[class*=b-grid-item].b-xl\\:order-10{order:10}[class*=b-grid-item].b-xl\\:order-11{order:11}[class*=b-grid-item].b-xl\\:order-12{order:12}[class*=b-grid-item].b-xl\\:order-13{order:13}[class*=b-grid-item].b-xl\\:order-14{order:14}[class*=b-grid-item].b-xl\\:order-15{order:15}[class*=b-grid-item].b-xl\\:order-16{order:16}[class*=b-grid-item].b-xl\\:order-17{order:17}[class*=b-grid-item].b-xl\\:order-18{order:18}[class*=b-grid-item].b-xl\\:order-19{order:19}[class*=b-grid-item].b-xl\\:order-20{order:20}}@media (width >= 1600px){[class*=b-grid-item].b-xxl\\:order-1{order:1}[class*=b-grid-item].b-xxl\\:order-2{order:2}[class*=b-grid-item].b-xxl\\:order-3{order:3}[class*=b-grid-item].b-xxl\\:order-4{order:4}[class*=b-grid-item].b-xxl\\:order-5{order:5}[class*=b-grid-item].b-xxl\\:order-6{order:6}[class*=b-grid-item].b-xxl\\:order-7{order:7}[class*=b-grid-item].b-xxl\\:order-8{order:8}[class*=b-grid-item].b-xxl\\:order-9{order:9}[class*=b-grid-item].b-xxl\\:order-10{order:10}[class*=b-grid-item].b-xxl\\:order-11{order:11}[class*=b-grid-item].b-xxl\\:order-12{order:12}[class*=b-grid-item].b-xxl\\:order-13{order:13}[class*=b-grid-item].b-xxl\\:order-14{order:14}[class*=b-grid-item].b-xxl\\:order-15{order:15}[class*=b-grid-item].b-xxl\\:order-16{order:16}[class*=b-grid-item].b-xxl\\:order-17{order:17}[class*=b-grid-item].b-xxl\\:order-18{order:18}[class*=b-grid-item].b-xxl\\:order-19{order:19}[class*=b-grid-item].b-xxl\\:order-20{order:20}}@media (width >= 1920px){[class*=b-grid-item].b-xxxl\\:order-1{order:1}[class*=b-grid-item].b-xxxl\\:order-2{order:2}[class*=b-grid-item].b-xxxl\\:order-3{order:3}[class*=b-grid-item].b-xxxl\\:order-4{order:4}[class*=b-grid-item].b-xxxl\\:order-5{order:5}[class*=b-grid-item].b-xxxl\\:order-6{order:6}[class*=b-grid-item].b-xxxl\\:order-7{order:7}[class*=b-grid-item].b-xxxl\\:order-8{order:8}[class*=b-grid-item].b-xxxl\\:order-9{order:9}[class*=b-grid-item].b-xxxl\\:order-10{order:10}[class*=b-grid-item].b-xxxl\\:order-11{order:11}[class*=b-grid-item].b-xxxl\\:order-12{order:12}[class*=b-grid-item].b-xxxl\\:order-13{order:13}[class*=b-grid-item].b-xxxl\\:order-14{order:14}[class*=b-grid-item].b-xxxl\\:order-15{order:15}[class*=b-grid-item].b-xxxl\\:order-16{order:16}[class*=b-grid-item].b-xxxl\\:order-17{order:17}[class*=b-grid-item].b-xxxl\\:order-18{order:18}[class*=b-grid-item].b-xxxl\\:order-19{order:19}[class*=b-grid-item].b-xxxl\\:order-20{order:20}}@media (width < 640px){[class*=b-grid-item].b-sm-only\\:order-1{order:1}[class*=b-grid-item].b-sm-only\\:order-2{order:2}[class*=b-grid-item].b-sm-only\\:order-3{order:3}[class*=b-grid-item].b-sm-only\\:order-4{order:4}[class*=b-grid-item].b-sm-only\\:order-5{order:5}[class*=b-grid-item].b-sm-only\\:order-6{order:6}[class*=b-grid-item].b-sm-only\\:order-7{order:7}[class*=b-grid-item].b-sm-only\\:order-8{order:8}[class*=b-grid-item].b-sm-only\\:order-9{order:9}[class*=b-grid-item].b-sm-only\\:order-10{order:10}[class*=b-grid-item].b-sm-only\\:order-11{order:11}[class*=b-grid-item].b-sm-only\\:order-12{order:12}[class*=b-grid-item].b-sm-only\\:order-13{order:13}[class*=b-grid-item].b-sm-only\\:order-14{order:14}[class*=b-grid-item].b-sm-only\\:order-15{order:15}[class*=b-grid-item].b-sm-only\\:order-16{order:16}[class*=b-grid-item].b-sm-only\\:order-17{order:17}[class*=b-grid-item].b-sm-only\\:order-18{order:18}[class*=b-grid-item].b-sm-only\\:order-19{order:19}[class*=b-grid-item].b-sm-only\\:order-20{order:20}}@media (640px <= width < 960px){[class*=b-grid-item].b-md-only\\:order-1{order:1}[class*=b-grid-item].b-md-only\\:order-2{order:2}[class*=b-grid-item].b-md-only\\:order-3{order:3}[class*=b-grid-item].b-md-only\\:order-4{order:4}[class*=b-grid-item].b-md-only\\:order-5{order:5}[class*=b-grid-item].b-md-only\\:order-6{order:6}[class*=b-grid-item].b-md-only\\:order-7{order:7}[class*=b-grid-item].b-md-only\\:order-8{order:8}[class*=b-grid-item].b-md-only\\:order-9{order:9}[class*=b-grid-item].b-md-only\\:order-10{order:10}[class*=b-grid-item].b-md-only\\:order-11{order:11}[class*=b-grid-item].b-md-only\\:order-12{order:12}[class*=b-grid-item].b-md-only\\:order-13{order:13}[class*=b-grid-item].b-md-only\\:order-14{order:14}[class*=b-grid-item].b-md-only\\:order-15{order:15}[class*=b-grid-item].b-md-only\\:order-16{order:16}[class*=b-grid-item].b-md-only\\:order-17{order:17}[class*=b-grid-item].b-md-only\\:order-18{order:18}[class*=b-grid-item].b-md-only\\:order-19{order:19}[class*=b-grid-item].b-md-only\\:order-20{order:20}}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item]{grid-column:var(--b-grid-start, auto)/span var(--b-grid-offset-column, var(--b-grid-span, 1))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--full-col{--b-grid-span: var(--b-default-column-count)}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item--offset]{--b-grid-offset-column: calc(var(--b-grid-offset) + var(--b-grid-offset-span));margin-inline-start:calc((100% + var(--b-default-grid-gap)) / (var(--b-grid-offset-span) + var(--b-grid-offset)) * var(--b-grid-offset))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--1-col{--b-grid-offset-span: 1;--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-1:not([class*=b-grid-item--offset]){--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--2-col{--b-grid-offset-span: 2;--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-2:not([class*=b-grid-item--offset]){--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--3-col{--b-grid-offset-span: 3;--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-3:not([class*=b-grid-item--offset]){--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--4-col{--b-grid-offset-span: 4;--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-4:not([class*=b-grid-item--offset]){--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--5-col{--b-grid-offset-span: 5;--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-5:not([class*=b-grid-item--offset]){--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--6-col{--b-grid-offset-span: 6;--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-6:not([class*=b-grid-item--offset]){--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--7-col{--b-grid-offset-span: 7;--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-7:not([class*=b-grid-item--offset]){--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--8-col{--b-grid-offset-span: 8;--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-8:not([class*=b-grid-item--offset]){--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--9-col{--b-grid-offset-span: 9;--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-9:not([class*=b-grid-item--offset]){--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--10-col{--b-grid-offset-span: 10;--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-10:not([class*=b-grid-item--offset]){--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--11-col{--b-grid-offset-span: 11;--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-11:not([class*=b-grid-item--offset]){--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--12-col{--b-grid-offset-span: 12;--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-12:not([class*=b-grid-item--offset]){--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-12{--b-grid-offset: 12}@media (width >= 320px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-12{--b-grid-offset: 12}}@media (width >= 640px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-12{--b-grid-offset: 12}}@media (width >= 960px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-12{--b-grid-offset: 12}}@media (width >= 1280px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1600px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1920px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1600px){:root{--beacon-grid-layout-space-margin: 10rem;--beacon-grid-gutter-size-inline: 2rem}}.wrapper{display:grid;gap:var(--beacon-system-space-micro-normal)}.header{align-items:baseline;display:flex;gap:var(--beacon-reference-space-3);padding-block:var(--beacon-system-space-cell-contained)}.title{color:var(--beacon-system-color-text-title)}.title ::slotted(*){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}.item-count{color:var(--beacon-system-color-text-standard);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.countries{--b-grid-columns: 1;--b-grid-gap: var(--beacon-system-space-micro-normal);margin-inline:0}@media (width >= 640px){.countries{--b-grid-columns: 2;--b-grid-gap: var(--beacon-system-space-micro-jumbo)}}@media (width >= 960px){.countries{--b-grid-columns: 4;row-gap:var(--beacon-system-space-micro-normal)}}`, o = class extends Bt$3 {
  constructor() {
    super(...arguments), this.beaconTagName = b$5.beaconTagName, this.resetSpacing = true;
  }
  static get styles() {
    return [super.styles, g];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, f$1];
  }
  render() {
    return tt$1`<div class="wrapper">
      <header class="header">
        <div class="title">
          <slot name="title"></slot>
        </div>
        <div class="item-count">
          <slot name="item-count"></slot>
        </div>
      </header>
      <section class="countries b-grid">
        <slot></slot>
      </section>
    </div>`;
  }
};
o.tagName = b$5.beaconTagName;
let i4 = o;
const c$1 = (t3) => (Se$3(t3, i4), Dt$3({
  tagName: t3 ? t3 + "-" + i4.tagName : i4.tagName,
  elementClass: i4,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const S$2 = /* @__PURE__ */ new Map([
  [
    "australia",
    `<svg
      id="australia-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23654)">
        <rect y="-0.00292969" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23654" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23654">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23654"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,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"
        />
      </defs>
    </svg>`
  ],
  [
    "austria",
    `<svg
      id="austria-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#a)"><path fill="url(#b)" d="M0 0h20v16H0z" /></g>
      <defs>
        <clipPath id="a"><path fill="#fff" d="M0 0h20v16H0z" /></clipPath>
        <pattern id="b" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#c" transform="scale(.0125 .01563)" />
        </pattern>
        <image
          id="c"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC3SURBVHgB7dtBEcJAEAXRXQoBKME13EFFvCQekmjYvr4noav+aWrm9nqfg2WPQSJgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgNPfPz1EpmOdtsMyEIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBo+fx/Q/WTa9ejQlHAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYX6O0OCRYnNboAAAAASUVORK5CYII="
        />
      </defs>
    </svg>`
  ],
  [
    "belgium",
    `<svg
      id="belgium-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#a)"><path fill="url(#b)" d="M0 0h20v16H0z" /></g>
      <defs>
        <clipPath id="a"><path fill="#fff" d="M0 0h20v16H0z" /></clipPath>
        <pattern id="b" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#c" transform="scale(.0125 .01563)" />
        </pattern>
        <image
          id="c"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACxSURBVHgB7dAxDcJQGIDBH8LAxIgwFOAGXCADbU2HVsSXvOlOwl1m5pgF3q/b/D73WWH7Pmf/P2aF65AIjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYHQCjOkGuptKsZYAAAAASUVORK5CYII="
        />
      </defs>
    </svg>`
  ],
  [
    "canada",
    `<svg
      id="canada-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23675)">
        <rect y="-0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23675" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23675">
          <rect width="20" height="16.0013" fill="white" />
        </clipPath>
        <image
          id="image0_306_23675"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAN8SURBVHgB7ZtNSFRRFMePTpOmaFL0gaMZbRy0ZYLQzoUta1G4KeiDNi4iKSgoihZBmzBa2CKyhW2CWdQqEKplUstSDFooOhIIkjOl5ujU/b/xDtPLj9Ez90M4PxjG9+b5Bn6ee8+55z7LhlsP/aES0PJlnLYTI0ebqBSUk8BCBDIRgUxEIBMRyEQEMhGBTEQgExHIRAQyEYFMvBa4nE6R73grcHFqkr4/uEe+463AuY9DNPs6Qb8+DZHPeCtw+klv7r2vl3zGS4E/XiUok5wMfp5TEehzFDoXiESB+a4QHX3541AUznkk1IsI/NZ5PEgYEFkYfRodhfOjIzR2oYsmrlwmX9hBjonU1FK0voFmXvRT+v0gLadWL10gLbtS1lS1tZMveBGBlfGW4B2Rl12j9is8v6u5hXzBC4HRWMOmrpcIDFHZ3Lqp66OxRvIFJwJ1wtBUbyKiMGfqIQ/S7wad1opGBULSgsqc4XNIGOMqm2qJGMLlSkwxVBTIw+8nb12jmYH+/9bNyNw21tJGs/CSSgooOyCo6lh7EDmQB5AwJlVmbXr+MpeJ1TW/Q7JXQycQyMMfQSeXKSUS98+o86m3g8H5I4k3FImbTThGBWKyR2RB1mwyoda2/36O6MRwjt1/GIgpRiDuqeUV1osYynhpUBpVxs1na+NzYN2p0+t+joYB5rClIofbwteRIHLDxXaYakuZ2nghXdtxIpij1mO67xEVS7HX2ip1jEcghpILbJU6xgUu/3TTVc6mZskGRgWixBg730UuSN6+bqU+NCpwf3dPUKK4YKcqi+pOniHTGBWI2u6wqvNsz4M1HZ25742Z/17zSWRFYkXcTgdl79lL1Pj4adErGy5W1sJaIiLDJAdv3KUDN++QTaw1EzAXIjL2nLtIpQbRhiWhiXtvhPWONKIkUrO7ZBkS86ut+W41nLSz9nVfVa8eKgUu5QFnDVVI5ILocykPOBMY3srcClkPnp1xtis3M/As33KK1OZ25qL1jfljdFuwE9f84XPQ9oKsRXUuMzURHKNZimuw3VntcI/EmUAkE7zWYn50ON9R1n29qjbyDm+fjcmm0rQd8P4By0wJ5kqTyBOqTEQgE+8FLiZlCG8JlCvbAW8Flq88teU7ZfIf6zwkiTARgUxEIBMRyEQEMhGBTEQgExHIRAQyEYFMRCATEchEBDL5C8eiR4K4AdZGAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "china",
    `<svg
      id="china-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23683)">
        <rect y="-0.00292969" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23683" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23683">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23683"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMiSURBVHgB7ZpbUhNBFIbP5H4l4g2sCl4efMENiAswLEDYgLoAwwIoNiAbSDYQVqALEDfgsw8ELUulYHKdTJjYp8sJiU50pk+YTMP5qqgiBRkyH6fP+bsT46T8eASMMjFgSLBAIqEKNJaciz9ctqce60roFZh/+w0yr06h2GgKgeegO6EKHJkxsA6WILv7HWJrQ0hu9EB3lAXGn1hKAlLP2+PvE+L5qUoHdEZZYPpFCxJPgwnEvmd/zIG5eR/OP6WhU12Bwbs86EwCFElWWmIqGNDbv+n7OU4zKb8Qq34DrgJKFYjLF3sYVpRqH8NeOHXNdUteTzeUBOLydQm6jGeBA6bYOBY9siMntS4oCZTL9zepbRPmQbwsKnrNhnz9C9iHWdCFmT0wvWVCautvORh+cfm64LLDTOdFv74Mto8hkRRVnBbZEKsQr595eSqeV5CPo47xr8MElJh583NKmB/wxrvV1cATtlD7KqZ0Vk5o5ygxHjhRxvjfaQxWWLZ64lmNXgwPcyKe3FW6eaxCq6bXdDb8Hmfh9gurcdb+Fauut39LOwFUfDeZvhAzaJRm/tyqLV87eUigLj05ff9kXtNYN3wLdMOzi9voxxcihGoXzJS6HTD4FjgZni0RT3A/e/bsEfRF33OhhmqUN69gHha+h0jpw2f8dejsrIhJOx10x1lQ7I3PNh5CUHDCZ3FAlRw5pJyjJLRf35NVHnV8VSAuX/t9UVbd0GOXgJHF3Hwgw6/KEhyIfXFnZ3U84bt7d7SQh/iqQLyxy94VYGjH80GZH8UrCnLKs0iMqLytiW3ADd9h/MPmxcJeJQqbPL6a3LnoIg8J/ZXmdn/IwwMcOiMzDroTukDnOAGFg6bMlKlKW8tD1ElCF2gUL97KjK8PAp/0RI1QBWIcclpxaG2XZc/r7t32jEU6sbApjJFFd3nIwsbdVZCH8IeLiLBAIiyQCAskwgKJsEAiLJAICyTCAomwQCIskAgLJMICibBAIiyQCAskwgKJsEAiLJAICyTCAomwQCIskAgLJMICibBAIiyQCAskwgKJsEAiLJAICyTCAon8Al3oDOPx/R4bAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "mainland china",
    `<svg
      id="mainland-china-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23683)">
        <rect y="-0.00292969" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23683" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23683">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23683"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMiSURBVHgB7ZpbUhNBFIbP5H4l4g2sCl4efMENiAswLEDYgLoAwwIoNiAbSDYQVqALEDfgsw8ELUulYHKdTJjYp8sJiU50pk+YTMP5qqgiBRkyH6fP+bsT46T8eASMMjFgSLBAIqEKNJaciz9ctqce60roFZh/+w0yr06h2GgKgeegO6EKHJkxsA6WILv7HWJrQ0hu9EB3lAXGn1hKAlLP2+PvE+L5qUoHdEZZYPpFCxJPgwnEvmd/zIG5eR/OP6WhU12Bwbs86EwCFElWWmIqGNDbv+n7OU4zKb8Qq34DrgJKFYjLF3sYVpRqH8NeOHXNdUteTzeUBOLydQm6jGeBA6bYOBY9siMntS4oCZTL9zepbRPmQbwsKnrNhnz9C9iHWdCFmT0wvWVCautvORh+cfm64LLDTOdFv74Mto8hkRRVnBbZEKsQr595eSqeV5CPo47xr8MElJh583NKmB/wxrvV1cATtlD7KqZ0Vk5o5ygxHjhRxvjfaQxWWLZ64lmNXgwPcyKe3FW6eaxCq6bXdDb8Hmfh9gurcdb+Fauut39LOwFUfDeZvhAzaJRm/tyqLV87eUigLj05ff9kXtNYN3wLdMOzi9voxxcihGoXzJS6HTD4FjgZni0RT3A/e/bsEfRF33OhhmqUN69gHha+h0jpw2f8dejsrIhJOx10x1lQ7I3PNh5CUHDCZ3FAlRw5pJyjJLRf35NVHnV8VSAuX/t9UVbd0GOXgJHF3Hwgw6/KEhyIfXFnZ3U84bt7d7SQh/iqQLyxy94VYGjH80GZH8UrCnLKs0iMqLytiW3ADd9h/MPmxcJeJQqbPL6a3LnoIg8J/ZXmdn/IwwMcOiMzDroTukDnOAGFg6bMlKlKW8tD1ElCF2gUL97KjK8PAp/0RI1QBWIcclpxaG2XZc/r7t32jEU6sbApjJFFd3nIwsbdVZCH8IeLiLBAIiyQCAskwgKJsEAiLJAICyTCAomwQCIskAgLJMICibBAIiyQCAskwgKJsEAiLJAICyTCAomwQCIskAgLJMICibBAIiyQCAskwgKJsEAiLJAICyTCAon8Al3oDOPx/R4bAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "chile",
    `<svg
      id="chile-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <rect width="20" height="16" fill="url(#pattern0)" />
      <rect x="0.1" y="0.1" width="19.8" height="15.8" stroke="black" stroke-opacity="0.32" stroke-width="0.2" />
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23674" transform="scale(0.0125 0.015625)" />
        </pattern>
        <image
          id="image0_306_23674"
          width="80"
          height="64"
          xlink:href="data:image/jpeg;base64,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"
        />
      </defs>
    </svg>`
  ],
  [
    "colombia",
    `<svg
      id="colombia-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <rect width="20" height="16" fill="url(#pattern0)" />
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23680" transform="scale(0.0125 0.015625)" />
        </pattern>
        <image
          id="image0_306_23680"
          width="80"
          height="64"
          xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBIAEgAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCABAAFADAREAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD+qOv+EA/vMKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA/wAjuv8A1wj/ABtCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD9Oa/5Fj/AL/QoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA/9k="
        />
      </defs>
    </svg>`
  ],
  [
    "denmark",
    `<svg
      id="denmark-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23689)">
        <rect width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23689" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23689">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23689"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEISURBVHgB7dqxDQFhGIfx90SlEBsoneSodFZgCWbQWEBiB1sYQaHQSYjSCgrtcQsc8TjJxfOr3+q5XPIV/2TfGeZRsfZ4FP3tpvTmPJ3HbXeIummEEANCBoQMCBkQMiBkQMiAkAEhA0IGhAwIGRAyIGRAyICQASEDQgaEDAgZEDIgZEDIgJABIQNCzWJ2UbXWIH19k/UiKh+ZfF+SP4U+5i8MGRAyIGRAyICQASEDQslpMqv8HdjK0uiuFqU31+U67sdL1E3zJ8PuNz5REc+R+R8yIGRAyICQASEDQgaEDAgZEDIgZEDIgJABIQNCBoQMCBkQMiBkQMiAkAEhA0IGhAwIGRAyIPQAlsUf41H6Vc4AAAAASUVORK5CYII="
        />
      </defs>
    </svg>`
  ],
  [
    "estonia",
    `<svg
      id="estonia-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23655)">
        <rect width="20" height="16" fill="url(#pattern0)" />
        <rect x="0.1" y="0.1" width="19.8" height="15.8" stroke="black" stroke-opacity="0.32" stroke-width="0.2" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23655" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23655">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23655"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC1SURBVHgB7dtBDcQwDADB5HSfIiiT4gmlIk6LofudkUxgJb8sz/Pee/DZb5AIGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGM3jWo5KwXxHwMAKRwJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRv+11uC7ubdXr8IKRwJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGDzadCt6W3CJ8AAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "finland",
    `<svg
      id="finland-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23660)">
        <rect y="0.00146484" width="20" height="16" fill="url(#pattern0)" />
        <rect x="0.1" y="0.101465" width="19.8" height="15.8" stroke="black" stroke-opacity="0.32" stroke-width="0.2" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23660" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23660">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00146484)" />
        </clipPath>
        <image
          id="image0_306_23660"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADHSURBVHgB7duxEUEBEEXR/ToRiCUKEKvFaEEjetGKSKgF9HB+YMY9Jdx52c4u769Z2eP5mu3pOuJ+u8zxsJtft5mQAqICogKiAqICogKiAqICogKiAqICogKiAqICogKiAqICogKiAqICogKiAqJl9ufV78L/pAWiAqICogKiAqICogKiAqICogKiAqICogKiAqICoqU/EdMCUQFRAVEBUQFRAVEBUQFRAVEBUQFRAVEBUQFRAVEBUQFRAVEBUQFRAVEBUQHRB+8SFhBAN853AAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "france",
    `<svg
      id="france-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23665)">
        <rect width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23665" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23665">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23665"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC1SURBVHgB7dAxEcJAFEDBD2LQgQYGAfRRgAJkUNLhCQNYSES8mat2JexpLvd9FnjcrvN+bbPCb3vO//OdFc5DIjASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4HRAUtXCISstEosAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "germany",
    `<svg
      id="germany-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23690)">
        <rect y="0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23690" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23690">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00146484)" />
        </clipPath>
        <image
          id="image0_306_23690"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACtSURBVHgB7dkxDYBQFATB9wkl1lCGNxygBTyw7YyETa66NTPv8Ns2JAJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJG+zUU6/HKJSYcCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkY7cc5BOu9nUqFCUcCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRh8VMgcN4hbzHwAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>`
  ],
  [
    "greece",
    `<svg
      id="greece-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23673)">
        <rect y="0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23673" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23673">
          <rect width="20" height="16.0013" fill="white" transform="translate(0 0.00146484)" />
        </clipPath>
        <image
          id="image0_306_23673"
          width="80"
          height="64"
          xlink:href="data:image/jpeg;base64,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"
        />
      </defs>
    </svg>`
  ],
  [
    "guernsey",
    `<svg
      id="guernsey-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23694)">
        <rect width="20" height="16" fill="url(#pattern0)" />
        <rect x="0.1" y="0.1" width="19.8" height="15.8" stroke="black" stroke-opacity="0.32" stroke-width="0.2" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23694" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23694">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23694"
          width="80"
          height="64"
          xlink:href="data:image/jpeg;base64,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"
        />
      </defs>
    </svg>`
  ],
  [
    "hong kong",
    `<svg
      id="hong-kong-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23656)">
        <rect y="-0.00292969" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23656" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23656">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23656"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARdSURBVHgB7ZvNShtRFMfPVAuRajXSCnXhR4XWYkEFCy4K6s6d+gBFfQJ15059AnXlUn0D3Uk3Ku0i0oJmIWihapSKKPWjWgxV2p7/kCtpnMwkHmfmQu8PQjQzMczPc+495zha74n+kOHOPCCDCCNQiBEoxAgUYgQKMQKFGIFCjEAhRqAQI1CIESjECBRiBAoxAoVoLzBSU0MV3d30sKyMdKSQNATSXk9PU0lTExWyuPO1NYrNzZGOaCewamCA6kZHbXEKCNQVrQRW9vXRy4mJW69H29tJV7RZA5G2z0dGHI8V8THI1RFtBCJtISob2Eh0RBuB0bY21+PFjY2kI1oIxBrnFn06o4XA8hw2iYt4nHTE910Yi//+zAxJ2RwctJ8RreWc7ipqL3d27NdPlpfpG39OMvV9UPgqEDtrAxfEWN9wgXZhXFpKyUSCjpeW6IQf4Or0NOvPuOZjm0ND9jkNLKiyt/fWZwAIxS6OX9bXsbHARFp+3pmAi2pZXMx6HAXyWk+PHUlO50HEHteFBVxU43iu6ySi8nNHRyASfV0DvS4YEYmWDZF4nRGFiLotLm0QefnIU5+L9wTRP4e+iSBK8UC0KS44MndTHUkdp+Vddmi8pyq1bvqJrwIPcxwAPOZIhDC1Jv5I9b7oh5+lOhCk47XLWukE+mq/o9BXgbhgJcUNVSRjPcS6CKEA3cfR/DwtRaP0obaWFvkZqe0FPhNr4Cd+RHyuLy2/b2/z2kgARH9kQVjvEHVo6xC9Fh87dvgFoDTC7u7E/uwsrQfYNxe8IxolH7FT7+yMnnR2Zj3nQSRCj+rr6XRlhX4dHND3hQVb6s+NDTsKX01N2dJKmpvpdzJJRyz3kCOzmN+j1kdE3Ravo9h4gsQK6gZLRFW2aUs6EIEyBKmLZ6R0Maf0G45iNSPE65B1HwW6FN8jUAEx59yOlbW2/jMszQQR+4XXubNYjGqHh+2IxK5cUFR0MxfExoDIRIqjQA8TK4xbfJGOditWXW3LtCON5Z6kdSd4vXV1lfYmJynBOzRS9e329q2fBdkJhyFsUIQykUbqpacfdsr0rgHyWlgkpKldtCBL1L4YH7c3mrDG/qGN9CEG62JFV9dNSiP68DXEqdfQOwNV2jiBiN4MoGh2IpQUjqRarVw6jF1OYchB+mY7Hzs2asQwCKWV8xrfp4OofMobhtv5iNYSlwj1k8AF4mIzR1JupHcmbvw3AvO5UKQvdujLgIek+RC4wFz/PIldWXUVaOu8BglhSQ5MoJ26LA+7rhfJ1EBUTarVVNqNi5DKmMAEontA8VzoMV5C2sa4582MKNSN6/39jlNmHLvKc9R1XwRexmANxKAzvf6DFAwHIMKrIFaDUsz6AKLTSXhQWGH+tyai8q6Ro/7AFOcZ4mGId26FenORJO0QqXGMtUK+7c0y/y8sw9ziK8QIFGIECjEChRiBQoxAIUagECNQiBEoxAgUYgQKMQKFGIFCjEAhRqCQv1c3xoYPQ/2zAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "iceland",
    `<svg
      id="iceland-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23661)">
        <rect y="0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23661" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23661">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00146484)" />
        </clipPath>
        <image
          id="image0_306_23661"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFrSURBVHgB7duvTkJRHMDx33U3sTkyJppUA8ymVhM8gfgYBJOBRzDqEwDJqhmC0dlMUmVuVuSqM4kb+3oYd3w/iY17t7Pvdnb/nZPF4dU8Erm5OImz0/3P37PRKKa93q/H1fr9qLbbX+fcPsX55V2UxU4IMSBkQMiAkAEhA0IGhAwIGRAyIGRAyICQASEDQgaEDAgZEDIgZEDIgJABIQNCBoQMCOXXi4/fqRwd7MWqjhfnpBzTf8u73ysHNkW9thvd2maN6S9OYSifDYexDu+TyfL/xuOIebIlOkllj41GOUe+IZzCkAEhA0IGhAwIZa+DwVquwsVtzLJbpmqnE5VmM8ooLwa/Flm2NGCl1fpZI102TmEoL1bFp1K8GCiebVfxPH2L+4eXKIs85ZaCYptDfcUXA0U8tzlsEQNCBoQMCBkQMiBkQMiAkAEhA0IGhAwIGRAyIGRAyICQASEDQgaEDAgZEDIgZEDIgNAHaks8gekWk8IAAAAASUVORK5CYII="
        />
      </defs>
    </svg>`
  ],
  [
    "ireland",
    `<svg
      id="ireland-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23666)">
        <rect width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23666" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23666">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23666"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACxSURBVHgB7dAxEcJAFEDBD17wQUGDC7CAHBoQEC2xlIh4M1ftStjLfJ/HLPC6PeZ3/8wS23tm/88K1yERGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwEhgJDASGAmMBEYCI4GRwOgEShMG99a/kU4AAAAASUVORK5CYII="
        />
      </defs>
    </svg>`
  ],
  [
    "italy",
    `<svg
      id="italy-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23677)">
        <rect y="0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23677" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23677">
          <rect width="20" height="16.0013" fill="white" transform="translate(0 0.00146484)" />
        </clipPath>
        <image
          id="image0_306_23677"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC0SURBVHgB7dBBFUFRGIDBnzZ6IIcQlnYaKKCCjUAKqPBeiO+cu5qJMId5XbdZ4Ha6zPt8nxV+j+f8P99Z4TgkAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhgJjARGAiOBkcBIYCQwEhjtya8Iry+6SywAAAAASUVORK5CYII="
        />
      </defs>
    </svg>`
  ],
  [
    "japan",
    `<svg
      id="japan-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23682)">
        <rect width="20" height="16" fill="url(#pattern0)" />
        <rect x="0.1" y="0.1" width="19.8" height="15.8" stroke="black" stroke-opacity="0.32" stroke-width="0.2" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23682" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23682">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00292969)" />
        </clipPath>
        <image
          id="image0_306_23682"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMOSURBVHgB7Zo9TJNRFIYPhkGSYmBwACMBBzUM/ESIg4Pg5CQy6CKJjU5MsLiZiMFdmNgEEpwcECcnhcEBgUgdjCxAJLSDQxvbRAYSvW9jDTog7el77yWeJ/nSLk2/Pj333vOdc2p+OMSomBNiqDCBSkygEhOoxAQqMYFKTKASE6jEBCoxgUpMoBITqKRWIiG3uCL51IZk8bq+Ifu5fPECtQ31crK1Werc1djXK41XeyTRdVFioCZkNWY/9012Jp9LemZB9rbTZX0WQs+NDTuZvcX3oQgmcOvxlHyZmPsdZZUCec3JAWl7NCwh8C5wb3tXUoOjUnDLtJpA5KW3z7xHo9dDJDP7Spa7b1ddHsAWsNx9S76+fCM+8RaBkPcp+VB80D4zLk13B8QHXgQiKj66ZesTXxLpArHnYdlqD4tyQepz+cML+p5I3wPX+u97lwfwnanBEWFDFbjpUpVy87tqgsMK6RITmkAs3YxLkENTjVzzMGgCs4urQaOvBOTtTM4JC9oh8q7tehQCAQ6SK1uvhQElAgvrn6ORB3AvKFIwoAjMLq1KbBRS1X/6ARyBi/EJZN0TRSBO4NjIu22FAUXg9+2MxAYrlaEIRKE0No6VwP8JisDahlMSGyguMCAJTEhssKoyFIH1kXTMDlLXekYYUAQ29vVIbLDuiSIw0XlBYgPtTwakCAzbq/0b3Euii/On0tKYpqSfps5RQAOeBU1gy8hQFOkMoo+1fAFNIPKus6N3JDTNrjPH3E7oXbn3rtmdX+eUkv4Fs5Bagv4o1zE/GWQpYwVg1IMNXSCi4PzTB+Kb9ulxL5mAl2ICTmT8IF+0Tz+R0zeviQ+8VWMgsWN+grqcsWwhryl5Q3wRYLwtLWv996redEKi3On2W98JfLABy82xKcnMLqhFFtMll3Myk+XDCDriW2o3VjICgkjD9FXL6BCt1ncUggo8COZYsksrvyYadl1fJf3HkDkulMlQVUGxAs/bMRCNwOOK9USUmEAlJlCJCVRiApWYQCUmUIkJVGIClZhAJSZQiQlU8hOvQCqCEt8W3gAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>`
  ],
  [
    "jersey",
    `<svg
      id="jersey-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23688)">
        <rect width="20" height="16" fill="url(#pattern0)" />
        <rect x="0.1" y="0.1" width="19.8" height="15.8" stroke="black" stroke-opacity="0.32" stroke-width="0.2" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23688" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23688">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23688"
          width="80"
          height="64"
          xlink:href="data:image/jpeg;base64,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"
        />
      </defs>
    </svg>`
  ],
  [
    "latvia",
    `<svg
      id="latvia-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23684)">
        <rect width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23684" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23684">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23684"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgB7dpBEYAwEATBHEIQgVrcBjRkvt0Spva5897PXhy7FomAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgNHs3+KYBUYCRgJGAkYCRgJGAkYCRgJGAkYCRuOl31hgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRg9AGcNAhIi1/QFAAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>`
  ],
  [
    "liechtenstein",
    `<svg
      id="liechtenstein-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23685)">
        <rect y="0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23685" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23685">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00146484)" />
        </clipPath>
        <image
          id="image0_306_23685"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAN0SURBVHgB7ZrPTxNBFMe/pUAh/FpSkCoC1RhEMbEEo3ICA948lKsHqHcTozcOpt48Ksa7jf8AxZMH1JroRY1UIgERTVVQkBq22IbWUuqbbSCYULV9cNjyPs1md2dm9/DJm/d2dmtBuzcNIW+KILAQgUxEIBMRyEQEMhGBTHZH4C8dLscs9gK7IlArj8LVHAZScRQ6Oy7QtX8W7rZn0Bdo3zqGQmfHBQa/HYF/4gS0fY3wv+9DocMTqKboNtPUe3EB3oFVaCXh/xpvZoqRJ55TAUNQ6LMOTasErGUI6Q6Elh2ILEdpRCmwughndRjuzjlopWHoseLMOBoT+NAGPVkHs2PJ+WUCRZCn4yH073Po6XKgpiJpNH+aT0Cz20loBFiPI00/S1E5nI1l0H8mkabr1LGFxiqRoS8R3H56HqhogZnJOQJVkVDR1N1nh7u3Glp15hah+TiG739FcCoKd18dWhptGB37Af9kGN7LLeg53bB5D9/IorH3dI3DN2FugTnnQFfzEpxNGgmp2ZSnUNF1a+gwXMcq6dhmRJrqv3ez1Ri7FU9/A7qpzVm/CsQXYGZyLyKpBOUxG0VcYtvuwf5MpAWnYoYoJTYbaaXZmr3fDOQ8hVUBcCXfQqvKRFVwOpZppynsaquAfyxsSFPRF3gRgUqw+soaaum8pspq9KmxiogqKiUazEzuVTip42S7HW+mdcp585TfmjejrKN/3Jiy7l67ca7EHep7iSsDjbhB4xSXhmZIrhXdZx3QozFotij0RCXMSu5FhOT1dC4BnQ1GdG3IU9E3cvf4H/lORaGf2rq3tA0a09pmXKdyqe/aGkUhTEtejzFPrj8mifzcdY6KTmDGCTOTexGhpD/6qglcVJEJTJo7/ynyWsr5HtUa+Y3D8IN60xcQRV5LOT11EFfvUCW2fqRKq5PMFK021v4qNVOZqQofKEPPGcp9zy+YOvdtYMn7uzBVY6xM0/bOWLr984FYRZt65qtwAlVHM/sCwLKjH9bXs7xtKYCpmo2838ZsS1FZZttDyEclJiKQiQhkIgKZiEAmlte1rfL/QAYSgUxEIBMRyEQEMhGBTEQgExHIRAQyEYFMRCATEchEBDIRgUxEIBMRyEQEMhGBTEQgExHIRAQyEYFMRCATEchEBDIRgUxEIBMRyEQEMhGBTEQgExHI5DcqkP5sdW+TDAAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>`
  ],
  [
    "lithuania",
    `<svg
      id="lithuania-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23691)">
        <rect width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23691" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23691">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23691"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADASURBVHgB7dsxDUJBAATR++QUgABKKnygA2fIoMQAJiiQQEXAw037noRJttztez/8Bst2g0TASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjAaF6fx8G6eXvtB+tMOBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMJqX92ewbnuczq5egQlHAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkZ/nSEKbAEm8YYAAAAASUVORK5CYII="
        />
      </defs>
    </svg>`
  ],
  [
    "luxembourg",
    `<svg
      id="luxembourg-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23657)">
        <rect y="0.00292969" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23657" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23657">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00292969)" />
        </clipPath>
        <image
          id="image0_306_23657"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC7SURBVHgB7dkxEQJBAATBOwozSMAtGCBDDjggI/js/zXcpN0Spmqjnb/bfR8suwwSASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjAaO5vd5OpWDup8EyE44EjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIyuj89/sG6O59epFJhwJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGB0AI9TDxLt6cISAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "malaysia",
    `<svg
      id="malaysia-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23668)">
        <rect width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23668" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23668">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00292969)" />
        </clipPath>
        <image
          id="image0_306_23668"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAR4SURBVHgB7Zk/bBNXHMe/V1nJkrRW3SVecl08NWoKXejCsXTCIlWnZPGxpGOC0h17L2pQp7C4LGSpRNKwtIsvS1mIav4seIkZiBdAgVhIAaHwvi9+5hJy9tmP4T14H+mSy51z0n39/f17z5vA7AEsIEATS7gN08i0MA4b2MMoTOQzOLRwAmriBNQkA0sYDwL4pRJMwxoBR/1J5MIQpuFCWJOBHZgdf4Xg9A4uBE0Ep1rd67vtEdQbOWzeyePPWwV8Kgwk4MLsA5Tnt4SI+91r0dYE1qOv0WyNYXdvRAocnm/I682WHT2mDqkEpCg3f/tHOO+d466uTqF87ZQQLX2DS+dGW3kMw8v6XexUKjCNvgJSvGhlA98Wnsq/6bKLlQBrkY80UHS68d35oYD+RFv8PEjt0pf1Olr1CKbRt4gsL/3XFY/89OuPqcUjMyJX8ksgZ4UD1fni3L2PIsR7CshcVhKHonLtdKoQjIf6WjSJ6uVInmfHXwvnvZDP/aIjJJkuPBPX92AjPQUsFR92z1kkykLANDR3xkTO/FeGab3xlcx9dOJ04Yn4/QiXRSFitaYbf1+6Le4/ttaNiTmQL3+kaNyYQlooxqUrZ/D/jb+wtunLQkNBCcUjk/k9bP+9KorRN1he7f/sTDaLkawP00gUkI6JowpBL+KFgce5X4qoiQKUjYWrgu0QU4JytQrh3faoLFTHyc5cwFT1Jkwj2YH5ozmJodgPhrnMm8VIure5w7D0Ej/P/Mrekv+3LgrTsnDjSeKZTKKA8Wb5UIh0cArhQUctzt2XAiXByYUhPGxvaAIpG+l9DAKLBoWL59CTOGxx9uFvtDu50i73kUQB465jDuPR7wWV61g0NoWrGJYsGsfTgeLSlR/kM3l/cfa+zLNJbnyz+xz7zSZMQySo+RM3leii2sqt7t+DNtCkWt7EzNntjkjtI/fY6sDzcG6+KHNgP86jgTIimEZiH8iiEXfcgnDIILC/Y0X+bu5n8HtS4qtqznHw+kZBiFzrVG87SRSQ4l2N9WfMZ3RlGvi5dTGBXCwHhy2MdyD7Qj6TrQvF5PPYwvAzoWjYT2p1bKDnJMIGV4ZaB4ZkmhdlHlO5jEJVVr7v9Iafy9xK96n5mtcppI0FhPQUUK28KFgkuKw1qFvUAuvdxpdSMD73eqfVsZ3EIhInLDa6CwJEThkpkz9FUnMu25Z4IYrf68dskMcfpUmYRioBCV+WY1m8mtJZLATHWw/Z9oy9ek9g9nyDLMDGCcMzqFZDmEZqARUc1RZErzcdWyMknCoYmo9Enqs/zMmx7ENiqoADbyrFRzU2wKoF4aYSW5RhHWYrQ+8LqxWXTx1rNtat3VQyBWs3lRy9cQJq4gTUJOP7OdhADhMQi2IwDe9AAMfQuBDWxAmoiRNQEyegJt4dblw4hsY5UBMnoCZOQE2cgJp4L2o1V0Q0cKOcJi6ENXECauIE1MTbDkOXAzVwo5wmLoQ1cQJq4gTUxAmoSWbE9+EYHjfKaeJCWBMnoCZOQE2cgJq8BSBl2qlDOZpbAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "mexico",
    `<svg
      id="mexico-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23676)">
        <rect y="-0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23676" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23676">
          <rect width="20" height="16.0013" fill="white" />
        </clipPath>
        <image
          id="image0_306_23676"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUBSURBVHgB7dlbTFNnAMDxP4WWW1tgCBQqKARKHSJ456LoooQ96LzFiTHTxWSbRhOzLDNxS7aXbW5e5tuSJS5q4rwmXhIWdY5F44VJEAZMQS4iV6FCoTdoC6WrZK97+hLPefh+T81J2jT/fud8l4axpyLIG/BhcTmndn7Gm9C97xD281d4EzRIQmRAQTKgIBlQkAwoSAYUJAMKkgEFyYCCZEBBMqAgGVCQDChIBhQkAwqSAQXJgIJkQEEyoCAZUJAMKEgGFBSBCjmdToxGI1XH96IZfcHgWIDs+UUUbvoYY8ps1ERVAT3jo8TGJND/4BIOYxRotTgD4fS2dXC3qZdlNTdZtmEXSzfvQy1UE7B/4AmesR7iJzzcOvNz6JtN8JYxhulIA6Y0I4/rbfR5Yqk5eoKPXFOs2nUANVDNM1CjCae79Q6asEdUHthKyZp3iHorkfauXrzeSZITopl2uYmanODcT8fpa/oLNVBNwFSTlfLNP/B3dwSBmLn47YN4nD5aX4zjsLnw+6exu7zMNcdh0Gu5efJH1EAVAW3Nh2eef7U1F4gzL8HrjuJ57zDDgyOM+Kbp84dRlp/C4rw0gnoDRn04nc+beVav/ChURcDk/EP0djfgcdlYumwLwYgIzMkxxM4ykJ0UQ0ZqHBEJWXgjTLhHxrCNBhgJjc6h/h6Uptgk4vW6mJhwkRBarnj9QYKhn9Ld08LdM5UsWLGJX5vceJ0jJIWefW0jfgo3lFFRVEpnaNS9aHvCQF8PUXrjzGf5/ePodDEoQbEReOfeWYZePcc9OEDg3kO04dFYyrYT1Gpoq73GqpJs/Bot45oo7K/GuHn6BK0NNax4fzcR6XmM6+JIt+TR0HiDc5e+RCmKjUB9bDx63SR6s4X+ppd0Txqg7wYBrYU0UwTjA81kpyTQNzpFfKSGXpuTc8e+orOzi5UbtjPscJJqTuef1ioSE9NQimIBl8+zYnN6Z16fmXJx/vdmvi5aSdloB7Ny3yUm08vi0O39rOUpRw/uxmTNo7/xATcunKKj9yX7D34+896F2VlEGzJRimIBg7FWqq5+SmmRjy/WryOjro7v/6jmpMNLkbGOqw9reK+gkAXO23ywx0qOKQpt6nXGDWbenm7BF2fkfs15unsa2bGtAqUoFlCni2Zebgld7X8yP3cJOyzhZBo2UtszhCfgwx4M40J9PU2RibiTrfjsWipG+7jWcY9f1pZTGNqdOBw2oqPjUJKiy5iy0p3kzs0NTSgX8emyuf/SQ6MhHW1mAc3lJpq2zOPptI7tCWGc3bqFxKQoTmxcS+GifAaGBsgxz2Z9xX6UpPg60FKwI7SmG6T67mk+WZ7P3uwkqgcdODqqCTy5yDF9A6sCj9nT7ibflEHxnEyu/3aEq1Xfkpa5Gm1or6wkVRwm5FnLcNi7GO28TM6sXI6m+ZmKraS6oZ4pPbQ7I/nGNIHfOYBvbIx4Ywq5lhL0+kSUpoqAVstK8OXw+GkdVy4fmblWHNqRTFryKZ2Kx26O5vat70IHDWFYtx2mZFEW2thU1EA954GRJhYvXEd+3hpcnmHcvkli7zyidqSFYtNq1lUcICN9vmI7jv+juhPp17Nzoi6d1zfnnMosCv67now6yf9EBMmAgmRAQTKgIBlQkAwoSAYUJAMKkgEFyYCCZEBBMqAgGVCQDChIBhQkAwqSAQXJgIJkQEEyoCAZUJAMKOhfGa2pqLCkAJkAAAAASUVORK5CYII="
        />
      </defs>
    </svg>`
  ],
  [
    "netherlands",
    `<svg
      id="netherlands-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <rect width="20" height="16" fill="url(#pattern0)" />
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23662" transform="scale(0.0125 0.015625)" />
        </pattern>
        <image
          id="image0_306_23662"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC8SURBVHgB7dlBDQJBAATBXYIMPvxQgjmckHAC0IEBlNydhu1vlYRO5jVzuz32wbLLIBEwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwmv/35lQK5n4aLDPhSMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjA6Pr5/gbr5v35cioFJhwJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGB3r+A3QtudbGAAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>`
  ],
  [
    "new zealand",
    `<svg
      id="new-zealand-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23667)">
        <rect y="-0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23667" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23667">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00146484)" />
        </clipPath>
        <image
          id="image0_306_23667"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,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"
        />
      </defs>
    </svg>`
  ],
  [
    "norway",
    `<svg
      id="norway-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23678)">
        <rect width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23678" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23678">
          <rect width="20" height="16" fill="white" />
        </clipPath>
        <image
          id="image0_306_23678"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEnSURBVHgB7ds7agJRGEDhf8I0aZMyTaqEZAMhSZNswMJeELQTOxfgAmwtBXEBbkErCxcg2NnYqa2liqCF2MhhxMHzwS2Gmepwp7mPZPnxvYkMPNYq+3HwX2rFcDw9++3f13sMeo3j87rd2Y88eAghBoQMCBkQMiBkQMiAkAEhA0IGhAwIGRAyIGRAyICQASEDQgaEDAgZEDIgZEDIgFD6NBnFrTndU75lzkDIgJABoSTeqpmcjbkXzkDIgJABIQNCBoQMCKXNeiGuodsfxWy+OPvu9eU5ysXfyKNksxNXcMkZ6TzxF4YMCKWrz5/IAlmS8prDHTEgZEDIgJABIQNCBoQMCBkQMiBkQMiAkAEhA0IGhAwIGRAyIGRAyICQASEDQgaEDAhtAWprLEBwCkuqAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "portugal",
    `<svg
      id="portugal-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23686)">
        <rect y="0.00292969" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23686" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23686">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00292969)" />
        </clipPath>
        <image
          id="image0_306_23686"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,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"
        />
      </defs>
    </svg>`
  ],
  [
    "singapore",
    `<svg
      id="singapore-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23692)">
        <rect width="20" height="16" fill="url(#pattern0)" />
        <rect x="0.1" y="0.1" width="19.8" height="15.8" stroke="black" stroke-opacity="0.32" stroke-width="0.2" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23692" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23692">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00292969)" />
        </clipPath>
        <image
          id="image0_306_23692"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL7SURBVHgB7ZkxThtBFIafASUoIshGKUIUReYG0NEBN+AGQEkFnABTUQInAG4AHR3cAOjoDFEUuYjAIEQsQlj2X2ms2Z3ZteFVzP6fZK29nhnJn96b93ZcaYpEQt7MgBAVFKiEApW8SuDw7KyMbW/Lt9NT+XFzI/Uoku/Npnyan5eyUumniEBcdX09uRqe222529mRu1go3peVnhEIcV+Pj1PyHs/P5ffUlLQbDa88zCkLQ0VfQkQ1lmQDea1Ypk8cUnmgWk3mPF1dJWMeDg4kZHJTeGRxUb7s7qbuPV1eSmtuLrn6GKrXk2jFtdfYUPBGIAT40rC9sVEoBN8hQs2Y0OUB7x6IVIREG8i439tzxqUWi9MXYxB59/v73nVDw5vCaE2yAv8sLTkCMQ7FpJ8q/GFyUsa2thK5IeFEIH5oVh54PDvrvsf+aCSjHxxdXZUiTO+ISo55dkV/7zgCkYY+bIGIxIfDw+599IJFXMeCsQWY3rFzciKh4Aj0RZ+vGEDGz1otEZkn3V4T4pDuvca+N5w90Ne+GFnExYlAO1W7g+KoKYqcXlEVWtTZOALzejcUlzxQRPIkYR6iOlQG4/rZsG9EnU5SJbN74fPtrfw9OkrdwxjIG1lYkI/T0zI4Pi7/Li6SNSCutrkpn5eXZXhmJvmMx7v/rZaEhLcPhEA8ktlgH/w1MeH0fGhRRldWkvsoEnYEQzDaFuDrI0PA+ySCNiPbaiBF0QhngTBUWAjMysUcrIOnklD3wdzDBPtgwOZ6bS3V9yE1TeExhwgGSDNS7XEhUXig2q/EMlN4oGqOpLLpjFTGy9d0lw2nCmdBCmIPQwVFShppqLrmANUcnpaRvv4TsYFAc+Bg9jjsbXiVUeKrBZI0/F9YCQUqoUAlFKiEApVUohghb4YRqIQClVCgEgpUQoFKKFAJBSqhQCUUqIQClVCgEgpUQoFKKFAJBSqhQCUUqIQClVCgEgpUQoFKKFAJBSqhQCUUqIQClVCgEgpUQoFKKFAJBSp5AQXLVIUCuryQAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "south africa",
    `<svg
      id="south-africa-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23681)">
        <rect y="0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23681" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23681">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00146484)" />
        </clipPath>
        <image
          id="image0_306_23681"
          width="80"
          height="64"
          xlink:href="data:image/jpeg;base64,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"
        />
      </defs>
    </svg>`
  ],
  [
    "south korea",
    `<svg
      id="south-korea-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23658)">
        <rect y="-0.00146484" width="20" height="16" fill="url(#pattern0)" />
        <rect x="0.1" y="0.0985352" width="19.8" height="15.8" stroke="black" stroke-opacity="0.32" stroke-width="0.2" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23658" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23658">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00146484)" />
        </clipPath>
        <image
          id="image0_306_23658"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAcxSURBVHgB7ZxdbBVFFMcPXwVCqzeWRIoxbWOEQCJtU1+QB2+fKgYQRF8MsQUS0KhpifHBB2wx+qAhocQH0QRaEj8iGlokEuKDbYzRxNC0RiX2EmwrsQUjtKG12EYc9z/Juc5d996dndndFtlfsuzdvcPumf+cM7M7c27nCQdKMGY+JViRCGhJIqAliYCWJAJakghoyW0r4Pj4OIWBtYAHDhygyspKGhoaoluFnp4eqqmpocOHD5M1woLBwUE8hMutoqJCzHXGxsbkBlthcyqVknWwwUpANgQbDGlvb5fnbI2Kgu7ubmkb9tjY7nQ6LWwwFrC1tTVrREtLS07LYsPxXAG2wNs4UnDc3NyctbWtrU2YYiSgV+iqBkFQlEHrzqY3wtOqq6ulYGqDw9awQtlIQHfoqiHBgjY2NmbP4fu4UW3aunWrPAcxVZvUMocOHRImBBbQL3S5L+RjCDlbIALYjs7OTtHX15fT0LAdwkFIfDZp6EAC6oYuCzrbAwruzX0f9l6hDPr7+6WtJqEcSMCgodvR0SFmG3hYkFAOOiprCxh16P51/bq4euqMGNz/mjj/ZIP4/pHtonfdQ6J/Q708Htj1nLjy3kdi6qeMCIoayghjr1A2HZW1BIwydKd/HRGX3miTQkEwnQ2C/n7qM6ELbIHXcV8X5qg8D/+QD+qrmmOE3NfV1cm9c1NybkY7d+4kJ2TlOewbGhr8Lkujbx+l397/mG5OTJAJRSvLaNXRt+ReB7zCwU4nlMkJbfk65/R/8jt3vRyvzZ4rhO+7MF66cTHQ1NRETktKIxjcBIKxeE7o+ooHwTK7n6fRI8eMxQMzI6P0w8YnnEY4oVUe7+1wBCdEpZhOl5P9DnVC3RxvlMdVVVVa19TyQACB0HIwAgYAJ3SlYGg1GAZvhKDY5wOVzux+Qe7DpOyZXVT27O6CZWAjvA5OARudvlBOKDjhLL+HeKgTvJKdxg/t2RgI5fQN2WkgGIAbc6sCHBcSD1xsfjl08QC82c8TYRsEArAZtuMYngfgS6ijrnhA2wNV4I24CfcpAAKrIeEFKol+L0rWnOigpavvL1gGEQPbASKGHSOIcIzRfCDEQmsODw/LY7Vl8wGvi1o8MLz/dd8yaGiIBhCu8EAT8cBCsgCilZeXS2P8Qvf0sbNUSdEzNXCBrn56hkq3PJq3DGzFKIy9qXCMUQgHZejKJJ3csofSfw5THCCEEcpxEMuayKmvL1HJ3zMUFzccL5w810dxEIuAXd/8QmExMb+IRhaU0MCiUvk5H+NffElxYNUH6tJ/8RrVLlpOtTPmjy/nisro3ZJa6i1amXO+dmaENk9laPONTM55eGEcxOKB43/MUM+ScjLl4B3raW/p5v+IB3CuNZWmPaWbpGcy0yOXKQ4iFxADCEBFe4v03llVIN6Hyx7wLYfr73VE5LCO4mHdi8gFTBX/20/BUwr1W256llRoicfAA98prqU4iV7AZUVyA6jgU8u354RaPtDntd75MAUFggdpJFti6QMr7i7OfoZ4CLXTS1d5ConKc583MX8xmXB66Wrf17mwiGUUTletoP6fr2WPIRzCGWAUxTNiiZihgYWllHEeT2zJONdZfM9NioNYBHxs/b3U1nne8zuvkdWWkQXFlKrTm8+zJZYQTq9bke0H4wDeXPxgDcWBtYCYFjp+/LhvueZtaykuttev9Z3mh81hZJRZCYgJScytYSbXz5imbWtyBpMo2bRrY8HvYStsxlqPbYqbkYDwOhjB6waYjFTXSbxACLe/uIGipmVHlW9DwVaeWcdUHOpi6o2BBdy3b5/0Ol7dwgYgql9roi9EBaOi+r67qHVHdcEysJFno3kBDPWBNyKigqItIG6qpsWyYOrsLtZE/FoSFYxCRHhd5yt1BcvANl5A4ll0dU0HU6OoYxBv1FrWZK/jRRiefYYx+J7XQnRCWf6/kEWEZ3e/WR8odFlIVVBeJAvijVoz0joL0OpCDZY9sYbsB6a5tr3anZ1wMAEN4Re2DBbDIAxsRqOrCQNIDsBnd8KALzrpCzq5JF6ZULq0f35BVDz9iaD6Du2t8eBXYvDyhNb11WRP3nRyfXQwSi5Sc0k47xh4ZUIFofu7UdF85FuRfulsjqCpxz+QxxCt7eSPYmxyOtB1vZI9OZ87X66PLoHS29xpYWglTkzkbCx3UuNs45Ux5vZGrzQ9XQIJ6BXKXV1doYVy2HhljKmRxN6IhuZykSZYAp20MNtQDgt3sqc7TY/T3NgTTRJCjZLMdTI83UmNcaPaxKGrDhJuu01/6mAkoO6ozEmNswX6P+7v1MhxHrGMR103ofzQxiuU59oPbQo1eJBR143VT728Qll9rJlL8GOLO3SDjrpurAT0CuW55Hlu2LYwQpexEhAglOeq1+WDvdEmdBnr7Cx1Xu1WglOSbYklve3/TPI3EyxJBLQkEdCSREBLEgEtSQS05B9yLaeTXb5nJwAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>`
  ],
  [
    "spain",
    `<svg
      id="spain-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23663)">
        <rect y="0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23663" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23663">
          <rect width="20" height="16.0013" fill="white" transform="translate(0 0.00146484)" />
        </clipPath>
        <image
          id="image0_306_23663"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,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"
        />
      </defs>
    </svg>`
  ],
  [
    "sweden",
    `<svg
      id="sweden-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <rect width="20" height="16" fill="url(#pattern0)" />
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_1458_117" transform="scale(0.0125 0.015625)" />
        </pattern>
        <image
          id="image0_1458_117"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC8SURBVHgB7doxDcNQEAXB+4YYHgEQBAFgWOHkBEO0cmF5pr5qdeVb89i/c4Lj9fzrfnvvc0XbkAgYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGK3jM6csE+7CB0YCRgJGAkYCRgJGAkYCRgJGAkYCRstKv/GBkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGAkYCRgJGA0Q8POA0Ol/ODkgAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>`
  ],
  [
    "switzerland",
    `<svg
      id="switzerland-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23679)">
        <rect y="0.00292969" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23679" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23679">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00292969)" />
        </clipPath>
        <image
          id="image0_306_23679"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEhSURBVHgB7dphDYJQGEbhV2cQIxjBBlaxgUawgVYwgRqBBpAEvQ2Aw93u5nkG/2CDs90fH5fNmPwOLbWNEANCBoQMCBkQMiBkQMiAkAEhA0IGhAwI7dKK8zk5naZd+/kk12ta0E7AwyE5Hqdd2/dphUsYMiBkQMiAkAEhA0IGhAwIGRAyIGRAaFPlz4TLJdnvM0uZg6feU2bh9zuzdF1yu2V1JeDq5+s1Nqc8U4V3dQlDBoQMCBkQMiBkQMiAkAEhA0J1tjWfz/lbj7VHuWFIFVVGuSXn4zF9LLvf23hmRznOgJABIQNCBoQMCBkQMiBkQMiAkAGhdv6RnvOBoOzxNqLOxvofcQlDBoQMCBkQMiBkQMiAkAEhA0IGhAwIGRD6At9jws8Ta/TeAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "taiwan",
    `<svg
      id="taiwan-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23669)">
        <rect width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23669" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23669">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00292969)" />
        </clipPath>
        <image
          id="image0_306_23669"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMOSURBVHgB7Zoxb9NgEIY/I9ROkFaEBZaEpZ2aVIIJBndkSrrAAqp3hrS/oO0viDKwt4KJpc7EmCxMDHWYmHA7lAmklE7NEvxe6qhOAiR+jRS790iV0y+OJT+6u+/OiWXM275JGX3zxswLt4xCoQJJVCDJfxO4vb1mbgKJCCyX82NrtVppbK1QuGOyRiICd3cfRyTa9kORhWMI/q/Xn5mskYjATuenabUqwwiz7QeRI9Zbrao5Pb0wWSMRge32d7O0tCiSQokHB19Nt3s5lIej6/oma8wsEKKq1UeRlPW8H+bk5MLs738ORN2VcwBe4w/riNJ2+2z4GQh1nFWTdqw4kwjkIWW73Z5E3+HhINrq9aeRuhcCcTs7n0Ts1taKpDZeb2w0Rf6spH4SwU3j5oHjrIi8o6PnE+UBrOP9wfmrlLx5w2Jm4TANc7nFqfo+pDLkoT4y8uYpAmmBSOPj4xdT9XiI1GLxfSBxQWpmXOZJ4O1ZTh5sIEWpgZVKQTYI225O3SDj86VSPqiJFRGI+tls+lIjITeNzFwDEXGIIAleir45P7+8ulZ6SSSFff/VsHX5G4i69fUPmUphupGu1dZMo/FlqnORsnt7T6aSnRZiCwwnDAiBmH9FFN5vNDoiHD3kpAcQaSSWwFAeUhEtCZJqc/PjHyVik8D7iLxB092TvjALT2dm2oVDyuX7QSPsRoR53kvp87CGnTqXWwg2iZ7MvxAFYah/jnN2dY28XIephfNArAh03W+RG8ekUSrdk1EO7Yjv/5J1vA5HPEgcnZ9xnbSTyNMYRBxEhePZ8vLi8EFBOPaFkZk1EhGI6Lo+22JTuX4cSHRl5MsaFvu9MDYGCBydbX3/dTC2vYus4bwkal5qR7lJIHU9b3wMQ8sySto3jElY+ssEDv1emEQFkqhAEquPkqLERiOQRAWSqEASFUiiAklUIIkKJFGBJCqQRAWSqEASFUiiAklUIIkKJFGBJCqQRAWSqEASFUiiAklUIIkKJFGBJCqQRAWSqEASFUiiAklUIIkKJFGBJCqQ5DdnYTqFg6Ay7QAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>`
  ],
  [
    "thailand",
    `<svg
      id="thailand-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23670)">
        <rect y="-0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23670" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23670">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00146484)" />
        </clipPath>
        <image
          id="image0_306_23670"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABACAYAAACNx/A2AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADHSURBVHgB7dwxDUJBEADRO/JNYIGEAhsIQgFWcEBocYAaSOjAw037noTJbrHJ5eZtf/oNlu0GiYCRgJGAkYCRgJGAkYCRgJGA0Xx/vk65wARGAkYCRgJGAkYCRgJGAkYCRtvj/hysm8fD2SkXWOFIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwEjASMBIwMj7wMgERgJGAkYCRgJGAkYCRgJGAkbb63IdrJt+7WiscCRgJGAkYCRgJGAkYCRgJGD0B4doEa13O6DuAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>`
  ],
  [
    "uae",
    `<svg
      id="uae-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23671)">
        <rect y="0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23671" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23671">
          <rect width="20" height="16" fill="white" transform="translate(0 0.00146484)" />
        </clipPath>
        <image
          id="image0_306_23671"
          width="80"
          height="64"
          xlink:href="data:image/jpeg;base64,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"
        />
      </defs>
    </svg>`
  ],
  [
    "united kingdom",
    `<svg
      id="united-kingdom-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23687)">
        <rect y="0.00292969" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23687" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23687">
          <rect width="20" height="16.0013" fill="white" transform="translate(0 0.00292969)" />
        </clipPath>
        <image
          id="image0_306_23687"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,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"
        />
      </defs>
    </svg>`
  ],
  [
    "united states",
    `<svg
      id="united-states-flag"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g clip-path="url(#clip0_306_23693)">
        <rect y="-0.00146484" width="20" height="16" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_306_23693" transform="scale(0.0125 0.015625)" />
        </pattern>
        <clipPath id="clip0_306_23693">
          <rect width="20" height="16.0013" fill="white" />
        </clipPath>
        <image
          id="image0_306_23693"
          width="80"
          height="64"
          xlink:href="data:image/png;base64,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"
        />
      </defs>
    </svg>`
  ],
  [
    "asia regional",
    `<svg id="asia-regional-flag" width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="16" transform="translate(0 0.00292969)" fill="#007DB3" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 2C13.3137 2 16 4.68629 16 8C16 11.3137 13.3137 14 10 14C6.68629 14 4 11.3137 4 8C4 4.68629 6.68629 2 10 2ZM10 13C10.2456 13 10.7372 12.7749 11.2269 11.7954C11.4114 11.4265 11.5723 10.9898 11.6988 10.5H8.30121C8.42775 10.9898 8.58863 11.4265 8.77311 11.7954C9.26285 12.7749 9.7544 13 10 13ZM8.10357 9.5C8.03676 9.02891 8 8.52588 8 8C8 7.47412 8.03676 6.97109 8.10357 6.5H11.8964C11.9632 6.97109 12 7.47412 12 8C12 8.52588 11.9632 9.02891 11.8964 9.5H8.10357ZM12.728 10.5C12.5388 11.3244 12.2589 12.0483 11.9139 12.6206C12.9337 12.1977 13.7833 11.447 14.3311 10.5H12.728ZM14.7711 9.5H12.9055C12.9672 9.02057 13 8.51795 13 8C13 7.48205 12.9672 6.97943 12.9055 6.5H14.7711C14.9198 6.97352 15 7.4774 15 8C15 8.5226 14.9198 9.02648 14.7711 9.5ZM7.09451 9.5H5.2289C5.08018 9.02648 5 8.5226 5 8C5 7.4774 5.08018 6.97352 5.2289 6.5H7.09451C7.03281 6.97943 7 7.48205 7 8C7 8.51795 7.03281 9.02057 7.09451 9.5ZM5.66891 10.5H7.27202C7.46122 11.3244 7.7411 12.0483 8.08612 12.6206C7.06629 12.1977 6.21675 11.447 5.66891 10.5ZM8.30121 5.5H11.6988C11.5723 5.01019 11.4114 4.57352 11.2269 4.20457C10.7372 3.22509 10.2456 3 10 3C9.7544 3 9.26285 3.22509 8.77311 4.20457C8.58863 4.57352 8.42775 5.01019 8.30121 5.5ZM12.728 5.5H14.3311C13.7833 4.55295 12.9337 3.80227 11.9139 3.37938C12.2589 3.95166 12.5388 4.67556 12.728 5.5ZM8.08612 3.37938C7.7411 3.95166 7.46122 4.67556 7.27202 5.5H5.66891C6.21675 4.55295 7.06629 3.80227 8.08612 3.37938Z"
        fill="white"
      />
    </svg>`
  ]
]), C$2 = {
  flagBaseClassName: "flag",
  defaultFlag: {
    selection: "united states",
    id: "united-states-flag"
  },
  flagSVGs: S$2
}, F$2 = T$7`::slotted([slot=icon]),svg{block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-6)}`;
var K = Object.defineProperty, Y = Object.getOwnPropertyDescriptor, l$1 = (h2, A3, t3, e5) => {
  for (var i5 = e5 > 1 ? void 0 : e5 ? Y(A3, t3) : A3, g2 = h2.length - 1, w2; g2 >= 0; g2--)
    (w2 = h2[g2]) && (i5 = (e5 ? w2(A3, t3, i5) : w2(i5)) || i5);
  return e5 && i5 && K(A3, t3, i5), i5;
};
function J$1(h2) {
  let A3 = class extends h2 {
    constructor() {
      super(...arguments), this.title = "";
    }
    static get flagStyles() {
      return [F$2];
    }
    /** The inner text of the first element in the title nodes. */
    get titleElementText() {
      return this.titleNodes.length < 1 ? "" : this.titleNodes[0].innerText;
    }
    get flagSVG() {
      var t3;
      return (t3 = this.slottedFlag) != null ? t3 : this.shadowFlag;
    }
    /** Callback for on beacon-event-country-flag-change */
    onBeaconCountryFlagChange() {
    }
    static getFlagSVGFromTitle(t3) {
      const e5 = t3 == null ? void 0 : t3.toLowerCase(), { flagSVGs: i5 } = C$2;
      return i5.has(e5) ? d$9(i5.get(e5)) : d$9(i5.get(C$2.defaultFlag.selection));
    }
    handleTitleSlotchange() {
      this.title = this.titleElementText;
    }
    emitFlagChange() {
      L$6(
        this,
        g$a.COUNTRY_FLAG_CHANGE,
        void 0,
        this.onBeaconCountryFlagChange
      );
    }
    handleFlagSlotchange() {
      this.emitFlagChange();
    }
    renderFlagContainer() {
      return tt$1`<slot name="icon" @slotchange=${this.handleFlagSlotchange}
        >${A3.getFlagSVGFromTitle(this.title)}</slot
      >`;
    }
    /** HTML for the title container. */
    renderTitleContainer() {
      return tt$1`<div class="title">
        <slot name="title" @slotchange=${this.handleTitleSlotchange}></slot>
      </div>`;
    }
    postrenderFlagChange() {
      this.emitFlagChange();
    }
  };
  return l$1([
    a$8({ slot: "title" })
  ], A3.prototype, "titleNodes", 2), l$1([
    h$9("svg")
  ], A3.prototype, "shadowFlag", 2), l$1([
    k$a('[slot="icon"]')
  ], A3.prototype, "slottedFlag", 2), l$1([
    it()
  ], A3.prototype, "title", 2), l$1([
    d$e
  ], A3.prototype, "postrenderFlagChange", 1), A3 = l$1([
    f$8("Flags")
  ], A3), A3;
}
const x$2 = {
  beaconTagName: "beacon-country",
  get lightDOMStyleID() {
    return `${this.beaconTagName}-styles`;
  }
}, X = T$7`[beacon-tag-name=beacon-country]{--country-link-color: var(--navigation-popover-country-color, var(--beacon-system-color-text-link));font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-country] [slot=title]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-country] [slot=title] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-country] a{color:var(--country-link-color)}[beacon-tag-name=beacon-country] a:not([selected-language]){text-decoration:underline}[beacon-tag-name=beacon-country] [selected-language]{color:var(--beacon-system-color-text-link-active);text-decoration:none}`, N$2 = T$7`:host{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.header,.languages{align-items:center;display:flex;padding-block:var(--beacon-system-space-cell-free-floating)}.header{align-items:center;gap:var(--beacon-reference-space-3)}.languages{gap:var(--beacon-reference-space-5)}.title{color:var(--beacon-system-color-text-standard)}`;
var b$4 = Object.defineProperty, L$1 = Object.getOwnPropertyDescriptor, a$3 = (h2, A3, t3, e5) => {
  for (var i5 = e5 > 1 ? void 0 : e5 ? L$1(A3, t3) : A3, g2 = h2.length - 1, w2; g2 >= 0; g2--)
    (w2 = h2[g2]) && (i5 = (e5 ? w2(A3, t3, i5) : w2(i5)) || i5);
  return e5 && i5 && b$4(A3, t3, i5), i5;
};
const d$4 = class d extends B$5(Bt$3).with(
  J$1,
  f$3
) {
  constructor() {
    super(...arguments), this.beaconTagName = x$2.beaconTagName, this.reestSpacing = true, this.isExpanded = false, this.current = false, this.clonedLocation = "", this.cloned = false, this.eventAddedToNavItem = false, this.currentCountryCreated = false, this.handleBreakpointChanges = ({ matches: A3 }) => {
      A3 ? (this.clonedLocation === "popover" && this.slottedNavigationItem.setAttribute("opens", "country-selector"), this.clonedLocation === "navigation" && this.slottedNavigationItem.removeAttribute("opens")) : (this.clonedLocation === "navigation" && this.slottedNavigationItem.setAttribute("opens", "country-selector"), this.clonedLocation === "popover" && this.slottedNavigationItem.removeAttribute("opens"));
    }, this.addCurrentCountryFlag = () => {
      window.customElements.whenDefined(this.getScopedTagName("beacon-navigation-button")).then(() => {
        var A3;
        const t3 = document.querySelector(
          '[opens="site-selector"]'
        ), e5 = t3 == null ? void 0 : t3.querySelector('[slot="flag"]');
        if (t3 instanceof B$2 && !t3.hasCountryFlag) {
          if (!e5) {
            const i5 = (A3 = this.flagSVG) == null ? void 0 : A3.cloneNode(true);
            i5 == null || i5.setAttribute("slot", "flag"), t3 == null || t3.appendChild(i5);
          }
          t3.hasCountryFlag = true;
        }
      });
    };
  }
  static get styles() {
    return [super.styles, this.flagStyles, N$2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, X];
  }
  /** Callback for on beacon-event-language-select */
  onBeaconLanguageSelect() {
  }
  get selectedLanguage() {
    return this.selectedLanguages[0];
  }
  get slottedNavigationItem() {
    return this.navigationItems[0];
  }
  countryPreRender() {
    this.largeBreakpointWatcher.addEventListener(
      "change",
      this.handleBreakpointChanges
    );
  }
  /** Emits `beacon-event-language-select` from the given element. */
  emitLanguageSelect(A3) {
    L$6(
      A3,
      g$a.LANGUAGE_SELECT,
      void 0,
      this.onBeaconLanguageSelect
    );
  }
  /**
   * When countries are added to the default slot, we add click event listeners to each language link to emit a custom event.
   *
   * @see emitLanguageSelect
   */
  handleSlotchange() {
    var A3;
    (A3 = this.languages) == null || A3.forEach((t3) => {
      t3.dataset.hasBeaconLanguageEvent || (t3.addEventListener("click", () => {
        this.emitLanguageSelect(t3);
      }), t3.dataset.hasBeaconLanguageEvent = "");
    }), this.selectedLanguage && !this.current && (L$6(this, g$a.NAV_LANGUAGE_SELECT, {
      detail: {
        country: this
      }
    }), this.current = true);
  }
  createCurrentCountry(A3) {
    if (A3)
      return;
    const t3 = document.createElement("template");
    t3.innerHTML = `
    <${this.getScopedTagName("beacon-navigation-button")}
      expanded-anchor
      slot="country-navigation-button"
      opens="country-selector">
      ${this.title}
    </${this.getScopedTagName("beacon-navigation-button")}>
    `, this.querySelector('[opens="country-selector"]') || this.appendChild(t3.content.cloneNode(true)), this.cloned || (this.moveCurrentCountry(), this.alterCanonicalCountryAttributes()), this.currentCountryCreated = true;
  }
  moveCurrentCountry() {
    const A3 = document.querySelector("[country-selector]"), t3 = document.querySelector(
      this.getScopedTagName("beacon-navigation")
    );
    if (A3 && !A3.querySelector('[opens="country-selector"]')) {
      const e5 = this.cloneNode(true);
      e5.cloned = true, e5.clonedLocation = "popover", A3.appendChild(e5), this.addCurrentCountryFlag();
    }
    if (t3) {
      const e5 = this.cloneNode(true);
      e5.cloned = true, e5.setAttribute("slot", "country-selector"), e5.clonedLocation = "navigation", t3.appendChild(e5);
    }
  }
  alterCanonicalCountryAttributes() {
    var A3;
    this.style.display = "none", (A3 = this.slottedNavigationItem) == null || A3.removeAttribute("opens");
  }
  /**
   * Updates attributes on slotted cloned navigation buttons to maintain open and close functionality across breakpoints.
   *
   * We directly remove attributes instead of setting values with their props because the property route was not working as intended.
   */
  handleNavItemSlotchange() {
    var A3;
    this.slottedNavigationItem && (this.cloned || this.slottedNavigationItem.removeAttribute("opens"), this.isMobile && this.clonedLocation === "popover" && this.slottedNavigationItem.removeAttribute("opens"), this.isDesktop && this.clonedLocation === "navigation" && this.slottedNavigationItem.removeAttribute("opens"), this.eventAddedToNavItem || (A3 = this.slottedNavigationItem.button) == null || A3.addEventListener("click", () => {
      L$6(
        this.slottedNavigationItem.button,
        g$a.COUNTRY_SELECTOR_OPEN
      ), this.eventAddedToNavItem = true;
    }));
  }
  renderTitleContainer() {
    return this.current && !this.isExpanded ? (this.createCurrentCountry(this.currentCountryCreated), tt$1`
        <slot name="title" style="display: none;"></slot>
        <slot
          class="navigation-button-slot"
          name="country-navigation-button"
          @slotchange=${this.handleNavItemSlotchange}></slot>
      `) : super.renderTitleContainer();
  }
  render() {
    return tt$1`
      <div class="header">
        ${this.renderFlagContainer()} ${this.renderTitleContainer()}
      </div>
      <div class="languages">
        <slot @slotchange=${this.handleSlotchange}></slot>
      </div>
    `;
  }
};
d$4.tagName = x$2.beaconTagName;
let n$2 = d$4;
a$3([
  v$c({ type: Boolean, reflect: true, attribute: "is-expanded" })
], n$2.prototype, "isExpanded", 2);
a$3([
  v$c({ type: Boolean, reflect: true })
], n$2.prototype, "current", 2);
a$3([
  it()
], n$2.prototype, "clonedLocation", 2);
a$3([
  it()
], n$2.prototype, "cloned", 2);
a$3([
  it()
], n$2.prototype, "eventAddedToNavItem", 2);
a$3([
  it()
], n$2.prototype, "currentCountryCreated", 2);
a$3([
  v$9({ selector: "a", flatten: true })
], n$2.prototype, "languages", 2);
a$3([
  v$9({
    selector: "[selected-language]",
    flatten: true
  })
], n$2.prototype, "selectedLanguages", 2);
a$3([
  v$9({
    slot: "country-navigation-button",
    flatten: true
  })
], n$2.prototype, "navigationItems", 2);
a$3([
  u$2
], n$2.prototype, "countryPreRender", 1);
const $$2 = (h2) => (Se$3(h2, n$2), Dt$3({
  tagName: h2 ? h2 + "-" + n$2.tagName : n$2.tagName,
  elementClass: n$2,
  react: React,
  events: {
    onBeaconEventLanguageSelect: "beacon-event-language-select",
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const r$2 = (n4) => (Se$3(n4, B$2), Dt$3({
  tagName: n4 ? n4 + "-" + B$2.tagName : B$2.tagName,
  elementClass: B$2,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const r$1 = (n4) => (Se$3(n4, ee$3), Dt$3({
  tagName: n4 ? n4 + "-" + ee$3.tagName : ee$3.tagName,
  elementClass: ee$3,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const r = (n4) => (Se$3(n4, ue$3), Dt$3({
  tagName: n4 ? n4 + "-" + ue$3.tagName : ue$3.tagName,
  elementClass: ue$3,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const E$1 = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M8 14L12 10L16 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`, N$1 = `<svg class="icon--close" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z" fill="#0063AD"/>
</svg>
`, Z = `<svg class="icon--error" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Error">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.57752 11.0009C1.22025 11.6197 1.22025 12.3821 1.57752 13.0009L5.92282 20.5272C6.28009 21.146 6.94034 21.5272 7.65487 21.5272H16.3455C17.06 21.5272 17.7203 21.146 18.0775 20.5272L22.4228 13.0009C22.7801 12.3821 22.7801 11.6197 22.4228 11.0009L18.0775 3.47461C17.7203 2.85581 17.06 2.47461 16.3455 2.47461H7.65487C6.94034 2.47461 6.28008 2.85581 5.92282 3.47461L1.57752 11.0009ZM11.2502 7.75087C11.2502 7.33665 11.586 7.00087 12.0002 7.00087C12.4144 7.00087 12.7502 7.33665 12.7502 7.75087V12.2509C12.7502 12.6651 12.4144 13.0009 12.0002 13.0009C11.586 13.0009 11.2502 12.6651 11.2502 12.2509V7.75087ZM13.0002 16.0009C13.0002 16.5532 12.5525 17.0009 12.0002 17.0009C11.4479 17.0009 11.0002 16.5532 11.0002 16.0009C11.0002 15.4486 11.4479 15.0009 12.0002 15.0009C12.5525 15.0009 13.0002 15.4486 13.0002 16.0009Z" fill="#DD3636"/>
</svg>
`, A$3 = `<svg class="icon--informational" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Informational">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.75 16.25C12.75 16.6642 12.4142 17 12 17C11.5858 17 11.25 16.6642 11.25 16.25V11.75C11.25 11.3358 11.5858 11 12 11C12.4142 11 12.75 11.3358 12.75 11.75V16.25ZM11 8C11 7.44771 11.4477 7 12 7C12.5523 7 13 7.44771 13 8C13 8.55229 12.5523 9 12 9C11.4477 9 11 8.55229 11 8Z" fill="#0063AD"/>
</svg>
`, D$1 = `<svg class="icon--success" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Succcess">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.6081 9.43895C16.8506 9.10309 16.7748 8.6343 16.439 8.39187C16.1031 8.14944 15.6343 8.22519 15.3919 8.56105L10.8463 14.8586L8.52152 12.6092C8.22385 12.3211 7.74904 12.3289 7.46101 12.6266C7.17298 12.9243 7.1808 13.3991 7.47848 13.6871L10.4258 16.539C10.5823 16.6903 10.7967 16.7663 11.0135 16.7471C11.2303 16.7279 11.4281 16.6154 11.5555 16.439L16.6081 9.43895Z" fill="#248647"/>
</svg>
`, R = `<svg class="icon--warning" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Warning">
  <path d="M10.0652 3C10.835 1.66667 12.7595 1.66667 13.5293 3L21.3235 16.5C22.0933 17.8333 21.131 19.5 19.5914 19.5H4.00298C2.46338 19.5 1.50113 17.8333 2.27093 16.5L10.0652 3Z" fill="#FFC42D"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C11.5858 7 11.25 7.33579 11.25 7.75V12.25C11.25 12.6642 11.5858 13 12 13C12.4142 13 12.75 12.6642 12.75 12.25V7.75C12.75 7.33579 12.4142 7 12 7ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill="#061937"/>
</svg>
`, m$2 = {
  beaconTagName: "beacon-notification",
  nestedComponents: ["beacon-icon-button"]
}, T$2 = T$7`:host([motion-state=enabled][in-motion]) .motion-wrap,:host([collapsed]) .motion-wrap{overflow:hidden}`;
var I$2 = (e5, o2, i5, b5) => {
  for (var n4 = o2, r3 = e5.length - 1, s2; r3 >= 0; r3--)
    (s2 = e5[r3]) && (n4 = s2(n4) || n4);
  return n4;
};
function V(e5) {
  let o2 = class extends e5 {
    static get NotificationMotionStyles() {
      return [T$2];
    }
  };
  return o2 = I$2([
    f$8("NotificationMotion")
  ], o2), o2;
}
const j$1 = T$7`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{background-color:var(--notification-background-color, var(--beacon-component-notification-color-background-standard))}:host([variant=informational]){--notification-background-color: var(--beacon-component-notification-color-background-informational);--notification-border-color: var(--beacon-component-notification-color-border-informational)}:host([variant=warning]){--notification-background-color: var(--beacon-component-notification-color-background-warning);--notification-border-color: var(--beacon-component-notification-color-border-warning)}:host([variant=error]){--notification-background-color: var(--beacon-component-notification-color-background-error);--notification-border-color: var(--beacon-component-notification-color-border-error)}:host([variant=success]){--notification-background-color: var(--beacon-component-notification-color-background-success);--notification-border-color: var(--beacon-component-notification-color-border-success)}:host(:is([type=inline],[type=toast])){max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.base{margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);position:relative}.base .shell{display:grid;grid-column-gap:var(--beacon-reference-space-4);grid-template-columns:auto 1fr;grid-template-rows:auto;padding:var(--beacon-system-space-cell-contained)}.base .shell .icon{align-self:center;display:grid;grid-area:1}.base .shell .description{grid-area:2/2}.base .shell .action-zone{grid-area:3/2}.base .shell .chevron,.base .shell .close-wrapper{align-self:baseline;grid-area:1/3}.base .shell .title{align-self:center}.base .shell:has(.icon.hide-slot-area){grid-template-columns:1fr auto}.base .shell:has(.icon.hide-slot-area) .description{grid-area:2}.base .shell:has(.icon.hide-slot-area) .action-zone{grid-area:3}.base .shell:has(.icon.hide-slot-area) .chevron{grid-area:1/2}.base:not(.standard){color:var(--beacon-system-color-text-set-navy)}.base:not(.standard) ::part(icon-button){color:var(--beacon-reference-palette-functional-blue-3)}.base:is(.alert,.banner){padding-block:var(--beacon-system-space-organism-normal);padding-inline:var(--beacon-system-space-organism-maxi)}.base:is(.alert,.banner) .title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100)}.base:is(.alert,.banner) .description{margin-block-start:var(--beacon-reference-space-3)}.base:is(.alert,.banner) .action-zone{margin-block-start:var(--beacon-reference-space-5)}.base.inline{padding:var(--beacon-system-space-organism-normal)}.base.inline .shell,.base.inline .body{padding:var(--beacon-system-space-cell-contained)}.base.toast{box-shadow:var(--beacon-system-color-shadow-low);padding:var(--beacon-system-space-cell-contained)}.base.toast .shell{padding:var(--beacon-reference-space-2)}.base.toast .shell .icon{align-self:baseline}.base:is(.inline,.toast){border:var(--beacon-system-width-border-normal) solid var(--notification-border-color, var(--beacon-component-notification-color-border-standard));border-radius:var(--beacon-system-radius-corner-standard)}.base:is(.inline,.toast) .title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200)}.base:is(.inline,.toast) .description{margin-block-start:var(--beacon-reference-space-2)}.base:is(.inline,.toast) .action-zone{margin-block-start:var(--beacon-reference-space-3)}.base.banner:not(.expanded) .description,.base.banner:not(.expanded) .action-zone,.base.banner:not(.expanded) .body{margin:0;opacity:0}.base.banner .chevron{--active-bg: var(--beacon-system-color-background-primary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--beacon-system-color-border-secondary);--border-width: var(--beacon-system-width-border-mini);--default-size: var(--beacon-reference-space-9);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--beacon-system-color-background-primary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-primary);align-items:center;background-color:var(--override-icon-button-bg-color, var(--bg-color));block-size:var(--override-icon-button-wrapper-block-size, var(--beacon-reference-space-10));border:var(--border-width) solid var(--border-color);border-radius:var(--override-icon-button-border-radius, var(--beacon-system-radius-corner-circle));box-shadow:var(--override-icon-button-box-shadow, initial);color:var(--override-icon-button-color, var(--beacon-host-override-icon-button-color, var(--icon-color)));cursor:pointer;display:inline-flex;inline-size:var(--override-icon-button-wrapper-inline-size, var(--beacon-reference-space-10));justify-content:center;outline-offset:var(--override-icon-button-outline-offset);position:relative;--active-bg: var(--beacon-system-color-background-tertiary-pressed);--active-icon: var(--beacon-system-color-icon-tertiary-pressed);--bg-color: transparent;--default-hover-bg: var(--beacon-system-color-background-tertiary-hover);--default-hover-icon: var(--beacon-system-color-icon-tertiary-hover);--default-icon-color: var(--beacon-system-color-icon-tertiary);--disabled-bg: transparent;--disabled-icon: var(--beacon-system-color-icon-tertiary-inactive);--hover-bg: var(--override-icon-button-hover-bg, var(--default-hover-bg));--hover-icon: var(--override-icon-button-icon-color, var(--default-hover-icon));--icon-color: var(--override-icon-button-icon-color, var(--default-icon-color));border:0;transform:rotate(0);transition-duration:var(--beacon-reference-motion-duration-3);transition-property:transform}.base.banner .chevron .contents{align-items:inherit;display:inherit;justify-content:inherit;position:inherit}.base.banner .chevron[aria-disabled=true]{--icon-color: var(--disabled-icon);background-color:var(--disabled-bg);border-color:var(--disabled-border);color:var(--disabled-icon);cursor:not-allowed}.base.banner .chevron svg,.base.banner .chevron [beacon-tag-name=beacon-icon]{position:absolute}.base.banner .chevron:-webkit-direct-focus{outline:-webkit-focus-ring-color auto 0}.base.banner .chevron:hover:not([aria-disabled=true]){--icon-color: var(--hover-icon);background-color:var(--hover-bg);border-color:var(--hover-border);color:var(--hover-icon)}.base.banner .chevron:active:not([aria-disabled=true]){--icon-color: var(--active-icon);background-color:var(--active-bg);border-color:var(--active-border);color:var(--active-icon)}.base.banner.expanded .chevron{transform:rotate(180deg)}.base.banner:not(.standard) svg{color:var(--beacon-reference-palette-functional-blue-3)}.base.banner :is(.description,.body,.action-zone){display:grid;transition-property:var(--unroll-from-transition-direction);--unroll-from-transition-property: grid-template-rows;grid-template-rows:0fr;transition-duration:var(--beacon-reference-motion-duration-5);transition-property:margin,opacity;transition-timing-function:var(--beacon-system-motion-easing-accelerate-emphasize-1)}.base.banner :is(.description,.body,.action-zone) [class*=wrapper]{overflow:hidden}.base.banner.expanded :is(.description,.body,.action-zone){display:grid;grid-template-rows:1fr}.shell .icon{flex-shrink:0}.shell .icon svg,.shell .icon ::slotted(svg),.shell .icon ::slotted(img){max-block-size:var(--beacon-reference-space-7);max-inline-size:var(--beacon-reference-space-7)}.shell .content{flex-grow:1}.shell:has(.description.hide-slot-area):has(.action-zone.hide-slot-area){align-items:center}.description,.body{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}@media (width >= 1920px){.base:is(.banner,.alert){padding-inline:0}}`;
var P$3 = Object.defineProperty, H = Object.getOwnPropertyDescriptor, d$3 = (e5, o2, i5, b5) => {
  for (var n4 = b5 > 1 ? void 0 : b5 ? H(o2, i5) : o2, r3 = e5.length - 1, s2; r3 >= 0; r3--)
    (s2 = e5[r3]) && (n4 = (b5 ? s2(o2, i5, n4) : s2(n4)) || n4);
  return b5 && n4 && P$3(o2, i5, n4), n4;
}, l3;
const t$2 = (l3 = class extends B$5(Bt$3).with(
  L$3({ autoRemoveMotionClasses: false }),
  V
) {
  constructor() {
    super(...arguments), this.beaconTagName = m$2.beaconTagName, this.resetSpacing = true, this.type = "inline", this.variant = "standard", this.dismissable = false, this.collapsed = false;
  }
  static get styles() {
    return [super.styles, j$1, this.NotificationMotionStyles];
  }
  static renderIcon(e5) {
    if (e5 === "standard")
      return tt$1`
        <div class="icon" aria-hidden="true">
          <slot ${f$7({ useParent: true })} name="icon"></slot>
        </div>
      `;
    let o2 = tt$1``;
    switch (e5) {
      case "informational":
        o2 = tt$1`${d$9(A$3)}`;
        break;
      case "success":
        o2 = tt$1`${d$9(D$1)}`;
        break;
      case "warning":
        o2 = tt$1`${d$9(R)}`;
        break;
      case "error":
        o2 = tt$1`${d$9(Z)}`;
        break;
    }
    return tt$1`<div class="icon" aria-hidden="true">${o2}</div>`;
  }
  toggleCollapsed() {
    this.collapsed = !this.collapsed;
  }
  renderIconByType() {
    return this.type === "banner" ? tt$1`
        <button
          class="${f$6({
      chevron: true
    })}"
          aria-expanded="${String(!this.collapsed)}"
          aria-controls="description action-zone body"
          @click=${this.toggleCollapsed}>
          <span class="visually-hidden">Notification Details</span>
          ${d$9(E$1)}
        </button>
      ` : this.type === "toast" || this.dismissable ? kt$1`
        <div class="close-wrapper">
          <${this.getScopedTag("beacon-icon-button")} @beacon-event-click=${this.dismiss} class="close" variant="tertiary">${d$9(N$1)} Dismiss</${this.getScopedTag("beacon-icon-button")}>
        </div>
      ` : tt$1``;
  }
  renderBodySlot() {
    return this.type !== "toast" ? tt$1`
        <div
          class="body"
          id="body"
          ?inert=${e$6(this.inertContentStatus())}>
          <div class="motion-wrap">
            <slot name="body" ${f$7({ container: ".body" })}></slot>
          </div>
        </div>
      ` : tt$1``;
  }
  dismiss() {
    L$6(this, g$a.DISMISS), this.remove();
  }
  static getRelevantAriaRole(e5) {
    if (e5 === "inline")
      return "status";
  }
  addAnalyticsAttributes() {
    const e5 = this.type === "toast" ? "PU" : "ALRT";
    this.dataset.metricsLocation = e5;
  }
  /**
   * Non-standard notifications default to a light mode. This will find the closest variant of light mode and add it to the class list.
   */
  addLightModeClasses() {
    if (this.variant !== "standard") {
      const e5 = this.closest(
        '[class*="beacon-on-light"]'
      );
      if (e5) {
        const o2 = Array.from(e5.classList).find(
          (i5) => i5.startsWith("beacon-on-light")
        );
        this.classList.add(o2 != null ? o2 : "beacon-on-light");
      } else
        this.classList.add("beacon-on-light");
    }
  }
  inertContentStatus() {
    if (this.type === "banner" && this.collapsed) return true;
  }
  // aria-role is added to the most important text area since live regions read out text within as a single string
  // so semantics of an anchor link or button will not be noted
  render() {
    const e5 = {
      base: true,
      dismissable: this.dismissable || this.type === "toast",
      expanded: !this.collapsed
    };
    return e5[this.variant] = true, e5[this.type] = true, tt$1`
      <div class="${f$6(e5)}">
        <div
          class="shell"
          role="${e$6(
      l3.getRelevantAriaRole(this.type)
    )}">
          ${l3.renderIcon(this.variant)}
          <div class="title" id="title" role="heading" aria-level="2">
            <slot></slot>
          </div>
          <div
            class="description"
            id="description"
            ?inert=${e$6(this.inertContentStatus())}>
            <div class="motion-wrap">
              <slot
                name="description"
                ${f$7({ container: ".description" })}></slot>
            </div>
          </div>
          <div
            class="action-zone"
            id="action-zone"
            ?inert=${e$6(this.inertContentStatus())}>
            <div class="motion-wrap">
              <slot
                name="action-zone"
                ${f$7({ container: ".action-zone" })}></slot>
            </div>
          </div>
          ${this.renderIconByType()}
        </div>
        ${this.renderBodySlot()}
      </div>
    `;
  }
}, l3.tagName = m$2.beaconTagName, l3.nestedComponents = m$2.nestedComponents, l3);
d$3([
  v$c({ reflect: true })
], t$2.prototype, "type", 2);
d$3([
  v$c({ reflect: true })
], t$2.prototype, "variant", 2);
d$3([
  v$c({ type: Boolean })
], t$2.prototype, "dismissable", 2);
d$3([
  v$c({ type: Boolean, reflect: true })
], t$2.prototype, "collapsed", 2);
d$3([
  d$e
], t$2.prototype, "addAnalyticsAttributes", 1);
d$3([
  d$e
], t$2.prototype, "addLightModeClasses", 1);
let h$2 = t$2;
const G$1 = (e5) => (Se$3(e5, h$2), Dt$3({
  tagName: e5 ? e5 + "-" + h$2.tagName : h$2.tagName,
  elementClass: h$2,
  react: React,
  events: {
    onBeaconEventDismiss: "beacon-event-dismiss",
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const e$1 = {
  beaconTagName: "beacon-popover",
  beaconNestedComponents: ["beacon-icon-button"],
  iconButtonElementName: "beacon-icon-button",
  arrowSpaceMargin: "24px",
  arrowSizeInline: "12px",
  targetQuerySelector: ".popover-target",
  popoverWrapperQuerySelector: ".beacon-popover-wrapper",
  DATA_METRICS_LOCATION_POPOVER: "PU",
  DATA_METRICS_LOCATION_BODY: "BDY"
};
const w$1 = T$7`:host([motion-state=enabled]) .icon-button{--button-base-transition-duration: var(--beacon-reference-motion-duration-5);--scale-value: 1.1;transition-property:var(--button-base-transition-property),transform}:host([motion-state=enabled]) .icon-button:is(:hover,:active){transform:scale(var(--scale-value))}:host([motion-state=enabled]) .icon-button:is(:hover,:active) .contents{transform:scale(calc(1 / var(--scale-value)))}`;
var E = (e5, o2, c4, u2) => {
  for (var r3 = o2, n4 = e5.length - 1, a2; n4 >= 0; n4--)
    (a2 = e5[n4]) && (r3 = a2(r3) || r3);
  return r3;
};
function T$1(e5) {
  let o2 = class extends e5 {
    static get IconButtonMotionStyles() {
      return [w$1];
    }
  };
  return o2 = E([
    f$8("IconButtonMotion")
  ], o2), o2;
}
const C$1 = T$7`:host{display:var(--override-icon-button-display, inline-block)}.icon-button{--active-bg: var(--beacon-system-color-background-primary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--beacon-system-color-border-secondary);--border-width: var(--beacon-system-width-border-mini);--default-size: var(--beacon-reference-space-9);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--beacon-system-color-background-primary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-primary);align-items:center;background-color:var(--override-icon-button-bg-color, var(--bg-color));block-size:var(--override-icon-button-wrapper-block-size, var(--beacon-reference-space-10));border:var(--border-width) solid var(--border-color);border-radius:var(--override-icon-button-border-radius, var(--beacon-system-radius-corner-circle));box-shadow:var(--override-icon-button-box-shadow, initial);color:var(--override-icon-button-color, var(--beacon-host-override-icon-button-color, var(--icon-color)));cursor:pointer;display:inline-flex;inline-size:var(--override-icon-button-wrapper-inline-size, var(--beacon-reference-space-10));justify-content:center;outline-offset:var(--override-icon-button-outline-offset);position:relative;padding:var(--override-icon-button-padding, 0)}.icon-button .contents{align-items:inherit;display:inherit;justify-content:inherit;position:inherit}.icon-button[aria-disabled=true]{--icon-color: var(--disabled-icon);background-color:var(--disabled-bg);border-color:var(--disabled-border);color:var(--disabled-icon);cursor:not-allowed}.icon-button svg,.icon-button [beacon-tag-name=beacon-icon]{position:absolute}.icon-button:-webkit-direct-focus{outline:-webkit-focus-ring-color auto 0}.icon-button:hover:not([aria-disabled=true]){--icon-color: var(--hover-icon);background-color:var(--hover-bg);border-color:var(--hover-border);color:var(--hover-icon)}.icon-button:active:not([aria-disabled=true]){--icon-color: var(--active-icon);background-color:var(--active-bg);border-color:var(--active-border);color:var(--active-icon)}.icon-button.primary{--active-bg: var(--override-icon-button-bg-color-pressed, var(--default-active-bg));--active-icon: var(--beacon-system-color-icon-primary);--bg-color: var(--override-icon-button-bg-color, var(--default-bg));--default-active-bg: var(--beacon-system-color-background-primary-pressed);--default-bg: var(--beacon-system-color-background-primary);--default-hover-bg: var(--beacon-system-color-background-primary-hover);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--override-icon-button-bg-color-hover, var(--default-hover-bg));--hover-icon: var(--beacon-system-color-icon-primary);--icon-color: var(--beacon-system-color-icon-primary);border:0}.icon-button.secondary{--active-bg: var(--beacon-system-color-background-secondary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: transparent;--border-color: var(--beacon-system-color-border-secondary);--disabled-bg: transparent;--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-secondary-inactive);--hover-bg: var(--beacon-system-color-background-secondary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-secondary)}.icon-button.tertiary{--active-bg: var(--beacon-system-color-background-tertiary-pressed);--active-icon: var(--beacon-system-color-icon-tertiary-pressed);--bg-color: transparent;--default-hover-bg: var(--beacon-system-color-background-tertiary-hover);--default-hover-icon: var(--beacon-system-color-icon-tertiary-hover);--default-icon-color: var(--beacon-system-color-icon-tertiary);--disabled-bg: transparent;--disabled-icon: var(--beacon-system-color-icon-tertiary-inactive);--hover-bg: var(--override-icon-button-hover-bg, var(--default-hover-bg));--hover-icon: var(--override-icon-button-icon-color, var(--default-hover-icon));--icon-color: var(--override-icon-button-icon-color, var(--default-icon-color));border:0}`;
var I$1 = Object.defineProperty, M$2 = Object.getOwnPropertyDescriptor, A$2 = (e5, o2, c4, u2) => {
  for (var r3 = M$2(o2, c4), n4 = e5.length - 1, a2; n4 >= 0; n4--)
    (a2 = e5[n4]) && (r3 = a2(o2, c4, r3) || r3);
  return r3 && I$1(o2, c4, r3), r3;
};
const d$2 = "beacon-icon-button", v$1 = class v extends B$5(Yt$2).with(
  T$1
) {
  constructor() {
    super(...arguments), this.beaconTagName = d$2;
  }
  static get styles() {
    return [super.styles, C$1, this.IconButtonMotionStyles];
  }
  /**
   * Returns the closest beacon-popover parent to determine if the related data-metrics-location attribute should apply
   */
  get isPopoverChild() {
    return !!this.closest('[beacon-tag-name="beacon-popover"]');
  }
  applyDataMetricsLocation() {
    this.isPopoverChild && this.setAttribute(
      "data-metrics-location",
      e$1.DATA_METRICS_LOCATION_BODY
    );
  }
  /**
   * Render function for beacon-button if link-href propety is passed in to support links as buttons
   *
   * @returns {TemplateResult} returns an `<a>` tag styled as a button
   */
  renderAnchorTag() {
    var o2;
    return tt$1` <a
      part="icon-link"
      id="${e$6(this._passthroughs.attributes.get("id"))}"
      @click=${this.handleClick}
      href="${this.linkHref}"
      download="${e$6(this.linkDownload)}"
      target="${e$6(this.linkTarget)}"
      class="icon-button ${this.variant}"
      aria-disabled="${this.disabled}"
      aria-label="${(o2 = this.defaultSlotText) != null ? o2 : h$c}">
      <span class="contents">
        <slot name="icon" @slotchange=${this.handleIconSlotchange}></slot>
      </span>
    </a>`;
  }
  /**
   * Render function for beacon-button as a `<button>` element
   *
   * @returns {TemplateResult} returns a `<button>` tag as the template
   */
  renderButtonTag() {
    var o2;
    return tt$1`
      <button
        part="icon-button"
        id="${e$6(this._passthroughs.attributes.get("id"))}"
        @click=${this.handleClick}
        class="icon-button ${this.variant}"
        aria-disabled="${this.disabled}"
        aria-label="${(o2 = this.defaultSlotText) != null ? o2 : h$c}">
        <span class="contents">
          <slot name="icon" @slotchange=${this.handleIconSlotchange}></slot>
        </span>
      </button>
    `;
  }
  render() {
    return tt$1`<slot
        style="display: none"
        @slotchange=${() => {
      this.requestUpdate();
    }}></slot>
      ${r$b(
      this.linkHref,
      () => this.renderAnchorTag(),
      () => this.renderButtonTag()
    )}`;
  }
};
v$1.tagName = d$2;
let t$1 = v$1;
A$2([
  d$e
], t$1.prototype, "applyDataMetricsLocation");
const P$2 = (e5) => (Se$3(e5, t$1), Dt$3({
  tagName: e5 ? e5 + "-" + t$1.tagName : t$1.tagName,
  elementClass: t$1,
  react: React,
  events: {
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
var Ns = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ce(m3) {
  return m3 && m3.__esModule && Object.prototype.hasOwnProperty.call(m3, "default") ? m3.default : m3;
}
var Yi = { exports: {} };
(function(m3) {
  (function(H2, s2) {
    m3.exports ? (s2.default = s2, m3.exports = H2 && H2.document ? s2(H2) : s2) : (H2.Highcharts && H2.Highcharts.error(16, true), H2.Highcharts = s2(H2));
  })(typeof window < "u" ? window : Ns, function(H2) {
    var s2 = {};
    function at2(B3, K2, q2, it2) {
      !B3.hasOwnProperty(K2) && (B3[K2] = it2.apply(null, q2), H2 && typeof CustomEvent == "function" && H2.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: K2, module: B3[K2] } })));
    }
    return at2(s2, "Core/Globals.js", [], function() {
      var B3, K2;
      return (K2 = B3 || (B3 = {})).SVG_NS = "http://www.w3.org/2000/svg", K2.product = "Highcharts", K2.version = "11.4.8", K2.win = H2 !== void 0 ? H2 : {}, K2.doc = K2.win.document, K2.svg = K2.doc && K2.doc.createElementNS && !!K2.doc.createElementNS(K2.SVG_NS, "svg").createSVGRect, K2.userAgent = K2.win.navigator && K2.win.navigator.userAgent || "", K2.isChrome = K2.win.chrome, K2.isFirefox = K2.userAgent.indexOf("Firefox") !== -1, K2.isMS = /(edge|msie|trident)/i.test(K2.userAgent) && !K2.win.opera, K2.isSafari = !K2.isChrome && K2.userAgent.indexOf("Safari") !== -1, K2.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(K2.userAgent), K2.isWebKit = K2.userAgent.indexOf("AppleWebKit") !== -1, K2.deg2rad = 2 * Math.PI / 360, K2.hasBidiBug = K2.isFirefox && 4 > parseInt(K2.userAgent.split("Firefox/")[1], 10), K2.marginNames = ["plotTop", "marginRight", "marginBottom", "plotLeft"], K2.noop = function() {
      }, K2.supportsPassiveEvents = function() {
        let q2 = false;
        if (!K2.isMS) {
          let it2 = Object.defineProperty({}, "passive", { get: function() {
            q2 = true;
          } });
          K2.win.addEventListener && K2.win.removeEventListener && (K2.win.addEventListener("testPassive", K2.noop, it2), K2.win.removeEventListener("testPassive", K2.noop, it2));
        }
        return q2;
      }(), K2.charts = [], K2.composed = [], K2.dateFormats = {}, K2.seriesTypes = {}, K2.symbolSizes = {}, K2.chartCount = 0, B3;
    }), at2(s2, "Core/Utilities.js", [s2["Core/Globals.js"]], function(B3) {
      let K2, { charts: q2, doc: it2, win: rt2 } = B3;
      function tt2(t3, e5, n4, u2) {
        let a2 = e5 ? "Highcharts error" : "Highcharts warning";
        t3 === 32 && (t3 = `${a2}: Deprecated member`);
        let g2 = f2(t3), r3 = g2 ? `${a2} #${t3}: www.highcharts.com/errors/${t3}/` : t3.toString();
        if (u2 !== void 0) {
          let A3 = "";
          g2 && (r3 += "?"), L2(u2, function(N2, k3) {
            A3 += `
 - ${k3}: ${N2}`, g2 && (r3 += encodeURI(k3) + "=" + encodeURI(N2));
          }), r3 += A3;
        }
        y2(B3, "displayError", { chart: n4, code: t3, message: r3, params: u2 }, function() {
          if (e5) throw Error(r3);
          rt2.console && tt2.messages.indexOf(r3) === -1 && console.warn(r3);
        }), tt2.messages.push(r3);
      }
      function Z2(t3, e5) {
        return parseInt(t3, e5 || 10);
      }
      function X2(t3) {
        return typeof t3 == "string";
      }
      function O3(t3) {
        let e5 = Object.prototype.toString.call(t3);
        return e5 === "[object Array]" || e5 === "[object Array Iterator]";
      }
      function j3(t3, e5) {
        return !!t3 && typeof t3 == "object" && (!e5 || !O3(t3));
      }
      function d3(t3) {
        return j3(t3) && typeof t3.nodeType == "number";
      }
      function x2(t3) {
        let e5 = t3 && t3.constructor;
        return !!(j3(t3, true) && !d3(t3) && e5 && e5.name && e5.name !== "Object");
      }
      function f2(t3) {
        return typeof t3 == "number" && !isNaN(t3) && t3 < 1 / 0 && t3 > -1 / 0;
      }
      function C3(t3) {
        return t3 != null;
      }
      function o2(t3, e5, n4) {
        let u2, a2 = X2(e5) && !C3(n4), g2 = (r3, A3) => {
          C3(r3) ? t3.setAttribute(A3, r3) : a2 ? (u2 = t3.getAttribute(A3)) || A3 !== "class" || (u2 = t3.getAttribute(A3 + "Name")) : t3.removeAttribute(A3);
        };
        return X2(e5) ? g2(n4, e5) : L2(e5, g2), u2;
      }
      function p2(t3) {
        return O3(t3) ? t3 : [t3];
      }
      function b5(t3, e5) {
        let n4;
        for (n4 in t3 || (t3 = {}), e5) t3[n4] = e5[n4];
        return t3;
      }
      function h2() {
        let t3 = arguments, e5 = t3.length;
        for (let n4 = 0; n4 < e5; n4++) {
          let u2 = t3[n4];
          if (u2 != null) return u2;
        }
      }
      function c4(t3, e5) {
        b5(t3.style, e5);
      }
      function T2(t3) {
        return Math.pow(10, Math.floor(Math.log(t3) / Math.LN10));
      }
      function I3(t3, e5) {
        return t3 > 1e14 ? t3 : parseFloat(t3.toPrecision(e5 || 14));
      }
      tt2.messages = [], Math.easeInOutSine = function(t3) {
        return -0.5 * (Math.cos(Math.PI * t3) - 1);
      };
      let G2 = Array.prototype.find ? function(t3, e5) {
        return t3.find(e5);
      } : function(t3, e5) {
        let n4, u2 = t3.length;
        for (n4 = 0; n4 < u2; n4++) if (e5(t3[n4], n4)) return t3[n4];
      };
      function L2(t3, e5, n4) {
        for (let u2 in t3) Object.hasOwnProperty.call(t3, u2) && e5.call(n4 || t3[u2], t3[u2], u2, t3);
      }
      function l4(t3, e5, n4) {
        function u2(r3, A3) {
          let N2 = t3.removeEventListener;
          N2 && N2.call(t3, r3, A3, false);
        }
        function a2(r3) {
          let A3, N2;
          t3.nodeName && (e5 ? (A3 = {})[e5] = true : A3 = r3, L2(A3, function(k3, E2) {
            if (r3[E2]) for (N2 = r3[E2].length; N2--; ) u2(E2, r3[E2][N2].fn);
          }));
        }
        let g2 = typeof t3 == "function" && t3.prototype || t3;
        if (Object.hasOwnProperty.call(g2, "hcEvents")) {
          let r3 = g2.hcEvents;
          if (e5) {
            let A3 = r3[e5] || [];
            n4 ? (r3[e5] = A3.filter(function(N2) {
              return n4 !== N2.fn;
            }), u2(e5, n4)) : (a2(r3), r3[e5] = []);
          } else a2(r3), delete g2.hcEvents;
        }
      }
      function y2(t3, e5, n4, u2) {
        if (n4 = n4 || {}, it2.createEvent && (t3.dispatchEvent || t3.fireEvent && t3 !== B3)) {
          let a2 = it2.createEvent("Events");
          a2.initEvent(e5, true, true), n4 = b5(a2, n4), t3.dispatchEvent ? t3.dispatchEvent(n4) : t3.fireEvent(e5, n4);
        } else if (t3.hcEvents) {
          n4.target || b5(n4, { preventDefault: function() {
            n4.defaultPrevented = true;
          }, target: t3, type: e5 });
          let a2 = [], g2 = t3, r3 = false;
          for (; g2.hcEvents; ) Object.hasOwnProperty.call(g2, "hcEvents") && g2.hcEvents[e5] && (a2.length && (r3 = true), a2.unshift.apply(a2, g2.hcEvents[e5])), g2 = Object.getPrototypeOf(g2);
          r3 && a2.sort((A3, N2) => A3.order - N2.order), a2.forEach((A3) => {
            A3.fn.call(t3, n4) === false && n4.preventDefault();
          });
        }
        u2 && !n4.defaultPrevented && u2.call(t3, n4);
      }
      L2({ map: "map", each: "forEach", grep: "filter", reduce: "reduce", some: "some" }, function(t3, e5) {
        B3[e5] = function(n4) {
          return tt2(32, false, void 0, { [`Highcharts.${e5}`]: `use Array.${t3}` }), Array.prototype[t3].apply(n4, [].slice.call(arguments, 1));
        };
      });
      let i5 = function() {
        let t3 = Math.random().toString(36).substring(2, 9) + "-", e5 = 0;
        return function() {
          return "highcharts-" + (K2 ? "" : t3) + e5++;
        };
      }();
      return rt2.jQuery && (rt2.jQuery.fn.highcharts = function() {
        let t3 = [].slice.call(arguments);
        if (this[0]) return t3[0] ? (new B3[X2(t3[0]) ? t3.shift() : "Chart"](this[0], t3[0], t3[1]), this) : q2[o2(this[0], "data-highcharts-chart")];
      }), { addEvent: function(t3, e5, n4, u2 = {}) {
        let a2 = typeof t3 == "function" && t3.prototype || t3;
        Object.hasOwnProperty.call(a2, "hcEvents") || (a2.hcEvents = {});
        let g2 = a2.hcEvents;
        B3.Point && t3 instanceof B3.Point && t3.series && t3.series.chart && (t3.series.chart.runTrackerClick = true);
        let r3 = t3.addEventListener;
        r3 && r3.call(t3, e5, n4, !!B3.supportsPassiveEvents && { passive: u2.passive === void 0 ? e5.indexOf("touch") !== -1 : u2.passive, capture: false }), g2[e5] || (g2[e5] = []);
        let A3 = { fn: n4, order: typeof u2.order == "number" ? u2.order : 1 / 0 };
        return g2[e5].push(A3), g2[e5].sort((N2, k3) => N2.order - k3.order), function() {
          l4(t3, e5, n4);
        };
      }, arrayMax: function(t3) {
        let e5 = t3.length, n4 = t3[0];
        for (; e5--; ) t3[e5] > n4 && (n4 = t3[e5]);
        return n4;
      }, arrayMin: function(t3) {
        let e5 = t3.length, n4 = t3[0];
        for (; e5--; ) t3[e5] < n4 && (n4 = t3[e5]);
        return n4;
      }, attr: o2, clamp: function(t3, e5, n4) {
        return t3 > e5 ? t3 < n4 ? t3 : n4 : e5;
      }, clearTimeout: function(t3) {
        C3(t3) && clearTimeout(t3);
      }, correctFloat: I3, createElement: function(t3, e5, n4, u2, a2) {
        let g2 = it2.createElement(t3);
        return e5 && b5(g2, e5), a2 && c4(g2, { padding: "0", border: "none", margin: "0" }), n4 && c4(g2, n4), u2 && u2.appendChild(g2), g2;
      }, crisp: (t3, e5 = 0, n4) => {
        let u2 = e5 % 2 / 2, a2 = n4 ? -1 : 1;
        return (Math.round(t3 * a2 - u2) + u2) * a2;
      }, css: c4, defined: C3, destroyObjectProperties: function(t3, e5, n4) {
        L2(t3, function(u2, a2) {
          u2 !== e5 && u2 != null && u2.destroy && u2.destroy(), (u2 != null && u2.destroy || !n4) && delete t3[a2];
        });
      }, diffObjects: function(t3, e5, n4, u2) {
        let a2 = {};
        return function g2(r3, A3, N2, k3) {
          let E2 = n4 ? A3 : r3;
          L2(r3, function(R2, z2) {
            if (!k3 && u2 && u2.indexOf(z2) > -1 && A3[z2]) {
              R2 = p2(R2), N2[z2] = [];
              for (let Q2 = 0; Q2 < Math.max(R2.length, A3[z2].length); Q2++) A3[z2][Q2] && (R2[Q2] === void 0 ? N2[z2][Q2] = A3[z2][Q2] : (N2[z2][Q2] = {}, g2(R2[Q2], A3[z2][Q2], N2[z2][Q2], k3 + 1)));
            } else j3(R2, true) && !R2.nodeType ? (N2[z2] = O3(R2) ? [] : {}, g2(R2, A3[z2] || {}, N2[z2], k3 + 1), Object.keys(N2[z2]).length !== 0 || z2 === "colorAxis" && k3 === 0 || delete N2[z2]) : (r3[z2] !== A3[z2] || z2 in r3 && !(z2 in A3)) && z2 !== "__proto__" && z2 !== "constructor" && (N2[z2] = E2[z2]);
          });
        }(t3, e5, a2, 0), a2;
      }, discardElement: function(t3) {
        t3 && t3.parentElement && t3.parentElement.removeChild(t3);
      }, erase: function(t3, e5) {
        let n4 = t3.length;
        for (; n4--; ) if (t3[n4] === e5) {
          t3.splice(n4, 1);
          break;
        }
      }, error: tt2, extend: b5, extendClass: function(t3, e5) {
        let n4 = function() {
        };
        return n4.prototype = new t3(), b5(n4.prototype, e5), n4;
      }, find: G2, fireEvent: y2, getClosestDistance: function(t3, e5) {
        let n4, u2, a2, g2 = !e5;
        return t3.forEach((r3) => {
          if (r3.length > 1) for (a2 = r3.length - 1; a2 > 0; a2--) (u2 = r3[a2] - r3[a2 - 1]) < 0 && !g2 ? (e5 == null || e5(), e5 = void 0) : u2 && (n4 === void 0 || u2 < n4) && (n4 = u2);
        }), n4;
      }, getMagnitude: T2, getNestedProperty: function(t3, e5) {
        let n4 = t3.split(".");
        for (; n4.length && C3(e5); ) {
          let u2 = n4.shift();
          if (u2 === void 0 || u2 === "__proto__") return;
          if (u2 === "this") {
            let g2;
            return j3(e5) && (g2 = e5["@this"]), g2 != null ? g2 : e5;
          }
          let a2 = e5[u2];
          if (!C3(a2) || typeof a2 == "function" || typeof a2.nodeType == "number" || a2 === rt2) return;
          e5 = a2;
        }
        return e5;
      }, getStyle: function t3(e5, n4, u2) {
        let a2;
        if (n4 === "width") {
          let r3 = Math.min(e5.offsetWidth, e5.scrollWidth), A3 = e5.getBoundingClientRect && e5.getBoundingClientRect().width;
          return A3 < r3 && A3 >= r3 - 1 && (r3 = Math.floor(A3)), Math.max(0, r3 - (t3(e5, "padding-left", true) || 0) - (t3(e5, "padding-right", true) || 0));
        }
        if (n4 === "height") return Math.max(0, Math.min(e5.offsetHeight, e5.scrollHeight) - (t3(e5, "padding-top", true) || 0) - (t3(e5, "padding-bottom", true) || 0));
        let g2 = rt2.getComputedStyle(e5, void 0);
        return g2 && (a2 = g2.getPropertyValue(n4), h2(u2, n4 !== "opacity") && (a2 = Z2(a2))), a2;
      }, inArray: function(t3, e5, n4) {
        return tt2(32, false, void 0, { "Highcharts.inArray": "use Array.indexOf" }), e5.indexOf(t3, n4);
      }, insertItem: function(t3, e5) {
        let n4, u2 = t3.options.index, a2 = e5.length;
        for (n4 = t3.options.isInternal ? a2 : 0; n4 < a2 + 1; n4++) if (!e5[n4] || f2(u2) && u2 < h2(e5[n4].options.index, e5[n4]._i) || e5[n4].options.isInternal) {
          e5.splice(n4, 0, t3);
          break;
        }
        return n4;
      }, isArray: O3, isClass: x2, isDOMElement: d3, isFunction: function(t3) {
        return typeof t3 == "function";
      }, isNumber: f2, isObject: j3, isString: X2, keys: function(t3) {
        return tt2(32, false, void 0, { "Highcharts.keys": "use Object.keys" }), Object.keys(t3);
      }, merge: function() {
        let t3, e5 = arguments, n4 = {}, u2 = function(g2, r3) {
          return typeof g2 != "object" && (g2 = {}), L2(r3, function(A3, N2) {
            N2 !== "__proto__" && N2 !== "constructor" && (!j3(A3, true) || x2(A3) || d3(A3) ? g2[N2] = r3[N2] : g2[N2] = u2(g2[N2] || {}, A3));
          }), g2;
        };
        e5[0] === true && (n4 = e5[1], e5 = Array.prototype.slice.call(e5, 2));
        let a2 = e5.length;
        for (t3 = 0; t3 < a2; t3++) n4 = u2(n4, e5[t3]);
        return n4;
      }, normalizeTickInterval: function(t3, e5, n4, u2, a2) {
        let g2, r3 = t3;
        n4 = h2(n4, T2(t3));
        let A3 = t3 / n4;
        for (!e5 && (e5 = a2 ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], u2 === false && (n4 === 1 ? e5 = e5.filter(function(N2) {
          return N2 % 1 == 0;
        }) : n4 <= 0.1 && (e5 = [1 / n4]))), g2 = 0; g2 < e5.length && (r3 = e5[g2], (!a2 || !(r3 * n4 >= t3)) && (a2 || !(A3 <= (e5[g2] + (e5[g2 + 1] || e5[g2])) / 2))); g2++) ;
        return I3(r3 * n4, -Math.round(Math.log(1e-3) / Math.LN10));
      }, objectEach: L2, offset: function(t3) {
        let e5 = it2.documentElement, n4 = t3.parentElement || t3.parentNode ? t3.getBoundingClientRect() : { top: 0, left: 0, width: 0, height: 0 };
        return { top: n4.top + (rt2.pageYOffset || e5.scrollTop) - (e5.clientTop || 0), left: n4.left + (rt2.pageXOffset || e5.scrollLeft) - (e5.clientLeft || 0), width: n4.width, height: n4.height };
      }, pad: function(t3, e5, n4) {
        return Array((e5 || 2) + 1 - String(t3).replace("-", "").length).join(n4 || "0") + t3;
      }, pick: h2, pInt: Z2, pushUnique: function(t3, e5) {
        return 0 > t3.indexOf(e5) && !!t3.push(e5);
      }, relativeLength: function(t3, e5, n4) {
        return /%$/.test(t3) ? e5 * parseFloat(t3) / 100 + (n4 || 0) : parseFloat(t3);
      }, removeEvent: l4, replaceNested: function(t3, ...e5) {
        let n4, u2;
        do
          for (u2 of (n4 = t3, e5)) t3 = t3.replace(u2[0], u2[1]);
        while (t3 !== n4);
        return t3;
      }, splat: p2, stableSort: function(t3, e5) {
        let n4, u2, a2 = t3.length;
        for (u2 = 0; u2 < a2; u2++) t3[u2].safeI = u2;
        for (t3.sort(function(g2, r3) {
          return (n4 = e5(g2, r3)) === 0 ? g2.safeI - r3.safeI : n4;
        }), u2 = 0; u2 < a2; u2++) delete t3[u2].safeI;
      }, syncTimeout: function(t3, e5, n4) {
        return e5 > 0 ? setTimeout(t3, e5, n4) : (t3.call(0, n4), -1);
      }, timeUnits: { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5, month: 24192e5, year: 314496e5 }, uniqueKey: i5, useSerialIds: function(t3) {
        return K2 = h2(t3, K2);
      }, wrap: function(t3, e5, n4) {
        let u2 = t3[e5];
        t3[e5] = function() {
          let a2 = arguments, g2 = this;
          return n4.apply(this, [function() {
            return u2.apply(g2, arguments.length ? arguments : a2);
          }].concat([].slice.call(arguments)));
        };
      } };
    }), at2(s2, "Core/Chart/ChartDefaults.js", [], function() {
      return { alignThresholds: false, panning: { enabled: false, type: "x" }, styledMode: false, borderRadius: 0, colorCount: 10, allowMutatingData: true, ignoreHiddenSeries: true, spacing: [10, 10, 15, 10], resetZoomButton: { theme: {}, position: {} }, reflow: true, type: "line", zooming: { singleTouch: false, resetButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } } }, width: null, height: null, borderColor: "#334eff", backgroundColor: "#ffffff", plotBorderColor: "#cccccc" };
    }), at2(s2, "Core/Color/Palettes.js", [], function() {
      return { colors: ["#2caffe", "#544fc5", "#00e272", "#fe6a35", "#6b8abc", "#d568fb", "#2ee0ca", "#fa4b42", "#feb56a", "#91e8e1"] };
    }), at2(s2, "Core/Time.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { win: q2 } = B3, { defined: it2, error: rt2, extend: tt2, isNumber: Z2, isObject: X2, merge: O3, objectEach: j3, pad: d3, pick: x2, splat: f2, timeUnits: C3 } = K2, o2 = B3.isSafari && q2.Intl && q2.Intl.DateTimeFormat.prototype.formatRange, p2 = B3.isSafari && q2.Intl && !q2.Intl.DateTimeFormat.prototype.formatRange;
      class b5 {
        constructor(c4) {
          this.options = {}, this.useUTC = false, this.variableTimezone = false, this.Date = q2.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(c4);
        }
        get(c4, T2) {
          if (this.variableTimezone || this.timezoneOffset) {
            let I3 = T2.getTime(), G2 = I3 - this.getTimezoneOffset(T2);
            T2.setTime(G2);
            let L2 = T2["getUTC" + c4]();
            return T2.setTime(I3), L2;
          }
          return this.useUTC ? T2["getUTC" + c4]() : T2["get" + c4]();
        }
        set(c4, T2, I3) {
          if (this.variableTimezone || this.timezoneOffset) {
            if (c4 === "Milliseconds" || c4 === "Seconds" || c4 === "Minutes" && this.getTimezoneOffset(T2) % 36e5 == 0) return T2["setUTC" + c4](I3);
            let G2 = this.getTimezoneOffset(T2), L2 = T2.getTime() - G2;
            T2.setTime(L2), T2["setUTC" + c4](I3);
            let l4 = this.getTimezoneOffset(T2);
            return L2 = T2.getTime() + l4, T2.setTime(L2);
          }
          return this.useUTC || o2 && c4 === "FullYear" ? T2["setUTC" + c4](I3) : T2["set" + c4](I3);
        }
        update(c4 = {}) {
          let T2 = x2(c4.useUTC, true);
          this.options = c4 = O3(true, this.options, c4), this.Date = c4.Date || q2.Date || Date, this.useUTC = T2, this.timezoneOffset = T2 && c4.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = T2 && !!(c4.getTimezoneOffset || c4.timezone);
        }
        makeTime(c4, T2, I3, G2, L2, l4) {
          let y2, i5, t3;
          return this.useUTC ? (y2 = this.Date.UTC.apply(0, arguments), i5 = this.getTimezoneOffset(y2), y2 += i5, i5 !== (t3 = this.getTimezoneOffset(y2)) ? y2 += t3 - i5 : i5 - 36e5 !== this.getTimezoneOffset(y2 - 36e5) || p2 || (y2 -= 36e5)) : y2 = new this.Date(c4, T2, x2(I3, 1), x2(G2, 0), x2(L2, 0), x2(l4, 0)).getTime(), y2;
        }
        timezoneOffsetFunction() {
          let c4 = this, T2 = this.options, I3 = T2.getTimezoneOffset;
          return this.useUTC ? T2.timezone ? (G2) => {
            try {
              let L2 = `shortOffset,${T2.timezone || ""}`, [l4, y2, i5, t3, e5 = 0] = (b5.formatCache[L2] = b5.formatCache[L2] || Intl.DateTimeFormat("en", { timeZone: T2.timezone, timeZoneName: "shortOffset" })).format(G2).split(/(GMT|:)/).map(Number), n4 = -(36e5 * (i5 + e5 / 60));
              if (Z2(n4)) return n4;
            } catch {
              rt2(34);
            }
            return 0;
          } : this.useUTC && I3 ? (G2) => 6e4 * I3(G2.valueOf()) : () => 6e4 * (c4.timezoneOffset || 0) : (G2) => 6e4 * new Date(G2.toString()).getTimezoneOffset();
        }
        dateFormat(c4, T2, I3) {
          if (!it2(T2) || isNaN(T2)) return B3.defaultOptions.lang && B3.defaultOptions.lang.invalidDate || "";
          c4 = x2(c4, "%Y-%m-%d %H:%M:%S");
          let G2 = this, L2 = new this.Date(T2), l4 = this.get("Hours", L2), y2 = this.get("Day", L2), i5 = this.get("Date", L2), t3 = this.get("Month", L2), e5 = this.get("FullYear", L2), n4 = B3.defaultOptions.lang, u2 = n4 && n4.weekdays, a2 = n4 && n4.shortWeekdays;
          return j3(tt2({ a: a2 ? a2[y2] : u2[y2].substr(0, 3), A: u2[y2], d: d3(i5), e: d3(i5, 2, " "), w: y2, b: n4.shortMonths[t3], B: n4.months[t3], m: d3(t3 + 1), o: t3 + 1, y: e5.toString().substr(2, 2), Y: e5, H: d3(l4), k: l4, I: d3(l4 % 12 || 12), l: l4 % 12 || 12, M: d3(this.get("Minutes", L2)), p: l4 < 12 ? "AM" : "PM", P: l4 < 12 ? "am" : "pm", S: d3(this.get("Seconds", L2)), L: d3(Math.floor(T2 % 1e3), 3) }, B3.dateFormats), function(g2, r3) {
            for (; c4.indexOf("%" + r3) !== -1; ) c4 = c4.replace("%" + r3, typeof g2 == "function" ? g2.call(G2, T2) : g2);
          }), I3 ? c4.substr(0, 1).toUpperCase() + c4.substr(1) : c4;
        }
        resolveDTLFormat(c4) {
          return X2(c4, true) ? c4 : { main: (c4 = f2(c4))[0], from: c4[1], to: c4[2] };
        }
        getTimeTicks(c4, T2, I3, G2) {
          let L2, l4, y2, i5, t3 = this, e5 = t3.Date, n4 = [], u2 = {}, a2 = new e5(T2), g2 = c4.unitRange, r3 = c4.count || 1;
          if (G2 = x2(G2, 1), it2(T2)) {
            t3.set("Milliseconds", a2, g2 >= C3.second ? 0 : r3 * Math.floor(t3.get("Milliseconds", a2) / r3)), g2 >= C3.second && t3.set("Seconds", a2, g2 >= C3.minute ? 0 : r3 * Math.floor(t3.get("Seconds", a2) / r3)), g2 >= C3.minute && t3.set("Minutes", a2, g2 >= C3.hour ? 0 : r3 * Math.floor(t3.get("Minutes", a2) / r3)), g2 >= C3.hour && t3.set("Hours", a2, g2 >= C3.day ? 0 : r3 * Math.floor(t3.get("Hours", a2) / r3)), g2 >= C3.day && t3.set("Date", a2, g2 >= C3.month ? 1 : Math.max(1, r3 * Math.floor(t3.get("Date", a2) / r3))), g2 >= C3.month && (t3.set("Month", a2, g2 >= C3.year ? 0 : r3 * Math.floor(t3.get("Month", a2) / r3)), l4 = t3.get("FullYear", a2)), g2 >= C3.year && (l4 -= l4 % r3, t3.set("FullYear", a2, l4)), g2 === C3.week && (i5 = t3.get("Day", a2), t3.set("Date", a2, t3.get("Date", a2) - i5 + G2 + (i5 < G2 ? -7 : 0))), l4 = t3.get("FullYear", a2);
            let A3 = t3.get("Month", a2), N2 = t3.get("Date", a2), k3 = t3.get("Hours", a2);
            T2 = a2.getTime(), (t3.variableTimezone || !t3.useUTC) && it2(I3) && (y2 = I3 - T2 > 4 * C3.month || t3.getTimezoneOffset(T2) !== t3.getTimezoneOffset(I3));
            let E2 = a2.getTime();
            for (L2 = 1; E2 < I3; ) n4.push(E2), g2 === C3.year ? E2 = t3.makeTime(l4 + L2 * r3, 0) : g2 === C3.month ? E2 = t3.makeTime(l4, A3 + L2 * r3) : y2 && (g2 === C3.day || g2 === C3.week) ? E2 = t3.makeTime(l4, A3, N2 + L2 * r3 * (g2 === C3.day ? 1 : 7)) : y2 && g2 === C3.hour && r3 > 1 ? E2 = t3.makeTime(l4, A3, N2, k3 + L2 * r3) : E2 += g2 * r3, L2++;
            n4.push(E2), g2 <= C3.hour && n4.length < 1e4 && n4.forEach(function(R2) {
              R2 % 18e5 == 0 && t3.dateFormat("%H%M%S%L", R2) === "000000000" && (u2[R2] = "day");
            });
          }
          return n4.info = tt2(c4, { higherRanks: u2, totalRange: g2 * r3 }), n4;
        }
        getDateFormat(c4, T2, I3, G2) {
          let L2 = this.dateFormat("%m-%d %H:%M:%S.%L", T2), l4 = "01-01 00:00:00.000", y2 = { millisecond: 15, second: 12, minute: 9, hour: 6, day: 3 }, i5 = "millisecond", t3 = i5;
          for (i5 in C3) {
            if (c4 === C3.week && +this.dateFormat("%w", T2) === I3 && L2.substr(6) === l4.substr(6)) {
              i5 = "week";
              break;
            }
            if (C3[i5] > c4) {
              i5 = t3;
              break;
            }
            if (y2[i5] && L2.substr(y2[i5]) !== l4.substr(y2[i5])) break;
            i5 !== "week" && (t3 = i5);
          }
          return this.resolveDTLFormat(G2[i5]).main;
        }
      }
      return b5.formatCache = {}, b5;
    }), at2(s2, "Core/Defaults.js", [s2["Core/Chart/ChartDefaults.js"], s2["Core/Globals.js"], s2["Core/Color/Palettes.js"], s2["Core/Time.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2) {
      let { isTouchDevice: tt2 } = K2, { fireEvent: Z2, merge: X2 } = rt2, O3 = { colors: q2.colors, symbols: ["circle", "diamond", "square", "triangle", "triangle-down"], lang: { loading: "Loading...", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], decimalPoint: ".", numericSymbols: ["k", "M", "G", "T", "P", "E"], resetZoom: "Reset zoom", resetZoomTitle: "Reset zoom level 1:1", thousandsSep: " " }, global: { buttonTheme: { fill: "#f7f7f7", padding: 8, r: 2, stroke: "#cccccc", "stroke-width": 1, style: { color: "#333333", cursor: "pointer", fontSize: "0.8em", fontWeight: "normal" }, states: { hover: { fill: "#e6e6e6" }, select: { fill: "#e6e9ff", style: { color: "#000000", fontWeight: "bold" } }, disabled: { style: { color: "#cccccc" } } } } }, time: { Date: void 0, getTimezoneOffset: void 0, timezone: void 0, timezoneOffset: 0, useUTC: true }, chart: B3, title: { style: { color: "#333333", fontWeight: "bold" }, text: "Chart title", align: "center", margin: 15, widthAdjust: -44 }, subtitle: { style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "center", widthAdjust: -44 }, caption: { margin: 15, style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "left", verticalAlign: "bottom" }, plotOptions: {}, legend: { enabled: true, align: "center", alignColumns: true, className: "highcharts-no-tooltip", events: {}, layout: "horizontal", itemMarginBottom: 2, itemMarginTop: 2, labelFormatter: function() {
        return this.name;
      }, borderColor: "#999999", borderRadius: 0, navigation: { style: { fontSize: "0.8em" }, activeColor: "#0022ff", inactiveColor: "#cccccc" }, itemStyle: { color: "#333333", cursor: "pointer", fontSize: "0.8em", textDecoration: "none", textOverflow: "ellipsis" }, itemHoverStyle: { color: "#000000" }, itemHiddenStyle: { color: "#666666", textDecoration: "line-through" }, shadow: false, itemCheckboxStyle: { position: "absolute", width: "13px", height: "13px" }, squareSymbol: true, symbolPadding: 5, verticalAlign: "bottom", x: 0, y: 0, title: { style: { fontSize: "0.8em", fontWeight: "bold" } } }, loading: { labelStyle: { fontWeight: "bold", position: "relative", top: "45%" }, style: { position: "absolute", backgroundColor: "#ffffff", opacity: 0.5, textAlign: "center" } }, tooltip: { enabled: true, animation: { duration: 300, easing: (d3) => Math.sqrt(1 - Math.pow(d3 - 1, 2)) }, borderRadius: 3, dateTimeLabelFormats: { millisecond: "%A, %e %b, %H:%M:%S.%L", second: "%A, %e %b, %H:%M:%S", minute: "%A, %e %b, %H:%M", hour: "%A, %e %b, %H:%M", day: "%A, %e %b %Y", week: "Week from %A, %e %b %Y", month: "%B %Y", year: "%Y" }, footerFormat: "", headerShape: "callout", hideDelay: 500, padding: 8, shape: "callout", shared: false, snap: tt2 ? 25 : 10, headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>', pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>', backgroundColor: "#ffffff", borderWidth: void 0, shadow: true, stickOnContact: false, style: { color: "#333333", cursor: "default", fontSize: "0.8em" }, useHTML: false }, credits: { enabled: true, href: "https://www.highcharts.com?credits", position: { align: "right", x: -10, verticalAlign: "bottom", y: -5 }, style: { cursor: "pointer", color: "#999999", fontSize: "0.6em" }, text: "Highcharts.com" } };
      O3.chart.styledMode = false;
      let j3 = new it2(O3.time);
      return { defaultOptions: O3, defaultTime: j3, getOptions: function() {
        return O3;
      }, setOptions: function(d3) {
        return Z2(K2, "setOptions", { options: d3 }), X2(true, O3, d3), (d3.time || d3.global) && (K2.time ? K2.time.update(X2(O3.global, O3.time, d3.global, d3.time)) : K2.time = j3), O3;
      } };
    }), at2(s2, "Core/Color/Color.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { isNumber: q2, merge: it2, pInt: rt2 } = K2;
      class tt2 {
        static parse(X2) {
          return X2 ? new tt2(X2) : tt2.None;
        }
        constructor(X2) {
          let O3, j3, d3, x2;
          this.rgba = [NaN, NaN, NaN, NaN], this.input = X2;
          let f2 = B3.Color;
          if (f2 && f2 !== tt2) return new f2(X2);
          if (typeof X2 == "object" && X2.stops !== void 0) this.stops = X2.stops.map((C3) => new tt2(C3[1]));
          else if (typeof X2 == "string") {
            if (this.input = X2 = tt2.names[X2.toLowerCase()] || X2, X2.charAt(0) === "#") {
              let C3 = X2.length, o2 = parseInt(X2.substr(1), 16);
              C3 === 7 ? j3 = [(16711680 & o2) >> 16, (65280 & o2) >> 8, 255 & o2, 1] : C3 === 4 && (j3 = [(3840 & o2) >> 4 | (3840 & o2) >> 8, (240 & o2) >> 4 | 240 & o2, (15 & o2) << 4 | 15 & o2, 1]);
            }
            if (!j3) for (d3 = tt2.parsers.length; d3-- && !j3; ) (O3 = (x2 = tt2.parsers[d3]).regex.exec(X2)) && (j3 = x2.parse(O3));
          }
          j3 && (this.rgba = j3);
        }
        get(X2) {
          let O3 = this.input, j3 = this.rgba;
          if (typeof O3 == "object" && this.stops !== void 0) {
            let d3 = it2(O3);
            return d3.stops = [].slice.call(d3.stops), this.stops.forEach((x2, f2) => {
              d3.stops[f2] = [d3.stops[f2][0], x2.get(X2)];
            }), d3;
          }
          return j3 && q2(j3[0]) ? X2 !== "rgb" && (X2 || j3[3] !== 1) ? X2 === "a" ? `${j3[3]}` : "rgba(" + j3.join(",") + ")" : "rgb(" + j3[0] + "," + j3[1] + "," + j3[2] + ")" : O3;
        }
        brighten(X2) {
          let O3 = this.rgba;
          if (this.stops) this.stops.forEach(function(j3) {
            j3.brighten(X2);
          });
          else if (q2(X2) && X2 !== 0) for (let j3 = 0; j3 < 3; j3++) O3[j3] += rt2(255 * X2), O3[j3] < 0 && (O3[j3] = 0), O3[j3] > 255 && (O3[j3] = 255);
          return this;
        }
        setOpacity(X2) {
          return this.rgba[3] = X2, this;
        }
        tweenTo(X2, O3) {
          let j3 = this.rgba, d3 = X2.rgba;
          if (!q2(j3[0]) || !q2(d3[0])) return X2.input || "none";
          let x2 = d3[3] !== 1 || j3[3] !== 1;
          return (x2 ? "rgba(" : "rgb(") + Math.round(d3[0] + (j3[0] - d3[0]) * (1 - O3)) + "," + Math.round(d3[1] + (j3[1] - d3[1]) * (1 - O3)) + "," + Math.round(d3[2] + (j3[2] - d3[2]) * (1 - O3)) + (x2 ? "," + (d3[3] + (j3[3] - d3[3]) * (1 - O3)) : "") + ")";
        }
      }
      return tt2.names = { white: "#ffffff", black: "#000000" }, tt2.parsers = [{ regex: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?(?:\.\d+)?)\s*\)/, parse: function(Z2) {
        return [rt2(Z2[1]), rt2(Z2[2]), rt2(Z2[3]), parseFloat(Z2[4], 10)];
      } }, { regex: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/, parse: function(Z2) {
        return [rt2(Z2[1]), rt2(Z2[2]), rt2(Z2[3]), 1];
      } }], tt2.None = new tt2(""), tt2;
    }), at2(s2, "Core/Animation/Fx.js", [s2["Core/Color/Color.js"], s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { parse: it2 } = B3, { win: rt2 } = K2, { isNumber: tt2, objectEach: Z2 } = q2;
      class X2 {
        constructor(j3, d3, x2) {
          this.pos = NaN, this.options = d3, this.elem = j3, this.prop = x2;
        }
        dSetter() {
          let j3 = this.paths, d3 = j3 && j3[0], x2 = j3 && j3[1], f2 = this.now || 0, C3 = [];
          if (f2 !== 1 && d3 && x2)
            if (d3.length === x2.length && f2 < 1) for (let o2 = 0; o2 < x2.length; o2++) {
              let p2 = d3[o2], b5 = x2[o2], h2 = [];
              for (let c4 = 0; c4 < b5.length; c4++) {
                let T2 = p2[c4], I3 = b5[c4];
                tt2(T2) && tt2(I3) && !(b5[0] === "A" && (c4 === 4 || c4 === 5)) ? h2[c4] = T2 + f2 * (I3 - T2) : h2[c4] = I3;
              }
              C3.push(h2);
            }
            else C3 = x2;
          else C3 = this.toD || [];
          this.elem.attr("d", C3, void 0, true);
        }
        update() {
          let j3 = this.elem, d3 = this.prop, x2 = this.now, f2 = this.options.step;
          this[d3 + "Setter"] ? this[d3 + "Setter"]() : j3.attr ? j3.element && j3.attr(d3, x2, null, true) : j3.style[d3] = x2 + this.unit, f2 && f2.call(j3, x2, this);
        }
        run(j3, d3, x2) {
          let f2 = this, C3 = f2.options, o2 = function(h2) {
            return !o2.stopped && f2.step(h2);
          }, p2 = rt2.requestAnimationFrame || function(h2) {
            setTimeout(h2, 13);
          }, b5 = function() {
            for (let h2 = 0; h2 < X2.timers.length; h2++) X2.timers[h2]() || X2.timers.splice(h2--, 1);
            X2.timers.length && p2(b5);
          };
          j3 !== d3 || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +/* @__PURE__ */ new Date(), this.start = j3, this.end = d3, this.unit = x2, this.now = this.start, this.pos = 0, o2.elem = this.elem, o2.prop = this.prop, o2() && X2.timers.push(o2) === 1 && p2(b5)) : (delete C3.curAnim[this.prop], C3.complete && Object.keys(C3.curAnim).length === 0 && C3.complete.call(this.elem));
        }
        step(j3) {
          let d3, x2, f2 = +/* @__PURE__ */ new Date(), C3 = this.options, o2 = this.elem, p2 = C3.complete, b5 = C3.duration, h2 = C3.curAnim;
          return o2.attr && !o2.element ? d3 = false : j3 || f2 >= b5 + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), h2[this.prop] = true, x2 = true, Z2(h2, function(c4) {
            c4 !== true && (x2 = false);
          }), x2 && p2 && p2.call(o2), d3 = false) : (this.pos = C3.easing((f2 - this.startTime) / b5), this.now = this.start + (this.end - this.start) * this.pos, this.update(), d3 = true), d3;
        }
        initPath(j3, d3, x2) {
          let f2 = j3.startX, C3 = j3.endX, o2 = x2.slice(), p2 = j3.isArea, b5 = p2 ? 2 : 1, h2 = d3 && x2.length > d3.length && x2.hasStackedCliffs, c4, T2, I3, G2, L2 = d3 && d3.slice();
          if (!L2 || h2) return [o2, o2];
          function l4(i5, t3) {
            for (; i5.length < T2; ) {
              let e5 = i5[0], n4 = t3[T2 - i5.length];
              if (n4 && e5[0] === "M" && (n4[0] === "C" ? i5[0] = ["C", e5[1], e5[2], e5[1], e5[2], e5[1], e5[2]] : i5[0] = ["L", e5[1], e5[2]]), i5.unshift(e5), p2) {
                let u2 = i5.pop();
                i5.push(i5[i5.length - 1], u2);
              }
            }
          }
          function y2(i5) {
            for (; i5.length < T2; ) {
              let t3 = i5[Math.floor(i5.length / b5) - 1].slice();
              if (t3[0] === "C" && (t3[1] = t3[5], t3[2] = t3[6]), p2) {
                let e5 = i5[Math.floor(i5.length / b5)].slice();
                i5.splice(i5.length / 2, 0, t3, e5);
              } else i5.push(t3);
            }
          }
          if (f2 && C3 && C3.length) {
            for (I3 = 0; I3 < f2.length; I3++) {
              if (f2[I3] === C3[0]) {
                c4 = I3;
                break;
              }
              if (f2[0] === C3[C3.length - f2.length + I3]) {
                c4 = I3, G2 = true;
                break;
              }
              if (f2[f2.length - 1] === C3[C3.length - f2.length + I3]) {
                c4 = f2.length - I3;
                break;
              }
            }
            c4 === void 0 && (L2 = []);
          }
          return L2.length && tt2(c4) && (T2 = o2.length + c4 * b5, G2 ? (l4(L2, o2), y2(o2)) : (l4(o2, L2), y2(L2))), [L2, o2];
        }
        fillSetter() {
          X2.prototype.strokeSetter.apply(this, arguments);
        }
        strokeSetter() {
          this.elem.attr(this.prop, it2(this.start).tweenTo(it2(this.end), this.pos), void 0, true);
        }
      }
      return X2.timers = [], X2;
    }), at2(s2, "Core/Animation/AnimationUtilities.js", [s2["Core/Animation/Fx.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { defined: q2, getStyle: it2, isArray: rt2, isNumber: tt2, isObject: Z2, merge: X2, objectEach: O3, pick: j3 } = K2;
      function d3(f2) {
        return Z2(f2) ? X2({ duration: 500, defer: 0 }, f2) : { duration: f2 ? 500 : 0, defer: 0 };
      }
      function x2(f2, C3) {
        let o2 = B3.timers.length;
        for (; o2--; ) B3.timers[o2].elem !== f2 || C3 && C3 !== B3.timers[o2].prop || (B3.timers[o2].stopped = true);
      }
      return { animate: function(f2, C3, o2) {
        let p2, b5 = "", h2, c4, T2;
        Z2(o2) || (T2 = arguments, o2 = { duration: T2[2], easing: T2[3], complete: T2[4] }), tt2(o2.duration) || (o2.duration = 400), o2.easing = typeof o2.easing == "function" ? o2.easing : Math[o2.easing] || Math.easeInOutSine, o2.curAnim = X2(C3), O3(C3, function(I3, G2) {
          x2(f2, G2), c4 = new B3(f2, o2, G2), h2 = void 0, G2 === "d" && rt2(C3.d) ? (c4.paths = c4.initPath(f2, f2.pathArray, C3.d), c4.toD = C3.d, p2 = 0, h2 = 1) : f2.attr ? p2 = f2.attr(G2) : (p2 = parseFloat(it2(f2, G2)) || 0, G2 !== "opacity" && (b5 = "px")), h2 || (h2 = I3), typeof h2 == "string" && h2.match("px") && (h2 = h2.replace(/px/g, "")), c4.run(p2, h2, b5);
        });
      }, animObject: d3, getDeferredAnimation: function(f2, C3, o2) {
        let p2 = d3(C3), b5 = o2 ? [o2] : f2.series, h2 = 0, c4 = 0;
        return b5.forEach((T2) => {
          let I3 = d3(T2.options.animation);
          h2 = Z2(C3) && q2(C3.defer) ? p2.defer : Math.max(h2, I3.duration + I3.defer), c4 = Math.min(p2.duration, I3.duration);
        }), f2.renderer.forExport && (h2 = 0), { defer: Math.max(0, h2 - c4), duration: Math.min(h2, c4) };
      }, setAnimation: function(f2, C3) {
        C3.renderer.globalAnimation = j3(f2, C3.options.chart.animation, true);
      }, stop: x2 };
    }), at2(s2, "Core/Renderer/HTML/AST.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { SVG_NS: q2, win: it2 } = B3, { attr: rt2, createElement: tt2, css: Z2, error: X2, isFunction: O3, isString: j3, objectEach: d3, splat: x2 } = K2, { trustedTypes: f2 } = it2, C3 = f2 && O3(f2.createPolicy) && f2.createPolicy("highcharts", { createHTML: (h2) => h2 }), o2 = C3 ? C3.createHTML("") : "", p2 = function() {
        try {
          return !!new DOMParser().parseFromString(o2, "text/html");
        } catch {
          return false;
        }
      }();
      class b5 {
        static filterUserAttributes(c4) {
          return d3(c4, (T2, I3) => {
            let G2 = true;
            b5.allowedAttributes.indexOf(I3) === -1 && (G2 = false), ["background", "dynsrc", "href", "lowsrc", "src"].indexOf(I3) !== -1 && (G2 = j3(T2) && b5.allowedReferences.some((L2) => T2.indexOf(L2) === 0)), G2 || (X2(33, false, void 0, { "Invalid attribute in config": `${I3}` }), delete c4[I3]), j3(T2) && c4[I3] && (c4[I3] = T2.replace(/</g, "&lt;"));
          }), c4;
        }
        static parseStyle(c4) {
          return c4.split(";").reduce((T2, I3) => {
            let G2 = I3.split(":").map((l4) => l4.trim()), L2 = G2.shift();
            return L2 && G2.length && (T2[L2.replace(/-([a-z])/g, (l4) => l4[1].toUpperCase())] = G2.join(":")), T2;
          }, {});
        }
        static setElementHTML(c4, T2) {
          c4.innerHTML = b5.emptyHTML, T2 && new b5(T2).addToDOM(c4);
        }
        constructor(c4) {
          this.nodes = typeof c4 == "string" ? this.parseMarkup(c4) : c4;
        }
        addToDOM(c4) {
          return function T2(I3, G2) {
            let L2;
            return x2(I3).forEach(function(l4) {
              let y2, i5 = l4.tagName, t3 = l4.textContent ? B3.doc.createTextNode(l4.textContent) : void 0, e5 = b5.bypassHTMLFiltering;
              if (i5)
                if (i5 === "#text") y2 = t3;
                else if (b5.allowedTags.indexOf(i5) !== -1 || e5) {
                  let n4 = i5 === "svg" ? q2 : G2.namespaceURI || q2, u2 = B3.doc.createElementNS(n4, i5), a2 = l4.attributes || {};
                  d3(l4, function(g2, r3) {
                    r3 !== "tagName" && r3 !== "attributes" && r3 !== "children" && r3 !== "style" && r3 !== "textContent" && (a2[r3] = g2);
                  }), rt2(u2, e5 ? a2 : b5.filterUserAttributes(a2)), l4.style && Z2(u2, l4.style), t3 && u2.appendChild(t3), T2(l4.children || [], u2), y2 = u2;
                } else X2(33, false, void 0, { "Invalid tagName in config": i5 });
              y2 && G2.appendChild(y2), L2 = y2;
            }), L2;
          }(this.nodes, c4);
        }
        parseMarkup(c4) {
          let T2, I3 = [];
          if (c4 = c4.trim().replace(/ style=(["'])/g, " data-style=$1"), p2) T2 = new DOMParser().parseFromString(C3 ? C3.createHTML(c4) : c4, "text/html");
          else {
            let L2 = tt2("div");
            L2.innerHTML = c4, T2 = { body: L2 };
          }
          let G2 = (L2, l4) => {
            let y2 = L2.nodeName.toLowerCase(), i5 = { tagName: y2 };
            y2 === "#text" && (i5.textContent = L2.textContent || "");
            let t3 = L2.attributes;
            if (t3) {
              let e5 = {};
              [].forEach.call(t3, (n4) => {
                n4.name === "data-style" ? i5.style = b5.parseStyle(n4.value) : e5[n4.name] = n4.value;
              }), i5.attributes = e5;
            }
            if (L2.childNodes.length) {
              let e5 = [];
              [].forEach.call(L2.childNodes, (n4) => {
                G2(n4, e5);
              }), e5.length && (i5.children = e5);
            }
            l4.push(i5);
          };
          return [].forEach.call(T2.body.childNodes, (L2) => G2(L2, I3)), I3;
        }
      }
      return b5.allowedAttributes = ["alt", "aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup", "aria-hidden", "aria-label", "aria-labelledby", "aria-live", "aria-pressed", "aria-readonly", "aria-roledescription", "aria-selected", "class", "clip-path", "color", "colspan", "cx", "cy", "d", "dx", "dy", "disabled", "fill", "filterUnits", "flood-color", "flood-opacity", "height", "href", "id", "in", "in2", "markerHeight", "markerWidth", "offset", "opacity", "operator", "orient", "padding", "paddingLeft", "paddingRight", "patternUnits", "r", "radius", "refX", "refY", "role", "scope", "slope", "src", "startOffset", "stdDeviation", "stroke", "stroke-linecap", "stroke-width", "style", "tableValues", "result", "rowspan", "summary", "target", "tabindex", "text-align", "text-anchor", "textAnchor", "textLength", "title", "type", "valign", "width", "x", "x1", "x2", "xlink:href", "y", "y1", "y2", "zIndex"], b5.allowedReferences = ["https://", "http://", "mailto:", "/", "../", "./", "#"], b5.allowedTags = ["a", "abbr", "b", "br", "button", "caption", "circle", "clipPath", "code", "dd", "defs", "div", "dl", "dt", "em", "feComponentTransfer", "feComposite", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feMorphology", "feOffset", "feMerge", "feMergeNode", "filter", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "li", "linearGradient", "marker", "ol", "p", "path", "pattern", "pre", "rect", "small", "span", "stop", "strong", "style", "sub", "sup", "svg", "table", "text", "textPath", "thead", "title", "tbody", "tspan", "td", "th", "tr", "u", "ul", "#text"], b5.emptyHTML = o2, b5.bypassHTMLFiltering = false, b5;
    }), at2(s2, "Core/Templating.js", [s2["Core/Defaults.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { defaultOptions: q2, defaultTime: it2 } = B3, { extend: rt2, getNestedProperty: tt2, isArray: Z2, isNumber: X2, isObject: O3, pick: j3, pInt: d3 } = K2, x2 = { add: (o2, p2) => o2 + p2, divide: (o2, p2) => p2 !== 0 ? o2 / p2 : "", eq: (o2, p2) => o2 == p2, each: function(o2) {
        let p2 = arguments[arguments.length - 1];
        return !!Z2(o2) && o2.map((b5, h2) => f2(p2.body, rt2(O3(b5) ? b5 : { "@this": b5 }, { "@index": h2, "@first": h2 === 0, "@last": h2 === o2.length - 1 }))).join("");
      }, ge: (o2, p2) => o2 >= p2, gt: (o2, p2) => o2 > p2, if: (o2) => !!o2, le: (o2, p2) => o2 <= p2, lt: (o2, p2) => o2 < p2, multiply: (o2, p2) => o2 * p2, ne: (o2, p2) => o2 != p2, subtract: (o2, p2) => o2 - p2, unless: (o2) => !o2 };
      function f2(o2 = "", p2, b5) {
        let h2 = /\{([\w\:\.\,;\-\/<>%@"'’= #\(\)]+)\}/g, c4 = /\(([\w\:\.\,;\-\/<>%@"'= ]+)\)/g, T2 = [], I3 = /f$/, G2 = /\.(\d)/, L2 = q2.lang, l4 = b5 && b5.time || it2, y2 = b5 && b5.numberFormatter || C3, i5 = (a2 = "") => {
          let g2;
          return a2 === "true" || a2 !== "false" && ((g2 = Number(a2)).toString() === a2 ? g2 : tt2(a2, p2));
        }, t3, e5, n4 = 0, u2;
        for (; (t3 = h2.exec(o2)) !== null; ) {
          let a2 = c4.exec(t3[1]);
          a2 && (t3 = a2, u2 = true), e5 && e5.isBlock || (e5 = { ctx: p2, expression: t3[1], find: t3[0], isBlock: t3[1].charAt(0) === "#", start: t3.index, startInner: t3.index + t3[0].length, length: t3[0].length });
          let g2 = t3[1].split(" ")[0].replace("#", "");
          x2[g2] && (e5.isBlock && g2 === e5.fn && n4++, e5.fn || (e5.fn = g2));
          let r3 = t3[1] === "else";
          if (e5.isBlock && e5.fn && (t3[1] === `/${e5.fn}` || r3))
            if (n4) !r3 && n4--;
            else {
              let A3 = e5.startInner, N2 = o2.substr(A3, t3.index - A3);
              e5.body === void 0 ? (e5.body = N2, e5.startInner = t3.index + t3[0].length) : e5.elseBody = N2, e5.find += N2 + t3[0], r3 || (T2.push(e5), e5 = void 0);
            }
          else e5.isBlock || T2.push(e5);
          if (a2 && !(e5 != null && e5.isBlock)) break;
        }
        return T2.forEach((a2) => {
          let g2, r3, { body: A3, elseBody: N2, expression: k3, fn: E2 } = a2;
          if (E2) {
            let R2 = [a2], z2 = k3.split(" ");
            for (r3 = x2[E2].length; r3--; ) R2.unshift(i5(z2[r3 + 1]));
            g2 = x2[E2].apply(p2, R2), a2.isBlock && typeof g2 == "boolean" && (g2 = f2(g2 ? A3 : N2, p2, b5));
          } else {
            let R2 = k3.split(":");
            if (g2 = i5(R2.shift() || ""), R2.length && typeof g2 == "number") {
              let z2 = R2.join(":");
              if (I3.test(z2)) {
                let Q2 = parseInt((z2.match(G2) || ["", "-1"])[1], 10);
                g2 !== null && (g2 = y2(g2, Q2, L2.decimalPoint, z2.indexOf(",") > -1 ? L2.thousandsSep : ""));
              } else g2 = l4.dateFormat(z2, g2);
            }
          }
          o2 = o2.replace(a2.find, j3(g2, ""));
        }), u2 ? f2(o2, p2, b5) : o2;
      }
      function C3(o2, p2, b5, h2) {
        let c4, T2;
        o2 = +o2 || 0, p2 = +p2;
        let I3 = q2.lang, G2 = (o2.toString().split(".")[1] || "").split("e")[0].length, L2 = o2.toString().split("e"), l4 = p2;
        p2 === -1 ? p2 = Math.min(G2, 20) : X2(p2) ? p2 && L2[1] && L2[1] < 0 && ((T2 = p2 + +L2[1]) >= 0 ? (L2[0] = (+L2[0]).toExponential(T2).split("e")[0], p2 = T2) : (L2[0] = L2[0].split(".")[0] || 0, o2 = p2 < 20 ? (L2[0] * Math.pow(10, L2[1])).toFixed(p2) : 0, L2[1] = 0)) : p2 = 2;
        let y2 = (Math.abs(L2[1] ? L2[0] : o2) + Math.pow(10, -Math.max(p2, G2) - 1)).toFixed(p2), i5 = String(d3(y2)), t3 = i5.length > 3 ? i5.length % 3 : 0;
        return b5 = j3(b5, I3.decimalPoint), h2 = j3(h2, I3.thousandsSep), c4 = (o2 < 0 ? "-" : "") + (t3 ? i5.substr(0, t3) + h2 : ""), 0 > +L2[1] && !l4 ? c4 = "0" : c4 += i5.substr(t3).replace(/(\d{3})(?=\d)/g, "$1" + h2), p2 ? c4 += b5 + y2.slice(-p2) : +c4 == 0 && (c4 = "0"), L2[1] && +c4 != 0 && (c4 += "e" + L2[1]), c4;
      }
      return { dateFormat: function(o2, p2, b5) {
        return it2.dateFormat(o2, p2, b5);
      }, format: f2, helpers: x2, numberFormat: C3 };
    }), at2(s2, "Core/Renderer/RendererRegistry.js", [s2["Core/Globals.js"]], function(B3) {
      var K2, q2;
      let it2;
      return (q2 = K2 || (K2 = {})).rendererTypes = {}, q2.getRendererType = function(rt2 = it2) {
        return q2.rendererTypes[rt2] || q2.rendererTypes[it2];
      }, q2.registerRendererType = function(rt2, tt2, Z2) {
        q2.rendererTypes[rt2] = tt2, (!it2 || Z2) && (it2 = rt2, B3.Renderer = tt2);
      }, K2;
    }), at2(s2, "Core/Renderer/RendererUtilities.js", [s2["Core/Utilities.js"]], function(B3) {
      var K2;
      let { clamp: q2, pick: it2, pushUnique: rt2, stableSort: tt2 } = B3;
      return (K2 || (K2 = {})).distribute = function Z2(X2, O3, j3) {
        let d3 = X2, x2 = d3.reducedLen || O3, f2 = (i5, t3) => i5.target - t3.target, C3 = [], o2 = X2.length, p2 = [], b5 = C3.push, h2, c4, T2, I3 = true, G2, L2, l4 = 0, y2;
        for (h2 = o2; h2--; ) l4 += X2[h2].size;
        if (l4 > x2) {
          for (tt2(X2, (i5, t3) => (t3.rank || 0) - (i5.rank || 0)), T2 = (y2 = X2[0].rank === X2[X2.length - 1].rank) ? o2 / 2 : -1, c4 = y2 ? T2 : o2 - 1; T2 && l4 > x2; ) G2 = X2[h2 = Math.floor(c4)], rt2(p2, h2) && (l4 -= G2.size), c4 += T2, y2 && c4 >= X2.length && (T2 /= 2, c4 = T2);
          p2.sort((i5, t3) => t3 - i5).forEach((i5) => b5.apply(C3, X2.splice(i5, 1)));
        }
        for (tt2(X2, f2), X2 = X2.map((i5) => ({ size: i5.size, targets: [i5.target], align: it2(i5.align, 0.5) })); I3; ) {
          for (h2 = X2.length; h2--; ) G2 = X2[h2], L2 = (Math.min.apply(0, G2.targets) + Math.max.apply(0, G2.targets)) / 2, G2.pos = q2(L2 - G2.size * G2.align, 0, O3 - G2.size);
          for (h2 = X2.length, I3 = false; h2--; ) h2 > 0 && X2[h2 - 1].pos + X2[h2 - 1].size > X2[h2].pos && (X2[h2 - 1].size += X2[h2].size, X2[h2 - 1].targets = X2[h2 - 1].targets.concat(X2[h2].targets), X2[h2 - 1].align = 0.5, X2[h2 - 1].pos + X2[h2 - 1].size > O3 && (X2[h2 - 1].pos = O3 - X2[h2 - 1].size), X2.splice(h2, 1), I3 = true);
        }
        return b5.apply(d3, C3), h2 = 0, X2.some((i5) => {
          let t3 = 0;
          return (i5.targets || []).some(() => (d3[h2].pos = i5.pos + t3, j3 !== void 0 && Math.abs(d3[h2].pos - d3[h2].target) > j3 ? (d3.slice(0, h2 + 1).forEach((e5) => delete e5.pos), d3.reducedLen = (d3.reducedLen || O3) - 0.1 * O3, d3.reducedLen > 0.1 * O3 && Z2(d3, O3, j3), true) : (t3 += d3[h2].size, h2++, false)));
        }), tt2(d3, f2), d3;
      }, K2;
    }), at2(s2, "Core/Renderer/SVG/SVGElement.js", [s2["Core/Animation/AnimationUtilities.js"], s2["Core/Color/Color.js"], s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2) {
      let { animate: rt2, animObject: tt2, stop: Z2 } = B3, { deg2rad: X2, doc: O3, svg: j3, SVG_NS: d3, win: x2 } = q2, { addEvent: f2, attr: C3, createElement: o2, crisp: p2, css: b5, defined: h2, erase: c4, extend: T2, fireEvent: I3, isArray: G2, isFunction: L2, isObject: l4, isString: y2, merge: i5, objectEach: t3, pick: e5, pInt: n4, pushUnique: u2, replaceNested: a2, syncTimeout: g2, uniqueKey: r3 } = it2;
      class A3 {
        _defaultGetter(k3) {
          let E2 = e5(this[k3 + "Value"], this[k3], this.element ? this.element.getAttribute(k3) : null, 0);
          return /^-?[\d\.]+$/.test(E2) && (E2 = parseFloat(E2)), E2;
        }
        _defaultSetter(k3, E2, R2) {
          R2.setAttribute(E2, k3);
        }
        add(k3) {
          let E2, R2 = this.renderer, z2 = this.element;
          return k3 && (this.parentGroup = k3), this.textStr !== void 0 && this.element.nodeName === "text" && R2.buildText(this), this.added = true, (!k3 || k3.handleZ || this.zIndex) && (E2 = this.zIndexSetter()), E2 || (k3 ? k3.element : R2.box).appendChild(z2), this.onAdd && this.onAdd(), this;
        }
        addClass(k3, E2) {
          let R2 = E2 ? "" : this.attr("class") || "";
          return (k3 = (k3 || "").split(/ /g).reduce(function(z2, Q2) {
            return R2.indexOf(Q2) === -1 && z2.push(Q2), z2;
          }, R2 ? [R2] : []).join(" ")) !== R2 && this.attr("class", k3), this;
        }
        afterSetters() {
          this.doTransform && (this.updateTransform(), this.doTransform = false);
        }
        align(k3, E2, R2, z2 = true) {
          let Q2, v3, S2, P2, U2 = {}, w2 = this.renderer, M2 = w2.alignedObjects, D2 = !!k3;
          k3 ? (this.alignOptions = k3, this.alignByTranslate = E2, this.alignTo = R2) : (k3 = this.alignOptions || {}, E2 = this.alignByTranslate, R2 = this.alignTo);
          let F2 = !R2 || y2(R2) ? R2 || "renderer" : void 0;
          F2 && (D2 && u2(M2, this), R2 = void 0);
          let $2 = e5(R2, w2[F2], w2), W2 = k3.align, V2 = k3.verticalAlign;
          return Q2 = ($2.x || 0) + (k3.x || 0), v3 = ($2.y || 0) + (k3.y || 0), W2 === "right" ? S2 = 1 : W2 === "center" && (S2 = 2), S2 && (Q2 += (($2.width || 0) - (k3.width || 0)) / S2), U2[E2 ? "translateX" : "x"] = Math.round(Q2), V2 === "bottom" ? P2 = 1 : V2 === "middle" && (P2 = 2), P2 && (v3 += (($2.height || 0) - (k3.height || 0)) / P2), U2[E2 ? "translateY" : "y"] = Math.round(v3), z2 && (this[this.placed ? "animate" : "attr"](U2), this.placed = true), this.alignAttr = U2, this;
        }
        alignSetter(k3) {
          let E2 = { left: "start", center: "middle", right: "end" };
          E2[k3] && (this.alignValue = k3, this.element.setAttribute("text-anchor", E2[k3]));
        }
        animate(k3, E2, R2) {
          let z2 = tt2(e5(E2, this.renderer.globalAnimation, true)), Q2 = z2.defer;
          return O3.hidden && (z2.duration = 0), z2.duration !== 0 ? (R2 && (z2.complete = R2), g2(() => {
            this.element && rt2(this, k3, z2);
          }, Q2)) : (this.attr(k3, void 0, R2 || z2.complete), t3(k3, function(v3, S2) {
            z2.step && z2.step.call(this, v3, { prop: S2, pos: 1, elem: this });
          }, this)), this;
        }
        applyTextOutline(k3) {
          let E2 = this.element;
          k3.indexOf("contrast") !== -1 && (k3 = k3.replace(/contrast/g, this.renderer.getContrast(E2.style.fill)));
          let R2 = k3.split(" "), z2 = R2[R2.length - 1], Q2 = R2[0];
          if (Q2 && Q2 !== "none" && q2.svg) {
            this.fakeTS = true, Q2 = Q2.replace(/(^[\d\.]+)(.*?)$/g, function(w2, M2, D2) {
              return 2 * Number(M2) + D2;
            }), this.removeTextOutline();
            let v3 = O3.createElementNS(d3, "tspan");
            C3(v3, { class: "highcharts-text-outline", fill: z2, stroke: z2, "stroke-width": Q2, "stroke-linejoin": "round" });
            let S2 = E2.querySelector("textPath") || E2;
            [].forEach.call(S2.childNodes, (w2) => {
              let M2 = w2.cloneNode(true);
              M2.removeAttribute && ["fill", "stroke", "stroke-width", "stroke"].forEach((D2) => M2.removeAttribute(D2)), v3.appendChild(M2);
            });
            let P2 = 0;
            [].forEach.call(S2.querySelectorAll("text tspan"), (w2) => {
              P2 += Number(w2.getAttribute("dy"));
            });
            let U2 = O3.createElementNS(d3, "tspan");
            U2.textContent = "​", C3(U2, { x: Number(E2.getAttribute("x")), dy: -P2 }), v3.appendChild(U2), S2.insertBefore(v3, S2.firstChild);
          }
        }
        attr(k3, E2, R2, z2) {
          let { element: Q2 } = this, v3 = A3.symbolCustomAttribs, S2, P2, U2 = this, w2;
          return typeof k3 == "string" && E2 !== void 0 && (S2 = k3, (k3 = {})[S2] = E2), typeof k3 == "string" ? U2 = (this[k3 + "Getter"] || this._defaultGetter).call(this, k3, Q2) : (t3(k3, function(M2, D2) {
            w2 = false, z2 || Z2(this, D2), this.symbolName && v3.indexOf(D2) !== -1 && (P2 || (this.symbolAttr(k3), P2 = true), w2 = true), this.rotation && (D2 === "x" || D2 === "y") && (this.doTransform = true), w2 || (this[D2 + "Setter"] || this._defaultSetter).call(this, M2, D2, Q2);
          }, this), this.afterSetters()), R2 && R2.call(this), U2;
        }
        clip(k3) {
          if (k3 && !k3.clipPath) {
            let E2 = r3() + "-", R2 = this.renderer.createElement("clipPath").attr({ id: E2 }).add(this.renderer.defs);
            T2(k3, { clipPath: R2, id: E2, count: 0 }), k3.add(R2);
          }
          return this.attr("clip-path", k3 ? `url(${this.renderer.url}#${k3.id})` : "none");
        }
        crisp(k3, E2) {
          E2 = Math.round(E2 || k3.strokeWidth || 0);
          let R2 = k3.x || this.x || 0, z2 = k3.y || this.y || 0, Q2 = (k3.width || this.width || 0) + R2, v3 = (k3.height || this.height || 0) + z2, S2 = p2(R2, E2), P2 = p2(z2, E2);
          return T2(k3, { x: S2, y: P2, width: p2(Q2, E2) - S2, height: p2(v3, E2) - P2 }), h2(k3.strokeWidth) && (k3.strokeWidth = E2), k3;
        }
        complexColor(k3, E2, R2) {
          let z2 = this.renderer, Q2, v3, S2, P2, U2, w2, M2, D2, F2, $2, W2 = [], V2;
          I3(this.renderer, "complexColor", { args: arguments }, function() {
            if (k3.radialGradient ? v3 = "radialGradient" : k3.linearGradient && (v3 = "linearGradient"), v3) {
              if (S2 = k3[v3], U2 = z2.gradients, w2 = k3.stops, F2 = R2.radialReference, G2(S2) && (k3[v3] = S2 = { x1: S2[0], y1: S2[1], x2: S2[2], y2: S2[3], gradientUnits: "userSpaceOnUse" }), v3 === "radialGradient" && F2 && !h2(S2.gradientUnits) && (P2 = S2, S2 = i5(S2, z2.getRadialAttr(F2, P2), { gradientUnits: "userSpaceOnUse" })), t3(S2, function(_2, et2) {
                et2 !== "id" && W2.push(et2, _2);
              }), t3(w2, function(_2) {
                W2.push(_2);
              }), U2[W2 = W2.join(",")]) $2 = U2[W2].attr("id");
              else {
                S2.id = $2 = r3();
                let _2 = U2[W2] = z2.createElement(v3).attr(S2).add(z2.defs);
                _2.radAttr = P2, _2.stops = [], w2.forEach(function(et2) {
                  et2[1].indexOf("rgba") === 0 ? (M2 = (Q2 = K2.parse(et2[1])).get("rgb"), D2 = Q2.get("a")) : (M2 = et2[1], D2 = 1);
                  let lt2 = z2.createElement("stop").attr({ offset: et2[0], "stop-color": M2, "stop-opacity": D2 }).add(_2);
                  _2.stops.push(lt2);
                });
              }
              V2 = "url(" + z2.url + "#" + $2 + ")", R2.setAttribute(E2, V2), R2.gradient = W2, k3.toString = function() {
                return V2;
              };
            }
          });
        }
        css(k3) {
          let E2 = this.styles, R2 = {}, z2 = this.element, Q2, v3 = !E2;
          if (E2 && t3(k3, function(S2, P2) {
            E2 && E2[P2] !== S2 && (R2[P2] = S2, v3 = true);
          }), v3) {
            E2 && (k3 = T2(E2, R2)), k3.width === null || k3.width === "auto" ? delete this.textWidth : z2.nodeName.toLowerCase() === "text" && k3.width && (Q2 = this.textWidth = n4(k3.width)), T2(this.styles, k3), Q2 && !j3 && this.renderer.forExport && delete k3.width;
            let S2 = i5(k3);
            z2.namespaceURI === this.SVG_NS && (["textOutline", "textOverflow", "width"].forEach((P2) => S2 && delete S2[P2]), S2.color && (S2.fill = S2.color)), b5(z2, S2);
          }
          return this.added && (this.element.nodeName === "text" && this.renderer.buildText(this), k3.textOutline && this.applyTextOutline(k3.textOutline)), this;
        }
        dashstyleSetter(k3) {
          let E2, R2 = this["stroke-width"];
          if (R2 === "inherit" && (R2 = 1), k3 = k3 && k3.toLowerCase()) {
            let z2 = k3.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
            for (E2 = z2.length; E2--; ) z2[E2] = "" + n4(z2[E2]) * e5(R2, NaN);
            k3 = z2.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", k3);
          }
        }
        destroy() {
          var k3;
          let E2 = this, R2 = E2.element || {}, z2 = E2.renderer, Q2 = R2.ownerSVGElement, v3 = R2.nodeName === "SPAN" && E2.parentGroup || void 0, S2, P2;
          if (R2.onclick = R2.onmouseout = R2.onmouseover = R2.onmousemove = R2.point = null, Z2(E2), E2.clipPath && Q2) {
            let U2 = E2.clipPath;
            [].forEach.call(Q2.querySelectorAll("[clip-path],[CLIP-PATH]"), function(w2) {
              w2.getAttribute("clip-path").indexOf(U2.element.id) > -1 && w2.removeAttribute("clip-path");
            }), E2.clipPath = U2.destroy();
          }
          if (E2.connector = (k3 = E2.connector) == null ? void 0 : k3.destroy(), E2.stops) {
            for (P2 = 0; P2 < E2.stops.length; P2++) E2.stops[P2].destroy();
            E2.stops.length = 0, E2.stops = void 0;
          }
          for (E2.safeRemoveChild(R2); v3 && v3.div && v3.div.childNodes.length === 0; ) S2 = v3.parentGroup, E2.safeRemoveChild(v3.div), delete v3.div, v3 = S2;
          E2.alignOptions && c4(z2.alignedObjects, E2), t3(E2, function(U2, w2) {
            E2[w2] && E2[w2].parentGroup === E2 && E2[w2].destroy && E2[w2].destroy(), delete E2[w2];
          });
        }
        dSetter(k3, E2, R2) {
          G2(k3) && (typeof k3[0] == "string" && (k3 = this.renderer.pathToSegments(k3)), this.pathArray = k3, k3 = k3.reduce((z2, Q2, v3) => Q2 && Q2.join ? (v3 ? z2 + " " : "") + Q2.join(" ") : (Q2 || "").toString(), "")), /(NaN| {2}|^$)/.test(k3) && (k3 = "M 0 0"), this[E2] !== k3 && (R2.setAttribute(E2, k3), this[E2] = k3);
        }
        fillSetter(k3, E2, R2) {
          typeof k3 == "string" ? R2.setAttribute(E2, k3) : k3 && this.complexColor(k3, E2, R2);
        }
        hrefSetter(k3, E2, R2) {
          R2.setAttributeNS("http://www.w3.org/1999/xlink", E2, k3);
        }
        getBBox(k3, E2) {
          let R2, z2, Q2, v3, { alignValue: S2, element: P2, renderer: U2, styles: w2, textStr: M2 } = this, { cache: D2, cacheKeys: F2 } = U2, $2 = P2.namespaceURI === this.SVG_NS, W2 = e5(E2, this.rotation, 0), V2 = U2.styledMode ? P2 && A3.prototype.getStyle.call(P2, "font-size") : w2.fontSize;
          if (h2(M2) && ((v3 = M2.toString()).indexOf("<") === -1 && (v3 = v3.replace(/\d/g, "0")), v3 += ["", U2.rootFontSize, V2, W2, this.textWidth, S2, w2.textOverflow, w2.fontWeight].join(",")), v3 && !k3 && (R2 = D2[v3]), !R2 || R2.polygon) {
            if ($2 || U2.forExport) {
              try {
                Q2 = this.fakeTS && function(et2) {
                  let lt2 = P2.querySelector(".highcharts-text-outline");
                  lt2 && b5(lt2, { display: et2 });
                }, L2(Q2) && Q2("none"), R2 = P2.getBBox ? T2({}, P2.getBBox()) : { width: P2.offsetWidth, height: P2.offsetHeight, x: 0, y: 0 }, L2(Q2) && Q2("");
              } catch {
              }
              (!R2 || R2.width < 0) && (R2 = { x: 0, y: 0, width: 0, height: 0 });
            } else R2 = this.htmlGetBBox();
            z2 = R2.height, $2 && (R2.height = z2 = { "11px,17": 14, "13px,20": 16 }[`${V2 || ""},${Math.round(z2)}`] || z2), W2 && (R2 = this.getRotatedBox(R2, W2));
            let _2 = { bBox: R2 };
            I3(this, "afterGetBBox", _2), R2 = _2.bBox;
          }
          if (v3 && (M2 === "" || R2.height > 0)) {
            for (; F2.length > 250; ) delete D2[F2.shift()];
            D2[v3] || F2.push(v3), D2[v3] = R2;
          }
          return R2;
        }
        getRotatedBox(k3, E2) {
          let { x: R2, y: z2, width: Q2, height: v3 } = k3, { alignValue: S2, translateY: P2, rotationOriginX: U2 = 0, rotationOriginY: w2 = 0 } = this, M2 = { right: 1, center: 0.5 }[S2 || 0] || 0, D2 = Number(this.element.getAttribute("y") || 0) - (P2 ? 0 : z2), F2 = E2 * X2, $2 = (E2 - 90) * X2, W2 = Math.cos(F2), V2 = Math.sin(F2), _2 = Q2 * W2, et2 = Q2 * V2, lt2 = Math.cos($2), ht2 = Math.sin($2), [[J2, Y2], [st2, nt2]] = [U2, w2].map((Ct2) => [Ct2 - Ct2 * W2, Ct2 * V2]), ot2 = R2 + M2 * (Q2 - _2) + J2 + nt2 + D2 * lt2, ut2 = ot2 + _2, dt2 = ut2 - v3 * lt2, ct2 = dt2 - _2, gt2 = z2 + D2 - M2 * et2 - Y2 + st2 + D2 * ht2, ft2 = gt2 + et2, pt2 = ft2 - v3 * ht2, mt2 = pt2 - et2, yt2 = Math.min(ot2, ut2, dt2, ct2), vt2 = Math.min(gt2, ft2, pt2, mt2), bt2 = Math.max(ot2, ut2, dt2, ct2) - yt2, xt2 = Math.max(gt2, ft2, pt2, mt2) - vt2;
          return { x: yt2, y: vt2, width: bt2, height: xt2, polygon: [[ot2, gt2], [ut2, ft2], [dt2, pt2], [ct2, mt2]] };
        }
        getStyle(k3) {
          return x2.getComputedStyle(this.element || this, "").getPropertyValue(k3);
        }
        hasClass(k3) {
          return ("" + this.attr("class")).split(" ").indexOf(k3) !== -1;
        }
        hide() {
          return this.attr({ visibility: "hidden" });
        }
        htmlGetBBox() {
          return { height: 0, width: 0, x: 0, y: 0 };
        }
        constructor(k3, E2) {
          this.onEvents = {}, this.opacity = 1, this.SVG_NS = d3, this.element = E2 === "span" || E2 === "body" ? o2(E2) : O3.createElementNS(this.SVG_NS, E2), this.renderer = k3, this.styles = {}, I3(this, "afterInit");
        }
        on(k3, E2) {
          let { onEvents: R2 } = this;
          return R2[k3] && R2[k3](), R2[k3] = f2(this.element, k3, E2), this;
        }
        opacitySetter(k3, E2, R2) {
          let z2 = Number(Number(k3).toFixed(3));
          this.opacity = z2, R2.setAttribute(E2, z2);
        }
        reAlign() {
          var k3;
          (k3 = this.alignOptions) != null && k3.width && this.alignOptions.align !== "left" && (this.alignOptions.width = this.getBBox().width, this.placed = false, this.align());
        }
        removeClass(k3) {
          return this.attr("class", ("" + this.attr("class")).replace(y2(k3) ? RegExp(`(^| )${k3}( |$)`) : k3, " ").replace(/ +/g, " ").trim());
        }
        removeTextOutline() {
          let k3 = this.element.querySelector("tspan.highcharts-text-outline");
          k3 && this.safeRemoveChild(k3);
        }
        safeRemoveChild(k3) {
          let E2 = k3.parentNode;
          E2 && E2.removeChild(k3);
        }
        setRadialReference(k3) {
          let E2 = this.element.gradient && this.renderer.gradients[this.element.gradient];
          return this.element.radialReference = k3, E2 && E2.radAttr && E2.animate(this.renderer.getRadialAttr(k3, E2.radAttr)), this;
        }
        shadow(k3) {
          var E2;
          let { renderer: R2 } = this, z2 = i5(((E2 = this.parentGroup) == null ? void 0 : E2.rotation) === 90 ? { offsetX: -1, offsetY: -1 } : {}, l4(k3) ? k3 : {}), Q2 = R2.shadowDefinition(z2);
          return this.attr({ filter: k3 ? `url(${R2.url}#${Q2})` : "none" });
        }
        show(k3 = true) {
          return this.attr({ visibility: k3 ? "inherit" : "visible" });
        }
        "stroke-widthSetter"(k3, E2, R2) {
          this[E2] = k3, R2.setAttribute(E2, k3);
        }
        strokeWidth() {
          if (!this.renderer.styledMode) return this["stroke-width"] || 0;
          let k3 = this.getStyle("stroke-width"), E2 = 0, R2;
          return /px$/.test(k3) ? E2 = n4(k3) : k3 !== "" && (C3(R2 = O3.createElementNS(d3, "rect"), { width: k3, "stroke-width": 0 }), this.element.parentNode.appendChild(R2), E2 = R2.getBBox().width, R2.parentNode.removeChild(R2)), E2;
        }
        symbolAttr(k3) {
          let E2 = this;
          A3.symbolCustomAttribs.forEach(function(R2) {
            E2[R2] = e5(k3[R2], E2[R2]);
          }), E2.attr({ d: E2.renderer.symbols[E2.symbolName](E2.x, E2.y, E2.width, E2.height, E2) });
        }
        textSetter(k3) {
          k3 !== this.textStr && (delete this.textPxLength, this.textStr = k3, this.added && this.renderer.buildText(this), this.reAlign());
        }
        titleSetter(k3) {
          let E2 = this.element, R2 = E2.getElementsByTagName("title")[0] || O3.createElementNS(this.SVG_NS, "title");
          E2.insertBefore ? E2.insertBefore(R2, E2.firstChild) : E2.appendChild(R2), R2.textContent = a2(e5(k3, ""), [/<[^>]*>/g, ""]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        }
        toFront() {
          let k3 = this.element;
          return k3.parentNode.appendChild(k3), this;
        }
        translate(k3, E2) {
          return this.attr({ translateX: k3, translateY: E2 });
        }
        updateTransform(k3 = "transform") {
          var E2;
          let { element: R2, matrix: z2, rotation: Q2 = 0, rotationOriginX: v3, rotationOriginY: S2, scaleX: P2, scaleY: U2, translateX: w2 = 0, translateY: M2 = 0 } = this, D2 = ["translate(" + w2 + "," + M2 + ")"];
          h2(z2) && D2.push("matrix(" + z2.join(",") + ")"), Q2 && (D2.push("rotate(" + Q2 + " " + e5(v3, R2.getAttribute("x"), 0) + " " + e5(S2, R2.getAttribute("y") || 0) + ")"), ((E2 = this.text) == null ? void 0 : E2.element.tagName) === "SPAN" && this.text.attr({ rotation: Q2, rotationOriginX: (v3 || 0) - this.padding, rotationOriginY: (S2 || 0) - this.padding })), (h2(P2) || h2(U2)) && D2.push("scale(" + e5(P2, 1) + " " + e5(U2, 1) + ")"), D2.length && !(this.text || this).textPath && R2.setAttribute(k3, D2.join(" "));
        }
        visibilitySetter(k3, E2, R2) {
          k3 === "inherit" ? R2.removeAttribute(E2) : this[E2] !== k3 && R2.setAttribute(E2, k3), this[E2] = k3;
        }
        xGetter(k3) {
          return this.element.nodeName === "circle" && (k3 === "x" ? k3 = "cx" : k3 === "y" && (k3 = "cy")), this._defaultGetter(k3);
        }
        zIndexSetter(k3, E2) {
          let R2 = this.renderer, z2 = this.parentGroup, Q2 = (z2 || R2).element || R2.box, v3 = this.element, S2 = Q2 === R2.box, P2, U2, w2, M2 = false, D2, F2 = this.added, $2;
          if (h2(k3) ? (v3.setAttribute("data-z-index", k3), k3 = +k3, this[E2] === k3 && (F2 = false)) : h2(this[E2]) && v3.removeAttribute("data-z-index"), this[E2] = k3, F2) {
            for ((k3 = this.zIndex) && z2 && (z2.handleZ = true), $2 = (P2 = Q2.childNodes).length - 1; $2 >= 0 && !M2; $2--) D2 = !h2(w2 = (U2 = P2[$2]).getAttribute("data-z-index")), U2 !== v3 && (k3 < 0 && D2 && !S2 && !$2 ? (Q2.insertBefore(v3, P2[$2]), M2 = true) : (n4(w2) <= k3 || D2 && (!h2(k3) || k3 >= 0)) && (Q2.insertBefore(v3, P2[$2 + 1]), M2 = true));
            M2 || (Q2.insertBefore(v3, P2[S2 ? 3 : 0]), M2 = true);
          }
          return M2;
        }
      }
      return A3.symbolCustomAttribs = ["anchorX", "anchorY", "clockwise", "end", "height", "innerR", "r", "start", "width", "x", "y"], A3.prototype.strokeSetter = A3.prototype.fillSetter, A3.prototype.yGetter = A3.prototype.xGetter, A3.prototype.matrixSetter = A3.prototype.rotationOriginXSetter = A3.prototype.rotationOriginYSetter = A3.prototype.rotationSetter = A3.prototype.scaleXSetter = A3.prototype.scaleYSetter = A3.prototype.translateXSetter = A3.prototype.translateYSetter = A3.prototype.verticalAlignSetter = function(N2, k3) {
        this[k3] = N2, this.doTransform = true;
      }, A3;
    }), at2(s2, "Core/Renderer/SVG/SVGLabel.js", [s2["Core/Renderer/SVG/SVGElement.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { defined: q2, extend: it2, isNumber: rt2, merge: tt2, pick: Z2, removeEvent: X2 } = K2;
      class O3 extends B3 {
        constructor(d3, x2, f2, C3, o2, p2, b5, h2, c4, T2) {
          let I3;
          super(d3, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.doUpdate = false, this.textStr = x2, this.x = f2, this.y = C3, this.anchorX = p2, this.anchorY = b5, this.baseline = c4, this.className = T2, this.addClass(T2 === "button" ? "highcharts-no-tooltip" : "highcharts-label"), T2 && this.addClass("highcharts-" + T2), this.text = d3.text(void 0, 0, 0, h2).attr({ zIndex: 1 }), typeof o2 == "string" && ((I3 = /^url\((.*?)\)$/.test(o2)) || this.renderer.symbols[o2]) && (this.symbolKey = o2), this.bBox = O3.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = d3.styledMode || I3, this.deferredAttr = {}, this.alignFactor = 0;
        }
        alignSetter(d3) {
          let x2 = { left: 0, center: 0.5, right: 1 }[d3];
          x2 !== this.alignFactor && (this.alignFactor = x2, this.bBox && rt2(this.xSetting) && this.attr({ x: this.xSetting }));
        }
        anchorXSetter(d3, x2) {
          this.anchorX = d3, this.boxAttr(x2, Math.round(d3) - this.getCrispAdjust() - this.xSetting);
        }
        anchorYSetter(d3, x2) {
          this.anchorY = d3, this.boxAttr(x2, d3 - this.ySetting);
        }
        boxAttr(d3, x2) {
          this.box ? this.box.attr(d3, x2) : this.deferredAttr[d3] = x2;
        }
        css(d3) {
          if (d3) {
            let x2 = {};
            d3 = tt2(d3), O3.textProps.forEach((f2) => {
              d3[f2] !== void 0 && (x2[f2] = d3[f2], delete d3[f2]);
            }), this.text.css(x2), "fontSize" in x2 || "fontWeight" in x2 ? this.updateTextPadding() : ("width" in x2 || "textOverflow" in x2) && this.updateBoxSize();
          }
          return B3.prototype.css.call(this, d3);
        }
        destroy() {
          X2(this.element, "mouseenter"), X2(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), B3.prototype.destroy.call(this);
        }
        fillSetter(d3, x2) {
          d3 && (this.needsBox = true), this.fill = d3, this.boxAttr(x2, d3);
        }
        getBBox(d3, x2) {
          this.textStr && this.bBox.width === 0 && this.bBox.height === 0 && this.updateBoxSize();
          let { padding: f2, height: C3 = 0, translateX: o2 = 0, translateY: p2 = 0, width: b5 = 0 } = this, h2 = Z2(this.paddingLeft, f2), c4 = x2 != null ? x2 : this.rotation || 0, T2 = { width: b5, height: C3, x: o2 + this.bBox.x - h2, y: p2 + this.bBox.y - f2 + this.baselineOffset };
          return c4 && (T2 = this.getRotatedBox(T2, c4)), T2;
        }
        getCrispAdjust() {
          return (this.renderer.styledMode && this.box ? this.box.strokeWidth() : this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
        }
        heightSetter(d3) {
          this.heightSetting = d3, this.doUpdate = true;
        }
        afterSetters() {
          super.afterSetters(), this.doUpdate && (this.updateBoxSize(), this.doUpdate = false);
        }
        onAdd() {
          this.text.add(this), this.attr({ text: Z2(this.textStr, ""), x: this.x || 0, y: this.y || 0 }), this.box && q2(this.anchorX) && this.attr({ anchorX: this.anchorX, anchorY: this.anchorY });
        }
        paddingSetter(d3, x2) {
          rt2(d3) ? d3 !== this[x2] && (this[x2] = d3, this.updateTextPadding()) : this[x2] = void 0;
        }
        rSetter(d3, x2) {
          this.boxAttr(x2, d3);
        }
        strokeSetter(d3, x2) {
          this.stroke = d3, this.boxAttr(x2, d3);
        }
        "stroke-widthSetter"(d3, x2) {
          d3 && (this.needsBox = true), this["stroke-width"] = d3, this.boxAttr(x2, d3);
        }
        "text-alignSetter"(d3) {
          this.textAlign = d3;
        }
        textSetter(d3) {
          d3 !== void 0 && this.text.attr({ text: d3 }), this.updateTextPadding(), this.reAlign();
        }
        updateBoxSize() {
          let d3, x2 = this.text, f2 = {}, C3 = this.padding, o2 = this.bBox = (!rt2(this.widthSetting) || !rt2(this.heightSetting) || this.textAlign) && q2(x2.textStr) ? x2.getBBox(void 0, 0) : O3.emptyBBox;
          this.width = this.getPaddedWidth(), this.height = (this.heightSetting || o2.height || 0) + 2 * C3;
          let p2 = this.renderer.fontMetrics(x2);
          if (this.baselineOffset = C3 + Math.min((this.text.firstLineMetrics || p2).b, o2.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - p2.h) / 2), this.needsBox && !x2.textPath) {
            if (!this.box) {
              let b5 = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
              b5.addClass((this.className === "button" ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), b5.add(this);
            }
            d3 = this.getCrispAdjust(), f2.x = d3, f2.y = (this.baseline ? -this.baselineOffset : 0) + d3, f2.width = Math.round(this.width), f2.height = Math.round(this.height), this.box.attr(it2(f2, this.deferredAttr)), this.deferredAttr = {};
          }
        }
        updateTextPadding() {
          let d3 = this.text;
          if (!d3.textPath) {
            this.updateBoxSize();
            let x2 = this.baseline ? 0 : this.baselineOffset, f2 = Z2(this.paddingLeft, this.padding);
            q2(this.widthSetting) && this.bBox && (this.textAlign === "center" || this.textAlign === "right") && (f2 += { center: 0.5, right: 1 }[this.textAlign] * (this.widthSetting - this.bBox.width)), (f2 !== d3.x || x2 !== d3.y) && (d3.attr("x", f2), d3.hasBoxWidthChanged && (this.bBox = d3.getBBox(true)), x2 !== void 0 && d3.attr("y", x2)), d3.x = f2, d3.y = x2;
          }
        }
        widthSetter(d3) {
          this.widthSetting = rt2(d3) ? d3 : void 0, this.doUpdate = true;
        }
        getPaddedWidth() {
          let d3 = this.padding, x2 = Z2(this.paddingLeft, d3), f2 = Z2(this.paddingRight, d3);
          return (this.widthSetting || this.bBox.width || 0) + x2 + f2;
        }
        xSetter(d3) {
          this.x = d3, this.alignFactor && (d3 -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = true), this.xSetting = Math.round(d3), this.attr("translateX", this.xSetting);
        }
        ySetter(d3) {
          this.ySetting = this.y = Math.round(d3), this.attr("translateY", this.ySetting);
        }
      }
      return O3.emptyBBox = { width: 0, height: 0, x: 0, y: 0 }, O3.textProps = ["color", "direction", "fontFamily", "fontSize", "fontStyle", "fontWeight", "lineHeight", "textAlign", "textDecoration", "textOutline", "textOverflow", "whiteSpace", "width"], O3;
    }), at2(s2, "Core/Renderer/SVG/Symbols.js", [s2["Core/Utilities.js"]], function(B3) {
      let { defined: K2, isNumber: q2, pick: it2 } = B3;
      function rt2(X2, O3, j3, d3, x2) {
        let f2 = [];
        if (x2) {
          let C3 = x2.start || 0, o2 = it2(x2.r, j3), p2 = it2(x2.r, d3 || j3), b5 = 2e-4 / (x2.borderRadius ? 1 : Math.max(o2, 1)), h2 = Math.abs((x2.end || 0) - C3 - 2 * Math.PI) < b5, c4 = (x2.end || 0) - (h2 ? b5 : 0), T2 = x2.innerR, I3 = it2(x2.open, h2), G2 = Math.cos(C3), L2 = Math.sin(C3), l4 = Math.cos(c4), y2 = Math.sin(c4), i5 = it2(x2.longArc, c4 - C3 - Math.PI < b5 ? 0 : 1), t3 = ["A", o2, p2, 0, i5, it2(x2.clockwise, 1), X2 + o2 * l4, O3 + p2 * y2];
          t3.params = { start: C3, end: c4, cx: X2, cy: O3 }, f2.push(["M", X2 + o2 * G2, O3 + p2 * L2], t3), K2(T2) && ((t3 = ["A", T2, T2, 0, i5, K2(x2.clockwise) ? 1 - x2.clockwise : 0, X2 + T2 * G2, O3 + T2 * L2]).params = { start: c4, end: C3, cx: X2, cy: O3 }, f2.push(I3 ? ["M", X2 + T2 * l4, O3 + T2 * y2] : ["L", X2 + T2 * l4, O3 + T2 * y2], t3)), I3 || f2.push(["Z"]);
        }
        return f2;
      }
      function tt2(X2, O3, j3, d3, x2) {
        return x2 && x2.r ? Z2(X2, O3, j3, d3, x2) : [["M", X2, O3], ["L", X2 + j3, O3], ["L", X2 + j3, O3 + d3], ["L", X2, O3 + d3], ["Z"]];
      }
      function Z2(X2, O3, j3, d3, x2) {
        let f2 = (x2 == null ? void 0 : x2.r) || 0;
        return [["M", X2 + f2, O3], ["L", X2 + j3 - f2, O3], ["A", f2, f2, 0, 0, 1, X2 + j3, O3 + f2], ["L", X2 + j3, O3 + d3 - f2], ["A", f2, f2, 0, 0, 1, X2 + j3 - f2, O3 + d3], ["L", X2 + f2, O3 + d3], ["A", f2, f2, 0, 0, 1, X2, O3 + d3 - f2], ["L", X2, O3 + f2], ["A", f2, f2, 0, 0, 1, X2 + f2, O3], ["Z"]];
      }
      return { arc: rt2, callout: function(X2, O3, j3, d3, x2) {
        let f2 = Math.min(x2 && x2.r || 0, j3, d3), C3 = f2 + 6, o2 = x2 && x2.anchorX, p2 = x2 && x2.anchorY || 0, b5 = Z2(X2, O3, j3, d3, { r: f2 });
        if (!q2(o2) || o2 < j3 && o2 > 0 && p2 < d3 && p2 > 0) return b5;
        if (X2 + o2 > j3 - C3)
          if (p2 > O3 + C3 && p2 < O3 + d3 - C3) b5.splice(3, 1, ["L", X2 + j3, p2 - 6], ["L", X2 + j3 + 6, p2], ["L", X2 + j3, p2 + 6], ["L", X2 + j3, O3 + d3 - f2]);
          else if (o2 < j3) {
            let h2 = p2 < O3 + C3, c4 = h2 ? O3 : O3 + d3;
            b5.splice(h2 ? 2 : 5, 0, ["L", o2, p2], ["L", X2 + j3 - f2, c4]);
          } else b5.splice(3, 1, ["L", X2 + j3, d3 / 2], ["L", o2, p2], ["L", X2 + j3, d3 / 2], ["L", X2 + j3, O3 + d3 - f2]);
        else if (X2 + o2 < C3)
          if (p2 > O3 + C3 && p2 < O3 + d3 - C3) b5.splice(7, 1, ["L", X2, p2 + 6], ["L", X2 - 6, p2], ["L", X2, p2 - 6], ["L", X2, O3 + f2]);
          else if (o2 > 0) {
            let h2 = p2 < O3 + C3, c4 = h2 ? O3 : O3 + d3;
            b5.splice(h2 ? 1 : 6, 0, ["L", o2, p2], ["L", X2 + f2, c4]);
          } else b5.splice(7, 1, ["L", X2, d3 / 2], ["L", o2, p2], ["L", X2, d3 / 2], ["L", X2, O3 + f2]);
        else p2 > d3 && o2 < j3 - C3 ? b5.splice(5, 1, ["L", o2 + 6, O3 + d3], ["L", o2, O3 + d3 + 6], ["L", o2 - 6, O3 + d3], ["L", X2 + f2, O3 + d3]) : p2 < 0 && o2 > C3 && b5.splice(1, 1, ["L", o2 - 6, O3], ["L", o2, O3 - 6], ["L", o2 + 6, O3], ["L", j3 - f2, O3]);
        return b5;
      }, circle: function(X2, O3, j3, d3) {
        return rt2(X2 + j3 / 2, O3 + d3 / 2, j3 / 2, d3 / 2, { start: 0.5 * Math.PI, end: 2.5 * Math.PI, open: false });
      }, diamond: function(X2, O3, j3, d3) {
        return [["M", X2 + j3 / 2, O3], ["L", X2 + j3, O3 + d3 / 2], ["L", X2 + j3 / 2, O3 + d3], ["L", X2, O3 + d3 / 2], ["Z"]];
      }, rect: tt2, roundedRect: Z2, square: tt2, triangle: function(X2, O3, j3, d3) {
        return [["M", X2 + j3 / 2, O3], ["L", X2 + j3, O3 + d3], ["L", X2, O3 + d3], ["Z"]];
      }, "triangle-down": function(X2, O3, j3, d3) {
        return [["M", X2, O3], ["L", X2 + j3, O3], ["L", X2 + j3 / 2, O3 + d3], ["Z"]];
      } };
    }), at2(s2, "Core/Renderer/SVG/TextBuilder.js", [s2["Core/Renderer/HTML/AST.js"], s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { doc: it2, SVG_NS: rt2, win: tt2 } = K2, { attr: Z2, extend: X2, fireEvent: O3, isString: j3, objectEach: d3, pick: x2 } = q2;
      return class {
        constructor(f2) {
          let C3 = f2.styles;
          this.renderer = f2.renderer, this.svgElement = f2, this.width = f2.textWidth, this.textLineHeight = C3 && C3.lineHeight, this.textOutline = C3 && C3.textOutline, this.ellipsis = !!(C3 && C3.textOverflow === "ellipsis"), this.noWrap = !!(C3 && C3.whiteSpace === "nowrap");
        }
        buildSVG() {
          let f2 = this.svgElement, C3 = f2.element, o2 = f2.renderer, p2 = x2(f2.textStr, "").toString(), b5 = p2.indexOf("<") !== -1, h2 = C3.childNodes, c4 = !f2.added && o2.box, T2 = [p2, this.ellipsis, this.noWrap, this.textLineHeight, this.textOutline, f2.getStyle("font-size"), this.width].join(",");
          if (T2 !== f2.textCache) {
            f2.textCache = T2, delete f2.actualWidth;
            for (let I3 = h2.length; I3--; ) C3.removeChild(h2[I3]);
            if (b5 || this.ellipsis || this.width || f2.textPath || p2.indexOf(" ") !== -1 && (!this.noWrap || /<br.*?>/g.test(p2))) {
              if (p2 !== "") {
                c4 && c4.appendChild(C3);
                let I3 = new B3(p2);
                this.modifyTree(I3.nodes), I3.addToDOM(C3), this.modifyDOM(), this.ellipsis && (C3.textContent || "").indexOf("…") !== -1 && f2.attr("title", this.unescapeEntities(f2.textStr || "", ["&lt;", "&gt;"])), c4 && c4.removeChild(C3);
              }
            } else C3.appendChild(it2.createTextNode(this.unescapeEntities(p2)));
            j3(this.textOutline) && f2.applyTextOutline && f2.applyTextOutline(this.textOutline);
          }
        }
        modifyDOM() {
          let f2, C3 = this.svgElement, o2 = Z2(C3.element, "x");
          for (C3.firstLineMetrics = void 0; (f2 = C3.element.firstChild) && /^[\s\u200B]*$/.test(f2.textContent || " "); ) C3.element.removeChild(f2);
          [].forEach.call(C3.element.querySelectorAll("tspan.highcharts-br"), (c4, T2) => {
            c4.nextSibling && c4.previousSibling && (T2 === 0 && c4.previousSibling.nodeType === 1 && (C3.firstLineMetrics = C3.renderer.fontMetrics(c4.previousSibling)), Z2(c4, { dy: this.getLineHeight(c4.nextSibling), x: o2 }));
          });
          let p2 = this.width || 0;
          if (!p2) return;
          let b5 = (c4, T2) => {
            let I3 = c4.textContent || "", G2 = I3.replace(/([^\^])-/g, "$1- ").split(" "), L2 = !this.noWrap && (G2.length > 1 || C3.element.childNodes.length > 1), l4 = this.getLineHeight(T2), y2 = 0, i5 = C3.actualWidth;
            if (this.ellipsis) I3 && this.truncate(c4, I3, void 0, 0, Math.max(0, p2 - 0.8 * l4), (t3, e5) => t3.substring(0, e5) + "…");
            else if (L2) {
              let t3 = [], e5 = [];
              for (; T2.firstChild && T2.firstChild !== c4; ) e5.push(T2.firstChild), T2.removeChild(T2.firstChild);
              for (; G2.length; ) G2.length && !this.noWrap && y2 > 0 && (t3.push(c4.textContent || ""), c4.textContent = G2.join(" ").replace(/- /g, "-")), this.truncate(c4, void 0, G2, y2 === 0 && i5 || 0, p2, (n4, u2) => G2.slice(0, u2).join(" ").replace(/- /g, "-")), i5 = C3.actualWidth, y2++;
              e5.forEach((n4) => {
                T2.insertBefore(n4, c4);
              }), t3.forEach((n4) => {
                T2.insertBefore(it2.createTextNode(n4), c4);
                let u2 = it2.createElementNS(rt2, "tspan");
                u2.textContent = "​", Z2(u2, { dy: l4, x: o2 }), T2.insertBefore(u2, c4);
              });
            }
          }, h2 = (c4) => {
            [].slice.call(c4.childNodes).forEach((T2) => {
              T2.nodeType === tt2.Node.TEXT_NODE ? b5(T2, c4) : (T2.className.baseVal.indexOf("highcharts-br") !== -1 && (C3.actualWidth = 0), h2(T2));
            });
          };
          h2(C3.element);
        }
        getLineHeight(f2) {
          let C3 = f2.nodeType === tt2.Node.TEXT_NODE ? f2.parentElement : f2;
          return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(C3 || this.svgElement.element).h;
        }
        modifyTree(f2) {
          let C3 = (o2, p2) => {
            let { attributes: b5 = {}, children: h2, style: c4 = {}, tagName: T2 } = o2, I3 = this.renderer.styledMode;
            if (T2 === "b" || T2 === "strong" ? I3 ? b5.class = "highcharts-strong" : c4.fontWeight = "bold" : (T2 === "i" || T2 === "em") && (I3 ? b5.class = "highcharts-emphasized" : c4.fontStyle = "italic"), c4 && c4.color && (c4.fill = c4.color), T2 === "br") {
              b5.class = "highcharts-br", o2.textContent = "​";
              let G2 = f2[p2 + 1];
              G2 && G2.textContent && (G2.textContent = G2.textContent.replace(/^ +/gm, ""));
            } else T2 === "a" && h2 && h2.some((G2) => G2.tagName === "#text") && (o2.children = [{ children: h2, tagName: "tspan" }]);
            T2 !== "#text" && T2 !== "a" && (o2.tagName = "tspan"), X2(o2, { attributes: b5, style: c4 }), h2 && h2.filter((G2) => G2.tagName !== "#text").forEach(C3);
          };
          f2.forEach(C3), O3(this.svgElement, "afterModifyTree", { nodes: f2 });
        }
        truncate(f2, C3, o2, p2, b5, h2) {
          let c4, T2, I3 = this.svgElement, { rotation: G2 } = I3, L2 = [], l4 = o2 ? 1 : 0, y2 = (C3 || o2 || "").length, i5 = y2, t3 = function(e5, n4) {
            let u2 = n4 || e5, a2 = f2.parentNode;
            if (a2 && L2[u2] === void 0 && a2.getSubStringLength) try {
              L2[u2] = p2 + a2.getSubStringLength(0, o2 ? u2 + 1 : u2);
            } catch {
            }
            return L2[u2];
          };
          if (I3.rotation = 0, p2 + (T2 = t3(f2.textContent.length)) > b5) {
            for (; l4 <= y2; ) i5 = Math.ceil((l4 + y2) / 2), o2 && (c4 = h2(o2, i5)), T2 = t3(i5, c4 && c4.length - 1), l4 === y2 ? l4 = y2 + 1 : T2 > b5 ? y2 = i5 - 1 : l4 = i5;
            y2 === 0 ? f2.textContent = "" : C3 && y2 === C3.length - 1 || (f2.textContent = c4 || h2(C3 || o2, i5));
          }
          o2 && o2.splice(0, i5), I3.actualWidth = T2, I3.rotation = G2;
        }
        unescapeEntities(f2, C3) {
          return d3(this.renderer.escapes, function(o2, p2) {
            C3 && C3.indexOf(o2) !== -1 || (f2 = f2.toString().replace(RegExp(o2, "g"), p2));
          }), f2;
        }
      };
    }), at2(s2, "Core/Renderer/SVG/SVGRenderer.js", [s2["Core/Renderer/HTML/AST.js"], s2["Core/Defaults.js"], s2["Core/Color/Color.js"], s2["Core/Globals.js"], s2["Core/Renderer/RendererRegistry.js"], s2["Core/Renderer/SVG/SVGElement.js"], s2["Core/Renderer/SVG/SVGLabel.js"], s2["Core/Renderer/SVG/Symbols.js"], s2["Core/Renderer/SVG/TextBuilder.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2, O3, j3) {
      let d3, { defaultOptions: x2 } = K2, { charts: f2, deg2rad: C3, doc: o2, isFirefox: p2, isMS: b5, isWebKit: h2, noop: c4, SVG_NS: T2, symbolSizes: I3, win: G2 } = it2, { addEvent: L2, attr: l4, createElement: y2, crisp: i5, css: t3, defined: e5, destroyObjectProperties: n4, extend: u2, isArray: a2, isNumber: g2, isObject: r3, isString: A3, merge: N2, pick: k3, pInt: E2, replaceNested: R2, uniqueKey: z2 } = j3;
      class Q2 {
        constructor(S2, P2, U2, w2, M2, D2, F2) {
          let $2, W2, V2 = this.createElement("svg").attr({ version: "1.1", class: "highcharts-root" }), _2 = V2.element;
          F2 || V2.css(this.getStyle(w2 || {})), S2.appendChild(_2), l4(S2, "dir", "ltr"), S2.innerHTML.indexOf("xmlns") === -1 && l4(_2, "xmlns", this.SVG_NS), this.box = _2, this.boxWrapper = V2, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(o2.createTextNode("Created with Highcharts 11.4.8")), this.defs = this.createElement("defs").add(), this.allowHTML = D2, this.forExport = M2, this.styledMode = F2, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.rootFontSize = V2.getStyle("font-size"), this.setSize(P2, U2, false), p2 && S2.getBoundingClientRect && (($2 = function() {
            t3(S2, { left: 0, top: 0 }), W2 = S2.getBoundingClientRect(), t3(S2, { left: Math.ceil(W2.left) - W2.left + "px", top: Math.ceil(W2.top) - W2.top + "px" });
          })(), this.unSubPixelFix = L2(G2, "resize", $2));
        }
        definition(S2) {
          return new B3([S2]).addToDOM(this.defs.element);
        }
        getReferenceURL() {
          if ((p2 || h2) && o2.getElementsByTagName("base").length) {
            if (!e5(d3)) {
              let S2 = z2(), P2 = new B3([{ tagName: "svg", attributes: { width: 8, height: 8 }, children: [{ tagName: "defs", children: [{ tagName: "clipPath", attributes: { id: S2 }, children: [{ tagName: "rect", attributes: { width: 4, height: 4 } }] }] }, { tagName: "rect", attributes: { id: "hitme", width: 8, height: 8, "clip-path": `url(#${S2})`, fill: "rgba(0,0,0,0.001)" } }] }]).addToDOM(o2.body);
              t3(P2, { position: "fixed", top: 0, left: 0, zIndex: 9e5 });
              let U2 = o2.elementFromPoint(6, 6);
              d3 = (U2 && U2.id) === "hitme", o2.body.removeChild(P2);
            }
            if (d3) return R2(G2.location.href.split("#")[0], [/<[^>]*>/g, ""], [/([\('\)])/g, "\\$1"], [/ /g, "%20"]);
          }
          return "";
        }
        getStyle(S2) {
          return this.style = u2({ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "1rem" }, S2), this.style;
        }
        setStyle(S2) {
          this.boxWrapper.css(this.getStyle(S2));
        }
        isHidden() {
          return !this.boxWrapper.getBBox().width;
        }
        destroy() {
          let S2 = this.defs;
          return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), n4(this.gradients || {}), this.gradients = null, this.defs = S2.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null, null;
        }
        createElement(S2) {
          return new this.Element(this, S2);
        }
        getRadialAttr(S2, P2) {
          return { cx: S2[0] - S2[2] / 2 + (P2.cx || 0) * S2[2], cy: S2[1] - S2[2] / 2 + (P2.cy || 0) * S2[2], r: (P2.r || 0) * S2[2] };
        }
        shadowDefinition(S2) {
          let P2 = [`highcharts-drop-shadow-${this.chartIndex}`, ...Object.keys(S2).map((w2) => `${w2}-${S2[w2]}`)].join("-").toLowerCase().replace(/[^a-z\d\-]/g, ""), U2 = N2({ color: "#000000", offsetX: 1, offsetY: 1, opacity: 0.15, width: 5 }, S2);
          return this.defs.element.querySelector(`#${P2}`) || this.definition({ tagName: "filter", attributes: { id: P2, filterUnits: U2.filterUnits }, children: this.getShadowFilterContent(U2) }), P2;
        }
        getShadowFilterContent(S2) {
          return [{ tagName: "feDropShadow", attributes: { dx: S2.offsetX, dy: S2.offsetY, "flood-color": S2.color, "flood-opacity": Math.min(5 * S2.opacity, 1), stdDeviation: S2.width / 2 } }];
        }
        buildText(S2) {
          new O3(S2).buildSVG();
        }
        getContrast(S2) {
          let P2 = q2.parse(S2).rgba.map((w2) => {
            let M2 = w2 / 255;
            return M2 <= 0.03928 ? M2 / 12.92 : Math.pow((M2 + 0.055) / 1.055, 2.4);
          }), U2 = 0.2126 * P2[0] + 0.7152 * P2[1] + 0.0722 * P2[2];
          return 1.05 / (U2 + 0.05) > (U2 + 0.05) / 0.05 ? "#FFFFFF" : "#000000";
        }
        button(S2, P2, U2, w2, M2 = {}, D2, F2, $2, W2, V2) {
          let _2 = this.label(S2, P2, U2, W2, void 0, void 0, V2, void 0, "button"), et2 = this.styledMode, lt2 = arguments, ht2 = 0;
          M2 = N2(x2.global.buttonTheme, M2), et2 && (delete M2.fill, delete M2.stroke, delete M2["stroke-width"]);
          let J2 = M2.states || {}, Y2 = M2.style || {};
          delete M2.states, delete M2.style;
          let st2 = [B3.filterUserAttributes(M2)], nt2 = [Y2];
          return et2 || ["hover", "select", "disabled"].forEach((ot2, ut2) => {
            st2.push(N2(st2[0], B3.filterUserAttributes(lt2[ut2 + 5] || J2[ot2] || {}))), nt2.push(st2[ut2 + 1].style), delete st2[ut2 + 1].style;
          }), L2(_2.element, b5 ? "mouseover" : "mouseenter", function() {
            ht2 !== 3 && _2.setState(1);
          }), L2(_2.element, b5 ? "mouseout" : "mouseleave", function() {
            ht2 !== 3 && _2.setState(ht2);
          }), _2.setState = (ot2 = 0) => {
            if (ot2 !== 1 && (_2.state = ht2 = ot2), _2.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][ot2]), !et2) {
              _2.attr(st2[ot2]);
              let ut2 = nt2[ot2];
              r3(ut2) && _2.css(ut2);
            }
          }, _2.attr(st2[0]), !et2 && (_2.css(u2({ cursor: "default" }, Y2)), V2 && _2.text.css({ pointerEvents: "none" })), _2.on("touchstart", (ot2) => ot2.stopPropagation()).on("click", function(ot2) {
            ht2 !== 3 && w2.call(_2, ot2);
          });
        }
        crispLine(S2, P2) {
          let [U2, w2] = S2;
          return e5(U2[1]) && U2[1] === w2[1] && (U2[1] = w2[1] = i5(U2[1], P2)), e5(U2[2]) && U2[2] === w2[2] && (U2[2] = w2[2] = i5(U2[2], P2)), S2;
        }
        path(S2) {
          let P2 = this.styledMode ? {} : { fill: "none" };
          return a2(S2) ? P2.d = S2 : r3(S2) && u2(P2, S2), this.createElement("path").attr(P2);
        }
        circle(S2, P2, U2) {
          let w2 = r3(S2) ? S2 : S2 === void 0 ? {} : { x: S2, y: P2, r: U2 }, M2 = this.createElement("circle");
          return M2.xSetter = M2.ySetter = function(D2, F2, $2) {
            $2.setAttribute("c" + F2, D2);
          }, M2.attr(w2);
        }
        arc(S2, P2, U2, w2, M2, D2) {
          let F2;
          r3(S2) ? (P2 = (F2 = S2).y, U2 = F2.r, w2 = F2.innerR, M2 = F2.start, D2 = F2.end, S2 = F2.x) : F2 = { innerR: w2, start: M2, end: D2 };
          let $2 = this.symbol("arc", S2, P2, U2, U2, F2);
          return $2.r = U2, $2;
        }
        rect(S2, P2, U2, w2, M2, D2) {
          let F2 = r3(S2) ? S2 : S2 === void 0 ? {} : { x: S2, y: P2, r: M2, width: Math.max(U2 || 0, 0), height: Math.max(w2 || 0, 0) }, $2 = this.createElement("rect");
          return this.styledMode || (D2 !== void 0 && (F2["stroke-width"] = D2, u2(F2, $2.crisp(F2))), F2.fill = "none"), $2.rSetter = function(W2, V2, _2) {
            $2.r = W2, l4(_2, { rx: W2, ry: W2 });
          }, $2.rGetter = function() {
            return $2.r || 0;
          }, $2.attr(F2);
        }
        roundedRect(S2) {
          return this.symbol("roundedRect").attr(S2);
        }
        setSize(S2, P2, U2) {
          this.width = S2, this.height = P2, this.boxWrapper.animate({ width: S2, height: P2 }, { step: function() {
            this.attr({ viewBox: "0 0 " + this.attr("width") + " " + this.attr("height") });
          }, duration: k3(U2, true) ? void 0 : 0 }), this.alignElements();
        }
        g(S2) {
          let P2 = this.createElement("g");
          return S2 ? P2.attr({ class: "highcharts-" + S2 }) : P2;
        }
        image(S2, P2, U2, w2, M2, D2) {
          let F2 = { preserveAspectRatio: "none" };
          g2(P2) && (F2.x = P2), g2(U2) && (F2.y = U2), g2(w2) && (F2.width = w2), g2(M2) && (F2.height = M2);
          let $2 = this.createElement("image").attr(F2), W2 = function(V2) {
            $2.attr({ href: S2 }), D2.call($2, V2);
          };
          if (D2) {
            $2.attr({ href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" });
            let V2 = new G2.Image();
            L2(V2, "load", W2), V2.src = S2, V2.complete && W2({});
          } else $2.attr({ href: S2 });
          return $2;
        }
        symbol(S2, P2, U2, w2, M2, D2) {
          let F2, $2, W2, V2, _2 = this, et2 = /^url\((.*?)\)$/, lt2 = et2.test(S2), ht2 = !lt2 && (this.symbols[S2] ? S2 : "circle"), J2 = ht2 && this.symbols[ht2];
          if (J2) typeof P2 == "number" && ($2 = J2.call(this.symbols, P2 || 0, U2 || 0, w2 || 0, M2 || 0, D2)), F2 = this.path($2), _2.styledMode || F2.attr("fill", "none"), u2(F2, { symbolName: ht2 || void 0, x: P2, y: U2, width: w2, height: M2 }), D2 && u2(F2, D2);
          else if (lt2) {
            W2 = S2.match(et2)[1];
            let Y2 = F2 = this.image(W2);
            Y2.imgwidth = k3(D2 && D2.width, I3[W2] && I3[W2].width), Y2.imgheight = k3(D2 && D2.height, I3[W2] && I3[W2].height), V2 = (st2) => st2.attr({ width: st2.width, height: st2.height }), ["width", "height"].forEach((st2) => {
              Y2[`${st2}Setter`] = function(nt2, ot2) {
                this[ot2] = nt2;
                let { alignByTranslate: ut2, element: dt2, width: ct2, height: gt2, imgwidth: ft2, imgheight: pt2 } = this, mt2 = ot2 === "width" ? ft2 : pt2, yt2 = 1;
                D2 && D2.backgroundSize === "within" && ct2 && gt2 && ft2 && pt2 ? (yt2 = Math.min(ct2 / ft2, gt2 / pt2), l4(dt2, { width: Math.round(ft2 * yt2), height: Math.round(pt2 * yt2) })) : dt2 && mt2 && dt2.setAttribute(ot2, mt2), !ut2 && ft2 && pt2 && this.translate(((ct2 || 0) - ft2 * yt2) / 2, ((gt2 || 0) - pt2 * yt2) / 2);
              };
            }), e5(P2) && Y2.attr({ x: P2, y: U2 }), Y2.isImg = true, Y2.symbolUrl = S2, e5(Y2.imgwidth) && e5(Y2.imgheight) ? V2(Y2) : (Y2.attr({ width: 0, height: 0 }), y2("img", { onload: function() {
              let st2 = f2[_2.chartIndex];
              this.width === 0 && (t3(this, { position: "absolute", top: "-999em" }), o2.body.appendChild(this)), I3[W2] = { width: this.width, height: this.height }, Y2.imgwidth = this.width, Y2.imgheight = this.height, Y2.element && V2(Y2), this.parentNode && this.parentNode.removeChild(this), _2.imgCount--, _2.imgCount || !st2 || st2.hasLoaded || st2.onload();
            }, src: W2 }), this.imgCount++);
          }
          return F2;
        }
        clipRect(S2, P2, U2, w2) {
          return this.rect(S2, P2, U2, w2, 0);
        }
        text(S2, P2, U2, w2) {
          let M2 = {};
          if (w2 && (this.allowHTML || !this.forExport)) return this.html(S2, P2, U2);
          M2.x = Math.round(P2 || 0), U2 && (M2.y = Math.round(U2)), e5(S2) && (M2.text = S2);
          let D2 = this.createElement("text").attr(M2);
          return w2 && (!this.forExport || this.allowHTML) || (D2.xSetter = function(F2, $2, W2) {
            let V2 = W2.getElementsByTagName("tspan"), _2 = W2.getAttribute($2);
            for (let et2 = 0, lt2; et2 < V2.length; et2++) (lt2 = V2[et2]).getAttribute($2) === _2 && lt2.setAttribute($2, F2);
            W2.setAttribute($2, F2);
          }), D2;
        }
        fontMetrics(S2) {
          let P2 = E2(tt2.prototype.getStyle.call(S2, "font-size") || 0), U2 = P2 < 24 ? P2 + 3 : Math.round(1.2 * P2), w2 = Math.round(0.8 * U2);
          return { h: U2, b: w2, f: P2 };
        }
        rotCorr(S2, P2, U2) {
          let w2 = S2;
          return P2 && U2 && (w2 = Math.max(w2 * Math.cos(P2 * C3), 4)), { x: -S2 / 3 * Math.sin(P2 * C3), y: w2 };
        }
        pathToSegments(S2) {
          let P2 = [], U2 = [], w2 = { A: 8, C: 7, H: 2, L: 3, M: 3, Q: 5, S: 5, T: 3, V: 2 };
          for (let M2 = 0; M2 < S2.length; M2++) A3(U2[0]) && g2(S2[M2]) && U2.length === w2[U2[0].toUpperCase()] && S2.splice(M2, 0, U2[0].replace("M", "L").replace("m", "l")), typeof S2[M2] == "string" && (U2.length && P2.push(U2.slice(0)), U2.length = 0), U2.push(S2[M2]);
          return P2.push(U2.slice(0)), P2;
        }
        label(S2, P2, U2, w2, M2, D2, F2, $2, W2) {
          return new Z2(this, S2, P2, U2, w2, M2, D2, F2, $2, W2);
        }
        alignElements() {
          this.alignedObjects.forEach((S2) => S2.align());
        }
      }
      return u2(Q2.prototype, { Element: tt2, SVG_NS: T2, escapes: { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }, symbols: X2, draw: c4 }), rt2.registerRendererType("svg", Q2, true), Q2;
    }), at2(s2, "Core/Renderer/HTML/HTMLElement.js", [s2["Core/Renderer/HTML/AST.js"], s2["Core/Globals.js"], s2["Core/Renderer/SVG/SVGElement.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2) {
      let { composed: rt2 } = K2, { attr: tt2, css: Z2, createElement: X2, defined: O3, extend: j3, pInt: d3, pushUnique: x2 } = it2;
      function f2(b5, h2, c4) {
        var T2;
        let I3 = ((T2 = this.div) == null ? void 0 : T2.style) || c4.style;
        q2.prototype[`${h2}Setter`].call(this, b5, h2, c4), I3 && (I3[h2] = b5);
      }
      let C3 = (b5, h2) => {
        var c4;
        if (!b5.div) {
          let T2 = tt2(b5.element, "class"), I3 = b5.css, G2 = X2("div", T2 ? { className: T2 } : void 0, { position: "absolute", left: `${b5.translateX || 0}px`, top: `${b5.translateY || 0}px`, ...b5.styles, display: b5.display, opacity: b5.opacity, visibility: b5.visibility }, ((c4 = b5.parentGroup) == null ? void 0 : c4.div) || h2);
          b5.classSetter = (L2, l4, y2) => {
            y2.setAttribute("class", L2), G2.className = L2;
          }, b5.translateXSetter = b5.translateYSetter = (L2, l4) => {
            b5[l4] = L2, G2.style[l4 === "translateX" ? "left" : "top"] = `${L2}px`, b5.doTransform = true;
          }, b5.opacitySetter = b5.visibilitySetter = f2, b5.css = (L2) => (I3.call(b5, L2), L2.cursor && (G2.style.cursor = L2.cursor), L2.pointerEvents && (G2.style.pointerEvents = L2.pointerEvents), b5), b5.on = function() {
            return q2.prototype.on.apply({ element: G2, onEvents: b5.onEvents }, arguments), b5;
          }, b5.div = G2;
        }
        return b5.div;
      };
      class o2 extends q2 {
        static compose(h2) {
          x2(rt2, this.compose) && (h2.prototype.html = function(c4, T2, I3) {
            return new o2(this, "span").attr({ text: c4, x: Math.round(T2), y: Math.round(I3) });
          });
        }
        constructor(h2, c4) {
          super(h2, c4), this.css({ position: "absolute", ...h2.styledMode ? {} : { fontFamily: h2.style.fontFamily, fontSize: h2.style.fontSize } }), this.element.style.whiteSpace = "nowrap";
        }
        getSpanCorrection(h2, c4, T2) {
          this.xCorr = -h2 * T2, this.yCorr = -c4;
        }
        css(h2) {
          let c4, { element: T2 } = this, I3 = T2.tagName === "SPAN" && h2 && "width" in h2, G2 = I3 && h2.width;
          return I3 && (delete h2.width, this.textWidth = d3(G2) || void 0, c4 = true), (h2 == null ? void 0 : h2.textOverflow) === "ellipsis" && (h2.whiteSpace = "nowrap", h2.overflow = "hidden"), j3(this.styles, h2), Z2(T2, h2), c4 && this.updateTransform(), this;
        }
        htmlGetBBox() {
          let { element: h2 } = this;
          return { x: h2.offsetLeft, y: h2.offsetTop, width: h2.offsetWidth, height: h2.offsetHeight };
        }
        updateTransform() {
          var h2;
          if (!this.added) {
            this.alignOnAdd = true;
            return;
          }
          let { element: c4, renderer: T2, rotation: I3, rotationOriginX: G2, rotationOriginY: L2, styles: l4, textAlign: y2 = "left", textWidth: i5, translateX: t3 = 0, translateY: e5 = 0, x: n4 = 0, y: u2 = 0 } = this, a2 = { left: 0, center: 0.5, right: 1 }[y2], g2 = l4.whiteSpace;
          if (Z2(c4, { marginLeft: `${t3}px`, marginTop: `${e5}px` }), c4.tagName === "SPAN") {
            let r3 = [I3, y2, c4.innerHTML, i5, this.textAlign].join(","), A3 = -(((h2 = this.parentGroup) == null ? void 0 : h2.padding) * 1) || 0, N2, k3 = false;
            if (i5 !== this.oldTextWidth) {
              let v3 = this.textPxLength ? this.textPxLength : (Z2(c4, { width: "", whiteSpace: g2 || "nowrap" }), c4.offsetWidth), S2 = i5 || 0;
              (S2 > this.oldTextWidth || v3 > S2) && (/[ \-]/.test(c4.textContent || c4.innerText) || c4.style.textOverflow === "ellipsis") && (Z2(c4, { width: v3 > S2 || I3 ? i5 + "px" : "auto", display: "block", whiteSpace: g2 || "normal" }), this.oldTextWidth = i5, k3 = true);
            }
            this.hasBoxWidthChanged = k3, r3 !== this.cTT && (N2 = T2.fontMetrics(c4).b, O3(I3) && (I3 !== (this.oldRotation || 0) || y2 !== this.oldAlign) && this.setSpanRotation(I3, A3, A3), this.getSpanCorrection(!O3(I3) && this.textPxLength || c4.offsetWidth, N2, a2));
            let { xCorr: E2 = 0, yCorr: R2 = 0 } = this, z2 = (G2 != null ? G2 : n4) - E2 - n4 - A3, Q2 = (L2 != null ? L2 : u2) - R2 - u2 - A3;
            Z2(c4, { left: `${n4 + E2}px`, top: `${u2 + R2}px`, transformOrigin: `${z2}px ${Q2}px` }), this.cTT = r3, this.oldRotation = I3, this.oldAlign = y2;
          }
        }
        setSpanRotation(h2, c4, T2) {
          Z2(this.element, { transform: `rotate(${h2}deg)`, transformOrigin: `${c4}% ${T2}px` });
        }
        add(h2) {
          let c4, T2 = this.renderer.box.parentNode, I3 = [];
          if (this.parentGroup = h2, h2 && !(c4 = h2.div)) {
            let G2 = h2;
            for (; G2; ) I3.push(G2), G2 = G2.parentGroup;
            for (let L2 of I3.reverse()) c4 = C3(L2, T2);
          }
          return (c4 || T2).appendChild(this.element), this.added = true, this.alignOnAdd && this.updateTransform(), this;
        }
        textSetter(h2) {
          h2 !== this.textStr && (delete this.bBox, delete this.oldTextWidth, B3.setElementHTML(this.element, h2 != null ? h2 : ""), this.textStr = h2, this.doTransform = true);
        }
        alignSetter(h2) {
          this.alignValue = this.textAlign = h2, this.doTransform = true;
        }
        xSetter(h2, c4) {
          this[c4] = h2, this.doTransform = true;
        }
      }
      let p2 = o2.prototype;
      return p2.visibilitySetter = p2.opacitySetter = f2, p2.ySetter = p2.rotationSetter = p2.rotationOriginXSetter = p2.rotationOriginYSetter = p2.xSetter, o2;
    }), at2(s2, "Core/Axis/AxisDefaults.js", [], function() {
      var B3, K2;
      return (K2 = B3 || (B3 = {})).xAxis = { alignTicks: true, allowDecimals: void 0, panningEnabled: true, zIndex: 2, zoomEnabled: true, dateTimeLabelFormats: { millisecond: { main: "%H:%M:%S.%L", range: false }, second: { main: "%H:%M:%S", range: false }, minute: { main: "%H:%M", range: false }, hour: { main: "%H:%M", range: false }, day: { main: "%e %b" }, week: { main: "%e %b" }, month: { main: "%b '%y" }, year: { main: "%Y" } }, endOnTick: false, gridLineDashStyle: "Solid", gridZIndex: 1, labels: { autoRotationLimit: 80, distance: 15, enabled: true, indentation: 10, overflow: "justify", reserveSpace: void 0, rotation: void 0, staggerLines: 0, step: 0, useHTML: false, zIndex: 7, style: { color: "#333333", cursor: "default", fontSize: "0.8em" } }, maxPadding: 0.01, minorGridLineDashStyle: "Solid", minorTickLength: 2, minorTickPosition: "outside", minorTicksPerMajor: 5, minPadding: 0.01, offset: void 0, reversed: void 0, reversedStacks: false, showEmpty: true, showFirstLabel: true, showLastLabel: true, startOfWeek: 1, startOnTick: false, tickLength: 10, tickPixelInterval: 100, tickmarkPlacement: "between", tickPosition: "outside", title: { align: "middle", useHTML: false, x: 0, y: 0, style: { color: "#666666", fontSize: "0.8em" } }, visible: true, minorGridLineColor: "#f2f2f2", minorGridLineWidth: 1, minorTickColor: "#999999", lineColor: "#333333", lineWidth: 1, gridLineColor: "#e6e6e6", gridLineWidth: void 0, tickColor: "#333333" }, K2.yAxis = { reversedStacks: true, endOnTick: true, maxPadding: 0.05, minPadding: 0.05, tickPixelInterval: 72, showLastLabel: true, labels: { x: void 0 }, startOnTick: true, title: { text: "Values" }, stackLabels: { animation: {}, allowOverlap: false, enabled: false, crop: true, overflow: "justify", formatter: function() {
        let { numberFormatter: q2 } = this.axis.chart;
        return q2(this.total || 0, -1);
      }, style: { color: "#000000", fontSize: "0.7em", fontWeight: "bold", textOutline: "1px contrast" } }, gridLineWidth: 1, lineWidth: 0 }, B3;
    }), at2(s2, "Core/Foundation.js", [s2["Core/Utilities.js"]], function(B3) {
      var K2;
      let { addEvent: q2, isFunction: it2, objectEach: rt2, removeEvent: tt2 } = B3;
      return (K2 || (K2 = {})).registerEventOptions = function(Z2, X2) {
        Z2.eventOptions = Z2.eventOptions || {}, rt2(X2.events, function(O3, j3) {
          Z2.eventOptions[j3] !== O3 && (Z2.eventOptions[j3] && (tt2(Z2, j3, Z2.eventOptions[j3]), delete Z2.eventOptions[j3]), it2(O3) && (Z2.eventOptions[j3] = O3, q2(Z2, j3, O3, { order: 0 })));
        });
      }, K2;
    }), at2(s2, "Core/Axis/Tick.js", [s2["Core/Templating.js"], s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { deg2rad: it2 } = K2, { clamp: rt2, correctFloat: tt2, defined: Z2, destroyObjectProperties: X2, extend: O3, fireEvent: j3, isNumber: d3, merge: x2, objectEach: f2, pick: C3 } = q2;
      return class {
        constructor(o2, p2, b5, h2, c4) {
          this.isNew = true, this.isNewLabel = true, this.axis = o2, this.pos = p2, this.type = b5 || "", this.parameters = c4 || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, j3(this, "init"), b5 || h2 || this.addLabel();
        }
        addLabel() {
          let o2 = this, p2 = o2.axis, b5 = p2.options, h2 = p2.chart, c4 = p2.categories, T2 = p2.logarithmic, I3 = p2.names, G2 = o2.pos, L2 = C3(o2.options && o2.options.labels, b5.labels), l4 = p2.tickPositions, y2 = G2 === l4[0], i5 = G2 === l4[l4.length - 1], t3 = (!L2.step || L2.step === 1) && p2.tickInterval === 1, e5 = l4.info, n4 = o2.label, u2, a2, g2, r3 = this.parameters.category || (c4 ? C3(c4[G2], I3[G2], G2) : G2);
          T2 && d3(r3) && (r3 = tt2(T2.lin2log(r3))), p2.dateTime && (e5 ? u2 = (a2 = h2.time.resolveDTLFormat(b5.dateTimeLabelFormats[!b5.grid && e5.higherRanks[G2] || e5.unitName])).main : d3(r3) && (u2 = p2.dateTime.getXDateFormat(r3, b5.dateTimeLabelFormats || {}))), o2.isFirst = y2, o2.isLast = i5;
          let A3 = { axis: p2, chart: h2, dateTimeLabelFormat: u2, isFirst: y2, isLast: i5, pos: G2, tick: o2, tickPositionInfo: e5, value: r3 };
          j3(this, "labelFormat", A3);
          let N2 = (R2) => L2.formatter ? L2.formatter.call(R2, R2) : L2.format ? (R2.text = p2.defaultLabelFormatter.call(R2), B3.format(L2.format, R2, h2)) : p2.defaultLabelFormatter.call(R2), k3 = N2.call(A3, A3), E2 = a2 && a2.list;
          E2 ? o2.shortenLabel = function() {
            for (g2 = 0; g2 < E2.length; g2++) if (O3(A3, { dateTimeLabelFormat: E2[g2] }), n4.attr({ text: N2.call(A3, A3) }), n4.getBBox().width < p2.getSlotWidth(o2) - 2 * (L2.padding || 0)) return;
            n4.attr({ text: "" });
          } : o2.shortenLabel = void 0, t3 && p2._addedPlotLB && o2.moveLabel(k3, L2), Z2(n4) || o2.movedLabel ? n4 && n4.textStr !== k3 && !t3 && (!n4.textWidth || L2.style.width || n4.styles.width || n4.css({ width: null }), n4.attr({ text: k3 }), n4.textPxLength = n4.getBBox().width) : (o2.label = n4 = o2.createLabel(k3, L2), o2.rotation = 0);
        }
        createLabel(o2, p2, b5) {
          let h2 = this.axis, c4 = h2.chart, T2 = Z2(o2) && p2.enabled ? c4.renderer.text(o2, b5 == null ? void 0 : b5.x, b5 == null ? void 0 : b5.y, p2.useHTML).add(h2.labelGroup) : void 0;
          return T2 && (c4.styledMode || T2.css(x2(p2.style)), T2.textPxLength = T2.getBBox().width), T2;
        }
        destroy() {
          X2(this, this.axis);
        }
        getPosition(o2, p2, b5, h2) {
          let c4 = this.axis, T2 = c4.chart, I3 = h2 && T2.oldChartHeight || T2.chartHeight, G2 = { x: o2 ? tt2(c4.translate(p2 + b5, void 0, void 0, h2) + c4.transB) : c4.left + c4.offset + (c4.opposite ? (h2 && T2.oldChartWidth || T2.chartWidth) - c4.right - c4.left : 0), y: o2 ? I3 - c4.bottom + c4.offset - (c4.opposite ? c4.height : 0) : tt2(I3 - c4.translate(p2 + b5, void 0, void 0, h2) - c4.transB) };
          return G2.y = rt2(G2.y, -1e9, 1e9), j3(this, "afterGetPosition", { pos: G2 }), G2;
        }
        getLabelPosition(o2, p2, b5, h2, c4, T2, I3, G2) {
          let L2, l4, y2 = this.axis, i5 = y2.transA, t3 = y2.isLinked && y2.linkedParent ? y2.linkedParent.reversed : y2.reversed, e5 = y2.staggerLines, n4 = y2.tickRotCorr || { x: 0, y: 0 }, u2 = h2 || y2.reserveSpaceDefault ? 0 : -y2.labelOffset * (y2.labelAlign === "center" ? 0.5 : 1), a2 = c4.distance, g2 = {};
          return L2 = y2.side === 0 ? b5.rotation ? -a2 : -b5.getBBox().height : y2.side === 2 ? n4.y + a2 : Math.cos(b5.rotation * it2) * (n4.y - b5.getBBox(false, 0).height / 2), Z2(c4.y) && (L2 = y2.side === 0 && y2.horiz ? c4.y + L2 : c4.y), o2 = o2 + C3(c4.x, [0, 1, 0, -1][y2.side] * a2) + u2 + n4.x - (T2 && h2 ? T2 * i5 * (t3 ? -1 : 1) : 0), p2 = p2 + L2 - (T2 && !h2 ? T2 * i5 * (t3 ? 1 : -1) : 0), e5 && (l4 = I3 / (G2 || 1) % e5, y2.opposite && (l4 = e5 - l4 - 1), p2 += l4 * (y2.labelOffset / e5)), g2.x = o2, g2.y = Math.round(p2), j3(this, "afterGetLabelPosition", { pos: g2, tickmarkOffset: T2, index: I3 }), g2;
        }
        getLabelSize() {
          return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
        }
        getMarkPath(o2, p2, b5, h2, c4 = false, T2) {
          return T2.crispLine([["M", o2, p2], ["L", o2 + (c4 ? 0 : -b5), p2 + (c4 ? b5 : 0)]], h2);
        }
        handleOverflow(o2) {
          let p2 = this.axis, b5 = p2.options.labels, h2 = o2.x, c4 = p2.chart.chartWidth, T2 = p2.chart.spacing, I3 = C3(p2.labelLeft, Math.min(p2.pos, T2[3])), G2 = C3(p2.labelRight, Math.max(p2.isRadial ? 0 : p2.pos + p2.len, c4 - T2[1])), L2 = this.label, l4 = this.rotation, y2 = { left: 0, center: 0.5, right: 1 }[p2.labelAlign || L2.attr("align")], i5 = L2.getBBox().width, t3 = p2.getSlotWidth(this), e5 = {}, n4 = t3, u2 = 1, a2, g2, r3;
          l4 || b5.overflow !== "justify" ? l4 < 0 && h2 - y2 * i5 < I3 ? r3 = Math.round(h2 / Math.cos(l4 * it2) - I3) : l4 > 0 && h2 + y2 * i5 > G2 && (r3 = Math.round((c4 - h2) / Math.cos(l4 * it2))) : (a2 = h2 - y2 * i5, g2 = h2 + (1 - y2) * i5, a2 < I3 ? n4 = o2.x + n4 * (1 - y2) - I3 : g2 > G2 && (n4 = G2 - o2.x + n4 * y2, u2 = -1), (n4 = Math.min(t3, n4)) < t3 && p2.labelAlign === "center" && (o2.x += u2 * (t3 - n4 - y2 * (t3 - Math.min(i5, n4)))), (i5 > n4 || p2.autoRotation && (L2.styles || {}).width) && (r3 = n4)), r3 && (this.shortenLabel ? this.shortenLabel() : (e5.width = Math.floor(r3) + "px", (b5.style || {}).textOverflow || (e5.textOverflow = "ellipsis"), L2.css(e5)));
        }
        moveLabel(o2, p2) {
          let b5 = this, h2 = b5.label, c4 = b5.axis, T2 = false, I3;
          h2 && h2.textStr === o2 ? (b5.movedLabel = h2, T2 = true, delete b5.label) : f2(c4.ticks, function(G2) {
            T2 || G2.isNew || G2 === b5 || !G2.label || G2.label.textStr !== o2 || (b5.movedLabel = G2.label, T2 = true, G2.labelPos = b5.movedLabel.xy, delete G2.label);
          }), !T2 && (b5.labelPos || h2) && (I3 = b5.labelPos || h2.xy, b5.movedLabel = b5.createLabel(o2, p2, I3), b5.movedLabel && b5.movedLabel.attr({ opacity: 0 }));
        }
        render(o2, p2, b5) {
          let h2 = this.axis, c4 = h2.horiz, T2 = this.pos, I3 = C3(this.tickmarkOffset, h2.tickmarkOffset), G2 = this.getPosition(c4, T2, I3, p2), L2 = G2.x, l4 = G2.y, y2 = h2.pos, i5 = y2 + h2.len, t3 = c4 ? L2 : l4;
          !h2.chart.polar && this.isNew && (tt2(t3) < y2 || t3 > i5) && (b5 = 0);
          let e5 = C3(b5, this.label && this.label.newOpacity, 1);
          b5 = C3(b5, 1), this.isActive = true, this.renderGridLine(p2, b5), this.renderMark(G2, b5), this.renderLabel(G2, p2, e5, o2), this.isNew = false, j3(this, "afterRender");
        }
        renderGridLine(o2, p2) {
          let b5 = this.axis, h2 = b5.options, c4 = {}, T2 = this.pos, I3 = this.type, G2 = C3(this.tickmarkOffset, b5.tickmarkOffset), L2 = b5.chart.renderer, l4 = this.gridLine, y2, i5 = h2.gridLineWidth, t3 = h2.gridLineColor, e5 = h2.gridLineDashStyle;
          this.type === "minor" && (i5 = h2.minorGridLineWidth, t3 = h2.minorGridLineColor, e5 = h2.minorGridLineDashStyle), l4 || (b5.chart.styledMode || (c4.stroke = t3, c4["stroke-width"] = i5 || 0, c4.dashstyle = e5), I3 || (c4.zIndex = 1), o2 && (p2 = 0), this.gridLine = l4 = L2.path().attr(c4).addClass("highcharts-" + (I3 ? I3 + "-" : "") + "grid-line").add(b5.gridGroup)), l4 && (y2 = b5.getPlotLinePath({ value: T2 + G2, lineWidth: l4.strokeWidth(), force: "pass", old: o2, acrossPanes: false })) && l4[o2 || this.isNew ? "attr" : "animate"]({ d: y2, opacity: p2 });
        }
        renderMark(o2, p2) {
          let b5 = this.axis, h2 = b5.options, c4 = b5.chart.renderer, T2 = this.type, I3 = b5.tickSize(T2 ? T2 + "Tick" : "tick"), G2 = o2.x, L2 = o2.y, l4 = C3(h2[T2 !== "minor" ? "tickWidth" : "minorTickWidth"], !T2 && b5.isXAxis ? 1 : 0), y2 = h2[T2 !== "minor" ? "tickColor" : "minorTickColor"], i5 = this.mark, t3 = !i5;
          I3 && (b5.opposite && (I3[0] = -I3[0]), i5 || (this.mark = i5 = c4.path().addClass("highcharts-" + (T2 ? T2 + "-" : "") + "tick").add(b5.axisGroup), b5.chart.styledMode || i5.attr({ stroke: y2, "stroke-width": l4 })), i5[t3 ? "attr" : "animate"]({ d: this.getMarkPath(G2, L2, I3[0], i5.strokeWidth(), b5.horiz, c4), opacity: p2 }));
        }
        renderLabel(o2, p2, b5, h2) {
          let c4 = this.axis, T2 = c4.horiz, I3 = c4.options, G2 = this.label, L2 = I3.labels, l4 = L2.step, y2 = C3(this.tickmarkOffset, c4.tickmarkOffset), i5 = o2.x, t3 = o2.y, e5 = true;
          G2 && d3(i5) && (G2.xy = o2 = this.getLabelPosition(i5, t3, G2, T2, L2, y2, h2, l4), (!this.isFirst || this.isLast || I3.showFirstLabel) && (!this.isLast || this.isFirst || I3.showLastLabel) ? !T2 || L2.step || L2.rotation || p2 || b5 === 0 || this.handleOverflow(o2) : e5 = false, l4 && h2 % l4 && (e5 = false), e5 && d3(o2.y) ? (o2.opacity = b5, G2[this.isNewLabel ? "attr" : "animate"](o2).show(true), this.isNewLabel = false) : (G2.hide(), this.isNewLabel = true));
        }
        replaceMovedLabel() {
          let o2 = this.label, p2 = this.axis;
          o2 && !this.isNew && (o2.animate({ opacity: 0 }, void 0, o2.destroy), delete this.label), p2.isDirty = true, this.label = this.movedLabel, delete this.movedLabel;
        }
      };
    }), at2(s2, "Core/Axis/Axis.js", [s2["Core/Animation/AnimationUtilities.js"], s2["Core/Axis/AxisDefaults.js"], s2["Core/Color/Color.js"], s2["Core/Defaults.js"], s2["Core/Foundation.js"], s2["Core/Globals.js"], s2["Core/Axis/Tick.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2) {
      let { animObject: O3 } = B3, { xAxis: j3, yAxis: d3 } = K2, { defaultOptions: x2 } = it2, { registerEventOptions: f2 } = rt2, { deg2rad: C3 } = tt2, { arrayMax: o2, arrayMin: p2, clamp: b5, correctFloat: h2, defined: c4, destroyObjectProperties: T2, erase: I3, error: G2, extend: L2, fireEvent: l4, getClosestDistance: y2, insertItem: i5, isArray: t3, isNumber: e5, isString: n4, merge: u2, normalizeTickInterval: a2, objectEach: g2, pick: r3, relativeLength: A3, removeEvent: N2, splat: k3, syncTimeout: E2 } = X2, R2 = (Q2, v3) => a2(v3, void 0, void 0, r3(Q2.options.allowDecimals, v3 < 0.5 || Q2.tickAmount !== void 0), !!Q2.tickAmount);
      L2(x2, { xAxis: j3, yAxis: u2(j3, d3) });
      class z2 {
        constructor(v3, S2, P2) {
          this.init(v3, S2, P2);
        }
        init(v3, S2, P2 = this.coll) {
          var U2;
          let w2 = P2 === "xAxis", M2 = this.isZAxis || (v3.inverted ? !w2 : w2);
          this.chart = v3, this.horiz = M2, this.isXAxis = w2, this.coll = P2, l4(this, "init", { userOptions: S2 }), this.opposite = r3(S2.opposite, this.opposite), this.side = r3(S2.side, this.side, M2 ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(S2);
          let D2 = this.options, F2 = D2.labels;
          this.type != null || (this.type = D2.type || "linear"), this.uniqueNames != null || (this.uniqueNames = (U2 = D2.uniqueNames) != null ? U2 : true), l4(this, "afterSetType"), this.userOptions = S2, this.minPixelPadding = 0, this.reversed = r3(D2.reversed, this.reversed), this.visible = D2.visible, this.zoomEnabled = D2.zoomEnabled, this.hasNames = this.type === "category" || D2.categories === true, this.categories = t3(D2.categories) && D2.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = c4(D2.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, this.len != null || (this.len = 0), this.minRange = this.userMinRange = D2.minRange || D2.maxZoom, this.range = D2.range, this.offset = D2.offset || 0, this.max = void 0, this.min = void 0;
          let $2 = r3(D2.crosshair, k3(v3.options.tooltip.crosshairs)[w2 ? 0 : 1]);
          this.crosshair = $2 === true ? {} : $2, v3.axes.indexOf(this) === -1 && (w2 ? v3.axes.splice(v3.xAxis.length, 0, this) : v3.axes.push(this), i5(this, v3[this.coll])), v3.orderItems(this.coll), this.series = this.series || [], v3.inverted && !this.isZAxis && w2 && !c4(this.reversed) && (this.reversed = true), this.labelRotation = e5(F2.rotation) ? F2.rotation : void 0, f2(this, D2), l4(this, "afterInit");
        }
        setOptions(v3) {
          let S2 = this.horiz ? { labels: { autoRotation: [-45], padding: 4 }, margin: 15 } : { labels: { padding: 1 }, title: { rotation: 90 * this.side } };
          this.options = u2(S2, x2[this.coll], v3), l4(this, "afterSetOptions", { userOptions: v3 });
        }
        defaultLabelFormatter() {
          let v3 = this.axis, { numberFormatter: S2 } = this.chart, P2 = e5(this.value) ? this.value : NaN, U2 = v3.chart.time, w2 = v3.categories, M2 = this.dateTimeLabelFormat, D2 = x2.lang, F2 = D2.numericSymbols, $2 = D2.numericSymbolMagnitude || 1e3, W2 = v3.logarithmic ? Math.abs(P2) : v3.tickInterval, V2 = F2 && F2.length, _2, et2;
          if (w2) et2 = `${this.value}`;
          else if (M2) et2 = U2.dateFormat(M2, P2);
          else if (V2 && F2 && W2 >= 1e3) for (; V2-- && et2 === void 0; ) W2 >= (_2 = Math.pow($2, V2 + 1)) && 10 * P2 % _2 == 0 && F2[V2] !== null && P2 !== 0 && (et2 = S2(P2 / _2, -1) + F2[V2]);
          return et2 === void 0 && (et2 = Math.abs(P2) >= 1e4 ? S2(P2, -1) : S2(P2, -1, void 0, "")), et2;
        }
        getSeriesExtremes() {
          let v3, S2 = this;
          l4(this, "getSeriesExtremes", null, function() {
            S2.hasVisibleSeries = false, S2.dataMin = S2.dataMax = S2.threshold = void 0, S2.softThreshold = !S2.isXAxis, S2.series.forEach((P2) => {
              if (P2.reserveSpace()) {
                let U2 = P2.options, w2, M2 = U2.threshold, D2, F2;
                if (S2.hasVisibleSeries = true, S2.positiveValuesOnly && 0 >= (M2 || 0) && (M2 = void 0), S2.isXAxis) (w2 = P2.xData) && w2.length && (w2 = S2.logarithmic ? w2.filter(($2) => $2 > 0) : w2, D2 = (v3 = P2.getXExtremes(w2)).min, F2 = v3.max, e5(D2) || D2 instanceof Date || (w2 = w2.filter(e5), D2 = (v3 = P2.getXExtremes(w2)).min, F2 = v3.max), w2.length && (S2.dataMin = Math.min(r3(S2.dataMin, D2), D2), S2.dataMax = Math.max(r3(S2.dataMax, F2), F2)));
                else {
                  let $2 = P2.applyExtremes();
                  e5($2.dataMin) && (D2 = $2.dataMin, S2.dataMin = Math.min(r3(S2.dataMin, D2), D2)), e5($2.dataMax) && (F2 = $2.dataMax, S2.dataMax = Math.max(r3(S2.dataMax, F2), F2)), c4(M2) && (S2.threshold = M2), (!U2.softThreshold || S2.positiveValuesOnly) && (S2.softThreshold = false);
                }
              }
            });
          }), l4(this, "afterGetSeriesExtremes");
        }
        translate(v3, S2, P2, U2, w2, M2) {
          var D2;
          let F2 = this.linkedParent || this, $2 = U2 && F2.old ? F2.old.min : F2.min;
          if (!e5($2)) return NaN;
          let W2 = F2.minPixelPadding, V2 = (F2.isOrdinal || ((D2 = F2.brokenAxis) == null ? void 0 : D2.hasBreaks) || F2.logarithmic && w2) && F2.lin2val, _2 = 1, et2 = 0, lt2 = U2 && F2.old ? F2.old.transA : F2.transA, ht2 = 0;
          return lt2 || (lt2 = F2.transA), P2 && (_2 *= -1, et2 = F2.len), F2.reversed && (_2 *= -1, et2 -= _2 * (F2.sector || F2.len)), S2 ? (ht2 = (v3 = v3 * _2 + et2 - W2) / lt2 + $2, V2 && (ht2 = F2.lin2val(ht2))) : (V2 && (v3 = F2.val2lin(v3)), ht2 = _2 * (v3 - $2) * lt2 + et2 + _2 * W2 + (e5(M2) ? lt2 * M2 : 0), F2.isRadial || (ht2 = h2(ht2))), ht2;
        }
        toPixels(v3, S2) {
          return this.translate(v3, false, !this.horiz, void 0, true) + (S2 ? 0 : this.pos);
        }
        toValue(v3, S2) {
          return this.translate(v3 - (S2 ? 0 : this.pos), true, !this.horiz, void 0, true);
        }
        getPlotLinePath(v3) {
          let S2 = this, P2 = S2.chart, U2 = S2.left, w2 = S2.top, M2 = v3.old, D2 = v3.value, F2 = v3.lineWidth, $2 = M2 && P2.oldChartHeight || P2.chartHeight, W2 = M2 && P2.oldChartWidth || P2.chartWidth, V2 = S2.transB, _2 = v3.translatedValue, et2 = v3.force, lt2, ht2, J2, Y2, st2;
          function nt2(ut2, dt2, ct2) {
            return et2 !== "pass" && (ut2 < dt2 || ut2 > ct2) && (et2 ? ut2 = b5(ut2, dt2, ct2) : st2 = true), ut2;
          }
          let ot2 = { value: D2, lineWidth: F2, old: M2, force: et2, acrossPanes: v3.acrossPanes, translatedValue: _2 };
          return l4(this, "getPlotLinePath", ot2, function(ut2) {
            lt2 = J2 = (_2 = b5(_2 = r3(_2, S2.translate(D2, void 0, void 0, M2)), -1e9, 1e9)) + V2, ht2 = Y2 = $2 - _2 - V2, e5(_2) ? S2.horiz ? (ht2 = w2, Y2 = $2 - S2.bottom + (S2.options.isInternal ? 0 : P2.scrollablePixelsY || 0), lt2 = J2 = nt2(lt2, U2, U2 + S2.width)) : (lt2 = U2, J2 = W2 - S2.right + (P2.scrollablePixelsX || 0), ht2 = Y2 = nt2(ht2, w2, w2 + S2.height)) : (st2 = true, et2 = false), ut2.path = st2 && !et2 ? void 0 : P2.renderer.crispLine([["M", lt2, ht2], ["L", J2, Y2]], F2 || 1);
          }), ot2.path;
        }
        getLinearTickPositions(v3, S2, P2) {
          let U2, w2, M2, D2 = h2(Math.floor(S2 / v3) * v3), F2 = h2(Math.ceil(P2 / v3) * v3), $2 = [];
          if (h2(D2 + v3) === D2 && (M2 = 20), this.single) return [S2];
          for (U2 = D2; U2 <= F2 && ($2.push(U2), (U2 = h2(U2 + v3, M2)) !== w2); ) w2 = U2;
          return $2;
        }
        getMinorTickInterval() {
          let { minorTicks: v3, minorTickInterval: S2 } = this.options;
          return v3 === true ? r3(S2, "auto") : v3 !== false ? S2 : void 0;
        }
        getMinorTickPositions() {
          let v3 = this.options, S2 = this.tickPositions, P2 = this.minorTickInterval, U2 = this.pointRangePadding || 0, w2 = (this.min || 0) - U2, M2 = (this.max || 0) + U2, D2 = M2 - w2, F2 = [], $2;
          if (D2 && D2 / P2 < this.len / 3) {
            let W2 = this.logarithmic;
            if (W2) this.paddedTicks.forEach(function(V2, _2, et2) {
              _2 && F2.push.apply(F2, W2.getLogTickPositions(P2, et2[_2 - 1], et2[_2], true));
            });
            else if (this.dateTime && this.getMinorTickInterval() === "auto") F2 = F2.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(P2), w2, M2, v3.startOfWeek));
            else for ($2 = w2 + (S2[0] - w2) % P2; $2 <= M2 && $2 !== F2[0]; $2 += P2) F2.push($2);
          }
          return F2.length !== 0 && this.trimTicks(F2), F2;
        }
        adjustForMinRange() {
          let v3 = this.options, S2 = this.logarithmic, { max: P2, min: U2, minRange: w2 } = this, M2, D2, F2, $2;
          this.isXAxis && w2 === void 0 && !S2 && (w2 = c4(v3.min) || c4(v3.max) || c4(v3.floor) || c4(v3.ceiling) ? null : Math.min(5 * (y2(this.series.map((W2) => {
            var V2;
            return (W2.xIncrement ? (V2 = W2.xData) == null ? void 0 : V2.slice(0, 2) : W2.xData) || [];
          })) || 0), this.dataMax - this.dataMin)), e5(P2) && e5(U2) && e5(w2) && P2 - U2 < w2 && (D2 = this.dataMax - this.dataMin >= w2, M2 = (w2 - P2 + U2) / 2, F2 = [U2 - M2, r3(v3.min, U2 - M2)], D2 && (F2[2] = S2 ? S2.log2lin(this.dataMin) : this.dataMin), $2 = [(U2 = o2(F2)) + w2, r3(v3.max, U2 + w2)], D2 && ($2[2] = S2 ? S2.log2lin(this.dataMax) : this.dataMax), (P2 = p2($2)) - U2 < w2 && (F2[0] = P2 - w2, F2[1] = r3(v3.min, P2 - w2), U2 = o2(F2))), this.minRange = w2, this.min = U2, this.max = P2;
        }
        getClosest() {
          let v3, S2;
          if (this.categories) S2 = 1;
          else {
            let P2 = [];
            this.series.forEach(function(U2) {
              var w2;
              let M2 = U2.closestPointRange;
              ((w2 = U2.xData) == null ? void 0 : w2.length) === 1 ? P2.push(U2.xData[0]) : !U2.noSharedTooltip && c4(M2) && U2.reserveSpace() && (S2 = c4(S2) ? Math.min(S2, M2) : M2);
            }), P2.length && (P2.sort((U2, w2) => U2 - w2), v3 = y2([P2]));
          }
          return v3 && S2 ? Math.min(v3, S2) : v3 || S2;
        }
        nameToX(v3) {
          let S2 = t3(this.options.categories), P2 = S2 ? this.categories : this.names, U2 = v3.options.x, w2;
          return v3.series.requireSorting = false, c4(U2) || (U2 = this.uniqueNames && P2 ? S2 ? P2.indexOf(v3.name) : r3(P2.keys[v3.name], -1) : v3.series.autoIncrement()), U2 === -1 ? !S2 && P2 && (w2 = P2.length) : w2 = U2, w2 !== void 0 ? (this.names[w2] = v3.name, this.names.keys[v3.name] = w2) : v3.x && (w2 = v3.x), w2;
        }
        updateNames() {
          let v3 = this, S2 = this.names;
          S2.length > 0 && (Object.keys(S2.keys).forEach(function(P2) {
            delete S2.keys[P2];
          }), S2.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((P2) => {
            P2.xIncrement = null, (!P2.points || P2.isDirtyData) && (v3.max = Math.max(v3.max, P2.xData.length - 1), P2.processData(), P2.generatePoints()), P2.data.forEach(function(U2, w2) {
              let M2;
              U2 != null && U2.options && U2.name !== void 0 && (M2 = v3.nameToX(U2)) !== void 0 && M2 !== U2.x && (U2.x = M2, P2.xData[w2] = M2);
            });
          }));
        }
        setAxisTranslation() {
          let v3 = this, S2 = v3.max - v3.min, P2 = v3.linkedParent, U2 = !!v3.categories, w2 = v3.isXAxis, M2 = v3.axisPointRange || 0, D2, F2 = 0, $2 = 0, W2, V2 = v3.transA;
          (w2 || U2 || M2) && (D2 = v3.getClosest(), P2 ? (F2 = P2.minPointOffset, $2 = P2.pointRangePadding) : v3.series.forEach(function(_2) {
            let et2 = U2 ? 1 : w2 ? r3(_2.options.pointRange, D2, 0) : v3.axisPointRange || 0, lt2 = _2.options.pointPlacement;
            if (M2 = Math.max(M2, et2), !v3.single || U2) {
              let ht2 = _2.is("xrange") ? !w2 : w2;
              F2 = Math.max(F2, ht2 && n4(lt2) ? 0 : et2 / 2), $2 = Math.max($2, ht2 && lt2 === "on" ? 0 : et2);
            }
          }), W2 = v3.ordinal && v3.ordinal.slope && D2 ? v3.ordinal.slope / D2 : 1, v3.minPointOffset = F2 *= W2, v3.pointRangePadding = $2 *= W2, v3.pointRange = Math.min(M2, v3.single && U2 ? 1 : S2), w2 && D2 && (v3.closestPointRange = D2)), v3.translationSlope = v3.transA = V2 = v3.staticScale || v3.len / (S2 + $2 || 1), v3.transB = v3.horiz ? v3.left : v3.bottom, v3.minPixelPadding = V2 * F2, l4(this, "afterSetAxisTranslation");
        }
        minFromRange() {
          let { max: v3, min: S2 } = this;
          return e5(v3) && e5(S2) && v3 - S2 || void 0;
        }
        setTickInterval(v3) {
          var S2, P2, U2, w2;
          let { categories: M2, chart: D2, dataMax: F2, dataMin: $2, dateTime: W2, isXAxis: V2, logarithmic: _2, options: et2, softThreshold: lt2 } = this, ht2 = e5(this.threshold) ? this.threshold : void 0, J2 = this.minRange || 0, { ceiling: Y2, floor: st2, linkedTo: nt2, softMax: ot2, softMin: ut2 } = et2, dt2 = e5(nt2) && ((S2 = D2[this.coll]) == null ? void 0 : S2[nt2]), ct2 = et2.tickPixelInterval, gt2 = et2.maxPadding, ft2 = et2.minPadding, pt2 = 0, mt2, yt2 = e5(et2.tickInterval) && et2.tickInterval >= 0 ? et2.tickInterval : void 0, vt2, bt2, xt2, Ct2;
          if (W2 || M2 || dt2 || this.getTickAmount(), xt2 = r3(this.userMin, et2.min), Ct2 = r3(this.userMax, et2.max), dt2 ? (this.linkedParent = dt2, mt2 = dt2.getExtremes(), this.min = r3(mt2.min, mt2.dataMin), this.max = r3(mt2.max, mt2.dataMax), this.type !== dt2.type && G2(11, true, D2)) : (lt2 && c4(ht2) && e5(F2) && e5($2) && ($2 >= ht2 ? (vt2 = ht2, ft2 = 0) : F2 <= ht2 && (bt2 = ht2, gt2 = 0)), this.min = r3(xt2, vt2, $2), this.max = r3(Ct2, bt2, F2)), e5(this.max) && e5(this.min) && (_2 && (this.positiveValuesOnly && !v3 && 0 >= Math.min(this.min, r3($2, this.min)) && G2(10, true, D2), this.min = h2(_2.log2lin(this.min), 16), this.max = h2(_2.log2lin(this.max), 16)), this.range && e5($2) && (this.userMin = this.min = xt2 = Math.max($2, this.minFromRange() || 0), this.userMax = Ct2 = this.max, this.range = void 0)), l4(this, "foundExtremes"), this.adjustForMinRange(), e5(this.min) && e5(this.max)) {
            if (!e5(this.userMin) && e5(ut2) && ut2 < this.min && (this.min = xt2 = ut2), !e5(this.userMax) && e5(ot2) && ot2 > this.max && (this.max = Ct2 = ot2), M2 || this.axisPointRange || (P2 = this.stacking) != null && P2.usePercentage || dt2 || !(pt2 = this.max - this.min) || (!c4(xt2) && ft2 && (this.min -= pt2 * ft2), c4(Ct2) || !gt2 || (this.max += pt2 * gt2)), !e5(this.userMin) && e5(st2) && (this.min = Math.max(this.min, st2)), !e5(this.userMax) && e5(Y2) && (this.max = Math.min(this.max, Y2)), lt2 && e5($2) && e5(F2)) {
              let kt2 = ht2 || 0;
              !c4(xt2) && this.min < kt2 && $2 >= kt2 ? this.min = et2.minRange ? Math.min(kt2, this.max - J2) : kt2 : !c4(Ct2) && this.max > kt2 && F2 <= kt2 && (this.max = et2.minRange ? Math.max(kt2, this.min + J2) : kt2);
            }
            !D2.polar && this.min > this.max && (c4(et2.min) ? this.max = this.min : c4(et2.max) && (this.min = this.max)), pt2 = this.max - this.min;
          }
          if (this.min !== this.max && e5(this.min) && e5(this.max) ? dt2 && !yt2 && ct2 === dt2.options.tickPixelInterval ? this.tickInterval = yt2 = dt2.tickInterval : this.tickInterval = r3(yt2, this.tickAmount ? pt2 / Math.max(this.tickAmount - 1, 1) : void 0, M2 ? 1 : pt2 * ct2 / Math.max(this.len, ct2)) : this.tickInterval = 1, V2 && !v3) {
            let kt2 = this.min !== ((U2 = this.old) == null ? void 0 : U2.min) || this.max !== ((w2 = this.old) == null ? void 0 : w2.max);
            this.series.forEach(function(St2) {
              var Tt2;
              St2.forceCrop = (Tt2 = St2.forceCropping) == null ? void 0 : Tt2.call(St2), St2.processData(kt2);
            }), l4(this, "postProcessData", { hasExtremesChanged: kt2 });
          }
          this.setAxisTranslation(), l4(this, "initialAxisTranslation"), this.pointRange && !yt2 && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
          let wt2 = r3(et2.minTickInterval, W2 && !this.series.some((kt2) => kt2.noSharedTooltip) ? this.closestPointRange : 0);
          !yt2 && this.tickInterval < wt2 && (this.tickInterval = wt2), W2 || _2 || yt2 || (this.tickInterval = R2(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
        }
        setTickPositions() {
          var v3, S2;
          let P2 = this.options, U2 = P2.tickPositions, w2 = P2.tickPositioner, M2 = this.getMinorTickInterval(), D2 = !this.isPanning, F2 = D2 && P2.startOnTick, $2 = D2 && P2.endOnTick, W2 = [], V2;
          if (this.tickmarkOffset = this.categories && P2.tickmarkPlacement === "between" && this.tickInterval === 1 ? 0.5 : 0, this.single = this.min === this.max && c4(this.min) && !this.tickAmount && (this.min % 1 == 0 || P2.allowDecimals !== false), U2) W2 = U2.slice();
          else if (e5(this.min) && e5(this.max)) {
            if (!((v3 = this.ordinal) != null && v3.positions) && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)) W2 = [this.min, this.max], G2(19, false, this.chart);
            else if (this.dateTime) W2 = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, P2.units), this.min, this.max, P2.startOfWeek, (S2 = this.ordinal) == null ? void 0 : S2.positions, this.closestPointRange, true);
            else if (this.logarithmic) W2 = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
            else {
              let _2 = this.tickInterval, et2 = _2;
              for (; et2 <= 2 * _2 && (W2 = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && W2.length > this.tickAmount); ) this.tickInterval = R2(this, et2 *= 1.1);
            }
            W2.length > this.len && (W2 = [W2[0], W2[W2.length - 1]])[0] === W2[1] && (W2.length = 1), w2 && (this.tickPositions = W2, (V2 = w2.apply(this, [this.min, this.max])) && (W2 = V2));
          }
          this.tickPositions = W2, this.minorTickInterval = M2 === "auto" && this.tickInterval ? this.tickInterval / P2.minorTicksPerMajor : M2, this.paddedTicks = W2.slice(0), this.trimTicks(W2, F2, $2), !this.isLinked && e5(this.min) && e5(this.max) && (this.single && W2.length < 2 && !this.categories && !this.series.some((_2) => _2.is("heatmap") && _2.options.pointPlacement === "between") && (this.min -= 0.5, this.max += 0.5), U2 || V2 || this.adjustTickAmount()), l4(this, "afterSetTickPositions");
        }
        trimTicks(v3, S2, P2) {
          let U2 = v3[0], w2 = v3[v3.length - 1], M2 = !this.isOrdinal && this.minPointOffset || 0;
          if (l4(this, "trimTicks"), !this.isLinked) {
            if (S2 && U2 !== -1 / 0) this.min = U2;
            else for (; this.min - M2 > v3[0]; ) v3.shift();
            if (P2) this.max = w2;
            else for (; this.max + M2 < v3[v3.length - 1]; ) v3.pop();
            v3.length === 0 && c4(U2) && !this.options.tickPositions && v3.push((w2 + U2) / 2);
          }
        }
        alignToOthers() {
          let v3, S2 = this, P2 = S2.chart, U2 = [this], w2 = S2.options, M2 = P2.options.chart, D2 = this.coll === "yAxis" && M2.alignThresholds, F2 = [];
          if (S2.thresholdAlignment = void 0, (M2.alignTicks !== false && w2.alignTicks || D2) && w2.startOnTick !== false && w2.endOnTick !== false && !S2.logarithmic) {
            let $2 = (V2) => {
              let { horiz: _2, options: et2 } = V2;
              return [_2 ? et2.left : et2.top, et2.width, et2.height, et2.pane].join(",");
            }, W2 = $2(this);
            P2[this.coll].forEach(function(V2) {
              let { series: _2 } = V2;
              _2.length && _2.some((et2) => et2.visible) && V2 !== S2 && $2(V2) === W2 && (v3 = true, U2.push(V2));
            });
          }
          if (v3 && D2) {
            U2.forEach((W2) => {
              let V2 = W2.getThresholdAlignment(S2);
              e5(V2) && F2.push(V2);
            });
            let $2 = F2.length > 1 ? F2.reduce((W2, V2) => W2 += V2, 0) / F2.length : void 0;
            U2.forEach((W2) => {
              W2.thresholdAlignment = $2;
            });
          }
          return v3;
        }
        getThresholdAlignment(v3) {
          if ((!e5(this.dataMin) || this !== v3 && this.series.some((S2) => S2.isDirty || S2.isDirtyData)) && this.getSeriesExtremes(), e5(this.threshold)) {
            let S2 = b5((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
            return this.options.reversed && (S2 = 1 - S2), S2;
          }
        }
        getTickAmount() {
          let v3 = this.options, S2 = v3.tickPixelInterval, P2 = v3.tickAmount;
          c4(v3.tickInterval) || P2 || !(this.len < S2) || this.isRadial || this.logarithmic || !v3.startOnTick || !v3.endOnTick || (P2 = 2), !P2 && this.alignToOthers() && (P2 = Math.ceil(this.len / S2) + 1), P2 < 4 && (this.finalTickAmt = P2, P2 = 5), this.tickAmount = P2;
        }
        adjustTickAmount() {
          let v3 = this, { finalTickAmt: S2, max: P2, min: U2, options: w2, tickPositions: M2, tickAmount: D2, thresholdAlignment: F2 } = v3, $2 = M2 == null ? void 0 : M2.length, W2 = r3(v3.threshold, v3.softThreshold ? 0 : null), V2, _2, et2 = v3.tickInterval, lt2, ht2 = () => M2.push(h2(M2[M2.length - 1] + et2)), J2 = () => M2.unshift(h2(M2[0] - et2));
          if (e5(F2) && (lt2 = F2 < 0.5 ? Math.ceil(F2 * (D2 - 1)) : Math.floor(F2 * (D2 - 1)), w2.reversed && (lt2 = D2 - 1 - lt2)), v3.hasData() && e5(U2) && e5(P2)) {
            let Y2 = () => {
              v3.transA *= ($2 - 1) / (D2 - 1), v3.min = w2.startOnTick ? M2[0] : Math.min(U2, M2[0]), v3.max = w2.endOnTick ? M2[M2.length - 1] : Math.max(P2, M2[M2.length - 1]);
            };
            if (e5(lt2) && e5(v3.threshold)) {
              for (; M2[lt2] !== W2 || M2.length !== D2 || M2[0] > U2 || M2[M2.length - 1] < P2; ) {
                for (M2.length = 0, M2.push(v3.threshold); M2.length < D2; ) M2[lt2] === void 0 || M2[lt2] > v3.threshold ? J2() : ht2();
                if (et2 > 8 * v3.tickInterval) break;
                et2 *= 2;
              }
              Y2();
            } else if ($2 < D2) {
              for (; M2.length < D2; ) M2.length % 2 || U2 === W2 ? ht2() : J2();
              Y2();
            }
            if (c4(S2)) {
              for (_2 = V2 = M2.length; _2--; ) (S2 === 3 && _2 % 2 == 1 || S2 <= 2 && _2 > 0 && _2 < V2 - 1) && M2.splice(_2, 1);
              v3.finalTickAmt = void 0;
            }
          }
        }
        setScale() {
          var v3, S2;
          let { coll: P2, stacking: U2 } = this, w2 = false, M2 = false;
          this.series.forEach((F2) => {
            w2 = w2 || F2.isDirtyData || F2.isDirty, M2 = M2 || F2.xAxis && F2.xAxis.isDirty || false;
          }), this.setAxisSize();
          let D2 = this.len !== (this.old && this.old.len);
          D2 || w2 || M2 || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (U2 && P2 === "yAxis" && U2.buildStacks(), this.forceRedraw = false, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), U2 && P2 === "xAxis" && U2.buildStacks(), this.isDirty || (this.isDirty = D2 || this.min !== ((v3 = this.old) == null ? void 0 : v3.min) || this.max !== ((S2 = this.old) == null ? void 0 : S2.max))) : U2 && U2.cleanStacks(), w2 && delete this.allExtremes, l4(this, "afterSetScale");
        }
        setExtremes(v3, S2, P2 = true, U2, w2) {
          this.series.forEach((M2) => {
            delete M2.kdTree;
          }), l4(this, "setExtremes", w2 = L2(w2, { min: v3, max: S2 }), (M2) => {
            this.userMin = M2.min, this.userMax = M2.max, this.eventArgs = M2, P2 && this.chart.redraw(U2);
          });
        }
        setAxisSize() {
          let v3 = this.chart, S2 = this.options, P2 = S2.offsets || [0, 0, 0, 0], U2 = this.horiz, w2 = this.width = Math.round(A3(r3(S2.width, v3.plotWidth - P2[3] + P2[1]), v3.plotWidth)), M2 = this.height = Math.round(A3(r3(S2.height, v3.plotHeight - P2[0] + P2[2]), v3.plotHeight)), D2 = this.top = Math.round(A3(r3(S2.top, v3.plotTop + P2[0]), v3.plotHeight, v3.plotTop)), F2 = this.left = Math.round(A3(r3(S2.left, v3.plotLeft + P2[3]), v3.plotWidth, v3.plotLeft));
          this.bottom = v3.chartHeight - M2 - D2, this.right = v3.chartWidth - w2 - F2, this.len = Math.max(U2 ? w2 : M2, 0), this.pos = U2 ? F2 : D2;
        }
        getExtremes() {
          let v3 = this.logarithmic;
          return { min: v3 ? h2(v3.lin2log(this.min)) : this.min, max: v3 ? h2(v3.lin2log(this.max)) : this.max, dataMin: this.dataMin, dataMax: this.dataMax, userMin: this.userMin, userMax: this.userMax };
        }
        getThreshold(v3) {
          let S2 = this.logarithmic, P2 = S2 ? S2.lin2log(this.min) : this.min, U2 = S2 ? S2.lin2log(this.max) : this.max;
          return v3 === null || v3 === -1 / 0 ? v3 = P2 : v3 === 1 / 0 ? v3 = U2 : P2 > v3 ? v3 = P2 : U2 < v3 && (v3 = U2), this.translate(v3, 0, 1, 0, 1);
        }
        autoLabelAlign(v3) {
          let S2 = (r3(v3, 0) - 90 * this.side + 720) % 360, P2 = { align: "center" };
          return l4(this, "autoLabelAlign", P2, function(U2) {
            S2 > 15 && S2 < 165 ? U2.align = "right" : S2 > 195 && S2 < 345 && (U2.align = "left");
          }), P2.align;
        }
        tickSize(v3) {
          let S2 = this.options, P2 = r3(S2[v3 === "tick" ? "tickWidth" : "minorTickWidth"], v3 === "tick" && this.isXAxis && !this.categories ? 1 : 0), U2 = S2[v3 === "tick" ? "tickLength" : "minorTickLength"], w2;
          P2 && U2 && (S2[v3 + "Position"] === "inside" && (U2 = -U2), w2 = [U2, P2]);
          let M2 = { tickSize: w2 };
          return l4(this, "afterTickSize", M2), M2.tickSize;
        }
        labelMetrics() {
          let v3 = this.chart.renderer, S2 = this.ticks, P2 = S2[Object.keys(S2)[0]] || {};
          return this.chart.renderer.fontMetrics(P2.label || P2.movedLabel || v3.box);
        }
        unsquish() {
          let v3 = this.options.labels, S2 = v3.padding || 0, P2 = this.horiz, U2 = this.tickInterval, w2 = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / U2), M2 = v3.rotation, D2 = h2(0.8 * this.labelMetrics().h), F2 = Math.max(this.max - this.min, 0), $2 = function(lt2) {
            let ht2 = (lt2 + 2 * S2) / (w2 || 1);
            return (ht2 = ht2 > 1 ? Math.ceil(ht2) : 1) * U2 > F2 && lt2 !== 1 / 0 && w2 !== 1 / 0 && F2 && (ht2 = Math.ceil(F2 / U2)), h2(ht2 * U2);
          }, W2 = U2, V2, _2 = Number.MAX_VALUE, et2;
          if (P2) {
            if (!v3.staggerLines && (e5(M2) ? et2 = [M2] : w2 < v3.autoRotationLimit && (et2 = v3.autoRotation)), et2) {
              let lt2, ht2;
              for (let J2 of et2) (J2 === M2 || J2 && J2 >= -90 && J2 <= 90) && (ht2 = (lt2 = $2(Math.abs(D2 / Math.sin(C3 * J2)))) + Math.abs(J2 / 360)) < _2 && (_2 = ht2, V2 = J2, W2 = lt2);
            }
          } else W2 = $2(0.75 * D2);
          return this.autoRotation = et2, this.labelRotation = r3(V2, e5(M2) ? M2 : 0), v3.step ? U2 : W2;
        }
        getSlotWidth(v3) {
          let S2 = this.chart, P2 = this.horiz, U2 = this.options.labels, w2 = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), M2 = S2.margin[3];
          if (v3 && e5(v3.slotWidth)) return v3.slotWidth;
          if (P2 && U2.step < 2) return U2.rotation ? 0 : (this.staggerLines || 1) * this.len / w2;
          if (!P2) {
            let D2 = U2.style.width;
            if (D2 !== void 0) return parseInt(String(D2), 10);
            if (M2) return M2 - S2.spacing[3];
          }
          return 0.33 * S2.chartWidth;
        }
        renderUnsquish() {
          let v3 = this.chart, S2 = v3.renderer, P2 = this.tickPositions, U2 = this.ticks, w2 = this.options.labels, M2 = w2.style, D2 = this.horiz, F2 = this.getSlotWidth(), $2 = Math.max(1, Math.round(F2 - (D2 ? 2 * (w2.padding || 0) : w2.distance || 0))), W2 = {}, V2 = this.labelMetrics(), _2 = M2.textOverflow, et2, lt2, ht2 = 0, J2, Y2;
          if (n4(w2.rotation) || (W2.rotation = w2.rotation || 0), P2.forEach(function(st2) {
            let nt2 = U2[st2];
            nt2.movedLabel && nt2.replaceMovedLabel(), nt2 && nt2.label && nt2.label.textPxLength > ht2 && (ht2 = nt2.label.textPxLength);
          }), this.maxLabelLength = ht2, this.autoRotation) ht2 > $2 && ht2 > V2.h ? W2.rotation = this.labelRotation : this.labelRotation = 0;
          else if (F2 && (et2 = $2, !_2)) for (lt2 = "clip", Y2 = P2.length; !D2 && Y2--; ) (J2 = U2[P2[Y2]].label) && (J2.styles.textOverflow === "ellipsis" ? J2.css({ textOverflow: "clip" }) : J2.textPxLength > F2 && J2.css({ width: F2 + "px" }), J2.getBBox().height > this.len / P2.length - (V2.h - V2.f) && (J2.specificTextOverflow = "ellipsis"));
          W2.rotation && (et2 = ht2 > 0.5 * v3.chartHeight ? 0.33 * v3.chartHeight : ht2, _2 || (lt2 = "ellipsis")), this.labelAlign = w2.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (W2.align = this.labelAlign), P2.forEach(function(st2) {
            let nt2 = U2[st2], ot2 = nt2 && nt2.label, ut2 = M2.width, dt2 = {};
            ot2 && (ot2.attr(W2), nt2.shortenLabel ? nt2.shortenLabel() : et2 && !ut2 && M2.whiteSpace !== "nowrap" && (et2 < ot2.textPxLength || ot2.element.tagName === "SPAN") ? (dt2.width = et2 + "px", _2 || (dt2.textOverflow = ot2.specificTextOverflow || lt2), ot2.css(dt2)) : !ot2.styles.width || dt2.width || ut2 || ot2.css({ width: null }), delete ot2.specificTextOverflow, nt2.rotation = W2.rotation);
          }, this), this.tickRotCorr = S2.rotCorr(V2.b, this.labelRotation || 0, this.side !== 0);
        }
        hasData() {
          return this.series.some(function(v3) {
            return v3.hasData();
          }) || this.options.showEmpty && c4(this.min) && c4(this.max);
        }
        addTitle(v3) {
          let S2, P2 = this.chart.renderer, U2 = this.horiz, w2 = this.opposite, M2 = this.options.title, D2 = this.chart.styledMode;
          this.axisTitle || ((S2 = M2.textAlign) || (S2 = (U2 ? { low: "left", middle: "center", high: "right" } : { low: w2 ? "right" : "left", middle: "center", high: w2 ? "left" : "right" })[M2.align]), this.axisTitle = P2.text(M2.text || "", 0, 0, M2.useHTML).attr({ zIndex: 7, rotation: M2.rotation || 0, align: S2 }).addClass("highcharts-axis-title"), D2 || this.axisTitle.css(u2(M2.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = true), D2 || M2.style.width || this.isRadial || this.axisTitle.css({ width: this.len + "px" }), this.axisTitle[v3 ? "show" : "hide"](v3);
        }
        generateTick(v3) {
          let S2 = this.ticks;
          S2[v3] ? S2[v3].addLabel() : S2[v3] = new Z2(this, v3);
        }
        createGroups() {
          let { axisParent: v3, chart: S2, coll: P2, options: U2 } = this, w2 = S2.renderer, M2 = (D2, F2, $2) => w2.g(D2).attr({ zIndex: $2 }).addClass(`highcharts-${P2.toLowerCase()}${F2} ` + (this.isRadial ? `highcharts-radial-axis${F2} ` : "") + (U2.className || "")).add(v3);
          this.axisGroup || (this.gridGroup = M2("grid", "-grid", U2.gridZIndex), this.axisGroup = M2("axis", "", U2.zIndex), this.labelGroup = M2("axis-labels", "-labels", U2.labels.zIndex));
        }
        getOffset() {
          let v3 = this, { chart: S2, horiz: P2, options: U2, side: w2, ticks: M2, tickPositions: D2, coll: F2 } = v3, $2 = S2.inverted && !v3.isZAxis ? [1, 0, 3, 2][w2] : w2, W2 = v3.hasData(), V2 = U2.title, _2 = U2.labels, et2 = e5(U2.crossing), lt2 = S2.axisOffset, ht2 = S2.clipOffset, J2 = [-1, 1, 1, -1][w2], Y2, st2 = 0, nt2, ot2 = 0, ut2 = 0, dt2, ct2;
          if (v3.showAxis = Y2 = W2 || U2.showEmpty, v3.staggerLines = v3.horiz && _2.staggerLines || void 0, v3.createGroups(), W2 || v3.isLinked ? (D2.forEach(function(gt2) {
            v3.generateTick(gt2);
          }), v3.renderUnsquish(), v3.reserveSpaceDefault = w2 === 0 || w2 === 2 || { 1: "left", 3: "right" }[w2] === v3.labelAlign, r3(_2.reserveSpace, !et2 && null, v3.labelAlign === "center" || null, v3.reserveSpaceDefault) && D2.forEach(function(gt2) {
            ut2 = Math.max(M2[gt2].getLabelSize(), ut2);
          }), v3.staggerLines && (ut2 *= v3.staggerLines), v3.labelOffset = ut2 * (v3.opposite ? -1 : 1)) : g2(M2, function(gt2, ft2) {
            gt2.destroy(), delete M2[ft2];
          }), V2 != null && V2.text && V2.enabled !== false && (v3.addTitle(Y2), Y2 && !et2 && V2.reserveSpace !== false && (v3.titleOffset = st2 = v3.axisTitle.getBBox()[P2 ? "height" : "width"], ot2 = c4(nt2 = V2.offset) ? 0 : r3(V2.margin, P2 ? 5 : 10))), v3.renderLine(), v3.offset = J2 * r3(U2.offset, lt2[w2] ? lt2[w2] + (U2.margin || 0) : 0), v3.tickRotCorr = v3.tickRotCorr || { x: 0, y: 0 }, ct2 = w2 === 0 ? -v3.labelMetrics().h : w2 === 2 ? v3.tickRotCorr.y : 0, dt2 = Math.abs(ut2) + ot2, ut2 && (dt2 -= ct2, dt2 += J2 * (P2 ? r3(_2.y, v3.tickRotCorr.y + J2 * _2.distance) : r3(_2.x, J2 * _2.distance))), v3.axisTitleMargin = r3(nt2, dt2), v3.getMaxLabelDimensions && (v3.maxLabelDimensions = v3.getMaxLabelDimensions(M2, D2)), F2 !== "colorAxis" && ht2) {
            let gt2 = this.tickSize("tick");
            lt2[w2] = Math.max(lt2[w2], (v3.axisTitleMargin || 0) + st2 + J2 * v3.offset, dt2, D2 && D2.length && gt2 ? gt2[0] + J2 * v3.offset : 0);
            let ft2 = !v3.axisLine || U2.offset ? 0 : v3.axisLine.strokeWidth() / 2;
            ht2[$2] = Math.max(ht2[$2], ft2);
          }
          l4(this, "afterGetOffset");
        }
        getLinePath(v3) {
          let S2 = this.chart, P2 = this.opposite, U2 = this.offset, w2 = this.horiz, M2 = this.left + (P2 ? this.width : 0) + U2, D2 = S2.chartHeight - this.bottom - (P2 ? this.height : 0) + U2;
          return P2 && (v3 *= -1), S2.renderer.crispLine([["M", w2 ? this.left : M2, w2 ? D2 : this.top], ["L", w2 ? S2.chartWidth - this.right : M2, w2 ? D2 : S2.chartHeight - this.bottom]], v3);
        }
        renderLine() {
          this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({ stroke: this.options.lineColor, "stroke-width": this.options.lineWidth, zIndex: 7 }));
        }
        getTitlePosition(v3) {
          let S2 = this.horiz, P2 = this.left, U2 = this.top, w2 = this.len, M2 = this.options.title, D2 = S2 ? P2 : U2, F2 = this.opposite, $2 = this.offset, W2 = M2.x, V2 = M2.y, _2 = this.chart.renderer.fontMetrics(v3), et2 = v3 ? Math.max(v3.getBBox(false, 0).height - _2.h - 1, 0) : 0, lt2 = { low: D2 + (S2 ? 0 : w2), middle: D2 + w2 / 2, high: D2 + (S2 ? w2 : 0) }[M2.align], ht2 = (S2 ? U2 + this.height : P2) + (S2 ? 1 : -1) * (F2 ? -1 : 1) * (this.axisTitleMargin || 0) + [-et2, et2, _2.f, -et2][this.side], J2 = { x: S2 ? lt2 + W2 : ht2 + (F2 ? this.width : 0) + $2 + W2, y: S2 ? ht2 + V2 - (F2 ? this.height : 0) + $2 : lt2 + V2 };
          return l4(this, "afterGetTitlePosition", { titlePosition: J2 }), J2;
        }
        renderMinorTick(v3, S2) {
          let P2 = this.minorTicks;
          P2[v3] || (P2[v3] = new Z2(this, v3, "minor")), S2 && P2[v3].isNew && P2[v3].render(null, true), P2[v3].render(null, false, 1);
        }
        renderTick(v3, S2, P2) {
          let U2 = this.isLinked, w2 = this.ticks;
          (!U2 || v3 >= this.min && v3 <= this.max || this.grid && this.grid.isColumn) && (w2[v3] || (w2[v3] = new Z2(this, v3)), P2 && w2[v3].isNew && w2[v3].render(S2, true, -1), w2[v3].render(S2));
        }
        render() {
          let v3, S2, P2 = this, U2 = P2.chart, w2 = P2.logarithmic, M2 = U2.renderer, D2 = P2.options, F2 = P2.isLinked, $2 = P2.tickPositions, W2 = P2.axisTitle, V2 = P2.ticks, _2 = P2.minorTicks, et2 = P2.alternateBands, lt2 = D2.stackLabels, ht2 = D2.alternateGridColor, J2 = D2.crossing, Y2 = P2.tickmarkOffset, st2 = P2.axisLine, nt2 = P2.showAxis, ot2 = O3(M2.globalAnimation);
          if (P2.labelEdge.length = 0, P2.overlap = false, [V2, _2, et2].forEach(function(ut2) {
            g2(ut2, function(dt2) {
              dt2.isActive = false;
            });
          }), e5(J2)) {
            let ut2 = this.isXAxis ? U2.yAxis[0] : U2.xAxis[0], dt2 = [1, -1, -1, 1][this.side];
            if (ut2) {
              let ct2 = ut2.toPixels(J2, true);
              P2.horiz && (ct2 = ut2.len - ct2), P2.offset = dt2 * ct2;
            }
          }
          if (P2.hasData() || F2) {
            let ut2 = P2.chart.hasRendered && P2.old && e5(P2.old.min);
            P2.minorTickInterval && !P2.categories && P2.getMinorTickPositions().forEach(function(dt2) {
              P2.renderMinorTick(dt2, ut2);
            }), $2.length && ($2.forEach(function(dt2, ct2) {
              P2.renderTick(dt2, ct2, ut2);
            }), Y2 && (P2.min === 0 || P2.single) && (V2[-1] || (V2[-1] = new Z2(P2, -1, null, true)), V2[-1].render(-1))), ht2 && $2.forEach(function(dt2, ct2) {
              S2 = $2[ct2 + 1] !== void 0 ? $2[ct2 + 1] + Y2 : P2.max - Y2, ct2 % 2 == 0 && dt2 < P2.max && S2 <= P2.max + (U2.polar ? -Y2 : Y2) && (et2[dt2] || (et2[dt2] = new tt2.PlotLineOrBand(P2, {})), v3 = dt2 + Y2, et2[dt2].options = { from: w2 ? w2.lin2log(v3) : v3, to: w2 ? w2.lin2log(S2) : S2, color: ht2, className: "highcharts-alternate-grid" }, et2[dt2].render(), et2[dt2].isActive = true);
            }), P2._addedPlotLB || (P2._addedPlotLB = true, (D2.plotLines || []).concat(D2.plotBands || []).forEach(function(dt2) {
              P2.addPlotBandOrLine(dt2);
            }));
          }
          [V2, _2, et2].forEach(function(ut2) {
            let dt2 = [], ct2 = ot2.duration;
            g2(ut2, function(gt2, ft2) {
              gt2.isActive || (gt2.render(ft2, false, 0), gt2.isActive = false, dt2.push(ft2));
            }), E2(function() {
              let gt2 = dt2.length;
              for (; gt2--; ) ut2[dt2[gt2]] && !ut2[dt2[gt2]].isActive && (ut2[dt2[gt2]].destroy(), delete ut2[dt2[gt2]]);
            }, ut2 !== et2 && U2.hasRendered && ct2 ? ct2 : 0);
          }), st2 && (st2[st2.isPlaced ? "animate" : "attr"]({ d: this.getLinePath(st2.strokeWidth()) }), st2.isPlaced = true, st2[nt2 ? "show" : "hide"](nt2)), W2 && nt2 && (W2[W2.isNew ? "attr" : "animate"](P2.getTitlePosition(W2)), W2.isNew = false), lt2 && lt2.enabled && P2.stacking && P2.stacking.renderStackTotals(), P2.old = { len: P2.len, max: P2.max, min: P2.min, transA: P2.transA, userMax: P2.userMax, userMin: P2.userMin }, P2.isDirty = false, l4(this, "afterRender");
        }
        redraw() {
          this.visible && (this.render(), this.plotLinesAndBands.forEach(function(v3) {
            v3.render();
          })), this.series.forEach(function(v3) {
            v3.isDirty = true;
          });
        }
        getKeepProps() {
          return this.keepProps || z2.keepProps;
        }
        destroy(v3) {
          let S2 = this, P2 = S2.plotLinesAndBands, U2 = this.eventOptions;
          if (l4(this, "destroy", { keepEvents: v3 }), v3 || N2(S2), [S2.ticks, S2.minorTicks, S2.alternateBands].forEach(function(w2) {
            T2(w2);
          }), P2) {
            let w2 = P2.length;
            for (; w2--; ) P2[w2].destroy();
          }
          for (let w2 in ["axisLine", "axisTitle", "axisGroup", "gridGroup", "labelGroup", "cross", "scrollbar"].forEach(function(M2) {
            S2[M2] && (S2[M2] = S2[M2].destroy());
          }), S2.plotLinesAndBandsGroups) S2.plotLinesAndBandsGroups[w2] = S2.plotLinesAndBandsGroups[w2].destroy();
          g2(S2, function(w2, M2) {
            S2.getKeepProps().indexOf(M2) === -1 && delete S2[M2];
          }), this.eventOptions = U2;
        }
        drawCrosshair(v3, S2) {
          let P2 = this.crosshair, U2 = r3(P2 && P2.snap, true), w2 = this.chart, M2, D2, F2, $2 = this.cross, W2;
          if (l4(this, "drawCrosshair", { e: v3, point: S2 }), v3 || (v3 = this.cross && this.cross.e), P2 && (c4(S2) || !U2) !== false) {
            if (U2 ? c4(S2) && (D2 = r3(this.coll !== "colorAxis" ? S2.crosshairPos : null, this.isXAxis ? S2.plotX : this.len - S2.plotY)) : D2 = v3 && (this.horiz ? v3.chartX - this.pos : this.len - v3.chartY + this.pos), c4(D2) && (W2 = { value: S2 && (this.isXAxis ? S2.x : r3(S2.stackY, S2.y)), translatedValue: D2 }, w2.polar && L2(W2, { isCrosshair: true, chartX: v3 && v3.chartX, chartY: v3 && v3.chartY, point: S2 }), M2 = this.getPlotLinePath(W2) || null), !c4(M2)) {
              this.hideCrosshair();
              return;
            }
            F2 = this.categories && !this.isRadial, $2 || (this.cross = $2 = w2.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (F2 ? "category " : "thin ") + (P2.className || "")).attr({ zIndex: r3(P2.zIndex, 2) }).add(), !w2.styledMode && ($2.attr({ stroke: P2.color || (F2 ? q2.parse("#ccd3ff").setOpacity(0.25).get() : "#cccccc"), "stroke-width": r3(P2.width, 1) }).css({ "pointer-events": "none" }), P2.dashStyle && $2.attr({ dashstyle: P2.dashStyle }))), $2.show().attr({ d: M2 }), F2 && !P2.width && $2.attr({ "stroke-width": this.transA }), this.cross.e = v3;
          } else this.hideCrosshair();
          l4(this, "afterDrawCrosshair", { e: v3, point: S2 });
        }
        hideCrosshair() {
          this.cross && this.cross.hide(), l4(this, "afterHideCrosshair");
        }
        update(v3, S2) {
          let P2 = this.chart;
          v3 = u2(this.userOptions, v3), this.destroy(true), this.init(P2, v3), P2.isDirtyBox = true, r3(S2, true) && P2.redraw();
        }
        remove(v3) {
          let S2 = this.chart, P2 = this.coll, U2 = this.series, w2 = U2.length;
          for (; w2--; ) U2[w2] && U2[w2].remove(false);
          I3(S2.axes, this), I3(S2[P2] || [], this), S2.orderItems(P2), this.destroy(), S2.isDirtyBox = true, r3(v3, true) && S2.redraw();
        }
        setTitle(v3, S2) {
          this.update({ title: v3 }, S2);
        }
        setCategories(v3, S2) {
          this.update({ categories: v3 }, S2);
        }
      }
      return z2.keepProps = ["coll", "extKey", "hcEvents", "len", "names", "series", "userMax", "userMin"], z2;
    }), at2(s2, "Core/Axis/DateTimeAxis.js", [s2["Core/Utilities.js"]], function(B3) {
      var K2;
      let { addEvent: q2, getMagnitude: it2, normalizeTickInterval: rt2, timeUnits: tt2 } = B3;
      return function(Z2) {
        function X2() {
          return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
        }
        function O3() {
          if (this.type !== "datetime") {
            this.dateTime = void 0;
            return;
          }
          this.dateTime || (this.dateTime = new j3(this));
        }
        Z2.compose = function(d3) {
          return d3.keepProps.includes("dateTime") || (d3.keepProps.push("dateTime"), d3.prototype.getTimeTicks = X2, q2(d3, "afterSetType", O3)), d3;
        };
        class j3 {
          constructor(x2) {
            this.axis = x2;
          }
          normalizeTimeTickInterval(x2, f2) {
            let C3 = f2 || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]], o2 = C3[C3.length - 1], p2 = tt2[o2[0]], b5 = o2[1], h2;
            for (h2 = 0; h2 < C3.length && (p2 = tt2[(o2 = C3[h2])[0]], b5 = o2[1], !C3[h2 + 1] || !(x2 <= (p2 * b5[b5.length - 1] + tt2[C3[h2 + 1][0]]) / 2)); h2++) ;
            p2 === tt2.year && x2 < 5 * p2 && (b5 = [1, 2, 5]);
            let c4 = rt2(x2 / p2, b5, o2[0] === "year" ? Math.max(it2(x2 / p2), 1) : 1);
            return { unitRange: p2, count: c4, unitName: o2[0] };
          }
          getXDateFormat(x2, f2) {
            let { axis: C3 } = this, o2 = C3.chart.time;
            return C3.closestPointRange ? o2.getDateFormat(C3.closestPointRange, x2, C3.options.startOfWeek, f2) || o2.resolveDTLFormat(f2.year).main : o2.resolveDTLFormat(f2.day).main;
          }
        }
        Z2.Additions = j3;
      }(K2 || (K2 = {})), K2;
    }), at2(s2, "Core/Axis/LogarithmicAxis.js", [s2["Core/Utilities.js"]], function(B3) {
      var K2;
      let { addEvent: q2, normalizeTickInterval: it2, pick: rt2 } = B3;
      return function(tt2) {
        function Z2() {
          this.type !== "logarithmic" ? this.logarithmic = void 0 : this.logarithmic != null || (this.logarithmic = new O3(this));
        }
        function X2() {
          let j3 = this.logarithmic;
          j3 && (this.lin2val = function(d3) {
            return j3.lin2log(d3);
          }, this.val2lin = function(d3) {
            return j3.log2lin(d3);
          });
        }
        tt2.compose = function(j3) {
          return j3.keepProps.includes("logarithmic") || (j3.keepProps.push("logarithmic"), q2(j3, "afterSetType", Z2), q2(j3, "afterInit", X2)), j3;
        };
        class O3 {
          constructor(d3) {
            this.axis = d3;
          }
          getLogTickPositions(d3, x2, f2, C3) {
            let o2 = this.axis, p2 = o2.len, b5 = o2.options, h2 = [];
            if (C3 || (this.minorAutoInterval = void 0), d3 >= 0.5) d3 = Math.round(d3), h2 = o2.getLinearTickPositions(d3, x2, f2);
            else if (d3 >= 0.08) {
              let c4, T2, I3, G2, L2, l4, y2, i5 = Math.floor(x2);
              for (c4 = d3 > 0.3 ? [1, 2, 4] : d3 > 0.15 ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9], T2 = i5; T2 < f2 + 1 && !y2; T2++) for (I3 = 0, G2 = c4.length; I3 < G2 && !y2; I3++) (L2 = this.log2lin(this.lin2log(T2) * c4[I3])) > x2 && (!C3 || l4 <= f2) && l4 !== void 0 && h2.push(l4), l4 > f2 && (y2 = true), l4 = L2;
            } else {
              let c4 = this.lin2log(x2), T2 = this.lin2log(f2), I3 = C3 ? o2.getMinorTickInterval() : b5.tickInterval, G2 = b5.tickPixelInterval / (C3 ? 5 : 1), L2 = C3 ? p2 / o2.tickPositions.length : p2;
              d3 = it2(d3 = rt2(I3 === "auto" ? null : I3, this.minorAutoInterval, (T2 - c4) * G2 / (L2 || 1))), h2 = o2.getLinearTickPositions(d3, c4, T2).map(this.log2lin), C3 || (this.minorAutoInterval = d3 / 5);
            }
            return C3 || (o2.tickInterval = d3), h2;
          }
          lin2log(d3) {
            return Math.pow(10, d3);
          }
          log2lin(d3) {
            return Math.log(d3) / Math.LN10;
          }
        }
        tt2.Additions = O3;
      }(K2 || (K2 = {})), K2;
    }), at2(s2, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [s2["Core/Utilities.js"]], function(B3) {
      var K2;
      let { erase: q2, extend: it2, isNumber: rt2 } = B3;
      return function(tt2) {
        let Z2;
        function X2(o2) {
          return this.addPlotBandOrLine(o2, "plotBands");
        }
        function O3(o2, p2) {
          let b5 = this.userOptions, h2 = new Z2(this, o2);
          if (this.visible && (h2 = h2.render()), h2) {
            if (this._addedPlotLB || (this._addedPlotLB = true, (b5.plotLines || []).concat(b5.plotBands || []).forEach((c4) => {
              this.addPlotBandOrLine(c4);
            })), p2) {
              let c4 = b5[p2] || [];
              c4.push(o2), b5[p2] = c4;
            }
            this.plotLinesAndBands.push(h2);
          }
          return h2;
        }
        function j3(o2) {
          return this.addPlotBandOrLine(o2, "plotLines");
        }
        function d3(o2, p2, b5) {
          b5 = b5 || this.options;
          let h2 = this.getPlotLinePath({ value: p2, force: true, acrossPanes: b5.acrossPanes }), c4 = [], T2 = this.horiz, I3 = !rt2(this.min) || !rt2(this.max) || o2 < this.min && p2 < this.min || o2 > this.max && p2 > this.max, G2 = this.getPlotLinePath({ value: o2, force: true, acrossPanes: b5.acrossPanes }), L2, l4 = 1, y2;
          if (G2 && h2) for (I3 && (y2 = G2.toString() === h2.toString(), l4 = 0), L2 = 0; L2 < G2.length; L2 += 2) {
            let i5 = G2[L2], t3 = G2[L2 + 1], e5 = h2[L2], n4 = h2[L2 + 1];
            (i5[0] === "M" || i5[0] === "L") && (t3[0] === "M" || t3[0] === "L") && (e5[0] === "M" || e5[0] === "L") && (n4[0] === "M" || n4[0] === "L") && (T2 && e5[1] === i5[1] ? (e5[1] += l4, n4[1] += l4) : T2 || e5[2] !== i5[2] || (e5[2] += l4, n4[2] += l4), c4.push(["M", i5[1], i5[2]], ["L", t3[1], t3[2]], ["L", n4[1], n4[2]], ["L", e5[1], e5[2]], ["Z"])), c4.isFlat = y2;
          }
          return c4;
        }
        function x2(o2) {
          this.removePlotBandOrLine(o2);
        }
        function f2(o2) {
          let p2 = this.plotLinesAndBands, b5 = this.options, h2 = this.userOptions;
          if (p2) {
            let c4 = p2.length;
            for (; c4--; ) p2[c4].id === o2 && p2[c4].destroy();
            [b5.plotLines || [], h2.plotLines || [], b5.plotBands || [], h2.plotBands || []].forEach(function(T2) {
              for (c4 = T2.length; c4--; ) (T2[c4] || {}).id === o2 && q2(T2, T2[c4]);
            });
          }
        }
        function C3(o2) {
          this.removePlotBandOrLine(o2);
        }
        tt2.compose = function(o2, p2) {
          let b5 = p2.prototype;
          return b5.addPlotBand || (Z2 = o2, it2(b5, { addPlotBand: X2, addPlotLine: j3, addPlotBandOrLine: O3, getPlotBandPath: d3, removePlotBand: x2, removePlotLine: C3, removePlotBandOrLine: f2 })), p2;
        };
      }(K2 || (K2 = {})), K2;
    }), at2(s2, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [s2["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { addEvent: q2, arrayMax: it2, arrayMin: rt2, defined: tt2, destroyObjectProperties: Z2, erase: X2, fireEvent: O3, merge: j3, objectEach: d3, pick: x2 } = K2;
      class f2 {
        static compose(o2, p2) {
          return q2(o2, "afterInit", function() {
            this.labelCollectors.push(() => {
              var b5;
              let h2 = [];
              for (let c4 of this.axes) for (let { label: T2, options: I3 } of c4.plotLinesAndBands) T2 && !((b5 = I3 == null ? void 0 : I3.label) != null && b5.allowOverlap) && h2.push(T2);
              return h2;
            });
          }), B3.compose(f2, p2);
        }
        constructor(o2, p2) {
          this.axis = o2, this.options = p2, this.id = p2.id;
        }
        render() {
          var o2, p2, b5;
          O3(this, "render");
          let { axis: h2, options: c4 } = this, { horiz: T2, logarithmic: I3 } = h2, { color: G2, events: L2, zIndex: l4 = 0 } = c4, y2 = {}, i5 = h2.chart.renderer, t3 = c4.to, e5 = c4.from, n4 = c4.value, u2 = c4.borderWidth, a2 = c4.label, { label: g2, svgElem: r3 } = this, A3 = [], N2, k3 = tt2(e5) && tt2(t3), E2 = tt2(n4), R2 = !r3, z2 = { class: "highcharts-plot-" + (k3 ? "band " : "line ") + (c4.className || "") }, Q2 = k3 ? "bands" : "lines";
          if (!h2.chart.styledMode && (E2 ? (z2.stroke = G2 || "#999999", z2["stroke-width"] = x2(c4.width, 1), c4.dashStyle && (z2.dashstyle = c4.dashStyle)) : k3 && (z2.fill = G2 || "#e6e9ff", u2 && (z2.stroke = c4.borderColor, z2["stroke-width"] = u2))), y2.zIndex = l4, Q2 += "-" + l4, (N2 = h2.plotLinesAndBandsGroups[Q2]) || (h2.plotLinesAndBandsGroups[Q2] = N2 = i5.g("plot-" + Q2).attr(y2).add()), r3 || (this.svgElem = r3 = i5.path().attr(z2).add(N2)), tt2(n4)) A3 = h2.getPlotLinePath({ value: (o2 = I3 == null ? void 0 : I3.log2lin(n4)) != null ? o2 : n4, lineWidth: r3.strokeWidth(), acrossPanes: c4.acrossPanes });
          else {
            if (!(tt2(e5) && tt2(t3))) return;
            A3 = h2.getPlotBandPath((p2 = I3 == null ? void 0 : I3.log2lin(e5)) != null ? p2 : e5, (b5 = I3 == null ? void 0 : I3.log2lin(t3)) != null ? b5 : t3, c4);
          }
          return !this.eventsAdded && L2 && (d3(L2, (v3, S2) => {
            r3 == null || r3.on(S2, (P2) => {
              L2[S2].apply(this, [P2]);
            });
          }), this.eventsAdded = true), (R2 || !r3.d) && A3 != null && A3.length ? r3.attr({ d: A3 }) : r3 && (A3 ? (r3.show(), r3.animate({ d: A3 })) : r3.d && (r3.hide(), g2 && (this.label = g2 = g2.destroy()))), a2 && (tt2(a2.text) || tt2(a2.formatter)) && A3 != null && A3.length && h2.width > 0 && h2.height > 0 && !A3.isFlat ? (a2 = j3({ align: T2 && k3 ? "center" : void 0, x: T2 ? !k3 && 4 : 10, verticalAlign: !T2 && k3 ? "middle" : void 0, y: T2 ? k3 ? 16 : 10 : k3 ? 6 : -4, rotation: T2 && !k3 ? 90 : 0, ...k3 ? { inside: true } : {} }, a2), this.renderLabel(a2, A3, k3, l4)) : g2 && g2.hide(), this;
        }
        renderLabel(o2, p2, b5, h2) {
          var c4;
          let T2 = this.axis, I3 = T2.chart.renderer, G2 = o2.inside, L2 = this.label;
          L2 || (this.label = L2 = I3.text(this.getLabelText(o2), 0, 0, o2.useHTML).attr({ align: o2.textAlign || o2.align, rotation: o2.rotation, class: "highcharts-plot-" + (b5 ? "band" : "line") + "-label " + (o2.className || ""), zIndex: h2 }), T2.chart.styledMode || L2.css(j3({ fontSize: "0.8em", textOverflow: b5 && !G2 ? "" : "ellipsis" }, o2.style)), L2.add());
          let l4 = p2.xBounds || [p2[0][1], p2[1][1], b5 ? p2[2][1] : p2[0][1]], y2 = p2.yBounds || [p2[0][2], p2[1][2], b5 ? p2[2][2] : p2[0][2]], i5 = rt2(l4), t3 = rt2(y2), e5 = it2(l4) - i5;
          L2.align(o2, false, { x: i5, y: t3, width: e5, height: it2(y2) - t3 }), (!L2.alignValue || L2.alignValue === "left" || tt2(G2)) && L2.css({ width: (((c4 = o2.style) == null ? void 0 : c4.width) || (b5 && G2 ? e5 : L2.rotation === 90 ? T2.height - (L2.alignAttr.y - T2.top) : (o2.clip ? T2.width : T2.chart.chartWidth) - (L2.alignAttr.x - T2.left))) + "px" }), L2.show(true);
        }
        getLabelText(o2) {
          return tt2(o2.formatter) ? o2.formatter.call(this) : o2.text;
        }
        destroy() {
          X2(this.axis.plotLinesAndBands, this), delete this.axis, Z2(this);
        }
      }
      return f2;
    }), at2(s2, "Core/Tooltip.js", [s2["Core/Animation/AnimationUtilities.js"], s2["Core/Templating.js"], s2["Core/Globals.js"], s2["Core/Renderer/RendererUtilities.js"], s2["Core/Renderer/RendererRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2) {
      var Z2;
      let { animObject: X2 } = B3, { format: O3 } = K2, { composed: j3, doc: d3, isSafari: x2 } = q2, { distribute: f2 } = it2, { addEvent: C3, clamp: o2, css: p2, discardElement: b5, extend: h2, fireEvent: c4, isArray: T2, isNumber: I3, isString: G2, merge: L2, pick: l4, pushUnique: y2, splat: i5, syncTimeout: t3 } = tt2;
      class e5 {
        constructor(u2, a2, g2) {
          this.allowShared = true, this.crosshairs = [], this.distance = 0, this.isHidden = true, this.isSticky = false, this.options = {}, this.outside = false, this.chart = u2, this.init(u2, a2), this.pointer = g2;
        }
        bodyFormatter(u2) {
          return u2.map(function(a2) {
            let g2 = a2.series.tooltipOptions;
            return (g2[(a2.point.formatPrefix || "point") + "Formatter"] || a2.point.tooltipFormatter).call(a2.point, g2[(a2.point.formatPrefix || "point") + "Format"] || "");
          });
        }
        cleanSplit(u2) {
          this.chart.series.forEach(function(a2) {
            let g2 = a2 && a2.tt;
            g2 && (!g2.isActive || u2 ? a2.tt = g2.destroy() : g2.isActive = false);
          });
        }
        defaultFormatter(u2) {
          let a2, g2 = this.points || i5(this);
          return (a2 = (a2 = [u2.tooltipFooterHeaderFormatter(g2[0])]).concat(u2.bodyFormatter(g2))).push(u2.tooltipFooterHeaderFormatter(g2[0], true)), a2;
        }
        destroy() {
          this.label && (this.label = this.label.destroy()), this.split && (this.cleanSplit(true), this.tt && (this.tt = this.tt.destroy())), this.renderer && (this.renderer = this.renderer.destroy(), b5(this.container)), tt2.clearTimeout(this.hideTimer);
        }
        getAnchor(u2, a2) {
          let g2, { chart: r3, pointer: A3 } = this, N2 = r3.inverted, k3 = r3.plotTop, E2 = r3.plotLeft;
          if ((u2 = i5(u2))[0].series && u2[0].series.yAxis && !u2[0].series.yAxis.options.reversedStacks && (u2 = u2.slice().reverse()), this.followPointer && a2) a2.chartX === void 0 && (a2 = A3.normalize(a2)), g2 = [a2.chartX - E2, a2.chartY - k3];
          else if (u2[0].tooltipPos) g2 = u2[0].tooltipPos;
          else {
            let R2 = 0, z2 = 0;
            u2.forEach(function(Q2) {
              let v3 = Q2.pos(true);
              v3 && (R2 += v3[0], z2 += v3[1]);
            }), R2 /= u2.length, z2 /= u2.length, this.shared && u2.length > 1 && a2 && (N2 ? R2 = a2.chartX : z2 = a2.chartY), g2 = [R2 - E2, z2 - k3];
          }
          return g2.map(Math.round);
        }
        getClassName(u2, a2, g2) {
          let r3 = this.options, A3 = u2.series, N2 = A3.options;
          return [r3.className, "highcharts-label", g2 && "highcharts-tooltip-header", a2 ? "highcharts-tooltip-box" : "highcharts-tooltip", !g2 && "highcharts-color-" + l4(u2.colorIndex, A3.colorIndex), N2 && N2.className].filter(G2).join(" ");
        }
        getLabel({ anchorX: u2, anchorY: a2 } = { anchorX: 0, anchorY: 0 }) {
          let g2 = this, r3 = this.chart.styledMode, A3 = this.options, N2 = this.split && this.allowShared, k3 = this.container, E2 = this.chart.renderer;
          if (this.label) {
            let R2 = !this.label.hasClass("highcharts-label");
            (!N2 && R2 || N2 && !R2) && this.destroy();
          }
          if (!this.label) {
            if (this.outside) {
              let R2 = this.chart.options.chart.style, z2 = rt2.getRendererType();
              this.container = k3 = q2.doc.createElement("div"), k3.className = "highcharts-tooltip-container", p2(k3, { position: "absolute", top: "1px", pointerEvents: "none", zIndex: Math.max(this.options.style.zIndex || 0, (R2 && R2.zIndex || 0) + 3) }), this.renderer = E2 = new z2(k3, 0, 0, R2, void 0, void 0, E2.styledMode);
            }
            if (N2 ? this.label = E2.g("tooltip") : (this.label = E2.label("", u2, a2, A3.shape, void 0, void 0, A3.useHTML, void 0, "tooltip").attr({ padding: A3.padding, r: A3.borderRadius }), r3 || this.label.attr({ fill: A3.backgroundColor, "stroke-width": A3.borderWidth || 0 }).css(A3.style).css({ pointerEvents: A3.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none") })), g2.outside) {
              let R2 = this.label;
              [R2.xSetter, R2.ySetter].forEach((z2, Q2) => {
                R2[Q2 ? "ySetter" : "xSetter"] = (v3) => {
                  z2.call(R2, g2.distance), R2[Q2 ? "y" : "x"] = v3, k3 && (k3.style[Q2 ? "top" : "left"] = `${v3}px`);
                };
              });
            }
            this.label.attr({ zIndex: 8 }).shadow(A3.shadow).add();
          }
          return k3 && !k3.parentElement && q2.doc.body.appendChild(k3), this.label;
        }
        getPlayingField() {
          let { body: u2, documentElement: a2 } = d3, { chart: g2, distance: r3, outside: A3 } = this;
          return { width: A3 ? Math.max(u2.scrollWidth, a2.scrollWidth, u2.offsetWidth, a2.offsetWidth, a2.clientWidth) - 2 * r3 : g2.chartWidth, height: A3 ? Math.max(u2.scrollHeight, a2.scrollHeight, u2.offsetHeight, a2.offsetHeight, a2.clientHeight) : g2.chartHeight };
        }
        getPosition(u2, a2, g2) {
          var r3, A3;
          let { distance: N2, chart: k3, outside: E2, pointer: R2 } = this, { inverted: z2, plotLeft: Q2, plotTop: v3, polar: S2 } = k3, { plotX: P2 = 0, plotY: U2 = 0 } = g2, w2 = {}, M2 = z2 && g2.h || 0, { height: D2, width: F2 } = this.getPlayingField(), $2 = R2.getChartPosition(), W2 = (dt2) => dt2 * $2.scaleX, V2 = (dt2) => dt2 * $2.scaleY, _2 = (dt2) => {
            let ct2 = dt2 === "x";
            return [dt2, ct2 ? F2 : D2, ct2 ? u2 : a2].concat(E2 ? [ct2 ? W2(u2) : V2(a2), ct2 ? $2.left - N2 + W2(P2 + Q2) : $2.top - N2 + V2(U2 + v3), 0, ct2 ? F2 : D2] : [ct2 ? u2 : a2, ct2 ? P2 + Q2 : U2 + v3, ct2 ? Q2 : v3, ct2 ? Q2 + k3.plotWidth : v3 + k3.plotHeight]);
          }, et2 = _2("y"), lt2 = _2("x"), ht2, J2 = !!g2.negative;
          !S2 && (A3 = (r3 = k3.hoverSeries) == null ? void 0 : r3.yAxis) != null && A3.reversed && (J2 = !J2);
          let Y2 = !this.followPointer && l4(g2.ttBelow, !S2 && !z2 === J2), st2 = function(dt2, ct2, gt2, ft2, pt2, mt2, yt2) {
            let vt2 = E2 ? dt2 === "y" ? V2(N2) : W2(N2) : N2, bt2 = (gt2 - ft2) / 2, xt2 = ft2 < pt2 - N2, Ct2 = pt2 + N2 + ft2 < ct2, wt2 = pt2 - vt2 - gt2 + bt2, kt2 = pt2 + vt2 - bt2;
            if (Y2 && Ct2) w2[dt2] = kt2;
            else if (!Y2 && xt2) w2[dt2] = wt2;
            else if (xt2) w2[dt2] = Math.min(yt2 - ft2, wt2 - M2 < 0 ? wt2 : wt2 - M2);
            else {
              if (!Ct2) return false;
              w2[dt2] = Math.max(mt2, kt2 + M2 + gt2 > ct2 ? kt2 : kt2 + M2);
            }
          }, nt2 = function(dt2, ct2, gt2, ft2, pt2) {
            if (pt2 < N2 || pt2 > ct2 - N2) return false;
            pt2 < gt2 / 2 ? w2[dt2] = 1 : pt2 > ct2 - ft2 / 2 ? w2[dt2] = ct2 - ft2 - 2 : w2[dt2] = pt2 - gt2 / 2;
          }, ot2 = function(dt2) {
            [et2, lt2] = [lt2, et2], ht2 = dt2;
          }, ut2 = () => {
            st2.apply(0, et2) !== false ? nt2.apply(0, lt2) !== false || ht2 || (ot2(true), ut2()) : ht2 ? w2.x = w2.y = 0 : (ot2(true), ut2());
          };
          return (z2 && !S2 || this.len > 1) && ot2(), ut2(), w2;
        }
        hide(u2) {
          let a2 = this;
          tt2.clearTimeout(this.hideTimer), u2 = l4(u2, this.options.hideDelay), this.isHidden || (this.hideTimer = t3(function() {
            let g2 = a2.getLabel();
            a2.getLabel().animate({ opacity: 0 }, { duration: u2 && 150, complete: () => {
              g2.hide(), a2.container && a2.container.remove();
            } }), a2.isHidden = true;
          }, u2));
        }
        init(u2, a2) {
          this.chart = u2, this.options = a2, this.crosshairs = [], this.isHidden = true, this.split = a2.split && !u2.inverted && !u2.polar, this.shared = a2.shared || this.split, this.outside = l4(a2.outside, !!(u2.scrollablePixelsX || u2.scrollablePixelsY));
        }
        shouldStickOnContact(u2) {
          return !!(!this.followPointer && this.options.stickOnContact && (!u2 || this.pointer.inClass(u2.target, "highcharts-tooltip")));
        }
        move(u2, a2, g2, r3) {
          let A3 = this, N2 = X2(!A3.isHidden && A3.options.animation), k3 = A3.followPointer || (A3.len || 0) > 1, E2 = { x: u2, y: a2 };
          k3 || (E2.anchorX = g2, E2.anchorY = r3), N2.step = () => A3.drawTracker(), A3.getLabel().animate(E2, N2);
        }
        refresh(u2, a2) {
          let { chart: g2, options: r3, pointer: A3, shared: N2 } = this, k3 = i5(u2), E2 = k3[0], R2 = [], z2 = r3.format, Q2 = r3.formatter || this.defaultFormatter, v3 = g2.styledMode, S2 = {}, P2 = this.allowShared;
          if (!r3.enabled || !E2.series) return;
          tt2.clearTimeout(this.hideTimer), this.allowShared = !(!T2(u2) && u2.series && u2.series.noSharedTooltip), P2 = P2 && !this.allowShared, this.followPointer = !this.split && E2.series.tooltipOptions.followPointer;
          let U2 = this.getAnchor(u2, a2), w2 = U2[0], M2 = U2[1];
          N2 && this.allowShared ? (A3.applyInactiveState(k3), k3.forEach(function($2) {
            $2.setState("hover"), R2.push($2.getLabelConfig());
          }), (S2 = E2.getLabelConfig()).points = R2) : S2 = E2.getLabelConfig(), this.len = R2.length;
          let D2 = G2(z2) ? O3(z2, S2, g2) : Q2.call(S2, this), F2 = E2.series;
          if (this.distance = l4(F2.tooltipOptions.distance, 16), D2 === false) this.hide();
          else {
            if (this.split && this.allowShared) this.renderSplit(D2, k3);
            else {
              let $2 = w2, W2 = M2;
              if (a2 && A3.isDirectTouch && ($2 = a2.chartX - g2.plotLeft, W2 = a2.chartY - g2.plotTop), g2.polar || F2.options.clip === false || k3.some((V2) => A3.isDirectTouch || V2.series.shouldShowTooltip($2, W2))) {
                let V2 = this.getLabel(P2 && this.tt || {});
                (!r3.style.width || v3) && V2.css({ width: (this.outside ? this.getPlayingField() : g2.spacingBox).width + "px" }), V2.attr({ class: this.getClassName(E2), text: D2 && D2.join ? D2.join("") : D2 }), this.outside && V2.attr({ x: o2(V2.x || 0, 0, this.getPlayingField().width - (V2.width || 0)) }), v3 || V2.attr({ stroke: r3.borderColor || E2.color || F2.color || "#666666" }), this.updatePosition({ plotX: w2, plotY: M2, negative: E2.negative, ttBelow: E2.ttBelow, h: U2[2] || 0 });
              } else {
                this.hide();
                return;
              }
            }
            this.isHidden && this.label && this.label.attr({ opacity: 1 }).show(), this.isHidden = false;
          }
          c4(this, "refresh");
        }
        renderSplit(u2, a2) {
          var g2;
          let r3 = this, { chart: A3, chart: { chartWidth: N2, chartHeight: k3, plotHeight: E2, plotLeft: R2, plotTop: z2, scrollablePixelsY: Q2 = 0, scrollablePixelsX: v3, styledMode: S2 }, distance: P2, options: U2, options: { positioner: w2 }, pointer: M2 } = r3, { scrollLeft: D2 = 0, scrollTop: F2 = 0 } = ((g2 = A3.scrollablePlotArea) == null ? void 0 : g2.scrollingContainer) || {}, $2 = r3.outside && typeof v3 != "number" ? d3.documentElement.getBoundingClientRect() : { left: D2, right: D2 + N2, top: F2, bottom: F2 + k3 }, W2 = r3.getLabel(), V2 = this.renderer || A3.renderer, _2 = !!(A3.xAxis[0] && A3.xAxis[0].opposite), { left: et2, top: lt2 } = M2.getChartPosition(), ht2 = z2 + F2, J2 = 0, Y2 = E2 - Q2;
          function st2(gt2, ft2, pt2, mt2, yt2 = true) {
            let vt2, bt2;
            return pt2 ? (vt2 = _2 ? 0 : Y2, bt2 = o2(gt2 - mt2 / 2, $2.left, $2.right - mt2 - (r3.outside ? et2 : 0))) : (vt2 = ft2 - ht2, bt2 = o2(bt2 = yt2 ? gt2 - mt2 - P2 : gt2 + P2, yt2 ? bt2 : $2.left, $2.right)), { x: bt2, y: vt2 };
          }
          G2(u2) && (u2 = [false, u2]);
          let nt2 = u2.slice(0, a2.length + 1).reduce(function(gt2, ft2, pt2) {
            if (ft2 !== false && ft2 !== "") {
              let mt2 = a2[pt2 - 1] || { isHeader: true, plotX: a2[0].plotX, plotY: E2, series: {} }, yt2 = mt2.isHeader, vt2 = yt2 ? r3 : mt2.series, bt2 = vt2.tt = function(St2, Tt2, Et2) {
                var Ot2;
                let It2 = St2, { isHeader: Xt2, series: _t2 } = Tt2;
                if (!It2) {
                  let Gt2 = { padding: U2.padding, r: U2.borderRadius };
                  S2 || (Gt2.fill = U2.backgroundColor, Gt2["stroke-width"] = (Ot2 = U2.borderWidth) != null ? Ot2 : 1), It2 = V2.label("", 0, 0, U2[Xt2 ? "headerShape" : "shape"], void 0, void 0, U2.useHTML).addClass(r3.getClassName(Tt2, true, Xt2)).attr(Gt2).add(W2);
                }
                return It2.isActive = true, It2.attr({ text: Et2 }), S2 || It2.css(U2.style).attr({ stroke: U2.borderColor || Tt2.color || _t2.color || "#333333" }), It2;
              }(vt2.tt, mt2, ft2.toString()), xt2 = bt2.getBBox(), Ct2 = xt2.width + bt2.strokeWidth();
              yt2 && (J2 = xt2.height, Y2 += J2, _2 && (ht2 -= J2));
              let { anchorX: wt2, anchorY: kt2 } = function(St2) {
                let Tt2, Et2, { isHeader: Ot2, plotX: It2 = 0, plotY: Xt2 = 0, series: _t2 } = St2;
                if (Ot2) Tt2 = Math.max(R2 + It2, R2), Et2 = z2 + E2 / 2;
                else {
                  let { xAxis: Gt2, yAxis: Bt2 } = _t2;
                  Tt2 = Gt2.pos + o2(It2, -P2, Gt2.len + P2), _t2.shouldShowTooltip(0, Bt2.pos - z2 + Xt2, { ignoreX: true }) && (Et2 = Bt2.pos + Xt2);
                }
                return { anchorX: Tt2 = o2(Tt2, $2.left - P2, $2.right + P2), anchorY: Et2 };
              }(mt2);
              if (typeof kt2 == "number") {
                let St2 = xt2.height + 1, Tt2 = w2 ? w2.call(r3, Ct2, St2, mt2) : st2(wt2, kt2, yt2, Ct2);
                gt2.push({ align: w2 ? 0 : void 0, anchorX: wt2, anchorY: kt2, boxWidth: Ct2, point: mt2, rank: l4(Tt2.rank, yt2 ? 1 : 0), size: St2, target: Tt2.y, tt: bt2, x: Tt2.x });
              } else bt2.isActive = false;
            }
            return gt2;
          }, []);
          !w2 && nt2.some((gt2) => {
            let { outside: ft2 } = r3, pt2 = (ft2 ? et2 : 0) + gt2.anchorX;
            return pt2 < $2.left && pt2 + gt2.boxWidth < $2.right || pt2 < et2 - $2.left + gt2.boxWidth && $2.right - pt2 > pt2;
          }) && (nt2 = nt2.map((gt2) => {
            let { x: ft2, y: pt2 } = st2(gt2.anchorX, gt2.anchorY, gt2.point.isHeader, gt2.boxWidth, false);
            return h2(gt2, { target: pt2, x: ft2 });
          })), r3.cleanSplit(), f2(nt2, Y2);
          let ot2 = { left: et2, right: et2 };
          nt2.forEach(function(gt2) {
            let { x: ft2, boxWidth: pt2, isHeader: mt2 } = gt2;
            !mt2 && (r3.outside && et2 + ft2 < ot2.left && (ot2.left = et2 + ft2), !mt2 && r3.outside && ot2.left + pt2 > ot2.right && (ot2.right = et2 + ft2));
          }), nt2.forEach(function(gt2) {
            let { x: ft2, anchorX: pt2, anchorY: mt2, pos: yt2, point: { isHeader: vt2 } } = gt2, bt2 = { visibility: yt2 === void 0 ? "hidden" : "inherit", x: ft2, y: (yt2 || 0) + ht2, anchorX: pt2, anchorY: mt2 };
            if (r3.outside && ft2 < pt2) {
              let xt2 = et2 - ot2.left;
              xt2 > 0 && (vt2 || (bt2.x = ft2 + xt2, bt2.anchorX = pt2 + xt2), vt2 && (bt2.x = (ot2.right - ot2.left) / 2, bt2.anchorX = pt2 + xt2));
            }
            gt2.tt.attr(bt2);
          });
          let { container: ut2, outside: dt2, renderer: ct2 } = r3;
          if (dt2 && ut2 && ct2) {
            let { width: gt2, height: ft2, x: pt2, y: mt2 } = W2.getBBox();
            ct2.setSize(gt2 + pt2, ft2 + mt2, false), ut2.style.left = ot2.left + "px", ut2.style.top = lt2 + "px";
          }
          x2 && W2.attr({ opacity: W2.opacity === 1 ? 0.999 : 1 });
        }
        drawTracker() {
          if (!this.shouldStickOnContact()) {
            this.tracker && (this.tracker = this.tracker.destroy());
            return;
          }
          let u2 = this.chart, a2 = this.label, g2 = this.shared ? u2.hoverPoints : u2.hoverPoint;
          if (!a2 || !g2) return;
          let r3 = { x: 0, y: 0, width: 0, height: 0 }, A3 = this.getAnchor(g2), N2 = a2.getBBox();
          A3[0] += u2.plotLeft - (a2.translateX || 0), A3[1] += u2.plotTop - (a2.translateY || 0), r3.x = Math.min(0, A3[0]), r3.y = Math.min(0, A3[1]), r3.width = A3[0] < 0 ? Math.max(Math.abs(A3[0]), N2.width - A3[0]) : Math.max(Math.abs(A3[0]), N2.width), r3.height = A3[1] < 0 ? Math.max(Math.abs(A3[1]), N2.height - Math.abs(A3[1])) : Math.max(Math.abs(A3[1]), N2.height), this.tracker ? this.tracker.attr(r3) : (this.tracker = a2.renderer.rect(r3).addClass("highcharts-tracker").add(a2), u2.styledMode || this.tracker.attr({ fill: "rgba(0,0,0,0)" }));
        }
        styledModeFormat(u2) {
          return u2.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
        }
        tooltipFooterHeaderFormatter(u2, a2) {
          let g2 = u2.series, r3 = g2.tooltipOptions, A3 = g2.xAxis, N2 = A3 && A3.dateTime, k3 = { isFooter: a2, labelConfig: u2 }, E2 = r3.xDateFormat, R2 = r3[a2 ? "footerFormat" : "headerFormat"];
          return c4(this, "headerFormatter", k3, function(z2) {
            N2 && !E2 && I3(u2.key) && (E2 = N2.getXDateFormat(u2.key, r3.dateTimeLabelFormats)), N2 && E2 && (u2.point && u2.point.tooltipDateKeys || ["key"]).forEach(function(Q2) {
              R2 = R2.replace("{point." + Q2 + "}", "{point." + Q2 + ":" + E2 + "}");
            }), g2.chart.styledMode && (R2 = this.styledModeFormat(R2)), z2.text = O3(R2, { point: u2, series: g2 }, this.chart);
          }), k3.text;
        }
        update(u2) {
          this.destroy(), this.init(this.chart, L2(true, this.options, u2));
        }
        updatePosition(u2) {
          let { chart: a2, container: g2, distance: r3, options: A3, pointer: N2, renderer: k3 } = this, { height: E2 = 0, width: R2 = 0 } = this.getLabel(), { left: z2, top: Q2, scaleX: v3, scaleY: S2 } = N2.getChartPosition(), P2 = (A3.positioner || this.getPosition).call(this, R2, E2, u2), U2 = (u2.plotX || 0) + a2.plotLeft, w2 = (u2.plotY || 0) + a2.plotTop, M2;
          k3 && g2 && (A3.positioner && (P2.x += z2 - r3, P2.y += Q2 - r3), M2 = (A3.borderWidth || 0) + 2 * r3 + 2, k3.setSize(R2 + M2, E2 + M2, false), (v3 !== 1 || S2 !== 1) && (p2(g2, { transform: `scale(${v3}, ${S2})` }), U2 *= v3, w2 *= S2), U2 += z2 - P2.x, w2 += Q2 - P2.y), this.move(Math.round(P2.x), Math.round(P2.y || 0), U2, w2);
        }
      }
      return (Z2 = e5).compose = function(n4) {
        y2(j3, "Core.Tooltip") && C3(n4, "afterInit", function() {
          let u2 = this.chart;
          u2.options.tooltip && (u2.tooltip = new Z2(u2, u2.options.tooltip, this));
        });
      }, e5;
    }), at2(s2, "Core/Series/Point.js", [s2["Core/Renderer/HTML/AST.js"], s2["Core/Animation/AnimationUtilities.js"], s2["Core/Defaults.js"], s2["Core/Templating.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2) {
      let { animObject: tt2 } = K2, { defaultOptions: Z2 } = q2, { format: X2 } = it2, { addEvent: O3, crisp: j3, erase: d3, extend: x2, fireEvent: f2, getNestedProperty: C3, isArray: o2, isFunction: p2, isNumber: b5, isObject: h2, merge: c4, pick: T2, syncTimeout: I3, removeEvent: G2, uniqueKey: L2 } = rt2;
      class l4 {
        animateBeforeDestroy() {
          let i5 = this, t3 = { x: i5.startXPos, opacity: 0 }, e5 = i5.getGraphicalProps();
          e5.singular.forEach(function(n4) {
            i5[n4] = i5[n4].animate(n4 === "dataLabel" ? { x: i5[n4].startXPos, y: i5[n4].startYPos, opacity: 0 } : t3);
          }), e5.plural.forEach(function(n4) {
            i5[n4].forEach(function(u2) {
              u2.element && u2.animate(x2({ x: i5.startXPos }, u2.startYPos ? { x: u2.startXPos, y: u2.startYPos } : {}));
            });
          });
        }
        applyOptions(i5, t3) {
          let e5 = this.series, n4 = e5.options.pointValKey || e5.pointValKey;
          return x2(this, i5 = l4.prototype.optionsToObject.call(this, i5)), this.options = this.options ? x2(this.options, i5) : i5, i5.group && delete this.group, i5.dataLabels && delete this.dataLabels, n4 && (this.y = l4.prototype.getNestedProperty.call(this, n4)), this.selected && (this.state = "select"), "name" in this && t3 === void 0 && e5.xAxis && e5.xAxis.hasNames && (this.x = e5.xAxis.nameToX(this)), this.x === void 0 && e5 ? this.x = t3 != null ? t3 : e5.autoIncrement() : b5(i5.x) && e5.options.relativeXValue && (this.x = e5.autoIncrement(i5.x)), this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point", this;
        }
        destroy() {
          if (!this.destroyed) {
            let i5 = this, t3 = i5.series, e5 = t3.chart, n4 = t3.options.dataSorting, u2 = e5.hoverPoints, a2 = tt2(i5.series.chart.renderer.globalAnimation), g2 = () => {
              for (let r3 in (i5.graphic || i5.graphics || i5.dataLabel || i5.dataLabels) && (G2(i5), i5.destroyElements()), i5) delete i5[r3];
            };
            i5.legendItem && e5.legend.destroyItem(i5), u2 && (i5.setState(), d3(u2, i5), u2.length || (e5.hoverPoints = null)), i5 === e5.hoverPoint && i5.onMouseOut(), n4 && n4.enabled ? (this.animateBeforeDestroy(), I3(g2, a2.duration)) : g2(), e5.pointCount--;
          }
          this.destroyed = true;
        }
        destroyElements(i5) {
          let t3 = this, e5 = t3.getGraphicalProps(i5);
          e5.singular.forEach(function(n4) {
            t3[n4] = t3[n4].destroy();
          }), e5.plural.forEach(function(n4) {
            t3[n4].forEach(function(u2) {
              u2 && u2.element && u2.destroy();
            }), delete t3[n4];
          });
        }
        firePointEvent(i5, t3, e5) {
          let n4 = this, u2 = this.series.options;
          n4.manageEvent(i5), i5 === "click" && u2.allowPointSelect && (e5 = function(a2) {
            !n4.destroyed && n4.select && n4.select(null, a2.ctrlKey || a2.metaKey || a2.shiftKey);
          }), f2(n4, i5, t3, e5);
        }
        getClassName() {
          return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (this.colorIndex !== void 0 ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
        }
        getGraphicalProps(i5) {
          let t3, e5, n4 = this, u2 = [], a2 = { singular: [], plural: [] };
          for ((i5 = i5 || { graphic: 1, dataLabel: 1 }).graphic && u2.push("graphic", "connector"), i5.dataLabel && u2.push("dataLabel", "dataLabelPath", "dataLabelUpper"), e5 = u2.length; e5--; ) n4[t3 = u2[e5]] && a2.singular.push(t3);
          return ["graphic", "dataLabel"].forEach(function(g2) {
            let r3 = g2 + "s";
            i5[g2] && n4[r3] && a2.plural.push(r3);
          }), a2;
        }
        getLabelConfig() {
          return { x: this.category, y: this.y, color: this.color, colorIndex: this.colorIndex, key: this.name || this.category, series: this.series, point: this, percentage: this.percentage, total: this.total || this.stackTotal };
        }
        getNestedProperty(i5) {
          return i5 ? i5.indexOf("custom.") === 0 ? C3(i5, this.options) : this[i5] : void 0;
        }
        getZone() {
          let i5 = this.series, t3 = i5.zones, e5 = i5.zoneAxis || "y", n4, u2 = 0;
          for (n4 = t3[0]; this[e5] >= n4.value; ) n4 = t3[++u2];
          return this.nonZonedColor || (this.nonZonedColor = this.color), n4 && n4.color && !this.options.color ? this.color = n4.color : this.color = this.nonZonedColor, n4;
        }
        hasNewShapeType() {
          return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
        }
        constructor(i5, t3, e5) {
          this.formatPrefix = "point", this.visible = true, this.series = i5, this.applyOptions(t3, e5), this.id != null || (this.id = L2()), this.resolveColor(), i5.chart.pointCount++, f2(this, "afterInit");
        }
        isValid() {
          return (b5(this.x) || this.x instanceof Date) && b5(this.y);
        }
        optionsToObject(i5) {
          let t3 = this.series, e5 = t3.options.keys, n4 = e5 || t3.pointArrayMap || ["y"], u2 = n4.length, a2 = {}, g2, r3 = 0, A3 = 0;
          if (b5(i5) || i5 === null) a2[n4[0]] = i5;
          else if (o2(i5)) for (!e5 && i5.length > u2 && ((g2 = typeof i5[0]) == "string" ? a2.name = i5[0] : g2 === "number" && (a2.x = i5[0]), r3++); A3 < u2; ) e5 && i5[r3] === void 0 || (n4[A3].indexOf(".") > 0 ? l4.prototype.setNestedProperty(a2, i5[r3], n4[A3]) : a2[n4[A3]] = i5[r3]), r3++, A3++;
          else typeof i5 == "object" && (a2 = i5, i5.dataLabels && (t3.hasDataLabels = () => true), i5.marker && (t3._hasPointMarkers = true));
          return a2;
        }
        pos(i5, t3 = this.plotY) {
          if (!this.destroyed) {
            let { plotX: e5, series: n4 } = this, { chart: u2, xAxis: a2, yAxis: g2 } = n4, r3 = 0, A3 = 0;
            if (b5(e5) && b5(t3)) return i5 && (r3 = a2 ? a2.pos : u2.plotLeft, A3 = g2 ? g2.pos : u2.plotTop), u2.inverted && a2 && g2 ? [g2.len - t3 + A3, a2.len - e5 + r3] : [e5 + r3, t3 + A3];
          }
        }
        resolveColor() {
          let i5 = this.series, t3 = i5.chart.options.chart, e5 = i5.chart.styledMode, n4, u2, a2 = t3.colorCount, g2;
          delete this.nonZonedColor, i5.options.colorByPoint ? (e5 || (n4 = (u2 = i5.options.colors || i5.chart.options.colors)[i5.colorCounter], a2 = u2.length), g2 = i5.colorCounter, i5.colorCounter++, i5.colorCounter === a2 && (i5.colorCounter = 0)) : (e5 || (n4 = i5.color), g2 = i5.colorIndex), this.colorIndex = T2(this.options.colorIndex, g2), this.color = T2(this.options.color, n4);
        }
        setNestedProperty(i5, t3, e5) {
          return e5.split(".").reduce(function(n4, u2, a2, g2) {
            let r3 = g2.length - 1 === a2;
            return n4[u2] = r3 ? t3 : h2(n4[u2], true) ? n4[u2] : {}, n4[u2];
          }, i5), i5;
        }
        shouldDraw() {
          return !this.isNull;
        }
        tooltipFormatter(i5) {
          let t3 = this.series, e5 = t3.tooltipOptions, n4 = T2(e5.valueDecimals, ""), u2 = e5.valuePrefix || "", a2 = e5.valueSuffix || "";
          return t3.chart.styledMode && (i5 = t3.chart.tooltip.styledModeFormat(i5)), (t3.pointArrayMap || ["y"]).forEach(function(g2) {
            g2 = "{point." + g2, (u2 || a2) && (i5 = i5.replace(RegExp(g2 + "}", "g"), u2 + g2 + "}" + a2)), i5 = i5.replace(RegExp(g2 + "}", "g"), g2 + ":,." + n4 + "f}");
          }), X2(i5, { point: this, series: this.series }, t3.chart);
        }
        update(i5, t3, e5, n4) {
          let u2, a2 = this, g2 = a2.series, r3 = a2.graphic, A3 = g2.chart, N2 = g2.options;
          function k3() {
            a2.applyOptions(i5);
            let E2 = r3 && a2.hasMockGraphic, R2 = a2.y === null ? !E2 : E2;
            r3 && R2 && (a2.graphic = r3.destroy(), delete a2.hasMockGraphic), h2(i5, true) && (r3 && r3.element && i5 && i5.marker && i5.marker.symbol !== void 0 && (a2.graphic = r3.destroy()), i5 != null && i5.dataLabels && a2.dataLabel && (a2.dataLabel = a2.dataLabel.destroy())), u2 = a2.index, g2.updateParallelArrays(a2, u2), N2.data[u2] = h2(N2.data[u2], true) || h2(i5, true) ? a2.options : T2(i5, N2.data[u2]), g2.isDirty = g2.isDirtyData = true, !g2.fixedBox && g2.hasCartesianSeries && (A3.isDirtyBox = true), N2.legendType === "point" && (A3.isDirtyLegend = true), t3 && A3.redraw(e5);
          }
          t3 = T2(t3, true), n4 === false ? k3() : a2.firePointEvent("update", { options: i5 }, k3);
        }
        remove(i5, t3) {
          this.series.removePoint(this.series.data.indexOf(this), i5, t3);
        }
        select(i5, t3) {
          let e5 = this, n4 = e5.series, u2 = n4.chart;
          i5 = T2(i5, !e5.selected), this.selectedStaging = i5, e5.firePointEvent(i5 ? "select" : "unselect", { accumulate: t3 }, function() {
            e5.selected = e5.options.selected = i5, n4.options.data[n4.data.indexOf(e5)] = e5.options, e5.setState(i5 && "select"), t3 || u2.getSelectedPoints().forEach(function(a2) {
              let g2 = a2.series;
              a2.selected && a2 !== e5 && (a2.selected = a2.options.selected = false, g2.options.data[g2.data.indexOf(a2)] = a2.options, a2.setState(u2.hoverPoints && g2.options.inactiveOtherPoints ? "inactive" : ""), a2.firePointEvent("unselect"));
            });
          }), delete this.selectedStaging;
        }
        onMouseOver(i5) {
          let { inverted: t3, pointer: e5 } = this.series.chart;
          e5 && (i5 = i5 ? e5.normalize(i5) : e5.getChartCoordinatesFromPoint(this, t3), e5.runPointActions(i5, this));
        }
        onMouseOut() {
          let i5 = this.series.chart;
          this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (i5.hoverPoints || []).forEach(function(t3) {
            t3.setState();
          }), i5.hoverPoints = i5.hoverPoint = null;
        }
        manageEvent(i5) {
          var t3, e5, n4, u2, a2, g2;
          let r3 = c4(this.series.options.point, this.options), A3 = (t3 = r3.events) == null ? void 0 : t3[i5];
          p2(A3) && (!((e5 = this.hcEvents) != null && e5[i5]) || ((u2 = (n4 = this.hcEvents) == null ? void 0 : n4[i5]) == null ? void 0 : u2.map((N2) => N2.fn).indexOf(A3)) === -1) ? ((a2 = this.importedUserEvent) == null || a2.call(this), this.importedUserEvent = O3(this, i5, A3)) : this.importedUserEvent && !A3 && (g2 = this.hcEvents) != null && g2[i5] && (G2(this, i5), delete this.hcEvents[i5], Object.keys(this.hcEvents) || delete this.importedUserEvent);
        }
        setState(i5, t3) {
          var e5;
          let n4 = this.series, u2 = this.state, a2 = n4.options.states[i5 || "normal"] || {}, g2 = Z2.plotOptions[n4.type].marker && n4.options.marker, r3 = g2 && g2.enabled === false, A3 = g2 && g2.states && g2.states[i5 || "normal"] || {}, N2 = A3.enabled === false, k3 = this.marker || {}, E2 = n4.chart, R2 = g2 && n4.markerAttribs, z2 = n4.halo, Q2, v3, S2, P2 = n4.stateMarkerGraphic, U2;
          if ((i5 = i5 || "") === this.state && !t3 || this.selected && i5 !== "select" || a2.enabled === false || i5 && (N2 || r3 && A3.enabled === false) || i5 && k3.states && k3.states[i5] && k3.states[i5].enabled === false) return;
          if (this.state = i5, R2 && (Q2 = n4.markerAttribs(this, i5)), this.graphic && !this.hasMockGraphic) {
            if (u2 && this.graphic.removeClass("highcharts-point-" + u2), i5 && this.graphic.addClass("highcharts-point-" + i5), !E2.styledMode) {
              v3 = n4.pointAttribs(this, i5), S2 = T2(E2.options.chart.animation, a2.animation);
              let F2 = v3.opacity;
              n4.options.inactiveOtherPoints && b5(F2) && (this.dataLabels || []).forEach(function($2) {
                $2 && !$2.hasClass("highcharts-data-label-hidden") && ($2.animate({ opacity: F2 }, S2), $2.connector && $2.connector.animate({ opacity: F2 }, S2));
              }), this.graphic.animate(v3, S2);
            }
            Q2 && this.graphic.animate(Q2, T2(E2.options.chart.animation, A3.animation, g2.animation)), P2 && P2.hide();
          } else i5 && A3 && (U2 = k3.symbol || n4.symbol, P2 && P2.currentSymbol !== U2 && (P2 = P2.destroy()), Q2 && (P2 ? P2[t3 ? "animate" : "attr"]({ x: Q2.x, y: Q2.y }) : U2 && (n4.stateMarkerGraphic = P2 = E2.renderer.symbol(U2, Q2.x, Q2.y, Q2.width, Q2.height).add(n4.markerGroup), P2.currentSymbol = U2)), !E2.styledMode && P2 && this.state !== "inactive" && P2.attr(n4.pointAttribs(this, i5))), P2 && (P2[i5 && this.isInside ? "show" : "hide"](), P2.element.point = this, P2.addClass(this.getClassName(), true));
          let w2 = a2.halo, M2 = this.graphic || P2, D2 = M2 && M2.visibility || "inherit";
          w2 && w2.size && M2 && D2 !== "hidden" && !this.isCluster ? (z2 || (n4.halo = z2 = E2.renderer.path().add(M2.parentGroup)), z2.show()[t3 ? "animate" : "attr"]({ d: this.haloPath(w2.size) }), z2.attr({ class: "highcharts-halo highcharts-color-" + T2(this.colorIndex, n4.colorIndex) + (this.className ? " " + this.className : ""), visibility: D2, zIndex: -1 }), z2.point = this, E2.styledMode || z2.attr(x2({ fill: this.color || n4.color, "fill-opacity": w2.opacity }, B3.filterUserAttributes(w2.attributes || {})))) : (e5 = z2 == null ? void 0 : z2.point) != null && e5.haloPath && !z2.point.destroyed && z2.animate({ d: z2.point.haloPath(0) }, null, z2.hide), f2(this, "afterSetState", { state: i5 });
        }
        haloPath(i5) {
          let t3 = this.pos();
          return t3 ? this.series.chart.renderer.symbols.circle(j3(t3[0], 1) - i5, t3[1] - i5, 2 * i5, 2 * i5) : [];
        }
      }
      return l4;
    }), at2(s2, "Core/Pointer.js", [s2["Core/Color/Color.js"], s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      var it2;
      let { parse: rt2 } = B3, { charts: tt2, composed: Z2, isTouchDevice: X2 } = K2, { addEvent: O3, attr: j3, css: d3, extend: x2, find: f2, fireEvent: C3, isNumber: o2, isObject: p2, objectEach: b5, offset: h2, pick: c4, pushUnique: T2, splat: I3 } = q2;
      class G2 {
        applyInactiveState(l4) {
          let y2 = [], i5;
          (l4 || []).forEach(function(t3) {
            i5 = t3.series, y2.push(i5), i5.linkedParent && y2.push(i5.linkedParent), i5.linkedSeries && (y2 = y2.concat(i5.linkedSeries)), i5.navigatorSeries && y2.push(i5.navigatorSeries);
          }), this.chart.series.forEach(function(t3) {
            y2.indexOf(t3) === -1 ? t3.setState("inactive", true) : t3.options.inactiveOtherPoints && t3.setAllPointsToState("inactive");
          });
        }
        destroy() {
          let l4 = this;
          this.eventsToUnbind.forEach((y2) => y2()), this.eventsToUnbind = [], !K2.chartCount && (G2.unbindDocumentMouseUp && G2.unbindDocumentMouseUp.forEach((y2) => y2()), G2.unbindDocumentTouchEnd && (G2.unbindDocumentTouchEnd = G2.unbindDocumentTouchEnd())), clearInterval(l4.tooltipTimeout), b5(l4, function(y2, i5) {
            l4[i5] = void 0;
          });
        }
        getSelectionMarkerAttrs(l4, y2) {
          let i5 = { args: { chartX: l4, chartY: y2 }, attrs: {}, shapeType: "rect" };
          return C3(this, "getSelectionMarkerAttrs", i5, (t3) => {
            let e5, { chart: n4, zoomHor: u2, zoomVert: a2 } = this, { mouseDownX: g2 = 0, mouseDownY: r3 = 0 } = n4, A3 = t3.attrs;
            A3.x = n4.plotLeft, A3.y = n4.plotTop, A3.width = u2 ? 1 : n4.plotWidth, A3.height = a2 ? 1 : n4.plotHeight, u2 && (e5 = l4 - g2, A3.width = Math.max(1, Math.abs(e5)), A3.x = (e5 > 0 ? 0 : e5) + g2), a2 && (e5 = y2 - r3, A3.height = Math.max(1, Math.abs(e5)), A3.y = (e5 > 0 ? 0 : e5) + r3);
          }), i5;
        }
        drag(l4) {
          let { chart: y2 } = this, { mouseDownX: i5 = 0, mouseDownY: t3 = 0 } = y2, { panning: e5, panKey: n4, selectionMarkerFill: u2 } = y2.options.chart, a2 = y2.plotLeft, g2 = y2.plotTop, r3 = y2.plotWidth, A3 = y2.plotHeight, N2 = p2(e5) ? e5.enabled : e5, k3 = n4 && l4[`${n4}Key`], E2 = l4.chartX, R2 = l4.chartY, z2, Q2 = this.selectionMarker;
          if ((!Q2 || !Q2.touch) && (E2 < a2 ? E2 = a2 : E2 > a2 + r3 && (E2 = a2 + r3), R2 < g2 ? R2 = g2 : R2 > g2 + A3 && (R2 = g2 + A3), this.hasDragged = Math.sqrt(Math.pow(i5 - E2, 2) + Math.pow(t3 - R2, 2)), this.hasDragged > 10)) {
            z2 = y2.isInsidePlot(i5 - a2, t3 - g2, { visiblePlotOnly: true });
            let { shapeType: v3, attrs: S2 } = this.getSelectionMarkerAttrs(E2, R2);
            (y2.hasCartesianSeries || y2.mapView) && this.hasZoom && z2 && !k3 && !Q2 && (this.selectionMarker = Q2 = y2.renderer[v3](), Q2.attr({ class: "highcharts-selection-marker", zIndex: 7 }).add(), y2.styledMode || Q2.attr({ fill: u2 || rt2("#334eff").setOpacity(0.25).get() })), Q2 && Q2.attr(S2), z2 && !Q2 && N2 && y2.pan(l4, e5);
          }
        }
        dragStart(l4) {
          let y2 = this.chart;
          y2.mouseIsDown = l4.type, y2.cancelClick = false, y2.mouseDownX = l4.chartX, y2.mouseDownY = l4.chartY;
        }
        getSelectionBox(l4) {
          let y2 = { args: { marker: l4 }, result: l4.getBBox() };
          return C3(this, "getSelectionBox", y2), y2.result;
        }
        drop(l4) {
          let y2, { chart: i5, selectionMarker: t3 } = this;
          for (let e5 of i5.axes) e5.isPanning && (e5.isPanning = false, (e5.options.startOnTick || e5.options.endOnTick || e5.series.some((n4) => n4.boosted)) && (e5.forceRedraw = true, e5.setExtremes(e5.userMin, e5.userMax, false), y2 = true));
          if (y2 && i5.redraw(), t3 && l4) {
            if (this.hasDragged) {
              let e5 = this.getSelectionBox(t3);
              i5.transform({ axes: i5.axes.filter((n4) => n4.zoomEnabled && (n4.coll === "xAxis" && this.zoomX || n4.coll === "yAxis" && this.zoomY)), selection: { originalEvent: l4, xAxis: [], yAxis: [], ...e5 }, from: e5 });
            }
            o2(i5.index) && (this.selectionMarker = t3.destroy());
          }
          i5 && o2(i5.index) && (d3(i5.container, { cursor: i5._cursor }), i5.cancelClick = this.hasDragged > 10, i5.mouseIsDown = false, this.hasDragged = 0, this.pinchDown = []);
        }
        findNearestKDPoint(l4, y2, i5) {
          let t3;
          return l4.forEach(function(e5) {
            let n4 = !(e5.noSharedTooltip && y2) && 0 > e5.options.findNearestPointBy.indexOf("y"), u2 = e5.searchPoint(i5, n4);
            p2(u2, true) && u2.series && (!p2(t3, true) || function(a2, g2) {
              var r3, A3;
              let N2 = a2.distX - g2.distX, k3 = a2.dist - g2.dist, E2 = ((r3 = g2.series.group) == null ? void 0 : r3.zIndex) - ((A3 = a2.series.group) == null ? void 0 : A3.zIndex);
              return N2 !== 0 && y2 ? N2 : k3 !== 0 ? k3 : E2 !== 0 ? E2 : a2.series.index > g2.series.index ? -1 : 1;
            }(t3, u2) > 0) && (t3 = u2);
          }), t3;
        }
        getChartCoordinatesFromPoint(l4, y2) {
          var i5, t3;
          let { xAxis: e5, yAxis: n4 } = l4.series, u2 = l4.shapeArgs;
          if (e5 && n4) {
            let a2 = (t3 = (i5 = l4.clientX) != null ? i5 : l4.plotX) != null ? t3 : 0, g2 = l4.plotY || 0;
            return l4.isNode && u2 && o2(u2.x) && o2(u2.y) && (a2 = u2.x, g2 = u2.y), y2 ? { chartX: n4.len + n4.pos - g2, chartY: e5.len + e5.pos - a2 } : { chartX: a2 + e5.pos, chartY: g2 + n4.pos };
          }
          if (u2 && u2.x && u2.y) return { chartX: u2.x, chartY: u2.y };
        }
        getChartPosition() {
          if (this.chartPosition) return this.chartPosition;
          let { container: l4 } = this.chart, y2 = h2(l4);
          this.chartPosition = { left: y2.left, top: y2.top, scaleX: 1, scaleY: 1 };
          let { offsetHeight: i5, offsetWidth: t3 } = l4;
          return t3 > 2 && i5 > 2 && (this.chartPosition.scaleX = y2.width / t3, this.chartPosition.scaleY = y2.height / i5), this.chartPosition;
        }
        getCoordinates(l4) {
          let y2 = { xAxis: [], yAxis: [] };
          for (let i5 of this.chart.axes) y2[i5.isXAxis ? "xAxis" : "yAxis"].push({ axis: i5, value: i5.toValue(l4[i5.horiz ? "chartX" : "chartY"]) });
          return y2;
        }
        getHoverData(l4, y2, i5, t3, e5, n4) {
          let u2 = [], a2 = function(k3) {
            return k3.visible && !(!e5 && k3.directTouch) && c4(k3.options.enableMouseTracking, true);
          }, g2 = y2, r3, A3 = { chartX: n4 ? n4.chartX : void 0, chartY: n4 ? n4.chartY : void 0, shared: e5 };
          C3(this, "beforeGetHoverData", A3), r3 = g2 && !g2.stickyTracking ? [g2] : i5.filter((k3) => k3.stickyTracking && (A3.filter || a2)(k3));
          let N2 = t3 && l4 || !n4 ? l4 : this.findNearestKDPoint(r3, e5, n4);
          return g2 = N2 && N2.series, N2 && (e5 && !g2.noSharedTooltip ? (r3 = i5.filter(function(k3) {
            return A3.filter ? A3.filter(k3) : a2(k3) && !k3.noSharedTooltip;
          })).forEach(function(k3) {
            let E2 = f2(k3.points, function(R2) {
              return R2.x === N2.x && !R2.isNull;
            });
            p2(E2) && (k3.boosted && k3.boost && (E2 = k3.boost.getPoint(E2)), u2.push(E2));
          }) : u2.push(N2)), C3(this, "afterGetHoverData", A3 = { hoverPoint: N2 }), { hoverPoint: A3.hoverPoint, hoverSeries: g2, hoverPoints: u2 };
        }
        getPointFromEvent(l4) {
          let y2 = l4.target, i5;
          for (; y2 && !i5; ) i5 = y2.point, y2 = y2.parentNode;
          return i5;
        }
        onTrackerMouseOut(l4) {
          let y2 = this.chart, i5 = l4.relatedTarget, t3 = y2.hoverSeries;
          this.isDirectTouch = false, !t3 || !i5 || t3.stickyTracking || this.inClass(i5, "highcharts-tooltip") || this.inClass(i5, "highcharts-series-" + t3.index) && this.inClass(i5, "highcharts-tracker") || t3.onMouseOut();
        }
        inClass(l4, y2) {
          let i5 = l4, t3;
          for (; i5; ) {
            if (t3 = j3(i5, "class")) {
              if (t3.indexOf(y2) !== -1) return true;
              if (t3.indexOf("highcharts-container") !== -1) return false;
            }
            i5 = i5.parentElement;
          }
        }
        constructor(l4, y2) {
          var i5;
          this.hasDragged = 0, this.pointerCaptureEventsToUnbind = [], this.eventsToUnbind = [], this.options = y2, this.chart = l4, this.runChartClick = !!((i5 = y2.chart.events) != null && i5.click), this.pinchDown = [], this.setDOMEvents(), C3(this, "afterInit");
        }
        normalize(l4, y2) {
          let i5 = l4.touches, t3 = i5 ? i5.length ? i5.item(0) : c4(i5.changedTouches, l4.changedTouches)[0] : l4;
          y2 || (y2 = this.getChartPosition());
          let e5 = t3.pageX - y2.left, n4 = t3.pageY - y2.top;
          return x2(l4, { chartX: Math.round(e5 /= y2.scaleX), chartY: Math.round(n4 /= y2.scaleY) });
        }
        onContainerClick(l4) {
          let y2 = this.chart, i5 = y2.hoverPoint, t3 = this.normalize(l4), e5 = y2.plotLeft, n4 = y2.plotTop;
          !y2.cancelClick && (i5 && this.inClass(t3.target, "highcharts-tracker") ? (C3(i5.series, "click", x2(t3, { point: i5 })), y2.hoverPoint && i5.firePointEvent("click", t3)) : (x2(t3, this.getCoordinates(t3)), y2.isInsidePlot(t3.chartX - e5, t3.chartY - n4, { visiblePlotOnly: true }) && C3(y2, "click", t3)));
        }
        onContainerMouseDown(l4) {
          var y2;
          let i5 = (1 & (l4.buttons || l4.button)) == 1;
          l4 = this.normalize(l4), K2.isFirefox && l4.button !== 0 && this.onContainerMouseMove(l4), (l4.button === void 0 || i5) && (this.zoomOption(l4), i5 && ((y2 = l4.preventDefault) == null || y2.call(l4)), this.dragStart(l4));
        }
        onContainerMouseLeave(l4) {
          let { pointer: y2 } = tt2[c4(G2.hoverChartIndex, -1)] || {};
          l4 = this.normalize(l4), this.onContainerMouseMove(l4), y2 && !this.inClass(l4.relatedTarget, "highcharts-tooltip") && (y2.reset(), y2.chartPosition = void 0);
        }
        onContainerMouseEnter() {
          delete this.chartPosition;
        }
        onContainerMouseMove(l4) {
          let y2 = this.chart, i5 = y2.tooltip, t3 = this.normalize(l4);
          this.setHoverChartIndex(l4), (y2.mouseIsDown === "mousedown" || this.touchSelect(t3)) && this.drag(t3), !y2.openMenu && (this.inClass(t3.target, "highcharts-tracker") || y2.isInsidePlot(t3.chartX - y2.plotLeft, t3.chartY - y2.plotTop, { visiblePlotOnly: true })) && !(i5 && i5.shouldStickOnContact(t3)) && (this.inClass(t3.target, "highcharts-no-tooltip") ? this.reset(false, 0) : this.runPointActions(t3));
        }
        onDocumentTouchEnd(l4) {
          this.onDocumentMouseUp(l4);
        }
        onContainerTouchMove(l4) {
          this.touchSelect(l4) ? this.onContainerMouseMove(l4) : this.touch(l4);
        }
        onContainerTouchStart(l4) {
          this.touchSelect(l4) ? this.onContainerMouseDown(l4) : (this.zoomOption(l4), this.touch(l4, true));
        }
        onDocumentMouseMove(l4) {
          let y2 = this.chart, i5 = y2.tooltip, t3 = this.chartPosition, e5 = this.normalize(l4, t3);
          !t3 || y2.isInsidePlot(e5.chartX - y2.plotLeft, e5.chartY - y2.plotTop, { visiblePlotOnly: true }) || i5 && i5.shouldStickOnContact(e5) || e5.target !== y2.container.ownerDocument && this.inClass(e5.target, "highcharts-tracker") || this.reset();
        }
        onDocumentMouseUp(l4) {
          var y2, i5;
          (i5 = (y2 = tt2[c4(G2.hoverChartIndex, -1)]) == null ? void 0 : y2.pointer) == null || i5.drop(l4);
        }
        pinch(l4) {
          let y2 = this, { chart: i5, hasZoom: t3, lastTouches: e5 } = y2, n4 = [].map.call(l4.touches || [], (A3) => y2.normalize(A3)), u2 = n4.length, a2 = u2 === 1 && (y2.inClass(l4.target, "highcharts-tracker") && i5.runTrackerClick || y2.runChartClick), g2 = i5.tooltip, r3 = u2 === 1 && c4(g2 == null ? void 0 : g2.options.followTouchMove, true);
          u2 > 1 ? y2.initiated = true : r3 && (y2.initiated = false), t3 && y2.initiated && !a2 && l4.cancelable !== false && l4.preventDefault(), l4.type === "touchstart" ? (y2.pinchDown = n4, y2.res = true, i5.mouseDownX = l4.chartX) : r3 ? this.runPointActions(y2.normalize(l4)) : e5 && (C3(i5, "touchpan", { originalEvent: l4, touches: n4 }, () => {
            let A3 = (N2) => {
              let k3 = N2[0], E2 = N2[1] || k3;
              return { x: k3.chartX, y: k3.chartY, width: E2.chartX - k3.chartX, height: E2.chartY - k3.chartY };
            };
            i5.transform({ axes: i5.axes.filter((N2) => N2.zoomEnabled && (this.zoomHor && N2.horiz || this.zoomVert && !N2.horiz)), to: A3(n4), from: A3(e5), trigger: l4.type });
          }), y2.res && (y2.res = false, this.reset(false, 0))), y2.lastTouches = n4;
        }
        reset(l4, y2) {
          let i5 = this.chart, t3 = i5.hoverSeries, e5 = i5.hoverPoint, n4 = i5.hoverPoints, u2 = i5.tooltip, a2 = u2 && u2.shared ? n4 : e5;
          l4 && a2 && I3(a2).forEach(function(g2) {
            g2.series.isCartesian && g2.plotX === void 0 && (l4 = false);
          }), l4 ? u2 && a2 && I3(a2).length && (u2.refresh(a2), u2.shared && n4 ? n4.forEach(function(g2) {
            g2.setState(g2.state, true), g2.series.isCartesian && (g2.series.xAxis.crosshair && g2.series.xAxis.drawCrosshair(null, g2), g2.series.yAxis.crosshair && g2.series.yAxis.drawCrosshair(null, g2));
          }) : e5 && (e5.setState(e5.state, true), i5.axes.forEach(function(g2) {
            g2.crosshair && e5.series[g2.coll] === g2 && g2.drawCrosshair(null, e5);
          }))) : (e5 && e5.onMouseOut(), n4 && n4.forEach(function(g2) {
            g2.setState();
          }), t3 && t3.onMouseOut(), u2 && u2.hide(y2), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), i5.axes.forEach(function(g2) {
            g2.hideCrosshair();
          }), i5.hoverPoints = i5.hoverPoint = void 0);
        }
        runPointActions(l4, y2, i5) {
          let t3 = this.chart, e5 = t3.series, n4 = t3.tooltip && t3.tooltip.options.enabled ? t3.tooltip : void 0, u2 = !!n4 && n4.shared, a2 = y2 || t3.hoverPoint, g2 = a2 && a2.series || t3.hoverSeries, r3 = (!l4 || l4.type !== "touchmove") && (!!y2 || g2 && g2.directTouch && this.isDirectTouch), A3 = this.getHoverData(a2, g2, e5, r3, u2, l4);
          a2 = A3.hoverPoint, g2 = A3.hoverSeries;
          let N2 = A3.hoverPoints, k3 = g2 && g2.tooltipOptions.followPointer && !g2.tooltipOptions.split, E2 = u2 && g2 && !g2.noSharedTooltip;
          if (a2 && (i5 || a2 !== t3.hoverPoint || n4 && n4.isHidden)) {
            if ((t3.hoverPoints || []).forEach(function(R2) {
              N2.indexOf(R2) === -1 && R2.setState();
            }), t3.hoverSeries !== g2 && g2.onMouseOver(), this.applyInactiveState(N2), (N2 || []).forEach(function(R2) {
              R2.setState("hover");
            }), t3.hoverPoint && t3.hoverPoint.firePointEvent("mouseOut"), !a2.series) return;
            t3.hoverPoints = N2, t3.hoverPoint = a2, a2.firePointEvent("mouseOver", void 0, () => {
              n4 && a2 && n4.refresh(E2 ? N2 : a2, l4);
            });
          } else if (k3 && n4 && !n4.isHidden) {
            let R2 = n4.getAnchor([{}], l4);
            t3.isInsidePlot(R2[0], R2[1], { visiblePlotOnly: true }) && n4.updatePosition({ plotX: R2[0], plotY: R2[1] });
          }
          this.unDocMouseMove || (this.unDocMouseMove = O3(t3.container.ownerDocument, "mousemove", (R2) => {
            var z2, Q2, v3;
            return (v3 = (Q2 = tt2[(z2 = G2.hoverChartIndex) != null ? z2 : -1]) == null ? void 0 : Q2.pointer) == null ? void 0 : v3.onDocumentMouseMove(R2);
          }), this.eventsToUnbind.push(this.unDocMouseMove)), t3.axes.forEach(function(R2) {
            let z2, Q2 = c4((R2.crosshair || {}).snap, true);
            !Q2 || (z2 = t3.hoverPoint) && z2.series[R2.coll] === R2 || (z2 = f2(N2, (v3) => v3.series && v3.series[R2.coll] === R2)), z2 || !Q2 ? R2.drawCrosshair(l4, z2) : R2.hideCrosshair();
          });
        }
        setDOMEvents() {
          let l4 = this.chart.container, y2 = l4.ownerDocument;
          l4.onmousedown = this.onContainerMouseDown.bind(this), l4.onmousemove = this.onContainerMouseMove.bind(this), l4.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(O3(l4, "mouseenter", this.onContainerMouseEnter.bind(this)), O3(l4, "mouseleave", this.onContainerMouseLeave.bind(this))), G2.unbindDocumentMouseUp || (G2.unbindDocumentMouseUp = []), G2.unbindDocumentMouseUp.push(O3(y2, "mouseup", this.onDocumentMouseUp.bind(this)));
          let i5 = this.chart.renderTo.parentElement;
          for (; i5 && i5.tagName !== "BODY"; ) this.eventsToUnbind.push(O3(i5, "scroll", () => {
            delete this.chartPosition;
          })), i5 = i5.parentElement;
          this.eventsToUnbind.push(O3(l4, "touchstart", this.onContainerTouchStart.bind(this), { passive: false }), O3(l4, "touchmove", this.onContainerTouchMove.bind(this), { passive: false })), G2.unbindDocumentTouchEnd || (G2.unbindDocumentTouchEnd = O3(y2, "touchend", this.onDocumentTouchEnd.bind(this), { passive: false })), this.setPointerCapture(), O3(this.chart, "redraw", this.setPointerCapture.bind(this));
        }
        setPointerCapture() {
          var l4, y2;
          if (!X2) return;
          let i5 = this.pointerCaptureEventsToUnbind, t3 = this.chart, e5 = t3.container, n4 = c4((l4 = t3.options.tooltip) == null ? void 0 : l4.followTouchMove, true) && t3.series.some((u2) => u2.options.findNearestPointBy.indexOf("y") > -1);
          !this.hasPointerCapture && n4 ? (i5.push(O3(e5, "pointerdown", (u2) => {
            var a2, g2;
            (a2 = u2.target) != null && a2.hasPointerCapture(u2.pointerId) && ((g2 = u2.target) == null || g2.releasePointerCapture(u2.pointerId));
          }), O3(e5, "pointermove", (u2) => {
            var a2, g2;
            (g2 = (a2 = t3.pointer) == null ? void 0 : a2.getPointFromEvent(u2)) == null || g2.onMouseOver(u2);
          })), t3.styledMode || d3(e5, { "touch-action": "none" }), e5.className += " highcharts-no-touch-action", this.hasPointerCapture = true) : this.hasPointerCapture && !n4 && (i5.forEach((u2) => u2()), i5.length = 0, t3.styledMode || d3(e5, { "touch-action": c4((y2 = t3.options.chart.style) == null ? void 0 : y2["touch-action"], "manipulation") }), e5.className = e5.className.replace(" highcharts-no-touch-action", ""), this.hasPointerCapture = false);
        }
        setHoverChartIndex(l4) {
          var y2;
          let i5 = this.chart, t3 = K2.charts[c4(G2.hoverChartIndex, -1)];
          if (t3 && t3 !== i5) {
            let e5 = { relatedTarget: i5.container };
            l4 && !(l4 != null && l4.relatedTarget) && (l4 = { ...e5, ...l4 }), (y2 = t3.pointer) == null || y2.onContainerMouseLeave(l4 || e5);
          }
          t3 && t3.mouseIsDown || (G2.hoverChartIndex = i5.index);
        }
        touch(l4, y2) {
          let i5, { chart: t3, pinchDown: e5 = [] } = this;
          this.setHoverChartIndex(), (l4 = this.normalize(l4)).touches.length === 1 ? t3.isInsidePlot(l4.chartX - t3.plotLeft, l4.chartY - t3.plotTop, { visiblePlotOnly: true }) && !t3.openMenu ? (y2 && this.runPointActions(l4), l4.type === "touchmove" && (i5 = !!e5[0] && Math.pow(e5[0].chartX - l4.chartX, 2) + Math.pow(e5[0].chartY - l4.chartY, 2) >= 16), c4(i5, true) && this.pinch(l4)) : y2 && this.reset() : l4.touches.length === 2 && this.pinch(l4);
        }
        touchSelect(l4) {
          return !!(this.chart.zooming.singleTouch && l4.touches && l4.touches.length === 1);
        }
        zoomOption(l4) {
          let y2 = this.chart, i5 = y2.inverted, t3 = y2.zooming.type || "", e5, n4;
          /touch/.test(l4.type) && (t3 = c4(y2.zooming.pinchType, t3)), this.zoomX = e5 = /x/.test(t3), this.zoomY = n4 = /y/.test(t3), this.zoomHor = e5 && !i5 || n4 && i5, this.zoomVert = n4 && !i5 || e5 && i5, this.hasZoom = e5 || n4;
        }
      }
      return (it2 = G2).compose = function(L2) {
        T2(Z2, "Core.Pointer") && O3(L2, "beforeRender", function() {
          this.pointer = new it2(this, this.options);
        });
      }, G2;
    }), at2(s2, "Core/Legend/LegendSymbol.js", [s2["Core/Utilities.js"]], function(B3) {
      var K2;
      let { extend: q2, merge: it2, pick: rt2 } = B3;
      return function(tt2) {
        function Z2(X2, O3, j3) {
          var d3, x2;
          let f2 = this.legendItem = this.legendItem || {}, { chart: C3, options: o2 } = this, { baseline: p2 = 0, symbolWidth: b5, symbolHeight: h2 } = X2, c4 = this.symbol || "circle", T2 = h2 / 2, I3 = C3.renderer, G2 = f2.group, L2 = p2 - Math.round((((d3 = X2.fontMetrics) == null ? void 0 : d3.b) || h2) * (j3 ? 0.4 : 0.3)), l4 = {}, y2, i5 = o2.marker, t3 = 0;
          if (C3.styledMode || (l4["stroke-width"] = Math.min(o2.lineWidth || 0, 24), o2.dashStyle ? l4.dashstyle = o2.dashStyle : o2.linecap === "square" || (l4["stroke-linecap"] = "round")), f2.line = I3.path().addClass("highcharts-graph").attr(l4).add(G2), j3 && (f2.area = I3.path().addClass("highcharts-area").add(G2)), l4["stroke-linecap"] && (t3 = Math.min(f2.line.strokeWidth(), b5) / 2), b5) {
            let e5 = [["M", t3, L2], ["L", b5 - t3, L2]];
            f2.line.attr({ d: e5 }), (x2 = f2.area) == null || x2.attr({ d: [...e5, ["L", b5 - t3, p2], ["L", t3, p2]] });
          }
          if (i5 && i5.enabled !== false && b5) {
            let e5 = Math.min(rt2(i5.radius, T2), T2);
            c4.indexOf("url") === 0 && (i5 = it2(i5, { width: h2, height: h2 }), e5 = 0), f2.symbol = y2 = I3.symbol(c4, b5 / 2 - e5, L2 - e5, 2 * e5, 2 * e5, q2({ context: "legend" }, i5)).addClass("highcharts-point").add(G2), y2.isMarker = true;
          }
        }
        tt2.areaMarker = function(X2, O3) {
          Z2.call(this, X2, O3, true);
        }, tt2.lineMarker = Z2, tt2.rectangle = function(X2, O3) {
          let j3 = O3.legendItem || {}, d3 = X2.options, x2 = X2.symbolHeight, f2 = d3.squareSymbol, C3 = f2 ? x2 : X2.symbolWidth;
          j3.symbol = this.chart.renderer.rect(f2 ? (X2.symbolWidth - x2) / 2 : 0, X2.baseline - x2 + 1, C3, x2, rt2(X2.options.symbolRadius, x2 / 2)).addClass("highcharts-point").attr({ zIndex: 3 }).add(j3.group);
        };
      }(K2 || (K2 = {})), K2;
    }), at2(s2, "Core/Series/SeriesDefaults.js", [], function() {
      return { lineWidth: 2, allowPointSelect: false, crisp: true, showCheckbox: false, animation: { duration: 1e3 }, enableMouseTracking: true, events: {}, marker: { enabledThreshold: 2, lineColor: "#ffffff", lineWidth: 0, radius: 4, states: { normal: { animation: true }, hover: { animation: { duration: 150 }, enabled: true, radiusPlus: 2, lineWidthPlus: 1 }, select: { fillColor: "#cccccc", lineColor: "#000000", lineWidth: 2 } } }, point: { events: {} }, dataLabels: { animation: {}, align: "center", borderWidth: 0, defer: true, formatter: function() {
        let { numberFormatter: B3 } = this.series.chart;
        return typeof this.y != "number" ? "" : B3(this.y, -1);
      }, padding: 5, style: { fontSize: "0.7em", fontWeight: "bold", color: "contrast", textOutline: "1px contrast" }, verticalAlign: "bottom", x: 0, y: 0 }, cropThreshold: 300, opacity: 1, pointRange: 0, softThreshold: true, states: { normal: { animation: true }, hover: { animation: { duration: 150 }, lineWidthPlus: 1, marker: {}, halo: { size: 10, opacity: 0.25 } }, select: { animation: { duration: 0 } }, inactive: { animation: { duration: 150 }, opacity: 0.2 } }, stickyTracking: true, turboThreshold: 1e3, findNearestPointBy: "x" };
    }), at2(s2, "Core/Series/SeriesRegistry.js", [s2["Core/Globals.js"], s2["Core/Defaults.js"], s2["Core/Series/Point.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2) {
      var rt2;
      let { defaultOptions: tt2 } = K2, { extend: Z2, extendClass: X2, merge: O3 } = it2;
      return function(j3) {
        function d3(x2, f2) {
          let C3 = tt2.plotOptions || {}, o2 = f2.defaultOptions, p2 = f2.prototype;
          return p2.type = x2, p2.pointClass || (p2.pointClass = q2), !j3.seriesTypes[x2] && (o2 && (C3[x2] = o2), j3.seriesTypes[x2] = f2, true);
        }
        j3.seriesTypes = B3.seriesTypes, j3.registerSeriesType = d3, j3.seriesType = function(x2, f2, C3, o2, p2) {
          let b5 = tt2.plotOptions || {};
          if (f2 = f2 || "", b5[x2] = O3(b5[f2], C3), delete j3.seriesTypes[x2], d3(x2, X2(j3.seriesTypes[f2] || function() {
          }, o2)), j3.seriesTypes[x2].prototype.type = x2, p2) {
            class h2 extends q2 {
            }
            Z2(h2.prototype, p2), j3.seriesTypes[x2].prototype.pointClass = h2;
          }
          return j3.seriesTypes[x2];
        };
      }(rt2 || (rt2 = {})), rt2;
    }), at2(s2, "Core/Series/Series.js", [s2["Core/Animation/AnimationUtilities.js"], s2["Core/Defaults.js"], s2["Core/Foundation.js"], s2["Core/Globals.js"], s2["Core/Legend/LegendSymbol.js"], s2["Core/Series/Point.js"], s2["Core/Series/SeriesDefaults.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Renderer/SVG/SVGElement.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2, O3, j3) {
      let { animObject: d3, setAnimation: x2 } = B3, { defaultOptions: f2 } = K2, { registerEventOptions: C3 } = q2, { svg: o2, win: p2 } = it2, { seriesTypes: b5 } = X2, { arrayMax: h2, arrayMin: c4, clamp: T2, correctFloat: I3, crisp: G2, defined: L2, destroyObjectProperties: l4, diffObjects: y2, erase: i5, error: t3, extend: e5, find: n4, fireEvent: u2, getClosestDistance: a2, getNestedProperty: g2, insertItem: r3, isArray: A3, isNumber: N2, isString: k3, merge: E2, objectEach: R2, pick: z2, removeEvent: Q2, splat: v3, syncTimeout: S2 } = j3;
      class P2 {
        constructor() {
          this.zoneAxis = "y";
        }
        init(w2, M2) {
          let D2;
          u2(this, "init", { options: M2 });
          let F2 = this, $2 = w2.series;
          this.eventsToUnbind = [], F2.chart = w2, F2.options = F2.setOptions(M2);
          let W2 = F2.options, V2 = W2.visible !== false;
          F2.linkedSeries = [], F2.bindAxes(), e5(F2, { name: W2.name, state: "", visible: V2, selected: W2.selected === true }), C3(this, W2);
          let _2 = W2.events;
          (_2 && _2.click || W2.point && W2.point.events && W2.point.events.click || W2.allowPointSelect) && (w2.runTrackerClick = true), F2.getColor(), F2.getSymbol(), F2.parallelArrays.forEach(function(et2) {
            F2[et2 + "Data"] || (F2[et2 + "Data"] = []);
          }), F2.isCartesian && (w2.hasCartesianSeries = true), $2.length && (D2 = $2[$2.length - 1]), F2._i = z2(D2 && D2._i, -1) + 1, F2.opacity = F2.options.opacity, w2.orderItems("series", r3(this, $2)), W2.dataSorting && W2.dataSorting.enabled ? F2.setDataSortingOptions() : F2.points || F2.data || F2.setData(W2.data, false), u2(this, "afterInit");
        }
        is(w2) {
          return b5[w2] && this instanceof b5[w2];
        }
        bindAxes() {
          let w2, M2 = this, D2 = M2.options, F2 = M2.chart;
          u2(this, "bindAxes", null, function() {
            (M2.axisTypes || []).forEach(function($2) {
              (F2[$2] || []).forEach(function(W2) {
                w2 = W2.options, (z2(D2[$2], 0) === W2.index || D2[$2] !== void 0 && D2[$2] === w2.id) && (r3(M2, W2.series), M2[$2] = W2, W2.isDirty = true);
              }), M2[$2] || M2.optionalAxis === $2 || t3(18, true, F2);
            });
          }), u2(this, "afterBindAxes");
        }
        updateParallelArrays(w2, M2, D2) {
          let F2 = w2.series, $2 = N2(M2) ? function(W2) {
            let V2 = W2 === "y" && F2.toYData ? F2.toYData(w2) : w2[W2];
            F2[W2 + "Data"][M2] = V2;
          } : function(W2) {
            Array.prototype[M2].apply(F2[W2 + "Data"], D2);
          };
          F2.parallelArrays.forEach($2);
        }
        hasData() {
          return this.visible && this.dataMax !== void 0 && this.dataMin !== void 0 || this.visible && this.yData && this.yData.length > 0;
        }
        hasMarkerChanged(w2, M2) {
          let D2 = w2.marker, F2 = M2.marker || {};
          return D2 && (F2.enabled && !D2.enabled || F2.symbol !== D2.symbol || F2.height !== D2.height || F2.width !== D2.width);
        }
        autoIncrement(w2) {
          let M2 = this.options, D2 = M2.pointIntervalUnit, F2 = M2.relativeXValue, $2 = this.chart.time, W2 = this.xIncrement, V2, _2;
          return W2 = z2(W2, M2.pointStart, 0), this.pointInterval = _2 = z2(this.pointInterval, M2.pointInterval, 1), F2 && N2(w2) && (_2 *= w2), D2 && (V2 = new $2.Date(W2), D2 === "day" ? $2.set("Date", V2, $2.get("Date", V2) + _2) : D2 === "month" ? $2.set("Month", V2, $2.get("Month", V2) + _2) : D2 === "year" && $2.set("FullYear", V2, $2.get("FullYear", V2) + _2), _2 = V2.getTime() - W2), F2 && N2(w2) ? W2 + _2 : (this.xIncrement = W2 + _2, W2);
        }
        setDataSortingOptions() {
          let w2 = this.options;
          e5(this, { requireSorting: false, sorted: false, enabledDataSorting: true, allowDG: false }), L2(w2.pointRange) || (w2.pointRange = 1);
        }
        setOptions(w2) {
          var M2, D2;
          let F2, $2 = this.chart, W2 = $2.options.plotOptions, V2 = $2.userOptions || {}, _2 = E2(w2), et2 = $2.styledMode, lt2 = { plotOptions: W2, userOptions: _2 };
          u2(this, "setOptions", lt2);
          let ht2 = lt2.plotOptions[this.type], J2 = V2.plotOptions || {}, Y2 = J2.series || {}, st2 = f2.plotOptions[this.type] || {}, nt2 = J2[this.type] || {};
          this.userOptions = lt2.userOptions;
          let ot2 = E2(ht2, W2.series, nt2, _2);
          this.tooltipOptions = E2(f2.tooltip, (M2 = f2.plotOptions.series) == null ? void 0 : M2.tooltip, st2 == null ? void 0 : st2.tooltip, $2.userOptions.tooltip, (D2 = J2.series) == null ? void 0 : D2.tooltip, nt2.tooltip, _2.tooltip), this.stickyTracking = z2(_2.stickyTracking, nt2.stickyTracking, Y2.stickyTracking, !!this.tooltipOptions.shared && !this.noSharedTooltip || ot2.stickyTracking), ht2.marker === null && delete ot2.marker, this.zoneAxis = ot2.zoneAxis || "y";
          let ut2 = this.zones = (ot2.zones || []).map((dt2) => ({ ...dt2 }));
          return (ot2.negativeColor || ot2.negativeFillColor) && !ot2.zones && (F2 = { value: ot2[this.zoneAxis + "Threshold"] || ot2.threshold || 0, className: "highcharts-negative" }, et2 || (F2.color = ot2.negativeColor, F2.fillColor = ot2.negativeFillColor), ut2.push(F2)), ut2.length && L2(ut2[ut2.length - 1].value) && ut2.push(et2 ? {} : { color: this.color, fillColor: this.fillColor }), u2(this, "afterSetOptions", { options: ot2 }), ot2;
        }
        getName() {
          return z2(this.options.name, "Series " + (this.index + 1));
        }
        getCyclic(w2, M2, D2) {
          let F2, $2, W2 = this.chart, V2 = `${w2}Index`, _2 = `${w2}Counter`, et2 = (D2 == null ? void 0 : D2.length) || W2.options.chart.colorCount;
          !M2 && (L2($2 = z2(w2 === "color" ? this.options.colorIndex : void 0, this[V2])) ? F2 = $2 : (W2.series.length || (W2[_2] = 0), F2 = W2[_2] % et2, W2[_2] += 1), D2 && (M2 = D2[F2])), F2 !== void 0 && (this[V2] = F2), this[w2] = M2;
        }
        getColor() {
          this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || f2.plotOptions[this.type].color, this.chart.options.colors);
        }
        getPointsCollection() {
          return (this.hasGroupedData ? this.points : this.data) || [];
        }
        getSymbol() {
          let w2 = this.options.marker;
          this.getCyclic("symbol", w2.symbol, this.chart.options.symbols);
        }
        findPointIndex(w2, M2) {
          let D2, F2, $2, W2 = w2.id, V2 = w2.x, _2 = this.points, et2 = this.options.dataSorting;
          if (W2) {
            let lt2 = this.chart.get(W2);
            lt2 instanceof tt2 && (D2 = lt2);
          } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
            let lt2 = (ht2) => !ht2.touched && ht2.index === w2.index;
            if (et2 && et2.matchByName ? lt2 = (ht2) => !ht2.touched && ht2.name === w2.name : this.options.relativeXValue && (lt2 = (ht2) => !ht2.touched && ht2.options.x === w2.x), !(D2 = n4(_2, lt2))) return;
          }
          return D2 && ($2 = D2 && D2.index) !== void 0 && (F2 = true), $2 === void 0 && N2(V2) && ($2 = this.xData.indexOf(V2, M2)), $2 !== -1 && $2 !== void 0 && this.cropped && ($2 = $2 >= this.cropStart ? $2 - this.cropStart : $2), !F2 && N2($2) && _2[$2] && _2[$2].touched && ($2 = void 0), $2;
        }
        updateData(w2, M2) {
          let D2 = this.options, F2 = D2.dataSorting, $2 = this.points, W2 = [], V2 = this.requireSorting, _2 = w2.length === $2.length, et2, lt2, ht2, J2, Y2 = true;
          if (this.xIncrement = null, w2.forEach(function(st2, nt2) {
            let ot2, ut2 = L2(st2) && this.pointClass.prototype.optionsToObject.call({ series: this }, st2) || {}, dt2 = ut2.x;
            ut2.id || N2(dt2) ? ((ot2 = this.findPointIndex(ut2, J2)) === -1 || ot2 === void 0 ? W2.push(st2) : $2[ot2] && st2 !== D2.data[ot2] ? ($2[ot2].update(st2, false, null, false), $2[ot2].touched = true, V2 && (J2 = ot2 + 1)) : $2[ot2] && ($2[ot2].touched = true), (!_2 || nt2 !== ot2 || F2 && F2.enabled || this.hasDerivedData) && (et2 = true)) : W2.push(st2);
          }, this), et2) for (lt2 = $2.length; lt2--; ) (ht2 = $2[lt2]) && !ht2.touched && ht2.remove && ht2.remove(false, M2);
          else !_2 || F2 && F2.enabled ? Y2 = false : (w2.forEach(function(st2, nt2) {
            st2 === $2[nt2].y || $2[nt2].destroyed || $2[nt2].update(st2, false, null, false);
          }), W2.length = 0);
          return $2.forEach(function(st2) {
            st2 && (st2.touched = false);
          }), !!Y2 && (W2.forEach(function(st2) {
            this.addPoint(st2, false, null, null, false);
          }, this), this.xIncrement === null && this.xData && this.xData.length && (this.xIncrement = h2(this.xData), this.autoIncrement()), true);
        }
        setData(w2, M2 = true, D2, F2) {
          var $2;
          let W2 = this, V2 = W2.points, _2 = V2 && V2.length || 0, et2 = W2.options, lt2 = W2.chart, ht2 = et2.dataSorting, J2 = W2.xAxis, Y2 = et2.turboThreshold, st2 = this.xData, nt2 = this.yData, ot2 = W2.pointArrayMap, ut2 = ot2 && ot2.length, dt2 = et2.keys, ct2, gt2, ft2, pt2 = 0, mt2 = 1, yt2;
          lt2.options.chart.allowMutatingData || (et2.data && delete W2.options.data, W2.userOptions.data && delete W2.userOptions.data, yt2 = E2(true, w2));
          let vt2 = (w2 = yt2 || w2 || []).length;
          if (ht2 && ht2.enabled && (w2 = this.sortData(w2)), lt2.options.chart.allowMutatingData && F2 !== false && vt2 && _2 && !W2.cropped && !W2.hasGroupedData && W2.visible && !W2.boosted && (ft2 = this.updateData(w2, D2)), !ft2) {
            W2.xIncrement = null, W2.colorCounter = 0, this.parallelArrays.forEach(function(xt2) {
              W2[xt2 + "Data"].length = 0;
            });
            let bt2 = Y2 && vt2 > Y2;
            if (bt2) {
              let xt2 = W2.getFirstValidPoint(w2), Ct2 = W2.getFirstValidPoint(w2, vt2 - 1, -1), wt2 = (kt2) => !!(A3(kt2) && (dt2 || N2(kt2[0])));
              if (N2(xt2) && N2(Ct2)) for (ct2 = 0; ct2 < vt2; ct2++) st2[ct2] = this.autoIncrement(), nt2[ct2] = w2[ct2];
              else if (wt2(xt2) && wt2(Ct2))
                if (ut2)
                  if (xt2.length === ut2) for (ct2 = 0; ct2 < vt2; ct2++) st2[ct2] = this.autoIncrement(), nt2[ct2] = w2[ct2];
                  else for (ct2 = 0; ct2 < vt2; ct2++) gt2 = w2[ct2], st2[ct2] = gt2[0], nt2[ct2] = gt2.slice(1, ut2 + 1);
                else if (dt2 && (pt2 = dt2.indexOf("x"), mt2 = dt2.indexOf("y"), pt2 = pt2 >= 0 ? pt2 : 0, mt2 = mt2 >= 0 ? mt2 : 1), xt2.length === 1 && (mt2 = 0), pt2 === mt2) for (ct2 = 0; ct2 < vt2; ct2++) st2[ct2] = this.autoIncrement(), nt2[ct2] = w2[ct2][mt2];
                else for (ct2 = 0; ct2 < vt2; ct2++) gt2 = w2[ct2], st2[ct2] = gt2[pt2], nt2[ct2] = gt2[mt2];
              else bt2 = false;
            }
            if (!bt2) for (ct2 = 0; ct2 < vt2; ct2++) gt2 = { series: W2 }, W2.pointClass.prototype.applyOptions.apply(gt2, [w2[ct2]]), W2.updateParallelArrays(gt2, ct2);
            for (nt2 && k3(nt2[0]) && t3(14, true, lt2), W2.data = [], W2.options.data = W2.userOptions.data = w2, ct2 = _2; ct2--; ) ($2 = V2[ct2]) == null || $2.destroy();
            J2 && (J2.minRange = J2.userMinRange), W2.isDirty = lt2.isDirtyBox = true, W2.isDirtyData = !!V2, D2 = false;
          }
          et2.legendType === "point" && (this.processData(), this.generatePoints()), M2 && lt2.redraw(D2);
        }
        sortData(w2) {
          let M2 = this, D2 = M2.options.dataSorting.sortKey || "y", F2 = function($2, W2) {
            return L2(W2) && $2.pointClass.prototype.optionsToObject.call({ series: $2 }, W2) || {};
          };
          return w2.forEach(function($2, W2) {
            w2[W2] = F2(M2, $2), w2[W2].index = W2;
          }, this), w2.concat().sort(($2, W2) => {
            let V2 = g2(D2, $2), _2 = g2(D2, W2);
            return _2 < V2 ? -1 : _2 > V2 ? 1 : 0;
          }).forEach(function($2, W2) {
            $2.x = W2;
          }, this), M2.linkedSeries && M2.linkedSeries.forEach(function($2) {
            let W2 = $2.options, V2 = W2.data;
            W2.dataSorting && W2.dataSorting.enabled || !V2 || (V2.forEach(function(_2, et2) {
              V2[et2] = F2($2, _2), w2[et2] && (V2[et2].x = w2[et2].x, V2[et2].index = et2);
            }), $2.setData(V2, false));
          }), w2;
        }
        getProcessedData(w2) {
          let M2 = this, D2 = M2.xAxis, F2 = M2.options.cropThreshold, $2 = D2 == null ? void 0 : D2.logarithmic, W2 = M2.isCartesian, V2, _2, et2 = 0, lt2, ht2, J2, Y2 = M2.xData, st2 = M2.yData, nt2 = false, ot2 = Y2.length;
          D2 && (ht2 = (lt2 = D2.getExtremes()).min, J2 = lt2.max, nt2 = !!(D2.categories && !D2.names.length)), W2 && M2.sorted && !w2 && (!F2 || ot2 > F2 || M2.forceCrop) && (Y2[ot2 - 1] < ht2 || Y2[0] > J2 ? (Y2 = [], st2 = []) : M2.yData && (Y2[0] < ht2 || Y2[ot2 - 1] > J2) && (Y2 = (V2 = this.cropData(M2.xData, M2.yData, ht2, J2)).xData, st2 = V2.yData, et2 = V2.start, _2 = true));
          let ut2 = a2([$2 ? Y2.map($2.log2lin) : Y2], () => M2.requireSorting && !nt2 && t3(15, false, M2.chart));
          return { xData: Y2, yData: st2, cropped: _2, cropStart: et2, closestPointRange: ut2 };
        }
        processData(w2) {
          let M2 = this.xAxis;
          if (this.isCartesian && !this.isDirty && !M2.isDirty && !this.yAxis.isDirty && !w2) return false;
          let D2 = this.getProcessedData();
          this.cropped = D2.cropped, this.cropStart = D2.cropStart, this.processedXData = D2.xData, this.processedYData = D2.yData, this.closestPointRange = this.basePointRange = D2.closestPointRange, u2(this, "afterProcessData");
        }
        cropData(w2, M2, D2, F2) {
          let $2 = w2.length, W2, V2, _2 = 0, et2 = $2;
          for (W2 = 0; W2 < $2; W2++) if (w2[W2] >= D2) {
            _2 = Math.max(0, W2 - 1);
            break;
          }
          for (V2 = W2; V2 < $2; V2++) if (w2[V2] > F2) {
            et2 = V2 + 1;
            break;
          }
          return { xData: w2.slice(_2, et2), yData: M2.slice(_2, et2), start: _2, end: et2 };
        }
        generatePoints() {
          let w2 = this.options, M2 = this.processedData || w2.data, D2 = this.processedXData, F2 = this.processedYData, $2 = this.pointClass, W2 = D2.length, V2 = this.cropStart || 0, _2 = this.hasGroupedData, et2 = w2.keys, lt2 = [], ht2 = w2.dataGrouping && w2.dataGrouping.groupAll ? V2 : 0, J2, Y2, st2, nt2, ot2 = this.data;
          if (!ot2 && !_2) {
            let ut2 = [];
            ut2.length = M2.length, ot2 = this.data = ut2;
          }
          for (et2 && _2 && (this.options.keys = false), nt2 = 0; nt2 < W2; nt2++) Y2 = V2 + nt2, _2 ? ((st2 = new $2(this, [D2[nt2]].concat(v3(F2[nt2])))).dataGroup = this.groupMap[ht2 + nt2], st2.dataGroup.options && (st2.options = st2.dataGroup.options, e5(st2, st2.dataGroup.options), delete st2.dataLabels)) : (st2 = ot2[Y2]) || M2[Y2] === void 0 || (ot2[Y2] = st2 = new $2(this, M2[Y2], D2[nt2])), st2 && (st2.index = _2 ? ht2 + nt2 : Y2, lt2[nt2] = st2);
          if (this.options.keys = et2, ot2 && (W2 !== (J2 = ot2.length) || _2)) for (nt2 = 0; nt2 < J2; nt2++) nt2 !== V2 || _2 || (nt2 += W2), ot2[nt2] && (ot2[nt2].destroyElements(), ot2[nt2].plotX = void 0);
          this.data = ot2, this.points = lt2, u2(this, "afterGeneratePoints");
        }
        getXExtremes(w2) {
          return { min: c4(w2), max: h2(w2) };
        }
        getExtremes(w2, M2) {
          let D2 = this.xAxis, F2 = this.yAxis, $2 = [], W2 = this.requireSorting && !this.is("column") ? 1 : 0, V2 = !!F2 && F2.positiveValuesOnly, _2 = M2 || this.getExtremesFromAll || this.options.getExtremesFromAll, { processedXData: et2, processedYData: lt2 } = this, ht2, J2, Y2, st2, nt2, ot2, ut2, dt2 = 0, ct2 = 0, gt2 = 0;
          if (this.cropped && _2) {
            let yt2 = this.getProcessedData(true);
            et2 = yt2.xData, lt2 = yt2.yData;
          }
          let ft2 = (w2 = w2 || this.stackedYData || lt2 || []).length, pt2 = et2 || this.xData;
          for (D2 && (dt2 = (ht2 = D2.getExtremes()).min, ct2 = ht2.max), ot2 = 0; ot2 < ft2; ot2++) if (st2 = pt2[ot2], J2 = (N2(nt2 = w2[ot2]) || A3(nt2)) && ((N2(nt2) ? nt2 > 0 : nt2.length) || !V2), Y2 = M2 || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !D2 || (pt2[ot2 + W2] || st2) >= dt2 && (pt2[ot2 - W2] || st2) <= ct2, J2 && Y2)
            if (ut2 = nt2.length) for (; ut2--; ) N2(nt2[ut2]) && ($2[gt2++] = nt2[ut2]);
            else $2[gt2++] = nt2;
          let mt2 = { activeYData: $2, dataMin: c4($2), dataMax: h2($2) };
          return u2(this, "afterGetExtremes", { dataExtremes: mt2 }), mt2;
        }
        applyExtremes() {
          let w2 = this.getExtremes();
          return this.dataMin = w2.dataMin, this.dataMax = w2.dataMax, w2;
        }
        getFirstValidPoint(w2, M2 = 0, D2 = 1) {
          let F2 = w2.length, $2 = M2;
          for (; $2 >= 0 && $2 < F2; ) {
            if (L2(w2[$2])) return w2[$2];
            $2 += D2;
          }
        }
        translate() {
          var w2;
          this.processedXData || this.processData(), this.generatePoints();
          let M2 = this.options, D2 = M2.stacking, F2 = this.xAxis, $2 = F2.categories, W2 = this.enabledDataSorting, V2 = this.yAxis, _2 = this.points, et2 = _2.length, lt2 = this.pointPlacementToXValue(), ht2 = !!lt2, J2 = M2.threshold, Y2 = M2.startFromThreshold ? J2 : 0, st2, nt2, ot2, ut2, dt2 = Number.MAX_VALUE;
          function ct2(gt2) {
            return T2(gt2, -1e9, 1e9);
          }
          for (st2 = 0; st2 < et2; st2++) {
            let gt2, ft2 = _2[st2], pt2 = ft2.x, mt2, yt2, vt2 = ft2.y, bt2 = ft2.low, xt2 = D2 && ((w2 = V2.stacking) == null ? void 0 : w2.stacks[(this.negStacks && vt2 < (Y2 ? 0 : J2) ? "-" : "") + this.stackKey]);
            nt2 = F2.translate(pt2, false, false, false, true, lt2), ft2.plotX = N2(nt2) ? I3(ct2(nt2)) : void 0, D2 && this.visible && xt2 && xt2[pt2] && (ut2 = this.getStackIndicator(ut2, pt2, this.index), !ft2.isNull && ut2.key && (yt2 = (mt2 = xt2[pt2]).points[ut2.key]), mt2 && A3(yt2) && (bt2 = yt2[0], vt2 = yt2[1], bt2 === Y2 && ut2.key === xt2[pt2].base && (bt2 = z2(N2(J2) ? J2 : V2.min)), V2.positiveValuesOnly && L2(bt2) && bt2 <= 0 && (bt2 = void 0), ft2.total = ft2.stackTotal = z2(mt2.total), ft2.percentage = L2(ft2.y) && mt2.total ? ft2.y / mt2.total * 100 : void 0, ft2.stackY = vt2, this.irregularWidths || mt2.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), ft2.yBottom = L2(bt2) ? ct2(V2.translate(bt2, false, true, false, true)) : void 0, this.dataModify && (vt2 = this.dataModify.modifyValue(vt2, st2)), N2(vt2) && ft2.plotX !== void 0 && (gt2 = N2(gt2 = V2.translate(vt2, false, true, false, true)) ? ct2(gt2) : void 0), ft2.plotY = gt2, ft2.isInside = this.isPointInside(ft2), ft2.clientX = ht2 ? I3(F2.translate(pt2, false, false, false, true, lt2)) : nt2, ft2.negative = (ft2.y || 0) < (J2 || 0), ft2.category = z2($2 && $2[ft2.x], ft2.x), ft2.isNull || ft2.visible === false || (ot2 !== void 0 && (dt2 = Math.min(dt2, Math.abs(nt2 - ot2))), ot2 = nt2), ft2.zone = this.zones.length ? ft2.getZone() : void 0, !ft2.graphic && this.group && W2 && (ft2.isNew = true);
          }
          this.closestPointRangePx = dt2, u2(this, "afterTranslate");
        }
        getValidPoints(w2, M2, D2) {
          let F2 = this.chart;
          return (w2 || this.points || []).filter(function($2) {
            let { plotX: W2, plotY: V2 } = $2;
            return !!((D2 || !$2.isNull && N2(V2)) && (!M2 || F2.isInsidePlot(W2, V2, { inverted: F2.inverted }))) && $2.visible !== false;
          });
        }
        getClipBox() {
          let { chart: w2, xAxis: M2, yAxis: D2 } = this, { x: F2, y: $2, width: W2, height: V2 } = E2(w2.clipBox);
          return M2 && M2.len !== w2.plotSizeX && (W2 = M2.len), D2 && D2.len !== w2.plotSizeY && (V2 = D2.len), w2.inverted && !this.invertible && ([W2, V2] = [V2, W2]), { x: F2, y: $2, width: W2, height: V2 };
        }
        getSharedClipKey() {
          return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
        }
        setClip() {
          let { chart: w2, group: M2, markerGroup: D2 } = this, F2 = w2.sharedClips, $2 = w2.renderer, W2 = this.getClipBox(), V2 = this.getSharedClipKey(), _2 = F2[V2];
          _2 ? _2.animate(W2) : F2[V2] = _2 = $2.clipRect(W2), M2 && M2.clip(this.options.clip === false ? void 0 : _2), D2 && D2.clip();
        }
        animate(w2) {
          let { chart: M2, group: D2, markerGroup: F2 } = this, $2 = M2.inverted, W2 = d3(this.options.animation), V2 = [this.getSharedClipKey(), W2.duration, W2.easing, W2.defer].join(","), _2 = M2.sharedClips[V2], et2 = M2.sharedClips[V2 + "m"];
          if (w2 && D2) {
            let lt2 = this.getClipBox();
            if (_2) _2.attr("height", lt2.height);
            else {
              lt2.width = 0, $2 && (lt2.x = M2.plotHeight), _2 = M2.renderer.clipRect(lt2), M2.sharedClips[V2] = _2;
              let ht2 = { x: -99, y: -99, width: $2 ? M2.plotWidth + 199 : 99, height: $2 ? 99 : M2.plotHeight + 199 };
              et2 = M2.renderer.clipRect(ht2), M2.sharedClips[V2 + "m"] = et2;
            }
            D2.clip(_2), F2 == null || F2.clip(et2);
          } else if (_2 && !_2.hasClass("highcharts-animating")) {
            let lt2 = this.getClipBox(), ht2 = W2.step;
            (F2 != null && F2.element.childNodes.length || M2.series.length > 1) && (W2.step = function(J2, Y2) {
              ht2 && ht2.apply(Y2, arguments), Y2.prop === "width" && et2 != null && et2.element && et2.attr($2 ? "height" : "width", J2 + 99);
            }), _2.addClass("highcharts-animating").animate(lt2, W2);
          }
        }
        afterAnimate() {
          this.setClip(), R2(this.chart.sharedClips, (w2, M2, D2) => {
            w2 && !this.chart.container.querySelector(`[clip-path="url(#${w2.id})"]`) && (w2.destroy(), delete D2[M2]);
          }), this.finishedAnimating = true, u2(this, "afterAnimate");
        }
        drawPoints(w2 = this.points) {
          let M2, D2, F2, $2, W2, V2, _2, et2 = this.chart, lt2 = et2.styledMode, { colorAxis: ht2, options: J2 } = this, Y2 = J2.marker, st2 = this[this.specialGroup || "markerGroup"], nt2 = this.xAxis, ot2 = z2(Y2.enabled, !nt2 || !!nt2.isRadial || null, this.closestPointRangePx >= Y2.enabledThreshold * Y2.radius);
          if (Y2.enabled !== false || this._hasPointMarkers) for (M2 = 0; M2 < w2.length; M2++) if ($2 = (F2 = (D2 = w2[M2]).graphic) ? "animate" : "attr", W2 = D2.marker || {}, V2 = !!D2.marker, (ot2 && W2.enabled === void 0 || W2.enabled) && !D2.isNull && D2.visible !== false) {
            let ut2 = z2(W2.symbol, this.symbol, "rect");
            _2 = this.markerAttribs(D2, D2.selected && "select"), this.enabledDataSorting && (D2.startXPos = nt2.reversed ? -(_2.width || 0) : nt2.width);
            let dt2 = D2.isInside !== false;
            if (!F2 && dt2 && ((_2.width || 0) > 0 || D2.hasImage) && (D2.graphic = F2 = et2.renderer.symbol(ut2, _2.x, _2.y, _2.width, _2.height, V2 ? W2 : Y2).add(st2), this.enabledDataSorting && et2.hasRendered && (F2.attr({ x: D2.startXPos }), $2 = "animate")), F2 && $2 === "animate" && F2[dt2 ? "show" : "hide"](dt2).animate(_2), F2) {
              let ct2 = this.pointAttribs(D2, lt2 || !D2.selected ? void 0 : "select");
              lt2 ? ht2 && F2.css({ fill: ct2.fill }) : F2[$2](ct2);
            }
            F2 && F2.addClass(D2.getClassName(), true);
          } else F2 && (D2.graphic = F2.destroy());
        }
        markerAttribs(w2, M2) {
          let D2 = this.options, F2 = D2.marker, $2 = w2.marker || {}, W2 = $2.symbol || F2.symbol, V2 = {}, _2, et2, lt2 = z2($2.radius, F2 && F2.radius);
          M2 && (_2 = F2.states[M2], lt2 = z2((et2 = $2.states && $2.states[M2]) && et2.radius, _2 && _2.radius, lt2 && lt2 + (_2 && _2.radiusPlus || 0))), w2.hasImage = W2 && W2.indexOf("url") === 0, w2.hasImage && (lt2 = 0);
          let ht2 = w2.pos();
          return N2(lt2) && ht2 && (D2.crisp && (ht2[0] = G2(ht2[0], w2.hasImage ? 0 : W2 === "rect" ? (F2 == null ? void 0 : F2.lineWidth) || 0 : 1)), V2.x = ht2[0] - lt2, V2.y = ht2[1] - lt2), lt2 && (V2.width = V2.height = 2 * lt2), V2;
        }
        pointAttribs(w2, M2) {
          let D2 = this.options.marker, F2 = w2 && w2.options, $2 = F2 && F2.marker || {}, W2 = F2 && F2.color, V2 = w2 && w2.color, _2 = w2 && w2.zone && w2.zone.color, et2, lt2, ht2 = this.color, J2, Y2, st2 = z2($2.lineWidth, D2.lineWidth), nt2 = 1;
          return ht2 = W2 || _2 || V2 || ht2, J2 = $2.fillColor || D2.fillColor || ht2, Y2 = $2.lineColor || D2.lineColor || ht2, M2 = M2 || "normal", et2 = D2.states[M2] || {}, st2 = z2((lt2 = $2.states && $2.states[M2] || {}).lineWidth, et2.lineWidth, st2 + z2(lt2.lineWidthPlus, et2.lineWidthPlus, 0)), J2 = lt2.fillColor || et2.fillColor || J2, { stroke: Y2 = lt2.lineColor || et2.lineColor || Y2, "stroke-width": st2, fill: J2, opacity: nt2 = z2(lt2.opacity, et2.opacity, nt2) };
        }
        destroy(w2) {
          let M2, D2, F2, $2 = this, W2 = $2.chart, V2 = /AppleWebKit\/533/.test(p2.navigator.userAgent), _2 = $2.data || [];
          for (u2($2, "destroy", { keepEventsForUpdate: w2 }), this.removeEvents(w2), ($2.axisTypes || []).forEach(function(et2) {
            (F2 = $2[et2]) && F2.series && (i5(F2.series, $2), F2.isDirty = F2.forceRedraw = true);
          }), $2.legendItem && $2.chart.legend.destroyItem($2), M2 = _2.length; M2--; ) (D2 = _2[M2]) && D2.destroy && D2.destroy();
          for (let et2 of $2.zones) l4(et2, void 0, true);
          j3.clearTimeout($2.animationTimeout), R2($2, function(et2, lt2) {
            et2 instanceof O3 && !et2.survive && et2[V2 && lt2 === "group" ? "hide" : "destroy"]();
          }), W2.hoverSeries === $2 && (W2.hoverSeries = void 0), i5(W2.series, $2), W2.orderItems("series"), R2($2, function(et2, lt2) {
            w2 && lt2 === "hcEvents" || delete $2[lt2];
          });
        }
        applyZones() {
          let { area: w2, chart: M2, graph: D2, zones: F2, points: $2, xAxis: W2, yAxis: V2, zoneAxis: _2 } = this, { inverted: et2, renderer: lt2 } = M2, ht2 = this[`${_2}Axis`], { isXAxis: J2, len: Y2 = 0 } = ht2 || {}, st2 = ((D2 == null ? void 0 : D2.strokeWidth()) || 0) / 2 + 1, nt2 = (ot2, ut2 = 0, dt2 = 0) => {
            et2 && (dt2 = Y2 - dt2);
            let { translated: ct2 = 0, lineClip: gt2 } = ot2, ft2 = dt2 - ct2;
            gt2 == null || gt2.push(["L", ut2, Math.abs(ft2) < st2 ? dt2 - st2 * (ft2 <= 0 ? -1 : 1) : ct2]);
          };
          if (F2.length && (D2 || w2) && ht2 && N2(ht2.min)) {
            let ot2 = ht2.getExtremes().max, ut2 = (gt2) => {
              gt2.forEach((ft2, pt2) => {
                (ft2[0] === "M" || ft2[0] === "L") && (gt2[pt2] = [ft2[0], J2 ? Y2 - ft2[1] : ft2[1], J2 ? ft2[2] : Y2 - ft2[2]]);
              });
            };
            if (F2.forEach((gt2) => {
              gt2.lineClip = [], gt2.translated = T2(ht2.toPixels(z2(gt2.value, ot2), true) || 0, 0, Y2);
            }), D2 && !this.showLine && D2.hide(), w2 && w2.hide(), _2 === "y" && $2.length < W2.len) for (let gt2 of $2) {
              let { plotX: ft2, plotY: pt2, zone: mt2 } = gt2, yt2 = mt2 && F2[F2.indexOf(mt2) - 1];
              mt2 && nt2(mt2, ft2, pt2), yt2 && nt2(yt2, ft2, pt2);
            }
            let dt2 = [], ct2 = ht2.toPixels(ht2.getExtremes().min, true);
            F2.forEach((gt2) => {
              var ft2, pt2;
              let mt2 = gt2.lineClip || [], yt2 = Math.round(gt2.translated || 0);
              W2.reversed && mt2.reverse();
              let { clip: vt2, simpleClip: bt2 } = gt2, xt2 = 0, Ct2 = 0, wt2 = W2.len, kt2 = V2.len;
              J2 ? (xt2 = yt2, wt2 = ct2) : (Ct2 = yt2, kt2 = ct2);
              let St2 = [["M", xt2, Ct2], ["L", wt2, Ct2], ["L", wt2, kt2], ["L", xt2, kt2], ["Z"]], Tt2 = [St2[0], ...mt2, St2[1], St2[2], ...dt2, St2[3], St2[4]];
              dt2 = mt2.reverse(), ct2 = yt2, et2 && (ut2(Tt2), w2 && ut2(St2)), vt2 ? (vt2.animate({ d: Tt2 }), bt2 == null || bt2.animate({ d: St2 })) : (vt2 = gt2.clip = lt2.path(Tt2), w2 && (bt2 = gt2.simpleClip = lt2.path(St2))), D2 && ((ft2 = gt2.graph) == null || ft2.clip(vt2)), w2 && ((pt2 = gt2.area) == null || pt2.clip(bt2));
            });
          } else this.visible && (D2 && D2.show(), w2 && w2.show());
        }
        plotGroup(w2, M2, D2, F2, $2) {
          let W2 = this[w2], V2 = !W2, _2 = { visibility: D2, zIndex: F2 || 0.1 };
          return L2(this.opacity) && !this.chart.styledMode && this.state !== "inactive" && (_2.opacity = this.opacity), W2 || (this[w2] = W2 = this.chart.renderer.g().add($2)), W2.addClass("highcharts-" + M2 + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (L2(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (W2.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), true), W2.attr(_2)[V2 ? "attr" : "animate"](this.getPlotBox(M2)), W2;
        }
        getPlotBox(w2) {
          let M2 = this.xAxis, D2 = this.yAxis, F2 = this.chart, $2 = F2.inverted && !F2.polar && M2 && this.invertible && w2 === "series";
          return F2.inverted && (M2 = D2, D2 = this.xAxis), { translateX: M2 ? M2.left : F2.plotLeft, translateY: D2 ? D2.top : F2.plotTop, rotation: $2 ? 90 : 0, rotationOriginX: $2 ? (M2.len - D2.len) / 2 : 0, rotationOriginY: $2 ? (M2.len + D2.len) / 2 : 0, scaleX: $2 ? -1 : 1, scaleY: 1 };
        }
        removeEvents(w2) {
          let { eventsToUnbind: M2 } = this;
          w2 || Q2(this), M2.length && (M2.forEach((D2) => {
            D2();
          }), M2.length = 0);
        }
        render() {
          var w2, M2, D2, F2, $2;
          let W2 = this, { chart: V2, options: _2, hasRendered: et2 } = W2, lt2 = d3(_2.animation), ht2 = W2.visible ? "inherit" : "hidden", J2 = _2.zIndex, Y2 = V2.seriesGroup, st2 = W2.finishedAnimating ? 0 : lt2.duration;
          u2(this, "render"), W2.plotGroup("group", "series", ht2, J2, Y2), W2.markerGroup = W2.plotGroup("markerGroup", "markers", ht2, J2, Y2), _2.clip !== false && W2.setClip(), st2 && ((w2 = W2.animate) == null || w2.call(W2, true)), W2.drawGraph && (W2.drawGraph(), W2.applyZones()), W2.visible && W2.drawPoints(), (M2 = W2.drawDataLabels) == null || M2.call(W2), (D2 = W2.redrawPoints) == null || D2.call(W2), _2.enableMouseTracking && ((F2 = W2.drawTracker) == null || F2.call(W2)), st2 && (($2 = W2.animate) == null || $2.call(W2)), et2 || (st2 && lt2.defer && (st2 += lt2.defer), W2.animationTimeout = S2(() => {
            W2.afterAnimate();
          }, st2 || 0)), W2.isDirty = false, W2.hasRendered = true, u2(W2, "afterRender");
        }
        redraw() {
          let w2 = this.isDirty || this.isDirtyData;
          this.translate(), this.render(), w2 && delete this.kdTree;
        }
        reserveSpace() {
          return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
        }
        searchPoint(w2, M2) {
          let { xAxis: D2, yAxis: F2 } = this, $2 = this.chart.inverted;
          return this.searchKDTree({ clientX: $2 ? D2.len - w2.chartY + D2.pos : w2.chartX - D2.pos, plotY: $2 ? F2.len - w2.chartX + F2.pos : w2.chartY - F2.pos }, M2, w2);
        }
        buildKDTree(w2) {
          this.buildingKdTree = true;
          let M2 = this, D2 = M2.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
          delete M2.kdTree, S2(function() {
            M2.kdTree = function F2($2, W2, V2) {
              let _2, et2, lt2 = $2 == null ? void 0 : $2.length;
              if (lt2) return _2 = M2.kdAxisArray[W2 % V2], $2.sort((ht2, J2) => (ht2[_2] || 0) - (J2[_2] || 0)), { point: $2[et2 = Math.floor(lt2 / 2)], left: F2($2.slice(0, et2), W2 + 1, V2), right: F2($2.slice(et2 + 1), W2 + 1, V2) };
            }(M2.getValidPoints(void 0, !M2.directTouch), D2, D2), M2.buildingKdTree = false;
          }, M2.options.kdNow || (w2 == null ? void 0 : w2.type) === "touchstart" ? 0 : 1);
        }
        searchKDTree(w2, M2, D2) {
          let F2 = this, [$2, W2] = this.kdAxisArray, V2 = M2 ? "distX" : "dist", _2 = (F2.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, et2 = !!F2.isBubble;
          if (this.kdTree || this.buildingKdTree || this.buildKDTree(D2), this.kdTree) return function lt2(ht2, J2, Y2, st2) {
            var nt2;
            let ot2 = J2.point, ut2 = F2.kdAxisArray[Y2 % st2], dt2, ct2, gt2 = ot2;
            (function(yt2, vt2) {
              var bt2;
              let xt2 = yt2[$2], Ct2 = vt2[$2], wt2 = L2(xt2) && L2(Ct2) ? xt2 - Ct2 : null, kt2 = yt2[W2], St2 = vt2[W2], Tt2 = L2(kt2) && L2(St2) ? kt2 - St2 : 0, Et2 = et2 && ((bt2 = vt2.marker) == null ? void 0 : bt2.radius) || 0;
              vt2.dist = Math.sqrt((wt2 && wt2 * wt2 || 0) + Tt2 * Tt2) - Et2, vt2.distX = L2(wt2) ? Math.abs(wt2) - Et2 : Number.MAX_VALUE;
            })(ht2, ot2);
            let ft2 = (ht2[ut2] || 0) - (ot2[ut2] || 0) + (et2 && ((nt2 = ot2.marker) == null ? void 0 : nt2.radius) || 0), pt2 = ft2 < 0 ? "left" : "right", mt2 = ft2 < 0 ? "right" : "left";
            return J2[pt2] && (gt2 = (dt2 = lt2(ht2, J2[pt2], Y2 + 1, st2))[V2] < gt2[V2] ? dt2 : ot2), J2[mt2] && Math.sqrt(ft2 * ft2) < gt2[V2] && (gt2 = (ct2 = lt2(ht2, J2[mt2], Y2 + 1, st2))[V2] < gt2[V2] ? ct2 : gt2), gt2;
          }(w2, this.kdTree, _2, _2);
        }
        pointPlacementToXValue() {
          let { options: w2, xAxis: M2 } = this, D2 = w2.pointPlacement;
          return D2 === "between" && (D2 = M2.reversed ? -0.5 : 0.5), N2(D2) ? D2 * (w2.pointRange || M2.pointRange) : 0;
        }
        isPointInside(w2) {
          let { chart: M2, xAxis: D2, yAxis: F2 } = this, { plotX: $2 = -1, plotY: W2 = -1 } = w2;
          return W2 >= 0 && W2 <= (F2 ? F2.len : M2.plotHeight) && $2 >= 0 && $2 <= (D2 ? D2.len : M2.plotWidth);
        }
        drawTracker() {
          var w2;
          let M2 = this, D2 = M2.options, F2 = D2.trackByArea, $2 = [].concat((F2 ? M2.areaPath : M2.graphPath) || []), W2 = M2.chart, V2 = W2.pointer, _2 = W2.renderer, et2 = ((w2 = W2.options.tooltip) == null ? void 0 : w2.snap) || 0, lt2 = () => {
            D2.enableMouseTracking && W2.hoverSeries !== M2 && M2.onMouseOver();
          }, ht2 = "rgba(192,192,192," + (o2 ? 1e-4 : 2e-3) + ")", J2 = M2.tracker;
          J2 ? J2.attr({ d: $2 }) : M2.graph && (M2.tracker = J2 = _2.path($2).attr({ visibility: M2.visible ? "inherit" : "hidden", zIndex: 2 }).addClass(F2 ? "highcharts-tracker-area" : "highcharts-tracker-line").add(M2.group), W2.styledMode || J2.attr({ "stroke-linecap": "round", "stroke-linejoin": "round", stroke: ht2, fill: F2 ? ht2 : "none", "stroke-width": M2.graph.strokeWidth() + (F2 ? 0 : 2 * et2) }), [M2.tracker, M2.markerGroup, M2.dataLabelsGroup].forEach((Y2) => {
            Y2 && (Y2.addClass("highcharts-tracker").on("mouseover", lt2).on("mouseout", (st2) => {
              V2 == null || V2.onTrackerMouseOut(st2);
            }), D2.cursor && !W2.styledMode && Y2.css({ cursor: D2.cursor }), Y2.on("touchstart", lt2));
          })), u2(this, "afterDrawTracker");
        }
        addPoint(w2, M2, D2, F2, $2) {
          let W2, V2, _2 = this.options, et2 = this.data, lt2 = this.chart, ht2 = this.xAxis, J2 = ht2 && ht2.hasNames && ht2.names, Y2 = _2.data, st2 = this.xData;
          M2 = z2(M2, true);
          let nt2 = { series: this };
          this.pointClass.prototype.applyOptions.apply(nt2, [w2]);
          let ot2 = nt2.x;
          if (V2 = st2.length, this.requireSorting && ot2 < st2[V2 - 1]) for (W2 = true; V2 && st2[V2 - 1] > ot2; ) V2--;
          this.updateParallelArrays(nt2, "splice", [V2, 0, 0]), this.updateParallelArrays(nt2, V2), J2 && nt2.name && (J2[ot2] = nt2.name), Y2.splice(V2, 0, w2), (W2 || this.processedData) && (this.data.splice(V2, 0, null), this.processData()), _2.legendType === "point" && this.generatePoints(), D2 && (et2[0] && et2[0].remove ? et2[0].remove(false) : (et2.shift(), this.updateParallelArrays(nt2, "shift"), Y2.shift())), $2 !== false && u2(this, "addPoint", { point: nt2 }), this.isDirty = true, this.isDirtyData = true, M2 && lt2.redraw(F2);
        }
        removePoint(w2, M2, D2) {
          let F2 = this, $2 = F2.data, W2 = $2[w2], V2 = F2.points, _2 = F2.chart, et2 = function() {
            V2 && V2.length === $2.length && V2.splice(w2, 1), $2.splice(w2, 1), F2.options.data.splice(w2, 1), F2.updateParallelArrays(W2 || { series: F2 }, "splice", [w2, 1]), W2 && W2.destroy(), F2.isDirty = true, F2.isDirtyData = true, M2 && _2.redraw();
          };
          x2(D2, _2), M2 = z2(M2, true), W2 ? W2.firePointEvent("remove", null, et2) : et2();
        }
        remove(w2, M2, D2, F2) {
          let $2 = this, W2 = $2.chart;
          function V2() {
            $2.destroy(F2), W2.isDirtyLegend = W2.isDirtyBox = true, W2.linkSeries(F2), z2(w2, true) && W2.redraw(M2);
          }
          D2 !== false ? u2($2, "remove", null, V2) : V2();
        }
        update(w2, M2) {
          var D2, F2, $2, W2, V2;
          u2(this, "update", { options: w2 = y2(w2, this.userOptions) });
          let _2 = this, et2 = _2.chart, lt2 = _2.userOptions, ht2 = _2.initialType || _2.type, J2 = et2.options.plotOptions, Y2 = b5[ht2].prototype, st2 = _2.finishedAnimating && { animation: false }, nt2 = {}, ot2, ut2, dt2 = ["colorIndex", "eventOptions", "navigatorSeries", "symbolIndex", "baseSeries"], ct2 = w2.type || lt2.type || et2.options.chart.type, gt2 = !(this.hasDerivedData || ct2 && ct2 !== this.type || w2.pointStart !== void 0 || w2.pointInterval !== void 0 || w2.relativeXValue !== void 0 || w2.joinBy || w2.mapData || ["dataGrouping", "pointStart", "pointInterval", "pointIntervalUnit", "keys"].some((pt2) => _2.hasOptionChanged(pt2)));
          ct2 = ct2 || ht2, gt2 && (dt2.push("data", "isDirtyData", "isDirtyCanvas", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "hasDataLabels", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX", "transformGroups"), w2.visible !== false && dt2.push("area", "graph"), _2.parallelArrays.forEach(function(pt2) {
            dt2.push(pt2 + "Data");
          }), w2.data && (w2.dataSorting && e5(_2.options.dataSorting, w2.dataSorting), this.setData(w2.data, false))), w2 = E2(lt2, { index: lt2.index === void 0 ? _2.index : lt2.index, pointStart: (W2 = (F2 = (D2 = J2 == null ? void 0 : J2.series) == null ? void 0 : D2.pointStart) != null ? F2 : lt2.pointStart) != null ? W2 : ($2 = _2.xData) == null ? void 0 : $2[0] }, !gt2 && { data: _2.options.data }, w2, st2), gt2 && w2.data && (w2.data = _2.options.data), (dt2 = ["group", "markerGroup", "dataLabelsGroup", "transformGroup"].concat(dt2)).forEach(function(pt2) {
            dt2[pt2] = _2[pt2], delete _2[pt2];
          });
          let ft2 = false;
          if (b5[ct2]) {
            if (ft2 = ct2 !== _2.type, _2.remove(false, false, false, true), ft2)
              if (et2.propFromSeries(), Object.setPrototypeOf) Object.setPrototypeOf(_2, b5[ct2].prototype);
              else {
                let pt2 = Object.hasOwnProperty.call(_2, "hcEvents") && _2.hcEvents;
                for (ut2 in Y2) _2[ut2] = void 0;
                e5(_2, b5[ct2].prototype), pt2 ? _2.hcEvents = pt2 : delete _2.hcEvents;
              }
          } else t3(17, true, et2, { missingModuleFor: ct2 });
          if (dt2.forEach(function(pt2) {
            _2[pt2] = dt2[pt2];
          }), _2.init(et2, w2), gt2 && this.points) for (let pt2 of ((ot2 = _2.options).visible === false ? (nt2.graphic = 1, nt2.dataLabel = 1) : (this.hasMarkerChanged(ot2, lt2) && (nt2.graphic = 1), (V2 = _2.hasDataLabels) != null && V2.call(_2) || (nt2.dataLabel = 1)), this.points)) pt2 && pt2.series && (pt2.resolveColor(), Object.keys(nt2).length && pt2.destroyElements(nt2), ot2.showInLegend === false && pt2.legendItem && et2.legend.destroyItem(pt2));
          _2.initialType = ht2, et2.linkSeries(), et2.setSortedData(), ft2 && _2.linkedSeries.length && (_2.isDirtyData = true), u2(this, "afterUpdate"), z2(M2, true) && et2.redraw(!!gt2 && void 0);
        }
        setName(w2) {
          this.name = this.options.name = this.userOptions.name = w2, this.chart.isDirtyLegend = true;
        }
        hasOptionChanged(w2) {
          var M2, D2;
          let F2 = this.chart, $2 = this.options[w2], W2 = F2.options.plotOptions, V2 = this.userOptions[w2], _2 = z2((M2 = W2 == null ? void 0 : W2[this.type]) == null ? void 0 : M2[w2], (D2 = W2 == null ? void 0 : W2.series) == null ? void 0 : D2[w2]);
          return V2 && !L2(_2) ? $2 !== V2 : $2 !== z2(_2, $2);
        }
        onMouseOver() {
          let w2 = this.chart, M2 = w2.hoverSeries, D2 = w2.pointer;
          D2 == null || D2.setHoverChartIndex(), M2 && M2 !== this && M2.onMouseOut(), this.options.events.mouseOver && u2(this, "mouseOver"), this.setState("hover"), w2.hoverSeries = this;
        }
        onMouseOut() {
          let w2 = this.options, M2 = this.chart, D2 = M2.tooltip, F2 = M2.hoverPoint;
          M2.hoverSeries = null, F2 && F2.onMouseOut(), this && w2.events.mouseOut && u2(this, "mouseOut"), D2 && !this.stickyTracking && (!D2.shared || this.noSharedTooltip) && D2.hide(), M2.series.forEach(function($2) {
            $2.setState("", true);
          });
        }
        setState(w2, M2) {
          let D2 = this, F2 = D2.options, $2 = D2.graph, W2 = F2.inactiveOtherPoints, V2 = F2.states, _2 = z2(V2[w2 || "normal"] && V2[w2 || "normal"].animation, D2.chart.options.chart.animation), et2 = F2.lineWidth, lt2 = F2.opacity;
          if (w2 = w2 || "", D2.state !== w2 && ([D2.group, D2.markerGroup, D2.dataLabelsGroup].forEach(function(ht2) {
            ht2 && (D2.state && ht2.removeClass("highcharts-series-" + D2.state), w2 && ht2.addClass("highcharts-series-" + w2));
          }), D2.state = w2, !D2.chart.styledMode)) {
            if (V2[w2] && V2[w2].enabled === false) return;
            if (w2 && (et2 = V2[w2].lineWidth || et2 + (V2[w2].lineWidthPlus || 0), lt2 = z2(V2[w2].opacity, lt2)), $2 && !$2.dashstyle && N2(et2)) for (let ht2 of [$2, ...this.zones.map((J2) => J2.graph)]) ht2 == null || ht2.animate({ "stroke-width": et2 }, _2);
            W2 || [D2.group, D2.markerGroup, D2.dataLabelsGroup, D2.labelBySeries].forEach(function(ht2) {
              ht2 && ht2.animate({ opacity: lt2 }, _2);
            });
          }
          M2 && W2 && D2.points && D2.setAllPointsToState(w2 || void 0);
        }
        setAllPointsToState(w2) {
          this.points.forEach(function(M2) {
            M2.setState && M2.setState(w2);
          });
        }
        setVisible(w2, M2) {
          var D2;
          let F2 = this, $2 = F2.chart, W2 = $2.options.chart.ignoreHiddenSeries, V2 = F2.visible;
          F2.visible = w2 = F2.options.visible = F2.userOptions.visible = w2 === void 0 ? !V2 : w2;
          let _2 = w2 ? "show" : "hide";
          ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach((et2) => {
            var lt2;
            (lt2 = F2[et2]) == null || lt2[_2]();
          }), ($2.hoverSeries === F2 || ((D2 = $2.hoverPoint) == null ? void 0 : D2.series) === F2) && F2.onMouseOut(), F2.legendItem && $2.legend.colorizeItem(F2, w2), F2.isDirty = true, F2.options.stacking && $2.series.forEach((et2) => {
            et2.options.stacking && et2.visible && (et2.isDirty = true);
          }), F2.linkedSeries.forEach((et2) => {
            et2.setVisible(w2, false);
          }), W2 && ($2.isDirtyBox = true), u2(F2, _2), M2 !== false && $2.redraw();
        }
        show() {
          this.setVisible(true);
        }
        hide() {
          this.setVisible(false);
        }
        select(w2) {
          this.selected = w2 = this.options.selected = w2 === void 0 ? !this.selected : w2, this.checkbox && (this.checkbox.checked = w2), u2(this, w2 ? "select" : "unselect");
        }
        shouldShowTooltip(w2, M2, D2 = {}) {
          return D2.series = this, D2.visiblePlotOnly = true, this.chart.isInsidePlot(w2, M2, D2);
        }
        drawLegendSymbol(w2, M2) {
          var D2;
          (D2 = rt2[this.options.legendSymbol || "rectangle"]) == null || D2.call(this, w2, M2);
        }
      }
      return P2.defaultOptions = Z2, P2.types = X2.seriesTypes, P2.registerType = X2.registerSeriesType, e5(P2.prototype, { axisTypes: ["xAxis", "yAxis"], coll: "series", colorCounter: 0, directTouch: false, invertible: true, isCartesian: true, kdAxisArray: ["clientX", "plotY"], parallelArrays: ["x", "y"], pointClass: tt2, requireSorting: true, sorted: true }), X2.series = P2, P2;
    }), at2(s2, "Core/Legend/Legend.js", [s2["Core/Animation/AnimationUtilities.js"], s2["Core/Foundation.js"], s2["Core/Globals.js"], s2["Core/Series/Series.js"], s2["Core/Series/Point.js"], s2["Core/Renderer/RendererUtilities.js"], s2["Core/Templating.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2) {
      var O3;
      let { animObject: j3, setAnimation: d3 } = B3, { registerEventOptions: x2 } = K2, { composed: f2, marginNames: C3 } = q2, { distribute: o2 } = tt2, { format: p2 } = Z2, { addEvent: b5, createElement: h2, css: c4, defined: T2, discardElement: I3, find: G2, fireEvent: L2, isNumber: l4, merge: y2, pick: i5, pushUnique: t3, relativeLength: e5, stableSort: n4, syncTimeout: u2 } = X2;
      class a2 {
        constructor(r3, A3) {
          this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = r3, this.setOptions(A3), A3.enabled && (this.render(), x2(this, A3), b5(this.chart, "endResize", function() {
            this.legend.positionCheckboxes();
          })), b5(this.chart, "render", () => {
            this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
          });
        }
        setOptions(r3) {
          let A3 = i5(r3.padding, 8);
          this.options = r3, this.chart.styledMode || (this.itemStyle = r3.itemStyle, this.itemHiddenStyle = y2(this.itemStyle, r3.itemHiddenStyle)), this.itemMarginTop = r3.itemMarginTop, this.itemMarginBottom = r3.itemMarginBottom, this.padding = A3, this.initialItemY = A3 - 5, this.symbolWidth = i5(r3.symbolWidth, 16), this.pages = [], this.proximate = r3.layout === "proximate" && !this.chart.inverted, this.baseline = void 0;
        }
        update(r3, A3) {
          let N2 = this.chart;
          this.setOptions(y2(true, this.options, r3)), "events" in this.options && x2(this, this.options), this.destroy(), N2.isDirtyLegend = N2.isDirtyBox = true, i5(A3, true) && N2.redraw(), L2(this, "afterUpdate", { redraw: A3 });
        }
        colorizeItem(r3, A3) {
          let { area: N2, group: k3, label: E2, line: R2, symbol: z2 } = r3.legendItem || {};
          if (k3 == null || k3[A3 ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
            let { itemHiddenStyle: Q2 = {} } = this, v3 = Q2.color, { fillColor: S2, fillOpacity: P2, lineColor: U2, marker: w2 } = r3.options, M2 = (D2) => (!A3 && (D2.fill && (D2.fill = v3), D2.stroke && (D2.stroke = v3)), D2);
            E2 == null || E2.css(y2(A3 ? this.itemStyle : Q2)), R2 == null || R2.attr(M2({ stroke: U2 || r3.color })), z2 && z2.attr(M2(w2 && z2.isMarker ? r3.pointAttribs() : { fill: r3.color })), N2 == null || N2.attr(M2({ fill: S2 || r3.color, "fill-opacity": S2 ? 1 : P2 != null ? P2 : 0.75 }));
          }
          L2(this, "afterColorizeItem", { item: r3, visible: A3 });
        }
        positionItems() {
          this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
        }
        positionItem(r3) {
          let { group: A3, x: N2 = 0, y: k3 = 0 } = r3.legendItem || {}, E2 = this.options, R2 = E2.symbolPadding, z2 = !E2.rtl, Q2 = r3.checkbox;
          if (A3 && A3.element) {
            let v3 = { translateX: z2 ? N2 : this.legendWidth - N2 - 2 * R2 - 4, translateY: k3 };
            A3[T2(A3.translateY) ? "animate" : "attr"](v3, void 0, () => {
              L2(this, "afterPositionItem", { item: r3 });
            });
          }
          Q2 && (Q2.x = N2, Q2.y = k3);
        }
        destroyItem(r3) {
          let A3 = r3.checkbox, N2 = r3.legendItem || {};
          for (let k3 of ["group", "label", "line", "symbol"]) N2[k3] && (N2[k3] = N2[k3].destroy());
          A3 && I3(A3), r3.legendItem = void 0;
        }
        destroy() {
          for (let r3 of this.getAllItems()) this.destroyItem(r3);
          for (let r3 of ["clipRect", "up", "down", "pager", "nav", "box", "title", "group"]) this[r3] && (this[r3] = this[r3].destroy());
          this.display = null;
        }
        positionCheckboxes() {
          let r3, A3 = this.group && this.group.alignAttr, N2 = this.clipHeight || this.legendHeight, k3 = this.titleHeight;
          A3 && (r3 = A3.translateY, this.allItems.forEach(function(E2) {
            let R2, z2 = E2.checkbox;
            z2 && (R2 = r3 + k3 + z2.y + (this.scrollOffset || 0) + 3, c4(z2, { left: A3.translateX + E2.checkboxOffset + z2.x - 20 + "px", top: R2 + "px", display: this.proximate || R2 > r3 - 6 && R2 < r3 + N2 - 6 ? "" : "none" }));
          }, this));
        }
        renderTitle() {
          let r3 = this.options, A3 = this.padding, N2 = r3.title, k3, E2 = 0;
          N2.text && (this.title || (this.title = this.chart.renderer.label(N2.text, A3 - 3, A3 - 4, void 0, void 0, void 0, r3.useHTML, void 0, "legend-title").attr({ zIndex: 1 }), this.chart.styledMode || this.title.css(N2.style), this.title.add(this.group)), N2.width || this.title.css({ width: this.maxLegendWidth + "px" }), E2 = (k3 = this.title.getBBox()).height, this.offsetWidth = k3.width, this.contentGroup.attr({ translateY: E2 })), this.titleHeight = E2;
        }
        setText(r3) {
          let A3 = this.options;
          r3.legendItem.label.attr({ text: A3.labelFormat ? p2(A3.labelFormat, r3, this.chart) : A3.labelFormatter.call(r3) });
        }
        renderItem(r3) {
          let A3 = r3.legendItem = r3.legendItem || {}, N2 = this.chart, k3 = N2.renderer, E2 = this.options, R2 = E2.layout === "horizontal", z2 = this.symbolWidth, Q2 = E2.symbolPadding || 0, v3 = this.itemStyle, S2 = this.itemHiddenStyle, P2 = R2 ? i5(E2.itemDistance, 20) : 0, U2 = !E2.rtl, w2 = !r3.series, M2 = !w2 && r3.series.drawLegendSymbol ? r3.series : r3, D2 = M2.options, F2 = !!this.createCheckboxForItem && D2 && D2.showCheckbox, $2 = E2.useHTML, W2 = r3.options.className, V2 = A3.label, _2 = z2 + Q2 + P2 + (F2 ? 20 : 0);
          !V2 && (A3.group = k3.g("legend-item").addClass("highcharts-" + M2.type + "-series highcharts-color-" + r3.colorIndex + (W2 ? " " + W2 : "") + (w2 ? " highcharts-series-" + r3.index : "")).attr({ zIndex: 1 }).add(this.scrollGroup), A3.label = V2 = k3.text("", U2 ? z2 + Q2 : -Q2, this.baseline || 0, $2), N2.styledMode || V2.css(y2(r3.visible ? v3 : S2)), V2.attr({ align: U2 ? "left" : "right", zIndex: 2 }).add(A3.group), !this.baseline && (this.fontMetrics = k3.fontMetrics(V2), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, V2.attr("y", this.baseline), this.symbolHeight = i5(E2.symbolHeight, this.fontMetrics.f), E2.squareSymbol && (this.symbolWidth = i5(E2.symbolWidth, Math.max(this.symbolHeight, 16)), _2 = this.symbolWidth + Q2 + P2 + (F2 ? 20 : 0), U2 && V2.attr("x", this.symbolWidth + Q2))), M2.drawLegendSymbol(this, r3), this.setItemEvents && this.setItemEvents(r3, V2, $2)), F2 && !r3.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(r3), this.colorizeItem(r3, r3.visible), (N2.styledMode || !v3.width) && V2.css({ width: (E2.itemWidth || this.widthOption || N2.spacingBox.width) - _2 + "px" }), this.setText(r3);
          let et2 = V2.getBBox(), lt2 = this.fontMetrics && this.fontMetrics.h || 0;
          r3.itemWidth = r3.checkboxOffset = E2.itemWidth || A3.labelWidth || et2.width + _2, this.maxItemWidth = Math.max(this.maxItemWidth, r3.itemWidth), this.totalItemWidth += r3.itemWidth, this.itemHeight = r3.itemHeight = Math.round(A3.labelHeight || (et2.height > 1.5 * lt2 ? et2.height : lt2));
        }
        layoutItem(r3) {
          let A3 = this.options, N2 = this.padding, k3 = A3.layout === "horizontal", E2 = r3.itemHeight, R2 = this.itemMarginBottom, z2 = this.itemMarginTop, Q2 = k3 ? i5(A3.itemDistance, 20) : 0, v3 = this.maxLegendWidth, S2 = A3.alignColumns && this.totalItemWidth > v3 ? this.maxItemWidth : r3.itemWidth, P2 = r3.legendItem || {};
          k3 && this.itemX - N2 + S2 > v3 && (this.itemX = N2, this.lastLineHeight && (this.itemY += z2 + this.lastLineHeight + R2), this.lastLineHeight = 0), this.lastItemY = z2 + this.itemY + R2, this.lastLineHeight = Math.max(E2, this.lastLineHeight), P2.x = this.itemX, P2.y = this.itemY, k3 ? this.itemX += S2 : (this.itemY += z2 + E2 + R2, this.lastLineHeight = E2), this.offsetWidth = this.widthOption || Math.max((k3 ? this.itemX - N2 - (r3.checkbox ? 0 : Q2) : S2) + N2, this.offsetWidth);
        }
        getAllItems() {
          let r3 = [];
          return this.chart.series.forEach(function(A3) {
            let N2 = A3 && A3.options;
            A3 && i5(N2.showInLegend, !T2(N2.linkedTo) && void 0, true) && (r3 = r3.concat((A3.legendItem || {}).labels || (N2.legendType === "point" ? A3.data : A3)));
          }), L2(this, "afterGetAllItems", { allItems: r3 }), r3;
        }
        getAlignment() {
          let r3 = this.options;
          return this.proximate ? r3.align.charAt(0) + "tv" : r3.floating ? "" : r3.align.charAt(0) + r3.verticalAlign.charAt(0) + r3.layout.charAt(0);
        }
        adjustMargins(r3, A3) {
          let N2 = this.chart, k3 = this.options, E2 = this.getAlignment();
          E2 && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function(R2, z2) {
            R2.test(E2) && !T2(r3[z2]) && (N2[C3[z2]] = Math.max(N2[C3[z2]], N2.legend[(z2 + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][z2] * k3[z2 % 2 ? "x" : "y"] + i5(k3.margin, 12) + A3[z2] + (N2.titleOffset[z2] || 0)));
          });
        }
        proximatePositions() {
          let r3, A3 = this.chart, N2 = [], k3 = this.options.align === "left";
          for (let E2 of (this.allItems.forEach(function(R2) {
            let z2, Q2, v3 = k3, S2, P2;
            R2.yAxis && (R2.xAxis.options.reversed && (v3 = !v3), R2.points && (z2 = G2(v3 ? R2.points : R2.points.slice(0).reverse(), function(U2) {
              return l4(U2.plotY);
            })), Q2 = this.itemMarginTop + R2.legendItem.label.getBBox().height + this.itemMarginBottom, P2 = R2.yAxis.top - A3.plotTop, S2 = R2.visible ? (z2 ? z2.plotY : R2.yAxis.height) + (P2 - 0.3 * Q2) : P2 + R2.yAxis.height, N2.push({ target: S2, size: Q2, item: R2 }));
          }, this), o2(N2, A3.plotHeight))) r3 = E2.item.legendItem || {}, l4(E2.pos) && (r3.y = A3.plotTop - A3.spacing[0] + E2.pos);
        }
        render() {
          let r3 = this.chart, A3 = r3.renderer, N2 = this.options, k3 = this.padding, E2 = this.getAllItems(), R2, z2, Q2, v3 = this.group, S2, P2 = this.box;
          this.itemX = k3, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = e5(N2.width, r3.spacingBox.width - k3), S2 = r3.spacingBox.width - 2 * k3 - N2.x, ["rm", "lm"].indexOf(this.getAlignment().substring(0, 2)) > -1 && (S2 /= 2), this.maxLegendWidth = this.widthOption || S2, v3 || (this.group = v3 = A3.g("legend").addClass(N2.className || "").attr({ zIndex: 7 }).add(), this.contentGroup = A3.g().attr({ zIndex: 1 }).add(v3), this.scrollGroup = A3.g().add(this.contentGroup)), this.renderTitle(), n4(E2, (U2, w2) => (U2.options && U2.options.legendIndex || 0) - (w2.options && w2.options.legendIndex || 0)), N2.reversed && E2.reverse(), this.allItems = E2, this.display = R2 = !!E2.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, E2.forEach(this.renderItem, this), E2.forEach(this.layoutItem, this), z2 = (this.widthOption || this.offsetWidth) + k3, Q2 = this.lastItemY + this.lastLineHeight + this.titleHeight, Q2 = this.handleOverflow(Q2) + k3, P2 || (this.box = P2 = A3.rect().addClass("highcharts-legend-box").attr({ r: N2.borderRadius }).add(v3)), r3.styledMode || P2.attr({ stroke: N2.borderColor, "stroke-width": N2.borderWidth || 0, fill: N2.backgroundColor || "none" }).shadow(N2.shadow), z2 > 0 && Q2 > 0 && P2[P2.placed ? "animate" : "attr"](P2.crisp.call({}, { x: 0, y: 0, width: z2, height: Q2 }, P2.strokeWidth())), v3[R2 ? "show" : "hide"](), r3.styledMode && v3.getStyle("display") === "none" && (z2 = Q2 = 0), this.legendWidth = z2, this.legendHeight = Q2, R2 && this.align(), this.proximate || this.positionItems(), L2(this, "afterRender");
        }
        align(r3 = this.chart.spacingBox) {
          let A3 = this.chart, N2 = this.options, k3 = r3.y;
          /(lth|ct|rth)/.test(this.getAlignment()) && A3.titleOffset[0] > 0 ? k3 += A3.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && A3.titleOffset[2] > 0 && (k3 -= A3.titleOffset[2]), k3 !== r3.y && (r3 = y2(r3, { y: k3 })), A3.hasRendered || (this.group.placed = false), this.group.align(y2(N2, { width: this.legendWidth, height: this.legendHeight, verticalAlign: this.proximate ? "top" : N2.verticalAlign }), true, r3);
        }
        handleOverflow(r3) {
          let A3 = this, N2 = this.chart, k3 = N2.renderer, E2 = this.options, R2 = E2.y, z2 = E2.verticalAlign === "top", Q2 = this.padding, v3 = E2.maxHeight, S2 = E2.navigation, P2 = i5(S2.animation, true), U2 = S2.arrowSize || 12, w2 = this.pages, M2 = this.allItems, D2 = function(ht2) {
            typeof ht2 == "number" ? lt2.attr({ height: ht2 }) : lt2 && (A3.clipRect = lt2.destroy(), A3.contentGroup.clip()), A3.contentGroup.div && (A3.contentGroup.div.style.clip = ht2 ? "rect(" + Q2 + "px,9999px," + (Q2 + ht2) + "px,0)" : "auto");
          }, F2 = function(ht2) {
            return A3[ht2] = k3.circle(0, 0, 1.3 * U2).translate(U2 / 2, U2 / 2).add(et2), N2.styledMode || A3[ht2].attr("fill", "rgba(0,0,0,0.0001)"), A3[ht2];
          }, $2, W2, V2, _2 = N2.spacingBox.height + (z2 ? -R2 : R2) - Q2, et2 = this.nav, lt2 = this.clipRect;
          return E2.layout !== "horizontal" || E2.verticalAlign === "middle" || E2.floating || (_2 /= 2), v3 && (_2 = Math.min(_2, v3)), w2.length = 0, r3 && _2 > 0 && r3 > _2 && S2.enabled !== false ? (this.clipHeight = $2 = Math.max(_2 - 20 - this.titleHeight - Q2, 0), this.currentPage = i5(this.currentPage, 1), this.fullHeight = r3, M2.forEach((ht2, J2) => {
            let Y2 = (V2 = ht2.legendItem || {}).y || 0, st2 = Math.round(V2.label.getBBox().height), nt2 = w2.length;
            (!nt2 || Y2 - w2[nt2 - 1] > $2 && (W2 || Y2) !== w2[nt2 - 1]) && (w2.push(W2 || Y2), nt2++), V2.pageIx = nt2 - 1, W2 && ((M2[J2 - 1].legendItem || {}).pageIx = nt2 - 1), J2 === M2.length - 1 && Y2 + st2 - w2[nt2 - 1] > $2 && Y2 > w2[nt2 - 1] && (w2.push(Y2), V2.pageIx = nt2), Y2 !== W2 && (W2 = Y2);
          }), lt2 || (lt2 = A3.clipRect = k3.clipRect(0, Q2 - 2, 9999, 0), A3.contentGroup.clip(lt2)), D2($2), et2 || (this.nav = et2 = k3.g().attr({ zIndex: 1 }).add(this.group), this.up = k3.symbol("triangle", 0, 0, U2, U2).add(et2), F2("upTracker").on("click", function() {
            A3.scroll(-1, P2);
          }), this.pager = k3.text("", 15, 10).addClass("highcharts-legend-navigation"), !N2.styledMode && S2.style && this.pager.css(S2.style), this.pager.add(et2), this.down = k3.symbol("triangle-down", 0, 0, U2, U2).add(et2), F2("downTracker").on("click", function() {
            A3.scroll(1, P2);
          })), A3.scroll(0), r3 = _2) : et2 && (D2(), this.nav = et2.destroy(), this.scrollGroup.attr({ translateY: 1 }), this.clipHeight = 0), r3;
        }
        scroll(r3, A3) {
          let N2 = this.chart, k3 = this.pages, E2 = k3.length, R2 = this.clipHeight, z2 = this.options.navigation, Q2 = this.pager, v3 = this.padding, S2 = this.currentPage + r3;
          S2 > E2 && (S2 = E2), S2 > 0 && (A3 !== void 0 && d3(A3, N2), this.nav.attr({ translateX: v3, translateY: R2 + this.padding + 7 + this.titleHeight, visibility: "inherit" }), [this.up, this.upTracker].forEach(function(P2) {
            P2.attr({ class: S2 === 1 ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }), Q2.attr({ text: S2 + "/" + E2 }), [this.down, this.downTracker].forEach(function(P2) {
            P2.attr({ x: 18 + this.pager.getBBox().width, class: S2 === E2 ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }, this), N2.styledMode || (this.up.attr({ fill: S2 === 1 ? z2.inactiveColor : z2.activeColor }), this.upTracker.css({ cursor: S2 === 1 ? "default" : "pointer" }), this.down.attr({ fill: S2 === E2 ? z2.inactiveColor : z2.activeColor }), this.downTracker.css({ cursor: S2 === E2 ? "default" : "pointer" })), this.scrollOffset = -k3[S2 - 1] + this.initialItemY, this.scrollGroup.animate({ translateY: this.scrollOffset }), this.currentPage = S2, this.positionCheckboxes(), u2(() => {
            L2(this, "afterScroll", { currentPage: S2 });
          }, j3(i5(A3, N2.renderer.globalAnimation, true)).duration));
        }
        setItemEvents(r3, A3, N2) {
          let k3 = this, E2 = r3.legendItem || {}, R2 = k3.chart.renderer.boxWrapper, z2 = r3 instanceof rt2, Q2 = r3 instanceof it2, v3 = "highcharts-legend-" + (z2 ? "point" : "series") + "-active", S2 = k3.chart.styledMode, P2 = N2 ? [A3, E2.symbol] : [E2.group], U2 = (w2) => {
            k3.allItems.forEach((M2) => {
              r3 !== M2 && [M2].concat(M2.linkedSeries || []).forEach((D2) => {
                D2.setState(w2, !z2);
              });
            });
          };
          for (let w2 of P2) w2 && w2.on("mouseover", function() {
            r3.visible && U2("inactive"), r3.setState("hover"), r3.visible && R2.addClass(v3), S2 || A3.css(k3.options.itemHoverStyle);
          }).on("mouseout", function() {
            k3.chart.styledMode || A3.css(y2(r3.visible ? k3.itemStyle : k3.itemHiddenStyle)), U2(""), R2.removeClass(v3), r3.setState();
          }).on("click", function(M2) {
            let D2 = function() {
              r3.setVisible && r3.setVisible(), U2(r3.visible ? "inactive" : "");
            };
            R2.removeClass(v3), L2(k3, "itemClick", { browserEvent: M2, legendItem: r3 }, D2), z2 ? r3.firePointEvent("legendItemClick", { browserEvent: M2 }) : Q2 && L2(r3, "legendItemClick", { browserEvent: M2 });
          });
        }
        createCheckboxForItem(r3) {
          r3.checkbox = h2("input", { type: "checkbox", className: "highcharts-legend-checkbox", checked: r3.selected, defaultChecked: r3.selected }, this.options.itemCheckboxStyle, this.chart.container), b5(r3.checkbox, "click", function(A3) {
            let N2 = A3.target;
            L2(r3.series || r3, "checkboxClick", { checked: N2.checked, item: r3 }, function() {
              r3.select();
            });
          });
        }
      }
      return (O3 = a2).compose = function(g2) {
        t3(f2, "Core.Legend") && b5(g2, "beforeMargins", function() {
          this.legend = new O3(this, this.options.legend);
        });
      }, a2;
    }), at2(s2, "Core/Chart/Chart.js", [s2["Core/Animation/AnimationUtilities.js"], s2["Core/Axis/Axis.js"], s2["Core/Defaults.js"], s2["Core/Templating.js"], s2["Core/Foundation.js"], s2["Core/Globals.js"], s2["Core/Renderer/RendererRegistry.js"], s2["Core/Series/Series.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Renderer/SVG/SVGRenderer.js"], s2["Core/Time.js"], s2["Core/Utilities.js"], s2["Core/Renderer/HTML/AST.js"], s2["Core/Axis/Tick.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2, O3, j3, d3, x2, f2, C3) {
      let { animate: o2, animObject: p2, setAnimation: b5 } = B3, { defaultOptions: h2, defaultTime: c4 } = q2, { numberFormat: T2 } = it2, { registerEventOptions: I3 } = rt2, { charts: G2, doc: L2, marginNames: l4, svg: y2, win: i5 } = tt2, { seriesTypes: t3 } = O3, { addEvent: e5, attr: n4, createElement: u2, css: a2, defined: g2, diffObjects: r3, discardElement: A3, erase: N2, error: k3, extend: E2, find: R2, fireEvent: z2, getStyle: Q2, isArray: v3, isNumber: S2, isObject: P2, isString: U2, merge: w2, objectEach: M2, pick: D2, pInt: F2, relativeLength: $2, removeEvent: W2, splat: V2, syncTimeout: _2, uniqueKey: et2 } = x2;
      class lt2 {
        static chart(J2, Y2, st2) {
          return new lt2(J2, Y2, st2);
        }
        constructor(J2, Y2, st2) {
          this.sharedClips = {};
          let nt2 = [...arguments];
          (U2(J2) || J2.nodeName) && (this.renderTo = nt2.shift()), this.init(nt2[0], nt2[1]);
        }
        setZoomOptions() {
          let J2 = this.options.chart, Y2 = J2.zooming;
          this.zooming = { ...Y2, type: D2(J2.zoomType, Y2.type), key: D2(J2.zoomKey, Y2.key), pinchType: D2(J2.pinchType, Y2.pinchType), singleTouch: D2(J2.zoomBySingleTouch, Y2.singleTouch, false), resetButton: w2(Y2.resetButton, J2.resetZoomButton) };
        }
        init(J2, Y2) {
          z2(this, "init", { args: arguments }, function() {
            let st2 = w2(h2, J2), nt2 = st2.chart;
            this.userOptions = E2({}, J2), this.margin = [], this.spacing = [], this.labelCollectors = [], this.callback = Y2, this.isResizing = 0, this.options = st2, this.axes = [], this.series = [], this.time = J2.time && Object.keys(J2.time).length ? new d3(J2.time) : tt2.time, this.numberFormatter = nt2.numberFormatter || T2, this.styledMode = nt2.styledMode, this.hasCartesianSeries = nt2.showAxes, this.index = G2.length, G2.push(this), tt2.chartCount++, I3(this, nt2), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), z2(this, "afterInit"), this.firstRender();
          });
        }
        initSeries(J2) {
          let Y2 = this.options.chart, st2 = J2.type || Y2.type, nt2 = t3[st2];
          nt2 || k3(17, true, this, { missingModuleFor: st2 });
          let ot2 = new nt2();
          return typeof ot2.init == "function" && ot2.init(this, J2), ot2;
        }
        setSortedData() {
          this.getSeriesOrderByLinks().forEach(function(J2) {
            J2.points || J2.data || !J2.enabledDataSorting || J2.setData(J2.options.data, false);
          });
        }
        getSeriesOrderByLinks() {
          return this.series.concat().sort(function(J2, Y2) {
            return J2.linkedSeries.length || Y2.linkedSeries.length ? Y2.linkedSeries.length - J2.linkedSeries.length : 0;
          });
        }
        orderItems(J2, Y2 = 0) {
          let st2 = this[J2], nt2 = this.options[J2] = V2(this.options[J2]).slice(), ot2 = this.userOptions[J2] = this.userOptions[J2] ? V2(this.userOptions[J2]).slice() : [];
          if (this.hasRendered && (nt2.splice(Y2), ot2.splice(Y2)), st2) for (let ut2 = Y2, dt2 = st2.length; ut2 < dt2; ++ut2) {
            let ct2 = st2[ut2];
            ct2 && (ct2.index = ut2, ct2 instanceof X2 && (ct2.name = ct2.getName()), ct2.options.isInternal || (nt2[ut2] = ct2.options, ot2[ut2] = ct2.userOptions));
          }
        }
        isInsidePlot(J2, Y2, st2 = {}) {
          var nt2;
          let { inverted: ot2, plotBox: ut2, plotLeft: dt2, plotTop: ct2, scrollablePlotBox: gt2 } = this, { scrollLeft: ft2 = 0, scrollTop: pt2 = 0 } = st2.visiblePlotOnly && ((nt2 = this.scrollablePlotArea) == null ? void 0 : nt2.scrollingContainer) || {}, mt2 = st2.series, yt2 = st2.visiblePlotOnly && gt2 || ut2, vt2 = st2.inverted ? Y2 : J2, bt2 = st2.inverted ? J2 : Y2, xt2 = { x: vt2, y: bt2, isInsidePlot: true, options: st2 };
          if (!st2.ignoreX) {
            let Ct2 = mt2 && (ot2 && !this.polar ? mt2.yAxis : mt2.xAxis) || { pos: dt2, len: 1 / 0 }, wt2 = st2.paneCoordinates ? Ct2.pos + vt2 : dt2 + vt2;
            wt2 >= Math.max(ft2 + dt2, Ct2.pos) && wt2 <= Math.min(ft2 + dt2 + yt2.width, Ct2.pos + Ct2.len) || (xt2.isInsidePlot = false);
          }
          if (!st2.ignoreY && xt2.isInsidePlot) {
            let Ct2 = !ot2 && st2.axis && !st2.axis.isXAxis && st2.axis || mt2 && (ot2 ? mt2.xAxis : mt2.yAxis) || { pos: ct2, len: 1 / 0 }, wt2 = st2.paneCoordinates ? Ct2.pos + bt2 : ct2 + bt2;
            wt2 >= Math.max(pt2 + ct2, Ct2.pos) && wt2 <= Math.min(pt2 + ct2 + yt2.height, Ct2.pos + Ct2.len) || (xt2.isInsidePlot = false);
          }
          return z2(this, "afterIsInsidePlot", xt2), xt2.isInsidePlot;
        }
        redraw(J2) {
          z2(this, "beforeRedraw");
          let Y2 = this.hasCartesianSeries ? this.axes : this.colorAxis || [], st2 = this.series, nt2 = this.pointer, ot2 = this.legend, ut2 = this.userOptions.legend, dt2 = this.renderer, ct2 = dt2.isHidden(), gt2 = [], ft2, pt2, mt2, yt2 = this.isDirtyBox, vt2 = this.isDirtyLegend, bt2;
          for (dt2.rootFontSize = dt2.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(false), b5(!!this.hasRendered && J2, this), ct2 && this.temporaryDisplay(), this.layOutTitles(false), mt2 = st2.length; mt2--; ) if (((bt2 = st2[mt2]).options.stacking || bt2.options.centerInCategory) && (pt2 = true, bt2.isDirty)) {
            ft2 = true;
            break;
          }
          if (ft2) for (mt2 = st2.length; mt2--; ) (bt2 = st2[mt2]).options.stacking && (bt2.isDirty = true);
          st2.forEach(function(xt2) {
            xt2.isDirty && (xt2.options.legendType === "point" ? (typeof xt2.updateTotals == "function" && xt2.updateTotals(), vt2 = true) : ut2 && (ut2.labelFormatter || ut2.labelFormat) && (vt2 = true)), xt2.isDirtyData && z2(xt2, "updatedData");
          }), vt2 && ot2 && ot2.options.enabled && (ot2.render(), this.isDirtyLegend = false), pt2 && this.getStacks(), Y2.forEach(function(xt2) {
            xt2.updateNames(), xt2.setScale();
          }), this.getMargins(), Y2.forEach(function(xt2) {
            xt2.isDirty && (yt2 = true);
          }), Y2.forEach(function(xt2) {
            let Ct2 = xt2.min + "," + xt2.max;
            xt2.extKey !== Ct2 && (xt2.extKey = Ct2, gt2.push(function() {
              z2(xt2, "afterSetExtremes", E2(xt2.eventArgs, xt2.getExtremes())), delete xt2.eventArgs;
            })), (yt2 || pt2) && xt2.redraw();
          }), yt2 && this.drawChartBox(), z2(this, "predraw"), st2.forEach(function(xt2) {
            (yt2 || xt2.isDirty) && xt2.visible && xt2.redraw(), xt2.isDirtyData = false;
          }), nt2 && nt2.reset(true), dt2.draw(), z2(this, "redraw"), z2(this, "render"), ct2 && this.temporaryDisplay(true), gt2.forEach(function(xt2) {
            xt2.call();
          });
        }
        get(J2) {
          let Y2 = this.series;
          function st2(ot2) {
            return ot2.id === J2 || ot2.options && ot2.options.id === J2;
          }
          let nt2 = R2(this.axes, st2) || R2(this.series, st2);
          for (let ot2 = 0; !nt2 && ot2 < Y2.length; ot2++) nt2 = R2(Y2[ot2].points || [], st2);
          return nt2;
        }
        getAxes() {
          let J2 = this.userOptions;
          for (let Y2 of (z2(this, "getAxes"), ["xAxis", "yAxis"])) for (let st2 of J2[Y2] = V2(J2[Y2] || {})) new K2(this, st2, Y2);
          z2(this, "afterGetAxes");
        }
        getSelectedPoints() {
          return this.series.reduce((J2, Y2) => (Y2.getPointsCollection().forEach((st2) => {
            D2(st2.selectedStaging, st2.selected) && J2.push(st2);
          }), J2), []);
        }
        getSelectedSeries() {
          return this.series.filter(function(J2) {
            return J2.selected;
          });
        }
        setTitle(J2, Y2, st2) {
          this.applyDescription("title", J2), this.applyDescription("subtitle", Y2), this.applyDescription("caption", void 0), this.layOutTitles(st2);
        }
        applyDescription(J2, Y2) {
          let st2 = this, nt2 = this.options[J2] = w2(this.options[J2], Y2), ot2 = this[J2];
          ot2 && Y2 && (this[J2] = ot2 = ot2.destroy()), nt2 && !ot2 && ((ot2 = this.renderer.text(nt2.text, 0, 0, nt2.useHTML).attr({ align: nt2.align, class: "highcharts-" + J2, zIndex: nt2.zIndex || 4 }).add()).update = function(ut2, dt2) {
            st2.applyDescription(J2, ut2), st2.layOutTitles(dt2);
          }, this.styledMode || ot2.css(E2(J2 === "title" ? { fontSize: this.options.isStock ? "1em" : "1.2em" } : {}, nt2.style)), this[J2] = ot2);
        }
        layOutTitles(J2 = true) {
          let Y2 = [0, 0, 0], st2 = this.renderer, nt2 = this.spacingBox;
          ["title", "subtitle", "caption"].forEach(function(ut2) {
            let dt2 = this[ut2], ct2 = this.options[ut2], gt2 = ct2.verticalAlign || "top", ft2 = ut2 === "title" ? gt2 === "top" ? -3 : 0 : gt2 === "top" ? Y2[0] + 2 : 0;
            if (dt2) {
              dt2.css({ width: (ct2.width || nt2.width + (ct2.widthAdjust || 0)) + "px" });
              let pt2 = st2.fontMetrics(dt2).b, mt2 = Math.round(dt2.getBBox(ct2.useHTML).height);
              dt2.align(E2({ y: gt2 === "bottom" ? pt2 : ft2 + pt2, height: mt2 }, ct2), false, "spacingBox"), ct2.floating || (gt2 === "top" ? Y2[0] = Math.ceil(Y2[0] + mt2) : gt2 === "bottom" && (Y2[2] = Math.ceil(Y2[2] + mt2)));
            }
          }, this), Y2[0] && (this.options.title.verticalAlign || "top") === "top" && (Y2[0] += this.options.title.margin), Y2[2] && this.options.caption.verticalAlign === "bottom" && (Y2[2] += this.options.caption.margin);
          let ot2 = !this.titleOffset || this.titleOffset.join(",") !== Y2.join(",");
          this.titleOffset = Y2, z2(this, "afterLayOutTitles"), !this.isDirtyBox && ot2 && (this.isDirtyBox = this.isDirtyLegend = ot2, this.hasRendered && J2 && this.isDirtyBox && this.redraw());
        }
        getContainerBox() {
          let J2 = [].map.call(this.renderTo.children, (st2) => {
            if (st2 !== this.container) {
              let nt2 = st2.style.display;
              return st2.style.display = "none", [st2, nt2];
            }
          }), Y2 = { width: Q2(this.renderTo, "width", true) || 0, height: Q2(this.renderTo, "height", true) || 0 };
          return J2.filter(Boolean).forEach(([st2, nt2]) => {
            st2.style.display = nt2;
          }), Y2;
        }
        getChartSize() {
          var J2;
          let Y2 = this.options.chart, st2 = Y2.width, nt2 = Y2.height, ot2 = this.getContainerBox(), ut2 = ot2.height > 1 && !(!((J2 = this.renderTo.parentElement) != null && J2.style.height) && this.renderTo.style.height === "100%");
          this.chartWidth = Math.max(0, st2 || ot2.width || 600), this.chartHeight = Math.max(0, $2(nt2, this.chartWidth) || (ut2 ? ot2.height : 400)), this.containerBox = ot2;
        }
        temporaryDisplay(J2) {
          let Y2 = this.renderTo, st2;
          if (J2) for (; Y2 && Y2.style; ) Y2.hcOrigStyle && (a2(Y2, Y2.hcOrigStyle), delete Y2.hcOrigStyle), Y2.hcOrigDetached && (L2.body.removeChild(Y2), Y2.hcOrigDetached = false), Y2 = Y2.parentNode;
          else for (; Y2 && Y2.style && (L2.body.contains(Y2) || Y2.parentNode || (Y2.hcOrigDetached = true, L2.body.appendChild(Y2)), (Q2(Y2, "display", false) === "none" || Y2.hcOricDetached) && (Y2.hcOrigStyle = { display: Y2.style.display, height: Y2.style.height, overflow: Y2.style.overflow }, st2 = { display: "block", overflow: "hidden" }, Y2 !== this.renderTo && (st2.height = 0), a2(Y2, st2), Y2.offsetWidth || Y2.style.setProperty("display", "block", "important")), (Y2 = Y2.parentNode) !== L2.body); ) ;
        }
        setClassName(J2) {
          this.container.className = "highcharts-container " + (J2 || "");
        }
        getContainer() {
          var J2;
          let Y2 = this.options, st2 = Y2.chart, nt2 = "data-highcharts-chart", ot2 = et2(), ut2, dt2 = this.renderTo;
          dt2 || (this.renderTo = dt2 = st2.renderTo), U2(dt2) && (this.renderTo = dt2 = L2.getElementById(dt2)), dt2 || k3(13, true, this);
          let ct2 = F2(n4(dt2, nt2));
          S2(ct2) && G2[ct2] && G2[ct2].hasRendered && G2[ct2].destroy(), n4(dt2, nt2, this.index), dt2.innerHTML = f2.emptyHTML, st2.skipClone || dt2.offsetWidth || this.temporaryDisplay(), this.getChartSize();
          let gt2 = this.chartHeight, ft2 = this.chartWidth;
          a2(dt2, { overflow: "hidden" }), this.styledMode || (ut2 = E2({ position: "relative", overflow: "hidden", width: ft2 + "px", height: gt2 + "px", textAlign: "left", lineHeight: "normal", zIndex: 0, "-webkit-tap-highlight-color": "rgba(0,0,0,0)", userSelect: "none", "touch-action": "manipulation", outline: "none", padding: "0px" }, st2.style || {}));
          let pt2 = u2("div", { id: ot2 }, ut2, dt2);
          this.container = pt2, this.getChartSize(), ft2 === this.chartWidth || (ft2 = this.chartWidth, this.styledMode || a2(pt2, { width: D2((J2 = st2.style) == null ? void 0 : J2.width, ft2 + "px") })), this.containerBox = this.getContainerBox(), this._cursor = pt2.style.cursor;
          let mt2 = st2.renderer || !y2 ? Z2.getRendererType(st2.renderer) : j3;
          if (this.renderer = new mt2(pt2, ft2, gt2, void 0, st2.forExport, Y2.exporting && Y2.exporting.allowHTML, this.styledMode), b5(void 0, this), this.setClassName(st2.className), this.styledMode) for (let yt2 in Y2.defs) this.renderer.definition(Y2.defs[yt2]);
          else this.renderer.setStyle(st2.style);
          this.renderer.chartIndex = this.index, z2(this, "afterGetContainer");
        }
        getMargins(J2) {
          let { spacing: Y2, margin: st2, titleOffset: nt2 } = this;
          this.resetMargins(), nt2[0] && !g2(st2[0]) && (this.plotTop = Math.max(this.plotTop, nt2[0] + Y2[0])), nt2[2] && !g2(st2[2]) && (this.marginBottom = Math.max(this.marginBottom, nt2[2] + Y2[2])), this.legend && this.legend.display && this.legend.adjustMargins(st2, Y2), z2(this, "getMargins"), J2 || this.getAxisMargins();
        }
        getAxisMargins() {
          let J2 = this, Y2 = J2.axisOffset = [0, 0, 0, 0], st2 = J2.colorAxis, nt2 = J2.margin, ot2 = function(ut2) {
            ut2.forEach(function(dt2) {
              dt2.visible && dt2.getOffset();
            });
          };
          J2.hasCartesianSeries ? ot2(J2.axes) : st2 && st2.length && ot2(st2), l4.forEach(function(ut2, dt2) {
            g2(nt2[dt2]) || (J2[ut2] += Y2[dt2]);
          }), J2.setChartSize();
        }
        getOptions() {
          return r3(this.userOptions, h2);
        }
        reflow(J2) {
          var Y2;
          let st2 = this, nt2 = st2.containerBox, ot2 = st2.getContainerBox();
          (Y2 = st2.pointer) == null || delete Y2.chartPosition, !st2.isPrinting && !st2.isResizing && nt2 && ot2.width && ((ot2.width !== nt2.width || ot2.height !== nt2.height) && (x2.clearTimeout(st2.reflowTimeout), st2.reflowTimeout = _2(function() {
            st2.container && st2.setSize(void 0, void 0, false);
          }, J2 ? 100 : 0)), st2.containerBox = ot2);
        }
        setReflow() {
          let J2 = this, Y2 = (st2) => {
            var nt2;
            (nt2 = J2.options) != null && nt2.chart.reflow && J2.hasLoaded && J2.reflow(st2);
          };
          if (typeof ResizeObserver == "function") new ResizeObserver(Y2).observe(J2.renderTo);
          else {
            let st2 = e5(i5, "resize", Y2);
            e5(this, "destroy", st2);
          }
        }
        setSize(J2, Y2, st2) {
          let nt2 = this, ot2 = nt2.renderer;
          nt2.isResizing += 1, b5(st2, nt2);
          let ut2 = ot2.globalAnimation;
          nt2.oldChartHeight = nt2.chartHeight, nt2.oldChartWidth = nt2.chartWidth, J2 !== void 0 && (nt2.options.chart.width = J2), Y2 !== void 0 && (nt2.options.chart.height = Y2), nt2.getChartSize();
          let { chartWidth: dt2, chartHeight: ct2, scrollablePixelsX: gt2 = 0, scrollablePixelsY: ft2 = 0 } = nt2;
          (nt2.isDirtyBox || dt2 !== nt2.oldChartWidth || ct2 !== nt2.oldChartHeight) && (nt2.styledMode || (ut2 ? o2 : a2)(nt2.container, { width: `${dt2 + gt2}px`, height: `${ct2 + ft2}px` }, ut2), nt2.setChartSize(true), ot2.setSize(dt2, ct2, ut2), nt2.axes.forEach(function(pt2) {
            pt2.isDirty = true, pt2.setScale();
          }), nt2.isDirtyLegend = true, nt2.isDirtyBox = true, nt2.layOutTitles(), nt2.getMargins(), nt2.redraw(ut2), nt2.oldChartHeight = void 0, z2(nt2, "resize"), setTimeout(() => {
            nt2 && z2(nt2, "endResize");
          }, p2(ut2).duration)), nt2.isResizing -= 1;
        }
        setChartSize(J2) {
          let Y2, st2, nt2, ot2, { chartHeight: ut2, chartWidth: dt2, inverted: ct2, spacing: gt2, renderer: ft2 } = this, pt2 = this.clipOffset, mt2 = Math[ct2 ? "floor" : "round"];
          this.plotLeft = Y2 = Math.round(this.plotLeft), this.plotTop = st2 = Math.round(this.plotTop), this.plotWidth = nt2 = Math.max(0, Math.round(dt2 - Y2 - this.marginRight)), this.plotHeight = ot2 = Math.max(0, Math.round(ut2 - st2 - this.marginBottom)), this.plotSizeX = ct2 ? ot2 : nt2, this.plotSizeY = ct2 ? nt2 : ot2, this.spacingBox = ft2.spacingBox = { x: gt2[3], y: gt2[0], width: dt2 - gt2[3] - gt2[1], height: ut2 - gt2[0] - gt2[2] }, this.plotBox = ft2.plotBox = { x: Y2, y: st2, width: nt2, height: ot2 }, pt2 && (this.clipBox = { x: mt2(pt2[3]), y: mt2(pt2[0]), width: mt2(this.plotSizeX - pt2[1] - pt2[3]), height: mt2(this.plotSizeY - pt2[0] - pt2[2]) }), J2 || (this.axes.forEach(function(yt2) {
            yt2.setAxisSize(), yt2.setAxisTranslation();
          }), ft2.alignElements()), z2(this, "afterSetChartSize", { skipAxes: J2 });
        }
        resetMargins() {
          z2(this, "resetMargins");
          let J2 = this, Y2 = J2.options.chart, st2 = Y2.plotBorderWidth || 0, nt2 = st2 / 2;
          ["margin", "spacing"].forEach(function(ot2) {
            let ut2 = Y2[ot2], dt2 = P2(ut2) ? ut2 : [ut2, ut2, ut2, ut2];
            ["Top", "Right", "Bottom", "Left"].forEach(function(ct2, gt2) {
              J2[ot2][gt2] = D2(Y2[ot2 + ct2], dt2[gt2]);
            });
          }), l4.forEach(function(ot2, ut2) {
            J2[ot2] = D2(J2.margin[ut2], J2.spacing[ut2]);
          }), J2.axisOffset = [0, 0, 0, 0], J2.clipOffset = [nt2, nt2, nt2, nt2], J2.plotBorderWidth = st2;
        }
        drawChartBox() {
          let J2 = this.options.chart, Y2 = this.renderer, st2 = this.chartWidth, nt2 = this.chartHeight, ot2 = this.styledMode, ut2 = this.plotBGImage, dt2 = J2.backgroundColor, ct2 = J2.plotBackgroundColor, gt2 = J2.plotBackgroundImage, ft2 = this.plotLeft, pt2 = this.plotTop, mt2 = this.plotWidth, yt2 = this.plotHeight, vt2 = this.plotBox, bt2 = this.clipRect, xt2 = this.clipBox, Ct2 = this.chartBackground, wt2 = this.plotBackground, kt2 = this.plotBorder, St2, Tt2, Et2, Ot2 = "animate";
          Ct2 || (this.chartBackground = Ct2 = Y2.rect().addClass("highcharts-background").add(), Ot2 = "attr"), ot2 ? St2 = Tt2 = Ct2.strokeWidth() : (Tt2 = (St2 = J2.borderWidth || 0) + (J2.shadow ? 8 : 0), Et2 = { fill: dt2 || "none" }, (St2 || Ct2["stroke-width"]) && (Et2.stroke = J2.borderColor, Et2["stroke-width"] = St2), Ct2.attr(Et2).shadow(J2.shadow)), Ct2[Ot2]({ x: Tt2 / 2, y: Tt2 / 2, width: st2 - Tt2 - St2 % 2, height: nt2 - Tt2 - St2 % 2, r: J2.borderRadius }), Ot2 = "animate", wt2 || (Ot2 = "attr", this.plotBackground = wt2 = Y2.rect().addClass("highcharts-plot-background").add()), wt2[Ot2](vt2), !ot2 && (wt2.attr({ fill: ct2 || "none" }).shadow(J2.plotShadow), gt2 && (ut2 ? (gt2 !== ut2.attr("href") && ut2.attr("href", gt2), ut2.animate(vt2)) : this.plotBGImage = Y2.image(gt2, ft2, pt2, mt2, yt2).add())), bt2 ? bt2.animate({ width: xt2.width, height: xt2.height }) : this.clipRect = Y2.clipRect(xt2), Ot2 = "animate", kt2 || (Ot2 = "attr", this.plotBorder = kt2 = Y2.rect().addClass("highcharts-plot-border").attr({ zIndex: 1 }).add()), ot2 || kt2.attr({ stroke: J2.plotBorderColor, "stroke-width": J2.plotBorderWidth || 0, fill: "none" }), kt2[Ot2](kt2.crisp({ x: ft2, y: pt2, width: mt2, height: yt2 }, -kt2.strokeWidth())), this.isDirtyBox = false, z2(this, "afterDrawChartBox");
        }
        propFromSeries() {
          let J2, Y2, st2, nt2 = this, ot2 = nt2.options.chart, ut2 = nt2.options.series;
          ["inverted", "angular", "polar"].forEach(function(dt2) {
            for (Y2 = t3[ot2.type], st2 = ot2[dt2] || Y2 && Y2.prototype[dt2], J2 = ut2 && ut2.length; !st2 && J2--; ) (Y2 = t3[ut2[J2].type]) && Y2.prototype[dt2] && (st2 = true);
            nt2[dt2] = st2;
          });
        }
        linkSeries(J2) {
          let Y2 = this, st2 = Y2.series;
          st2.forEach(function(nt2) {
            nt2.linkedSeries.length = 0;
          }), st2.forEach(function(nt2) {
            let { linkedTo: ot2 } = nt2.options;
            if (U2(ot2)) {
              let ut2;
              (ut2 = ot2 === ":previous" ? Y2.series[nt2.index - 1] : Y2.get(ot2)) && ut2.linkedParent !== nt2 && (ut2.linkedSeries.push(nt2), nt2.linkedParent = ut2, ut2.enabledDataSorting && nt2.setDataSortingOptions(), nt2.visible = D2(nt2.options.visible, ut2.options.visible, nt2.visible));
            }
          }), z2(this, "afterLinkSeries", { isUpdating: J2 });
        }
        renderSeries() {
          this.series.forEach(function(J2) {
            J2.translate(), J2.render();
          });
        }
        render() {
          var J2;
          let Y2 = this.axes, st2 = this.colorAxis, nt2 = this.renderer, ot2 = this.options.chart.axisLayoutRuns || 2, ut2 = (pt2) => {
            pt2.forEach((mt2) => {
              mt2.visible && mt2.render();
            });
          }, dt2 = 0, ct2 = true, gt2, ft2 = 0;
          for (let pt2 of (this.setTitle(), z2(this, "beforeMargins"), (J2 = this.getStacks) == null || J2.call(this), this.getMargins(true), this.setChartSize(), Y2)) {
            let { options: mt2 } = pt2, { labels: yt2 } = mt2;
            if (this.hasCartesianSeries && pt2.horiz && pt2.visible && yt2.enabled && pt2.series.length && pt2.coll !== "colorAxis" && !this.polar) {
              dt2 = mt2.tickLength, pt2.createGroups();
              let vt2 = new C3(pt2, 0, "", true), bt2 = vt2.createLabel("x", yt2);
              if (vt2.destroy(), bt2 && D2(yt2.reserveSpace, !S2(mt2.crossing)) && (dt2 = bt2.getBBox().height + yt2.distance + Math.max(mt2.offset || 0, 0)), dt2) {
                bt2 == null || bt2.destroy();
                break;
              }
            }
          }
          for (this.plotHeight = Math.max(this.plotHeight - dt2, 0); (ct2 || gt2 || ot2 > 1) && ft2 < ot2; ) {
            let pt2 = this.plotWidth, mt2 = this.plotHeight;
            for (let yt2 of Y2) ft2 === 0 ? yt2.setScale() : (yt2.horiz && ct2 || !yt2.horiz && gt2) && yt2.setTickInterval(true);
            ft2 === 0 ? this.getAxisMargins() : this.getMargins(), ct2 = pt2 / this.plotWidth > (ft2 ? 1 : 1.1), gt2 = mt2 / this.plotHeight > (ft2 ? 1 : 1.05), ft2++;
          }
          this.drawChartBox(), this.hasCartesianSeries ? ut2(Y2) : st2 && st2.length && ut2(st2), this.seriesGroup || (this.seriesGroup = nt2.g("series-group").attr({ zIndex: 3 }).shadow(this.options.chart.seriesGroupShadow).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = true;
        }
        addCredits(J2) {
          let Y2 = this, st2 = w2(true, this.options.credits, J2);
          st2.enabled && !this.credits && (this.credits = this.renderer.text(st2.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
            st2.href && (i5.location.href = st2.href);
          }).attr({ align: st2.position.align, zIndex: 8 }), Y2.styledMode || this.credits.css(st2.style), this.credits.add().align(st2.position), this.credits.update = function(nt2) {
            Y2.credits = Y2.credits.destroy(), Y2.addCredits(nt2);
          });
        }
        destroy() {
          let J2, Y2 = this, st2 = Y2.axes, nt2 = Y2.series, ot2 = Y2.container, ut2 = ot2 && ot2.parentNode;
          for (z2(Y2, "destroy"), Y2.renderer.forExport ? N2(G2, Y2) : G2[Y2.index] = void 0, tt2.chartCount--, Y2.renderTo.removeAttribute("data-highcharts-chart"), W2(Y2), J2 = st2.length; J2--; ) st2[J2] = st2[J2].destroy();
          for (this.scroller && this.scroller.destroy && this.scroller.destroy(), J2 = nt2.length; J2--; ) nt2[J2] = nt2[J2].destroy();
          ["title", "subtitle", "chartBackground", "plotBackground", "plotBGImage", "plotBorder", "seriesGroup", "clipRect", "credits", "pointer", "rangeSelector", "legend", "resetZoomButton", "tooltip", "renderer"].forEach(function(dt2) {
            let ct2 = Y2[dt2];
            ct2 && ct2.destroy && (Y2[dt2] = ct2.destroy());
          }), ot2 && (ot2.innerHTML = f2.emptyHTML, W2(ot2), ut2 && A3(ot2)), M2(Y2, function(dt2, ct2) {
            delete Y2[ct2];
          });
        }
        firstRender() {
          var J2;
          let Y2 = this, st2 = Y2.options;
          Y2.getContainer(), Y2.resetMargins(), Y2.setChartSize(), Y2.propFromSeries(), Y2.getAxes();
          let nt2 = v3(st2.series) ? st2.series : [];
          st2.series = [], nt2.forEach(function(ot2) {
            Y2.initSeries(ot2);
          }), Y2.linkSeries(), Y2.setSortedData(), z2(Y2, "beforeRender"), Y2.render(), (J2 = Y2.pointer) == null || J2.getChartPosition(), Y2.renderer.imgCount || Y2.hasLoaded || Y2.onload(), Y2.temporaryDisplay(true);
        }
        onload() {
          this.callbacks.concat([this.callback]).forEach(function(J2) {
            J2 && this.index !== void 0 && J2.apply(this, [this]);
          }, this), z2(this, "load"), z2(this, "render"), g2(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = true;
        }
        warnIfA11yModuleNotLoaded() {
          let { options: J2, title: Y2 } = this;
          !J2 || this.accessibility || (this.renderer.boxWrapper.attr({ role: "img", "aria-label": (Y2 && Y2.element.textContent || "").replace(/</g, "&lt;") }), J2.accessibility && J2.accessibility.enabled === false || k3('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', false, this));
        }
        addSeries(J2, Y2, st2) {
          let nt2, ot2 = this;
          return J2 && (Y2 = D2(Y2, true), z2(ot2, "addSeries", { options: J2 }, function() {
            nt2 = ot2.initSeries(J2), ot2.isDirtyLegend = true, ot2.linkSeries(), nt2.enabledDataSorting && nt2.setData(J2.data, false), z2(ot2, "afterAddSeries", { series: nt2 }), Y2 && ot2.redraw(st2);
          })), nt2;
        }
        addAxis(J2, Y2, st2, nt2) {
          return this.createAxis(Y2 ? "xAxis" : "yAxis", { axis: J2, redraw: st2, animation: nt2 });
        }
        addColorAxis(J2, Y2, st2) {
          return this.createAxis("colorAxis", { axis: J2, redraw: Y2, animation: st2 });
        }
        createAxis(J2, Y2) {
          let st2 = new K2(this, Y2.axis, J2);
          return D2(Y2.redraw, true) && this.redraw(Y2.animation), st2;
        }
        showLoading(J2) {
          let Y2 = this, st2 = Y2.options, nt2 = st2.loading, ot2 = function() {
            ut2 && a2(ut2, { left: Y2.plotLeft + "px", top: Y2.plotTop + "px", width: Y2.plotWidth + "px", height: Y2.plotHeight + "px" });
          }, ut2 = Y2.loadingDiv, dt2 = Y2.loadingSpan;
          ut2 || (Y2.loadingDiv = ut2 = u2("div", { className: "highcharts-loading highcharts-loading-hidden" }, null, Y2.container)), dt2 || (Y2.loadingSpan = dt2 = u2("span", { className: "highcharts-loading-inner" }, null, ut2), e5(Y2, "redraw", ot2)), ut2.className = "highcharts-loading", f2.setElementHTML(dt2, D2(J2, st2.lang.loading, "")), Y2.styledMode || (a2(ut2, E2(nt2.style, { zIndex: 10 })), a2(dt2, nt2.labelStyle), Y2.loadingShown || (a2(ut2, { opacity: 0, display: "" }), o2(ut2, { opacity: nt2.style.opacity || 0.5 }, { duration: nt2.showDuration || 0 }))), Y2.loadingShown = true, ot2();
        }
        hideLoading() {
          let J2 = this.options, Y2 = this.loadingDiv;
          Y2 && (Y2.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || o2(Y2, { opacity: 0 }, { duration: J2.loading.hideDuration || 100, complete: function() {
            a2(Y2, { display: "none" });
          } })), this.loadingShown = false;
        }
        update(J2, Y2, st2, nt2) {
          let ot2, ut2, dt2, ct2 = this, gt2 = { credits: "addCredits", title: "setTitle", subtitle: "setSubtitle", caption: "setCaption" }, ft2 = J2.isResponsiveOptions, pt2 = [];
          z2(ct2, "update", { options: J2 }), ft2 || ct2.setResponsive(false, true), J2 = r3(J2, ct2.options), ct2.userOptions = w2(ct2.userOptions, J2);
          let mt2 = J2.chart;
          mt2 && (w2(true, ct2.options.chart, mt2), this.setZoomOptions(), "className" in mt2 && ct2.setClassName(mt2.className), ("inverted" in mt2 || "polar" in mt2 || "type" in mt2) && (ct2.propFromSeries(), ot2 = true), "alignTicks" in mt2 && (ot2 = true), "events" in mt2 && I3(this, mt2), M2(mt2, function(bt2, xt2) {
            ct2.propsRequireUpdateSeries.indexOf("chart." + xt2) !== -1 && (ut2 = true), ct2.propsRequireDirtyBox.indexOf(xt2) !== -1 && (ct2.isDirtyBox = true), ct2.propsRequireReflow.indexOf(xt2) === -1 || (ct2.isDirtyBox = true, ft2 || (dt2 = true));
          }), !ct2.styledMode && mt2.style && ct2.renderer.setStyle(ct2.options.chart.style || {})), !ct2.styledMode && J2.colors && (this.options.colors = J2.colors), J2.time && (this.time === c4 && (this.time = new d3(J2.time)), w2(true, ct2.options.time, J2.time)), M2(J2, function(bt2, xt2) {
            ct2[xt2] && typeof ct2[xt2].update == "function" ? ct2[xt2].update(bt2, false) : typeof ct2[gt2[xt2]] == "function" ? ct2[gt2[xt2]](bt2) : xt2 !== "colors" && ct2.collectionsWithUpdate.indexOf(xt2) === -1 && w2(true, ct2.options[xt2], J2[xt2]), xt2 !== "chart" && ct2.propsRequireUpdateSeries.indexOf(xt2) !== -1 && (ut2 = true);
          }), this.collectionsWithUpdate.forEach(function(bt2) {
            J2[bt2] && (V2(J2[bt2]).forEach(function(xt2, Ct2) {
              let wt2, kt2 = g2(xt2.id);
              kt2 && (wt2 = ct2.get(xt2.id)), !wt2 && ct2[bt2] && (wt2 = ct2[bt2][D2(xt2.index, Ct2)]) && (kt2 && g2(wt2.options.id) || wt2.options.isInternal) && (wt2 = void 0), wt2 && wt2.coll === bt2 && (wt2.update(xt2, false), st2 && (wt2.touched = true)), !wt2 && st2 && ct2.collectionsWithInit[bt2] && (ct2.collectionsWithInit[bt2][0].apply(ct2, [xt2].concat(ct2.collectionsWithInit[bt2][1] || []).concat([false])).touched = true);
            }), st2 && ct2[bt2].forEach(function(xt2) {
              xt2.touched || xt2.options.isInternal ? delete xt2.touched : pt2.push(xt2);
            }));
          }), pt2.forEach(function(bt2) {
            bt2.chart && bt2.remove && bt2.remove(false);
          }), ot2 && ct2.axes.forEach(function(bt2) {
            bt2.update({}, false);
          }), ut2 && ct2.getSeriesOrderByLinks().forEach(function(bt2) {
            bt2.chart && bt2.update({}, false);
          }, this);
          let yt2 = mt2 && mt2.width, vt2 = mt2 && (U2(mt2.height) ? $2(mt2.height, yt2 || ct2.chartWidth) : mt2.height);
          dt2 || S2(yt2) && yt2 !== ct2.chartWidth || S2(vt2) && vt2 !== ct2.chartHeight ? ct2.setSize(yt2, vt2, nt2) : D2(Y2, true) && ct2.redraw(nt2), z2(ct2, "afterUpdate", { options: J2, redraw: Y2, animation: nt2 });
        }
        setSubtitle(J2, Y2) {
          this.applyDescription("subtitle", J2), this.layOutTitles(Y2);
        }
        setCaption(J2, Y2) {
          this.applyDescription("caption", J2), this.layOutTitles(Y2);
        }
        showResetZoom() {
          let J2 = this, Y2 = h2.lang, st2 = J2.zooming.resetButton, nt2 = st2.theme, ot2 = st2.relativeTo === "chart" || st2.relativeTo === "spacingBox" ? null : "plotBox";
          function ut2() {
            J2.zoomOut();
          }
          z2(this, "beforeShowResetZoom", null, function() {
            J2.resetZoomButton = J2.renderer.button(Y2.resetZoom, null, null, ut2, nt2).attr({ align: st2.position.align, title: Y2.resetZoomTitle }).addClass("highcharts-reset-zoom").add().align(st2.position, false, ot2);
          }), z2(this, "afterShowResetZoom");
        }
        zoomOut() {
          z2(this, "selection", { resetSelection: true }, () => this.transform({ reset: true, trigger: "zoom" }));
        }
        pan(J2, Y2) {
          let st2 = this, nt2 = typeof Y2 == "object" ? Y2 : { enabled: Y2, type: "x" }, ot2 = nt2.type, ut2 = ot2 && st2[{ x: "xAxis", xy: "axes", y: "yAxis" }[ot2]].filter((ct2) => ct2.options.panningEnabled && !ct2.options.isInternal), dt2 = st2.options.chart;
          dt2 != null && dt2.panning && (dt2.panning = nt2), z2(this, "pan", { originalEvent: J2 }, () => {
            st2.transform({ axes: ut2, event: J2, to: { x: J2.chartX - (st2.mouseDownX || 0), y: J2.chartY - (st2.mouseDownY || 0) }, trigger: "pan" }), a2(st2.container, { cursor: "move" });
          });
        }
        transform(J2) {
          var Y2, st2, nt2, ot2, ut2;
          let { axes: dt2 = this.axes, event: ct2, from: gt2 = {}, reset: ft2, selection: pt2, to: mt2 = {}, trigger: yt2 } = J2, { inverted: vt2 } = this, bt2 = false, xt2, Ct2;
          for (let wt2 of ((Y2 = this.hoverPoints) == null || Y2.forEach((kt2) => kt2.setState()), dt2)) {
            let { horiz: kt2, len: St2, minPointOffset: Tt2 = 0, options: Et2, reversed: Ot2 } = wt2, It2 = kt2 ? "width" : "height", Xt2 = kt2 ? "x" : "y", _t2 = D2(mt2[It2], wt2.len), Gt2 = D2(gt2[It2], wt2.len), Bt2 = 10 > Math.abs(_t2) ? 1 : _t2 / Gt2, Me2 = (gt2[Xt2] || 0) + Gt2 / 2 - wt2.pos, Ee2 = Me2 - (((st2 = mt2[Xt2]) != null ? st2 : wt2.pos) + _t2 / 2 - wt2.pos) / Bt2, ri = Ot2 && !vt2 || !Ot2 && vt2 ? -1 : 1;
            if (!ft2 && (Me2 < 0 || Me2 > wt2.len)) continue;
            let jt2 = wt2.toValue(Ee2, true) + (pt2 || wt2.isOrdinal ? 0 : Tt2 * ri), Nt2 = wt2.toValue(Ee2 + St2 / Bt2, true) - (pt2 || wt2.isOrdinal ? 0 : Tt2 * ri || 0), Ut2 = wt2.allExtremes;
            if (jt2 > Nt2 && ([jt2, Nt2] = [Nt2, jt2]), Bt2 === 1 && !ft2 && wt2.coll === "yAxis" && !Ut2) {
              for (let pi of wt2.series) {
                let fe2 = pi.getExtremes(pi.getProcessedData(true).yData, true);
                Ut2 != null || (Ut2 = { dataMin: Number.MAX_VALUE, dataMax: -Number.MAX_VALUE }), S2(fe2.dataMin) && S2(fe2.dataMax) && (Ut2.dataMin = Math.min(fe2.dataMin, Ut2.dataMin), Ut2.dataMax = Math.max(fe2.dataMax, Ut2.dataMax));
              }
              wt2.allExtremes = Ut2;
            }
            let { dataMin: ni, dataMax: oi, min: ai, max: li } = E2(wt2.getExtremes(), Ut2 || {}), hi = ni != null ? ni : Et2.min, ci = oi != null ? oi : Et2.max, Pe2 = Nt2 - jt2, di = wt2.categories ? 0 : Math.min(Pe2, ci - hi), Le3 = hi - di * (g2(Et2.min) ? 0 : Et2.minPadding), Oe2 = ci + di * (g2(Et2.max) ? 0 : Et2.maxPadding), ui = wt2.allowZoomOutside || Bt2 === 1 || yt2 !== "zoom" && Bt2 > 1, pe2 = Math.min((nt2 = Et2.min) != null ? nt2 : Le3, Le3, ui ? ai : Le3), ge2 = Math.max((ot2 = Et2.max) != null ? ot2 : Oe2, Oe2, ui ? li : Oe2);
            (!wt2.isOrdinal || wt2.options.overscroll || Bt2 !== 1 || ft2) && (jt2 < pe2 && (jt2 = pe2, Bt2 >= 1 && (Nt2 = jt2 + Pe2)), Nt2 > ge2 && (Nt2 = ge2, Bt2 >= 1 && (jt2 = Nt2 - Pe2)), (ft2 || wt2.series.length && (jt2 !== ai || Nt2 !== li) && jt2 >= pe2 && Nt2 <= ge2) && (pt2 ? pt2[wt2.coll].push({ axis: wt2, min: jt2, max: Nt2 }) : (wt2.isPanning = yt2 !== "zoom", wt2.isPanning && (Ct2 = true), wt2.setExtremes(ft2 ? void 0 : jt2, ft2 ? void 0 : Nt2, false, false, { move: Ee2, trigger: yt2, scale: Bt2 }), !ft2 && (jt2 > pe2 || Nt2 < ge2) && yt2 !== "mousewheel" && (xt2 = true)), bt2 = true), ct2 && (this[kt2 ? "mouseDownX" : "mouseDownY"] = ct2[kt2 ? "chartX" : "chartY"]));
          }
          return bt2 && (pt2 ? z2(this, "selection", pt2, () => {
            delete J2.selection, J2.trigger = "zoom", this.transform(J2);
          }) : (!xt2 || Ct2 || this.resetZoomButton ? !xt2 && this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy()) : this.showResetZoom(), this.redraw(yt2 === "zoom" && ((ut2 = this.options.chart.animation) != null ? ut2 : this.pointCount < 100)))), bt2;
        }
      }
      return E2(lt2.prototype, { callbacks: [], collectionsWithInit: { xAxis: [lt2.prototype.addAxis, [true]], yAxis: [lt2.prototype.addAxis, [false]], series: [lt2.prototype.addSeries] }, collectionsWithUpdate: ["xAxis", "yAxis", "series"], propsRequireDirtyBox: ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "plotBackgroundColor", "plotBackgroundImage", "plotBorderColor", "plotBorderWidth", "plotShadow", "shadow"], propsRequireReflow: ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "spacing", "spacingTop", "spacingRight", "spacingBottom", "spacingLeft"], propsRequireUpdateSeries: ["chart.inverted", "chart.polar", "chart.ignoreHiddenSeries", "chart.type", "colors", "plotOptions", "time", "tooltip"] }), lt2;
    }), at2(s2, "Extensions/ScrollablePlotArea.js", [s2["Core/Animation/AnimationUtilities.js"], s2["Core/Globals.js"], s2["Core/Renderer/RendererRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2) {
      let { stop: rt2 } = B3, { composed: tt2 } = K2, { addEvent: Z2, createElement: X2, css: O3, defined: j3, merge: d3, pushUnique: x2 } = it2;
      function f2() {
        let p2 = this.scrollablePlotArea;
        (this.scrollablePixelsX || this.scrollablePixelsY) && !p2 && (this.scrollablePlotArea = p2 = new o2(this)), p2 == null || p2.applyFixed();
      }
      function C3() {
        this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = true);
      }
      class o2 {
        static compose(b5, h2, c4) {
          x2(tt2, this.compose) && (Z2(b5, "afterInit", C3), Z2(h2, "afterSetChartSize", (T2) => this.afterSetSize(T2.target, T2)), Z2(h2, "render", f2), Z2(c4, "show", C3));
        }
        static afterSetSize(b5, h2) {
          let c4, T2, I3, { minWidth: G2, minHeight: L2 } = b5.options.chart.scrollablePlotArea || {}, { clipBox: l4, plotBox: y2, inverted: i5, renderer: t3 } = b5;
          if (!t3.forExport && (G2 ? (b5.scrollablePixelsX = c4 = Math.max(0, G2 - b5.chartWidth), c4 && (b5.scrollablePlotBox = d3(b5.plotBox), y2.width = b5.plotWidth += c4, l4[i5 ? "height" : "width"] += c4, I3 = true)) : L2 && (b5.scrollablePixelsY = T2 = Math.max(0, L2 - b5.chartHeight), j3(T2) && (b5.scrollablePlotBox = d3(b5.plotBox), y2.height = b5.plotHeight += T2, l4[i5 ? "width" : "height"] += T2, I3 = false)), j3(I3) && !h2.skipAxes)) for (let e5 of b5.axes) e5.horiz === I3 && (e5.setAxisSize(), e5.setAxisTranslation());
        }
        constructor(b5) {
          var h2, c4;
          let T2, I3 = b5.options.chart, G2 = q2.getRendererType(), L2 = I3.scrollablePlotArea || {}, l4 = this.moveFixedElements.bind(this), y2 = { WebkitOverflowScrolling: "touch", overflowX: "hidden", overflowY: "hidden" };
          b5.scrollablePixelsX && (y2.overflowX = "auto"), b5.scrollablePixelsY && (y2.overflowY = "auto"), this.chart = b5;
          let i5 = this.parentDiv = X2("div", { className: "highcharts-scrolling-parent" }, { position: "relative" }, b5.renderTo), t3 = this.scrollingContainer = X2("div", { className: "highcharts-scrolling" }, y2, i5), e5 = this.innerContainer = X2("div", { className: "highcharts-inner-container" }, void 0, t3), n4 = this.fixedDiv = X2("div", { className: "highcharts-fixed" }, { position: "absolute", overflow: "hidden", pointerEvents: "none", zIndex: (((h2 = I3.style) == null ? void 0 : h2.zIndex) || 0) + 2, top: 0 }, void 0, true), u2 = this.fixedRenderer = new G2(n4, b5.chartWidth, b5.chartHeight, I3.style);
          this.mask = u2.path().attr({ fill: I3.backgroundColor || "#fff", "fill-opacity": (c4 = L2.opacity) != null ? c4 : 0.85, zIndex: -1 }).addClass("highcharts-scrollable-mask").add(), t3.parentNode.insertBefore(n4, t3), O3(b5.renderTo, { overflow: "visible" }), Z2(b5, "afterShowResetZoom", l4), Z2(b5, "afterApplyDrilldown", l4), Z2(b5, "afterLayOutTitles", l4), Z2(t3, "scroll", () => {
            let { pointer: a2, hoverPoint: g2 } = b5;
            a2 && (delete a2.chartPosition, g2 && (T2 = g2), a2.runPointActions(void 0, T2, true));
          }), e5.appendChild(b5.container);
        }
        applyFixed() {
          var b5;
          let { chart: h2, fixedRenderer: c4, isDirty: T2, scrollingContainer: I3 } = this, { axisOffset: G2, chartWidth: L2, chartHeight: l4, container: y2, plotHeight: i5, plotLeft: t3, plotTop: e5, plotWidth: n4, scrollablePixelsX: u2 = 0, scrollablePixelsY: a2 = 0 } = h2, { scrollPositionX: g2 = 0, scrollPositionY: r3 = 0 } = h2.options.chart.scrollablePlotArea || {}, A3 = L2 + u2, N2 = l4 + a2;
          c4.setSize(L2, l4), (T2 == null || T2) && (this.isDirty = false, this.moveFixedElements()), rt2(h2.container), O3(y2, { width: `${A3}px`, height: `${N2}px` }), h2.renderer.boxWrapper.attr({ width: A3, height: N2, viewBox: [0, 0, A3, N2].join(" ") }), (b5 = h2.chartBackground) == null || b5.attr({ width: A3, height: N2 }), O3(I3, { width: `${L2}px`, height: `${l4}px` }), j3(T2) || (I3.scrollLeft = u2 * g2, I3.scrollTop = a2 * r3);
          let k3 = e5 - G2[0] - 1, E2 = t3 - G2[3] - 1, R2 = e5 + i5 + G2[2] + 1, z2 = t3 + n4 + G2[1] + 1, Q2 = t3 + n4 - u2, v3 = e5 + i5 - a2, S2 = [["M", 0, 0]];
          u2 ? S2 = [["M", 0, k3], ["L", t3 - 1, k3], ["L", t3 - 1, R2], ["L", 0, R2], ["Z"], ["M", Q2, k3], ["L", L2, k3], ["L", L2, R2], ["L", Q2, R2], ["Z"]] : a2 && (S2 = [["M", E2, 0], ["L", E2, e5 - 1], ["L", z2, e5 - 1], ["L", z2, 0], ["Z"], ["M", E2, v3], ["L", E2, l4], ["L", z2, l4], ["L", z2, v3], ["Z"]]), h2.redrawTrigger !== "adjustHeight" && this.mask.attr({ d: S2 });
        }
        moveFixedElements() {
          let b5, { container: h2, inverted: c4, scrollablePixelsX: T2, scrollablePixelsY: I3 } = this.chart, G2 = this.fixedRenderer, L2 = o2.fixedSelectors;
          for (let l4 of (T2 && !c4 ? b5 = ".highcharts-yaxis" : T2 && c4 || I3 && !c4 ? b5 = ".highcharts-xaxis" : I3 && c4 && (b5 = ".highcharts-yaxis"), b5 && L2.push(`${b5}:not(.highcharts-radial-axis)`, `${b5}-labels:not(.highcharts-radial-axis-labels)`), L2)) [].forEach.call(h2.querySelectorAll(l4), (y2) => {
            (y2.namespaceURI === G2.SVG_NS ? G2.box : G2.box.parentNode).appendChild(y2), y2.style.pointerEvents = "auto";
          });
        }
      }
      return o2.fixedSelectors = [".highcharts-breadcrumbs-group", ".highcharts-contextbutton", ".highcharts-caption", ".highcharts-credits", ".highcharts-drillup-button", ".highcharts-legend", ".highcharts-legend-checkbox", ".highcharts-navigator-series", ".highcharts-navigator-xaxis", ".highcharts-navigator-yaxis", ".highcharts-navigator", ".highcharts-range-selector-group", ".highcharts-reset-zoom", ".highcharts-scrollbar", ".highcharts-subtitle", ".highcharts-title"], o2;
    }), at2(s2, "Core/Axis/Stacking/StackItem.js", [s2["Core/Templating.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { format: it2 } = B3, { series: rt2 } = K2, { destroyObjectProperties: tt2, fireEvent: Z2, isNumber: X2, pick: O3 } = q2;
      return class {
        constructor(j3, d3, x2, f2, C3) {
          let o2 = j3.chart.inverted, p2 = j3.reversed;
          this.axis = j3;
          let b5 = this.isNegative = !!x2 != !!p2;
          this.options = d3 = d3 || {}, this.x = f2, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = false, this.stack = C3, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = { align: d3.align || (o2 ? b5 ? "left" : "right" : "center"), verticalAlign: d3.verticalAlign || (o2 ? "middle" : b5 ? "bottom" : "top"), y: d3.y, x: d3.x }, this.textAlign = d3.textAlign || (o2 ? b5 ? "right" : "left" : "center");
        }
        destroy() {
          tt2(this, this.axis);
        }
        render(j3) {
          let d3 = this.axis.chart, x2 = this.options, f2 = x2.format, C3 = f2 ? it2(f2, this, d3) : x2.formatter.call(this);
          if (this.label) this.label.attr({ text: C3, visibility: "hidden" });
          else {
            this.label = d3.renderer.label(C3, null, void 0, x2.shape, void 0, void 0, x2.useHTML, false, "stack-labels");
            let o2 = { r: x2.borderRadius || 0, text: C3, padding: O3(x2.padding, 5), visibility: "hidden" };
            d3.styledMode || (o2.fill = x2.backgroundColor, o2.stroke = x2.borderColor, o2["stroke-width"] = x2.borderWidth, this.label.css(x2.style || {})), this.label.attr(o2), this.label.added || this.label.add(j3);
          }
          this.label.labelrank = d3.plotSizeY, Z2(this, "afterRender");
        }
        setOffset(j3, d3, x2, f2, C3, o2) {
          let { alignOptions: p2, axis: b5, label: h2, options: c4, textAlign: T2 } = this, I3 = b5.chart, G2 = this.getStackBox({ xOffset: j3, width: d3, boxBottom: x2, boxTop: f2, defaultX: C3, xAxis: o2 }), { verticalAlign: L2 } = p2;
          if (h2 && G2) {
            let l4 = h2.getBBox(void 0, 0), y2 = h2.padding, i5 = O3(c4.overflow, "justify") === "justify", t3;
            p2.x = c4.x || 0, p2.y = c4.y || 0;
            let { x: e5, y: n4 } = this.adjustStackPosition({ labelBox: l4, verticalAlign: L2, textAlign: T2 });
            G2.x -= e5, G2.y -= n4, h2.align(p2, false, G2), (t3 = I3.isInsidePlot(h2.alignAttr.x + p2.x + e5, h2.alignAttr.y + p2.y + n4)) || (i5 = false), i5 && rt2.prototype.justifyDataLabel.call(b5, h2, p2, h2.alignAttr, l4, G2), h2.attr({ x: h2.alignAttr.x, y: h2.alignAttr.y, rotation: c4.rotation, rotationOriginX: l4.width * { left: 0, center: 0.5, right: 1 }[c4.textAlign || "center"], rotationOriginY: l4.height / 2 }), O3(!i5 && c4.crop, true) && (t3 = X2(h2.x) && X2(h2.y) && I3.isInsidePlot(h2.x - y2 + (h2.width || 0), h2.y) && I3.isInsidePlot(h2.x + y2, h2.y)), h2[t3 ? "show" : "hide"]();
          }
          Z2(this, "afterSetOffset", { xOffset: j3, width: d3 });
        }
        adjustStackPosition({ labelBox: j3, verticalAlign: d3, textAlign: x2 }) {
          let f2 = { bottom: 0, middle: 1, top: 2, right: 1, center: 0, left: -1 }, C3 = f2[d3], o2 = f2[x2];
          return { x: j3.width / 2 + j3.width / 2 * o2, y: j3.height / 2 * C3 };
        }
        getStackBox(j3) {
          let d3 = this.axis, x2 = d3.chart, { boxTop: f2, defaultX: C3, xOffset: o2, width: p2, boxBottom: b5 } = j3, h2 = d3.stacking.usePercentage ? 100 : O3(f2, this.total, 0), c4 = d3.toPixels(h2), T2 = j3.xAxis || x2.xAxis[0], I3 = O3(C3, T2.translate(this.x)) + o2, G2 = Math.abs(c4 - d3.toPixels(b5 || X2(d3.min) && d3.logarithmic && d3.logarithmic.lin2log(d3.min) || 0)), L2 = x2.inverted, l4 = this.isNegative;
          return L2 ? { x: (l4 ? c4 : c4 - G2) - x2.plotLeft, y: T2.height - I3 - p2 + T2.top - x2.plotTop, width: G2, height: p2 } : { x: I3 + T2.transB - x2.plotLeft, y: (l4 ? c4 - G2 : c4) - x2.plotTop, width: p2, height: G2 };
        }
      };
    }), at2(s2, "Core/Axis/Stacking/StackingAxis.js", [s2["Core/Animation/AnimationUtilities.js"], s2["Core/Axis/Axis.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Axis/Stacking/StackItem.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2) {
      var tt2;
      let { getDeferredAnimation: Z2 } = B3, { series: { prototype: X2 } } = q2, { addEvent: O3, correctFloat: j3, defined: d3, destroyObjectProperties: x2, fireEvent: f2, isArray: C3, isNumber: o2, objectEach: p2, pick: b5 } = rt2;
      function h2() {
        let t3 = this.inverted;
        this.axes.forEach((e5) => {
          e5.stacking && e5.stacking.stacks && e5.hasVisibleSeries && (e5.stacking.oldStacks = e5.stacking.stacks);
        }), this.series.forEach((e5) => {
          let n4 = e5.xAxis && e5.xAxis.options || {};
          e5.options.stacking && e5.reserveSpace() && (e5.stackKey = [e5.type, b5(e5.options.stack, ""), t3 ? n4.top : n4.left, t3 ? n4.height : n4.width].join(","));
        });
      }
      function c4() {
        var t3;
        let e5 = this.stacking;
        if (e5) {
          let n4 = e5.stacks;
          p2(n4, (u2, a2) => {
            x2(u2), delete n4[a2];
          }), (t3 = e5.stackTotalGroup) == null || t3.destroy();
        }
      }
      function T2() {
        this.stacking || (this.stacking = new i5(this));
      }
      function I3(t3, e5, n4, u2) {
        return !d3(t3) || t3.x !== e5 || u2 && t3.stackKey !== u2 ? t3 = { x: e5, index: 0, key: u2, stackKey: u2 } : t3.index++, t3.key = [n4, e5, t3.index].join(","), t3;
      }
      function G2() {
        let t3, e5 = this, n4 = e5.yAxis, u2 = e5.stackKey || "", a2 = n4.stacking.stacks, g2 = e5.processedXData, r3 = e5.options.stacking, A3 = e5[r3 + "Stacker"];
        A3 && [u2, "-" + u2].forEach((N2) => {
          var k3;
          let E2 = g2.length, R2, z2, Q2;
          for (; E2--; ) R2 = g2[E2], t3 = e5.getStackIndicator(t3, R2, e5.index, N2), z2 = (k3 = a2[N2]) == null ? void 0 : k3[R2], (Q2 = z2 == null ? void 0 : z2.points[t3.key || ""]) && A3.call(e5, Q2, z2, E2);
        });
      }
      function L2(t3, e5, n4) {
        let u2 = e5.total ? 100 / e5.total : 0;
        t3[0] = j3(t3[0] * u2), t3[1] = j3(t3[1] * u2), this.stackedYData[n4] = t3[1];
      }
      function l4(t3) {
        (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && !this.options.stacking && this.chart.series.length > 1 ? X2.setStackedPoints.call(this, t3, "group") : t3.stacking.resetStacks());
      }
      function y2(t3, e5) {
        var n4, u2;
        let a2, g2, r3, A3, N2, k3, E2, R2, z2, Q2 = e5 || this.options.stacking;
        if (!Q2 || !this.reserveSpace() || ({ group: "xAxis" }[Q2] || "yAxis") !== t3.coll) return;
        let v3 = this.processedXData, S2 = this.processedYData, P2 = [], U2 = S2.length, w2 = this.options, M2 = w2.threshold || 0, D2 = w2.startFromThreshold ? M2 : 0, F2 = w2.stack, $2 = e5 ? `${this.type},${Q2}` : this.stackKey || "", W2 = "-" + $2, V2 = this.negStacks, _2 = t3.stacking, et2 = _2.stacks, lt2 = _2.oldStacks;
        for (_2.stacksTouched += 1, E2 = 0; E2 < U2; E2++) {
          R2 = v3[E2], z2 = S2[E2], k3 = (a2 = this.getStackIndicator(a2, R2, this.index)).key || "", et2[N2 = (g2 = V2 && z2 < (D2 ? 0 : M2)) ? W2 : $2] || (et2[N2] = {}), et2[N2][R2] || ((n4 = lt2[N2]) != null && n4[R2] ? (et2[N2][R2] = lt2[N2][R2], et2[N2][R2].total = null) : et2[N2][R2] = new it2(t3, t3.options.stackLabels, !!g2, R2, F2)), r3 = et2[N2][R2], z2 !== null ? (r3.points[k3] = r3.points[this.index] = [b5(r3.cumulative, D2)], d3(r3.cumulative) || (r3.base = k3), r3.touched = _2.stacksTouched, a2.index > 0 && this.singleStacks === false && (r3.points[k3][0] = r3.points[this.index + "," + R2 + ",0"][0])) : (delete r3.points[k3], delete r3.points[this.index]);
          let ht2 = r3.total || 0;
          Q2 === "percent" ? (A3 = g2 ? $2 : W2, ht2 = V2 && (u2 = et2[A3]) != null && u2[R2] ? (A3 = et2[A3][R2]).total = Math.max(A3.total || 0, ht2) + Math.abs(z2) || 0 : j3(ht2 + (Math.abs(z2) || 0))) : Q2 === "group" ? (C3(z2) && (z2 = z2[0]), z2 !== null && ht2++) : ht2 = j3(ht2 + (z2 || 0)), Q2 === "group" ? r3.cumulative = (ht2 || 1) - 1 : r3.cumulative = j3(b5(r3.cumulative, D2) + (z2 || 0)), r3.total = ht2, z2 !== null && (r3.points[k3].push(r3.cumulative), P2[E2] = r3.cumulative, r3.hasValidPoints = true);
        }
        Q2 === "percent" && (_2.usePercentage = true), Q2 !== "group" && (this.stackedYData = P2), _2.oldStacks = {};
      }
      class i5 {
        constructor(e5) {
          this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = e5;
        }
        buildStacks() {
          let e5, n4, u2 = this.axis, a2 = u2.series, g2 = u2.coll === "xAxis", r3 = u2.options.reversedStacks, A3 = a2.length;
          for (this.resetStacks(), this.usePercentage = false, n4 = A3; n4--; ) e5 = a2[r3 ? n4 : A3 - n4 - 1], g2 && e5.setGroupedPoints(u2), e5.setStackedPoints(u2);
          if (!g2) for (n4 = 0; n4 < A3; n4++) a2[n4].modifyStacks();
          f2(u2, "afterBuildStacks");
        }
        cleanStacks() {
          this.oldStacks && (this.stacks = this.oldStacks, p2(this.stacks, (e5) => {
            p2(e5, (n4) => {
              n4.cumulative = n4.total;
            });
          }));
        }
        resetStacks() {
          p2(this.stacks, (e5) => {
            p2(e5, (n4, u2) => {
              o2(n4.touched) && n4.touched < this.stacksTouched ? (n4.destroy(), delete e5[u2]) : (n4.total = null, n4.cumulative = null);
            });
          });
        }
        renderStackTotals() {
          var e5;
          let n4 = this.axis, u2 = n4.chart, a2 = u2.renderer, g2 = this.stacks, r3 = Z2(u2, ((e5 = n4.options.stackLabels) == null ? void 0 : e5.animation) || false), A3 = this.stackTotalGroup = this.stackTotalGroup || a2.g("stack-labels").attr({ zIndex: 6, opacity: 0 }).add();
          A3.translate(u2.plotLeft, u2.plotTop), p2(g2, (N2) => {
            p2(N2, (k3) => {
              k3.render(A3);
            });
          }), A3.animate({ opacity: 1 }, r3);
        }
      }
      return (tt2 || (tt2 = {})).compose = function(t3, e5, n4) {
        let u2 = e5.prototype, a2 = n4.prototype;
        u2.getStacks || (O3(t3, "init", T2), O3(t3, "destroy", c4), u2.getStacks = h2, a2.getStackIndicator = I3, a2.modifyStacks = G2, a2.percentStacker = L2, a2.setGroupedPoints = l4, a2.setStackedPoints = y2);
      }, tt2;
    }), at2(s2, "Series/Line/LineSeries.js", [s2["Core/Series/Series.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { defined: it2, merge: rt2, isObject: tt2 } = q2;
      class Z2 extends B3 {
        drawGraph() {
          let O3 = this.options, j3 = (this.gappedPath || this.getGraphPath).call(this), d3 = this.chart.styledMode;
          [this, ...this.zones].forEach((x2, f2) => {
            let C3, o2 = x2.graph, p2 = o2 ? "animate" : "attr", b5 = x2.dashStyle || O3.dashStyle;
            o2 ? (o2.endX = this.preventGraphAnimation ? null : j3.xMap, o2.animate({ d: j3 })) : j3.length && (x2.graph = o2 = this.chart.renderer.path(j3).addClass("highcharts-graph" + (f2 ? ` highcharts-zone-graph-${f2 - 1} ` : " ") + (f2 && x2.className || "")).attr({ zIndex: 1 }).add(this.group)), o2 && !d3 && (C3 = { stroke: !f2 && O3.lineColor || x2.color || this.color || "#cccccc", "stroke-width": O3.lineWidth || 0, fill: this.fillGraph && this.color || "none" }, b5 ? C3.dashstyle = b5 : O3.linecap !== "square" && (C3["stroke-linecap"] = C3["stroke-linejoin"] = "round"), o2[p2](C3).shadow(f2 < 2 && O3.shadow && rt2({ filterUnits: "userSpaceOnUse" }, tt2(O3.shadow) ? O3.shadow : {}))), o2 && (o2.startX = j3.xMap, o2.isArea = j3.isArea);
          });
        }
        getGraphPath(O3, j3, d3) {
          let x2 = this, f2 = x2.options, C3 = [], o2 = [], p2, b5 = f2.step, h2 = (O3 = O3 || x2.points).reversed;
          return h2 && O3.reverse(), (b5 = { right: 1, center: 2 }[b5] || b5 && 3) && h2 && (b5 = 4 - b5), (O3 = this.getValidPoints(O3, false, !(f2.connectNulls && !j3 && !d3))).forEach(function(c4, T2) {
            let I3, G2 = c4.plotX, L2 = c4.plotY, l4 = O3[T2 - 1], y2 = c4.isNull || typeof L2 != "number";
            (c4.leftCliff || l4 && l4.rightCliff) && !d3 && (p2 = true), y2 && !it2(j3) && T2 > 0 ? p2 = !f2.connectNulls : y2 && !j3 ? p2 = true : (T2 === 0 || p2 ? I3 = [["M", c4.plotX, c4.plotY]] : x2.getPointSpline ? I3 = [x2.getPointSpline(O3, c4, T2)] : b5 ? (I3 = b5 === 1 ? [["L", l4.plotX, L2]] : b5 === 2 ? [["L", (l4.plotX + G2) / 2, l4.plotY], ["L", (l4.plotX + G2) / 2, L2]] : [["L", G2, l4.plotY]]).push(["L", G2, L2]) : I3 = [["L", G2, L2]], o2.push(c4.x), b5 && (o2.push(c4.x), b5 === 2 && o2.push(c4.x)), C3.push.apply(C3, I3), p2 = false);
          }), C3.xMap = o2, x2.graphPath = C3, C3;
        }
      }
      return Z2.defaultOptions = rt2(B3.defaultOptions, { legendSymbol: "lineMarker" }), K2.registerSeriesType("line", Z2), Z2;
    }), at2(s2, "Series/Area/AreaSeriesDefaults.js", [], function() {
      return { threshold: 0, legendSymbol: "areaMarker" };
    }), at2(s2, "Series/Area/AreaSeries.js", [s2["Series/Area/AreaSeriesDefaults.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { seriesTypes: { line: it2 } } = K2, { extend: rt2, merge: tt2, objectEach: Z2, pick: X2 } = q2;
      class O3 extends it2 {
        drawGraph() {
          this.areaPath = [], super.drawGraph.apply(this);
          let { areaPath: d3, options: x2 } = this;
          [this, ...this.zones].forEach((f2, C3) => {
            var o2;
            let p2 = {}, b5 = f2.fillColor || x2.fillColor, h2 = f2.area, c4 = h2 ? "animate" : "attr";
            h2 ? (h2.endX = this.preventGraphAnimation ? null : d3.xMap, h2.animate({ d: d3 })) : (p2.zIndex = 0, (h2 = f2.area = this.chart.renderer.path(d3).addClass("highcharts-area" + (C3 ? ` highcharts-zone-area-${C3 - 1} ` : " ") + (C3 && f2.className || "")).add(this.group)).isArea = true), this.chart.styledMode || (p2.fill = b5 || f2.color || this.color, p2["fill-opacity"] = b5 ? 1 : (o2 = x2.fillOpacity) != null ? o2 : 0.75, h2.css({ pointerEvents: this.stickyTracking ? "none" : "auto" })), h2[c4](p2), h2.startX = d3.xMap, h2.shiftUnit = x2.step ? 2 : 1;
          });
        }
        getGraphPath(d3) {
          let x2, f2, C3, o2 = it2.prototype.getGraphPath, p2 = this.options, b5 = p2.stacking, h2 = this.yAxis, c4 = [], T2 = [], I3 = this.index, G2 = h2.stacking.stacks[this.stackKey], L2 = p2.threshold, l4 = Math.round(h2.getThreshold(p2.threshold)), y2 = X2(p2.connectNulls, b5 === "percent"), i5 = function(g2, r3, A3) {
            let N2 = d3[g2], k3 = b5 && G2[N2.x].points[I3], E2 = N2[A3 + "Null"] || 0, R2 = N2[A3 + "Cliff"] || 0, z2, Q2, v3 = true;
            R2 || E2 ? (z2 = (E2 ? k3[0] : k3[1]) + R2, Q2 = k3[0] + R2, v3 = !!E2) : !b5 && d3[r3] && d3[r3].isNull && (z2 = Q2 = L2), z2 !== void 0 && (T2.push({ plotX: x2, plotY: z2 === null ? l4 : h2.getThreshold(z2), isNull: v3, isCliff: true }), c4.push({ plotX: x2, plotY: Q2 === null ? l4 : h2.getThreshold(Q2), doCurve: false }));
          };
          d3 = d3 || this.points, b5 && (d3 = this.getStackPoints(d3));
          for (let g2 = 0, r3 = d3.length; g2 < r3; ++g2) b5 || (d3[g2].leftCliff = d3[g2].rightCliff = d3[g2].leftNull = d3[g2].rightNull = void 0), f2 = d3[g2].isNull, x2 = X2(d3[g2].rectPlotX, d3[g2].plotX), C3 = b5 ? X2(d3[g2].yBottom, l4) : l4, f2 && !y2 || (y2 || i5(g2, g2 - 1, "left"), f2 && !b5 && y2 || (T2.push(d3[g2]), c4.push({ x: g2, plotX: x2, plotY: C3 })), y2 || i5(g2, g2 + 1, "right"));
          let t3 = o2.call(this, T2, true, true);
          c4.reversed = true;
          let e5 = o2.call(this, c4, true, true), n4 = e5[0];
          n4 && n4[0] === "M" && (e5[0] = ["L", n4[1], n4[2]]);
          let u2 = t3.concat(e5);
          u2.length && u2.push(["Z"]);
          let a2 = o2.call(this, T2, false, y2);
          return this.chart.series.length > 1 && b5 && T2.some((g2) => g2.isCliff) && (u2.hasStackedCliffs = a2.hasStackedCliffs = true), u2.xMap = t3.xMap, this.areaPath = u2, a2;
        }
        getStackPoints(d3) {
          let x2 = this, f2 = [], C3 = [], o2 = this.xAxis, p2 = this.yAxis, b5 = p2.stacking.stacks[this.stackKey], h2 = {}, c4 = p2.series, T2 = c4.length, I3 = p2.options.reversedStacks ? 1 : -1, G2 = c4.indexOf(x2);
          if (d3 = d3 || this.points, this.options.stacking) {
            for (let l4 = 0; l4 < d3.length; l4++) d3[l4].leftNull = d3[l4].rightNull = void 0, h2[d3[l4].x] = d3[l4];
            Z2(b5, function(l4, y2) {
              l4.total !== null && C3.push(y2);
            }), C3.sort(function(l4, y2) {
              return l4 - y2;
            });
            let L2 = c4.map((l4) => l4.visible);
            C3.forEach(function(l4, y2) {
              let i5 = 0, t3, e5;
              if (h2[l4] && !h2[l4].isNull) f2.push(h2[l4]), [-1, 1].forEach(function(n4) {
                let u2 = n4 === 1 ? "rightNull" : "leftNull", a2 = b5[C3[y2 + n4]], g2 = 0;
                if (a2) {
                  let r3 = G2;
                  for (; r3 >= 0 && r3 < T2; ) {
                    let A3 = c4[r3].index;
                    !(t3 = a2.points[A3]) && (A3 === x2.index ? h2[l4][u2] = true : L2[r3] && (e5 = b5[l4].points[A3]) && (g2 -= e5[1] - e5[0])), r3 += I3;
                  }
                }
                h2[l4][n4 === 1 ? "rightCliff" : "leftCliff"] = g2;
              });
              else {
                let n4 = G2;
                for (; n4 >= 0 && n4 < T2; ) {
                  let u2 = c4[n4].index;
                  if (t3 = b5[l4].points[u2]) {
                    i5 = t3[1];
                    break;
                  }
                  n4 += I3;
                }
                i5 = X2(i5, 0), i5 = p2.translate(i5, 0, 1, 0, 1), f2.push({ isNull: true, plotX: o2.translate(l4, 0, 0, 0, 1), x: l4, plotY: i5, yBottom: i5 });
              }
            });
          }
          return f2;
        }
      }
      return O3.defaultOptions = tt2(it2.defaultOptions, B3), rt2(O3.prototype, { singleStacks: false }), K2.registerSeriesType("area", O3), O3;
    }), at2(s2, "Series/Spline/SplineSeries.js", [s2["Core/Series/SeriesRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { line: q2 } = B3.seriesTypes, { merge: it2, pick: rt2 } = K2;
      class tt2 extends q2 {
        getPointSpline(X2, O3, j3) {
          let d3, x2, f2, C3, o2 = O3.plotX || 0, p2 = O3.plotY || 0, b5 = X2[j3 - 1], h2 = X2[j3 + 1];
          function c4(I3) {
            return I3 && !I3.isNull && I3.doCurve !== false && !O3.isCliff;
          }
          if (c4(b5) && c4(h2)) {
            let I3 = b5.plotX || 0, G2 = b5.plotY || 0, L2 = h2.plotX || 0, l4 = h2.plotY || 0, y2 = 0;
            d3 = (1.5 * o2 + I3) / 2.5, x2 = (1.5 * p2 + G2) / 2.5, f2 = (1.5 * o2 + L2) / 2.5, C3 = (1.5 * p2 + l4) / 2.5, f2 !== d3 && (y2 = (C3 - x2) * (f2 - o2) / (f2 - d3) + p2 - C3), x2 += y2, C3 += y2, x2 > G2 && x2 > p2 ? (x2 = Math.max(G2, p2), C3 = 2 * p2 - x2) : x2 < G2 && x2 < p2 && (x2 = Math.min(G2, p2), C3 = 2 * p2 - x2), C3 > l4 && C3 > p2 ? (C3 = Math.max(l4, p2), x2 = 2 * p2 - C3) : C3 < l4 && C3 < p2 && (C3 = Math.min(l4, p2), x2 = 2 * p2 - C3), O3.rightContX = f2, O3.rightContY = C3, O3.controlPoints = { low: [d3, x2], high: [f2, C3] };
          }
          let T2 = ["C", rt2(b5.rightContX, b5.plotX, 0), rt2(b5.rightContY, b5.plotY, 0), rt2(d3, o2, 0), rt2(x2, p2, 0), o2, p2];
          return b5.rightContX = b5.rightContY = void 0, T2;
        }
      }
      return tt2.defaultOptions = it2(q2.defaultOptions), B3.registerSeriesType("spline", tt2), tt2;
    }), at2(s2, "Series/AreaSpline/AreaSplineSeries.js", [s2["Series/Spline/SplineSeries.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { area: it2, area: { prototype: rt2 } } = K2.seriesTypes, { extend: tt2, merge: Z2 } = q2;
      class X2 extends B3 {
      }
      return X2.defaultOptions = Z2(B3.defaultOptions, it2.defaultOptions), tt2(X2.prototype, { getGraphPath: rt2.getGraphPath, getStackPoints: rt2.getStackPoints, drawGraph: rt2.drawGraph }), K2.registerSeriesType("areaspline", X2), X2;
    }), at2(s2, "Series/Column/ColumnSeriesDefaults.js", [], function() {
      return { borderRadius: 3, centerInCategory: false, groupPadding: 0.2, marker: null, pointPadding: 0.1, minPointLength: 0, cropThreshold: 50, pointRange: null, states: { hover: { halo: false, brightness: 0.1 }, select: { color: "#cccccc", borderColor: "#000000" } }, dataLabels: { align: void 0, verticalAlign: void 0, y: void 0 }, startFromThreshold: true, stickyTracking: false, tooltip: { distance: 6 }, threshold: 0, borderColor: "#ffffff" };
    }), at2(s2, "Series/Column/ColumnSeries.js", [s2["Core/Animation/AnimationUtilities.js"], s2["Core/Color/Color.js"], s2["Series/Column/ColumnSeriesDefaults.js"], s2["Core/Globals.js"], s2["Core/Series/Series.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2) {
      let { animObject: X2 } = B3, { parse: O3 } = K2, { noop: j3 } = it2, { clamp: d3, crisp: x2, defined: f2, extend: C3, fireEvent: o2, isArray: p2, isNumber: b5, merge: h2, pick: c4, objectEach: T2 } = Z2;
      class I3 extends rt2 {
        animate(L2) {
          let l4, y2, i5 = this, t3 = this.yAxis, e5 = t3.pos, n4 = t3.reversed, u2 = i5.options, { clipOffset: a2, inverted: g2 } = this.chart, r3 = {}, A3 = g2 ? "translateX" : "translateY";
          L2 && a2 ? (r3.scaleY = 1e-3, y2 = d3(t3.toPixels(u2.threshold), e5, e5 + t3.len), g2 ? (y2 += n4 ? -Math.floor(a2[0]) : Math.ceil(a2[2]), r3.translateX = y2 - t3.len) : (y2 += n4 ? Math.ceil(a2[0]) : -Math.floor(a2[2]), r3.translateY = y2), i5.clipBox && i5.setClip(), i5.group.attr(r3)) : (l4 = Number(i5.group.attr(A3)), i5.group.animate({ scaleY: 1 }, C3(X2(i5.options.animation), { step: function(N2, k3) {
            i5.group && (r3[A3] = l4 + k3.pos * (e5 - l4), i5.group.attr(r3));
          } })));
        }
        init(L2, l4) {
          super.init.apply(this, arguments);
          let y2 = this;
          (L2 = y2.chart).hasRendered && L2.series.forEach(function(i5) {
            i5.type === y2.type && (i5.isDirty = true);
          });
        }
        getColumnMetrics() {
          var L2, l4;
          let y2 = this, i5 = y2.options, t3 = y2.xAxis, e5 = y2.yAxis, n4 = t3.options.reversedStacks, u2 = t3.reversed && !n4 || !t3.reversed && n4, a2 = {}, g2, r3 = 0;
          i5.grouping === false ? r3 = 1 : y2.chart.series.forEach(function(z2) {
            let Q2, v3 = z2.yAxis, S2 = z2.options;
            z2.type === y2.type && z2.reserveSpace() && e5.len === v3.len && e5.pos === v3.pos && (S2.stacking && S2.stacking !== "group" ? (a2[g2 = z2.stackKey] === void 0 && (a2[g2] = r3++), Q2 = a2[g2]) : S2.grouping !== false && (Q2 = r3++), z2.columnIndex = Q2);
          });
          let A3 = Math.min(Math.abs(t3.transA) * (!((L2 = t3.brokenAxis) != null && L2.hasBreaks) && ((l4 = t3.ordinal) == null ? void 0 : l4.slope) || i5.pointRange || t3.closestPointRange || t3.tickInterval || 1), t3.len), N2 = A3 * i5.groupPadding, k3 = (A3 - 2 * N2) / (r3 || 1), E2 = Math.min(i5.maxPointWidth || t3.len, c4(i5.pointWidth, k3 * (1 - 2 * i5.pointPadding))), R2 = (y2.columnIndex || 0) + (u2 ? 1 : 0);
          return y2.columnMetrics = { width: E2, offset: (k3 - E2) / 2 + (N2 + R2 * k3 - A3 / 2) * (u2 ? -1 : 1), paddedWidth: k3, columnCount: r3 }, y2.columnMetrics;
        }
        crispCol(L2, l4, y2, i5) {
          let t3 = this.borderWidth, e5 = this.chart.inverted;
          return i5 = x2(l4 + i5, t3, e5) - (l4 = x2(l4, t3, e5)), this.options.crisp && (y2 = x2(L2 + y2, t3) - (L2 = x2(L2, t3))), { x: L2, y: l4, width: y2, height: i5 };
        }
        adjustForMissingColumns(L2, l4, y2, i5) {
          var t3;
          if (!y2.isNull && i5.columnCount > 1) {
            let e5 = this.xAxis.series.filter((g2) => g2.visible).map((g2) => g2.index), n4 = 0, u2 = 0;
            T2((t3 = this.xAxis.stacking) == null ? void 0 : t3.stacks, (g2) => {
              if (typeof y2.x == "number") {
                let r3 = g2[y2.x.toString()];
                if (r3 && p2(r3.points[this.index])) {
                  let A3 = Object.keys(r3.points).filter((N2) => !N2.match(",") && r3.points[N2] && r3.points[N2].length > 1).map(parseFloat).filter((N2) => e5.indexOf(N2) !== -1).sort((N2, k3) => k3 - N2);
                  n4 = A3.indexOf(this.index), u2 = A3.length;
                }
              }
            }), n4 = this.xAxis.reversed ? u2 - 1 - n4 : n4;
            let a2 = (u2 - 1) * i5.paddedWidth + l4;
            L2 = (y2.plotX || 0) + a2 / 2 - l4 - n4 * i5.paddedWidth;
          }
          return L2;
        }
        translate() {
          let L2 = this, l4 = L2.chart, y2 = L2.options, i5 = L2.dense = L2.closestPointRange * L2.xAxis.transA < 2, t3 = L2.borderWidth = c4(y2.borderWidth, i5 ? 0 : 1), e5 = L2.xAxis, n4 = L2.yAxis, u2 = y2.threshold, a2 = c4(y2.minPointLength, 5), g2 = L2.getColumnMetrics(), r3 = g2.width, A3 = L2.pointXOffset = g2.offset, N2 = L2.dataMin, k3 = L2.dataMax, E2 = L2.translatedThreshold = n4.getThreshold(u2), R2 = L2.barW = Math.max(r3, 1 + 2 * t3);
          y2.pointPadding && (R2 = Math.ceil(R2)), rt2.prototype.translate.apply(L2), L2.points.forEach(function(z2) {
            let Q2 = c4(z2.yBottom, E2), v3 = 999 + Math.abs(Q2), S2 = z2.plotX || 0, P2 = d3(z2.plotY, -v3, n4.len + v3), U2, w2 = Math.min(P2, Q2), M2 = Math.max(P2, Q2) - w2, D2 = r3, F2 = S2 + A3, $2 = R2;
            a2 && Math.abs(M2) < a2 && (M2 = a2, U2 = !n4.reversed && !z2.negative || n4.reversed && z2.negative, b5(u2) && b5(k3) && z2.y === u2 && k3 <= u2 && (n4.min || 0) < u2 && (N2 !== k3 || (n4.max || 0) <= u2) && (U2 = !U2, z2.negative = !z2.negative), w2 = Math.abs(w2 - E2) > a2 ? Q2 - a2 : E2 - (U2 ? a2 : 0)), f2(z2.options.pointWidth) && (F2 -= Math.round(((D2 = $2 = Math.ceil(z2.options.pointWidth)) - r3) / 2)), y2.centerInCategory && !y2.stacking && (F2 = L2.adjustForMissingColumns(F2, D2, z2, g2)), z2.barX = F2, z2.pointWidth = D2, z2.tooltipPos = l4.inverted ? [d3(n4.len + n4.pos - l4.plotLeft - P2, n4.pos - l4.plotLeft, n4.len + n4.pos - l4.plotLeft), e5.len + e5.pos - l4.plotTop - F2 - $2 / 2, M2] : [e5.left - l4.plotLeft + F2 + $2 / 2, d3(P2 + n4.pos - l4.plotTop, n4.pos - l4.plotTop, n4.len + n4.pos - l4.plotTop), M2], z2.shapeType = L2.pointClass.prototype.shapeType || "roundedRect", z2.shapeArgs = L2.crispCol(F2, z2.isNull ? E2 : w2, $2, z2.isNull ? 0 : M2);
          }), o2(this, "afterColumnTranslate");
        }
        drawGraph() {
          this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
        }
        pointAttribs(L2, l4) {
          let y2 = this.options, i5 = this.pointAttrToOptions || {}, t3 = i5.stroke || "borderColor", e5 = i5["stroke-width"] || "borderWidth", n4, u2, a2, g2 = L2 && L2.color || this.color, r3 = L2 && L2[t3] || y2[t3] || g2, A3 = L2 && L2.options.dashStyle || y2.dashStyle, N2 = L2 && L2[e5] || y2[e5] || this[e5] || 0, k3 = c4(L2 && L2.opacity, y2.opacity, 1);
          L2 && this.zones.length && (u2 = L2.getZone(), g2 = L2.options.color || u2 && (u2.color || L2.nonZonedColor) || this.color, u2 && (r3 = u2.borderColor || r3, A3 = u2.dashStyle || A3, N2 = u2.borderWidth || N2)), l4 && L2 && (a2 = (n4 = h2(y2.states[l4], L2.options.states && L2.options.states[l4] || {})).brightness, g2 = n4.color || a2 !== void 0 && O3(g2).brighten(n4.brightness).get() || g2, r3 = n4[t3] || r3, N2 = n4[e5] || N2, A3 = n4.dashStyle || A3, k3 = c4(n4.opacity, k3));
          let E2 = { fill: g2, stroke: r3, "stroke-width": N2, opacity: k3 };
          return A3 && (E2.dashstyle = A3), E2;
        }
        drawPoints(L2 = this.points) {
          let l4, y2 = this, i5 = this.chart, t3 = y2.options, e5 = i5.renderer, n4 = t3.animationLimit || 250;
          L2.forEach(function(u2) {
            let a2 = u2.plotY, g2 = u2.graphic, r3 = !!g2, A3 = g2 && i5.pointCount < n4 ? "animate" : "attr";
            b5(a2) && u2.y !== null ? (l4 = u2.shapeArgs, g2 && u2.hasNewShapeType() && (g2 = g2.destroy()), y2.enabledDataSorting && (u2.startXPos = y2.xAxis.reversed ? -(l4 && l4.width || 0) : y2.xAxis.width), !g2 && (u2.graphic = g2 = e5[u2.shapeType](l4).add(u2.group || y2.group), g2 && y2.enabledDataSorting && i5.hasRendered && i5.pointCount < n4 && (g2.attr({ x: u2.startXPos }), r3 = true, A3 = "animate")), g2 && r3 && g2[A3](h2(l4)), i5.styledMode || g2[A3](y2.pointAttribs(u2, u2.selected && "select")).shadow(u2.allowShadow !== false && t3.shadow), g2 && (g2.addClass(u2.getClassName(), true), g2.attr({ visibility: u2.visible ? "inherit" : "hidden" }))) : g2 && (u2.graphic = g2.destroy());
          });
        }
        drawTracker(L2 = this.points) {
          let l4, y2 = this, i5 = y2.chart, t3 = i5.pointer, e5 = function(n4) {
            let u2 = t3 == null ? void 0 : t3.getPointFromEvent(n4);
            t3 && u2 && y2.options.enableMouseTracking && (t3.isDirectTouch = true, u2.onMouseOver(n4));
          };
          L2.forEach(function(n4) {
            l4 = p2(n4.dataLabels) ? n4.dataLabels : n4.dataLabel ? [n4.dataLabel] : [], n4.graphic && (n4.graphic.element.point = n4), l4.forEach(function(u2) {
              (u2.div || u2.element).point = n4;
            });
          }), y2._hasTracking || (y2.trackerGroups.forEach(function(n4) {
            y2[n4] && (y2[n4].addClass("highcharts-tracker").on("mouseover", e5).on("mouseout", function(u2) {
              t3 == null || t3.onTrackerMouseOut(u2);
            }).on("touchstart", e5), !i5.styledMode && y2.options.cursor && y2[n4].css({ cursor: y2.options.cursor }));
          }), y2._hasTracking = true), o2(this, "afterDrawTracker");
        }
        remove() {
          let L2 = this, l4 = L2.chart;
          l4.hasRendered && l4.series.forEach(function(y2) {
            y2.type === L2.type && (y2.isDirty = true);
          }), rt2.prototype.remove.apply(L2, arguments);
        }
      }
      return I3.defaultOptions = h2(rt2.defaultOptions, q2), C3(I3.prototype, { directTouch: true, getSymbol: j3, negStacks: true, trackerGroups: ["group", "dataLabelsGroup"] }), tt2.registerSeriesType("column", I3), I3;
    }), at2(s2, "Core/Series/DataLabel.js", [s2["Core/Animation/AnimationUtilities.js"], s2["Core/Templating.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      var it2;
      let { getDeferredAnimation: rt2 } = B3, { format: tt2 } = K2, { defined: Z2, extend: X2, fireEvent: O3, isArray: j3, isString: d3, merge: x2, objectEach: f2, pick: C3, pInt: o2, splat: p2 } = q2;
      return function(b5) {
        function h2() {
          return y2(this).some((t3) => t3 == null ? void 0 : t3.enabled);
        }
        function c4(t3, e5, n4, u2, a2) {
          var g2;
          let { chart: r3, enabledDataSorting: A3 } = this, N2 = this.isCartesian && r3.inverted, k3 = t3.plotX, E2 = t3.plotY, R2 = n4.rotation || 0, z2 = Z2(k3) && Z2(E2) && r3.isInsidePlot(k3, Math.round(E2), { inverted: N2, paneCoordinates: true, series: this }), Q2 = R2 === 0 && C3(n4.overflow, A3 ? "none" : "justify") === "justify", v3 = this.visible && t3.visible !== false && Z2(k3) && (t3.series.forceDL || A3 && !Q2 || z2 || C3(n4.inside, !!this.options.stacking) && u2 && r3.isInsidePlot(k3, N2 ? u2.x + 1 : u2.y + u2.height - 1, { inverted: N2, paneCoordinates: true, series: this })), S2 = t3.pos();
          if (v3 && S2) {
            var P2;
            let U2 = e5.getBBox(), w2 = e5.getBBox(void 0, 0), M2 = { right: 1, center: 0.5 }[n4.align || 0] || 0, D2 = { bottom: 1, middle: 0.5 }[n4.verticalAlign || 0] || 0;
            if (u2 = X2({ x: S2[0], y: Math.round(S2[1]), width: 0, height: 0 }, u2 || {}), n4.alignTo === "plotEdges" && this.isCartesian && (u2[N2 ? "x" : "y"] = 0, u2[N2 ? "width" : "height"] = ((g2 = this.yAxis) == null ? void 0 : g2.len) || 0), X2(n4, { width: U2.width, height: U2.height }), P2 = u2, A3 && this.xAxis && !Q2 && this.setDataLabelStartPos(t3, e5, a2, z2, P2), e5.align(x2(n4, { width: w2.width, height: w2.height }), false, u2, false), e5.alignAttr.x += M2 * (w2.width - U2.width), e5.alignAttr.y += D2 * (w2.height - U2.height), e5[e5.placed ? "animate" : "attr"]({ x: e5.alignAttr.x + (U2.width - w2.width) / 2, y: e5.alignAttr.y + (U2.height - w2.height) / 2, rotationOriginX: (e5.width || 0) / 2, rotationOriginY: (e5.height || 0) / 2 }), Q2 && u2.height >= 0) this.justifyDataLabel(e5, n4, e5.alignAttr, U2, u2, a2);
            else if (C3(n4.crop, true)) {
              let { x: F2, y: $2 } = e5.alignAttr;
              v3 = r3.isInsidePlot(F2, $2, { paneCoordinates: true, series: this }) && r3.isInsidePlot(F2 + U2.width - 1, $2 + U2.height - 1, { paneCoordinates: true, series: this });
            }
            n4.shape && !R2 && e5[a2 ? "attr" : "animate"]({ anchorX: S2[0], anchorY: S2[1] });
          }
          a2 && A3 && (e5.placed = false), v3 || A3 && !Q2 ? (e5.show(), e5.placed = true) : (e5.hide(), e5.placed = false);
        }
        function T2() {
          return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
        }
        function I3(t3) {
          let e5 = this.hasRendered || 0, n4 = this.initDataLabelsGroup().attr({ opacity: +e5 });
          return !e5 && n4 && (this.visible && n4.show(), this.options.animation ? n4.animate({ opacity: 1 }, t3) : n4.attr({ opacity: 1 })), n4;
        }
        function G2(t3) {
          var e5;
          let n4;
          t3 = t3 || this.points;
          let u2 = this, a2 = u2.chart, g2 = u2.options, r3 = a2.renderer, { backgroundColor: A3, plotBackgroundColor: N2 } = a2.options.chart, k3 = r3.getContrast(d3(N2) && N2 || d3(A3) && A3 || "#000000"), E2 = y2(u2), { animation: R2, defer: z2 } = E2[0], Q2 = z2 ? rt2(a2, R2, u2) : { defer: 0, duration: 0 };
          O3(this, "drawDataLabels"), (e5 = u2.hasDataLabels) != null && e5.call(u2) && (n4 = this.initDataLabels(Q2), t3.forEach((v3) => {
            var S2, P2;
            let U2 = v3.dataLabels || [];
            p2(l4(E2, v3.dlOptions || ((S2 = v3.options) == null ? void 0 : S2.dataLabels))).forEach((M2, D2) => {
              let F2 = M2.enabled && (v3.visible || v3.dataLabelOnHidden) && (!v3.isNull || v3.dataLabelOnNull) && function(ut2, dt2) {
                let ct2 = dt2.filter;
                if (ct2) {
                  let gt2 = ct2.operator, ft2 = ut2[ct2.property], pt2 = ct2.value;
                  return gt2 === ">" && ft2 > pt2 || gt2 === "<" && ft2 < pt2 || gt2 === ">=" && ft2 >= pt2 || gt2 === "<=" && ft2 <= pt2 || gt2 === "==" && ft2 == pt2 || gt2 === "===" && ft2 === pt2 || gt2 === "!=" && ft2 != pt2 || gt2 === "!==" && ft2 !== pt2;
                }
                return true;
              }(v3, M2), { backgroundColor: $2, borderColor: W2, distance: V2, style: _2 = {} } = M2, et2, lt2, ht2, J2, Y2 = {}, st2 = U2[D2], nt2 = !st2, ot2;
              F2 && (lt2 = C3(M2[v3.formatPrefix + "Format"], M2.format), et2 = v3.getLabelConfig(), ht2 = Z2(lt2) ? tt2(lt2, et2, a2) : (M2[v3.formatPrefix + "Formatter"] || M2.formatter).call(et2, M2), J2 = M2.rotation, !a2.styledMode && (_2.color = C3(M2.color, _2.color, d3(u2.color) ? u2.color : void 0, "#000000"), _2.color === "contrast" ? ($2 !== "none" && (ot2 = $2), v3.contrastColor = r3.getContrast(ot2 !== "auto" && ot2 || v3.color || u2.color), _2.color = ot2 || !Z2(V2) && M2.inside || 0 > o2(V2 || 0) || g2.stacking ? v3.contrastColor : k3) : delete v3.contrastColor, g2.cursor && (_2.cursor = g2.cursor)), Y2 = { r: M2.borderRadius || 0, rotation: J2, padding: M2.padding, zIndex: 1 }, a2.styledMode || (Y2.fill = $2 === "auto" ? v3.color : $2, Y2.stroke = W2 === "auto" ? v3.color : W2, Y2["stroke-width"] = M2.borderWidth), f2(Y2, (ut2, dt2) => {
                ut2 === void 0 && delete Y2[dt2];
              })), !st2 || F2 && Z2(ht2) && !!st2.div == !!M2.useHTML && (st2.rotation && M2.rotation || st2.rotation === M2.rotation) || (st2 = void 0, nt2 = true), F2 && Z2(ht2) && (st2 ? Y2.text = ht2 : (st2 = r3.label(ht2, 0, 0, M2.shape, void 0, void 0, M2.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + v3.colorIndex + " " + (M2.className || "") + (M2.useHTML ? " highcharts-tracker" : "")), st2 && (st2.options = M2, st2.attr(Y2), a2.styledMode ? _2.width && st2.css({ width: _2.width, textOverflow: _2.textOverflow }) : st2.css(_2).shadow(M2.shadow), O3(st2, "beforeAddingDataLabel", { labelOptions: M2, point: v3 }), st2.added || st2.add(n4), u2.alignDataLabel(v3, st2, M2, void 0, nt2), st2.isActive = true, U2[D2] && U2[D2] !== st2 && U2[D2].destroy(), U2[D2] = st2));
            });
            let w2 = U2.length;
            for (; w2--; ) U2[w2] && U2[w2].isActive ? U2[w2].isActive = false : ((P2 = U2[w2]) == null || P2.destroy(), U2.splice(w2, 1));
            v3.dataLabel = U2[0], v3.dataLabels = U2;
          })), O3(this, "afterDrawDataLabels");
        }
        function L2(t3, e5, n4, u2, a2, g2) {
          let r3 = this.chart, A3 = e5.align, N2 = e5.verticalAlign, k3 = t3.box ? 0 : t3.padding || 0, E2 = r3.inverted ? this.yAxis : this.xAxis, R2 = E2 ? E2.left - r3.plotLeft : 0, z2 = r3.inverted ? this.xAxis : this.yAxis, Q2 = z2 ? z2.top - r3.plotTop : 0, { x: v3 = 0, y: S2 = 0 } = e5, P2, U2;
          return (P2 = (n4.x || 0) + k3 + R2) < 0 && (A3 === "right" && v3 >= 0 ? (e5.align = "left", e5.inside = true) : v3 -= P2, U2 = true), (P2 = (n4.x || 0) + u2.width - k3 + R2) > r3.plotWidth && (A3 === "left" && v3 <= 0 ? (e5.align = "right", e5.inside = true) : v3 += r3.plotWidth - P2, U2 = true), (P2 = n4.y + k3 + Q2) < 0 && (N2 === "bottom" && S2 >= 0 ? (e5.verticalAlign = "top", e5.inside = true) : S2 -= P2, U2 = true), (P2 = (n4.y || 0) + u2.height - k3 + Q2) > r3.plotHeight && (N2 === "top" && S2 <= 0 ? (e5.verticalAlign = "bottom", e5.inside = true) : S2 += r3.plotHeight - P2, U2 = true), U2 && (e5.x = v3, e5.y = S2, t3.placed = !g2, t3.align(e5, void 0, a2)), U2;
        }
        function l4(t3, e5) {
          let n4 = [], u2;
          if (j3(t3) && !j3(e5)) n4 = t3.map(function(a2) {
            return x2(a2, e5);
          });
          else if (j3(e5) && !j3(t3)) n4 = e5.map(function(a2) {
            return x2(t3, a2);
          });
          else if (j3(t3) || j3(e5)) {
            if (j3(t3) && j3(e5)) for (u2 = Math.max(t3.length, e5.length); u2--; ) n4[u2] = x2(t3[u2], e5[u2]);
          } else n4 = x2(t3, e5);
          return n4;
        }
        function y2(t3) {
          var e5, n4;
          let u2 = t3.chart.options.plotOptions;
          return p2(l4(l4((e5 = u2 == null ? void 0 : u2.series) == null ? void 0 : e5.dataLabels, (n4 = u2 == null ? void 0 : u2[t3.type]) == null ? void 0 : n4.dataLabels), t3.options.dataLabels));
        }
        function i5(t3, e5, n4, u2, a2) {
          let g2 = this.chart, r3 = g2.inverted, A3 = this.xAxis, N2 = A3.reversed, k3 = ((r3 ? e5.height : e5.width) || 0) / 2, E2 = t3.pointWidth, R2 = E2 ? E2 / 2 : 0;
          e5.startXPos = r3 ? a2.x : N2 ? -k3 - R2 : A3.width - k3 + R2, e5.startYPos = r3 ? N2 ? this.yAxis.height - k3 + R2 : -k3 - R2 : a2.y, u2 ? e5.visibility === "hidden" && (e5.show(), e5.attr({ opacity: 0 }).animate({ opacity: 1 })) : e5.attr({ opacity: 1 }).animate({ opacity: 0 }, void 0, e5.hide), g2.hasRendered && (n4 && e5.attr({ x: e5.startXPos, y: e5.startYPos }), e5.placed = true);
        }
        b5.compose = function(t3) {
          let e5 = t3.prototype;
          e5.initDataLabels || (e5.initDataLabels = I3, e5.initDataLabelsGroup = T2, e5.alignDataLabel = c4, e5.drawDataLabels = G2, e5.justifyDataLabel = L2, e5.setDataLabelStartPos = i5, e5.hasDataLabels = h2);
        };
      }(it2 || (it2 = {})), it2;
    }), at2(s2, "Series/Column/ColumnDataLabel.js", [s2["Core/Series/DataLabel.js"], s2["Core/Globals.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2) {
      var rt2;
      let { composed: tt2 } = K2, { series: Z2 } = q2, { merge: X2, pick: O3, pushUnique: j3 } = it2;
      return function(d3) {
        function x2(f2, C3, o2, p2, b5) {
          let h2 = this.chart.inverted, c4 = f2.series, T2 = (c4.xAxis ? c4.xAxis.len : this.chart.plotSizeX) || 0, I3 = (c4.yAxis ? c4.yAxis.len : this.chart.plotSizeY) || 0, G2 = f2.dlBox || f2.shapeArgs, L2 = O3(f2.below, f2.plotY > O3(this.translatedThreshold, I3)), l4 = O3(o2.inside, !!this.options.stacking);
          if (G2) {
            if (p2 = X2(G2), !(o2.overflow === "allow" && o2.crop === false)) {
              p2.y < 0 && (p2.height += p2.y, p2.y = 0);
              let y2 = p2.y + p2.height - I3;
              y2 > 0 && y2 < p2.height - 1 && (p2.height -= y2);
            }
            h2 && (p2 = { x: I3 - p2.y - p2.height, y: T2 - p2.x - p2.width, width: p2.height, height: p2.width }), l4 || (h2 ? (p2.x += L2 ? 0 : p2.width, p2.width = 0) : (p2.y += L2 ? p2.height : 0, p2.height = 0));
          }
          o2.align = O3(o2.align, !h2 || l4 ? "center" : L2 ? "right" : "left"), o2.verticalAlign = O3(o2.verticalAlign, h2 || l4 ? "middle" : L2 ? "top" : "bottom"), Z2.prototype.alignDataLabel.call(this, f2, C3, o2, p2, b5), o2.inside && f2.contrastColor && C3.css({ color: f2.contrastColor });
        }
        d3.compose = function(f2) {
          B3.compose(Z2), j3(tt2, "ColumnDataLabel") && (f2.prototype.alignDataLabel = x2);
        };
      }(rt2 || (rt2 = {})), rt2;
    }), at2(s2, "Series/Bar/BarSeries.js", [s2["Series/Column/ColumnSeries.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { extend: it2, merge: rt2 } = q2;
      class tt2 extends B3 {
      }
      return tt2.defaultOptions = rt2(B3.defaultOptions, {}), it2(tt2.prototype, { inverted: true }), K2.registerSeriesType("bar", tt2), tt2;
    }), at2(s2, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
      return { lineWidth: 0, findNearestPointBy: "xy", jitter: { x: 0, y: 0 }, marker: { enabled: true }, tooltip: { headerFormat: '<span style="color:{point.color}">●</span> <span style="font-size: 0.8em"> {series.name}</span><br/>', pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>" } };
    }), at2(s2, "Series/Scatter/ScatterSeries.js", [s2["Series/Scatter/ScatterSeriesDefaults.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { column: it2, line: rt2 } = K2.seriesTypes, { addEvent: tt2, extend: Z2, merge: X2 } = q2;
      class O3 extends rt2 {
        applyJitter() {
          let d3 = this, x2 = this.options.jitter, f2 = this.points.length;
          x2 && this.points.forEach(function(C3, o2) {
            ["x", "y"].forEach(function(p2, b5) {
              if (x2[p2] && !C3.isNull) {
                let h2 = `plot${p2.toUpperCase()}`, c4 = d3[`${p2}Axis`], T2 = x2[p2] * c4.transA;
                if (c4 && !c4.logarithmic) {
                  let I3 = Math.max(0, (C3[h2] || 0) - T2), G2 = Math.min(c4.len, (C3[h2] || 0) + T2);
                  C3[h2] = I3 + (G2 - I3) * function(L2) {
                    let l4 = 1e4 * Math.sin(L2);
                    return l4 - Math.floor(l4);
                  }(o2 + b5 * f2), p2 === "x" && (C3.clientX = C3.plotX);
                }
              }
            });
          });
        }
        drawGraph() {
          this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
        }
      }
      return O3.defaultOptions = X2(rt2.defaultOptions, B3), Z2(O3.prototype, { drawTracker: it2.prototype.drawTracker, sorted: false, requireSorting: false, noSharedTooltip: true, trackerGroups: ["group", "markerGroup", "dataLabelsGroup"] }), tt2(O3, "afterTranslate", function() {
        this.applyJitter();
      }), K2.registerSeriesType("scatter", O3), O3;
    }), at2(s2, "Series/CenteredUtilities.js", [s2["Core/Globals.js"], s2["Core/Series/Series.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      var it2, rt2;
      let { deg2rad: tt2 } = B3, { fireEvent: Z2, isNumber: X2, pick: O3, relativeLength: j3 } = q2;
      return (rt2 = it2 || (it2 = {})).getCenter = function() {
        let d3 = this.options, x2 = this.chart, f2 = 2 * (d3.slicedOffset || 0), C3 = x2.plotWidth - 2 * f2, o2 = x2.plotHeight - 2 * f2, p2 = d3.center, b5 = Math.min(C3, o2), h2 = d3.thickness, c4, T2 = d3.size, I3 = d3.innerSize || 0, G2, L2;
        typeof T2 == "string" && (T2 = parseFloat(T2)), typeof I3 == "string" && (I3 = parseFloat(I3));
        let l4 = [O3(p2[0], "50%"), O3(p2[1], "50%"), O3(T2 && T2 < 0 ? void 0 : d3.size, "100%"), O3(I3 && I3 < 0 ? void 0 : d3.innerSize || 0, "0%")];
        for (!x2.angular || this instanceof K2 || (l4[3] = 0), G2 = 0; G2 < 4; ++G2) L2 = l4[G2], c4 = G2 < 2 || G2 === 2 && /%$/.test(L2), l4[G2] = j3(L2, [C3, o2, b5, l4[2]][G2]) + (c4 ? f2 : 0);
        return l4[3] > l4[2] && (l4[3] = l4[2]), X2(h2) && 2 * h2 < l4[2] && h2 > 0 && (l4[3] = l4[2] - 2 * h2), Z2(this, "afterGetCenter", { positions: l4 }), l4;
      }, rt2.getStartAndEndRadians = function(d3, x2) {
        let f2 = X2(d3) ? d3 : 0, C3 = X2(x2) && x2 > f2 && x2 - f2 < 360 ? x2 : f2 + 360;
        return { start: tt2 * (f2 + -90), end: tt2 * (C3 + -90) };
      }, it2;
    }), at2(s2, "Series/Pie/PiePoint.js", [s2["Core/Animation/AnimationUtilities.js"], s2["Core/Series/Point.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { setAnimation: it2 } = B3, { addEvent: rt2, defined: tt2, extend: Z2, isNumber: X2, pick: O3, relativeLength: j3 } = q2;
      class d3 extends K2 {
        getConnectorPath(f2) {
          let C3 = f2.dataLabelPosition, o2 = f2.options || {}, p2 = o2.connectorShape, b5 = this.connectorShapes[p2] || p2;
          return C3 && b5.call(this, { ...C3.computed, alignment: C3.alignment }, C3.connectorPosition, o2) || [];
        }
        getTranslate() {
          return this.sliced && this.slicedTranslation || { translateX: 0, translateY: 0 };
        }
        haloPath(f2) {
          let C3 = this.shapeArgs;
          return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(C3.x, C3.y, C3.r + f2, C3.r + f2, { innerR: C3.r - 1, start: C3.start, end: C3.end, borderRadius: C3.borderRadius });
        }
        constructor(f2, C3, o2) {
          super(f2, C3, o2), this.half = 0, this.name != null || (this.name = "Slice");
          let p2 = (b5) => {
            this.slice(b5.type === "select");
          };
          rt2(this, "select", p2), rt2(this, "unselect", p2);
        }
        isValid() {
          return X2(this.y) && this.y >= 0;
        }
        setVisible(f2, C3 = true) {
          f2 !== this.visible && this.update({ visible: f2 != null ? f2 : !this.visible }, C3, void 0, false);
        }
        slice(f2, C3, o2) {
          let p2 = this.series;
          it2(o2, p2.chart), C3 = O3(C3, true), this.sliced = this.options.sliced = f2 = tt2(f2) ? f2 : !this.sliced, p2.options.data[p2.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate());
        }
      }
      return Z2(d3.prototype, { connectorShapes: { fixedOffset: function(x2, f2, C3) {
        let o2 = f2.breakAt, p2 = f2.touchingSliceAt, b5 = C3.softConnector ? ["C", x2.x + (x2.alignment === "left" ? -5 : 5), x2.y, 2 * o2.x - p2.x, 2 * o2.y - p2.y, o2.x, o2.y] : ["L", o2.x, o2.y];
        return [["M", x2.x, x2.y], b5, ["L", p2.x, p2.y]];
      }, straight: function(x2, f2) {
        let C3 = f2.touchingSliceAt;
        return [["M", x2.x, x2.y], ["L", C3.x, C3.y]];
      }, crookedLine: function(x2, f2, C3) {
        let { breakAt: o2, touchingSliceAt: p2 } = f2, { series: b5 } = this, [h2, c4, T2] = b5.center, I3 = T2 / 2, { plotLeft: G2, plotWidth: L2 } = b5.chart, l4 = x2.alignment === "left", { x: y2, y: i5 } = x2, t3 = o2.x;
        if (C3.crookDistance) {
          let n4 = j3(C3.crookDistance, 1);
          t3 = l4 ? h2 + I3 + (L2 + G2 - h2 - I3) * (1 - n4) : G2 + (h2 - I3) * n4;
        } else t3 = h2 + (c4 - i5) * Math.tan((this.angle || 0) - Math.PI / 2);
        let e5 = [["M", y2, i5]];
        return (l4 ? t3 <= y2 && t3 >= o2.x : t3 >= y2 && t3 <= o2.x) && e5.push(["L", t3, i5]), e5.push(["L", o2.x, o2.y], ["L", p2.x, p2.y]), e5;
      } } }), d3;
    }), at2(s2, "Series/Pie/PieSeriesDefaults.js", [], function() {
      return { borderRadius: 3, center: [null, null], clip: false, colorByPoint: true, dataLabels: { connectorPadding: 5, connectorShape: "crookedLine", crookDistance: void 0, distance: 30, enabled: true, formatter: function() {
        return this.point.isNull ? void 0 : this.point.name;
      }, softConnector: true, x: 0 }, fillColor: void 0, ignoreHiddenPoint: true, inactiveOtherPoints: true, legendType: "point", marker: null, size: null, showInLegend: false, slicedOffset: 10, stickyTracking: false, tooltip: { followPointer: true }, borderColor: "#ffffff", borderWidth: 1, lineWidth: void 0, states: { hover: { brightness: 0.1 } } };
    }), at2(s2, "Series/Pie/PieSeries.js", [s2["Series/CenteredUtilities.js"], s2["Series/Column/ColumnSeries.js"], s2["Core/Globals.js"], s2["Series/Pie/PiePoint.js"], s2["Series/Pie/PieSeriesDefaults.js"], s2["Core/Series/Series.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Renderer/SVG/Symbols.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2, O3) {
      let { getStartAndEndRadians: j3 } = B3, { noop: d3 } = q2, { clamp: x2, extend: f2, fireEvent: C3, merge: o2, pick: p2 } = O3;
      class b5 extends tt2 {
        animate(c4) {
          let T2 = this, I3 = T2.points, G2 = T2.startAngleRad;
          c4 || I3.forEach(function(L2) {
            let l4 = L2.graphic, y2 = L2.shapeArgs;
            l4 && y2 && (l4.attr({ r: p2(L2.startR, T2.center && T2.center[3] / 2), start: G2, end: G2 }), l4.animate({ r: y2.r, start: y2.start, end: y2.end }, T2.options.animation));
          });
        }
        drawEmpty() {
          let c4, T2, I3 = this.startAngleRad, G2 = this.endAngleRad, L2 = this.options;
          this.total === 0 && this.center ? (c4 = this.center[0], T2 = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(c4, T2, this.center[1] / 2, 0, I3, G2).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({ d: X2.arc(c4, T2, this.center[2] / 2, 0, { start: I3, end: G2, innerR: this.center[3] / 2 }) }), this.chart.styledMode || this.graph.attr({ "stroke-width": L2.borderWidth, fill: L2.fillColor || "none", stroke: L2.color || "#cccccc" })) : this.graph && (this.graph = this.graph.destroy());
        }
        drawPoints() {
          let c4 = this.chart.renderer;
          this.points.forEach(function(T2) {
            T2.graphic && T2.hasNewShapeType() && (T2.graphic = T2.graphic.destroy()), T2.graphic || (T2.graphic = c4[T2.shapeType](T2.shapeArgs).add(T2.series.group), T2.delayedRendering = true);
          });
        }
        generatePoints() {
          super.generatePoints(), this.updateTotals();
        }
        getX(c4, T2, I3, G2) {
          let L2 = this.center, l4 = this.radii ? this.radii[I3.index] || 0 : L2[2] / 2, y2 = G2.dataLabelPosition, i5 = (y2 == null ? void 0 : y2.distance) || 0, t3 = Math.asin(x2((c4 - L2[1]) / (l4 + i5), -1, 1));
          return L2[0] + Math.cos(t3) * (l4 + i5) * (T2 ? -1 : 1) + (i5 > 0 ? (T2 ? -1 : 1) * (G2.padding || 0) : 0);
        }
        hasData() {
          return !!this.processedXData.length;
        }
        redrawPoints() {
          let c4, T2, I3, G2, L2 = this, l4 = L2.chart;
          this.drawEmpty(), L2.group && !l4.styledMode && L2.group.shadow(L2.options.shadow), L2.points.forEach(function(y2) {
            let i5 = {};
            T2 = y2.graphic, !y2.isNull && T2 ? (G2 = y2.shapeArgs, c4 = y2.getTranslate(), l4.styledMode || (I3 = L2.pointAttribs(y2, y2.selected && "select")), y2.delayedRendering ? (T2.setRadialReference(L2.center).attr(G2).attr(c4), l4.styledMode || T2.attr(I3).attr({ "stroke-linejoin": "round" }), y2.delayedRendering = false) : (T2.setRadialReference(L2.center), l4.styledMode || o2(true, i5, I3), o2(true, i5, G2, c4), T2.animate(i5)), T2.attr({ visibility: y2.visible ? "inherit" : "hidden" }), T2.addClass(y2.getClassName(), true)) : T2 && (y2.graphic = T2.destroy());
          });
        }
        sortByAngle(c4, T2) {
          c4.sort(function(I3, G2) {
            return I3.angle !== void 0 && (G2.angle - I3.angle) * T2;
          });
        }
        translate(c4) {
          C3(this, "translate"), this.generatePoints();
          let T2 = this.options, I3 = T2.slicedOffset, G2 = j3(T2.startAngle, T2.endAngle), L2 = this.startAngleRad = G2.start, l4 = (this.endAngleRad = G2.end) - L2, y2 = this.points, i5 = T2.ignoreHiddenPoint, t3 = y2.length, e5, n4, u2, a2, g2, r3, A3, N2 = 0;
          for (c4 || (this.center = c4 = this.getCenter()), r3 = 0; r3 < t3; r3++) {
            A3 = y2[r3], e5 = L2 + N2 * l4, A3.isValid() && (!i5 || A3.visible) && (N2 += A3.percentage / 100), n4 = L2 + N2 * l4;
            let k3 = { x: c4[0], y: c4[1], r: c4[2] / 2, innerR: c4[3] / 2, start: Math.round(1e3 * e5) / 1e3, end: Math.round(1e3 * n4) / 1e3 };
            A3.shapeType = "arc", A3.shapeArgs = k3, (u2 = (n4 + e5) / 2) > 1.5 * Math.PI ? u2 -= 2 * Math.PI : u2 < -Math.PI / 2 && (u2 += 2 * Math.PI), A3.slicedTranslation = { translateX: Math.round(Math.cos(u2) * I3), translateY: Math.round(Math.sin(u2) * I3) }, a2 = Math.cos(u2) * c4[2] / 2, g2 = Math.sin(u2) * c4[2] / 2, A3.tooltipPos = [c4[0] + 0.7 * a2, c4[1] + 0.7 * g2], A3.half = u2 < -Math.PI / 2 || u2 > Math.PI / 2 ? 1 : 0, A3.angle = u2;
          }
          C3(this, "afterTranslate");
        }
        updateTotals() {
          let c4 = this.points, T2 = c4.length, I3 = this.options.ignoreHiddenPoint, G2, L2, l4 = 0;
          for (G2 = 0; G2 < T2; G2++) (L2 = c4[G2]).isValid() && (!I3 || L2.visible) && (l4 += L2.y);
          for (G2 = 0, this.total = l4; G2 < T2; G2++) (L2 = c4[G2]).percentage = l4 > 0 && (L2.visible || !I3) ? L2.y / l4 * 100 : 0, L2.total = l4;
        }
      }
      return b5.defaultOptions = o2(tt2.defaultOptions, rt2), f2(b5.prototype, { axisTypes: [], directTouch: true, drawGraph: void 0, drawTracker: K2.prototype.drawTracker, getCenter: B3.getCenter, getSymbol: d3, invertible: false, isCartesian: false, noSharedTooltip: true, pointAttribs: K2.prototype.pointAttribs, pointClass: it2, requireSorting: false, searchPoint: d3, trackerGroups: ["group", "dataLabelsGroup"] }), Z2.registerSeriesType("pie", b5), b5;
    }), at2(s2, "Series/Pie/PieDataLabel.js", [s2["Core/Series/DataLabel.js"], s2["Core/Globals.js"], s2["Core/Renderer/RendererUtilities.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2) {
      var tt2;
      let { composed: Z2, noop: X2 } = K2, { distribute: O3 } = q2, { series: j3 } = it2, { arrayMax: d3, clamp: x2, defined: f2, pick: C3, pushUnique: o2, relativeLength: p2 } = rt2;
      return function(b5) {
        let h2 = { radialDistributionY: function(L2, l4) {
          var y2;
          return (((y2 = l4.dataLabelPosition) == null ? void 0 : y2.top) || 0) + L2.distributeBox.pos;
        }, radialDistributionX: function(L2, l4, y2, i5, t3) {
          let e5 = t3.dataLabelPosition;
          return L2.getX(y2 < ((e5 == null ? void 0 : e5.top) || 0) + 2 || y2 > ((e5 == null ? void 0 : e5.bottom) || 0) - 2 ? i5 : y2, l4.half, l4, t3);
        }, justify: function(L2, l4, y2, i5) {
          var t3;
          return i5[0] + (L2.half ? -1 : 1) * (y2 + (((t3 = l4.dataLabelPosition) == null ? void 0 : t3.distance) || 0));
        }, alignToPlotEdges: function(L2, l4, y2, i5) {
          let t3 = L2.getBBox().width;
          return l4 ? t3 + i5 : y2 - t3 - i5;
        }, alignToConnectors: function(L2, l4, y2, i5) {
          let t3 = 0, e5;
          return L2.forEach(function(n4) {
            (e5 = n4.dataLabel.getBBox().width) > t3 && (t3 = e5);
          }), l4 ? t3 + i5 : y2 - t3 - i5;
        } };
        function c4(L2, l4) {
          let { center: y2, options: i5 } = this, t3 = y2[2] / 2, e5 = L2.angle || 0, n4 = Math.cos(e5), u2 = Math.sin(e5), a2 = y2[0] + n4 * t3, g2 = y2[1] + u2 * t3, r3 = Math.min((i5.slicedOffset || 0) + (i5.borderWidth || 0), l4 / 5);
          return { natural: { x: a2 + n4 * l4, y: g2 + u2 * l4 }, computed: {}, alignment: l4 < 0 ? "center" : L2.half ? "right" : "left", connectorPosition: { breakAt: { x: a2 + n4 * r3, y: g2 + u2 * r3 }, touchingSliceAt: { x: a2, y: g2 } }, distance: l4 };
        }
        function T2() {
          var L2;
          let l4 = this, y2 = l4.points, i5 = l4.chart, t3 = i5.plotWidth, e5 = i5.plotHeight, n4 = i5.plotLeft, u2 = Math.round(i5.chartWidth / 3), a2 = l4.center, g2 = a2[2] / 2, r3 = a2[1], A3 = [[], []], N2 = [0, 0, 0, 0], k3 = l4.dataLabelPositioners, E2, R2, z2, Q2 = 0;
          l4.visible && (L2 = l4.hasDataLabels) != null && L2.call(l4) && (y2.forEach((v3) => {
            (v3.dataLabels || []).forEach((S2) => {
              S2.shortened && (S2.attr({ width: "auto" }).css({ width: "auto", textOverflow: "clip" }), S2.shortened = false);
            });
          }), j3.prototype.drawDataLabels.apply(l4), y2.forEach((v3) => {
            (v3.dataLabels || []).forEach((S2, P2) => {
              var U2;
              let w2 = a2[2] / 2, M2 = S2.options, D2 = p2((M2 == null ? void 0 : M2.distance) || 0, w2);
              P2 === 0 && A3[v3.half].push(v3), !f2((U2 = M2 == null ? void 0 : M2.style) == null ? void 0 : U2.width) && S2.getBBox().width > u2 && (S2.css({ width: Math.round(0.7 * u2) + "px" }), S2.shortened = true), S2.dataLabelPosition = this.getDataLabelPosition(v3, D2), Q2 = Math.max(Q2, D2);
            });
          }), A3.forEach((v3, S2) => {
            let P2 = v3.length, U2 = [], w2, M2, D2 = 0, F2;
            P2 && (l4.sortByAngle(v3, S2 - 0.5), Q2 > 0 && (w2 = Math.max(0, r3 - g2 - Q2), M2 = Math.min(r3 + g2 + Q2, i5.plotHeight), v3.forEach(($2) => {
              ($2.dataLabels || []).forEach((W2) => {
                var V2;
                let _2 = W2.dataLabelPosition;
                _2 && _2.distance > 0 && (_2.top = Math.max(0, r3 - g2 - _2.distance), _2.bottom = Math.min(r3 + g2 + _2.distance, i5.plotHeight), D2 = W2.getBBox().height || 21, W2.lineHeight = i5.renderer.fontMetrics(W2.text || W2).h + 2 * W2.padding, $2.distributeBox = { target: (((V2 = W2.dataLabelPosition) == null ? void 0 : V2.natural.y) || 0) - _2.top + W2.lineHeight / 2, size: D2, rank: $2.y }, U2.push($2.distributeBox));
              });
            }), O3(U2, F2 = M2 + D2 - w2, F2 / 5)), v3.forEach(($2) => {
              ($2.dataLabels || []).forEach((W2) => {
                let V2 = W2.options || {}, _2 = $2.distributeBox, et2 = W2.dataLabelPosition, lt2 = (et2 == null ? void 0 : et2.natural.y) || 0, ht2 = V2.connectorPadding || 0, J2 = W2.lineHeight || 21, Y2 = (J2 - W2.getBBox().height) / 2, st2 = 0, nt2 = lt2, ot2 = "inherit";
                if (et2) {
                  if (f2(_2) && et2.distance > 0 && (_2.pos === void 0 ? ot2 = "hidden" : (z2 = _2.size, nt2 = k3.radialDistributionY($2, W2))), V2.justify) st2 = k3.justify($2, W2, g2, a2);
                  else switch (V2.alignTo) {
                    case "connectors":
                      st2 = k3.alignToConnectors(v3, S2, t3, n4);
                      break;
                    case "plotEdges":
                      st2 = k3.alignToPlotEdges(W2, S2, t3, n4);
                      break;
                    default:
                      st2 = k3.radialDistributionX(l4, $2, nt2 - Y2, lt2, W2);
                  }
                  if (et2.attribs = { visibility: ot2, align: et2.alignment }, et2.posAttribs = { x: st2 + (V2.x || 0) + ({ left: ht2, right: -ht2 }[et2.alignment] || 0), y: nt2 + (V2.y || 0) - J2 / 2 }, et2.computed.x = st2, et2.computed.y = nt2 - Y2, C3(V2.crop, true)) {
                    let ut2;
                    st2 - (R2 = W2.getBBox().width) < ht2 && S2 === 1 ? (ut2 = Math.round(R2 - st2 + ht2), N2[3] = Math.max(ut2, N2[3])) : st2 + R2 > t3 - ht2 && S2 === 0 && (ut2 = Math.round(st2 + R2 - t3 + ht2), N2[1] = Math.max(ut2, N2[1])), nt2 - z2 / 2 < 0 ? N2[0] = Math.max(Math.round(-nt2 + z2 / 2), N2[0]) : nt2 + z2 / 2 > e5 && (N2[2] = Math.max(Math.round(nt2 + z2 / 2 - e5), N2[2])), et2.sideOverflow = ut2;
                  }
                }
              });
            }));
          }), (d3(N2) === 0 || this.verifyDataLabelOverflow(N2)) && (this.placeDataLabels(), this.points.forEach((v3) => {
            (v3.dataLabels || []).forEach((S2) => {
              var P2;
              let { connectorColor: U2, connectorWidth: w2 = 1 } = S2.options || {}, M2 = S2.dataLabelPosition;
              if (w2) {
                let D2;
                E2 = S2.connector, M2 && M2.distance > 0 ? (D2 = !E2, E2 || (S2.connector = E2 = i5.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + v3.colorIndex + (v3.className ? " " + v3.className : "")).add(l4.dataLabelsGroup)), i5.styledMode || E2.attr({ "stroke-width": w2, stroke: U2 || v3.color || "#666666" }), E2[D2 ? "attr" : "animate"]({ d: v3.getConnectorPath(S2) }), E2.attr({ visibility: (P2 = M2.attribs) == null ? void 0 : P2.visibility })) : E2 && (S2.connector = E2.destroy());
              }
            });
          })));
        }
        function I3() {
          this.points.forEach((L2) => {
            (L2.dataLabels || []).forEach((l4) => {
              var y2;
              let i5 = l4.dataLabelPosition;
              i5 ? (i5.sideOverflow && (l4.css({ width: Math.max(l4.getBBox().width - i5.sideOverflow, 0) + "px", textOverflow: (((y2 = l4.options) == null ? void 0 : y2.style) || {}).textOverflow || "ellipsis" }), l4.shortened = true), l4.attr(i5.attribs), l4[l4.moved ? "animate" : "attr"](i5.posAttribs), l4.moved = true) : l4 && l4.attr({ y: -9999 });
            }), delete L2.distributeBox;
          }, this);
        }
        function G2(L2) {
          let l4 = this.center, y2 = this.options, i5 = y2.center, t3 = y2.minSize || 80, e5 = t3, n4 = y2.size !== null;
          return !n4 && (i5[0] !== null ? e5 = Math.max(l4[2] - Math.max(L2[1], L2[3]), t3) : (e5 = Math.max(l4[2] - L2[1] - L2[3], t3), l4[0] += (L2[3] - L2[1]) / 2), i5[1] !== null ? e5 = x2(e5, t3, l4[2] - Math.max(L2[0], L2[2])) : (e5 = x2(e5, t3, l4[2] - L2[0] - L2[2]), l4[1] += (L2[0] - L2[2]) / 2), e5 < l4[2] ? (l4[2] = e5, l4[3] = Math.min(y2.thickness ? Math.max(0, e5 - 2 * y2.thickness) : Math.max(0, p2(y2.innerSize || 0, e5)), e5), this.translate(l4), this.drawDataLabels && this.drawDataLabels()) : n4 = true), n4;
        }
        b5.compose = function(L2) {
          if (B3.compose(j3), o2(Z2, "PieDataLabel")) {
            let l4 = L2.prototype;
            l4.dataLabelPositioners = h2, l4.alignDataLabel = X2, l4.drawDataLabels = T2, l4.getDataLabelPosition = c4, l4.placeDataLabels = I3, l4.verifyDataLabelOverflow = G2;
          }
        };
      }(tt2 || (tt2 = {})), tt2;
    }), at2(s2, "Core/Geometry/GeometryUtilities.js", [], function() {
      var B3, K2;
      return (K2 = B3 || (B3 = {})).getCenterOfPoints = function(q2) {
        let it2 = q2.reduce((rt2, tt2) => (rt2.x += tt2.x, rt2.y += tt2.y, rt2), { x: 0, y: 0 });
        return { x: it2.x / q2.length, y: it2.y / q2.length };
      }, K2.getDistanceBetweenPoints = function(q2, it2) {
        return Math.sqrt(Math.pow(it2.x - q2.x, 2) + Math.pow(it2.y - q2.y, 2));
      }, K2.getAngleBetweenPoints = function(q2, it2) {
        return Math.atan2(it2.x - q2.x, it2.y - q2.y);
      }, K2.pointInPolygon = function({ x: q2, y: it2 }, rt2) {
        let tt2 = rt2.length, Z2, X2, O3 = false;
        for (Z2 = 0, X2 = tt2 - 1; Z2 < tt2; X2 = Z2++) {
          let [j3, d3] = rt2[Z2], [x2, f2] = rt2[X2];
          d3 > it2 != f2 > it2 && q2 < (x2 - j3) * (it2 - d3) / (f2 - d3) + j3 && (O3 = !O3);
        }
        return O3;
      }, B3;
    }), at2(s2, "Extensions/OverlappingDataLabels.js", [s2["Core/Geometry/GeometryUtilities.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { pointInPolygon: q2 } = B3, { addEvent: it2, fireEvent: rt2, objectEach: tt2, pick: Z2 } = K2;
      function X2(d3) {
        let x2 = d3.length, f2 = (I3, G2) => !(G2.x >= I3.x + I3.width || G2.x + G2.width <= I3.x || G2.y >= I3.y + I3.height || G2.y + G2.height <= I3.y), C3 = (I3, G2) => {
          for (let L2 of I3) if (q2({ x: L2[0], y: L2[1] }, G2)) return true;
          return false;
        }, o2, p2, b5, h2, c4, T2 = false;
        for (let I3 = 0; I3 < x2; I3++) (o2 = d3[I3]) && (o2.oldOpacity = o2.opacity, o2.newOpacity = 1, o2.absoluteBox = function(G2) {
          var L2, l4;
          if (G2 && (!G2.alignAttr || G2.placed)) {
            let y2 = G2.box ? 0 : G2.padding || 0, i5 = G2.alignAttr || { x: G2.attr("x"), y: G2.attr("y") }, t3 = G2.getBBox();
            return G2.width = t3.width, G2.height = t3.height, { x: i5.x + (((L2 = G2.parentGroup) == null ? void 0 : L2.translateX) || 0) + y2, y: i5.y + (((l4 = G2.parentGroup) == null ? void 0 : l4.translateY) || 0) + y2, width: (G2.width || 0) - 2 * y2, height: (G2.height || 0) - 2 * y2, polygon: t3 == null ? void 0 : t3.polygon };
          }
        }(o2));
        d3.sort((I3, G2) => (G2.labelrank || 0) - (I3.labelrank || 0));
        for (let I3 = 0; I3 < x2; ++I3) {
          h2 = (p2 = d3[I3]) && p2.absoluteBox;
          let G2 = h2 == null ? void 0 : h2.polygon;
          for (let L2 = I3 + 1; L2 < x2; ++L2) {
            c4 = (b5 = d3[L2]) && b5.absoluteBox;
            let l4 = false;
            if (h2 && c4 && p2 !== b5 && p2.newOpacity !== 0 && b5.newOpacity !== 0 && p2.visibility !== "hidden" && b5.visibility !== "hidden") {
              let y2 = c4.polygon;
              if (G2 && y2 && G2 !== y2 ? C3(G2, y2) && (l4 = true) : f2(h2, c4) && (l4 = true), l4) {
                let i5 = p2.labelrank < b5.labelrank ? p2 : b5, t3 = i5.text;
                i5.newOpacity = 0, t3 != null && t3.element.querySelector("textPath") && t3.hide();
              }
            }
          }
        }
        for (let I3 of d3) O3(I3, this) && (T2 = true);
        T2 && rt2(this, "afterHideAllOverlappingLabels");
      }
      function O3(d3, x2) {
        let f2, C3, o2 = false;
        return d3 && (C3 = d3.newOpacity, d3.oldOpacity !== C3 && (d3.hasClass("highcharts-data-label") ? (d3[C3 ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), f2 = function() {
          x2.styledMode || d3.css({ pointerEvents: C3 ? "auto" : "none" });
        }, o2 = true, d3[d3.isOld ? "animate" : "attr"]({ opacity: C3 }, void 0, f2), rt2(x2, "afterHideOverlappingLabel")) : d3.attr({ opacity: C3 })), d3.isOld = true), o2;
      }
      function j3() {
        var d3;
        let x2 = this, f2 = [];
        for (let C3 of x2.labelCollectors || []) f2 = f2.concat(C3());
        for (let C3 of x2.yAxis || []) C3.stacking && C3.options.stackLabels && !C3.options.stackLabels.allowOverlap && tt2(C3.stacking.stacks, (o2) => {
          tt2(o2, (p2) => {
            p2.label && f2.push(p2.label);
          });
        });
        for (let C3 of x2.series || []) if (C3.visible && (d3 = C3.hasDataLabels) != null && d3.call(C3)) {
          let o2 = (p2) => {
            for (let b5 of p2) b5.visible && (b5.dataLabels || []).forEach((h2) => {
              var c4, T2;
              let I3 = h2.options || {};
              h2.labelrank = Z2(I3.labelrank, b5.labelrank, (c4 = b5.shapeArgs) == null ? void 0 : c4.height), ((T2 = I3.allowOverlap) != null ? T2 : Number(I3.distance) > 0) ? (h2.oldOpacity = h2.opacity, h2.newOpacity = 1, O3(h2, x2)) : f2.push(h2);
            });
          };
          o2(C3.nodes || []), o2(C3.points);
        }
        this.hideOverlappingLabels(f2);
      }
      return { compose: function(d3) {
        let x2 = d3.prototype;
        x2.hideOverlappingLabels || (x2.hideOverlappingLabels = X2, it2(d3, "render", j3));
      } };
    }), at2(s2, "Extensions/BorderRadius.js", [s2["Core/Defaults.js"], s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { defaultOptions: it2 } = B3, { noop: rt2 } = K2, { addEvent: tt2, extend: Z2, isObject: X2, merge: O3, relativeLength: j3 } = q2, d3 = { radius: 0, scope: "stack", where: void 0 }, x2 = rt2, f2 = rt2;
      function C3(c4, T2, I3, G2, L2 = {}) {
        let l4 = x2(c4, T2, I3, G2, L2), { innerR: y2 = 0, r: i5 = I3, start: t3 = 0, end: e5 = 0 } = L2;
        if (L2.open || !L2.borderRadius) return l4;
        let n4 = e5 - t3, u2 = Math.sin(n4 / 2), a2 = Math.max(Math.min(j3(L2.borderRadius || 0, i5 - y2), (i5 - y2) / 2, i5 * u2 / (1 + u2)), 0), g2 = Math.min(a2, n4 / Math.PI * 2 * y2), r3 = l4.length - 1;
        for (; r3--; ) (function(A3, N2, k3) {
          let E2, R2, z2, Q2 = A3[N2], v3 = A3[N2 + 1];
          if (v3[0] === "Z" && (v3 = A3[0]), (Q2[0] === "M" || Q2[0] === "L") && v3[0] === "A" ? (E2 = Q2, R2 = v3, z2 = true) : Q2[0] === "A" && (v3[0] === "M" || v3[0] === "L") && (E2 = v3, R2 = Q2), E2 && R2 && R2.params) {
            let S2 = R2[1], P2 = R2[5], U2 = R2.params, { start: w2, end: M2, cx: D2, cy: F2 } = U2, $2 = P2 ? S2 - k3 : S2 + k3, W2 = $2 ? Math.asin(k3 / $2) : 0, V2 = P2 ? W2 : -W2, _2 = Math.cos(W2) * $2;
            z2 ? (U2.start = w2 + V2, E2[1] = D2 + _2 * Math.cos(w2), E2[2] = F2 + _2 * Math.sin(w2), A3.splice(N2 + 1, 0, ["A", k3, k3, 0, 0, 1, D2 + S2 * Math.cos(U2.start), F2 + S2 * Math.sin(U2.start)])) : (U2.end = M2 - V2, R2[6] = D2 + S2 * Math.cos(U2.end), R2[7] = F2 + S2 * Math.sin(U2.end), A3.splice(N2 + 1, 0, ["A", k3, k3, 0, 0, 1, D2 + _2 * Math.cos(M2), F2 + _2 * Math.sin(M2)])), R2[4] = Math.abs(U2.end - U2.start) < Math.PI ? 0 : 1;
          }
        })(l4, r3, r3 > 1 ? g2 : a2);
        return l4;
      }
      function o2() {
        var c4, T2;
        if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
          let { options: I3, yAxis: G2 } = this, L2 = I3.stacking === "percent", l4 = (T2 = (c4 = it2.plotOptions) == null ? void 0 : c4[this.type]) == null ? void 0 : T2.borderRadius, y2 = p2(I3.borderRadius, X2(l4) ? l4 : {}), i5 = G2.options.reversed;
          for (let t3 of this.points) {
            let { shapeArgs: e5 } = t3;
            if (t3.shapeType === "roundedRect" && e5) {
              let { width: n4 = 0, height: u2 = 0, y: a2 = 0 } = e5, g2 = a2, r3 = u2;
              if (y2.scope === "stack" && t3.stackTotal) {
                let E2 = G2.translate(L2 ? 100 : t3.stackTotal, false, true, false, true), R2 = G2.translate(I3.threshold || 0, false, true, false, true), z2 = this.crispCol(0, Math.min(E2, R2), 0, Math.abs(E2 - R2));
                g2 = z2.y, r3 = z2.height;
              }
              let A3 = (t3.negative ? -1 : 1) * (i5 ? -1 : 1) == -1, N2 = y2.where;
              !N2 && this.is("waterfall") && Math.abs((t3.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (N2 = "all"), N2 || (N2 = "end");
              let k3 = Math.min(j3(y2.radius, n4), n4 / 2, N2 === "all" ? u2 / 2 : 1 / 0) || 0;
              N2 === "end" && (A3 && (g2 -= k3), r3 += k3), Z2(e5, { brBoxHeight: r3, brBoxY: g2, r: k3 });
            }
          }
        }
      }
      function p2(c4, T2) {
        return X2(c4) || (c4 = { radius: c4 || 0 }), O3(d3, T2, c4);
      }
      function b5() {
        let c4 = p2(this.options.borderRadius);
        for (let T2 of this.points) {
          let I3 = T2.shapeArgs;
          I3 && (I3.borderRadius = j3(c4.radius, (I3.r || 0) - (I3.innerR || 0)));
        }
      }
      function h2(c4, T2, I3, G2, L2 = {}) {
        let l4 = f2(c4, T2, I3, G2, L2), { r: y2 = 0, brBoxHeight: i5 = G2, brBoxY: t3 = T2 } = L2, e5 = T2 - t3, n4 = t3 + i5 - (T2 + G2), u2 = e5 - y2 > -0.1 ? 0 : y2, a2 = n4 - y2 > -0.1 ? 0 : y2, g2 = Math.max(u2 && e5, 0), r3 = Math.max(a2 && n4, 0), A3 = [c4 + u2, T2], N2 = [c4 + I3 - u2, T2], k3 = [c4 + I3, T2 + u2], E2 = [c4 + I3, T2 + G2 - a2], R2 = [c4 + I3 - a2, T2 + G2], z2 = [c4 + a2, T2 + G2], Q2 = [c4, T2 + G2 - a2], v3 = [c4, T2 + u2], S2 = (P2, U2) => Math.sqrt(Math.pow(P2, 2) - Math.pow(U2, 2));
        if (g2) {
          let P2 = S2(u2, u2 - g2);
          A3[0] -= P2, N2[0] += P2, k3[1] = v3[1] = T2 + u2 - g2;
        }
        if (G2 < u2 - g2) {
          let P2 = S2(u2, u2 - g2 - G2);
          k3[0] = E2[0] = c4 + I3 - u2 + P2, R2[0] = Math.min(k3[0], R2[0]), z2[0] = Math.max(E2[0], z2[0]), Q2[0] = v3[0] = c4 + u2 - P2, k3[1] = v3[1] = T2 + G2;
        }
        if (r3) {
          let P2 = S2(a2, a2 - r3);
          R2[0] += P2, z2[0] -= P2, E2[1] = Q2[1] = T2 + G2 - a2 + r3;
        }
        if (G2 < a2 - r3) {
          let P2 = S2(a2, a2 - r3 - G2);
          k3[0] = E2[0] = c4 + I3 - a2 + P2, N2[0] = Math.min(k3[0], N2[0]), A3[0] = Math.max(E2[0], A3[0]), Q2[0] = v3[0] = c4 + a2 - P2, E2[1] = Q2[1] = T2;
        }
        return l4.length = 0, l4.push(["M", ...A3], ["L", ...N2], ["A", u2, u2, 0, 0, 1, ...k3], ["L", ...E2], ["A", a2, a2, 0, 0, 1, ...R2], ["L", ...z2], ["A", a2, a2, 0, 0, 1, ...Q2], ["L", ...v3], ["A", u2, u2, 0, 0, 1, ...A3], ["Z"]), l4;
      }
      return { compose: function(c4, T2, I3) {
        let G2 = c4.types.pie;
        if (!T2.symbolCustomAttribs.includes("borderRadius")) {
          let L2 = I3.prototype.symbols;
          tt2(c4, "afterColumnTranslate", o2, { order: 9 }), tt2(G2, "afterTranslate", b5), T2.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY"), x2 = L2.arc, f2 = L2.roundedRect, L2.arc = C3, L2.roundedRect = h2;
        }
      }, optionsToObject: p2 };
    }), at2(s2, "Core/Responsive.js", [s2["Core/Utilities.js"]], function(B3) {
      var K2;
      let { diffObjects: q2, extend: it2, find: rt2, merge: tt2, pick: Z2, uniqueKey: X2 } = B3;
      return function(O3) {
        function j3(x2, f2) {
          let C3 = x2.condition;
          (C3.callback || function() {
            return this.chartWidth <= Z2(C3.maxWidth, Number.MAX_VALUE) && this.chartHeight <= Z2(C3.maxHeight, Number.MAX_VALUE) && this.chartWidth >= Z2(C3.minWidth, 0) && this.chartHeight >= Z2(C3.minHeight, 0);
          }).call(this) && f2.push(x2._id);
        }
        function d3(x2, f2) {
          let C3 = this.options.responsive, o2 = this.currentResponsive, p2 = [], b5;
          !f2 && C3 && C3.rules && C3.rules.forEach((T2) => {
            T2._id === void 0 && (T2._id = X2()), this.matchResponsiveRule(T2, p2);
          }, this);
          let h2 = tt2(...p2.map((T2) => rt2((C3 || {}).rules || [], (I3) => I3._id === T2)).map((T2) => T2 && T2.chartOptions));
          h2.isResponsiveOptions = true, p2 = p2.toString() || void 0;
          let c4 = o2 && o2.ruleIds;
          p2 === c4 || (o2 && (this.currentResponsive = void 0, this.updatingResponsive = true, this.update(o2.undoOptions, x2, true), this.updatingResponsive = false), p2 ? ((b5 = q2(h2, this.options, true, this.collectionsWithUpdate)).isResponsiveOptions = true, this.currentResponsive = { ruleIds: p2, mergedOptions: h2, undoOptions: b5 }, this.updatingResponsive || this.update(h2, x2, true)) : this.currentResponsive = void 0);
        }
        O3.compose = function(x2) {
          let f2 = x2.prototype;
          return f2.matchResponsiveRule || it2(f2, { matchResponsiveRule: j3, setResponsive: d3 }), x2;
        };
      }(K2 || (K2 = {})), K2;
    }), at2(s2, "masters/highcharts.src.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"], s2["Core/Defaults.js"], s2["Core/Animation/Fx.js"], s2["Core/Animation/AnimationUtilities.js"], s2["Core/Renderer/HTML/AST.js"], s2["Core/Templating.js"], s2["Core/Renderer/RendererRegistry.js"], s2["Core/Renderer/RendererUtilities.js"], s2["Core/Renderer/SVG/SVGElement.js"], s2["Core/Renderer/SVG/SVGRenderer.js"], s2["Core/Renderer/HTML/HTMLElement.js"], s2["Core/Axis/Axis.js"], s2["Core/Axis/DateTimeAxis.js"], s2["Core/Axis/LogarithmicAxis.js"], s2["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"], s2["Core/Axis/Tick.js"], s2["Core/Tooltip.js"], s2["Core/Series/Point.js"], s2["Core/Pointer.js"], s2["Core/Legend/Legend.js"], s2["Core/Legend/LegendSymbol.js"], s2["Core/Chart/Chart.js"], s2["Extensions/ScrollablePlotArea.js"], s2["Core/Axis/Stacking/StackingAxis.js"], s2["Core/Axis/Stacking/StackItem.js"], s2["Core/Series/Series.js"], s2["Core/Series/SeriesRegistry.js"], s2["Series/Column/ColumnDataLabel.js"], s2["Series/Pie/PieDataLabel.js"], s2["Core/Series/DataLabel.js"], s2["Extensions/OverlappingDataLabels.js"], s2["Extensions/BorderRadius.js"], s2["Core/Responsive.js"], s2["Core/Color/Color.js"], s2["Core/Time.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2, O3, j3, d3, x2, f2, C3, o2, p2, b5, h2, c4, T2, I3, G2, L2, l4, y2, i5, t3, e5, n4, u2, a2, g2, r3, A3, N2, k3) {
      return B3.AST = tt2, B3.Axis = f2, B3.Chart = L2, B3.Color = N2, B3.DataLabel = a2, B3.Fx = it2, B3.HTMLElement = x2, B3.Legend = I3, B3.LegendSymbol = G2, B3.OverlappingDataLabels = B3.OverlappingDataLabels || g2, B3.PlotLineOrBand = p2, B3.Point = c4, B3.Pointer = T2, B3.RendererRegistry = X2, B3.Series = t3, B3.SeriesRegistry = e5, B3.StackItem = i5, B3.SVGElement = j3, B3.SVGRenderer = d3, B3.Templating = Z2, B3.Tick = b5, B3.Time = k3, B3.Tooltip = h2, B3.animate = rt2.animate, B3.animObject = rt2.animObject, B3.chart = L2.chart, B3.color = N2.parse, B3.dateFormat = Z2.dateFormat, B3.defaultOptions = q2.defaultOptions, B3.distribute = O3.distribute, B3.format = Z2.format, B3.getDeferredAnimation = rt2.getDeferredAnimation, B3.getOptions = q2.getOptions, B3.numberFormat = Z2.numberFormat, B3.seriesType = e5.seriesType, B3.setAnimation = rt2.setAnimation, B3.setOptions = q2.setOptions, B3.stop = rt2.stop, B3.time = q2.defaultTime, B3.timers = it2.timers, r3.compose(B3.Series, B3.SVGElement, B3.SVGRenderer), n4.compose(B3.Series.types.column), a2.compose(B3.Series), C3.compose(B3.Axis), x2.compose(B3.SVGRenderer), I3.compose(B3.Chart), o2.compose(B3.Axis), g2.compose(B3.Chart), u2.compose(B3.Series.types.pie), p2.compose(B3.Chart, B3.Axis), T2.compose(B3.Chart), A3.compose(B3.Chart), l4.compose(B3.Axis, B3.Chart, B3.Series), y2.compose(B3.Axis, B3.Chart, B3.Series), h2.compose(B3.Pointer), K2.extend(B3, K2), B3;
    }), s2["masters/highcharts.src.js"]._modules = s2, s2["masters/highcharts.src.js"];
  });
})(Yi);
var Qt$1 = Yi.exports;
const mi = /* @__PURE__ */ ce(Qt$1), Is = T$7`/**
 * @license Highcharts
 *
 * (c) 2009-2022 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */:root,.highcharts-light{--highcharts-color-0: #2caffe;--highcharts-color-1: #544fc5;--highcharts-color-2: #00e272;--highcharts-color-3: #fe6a35;--highcharts-color-4: #6b8abc;--highcharts-color-5: #d568fb;--highcharts-color-6: #2ee0ca;--highcharts-color-7: #fa4b42;--highcharts-color-8: #feb56a;--highcharts-color-9: #91e8e1;--highcharts-background-color: #ffffff;--highcharts-neutral-color-100: #000000;--highcharts-neutral-color-80: #333333;--highcharts-neutral-color-60: #666666;--highcharts-neutral-color-40: #999999;--highcharts-neutral-color-20: #cccccc;--highcharts-neutral-color-10: #e6e6e6;--highcharts-neutral-color-5: #f2f2f2;--highcharts-neutral-color-3: #f7f7f7;--highcharts-highlight-color-100: #0022ff;--highcharts-highlight-color-80: #334eff;--highcharts-highlight-color-60: #667aff;--highcharts-highlight-color-20: #ccd3ff;--highcharts-highlight-color-10: #e6e9ff;--highcharts-positive-color: #06b535;--highcharts-negative-color: #f21313;--highcharts-annotation-color-0: rgba(130, 170, 255, .4);--highcharts-annotation-color-1: rgba(139, 191, 216, .4);--highcharts-annotation-color-2: rgba(150, 216, 192, .4);--highcharts-annotation-color-3: rgba(156, 229, 161, .4);--highcharts-annotation-color-4: rgba(162, 241, 130, .4);--highcharts-annotation-color-5: rgba(169, 255, 101, .4)}@media (prefers-color-scheme: dark){:root{--highcharts-background-color: rgb(48, 48, 48);--highcharts-neutral-color-100: rgb(255, 255, 255);--highcharts-neutral-color-80: rgb(214, 214, 214);--highcharts-neutral-color-60: rgb(173, 173, 173);--highcharts-neutral-color-40: rgb(133, 133, 133);--highcharts-neutral-color-20: rgb(92, 92, 92);--highcharts-neutral-color-10: rgb(71, 71, 71);--highcharts-neutral-color-5: rgb(61, 61, 61);--highcharts-neutral-color-3: rgb(57, 57, 57);--highcharts-highlight-color-100: rgb(122, 167, 255);--highcharts-highlight-color-80: rgb(108, 144, 214);--highcharts-highlight-color-60: rgb(94, 121, 173);--highcharts-highlight-color-20: rgb(65, 74, 92);--highcharts-highlight-color-10: rgb(58, 63, 71)}}.highcharts-dark{--highcharts-background-color: rgb(48, 48, 48);--highcharts-neutral-color-100: rgb(255, 255, 255);--highcharts-neutral-color-80: rgb(214, 214, 214);--highcharts-neutral-color-60: rgb(173, 173, 173);--highcharts-neutral-color-40: rgb(133, 133, 133);--highcharts-neutral-color-20: rgb(92, 92, 92);--highcharts-neutral-color-10: rgb(71, 71, 71);--highcharts-neutral-color-5: rgb(61, 61, 61);--highcharts-neutral-color-3: rgb(57, 57, 57);--highcharts-highlight-color-100: rgb(122, 167, 255);--highcharts-highlight-color-80: rgb(108, 144, 214);--highcharts-highlight-color-60: rgb(94, 121, 173);--highcharts-highlight-color-20: rgb(65, 74, 92);--highcharts-highlight-color-10: rgb(58, 63, 71)}.highcharts-container{position:relative;overflow:hidden;width:100%;height:100%;text-align:left;line-height:normal;z-index:0;-webkit-tap-highlight-color:rgba(0,0,0,0);font-family:Helvetica,Arial,sans-serif;font-size:1rem;-webkit-user-select:none;user-select:none;touch-action:manipulation;outline:none}.highcharts-no-touch-action{touch-action:none}.highcharts-root{display:block}.highcharts-root text{stroke-width:0}.highcharts-strong{font-weight:700}.highcharts-emphasized{font-style:italic}.highcharts-anchor{cursor:pointer}.highcharts-background{fill:var(--highcharts-background-color)}.highcharts-plot-border,.highcharts-plot-background,.highcharts-label-box{fill:none}.highcharts-label text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-button-box{fill:inherit}.highcharts-tracker-line{stroke-linejoin:round;stroke:#c0c0c000;stroke-width:22;fill:none}.highcharts-tracker-area{fill:#c0c0c000;stroke-width:0}.highcharts-title{fill:var(--highcharts-neutral-color-80);font-size:1.2em;font-weight:700}.highcharts-subtitle{fill:var(--highcharts-neutral-color-60);font-size:.8em}.highcharts-axis-line{fill:none;stroke:var(--highcharts-neutral-color-80)}.highcharts-yaxis .highcharts-axis-line{stroke-width:0}.highcharts-axis-title{fill:var(--highcharts-neutral-color-60);font-size:.8em}.highcharts-axis-labels{fill:var(--highcharts-neutral-color-80);cursor:default;font-size:.8em}.highcharts-grid-line{fill:none;stroke:var(--highcharts-neutral-color-10)}.highcharts-xaxis-grid .highcharts-grid-line{stroke-width:0}.highcharts-tick{stroke:var(--highcharts-neutral-color-80)}.highcharts-yaxis .highcharts-tick{stroke-width:0}.highcharts-minor-grid-line{stroke:var(--highcharts-neutral-color-5)}.highcharts-crosshair-thin{stroke-width:1px;stroke:var(--highcharts-neutral-color-20)}.highcharts-crosshair-category{stroke:var(--highcharts-highlight-color-20);stroke-opacity:.25}.highcharts-credits{cursor:pointer;fill:var(--highcharts-neutral-color-40);font-size:.6em;transition:fill .25s,font-size .25s}.highcharts-credits:hover{fill:var(--highcharts-neutral-color-100);font-size:.7em}.highcharts-tooltip{cursor:default;pointer-events:none;white-space:nowrap;transition:stroke .15s}.highcharts-tooltip .highcharts-tracker{fill:none;stroke:none}.highcharts-tooltip text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-tooltip .highcharts-header{font-size:.8em}.highcharts-tooltip-box{stroke-width:1px;fill:var(--highcharts-background-color)}.highcharts-tooltip-box{stroke-width:0;fill:var(--highcharts-background-color)}.highcharts-tooltip-box .highcharts-label-box{fill:var(--highcharts-background-color)}div.highcharts-tooltip{filter:none;font-size:.8em}.highcharts-selection-marker{fill:var(--highcharts-highlight-color-80);fill-opacity:.25}.highcharts-graph{fill:none;stroke-width:2px;stroke-linecap:round;stroke-linejoin:round}.highcharts-empty-series{stroke-width:1px;fill:none;stroke:var(--highcharts-neutral-color-20)}.highcharts-state-hover .highcharts-graph{stroke-width:3}.highcharts-point-inactive,.highcharts-series-inactive{opacity:.2;transition:opacity 50ms}.highcharts-state-hover path{transition:stroke-width 50ms}.highcharts-state-normal path{transition:stroke-width .25s}g.highcharts-series,.highcharts-point,.highcharts-markers,.highcharts-data-labels{transition:opacity .25s}.highcharts-legend-series-active g.highcharts-series:not(.highcharts-series-hover),.highcharts-legend-point-active .highcharts-point:not(.highcharts-point-hover,.highcharts-point-select),.highcharts-legend-series-active .highcharts-markers:not(.highcharts-series-hover),.highcharts-legend-series-active .highcharts-data-labels:not(.highcharts-series-hover){opacity:.2}.highcharts-color-0{fill:var(--highcharts-color-0);stroke:var(--highcharts-color-0)}.highcharts-color-1{fill:var(--highcharts-color-1);stroke:var(--highcharts-color-1)}.highcharts-color-2{fill:var(--highcharts-color-2);stroke:var(--highcharts-color-2)}.highcharts-color-3{fill:var(--highcharts-color-3);stroke:var(--highcharts-color-3)}.highcharts-color-4{fill:var(--highcharts-color-4);stroke:var(--highcharts-color-4)}.highcharts-color-5{fill:var(--highcharts-color-5);stroke:var(--highcharts-color-5)}.highcharts-color-6{fill:var(--highcharts-color-6);stroke:var(--highcharts-color-6)}.highcharts-color-7{fill:var(--highcharts-color-7);stroke:var(--highcharts-color-7)}.highcharts-color-8{fill:var(--highcharts-color-8);stroke:var(--highcharts-color-8)}.highcharts-color-9{fill:var(--highcharts-color-9);stroke:var(--highcharts-color-9)}.highcharts-area{fill-opacity:.75;stroke-width:0}.highcharts-markers{stroke-width:1px;stroke:var(--highcharts-background-color)}.highcharts-a11y-markers-hidden .highcharts-point:not(.highcharts-point-hover,.highcharts-a11y-marker-visible),.highcharts-a11y-marker-hidden{opacity:0}.highcharts-point{stroke-width:1px}.highcharts-dense-data .highcharts-point{stroke-width:0}.highcharts-data-label text,text.highcharts-data-label{font-size:.7em;font-weight:700}.highcharts-data-label-box{fill:none;stroke-width:0}.highcharts-data-label text,text.highcharts-data-label{fill:var(--highcharts-neutral-color-80)}.highcharts-data-label-connector{fill:none}.highcharts-data-label-hidden{pointer-events:none}.highcharts-halo{fill-opacity:.25;stroke-width:0}.highcharts-series-label text{fill:inherit;font-weight:700}.highcharts-series:not(.highcharts-pie-series) .highcharts-point-select,.highcharts-markers .highcharts-point-select{fill:var(--highcharts-neutral-color-20);stroke:var(--highcharts-neutral-color-100)}.highcharts-column-series path.highcharts-point,.highcharts-bar-series path.highcharts-point{stroke:var(--highcharts-background-color)}.highcharts-column-series .highcharts-point{transition:fill-opacity .25s}.highcharts-column-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-pie-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-pie-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-funnel-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-funnel-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-funnel-series .highcharts-point-select{fill:inherit;stroke:inherit}.highcharts-pyramid-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-pyramid-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-pyramid-series .highcharts-point-select{fill:inherit;stroke:inherit}.highcharts-solidgauge-series .highcharts-point{stroke-width:0}.highcharts-treemap-series .highcharts-point{stroke-width:1px;stroke:var(--highcharts-neutral-color-10);transition:stroke .25s,fill .25s,fill-opacity .25s}.highcharts-treemap-series .highcharts-point-hover{stroke:var(--highcharts-neutral-color-40);transition:stroke 25ms,fill 25ms,fill-opacity 25ms}.highcharts-treemap-series .highcharts-above-level{display:none}.highcharts-treemap-series .highcharts-internal-node{fill:none}.highcharts-treemap-series .highcharts-internal-node-interactive{fill-opacity:.15;cursor:pointer}.highcharts-treemap-series .highcharts-internal-node-interactive:hover{fill-opacity:.75}.highcharts-vector-series .highcharts-point,.highcharts-windbarb-series .highcharts-point{fill:none;stroke-width:2px}.highcharts-lollipop-stem{stroke:var(--highcharts-neutral-color-100)}.highcharts-focus-border{fill:none;stroke-width:2px}.highcharts-legend-item-hidden .highcharts-focus-border{fill:none!important}.highcharts-legend-box{fill:none;stroke-width:0}.highcharts-legend-item>text{fill:var(--highcharts-neutral-color-80);font-weight:700;font-size:.8em;cursor:pointer;stroke-width:0}.highcharts-legend-item:hover text{fill:var(--highcharts-neutral-color-100)}.highcharts-legend-item-hidden *{fill:var(--highcharts-neutral-color-60)!important;stroke:var(--highcharts-neutral-color-60)!important;transition:fill .25s;text-decoration:line-through}.highcharts-legend-nav-active{fill:var(--highcharts-highlight-color-100);cursor:pointer}.highcharts-legend-nav-inactive{fill:var(--highcharts-neutral-color-20)}circle.highcharts-legend-nav-active,circle.highcharts-legend-nav-inactive{fill:#c0c0c000}.highcharts-legend-title-box{fill:none;stroke-width:0}.highcharts-bubble-legend-symbol{stroke-width:2;fill-opacity:.5}.highcharts-bubble-legend-connectors{stroke-width:1}.highcharts-bubble-legend-labels{fill:var(--highcharts-neutral-color-80);font-size:.7em}.highcharts-loading{position:absolute;background-color:var(--highcharts-background-color);opacity:.5;text-align:center;z-index:10;transition:opacity .25s}.highcharts-loading-hidden{height:0!important;opacity:0;overflow:hidden;transition:opacity .25s,height .25s step-end}.highcharts-loading-inner{font-weight:700;position:relative;top:45%}.highcharts-plot-band,.highcharts-pane{fill:var(--highcharts-neutral-color-100);fill-opacity:.05}.highcharts-plot-line{fill:none;stroke:var(--highcharts-neutral-color-40);stroke-width:1px}.highcharts-plot-line-label{font-size:.8em}.highcharts-boxplot-box{fill:var(--highcharts-background-color)}.highcharts-boxplot-median{stroke-width:2px}.highcharts-bubble-series .highcharts-point{fill-opacity:.5}.highcharts-errorbar-series .highcharts-point{stroke:var(--highcharts-neutral-color-100)}.highcharts-gauge-series .highcharts-data-label-box{stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-gauge-series .highcharts-dial{fill:var(--highcharts-neutral-color-100);stroke-width:0}.highcharts-polygon-series .highcharts-graph{fill:inherit;stroke-width:0}.highcharts-waterfall-series .highcharts-graph{stroke:var(--highcharts-neutral-color-80);stroke-dasharray:1,3}.highcharts-sankey-series .highcharts-point{stroke-width:0}.highcharts-sankey-series .highcharts-link{transition:fill .25s,fill-opacity .25s;fill-opacity:.5}.highcharts-sankey-series .highcharts-point-hover.highcharts-link{transition:fill 50ms,fill-opacity 50ms;fill-opacity:1}.highcharts-venn-series .highcharts-point{fill-opacity:.75;stroke:var(--highcharts-neutral-color-20);transition:stroke .25s,fill-opacity .25s}.highcharts-venn-series .highcharts-point-hover{fill-opacity:1;stroke:var(--highcharts-neutral-color-20)}.highcharts-timeline-series .highcharts-graph{stroke:var(--highcharts-neutral-color-20)}.highcharts-navigator-mask-outside{fill-opacity:0}.highcharts-navigator-mask-inside{fill:var(--highcharts-highlight-color-60);fill-opacity:.25;cursor:ew-resize}.highcharts-navigator-outline{stroke:var(--highcharts-neutral-color-40);fill:none}.highcharts-navigator-handle{stroke:var(--highcharts-neutral-color-40);fill:var(--highcharts-neutral-color-5);cursor:ew-resize}.highcharts-navigator-series{fill:var(--highcharts-highlight-color-80);stroke:var(--highcharts-highlight-color-80)}.highcharts-navigator-series .highcharts-graph{stroke-width:1px}.highcharts-navigator-series .highcharts-area{fill-opacity:.05}.highcharts-navigator-xaxis .highcharts-axis-line{stroke-width:0}.highcharts-navigator-xaxis .highcharts-grid-line{stroke-width:1px;stroke:var(--highcharts-neutral-color-10)}.highcharts-navigator-xaxis.highcharts-axis-labels{fill:var(--highcharts-neutral-color-100);font-size:.7em;opacity:.6}.highcharts-navigator-yaxis .highcharts-grid-line{stroke-width:0}.highcharts-scrollbar-thumb{fill:var(--highcharts-neutral-color-20);stroke:var(--highcharts-neutral-color-20);stroke-width:0}.highcharts-scrollbar-button{fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-scrollbar-arrow{fill:var(--highcharts-neutral-color-60)}.highcharts-scrollbar-rifles{stroke:none;stroke-width:1px}.highcharts-scrollbar-track{fill:#fff0;stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-button{fill:var(--highcharts-neutral-color-3);stroke:var(--highcharts-neutral-color-20);cursor:default;stroke-width:1px;transition:fill .25s}.highcharts-button text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-button-hover{transition:fill 0ms;fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-20)}.highcharts-button-hover text{fill:var(--highcharts-neutral-color-80)}.highcharts-button-pressed{font-weight:700;fill:var(--highcharts-highlight-color-10);stroke:var(--highcharts-neutral-color-20)}.highcharts-button-pressed text{fill:var(--highcharts-neutral-color-80);font-weight:700}.highcharts-button-disabled text{fill:var(--highcharts-neutral-color-80)}.highcharts-range-selector-buttons .highcharts-button{stroke-width:0}.highcharts-range-label rect{fill:none}.highcharts-range-label text{fill:var(--highcharts-neutral-color-60)}.highcharts-range-input rect{fill:none}.highcharts-range-input text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-range-input{stroke-width:1px;stroke:var(--highcharts-neutral-color-20)}input.highcharts-range-selector{position:absolute;border:0;width:1px;height:1px;padding:0;text-align:center;left:-9em}.highcharts-crosshair-label text{fill:var(--highcharts-background-color);font-size:1.7em}.highcharts-crosshair-label .highcharts-label-box{fill:inherit}.highcharts-candlestick-series .highcharts-point{stroke:var(--highcharts-neutral-color-100);stroke-width:1px}.highcharts-candlestick-series .highcharts-point-up{fill:var(--highcharts-background-color)}.highcharts-hollowcandlestick-series .highcharts-point-down{fill:var(--highcharts-negative-color);stroke:var(--highcharts-negative-color)}.highcharts-hollowcandlestick-series .highcharts-point-down-bearish-up{fill:var(--highcharts-positive-color);stroke:var(--highcharts-positive-color)}.highcharts-hollowcandlestick-series .highcharts-point-up{fill:transparent;stroke:var(--highcharts-positive-color)}.highcharts-ohlc-series .highcharts-point-hover{stroke-width:3px}.highcharts-flags-series .highcharts-point .highcharts-label-box{stroke:var(--highcharts-neutral-color-40);fill:var(--highcharts-background-color);transition:fill .25s}.highcharts-flags-series .highcharts-point-hover .highcharts-label-box{stroke:var(--highcharts-neutral-color-100);fill:var(--highcharts-highlight-color-20)}.highcharts-flags-series .highcharts-point text{fill:var(--highcharts-neutral-color-100);font-size:.9em;font-weight:700}.highcharts-map-series .highcharts-point{transition:fill .5s,fill-opacity .5s,stroke-width .25s;stroke:var(--highcharts-neutral-color-20);stroke-width:inherit}.highcharts-map-series .highcharts-point-hover{transition:fill 0ms,fill-opacity 0ms;fill-opacity:.5}.highcharts-mapline-series .highcharts-point{fill:none}.highcharts-heatmap-series .highcharts-point{stroke-width:0}.highcharts-map-navigation{font-size:1.3em;font-weight:700;text-align:center}.highcharts-map-navigation.highcharts-button{fill:var(--highcharts-background-color);stroke:var(--highcharts-neutral-color-10)}.highcharts-map-navigation.highcharts-button:hover{fill:var(--highcharts-neutral-color-10)}.highcharts-map-navigation.highcharts-button .highcharts-button-symbol{stroke-width:2px}.highcharts-mapview-inset-border{stroke:var(--highcharts-neutral-color-20);stroke-width:1px;fill:none}.highcharts-coloraxis{stroke-width:0}.highcharts-coloraxis-marker{fill:var(--highcharts-neutral-color-40)}.highcharts-null-point{fill:var(--highcharts-neutral-color-3)}.highcharts-3d-frame{fill:transparent}.highcharts-contextbutton{fill:var(--highcharts-background-color);stroke:none;stroke-linecap:round}.highcharts-contextbutton:hover{fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-10)}.highcharts-button-symbol{stroke:var(--highcharts-neutral-color-60);stroke-width:3px}.highcharts-menu{border:none;background:var(--highcharts-background-color);border-radius:3px;padding:.5em;box-shadow:3px 3px 10px #888}.highcharts-menu-item{background:none;border-radius:3px;color:var(--highcharts-neutral-color-80);cursor:pointer;font-size:.8em;list-style-type:none;padding:.5em;transition:background .25s,color .25s}.highcharts-menu-item:hover{background:var(--highcharts-neutral-color-5)}.highcharts-breadcrumbs-button{fill:none;stroke-width:0;cursor:pointer}.highcharts-breadcrumbs-separator{fill:var(--highcharts-neutral-color-60)}.highcharts-drilldown-point{cursor:pointer}.highcharts-drilldown-data-label text,text.highcharts-drilldown-data-label,.highcharts-drilldown-axis-label{cursor:pointer;fill:var(--highcharts-highlight-color-100);font-weight:700;text-decoration:underline}.highcharts-no-data text{font-weight:700;font-size:.8em;fill:var(--highcharts-neutral-color-60)}.highcharts-axis-resizer{cursor:ns-resize;stroke:var(--highcharts-neutral-color-100);stroke-width:2px}.highcharts-bullet-target{stroke-width:0}.highcharts-lineargauge-target,.highcharts-lineargauge-target-line{stroke-width:1px;stroke:var(--highcharts-neutral-color-80)}.highcharts-fibonacci-background-0,.highcharts-pitchfork-inner-background,.highcharts-measure-background{fill:var(--highcharts-annotation-color-0)}.highcharts-fibonacci-background-1{fill:var(--highcharts-annotation-color-1)}.highcharts-fibonacci-background-2{fill:var(--highcharts-annotation-color-2)}.highcharts-fibonacci-background-3,.highcharts-pitchfork-outer-background{fill:var(--highcharts-annotation-color-3)}.highcharts-fibonacci-background-4{fill:var(--highcharts-annotation-color-4)}.highcharts-fibonacci-background-5{fill:var(--highcharts-annotation-color-5)}.highcharts-fibonacci-line{stroke:var(--highcharts-neutral-color-40)}.highcharts-crooked-lines,.highcharts-tunnel-lines,.highcharts-infinity-lines,.highcharts-timecycles-lines,.highcharts-fibonacci-timezones-lines,.highcharts-pitchfork-lines,.highcharts-vertical-line,.highcharts-measure-crosshair-x,.highcharts-measure-crosshair-y{stroke:var(--highcharts-neutral-color-100);stroke-opacity:.75;fill:none}.highcharts-measure-crosshair-x,.highcharts-measure-crosshair-y{stroke-dasharray:1,3}.highcharts-tunnel-background{fill:var(--highcharts-color-0)}.highcharts-annotation-shapes{cursor:move}.highcharts-basic-shape{fill:var(--highcharts-neutral-color-100);stroke:var(--highcharts-neutral-color-100);opacity:.74}.highcharts-annotation-label-box{stroke-width:1px;stroke:var(--highcharts-neutral-color-100);fill:var(--highcharts-neutral-color-100);fill-opacity:.75}.highcharts-annotation-label text{fill:var(--highcharts-neutral-color-10);font-size:.8em}.highcharts-a11y-proxy-element{border-width:0;background-color:transparent;cursor:pointer;outline:none;opacity:.001;z-index:999;overflow:hidden;padding:0;margin:0;display:block;position:absolute}.highcharts-a11y-proxy-group li{list-style:none}.highcharts-visually-hidden{position:absolute;width:1px;height:1px;overflow:hidden;white-space:nowrap;clip:rect(1px,1px,1px,1px);margin-top:-3px;opacity:.01}.highcharts-a11y-invisible{visibility:hidden}.highcharts-a11y-proxy-container,.highcharts-a11y-proxy-container-before,.highcharts-a11y-proxy-container-after{position:absolute;white-space:nowrap}g.highcharts-series,.highcharts-markers,.highcharts-point{outline:none}.highcharts-treegrid-node-collapsed,.highcharts-treegrid-node-expanded{cursor:pointer}.highcharts-point-connecting-path{fill:none}.highcharts-grid-axis .highcharts-tick,.highcharts-grid-axis .highcharts-axis-line{stroke:var(--highcharts-neutral-color-20);stroke-width:1px}`;
var Xi = { exports: {} };
(function(m3) {
  (function(H2) {
    m3.exports ? (H2.default = H2, m3.exports = H2) : H2(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(H2) {
    var s2 = H2 ? H2._modules : {};
    function at2(B3, K2, q2, it2) {
      B3.hasOwnProperty(K2) || (B3[K2] = it2.apply(null, q2), typeof CustomEvent == "function" && H2.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: K2, module: B3[K2] } })));
    }
    at2(s2, "Accessibility/Utils/HTMLUtilities.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { doc: q2, win: it2 } = B3, { css: rt2 } = K2, tt2 = it2.EventTarget && new it2.EventTarget() || "none";
      function Z2(O3) {
        if (typeof it2.MouseEvent == "function") return new it2.MouseEvent(O3.type, O3);
        if (q2.createEvent) {
          let j3 = q2.createEvent("MouseEvent");
          if (j3.initMouseEvent) return j3.initMouseEvent(O3.type, O3.bubbles, O3.cancelable, O3.view || it2, O3.detail, O3.screenX, O3.screenY, O3.clientX, O3.clientY, O3.ctrlKey, O3.altKey, O3.shiftKey, O3.metaKey, O3.button, O3.relatedTarget), j3;
        }
        return X2(O3.type);
      }
      function X2(O3, j3, d3) {
        let x2 = j3 || { x: 0, y: 0 };
        if (typeof it2.MouseEvent == "function") return new it2.MouseEvent(O3, { bubbles: true, cancelable: true, composed: true, button: 0, buttons: 1, relatedTarget: d3 || tt2, view: it2, detail: O3 === "click" ? 1 : 0, screenX: x2.x, screenY: x2.y, clientX: x2.x, clientY: x2.y });
        if (q2.createEvent) {
          let f2 = q2.createEvent("MouseEvent");
          if (f2.initMouseEvent) return f2.initMouseEvent(O3, true, true, it2, O3 === "click" ? 1 : 0, x2.x, x2.y, x2.x, x2.y, false, false, false, false, 0, null), f2;
        }
        return { type: O3 };
      }
      return { addClass: function(O3, j3) {
        O3.classList ? O3.classList.add(j3) : 0 > O3.className.indexOf(j3) && (O3.className += " " + j3);
      }, cloneMouseEvent: Z2, cloneTouchEvent: function(O3) {
        let j3 = (x2) => {
          let f2 = [];
          for (let C3 = 0; C3 < x2.length; ++C3) {
            let o2 = x2.item(C3);
            o2 && f2.push(o2);
          }
          return f2;
        };
        if (typeof it2.TouchEvent == "function") {
          let x2 = new it2.TouchEvent(O3.type, { touches: j3(O3.touches), targetTouches: j3(O3.targetTouches), changedTouches: j3(O3.changedTouches), ctrlKey: O3.ctrlKey, shiftKey: O3.shiftKey, altKey: O3.altKey, metaKey: O3.metaKey, bubbles: O3.bubbles, cancelable: O3.cancelable, composed: O3.composed, detail: O3.detail, view: O3.view });
          return O3.defaultPrevented && x2.preventDefault(), x2;
        }
        let d3 = Z2(O3);
        return d3.touches = O3.touches, d3.changedTouches = O3.changedTouches, d3.targetTouches = O3.targetTouches, d3;
      }, escapeStringForHTML: function(O3) {
        return O3.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
      }, getElement: function(O3) {
        return q2.getElementById(O3);
      }, getFakeMouseEvent: X2, getHeadingTagNameForElement: function(O3) {
        let j3 = (C3) => "h" + Math.min(6, parseInt(C3.slice(1), 10) + 1), d3 = (C3) => /^H[1-6]$/i.test(C3), x2 = (C3) => {
          let o2 = C3;
          for (; o2 = o2.previousSibling; ) {
            let p2 = o2.tagName || "";
            if (d3(p2)) return p2;
          }
          return "";
        }, f2 = (C3) => {
          let o2 = x2(C3);
          if (o2) return j3(o2);
          let p2 = C3.parentElement;
          if (!p2) return "p";
          let b5 = p2.tagName;
          return d3(b5) ? j3(b5) : f2(p2);
        };
        return f2(O3);
      }, removeChildNodes: function(O3) {
        for (; O3.lastChild; ) O3.removeChild(O3.lastChild);
      }, removeClass: function(O3, j3) {
        O3.classList ? O3.classList.remove(j3) : O3.className = O3.className.replace(RegExp(j3, "g"), "");
      }, removeElement: function(O3) {
        O3 && O3.parentNode && O3.parentNode.removeChild(O3);
      }, reverseChildNodes: function(O3) {
        let j3 = O3.childNodes.length;
        for (; j3--; ) O3.appendChild(O3.childNodes[j3]);
      }, simulatedEventTarget: tt2, stripHTMLTagsFromString: function(O3, j3 = false) {
        return typeof O3 == "string" ? j3 ? O3.replace(/<\/?[^>]+(>|$)/g, "") : O3.replace(/<\/?(?!\s)[^>]+(>|$)/g, "") : O3;
      }, visuallyHideElement: function(O3) {
        rt2(O3, { position: "absolute", width: "1px", height: "1px", overflow: "hidden", whiteSpace: "nowrap", clip: "rect(1px, 1px, 1px, 1px)", marginTop: "-3px", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)", filter: "alpha(opacity=1)", opacity: 0.01 });
      } };
    }), at2(s2, "Accessibility/A11yI18n.js", [s2["Core/Templating.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      var q2;
      let { format: it2 } = B3, { getNestedProperty: rt2, pick: tt2 } = K2;
      return function(Z2) {
        function X2(j3, d3, x2) {
          let f2 = (h2, c4) => {
            let T2 = h2.slice(c4 || 0), I3 = T2.indexOf("{"), G2 = T2.indexOf("}");
            if (I3 > -1 && G2 > I3) return { statement: T2.substring(I3 + 1, G2), begin: c4 + I3 + 1, end: c4 + G2 };
          }, C3 = [], o2, p2, b5 = 0;
          do
            o2 = f2(j3, b5), (p2 = j3.substring(b5, o2 && o2.begin - 1)).length && C3.push({ value: p2, type: "constant" }), o2 && C3.push({ value: o2.statement, type: "statement" }), b5 = o2 ? o2.end + 1 : b5 + 1;
          while (o2);
          return C3.forEach((h2) => {
            h2.type === "statement" && (h2.value = function(c4, T2) {
              let I3, G2, L2 = c4.indexOf("#each("), l4 = c4.indexOf("#plural("), y2 = c4.indexOf("["), i5 = c4.indexOf("]");
              if (L2 > -1) {
                let e5 = c4.slice(L2).indexOf(")") + L2, n4 = c4.substring(0, L2), u2 = c4.substring(e5 + 1), a2 = c4.substring(L2 + 6, e5).split(","), g2 = Number(a2[1]), r3;
                if (G2 = "", I3 = rt2(a2[0], T2)) {
                  r3 = (g2 = isNaN(g2) ? I3.length : g2) < 0 ? I3.length + g2 : Math.min(g2, I3.length);
                  for (let A3 = 0; A3 < r3; ++A3) G2 += n4 + I3[A3] + u2;
                }
                return G2.length ? G2 : "";
              }
              if (l4 > -1) {
                var t3;
                let e5 = c4.slice(l4).indexOf(")") + l4, n4 = c4.substring(l4 + 8, e5).split(",");
                switch (Number(rt2(n4[0], T2))) {
                  case 0:
                    G2 = tt2(n4[4], n4[1]);
                    break;
                  case 1:
                    G2 = tt2(n4[2], n4[1]);
                    break;
                  case 2:
                    G2 = tt2(n4[3], n4[1]);
                    break;
                  default:
                    G2 = n4[1];
                }
                return G2 ? (t3 = G2).trim && t3.trim() || t3.replace(/^\s+|\s+$/g, "") : "";
              }
              if (y2 > -1) {
                let e5, n4 = c4.substring(0, y2), u2 = Number(c4.substring(y2 + 1, i5));
                return I3 = rt2(n4, T2), !isNaN(u2) && I3 && (u2 < 0 ? (e5 = I3[I3.length + u2]) === void 0 && (e5 = I3[0]) : (e5 = I3[u2]) === void 0 && (e5 = I3[I3.length - 1])), e5 !== void 0 ? e5 : "";
              }
              return "{" + c4 + "}";
            }(h2.value, d3));
          }), it2(C3.reduce((h2, c4) => h2 + c4.value, ""), d3, x2);
        }
        function O3(j3, d3) {
          let x2 = j3.split("."), f2 = this.options.lang, C3 = 0;
          for (; C3 < x2.length; ++C3) f2 = f2 && f2[x2[C3]];
          return typeof f2 == "string" ? X2(f2, d3, this) : "";
        }
        Z2.compose = function(j3) {
          let d3 = j3.prototype;
          d3.langFormat || (d3.langFormat = O3);
        }, Z2.i18nFormat = X2;
      }(q2 || (q2 = {})), q2;
    }), at2(s2, "Accessibility/Utils/ChartUtilities.js", [s2["Core/Globals.js"], s2["Accessibility/Utils/HTMLUtilities.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { doc: it2 } = B3, { stripHTMLTagsFromString: rt2 } = K2, { defined: tt2, find: Z2, fireEvent: X2 } = q2;
      function O3(d3) {
        if (d3.points && d3.points.length) {
          let x2 = Z2(d3.points, (f2) => !!f2.graphic);
          return x2 && x2.graphic && x2.graphic.element;
        }
      }
      function j3(d3) {
        let x2 = O3(d3);
        return x2 && x2.parentNode || d3.graph && d3.graph.element || d3.group && d3.group.element;
      }
      return { fireEventOnWrappedOrUnwrappedElement: function d3(x2, f2) {
        let C3 = f2.type, o2 = x2.hcEvents;
        it2.createEvent && (x2.dispatchEvent || x2.fireEvent) ? x2.dispatchEvent ? x2.dispatchEvent(f2) : x2.fireEvent(C3, f2) : o2 && o2[C3] ? X2(x2, C3, f2) : x2.element && d3(x2.element, f2);
      }, getChartTitle: function(d3) {
        return rt2(d3.options.title.text || d3.langFormat("accessibility.defaultChartTitle", { chart: d3 }), d3.renderer.forExport);
      }, getAxisDescription: function(d3) {
        var x2, f2;
        return d3 && (((x2 = d3.options.accessibility) == null ? void 0 : x2.description) || ((f2 = d3.axisTitle) == null ? void 0 : f2.textStr) || d3.options.id || d3.categories && "categories" || d3.dateTime && "Time" || "values");
      }, getAxisRangeDescription: function(d3) {
        let x2 = d3.options || {};
        return x2.accessibility && x2.accessibility.rangeDescription !== void 0 ? x2.accessibility.rangeDescription : d3.categories ? function(f2) {
          let C3 = f2.chart;
          return f2.dataMax && f2.dataMin ? C3.langFormat("accessibility.axis.rangeCategories", { chart: C3, axis: f2, numCategories: f2.dataMax - f2.dataMin + 1 }) : "";
        }(d3) : d3.dateTime && (d3.min === 0 || d3.dataMin === 0) ? function(f2) {
          let C3 = f2.chart, o2 = {}, p2 = f2.dataMin || f2.min || 0, b5 = f2.dataMax || f2.max || 0, h2 = "Seconds";
          o2.Seconds = (b5 - p2) / 1e3, o2.Minutes = o2.Seconds / 60, o2.Hours = o2.Minutes / 60, o2.Days = o2.Hours / 24, ["Minutes", "Hours", "Days"].forEach(function(T2) {
            o2[T2] > 2 && (h2 = T2);
          });
          let c4 = o2[h2].toFixed(h2 !== "Seconds" && h2 !== "Minutes" ? 1 : 0);
          return C3.langFormat("accessibility.axis.timeRange" + h2, { chart: C3, axis: f2, range: c4.replace(".0", "") });
        }(d3) : function(f2) {
          let C3 = f2.chart, o2 = C3.options, p2 = o2 && o2.accessibility && o2.accessibility.screenReaderSection.axisRangeDateFormat || "", b5 = { min: f2.dataMin || f2.min || 0, max: f2.dataMax || f2.max || 0 }, h2 = function(c4) {
            return f2.dateTime ? C3.time.dateFormat(p2, b5[c4]) : b5[c4].toString();
          };
          return C3.langFormat("accessibility.axis.rangeFromTo", { chart: C3, axis: f2, rangeFrom: h2("min"), rangeTo: h2("max") });
        }(d3);
      }, getPointFromXY: function(d3, x2, f2) {
        let C3 = d3.length, o2;
        for (; C3--; ) if (o2 = Z2(d3[C3].points || [], function(p2) {
          return p2.x === x2 && p2.y === f2;
        })) return o2;
      }, getSeriesFirstPointElement: O3, getSeriesFromName: function(d3, x2) {
        return x2 ? (d3.series || []).filter(function(f2) {
          return f2.name === x2;
        }) : d3.series;
      }, getSeriesA11yElement: j3, unhideChartElementFromAT: function d3(x2, f2) {
        f2.setAttribute("aria-hidden", false), f2 !== x2.renderTo && f2.parentNode && f2.parentNode !== it2.body && (Array.prototype.forEach.call(f2.parentNode.childNodes, function(C3) {
          C3.hasAttribute("aria-hidden") || C3.setAttribute("aria-hidden", true);
        }), d3(x2, f2.parentNode));
      }, hideSeriesFromAT: function(d3) {
        let x2 = j3(d3);
        x2 && x2.setAttribute("aria-hidden", true);
      }, scrollAxisToPoint: function(d3) {
        let x2 = d3.series.xAxis, f2 = d3.series.yAxis, C3 = x2 && x2.scrollbar ? x2 : f2, o2 = C3 && C3.scrollbar;
        if (o2 && tt2(o2.to) && tt2(o2.from)) {
          let p2 = o2.to - o2.from, b5 = function(h2, c4) {
            if (!tt2(h2.dataMin) || !tt2(h2.dataMax)) return 0;
            let T2 = h2.toPixels(h2.dataMin), I3 = h2.toPixels(h2.dataMax), G2 = h2.coll === "xAxis" ? "x" : "y";
            return (h2.toPixels(c4[G2] || 0) - T2) / (I3 - T2);
          }(C3, d3);
          o2.updatePosition(b5 - p2 / 2, b5 + p2 / 2), X2(o2, "changed", { from: o2.from, to: o2.to, trigger: "scrollbar", DOMEvent: null });
        }
      } };
    }), at2(s2, "Accessibility/Utils/DOMElementProvider.js", [s2["Core/Globals.js"], s2["Accessibility/Utils/HTMLUtilities.js"]], function(B3, K2) {
      let { doc: q2 } = B3, { removeElement: it2 } = K2;
      return class {
        constructor() {
          this.elements = [];
        }
        createElement() {
          let rt2 = q2.createElement.apply(q2, arguments);
          return this.elements.push(rt2), rt2;
        }
        removeElement(rt2) {
          it2(rt2), this.elements.splice(this.elements.indexOf(rt2), 1);
        }
        destroyCreatedElements() {
          this.elements.forEach(function(rt2) {
            it2(rt2);
          }), this.elements = [];
        }
      };
    }), at2(s2, "Accessibility/Utils/EventProvider.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { addEvent: q2 } = K2;
      return class {
        constructor() {
          this.eventRemovers = [];
        }
        addEvent() {
          let it2 = q2.apply(B3, arguments);
          return this.eventRemovers.push({ element: arguments[0], remover: it2 }), it2;
        }
        removeEvent(it2) {
          let rt2 = this.eventRemovers.map((tt2) => tt2.remover).indexOf(it2);
          this.eventRemovers[rt2].remover(), this.eventRemovers.splice(rt2, 1);
        }
        removeAddedEvents() {
          this.eventRemovers.map((it2) => it2.remover).forEach((it2) => it2()), this.eventRemovers = [];
        }
      };
    }), at2(s2, "Accessibility/AccessibilityComponent.js", [s2["Accessibility/Utils/ChartUtilities.js"], s2["Accessibility/Utils/DOMElementProvider.js"], s2["Accessibility/Utils/EventProvider.js"], s2["Accessibility/Utils/HTMLUtilities.js"]], function(B3, K2, q2, it2) {
      let { fireEventOnWrappedOrUnwrappedElement: rt2 } = B3, { getFakeMouseEvent: tt2 } = it2;
      return class {
        destroy() {
        }
        getKeyboardNavigation() {
          return [];
        }
        init() {
        }
        onChartRender() {
        }
        onChartUpdate() {
        }
        initBase(Z2, X2) {
          this.chart = Z2, this.eventProvider = new q2(), this.domElementProvider = new K2(), this.proxyProvider = X2, this.keyCodes = { left: 37, right: 39, up: 38, down: 40, enter: 13, space: 32, esc: 27, tab: 9, pageUp: 33, pageDown: 34, end: 35, home: 36 };
        }
        addEvent(Z2, X2, O3, j3) {
          return this.eventProvider.addEvent(Z2, X2, O3, j3);
        }
        createElement(Z2, X2) {
          return this.domElementProvider.createElement(Z2, X2);
        }
        fakeClickEvent(Z2) {
          rt2(Z2, tt2("click"));
        }
        destroyBase() {
          this.domElementProvider.destroyCreatedElements(), this.eventProvider.removeAddedEvents();
        }
      };
    }), at2(s2, "Accessibility/KeyboardNavigationHandler.js", [s2["Core/Utilities.js"]], function(B3) {
      let { find: K2 } = B3;
      return class {
        constructor(q2, it2) {
          this.chart = q2, this.keyCodeMap = it2.keyCodeMap || [], this.validate = it2.validate, this.init = it2.init, this.terminate = it2.terminate, this.response = { success: 1, prev: 2, next: 3, noHandler: 4, fail: 5 };
        }
        run(q2) {
          let it2 = q2.which || q2.keyCode, rt2 = this.response.noHandler, tt2 = K2(this.keyCodeMap, function(Z2) {
            return Z2[0].indexOf(it2) > -1;
          });
          return tt2 ? rt2 = tt2[1].call(this, it2, q2) : it2 === 9 && (rt2 = this.response[q2.shiftKey ? "prev" : "next"]), rt2;
        }
      };
    }), at2(s2, "Accessibility/Components/ContainerComponent.js", [s2["Accessibility/AccessibilityComponent.js"], s2["Accessibility/KeyboardNavigationHandler.js"], s2["Accessibility/Utils/ChartUtilities.js"], s2["Core/Globals.js"], s2["Accessibility/Utils/HTMLUtilities.js"]], function(B3, K2, q2, it2, rt2) {
      let { unhideChartElementFromAT: tt2, getChartTitle: Z2 } = q2, { doc: X2 } = it2, { stripHTMLTagsFromString: O3 } = rt2;
      return class extends B3 {
        onChartUpdate() {
          this.handleSVGTitleElement(), this.setSVGContainerLabel(), this.setGraphicContainerAttrs(), this.setRenderToAttrs(), this.makeCreditsAccessible();
        }
        handleSVGTitleElement() {
          let j3 = this.chart, d3 = "highcharts-title-" + j3.index, x2 = O3(j3.langFormat("accessibility.svgContainerTitle", { chartTitle: Z2(j3) }));
          if (x2.length) {
            let f2 = this.svgTitleElement = this.svgTitleElement || X2.createElementNS("http://www.w3.org/2000/svg", "title");
            f2.textContent = x2, f2.id = d3, j3.renderTo.insertBefore(f2, j3.renderTo.firstChild);
          }
        }
        setSVGContainerLabel() {
          let j3 = this.chart, d3 = j3.langFormat("accessibility.svgContainerLabel", { chartTitle: Z2(j3) });
          j3.renderer.box && d3.length && j3.renderer.box.setAttribute("aria-label", d3);
        }
        setGraphicContainerAttrs() {
          let j3 = this.chart, d3 = j3.langFormat("accessibility.graphicContainerLabel", { chartTitle: Z2(j3) });
          d3.length && j3.container.setAttribute("aria-label", d3);
        }
        setRenderToAttrs() {
          let j3 = this.chart, d3 = j3.options.accessibility.landmarkVerbosity !== "disabled", x2 = j3.langFormat("accessibility.chartContainerLabel", { title: Z2(j3), chart: j3 });
          x2 && (j3.renderTo.setAttribute("role", d3 ? "region" : "group"), j3.renderTo.setAttribute("aria-label", x2));
        }
        makeCreditsAccessible() {
          let j3 = this.chart, d3 = j3.credits;
          d3 && (d3.textStr && d3.element.setAttribute("aria-label", j3.langFormat("accessibility.credits", { creditsStr: O3(d3.textStr, j3.renderer.forExport) })), tt2(j3, d3.element));
        }
        getKeyboardNavigation() {
          let j3 = this.chart;
          return new K2(j3, { keyCodeMap: [], validate: function() {
            return true;
          }, init: function() {
            let d3 = j3.accessibility;
            d3 && d3.keyboardNavigation.tabindexContainer.focus();
          } });
        }
        destroy() {
          this.chart.renderTo.setAttribute("aria-hidden", true);
        }
      };
    }), at2(s2, "Accessibility/FocusBorder.js", [s2["Core/Utilities.js"]], function(B3) {
      var K2;
      let { addEvent: q2, pick: it2 } = B3;
      return function(rt2) {
        let tt2 = ["x", "y", "transform", "width", "height", "r", "d", "stroke-width"];
        function Z2() {
          let d3 = this.focusElement, x2 = this.options.accessibility.keyboardNavigation.focusBorder;
          d3 && (d3.removeFocusBorder(), x2.enabled && d3.addFocusBorder(x2.margin, { stroke: x2.style.color, strokeWidth: x2.style.lineWidth, r: x2.style.borderRadius }));
        }
        function X2(d3, x2) {
          let f2 = this.options.accessibility.keyboardNavigation.focusBorder, C3 = x2 || d3.element;
          C3 && C3.focus && (C3.hcEvents && C3.hcEvents.focusin || q2(C3, "focusin", function() {
          }), C3.focus(), f2.hideBrowserFocusOutline && (C3.style.outline = "none")), this.focusElement && this.focusElement.removeFocusBorder(), this.focusElement = d3, this.renderFocusBorder();
        }
        function O3(d3, x2) {
          this.focusBorder && this.removeFocusBorder();
          let f2 = this.getBBox(), C3 = it2(d3, 3), o2 = this.parentGroup, p2 = this.scaleX || o2 && o2.scaleX, b5 = this.scaleY || o2 && o2.scaleY, h2 = (p2 ? !b5 : b5) ? Math.abs(p2 || b5 || 1) : (Math.abs(p2 || 1) + Math.abs(b5 || 1)) / 2;
          f2.x += this.translateX ? this.translateX : 0, f2.y += this.translateY ? this.translateY : 0;
          let c4 = f2.x - C3, T2 = f2.y - C3, I3 = f2.width + 2 * C3, G2 = f2.height + 2 * C3, L2 = !!this.text;
          if (this.element.nodeName === "text" || L2) {
            let l4, y2, i5 = !!this.rotation, t3 = L2 ? { x: i5 ? 1 : 0, y: 0 } : (l4 = 0, y2 = 0, this.attr("text-anchor") === "middle" ? l4 = y2 = 0.5 : this.rotation ? l4 = 0.25 : y2 = 0.75, { x: l4, y: y2 }), e5 = +this.attr("x"), n4 = +this.attr("y");
            if (isNaN(e5) || (c4 = e5 - f2.width * t3.x - C3), isNaN(n4) || (T2 = n4 - f2.height * t3.y - C3), L2 && i5) {
              let u2 = I3;
              I3 = G2, G2 = u2, isNaN(e5) || (c4 = e5 - f2.height * t3.x - C3), isNaN(n4) || (T2 = n4 - f2.width * t3.y - C3);
            }
          }
          this.focusBorder = this.renderer.rect(c4, T2, I3, G2, parseInt((x2 && x2.r || 0).toString(), 10) / h2).addClass("highcharts-focus-border").attr({ zIndex: 99 }).add(o2), this.renderer.styledMode || this.focusBorder.attr({ stroke: x2 && x2.stroke, "stroke-width": (x2 && x2.strokeWidth || 0) / h2 }), function(l4, ...y2) {
            l4.focusBorderUpdateHooks || (l4.focusBorderUpdateHooks = {}, tt2.forEach((i5) => {
              let t3 = i5 + "Setter", e5 = l4[t3] || l4._defaultSetter;
              l4.focusBorderUpdateHooks[t3] = e5, l4[t3] = function() {
                let n4 = e5.apply(l4, arguments);
                return l4.addFocusBorder.apply(l4, y2), n4;
              };
            }));
          }(this, d3, x2), function(l4) {
            if (l4.focusBorderDestroyHook) return;
            let y2 = l4.destroy;
            l4.destroy = function() {
              return l4.focusBorder && l4.focusBorder.destroy && l4.focusBorder.destroy(), y2.apply(l4, arguments);
            }, l4.focusBorderDestroyHook = y2;
          }(this);
        }
        function j3() {
          var d3;
          d3 = this, d3.focusBorderUpdateHooks && (Object.keys(d3.focusBorderUpdateHooks).forEach((x2) => {
            let f2 = d3.focusBorderUpdateHooks[x2];
            f2 === d3._defaultSetter ? delete d3[x2] : d3[x2] = f2;
          }), delete d3.focusBorderUpdateHooks), this.focusBorderDestroyHook && (this.destroy = this.focusBorderDestroyHook, delete this.focusBorderDestroyHook), this.focusBorder && (this.focusBorder.destroy(), delete this.focusBorder);
        }
        rt2.compose = function(d3, x2) {
          let f2 = d3.prototype, C3 = x2.prototype;
          f2.renderFocusBorder || (f2.renderFocusBorder = Z2, f2.setFocusToElement = X2), C3.addFocusBorder || (C3.addFocusBorder = O3, C3.removeFocusBorder = j3);
        };
      }(K2 || (K2 = {})), K2;
    }), at2(s2, "Accessibility/Utils/Announcer.js", [s2["Core/Renderer/HTML/AST.js"], s2["Accessibility/Utils/DOMElementProvider.js"], s2["Core/Globals.js"], s2["Accessibility/Utils/HTMLUtilities.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2) {
      let { doc: tt2 } = q2, { addClass: Z2, visuallyHideElement: X2 } = it2, { attr: O3 } = rt2;
      return class {
        constructor(j3, d3) {
          this.chart = j3, this.domElementProvider = new K2(), this.announceRegion = this.addAnnounceRegion(d3);
        }
        destroy() {
          this.domElementProvider.destroyCreatedElements();
        }
        announce(j3) {
          B3.setElementHTML(this.announceRegion, j3), this.clearAnnouncementRegionTimer && clearTimeout(this.clearAnnouncementRegionTimer), this.clearAnnouncementRegionTimer = setTimeout(() => {
            this.announceRegion.innerHTML = B3.emptyHTML, delete this.clearAnnouncementRegionTimer;
          }, 3e3);
        }
        addAnnounceRegion(j3) {
          let d3 = this.chart.announcerContainer || this.createAnnouncerContainer(), x2 = this.domElementProvider.createElement("div");
          return O3(x2, { "aria-hidden": false, "aria-live": j3, "aria-atomic": true }), this.chart.styledMode ? Z2(x2, "highcharts-visually-hidden") : X2(x2), d3.appendChild(x2), x2;
        }
        createAnnouncerContainer() {
          let j3 = this.chart, d3 = tt2.createElement("div");
          return O3(d3, { "aria-hidden": false, class: "highcharts-announcer-container" }), d3.style.position = "relative", j3.renderTo.insertBefore(d3, j3.renderTo.firstChild), j3.announcerContainer = d3, d3;
        }
      };
    }), at2(s2, "Accessibility/Components/AnnotationsA11y.js", [s2["Accessibility/Utils/HTMLUtilities.js"]], function(B3) {
      let { escapeStringForHTML: K2, stripHTMLTagsFromString: q2 } = B3;
      function it2(X2) {
        return (X2.annotations || []).reduce((O3, j3) => (j3.options && j3.options.visible !== false && (O3 = O3.concat(j3.labels)), O3), []);
      }
      function rt2(X2) {
        return X2.options && X2.options.accessibility && X2.options.accessibility.description || X2.graphic && X2.graphic.text && X2.graphic.text.textStr || "";
      }
      function tt2(X2) {
        let O3 = X2.options && X2.options.accessibility && X2.options.accessibility.description;
        if (O3) return O3;
        let j3 = X2.chart, d3 = rt2(X2), x2 = X2.points, f2 = (h2) => h2.graphic && h2.graphic.element && h2.graphic.element.getAttribute("aria-label") || "", C3 = x2.filter((h2) => !!h2.graphic).map((h2) => {
          let c4 = h2.accessibility && h2.accessibility.valueDescription || f2(h2), T2 = h2 && h2.series.name || "";
          return (T2 ? T2 + ", " : "") + "data point " + c4;
        }).filter((h2) => !!h2), o2 = C3.length, p2 = o2 > 1 ? "MultiplePoints" : o2 ? "SinglePoint" : "NoPoints", b5 = { annotationText: d3, annotation: X2, numPoints: o2, annotationPoint: C3[0], additionalAnnotationPoints: C3.slice(1) };
        return j3.langFormat("accessibility.screenReaderSection.annotations.description" + p2, b5);
      }
      function Z2(X2) {
        return it2(X2).map((O3) => {
          let j3 = K2(q2(tt2(O3), X2.renderer.forExport));
          return j3 ? `<li>${j3}</li>` : "";
        });
      }
      return { getAnnotationsInfoHTML: function(X2) {
        let O3 = X2.annotations;
        return O3 && O3.length ? `<ul style="list-style-type: none">${Z2(X2).join(" ")}</ul>` : "";
      }, getAnnotationLabelDescription: tt2, getAnnotationListItems: Z2, getPointAnnotationTexts: function(X2) {
        let O3 = it2(X2.series.chart).filter((j3) => j3.points.indexOf(X2) > -1);
        return O3.length ? O3.map((j3) => `${rt2(j3)}`) : [];
      } };
    }), at2(s2, "Accessibility/Components/InfoRegionsComponent.js", [s2["Accessibility/A11yI18n.js"], s2["Accessibility/AccessibilityComponent.js"], s2["Accessibility/Utils/Announcer.js"], s2["Accessibility/Components/AnnotationsA11y.js"], s2["Core/Renderer/HTML/AST.js"], s2["Accessibility/Utils/ChartUtilities.js"], s2["Core/Templating.js"], s2["Core/Globals.js"], s2["Accessibility/Utils/HTMLUtilities.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2, O3, j3) {
      let { getAnnotationsInfoHTML: d3 } = it2, { getAxisDescription: x2, getAxisRangeDescription: f2, getChartTitle: C3, unhideChartElementFromAT: o2 } = tt2, { format: p2 } = Z2, { doc: b5 } = X2, { addClass: h2, getElement: c4, getHeadingTagNameForElement: T2, stripHTMLTagsFromString: I3, visuallyHideElement: G2 } = O3, { attr: L2, pick: l4, replaceNested: y2 } = j3;
      function i5(t3) {
        return y2(t3, [/<([\w\-.:!]+)\b[^<>]*>\s*<\/\1>/g, ""]);
      }
      return class extends K2 {
        constructor() {
          super(...arguments), this.screenReaderSections = {};
        }
        init() {
          let t3 = this.chart, e5 = this;
          this.initRegionsDefinitions(), this.addEvent(t3, "aftergetTableAST", function(n4) {
            e5.onDataTableCreated(n4);
          }), this.addEvent(t3, "afterViewData", function(n4) {
            n4.wasHidden && (e5.dataTableDiv = n4.element, setTimeout(function() {
              e5.focusDataTable();
            }, 300));
          }), this.addEvent(t3, "afterHideData", function() {
            e5.viewDataTableButton && e5.viewDataTableButton.setAttribute("aria-expanded", "false");
          }), t3.exporting && this.addEvent(t3, "afterPrint", function() {
            e5.updateAllScreenReaderSections();
          }), this.announcer = new q2(t3, "assertive");
        }
        initRegionsDefinitions() {
          let t3 = this, e5 = this.chart.options.accessibility;
          this.screenReaderSections = { before: { element: null, buildContent: function(n4) {
            let u2 = e5.screenReaderSection.beforeChartFormatter;
            return u2 ? u2(n4) : t3.defaultBeforeChartFormatter(n4);
          }, insertIntoDOM: function(n4, u2) {
            u2.renderTo.insertBefore(n4, u2.renderTo.firstChild);
          }, afterInserted: function() {
            t3.sonifyButtonId !== void 0 && t3.initSonifyButton(t3.sonifyButtonId), t3.dataTableButtonId !== void 0 && t3.initDataTableButton(t3.dataTableButtonId);
          } }, after: { element: null, buildContent: function(n4) {
            let u2 = e5.screenReaderSection.afterChartFormatter;
            return u2 ? u2(n4) : t3.defaultAfterChartFormatter();
          }, insertIntoDOM: function(n4, u2) {
            u2.renderTo.insertBefore(n4, u2.container.nextSibling);
          }, afterInserted: function() {
            t3.chart.accessibility && e5.keyboardNavigation.enabled && t3.chart.accessibility.keyboardNavigation.updateExitAnchor();
          } } };
        }
        onChartRender() {
          this.linkedDescriptionElement = this.getLinkedDescriptionElement(), this.setLinkedDescriptionAttrs(), this.updateAllScreenReaderSections();
        }
        updateAllScreenReaderSections() {
          let t3 = this;
          Object.keys(this.screenReaderSections).forEach(function(e5) {
            t3.updateScreenReaderSection(e5);
          });
        }
        getLinkedDescriptionElement() {
          let t3 = this.chart.options.accessibility.linkedDescription;
          if (!t3) return;
          if (typeof t3 != "string") return t3;
          let e5 = p2(t3, this.chart), n4 = b5.querySelectorAll(e5);
          if (n4.length === 1) return n4[0];
        }
        setLinkedDescriptionAttrs() {
          let t3 = this.linkedDescriptionElement;
          t3 && (t3.setAttribute("aria-hidden", "true"), h2(t3, "highcharts-linked-description"));
        }
        updateScreenReaderSection(t3) {
          let e5 = this.chart, n4 = this.screenReaderSections[t3], u2 = n4.buildContent(e5), a2 = n4.element = n4.element || this.createElement("div"), g2 = a2.firstChild || this.createElement("div");
          u2 ? (this.setScreenReaderSectionAttribs(a2, t3), rt2.setElementHTML(g2, u2), a2.appendChild(g2), n4.insertIntoDOM(a2, e5), e5.styledMode ? h2(g2, "highcharts-visually-hidden") : G2(g2), o2(e5, g2), n4.afterInserted && n4.afterInserted()) : (a2.parentNode && a2.parentNode.removeChild(a2), n4.element = null);
        }
        setScreenReaderSectionAttribs(t3, e5) {
          let n4 = this.chart, u2 = n4.langFormat("accessibility.screenReaderSection." + e5 + "RegionLabel", { chart: n4, chartTitle: C3(n4) });
          L2(t3, { id: `highcharts-screen-reader-region-${e5}-${n4.index}`, "aria-label": u2 || void 0 }), t3.style.position = "relative", u2 && t3.setAttribute("role", n4.options.accessibility.landmarkVerbosity === "all" ? "region" : "group");
        }
        defaultBeforeChartFormatter() {
          let t3 = this.chart, e5 = t3.options.accessibility.screenReaderSection.beforeChartFormat;
          if (!e5) return "";
          let n4 = this.getAxesDescription(), u2 = t3.sonify && t3.options.sonification && t3.options.sonification.enabled, a2 = "highcharts-a11y-sonify-data-btn-" + t3.index, g2 = "hc-linkto-highcharts-data-table-" + t3.index, r3 = d3(t3), A3 = t3.langFormat("accessibility.screenReaderSection.annotations.heading", { chart: t3 }), N2 = { headingTagName: T2(t3.renderTo), chartTitle: C3(t3), typeDescription: this.getTypeDescriptionText(), chartSubtitle: this.getSubtitleText(), chartLongdesc: this.getLongdescText(), xAxisDescription: n4.xAxis, yAxisDescription: n4.yAxis, playAsSoundButton: u2 ? this.getSonifyButtonText(a2) : "", viewTableButton: t3.getCSV ? this.getDataTableButtonText(g2) : "", annotationsTitle: r3 ? A3 : "", annotationsList: r3 }, k3 = B3.i18nFormat(e5, N2, t3);
          return this.dataTableButtonId = g2, this.sonifyButtonId = a2, i5(k3);
        }
        defaultAfterChartFormatter() {
          let t3 = this.chart, e5 = t3.options.accessibility.screenReaderSection.afterChartFormat;
          if (!e5) return "";
          let n4 = { endOfChartMarker: this.getEndOfChartMarkerText() };
          return i5(B3.i18nFormat(e5, n4, t3));
        }
        getLinkedDescription() {
          let t3 = this.linkedDescriptionElement;
          return I3(t3 && t3.innerHTML || "", this.chart.renderer.forExport);
        }
        getLongdescText() {
          let t3 = this.chart.options, e5 = t3.caption, n4 = e5 && e5.text, u2 = this.getLinkedDescription();
          return t3.accessibility.description || u2 || n4 || "";
        }
        getTypeDescriptionText() {
          let t3 = this.chart;
          return t3.types ? t3.options.accessibility.typeDescription || function(e5, n4) {
            let u2 = n4[0], a2 = e5.series && e5.series[0] || {}, g2 = e5.mapView && e5.mapView.geoMap && e5.mapView.geoMap.title, r3 = { numSeries: e5.series.length, numPoints: a2.points && a2.points.length, chart: e5, mapTitle: g2 };
            return u2 ? u2 === "map" || u2 === "tiledwebmap" ? r3.mapTitle ? e5.langFormat("accessibility.chartTypes.mapTypeDescription", r3) : e5.langFormat("accessibility.chartTypes.unknownMap", r3) : e5.types.length > 1 ? e5.langFormat("accessibility.chartTypes.combinationChart", r3) : function(A3, N2, k3) {
              let E2 = N2[0], R2 = A3.langFormat("accessibility.seriesTypeDescriptions." + E2, k3), z2 = A3.series && A3.series.length < 2 ? "Single" : "Multiple";
              return (A3.langFormat("accessibility.chartTypes." + E2 + z2, k3) || A3.langFormat("accessibility.chartTypes.default" + z2, k3)) + (R2 ? " " + R2 : "");
            }(e5, n4, r3) : e5.langFormat("accessibility.chartTypes.emptyChart", r3);
          }(t3, t3.types) : "";
        }
        getDataTableButtonText(t3) {
          let e5 = this.chart;
          return '<button id="' + t3 + '">' + e5.langFormat("accessibility.table.viewAsDataTableButtonText", { chart: e5, chartTitle: C3(e5) }) + "</button>";
        }
        getSonifyButtonText(t3) {
          let e5 = this.chart;
          return e5.options.sonification && e5.options.sonification.enabled === false ? "" : '<button id="' + t3 + '">' + e5.langFormat("accessibility.sonification.playAsSoundButtonText", { chart: e5, chartTitle: C3(e5) }) + "</button>";
        }
        getSubtitleText() {
          let t3 = this.chart.options.subtitle;
          return I3(t3 && t3.text || "", this.chart.renderer.forExport);
        }
        getEndOfChartMarkerText() {
          let t3 = c4(`highcharts-end-of-chart-marker-${this.chart.index}`);
          if (t3) return t3.outerHTML;
          let e5 = this.chart, n4 = e5.langFormat("accessibility.screenReaderSection.endOfChartMarker", { chart: e5 });
          return '<div id="highcharts-end-of-chart-marker-' + e5.index + '">' + n4 + "</div>";
        }
        onDataTableCreated(t3) {
          let e5 = this.chart;
          if (e5.options.accessibility.enabled) {
            this.viewDataTableButton && this.viewDataTableButton.setAttribute("aria-expanded", "true");
            let n4 = t3.tree.attributes || {};
            n4.tabindex = -1, n4.summary = e5.langFormat("accessibility.table.tableSummary", { chart: e5 }), t3.tree.attributes = n4;
          }
        }
        focusDataTable() {
          let t3 = this.dataTableDiv, e5 = t3 && t3.getElementsByTagName("table")[0];
          e5 && e5.focus && e5.focus();
        }
        initSonifyButton(t3) {
          let e5 = this.sonifyButton = c4(t3), n4 = this.chart, u2 = (a2) => {
            e5 && (e5.setAttribute("aria-hidden", "true"), e5.setAttribute("aria-label", "")), a2.preventDefault(), a2.stopPropagation();
            let g2 = n4.langFormat("accessibility.sonification.playAsSoundClickAnnouncement", { chart: n4 });
            this.announcer.announce(g2), setTimeout(() => {
              e5 && (e5.removeAttribute("aria-hidden"), e5.removeAttribute("aria-label")), n4.sonify && n4.sonify();
            }, 1e3);
          };
          e5 && n4 && (e5.setAttribute("tabindex", -1), e5.onclick = function(a2) {
            (n4.options.accessibility && n4.options.accessibility.screenReaderSection.onPlayAsSoundClick || u2).call(this, a2, n4);
          });
        }
        initDataTableButton(t3) {
          let e5 = this.viewDataTableButton = c4(t3), n4 = this.chart, u2 = t3.replace("hc-linkto-", "");
          e5 && (L2(e5, { tabindex: -1, "aria-expanded": !!c4(u2) }), e5.onclick = n4.options.accessibility.screenReaderSection.onViewDataTableClick || function() {
            n4.viewData();
          });
        }
        getAxesDescription() {
          let t3 = this.chart, e5 = function(A3, N2) {
            let k3 = t3[A3];
            return k3.length > 1 || k3[0] && l4(k3[0].options.accessibility && k3[0].options.accessibility.enabled, N2);
          }, n4 = !!t3.types && 0 > t3.types.indexOf("map") && 0 > t3.types.indexOf("treemap") && 0 > t3.types.indexOf("tilemap"), u2 = !!t3.hasCartesianSeries, a2 = e5("xAxis", !t3.angular && u2 && n4), g2 = e5("yAxis", u2 && n4), r3 = {};
          return a2 && (r3.xAxis = this.getAxisDescriptionText("xAxis")), g2 && (r3.yAxis = this.getAxisDescriptionText("yAxis")), r3;
        }
        getAxisDescriptionText(t3) {
          let e5 = this.chart, n4 = e5[t3];
          return e5.langFormat("accessibility.axis." + t3 + "Description" + (n4.length > 1 ? "Plural" : "Singular"), { chart: e5, names: n4.map(function(u2) {
            return x2(u2);
          }), ranges: n4.map(function(u2) {
            return f2(u2);
          }), numAxes: n4.length });
        }
        destroy() {
          this.announcer && this.announcer.destroy();
        }
      };
    }), at2(s2, "Accessibility/Components/MenuComponent.js", [s2["Core/Utilities.js"], s2["Accessibility/AccessibilityComponent.js"], s2["Accessibility/KeyboardNavigationHandler.js"], s2["Accessibility/Utils/ChartUtilities.js"], s2["Accessibility/Utils/HTMLUtilities.js"]], function(B3, K2, q2, it2, rt2) {
      let { attr: tt2 } = B3, { getChartTitle: Z2, unhideChartElementFromAT: X2 } = it2, { getFakeMouseEvent: O3 } = rt2;
      function j3(x2) {
        return x2.exportSVGElements && x2.exportSVGElements[0];
      }
      class d3 extends K2 {
        init() {
          let f2 = this.chart, C3 = this;
          this.addEvent(f2, "exportMenuShown", function() {
            C3.onMenuShown();
          }), this.addEvent(f2, "exportMenuHidden", function() {
            C3.onMenuHidden();
          }), this.createProxyGroup();
        }
        onMenuHidden() {
          let f2 = this.chart.exportContextMenu;
          f2 && f2.setAttribute("aria-hidden", "true"), this.setExportButtonExpandedState("false");
        }
        onMenuShown() {
          let f2 = this.chart, C3 = f2.exportContextMenu;
          C3 && (this.addAccessibleContextMenuAttribs(), X2(f2, C3)), this.setExportButtonExpandedState("true");
        }
        setExportButtonExpandedState(f2) {
          this.exportButtonProxy && this.exportButtonProxy.innerElement.setAttribute("aria-expanded", f2);
        }
        onChartRender() {
          let f2 = this.chart, C3 = f2.focusElement, o2 = f2.accessibility;
          this.proxyProvider.clearGroup("chartMenu"), this.proxyMenuButton(), this.exportButtonProxy && C3 && C3 === f2.exportingGroup && (C3.focusBorder ? f2.setFocusToElement(C3, this.exportButtonProxy.innerElement) : o2 && o2.keyboardNavigation.tabindexContainer.focus());
        }
        proxyMenuButton() {
          let f2 = this.chart, C3 = this.proxyProvider, o2 = j3(f2);
          (function(p2) {
            let b5 = p2.options.exporting, h2 = j3(p2);
            return !!(b5 && b5.enabled !== false && b5.accessibility && b5.accessibility.enabled && h2 && h2.element);
          })(f2) && o2 && (this.exportButtonProxy = C3.addProxyElement("chartMenu", { click: o2 }, "button", { "aria-label": f2.langFormat("accessibility.exporting.menuButtonLabel", { chart: f2, chartTitle: Z2(f2) }), "aria-expanded": false, title: f2.options.lang.contextButtonTitle || null }));
        }
        createProxyGroup() {
          this.chart && this.proxyProvider && this.proxyProvider.addGroup("chartMenu");
        }
        addAccessibleContextMenuAttribs() {
          let f2 = this.chart, C3 = f2.exportDivElements;
          if (C3 && C3.length) {
            C3.forEach((p2) => {
              p2 && (p2.tagName !== "LI" || p2.children && p2.children.length ? p2.setAttribute("aria-hidden", "true") : p2.setAttribute("tabindex", -1));
            });
            let o2 = C3[0] && C3[0].parentNode;
            o2 && tt2(o2, { "aria-hidden": void 0, "aria-label": f2.langFormat("accessibility.exporting.chartMenuLabel", { chart: f2 }), role: "list" });
          }
        }
        getKeyboardNavigation() {
          let f2 = this.keyCodes, C3 = this.chart, o2 = this;
          return new q2(C3, { keyCodeMap: [[[f2.left, f2.up], function() {
            return o2.onKbdPrevious(this);
          }], [[f2.right, f2.down], function() {
            return o2.onKbdNext(this);
          }], [[f2.enter, f2.space], function() {
            return o2.onKbdClick(this);
          }]], validate: function() {
            return !!C3.exporting && C3.options.exporting.enabled !== false && C3.options.exporting.accessibility.enabled !== false;
          }, init: function() {
            let p2 = o2.exportButtonProxy, b5 = o2.chart.exportingGroup;
            p2 && b5 && C3.setFocusToElement(b5, p2.innerElement);
          }, terminate: function() {
            C3.hideExportMenu();
          } });
        }
        onKbdPrevious(f2) {
          let C3 = this.chart, o2 = C3.options.accessibility, p2 = f2.response, b5 = C3.highlightedExportItemIx || 0;
          for (; b5--; ) if (C3.highlightExportItem(b5)) return p2.success;
          return o2.keyboardNavigation.wrapAround ? (C3.highlightLastExportItem(), p2.success) : p2.prev;
        }
        onKbdNext(f2) {
          let C3 = this.chart, o2 = C3.options.accessibility, p2 = f2.response;
          for (let b5 = (C3.highlightedExportItemIx || 0) + 1; b5 < C3.exportDivElements.length; ++b5) if (C3.highlightExportItem(b5)) return p2.success;
          return o2.keyboardNavigation.wrapAround ? (C3.highlightExportItem(0), p2.success) : p2.next;
        }
        onKbdClick(f2) {
          let C3 = this.chart, o2 = C3.exportDivElements[C3.highlightedExportItemIx], p2 = j3(C3).element;
          return C3.openMenu ? this.fakeClickEvent(o2) : (this.fakeClickEvent(p2), C3.highlightExportItem(0)), f2.response.success;
        }
      }
      return function(x2) {
        function f2() {
          let b5 = j3(this);
          if (b5) {
            let h2 = b5.element;
            h2.onclick && h2.onclick(O3("click"));
          }
        }
        function C3() {
          let b5 = this.exportDivElements;
          b5 && this.exportContextMenu && this.openMenu && (b5.forEach((h2) => {
            h2 && h2.className === "highcharts-menu-item" && h2.onmouseout && h2.onmouseout(O3("mouseout"));
          }), this.highlightedExportItemIx = 0, this.exportContextMenu.hideMenu(), this.container.focus());
        }
        function o2(b5) {
          let h2 = this.exportDivElements && this.exportDivElements[b5], c4 = this.exportDivElements && this.exportDivElements[this.highlightedExportItemIx];
          if (h2 && h2.tagName === "LI" && !(h2.children && h2.children.length)) {
            let T2 = !!(this.renderTo.getElementsByTagName("g")[0] || {}).focus;
            return h2.focus && T2 && h2.focus(), c4 && c4.onmouseout && c4.onmouseout(O3("mouseout")), h2.onmouseover && h2.onmouseover(O3("mouseover")), this.highlightedExportItemIx = b5, true;
          }
          return false;
        }
        function p2() {
          if (this.exportDivElements) {
            let b5 = this.exportDivElements.length;
            for (; b5--; ) if (this.highlightExportItem(b5)) return true;
          }
          return false;
        }
        x2.compose = function(b5) {
          let h2 = b5.prototype;
          h2.hideExportMenu || (h2.hideExportMenu = C3, h2.highlightExportItem = o2, h2.highlightLastExportItem = p2, h2.showExportMenu = f2);
        };
      }(d3), d3;
    }), at2(s2, "Accessibility/KeyboardNavigation.js", [s2["Core/Globals.js"], s2["Accessibility/Components/MenuComponent.js"], s2["Core/Utilities.js"], s2["Accessibility/Utils/EventProvider.js"], s2["Accessibility/Utils/HTMLUtilities.js"]], function(B3, K2, q2, it2, rt2) {
      let { doc: tt2, win: Z2 } = B3, { addEvent: X2, defined: O3, fireEvent: j3 } = q2, { getElement: d3, simulatedEventTarget: x2 } = rt2;
      class f2 {
        constructor(o2, p2) {
          this.currentModuleIx = NaN, this.modules = [], this.init(o2, p2);
        }
        init(o2, p2) {
          let b5 = this.eventProvider = new it2();
          this.chart = o2, this.components = p2, this.modules = [], this.currentModuleIx = 0, this.update(), b5.addEvent(this.tabindexContainer, "keydown", (h2) => this.onKeydown(h2)), b5.addEvent(this.tabindexContainer, "focus", (h2) => this.onFocus(h2)), ["mouseup", "touchend"].forEach((h2) => b5.addEvent(tt2, h2, (c4) => this.onMouseUp(c4))), ["mousedown", "touchstart"].forEach((h2) => b5.addEvent(o2.renderTo, h2, () => {
            this.isClickingChart = true;
          }));
        }
        update(o2) {
          let p2 = this.chart.options.accessibility, b5 = p2 && p2.keyboardNavigation, h2 = this.components;
          this.updateContainerTabindex(), b5 && b5.enabled && o2 && o2.length ? (this.modules = o2.reduce(function(c4, T2) {
            let I3 = h2[T2].getKeyboardNavigation();
            return c4.concat(I3);
          }, []), this.updateExitAnchor()) : (this.modules = [], this.currentModuleIx = 0, this.removeExitAnchor());
        }
        updateExitAnchor() {
          let o2 = d3(`highcharts-end-of-chart-marker-${this.chart.index}`);
          this.removeExitAnchor(), o2 ? (this.makeElementAnExitAnchor(o2), this.exitAnchor = o2) : this.createExitAnchor();
        }
        move(o2) {
          let p2 = this.modules && this.modules[this.currentModuleIx];
          p2 && p2.terminate && p2.terminate(o2), this.chart.focusElement && this.chart.focusElement.removeFocusBorder(), this.currentModuleIx += o2;
          let b5 = this.modules && this.modules[this.currentModuleIx];
          if (b5) {
            if (b5.validate && !b5.validate()) return this.move(o2);
            if (b5.init) return b5.init(o2), true;
          }
          return this.currentModuleIx = 0, this.exiting = true, o2 > 0 ? this.exitAnchor && this.exitAnchor.focus() : this.tabindexContainer.focus(), false;
        }
        onFocus(o2) {
          let p2 = this.chart, b5 = o2.relatedTarget && p2.container.contains(o2.relatedTarget), h2 = p2.options.accessibility, c4 = h2 && h2.keyboardNavigation;
          if (c4 && c4.enabled && !this.exiting && !this.tabbingInBackwards && !this.isClickingChart && !b5) {
            let T2 = this.getFirstValidModuleIx();
            T2 !== null && (this.currentModuleIx = T2, this.modules[T2].init(1));
          }
          this.keyboardReset = false, this.exiting = false;
        }
        onMouseUp(o2) {
          if (delete this.isClickingChart, !this.keyboardReset && o2.relatedTarget !== x2) {
            let p2 = this.chart;
            if (!o2.target || !p2.container.contains(o2.target)) {
              let b5 = this.modules && this.modules[this.currentModuleIx || 0];
              b5 && b5.terminate && b5.terminate(), this.currentModuleIx = 0;
            }
            p2.focusElement && (p2.focusElement.removeFocusBorder(), delete p2.focusElement), this.keyboardReset = true;
          }
        }
        onKeydown(o2) {
          let p2, b5 = o2 || Z2.event, h2 = this.modules && this.modules.length && this.modules[this.currentModuleIx], c4 = b5.target;
          if ((!c4 || c4.nodeName !== "INPUT" || c4.classList.contains("highcharts-a11y-proxy-element")) && (this.keyboardReset = false, this.exiting = false, h2)) {
            let T2 = h2.run(b5);
            T2 === h2.response.success ? p2 = true : T2 === h2.response.prev ? p2 = this.move(-1) : T2 === h2.response.next && (p2 = this.move(1)), p2 && (b5.preventDefault(), b5.stopPropagation());
          }
        }
        updateContainerTabindex() {
          let o2, p2 = this.chart.options.accessibility, b5 = p2 && p2.keyboardNavigation, h2 = !(b5 && b5.enabled === false), c4 = this.chart, T2 = c4.container;
          c4.renderTo.hasAttribute("tabindex") ? (T2.removeAttribute("tabindex"), o2 = c4.renderTo) : o2 = T2, this.tabindexContainer = o2;
          let I3 = o2.getAttribute("tabindex");
          h2 && !I3 ? o2.setAttribute("tabindex", "0") : h2 || c4.container.removeAttribute("tabindex");
        }
        createExitAnchor() {
          let o2 = this.chart, p2 = this.exitAnchor = tt2.createElement("div");
          o2.renderTo.appendChild(p2), this.makeElementAnExitAnchor(p2);
        }
        makeElementAnExitAnchor(o2) {
          let p2 = this.tabindexContainer.getAttribute("tabindex") || 0;
          o2.setAttribute("class", "highcharts-exit-anchor"), o2.setAttribute("tabindex", p2), o2.setAttribute("aria-hidden", false), this.addExitAnchorEventsToEl(o2);
        }
        removeExitAnchor() {
          if (this.exitAnchor) {
            let o2 = this.eventProvider.eventRemovers.find((p2) => p2.element === this.exitAnchor);
            o2 && O3(o2.remover) && this.eventProvider.removeEvent(o2.remover), this.exitAnchor.parentNode && this.exitAnchor.parentNode.removeChild(this.exitAnchor), delete this.exitAnchor;
          }
        }
        addExitAnchorEventsToEl(o2) {
          let p2 = this.chart, b5 = this;
          this.eventProvider.addEvent(o2, "focus", function(h2) {
            let c4 = h2 || Z2.event, T2 = !(c4.relatedTarget && p2.container.contains(c4.relatedTarget) || b5.exiting);
            if (p2.focusElement && delete p2.focusElement, T2) {
              if (b5.tabbingInBackwards = true, b5.tabindexContainer.focus(), delete b5.tabbingInBackwards, c4.preventDefault(), b5.modules && b5.modules.length) {
                b5.currentModuleIx = b5.modules.length - 1;
                let I3 = b5.modules[b5.currentModuleIx];
                I3 && I3.validate && !I3.validate() ? b5.move(-1) : I3 && I3.init(-1);
              }
            } else b5.exiting = false;
          });
        }
        getFirstValidModuleIx() {
          let o2 = this.modules.length;
          for (let p2 = 0; p2 < o2; ++p2) {
            let b5 = this.modules[p2];
            if (!b5.validate || b5.validate()) return p2;
          }
          return null;
        }
        destroy() {
          this.removeExitAnchor(), this.eventProvider.removeAddedEvents(), this.chart.container.removeAttribute("tabindex");
        }
      }
      return function(C3) {
        function o2() {
          let b5 = this;
          j3(this, "dismissPopupContent", {}, function() {
            b5.tooltip && b5.tooltip.hide(0), b5.hideExportMenu();
          });
        }
        function p2(b5) {
          (b5.which || b5.keyCode) === 27 && B3.charts && B3.charts.forEach((h2) => {
            h2 && h2.dismissPopupContent && h2.dismissPopupContent();
          });
        }
        C3.compose = function(b5) {
          K2.compose(b5);
          let h2 = b5.prototype;
          return h2.dismissPopupContent || (h2.dismissPopupContent = o2, X2(tt2, "keydown", p2)), b5;
        };
      }(f2), f2;
    }), at2(s2, "Accessibility/Components/LegendComponent.js", [s2["Core/Animation/AnimationUtilities.js"], s2["Core/Globals.js"], s2["Core/Legend/Legend.js"], s2["Core/Utilities.js"], s2["Accessibility/AccessibilityComponent.js"], s2["Accessibility/KeyboardNavigationHandler.js"], s2["Accessibility/Utils/ChartUtilities.js"], s2["Accessibility/Utils/HTMLUtilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2) {
      let { animObject: O3 } = B3, { doc: j3 } = K2, { addEvent: d3, fireEvent: x2, isNumber: f2, pick: C3, syncTimeout: o2 } = it2, { getChartTitle: p2 } = Z2, { stripHTMLTagsFromString: b5, addClass: h2, removeClass: c4 } = X2;
      function T2(L2) {
        let l4 = L2.legend && L2.legend.allItems, y2 = L2.options.legend.accessibility || {}, i5 = L2.colorAxis && L2.colorAxis.some((t3) => !t3.dataClasses || !t3.dataClasses.length);
        return !!(l4 && l4.length && !i5 && y2.enabled !== false);
      }
      function I3(L2, l4) {
        let y2 = l4.legendItem || {};
        for (let i5 of (l4.setState(L2 ? "hover" : "", true), ["group", "label", "symbol"])) {
          let t3 = y2[i5], e5 = t3 && t3.element || t3;
          e5 && x2(e5, L2 ? "mouseover" : "mouseout");
        }
      }
      class G2 extends rt2 {
        constructor() {
          super(...arguments), this.highlightedLegendItemIx = NaN, this.proxyGroup = null;
        }
        init() {
          let l4 = this;
          this.recreateProxies(), this.addEvent(q2, "afterScroll", function() {
            this.chart === l4.chart && (l4.proxyProvider.updateGroupProxyElementPositions("legend"), l4.updateLegendItemProxyVisibility(), l4.highlightedLegendItemIx > -1 && this.chart.highlightLegendItem(l4.highlightedLegendItemIx));
          }), this.addEvent(q2, "afterPositionItem", function(y2) {
            this.chart === l4.chart && this.chart.renderer && l4.updateProxyPositionForItem(y2.item);
          }), this.addEvent(q2, "afterRender", function() {
            this.chart === l4.chart && this.chart.renderer && l4.recreateProxies() && o2(() => l4.proxyProvider.updateGroupProxyElementPositions("legend"), O3(C3(this.chart.renderer.globalAnimation, true)).duration);
          });
        }
        updateLegendItemProxyVisibility() {
          let l4, y2 = this.chart, i5 = y2.legend, t3 = i5.allItems || [], e5 = i5.currentPage || 1, n4 = i5.clipHeight || 0;
          t3.forEach((u2) => {
            if (u2.a11yProxyElement) {
              let a2 = i5.pages && i5.pages.length, g2 = u2.a11yProxyElement.element, r3 = false;
              if (l4 = u2.legendItem || {}, a2) {
                let A3 = l4.pageIx || 0;
                r3 = (l4.y || 0) + (l4.label ? Math.round(l4.label.getBBox().height) : 0) - i5.pages[A3] > n4 || A3 !== e5 - 1;
              }
              r3 ? y2.styledMode ? h2(g2, "highcharts-a11y-invisible") : g2.style.visibility = "hidden" : (c4(g2, "highcharts-a11y-invisible"), g2.style.visibility = "");
            }
          });
        }
        onChartRender() {
          T2(this.chart) || this.removeProxies();
        }
        highlightAdjacentLegendPage(l4) {
          let y2 = this.chart, i5 = y2.legend, t3 = (i5.currentPage || 1) + l4, e5 = i5.pages || [];
          if (t3 > 0 && t3 <= e5.length) {
            let n4 = 0;
            for (let u2 of i5.allItems) ((u2.legendItem || {}).pageIx || 0) + 1 === t3 && y2.highlightLegendItem(n4) && (this.highlightedLegendItemIx = n4), ++n4;
          }
        }
        updateProxyPositionForItem(l4) {
          l4.a11yProxyElement && l4.a11yProxyElement.refreshPosition();
        }
        recreateProxies() {
          let l4 = j3.activeElement, y2 = this.proxyGroup, i5 = l4 && y2 && y2.contains(l4);
          return this.removeProxies(), !!T2(this.chart) && (this.addLegendProxyGroup(), this.proxyLegendItems(), this.updateLegendItemProxyVisibility(), this.updateLegendTitle(), i5 && this.chart.highlightLegendItem(this.highlightedLegendItemIx), true);
        }
        removeProxies() {
          this.proxyProvider.removeGroup("legend");
        }
        updateLegendTitle() {
          let l4 = this.chart, y2 = b5((l4.legend && l4.legend.options.title && l4.legend.options.title.text || "").replace(/<br ?\/?>/g, " "), l4.renderer.forExport), i5 = l4.langFormat("accessibility.legend.legendLabel" + (y2 ? "" : "NoTitle"), { chart: l4, legendTitle: y2, chartTitle: p2(l4) });
          this.proxyProvider.updateGroupAttrs("legend", { "aria-label": i5 });
        }
        addLegendProxyGroup() {
          let l4 = this.chart.options.accessibility.landmarkVerbosity === "all" ? "region" : null;
          this.proxyGroup = this.proxyProvider.addGroup("legend", "ul", { "aria-label": "_placeholder_", role: l4 });
        }
        proxyLegendItems() {
          let l4, y2 = this;
          ((this.chart.legend || {}).allItems || []).forEach((i5) => {
            (l4 = i5.legendItem || {}).label && l4.label.element && y2.proxyLegendItem(i5);
          });
        }
        proxyLegendItem(l4) {
          let y2 = l4.legendItem || {};
          if (!y2.label || !y2.group) return;
          let i5 = this.chart.langFormat("accessibility.legend.legendItem", { chart: this.chart, itemName: b5(l4.name, this.chart.renderer.forExport), item: l4 }), t3 = { tabindex: -1, "aria-pressed": l4.visible, "aria-label": i5 }, e5 = y2.group.div ? y2.label : y2.group;
          l4.a11yProxyElement = this.proxyProvider.addProxyElement("legend", { click: y2.label, visual: e5.element }, "button", t3);
        }
        getKeyboardNavigation() {
          let l4 = this.keyCodes, y2 = this, i5 = this.chart;
          return new tt2(i5, { keyCodeMap: [[[l4.left, l4.right, l4.up, l4.down], function(t3) {
            return y2.onKbdArrowKey(this, t3);
          }], [[l4.enter, l4.space], function() {
            return y2.onKbdClick(this);
          }], [[l4.pageDown, l4.pageUp], function(t3) {
            let e5 = t3 === l4.pageDown ? 1 : -1;
            return y2.highlightAdjacentLegendPage(e5), this.response.success;
          }]], validate: function() {
            return y2.shouldHaveLegendNavigation();
          }, init: function() {
            i5.highlightLegendItem(0), y2.highlightedLegendItemIx = 0;
          }, terminate: function() {
            y2.highlightedLegendItemIx = -1, i5.legend.allItems.forEach((t3) => I3(false, t3));
          } });
        }
        onKbdArrowKey(l4, y2) {
          let { keyCodes: { left: i5, up: t3 }, highlightedLegendItemIx: e5, chart: n4 } = this, u2 = n4.legend.allItems.length, a2 = n4.options.accessibility.keyboardNavigation.wrapAround, g2 = y2 === i5 || y2 === t3 ? -1 : 1;
          return n4.highlightLegendItem(e5 + g2) ? this.highlightedLegendItemIx += g2 : a2 && u2 > 1 && (this.highlightedLegendItemIx = g2 > 0 ? 0 : u2 - 1, n4.highlightLegendItem(this.highlightedLegendItemIx)), l4.response.success;
        }
        onKbdClick(l4) {
          let y2 = this.chart.legend.allItems[this.highlightedLegendItemIx];
          return y2 && y2.a11yProxyElement && y2.a11yProxyElement.click(), l4.response.success;
        }
        shouldHaveLegendNavigation() {
          if (!T2(this.chart)) return false;
          let l4 = this.chart, y2 = (l4.options.legend || {}).accessibility || {};
          return !!(l4.legend.display && y2.keyboardNavigation && y2.keyboardNavigation.enabled);
        }
        destroy() {
          this.removeProxies();
        }
      }
      return function(L2) {
        function l4(i5) {
          let t3 = this.legend.allItems, e5 = this.accessibility && this.accessibility.components.legend.highlightedLegendItemIx, n4 = t3[i5], u2 = (n4 == null ? void 0 : n4.legendItem) || {};
          if (n4) {
            f2(e5) && t3[e5] && I3(false, t3[e5]), function(r3, A3) {
              let N2 = (r3.allItems[A3].legendItem || {}).pageIx, k3 = r3.currentPage;
              N2 !== void 0 && N2 + 1 !== k3 && r3.scroll(1 + N2 - k3);
            }(this.legend, i5);
            let a2 = u2.label, g2 = n4.a11yProxyElement && n4.a11yProxyElement.innerElement;
            return a2 && a2.element && g2 && this.setFocusToElement(a2, g2), I3(true, n4), true;
          }
          return false;
        }
        function y2(i5) {
          let t3 = this.chart.options.accessibility, e5 = i5.item;
          t3.enabled && e5 && e5.a11yProxyElement && e5.a11yProxyElement.innerElement.setAttribute("aria-pressed", i5.visible ? "true" : "false");
        }
        L2.compose = function(i5, t3) {
          let e5 = i5.prototype;
          e5.highlightLegendItem || (e5.highlightLegendItem = l4, d3(t3, "afterColorizeItem", y2));
        };
      }(G2), G2;
    }), at2(s2, "Stock/Navigator/ChartNavigatorComposition.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let q2, { isTouchDevice: it2 } = B3, { addEvent: rt2, merge: tt2, pick: Z2 } = K2, X2 = [];
      function O3() {
        this.navigator && this.navigator.setBaseSeries(null, false);
      }
      function j3() {
        var p2;
        let b5, h2, c4, T2 = this.legend, I3 = this.navigator;
        if (I3) {
          b5 = T2 && T2.options, h2 = I3.xAxis, c4 = I3.yAxis;
          let { scrollbarHeight: G2, scrollButtonSize: L2 } = I3;
          this.inverted ? (I3.left = I3.opposite ? this.chartWidth - G2 - I3.height : this.spacing[3] + G2, I3.top = this.plotTop + L2) : (I3.left = Z2(h2.left, this.plotLeft + L2), I3.top = I3.navigatorOptions.top || this.chartHeight - I3.height - G2 - (((p2 = this.scrollbar) == null ? void 0 : p2.options.margin) || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (b5 && b5.verticalAlign === "bottom" && b5.layout !== "proximate" && b5.enabled && !b5.floating ? T2.legendHeight + Z2(b5.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), h2 && c4 && (this.inverted ? h2.options.left = c4.options.left = I3.left : h2.options.top = c4.options.top = I3.top, h2.setAxisSize(), c4.setAxisSize());
        }
      }
      function d3(p2) {
        !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new q2(this), Z2(p2.redraw, true) && this.redraw(p2.animation));
      }
      function x2() {
        let p2 = this.options;
        (p2.navigator.enabled || p2.scrollbar.enabled) && (this.scroller = this.navigator = new q2(this));
      }
      function f2() {
        let p2 = this.options, b5 = p2.navigator, h2 = p2.rangeSelector;
        if ((b5 && b5.enabled || h2 && h2.enabled) && (!it2 && this.zooming.type === "x" || it2 && this.zooming.pinchType === "x")) return false;
      }
      function C3(p2) {
        let b5 = p2.navigator;
        if (b5 && p2.xAxis[0]) {
          let h2 = p2.xAxis[0].getExtremes();
          b5.render(h2.min, h2.max);
        }
      }
      function o2(p2) {
        let b5 = p2.options.navigator || {}, h2 = p2.options.scrollbar || {};
        !this.navigator && !this.scroller && (b5.enabled || h2.enabled) && (tt2(true, this.options.navigator, b5), tt2(true, this.options.scrollbar, h2), delete p2.options.navigator, delete p2.options.scrollbar);
      }
      return { compose: function(p2, b5) {
        if (K2.pushUnique(X2, p2)) {
          let h2 = p2.prototype;
          q2 = b5, h2.callbacks.push(C3), rt2(p2, "afterAddSeries", O3), rt2(p2, "afterSetChartSize", j3), rt2(p2, "afterUpdate", d3), rt2(p2, "beforeRender", x2), rt2(p2, "beforeShowResetZoom", f2), rt2(p2, "update", o2);
        }
      } };
    }), at2(s2, "Core/Axis/NavigatorAxisComposition.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { isTouchDevice: q2 } = B3, { addEvent: it2, correctFloat: rt2, defined: tt2, isNumber: Z2, pick: X2 } = K2;
      function O3() {
        this.navigatorAxis || (this.navigatorAxis = new d3(this));
      }
      function j3(x2) {
        let f2, C3 = this.chart, o2 = C3.options, p2 = o2.navigator, b5 = this.navigatorAxis, h2 = C3.zooming.pinchType, c4 = o2.rangeSelector, T2 = C3.zooming.type;
        if (this.isXAxis && (p2 != null && p2.enabled || c4 != null && c4.enabled)) {
          if (T2 === "y" && x2.trigger === "zoom") f2 = false;
          else if ((x2.trigger === "zoom" && T2 === "xy" || q2 && h2 === "xy") && this.options.range) {
            let I3 = b5.previousZoom;
            tt2(x2.min) ? b5.previousZoom = [this.min, this.max] : I3 && (x2.min = I3[0], x2.max = I3[1], b5.previousZoom = void 0);
          }
        }
        f2 !== void 0 && x2.preventDefault();
      }
      class d3 {
        static compose(f2) {
          f2.keepProps.includes("navigatorAxis") || (f2.keepProps.push("navigatorAxis"), it2(f2, "init", O3), it2(f2, "setExtremes", j3));
        }
        constructor(f2) {
          this.axis = f2;
        }
        destroy() {
          this.axis = void 0;
        }
        toFixedRange(f2, C3, o2, p2) {
          let b5 = this.axis, h2 = (b5.pointRange || 0) / 2, c4 = X2(o2, b5.translate(f2, true, !b5.horiz)), T2 = X2(p2, b5.translate(C3, true, !b5.horiz));
          return tt2(o2) || (c4 = rt2(c4 + h2)), tt2(p2) || (T2 = rt2(T2 - h2)), Z2(c4) && Z2(T2) || (c4 = T2 = void 0), { min: c4, max: T2 };
        }
      }
      return d3;
    }), at2(s2, "Stock/Navigator/NavigatorDefaults.js", [s2["Core/Color/Color.js"], s2["Core/Series/SeriesRegistry.js"]], function(B3, K2) {
      let { parse: q2 } = B3, { seriesTypes: it2 } = K2;
      return { height: 40, margin: 25, maskInside: true, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: true, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: q2("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: it2.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: false }, dataGrouping: { approximation: "average", enabled: true, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: false, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: false }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: false }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: false, endOnTick: false, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: false }, crosshair: false, title: { text: null }, tickLength: 0, tickWidth: 0 } };
    }), at2(s2, "Stock/Navigator/NavigatorSymbols.js", [s2["Core/Renderer/SVG/Symbols.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { relativeLength: q2 } = K2;
      return { "navigator-handle": function(it2, rt2, tt2, Z2, X2 = {}) {
        let O3 = X2.width ? X2.width / 2 : tt2, j3 = q2(X2.borderRadius || 0, Math.min(2 * O3, Z2));
        return [["M", -1.5, (Z2 = X2.height || Z2) / 2 - 3.5], ["L", -1.5, Z2 / 2 + 4.5], ["M", 0.5, Z2 / 2 - 3.5], ["L", 0.5, Z2 / 2 + 4.5], ...B3.rect(-O3 - 1, 0.5, 2 * O3 + 1, Z2, { r: j3 })];
      } };
    }), at2(s2, "Stock/Utilities/StockUtilities.js", [s2["Core/Utilities.js"]], function(B3) {
      let { defined: K2 } = B3;
      return { setFixedRange: function(q2) {
        let it2 = this.xAxis[0];
        K2(it2.dataMax) && K2(it2.dataMin) && q2 ? this.fixedRange = Math.min(q2, it2.dataMax - it2.dataMin) : this.fixedRange = q2;
      } };
    }), at2(s2, "Stock/Navigator/NavigatorComposition.js", [s2["Core/Defaults.js"], s2["Core/Globals.js"], s2["Core/Axis/NavigatorAxisComposition.js"], s2["Stock/Navigator/NavigatorDefaults.js"], s2["Stock/Navigator/NavigatorSymbols.js"], s2["Core/Renderer/RendererRegistry.js"], s2["Stock/Utilities/StockUtilities.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2) {
      let { setOptions: O3 } = B3, { composed: j3 } = K2, { getRendererType: d3 } = tt2, { setFixedRange: x2 } = Z2, { addEvent: f2, extend: C3, pushUnique: o2 } = X2;
      function p2() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, false);
      }
      return { compose: function(b5, h2, c4) {
        q2.compose(h2), o2(j3, "Navigator") && (b5.prototype.setFixedRange = x2, C3(d3().prototype.symbols, rt2), f2(c4, "afterUpdate", p2), O3({ navigator: it2 }));
      } };
    }), at2(s2, "Core/Axis/ScrollbarAxis.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      var q2;
      let { composed: it2 } = B3, { addEvent: rt2, defined: tt2, pick: Z2, pushUnique: X2 } = K2;
      return function(O3) {
        let j3;
        function d3(o2) {
          let p2 = Z2(o2.options && o2.options.min, o2.min), b5 = Z2(o2.options && o2.options.max, o2.max);
          return { axisMin: p2, axisMax: b5, scrollMin: tt2(o2.dataMin) ? Math.min(p2, o2.min, o2.dataMin, Z2(o2.threshold, 1 / 0)) : p2, scrollMax: tt2(o2.dataMax) ? Math.max(b5, o2.max, o2.dataMax, Z2(o2.threshold, -1 / 0)) : b5 };
        }
        function x2() {
          let o2 = this.scrollbar, p2 = o2 && !o2.options.opposite, b5 = this.horiz ? 2 : p2 ? 3 : 1;
          o2 && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[b5] += o2.size + (o2.options.margin || 0));
        }
        function f2() {
          let o2 = this;
          o2.options && o2.options.scrollbar && o2.options.scrollbar.enabled && (o2.options.scrollbar.vertical = !o2.horiz, o2.options.startOnTick = o2.options.endOnTick = false, o2.scrollbar = new j3(o2.chart.renderer, o2.options.scrollbar, o2.chart), rt2(o2.scrollbar, "changed", function(p2) {
            let b5, h2, { axisMin: c4, axisMax: T2, scrollMin: I3, scrollMax: G2 } = d3(o2), L2 = G2 - I3;
            if (tt2(c4) && tt2(T2))
              if (o2.horiz && !o2.reversed || !o2.horiz && o2.reversed ? (b5 = I3 + L2 * this.to, h2 = I3 + L2 * this.from) : (b5 = I3 + L2 * (1 - this.from), h2 = I3 + L2 * (1 - this.to)), this.shouldUpdateExtremes(p2.DOMType)) {
                let l4 = p2.DOMType !== "mousemove" && p2.DOMType !== "touchmove" && void 0;
                o2.setExtremes(h2, b5, true, l4, p2);
              } else this.setRange(this.from, this.to);
          }));
        }
        function C3() {
          let o2, p2, b5, { scrollMin: h2, scrollMax: c4 } = d3(this), T2 = this.scrollbar, I3 = this.axisTitleMargin + (this.titleOffset || 0), G2 = this.chart.scrollbarsOffsets, L2 = this.options.margin || 0;
          if (T2 && G2) {
            if (this.horiz) this.opposite || (G2[1] += I3), T2.position(this.left, this.top + this.height + 2 + G2[1] - (this.opposite ? L2 : 0), this.width, this.height), this.opposite || (G2[1] += L2), o2 = 1;
            else {
              let l4;
              this.opposite && (G2[0] += I3), l4 = T2.options.opposite ? this.left + this.width + 2 + G2[0] - (this.opposite ? 0 : L2) : this.opposite ? 0 : L2, T2.position(l4, this.top, this.width, this.height), this.opposite && (G2[0] += L2), o2 = 0;
            }
            if (G2[o2] += T2.size + (T2.options.margin || 0), isNaN(h2) || isNaN(c4) || !tt2(this.min) || !tt2(this.max) || this.dataMin === this.dataMax) T2.setRange(0, 1);
            else if (this.min === this.max) {
              let l4 = this.pointRange / (this.dataMax + 1);
              p2 = l4 * this.min, b5 = l4 * (this.max + 1), T2.setRange(p2, b5);
            } else p2 = (this.min - h2) / (c4 - h2), b5 = (this.max - h2) / (c4 - h2), this.horiz && !this.reversed || !this.horiz && this.reversed ? T2.setRange(p2, b5) : T2.setRange(1 - b5, 1 - p2);
          }
        }
        O3.compose = function(o2, p2) {
          X2(it2, "Axis.Scrollbar") && (j3 = p2, rt2(o2, "afterGetOffset", x2), rt2(o2, "afterInit", f2), rt2(o2, "afterRender", C3));
        };
      }(q2 || (q2 = {})), q2;
    }), at2(s2, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
      return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: false, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: true, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
    }), at2(s2, "Stock/Scrollbar/Scrollbar.js", [s2["Core/Defaults.js"], s2["Core/Globals.js"], s2["Core/Axis/ScrollbarAxis.js"], s2["Stock/Scrollbar/ScrollbarDefaults.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2) {
      let { defaultOptions: tt2 } = B3, { addEvent: Z2, correctFloat: X2, crisp: O3, defined: j3, destroyObjectProperties: d3, fireEvent: x2, merge: f2, pick: C3, removeEvent: o2 } = rt2;
      class p2 {
        static compose(h2) {
          q2.compose(h2, p2);
        }
        static swapXY(h2, c4) {
          return c4 && h2.forEach((T2) => {
            let I3, G2 = T2.length;
            for (let L2 = 0; L2 < G2; L2 += 2) typeof (I3 = T2[L2 + 1]) == "number" && (T2[L2 + 1] = T2[L2 + 2], T2[L2 + 2] = I3);
          }), h2;
        }
        constructor(h2, c4, T2) {
          this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(h2, c4, T2);
        }
        addEvents() {
          let h2 = this.options.inverted ? [1, 0] : [0, 1], c4 = this.scrollbarButtons, T2 = this.scrollbarGroup.element, I3 = this.track.element, G2 = this.mouseDownHandler.bind(this), L2 = this.mouseMoveHandler.bind(this), l4 = this.mouseUpHandler.bind(this), y2 = [[c4[h2[0]].element, "click", this.buttonToMinClick.bind(this)], [c4[h2[1]].element, "click", this.buttonToMaxClick.bind(this)], [I3, "click", this.trackClick.bind(this)], [T2, "mousedown", G2], [T2.ownerDocument, "mousemove", L2], [T2.ownerDocument, "mouseup", l4], [T2, "touchstart", G2], [T2.ownerDocument, "touchmove", L2], [T2.ownerDocument, "touchend", l4]];
          y2.forEach(function(i5) {
            Z2.apply(null, i5);
          }), this._events = y2;
        }
        buttonToMaxClick(h2) {
          let c4 = (this.to - this.from) * C3(this.options.step, 0.2);
          this.updatePosition(this.from + c4, this.to + c4), x2(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: h2 });
        }
        buttonToMinClick(h2) {
          let c4 = X2(this.to - this.from) * C3(this.options.step, 0.2);
          this.updatePosition(X2(this.from - c4), X2(this.to - c4)), x2(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: h2 });
        }
        cursorToScrollbarPosition(h2) {
          let c4 = this.options, T2 = c4.minWidth > this.calculatedWidth ? c4.minWidth : 0;
          return { chartX: (h2.chartX - this.x - this.xOffset) / (this.barWidth - T2), chartY: (h2.chartY - this.y - this.yOffset) / (this.barWidth - T2) };
        }
        destroy() {
          let h2 = this, c4 = h2.chart.scroller;
          h2.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(T2) {
            h2[T2] && h2[T2].destroy && (h2[T2] = h2[T2].destroy());
          }), c4 && h2 === c4.scrollbar && (c4.scrollbar = null, d3(c4.scrollbarButtons));
        }
        drawScrollbarButton(h2) {
          let c4 = this.renderer, T2 = this.scrollbarButtons, I3 = this.options, G2 = this.size, L2 = c4.g().add(this.group);
          if (T2.push(L2), I3.buttonsEnabled) {
            let l4 = c4.rect().addClass("highcharts-scrollbar-button").add(L2);
            this.chart.styledMode || l4.attr({ stroke: I3.buttonBorderColor, "stroke-width": I3.buttonBorderWidth, fill: I3.buttonBackgroundColor }), l4.attr(l4.crisp({ x: -0.5, y: -0.5, width: G2, height: G2, r: I3.buttonBorderRadius }, l4.strokeWidth()));
            let y2 = c4.path(p2.swapXY([["M", G2 / 2 + (h2 ? -1 : 1), G2 / 2 - 3], ["L", G2 / 2 + (h2 ? -1 : 1), G2 / 2 + 3], ["L", G2 / 2 + (h2 ? 2 : -2), G2 / 2]], I3.vertical)).addClass("highcharts-scrollbar-arrow").add(T2[h2]);
            this.chart.styledMode || y2.attr({ fill: I3.buttonArrowColor });
          }
        }
        init(h2, c4, T2) {
          this.scrollbarButtons = [], this.renderer = h2, this.userOptions = c4, this.options = f2(it2, tt2.scrollbar, c4), this.options.margin = C3(this.options.margin, 10), this.chart = T2, this.size = C3(this.options.size, this.options.height), c4.enabled && (this.render(), this.addEvents());
        }
        mouseDownHandler(h2) {
          var c4;
          let T2 = ((c4 = this.chart.pointer) == null ? void 0 : c4.normalize(h2)) || h2, I3 = this.cursorToScrollbarPosition(T2);
          this.chartX = I3.chartX, this.chartY = I3.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = true;
        }
        mouseMoveHandler(h2) {
          var c4;
          let T2, I3 = ((c4 = this.chart.pointer) == null ? void 0 : c4.normalize(h2)) || h2, G2 = this.options.vertical ? "chartY" : "chartX", L2 = this.initPositions || [];
          this.grabbedCenter && (!h2.touches || h2.touches[0][G2] !== 0) && (T2 = this.cursorToScrollbarPosition(I3)[G2] - this[G2], this.hasDragged = true, this.updatePosition(L2[0] + T2, L2[1] + T2), this.hasDragged && x2(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: h2.type, DOMEvent: h2 }));
        }
        mouseUpHandler(h2) {
          this.hasDragged && x2(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: h2.type, DOMEvent: h2 }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }
        position(h2, c4, T2, I3) {
          let { buttonsEnabled: G2, margin: L2 = 0, vertical: l4 } = this.options, y2 = this.rendered ? "animate" : "attr", i5 = I3, t3 = 0;
          this.group.show(), this.x = h2, this.y = c4 + this.trackBorderWidth, this.width = T2, this.height = I3, this.xOffset = i5, this.yOffset = t3, l4 ? (this.width = this.yOffset = T2 = t3 = this.size, this.xOffset = i5 = 0, this.yOffset = t3 = G2 ? this.size : 0, this.barWidth = I3 - (G2 ? 2 * T2 : 0), this.x = h2 += L2) : (this.height = I3 = this.size, this.xOffset = i5 = G2 ? this.size : 0, this.barWidth = T2 - (G2 ? 2 * I3 : 0), this.y = this.y + L2), this.group[y2]({ translateX: h2, translateY: this.y }), this.track[y2]({ width: T2, height: I3 }), this.scrollbarButtons[1][y2]({ translateX: l4 ? 0 : T2 - i5, translateY: l4 ? I3 - t3 : 0 });
        }
        removeEvents() {
          this._events.forEach(function(h2) {
            o2.apply(null, h2);
          }), this._events.length = 0;
        }
        render() {
          let h2 = this.renderer, c4 = this.options, T2 = this.size, I3 = this.chart.styledMode, G2 = h2.g("scrollbar").attr({ zIndex: c4.zIndex }).hide().add();
          this.group = G2, this.track = h2.rect().addClass("highcharts-scrollbar-track").attr({ r: c4.trackBorderRadius || 0, height: T2, width: T2 }).add(G2), I3 || this.track.attr({ fill: c4.trackBackgroundColor, stroke: c4.trackBorderColor, "stroke-width": c4.trackBorderWidth });
          let L2 = this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({ x: -O3(0, L2), y: -O3(0, L2) }), this.scrollbarGroup = h2.g().add(G2), this.scrollbar = h2.rect().addClass("highcharts-scrollbar-thumb").attr({ height: T2 - L2, width: T2 - L2, r: c4.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = h2.path(p2.swapXY([["M", -3, T2 / 4], ["L", -3, 2 * T2 / 3], ["M", 0, T2 / 4], ["L", 0, 2 * T2 / 3], ["M", 3, T2 / 4], ["L", 3, 2 * T2 / 3]], c4.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), I3 || (this.scrollbar.attr({ fill: c4.barBackgroundColor, stroke: c4.barBorderColor, "stroke-width": c4.barBorderWidth }), this.scrollbarRifles.attr({ stroke: c4.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-O3(0, this.scrollbarStrokeWidth), -O3(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }
        setRange(h2, c4) {
          let T2, I3, G2 = this.options, L2 = G2.vertical, l4 = G2.minWidth, y2 = this.barWidth, i5 = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (!j3(y2)) return;
          let t3 = y2 * Math.min(c4, 1);
          T2 = Math.ceil(y2 * (h2 = Math.max(h2, 0))), this.calculatedWidth = I3 = X2(t3 - T2), I3 < l4 && (T2 = (y2 - l4 + I3) * h2, I3 = l4);
          let e5 = Math.floor(T2 + this.xOffset + this.yOffset), n4 = I3 / 2 - 0.5;
          this.from = h2, this.to = c4, L2 ? (this.scrollbarGroup[i5]({ translateY: e5 }), this.scrollbar[i5]({ height: I3 }), this.scrollbarRifles[i5]({ translateY: n4 }), this.scrollbarTop = e5, this.scrollbarLeft = 0) : (this.scrollbarGroup[i5]({ translateX: e5 }), this.scrollbar[i5]({ width: I3 }), this.scrollbarRifles[i5]({ translateX: n4 }), this.scrollbarLeft = e5, this.scrollbarTop = 0), I3 <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), G2.showFull === false && (h2 <= 0 && c4 >= 1 ? this.group.hide() : this.group.show()), this.rendered = true;
        }
        shouldUpdateExtremes(h2) {
          return C3(this.options.liveRedraw, K2.svg && !K2.isTouchDevice && !this.chart.boosted) || h2 === "mouseup" || h2 === "touchend" || !j3(h2);
        }
        trackClick(h2) {
          var c4;
          let T2 = ((c4 = this.chart.pointer) == null ? void 0 : c4.normalize(h2)) || h2, I3 = this.to - this.from, G2 = this.y + this.scrollbarTop, L2 = this.x + this.scrollbarLeft;
          this.options.vertical && T2.chartY > G2 || !this.options.vertical && T2.chartX > L2 ? this.updatePosition(this.from + I3, this.to + I3) : this.updatePosition(this.from - I3, this.to - I3), x2(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: h2 });
        }
        update(h2) {
          this.destroy(), this.init(this.chart.renderer, f2(true, this.options, h2), this.chart);
        }
        updatePosition(h2, c4) {
          c4 > 1 && (h2 = X2(1 - X2(c4 - h2)), c4 = 1), h2 < 0 && (c4 = X2(c4 - h2), h2 = 0), this.from = h2, this.to = c4;
        }
      }
      return p2.defaultOptions = it2, tt2.scrollbar = f2(true, p2.defaultOptions, tt2.scrollbar), p2;
    }), at2(s2, "Stock/Navigator/Navigator.js", [s2["Core/Axis/Axis.js"], s2["Stock/Navigator/ChartNavigatorComposition.js"], s2["Core/Defaults.js"], s2["Core/Globals.js"], s2["Core/Axis/NavigatorAxisComposition.js"], s2["Stock/Navigator/NavigatorComposition.js"], s2["Stock/Scrollbar/Scrollbar.js"], s2["Core/Renderer/SVG/SVGRenderer.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2, O3) {
      let { defaultOptions: j3 } = q2, { isTouchDevice: d3 } = it2, { prototype: { symbols: x2 } } = X2, { addEvent: f2, clamp: C3, correctFloat: o2, defined: p2, destroyObjectProperties: b5, erase: h2, extend: c4, find: T2, fireEvent: I3, isArray: G2, isNumber: L2, merge: l4, pick: y2, removeEvent: i5, splat: t3 } = O3;
      function e5(u2, ...a2) {
        let g2 = [].filter.call(a2, L2);
        if (g2.length) return Math[u2].apply(0, g2);
      }
      class n4 {
        static compose(a2, g2, r3) {
          K2.compose(a2, n4), tt2.compose(a2, g2, r3);
        }
        constructor(a2) {
          this.isDirty = false, this.scrollbarHeight = 0, this.init(a2);
        }
        drawHandle(a2, g2, r3, A3) {
          let N2 = this.navigatorOptions.handles.height;
          this.handles[g2][A3](r3 ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(a2, 10) + 0.5 - N2) } : { translateX: Math.round(this.left + parseInt(a2, 10)), translateY: Math.round(this.top + this.height / 2 - N2 / 2 - 1) });
        }
        drawOutline(a2, g2, r3, A3) {
          let N2 = this.navigatorOptions.maskInside, k3 = this.outline.strokeWidth(), E2 = k3 / 2, R2 = k3 % 2 / 2, z2 = this.scrollButtonSize, Q2 = this.size, v3 = this.top, S2 = this.height, P2 = v3 - E2, U2 = v3 + S2, w2 = this.left, M2, D2;
          r3 ? (M2 = v3 + g2 + R2, g2 = v3 + a2 + R2, D2 = [["M", w2 + S2, v3 - z2 - R2], ["L", w2 + S2, M2], ["L", w2, M2], ["M", w2, g2], ["L", w2 + S2, g2], ["L", w2 + S2, v3 + Q2 + z2]], N2 && D2.push(["M", w2 + S2, M2 - E2], ["L", w2 + S2, g2 + E2])) : (w2 -= z2, a2 += w2 + z2 - R2, g2 += w2 + z2 - R2, D2 = [["M", w2, P2], ["L", a2, P2], ["L", a2, U2], ["M", g2, U2], ["L", g2, P2], ["L", w2 + Q2 + 2 * z2, P2]], N2 && D2.push(["M", a2 - E2, P2], ["L", g2 + E2, P2])), this.outline[A3]({ d: D2 });
        }
        drawMasks(a2, g2, r3, A3) {
          let N2, k3, E2, R2, z2 = this.left, Q2 = this.top, v3 = this.height;
          r3 ? (E2 = [z2, z2, z2], R2 = [Q2, Q2 + a2, Q2 + g2], k3 = [v3, v3, v3], N2 = [a2, g2 - a2, this.size - g2]) : (E2 = [z2, z2 + a2, z2 + g2], R2 = [Q2, Q2, Q2], k3 = [a2, g2 - a2, this.size - g2], N2 = [v3, v3, v3]), this.shades.forEach((S2, P2) => {
            S2[A3]({ x: E2[P2], y: R2[P2], width: k3[P2], height: N2[P2] });
          });
        }
        renderElements() {
          var a2, g2;
          let r3 = this, A3 = r3.navigatorOptions, N2 = A3.maskInside, k3 = r3.chart, E2 = k3.inverted, R2 = k3.renderer, z2 = { cursor: E2 ? "ns-resize" : "ew-resize" }, Q2 = (a2 = r3.navigatorGroup) != null ? a2 : r3.navigatorGroup = R2.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add();
          if ([!N2, N2, !N2].forEach((v3, S2) => {
            var P2;
            let U2 = (P2 = r3.shades[S2]) != null ? P2 : r3.shades[S2] = R2.rect().addClass("highcharts-navigator-mask" + (S2 === 1 ? "-inside" : "-outside")).add(Q2);
            k3.styledMode || (U2.attr({ fill: v3 ? A3.maskFill : "rgba(0,0,0,0)" }), S2 === 1 && U2.css(z2));
          }), r3.outline || (r3.outline = R2.path().addClass("highcharts-navigator-outline").add(Q2)), k3.styledMode || r3.outline.attr({ "stroke-width": A3.outlineWidth, stroke: A3.outlineColor }), (g2 = A3.handles) == null ? void 0 : g2.enabled) {
            let v3 = A3.handles, { height: S2, width: P2 } = v3;
            [0, 1].forEach((U2) => {
              var w2;
              let M2 = v3.symbols[U2];
              if (r3.handles[U2] && r3.handles[U2].symbolUrl === M2) {
                if (!r3.handles[U2].isImg && r3.handles[U2].symbolName !== M2) {
                  let D2 = x2[M2].call(x2, -P2 / 2 - 1, 0, P2, S2);
                  r3.handles[U2].attr({ d: D2 }), r3.handles[U2].symbolName = M2;
                }
              } else (w2 = r3.handles[U2]) == null || w2.destroy(), r3.handles[U2] = R2.symbol(M2, -P2 / 2 - 1, 0, P2, S2, v3), r3.handles[U2].attr({ zIndex: 7 - U2 }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][U2]).add(Q2), r3.addMouseEvents();
              k3.inverted && r3.handles[U2].attr({ rotation: 90, rotationOriginX: Math.floor(-P2 / 2), rotationOriginY: (S2 + P2) / 2 }), k3.styledMode || r3.handles[U2].attr({ fill: v3.backgroundColor, stroke: v3.borderColor, "stroke-width": v3.lineWidth, width: v3.width, height: v3.height, x: -P2 / 2 - 1, y: 0 }).css(z2);
            });
          }
        }
        update(a2, g2 = false) {
          var r3, A3;
          let N2 = this.chart, k3 = N2.options.chart.inverted !== ((r3 = N2.scrollbar) == null ? void 0 : r3.options.vertical);
          if (l4(true, N2.options.navigator, a2), this.navigatorOptions = N2.options.navigator || {}, this.setOpposite(), p2(a2.enabled) || k3) return this.destroy(), this.navigatorEnabled = a2.enabled || this.navigatorEnabled, this.init(N2);
          if (this.navigatorEnabled && (this.isDirty = true, a2.adaptToUpdatedData === false && this.baseSeries.forEach((E2) => {
            i5(E2, "updatedData", this.updatedDataHandler);
          }, this), a2.adaptToUpdatedData && this.baseSeries.forEach((E2) => {
            E2.eventsToUnbind.push(f2(E2, "updatedData", this.updatedDataHandler));
          }, this), (a2.series || a2.baseSeries) && this.setBaseSeries(void 0, false), a2.height || a2.xAxis || a2.yAxis)) {
            this.height = (A3 = a2.height) != null ? A3 : this.height;
            let E2 = this.getXAxisOffsets();
            this.xAxis.update({ ...a2.xAxis, offsets: E2, [N2.inverted ? "width" : "height"]: this.height, [N2.inverted ? "height" : "width"]: void 0 }, false), this.yAxis.update({ ...a2.yAxis, [N2.inverted ? "width" : "height"]: this.height }, false);
          }
          g2 && N2.redraw();
        }
        render(a2, g2, r3, A3) {
          let N2 = this.chart, k3 = this.xAxis, E2 = k3.pointRange || 0, R2 = k3.navigatorAxis.fake ? N2.xAxis[0] : k3, z2 = this.navigatorEnabled, Q2 = this.rendered, v3 = N2.inverted, S2 = N2.xAxis[0].minRange, P2 = N2.xAxis[0].options.maxRange, U2 = this.scrollButtonSize, w2, M2, D2, F2 = this.scrollbarHeight, $2, W2;
          if (this.hasDragged && !p2(r3)) return;
          if (this.isDirty && this.renderElements(), a2 = o2(a2 - E2 / 2), g2 = o2(g2 + E2 / 2), !L2(a2) || !L2(g2)) {
            if (!Q2) return;
            r3 = 0, A3 = y2(k3.width, R2.width);
          }
          this.left = y2(k3.left, N2.plotLeft + U2 + (v3 ? N2.plotWidth : 0));
          let V2 = this.size = $2 = y2(k3.len, (v3 ? N2.plotHeight : N2.plotWidth) - 2 * U2);
          w2 = v3 ? F2 : $2 + 2 * U2, r3 = y2(r3, k3.toPixels(a2, true)), A3 = y2(A3, k3.toPixels(g2, true)), L2(r3) && Math.abs(r3) !== 1 / 0 || (r3 = 0, A3 = w2);
          let _2 = k3.toValue(r3, true), et2 = k3.toValue(A3, true), lt2 = Math.abs(o2(et2 - _2));
          lt2 < S2 ? this.grabbedLeft ? r3 = k3.toPixels(et2 - S2 - E2, true) : this.grabbedRight && (A3 = k3.toPixels(_2 + S2 + E2, true)) : p2(P2) && o2(lt2 - E2) > P2 && (this.grabbedLeft ? r3 = k3.toPixels(et2 - P2 - E2, true) : this.grabbedRight && (A3 = k3.toPixels(_2 + P2 + E2, true))), this.zoomedMax = C3(Math.max(r3, A3), 0, V2), this.zoomedMin = C3(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(r3, A3), 0, V2), this.range = this.zoomedMax - this.zoomedMin, V2 = Math.round(this.zoomedMax);
          let ht2 = Math.round(this.zoomedMin);
          z2 && (this.navigatorGroup.attr({ visibility: "inherit" }), W2 = Q2 && !this.hasDragged ? "animate" : "attr", this.drawMasks(ht2, V2, v3, W2), this.drawOutline(ht2, V2, v3, W2), this.navigatorOptions.handles.enabled && (this.drawHandle(ht2, 0, v3, W2), this.drawHandle(V2, 1, v3, W2))), this.scrollbar && (v3 ? (D2 = this.top - U2, M2 = this.left - F2 + (z2 || !R2.opposite ? 0 : (R2.titleOffset || 0) + R2.axisTitleMargin), F2 = $2 + 2 * U2) : (D2 = this.top + (z2 ? this.height : -F2), M2 = this.left - U2), this.scrollbar.position(M2, D2, w2, F2), this.scrollbar.setRange(this.zoomedMin / ($2 || 1), this.zoomedMax / ($2 || 1))), this.rendered = true, this.isDirty = false, I3(this, "afterRender");
        }
        addMouseEvents() {
          let a2 = this, g2 = a2.chart, r3 = g2.container, A3 = [], N2, k3;
          a2.mouseMoveHandler = N2 = function(E2) {
            a2.onMouseMove(E2);
          }, a2.mouseUpHandler = k3 = function(E2) {
            a2.onMouseUp(E2);
          }, (A3 = a2.getPartsEvents("mousedown")).push(f2(g2.renderTo, "mousemove", N2), f2(r3.ownerDocument, "mouseup", k3), f2(g2.renderTo, "touchmove", N2), f2(r3.ownerDocument, "touchend", k3)), A3.concat(a2.getPartsEvents("touchstart")), a2.eventsToUnbind = A3, a2.series && a2.series[0] && A3.push(f2(a2.series[0].xAxis, "foundExtremes", function() {
            g2.navigator.modifyNavigatorAxisExtremes();
          }));
        }
        getPartsEvents(a2) {
          let g2 = this, r3 = [];
          return ["shades", "handles"].forEach(function(A3) {
            g2[A3].forEach(function(N2, k3) {
              r3.push(f2(N2.element, a2, function(E2) {
                g2[A3 + "Mousedown"](E2, k3);
              }));
            });
          }), r3;
        }
        shadesMousedown(a2, g2) {
          var r3;
          a2 = ((r3 = this.chart.pointer) == null ? void 0 : r3.normalize(a2)) || a2;
          let A3 = this.chart, N2 = this.xAxis, k3 = this.zoomedMin, E2 = this.size, R2 = this.range, z2 = this.left, Q2 = a2.chartX, v3, S2, P2, U2;
          A3.inverted && (Q2 = a2.chartY, z2 = this.top), g2 === 1 ? (this.grabbedCenter = Q2, this.fixedWidth = R2, this.dragOffset = Q2 - k3) : (U2 = Q2 - z2 - R2 / 2, g2 === 0 ? U2 = Math.max(0, U2) : g2 === 2 && U2 + R2 >= E2 && (U2 = E2 - R2, this.reversedExtremes ? (U2 -= R2, S2 = this.getUnionExtremes().dataMin) : v3 = this.getUnionExtremes().dataMax), U2 !== k3 && (this.fixedWidth = R2, p2((P2 = N2.navigatorAxis.toFixedRange(U2, U2 + R2, S2, v3)).min) && I3(this, "setRange", { min: Math.min(P2.min, P2.max), max: Math.max(P2.min, P2.max), redraw: true, eventArguments: { trigger: "navigator" } })));
        }
        handlesMousedown(a2, g2) {
          var r3;
          a2 = ((r3 = this.chart.pointer) == null ? void 0 : r3.normalize(a2)) || a2;
          let A3 = this.chart, N2 = A3.xAxis[0], k3 = this.reversedExtremes;
          g2 === 0 ? (this.grabbedLeft = true, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = k3 ? N2.min : N2.max) : (this.grabbedRight = true, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = k3 ? N2.max : N2.min), A3.setFixedRange(void 0);
        }
        onMouseMove(a2) {
          var g2;
          let r3 = this, A3 = r3.chart, N2 = r3.navigatorSize, k3 = r3.range, E2 = r3.dragOffset, R2 = A3.inverted, z2 = r3.left, Q2;
          (!a2.touches || a2.touches[0].pageX !== 0) && (Q2 = (a2 = ((g2 = A3.pointer) == null ? void 0 : g2.normalize(a2)) || a2).chartX, R2 && (z2 = r3.top, Q2 = a2.chartY), r3.grabbedLeft ? (r3.hasDragged = true, r3.render(0, 0, Q2 - z2, r3.otherHandlePos)) : r3.grabbedRight ? (r3.hasDragged = true, r3.render(0, 0, r3.otherHandlePos, Q2 - z2)) : r3.grabbedCenter && (r3.hasDragged = true, Q2 < E2 ? Q2 = E2 : Q2 > N2 + E2 - k3 && (Q2 = N2 + E2 - k3), r3.render(0, 0, Q2 - E2, Q2 - E2 + k3)), r3.hasDragged && r3.scrollbar && y2(r3.scrollbar.options.liveRedraw, !d3 && !this.chart.boosted) && (a2.DOMType = a2.type, setTimeout(function() {
            r3.onMouseUp(a2);
          }, 0)));
        }
        onMouseUp(a2) {
          let g2, r3, A3, N2, k3, E2, R2 = this.chart, z2 = this.xAxis, Q2 = this.scrollbar, v3 = a2.DOMEvent || a2, S2 = R2.inverted, P2 = this.rendered && !this.hasDragged ? "animate" : "attr";
          (this.hasDragged && (!Q2 || !Q2.hasDragged) || a2.trigger === "scrollbar") && (A3 = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? N2 = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (k3 = this.fixedExtreme), this.zoomedMax === this.size && (k3 = this.reversedExtremes ? A3.dataMin : A3.dataMax), this.zoomedMin === 0 && (N2 = this.reversedExtremes ? A3.dataMax : A3.dataMin), p2((E2 = z2.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, N2, k3)).min) && I3(this, "setRange", { min: Math.min(E2.min, E2.max), max: Math.max(E2.min, E2.max), redraw: true, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: v3 } })), a2.DOMType !== "mousemove" && a2.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && L2(this.zoomedMin) && L2(this.zoomedMax) && (r3 = Math.round(this.zoomedMin), g2 = Math.round(this.zoomedMax), this.shades && this.drawMasks(r3, g2, S2, P2), this.outline && this.drawOutline(r3, g2, S2, P2), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(r3, 0, S2, P2), this.drawHandle(g2, 1, S2, P2)));
        }
        removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function(a2) {
            a2();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }
        removeBaseSeriesEvents() {
          let a2 = this.baseSeries || [];
          this.navigatorEnabled && a2[0] && (this.navigatorOptions.adaptToUpdatedData !== false && a2.forEach(function(g2) {
            i5(g2, "updatedData", this.updatedDataHandler);
          }, this), a2[0].xAxis && i5(a2[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }
        getXAxisOffsets() {
          return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
        }
        init(a2) {
          var g2;
          let r3 = a2.options, A3 = r3.navigator || {}, N2 = A3.enabled, k3 = r3.scrollbar || {}, E2 = k3.enabled, R2 = N2 && A3.height || 0, z2 = E2 && k3.height || 0, Q2 = k3.buttonsEnabled && z2 || 0;
          this.handles = [], this.shades = [], this.chart = a2, this.setBaseSeries(), this.height = R2, this.scrollbarHeight = z2, this.scrollButtonSize = Q2, this.scrollbarEnabled = E2, this.navigatorEnabled = N2, this.navigatorOptions = A3, this.scrollbarOptions = k3, this.setOpposite();
          let v3 = this, S2 = v3.baseSeries, P2 = a2.xAxis.length, U2 = a2.yAxis.length, w2 = S2 && S2[0] && S2[0].xAxis || a2.xAxis[0] || { options: {} };
          if (a2.isDirtyBox = true, v3.navigatorEnabled) {
            let M2 = this.getXAxisOffsets();
            v3.xAxis = new B3(a2, l4({ breaks: w2.options.breaks, ordinal: w2.options.ordinal, overscroll: w2.options.overscroll }, A3.xAxis, { type: "datetime", yAxis: (g2 = A3.yAxis) == null ? void 0 : g2.id, index: P2, isInternal: true, offset: 0, keepOrdinalPadding: true, startOnTick: false, endOnTick: false, minPadding: w2.options.ordinal ? 0 : w2.options.minPadding, maxPadding: w2.options.ordinal ? 0 : w2.options.maxPadding, zoomEnabled: false }, a2.inverted ? { offsets: M2, width: R2 } : { offsets: M2, height: R2 }), "xAxis"), v3.yAxis = new B3(a2, l4(A3.yAxis, { alignTicks: false, offset: 0, index: U2, isInternal: true, reversed: y2(A3.yAxis && A3.yAxis.reversed, a2.yAxis[0] && a2.yAxis[0].reversed, false), zoomEnabled: false }, a2.inverted ? { width: R2 } : { height: R2 }), "yAxis"), S2 || A3.series.data ? v3.updateNavigatorSeries(false) : a2.series.length === 0 && (v3.unbindRedraw = f2(a2, "beforeRedraw", function() {
              a2.series.length > 0 && !v3.series && (v3.setBaseSeries(), v3.unbindRedraw());
            })), v3.reversedExtremes = a2.inverted && !v3.xAxis.reversed || !a2.inverted && v3.xAxis.reversed, v3.renderElements(), v3.addMouseEvents();
          } else v3.xAxis = { chart: a2, navigatorAxis: { fake: true }, translate: function(M2, D2) {
            let F2 = a2.xAxis[0], $2 = F2.getExtremes(), W2 = F2.len - 2 * Q2, V2 = e5("min", F2.options.min, $2.dataMin), _2 = e5("max", F2.options.max, $2.dataMax) - V2;
            return D2 ? M2 * _2 / W2 + V2 : W2 * (M2 - V2) / _2;
          }, toPixels: function(M2) {
            return this.translate(M2);
          }, toValue: function(M2) {
            return this.translate(M2, true);
          } }, v3.xAxis.navigatorAxis.axis = v3.xAxis, v3.xAxis.navigatorAxis.toFixedRange = rt2.prototype.toFixedRange.bind(v3.xAxis.navigatorAxis);
          if (a2.options.scrollbar.enabled) {
            let M2 = l4(a2.options.scrollbar, { vertical: a2.inverted });
            !L2(M2.margin) && v3.navigatorEnabled && (M2.margin = a2.inverted ? -3 : 3), a2.scrollbar = v3.scrollbar = new Z2(a2.renderer, M2, a2), f2(v3.scrollbar, "changed", function(D2) {
              let F2 = v3.size, $2 = F2 * this.to, W2 = F2 * this.from;
              v3.hasDragged = v3.scrollbar.hasDragged, v3.render(0, 0, W2, $2), this.shouldUpdateExtremes(D2.DOMType) && setTimeout(function() {
                v3.onMouseUp(D2);
              });
            });
          }
          v3.addBaseSeriesEvents(), v3.addChartEvents();
        }
        setOpposite() {
          let a2 = this.navigatorOptions, g2 = this.navigatorEnabled, r3 = this.chart;
          this.opposite = y2(a2.opposite, !!(!g2 && r3.inverted));
        }
        getUnionExtremes(a2) {
          let g2, r3 = this.chart.xAxis[0], A3 = this.xAxis, N2 = A3.options, k3 = r3.options;
          return a2 && r3.dataMin === null || (g2 = { dataMin: y2(N2 && N2.min, e5("min", k3.min, r3.dataMin, A3.dataMin, A3.min)), dataMax: y2(N2 && N2.max, e5("max", k3.max, r3.dataMax, A3.dataMax, A3.max)) }), g2;
        }
        setBaseSeries(a2, g2) {
          let r3 = this.chart, A3 = this.baseSeries = [];
          a2 = a2 || r3.options && r3.options.navigator.baseSeries || (r3.series.length ? T2(r3.series, (N2) => !N2.options.isInternal).index : 0), (r3.series || []).forEach((N2, k3) => {
            !N2.options.isInternal && (N2.options.showInNavigator || (k3 === a2 || N2.options.id === a2) && N2.options.showInNavigator !== false) && A3.push(N2);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(true, g2);
        }
        updateNavigatorSeries(a2, g2) {
          var r3, A3;
          let N2 = this, k3 = N2.chart, E2 = N2.baseSeries, R2 = { enableMouseTracking: false, index: null, linkedTo: null, group: "nav", padXAxis: false, xAxis: (r3 = this.navigatorOptions.xAxis) == null ? void 0 : r3.id, yAxis: (A3 = this.navigatorOptions.yAxis) == null ? void 0 : A3.id, showInLegend: false, stacking: void 0, isInternal: true, states: { inactive: { opacity: 1 } } }, z2 = N2.series = (N2.series || []).filter((U2) => {
            let w2 = U2.baseSeries;
            return !(0 > E2.indexOf(w2)) || (w2 && (i5(w2, "updatedData", N2.updatedDataHandler), delete w2.navigatorSeries), U2.chart && U2.destroy(), false);
          }), Q2, v3, S2 = N2.navigatorOptions.series, P2;
          E2 && E2.length && E2.forEach((U2) => {
            let w2 = U2.navigatorSeries, M2 = c4({ color: U2.color, visible: U2.visible }, G2(S2) ? j3.navigator.series : S2);
            if (w2 && N2.navigatorOptions.adaptToUpdatedData === false) return;
            R2.name = "Navigator " + E2.length, P2 = (Q2 = U2.options || {}).navigatorOptions || {}, M2.dataLabels = t3(M2.dataLabels), (v3 = l4(Q2, R2, M2, P2)).pointRange = y2(M2.pointRange, P2.pointRange, j3.plotOptions[v3.type || "line"].pointRange);
            let D2 = P2.data || M2.data;
            N2.hasNavigatorData = N2.hasNavigatorData || !!D2, v3.data = D2 || Q2.data && Q2.data.slice(0), w2 && w2.options ? w2.update(v3, g2) : (U2.navigatorSeries = k3.initSeries(v3), k3.setSortedData(), U2.navigatorSeries.baseSeries = U2, z2.push(U2.navigatorSeries));
          }), (S2.data && !(E2 && E2.length) || G2(S2)) && (N2.hasNavigatorData = false, (S2 = t3(S2)).forEach((U2, w2) => {
            R2.name = "Navigator " + (z2.length + 1), (v3 = l4(j3.navigator.series, { color: k3.series[w2] && !k3.series[w2].options.isInternal && k3.series[w2].color || k3.options.colors[w2] || k3.options.colors[0] }, R2, U2)).data = U2.data, v3.data && (N2.hasNavigatorData = true, z2.push(k3.initSeries(v3)));
          })), a2 && this.addBaseSeriesEvents();
        }
        addBaseSeriesEvents() {
          let a2 = this, g2 = a2.baseSeries || [];
          g2[0] && g2[0].xAxis && g2[0].eventsToUnbind.push(f2(g2[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), g2.forEach((r3) => {
            r3.eventsToUnbind.push(f2(r3, "show", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(true, false);
            })), r3.eventsToUnbind.push(f2(r3, "hide", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(false, false);
            })), this.navigatorOptions.adaptToUpdatedData !== false && r3.xAxis && r3.eventsToUnbind.push(f2(r3, "updatedData", this.updatedDataHandler)), r3.eventsToUnbind.push(f2(r3, "remove", function() {
              h2(g2, r3), this.navigatorSeries && (h2(a2.series, this.navigatorSeries), p2(this.navigatorSeries.options) && this.navigatorSeries.remove(false), delete this.navigatorSeries);
            }));
          });
        }
        getBaseSeriesMin(a2) {
          return this.baseSeries.reduce(function(g2, r3) {
            return Math.min(g2, r3.xData && r3.xData.length ? r3.xData[0] : g2);
          }, a2);
        }
        modifyNavigatorAxisExtremes() {
          let a2 = this.xAxis;
          if (a2.getExtremes !== void 0) {
            let g2 = this.getUnionExtremes(true);
            g2 && (g2.dataMin !== a2.min || g2.dataMax !== a2.max) && (a2.min = g2.dataMin, a2.max = g2.dataMax);
          }
        }
        modifyBaseAxisExtremes() {
          var a2;
          let g2, r3, A3 = this.chart.navigator, N2 = this.getExtremes(), k3 = N2.min, E2 = N2.max, R2 = N2.dataMin, z2 = N2.dataMax, Q2 = E2 - k3, v3 = A3.stickToMin, S2 = A3.stickToMax, P2 = y2((a2 = this.ordinal) == null ? void 0 : a2.convertOverscroll(this.options.overscroll), 0), U2 = A3.series && A3.series[0], w2 = !!this.setExtremes;
          !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (v3 && (g2 = (r3 = R2) + Q2), S2 && (g2 = z2 + P2, v3 || (r3 = Math.max(R2, g2 - Q2, A3.getBaseSeriesMin(U2 && U2.xData ? U2.xData[0] : -Number.MAX_VALUE)))), w2 && (v3 || S2) && L2(r3) && (this.min = this.userMin = r3, this.max = this.userMax = g2)), A3.stickToMin = A3.stickToMax = null;
        }
        updatedDataHandler() {
          let a2 = this.chart.navigator, g2 = this.navigatorSeries, r3 = a2.reversedExtremes ? Math.round(a2.zoomedMin) === 0 : Math.round(a2.zoomedMax) >= Math.round(a2.size);
          a2.stickToMax = y2(this.chart.options.navigator && this.chart.options.navigator.stickToMax, r3), a2.stickToMin = a2.shouldStickToMin(this, a2), g2 && !a2.hasNavigatorData && (g2.options.pointStart = this.xData[0], g2.setData(this.options.data, false, null, false));
        }
        shouldStickToMin(a2, g2) {
          let r3 = g2.getBaseSeriesMin(a2.xData[0]), A3 = a2.xAxis, N2 = A3.max, k3 = A3.min, E2 = A3.options.range;
          return !!(L2(N2) && L2(k3)) && (E2 && N2 - r3 > 0 ? N2 - r3 < E2 : k3 <= r3);
        }
        addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(f2(this.chart, "redraw", function() {
            let a2 = this.navigator, g2 = a2 && (a2.baseSeries && a2.baseSeries[0] && a2.baseSeries[0].xAxis || this.xAxis[0]);
            g2 && a2.render(g2.min, g2.max);
          }), f2(this.chart, "getMargins", function() {
            let a2 = this.navigator, g2 = a2.opposite ? "plotTop" : "marginBottom";
            this.inverted && (g2 = a2.opposite ? "marginRight" : "plotLeft"), this[g2] = (this[g2] || 0) + (a2.navigatorEnabled || !this.inverted ? a2.height + a2.scrollbarHeight : 0) + a2.navigatorOptions.margin;
          }), f2(n4, "setRange", function(a2) {
            this.chart.xAxis[0].setExtremes(a2.min, a2.max, a2.redraw, a2.animation, a2.eventArguments);
          }));
        }
        destroy() {
          this.removeEvents(), this.xAxis && (h2(this.chart.xAxis, this.xAxis), h2(this.chart.axes, this.xAxis)), this.yAxis && (h2(this.chart.yAxis, this.yAxis), h2(this.chart.axes, this.yAxis)), (this.series || []).forEach((a2) => {
            a2.destroy && a2.destroy();
          }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((a2) => {
            this[a2] && this[a2].destroy && this[a2].destroy(), this[a2] = null;
          }), [this.handles].forEach((a2) => {
            b5(a2);
          }), this.navigatorEnabled = false;
        }
      }
      return n4;
    }), at2(s2, "Accessibility/Components/NavigatorComponent.js", [s2["Accessibility/AccessibilityComponent.js"], s2["Accessibility/Utils/Announcer.js"], s2["Accessibility/KeyboardNavigationHandler.js"], s2["Stock/Navigator/Navigator.js"], s2["Core/Animation/AnimationUtilities.js"], s2["Core/Templating.js"], s2["Core/Utilities.js"], s2["Accessibility/Utils/HTMLUtilities.js"], s2["Accessibility/Utils/ChartUtilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2, O3) {
      let { animObject: j3 } = rt2, { format: d3 } = tt2, { clamp: x2, pick: f2, syncTimeout: C3 } = Z2, { getFakeMouseEvent: o2 } = X2, { getAxisRangeDescription: p2, fireEventOnWrappedOrUnwrappedElement: b5 } = O3;
      return class extends B3 {
        init() {
          let h2 = this.chart, c4 = this;
          this.announcer = new K2(h2, "polite"), this.addEvent(it2, "afterRender", function() {
            this.chart === c4.chart && this.chart.renderer && C3(() => {
              c4.proxyProvider.updateGroupProxyElementPositions("navigator"), c4.updateHandleValues();
            }, j3(f2(this.chart.renderer.globalAnimation, true)).duration);
          });
        }
        onChartUpdate() {
          var h2, c4, T2;
          let I3 = this.chart, G2 = I3.options, L2 = G2.navigator;
          if (L2.enabled && (h2 = L2.accessibility) != null && h2.enabled) {
            let l4 = G2.accessibility.landmarkVerbosity, y2 = (c4 = G2.lang.accessibility) == null ? void 0 : c4.navigator.groupLabel;
            this.proxyProvider.removeGroup("navigator"), this.proxyProvider.addGroup("navigator", "div", { role: l4 === "all" ? "region" : "group", "aria-label": d3(y2, { chart: I3 }, I3) });
            let i5 = (T2 = G2.lang.accessibility) == null ? void 0 : T2.navigator.handleLabel;
            [0, 1].forEach((t3) => {
              let e5 = this.getHandleByIx(t3);
              if (e5) {
                let n4 = this.proxyProvider.addProxyElement("navigator", { click: e5 }, "input", { type: "range", "aria-label": d3(i5, { handleIx: t3, chart: I3 }, I3) });
                this[t3 ? "maxHandleProxy" : "minHandleProxy"] = n4.innerElement, n4.innerElement.style.pointerEvents = "none", n4.innerElement.oninput = () => this.updateNavigator();
              }
            }), this.updateHandleValues();
          } else this.proxyProvider.removeGroup("navigator");
        }
        getNavigatorHandleNavigation(h2) {
          let c4 = this, T2 = this.chart, I3 = h2 ? this.maxHandleProxy : this.minHandleProxy, G2 = this.keyCodes;
          return new q2(T2, { keyCodeMap: [[[G2.left, G2.right, G2.up, G2.down], function(L2) {
            if (I3) {
              let l4 = L2 === G2.left || L2 === G2.up ? -1 : 1;
              I3.value = "" + x2(parseFloat(I3.value) + l4, 0, 100), c4.updateNavigator(() => {
                let y2 = c4.getHandleByIx(h2);
                y2 && T2.setFocusToElement(y2, I3);
              });
            }
            return this.response.success;
          }]], init: () => {
            T2.setFocusToElement(this.getHandleByIx(h2), I3);
          }, validate: () => {
            var L2;
            return !!(this.getHandleByIx(h2) && I3 && (L2 = T2.options.navigator.accessibility) != null && L2.enabled);
          } });
        }
        getKeyboardNavigation() {
          return [this.getNavigatorHandleNavigation(0), this.getNavigatorHandleNavigation(1)];
        }
        destroy() {
          this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.proxyProvider.removeGroup("navigator"), this.announcer && this.announcer.destroy();
        }
        updateHandleValues() {
          let h2 = this.chart.navigator;
          if (h2 && this.minHandleProxy && this.maxHandleProxy) {
            let c4 = h2.size;
            this.minHandleProxy.value = "" + Math.round(h2.zoomedMin / c4 * 100), this.maxHandleProxy.value = "" + Math.round(h2.zoomedMax / c4 * 100);
          }
        }
        getHandleByIx(h2) {
          let c4 = this.chart.navigator;
          return c4 && c4.handles && c4.handles[h2];
        }
        updateNavigator(h2) {
          this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.updateNavigatorThrottleTimer = setTimeout(((c4) => {
            var T2;
            let I3 = this.chart, { navigator: G2, pointer: L2 } = I3;
            if (G2 && L2 && this.minHandleProxy && this.maxHandleProxy) {
              let l4 = L2.getChartPosition(), y2 = parseFloat(this.minHandleProxy.value) / 100 * G2.size, i5 = parseFloat(this.maxHandleProxy.value) / 100 * G2.size;
              [[0, "mousedown", G2.zoomedMin], [0, "mousemove", y2], [0, "mouseup", y2], [1, "mousedown", G2.zoomedMax], [1, "mousemove", i5], [1, "mouseup", i5]].forEach(([n4, u2, a2]) => {
                var g2;
                let r3 = (g2 = this.getHandleByIx(n4)) == null ? void 0 : g2.element;
                r3 && b5(r3, o2(u2, { x: l4.left + G2.left + a2, y: l4.top + G2.top }, r3));
              }), c4 && c4();
              let t3 = (T2 = I3.options.lang.accessibility) == null ? void 0 : T2.navigator.changeAnnouncement, e5 = p2(I3.xAxis[0]);
              this.announcer.announce(d3(t3, { axisRangeDescription: e5, chart: I3 }, I3));
            }
          }).bind(this, h2), 20);
        }
      };
    }), at2(s2, "Accessibility/Components/SeriesComponent/SeriesDescriber.js", [s2["Accessibility/Components/AnnotationsA11y.js"], s2["Accessibility/Utils/ChartUtilities.js"], s2["Core/Templating.js"], s2["Accessibility/Utils/HTMLUtilities.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2) {
      let { getPointAnnotationTexts: tt2 } = B3, { getAxisDescription: Z2, getSeriesFirstPointElement: X2, getSeriesA11yElement: O3, unhideChartElementFromAT: j3 } = K2, { format: d3, numberFormat: x2 } = q2, { reverseChildNodes: f2, stripHTMLTagsFromString: C3 } = it2, { find: o2, isNumber: p2, isString: b5, pick: h2, defined: c4 } = rt2;
      function T2(y2) {
        let i5 = y2.chart.options.accessibility.series.pointDescriptionEnabledThreshold;
        return !!(i5 !== false && y2.points && y2.points.length >= +i5);
      }
      function I3(y2, i5) {
        let t3 = y2.series, e5 = t3.chart, n4 = e5.options.accessibility.point || {}, u2 = t3.options.accessibility && t3.options.accessibility.point || {}, a2 = t3.tooltipOptions || {}, g2 = e5.options.lang;
        return p2(i5) ? x2(i5, u2.valueDecimals || n4.valueDecimals || a2.valueDecimals || -1, g2.decimalPoint, g2.accessibility.thousandsSep || g2.thousandsSep) : i5;
      }
      function G2(y2, i5) {
        let t3 = y2[i5];
        return y2.chart.langFormat("accessibility.series." + i5 + "Description", { name: Z2(t3), series: y2 });
      }
      function L2(y2) {
        let i5 = y2.series, t3 = i5.chart.series.length > 1 || i5.options.name, e5 = function(g2) {
          let r3 = g2.series, A3 = r3.chart, N2 = r3.options.accessibility, k3 = N2 && N2.point && N2.point.valueDescriptionFormat || A3.options.accessibility.point.valueDescriptionFormat, E2 = h2(r3.xAxis && r3.xAxis.options.accessibility && r3.xAxis.options.accessibility.enabled, !A3.angular && r3.type !== "flowmap"), R2 = E2 ? function(z2) {
            let Q2 = function(U2) {
              let w2 = U2.series, M2 = w2.chart, D2 = w2.options.accessibility && w2.options.accessibility.point || {}, F2 = M2.options.accessibility.point || {}, $2 = w2.xAxis && w2.xAxis.dateTime;
              if ($2) {
                let W2 = $2.getXDateFormat(U2.x || 0, M2.options.tooltip.dateTimeLabelFormats), V2 = D2.dateFormatter && D2.dateFormatter(U2) || F2.dateFormatter && F2.dateFormatter(U2) || D2.dateFormat || F2.dateFormat || W2;
                return M2.time.dateFormat(V2, U2.x || 0, void 0);
              }
            }(z2), v3 = (z2.series.xAxis || {}).categories && c4(z2.category) && ("" + z2.category).replace("<br/>", " "), S2 = c4(z2.id) && 0 > ("" + z2.id).indexOf("highcharts-"), P2 = "x, " + z2.x;
            return z2.name || Q2 || v3 || (S2 ? z2.id : P2);
          }(g2) : "";
          return d3(k3, { point: g2, index: c4(g2.index) ? g2.index + 1 : "", xDescription: R2, value: function(z2) {
            let Q2 = z2.series, v3 = Q2.chart.options.accessibility.point || {}, S2 = Q2.chart.options.accessibility && Q2.chart.options.accessibility.point || {}, P2 = Q2.tooltipOptions || {}, U2 = S2.valuePrefix || v3.valuePrefix || P2.valuePrefix || "", w2 = S2.valueSuffix || v3.valueSuffix || P2.valueSuffix || "", M2 = z2.value !== void 0 ? "value" : "y", D2 = I3(z2, z2[M2]);
            return z2.isNull ? Q2.chart.langFormat("accessibility.series.nullPointValue", { point: z2 }) : Q2.pointArrayMap ? function(F2, $2, W2) {
              let V2 = $2 || "", _2 = W2 || "", et2 = function(lt2) {
                let ht2 = I3(F2, h2(F2[lt2], F2.options[lt2]));
                return ht2 !== void 0 ? lt2 + ": " + V2 + ht2 + _2 : ht2;
              };
              return F2.series.pointArrayMap.reduce(function(lt2, ht2) {
                let J2 = et2(ht2);
                return J2 ? lt2 + (lt2.length ? ", " : "") + J2 : lt2;
              }, "");
            }(z2, U2, w2) : U2 + D2 + w2;
          }(g2), separator: E2 ? ", " : "" }, A3);
        }(y2), n4 = y2.options && y2.options.accessibility && y2.options.accessibility.description, u2 = t3 ? " " + i5.name + "." : "", a2 = function(g2) {
          let r3 = g2.series.chart, A3 = tt2(g2);
          return A3.length ? r3.langFormat("accessibility.series.pointAnnotationsDescription", { point: g2, annotations: A3 }) : "";
        }(y2);
        return y2.accessibility = y2.accessibility || {}, y2.accessibility.valueDescription = e5, e5 + (n4 ? " " + n4 : "") + u2 + (a2 ? " " + a2 : "");
      }
      function l4(y2) {
        let i5 = y2.chart, t3 = i5.types || [], e5 = function(E2) {
          let R2 = (E2.options.accessibility || {}).description;
          return R2 && E2.chart.langFormat("accessibility.series.description", { description: R2, series: E2 }) || "";
        }(y2), n4 = function(E2) {
          return i5[E2] && i5[E2].length > 1 && y2[E2];
        }, u2 = y2.index + 1, a2 = G2(y2, "xAxis"), g2 = G2(y2, "yAxis"), r3 = { seriesNumber: u2, series: y2, chart: i5 }, A3 = t3.length > 1 ? "Combination" : "", N2 = i5.langFormat("accessibility.series.summary." + y2.type + A3, r3) || i5.langFormat("accessibility.series.summary.default" + A3, r3), k3 = (n4("yAxis") ? " " + g2 + "." : "") + (n4("xAxis") ? " " + a2 + "." : "");
        return d3(h2(y2.options.accessibility && y2.options.accessibility.descriptionFormat, i5.options.accessibility.series.descriptionFormat, ""), { seriesDescription: N2, authorDescription: e5 ? " " + e5 : "", axisDescription: k3, series: y2, chart: i5, seriesNumber: u2 }, void 0);
      }
      return { defaultPointDescriptionFormatter: L2, defaultSeriesDescriptionFormatter: l4, describeSeries: function(y2) {
        let i5 = y2.chart, t3 = X2(y2), e5 = O3(y2), n4 = i5.is3d && i5.is3d();
        e5 && (e5.lastChild !== t3 || n4 || f2(e5), function(u2) {
          let a2 = function(A3) {
            let N2 = A3.options.accessibility || {};
            return !T2(A3) && !N2.exposeAsGroupOnly;
          }(u2), g2 = function(A3) {
            let N2 = A3.chart.options.accessibility.keyboardNavigation.seriesNavigation;
            return !!(A3.points && (A3.points.length < +N2.pointNavigationEnabledThreshold || N2.pointNavigationEnabledThreshold === false));
          }(u2), r3 = u2.chart.options.accessibility.point.describeNull;
          (a2 || g2) && u2.points.forEach((A3) => {
            let N2 = A3.graphic && A3.graphic.element || function(E2) {
              let R2 = E2.series, z2 = R2 && R2.chart, Q2 = R2 && R2.is("sunburst"), v3 = E2.isNull, S2 = z2 && z2.options.accessibility.point.describeNull;
              return v3 && !Q2 && S2;
            }(A3) && function(E2) {
              let R2 = E2.series, z2 = function(U2) {
                let w2 = U2.index;
                return U2.series && U2.series.data && c4(w2) && o2(U2.series.data, function(M2) {
                  return !!(M2 && M2.index !== void 0 && M2.index > w2 && M2.graphic && M2.graphic.element);
                }) || null;
              }(E2), Q2 = z2 && z2.graphic, v3 = Q2 ? Q2.parentGroup : R2.graph || R2.group, S2 = z2 ? { x: h2(E2.plotX, z2.plotX, 0), y: h2(E2.plotY, z2.plotY, 0) } : { x: h2(E2.plotX, 0), y: h2(E2.plotY, 0) }, P2 = function(U2, w2) {
                let M2 = U2.series.chart.renderer.rect(w2.x, w2.y, 1, 1);
                return M2.attr({ class: "highcharts-a11y-mock-point", fill: "none", opacity: 0, "fill-opacity": 0, "stroke-opacity": 0 }), M2;
              }(E2, S2);
              if (v3 && v3.element) return E2.graphic = P2, E2.hasMockGraphic = true, P2.add(v3), v3.element.insertBefore(P2.element, Q2 ? Q2.element : null), P2.element;
            }(A3), k3 = A3.options && A3.options.accessibility && A3.options.accessibility.enabled === false;
            if (N2) {
              if (A3.isNull && !r3) {
                N2.setAttribute("aria-hidden", true);
                return;
              }
              N2.setAttribute("tabindex", "-1"), u2.chart.styledMode || (N2.style.outline = "none"), a2 && !k3 ? function(E2, R2) {
                var z2, Q2, v3;
                let S2 = E2.series, P2 = ((z2 = S2.options.accessibility) == null ? void 0 : z2.point) || {}, U2 = S2.chart.options.accessibility.point || {}, w2 = C3(b5(P2.descriptionFormat) && d3(P2.descriptionFormat, E2, S2.chart) || ((Q2 = P2.descriptionFormatter) == null ? void 0 : Q2.call(P2, E2)) || b5(U2.descriptionFormat) && d3(U2.descriptionFormat, E2, S2.chart) || ((v3 = U2.descriptionFormatter) == null ? void 0 : v3.call(U2, E2)) || L2(E2), S2.chart.renderer.forExport);
                R2.setAttribute("role", "img"), R2.setAttribute("aria-label", w2);
              }(A3, N2) : N2.setAttribute("aria-hidden", true);
            }
          });
        }(y2), j3(i5, e5), function(u2) {
          let a2 = u2.chart, g2 = a2.options.chart, r3 = g2.options3d && g2.options3d.enabled, A3 = a2.series.length > 1, N2 = a2.options.accessibility.series.describeSingleSeries, k3 = (u2.options.accessibility || {}).exposeAsGroupOnly;
          return !(r3 && A3) && (A3 || N2 || k3 || T2(u2));
        }(y2) ? function(u2, a2) {
          let g2 = u2.options.accessibility || {}, r3 = u2.chart.options.accessibility, A3 = r3.landmarkVerbosity;
          g2.exposeAsGroupOnly ? a2.setAttribute("role", "img") : A3 === "all" ? a2.setAttribute("role", "region") : a2.setAttribute("role", "group"), a2.setAttribute("tabindex", "-1"), u2.chart.styledMode || (a2.style.outline = "none"), a2.setAttribute("aria-label", C3(r3.series.descriptionFormatter && r3.series.descriptionFormatter(u2) || l4(u2), u2.chart.renderer.forExport));
        }(y2, e5) : e5.removeAttribute("aria-label"));
      } };
    }), at2(s2, "Accessibility/Components/SeriesComponent/NewDataAnnouncer.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"], s2["Accessibility/Utils/Announcer.js"], s2["Accessibility/Utils/ChartUtilities.js"], s2["Accessibility/Utils/EventProvider.js"], s2["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(B3, K2, q2, it2, rt2, tt2) {
      let { composed: Z2 } = B3, { addEvent: X2, defined: O3, pushUnique: j3 } = K2, { getChartTitle: d3 } = it2, { defaultPointDescriptionFormatter: x2, defaultSeriesDescriptionFormatter: f2 } = tt2;
      function C3(p2) {
        return !!p2.options.accessibility.announceNewData.enabled;
      }
      class o2 {
        constructor(b5) {
          this.dirty = { allSeries: {} }, this.lastAnnouncementTime = 0, this.chart = b5;
        }
        init() {
          let b5 = this.chart, h2 = b5.options.accessibility.announceNewData.interruptUser ? "assertive" : "polite";
          this.lastAnnouncementTime = 0, this.dirty = { allSeries: {} }, this.eventProvider = new rt2(), this.announcer = new q2(b5, h2), this.addEventListeners();
        }
        destroy() {
          this.eventProvider.removeAddedEvents(), this.announcer.destroy();
        }
        addEventListeners() {
          let b5 = this, h2 = this.chart, c4 = this.eventProvider;
          c4.addEvent(h2, "afterApplyDrilldown", function() {
            b5.lastAnnouncementTime = 0;
          }), c4.addEvent(h2, "afterAddSeries", function(T2) {
            b5.onSeriesAdded(T2.series);
          }), c4.addEvent(h2, "redraw", function() {
            b5.announceDirtyData();
          });
        }
        onSeriesAdded(b5) {
          C3(this.chart) && (this.dirty.hasDirty = true, this.dirty.allSeries[b5.name + b5.index] = b5, this.dirty.newSeries = O3(this.dirty.newSeries) ? void 0 : b5);
        }
        announceDirtyData() {
          let b5 = this.chart, h2 = this;
          if (b5.options.accessibility.announceNewData && this.dirty.hasDirty) {
            let c4 = this.dirty.newPoint;
            c4 && (c4 = function(T2) {
              let I3 = T2.series.data.filter((G2) => T2.x === G2.x && T2.y === G2.y);
              return I3.length === 1 ? I3[0] : T2;
            }(c4)), this.queueAnnouncement(Object.keys(this.dirty.allSeries).map((T2) => h2.dirty.allSeries[T2]), this.dirty.newSeries, c4), this.dirty = { allSeries: {} };
          }
        }
        queueAnnouncement(b5, h2, c4) {
          let T2 = this.chart.options.accessibility.announceNewData;
          if (T2.enabled) {
            let I3 = +/* @__PURE__ */ new Date(), G2 = I3 - this.lastAnnouncementTime, L2 = Math.max(0, T2.minAnnounceInterval - G2), l4 = function(i5, t3) {
              let e5 = (i5 || []).concat(t3 || []).reduce((n4, u2) => (n4[u2.name + u2.index] = u2, n4), {});
              return Object.keys(e5).map((n4) => e5[n4]);
            }(this.queuedAnnouncement && this.queuedAnnouncement.series, b5), y2 = this.buildAnnouncementMessage(l4, h2, c4);
            y2 && (this.queuedAnnouncement && clearTimeout(this.queuedAnnouncementTimer), this.queuedAnnouncement = { time: I3, message: y2, series: l4 }, this.queuedAnnouncementTimer = setTimeout(() => {
              this && this.announcer && (this.lastAnnouncementTime = +/* @__PURE__ */ new Date(), this.announcer.announce(this.queuedAnnouncement.message), delete this.queuedAnnouncement, delete this.queuedAnnouncementTimer);
            }, L2));
          }
        }
        buildAnnouncementMessage(b5, h2, c4) {
          let T2 = this.chart, I3 = T2.options.accessibility.announceNewData;
          if (I3.announcementFormatter) {
            let y2 = I3.announcementFormatter(b5, h2, c4);
            if (y2 !== false) return y2.length ? y2 : null;
          }
          let G2 = B3.charts && B3.charts.length > 1 ? "Multiple" : "Single", L2 = h2 ? "newSeriesAnnounce" + G2 : c4 ? "newPointAnnounce" + G2 : "newDataAnnounce", l4 = d3(T2);
          return T2.langFormat("accessibility.announceNewData." + L2, { chartTitle: l4, seriesDesc: h2 ? f2(h2) : null, pointDesc: c4 ? x2(c4) : null, point: c4, series: h2 });
        }
      }
      return function(p2) {
        function b5(c4) {
          var T2;
          let I3 = this.chart, G2 = (T2 = I3.accessibility) == null ? void 0 : T2.components.series.newDataAnnouncer;
          G2 && G2.chart === I3 && C3(I3) && (G2.dirty.newPoint = O3(G2.dirty.newPoint) ? void 0 : c4.point);
        }
        function h2() {
          var c4;
          let T2 = this.chart, I3 = (c4 = T2.accessibility) == null ? void 0 : c4.components.series.newDataAnnouncer;
          I3 && I3.chart === T2 && C3(T2) && (I3.dirty.hasDirty = true, I3.dirty.allSeries[this.name + this.index] = this);
        }
        p2.compose = function(c4) {
          j3(Z2, "A11y.NDA") && (X2(c4, "addPoint", b5), X2(c4, "updatedData", h2));
        };
      }(o2), o2;
    }), at2(s2, "Accessibility/ProxyElement.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"], s2["Accessibility/Utils/EventProvider.js"], s2["Accessibility/Utils/ChartUtilities.js"], s2["Accessibility/Utils/HTMLUtilities.js"]], function(B3, K2, q2, it2, rt2) {
      let { doc: tt2 } = B3, { attr: Z2, css: X2, merge: O3 } = K2, { fireEventOnWrappedOrUnwrappedElement: j3 } = it2, { cloneMouseEvent: d3, cloneTouchEvent: x2, getFakeMouseEvent: f2, removeElement: C3 } = rt2;
      return class {
        constructor(o2, p2, b5 = "button", h2, c4) {
          this.chart = o2, this.target = p2, this.eventProvider = new q2();
          let T2 = this.innerElement = tt2.createElement(b5), I3 = this.element = h2 ? tt2.createElement(h2) : T2;
          o2.styledMode || this.hideElementVisually(T2), h2 && (h2 !== "li" || o2.styledMode || (I3.style.listStyle = "none"), I3.appendChild(T2), this.element = I3), this.updateTarget(p2, c4);
        }
        click() {
          let o2 = this.getTargetPosition();
          o2.x += o2.width / 2, o2.y += o2.height / 2;
          let p2 = f2("click", o2);
          j3(this.target.click, p2);
        }
        updateTarget(o2, p2) {
          this.target = o2, this.updateCSSClassName();
          let b5 = p2 || {};
          Object.keys(b5).forEach((c4) => {
            b5[c4] === null && delete b5[c4];
          });
          let h2 = this.getTargetAttr(o2.click, "aria-label");
          Z2(this.innerElement, O3(h2 ? { "aria-label": h2 } : {}, b5)), this.eventProvider.removeAddedEvents(), this.addProxyEventsToElement(this.innerElement, o2.click), this.refreshPosition();
        }
        refreshPosition() {
          let o2 = this.getTargetPosition();
          X2(this.innerElement, { width: (o2.width || 1) + "px", height: (o2.height || 1) + "px", left: (Math.round(o2.x) || 0) + "px", top: (Math.round(o2.y) || 0) + "px" });
        }
        remove() {
          this.eventProvider.removeAddedEvents(), C3(this.element);
        }
        updateCSSClassName() {
          let o2 = (T2) => T2.indexOf("highcharts-no-tooltip") > -1, p2 = this.chart.legend, b5 = p2.group && p2.group.div, h2 = o2(b5 && b5.className || ""), c4 = o2(this.getTargetAttr(this.target.click, "class") || "");
          this.innerElement.className = h2 || c4 ? "highcharts-a11y-proxy-element highcharts-no-tooltip" : "highcharts-a11y-proxy-element";
        }
        addProxyEventsToElement(o2, p2) {
          ["click", "touchstart", "touchend", "touchcancel", "touchmove", "mouseover", "mouseenter", "mouseleave", "mouseout"].forEach((b5) => {
            let h2 = b5.indexOf("touch") === 0;
            this.eventProvider.addEvent(o2, b5, (c4) => {
              let T2 = h2 ? x2(c4) : d3(c4);
              p2 && j3(p2, T2), c4.stopPropagation(), h2 || c4.preventDefault();
            }, { passive: false });
          });
        }
        hideElementVisually(o2) {
          X2(o2, { borderWidth: 0, backgroundColor: "transparent", cursor: "pointer", outline: "none", opacity: 1e-3, filter: "alpha(opacity=1)", zIndex: 999, overflow: "hidden", padding: 0, margin: 0, display: "block", position: "absolute", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)" });
        }
        getTargetPosition() {
          let o2 = this.target.click, p2 = o2.element ? o2.element : o2, b5 = this.target.visual || p2, h2 = this.chart.renderTo, c4 = this.chart.pointer;
          if (h2 && b5 != null && b5.getBoundingClientRect && c4) {
            let T2 = b5.getBoundingClientRect(), I3 = c4.getChartPosition();
            return { x: (T2.left - I3.left) / I3.scaleX, y: (T2.top - I3.top) / I3.scaleY, width: T2.right / I3.scaleX - T2.left / I3.scaleX, height: T2.bottom / I3.scaleY - T2.top / I3.scaleY };
          }
          return { x: 0, y: 0, width: 1, height: 1 };
        }
        getTargetAttr(o2, p2) {
          return o2.element ? o2.element.getAttribute(p2) : o2.getAttribute(p2);
        }
      };
    }), at2(s2, "Accessibility/ProxyProvider.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"], s2["Accessibility/Utils/ChartUtilities.js"], s2["Accessibility/Utils/DOMElementProvider.js"], s2["Accessibility/Utils/HTMLUtilities.js"], s2["Accessibility/ProxyElement.js"]], function(B3, K2, q2, it2, rt2, tt2) {
      let { doc: Z2 } = B3, { attr: X2, css: O3 } = K2, { unhideChartElementFromAT: j3 } = q2, { removeChildNodes: d3 } = rt2;
      return class {
        constructor(x2) {
          this.chart = x2, this.domElementProvider = new it2(), this.groups = {}, this.groupOrder = [], this.beforeChartProxyPosContainer = this.createProxyPosContainer("before"), this.afterChartProxyPosContainer = this.createProxyPosContainer("after"), this.update();
        }
        addProxyElement(x2, f2, C3 = "button", o2) {
          let p2 = this.groups[x2];
          if (!p2) throw Error("ProxyProvider.addProxyElement: Invalid group key " + x2);
          let b5 = p2.type === "ul" || p2.type === "ol" ? "li" : void 0, h2 = new tt2(this.chart, f2, C3, b5, o2);
          return p2.proxyContainerElement.appendChild(h2.element), p2.proxyElements.push(h2), h2;
        }
        addGroup(x2, f2 = "div", C3) {
          let o2, p2 = this.groups[x2];
          if (p2) return p2.groupElement;
          let b5 = this.domElementProvider.createElement(f2);
          return C3 && C3.role && f2 !== "div" ? (o2 = this.domElementProvider.createElement("div")).appendChild(b5) : o2 = b5, o2.className = "highcharts-a11y-proxy-group highcharts-a11y-proxy-group-" + x2.replace(/\W/g, "-"), this.groups[x2] = { proxyContainerElement: b5, groupElement: o2, type: f2, proxyElements: [] }, X2(o2, C3 || {}), f2 === "ul" && b5.setAttribute("role", "list"), this.afterChartProxyPosContainer.appendChild(o2), this.updateGroupOrder(this.groupOrder), o2;
        }
        updateGroupAttrs(x2, f2) {
          let C3 = this.groups[x2];
          if (!C3) throw Error("ProxyProvider.updateGroupAttrs: Invalid group key " + x2);
          X2(C3.groupElement, f2);
        }
        updateGroupOrder(x2) {
          if (this.groupOrder = x2.slice(), this.isDOMOrderGroupOrder()) return;
          let f2 = x2.indexOf("series"), C3 = f2 > -1 ? x2.slice(0, f2) : x2, o2 = f2 > -1 ? x2.slice(f2 + 1) : [], p2 = Z2.activeElement;
          ["before", "after"].forEach((b5) => {
            let h2 = this[b5 === "before" ? "beforeChartProxyPosContainer" : "afterChartProxyPosContainer"];
            d3(h2), (b5 === "before" ? C3 : o2).forEach((c4) => {
              let T2 = this.groups[c4];
              T2 && h2.appendChild(T2.groupElement);
            });
          }), (this.beforeChartProxyPosContainer.contains(p2) || this.afterChartProxyPosContainer.contains(p2)) && p2 && p2.focus && p2.focus();
        }
        clearGroup(x2) {
          let f2 = this.groups[x2];
          if (!f2) throw Error("ProxyProvider.clearGroup: Invalid group key " + x2);
          d3(f2.proxyContainerElement);
        }
        removeGroup(x2) {
          let f2 = this.groups[x2];
          f2 && (this.domElementProvider.removeElement(f2.groupElement), f2.groupElement !== f2.proxyContainerElement && this.domElementProvider.removeElement(f2.proxyContainerElement), delete this.groups[x2]);
        }
        update() {
          this.updatePosContainerPositions(), this.updateGroupOrder(this.groupOrder), this.updateProxyElementPositions();
        }
        updateProxyElementPositions() {
          Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this));
        }
        updateGroupProxyElementPositions(x2) {
          let f2 = this.groups[x2];
          f2 && f2.proxyElements.forEach((C3) => C3.refreshPosition());
        }
        destroy() {
          this.domElementProvider.destroyCreatedElements();
        }
        createProxyPosContainer(x2) {
          let f2 = this.domElementProvider.createElement("div");
          return f2.setAttribute("aria-hidden", "false"), f2.className = "highcharts-a11y-proxy-container" + (x2 ? "-" + x2 : ""), O3(f2, { top: "0", left: "0" }), this.chart.styledMode || (f2.style.whiteSpace = "nowrap", f2.style.position = "absolute"), f2;
        }
        getCurrentGroupOrderInDOM() {
          let x2 = (p2) => {
            let b5 = Object.keys(this.groups), h2 = b5.length;
            for (; h2--; ) {
              let c4 = b5[h2], T2 = this.groups[c4];
              if (T2 && p2 === T2.groupElement) return c4;
            }
          }, f2 = (p2) => {
            let b5 = [], h2 = p2.children;
            for (let c4 = 0; c4 < h2.length; ++c4) {
              let T2 = x2(h2[c4]);
              T2 && b5.push(T2);
            }
            return b5;
          }, C3 = f2(this.beforeChartProxyPosContainer), o2 = f2(this.afterChartProxyPosContainer);
          return C3.push("series"), C3.concat(o2);
        }
        isDOMOrderGroupOrder() {
          let x2 = this.getCurrentGroupOrderInDOM(), f2 = this.groupOrder.filter((o2) => o2 === "series" || !!this.groups[o2]), C3 = x2.length;
          if (C3 !== f2.length) return false;
          for (; C3--; ) if (x2[C3] !== f2[C3]) return false;
          return true;
        }
        updatePosContainerPositions() {
          let x2 = this.chart;
          if (x2.renderer.forExport) return;
          let f2 = x2.renderer.box;
          x2.container.insertBefore(this.afterChartProxyPosContainer, f2.nextSibling), x2.container.insertBefore(this.beforeChartProxyPosContainer, f2), j3(this.chart, this.afterChartProxyPosContainer), j3(this.chart, this.beforeChartProxyPosContainer);
        }
      };
    }), at2(s2, "Accessibility/Components/RangeSelectorComponent.js", [s2["Accessibility/AccessibilityComponent.js"], s2["Accessibility/Utils/Announcer.js"], s2["Accessibility/Utils/ChartUtilities.js"], s2["Accessibility/KeyboardNavigationHandler.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2) {
      let { unhideChartElementFromAT: tt2, getAxisRangeDescription: Z2 } = q2, { addEvent: X2, attr: O3 } = rt2;
      class j3 extends B3 {
        init() {
          let x2 = this.chart;
          this.announcer = new K2(x2, "polite");
        }
        onChartUpdate() {
          let x2 = this.chart, f2 = this, C3 = x2.rangeSelector;
          C3 && (this.updateSelectorVisibility(), this.setDropdownAttrs(), C3.buttons && C3.buttons.length && C3.buttons.forEach((o2) => {
            f2.setRangeButtonAttrs(o2);
          }), C3.maxInput && C3.minInput && ["minInput", "maxInput"].forEach(function(o2, p2) {
            let b5 = C3[o2];
            b5 && (tt2(x2, b5), f2.setRangeInputAttrs(b5, "accessibility.rangeSelector." + (p2 ? "max" : "min") + "InputLabel"));
          }));
        }
        updateSelectorVisibility() {
          let x2 = this.chart, f2 = x2.rangeSelector, C3 = f2 && f2.dropdown, o2 = f2 && f2.buttons || [], p2 = (b5) => b5.setAttribute("aria-hidden", true);
          f2 && f2.hasVisibleDropdown && C3 ? (tt2(x2, C3), o2.forEach((b5) => p2(b5.element))) : (C3 && p2(C3), o2.forEach((b5) => tt2(x2, b5.element)));
        }
        setDropdownAttrs() {
          let x2 = this.chart, f2 = x2.rangeSelector && x2.rangeSelector.dropdown;
          if (f2) {
            let C3 = x2.langFormat("accessibility.rangeSelector.dropdownLabel", { rangeTitle: x2.options.lang.rangeSelectorZoom });
            f2.setAttribute("aria-label", C3), f2.setAttribute("tabindex", -1);
          }
        }
        setRangeButtonAttrs(x2) {
          O3(x2.element, { tabindex: -1, role: "button" });
        }
        setRangeInputAttrs(x2, f2) {
          let C3 = this.chart;
          O3(x2, { tabindex: -1, "aria-label": C3.langFormat(f2, { chart: C3 }) });
        }
        onButtonNavKbdArrowKey(x2, f2) {
          let C3 = x2.response, o2 = this.keyCodes, p2 = this.chart, b5 = p2.options.accessibility.keyboardNavigation.wrapAround, h2 = f2 === o2.left || f2 === o2.up ? -1 : 1;
          return p2.highlightRangeSelectorButton(p2.highlightedRangeSelectorItemIx + h2) ? C3.success : b5 ? (x2.init(h2), C3.success) : C3[h2 > 0 ? "next" : "prev"];
        }
        onButtonNavKbdClick(x2) {
          let f2 = x2.response, C3 = this.chart;
          return C3.oldRangeSelectorItemState !== 3 && this.fakeClickEvent(C3.rangeSelector.buttons[C3.highlightedRangeSelectorItemIx].element), f2.success;
        }
        onAfterBtnClick() {
          let x2 = this.chart, f2 = Z2(x2.xAxis[0]), C3 = x2.langFormat("accessibility.rangeSelector.clickButtonAnnouncement", { chart: x2, axisRangeDescription: f2 });
          C3 && this.announcer.announce(C3);
        }
        onInputKbdMove(x2) {
          let f2 = this.chart, C3 = f2.rangeSelector, o2 = f2.highlightedInputRangeIx = (f2.highlightedInputRangeIx || 0) + x2;
          if (o2 > 1 || o2 < 0) {
            if (f2.accessibility) return f2.accessibility.keyboardNavigation.exiting = true, f2.accessibility.keyboardNavigation.tabindexContainer.focus(), f2.accessibility.keyboardNavigation.move(x2);
          } else if (C3) {
            let p2 = C3[o2 ? "maxDateBox" : "minDateBox"], b5 = C3[o2 ? "maxInput" : "minInput"];
            p2 && b5 && f2.setFocusToElement(p2, b5);
          }
          return true;
        }
        onInputNavInit(x2) {
          let f2 = this, C3 = this.chart, o2 = x2 > 0 ? 0 : 1, p2 = C3.rangeSelector, b5 = p2 && p2[o2 ? "maxDateBox" : "minDateBox"], h2 = p2 && p2.minInput, c4 = p2 && p2.maxInput;
          if (C3.highlightedInputRangeIx = o2, b5 && h2 && c4) {
            C3.setFocusToElement(b5, o2 ? c4 : h2), this.removeInputKeydownHandler && this.removeInputKeydownHandler();
            let T2 = (L2) => {
              (L2.which || L2.keyCode) === this.keyCodes.tab && f2.onInputKbdMove(L2.shiftKey ? -1 : 1) && (L2.preventDefault(), L2.stopPropagation());
            }, I3 = X2(h2, "keydown", T2), G2 = X2(c4, "keydown", T2);
            this.removeInputKeydownHandler = () => {
              I3(), G2();
            };
          }
        }
        onInputNavTerminate() {
          let x2 = this.chart.rangeSelector || {};
          x2.maxInput && x2.hideInput("max"), x2.minInput && x2.hideInput("min"), this.removeInputKeydownHandler && (this.removeInputKeydownHandler(), delete this.removeInputKeydownHandler);
        }
        initDropdownNav() {
          let x2 = this.chart, f2 = x2.rangeSelector, C3 = f2 && f2.dropdown;
          f2 && C3 && (x2.setFocusToElement(f2.buttonGroup, C3), this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeDropdownKeydownHandler = X2(C3, "keydown", (o2) => {
            let p2 = (o2.which || o2.keyCode) === this.keyCodes.tab, b5 = x2.accessibility;
            p2 && (o2.preventDefault(), o2.stopPropagation(), b5 && (b5.keyboardNavigation.tabindexContainer.focus(), b5.keyboardNavigation.move(o2.shiftKey ? -1 : 1)));
          }));
        }
        getRangeSelectorButtonNavigation() {
          let x2 = this.chart, f2 = this.keyCodes, C3 = this;
          return new it2(x2, { keyCodeMap: [[[f2.left, f2.right, f2.up, f2.down], function(o2) {
            return C3.onButtonNavKbdArrowKey(this, o2);
          }], [[f2.enter, f2.space], function() {
            return C3.onButtonNavKbdClick(this);
          }]], validate: function() {
            return !!(x2.rangeSelector && x2.rangeSelector.buttons && x2.rangeSelector.buttons.length);
          }, init: function(o2) {
            let p2 = x2.rangeSelector;
            if (p2 && p2.hasVisibleDropdown) C3.initDropdownNav();
            else if (p2) {
              let b5 = p2.buttons.length - 1;
              x2.highlightRangeSelectorButton(o2 > 0 ? 0 : b5);
            }
          }, terminate: function() {
            C3.removeDropdownKeydownHandler && (C3.removeDropdownKeydownHandler(), delete C3.removeDropdownKeydownHandler);
          } });
        }
        getRangeSelectorInputNavigation() {
          let x2 = this.chart, f2 = this;
          return new it2(x2, { keyCodeMap: [], validate: function() {
            return !!(x2.rangeSelector && x2.rangeSelector.inputGroup && x2.rangeSelector.inputGroup.element.style.visibility !== "hidden" && x2.options.rangeSelector.inputEnabled !== false && x2.rangeSelector.minInput && x2.rangeSelector.maxInput);
          }, init: function(C3) {
            f2.onInputNavInit(C3);
          }, terminate: function() {
            f2.onInputNavTerminate();
          } });
        }
        getKeyboardNavigation() {
          return [this.getRangeSelectorButtonNavigation(), this.getRangeSelectorInputNavigation()];
        }
        destroy() {
          this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), this.announcer && this.announcer.destroy();
        }
      }
      return function(d3) {
        function x2(C3) {
          let o2 = this.rangeSelector && this.rangeSelector.buttons || [], p2 = this.highlightedRangeSelectorItemIx, b5 = this.rangeSelector && this.rangeSelector.selected;
          return p2 !== void 0 && o2[p2] && p2 !== b5 && o2[p2].setState(this.oldRangeSelectorItemState || 0), this.highlightedRangeSelectorItemIx = C3, !!o2[C3] && (this.setFocusToElement(o2[C3].box, o2[C3].element), C3 !== b5 && (this.oldRangeSelectorItemState = o2[C3].state, o2[C3].setState(1)), true);
        }
        function f2() {
          let C3 = this.chart.accessibility;
          if (C3 && C3.components.rangeSelector) return C3.components.rangeSelector.onAfterBtnClick();
        }
        d3.compose = function(C3, o2) {
          let p2 = C3.prototype;
          p2.highlightRangeSelectorButton || (p2.highlightRangeSelectorButton = x2, X2(o2, "afterBtnClick", f2));
        };
      }(j3), j3;
    }), at2(s2, "Accessibility/Components/SeriesComponent/ForcedMarkers.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      var q2;
      let { composed: it2 } = B3, { addEvent: rt2, merge: tt2, pushUnique: Z2 } = K2;
      return function(X2) {
        function O3(p2) {
          tt2(true, p2, { marker: { enabled: true, states: { normal: { opacity: 0 } } } });
        }
        function j3(p2) {
          return p2.marker.states && p2.marker.states.normal && p2.marker.states.normal.opacity;
        }
        function d3(p2) {
          return !!(p2._hasPointMarkers && p2.points && p2.points.length);
        }
        function x2() {
          this.chart.styledMode && (this.markerGroup && this.markerGroup[this.a11yMarkersForced ? "addClass" : "removeClass"]("highcharts-a11y-markers-hidden"), d3(this) && this.points.forEach((p2) => {
            p2.graphic && (p2.graphic[p2.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-hidden"), p2.graphic[p2.hasForcedA11yMarker === false ? "addClass" : "removeClass"]("highcharts-a11y-marker-visible"));
          }));
        }
        function f2(p2) {
          this.resetA11yMarkerOptions = tt2(p2.options.marker || {}, this.userOptions.marker || {});
        }
        function C3() {
          let p2 = this.options;
          (function(b5) {
            let h2 = b5.chart.options.accessibility.enabled, c4 = (b5.options.accessibility && b5.options.accessibility.enabled) !== false;
            return h2 && c4 && function(T2) {
              let I3 = T2.chart.options.accessibility;
              return T2.points.length < I3.series.pointDescriptionEnabledThreshold || I3.series.pointDescriptionEnabledThreshold === false;
            }(b5);
          })(this) ? (p2.marker && p2.marker.enabled === false && (this.a11yMarkersForced = true, O3(this.options)), d3(this) && function(b5) {
            let h2 = b5.points.length;
            for (; h2--; ) {
              let c4 = b5.points[h2], T2 = c4.options, I3 = c4.hasForcedA11yMarker;
              if (delete c4.hasForcedA11yMarker, T2.marker) {
                let G2 = I3 && j3(T2) === 0;
                T2.marker.enabled && !G2 ? (tt2(true, T2.marker, { states: { normal: { opacity: j3(T2) || 1 } } }), c4.hasForcedA11yMarker = false) : T2.marker.enabled === false && (O3(T2), c4.hasForcedA11yMarker = true);
              }
            }
          }(this)) : this.a11yMarkersForced && (delete this.a11yMarkersForced, function(b5) {
            let h2 = b5.resetA11yMarkerOptions;
            if (h2) {
              let c4 = h2.states && h2.states.normal && h2.states.normal.opacity;
              b5.userOptions && b5.userOptions.marker && (b5.userOptions.marker.enabled = true), b5.update({ marker: { enabled: h2.enabled, states: { normal: { opacity: c4 } } } });
            }
          }(this), delete this.resetA11yMarkerOptions);
        }
        function o2() {
          this.boosted && this.a11yMarkersForced && (tt2(true, this.options, { marker: { enabled: false } }), delete this.a11yMarkersForced);
        }
        X2.compose = function(p2) {
          Z2(it2, "A11y.FM") && (rt2(p2, "afterSetOptions", f2), rt2(p2, "render", C3), rt2(p2, "afterRender", x2), rt2(p2, "renderCanvas", o2));
        };
      }(q2 || (q2 = {})), q2;
    }), at2(s2, "Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js", [s2["Core/Series/Point.js"], s2["Core/Series/Series.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Globals.js"], s2["Core/Utilities.js"], s2["Accessibility/KeyboardNavigationHandler.js"], s2["Accessibility/Utils/EventProvider.js"], s2["Accessibility/Utils/ChartUtilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2) {
      let { seriesTypes: O3 } = q2, { doc: j3 } = it2, { defined: d3, fireEvent: x2 } = rt2, { getPointFromXY: f2, getSeriesFromName: C3, scrollAxisToPoint: o2 } = X2;
      function p2(L2) {
        let l4 = L2.index, y2 = L2.series.points, i5 = y2.length;
        if (y2[l4] === L2) return l4;
        for (; i5--; ) if (y2[i5] === L2) return i5;
      }
      function b5(L2) {
        let l4 = L2.chart.options.accessibility.keyboardNavigation.seriesNavigation, y2 = L2.options.accessibility || {}, i5 = y2.keyboardNavigation;
        return i5 && i5.enabled === false || y2.enabled === false || L2.options.enableMouseTracking === false || !L2.visible || l4.pointNavigationEnabledThreshold && +l4.pointNavigationEnabledThreshold <= L2.points.length;
      }
      function h2(L2) {
        let l4 = L2.series.chart.options.accessibility, y2 = L2.options.accessibility && L2.options.accessibility.enabled === false;
        return L2.isNull && l4.keyboardNavigation.seriesNavigation.skipNullPoints || L2.visible === false || L2.isInside === false || y2 || b5(L2.series);
      }
      function c4(L2) {
        let l4 = L2.series || [], y2 = l4.length;
        for (let i5 = 0; i5 < y2; ++i5) if (!b5(l4[i5])) {
          let t3 = function(e5) {
            let n4 = e5.points || [], u2 = n4.length;
            for (let a2 = 0; a2 < u2; ++a2) if (!h2(n4[a2])) return n4[a2];
            return null;
          }(l4[i5]);
          if (t3) return t3;
        }
        return null;
      }
      function T2(L2) {
        let l4 = L2.series.length, y2 = false;
        for (; l4-- && (L2.highlightedPoint = L2.series[l4].points[L2.series[l4].points.length - 1], !(y2 = L2.series[l4].highlightNextValidPoint())); ) ;
        return y2;
      }
      function I3(L2) {
        delete L2.highlightedPoint;
        let l4 = c4(L2);
        return !!l4 && l4.highlight();
      }
      class G2 {
        constructor(l4, y2) {
          this.keyCodes = y2, this.chart = l4;
        }
        init() {
          let l4 = this, y2 = this.chart, i5 = this.eventProvider = new Z2();
          i5.addEvent(K2, "destroy", function() {
            return l4.onSeriesDestroy(this);
          }), i5.addEvent(y2, "afterApplyDrilldown", function() {
            (function(t3) {
              let e5 = c4(t3);
              e5 && e5.highlight(false);
            })(this);
          }), i5.addEvent(y2, "drilldown", function(t3) {
            let e5 = t3.point, n4 = e5.series;
            l4.lastDrilledDownPoint = { x: e5.x, y: e5.y, seriesName: n4 ? n4.name : "" };
          }), i5.addEvent(y2, "drillupall", function() {
            setTimeout(function() {
              l4.onDrillupAll();
            }, 10);
          }), i5.addEvent(B3, "afterSetState", function() {
            let t3 = this.graphic && this.graphic.element, e5 = j3.activeElement, n4 = e5 && e5.getAttribute("class"), u2 = n4 && n4.indexOf("highcharts-a11y-proxy-element") > -1;
            y2.highlightedPoint === this && e5 !== t3 && !u2 && t3 && t3.focus && t3.focus();
          });
        }
        onDrillupAll() {
          let l4, y2 = this.lastDrilledDownPoint, i5 = this.chart, t3 = y2 && C3(i5, y2.seriesName);
          y2 && t3 && d3(y2.x) && d3(y2.y) && (l4 = f2(t3, y2.x, y2.y)), l4 = l4 || c4(i5), i5.container && i5.container.focus(), l4 && l4.highlight && l4.highlight(false);
        }
        getKeyboardNavigationHandler() {
          let l4 = this, y2 = this.keyCodes, i5 = this.chart, t3 = i5.inverted;
          return new tt2(i5, { keyCodeMap: [[t3 ? [y2.up, y2.down] : [y2.left, y2.right], function(e5) {
            return l4.onKbdSideways(this, e5);
          }], [t3 ? [y2.left, y2.right] : [y2.up, y2.down], function(e5) {
            return l4.onKbdVertical(this, e5);
          }], [[y2.enter, y2.space], function(e5, n4) {
            var u2;
            let a2 = i5.highlightedPoint;
            if (a2) {
              let { plotLeft: g2, plotTop: r3 } = this.chart, { plotX: A3 = 0, plotY: N2 = 0 } = a2;
              n4 = { ...n4, chartX: g2 + A3, chartY: r3 + N2, point: a2, target: ((u2 = a2.graphic) == null ? void 0 : u2.element) || n4.target }, x2(a2.series, "click", n4), a2.firePointEvent("click", n4);
            }
            return this.response.success;
          }], [[y2.home], function() {
            return I3(i5), this.response.success;
          }], [[y2.end], function() {
            return T2(i5), this.response.success;
          }], [[y2.pageDown, y2.pageUp], function(e5) {
            return i5.highlightAdjacentSeries(e5 === y2.pageDown), this.response.success;
          }]], init: function() {
            return l4.onHandlerInit(this);
          }, validate: function() {
            return !!c4(i5);
          }, terminate: function() {
            return l4.onHandlerTerminate();
          } });
        }
        onKbdSideways(l4, y2) {
          let i5 = this.keyCodes, t3 = y2 === i5.right || y2 === i5.down;
          return this.attemptHighlightAdjacentPoint(l4, t3);
        }
        onHandlerInit(l4) {
          let y2 = this.chart;
          return y2.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus && y2.highlightedPoint ? y2.highlightedPoint.highlight() : I3(y2), l4.response.success;
        }
        onKbdVertical(l4, y2) {
          let i5 = this.chart, t3 = this.keyCodes, e5 = y2 === t3.down || y2 === t3.right, n4 = i5.options.accessibility.keyboardNavigation.seriesNavigation;
          if (n4.mode && n4.mode === "serialize") return this.attemptHighlightAdjacentPoint(l4, e5);
          let u2 = i5.highlightedPoint && i5.highlightedPoint.series.keyboardMoveVertical ? "highlightAdjacentPointVertical" : "highlightAdjacentSeries";
          return i5[u2](e5), l4.response.success;
        }
        onHandlerTerminate() {
          let l4 = this.chart, y2 = l4.options.accessibility.keyboardNavigation;
          l4.tooltip && l4.tooltip.hide(0);
          let i5 = l4.highlightedPoint && l4.highlightedPoint.series;
          i5 && i5.onMouseOut && i5.onMouseOut(), l4.highlightedPoint && l4.highlightedPoint.onMouseOut && l4.highlightedPoint.onMouseOut(), y2.seriesNavigation.rememberPointFocus || delete l4.highlightedPoint;
        }
        attemptHighlightAdjacentPoint(l4, y2) {
          let i5 = this.chart, t3 = i5.options.accessibility.keyboardNavigation.wrapAround;
          return i5.highlightAdjacentPoint(y2) || t3 && (y2 ? I3(i5) : T2(i5)) ? l4.response.success : l4.response[y2 ? "next" : "prev"];
        }
        onSeriesDestroy(l4) {
          let y2 = this.chart;
          y2.highlightedPoint && y2.highlightedPoint.series === l4 && (delete y2.highlightedPoint, y2.focusElement && y2.focusElement.removeFocusBorder());
        }
        destroy() {
          this.eventProvider.removeAddedEvents();
        }
      }
      return function(L2) {
        function l4(n4) {
          let u2, a2, g2 = this.series, r3 = this.highlightedPoint, A3 = r3 && p2(r3) || 0, N2 = r3 && r3.series.points || [], k3 = this.series && this.series[this.series.length - 1], E2 = k3 && k3.points && k3.points[k3.points.length - 1];
          if (!g2[0] || !g2[0].points) return false;
          if (r3) {
            if (u2 = g2[r3.series.index + (n4 ? 1 : -1)], (a2 = N2[A3 + (n4 ? 1 : -1)]) || !u2 || (a2 = u2.points[n4 ? 0 : u2.points.length - 1]), !a2) return false;
          } else a2 = n4 ? g2[0].points[0] : E2;
          return h2(a2) ? (b5(u2 = a2.series) ? this.highlightedPoint = n4 ? u2.points[u2.points.length - 1] : u2.points[0] : this.highlightedPoint = a2, this.highlightAdjacentPoint(n4)) : a2.highlight();
        }
        function y2(n4) {
          let u2 = this.highlightedPoint, a2 = 1 / 0, g2;
          return !!(d3(u2.plotX) && d3(u2.plotY)) && (this.series.forEach((r3) => {
            b5(r3) || r3.points.forEach((A3) => {
              if (!d3(A3.plotY) || !d3(A3.plotX) || A3 === u2) return;
              let N2 = A3.plotY - u2.plotY, k3 = Math.abs(A3.plotX - u2.plotX), E2 = Math.abs(N2) * Math.abs(N2) + k3 * k3 * 4;
              r3.yAxis && r3.yAxis.reversed && (N2 *= -1), !(N2 <= 0 && n4 || N2 >= 0 && !n4 || E2 < 5 || h2(A3)) && E2 < a2 && (a2 = E2, g2 = A3);
            });
          }), !!g2 && g2.highlight());
        }
        function i5(n4) {
          let u2, a2, g2, r3 = this.highlightedPoint, A3 = this.series && this.series[this.series.length - 1], N2 = A3 && A3.points && A3.points[A3.points.length - 1];
          return this.highlightedPoint ? !!((u2 = this.series[r3.series.index + (n4 ? -1 : 1)]) && (a2 = function(k3, E2, R2, z2) {
            let Q2 = 1 / 0, v3, S2, P2, U2 = E2.points.length, w2 = (M2) => !(d3(M2.plotX) && d3(M2.plotY));
            if (!w2(k3)) {
              for (; U2--; ) !w2(v3 = E2.points[U2]) && (P2 = (k3.plotX - v3.plotX) * (k3.plotX - v3.plotX) * 4 + (k3.plotY - v3.plotY) * (k3.plotY - v3.plotY) * 1) < Q2 && (Q2 = P2, S2 = U2);
              return d3(S2) ? E2.points[S2] : void 0;
            }
          }(r3, u2))) && (b5(u2) ? (a2.highlight(), (g2 = this.highlightAdjacentSeries(n4)) ? g2 : (r3.highlight(), false)) : (a2.highlight(), a2.series.highlightNextValidPoint())) : (u2 = n4 ? this.series && this.series[0] : A3, !!(a2 = n4 ? u2 && u2.points && u2.points[0] : N2) && a2.highlight());
        }
        function t3(n4 = true) {
          var u2, a2;
          let g2 = this.series.chart, r3 = (a2 = (u2 = g2.tooltip) == null ? void 0 : u2.label) == null ? void 0 : a2.element;
          !this.isNull && n4 ? this.onMouseOver() : g2.tooltip && g2.tooltip.hide(0), o2(this), this.graphic && (g2.setFocusToElement(this.graphic), !n4 && g2.focusElement && g2.focusElement.removeFocusBorder()), g2.highlightedPoint = this;
          let A3 = r3 == null ? void 0 : r3.getBoundingClientRect().top;
          if (r3 && A3 && A3 < 0) {
            let N2 = window.scrollY;
            window.scrollTo({ behavior: "smooth", top: N2 + A3 });
          }
          return this;
        }
        function e5() {
          let n4 = this.chart.highlightedPoint, u2 = (n4 && n4.series) === this ? p2(n4) : 0, a2 = this.points, g2 = a2.length;
          if (a2 && g2) {
            for (let r3 = u2; r3 < g2; ++r3) if (!h2(a2[r3])) return a2[r3].highlight();
            for (let r3 = u2; r3 >= 0; --r3) if (!h2(a2[r3])) return a2[r3].highlight();
          }
          return false;
        }
        L2.compose = function(n4, u2, a2) {
          let g2 = n4.prototype, r3 = u2.prototype, A3 = a2.prototype;
          g2.highlightAdjacentPoint || (g2.highlightAdjacentPoint = l4, g2.highlightAdjacentPointVertical = y2, g2.highlightAdjacentSeries = i5, r3.highlight = t3, A3.keyboardMoveVertical = true, ["column", "gantt", "pie"].forEach((N2) => {
            O3[N2] && (O3[N2].prototype.keyboardMoveVertical = false);
          }), A3.highlightNextValidPoint = e5);
        };
      }(G2), G2;
    }), at2(s2, "Accessibility/Components/SeriesComponent/SeriesComponent.js", [s2["Accessibility/AccessibilityComponent.js"], s2["Accessibility/Utils/ChartUtilities.js"], s2["Accessibility/Components/SeriesComponent/ForcedMarkers.js"], s2["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], s2["Accessibility/Components/SeriesComponent/SeriesDescriber.js"], s2["Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js"]], function(B3, K2, q2, it2, rt2, tt2) {
      let { hideSeriesFromAT: Z2 } = K2, { describeSeries: X2 } = rt2;
      return class extends B3 {
        static compose(O3, j3, d3) {
          it2.compose(d3), q2.compose(d3), tt2.compose(O3, j3, d3);
        }
        init() {
          this.newDataAnnouncer = new it2(this.chart), this.newDataAnnouncer.init(), this.keyboardNavigation = new tt2(this.chart, this.keyCodes), this.keyboardNavigation.init(), this.hideTooltipFromATWhenShown(), this.hideSeriesLabelsFromATWhenShown();
        }
        hideTooltipFromATWhenShown() {
          let O3 = this;
          this.chart.tooltip && this.addEvent(this.chart.tooltip.constructor, "refresh", function() {
            this.chart === O3.chart && this.label && this.label.element && this.label.element.setAttribute("aria-hidden", true);
          });
        }
        hideSeriesLabelsFromATWhenShown() {
          this.addEvent(this.chart, "afterDrawSeriesLabels", function() {
            this.series.forEach(function(O3) {
              O3.labelBySeries && O3.labelBySeries.attr("aria-hidden", true);
            });
          });
        }
        onChartRender() {
          this.chart.series.forEach(function(O3) {
            (O3.options.accessibility && O3.options.accessibility.enabled) !== false && O3.visible && O3.getPointsCollection().length !== 0 ? X2(O3) : Z2(O3);
          });
        }
        getKeyboardNavigation() {
          return this.keyboardNavigation.getKeyboardNavigationHandler();
        }
        destroy() {
          this.newDataAnnouncer.destroy(), this.keyboardNavigation.destroy();
        }
      };
    }), at2(s2, "Accessibility/Components/ZoomComponent.js", [s2["Accessibility/AccessibilityComponent.js"], s2["Accessibility/Utils/ChartUtilities.js"], s2["Accessibility/Utils/HTMLUtilities.js"], s2["Accessibility/KeyboardNavigationHandler.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2) {
      let { unhideChartElementFromAT: tt2 } = K2, { getFakeMouseEvent: Z2 } = q2, { attr: X2, pick: O3 } = rt2;
      return class extends B3 {
        constructor() {
          super(...arguments), this.focusedMapNavButtonIx = -1;
        }
        init() {
          let j3 = this, d3 = this.chart;
          this.proxyProvider.addGroup("zoom", "div"), ["afterShowResetZoom", "afterApplyDrilldown", "drillupall"].forEach((x2) => {
            j3.addEvent(d3, x2, function() {
              j3.updateProxyOverlays();
            });
          });
        }
        onChartUpdate() {
          let j3 = this.chart, d3 = this;
          j3.mapNavigation && j3.mapNavigation.navButtons.forEach((x2, f2) => {
            tt2(j3, x2.element), d3.setMapNavButtonAttrs(x2.element, "accessibility.zoom.mapZoom" + (f2 ? "Out" : "In"));
          });
        }
        setMapNavButtonAttrs(j3, d3) {
          let x2 = this.chart;
          X2(j3, { tabindex: -1, role: "button", "aria-label": x2.langFormat(d3, { chart: x2 }) });
        }
        onChartRender() {
          this.updateProxyOverlays();
        }
        updateProxyOverlays() {
          let j3 = this.chart;
          if (this.proxyProvider.clearGroup("zoom"), j3.resetZoomButton && this.createZoomProxyButton(j3.resetZoomButton, "resetZoomProxyButton", j3.langFormat("accessibility.zoom.resetZoomButton", { chart: j3 })), j3.drillUpButton && j3.breadcrumbs && j3.breadcrumbs.list) {
            let d3 = j3.breadcrumbs.list[j3.breadcrumbs.list.length - 1];
            this.createZoomProxyButton(j3.drillUpButton, "drillUpProxyButton", j3.langFormat("accessibility.drillUpButton", { chart: j3, buttonText: j3.breadcrumbs.getButtonText(d3) }));
          }
        }
        createZoomProxyButton(j3, d3, x2) {
          this[d3] = this.proxyProvider.addProxyElement("zoom", { click: j3 }, "button", { "aria-label": x2, tabindex: -1 });
        }
        getMapZoomNavigation() {
          let j3 = this.keyCodes, d3 = this.chart, x2 = this;
          return new it2(d3, { keyCodeMap: [[[j3.up, j3.down, j3.left, j3.right], function(f2) {
            return x2.onMapKbdArrow(this, f2);
          }], [[j3.tab], function(f2, C3) {
            return x2.onMapKbdTab(this, C3);
          }], [[j3.space, j3.enter], function() {
            return x2.onMapKbdClick(this);
          }]], validate: function() {
            return !!(d3.mapView && d3.mapNavigation && d3.mapNavigation.navButtons.length);
          }, init: function(f2) {
            return x2.onMapNavInit(f2);
          } });
        }
        onMapKbdArrow(j3, d3) {
          let x2 = this.chart, f2 = this.keyCodes, C3 = x2.container, o2 = d3 === f2.up || d3 === f2.down, p2 = d3 === f2.left || d3 === f2.up ? 1 : -1, b5 = (o2 ? x2.plotHeight : x2.plotWidth) / 10 * p2, h2 = 10 * Math.random(), c4 = { x: C3.offsetLeft + x2.plotLeft + x2.plotWidth / 2 + h2, y: C3.offsetTop + x2.plotTop + x2.plotHeight / 2 + h2 }, T2 = o2 ? { x: c4.x, y: c4.y + b5 } : { x: c4.x + b5, y: c4.y };
          return [Z2("mousedown", c4), Z2("mousemove", T2), Z2("mouseup", T2)].forEach((I3) => C3.dispatchEvent(I3)), j3.response.success;
        }
        onMapKbdTab(j3, d3) {
          let x2 = this.chart, f2 = j3.response, C3 = d3.shiftKey, o2 = C3 && !this.focusedMapNavButtonIx || !C3 && this.focusedMapNavButtonIx;
          if (x2.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0), o2) return x2.mapView && x2.mapView.zoomBy(), f2[C3 ? "prev" : "next"];
          this.focusedMapNavButtonIx += C3 ? -1 : 1;
          let p2 = x2.mapNavigation.navButtons[this.focusedMapNavButtonIx];
          return x2.setFocusToElement(p2.box, p2.element), p2.setState(2), f2.success;
        }
        onMapKbdClick(j3) {
          let d3 = this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element;
          return this.fakeClickEvent(d3), j3.response.success;
        }
        onMapNavInit(j3) {
          let d3 = this.chart, x2 = d3.mapNavigation.navButtons[0], f2 = d3.mapNavigation.navButtons[1], C3 = j3 > 0 ? x2 : f2;
          d3.setFocusToElement(C3.box, C3.element), C3.setState(2), this.focusedMapNavButtonIx = j3 > 0 ? 0 : 1;
        }
        simpleButtonNavigation(j3, d3, x2) {
          let f2 = this.keyCodes, C3 = this, o2 = this.chart;
          return new it2(o2, { keyCodeMap: [[[f2.tab, f2.up, f2.down, f2.left, f2.right], function(p2, b5) {
            let h2 = p2 === f2.tab && b5.shiftKey || p2 === f2.left || p2 === f2.up;
            return this.response[h2 ? "prev" : "next"];
          }], [[f2.space, f2.enter], function() {
            return O3(x2(this, o2), this.response.success);
          }]], validate: function() {
            return o2[j3] && o2[j3].box && C3[d3].innerElement;
          }, init: function() {
            o2.setFocusToElement(o2[j3].box, C3[d3].innerElement);
          } });
        }
        getKeyboardNavigation() {
          return [this.simpleButtonNavigation("resetZoomButton", "resetZoomProxyButton", function(j3, d3) {
            d3.zoomOut();
          }), this.simpleButtonNavigation("drillUpButton", "drillUpProxyButton", function(j3, d3) {
            return d3.drillUp(), j3.response.prev;
          }), this.getMapZoomNavigation()];
        }
      };
    }), at2(s2, "Accessibility/HighContrastMode.js", [s2["Core/Globals.js"]], function(B3) {
      let { doc: K2, isMS: q2, win: it2 } = B3;
      return { isHighContrastModeActive: function() {
        let rt2 = /(Edg)/.test(it2.navigator.userAgent);
        if (it2.matchMedia && rt2) return it2.matchMedia("(-ms-high-contrast: active)").matches;
        if (q2 && it2.getComputedStyle) {
          let tt2 = K2.createElement("div");
          tt2.style.backgroundImage = "url(data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)", K2.body.appendChild(tt2);
          let Z2 = (tt2.currentStyle || it2.getComputedStyle(tt2)).backgroundImage;
          return K2.body.removeChild(tt2), Z2 === "none";
        }
        return it2.matchMedia && it2.matchMedia("(forced-colors: active)").matches;
      }, setHighContrastTheme: function(rt2) {
        var tt2;
        rt2.highContrastModeActive = true;
        let Z2 = rt2.options.accessibility.highContrastTheme;
        rt2.update(Z2, false);
        let X2 = ((tt2 = Z2.colors) == null ? void 0 : tt2.length) > 1;
        rt2.series.forEach(function(O3) {
          let j3 = Z2.plotOptions[O3.type] || {}, d3 = X2 && O3.colorIndex !== void 0 ? Z2.colors[O3.colorIndex] : j3.color || "window", x2 = { color: j3.color || "windowText", colors: X2 ? Z2.colors : [j3.color || "windowText"], borderColor: j3.borderColor || "window", fillColor: d3 };
          O3.update(x2, false), O3.points && O3.points.forEach(function(f2) {
            f2.options && f2.options.color && f2.update({ color: j3.color || "windowText", borderColor: j3.borderColor || "window" }, false);
          });
        }), rt2.redraw();
      } };
    }), at2(s2, "Accessibility/HighContrastTheme.js", [], function() {
      return { chart: { backgroundColor: "window" }, title: { style: { color: "windowText" } }, subtitle: { style: { color: "windowText" } }, colorAxis: { minColor: "windowText", maxColor: "windowText", stops: [], dataClasses: [] }, colors: ["windowText"], xAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, yAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, tooltip: { backgroundColor: "window", borderColor: "windowText", style: { color: "windowText" } }, plotOptions: { series: { lineColor: "windowText", fillColor: "window", borderColor: "windowText", edgeColor: "windowText", borderWidth: 1, dataLabels: { connectorColor: "windowText", color: "windowText", style: { color: "windowText", textOutline: "none" } }, marker: { lineColor: "windowText", fillColor: "windowText" } }, pie: { color: "window", colors: ["window"], borderColor: "windowText", borderWidth: 1 }, boxplot: { fillColor: "window" }, candlestick: { lineColor: "windowText", fillColor: "window" }, errorbar: { fillColor: "window" } }, legend: { backgroundColor: "window", itemStyle: { color: "windowText" }, itemHoverStyle: { color: "windowText" }, itemHiddenStyle: { color: "#555" }, title: { style: { color: "windowText" } } }, credits: { style: { color: "windowText" } }, drilldown: { activeAxisLabelStyle: { color: "windowText" }, activeDataLabelStyle: { color: "windowText" } }, navigation: { buttonOptions: { symbolStroke: "windowText", theme: { fill: "window" } } }, rangeSelector: { buttonTheme: { fill: "window", stroke: "windowText", style: { color: "windowText" }, states: { hover: { fill: "window", stroke: "windowText", style: { color: "windowText" } }, select: { fill: "#444", stroke: "windowText", style: { color: "windowText" } } } }, inputBoxBorderColor: "windowText", inputStyle: { backgroundColor: "window", color: "windowText" }, labelStyle: { color: "windowText" } }, navigator: { handles: { backgroundColor: "window", borderColor: "windowText" }, outlineColor: "windowText", maskFill: "transparent", series: { color: "windowText", lineColor: "windowText" }, xAxis: { gridLineColor: "windowText" } }, scrollbar: { barBackgroundColor: "#444", barBorderColor: "windowText", buttonArrowColor: "windowText", buttonBackgroundColor: "window", buttonBorderColor: "windowText", rifleColor: "windowText", trackBackgroundColor: "window", trackBorderColor: "windowText" } };
    }), at2(s2, "Accessibility/Options/A11yDefaults.js", [], function() {
      return { accessibility: { enabled: true, screenReaderSection: { beforeChartFormat: "<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>", afterChartFormat: "{endOfChartMarker}", axisRangeDateFormat: "%Y-%m-%d %H:%M:%S" }, series: { descriptionFormat: "{seriesDescription}{authorDescription}{axisDescription}", describeSingleSeries: false, pointDescriptionEnabledThreshold: 200 }, point: { valueDescriptionFormat: "{xDescription}{separator}{value}.", describeNull: true }, landmarkVerbosity: "all", linkedDescription: '*[data-highcharts-chart="{index}"] + .highcharts-description', highContrastMode: "auto", keyboardNavigation: { enabled: true, focusBorder: { enabled: true, hideBrowserFocusOutline: true, style: { color: "#334eff", lineWidth: 2, borderRadius: 3 }, margin: 2 }, order: ["series", "zoom", "rangeSelector", "navigator", "legend", "chartMenu"], wrapAround: true, seriesNavigation: { skipNullPoints: true, pointNavigationEnabledThreshold: false, rememberPointFocus: false } }, announceNewData: { enabled: false, minAnnounceInterval: 5e3, interruptUser: false } }, legend: { accessibility: { enabled: true, keyboardNavigation: { enabled: true } } }, exporting: { accessibility: { enabled: true } }, navigator: { accessibility: { enabled: true } } };
    }), at2(s2, "Accessibility/Options/LangDefaults.js", [], function() {
      return { accessibility: { defaultChartTitle: "Chart", chartContainerLabel: "{title}. Highcharts interactive chart.", svgContainerLabel: "Interactive chart", drillUpButton: "{buttonText}", credits: "Chart credits: {creditsStr}", thousandsSep: ",", svgContainerTitle: "", graphicContainerLabel: "", screenReaderSection: { beforeRegionLabel: "", afterRegionLabel: "", annotations: { heading: "Chart annotations summary", descriptionSinglePoint: "{annotationText}. Related to {annotationPoint}", descriptionMultiplePoints: "{annotationText}. Related to {annotationPoint}{#each additionalAnnotationPoints}, also related to {this}{/each}", descriptionNoPoints: "{annotationText}" }, endOfChartMarker: "End of interactive chart." }, sonification: { playAsSoundButtonText: "Play as sound, {chartTitle}", playAsSoundClickAnnouncement: "Play" }, legend: { legendLabelNoTitle: "Toggle series visibility, {chartTitle}", legendLabel: "Chart legend: {legendTitle}", legendItem: "Show {itemName}" }, zoom: { mapZoomIn: "Zoom chart", mapZoomOut: "Zoom out chart", resetZoomButton: "Reset zoom" }, rangeSelector: { dropdownLabel: "{rangeTitle}", minInputLabel: "Select start date.", maxInputLabel: "Select end date.", clickButtonAnnouncement: "Viewing {axisRangeDescription}" }, navigator: { handleLabel: "{#eq handleIx 0}Start, percent{else}End, percent{/eq}", groupLabel: "Axis zoom", changeAnnouncement: "{axisRangeDescription}" }, table: { viewAsDataTableButtonText: "View as data table, {chartTitle}", tableSummary: "Table representation of chart." }, announceNewData: { newDataAnnounce: "Updated data for chart {chartTitle}", newSeriesAnnounceSingle: "New data series: {seriesDesc}", newPointAnnounceSingle: "New data point: {pointDesc}", newSeriesAnnounceMultiple: "New data series in chart {chartTitle}: {seriesDesc}", newPointAnnounceMultiple: "New data point in chart {chartTitle}: {pointDesc}" }, seriesTypeDescriptions: { boxplot: "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.", arearange: "Arearange charts are line charts displaying a range between a lower and higher value for each point.", areasplinerange: "These charts are line charts displaying a range between a lower and higher value for each point.", bubble: "Bubble charts are scatter charts where each data point also has a size value.", columnrange: "Columnrange charts are column charts displaying a range between a lower and higher value for each point.", errorbar: "Errorbar series are used to display the variability of the data.", funnel: "Funnel charts are used to display reduction of data in stages.", pyramid: "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.", waterfall: "A waterfall chart is a column chart where each column contributes towards a total end value." }, chartTypes: { emptyChart: "Empty chart", mapTypeDescription: "Map of {mapTitle} with {numSeries} data series.", unknownMap: "Map of unspecified region with {numSeries} data series.", combinationChart: "Combination chart with {numSeries} data series.", defaultSingle: "Chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", defaultMultiple: "Chart with {numSeries} data series.", splineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", splineMultiple: "Line chart with {numSeries} lines.", lineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", lineMultiple: "Line chart with {numSeries} lines.", columnSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", columnMultiple: "Bar chart with {numSeries} data series.", barSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", barMultiple: "Bar chart with {numSeries} data series.", pieSingle: "Pie chart with {numPoints} {#eq numPoints 1}slice{else}slices{/eq}.", pieMultiple: "Pie chart with {numSeries} pies.", scatterSingle: "Scatter chart with {numPoints} {#eq numPoints 1}point{else}points{/eq}.", scatterMultiple: "Scatter chart with {numSeries} data series.", boxplotSingle: "Boxplot with {numPoints} {#eq numPoints 1}box{else}boxes{/eq}.", boxplotMultiple: "Boxplot with {numSeries} data series.", bubbleSingle: "Bubble chart with {numPoints} {#eq numPoints 1}bubbles{else}bubble{/eq}.", bubbleMultiple: "Bubble chart with {numSeries} data series." }, axis: { xAxisDescriptionSingular: "The chart has 1 X axis displaying {names[0]}. {ranges[0]}", xAxisDescriptionPlural: "The chart has {numAxes} X axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", yAxisDescriptionSingular: "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}", yAxisDescriptionPlural: "The chart has {numAxes} Y axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", timeRangeDays: "Data range: {range} days.", timeRangeHours: "Data range: {range} hours.", timeRangeMinutes: "Data range: {range} minutes.", timeRangeSeconds: "Data range: {range} seconds.", rangeFromTo: "Data ranges from {rangeFrom} to {rangeTo}.", rangeCategories: "Data range: {numCategories} categories." }, exporting: { chartMenuLabel: "Chart menu", menuButtonLabel: "View chart menu, {chartTitle}" }, series: { summary: { default: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", defaultCombination: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", line: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", lineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", spline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", splineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", column: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", columnCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", bar: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", barCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", pie: "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", pieCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", scatter: "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", scatterCombination: "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", boxplot: "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", boxplotCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", bubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", bubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", map: "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", maplineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", mapbubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", mapbubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}." }, description: "{description}", xAxisDescription: "X axis, {name}", yAxisDescription: "Y axis, {name}", nullPointValue: "No value", pointAnnotationsDescription: "{#each annotations}Annotation: {this}{/each}" } } };
    }), at2(s2, "Accessibility/Options/DeprecatedOptions.js", [s2["Core/Utilities.js"]], function(B3) {
      let { error: K2, pick: q2 } = B3;
      function it2(tt2, Z2, X2) {
        let O3 = tt2, j3, d3 = 0;
        for (; d3 < Z2.length - 1; ++d3) O3 = O3[j3 = Z2[d3]] = q2(O3[j3], {});
        O3[Z2[Z2.length - 1]] = X2;
      }
      function rt2(tt2, Z2, X2, O3) {
        function j3(f2, C3) {
          return C3.reduce(function(o2, p2) {
            return o2[p2];
          }, f2);
        }
        let d3 = j3(tt2.options, Z2), x2 = j3(tt2.options, X2);
        Object.keys(O3).forEach(function(f2) {
          let C3 = d3[f2];
          C3 !== void 0 && (it2(x2, O3[f2], C3), K2(32, false, tt2, { [Z2.join(".") + "." + f2]: X2.join(".") + "." + O3[f2].join(".") }));
        });
      }
      return function(tt2) {
        (function(Z2) {
          let X2 = Z2.options.chart, O3 = Z2.options.accessibility || {};
          ["description", "typeDescription"].forEach(function(j3) {
            X2[j3] && (O3[j3] = X2[j3], K2(32, false, Z2, { [`chart.${j3}`]: `use accessibility.${j3}` }));
          });
        })(tt2), function(Z2) {
          Z2.axes.forEach(function(X2) {
            let O3 = X2.options;
            O3 && O3.description && (O3.accessibility = O3.accessibility || {}, O3.accessibility.description = O3.description, K2(32, false, Z2, { "axis.description": "use axis.accessibility.description" }));
          });
        }(tt2), tt2.series && function(Z2) {
          let X2 = { description: ["accessibility", "description"], exposeElementToA11y: ["accessibility", "exposeAsGroupOnly"], pointDescriptionFormatter: ["accessibility", "point", "descriptionFormatter"], skipKeyboardNavigation: ["accessibility", "keyboardNavigation", "enabled"], "accessibility.pointDescriptionFormatter": ["accessibility", "point", "descriptionFormatter"] };
          Z2.series.forEach(function(O3) {
            Object.keys(X2).forEach(function(j3) {
              let d3 = O3.options[j3];
              j3 === "accessibility.pointDescriptionFormatter" && (d3 = O3.options.accessibility && O3.options.accessibility.pointDescriptionFormatter), d3 !== void 0 && (it2(O3.options, X2[j3], j3 === "skipKeyboardNavigation" ? !d3 : d3), K2(32, false, Z2, { [`series.${j3}`]: "series." + X2[j3].join(".") }));
            });
          });
        }(tt2), rt2(tt2, ["accessibility"], ["accessibility"], { pointDateFormat: ["point", "dateFormat"], pointDateFormatter: ["point", "dateFormatter"], pointDescriptionFormatter: ["point", "descriptionFormatter"], pointDescriptionThreshold: ["series", "pointDescriptionEnabledThreshold"], pointNavigationThreshold: ["keyboardNavigation", "seriesNavigation", "pointNavigationEnabledThreshold"], pointValueDecimals: ["point", "valueDecimals"], pointValuePrefix: ["point", "valuePrefix"], pointValueSuffix: ["point", "valueSuffix"], screenReaderSectionFormatter: ["screenReaderSection", "beforeChartFormatter"], describeSingleSeries: ["series", "describeSingleSeries"], seriesDescriptionFormatter: ["series", "descriptionFormatter"], onTableAnchorClick: ["screenReaderSection", "onViewDataTableClick"], axisRangeDateFormat: ["screenReaderSection", "axisRangeDateFormat"] }), rt2(tt2, ["accessibility", "keyboardNavigation"], ["accessibility", "keyboardNavigation", "seriesNavigation"], { skipNullPoints: ["skipNullPoints"], mode: ["mode"] }), rt2(tt2, ["lang", "accessibility"], ["lang", "accessibility"], { legendItem: ["legend", "legendItem"], legendLabel: ["legend", "legendLabel"], mapZoomIn: ["zoom", "mapZoomIn"], mapZoomOut: ["zoom", "mapZoomOut"], resetZoomButton: ["zoom", "resetZoomButton"], screenReaderRegionLabel: ["screenReaderSection", "beforeRegionLabel"], rangeSelectorButton: ["rangeSelector", "buttonText"], rangeSelectorMaxInput: ["rangeSelector", "maxInputLabel"], rangeSelectorMinInput: ["rangeSelector", "minInputLabel"], svgContainerEnd: ["screenReaderSection", "endOfChartMarker"], viewAsDataTable: ["table", "viewAsDataTableButtonText"], tableSummary: ["table", "tableSummary"] });
      };
    }), at2(s2, "Accessibility/Accessibility.js", [s2["Core/Defaults.js"], s2["Core/Globals.js"], s2["Core/Utilities.js"], s2["Accessibility/Utils/HTMLUtilities.js"], s2["Accessibility/A11yI18n.js"], s2["Accessibility/Components/ContainerComponent.js"], s2["Accessibility/FocusBorder.js"], s2["Accessibility/Components/InfoRegionsComponent.js"], s2["Accessibility/KeyboardNavigation.js"], s2["Accessibility/Components/LegendComponent.js"], s2["Accessibility/Components/MenuComponent.js"], s2["Accessibility/Components/NavigatorComponent.js"], s2["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], s2["Accessibility/ProxyProvider.js"], s2["Accessibility/Components/RangeSelectorComponent.js"], s2["Accessibility/Components/SeriesComponent/SeriesComponent.js"], s2["Accessibility/Components/ZoomComponent.js"], s2["Accessibility/HighContrastMode.js"], s2["Accessibility/HighContrastTheme.js"], s2["Accessibility/Options/A11yDefaults.js"], s2["Accessibility/Options/LangDefaults.js"], s2["Accessibility/Options/DeprecatedOptions.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2, O3, j3, d3, x2, f2, C3, o2, p2, b5, h2, c4, T2, I3, G2) {
      let { defaultOptions: L2 } = B3, { doc: l4 } = K2, { addEvent: y2, extend: i5, fireEvent: t3, merge: e5 } = q2, { removeElement: n4 } = it2;
      class u2 {
        constructor(g2) {
          this.init(g2);
        }
        init(g2) {
          if (this.chart = g2, !l4.addEventListener) {
            this.zombie = true, this.components = {}, g2.renderTo.setAttribute("aria-hidden", true);
            return;
          }
          G2(g2), this.proxyProvider = new C3(this.chart), this.initComponents(), this.keyboardNavigation = new O3(g2, this.components);
        }
        initComponents() {
          let g2 = this.chart, r3 = this.proxyProvider, A3 = g2.options.accessibility;
          this.components = { container: new tt2(), infoRegions: new X2(), legend: new j3(), chartMenu: new d3(), rangeSelector: new o2(), series: new p2(), zoom: new b5(), navigator: new x2() }, A3.customComponents && i5(this.components, A3.customComponents);
          let N2 = this.components;
          this.getComponentOrder().forEach(function(k3) {
            N2[k3].initBase(g2, r3), N2[k3].init();
          });
        }
        getComponentOrder() {
          return this.components ? this.components.series ? ["series"].concat(Object.keys(this.components).filter((g2) => g2 !== "series")) : Object.keys(this.components) : [];
        }
        update() {
          let g2 = this.components, r3 = this.chart, A3 = r3.options.accessibility;
          t3(r3, "beforeA11yUpdate"), r3.types = this.getChartTypes();
          let N2 = A3.keyboardNavigation.order;
          this.proxyProvider.updateGroupOrder(N2), this.getComponentOrder().forEach(function(k3) {
            g2[k3].onChartUpdate(), t3(r3, "afterA11yComponentUpdate", { name: k3, component: g2[k3] });
          }), this.keyboardNavigation.update(N2), !r3.highContrastModeActive && A3.highContrastMode !== false && (h2.isHighContrastModeActive() || A3.highContrastMode === true) && h2.setHighContrastTheme(r3), t3(r3, "afterA11yUpdate", { accessibility: this });
        }
        destroy() {
          let g2 = this.chart || {}, r3 = this.components;
          Object.keys(r3).forEach(function(A3) {
            r3[A3].destroy(), r3[A3].destroyBase();
          }), this.proxyProvider && this.proxyProvider.destroy(), g2.announcerContainer && n4(g2.announcerContainer), this.keyboardNavigation && this.keyboardNavigation.destroy(), g2.renderTo && g2.renderTo.setAttribute("aria-hidden", true), g2.focusElement && g2.focusElement.removeFocusBorder();
        }
        getChartTypes() {
          let g2 = {};
          return this.chart.series.forEach(function(r3) {
            g2[r3.type] = 1;
          }), Object.keys(g2);
        }
      }
      return function(a2) {
        function g2() {
          this.accessibility && this.accessibility.destroy();
        }
        function r3() {
          this.a11yDirty && this.renderTo && (delete this.a11yDirty, this.updateA11yEnabled());
          let E2 = this.accessibility;
          E2 && !E2.zombie && (E2.proxyProvider.updateProxyElementPositions(), E2.getComponentOrder().forEach(function(R2) {
            E2.components[R2].onChartRender();
          }));
        }
        function A3(E2) {
          let R2 = E2.options.accessibility;
          R2 && (R2.customComponents && (this.options.accessibility.customComponents = R2.customComponents, delete R2.customComponents), e5(true, this.options.accessibility, R2), this.accessibility && this.accessibility.destroy && (this.accessibility.destroy(), delete this.accessibility)), this.a11yDirty = true;
        }
        function N2() {
          let E2 = this.accessibility, R2 = this.options.accessibility, z2 = this.renderer.boxWrapper.element, Q2 = this.title;
          if (R2 && R2.enabled) E2 && !E2.zombie ? E2.update() : (this.accessibility = E2 = new a2(this), E2 && !E2.zombie && E2.update(), z2.getAttribute("role") === "img" && z2.removeAttribute("role"));
          else if (E2) E2.destroy && E2.destroy(), delete this.accessibility;
          else {
            this.renderTo.setAttribute("role", "img"), this.renderTo.setAttribute("aria-hidden", false), this.renderTo.setAttribute("aria-label", (Q2 && Q2.element.textContent || "").replace(/</g, "&lt;")), z2.setAttribute("aria-hidden", true);
            let v3 = document.getElementsByClassName("highcharts-description")[0];
            v3 && (v3.setAttribute("aria-hidden", false), v3.classList.remove("highcharts-linked-description"));
          }
        }
        function k3() {
          this.series.chart.accessibility && (this.series.chart.a11yDirty = true);
        }
        a2.i18nFormat = rt2.i18nFormat, a2.compose = function(E2, R2, z2, Q2, v3, S2) {
          O3.compose(E2), f2.compose(Q2), j3.compose(E2, R2), d3.compose(E2), p2.compose(E2, z2, Q2), rt2.compose(E2), Z2.compose(E2, v3), S2 && o2.compose(E2, S2);
          let P2 = E2.prototype;
          P2.updateA11yEnabled || (P2.updateA11yEnabled = N2, y2(E2, "destroy", g2), y2(E2, "render", r3), y2(E2, "update", A3), ["addSeries", "init"].forEach((U2) => {
            y2(E2, U2, function() {
              this.a11yDirty = true;
            });
          }), ["afterApplyDrilldown", "drillupall"].forEach((U2) => {
            y2(E2, U2, function() {
              let w2 = this.accessibility;
              w2 && !w2.zombie && w2.update();
            });
          }), y2(z2, "update", k3), ["update", "updatedData", "remove"].forEach((U2) => {
            y2(Q2, U2, function() {
              this.chart.accessibility && (this.chart.a11yDirty = true);
            });
          }));
        };
      }(u2), e5(true, L2, T2, { accessibility: { highContrastTheme: c4 }, lang: I3 }), u2;
    }), at2(s2, "masters/modules/accessibility.src.js", [s2["Core/Globals.js"], s2["Accessibility/Accessibility.js"], s2["Accessibility/AccessibilityComponent.js"], s2["Accessibility/Utils/ChartUtilities.js"], s2["Accessibility/Utils/HTMLUtilities.js"], s2["Accessibility/KeyboardNavigationHandler.js"], s2["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2) {
      return B3.i18nFormat = K2.i18nFormat, B3.A11yChartUtilities = it2, B3.A11yHTMLUtilities = rt2, B3.AccessibilityComponent = q2, B3.KeyboardNavigationHandler = tt2, B3.SeriesAccessibilityDescriber = Z2, K2.compose(B3.Chart, B3.Legend, B3.Point, B3.Series, B3.SVGElement, B3.RangeSelector), B3;
    });
  });
})(Xi);
var Bs = Xi.exports;
const Rs = /* @__PURE__ */ ce(Bs);
var Zt$1 = /* @__PURE__ */ ((m3) => (m3.CIRCLE = "circle", m3.TRIANGLE = "triangle", m3.SQUARE = "square", m3.DIAMOND = "diamond", m3.TRIANGLE_DOWN = "triangle-down", m3))(Zt$1 || {}), oe$1 = /* @__PURE__ */ ((m3) => (m3.SINGLE_LINE = "single-line", m3.MULTI_LINE = "multi-line", m3.MULTI_LEVEL = "multi-level", m3))(oe$1 || {}), te$2 = /* @__PURE__ */ ((m3) => (m3.LINE = "line", m3.BAR = "bar", m3.COLUMN = "column", m3.SCATTER = "scatter", m3.PIE = "pie", m3.GAUGE = "gauge", m3.AREA = "area", m3))(te$2 || {}), _i = /* @__PURE__ */ ((m3) => (m3[m3.HEIGHT = 480] = "HEIGHT", m3))(_i || {}), $t = /* @__PURE__ */ ((m3) => (m3.STANDARD = "standard-set", m3.EXTENDED = "extended-set", m3))($t || {});
const bi = " ";
function zs(m3, H2 = bi) {
  return typeof H2 != "string" && (H2 = bi), m3 == null ? void 0 : m3.split(H2).map((s2) => s2.trim());
}
var Vi = /* @__PURE__ */ ((m3) => (m3.HORIZONTAL = "row", m3.VERTICAL = "column", m3))(Vi || {}), Ki = /* @__PURE__ */ ((m3) => (m3.CENTER = "center", m3.LEFT = "left", m3.RIGHT = "right", m3))(Ki || {}), Zi = /* @__PURE__ */ ((m3) => (m3.BOTTOM = "bottom", m3.TOP = "top", m3.MIDDLE = "middle", m3))(Zi || {});
Zi.TOP, Ki.CENTER, Vi.HORIZONTAL;
const Hs = `<svg height="12" width="12" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <circle stroke-width="0" cx="6" cy="6" r="2" />
</svg>
`, Gs = `<svg height="12" width="12" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <circle stroke-width="0" cx="6" cy="6" r="6" />
</svg>
`, Us = `<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <rect y="5" width="7" height="7" transform="rotate(-45 0 5)"/>
</svg>
`, $s = `<svg height="10" width="10" viewbox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <rect width="10" height="10"/>
</svg>
`, Ws = `<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <path d="M10 0L5 8L6.99382e-07 -8.74228e-07L10 0Z"/>
</svg>
`, Ys = `<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <path d="M0 8L5 0L10 8H0Z"/>
</svg>
`, Vt = {
  multiLevel: Hs,
  circle: Gs,
  triangle: Ys,
  square: $s,
  diamond: Us,
  triangleDown: Ws
};
function Xs(m3) {
  return !!(m3.custom && m3.custom.tableElement);
}
function _s(m3) {
  const H2 = m3.dataTableDiv.querySelector("table");
  if (!H2) return;
  const {
    userOptions: { plotOptions: s2 }
  } = m3;
  if (s2 && Xs(s2)) {
    const at2 = document.createElement(s2.custom.tableElement);
    m3.dataTableDiv.appendChild(at2), at2.appendChild(H2);
  }
}
function Vs(m3) {
  const H2 = [...Object.values(Zt$1)], s2 = m3 % H2.length;
  return H2[s2];
}
function je$1(m3, H2, s2) {
  if (H2)
    return Vt.multiLevel;
  const at2 = [
    te$2.LINE,
    te$2.SCATTER,
    te$2.AREA
  ];
  if (s2 && at2.includes(s2))
    switch (Vs(m3)) {
      case Zt$1.CIRCLE:
        return Vt.circle;
      case Zt$1.TRIANGLE:
        return Vt.triangle;
      case Zt$1.SQUARE:
        return Vt.square;
      case Zt$1.DIAMOND:
        return Vt.diamond;
      case Zt$1.TRIANGLE_DOWN:
        return Vt.triangleDown;
      default:
        return Vt.circle;
    }
  else
    return Vt.circle;
}
const xi = T$7`[beacon-tag-name$=chart] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-50)}[beacon-tag-name$=chart] [slot=subtitle],[beacon-tag-name$=chart] [slot=caption]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-loose-300)}.highcharts-tooltip-container svg{max-inline-size:unset}.beacon-chart-tooltip{background-color:var(--beacon-system-color-background-1);color:var(--beacon-system-color-text-standard);fill:var(--beacon-system-color-background-1)}.beacon-chart-tooltip .highcharts-color-0{fill:var(--beacon-system-color-data-viz-0);stroke:var(--beacon-system-color-data-viz-0)}.beacon-chart-tooltip .highcharts-color-1{fill:var(--beacon-system-color-data-viz-1);stroke:var(--beacon-system-color-data-viz-1)}.beacon-chart-tooltip .highcharts-color-2{fill:var(--beacon-system-color-data-viz-2);stroke:var(--beacon-system-color-data-viz-2)}.beacon-chart-tooltip .highcharts-color-3{fill:var(--beacon-system-color-data-viz-3);stroke:var(--beacon-system-color-data-viz-3)}.beacon-chart-tooltip .highcharts-color-4{fill:var(--beacon-system-color-data-viz-4);stroke:var(--beacon-system-color-data-viz-4)}.beacon-chart-tooltip .highcharts-color-5{fill:var(--beacon-system-color-data-viz-5);stroke:var(--beacon-system-color-data-viz-5)}.beacon-chart-tooltip .highcharts-color-6{fill:var(--beacon-system-color-data-viz-6);stroke:var(--beacon-system-color-data-viz-6)}.beacon-chart-tooltip .highcharts-color-7{fill:var(--beacon-system-color-data-viz-7);stroke:var(--beacon-system-color-data-viz-7)}.beacon-chart-tooltip .highcharts-color-8{fill:var(--beacon-system-color-data-viz-8);stroke:var(--beacon-system-color-data-viz-8)}.beacon-chart-tooltip .highcharts-color-9{fill:var(--beacon-system-color-data-viz-9);stroke:var(--beacon-system-color-data-viz-9)}.beacon-chart-tooltip .highcharts-color-10{fill:var(--beacon-system-color-data-viz-10);stroke:var(--beacon-system-color-data-viz-10)}.beacon-chart-tooltip .highcharts-color-11{fill:var(--beacon-system-color-data-viz-11);stroke:var(--beacon-system-color-data-viz-11)}.beacon-chart-tooltip.area.single-series-chart:not(.stacked-chart) .beacon-chart-tooltip__point.highcharts-color-0.negative{fill:var(--beacon-reference-palette-functional-red-3);stroke:var(--beacon-reference-palette-functional-red-3)}.beacon-chart-tooltip.area.single-series-chart:not(.stacked-chart) .beacon-chart-tooltip__point.highcharts-color-0.positive{fill:var(--beacon-reference-palette-functional-green-3);stroke:var(--beacon-reference-palette-functional-green-3)}.beacon-chart-tooltip__title{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.beacon-chart-tooltip__point,.beacon-chart-tooltip-point__label{align-items:center;display:flex}.beacon-chart-tooltip__point{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);gap:var(--beacon-reference-space-3)}.beacon-chart-tooltip__point:not(:first-of-type){margin-block-start:var(--beacon-reference-space-3)}.beacon-chart-tooltip__separator{border:0;border-block-start-color:var(--beacon-system-color-icon-primary-inactive);border-block-start-style:solid;border-block-start-width:var(--beacon-system-width-border-mini)}.beacon-chart-tooltip__point--multi-level .beacon-legend-item__icon{fill:var(--beacon-system-color-icon-primary-inactive)}.beacon-chart-tooltip__footer,.beacon-chart-tooltip__additional-content{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);margin-block-start:var(--beacon-reference-space-3)}.beacon-chart-tooltip-point__label{gap:var(--beacon-reference-space-4)}.beacon-chart-tooltip__point-value{font-weight:var(--beacon-system-font-weight-bold)}`, Ks = T$7`*{margin:0;padding:0}:host{--component-background-color: transparent;--component-gap-space: var(--beacon-system-space-micro-jumbo);background-color:var(--component-background-color)}.base{padding-block:var(--beacon-reference-space-3)}.chart{block-size:var(--beacon-custom-chart-container-size-block, auto)}.header{margin-block-end:var(--component-gap-space);padding-inline:var(--beacon-reference-space-5)}.caption{margin-block-start:var(--component-gap-space);padding-inline:var(--beacon-reference-space-5)}.highcharts-background{fill:var(--component-background-color)}.highcharts-focus-border{stroke:var(--beacon-system-color-border-focus-outer);stroke-width:var(--beacon-system-width-border-jumbo)}.highcharts-container{color:inherit;font-family:inherit}.highcharts-container :not(.highcharts-tooltip,.highcharts-tooltip-box,.highcharts-button)>text{fill:currentcolor}.highcharts-legend-item .highcharts-focus-border{display:none}.highcharts-legend-navigation{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);color:var(--beacon-system-color-text-standard)}.highcharts-legend-nav-active{fill:var(--beacon-system-color-icon-secondary)}.highcharts-legend-nav-inactive{fill:var(--beacon-system-color-icon-secondary-inactive)}.beacon-legend-item{--background-color: var(--beacon-system-color-background-1);--legend-item-padding: var(--beacon-system-space-cell-contained);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);align-items:center;background-color:var(--background-color);border-color:transparent;border-radius:var(--beacon-system-radius-corner-standard);border-style:solid;border-width:var(--beacon-system-width-border-normal, 2px);display:flex;gap:var(--beacon-reference-space-3);padding:var(--legend-item-padding)}.beacon-legend-item .beacon-legend-item__label{align-items:center;display:flex;gap:var(--beacon-reference-space-4)}.beacon-legend-item.beacon-legend-item--hover{--background-color: var(--beacon-system-color-background-secondary-hover);border-color:var(--beacon-system-color-border-secondary)}.beacon-legend-item.beacon-legend-item--hover .beacon-legend-item__label-text{text-decoration:underline}.beacon-legend-item.beacon-legend-item--focus{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;position:relative;z-index:1}.beacon-legend-item .beacon-legend-item__value{font-weight:var(--beacon-system-font-weight-bold)}.highcharts-legend-item-hidden *{text-decoration:none}.highcharts-legend-item-hidden .beacon-legend-item{--background-color: transparent}.highcharts-legend-item-hidden .beacon-legend-item.beacon-legend-item--hover{--background-color: var(--beacon-system-color-background-secondary-hover);border-color:var(--beacon-system-color-border-secondary)}.static-legend .highcharts-legend{pointer-events:none}.static-legend .highcharts-a11y-proxy-group-legend button{cursor:default;pointer-events:none}.static-legend .beacon-legend-item{--background-color: transparent;--legend-item-padding: 0;border-radius:0}.static-legend[legend-layout*=horizontal] .highcharts-legend-item:not(:last-of-type) .beacon-legend-item{border-inline-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-inline-end:var(--beacon-system-space-micro-jumbo)}.static-legend[legend-layout*=horizontal] .highcharts-legend-item:not(:first-of-type) .beacon-legend-item:not(.beacon-legend-item--0){padding-inline-start:var(--beacon-system-space-micro-jumbo)}.static-legend[legend-layout*=vertical] .highcharts-legend-item:not(:last-of-type) .beacon-legend-item{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-block-end:var(--beacon-system-space-micro-normal)}.static-legend[legend-layout*=vertical] .highcharts-legend-item:not(:first-of-type) .beacon-legend-item:not(.beacon-legend-item--0){padding-block-start:var(--beacon-system-space-micro-normal)}.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-10)}@media (width >= 640px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-11)}}@media (width >= 960px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-12)}}@media (width >= 1280px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-13)}}.highcharts-color-0{fill:var(--beacon-system-color-data-viz-0);stroke:var(--beacon-system-color-data-viz-0)}.highcharts-color-1{fill:var(--beacon-system-color-data-viz-1);stroke:var(--beacon-system-color-data-viz-1)}.highcharts-color-2{fill:var(--beacon-system-color-data-viz-2);stroke:var(--beacon-system-color-data-viz-2)}.highcharts-color-3{fill:var(--beacon-system-color-data-viz-3);stroke:var(--beacon-system-color-data-viz-3)}.highcharts-color-4{fill:var(--beacon-system-color-data-viz-4);stroke:var(--beacon-system-color-data-viz-4)}.highcharts-color-5{fill:var(--beacon-system-color-data-viz-5);stroke:var(--beacon-system-color-data-viz-5)}.highcharts-color-6{fill:var(--beacon-system-color-data-viz-6);stroke:var(--beacon-system-color-data-viz-6)}.highcharts-color-7{fill:var(--beacon-system-color-data-viz-7);stroke:var(--beacon-system-color-data-viz-7)}.highcharts-color-8{fill:var(--beacon-system-color-data-viz-8);stroke:var(--beacon-system-color-data-viz-8)}.highcharts-color-9{fill:var(--beacon-system-color-data-viz-9);stroke:var(--beacon-system-color-data-viz-9)}.highcharts-color-10{fill:var(--beacon-system-color-data-viz-10);stroke:var(--beacon-system-color-data-viz-10)}.highcharts-color-11{fill:var(--beacon-system-color-data-viz-11);stroke:var(--beacon-system-color-data-viz-11)}.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}`;
function qi(m3, H2) {
  for (var s2 = -1, at2 = m3 == null ? 0 : m3.length, B3 = Array(at2); ++s2 < at2; )
    B3[s2] = H2(m3[s2], s2, m3);
  return B3;
}
function Zs() {
  this.__data__ = [], this.size = 0;
}
function de$1(m3, H2) {
  return m3 === H2 || m3 !== m3 && H2 !== H2;
}
function Ce$1(m3, H2) {
  for (var s2 = m3.length; s2--; )
    if (de$1(m3[s2][0], H2))
      return s2;
  return -1;
}
var qs = Array.prototype, Js = qs.splice;
function Qs(m3) {
  var H2 = this.__data__, s2 = Ce$1(H2, m3);
  if (s2 < 0)
    return false;
  var at2 = H2.length - 1;
  return s2 == at2 ? H2.pop() : Js.call(H2, s2, 1), --this.size, true;
}
function tr(m3) {
  var H2 = this.__data__, s2 = Ce$1(H2, m3);
  return s2 < 0 ? void 0 : H2[s2][1];
}
function er(m3) {
  return Ce$1(this.__data__, m3) > -1;
}
function ir(m3, H2) {
  var s2 = this.__data__, at2 = Ce$1(s2, m3);
  return at2 < 0 ? (++this.size, s2.push([m3, H2])) : s2[at2][1] = H2, this;
}
function Wt(m3) {
  var H2 = -1, s2 = m3 == null ? 0 : m3.length;
  for (this.clear(); ++H2 < s2; ) {
    var at2 = m3[H2];
    this.set(at2[0], at2[1]);
  }
}
Wt.prototype.clear = Zs;
Wt.prototype.delete = Qs;
Wt.prototype.get = tr;
Wt.prototype.has = er;
Wt.prototype.set = ir;
function sr() {
  this.__data__ = new Wt(), this.size = 0;
}
function rr(m3) {
  var H2 = this.__data__, s2 = H2.delete(m3);
  return this.size = H2.size, s2;
}
function nr(m3) {
  return this.__data__.get(m3);
}
function or(m3) {
  return this.__data__.has(m3);
}
var Ji = typeof global == "object" && global && global.Object === Object && global, ar = typeof self == "object" && self && self.Object === Object && self, Ht = Ji || ar || Function("return this")(), qt = Ht.Symbol, Qi = Object.prototype, lr = Qi.hasOwnProperty, hr = Qi.toString, ne$1 = qt ? qt.toStringTag : void 0;
function cr(m3) {
  var H2 = lr.call(m3, ne$1), s2 = m3[ne$1];
  try {
    m3[ne$1] = void 0;
    var at2 = true;
  } catch {
  }
  var B3 = hr.call(m3);
  return at2 && (H2 ? m3[ne$1] = s2 : delete m3[ne$1]), B3;
}
var dr = Object.prototype, ur = dr.toString;
function pr(m3) {
  return ur.call(m3);
}
var gr = "[object Null]", fr = "[object Undefined]", yi = qt ? qt.toStringTag : void 0;
function ie$2(m3) {
  return m3 == null ? m3 === void 0 ? fr : gr : yi && yi in Object(m3) ? cr(m3) : pr(m3);
}
function zt(m3) {
  var H2 = typeof m3;
  return m3 != null && (H2 == "object" || H2 == "function");
}
var mr = "[object AsyncFunction]", br = "[object Function]", xr = "[object GeneratorFunction]", yr = "[object Proxy]";
function Ye(m3) {
  if (!zt(m3))
    return false;
  var H2 = ie$2(m3);
  return H2 == br || H2 == xr || H2 == mr || H2 == yr;
}
var Ne$1 = Ht["__core-js_shared__"], vi = function() {
  var m3 = /[^.]+$/.exec(Ne$1 && Ne$1.keys && Ne$1.keys.IE_PROTO || "");
  return m3 ? "Symbol(src)_1." + m3 : "";
}();
function vr(m3) {
  return !!vi && vi in m3;
}
var wr = Function.prototype, Cr = wr.toString;
function se$1(m3) {
  if (m3 != null) {
    try {
      return Cr.call(m3);
    } catch {
    }
    try {
      return m3 + "";
    } catch {
    }
  }
  return "";
}
var kr = /[\\^$.*+?()[\]{}|]/g, Sr = /^\[object .+?Constructor\]$/, Tr = Function.prototype, Ar = Object.prototype, Mr = Tr.toString, Er = Ar.hasOwnProperty, Pr = RegExp(
  "^" + Mr.call(Er).replace(kr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Lr(m3) {
  if (!zt(m3) || vr(m3))
    return false;
  var H2 = Ye(m3) ? Pr : Sr;
  return H2.test(se$1(m3));
}
function Or(m3, H2) {
  return m3 == null ? void 0 : m3[H2];
}
function re$1(m3, H2) {
  var s2 = Or(m3, H2);
  return Lr(s2) ? s2 : void 0;
}
var le$1 = re$1(Ht, "Map"), he$1 = re$1(Object, "create");
function Dr() {
  this.__data__ = he$1 ? he$1(null) : {}, this.size = 0;
}
function jr(m3) {
  var H2 = this.has(m3) && delete this.__data__[m3];
  return this.size -= H2 ? 1 : 0, H2;
}
var Nr = "__lodash_hash_undefined__", Ir = Object.prototype, Br = Ir.hasOwnProperty;
function Rr(m3) {
  var H2 = this.__data__;
  if (he$1) {
    var s2 = H2[m3];
    return s2 === Nr ? void 0 : s2;
  }
  return Br.call(H2, m3) ? H2[m3] : void 0;
}
var Fr = Object.prototype, zr = Fr.hasOwnProperty;
function Hr(m3) {
  var H2 = this.__data__;
  return he$1 ? H2[m3] !== void 0 : zr.call(H2, m3);
}
var Gr = "__lodash_hash_undefined__";
function Ur(m3, H2) {
  var s2 = this.__data__;
  return this.size += this.has(m3) ? 0 : 1, s2[m3] = he$1 && H2 === void 0 ? Gr : H2, this;
}
function ee$2(m3) {
  var H2 = -1, s2 = m3 == null ? 0 : m3.length;
  for (this.clear(); ++H2 < s2; ) {
    var at2 = m3[H2];
    this.set(at2[0], at2[1]);
  }
}
ee$2.prototype.clear = Dr;
ee$2.prototype.delete = jr;
ee$2.prototype.get = Rr;
ee$2.prototype.has = Hr;
ee$2.prototype.set = Ur;
function $r() {
  this.size = 0, this.__data__ = {
    hash: new ee$2(),
    map: new (le$1 || Wt)(),
    string: new ee$2()
  };
}
function Wr(m3) {
  var H2 = typeof m3;
  return H2 == "string" || H2 == "number" || H2 == "symbol" || H2 == "boolean" ? m3 !== "__proto__" : m3 === null;
}
function ke$1(m3, H2) {
  var s2 = m3.__data__;
  return Wr(H2) ? s2[typeof H2 == "string" ? "string" : "hash"] : s2.map;
}
function Yr(m3) {
  var H2 = ke$1(this, m3).delete(m3);
  return this.size -= H2 ? 1 : 0, H2;
}
function Xr(m3) {
  return ke$1(this, m3).get(m3);
}
function _r(m3) {
  return ke$1(this, m3).has(m3);
}
function Vr(m3, H2) {
  var s2 = ke$1(this, m3), at2 = s2.size;
  return s2.set(m3, H2), this.size += s2.size == at2 ? 0 : 1, this;
}
function Yt(m3) {
  var H2 = -1, s2 = m3 == null ? 0 : m3.length;
  for (this.clear(); ++H2 < s2; ) {
    var at2 = m3[H2];
    this.set(at2[0], at2[1]);
  }
}
Yt.prototype.clear = $r;
Yt.prototype.delete = Yr;
Yt.prototype.get = Xr;
Yt.prototype.has = _r;
Yt.prototype.set = Vr;
var Kr = 200;
function Zr(m3, H2) {
  var s2 = this.__data__;
  if (s2 instanceof Wt) {
    var at2 = s2.__data__;
    if (!le$1 || at2.length < Kr - 1)
      return at2.push([m3, H2]), this.size = ++s2.size, this;
    s2 = this.__data__ = new Yt(at2);
  }
  return s2.set(m3, H2), this.size = s2.size, this;
}
function Ft(m3) {
  var H2 = this.__data__ = new Wt(m3);
  this.size = H2.size;
}
Ft.prototype.clear = sr;
Ft.prototype.delete = rr;
Ft.prototype.get = nr;
Ft.prototype.has = or;
Ft.prototype.set = Zr;
var qr = "__lodash_hash_undefined__";
function Jr(m3) {
  return this.__data__.set(m3, qr), this;
}
function Qr(m3) {
  return this.__data__.has(m3);
}
function be$1(m3) {
  var H2 = -1, s2 = m3 == null ? 0 : m3.length;
  for (this.__data__ = new Yt(); ++H2 < s2; )
    this.add(m3[H2]);
}
be$1.prototype.add = be$1.prototype.push = Jr;
be$1.prototype.has = Qr;
function tn(m3, H2) {
  for (var s2 = -1, at2 = m3 == null ? 0 : m3.length; ++s2 < at2; )
    if (H2(m3[s2], s2, m3))
      return true;
  return false;
}
function en(m3, H2) {
  return m3.has(H2);
}
var sn = 1, rn = 2;
function ts(m3, H2, s2, at2, B3, K2) {
  var q2 = s2 & sn, it2 = m3.length, rt2 = H2.length;
  if (it2 != rt2 && !(q2 && rt2 > it2))
    return false;
  var tt2 = K2.get(m3), Z2 = K2.get(H2);
  if (tt2 && Z2)
    return tt2 == H2 && Z2 == m3;
  var X2 = -1, O3 = true, j3 = s2 & rn ? new be$1() : void 0;
  for (K2.set(m3, H2), K2.set(H2, m3); ++X2 < it2; ) {
    var d3 = m3[X2], x2 = H2[X2];
    if (at2)
      var f2 = q2 ? at2(x2, d3, X2, H2, m3, K2) : at2(d3, x2, X2, m3, H2, K2);
    if (f2 !== void 0) {
      if (f2)
        continue;
      O3 = false;
      break;
    }
    if (j3) {
      if (!tn(H2, function(C3, o2) {
        if (!en(j3, o2) && (d3 === C3 || B3(d3, C3, s2, at2, K2)))
          return j3.push(o2);
      })) {
        O3 = false;
        break;
      }
    } else if (!(d3 === x2 || B3(d3, x2, s2, at2, K2))) {
      O3 = false;
      break;
    }
  }
  return K2.delete(m3), K2.delete(H2), O3;
}
var xe$1 = Ht.Uint8Array;
function nn(m3) {
  var H2 = -1, s2 = Array(m3.size);
  return m3.forEach(function(at2, B3) {
    s2[++H2] = [B3, at2];
  }), s2;
}
function on(m3) {
  var H2 = -1, s2 = Array(m3.size);
  return m3.forEach(function(at2) {
    s2[++H2] = at2;
  }), s2;
}
var an = 1, ln = 2, hn = "[object Boolean]", cn = "[object Date]", dn = "[object Error]", un = "[object Map]", pn = "[object Number]", gn = "[object RegExp]", fn = "[object Set]", mn = "[object String]", bn = "[object Symbol]", xn = "[object ArrayBuffer]", yn = "[object DataView]", wi = qt ? qt.prototype : void 0, Ie$1 = wi ? wi.valueOf : void 0;
function vn(m3, H2, s2, at2, B3, K2, q2) {
  switch (s2) {
    case yn:
      if (m3.byteLength != H2.byteLength || m3.byteOffset != H2.byteOffset)
        return false;
      m3 = m3.buffer, H2 = H2.buffer;
    case xn:
      return !(m3.byteLength != H2.byteLength || !K2(new xe$1(m3), new xe$1(H2)));
    case hn:
    case cn:
    case pn:
      return de$1(+m3, +H2);
    case dn:
      return m3.name == H2.name && m3.message == H2.message;
    case gn:
    case mn:
      return m3 == H2 + "";
    case un:
      var it2 = nn;
    case fn:
      var rt2 = at2 & an;
      if (it2 || (it2 = on), m3.size != H2.size && !rt2)
        return false;
      var tt2 = q2.get(m3);
      if (tt2)
        return tt2 == H2;
      at2 |= ln, q2.set(m3, H2);
      var Z2 = ts(it2(m3), it2(H2), at2, B3, K2, q2);
      return q2.delete(m3), Z2;
    case bn:
      if (Ie$1)
        return Ie$1.call(m3) == Ie$1.call(H2);
  }
  return false;
}
function es(m3, H2) {
  for (var s2 = -1, at2 = H2.length, B3 = m3.length; ++s2 < at2; )
    m3[B3 + s2] = H2[s2];
  return m3;
}
var Rt = Array.isArray;
function is(m3, H2, s2) {
  var at2 = H2(m3);
  return Rt(m3) ? at2 : es(at2, s2(m3));
}
function wn(m3, H2) {
  for (var s2 = -1, at2 = m3 == null ? 0 : m3.length, B3 = 0, K2 = []; ++s2 < at2; ) {
    var q2 = m3[s2];
    H2(q2, s2, m3) && (K2[B3++] = q2);
  }
  return K2;
}
function ss() {
  return [];
}
var Cn = Object.prototype, kn = Cn.propertyIsEnumerable, Ci = Object.getOwnPropertySymbols, rs = Ci ? function(m3) {
  return m3 == null ? [] : (m3 = Object(m3), wn(Ci(m3), function(H2) {
    return kn.call(m3, H2);
  }));
} : ss;
function Sn(m3, H2) {
  for (var s2 = -1, at2 = Array(m3); ++s2 < m3; )
    at2[s2] = H2(s2);
  return at2;
}
function Jt$1(m3) {
  return m3 != null && typeof m3 == "object";
}
var Tn = "[object Arguments]";
function ki(m3) {
  return Jt$1(m3) && ie$2(m3) == Tn;
}
var ns = Object.prototype, An = ns.hasOwnProperty, Mn = ns.propertyIsEnumerable, ye$1 = ki(/* @__PURE__ */ function() {
  return arguments;
}()) ? ki : function(m3) {
  return Jt$1(m3) && An.call(m3, "callee") && !Mn.call(m3, "callee");
};
function En() {
  return false;
}
var os = typeof exports == "object" && exports && !exports.nodeType && exports, Si = os && typeof module == "object" && module && !module.nodeType && module, Pn = Si && Si.exports === os, Ti = Pn ? Ht.Buffer : void 0, Ln = Ti ? Ti.isBuffer : void 0, ve$1 = Ln || En, On = 9007199254740991, Dn = /^(?:0|[1-9]\d*)$/;
function Se$1(m3, H2) {
  var s2 = typeof m3;
  return H2 = H2 == null ? On : H2, !!H2 && (s2 == "number" || s2 != "symbol" && Dn.test(m3)) && m3 > -1 && m3 % 1 == 0 && m3 < H2;
}
var jn = 9007199254740991;
function Xe2(m3) {
  return typeof m3 == "number" && m3 > -1 && m3 % 1 == 0 && m3 <= jn;
}
var Nn = "[object Arguments]", In = "[object Array]", Bn = "[object Boolean]", Rn = "[object Date]", Fn = "[object Error]", zn = "[object Function]", Hn = "[object Map]", Gn = "[object Number]", Un = "[object Object]", $n = "[object RegExp]", Wn = "[object Set]", Yn = "[object String]", Xn = "[object WeakMap]", _n = "[object ArrayBuffer]", Vn = "[object DataView]", Kn = "[object Float32Array]", Zn = "[object Float64Array]", qn = "[object Int8Array]", Jn = "[object Int16Array]", Qn = "[object Int32Array]", to = "[object Uint8Array]", eo = "[object Uint8ClampedArray]", io = "[object Uint16Array]", so = "[object Uint32Array]", Mt$1 = {};
Mt$1[Kn] = Mt$1[Zn] = Mt$1[qn] = Mt$1[Jn] = Mt$1[Qn] = Mt$1[to] = Mt$1[eo] = Mt$1[io] = Mt$1[so] = true;
Mt$1[Nn] = Mt$1[In] = Mt$1[_n] = Mt$1[Bn] = Mt$1[Vn] = Mt$1[Rn] = Mt$1[Fn] = Mt$1[zn] = Mt$1[Hn] = Mt$1[Gn] = Mt$1[Un] = Mt$1[$n] = Mt$1[Wn] = Mt$1[Yn] = Mt$1[Xn] = false;
function ro(m3) {
  return Jt$1(m3) && Xe2(m3.length) && !!Mt$1[ie$2(m3)];
}
function no(m3) {
  return function(H2) {
    return m3(H2);
  };
}
var as = typeof exports == "object" && exports && !exports.nodeType && exports, ae$1 = as && typeof module == "object" && module && !module.nodeType && module, oo = ae$1 && ae$1.exports === as, Be = oo && Ji.process, Ai = function() {
  try {
    var m3 = ae$1 && ae$1.require && ae$1.require("util").types;
    return m3 || Be && Be.binding && Be.binding("util");
  } catch {
  }
}(), Mi = Ai && Ai.isTypedArray, _e = Mi ? no(Mi) : ro, ao = Object.prototype, lo = ao.hasOwnProperty;
function ls(m3, H2) {
  var s2 = Rt(m3), at2 = !s2 && ye$1(m3), B3 = !s2 && !at2 && ve$1(m3), K2 = !s2 && !at2 && !B3 && _e(m3), q2 = s2 || at2 || B3 || K2, it2 = q2 ? Sn(m3.length, String) : [], rt2 = it2.length;
  for (var tt2 in m3)
    (H2 || lo.call(m3, tt2)) && !(q2 && // Safari 9 has enumerable `arguments.length` in strict mode.
    (tt2 == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    B3 && (tt2 == "offset" || tt2 == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    K2 && (tt2 == "buffer" || tt2 == "byteLength" || tt2 == "byteOffset") || // Skip index properties.
    Se$1(tt2, rt2))) && it2.push(tt2);
  return it2;
}
var ho = Object.prototype;
function Ve(m3) {
  var H2 = m3 && m3.constructor, s2 = typeof H2 == "function" && H2.prototype || ho;
  return m3 === s2;
}
function hs(m3, H2) {
  return function(s2) {
    return m3(H2(s2));
  };
}
var co = hs(Object.keys, Object), uo = Object.prototype, po = uo.hasOwnProperty;
function go(m3) {
  if (!Ve(m3))
    return co(m3);
  var H2 = [];
  for (var s2 in Object(m3))
    po.call(m3, s2) && s2 != "constructor" && H2.push(s2);
  return H2;
}
function Te$1(m3) {
  return m3 != null && Xe2(m3.length) && !Ye(m3);
}
function cs(m3) {
  return Te$1(m3) ? ls(m3) : go(m3);
}
function Ei(m3) {
  return is(m3, cs, rs);
}
var fo = 1, mo = Object.prototype, bo = mo.hasOwnProperty;
function xo(m3, H2, s2, at2, B3, K2) {
  var q2 = s2 & fo, it2 = Ei(m3), rt2 = it2.length, tt2 = Ei(H2), Z2 = tt2.length;
  if (rt2 != Z2 && !q2)
    return false;
  for (var X2 = rt2; X2--; ) {
    var O3 = it2[X2];
    if (!(q2 ? O3 in H2 : bo.call(H2, O3)))
      return false;
  }
  var j3 = K2.get(m3), d3 = K2.get(H2);
  if (j3 && d3)
    return j3 == H2 && d3 == m3;
  var x2 = true;
  K2.set(m3, H2), K2.set(H2, m3);
  for (var f2 = q2; ++X2 < rt2; ) {
    O3 = it2[X2];
    var C3 = m3[O3], o2 = H2[O3];
    if (at2)
      var p2 = q2 ? at2(o2, C3, O3, H2, m3, K2) : at2(C3, o2, O3, m3, H2, K2);
    if (!(p2 === void 0 ? C3 === o2 || B3(C3, o2, s2, at2, K2) : p2)) {
      x2 = false;
      break;
    }
    f2 || (f2 = O3 == "constructor");
  }
  if (x2 && !f2) {
    var b5 = m3.constructor, h2 = H2.constructor;
    b5 != h2 && "constructor" in m3 && "constructor" in H2 && !(typeof b5 == "function" && b5 instanceof b5 && typeof h2 == "function" && h2 instanceof h2) && (x2 = false);
  }
  return K2.delete(m3), K2.delete(H2), x2;
}
var Fe$1 = re$1(Ht, "DataView"), ze = re$1(Ht, "Promise"), He = re$1(Ht, "Set"), Ge$1 = re$1(Ht, "WeakMap"), Pi = "[object Map]", yo = "[object Object]", Li = "[object Promise]", Oi = "[object Set]", Di = "[object WeakMap]", ji = "[object DataView]", vo = se$1(Fe$1), wo = se$1(le$1), Co = se$1(ze), ko = se$1(He), So = se$1(Ge$1), Kt$1 = ie$2;
(Fe$1 && Kt$1(new Fe$1(new ArrayBuffer(1))) != ji || le$1 && Kt$1(new le$1()) != Pi || ze && Kt$1(ze.resolve()) != Li || He && Kt$1(new He()) != Oi || Ge$1 && Kt$1(new Ge$1()) != Di) && (Kt$1 = function(m3) {
  var H2 = ie$2(m3), s2 = H2 == yo ? m3.constructor : void 0, at2 = s2 ? se$1(s2) : "";
  if (at2)
    switch (at2) {
      case vo:
        return ji;
      case wo:
        return Pi;
      case Co:
        return Li;
      case ko:
        return Oi;
      case So:
        return Di;
    }
  return H2;
});
var To = 1, Ni = "[object Arguments]", Ii = "[object Array]", me$1 = "[object Object]", Ao = Object.prototype, Bi = Ao.hasOwnProperty;
function Mo(m3, H2, s2, at2, B3, K2) {
  var q2 = Rt(m3), it2 = Rt(H2), rt2 = q2 ? Ii : Kt$1(m3), tt2 = it2 ? Ii : Kt$1(H2);
  rt2 = rt2 == Ni ? me$1 : rt2, tt2 = tt2 == Ni ? me$1 : tt2;
  var Z2 = rt2 == me$1, X2 = tt2 == me$1, O3 = rt2 == tt2;
  if (O3 && ve$1(m3)) {
    if (!ve$1(H2))
      return false;
    q2 = true, Z2 = false;
  }
  if (O3 && !Z2)
    return K2 || (K2 = new Ft()), q2 || _e(m3) ? ts(m3, H2, s2, at2, B3, K2) : vn(m3, H2, rt2, s2, at2, B3, K2);
  if (!(s2 & To)) {
    var j3 = Z2 && Bi.call(m3, "__wrapped__"), d3 = X2 && Bi.call(H2, "__wrapped__");
    if (j3 || d3) {
      var x2 = j3 ? m3.value() : m3, f2 = d3 ? H2.value() : H2;
      return K2 || (K2 = new Ft()), B3(x2, f2, s2, at2, K2);
    }
  }
  return O3 ? (K2 || (K2 = new Ft()), xo(m3, H2, s2, at2, B3, K2)) : false;
}
function Ke(m3, H2, s2, at2, B3) {
  return m3 === H2 ? true : m3 == null || H2 == null || !Jt$1(m3) && !Jt$1(H2) ? m3 !== m3 && H2 !== H2 : Mo(m3, H2, s2, at2, Ke, B3);
}
var Eo = 1, Po = 2;
function Lo(m3, H2, s2, at2) {
  var B3 = s2.length, K2 = B3;
  if (m3 == null)
    return !K2;
  for (m3 = Object(m3); B3--; ) {
    var q2 = s2[B3];
    if (q2[2] ? q2[1] !== m3[q2[0]] : !(q2[0] in m3))
      return false;
  }
  for (; ++B3 < K2; ) {
    q2 = s2[B3];
    var it2 = q2[0], rt2 = m3[it2], tt2 = q2[1];
    if (q2[2]) {
      if (rt2 === void 0 && !(it2 in m3))
        return false;
    } else {
      var Z2 = new Ft(), X2;
      if (!(X2 === void 0 ? Ke(tt2, rt2, Eo | Po, at2, Z2) : X2))
        return false;
    }
  }
  return true;
}
function ds(m3) {
  return m3 === m3 && !zt(m3);
}
function Oo(m3) {
  for (var H2 = cs(m3), s2 = H2.length; s2--; ) {
    var at2 = H2[s2], B3 = m3[at2];
    H2[s2] = [at2, B3, ds(B3)];
  }
  return H2;
}
function us(m3, H2) {
  return function(s2) {
    return s2 == null ? false : s2[m3] === H2 && (H2 !== void 0 || m3 in Object(s2));
  };
}
function Do(m3) {
  var H2 = Oo(m3);
  return H2.length == 1 && H2[0][2] ? us(H2[0][0], H2[0][1]) : function(s2) {
    return s2 === m3 || Lo(s2, m3, H2);
  };
}
var jo = "[object Symbol]";
function Ze(m3) {
  return typeof m3 == "symbol" || Jt$1(m3) && ie$2(m3) == jo;
}
var No = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Io = /^\w*$/;
function qe(m3, H2) {
  if (Rt(m3))
    return false;
  var s2 = typeof m3;
  return s2 == "number" || s2 == "symbol" || s2 == "boolean" || m3 == null || Ze(m3) ? true : Io.test(m3) || !No.test(m3) || H2 != null && m3 in Object(H2);
}
var Bo = "Expected a function";
function Je(m3, H2) {
  if (typeof m3 != "function" || H2 != null && typeof H2 != "function")
    throw new TypeError(Bo);
  var s2 = function() {
    var at2 = arguments, B3 = H2 ? H2.apply(this, at2) : at2[0], K2 = s2.cache;
    if (K2.has(B3))
      return K2.get(B3);
    var q2 = m3.apply(this, at2);
    return s2.cache = K2.set(B3, q2) || K2, q2;
  };
  return s2.cache = new (Je.Cache || Yt)(), s2;
}
Je.Cache = Yt;
var Ro = 500;
function Fo(m3) {
  var H2 = Je(m3, function(at2) {
    return s2.size === Ro && s2.clear(), at2;
  }), s2 = H2.cache;
  return H2;
}
var zo = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ho = /\\(\\)?/g, Go = Fo(function(m3) {
  var H2 = [];
  return m3.charCodeAt(0) === 46 && H2.push(""), m3.replace(zo, function(s2, at2, B3, K2) {
    H2.push(B3 ? K2.replace(Ho, "$1") : at2 || s2);
  }), H2;
}), Ri = qt ? qt.prototype : void 0, Fi = Ri ? Ri.toString : void 0;
function ps(m3) {
  if (typeof m3 == "string")
    return m3;
  if (Rt(m3))
    return qi(m3, ps) + "";
  if (Ze(m3))
    return Fi ? Fi.call(m3) : "";
  var H2 = m3 + "";
  return H2 == "0" && 1 / m3 == -1 / 0 ? "-0" : H2;
}
function Uo(m3) {
  return m3 == null ? "" : ps(m3);
}
function Ae$1(m3, H2) {
  return Rt(m3) ? m3 : qe(m3, H2) ? [m3] : Go(Uo(m3));
}
function ue$2(m3) {
  if (typeof m3 == "string" || Ze(m3))
    return m3;
  var H2 = m3 + "";
  return H2 == "0" && 1 / m3 == -1 / 0 ? "-0" : H2;
}
function Qe(m3, H2) {
  H2 = Ae$1(H2, m3);
  for (var s2 = 0, at2 = H2.length; m3 != null && s2 < at2; )
    m3 = m3[ue$2(H2[s2++])];
  return s2 && s2 == at2 ? m3 : void 0;
}
function $o(m3, H2, s2) {
  var at2 = m3 == null ? void 0 : Qe(m3, H2);
  return at2 === void 0 ? s2 : at2;
}
function Wo(m3, H2) {
  return m3 != null && H2 in Object(m3);
}
function Yo(m3, H2, s2) {
  H2 = Ae$1(H2, m3);
  for (var at2 = -1, B3 = H2.length, K2 = false; ++at2 < B3; ) {
    var q2 = ue$2(H2[at2]);
    if (!(K2 = m3 != null && s2(m3, q2)))
      break;
    m3 = m3[q2];
  }
  return K2 || ++at2 != B3 ? K2 : (B3 = m3 == null ? 0 : m3.length, !!B3 && Xe2(B3) && Se$1(q2, B3) && (Rt(m3) || ye$1(m3)));
}
function Xo(m3, H2) {
  return m3 != null && Yo(m3, H2, Wo);
}
var _o = 1, Vo = 2;
function Ko(m3, H2) {
  return qe(m3) && ds(H2) ? us(ue$2(m3), H2) : function(s2) {
    var at2 = $o(s2, m3);
    return at2 === void 0 && at2 === H2 ? Xo(s2, m3) : Ke(H2, at2, _o | Vo);
  };
}
function ti(m3) {
  return m3;
}
function Zo(m3) {
  return function(H2) {
    return H2 == null ? void 0 : H2[m3];
  };
}
function qo(m3) {
  return function(H2) {
    return Qe(H2, m3);
  };
}
function Jo(m3) {
  return qe(m3) ? Zo(ue$2(m3)) : qo(m3);
}
function Qo(m3) {
  return typeof m3 == "function" ? m3 : m3 == null ? ti : typeof m3 == "object" ? Rt(m3) ? Ko(m3[0], m3[1]) : Do(m3) : Jo(m3);
}
var we$1 = function() {
  try {
    var m3 = re$1(Object, "defineProperty");
    return m3({}, "", {}), m3;
  } catch {
  }
}();
function ei(m3, H2, s2) {
  H2 == "__proto__" && we$1 ? we$1(m3, H2, {
    configurable: true,
    enumerable: true,
    value: s2,
    writable: true
  }) : m3[H2] = s2;
}
var ta = Object.prototype, ea = ta.hasOwnProperty;
function gs(m3, H2, s2) {
  var at2 = m3[H2];
  (!(ea.call(m3, H2) && de$1(at2, s2)) || s2 === void 0 && !(H2 in m3)) && ei(m3, H2, s2);
}
function ia(m3, H2, s2, at2) {
  if (!zt(m3))
    return m3;
  H2 = Ae$1(H2, m3);
  for (var B3 = -1, K2 = H2.length, q2 = K2 - 1, it2 = m3; it2 != null && ++B3 < K2; ) {
    var rt2 = ue$2(H2[B3]), tt2 = s2;
    if (rt2 === "__proto__" || rt2 === "constructor" || rt2 === "prototype")
      return m3;
    if (B3 != q2) {
      var Z2 = it2[rt2];
      tt2 = void 0, tt2 === void 0 && (tt2 = zt(Z2) ? Z2 : Se$1(H2[B3 + 1]) ? [] : {});
    }
    gs(it2, rt2, tt2), it2 = it2[rt2];
  }
  return m3;
}
function sa(m3, H2, s2) {
  for (var at2 = -1, B3 = H2.length, K2 = {}; ++at2 < B3; ) {
    var q2 = H2[at2], it2 = Qe(m3, q2);
    s2(it2, q2) && ia(K2, Ae$1(q2, m3), it2);
  }
  return K2;
}
var ii = hs(Object.getPrototypeOf, Object), ra = Object.getOwnPropertySymbols, na = ra ? function(m3) {
  for (var H2 = []; m3; )
    es(H2, rs(m3)), m3 = ii(m3);
  return H2;
} : ss;
function oa(m3) {
  var H2 = [];
  if (m3 != null)
    for (var s2 in Object(m3))
      H2.push(s2);
  return H2;
}
var aa = Object.prototype, la = aa.hasOwnProperty;
function ha(m3) {
  if (!zt(m3))
    return oa(m3);
  var H2 = Ve(m3), s2 = [];
  for (var at2 in m3)
    at2 == "constructor" && (H2 || !la.call(m3, at2)) || s2.push(at2);
  return s2;
}
function si(m3) {
  return Te$1(m3) ? ls(m3, true) : ha(m3);
}
function ca(m3) {
  return is(m3, si, na);
}
function da(m3, H2) {
  if (m3 == null)
    return {};
  var s2 = qi(ca(m3), function(at2) {
    return [at2];
  });
  return H2 = Qo(H2), sa(m3, s2, function(at2, B3) {
    return H2(at2, B3[0]);
  });
}
function Ue2(m3, H2, s2) {
  (s2 !== void 0 && !de$1(m3[H2], s2) || s2 === void 0 && !(H2 in m3)) && ei(m3, H2, s2);
}
function ua(m3) {
  return function(H2, s2, at2) {
    for (var B3 = -1, K2 = Object(H2), q2 = at2(H2), it2 = q2.length; it2--; ) {
      var rt2 = q2[++B3];
      if (s2(K2[rt2], rt2, K2) === false)
        break;
    }
    return H2;
  };
}
var pa = ua(), fs = typeof exports == "object" && exports && !exports.nodeType && exports, zi = fs && typeof module == "object" && module && !module.nodeType && module, ga = zi && zi.exports === fs, Hi = ga ? Ht.Buffer : void 0;
Hi && Hi.allocUnsafe;
function fa(m3, H2) {
  return m3.slice();
}
function ma(m3) {
  var H2 = new m3.constructor(m3.byteLength);
  return new xe$1(H2).set(new xe$1(m3)), H2;
}
function ba(m3, H2) {
  var s2 = ma(m3.buffer);
  return new m3.constructor(s2, m3.byteOffset, m3.length);
}
function xa(m3, H2) {
  var s2 = -1, at2 = m3.length;
  for (H2 || (H2 = Array(at2)); ++s2 < at2; )
    H2[s2] = m3[s2];
  return H2;
}
var Gi = Object.create, ya = /* @__PURE__ */ function() {
  function m3() {
  }
  return function(H2) {
    if (!zt(H2))
      return {};
    if (Gi)
      return Gi(H2);
    m3.prototype = H2;
    var s2 = new m3();
    return m3.prototype = void 0, s2;
  };
}();
function va(m3) {
  return typeof m3.constructor == "function" && !Ve(m3) ? ya(ii(m3)) : {};
}
function wa(m3) {
  return Jt$1(m3) && Te$1(m3);
}
var Ca = "[object Object]", ka = Function.prototype, Sa = Object.prototype, ms = ka.toString, Ta = Sa.hasOwnProperty, Aa = ms.call(Object);
function Ma(m3) {
  if (!Jt$1(m3) || ie$2(m3) != Ca)
    return false;
  var H2 = ii(m3);
  if (H2 === null)
    return true;
  var s2 = Ta.call(H2, "constructor") && H2.constructor;
  return typeof s2 == "function" && s2 instanceof s2 && ms.call(s2) == Aa;
}
function $e(m3, H2) {
  if (!(H2 === "constructor" && typeof m3[H2] == "function") && H2 != "__proto__")
    return m3[H2];
}
function Ea(m3, H2, s2, at2) {
  var B3 = !s2;
  s2 || (s2 = {});
  for (var K2 = -1, q2 = H2.length; ++K2 < q2; ) {
    var it2 = H2[K2], rt2 = void 0;
    rt2 === void 0 && (rt2 = m3[it2]), B3 ? ei(s2, it2, rt2) : gs(s2, it2, rt2);
  }
  return s2;
}
function Pa(m3) {
  return Ea(m3, si(m3));
}
function La(m3, H2, s2, at2, B3, K2, q2) {
  var it2 = $e(m3, s2), rt2 = $e(H2, s2), tt2 = q2.get(rt2);
  if (tt2) {
    Ue2(m3, s2, tt2);
    return;
  }
  var Z2 = K2 ? K2(it2, rt2, s2 + "", m3, H2, q2) : void 0, X2 = Z2 === void 0;
  if (X2) {
    var O3 = Rt(rt2), j3 = !O3 && ve$1(rt2), d3 = !O3 && !j3 && _e(rt2);
    Z2 = rt2, O3 || j3 || d3 ? Rt(it2) ? Z2 = it2 : wa(it2) ? Z2 = xa(it2) : j3 ? (X2 = false, Z2 = fa(rt2)) : d3 ? (X2 = false, Z2 = ba(rt2)) : Z2 = [] : Ma(rt2) || ye$1(rt2) ? (Z2 = it2, ye$1(it2) ? Z2 = Pa(it2) : (!zt(it2) || Ye(it2)) && (Z2 = va(rt2))) : X2 = false;
  }
  X2 && (q2.set(rt2, Z2), B3(Z2, rt2, at2, K2, q2), q2.delete(rt2)), Ue2(m3, s2, Z2);
}
function bs(m3, H2, s2, at2, B3) {
  m3 !== H2 && pa(H2, function(K2, q2) {
    if (B3 || (B3 = new Ft()), zt(K2))
      La(m3, H2, q2, s2, bs, at2, B3);
    else {
      var it2 = at2 ? at2($e(m3, q2), K2, q2 + "", m3, H2, B3) : void 0;
      it2 === void 0 && (it2 = K2), Ue2(m3, q2, it2);
    }
  }, si);
}
function Oa(m3, H2, s2) {
  switch (s2.length) {
    case 0:
      return m3.call(H2);
    case 1:
      return m3.call(H2, s2[0]);
    case 2:
      return m3.call(H2, s2[0], s2[1]);
    case 3:
      return m3.call(H2, s2[0], s2[1], s2[2]);
  }
  return m3.apply(H2, s2);
}
var Ui = Math.max;
function Da(m3, H2, s2) {
  return H2 = Ui(H2 === void 0 ? m3.length - 1 : H2, 0), function() {
    for (var at2 = arguments, B3 = -1, K2 = Ui(at2.length - H2, 0), q2 = Array(K2); ++B3 < K2; )
      q2[B3] = at2[H2 + B3];
    B3 = -1;
    for (var it2 = Array(H2 + 1); ++B3 < H2; )
      it2[B3] = at2[B3];
    return it2[H2] = s2(q2), Oa(m3, this, it2);
  };
}
function ja(m3) {
  return function() {
    return m3;
  };
}
var Na = we$1 ? function(m3, H2) {
  return we$1(m3, "toString", {
    configurable: true,
    enumerable: false,
    value: ja(H2),
    writable: true
  });
} : ti, Ia = 800, Ba = 16, Ra = Date.now;
function Fa(m3) {
  var H2 = 0, s2 = 0;
  return function() {
    var at2 = Ra(), B3 = Ba - (at2 - s2);
    if (s2 = at2, B3 > 0) {
      if (++H2 >= Ia)
        return arguments[0];
    } else
      H2 = 0;
    return m3.apply(void 0, arguments);
  };
}
var za = Fa(Na);
function Ha(m3, H2) {
  return za(Da(m3, H2, ti), m3 + "");
}
function Ga(m3, H2, s2) {
  if (!zt(s2))
    return false;
  var at2 = typeof H2;
  return (at2 == "number" ? Te$1(s2) && Se$1(H2, s2.length) : at2 == "string" && H2 in s2) ? de$1(s2[H2], m3) : false;
}
function Ua(m3) {
  return Ha(function(H2, s2) {
    var at2 = -1, B3 = s2.length, K2 = B3 > 1 ? s2[B3 - 1] : void 0, q2 = B3 > 2 ? s2[2] : void 0;
    for (K2 = m3.length > 3 && typeof K2 == "function" ? (B3--, K2) : void 0, q2 && Ga(s2[0], s2[1], q2) && (K2 = B3 < 3 ? void 0 : K2, B3 = 1), H2 = Object(H2); ++at2 < B3; ) {
      var it2 = s2[at2];
      it2 && m3(H2, it2, at2, K2);
    }
    return H2;
  });
}
var $a = Ua(function(m3, H2, s2, at2) {
  bs(m3, H2, s2, at2);
}), Wa = Object.defineProperty, Ya = Object.getOwnPropertyDescriptor, Lt = (m3, H2, s2, at2) => {
  for (var B3 = at2 > 1 ? void 0 : at2 ? Ya(H2, s2) : H2, K2 = m3.length - 1, q2; K2 >= 0; K2--)
    (q2 = m3[K2]) && (B3 = (at2 ? q2(H2, s2, B3) : q2(B3)) || B3);
  return at2 && B3 && Wa(H2, s2, B3), B3;
};
const Xa = ["top", "middle", "bottom"], _a = ["center", "right"], Va = ["horizontal", "vertical"];
function Ka(m3) {
  return typeof m3.legendWidth == "number";
}
function Za(m3) {
  return typeof m3.maxLegendWidth == "number";
}
function $i(m3) {
  return m3.a11yProxyElement !== void 0;
}
function Wi(m3) {
  return m3.a11yProxyElement !== void 0;
}
var At;
const Pt = (At = class extends Bt$3 {
  constructor() {
    super(...arguments), this.resetSpacing = true, this._type = te$2.LINE, this.series = [], this.options = {}, this.staticLegend = false, this.disableLegend = false, this.hideLegendMetric = false, this.legendLayout = At.defaultLegendLayout, this.tooltipTitle = "", this.tooltipFooter = "", this.tooltipVariant = oe$1.SINGLE_LINE, this.disableMarkers = false, this.percentage = false, this.decimal = false, this.decimalPlaces = 1, this.chart = null, this.filteredOptions = {}, this.colorOrder = $t.STANDARD;
  }
  static get styles() {
    return [super.styles, Is, Ks];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, xi];
  }
  /**
   * The type of chart being rendered. Follows Highcharts chart types.
   * @abstract
   */
  get type() {
    return this._type;
  }
  /**
   * Local options defined on the component-level.
   * @abstract
   */
  get localComponentOptions() {
    return {};
  }
  /**
   * Global chart options applicable to all charts.
   */
  get chartOptions() {
    const m3 = this.hideLegendMetric, H2 = this.percentage, s2 = this.decimal, at2 = this.decimalPlaces, B3 = this.type, K2 = this.addBeaconModeToTooltipContainer.bind(this);
    return {
      accessibility: {
        linkedDescription: this.linkedDescriptionNode
      },
      chart: {
        animation: false,
        colorCount: 12,
        events: {
          /**
           * @this Chart
           *
           * On redraw, we assign styles and classes to the legend items so they can match our design spec.
           * Since we use custom HTML in the formatter, this is not captured on a persistant basis by Highcharts.
           */
          redraw() {
            var q2, it2, rt2;
            if ("hasLoaded" in this && this.hasLoaded) {
              const tt2 = (rt2 = (it2 = (q2 = this.userOptions) == null ? void 0 : q2.plotOptions) == null ? void 0 : it2.custom) == null ? void 0 : rt2.host;
              if (tt2 && tt2.staticLegend)
                return false;
              const { allItems: Z2 } = this.legend;
              Z2.forEach((X2) => {
                if (X2 instanceof Qt$1.Point && $i(X2) || X2 instanceof Qt$1.Series && Wi(X2)) {
                  const {
                    a11yProxyElement: {
                      target: { visual: O3 }
                    }
                  } = X2;
                  if (tt2 == null || tt2.style.setProperty(
                    "--legend-max-width",
                    O3.style.getPropertyValue("width")
                  ), O3.dataset.beaconRedrawEvent !== "attached") {
                    const j3 = O3.firstElementChild;
                    O3.addEventListener(
                      "mouseover",
                      (d3) => {
                        j3 == null || j3.classList.add(
                          "beacon-legend-item--hover"
                        ), (!d3.x || !d3.y) && (j3 == null || j3.classList.add(
                          "beacon-legend-item--focus"
                        ));
                      }
                    ), O3.addEventListener("mouseout", () => {
                      Z2.forEach((d3) => {
                        var x2;
                        if (d3 instanceof Qt$1.Point && $i(d3) || d3 instanceof Qt$1.Series && Wi(d3)) {
                          const {
                            a11yProxyElement: {
                              target: { visual: f2 }
                            }
                          } = d3;
                          (x2 = f2 == null ? void 0 : f2.firstElementChild) == null || x2.classList.remove(
                            "beacon-legend-item--hover",
                            "beacon-legend-item--focus"
                          );
                        }
                      });
                    });
                  }
                  O3.dataset.beaconRedrawEvent = "attached", At.setLegendWidthVariable(this);
                }
              });
            }
            this.reflow();
          }
        },
        // Highcharts default is 400
        // Previous version of Charts didn't take Legend height into account
        // We increase the default height to counteract a possible squished chart
        height: _i.HEIGHT,
        styledMode: true,
        type: this.type
      },
      credits: {
        enabled: false
      },
      legend: {
        accessibility: {
          keyboardNavigation: {
            enabled: !this.staticLegend
          }
        },
        align: "center",
        alignColumns: false,
        enabled: !this.disableLegend,
        labelFormatter() {
          return At.legendItemHTML(
            this,
            m3,
            H2,
            B3,
            s2,
            at2
          );
        },
        itemDistance: parseFloat(p$6) * 16,
        itemMarginBottom: parseFloat(p$6) * 16,
        itemMarginTop: 0,
        layout: this.legendLayout.direction,
        navigation: {
          enabled: false
        },
        symbolRadius: 0,
        symbolPadding: 0,
        symbolWidth: 0,
        useHTML: true,
        verticalAlign: "bottom",
        width: "100%",
        events: {
          /**
           * @this Series
           *
           * We reverse click interaction on legend items. Instead of toggling off, we toggle isolation and "on" state.
           */
          itemClick: function(q2) {
            var it2, rt2, tt2;
            q2.preventDefault();
            const { chart: Z2 } = this, X2 = (tt2 = (rt2 = (it2 = Z2 == null ? void 0 : Z2.userOptions) == null ? void 0 : it2.plotOptions) == null ? void 0 : rt2.custom) == null ? void 0 : tt2.host;
            if (X2 && X2.staticLegend)
              return false;
            const { series: O3 } = Z2, j3 = O3.filter((x2) => x2.visible).length === O3.length, d3 = O3.find(
              (x2) => q2.legendItem instanceof Qt$1.Series && x2.name === q2.legendItem.name
            );
            d3 && (O3.length > 1 && j3 ? O3.forEach((x2) => {
              q2.legendItem instanceof Qt$1.Series && x2.update(
                {
                  visible: x2.name === q2.legendItem.name
                },
                false
              );
            }) : d3.update(
              {
                visible: !d3.visible
              },
              false
            ), Z2.redraw(), Z2.reflow());
          }
        }
      },
      plotOptions: {
        custom: {
          host: this
        }
      },
      responsive: {
        rules: [
          {
            condition: {
              minWidth: parseInt(C$6, 10)
            },
            chartOptions: {
              legend: {
                align: this.legendLayout.horizontal,
                // center, right
                verticalAlign: At.setLegendVerticalAlignment(
                  this.legendLayout
                ),
                width: At.setLegendWidth(this.legendLayout)
              }
            }
          }
        ]
      },
      series: this.series,
      subtitle: {
        text: void 0
      },
      symbols: [...Object.values(Zt$1)],
      title: {
        text: void 0
      },
      tooltip: {
        borderRadius: parseFloat(m$8) * 16,
        className: this.getTooltipClasses(),
        footerFormat: At.tooltipFooterHTML(
          At.tooltipFooterContentHTML(this.tooltipFooter)
        ),
        headerFormat: At.tooltipHeaderHTML(this.tooltipTitle),
        outside: true,
        padding: At.tooltipPadding(this.tooltipVariant),
        pointFormatter() {
          return K2(), At.tooltipPointHTML(
            this,
            this.series.name,
            this.y
          );
        },
        shadow: {
          color: r$8
        },
        shared: this.tooltipVariant === oe$1.MULTI_LINE,
        useHTML: true
      }
    };
  }
  /**
   * Adds a beacon mode class to the Highcharts tooltip container.
   */
  addBeaconModeToTooltipContainer() {
    const m3 = this.closest('[class*="beacon-on"]');
    setTimeout(() => {
      const H2 = document.querySelector(
        ".highcharts-tooltip-container"
      );
      if (H2 && m3) {
        const s2 = Array.from(H2.classList).find(
          (B3) => B3.startsWith("beacon-on")
        ), at2 = Array.from(
          m3.classList
        ).find((B3) => B3.startsWith("beacon-on"));
        s2 !== at2 && (s2 && H2.classList.remove(s2), at2 && H2.classList.add(at2));
      }
    }, 0);
  }
  /** Parses the legend layout from a string of options. */
  static createLegendLayout(m3) {
    if (!m3)
      return this.defaultLegendLayout;
    const H2 = zs(m3);
    if (!H2)
      return this.defaultLegendLayout;
    const s2 = H2.find(
      (K2) => Xa.includes(K2)
    ) || this.defaultLegendLayout.vertical, at2 = H2.find(
      (K2) => _a.includes(K2)
    ) || this.defaultLegendLayout.horizontal;
    let B3 = H2.find(
      (K2) => Va.includes(K2)
    ) || this.defaultLegendLayout.direction;
    return H2.includes("row") ? B3 = "horizontal" : H2.includes("column") && (B3 = "vertical"), {
      vertical: s2,
      horizontal: at2,
      direction: B3
    };
  }
  /**
   * Sets a CSS variable on the host that helps control the width of the legend items in a vertical state.
   *
   * Takes into account the active and max widths of the Legend, as well as what direction the Legend is in.
   */
  static setLegendWidthVariable(m3, H2 = false) {
    var s2, at2, B3, K2, q2, it2, rt2, tt2;
    const Z2 = (at2 = (s2 = m3.legend) == null ? void 0 : s2.options) == null ? void 0 : at2.layout, X2 = (K2 = (B3 = m3.legend) == null ? void 0 : B3.options) == null ? void 0 : K2.align, O3 = Ka(m3.legend) ? m3.legend.legendWidth : 0, j3 = Za(m3.legend) ? (q2 = m3.legend) == null ? void 0 : q2.maxLegendWidth : 0, d3 = Math.min(j3, O3), x2 = (tt2 = (rt2 = (it2 = m3.userOptions) == null ? void 0 : it2.plotOptions) == null ? void 0 : rt2.custom) == null ? void 0 : tt2.host, f2 = x2 == null ? void 0 : x2.style.getPropertyValue("--legend-width");
    H2 && (x2 == null || x2.style.removeProperty("--legend-width"));
    let C3 = "auto", o2;
    Z2 === "vertical" && (o2 = d3, f2 && (x2 == null || x2.style.setProperty("--legend-width", o2 + "px")), f2 && X2 === "right" ? C3 = f2 : C3 = o2 ? o2 + "px" : "auto"), x2 == null || x2.style.setProperty("--legend-width", C3);
  }
  /** HTML for the Legend label. */
  static legendItemHTML(m3, H2, s2, at2, B3, K2) {
    var q2, it2;
    const { name: rt2, index: tt2 } = m3;
    let Z2 = "";
    if (at2 === te$2.GAUGE && !H2) {
      const X2 = ((q2 = m3 == null ? void 0 : m3.data[0]) == null ? void 0 : q2.y) != null && m3.yAxis.userOptions.min != null ? m3.data[0].y - m3.yAxis.userOptions.min : (it2 = m3 == null ? void 0 : m3.data[0]) == null ? void 0 : it2.y, O3 = m3.yAxis.userOptions.max != null && m3.yAxis.userOptions.min != null ? m3.yAxis.userOptions.max - m3.yAxis.userOptions.min : m3.yAxis.userOptions.max;
      Z2 = `<span class="beacon-legend-item__value">${At.percentageFormatter(s2, X2, O3, B3, K2)}</span>`;
    }
    return at2 === te$2.PIE && !H2 && (Z2 = `<span class="beacon-legend-item__value">${At.percentageFormatter(s2, m3.y, m3.total, B3, K2)}</span>`), `
      <div class="beacon-legend-item beacon-legend-item--${tt2}" style="inline-size: var(--legend-width); max-inline-size: var(--legend-max-width, none);">
        <div class="beacon-legend-item__label">
          ${je$1(tt2, false, at2)}
          <span class="beacon-legend-item__label-text">${rt2}</span>${Z2}
        </div>
      </div>
    `;
  }
  /** Forces Legend vertical alignment if necessary, but otherwise will return the requested value. */
  static setLegendVerticalAlignment({
    horizontal: m3,
    vertical: H2
  }) {
    return m3 === "center" ? "bottom" : H2;
  }
  /** Set the width of the Legend which depends on both alignment and direction. */
  static setLegendWidth({
    horizontal: m3,
    vertical: H2,
    direction: s2
  }) {
    if (s2 === "horizontal" && H2 !== "middle")
      return "100%";
    if (s2 === "vertical")
      return m3 === "center" ? "100%" : "33%";
  }
  /** HTML classes for the tooltip's elements. */
  getTooltipClasses() {
    return `beacon-chart-tooltip ${this.tooltipVariant} ${this.colorOrder}`.trim();
  }
  /** Sets the padding on the Tooltip based on variant. */
  static tooltipPadding(m3) {
    const H2 = parseFloat(s$7), s2 = parseFloat(
      e$5
    );
    let at2 = H2;
    return m3 !== oe$1.SINGLE_LINE && (at2 = H2 + s2), at2 * 16;
  }
  /**
   * HTML for the chart tooltip point.
   *
   * Can be used as a helper method for overrides to the point formatter.
   *
   * @example
   * ```ts
   * // Format the value before passing it to the tooltip.
   *
   * const options = {
   *   tooltip: {
   *    pointFormatter() {
   *      const { y } = this;
   *      const percentage = y / 100;
   *
   *      return BeaconChartBase.tooltipPointHTML(this, this.series.name, percentage);
   *    }
   *   }
   * }
   * ```
   */
  static tooltipPointHTML(m3, H2, s2, at2) {
    let B3;
    return s2 && Number(s2) < 0 ? B3 = "negative" : B3 = "positive", `
      <div class="beacon-chart-tooltip__point highcharts-color-${m3.colorIndex} ${B3}">
        <div class="beacon-chart-tooltip-point__label">
          ${at2 ? "" : je$1(m3.colorIndex || 0)}
          <span class="beacon-chart-tooltip-point__label-text">${H2}</span>
        </div>
        ${s2 ? `<div class="beacon-chart-tooltip__point-value">${s2}</div>` : ""}
      </div>
    `;
  }
  /** HTML for the Tooltip Title (Header). */
  static tooltipHeaderHTML(m3) {
    return m3 ? `<div class="beacon-chart-tooltip__title">${m3}</div>` : "";
  }
  /** HTML for the Tooltip's additional content slot (Footer). */
  static tooltipFooterContentHTML(m3) {
    return m3 ? `<div class="beacon-chart-tooltip__additional-content">${m3}</div>` : "";
  }
  /** HTML for the Tooltip footer that can include both multi-level content and the additional slot content. */
  static tooltipFooterHTML(m3, H2) {
    return !m3 && !H2 ? "" : `
      <div class="beacon-chart-tooltip__footer">
        ${H2 ? `<hr class="beacon-chart-tooltip__separator"/>${H2}` : ""}
        ${m3 || ""}
      </div>
    `;
  }
  /** HTML for the Tooltip Point belonging to multi-level tooltips. */
  static multiLevelTooltipPointHTML(m3, H2, s2) {
    return `
      <div class="beacon-chart-tooltip__point beacon-chart-tooltip__point--multi-level">
        <div class="beacon-chart-tooltip-point__label">
          ${s2 ? "" : je$1(0, true)}
          <span class="beacon-chart-tooltip-point__label-text">${m3}</span>
        </div>
        ${H2 ? `<div class="beacon-chart-tooltip__point-value">${H2}</div>` : ""}
      </div>
    `;
  }
  /** Modify user-supplied options by filtering out keys not leveraged or not accessible by our component. */
  static filterChartOptions(m3) {
    return da(m3, (H2, s2) => !this.disallowedChartOptions.includes(s2));
  }
  /** Merge all possible chart options into a single object. */
  static createChartOptions(...m3) {
    return $a(
      {},
      ...m3,
      function(H2, s2) {
        if (Rt(H2))
          return H2.concat(s2);
      }
    );
  }
  /** Update Highcharts accessibility data when the caption changes. */
  handleCaptionSlotchange() {
    var m3;
    (m3 = this.chart) == null || m3.update({
      accessibility: {
        linkedDescription: this.linkedDescriptionNode
      }
    });
  }
  /**
   * Apply modifications and modules to the Highcharts package.
   *
   * @todo Exhaust any options for API-styling before DOM manipulation. Keep in mind the symbol is separate from the button of the text label.
   */
  initializeHighcharts(m3) {
    m3.AST.allowedAttributes.push("transform", "viewbox", "viewBox", "xmlns"), Rs(m3), m3.addEvent(m3.Legend, "afterRender", function() {
      "hasLoaded" in this.chart && this.chart.hasLoaded && (this.chart.reflow(), At.setLegendWidthVariable(this.chart));
    }), m3.addEvent(m3.Chart, "load", this.onChartLoad), m3.addEvent(m3.Chart, "redraw", this.onChartRedraw);
  }
  /**
   * Callback when Highcharts initially loads the chart.
   * @abstract
   */
  onChartLoad(m3) {
  }
  /**
   * Callback when Highcharts redraws an existing chart.
   * @abstract
   */
  onChartRedraw(m3) {
  }
  /**
   * Calculates total series for use in chart modifications or restrictions.
   *
   * Calculation of the series length may vary by type of chart.
   */
  calculateSeriesLength(m3) {
    var H2;
    return (H2 = m3.series) == null ? void 0 : H2.length;
  }
  /** Determines the color order by length of series in the chart. */
  static calculateColorOrder(m3) {
    return typeof m3 == "number" && m3 > 6 ? $t.EXTENDED : $t.STANDARD;
  }
  /** Sets the class related to the color order on the host component. */
  applyColorOrder(m3) {
    var H2;
    switch (m3) {
      case $t.EXTENDED:
        this.classList.toggle($t.EXTENDED, true);
        break;
      case $t.STANDARD:
      default:
        this.classList.toggle($t.STANDARD, true);
        break;
    }
    (H2 = this.chart) == null || H2.update({
      tooltip: {
        className: this.getTooltipClasses()
      }
    });
  }
  setChart() {
    try {
      return this.chart = this.createChart(), this.chart;
    } catch (m3) {
      return console.error(m3), this.chart;
    }
  }
  setFilteredOptions() {
    this.filteredOptions = At.filterChartOptions(this.options);
  }
  createChart() {
    const m3 = At.createChartOptions(
      this.chartOptions,
      this.localComponentOptions,
      this.filteredOptions
    );
    return mi.chart(this.chartContainer, m3);
  }
  updateChart(m3) {
    var H2;
    (H2 = this.chart) == null || H2.update(m3, true, true), this.improveChartAccessibility();
  }
  static percentageFormatter(m3, H2, s2, at2, B3) {
    let K2;
    return m3 && H2 != null && s2 != null ? K2 = `${(100 * (H2 / (s2 || 100))).toFixed(at2 ? B3 : 0)}%` : H2 != null ? K2 = `${Math.round(H2)}` : K2 = "N/A", K2;
  }
  /* Since we are rendering highcharts tooltip outside of the shadow DOM, we need to append the lightDOM styles to body.
   */
  static appendLightDOMStyles() {
    var m3, H2;
    if (!document.getElementById("beacon-chart-light-DOM-styles")) {
      const s2 = document.createElement("style");
      s2.id = "beacon-chart-light-DOM-styles", s2.textContent = (m3 = xi) == null ? void 0 : m3.toString(), (H2 = document == null ? void 0 : document.body) == null || H2.append(s2);
    }
  }
  chartBaseInit() {
    this.initializeHighcharts(mi), At.appendLightDOMStyles();
  }
  chartLoaded() {
    var m3;
    this.setChart(), (m3 = this.chart) == null || m3.reflow();
  }
  /**
   * Removes tab sequential navigation for a button element rendered from HighChart Accessibility module when using the Export Data HighCharts module.
   * We have a github issue open with HighCharts (https://github.com/highcharts/highcharts/issues/22682).
   * TODO: Remove when HighCharts fixes issue
   */
  improveChartAccessibility() {
    var m3;
    const H2 = (m3 = this.chartContainer) == null ? void 0 : m3.querySelector(
      "[id^=hc-linkto-highcharts-data-table-]"
    );
    H2 == null || H2.setAttribute("tabindex", "-1"), H2 == null || H2.setAttribute("aria-expanded", "false");
  }
  willUpdate(m3) {
    var H2;
    (H2 = super.willUpdate) == null || H2.call(this, m3);
    const s2 = this.hideLegendMetric, at2 = this.percentage, B3 = this.decimal, K2 = this.decimalPlaces, q2 = this.type;
    if (this.chart) {
      if (m3.has("chart")) {
        const { chartHeight: it2, chartWidth: rt2, plotHeight: tt2, plotWidth: Z2 } = this.chart;
        this.chartSize = {
          chartHeight: it2,
          chartWidth: rt2,
          plotHeight: tt2,
          plotWidth: Z2
        };
      }
      m3.has("series") && this.updateChart({ series: this.series }), this.seriesLength = this.calculateSeriesLength(this.chart), this.colorOrder = At.calculateColorOrder(this.seriesLength), this.applyColorOrder(this.colorOrder), this.chart.reflow();
    }
    m3.has("options") && this.options && (this.setFilteredOptions(), this.updateChart(this.filteredOptions)), m3.has("legendLayout") && this.legendLayout && this.updateChart({
      legend: {
        align: this.legendLayout.horizontal,
        layout: this.legendLayout.direction,
        labelFormatter() {
          return At.legendItemHTML(
            this,
            s2,
            at2,
            q2,
            B3,
            K2
          );
        },
        verticalAlign: At.setLegendVerticalAlignment(
          this.legendLayout
        ),
        width: At.setLegendWidth(this.legendLayout)
      }
    }), (m3.has("hideLegendMetric") || m3.has("percentage") || m3.has("decimal") || m3.has("decimalPlaces")) && this.updateChart({
      legend: {
        labelFormatter() {
          return At.legendItemHTML(
            this,
            s2,
            at2,
            q2,
            B3,
            K2
          );
        }
      }
    }), m3.has("disableLegend") && this.updateChart({
      legend: { enabled: !this.disableLegend }
    }), m3.has("tooltipTitle") && this.updateChart({
      tooltip: {
        headerFormat: At.tooltipHeaderHTML(this.tooltipTitle)
      }
    }), m3.has("tooltipFooter") && this.updateChart({
      tooltip: {
        footerFormat: At.tooltipFooterHTML(this.tooltipFooter)
      }
    }), m3.has("tooltipVariant") && this.tooltipVariant && this.updateChart({
      tooltip: {
        padding: At.tooltipPadding(this.tooltipVariant),
        shared: this.tooltipVariant === oe$1.MULTI_LINE
      }
    });
  }
  render() {
    const m3 = {
      chart: true,
      "highcharts-light": true,
      "static-legend": this.staticLegend
    };
    m3["chart--" + this.type] = true;
    const H2 = {
      caption: true
    };
    return tt$1`
      <figure class="base">
        <div class="header">
          <div class="header-text">
            <div class="title" id="title">
              <slot name="title" ${f$7({ container: ".header" })}></slot>
            </div>
            <div class="subtitle" id="subtitle">
              <slot
                name="subtitle"
                ${f$7({ container: ".header" })}></slot>
            </div>
          </div>
          <div class="menu"></div>
        </div>
        <!-- Force Highcharts light theme -->
        <div
          role="region"
          class=${f$6(m3)}
          legend-layout="${Object.values(this.legendLayout).join(" ")}"
          aria-labelledby="title"
          aria-describedby="subtitle"></div>
        <figcaption class=${f$6(H2)}>
          <slot
            name="caption"
            @slotchange=${this.handleCaptionSlotchange}
            ${f$7({ useParent: true })}></slot>
        </figcaption>
      </figure>
    `;
  }
}, At.nestedComponents = ["beacon-table"], At.disallowedChartOptions = [
  "colors",
  "title",
  "caption",
  "subtitle"
], At.defaultLegendLayout = {
  direction: "horizontal",
  horizontal: "center",
  vertical: "bottom"
}, At);
Lt([
  v$c({
    type: Array
  })
], Pt.prototype, "series", 2);
Lt([
  v$c({
    type: Object
  })
], Pt.prototype, "options", 2);
Lt([
  v$c({ attribute: "static-legend", type: Boolean, reflect: true })
], Pt.prototype, "staticLegend", 2);
Lt([
  v$c({ attribute: "disable-legend", type: Boolean })
], Pt.prototype, "disableLegend", 2);
Lt([
  v$c({ attribute: "hide-legend-metric", type: Boolean })
], Pt.prototype, "hideLegendMetric", 2);
Lt([
  v$c({
    attribute: "legend-layout",
    converter: (m3) => Pt.createLegendLayout(m3)
  })
], Pt.prototype, "legendLayout", 2);
Lt([
  v$c({ attribute: "tooltip-title" })
], Pt.prototype, "tooltipTitle", 2);
Lt([
  v$c({ attribute: "tooltip-footer" })
], Pt.prototype, "tooltipFooter", 2);
Lt([
  v$c({ attribute: "tooltip-variant" })
], Pt.prototype, "tooltipVariant", 2);
Lt([
  v$c({ attribute: "disable-markers", type: Boolean })
], Pt.prototype, "disableMarkers", 2);
Lt([
  v$c({ type: Boolean })
], Pt.prototype, "percentage", 2);
Lt([
  v$c({ type: Boolean })
], Pt.prototype, "decimal", 2);
Lt([
  v$c({ attribute: "decimal-places", type: Number })
], Pt.prototype, "decimalPlaces", 2);
Lt([
  it()
], Pt.prototype, "chart", 2);
Lt([
  k$a('[slot="caption"]')
], Pt.prototype, "linkedDescriptionNode", 2);
Lt([
  h$9(".chart")
], Pt.prototype, "chartContainer", 2);
Lt([
  u$2
], Pt.prototype, "chartBaseInit", 1);
Lt([
  d$e
], Pt.prototype, "chartLoaded", 1);
let qa = Pt;
var xs = { exports: {} };
(function(m3) {
  (function(H2) {
    m3.exports ? (H2.default = H2, m3.exports = H2) : H2(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(H2) {
    var s2 = H2 ? H2._modules : {};
    function at2(B3, K2, q2, it2) {
      B3.hasOwnProperty(K2) || (B3[K2] = it2.apply(null, q2), typeof CustomEvent == "function" && H2.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: K2, module: B3[K2] } })));
    }
    at2(s2, "Core/HttpUtilities.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { win: q2 } = B3, { discardElement: it2, objectEach: rt2 } = K2, tt2 = { ajax: function(Z2) {
        let X2 = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, O3 = new XMLHttpRequest();
        function j3(d3, x2) {
          Z2.error && Z2.error(d3, x2);
        }
        if (!Z2.url) return false;
        O3.open((Z2.type || "get").toUpperCase(), Z2.url, true), Z2.headers && Z2.headers["Content-Type"] || O3.setRequestHeader("Content-Type", X2[Z2.dataType || "json"] || X2.text), rt2(Z2.headers, function(d3, x2) {
          O3.setRequestHeader(x2, d3);
        }), Z2.responseType && (O3.responseType = Z2.responseType), O3.onreadystatechange = function() {
          let d3;
          if (O3.readyState === 4) {
            if (O3.status === 200) {
              if (Z2.responseType !== "blob" && (d3 = O3.responseText, Z2.dataType === "json")) try {
                d3 = JSON.parse(d3);
              } catch (x2) {
                if (x2 instanceof Error) return j3(O3, x2);
              }
              return Z2.success && Z2.success(d3, O3);
            }
            j3(O3, O3.responseText);
          }
        }, Z2.data && typeof Z2.data != "string" && (Z2.data = JSON.stringify(Z2.data)), O3.send(Z2.data);
      }, getJSON: function(Z2, X2) {
        tt2.ajax({ url: Z2, success: X2, dataType: "json", headers: { "Content-Type": "text/plain" } });
      }, post: function(Z2, X2, O3) {
        let j3 = new q2.FormData();
        rt2(X2, function(f2, C3) {
          j3.append(C3, f2);
        }), j3.append("b64", "true");
        let { filename: d3, type: x2 } = X2;
        return q2.fetch(Z2, { method: "POST", body: j3, ...O3 }).then((f2) => {
          f2.ok && f2.text().then((C3) => {
            let o2 = document.createElement("a");
            o2.href = `data:${x2};base64,${C3}`, o2.download = d3, o2.click(), it2(o2);
          });
        });
      } };
      return tt2;
    }), at2(s2, "Extensions/Data.js", [s2["Core/Axis/Axis.js"], s2["Core/Chart/Chart.js"], s2["Core/Defaults.js"], s2["Core/Globals.js"], s2["Core/HttpUtilities.js"], s2["Core/Series/Point.js"], s2["Core/Series/SeriesRegistry.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2) {
      let { getOptions: O3 } = q2, { doc: j3 } = it2, { ajax: d3 } = rt2, { seriesTypes: x2 } = Z2, { addEvent: f2, defined: C3, extend: o2, fireEvent: p2, isNumber: b5, merge: h2, objectEach: c4, pick: T2, splat: I3 } = X2;
      function G2(y2) {
        return !!(y2 && (y2.rowsURL || y2.csvURL || y2.columnsURL));
      }
      class L2 {
        static data(i5, t3 = {}, e5) {
          return new L2(i5, t3, e5);
        }
        static rowsToColumns(i5) {
          let t3, e5, n4, u2, a2;
          if (i5) for (t3 = 0, a2 = [], e5 = i5.length; t3 < e5; t3++) for (n4 = 0, u2 = i5[t3].length; n4 < u2; n4++) a2[n4] || (a2[n4] = []), a2[n4][t3] = i5[t3][n4];
          return a2;
        }
        constructor(i5, t3 = {}, e5) {
          this.rowsToColumns = L2.rowsToColumns, this.dateFormats = { "YYYY/mm/dd": { regex: /^(\d{4})[\-\/\.](\d{1,2})[\-\/\.](\d{1,2})$/, parser: function(n4) {
            return n4 ? Date.UTC(+n4[1], +n4[2] - 1, +n4[3]) : NaN;
          } }, "dd/mm/YYYY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/, parser: function(n4) {
            return n4 ? Date.UTC(+n4[3], +n4[2] - 1, +n4[1]) : NaN;
          }, alternative: "mm/dd/YYYY" }, "mm/dd/YYYY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/, parser: function(n4) {
            return n4 ? Date.UTC(+n4[3], +n4[1] - 1, +n4[2]) : NaN;
          } }, "dd/mm/YY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/, parser: function(n4) {
            if (!n4) return NaN;
            let u2 = /* @__PURE__ */ new Date(), a2 = +n4[3];
            return a2 > u2.getFullYear() - 2e3 ? a2 += 1900 : a2 += 2e3, Date.UTC(a2, +n4[2] - 1, +n4[1]);
          }, alternative: "mm/dd/YY" }, "mm/dd/YY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/, parser: function(n4) {
            return n4 ? Date.UTC(+n4[3] + 2e3, +n4[1] - 1, +n4[2]) : NaN;
          } } }, this.chart = e5, this.chartOptions = t3, this.options = i5, this.rawColumns = [], this.init(i5, t3, e5);
        }
        init(i5, t3, e5) {
          let n4 = i5.decimalPoint, u2;
          t3 && (this.chartOptions = t3), e5 && (this.chart = e5), n4 !== "." && n4 !== "," && (n4 = void 0), this.options = i5, this.columns = i5.columns || this.rowsToColumns(i5.rows) || [], this.firstRowAsNames = T2(i5.firstRowAsNames, this.firstRowAsNames, true), this.decimalRegex = n4 && RegExp("^(-?[0-9]+)" + n4 + "([0-9]+)$"), this.liveDataTimeout !== void 0 && clearTimeout(this.liveDataTimeout), this.rawColumns = [], this.columns.length && (this.dataFound(), u2 = !G2(i5)), u2 || (u2 = this.fetchLiveData()), u2 || (u2 = !!this.parseCSV().length), u2 || (u2 = !!this.parseTable().length), u2 || (u2 = this.parseGoogleSpreadsheet()), !u2 && i5.afterComplete && i5.afterComplete(this);
        }
        getColumnDistribution() {
          var i5, t3;
          let e5 = this.chartOptions, n4 = this.options, u2 = [], a2 = function(z2 = "line") {
            return (x2[z2].prototype.pointArrayMap || [0]).length;
          }, g2 = function(z2 = "line") {
            return x2[z2].prototype.pointArrayMap;
          }, r3 = (i5 = e5 == null ? void 0 : e5.chart) == null ? void 0 : i5.type, A3 = [], N2 = [], k3 = (n4 == null ? void 0 : n4.seriesMapping) || ((t3 = e5 == null ? void 0 : e5.series) == null ? void 0 : t3.map(function() {
            return { x: 0 };
          })) || [], E2 = 0;
          ((e5 == null ? void 0 : e5.series) || []).forEach((z2) => {
            A3.push(a2(z2.type || r3));
          }), k3.forEach((z2) => {
            u2.push(z2.x || 0);
          }), u2.length === 0 && u2.push(0), k3.forEach((z2) => {
            var Q2, v3;
            let S2 = new l4(), P2 = A3[E2] || a2(r3), U2 = (v3 = ((Q2 = e5 == null ? void 0 : e5.series) != null ? Q2 : [])[E2]) != null ? v3 : {}, w2 = g2(U2.type || r3), M2 = w2 != null ? w2 : ["y"];
            (C3(z2.x) || U2.isCartesian || !w2) && S2.addColumnReader(z2.x, "x"), c4(z2, function(D2, F2) {
              F2 !== "x" && S2.addColumnReader(D2, F2);
            });
            for (let D2 = 0; D2 < P2; D2++) S2.hasReader(M2[D2]) || S2.addColumnReader(void 0, M2[D2]);
            N2.push(S2), E2++;
          });
          let R2 = g2(r3);
          R2 === void 0 && (R2 = ["y"]), this.valueCount = { global: a2(r3), xColumns: u2, individual: A3, seriesBuilders: N2, globalPointArrayMap: R2 };
        }
        dataFound() {
          this.options.switchRowsAndColumns && (this.columns = this.rowsToColumns(this.columns)), this.getColumnDistribution(), this.parseTypes(), this.parsed() !== false && this.complete();
        }
        parseCSV(i5) {
          let t3 = this, e5 = this.columns = [], n4 = i5 || this.options, u2 = n4.startColumn || 0, a2 = n4.endColumn || Number.MAX_VALUE, g2 = [], r3 = { ",": 0, ";": 0, "	": 0 }, A3 = n4.csv, N2 = n4.startRow || 0, k3 = n4.endRow || Number.MAX_VALUE, E2, R2, z2 = 0;
          if (A3 && n4.beforeParse && (A3 = n4.beforeParse.call(this, A3)), A3) {
            if (R2 = A3.replace(/\r\n/g, `
`).replace(/\r/g, `
`).split(n4.lineDelimiter || `
`), (!N2 || N2 < 0) && (N2 = 0), (!k3 || k3 >= R2.length) && (k3 = R2.length - 1), n4.itemDelimiter) E2 = n4.itemDelimiter;
            else {
              let v3, S2, P2;
              v3 = 0, S2 = 0, P2 = false, R2.some(function(U2, w2) {
                let M2 = false, D2, F2, $2, W2 = "";
                if (w2 > 13) return true;
                for (let V2 = 0; V2 < U2.length; V2++) {
                  if (D2 = U2[V2], F2 = U2[V2 + 1], $2 = U2[V2 - 1], D2 === "#") return;
                  if (D2 === '"')
                    if (M2) {
                      if ($2 !== '"' && F2 !== '"') {
                        for (; F2 === " " && V2 < U2.length; ) F2 = U2[++V2];
                        r3[F2] !== void 0 && r3[F2]++, M2 = false;
                      }
                    } else M2 = true;
                  else r3[D2] !== void 0 ? (isNaN(Date.parse(W2 = W2.trim())) ? (isNaN(W2) || !isFinite(W2)) && r3[D2]++ : r3[D2]++, W2 = "") : W2 += D2;
                  D2 === "," && S2++, D2 === "." && v3++;
                }
              }), r3[";"] > r3[","] ? P2 = ";" : (r3[","], r3[";"], P2 = ","), n4.decimalPoint || (v3 > S2 ? n4.decimalPoint = "." : n4.decimalPoint = ",", t3.decimalRegex = RegExp("^(-?[0-9]+)" + n4.decimalPoint + "([0-9]+)$")), E2 = P2;
            }
            let Q2 = 0;
            for (z2 = N2; z2 <= k3; z2++) R2[z2][0] === "#" ? Q2++ : function(v3, S2, P2, U2) {
              let w2 = 0, M2 = "", D2 = "", F2 = "", $2 = "", W2 = 0, V2 = 0;
              function _2(ht2) {
                M2 = v3[ht2], D2 = v3[ht2 - 1], F2 = v3[ht2 + 1];
              }
              function et2(ht2) {
                g2.length < V2 + 1 && g2.push([ht2]), g2[V2][g2[V2].length - 1] !== ht2 && g2[V2].push(ht2);
              }
              function lt2() {
                if (u2 > W2 || W2 > a2) {
                  ++W2, $2 = "";
                  return;
                }
                n4.columnTypes || (!isNaN(parseFloat($2)) && isFinite($2) ? ($2 = parseFloat($2), et2("number")) : isNaN(Date.parse($2)) ? et2("string") : ($2 = $2.replace(/\//g, "-"), et2("date"))), e5.length < V2 + 1 && e5.push([]), e5[V2][S2] = $2, $2 = "", ++V2, ++W2;
              }
              if (v3.trim().length && v3.trim()[0] !== "#") {
                for (; w2 < v3.length; w2++) if (_2(w2), M2 === '"') for (_2(++w2); w2 < v3.length && (M2 !== '"' || D2 === '"' || F2 === '"'); ) (M2 !== '"' || M2 === '"' && D2 !== '"') && ($2 += M2), _2(++w2);
                else M2 === E2 ? lt2() : $2 += M2;
                lt2();
              }
            }(R2[z2], z2 - N2 - Q2);
            (!n4.columnTypes || n4.columnTypes.length === 0) && g2.length && g2[0].length && g2[0][1] === "date" && !n4.dateFormat && (n4.dateFormat = function(v3, S2) {
              var P2;
              let U2 = "YYYY/mm/dd", w2 = [], M2 = [], D2, F2 = [], $2, W2 = 0, V2 = false, _2;
              for ((!S2 || S2 > v3.length) && (S2 = v3.length); W2 < S2; W2++) if (v3[W2] !== void 0 && (P2 = v3[W2]) != null && P2.length) for (_2 = 0, D2 = v3[W2].trim().replace(/\//g, " ").replace(/\-/g, " ").replace(/\./g, " ").split(" "), F2 = ["", "", ""]; _2 < D2.length; _2++) _2 < F2.length && (D2[_2] = parseInt(D2[_2], 10), D2[_2] && (M2[_2] = !M2[_2] || M2[_2] < D2[_2] ? D2[_2] : M2[_2], w2[_2] !== void 0 ? w2[_2] !== D2[_2] && (w2[_2] = false) : w2[_2] = D2[_2], D2[_2] > 31 ? D2[_2] < 100 ? F2[_2] = "YY" : F2[_2] = "YYYY" : D2[_2] > 12 && D2[_2] <= 31 ? (F2[_2] = "dd", V2 = true) : F2[_2].length || (F2[_2] = "mm")));
              if (V2) {
                for (_2 = 0; _2 < w2.length; _2++) w2[_2] !== false ? M2[_2] > 12 && F2[_2] !== "YY" && F2[_2] !== "YYYY" && (F2[_2] = "YY") : M2[_2] > 12 && F2[_2] === "mm" && (F2[_2] = "dd");
                return F2.length === 3 && F2[1] === "dd" && F2[2] === "dd" && (F2[2] = "YY"), $2 = F2.join("/"), (n4.dateFormats || t3.dateFormats)[$2] ? $2 : (p2(t3, "deduceDateFailed"), U2);
              }
              return U2;
            }(e5[0])), this.dataFound();
          }
          return e5;
        }
        parseTable() {
          let i5 = this.options, t3 = this.columns || [], e5 = i5.startRow || 0, n4 = i5.endRow || Number.MAX_VALUE, u2 = i5.startColumn || 0, a2 = i5.endColumn || Number.MAX_VALUE;
          if (i5.table) {
            let g2 = i5.table;
            typeof g2 == "string" && (g2 = j3.getElementById(g2)), [].forEach.call(g2.getElementsByTagName("tr"), (r3, A3) => {
              A3 >= e5 && A3 <= n4 && [].forEach.call(r3.children, (N2, k3) => {
                let E2 = t3[k3 - u2], R2 = 1;
                if ((N2.tagName === "TD" || N2.tagName === "TH") && k3 >= u2 && k3 <= a2) for (t3[k3 - u2] || (t3[k3 - u2] = []), t3[k3 - u2][A3 - e5] = N2.innerHTML; A3 - e5 >= R2 && E2[A3 - e5 - R2] === void 0; ) E2[A3 - e5 - R2] = null, R2++;
              });
            }), this.dataFound();
          }
          return t3;
        }
        fetchLiveData() {
          let i5 = this, t3 = this.chart, e5 = this.options, n4 = e5.enablePolling, u2 = h2(e5), a2 = 0, g2 = 1e3 * (e5.dataRefreshRate || 2);
          return !!G2(e5) && (g2 < 1e3 && (g2 = 1e3), delete e5.csvURL, delete e5.rowsURL, delete e5.columnsURL, function r3(A3) {
            function N2(k3, E2, R2) {
              if (!k3 || !/^(http|\/|\.\/|\.\.\/)/.test(k3)) return k3 && e5.error && e5.error("Invalid URL"), false;
              function z2() {
                n4 && t3.liveDataURL === k3 && (i5.liveDataTimeout = setTimeout(r3, g2));
              }
              return A3 && (clearTimeout(i5.liveDataTimeout), t3.liveDataURL = k3), d3({ url: k3, dataType: R2 || "json", success: function(Q2) {
                t3 != null && t3.series && E2(Q2), z2();
              }, error: function(Q2, v3) {
                var S2;
                return ++a2 < 3 && z2(), (S2 = e5.error) == null ? void 0 : S2.call(e5, v3, Q2);
              } }), true;
            }
            N2(u2.csvURL, function(k3) {
              t3.update({ data: { csv: k3 } });
            }, "text") || N2(u2.rowsURL, function(k3) {
              t3.update({ data: { rows: k3 } });
            }) || N2(u2.columnsURL, function(k3) {
              t3.update({ data: { columns: k3 } });
            });
          }(true), G2(e5));
        }
        parseGoogleSpreadsheet() {
          let i5 = this, t3 = this.options, e5 = t3.googleSpreadsheetKey, n4 = this.chart, u2 = Math.max(1e3 * (t3.dataRefreshRate || 2), 4e3), a2 = () => {
            if (t3.googleSpreadsheetRange) return t3.googleSpreadsheetRange;
            let g2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", r3 = (g2.charAt(t3.startColumn || 0) || "A") + ((t3.startRow || 0) + 1), A3 = g2.charAt(T2(t3.endColumn, -1)) || "ZZ";
            return C3(t3.endRow) && (A3 += t3.endRow + 1), `${r3}:${A3}`;
          };
          return e5 && (delete t3.googleSpreadsheetKey, function g2(r3) {
            d3({ url: ["https://sheets.googleapis.com/v4/spreadsheets", e5, "values", a2(), "?alt=json&majorDimension=COLUMNS&valueRenderOption=UNFORMATTED_VALUE&dateTimeRenderOption=FORMATTED_STRING&key=" + t3.googleAPIKey].join("/"), dataType: "json", success: function(A3) {
              r3(A3), t3.enablePolling && (i5.liveDataTimeout = setTimeout(function() {
                g2(r3);
              }, u2));
            }, error: function(A3, N2) {
              var k3;
              return (k3 = t3.error) == null ? void 0 : k3.call(t3, N2, A3);
            } });
          }(function(g2) {
            let r3 = g2.values;
            if (!r3 || r3.length === 0) return false;
            let A3 = r3.reduce((N2, k3) => Math.max(N2, k3.length), 0);
            r3.forEach((N2) => {
              for (let k3 = 0; k3 < A3; k3++) N2[k3] === void 0 && (N2[k3] = null);
            }), n4 != null && n4.series ? n4.update({ data: { columns: r3 } }) : (i5.columns = r3, i5.dataFound());
          })), false;
        }
        trim(i5, t3) {
          return typeof i5 == "string" && (i5 = i5.replace(/^\s+|\s+$/g, ""), t3 && /[\d\s]+/.test(i5) && (i5 = i5.replace(/\s/g, "")), this.decimalRegex && (i5 = i5.replace(this.decimalRegex, "$1.$2"))), i5;
        }
        parseTypes() {
          let i5 = this.columns || [], t3 = i5.length;
          for (; t3--; ) this.parseColumn(i5[t3], t3);
        }
        parseColumn(i5, t3) {
          var e5;
          let n4 = this.rawColumns, u2 = this.columns = this.columns || [], a2 = this.firstRowAsNames, g2 = ((e5 = this.valueCount) == null ? void 0 : e5.xColumns.indexOf(t3)) !== -1, r3 = [], A3 = this.chartOptions, N2 = (this.options.columnTypes || [])[t3], k3 = g2 && (A3 == null ? void 0 : A3.xAxis) && I3(A3.xAxis)[0].type === "category" || N2 === "string", E2 = C3(i5.name), R2 = i5.length, z2, Q2, v3, S2, P2, U2, w2;
          for (n4[t3] || (n4[t3] = []); R2--; ) z2 = r3[R2] || i5[R2], v3 = this.trim(z2), Q2 = parseFloat(S2 = this.trim(z2, true)), n4[t3][R2] === void 0 && (n4[t3][R2] = v3), k3 || R2 === 0 && a2 && !E2 ? i5[R2] = "" + v3 : +S2 === Q2 ? (i5[R2] = Q2, Q2 > 31536e6 && N2 !== "float" ? i5.isDatetime = true : i5.isNumeric = true, i5[R2 + 1] !== void 0 && (w2 = Q2 > i5[R2 + 1])) : (v3 != null && v3.length && (P2 = this.parseDate(z2)), g2 && b5(P2) && N2 !== "float" ? (r3[R2] = z2, i5[R2] = P2, i5.isDatetime = true, i5[R2 + 1] !== void 0 && ((U2 = P2 > i5[R2 + 1]) !== w2 && w2 !== void 0 && (this.alternativeFormat ? (this.dateFormat = this.alternativeFormat, R2 = i5.length, this.alternativeFormat = this.dateFormats[this.dateFormat].alternative) : i5.unsorted = true), w2 = U2)) : (i5[R2] = v3 === "" ? null : v3, R2 !== 0 && (i5.isDatetime || i5.isNumeric) && (i5.mixed = true)));
          if (g2 && i5.mixed && (u2[t3] = n4[t3]), g2 && w2 && this.options.sort) {
            for (t3 = 0; t3 < u2.length; t3++) if (u2[t3].reverse(), a2) {
              let M2 = u2[t3].pop();
              M2 && u2[t3].unshift(M2);
            }
          }
        }
        parseDate(i5) {
          let t3 = this.options.parseDate, e5, n4, u2, a2 = this.options.dateFormat || this.dateFormat, g2;
          if (t3) e5 = t3(i5);
          else if (typeof i5 == "string") {
            if (a2) (u2 = this.dateFormats[a2]) || (u2 = this.dateFormats["YYYY/mm/dd"]), (g2 = i5.match(u2.regex)) && (e5 = u2.parser(g2));
            else for (n4 in this.dateFormats) if (u2 = this.dateFormats[n4], g2 = i5.match(u2.regex)) {
              this.dateFormat = a2 = n4, this.alternativeFormat = u2.alternative, e5 = u2.parser(g2);
              break;
            }
            !g2 && (i5.match(/:.+(GMT|UTC|[Z+\-])/) && (i5 = i5.replace(/\s*(?:GMT|UTC)?([+\-])(\d\d)(\d\d)$/, "$1$2:$3").replace(/(?:\s+|GMT|UTC)([+\-])/, "$1").replace(/(\d)\s*(?:GMT|UTC|Z)$/, "$1+00:00")), typeof (g2 = Date.parse(i5)) == "object" && g2 !== null && g2.getTime ? e5 = g2.getTime() - 6e4 * g2.getTimezoneOffset() : b5(g2) && (e5 = g2 - 6e4 * new Date(g2).getTimezoneOffset()));
          }
          return e5;
        }
        getData() {
          var i5;
          if (this.columns) return (i5 = this.rowsToColumns(this.columns)) == null ? void 0 : i5.slice(1);
        }
        parsed() {
          if (this.options.parsed) return this.options.parsed.call(this, this.columns);
        }
        complete() {
          var i5, t3, e5, n4, u2;
          let a2 = this.columns = this.columns || [], g2 = this.options, r3 = [], A3 = "linear", N2, k3, E2, R2, z2, Q2, v3, S2, P2, U2, w2;
          if (a2.length, g2.complete || g2.afterComplete) {
            if (this.firstRowAsNames) for (E2 = 0; E2 < a2.length; E2++) {
              let M2 = a2[E2];
              C3(M2.name) || (M2.name = T2(M2.shift(), "").toString());
            }
            for (Q2 = 0, N2 = [], P2 = function(M2, D2) {
              let F2, $2, W2, V2 = [], _2 = [];
              for ($2 = 0; $2 < M2; $2 += 1) V2.push(true);
              for (F2 = 0; F2 < D2.length; F2 += 1) for ($2 = 0, W2 = D2[F2].getReferencedColumnIndexes(); $2 < W2.length; $2 += 1) V2[W2[$2]] = false;
              for ($2 = 0; $2 < V2.length; $2 += 1) V2[$2] && _2.push($2);
              return _2;
            }((a2 == null ? void 0 : a2.length) || 0, this.valueCount.seriesBuilders); Q2 < this.valueCount.seriesBuilders.length; Q2++) (S2 = this.valueCount.seriesBuilders[Q2]).populateColumns(P2) && r3.push(S2);
            for (; P2.length > 0; ) {
              for ((S2 = new l4()).addColumnReader(0, "x"), (w2 = P2.indexOf(0)) !== -1 && P2.splice(w2, 1), E2 = 0; E2 < this.valueCount.global; E2++) S2.addColumnReader(void 0, this.valueCount.globalPointArrayMap[E2]);
              S2.populateColumns(P2) && r3.push(S2);
            }
            if (r3.length > 0 && r3[0].readers.length > 0 && (U2 = a2 == null ? void 0 : a2[(i5 = r3[0].readers[0].columnIndex) != null ? i5 : -1]) !== void 0 && (U2.isDatetime ? A3 = "datetime" : U2.isNumeric || (A3 = "category")), A3 === "category") for (Q2 = 0; Q2 < r3.length; Q2++) for (z2 = 0, S2 = r3[Q2]; z2 < S2.readers.length; z2++) S2.readers[z2].configName === "x" && (S2.readers[z2].configName = "name");
            for (Q2 = 0; Q2 < r3.length; Q2++) {
              for (R2 = 0, S2 = r3[Q2], k3 = []; R2 < a2[0].length; R2++) k3[R2] = S2.read(a2, R2);
              N2[Q2] = { data: k3, pointStart: k3[0] && (S2.pointIsArray ? (t3 = k3[0]) == null ? void 0 : t3[0] : (e5 = k3[0]) == null ? void 0 : e5.x) || void 0 }, S2.name && (N2[Q2].name = S2.name), A3 === "category" && (N2[Q2].turboThreshold = 0, N2[Q2].pointStart = 0);
            }
            v3 = { series: N2 }, A3 !== "linear" || this.xAxisOptions && this.xAxisOptions.type !== A3 ? (this.xAxisOptions = { type: A3 }, A3 === "category" && (this.xAxisOptions.uniqueNames = false)) : A3 = this.xAxisOptions = void 0, this.chart || h2(true, v3, { xAxis: this.xAxisOptions || {} }), (n4 = g2.complete) == null || n4.call(g2, v3), (u2 = g2.afterComplete) == null || u2.call(g2, this, v3);
          }
        }
        xAxisUpdateHandler(i5) {
          let t3 = this.xAxisOptions;
          t3 && (!i5.options.type && t3.type && (i5.type = t3.type), i5.options.uniqueNames || t3.uniqueNames !== false || (i5.uniqueNames = t3.uniqueNames));
        }
        update(i5, t3) {
          var e5;
          let n4 = this.chart, u2 = n4.options;
          i5 && (i5.afterComplete = function(a2, g2) {
            if (!g2) return;
            let r3 = n4.xAxis[0], A3 = a2.xAxisOptions;
            A3 && r3 && (r3.type !== A3.type && !r3.options.type || r3.uniqueNames && A3.uniqueNames === false && r3.options.uniqueNames === void 0) ? r3.update({}, false) : ((g2 == null ? void 0 : g2.series) || []).forEach(function(N2) {
              delete N2.pointStart;
            }), n4.update(g2, t3, true);
          }, h2(true, u2.data, i5), (e5 = u2.data) != null && e5.googleSpreadsheetKey && !i5.columns && delete u2.data.columns, this.init(u2.data || {}, u2));
        }
      }
      f2(B3, "afterSetOptions", function() {
        var y2;
        this.isXAxis && (!this.chart.xAxis.length || this.chart.xAxis[0] === this) && ((y2 = this.chart.data) == null || y2.xAxisUpdateHandler(this));
      }), f2(K2, "init", function(y2) {
        let i5 = this, t3 = y2.args[1], e5 = O3().data, n4 = y2.args[0] || {};
        if ((e5 || n4 && n4.data) && !i5.hasDataDef) {
          i5.hasDataDef = true;
          let u2 = h2(e5, n4.data);
          i5.data = new L2(o2(u2, { afterComplete: function(a2, g2) {
            var r3, A3, N2, k3;
            let E2, R2;
            if (Object.hasOwnProperty.call(n4, "series"))
              if (typeof n4.series == "object") for (E2 = Math.max(n4.series.length, (A3 = (r3 = g2 == null ? void 0 : g2.series) == null ? void 0 : r3.length) != null ? A3 : 0); E2--; ) R2 = n4.series[E2] || {}, n4.series[E2] = h2(R2, (k3 = (N2 = g2 == null ? void 0 : g2.series) == null ? void 0 : N2[E2]) != null ? k3 : {});
              else delete n4.series;
            n4 = h2(g2, n4), i5.data = a2, i5.init(n4, t3);
          } }), n4, i5), y2.preventDefault();
        }
      });
      class l4 {
        constructor() {
          this.readers = [], this.pointIsArray = true;
        }
        populateColumns(i5) {
          let t3 = true;
          return this.readers.forEach((e5) => {
            e5.columnIndex === void 0 && (e5.columnIndex = i5.shift());
          }), this.readers.forEach((e5) => {
            e5.columnIndex === void 0 && (t3 = false);
          }), t3;
        }
        read(i5, t3) {
          let e5 = this.pointIsArray, n4 = e5 ? [] : {};
          if (this.readers.forEach((u2) => {
            let a2 = i5[u2.columnIndex][t3];
            e5 ? n4.push(a2) : u2.configName.indexOf(".") > 0 ? tt2.prototype.setNestedProperty(n4, a2, u2.configName) : n4[u2.configName] = a2;
          }), this.name === void 0 && this.readers.length >= 2) {
            let u2 = [];
            this.readers.forEach(function(a2) {
              (a2.configName === "x" || a2.configName === "name" || a2.configName === "y") && a2.columnIndex !== void 0 && u2.push(a2.columnIndex);
            }), u2.length >= 2 && (u2.shift(), u2.sort(function(a2, g2) {
              return a2 - g2;
            })), this.name = i5[T2(u2.shift(), 0)].name;
          }
          return n4;
        }
        addColumnReader(i5, t3) {
          this.readers.push({ columnIndex: i5, configName: t3 }), t3 === "x" || t3 === "y" || t3 === void 0 || (this.pointIsArray = false);
        }
        getReferencedColumnIndexes() {
          let i5, t3, e5 = [];
          for (i5 = 0; i5 < this.readers.length; i5 += 1) (t3 = this.readers[i5]).columnIndex !== void 0 && e5.push(t3.columnIndex);
          return e5;
        }
        hasReader(i5) {
          let t3;
          for (t3 = 0; t3 < this.readers.length; t3 += 1) if (this.readers[t3].configName === i5) return true;
        }
      }
      return L2;
    }), at2(s2, "masters/modules/data.src.js", [s2["Core/Globals.js"], s2["Core/HttpUtilities.js"], s2["Extensions/Data.js"]], function(B3, K2, q2) {
      return B3.Data = B3.Data || q2, B3.HttpUtilities = B3.HttpUtilities || K2, B3.ajax = B3.HttpUtilities.ajax, B3.data = B3.Data.data, B3.getJSON = B3.HttpUtilities.getJSON, B3.post = B3.HttpUtilities.post, B3;
    });
  });
})(xs);
var Ja = xs.exports;
const Qa = /* @__PURE__ */ ce(Ja);
var ys = { exports: {} };
(function(m3) {
  (function(H2) {
    m3.exports ? (H2.default = H2, m3.exports = H2) : H2(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(H2) {
    var s2 = H2 ? H2._modules : {};
    function at2(B3, K2, q2, it2) {
      B3.hasOwnProperty(K2) || (B3[K2] = it2.apply(null, q2), typeof CustomEvent == "function" && H2.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: K2, module: B3[K2] } })));
    }
    at2(s2, "Extensions/DownloadURL.js", [s2["Core/Globals.js"]], function(B3) {
      let { isSafari: K2, win: q2, win: { document: it2 } } = B3, rt2 = q2.URL || q2.webkitURL || q2;
      function tt2(Z2) {
        let X2 = Z2.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
        if (X2 && X2.length > 3 && q2.atob && q2.ArrayBuffer && q2.Uint8Array && q2.Blob && rt2.createObjectURL) {
          let O3 = q2.atob(X2[3]), j3 = new q2.ArrayBuffer(O3.length), d3 = new q2.Uint8Array(j3);
          for (let x2 = 0; x2 < d3.length; ++x2) d3[x2] = O3.charCodeAt(x2);
          return rt2.createObjectURL(new q2.Blob([d3], { type: X2[1] }));
        }
      }
      return { dataURLtoBlob: tt2, downloadURL: function(Z2, X2) {
        let O3 = q2.navigator, j3 = it2.createElement("a");
        if (typeof Z2 != "string" && !(Z2 instanceof String) && O3.msSaveOrOpenBlob) {
          O3.msSaveOrOpenBlob(Z2, X2);
          return;
        }
        if (Z2 = "" + Z2, O3.userAgent.length > 1e3) throw Error("Input too long");
        let d3 = /Edge\/\d+/.test(O3.userAgent);
        if ((K2 && typeof Z2 == "string" && Z2.indexOf("data:application/pdf") === 0 || d3 || Z2.length > 2e6) && !(Z2 = tt2(Z2) || "")) throw Error("Failed to convert to blob");
        if (j3.download !== void 0) j3.href = Z2, j3.download = X2, it2.body.appendChild(j3), j3.click(), it2.body.removeChild(j3);
        else try {
          if (!q2.open(Z2, "chart")) throw Error("Failed to open window");
        } catch {
          q2.location.href = Z2;
        }
      } };
    }), at2(s2, "Extensions/ExportData/ExportDataDefaults.js", [], function() {
      return { exporting: { csv: { annotations: { itemDelimiter: "; ", join: false }, columnHeaderFormatter: null, dateFormat: "%Y-%m-%d %H:%M:%S", decimalPoint: null, itemDelimiter: null, lineDelimiter: `
` }, showTable: false, useMultiLevelHeaders: true, useRowspanHeaders: true, showExportInProgress: true }, lang: { downloadCSV: "Download CSV", downloadXLS: "Download XLS", exportData: { annotationHeader: "Annotations", categoryHeader: "Category", categoryDatetimeHeader: "DateTime" }, viewData: "View data table", hideData: "Hide data table", exportInProgress: "Exporting..." } };
    }), at2(s2, "Extensions/ExportData/ExportData.js", [s2["Core/Renderer/HTML/AST.js"], s2["Core/Defaults.js"], s2["Extensions/DownloadURL.js"], s2["Extensions/ExportData/ExportDataDefaults.js"], s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2) {
      let { getOptions: Z2, setOptions: X2 } = K2, { downloadURL: O3 } = q2, { doc: j3, win: d3 } = rt2, { addEvent: x2, defined: f2, extend: C3, find: o2, fireEvent: p2, isNumber: b5, pick: h2 } = tt2;
      function c4(r3) {
        var A3;
        let N2 = !!((A3 = this.options.exporting) != null && A3.showExportInProgress), k3 = d3.requestAnimationFrame || setTimeout;
        k3(() => {
          N2 && this.showLoading(this.options.lang.exportInProgress), k3(() => {
            try {
              r3.call(this);
            } finally {
              N2 && this.hideLoading();
            }
          });
        });
      }
      function T2() {
        c4.call(this, () => {
          let r3 = this.getCSV(true);
          O3(n4(r3, "text/csv") || "data:text/csv,\uFEFF" + encodeURIComponent(r3), this.getFilename() + ".csv");
        });
      }
      function I3() {
        c4.call(this, () => {
          let r3 = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>' + this.getTable(true) + "</body></html>";
          O3(n4(r3, "application/vnd.ms-excel") || "data:application/vnd.ms-excel;base64," + d3.btoa(unescape(encodeURIComponent(r3))), this.getFilename() + ".xls");
        });
      }
      function G2(r3) {
        let A3 = "", N2 = this.getDataRows(), k3 = this.options.exporting.csv, E2 = h2(k3.decimalPoint, k3.itemDelimiter !== "," && r3 ? 1.1.toLocaleString()[1] : "."), R2 = h2(k3.itemDelimiter, E2 === "," ? ";" : ","), z2 = k3.lineDelimiter;
        return N2.forEach((Q2, v3) => {
          let S2 = "", P2 = Q2.length;
          for (; P2--; ) typeof (S2 = Q2[P2]) == "string" && (S2 = `"${S2}"`), typeof S2 == "number" && E2 !== "." && (S2 = S2.toString().replace(".", E2)), Q2[P2] = S2;
          Q2.length = N2.length ? N2[0].length : 0, A3 += Q2.join(R2), v3 < N2.length - 1 && (A3 += z2);
        }), A3;
      }
      function L2(r3) {
        let A3, N2, k3 = this.hasParallelCoordinates, E2 = this.time, R2 = this.options.exporting && this.options.exporting.csv || {}, z2 = this.xAxis, Q2 = {}, v3 = [], S2 = [], P2 = [], U2 = this.options.lang.exportData, w2 = U2.categoryHeader, M2 = U2.categoryDatetimeHeader, D2 = function(Y2, st2, nt2) {
          if (R2.columnHeaderFormatter) {
            let ot2 = R2.columnHeaderFormatter(Y2, st2, nt2);
            if (ot2 !== false) return ot2;
          }
          return Y2 ? Y2.bindAxes ? r3 ? { columnTitle: nt2 > 1 ? st2 : Y2.name, topLevelColumnTitle: Y2.name } : Y2.name + (nt2 > 1 ? " (" + st2 + ")" : "") : Y2.options.title && Y2.options.title.text || (Y2.dateTime ? M2 : w2) : w2;
        }, F2 = function(Y2, st2, nt2) {
          let ot2 = {}, ut2 = {};
          return st2.forEach(function(dt2) {
            let ct2 = (Y2.keyToAxis && Y2.keyToAxis[dt2] || dt2) + "Axis", gt2 = b5(nt2) ? Y2.chart[ct2][nt2] : Y2[ct2];
            ot2[dt2] = gt2 && gt2.categories || [], ut2[dt2] = gt2 && gt2.dateTime;
          }), { categoryMap: ot2, dateTimeValueAxisMap: ut2 };
        }, $2 = function(Y2, st2) {
          let nt2 = Y2.pointArrayMap || ["y"];
          return Y2.data.some((ot2) => ot2.y !== void 0 && ot2.name) && st2 && !st2.categories && Y2.exportKey !== "name" ? ["x", ...nt2] : nt2;
        }, W2 = [], V2, _2, et2, lt2 = 0, ht2, J2;
        for (ht2 in this.series.forEach(function(Y2) {
          let st2 = Y2.options.keys, nt2 = Y2.xAxis, ot2 = st2 || $2(Y2, nt2), ut2 = ot2.length, dt2 = !Y2.requireSorting && {}, ct2 = z2.indexOf(nt2), gt2 = F2(Y2, ot2), ft2, pt2;
          if (Y2.options.includeInDataExport !== false && !Y2.options.isInternal && Y2.visible !== false) {
            for (o2(W2, function(mt2) {
              return mt2[0] === ct2;
            }) || W2.push([ct2, lt2]), pt2 = 0; pt2 < ut2; ) et2 = D2(Y2, ot2[pt2], ot2.length), P2.push(et2.columnTitle || et2), r3 && S2.push(et2.topLevelColumnTitle || et2), pt2++;
            ft2 = { chart: Y2.chart, autoIncrement: Y2.autoIncrement, options: Y2.options, pointArrayMap: Y2.pointArrayMap, index: Y2.index }, Y2.options.data.forEach(function(mt2, yt2) {
              var vt2;
              let bt2, xt2, Ct2, wt2 = { series: ft2 };
              k3 && (gt2 = F2(Y2, ot2, yt2)), Y2.pointClass.prototype.applyOptions.apply(wt2, [mt2]);
              let kt2 = Y2.data[yt2] && Y2.data[yt2].name;
              if (bt2 = ((vt2 = wt2.x) != null ? vt2 : "") + "," + kt2, pt2 = 0, (!nt2 || Y2.exportKey === "name" || !k3 && nt2 && nt2.hasNames && kt2) && (bt2 = kt2), dt2 && (dt2[bt2] && (bt2 += "|" + yt2), dt2[bt2] = true), Q2[bt2]) {
                let St2 = `${bt2},${Q2[bt2].pointers[Y2.index]}`, Tt2 = bt2;
                Q2[bt2].pointers[Y2.index] && (Q2[St2] || (Q2[St2] = [], Q2[St2].xValues = [], Q2[St2].pointers = []), bt2 = St2), Q2[Tt2].pointers[Y2.index] += 1;
              } else {
                Q2[bt2] = [], Q2[bt2].xValues = [];
                let St2 = [];
                for (let Tt2 = 0; Tt2 < Y2.chart.series.length; Tt2++) St2[Tt2] = 0;
                Q2[bt2].pointers = St2, Q2[bt2].pointers[Y2.index] = 1;
              }
              for (Q2[bt2].x = wt2.x, Q2[bt2].name = kt2, Q2[bt2].xValues[ct2] = wt2.x; pt2 < ut2; ) Ct2 = wt2[xt2 = ot2[pt2]], Q2[bt2][lt2 + pt2] = h2(gt2.categoryMap[xt2][Ct2], gt2.dateTimeValueAxisMap[xt2] ? E2.dateFormat(R2.dateFormat, Ct2) : null, Ct2), pt2++;
            }), lt2 += pt2;
          }
        }), Q2) Object.hasOwnProperty.call(Q2, ht2) && v3.push(Q2[ht2]);
        for (_2 = r3 ? [S2, P2] : [P2], lt2 = W2.length; lt2--; ) A3 = W2[lt2][0], N2 = W2[lt2][1], V2 = z2[A3], v3.sort(function(Y2, st2) {
          return Y2.xValues[A3] - st2.xValues[A3];
        }), J2 = D2(V2), _2[0].splice(N2, 0, J2), r3 && _2[1] && _2[1].splice(N2, 0, J2), v3.forEach(function(Y2) {
          let st2 = Y2.name;
          V2 && !f2(st2) && (V2.dateTime ? (Y2.x instanceof Date && (Y2.x = Y2.x.getTime()), st2 = E2.dateFormat(R2.dateFormat, Y2.x)) : st2 = V2.categories ? h2(V2.names[Y2.x], V2.categories[Y2.x], Y2.x) : Y2.x), Y2.splice(N2, 0, st2);
        });
        return p2(this, "exportData", { dataRows: _2 = _2.concat(v3) }), _2;
      }
      function l4(r3) {
        let A3 = (N2) => {
          if (!N2.tagName || N2.tagName === "#text") return N2.textContent || "";
          let k3 = N2.attributes, E2 = `<${N2.tagName}`;
          return k3 && Object.keys(k3).forEach((R2) => {
            let z2 = k3[R2];
            E2 += ` ${R2}="${z2}"`;
          }), E2 += ">" + (N2.textContent || ""), (N2.children || []).forEach((R2) => {
            E2 += A3(R2);
          }), E2 += `</${N2.tagName}>`;
        };
        return A3(this.getTableAST(r3));
      }
      function y2(r3) {
        let A3 = 0, N2 = [], k3 = this.options, E2 = r3 ? 1.1.toLocaleString()[1] : ".", R2 = h2(k3.exporting.useMultiLevelHeaders, true), z2 = this.getDataRows(R2), Q2 = R2 ? z2.shift() : null, v3 = z2.shift(), S2 = function(M2, D2) {
          let F2 = M2.length;
          if (D2.length !== F2) return false;
          for (; F2--; ) if (M2[F2] !== D2[F2]) return false;
          return true;
        }, P2 = function(M2, D2, F2, $2) {
          let W2 = h2($2, ""), V2 = "highcharts-text" + (D2 ? " " + D2 : "");
          return typeof W2 == "number" ? (W2 = W2.toString(), E2 === "," && (W2 = W2.replace(".", E2)), V2 = "highcharts-number") : $2 || (V2 = "highcharts-empty"), { tagName: M2, attributes: F2 = C3({ class: V2 }, F2), textContent: W2 };
        };
        k3.exporting.tableCaption !== false && N2.push({ tagName: "caption", attributes: { class: "highcharts-table-caption" }, textContent: h2(k3.exporting.tableCaption, k3.title.text ? k3.title.text : "Chart") });
        for (let M2 = 0, D2 = z2.length; M2 < D2; ++M2) z2[M2].length > A3 && (A3 = z2[M2].length);
        N2.push(function(M2, D2, F2) {
          let $2 = [], W2 = 0, V2 = F2 || D2 && D2.length, _2, et2 = 0, lt2;
          if (R2 && M2 && D2 && !S2(M2, D2)) {
            let ht2 = [];
            for (; W2 < V2; ++W2) if ((_2 = M2[W2]) === M2[W2 + 1]) ++et2;
            else if (et2) ht2.push(P2("th", "highcharts-table-topheading", { scope: "col", colspan: et2 + 1 }, _2)), et2 = 0;
            else {
              _2 === D2[W2] ? k3.exporting.useRowspanHeaders ? (lt2 = 2, delete D2[W2]) : (lt2 = 1, D2[W2] = "") : lt2 = 1;
              let J2 = P2("th", "highcharts-table-topheading", { scope: "col" }, _2);
              lt2 > 1 && J2.attributes && (J2.attributes.valign = "top", J2.attributes.rowspan = lt2), ht2.push(J2);
            }
            $2.push({ tagName: "tr", children: ht2 });
          }
          if (D2) {
            let ht2 = [];
            for (W2 = 0, V2 = D2.length; W2 < V2; ++W2) D2[W2] !== void 0 && ht2.push(P2("th", null, { scope: "col" }, D2[W2]));
            $2.push({ tagName: "tr", children: ht2 });
          }
          return { tagName: "thead", children: $2 };
        }(Q2, v3, Math.max(A3, v3.length)));
        let U2 = [];
        z2.forEach(function(M2) {
          let D2 = [];
          for (let F2 = 0; F2 < A3; F2++) D2.push(P2(F2 ? "td" : "th", null, F2 ? {} : { scope: "row" }, M2[F2]));
          U2.push({ tagName: "tr", children: D2 });
        }), N2.push({ tagName: "tbody", children: U2 });
        let w2 = { tree: { tagName: "table", id: `highcharts-data-table-${this.index}`, children: N2 } };
        return p2(this, "aftergetTableAST", w2), w2.tree;
      }
      function i5() {
        this.toggleDataTable(false);
      }
      function t3(r3) {
        let A3 = (r3 = h2(r3, !this.isDataTableVisible)) && !this.dataTableDiv;
        if (A3 && (this.dataTableDiv = j3.createElement("div"), this.dataTableDiv.className = "highcharts-data-table", this.renderTo.parentNode.insertBefore(this.dataTableDiv, this.renderTo.nextSibling)), this.dataTableDiv) {
          let z2 = this.dataTableDiv.style, Q2 = z2.display;
          z2.display = r3 ? "block" : "none", r3 ? (this.dataTableDiv.innerHTML = B3.emptyHTML, new B3([this.getTableAST()]).addToDOM(this.dataTableDiv), p2(this, "afterViewData", { element: this.dataTableDiv, wasHidden: A3 || Q2 !== z2.display })) : p2(this, "afterHideData");
        }
        this.isDataTableVisible = r3;
        let N2 = this.exportDivElements, k3 = this.options.exporting, E2 = k3 && k3.buttons && k3.buttons.contextButton.menuItems, R2 = this.options.lang;
        if (k3 && k3.menuItemDefinitions && R2 && R2.viewData && R2.hideData && E2 && N2) {
          let z2 = N2[E2.indexOf("viewData")];
          z2 && B3.setElementHTML(z2, this.isDataTableVisible ? R2.hideData : R2.viewData);
        }
      }
      function e5() {
        this.toggleDataTable(true);
      }
      function n4(r3, A3) {
        let N2 = d3.navigator, k3 = d3.URL || d3.webkitURL || d3;
        try {
          if (N2.msSaveOrOpenBlob && d3.MSBlobBuilder) {
            let E2 = new d3.MSBlobBuilder();
            return E2.append(r3), E2.getBlob("image/svg+xml");
          }
          return k3.createObjectURL(new d3.Blob(["\uFEFF" + r3], { type: A3 }));
        } catch {
        }
      }
      function u2() {
        let r3 = this, A3 = r3.dataTableDiv, N2 = (E2, R2) => E2.children[R2].textContent, k3 = (E2, R2) => (z2, Q2) => {
          let v3, S2;
          return v3 = N2(R2 ? z2 : Q2, E2), S2 = N2(R2 ? Q2 : z2, E2), v3 === "" || S2 === "" || isNaN(v3) || isNaN(S2) ? v3.toString().localeCompare(S2) : v3 - S2;
        };
        if (A3 && r3.options.exporting && r3.options.exporting.allowTableSorting) {
          let E2 = A3.querySelector("thead tr");
          E2 && E2.childNodes.forEach((R2) => {
            let z2 = R2.closest("table");
            R2.addEventListener("click", function() {
              let Q2 = [...A3.querySelectorAll("tr:not(thead tr)")], v3 = [...R2.parentNode.children];
              Q2.sort(k3(v3.indexOf(R2), r3.ascendingOrderInTable = !r3.ascendingOrderInTable)).forEach((S2) => {
                z2.appendChild(S2);
              }), v3.forEach((S2) => {
                ["highcharts-sort-ascending", "highcharts-sort-descending"].forEach((P2) => {
                  S2.classList.contains(P2) && S2.classList.remove(P2);
                });
              }), R2.classList.add(r3.ascendingOrderInTable ? "highcharts-sort-ascending" : "highcharts-sort-descending");
            });
          });
        }
      }
      function a2() {
        this.options && this.options.exporting && this.options.exporting.showTable && !this.options.chart.forExport && this.viewData();
      }
      function g2() {
        var r3;
        (r3 = this.dataTableDiv) == null || r3.remove();
      }
      return { compose: function(r3, A3) {
        let N2 = r3.prototype;
        if (!N2.getCSV) {
          let k3 = Z2().exporting;
          x2(r3, "afterViewData", u2), x2(r3, "render", a2), x2(r3, "destroy", g2), N2.downloadCSV = T2, N2.downloadXLS = I3, N2.getCSV = G2, N2.getDataRows = L2, N2.getTable = l4, N2.getTableAST = y2, N2.hideData = i5, N2.toggleDataTable = t3, N2.viewData = e5, k3 && (C3(k3.menuItemDefinitions, { downloadCSV: { textKey: "downloadCSV", onclick: function() {
            this.downloadCSV();
          } }, downloadXLS: { textKey: "downloadXLS", onclick: function() {
            this.downloadXLS();
          } }, viewData: { textKey: "viewData", onclick: function() {
            c4.call(this, this.toggleDataTable);
          } } }), k3.buttons && k3.buttons.contextButton.menuItems && k3.buttons.contextButton.menuItems.push("separator", "downloadCSV", "downloadXLS", "viewData")), X2(it2);
          let { arearange: E2, gantt: R2, map: z2, mapbubble: Q2, treemap: v3, xrange: S2 } = A3.types;
          E2 && (E2.prototype.keyToAxis = { low: "y", high: "y" }), R2 && (R2.prototype.exportKey = "name", R2.prototype.keyToAxis = { start: "x", end: "x" }), z2 && (z2.prototype.exportKey = "name"), Q2 && (Q2.prototype.exportKey = "name"), v3 && (v3.prototype.exportKey = "name"), S2 && (S2.prototype.keyToAxis = { x2: "x" });
        }
      } };
    }), at2(s2, "masters/modules/export-data.src.js", [s2["Core/Globals.js"], s2["Extensions/DownloadURL.js"], s2["Extensions/ExportData/ExportData.js"]], function(B3, K2, q2) {
      return B3.dataURLtoBlob = B3.dataURLtoBlob || K2.dataURLtoBlob, B3.downloadURL = B3.downloadURL || K2.downloadURL, q2.compose(B3.Chart, B3.Series), B3;
    });
  });
})(ys);
var tl = ys.exports;
const el = /* @__PURE__ */ ce(tl);
var vs = { exports: {} };
(function(m3) {
  (function(H2) {
    m3.exports ? (H2.default = H2, m3.exports = H2) : H2(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(H2) {
    var s2 = H2 ? H2._modules : {};
    function at2(B3, K2, q2, it2) {
      B3.hasOwnProperty(K2) || (B3[K2] = it2.apply(null, q2), typeof CustomEvent == "function" && H2.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: K2, module: B3[K2] } })));
    }
    at2(s2, "Core/Chart/ChartNavigationComposition.js", [], function() {
      var B3;
      return function(K2) {
        K2.compose = function(it2) {
          return it2.navigation || (it2.navigation = new q2(it2)), it2;
        };
        class q2 {
          constructor(rt2) {
            this.updates = [], this.chart = rt2;
          }
          addUpdate(rt2) {
            this.chart.navigation.updates.push(rt2);
          }
          update(rt2, tt2) {
            this.updates.forEach((Z2) => {
              Z2.call(this.chart, rt2, tt2);
            });
          }
        }
        K2.Additions = q2;
      }(B3 || (B3 = {})), B3;
    }), at2(s2, "Extensions/Exporting/ExportingDefaults.js", [s2["Core/Globals.js"]], function(B3) {
      let { isTouchDevice: K2 } = B3;
      return { exporting: { allowTableSorting: true, type: "image/png", url: "https://export.highcharts.com/", pdfFont: { normal: void 0, bold: void 0, bolditalic: void 0, italic: void 0 }, printMaxWidth: 780, scale: 2, buttons: { contextButton: { className: "highcharts-contextbutton", menuClassName: "highcharts-contextmenu", symbol: "menu", titleKey: "contextButtonTitle", menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"] } }, menuItemDefinitions: { viewFullscreen: { textKey: "viewFullscreen", onclick: function() {
        this.fullscreen && this.fullscreen.toggle();
      } }, printChart: { textKey: "printChart", onclick: function() {
        this.print();
      } }, separator: { separator: true }, downloadPNG: { textKey: "downloadPNG", onclick: function() {
        this.exportChart();
      } }, downloadJPEG: { textKey: "downloadJPEG", onclick: function() {
        this.exportChart({ type: "image/jpeg" });
      } }, downloadPDF: { textKey: "downloadPDF", onclick: function() {
        this.exportChart({ type: "application/pdf" });
      } }, downloadSVG: { textKey: "downloadSVG", onclick: function() {
        this.exportChart({ type: "image/svg+xml" });
      } } } }, lang: { viewFullscreen: "View in full screen", exitFullscreen: "Exit from full screen", printChart: "Print chart", downloadPNG: "Download PNG image", downloadJPEG: "Download JPEG image", downloadPDF: "Download PDF document", downloadSVG: "Download SVG vector image", contextButtonTitle: "Chart context menu" }, navigation: { buttonOptions: { symbolSize: 14, symbolX: 14.5, symbolY: 13.5, align: "right", buttonSpacing: 3, height: 28, verticalAlign: "top", width: 28, symbolFill: "#666666", symbolStroke: "#666666", symbolStrokeWidth: 3, theme: { fill: "#ffffff", padding: 5, stroke: "none", "stroke-linecap": "round" } }, menuStyle: { border: "none", borderRadius: "3px", background: "#ffffff", padding: "0.5em" }, menuItemStyle: { background: "none", borderRadius: "3px", color: "#333333", padding: "0.5em", fontSize: K2 ? "0.9em" : "0.8em", transition: "background 250ms, color 250ms" }, menuItemHoverStyle: { background: "#f2f2f2" } } };
    }), at2(s2, "Extensions/Exporting/ExportingSymbols.js", [], function() {
      var B3;
      return function(K2) {
        let q2 = [];
        function it2(tt2, Z2, X2, O3) {
          return [["M", tt2, Z2 + 2.5], ["L", tt2 + X2, Z2 + 2.5], ["M", tt2, Z2 + O3 / 2 + 0.5], ["L", tt2 + X2, Z2 + O3 / 2 + 0.5], ["M", tt2, Z2 + O3 - 1.5], ["L", tt2 + X2, Z2 + O3 - 1.5]];
        }
        function rt2(tt2, Z2, X2, O3) {
          let j3 = O3 / 3 - 2;
          return [].concat(this.circle(X2 - j3, Z2, j3, j3), this.circle(X2 - j3, Z2 + j3 + 4, j3, j3), this.circle(X2 - j3, Z2 + 2 * (j3 + 4), j3, j3));
        }
        K2.compose = function(tt2) {
          if (q2.indexOf(tt2) === -1) {
            q2.push(tt2);
            let Z2 = tt2.prototype.symbols;
            Z2.menu = it2, Z2.menuball = rt2.bind(Z2);
          }
        };
      }(B3 || (B3 = {})), B3;
    }), at2(s2, "Extensions/Exporting/Fullscreen.js", [s2["Core/Renderer/HTML/AST.js"], s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2, q2) {
      let { composed: it2 } = K2, { addEvent: rt2, fireEvent: tt2, pushUnique: Z2 } = q2;
      function X2() {
        this.fullscreen = new O3(this);
      }
      class O3 {
        static compose(d3) {
          Z2(it2, "Fullscreen") && rt2(d3, "beforeRender", X2);
        }
        constructor(d3) {
          this.chart = d3, this.isOpen = false;
          let x2 = d3.renderTo;
          !this.browserProps && (typeof x2.requestFullscreen == "function" ? this.browserProps = { fullscreenChange: "fullscreenchange", requestFullscreen: "requestFullscreen", exitFullscreen: "exitFullscreen" } : x2.mozRequestFullScreen ? this.browserProps = { fullscreenChange: "mozfullscreenchange", requestFullscreen: "mozRequestFullScreen", exitFullscreen: "mozCancelFullScreen" } : x2.webkitRequestFullScreen ? this.browserProps = { fullscreenChange: "webkitfullscreenchange", requestFullscreen: "webkitRequestFullScreen", exitFullscreen: "webkitExitFullscreen" } : x2.msRequestFullscreen && (this.browserProps = { fullscreenChange: "MSFullscreenChange", requestFullscreen: "msRequestFullscreen", exitFullscreen: "msExitFullscreen" }));
        }
        close() {
          let d3 = this, x2 = d3.chart, f2 = x2.options.chart;
          tt2(x2, "fullscreenClose", null, function() {
            d3.isOpen && d3.browserProps && x2.container.ownerDocument instanceof Document && x2.container.ownerDocument[d3.browserProps.exitFullscreen](), d3.unbindFullscreenEvent && (d3.unbindFullscreenEvent = d3.unbindFullscreenEvent()), x2.setSize(d3.origWidth, d3.origHeight, false), d3.origWidth = void 0, d3.origHeight = void 0, f2.width = d3.origWidthOption, f2.height = d3.origHeightOption, d3.origWidthOption = void 0, d3.origHeightOption = void 0, d3.isOpen = false, d3.setButtonText();
          });
        }
        open() {
          let d3 = this, x2 = d3.chart, f2 = x2.options.chart;
          tt2(x2, "fullscreenOpen", null, function() {
            if (f2 && (d3.origWidthOption = f2.width, d3.origHeightOption = f2.height), d3.origWidth = x2.chartWidth, d3.origHeight = x2.chartHeight, d3.browserProps) {
              let C3 = rt2(x2.container.ownerDocument, d3.browserProps.fullscreenChange, function() {
                d3.isOpen ? (d3.isOpen = false, d3.close()) : (x2.setSize(null, null, false), d3.isOpen = true, d3.setButtonText());
              }), o2 = rt2(x2, "destroy", C3);
              d3.unbindFullscreenEvent = () => {
                C3(), o2();
              };
              let p2 = x2.renderTo[d3.browserProps.requestFullscreen]();
              p2 && p2.catch(function() {
                alert("Full screen is not supported inside a frame.");
              });
            }
          });
        }
        setButtonText() {
          let d3 = this.chart, x2 = d3.exportDivElements, f2 = d3.options.exporting, C3 = f2 && f2.buttons && f2.buttons.contextButton.menuItems, o2 = d3.options.lang;
          if (f2 && f2.menuItemDefinitions && o2 && o2.exitFullscreen && o2.viewFullscreen && C3 && x2) {
            let p2 = x2[C3.indexOf("viewFullscreen")];
            p2 && B3.setElementHTML(p2, this.isOpen ? o2.exitFullscreen : f2.menuItemDefinitions.viewFullscreen.text || o2.viewFullscreen);
          }
        }
        toggle() {
          this.isOpen ? this.close() : this.open();
        }
      }
      return O3;
    }), at2(s2, "Core/HttpUtilities.js", [s2["Core/Globals.js"], s2["Core/Utilities.js"]], function(B3, K2) {
      let { win: q2 } = B3, { discardElement: it2, objectEach: rt2 } = K2, tt2 = { ajax: function(Z2) {
        let X2 = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, O3 = new XMLHttpRequest();
        function j3(d3, x2) {
          Z2.error && Z2.error(d3, x2);
        }
        if (!Z2.url) return false;
        O3.open((Z2.type || "get").toUpperCase(), Z2.url, true), Z2.headers && Z2.headers["Content-Type"] || O3.setRequestHeader("Content-Type", X2[Z2.dataType || "json"] || X2.text), rt2(Z2.headers, function(d3, x2) {
          O3.setRequestHeader(x2, d3);
        }), Z2.responseType && (O3.responseType = Z2.responseType), O3.onreadystatechange = function() {
          let d3;
          if (O3.readyState === 4) {
            if (O3.status === 200) {
              if (Z2.responseType !== "blob" && (d3 = O3.responseText, Z2.dataType === "json")) try {
                d3 = JSON.parse(d3);
              } catch (x2) {
                if (x2 instanceof Error) return j3(O3, x2);
              }
              return Z2.success && Z2.success(d3, O3);
            }
            j3(O3, O3.responseText);
          }
        }, Z2.data && typeof Z2.data != "string" && (Z2.data = JSON.stringify(Z2.data)), O3.send(Z2.data);
      }, getJSON: function(Z2, X2) {
        tt2.ajax({ url: Z2, success: X2, dataType: "json", headers: { "Content-Type": "text/plain" } });
      }, post: function(Z2, X2, O3) {
        let j3 = new q2.FormData();
        rt2(X2, function(f2, C3) {
          j3.append(C3, f2);
        }), j3.append("b64", "true");
        let { filename: d3, type: x2 } = X2;
        return q2.fetch(Z2, { method: "POST", body: j3, ...O3 }).then((f2) => {
          f2.ok && f2.text().then((C3) => {
            let o2 = document.createElement("a");
            o2.href = `data:${x2};base64,${C3}`, o2.download = d3, o2.click(), it2(o2);
          });
        });
      } };
      return tt2;
    }), at2(s2, "Extensions/Exporting/Exporting.js", [s2["Core/Renderer/HTML/AST.js"], s2["Core/Chart/Chart.js"], s2["Core/Chart/ChartNavigationComposition.js"], s2["Core/Defaults.js"], s2["Extensions/Exporting/ExportingDefaults.js"], s2["Extensions/Exporting/ExportingSymbols.js"], s2["Extensions/Exporting/Fullscreen.js"], s2["Core/Globals.js"], s2["Core/HttpUtilities.js"], s2["Core/Utilities.js"]], function(B3, K2, q2, it2, rt2, tt2, Z2, X2, O3, j3) {
      var d3;
      let { defaultOptions: x2 } = it2, { doc: f2, SVG_NS: C3, win: o2 } = X2, { addEvent: p2, css: b5, createElement: h2, discardElement: c4, extend: T2, find: I3, fireEvent: G2, isObject: L2, merge: l4, objectEach: y2, pick: i5, removeEvent: t3, uniqueKey: e5 } = j3;
      return function(n4) {
        let u2, a2 = [/-/, /^(clipPath|cssText|d|height|width)$/, /^font$/, /[lL]ogical(Width|Height)$/, /^parentRule$/, /^(cssRules|ownerRules)$/, /perspective/, /TapHighlightColor/, /^transition/, /^length$/, /^\d+$/], g2 = ["fill", "stroke", "strokeLinecap", "strokeLinejoin", "strokeWidth", "textAnchor", "x", "y"];
        n4.inlineAllowlist = [];
        let r3 = ["clipPath", "defs", "desc"];
        function A3(V2) {
          let _2, et2, lt2 = this, ht2 = lt2.renderer, J2 = l4(lt2.options.navigation.buttonOptions, V2), Y2 = J2.onclick, st2 = J2.menuItems, nt2 = J2.symbolSize || 12;
          if (lt2.btnCount || (lt2.btnCount = 0), lt2.exportDivElements || (lt2.exportDivElements = [], lt2.exportSVGElements = []), J2.enabled === false || !J2.theme) return;
          let ot2 = lt2.styledMode ? {} : J2.theme;
          Y2 ? et2 = function(dt2) {
            dt2 && dt2.stopPropagation(), Y2.call(lt2, dt2);
          } : st2 && (et2 = function(dt2) {
            dt2 && dt2.stopPropagation(), lt2.contextMenu(ut2.menuClassName, st2, ut2.translateX || 0, ut2.translateY || 0, ut2.width || 0, ut2.height || 0, ut2), ut2.setState(2);
          }), J2.text && J2.symbol ? ot2.paddingLeft = i5(ot2.paddingLeft, 30) : J2.text || T2(ot2, { width: J2.width, height: J2.height, padding: 0 });
          let ut2 = ht2.button(J2.text, 0, 0, et2, ot2, void 0, void 0, void 0, void 0, J2.useHTML).addClass(V2.className).attr({ title: i5(lt2.options.lang[J2._titleKey || J2.titleKey], "") });
          ut2.menuClassName = V2.menuClassName || "highcharts-menu-" + lt2.btnCount++, J2.symbol && (_2 = ht2.symbol(J2.symbol, Math.round((J2.symbolX || 0) - nt2 / 2), Math.round((J2.symbolY || 0) - nt2 / 2), nt2, nt2, { width: nt2, height: nt2 }).addClass("highcharts-button-symbol").attr({ zIndex: 1 }).add(ut2), lt2.styledMode || _2.attr({ stroke: J2.symbolStroke, fill: J2.symbolFill, "stroke-width": J2.symbolStrokeWidth || 1 })), ut2.add(lt2.exportingGroup).align(T2(J2, { width: ut2.width, x: i5(J2.x, lt2.buttonOffset) }), true, "spacingBox"), lt2.buttonOffset += ((ut2.width || 0) + J2.buttonSpacing) * (J2.align === "right" ? -1 : 1), lt2.exportSVGElements.push(ut2, _2);
        }
        function N2() {
          if (!this.printReverseInfo) return;
          let { childNodes: V2, origDisplay: _2, resetParams: et2 } = this.printReverseInfo;
          this.moveContainers(this.renderTo), [].forEach.call(V2, function(lt2, ht2) {
            lt2.nodeType === 1 && (lt2.style.display = _2[ht2] || "");
          }), this.isPrinting = false, et2 && this.setSize.apply(this, et2), delete this.printReverseInfo, u2 = void 0, G2(this, "afterPrint");
        }
        function k3() {
          var V2;
          let _2 = f2.body, et2 = this.options.exporting.printMaxWidth, lt2 = { childNodes: _2.childNodes, origDisplay: [], resetParams: void 0 };
          this.isPrinting = true, (V2 = this.pointer) == null || V2.reset(void 0, 0), G2(this, "beforePrint"), et2 && this.chartWidth > et2 && (lt2.resetParams = [this.options.chart.width, void 0, false], this.setSize(et2, void 0, false)), [].forEach.call(lt2.childNodes, function(ht2, J2) {
            ht2.nodeType === 1 && (lt2.origDisplay[J2] = ht2.style.display, ht2.style.display = "none");
          }), this.moveContainers(_2), this.printReverseInfo = lt2;
        }
        function E2(V2) {
          V2.renderExporting(), p2(V2, "redraw", V2.renderExporting), p2(V2, "destroy", V2.destroyExport);
        }
        function R2(V2, _2, et2, lt2, ht2, J2, Y2) {
          var st2, nt2;
          let ot2 = this, ut2 = ot2.options.navigation, dt2 = ot2.chartWidth, ct2 = ot2.chartHeight, gt2 = "cache-" + V2, ft2 = Math.max(ht2, J2), pt2, mt2 = ot2[gt2];
          mt2 || (ot2.exportContextMenu = ot2[gt2] = mt2 = h2("div", { className: V2 }, { position: "absolute", zIndex: 1e3, padding: ft2 + "px", pointerEvents: "auto", ...ot2.renderer.style }, ((st2 = ot2.scrollablePlotArea) == null ? void 0 : st2.fixedDiv) || ot2.container), pt2 = h2("ul", { className: "highcharts-menu" }, ot2.styledMode ? {} : { listStyle: "none", margin: 0, padding: 0 }, mt2), ot2.styledMode || b5(pt2, T2({ MozBoxShadow: "3px 3px 10px #888", WebkitBoxShadow: "3px 3px 10px #888", boxShadow: "3px 3px 10px #888" }, ut2.menuStyle)), mt2.hideMenu = function() {
            b5(mt2, { display: "none" }), Y2 && Y2.setState(0), ot2.openMenu = false, b5(ot2.renderTo, { overflow: "hidden" }), b5(ot2.container, { overflow: "hidden" }), j3.clearTimeout(mt2.hideTimer), G2(ot2, "exportMenuHidden");
          }, ot2.exportEvents.push(p2(mt2, "mouseleave", function() {
            mt2.hideTimer = o2.setTimeout(mt2.hideMenu, 500);
          }), p2(mt2, "mouseenter", function() {
            j3.clearTimeout(mt2.hideTimer);
          }), p2(f2, "mouseup", function(vt2) {
            var bt2;
            (bt2 = ot2.pointer) != null && bt2.inClass(vt2.target, V2) || mt2.hideMenu();
          }), p2(mt2, "click", function() {
            ot2.openMenu && mt2.hideMenu();
          })), _2.forEach(function(vt2) {
            if (typeof vt2 == "string" && (vt2 = ot2.options.exporting.menuItemDefinitions[vt2]), L2(vt2, true)) {
              let bt2;
              vt2.separator ? bt2 = h2("hr", void 0, void 0, pt2) : (vt2.textKey === "viewData" && ot2.isDataTableVisible && (vt2.textKey = "hideData"), bt2 = h2("li", { className: "highcharts-menu-item", onclick: function(xt2) {
                xt2 && xt2.stopPropagation(), mt2.hideMenu(), typeof vt2 != "string" && vt2.onclick && vt2.onclick.apply(ot2, arguments);
              } }, void 0, pt2), B3.setElementHTML(bt2, vt2.text || ot2.options.lang[vt2.textKey]), ot2.styledMode || (bt2.onmouseover = function() {
                b5(this, ut2.menuItemHoverStyle);
              }, bt2.onmouseout = function() {
                b5(this, ut2.menuItemStyle);
              }, b5(bt2, T2({ cursor: "pointer" }, ut2.menuItemStyle || {})))), ot2.exportDivElements.push(bt2);
            }
          }), ot2.exportDivElements.push(pt2, mt2), ot2.exportMenuWidth = mt2.offsetWidth, ot2.exportMenuHeight = mt2.offsetHeight);
          let yt2 = { display: "block" };
          et2 + (ot2.exportMenuWidth || 0) > dt2 ? yt2.right = dt2 - et2 - ht2 - ft2 + "px" : yt2.left = et2 - ft2 + "px", lt2 + J2 + (ot2.exportMenuHeight || 0) > ct2 && ((nt2 = Y2.alignOptions) == null ? void 0 : nt2.verticalAlign) !== "top" ? yt2.bottom = ct2 - lt2 - ft2 + "px" : yt2.top = lt2 + J2 - ft2 + "px", b5(mt2, yt2), b5(ot2.renderTo, { overflow: "" }), b5(ot2.container, { overflow: "" }), ot2.openMenu = true, G2(ot2, "exportMenuShown");
        }
        function z2(V2) {
          let _2, et2 = V2 ? V2.target : this, lt2 = et2.exportSVGElements, ht2 = et2.exportDivElements, J2 = et2.exportEvents;
          lt2 && (lt2.forEach((Y2, st2) => {
            Y2 && (Y2.onclick = Y2.ontouchstart = null, et2[_2 = "cache-" + Y2.menuClassName] && delete et2[_2], lt2[st2] = Y2.destroy());
          }), lt2.length = 0), et2.exportingGroup && (et2.exportingGroup.destroy(), delete et2.exportingGroup), ht2 && (ht2.forEach(function(Y2, st2) {
            Y2 && (j3.clearTimeout(Y2.hideTimer), t3(Y2, "mouseleave"), ht2[st2] = Y2.onmouseout = Y2.onmouseover = Y2.ontouchstart = Y2.onclick = null, c4(Y2));
          }), ht2.length = 0), J2 && (J2.forEach(function(Y2) {
            Y2();
          }), J2.length = 0);
        }
        function Q2(V2, _2) {
          let et2 = this.getSVGForExport(V2, _2);
          V2 = l4(this.options.exporting, V2), O3.post(V2.url, { filename: V2.filename ? V2.filename.replace(/\//g, "-") : this.getFilename(), type: V2.type, width: V2.width, scale: V2.scale, svg: et2 }, V2.fetchOptions);
        }
        function v3() {
          return this.styledMode && this.inlineStyles(), this.container.innerHTML;
        }
        function S2() {
          let V2 = this.userOptions.title && this.userOptions.title.text, _2 = this.options.exporting.filename;
          return _2 ? _2.replace(/\//g, "-") : (typeof V2 == "string" && (_2 = V2.toLowerCase().replace(/<\/?[^>]+(>|$)/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z\d\-]/g, "").replace(/^[\-]+/g, "").replace(/[\-]+/g, "-").substr(0, 24).replace(/[\-]+$/g, "")), (!_2 || _2.length < 5) && (_2 = "chart"), _2);
        }
        function P2(V2) {
          let _2, et2, lt2 = l4(this.options, V2);
          lt2.plotOptions = l4(this.userOptions.plotOptions, V2 && V2.plotOptions), lt2.time = l4(this.userOptions.time, V2 && V2.time);
          let ht2 = h2("div", null, { position: "absolute", top: "-9999em", width: this.chartWidth + "px", height: this.chartHeight + "px" }, f2.body), J2 = this.renderTo.style.width, Y2 = this.renderTo.style.height, st2 = lt2.exporting.sourceWidth || lt2.chart.width || /px$/.test(J2) && parseInt(J2, 10) || (lt2.isGantt ? 800 : 600), nt2 = lt2.exporting.sourceHeight || lt2.chart.height || /px$/.test(Y2) && parseInt(Y2, 10) || 400;
          T2(lt2.chart, { animation: false, renderTo: ht2, forExport: true, renderer: "SVGRenderer", width: st2, height: nt2 }), lt2.exporting.enabled = false, delete lt2.data, lt2.series = [], this.series.forEach(function(dt2) {
            (et2 = l4(dt2.userOptions, { animation: false, enableMouseTracking: false, showCheckbox: false, visible: dt2.visible })).isInternal || lt2.series.push(et2);
          });
          let ot2 = {};
          this.axes.forEach(function(dt2) {
            dt2.userOptions.internalKey || (dt2.userOptions.internalKey = e5()), dt2.options.isInternal || (ot2[dt2.coll] || (ot2[dt2.coll] = true, lt2[dt2.coll] = []), lt2[dt2.coll].push(l4(dt2.userOptions, { visible: dt2.visible, type: dt2.type, uniqueNames: dt2.uniqueNames })));
          }), lt2.colorAxis = this.userOptions.colorAxis;
          let ut2 = new this.constructor(lt2, this.callback);
          return V2 && ["xAxis", "yAxis", "series"].forEach(function(dt2) {
            let ct2 = {};
            V2[dt2] && (ct2[dt2] = V2[dt2], ut2.update(ct2));
          }), this.axes.forEach(function(dt2) {
            let ct2 = I3(ut2.axes, function(mt2) {
              return mt2.options.internalKey === dt2.userOptions.internalKey;
            }), gt2 = dt2.getExtremes(), ft2 = gt2.userMin, pt2 = gt2.userMax;
            ct2 && (ft2 !== void 0 && ft2 !== ct2.min || pt2 !== void 0 && pt2 !== ct2.max) && ct2.setExtremes(ft2, pt2, true, false);
          }), _2 = ut2.getChartHTML(), G2(this, "getSVG", { chartCopy: ut2 }), _2 = this.sanitizeSVG(_2, lt2), lt2 = null, ut2.destroy(), c4(ht2), _2;
        }
        function U2(V2, _2) {
          let et2 = this.options.exporting;
          return this.getSVG(l4({ chart: { borderRadius: 0 } }, et2.chartOptions, _2, { exporting: { sourceWidth: V2 && V2.sourceWidth || et2.sourceWidth, sourceHeight: V2 && V2.sourceHeight || et2.sourceHeight } }));
        }
        function w2() {
          let V2, _2 = n4.inlineAllowlist, et2 = {}, lt2 = f2.createElement("iframe");
          b5(lt2, { width: "1px", height: "1px", visibility: "hidden" }), f2.body.appendChild(lt2);
          let ht2 = lt2.contentWindow && lt2.contentWindow.document;
          ht2 && ht2.body.appendChild(ht2.createElementNS(C3, "svg")), function J2(Y2) {
            let st2, nt2, ot2, ut2, dt2, ct2, gt2 = {};
            if (ht2 && Y2.nodeType === 1 && r3.indexOf(Y2.nodeName) === -1) {
              if (st2 = o2.getComputedStyle(Y2, null), nt2 = Y2.nodeName === "svg" ? {} : o2.getComputedStyle(Y2.parentNode, null), !et2[Y2.nodeName]) {
                V2 = ht2.getElementsByTagName("svg")[0], ot2 = ht2.createElementNS(Y2.namespaceURI, Y2.nodeName), V2.appendChild(ot2);
                let ft2 = o2.getComputedStyle(ot2, null), pt2 = {};
                for (let mt2 in ft2) mt2.length < 1e3 && typeof ft2[mt2] == "string" && !/^\d+$/.test(mt2) && (pt2[mt2] = ft2[mt2]);
                et2[Y2.nodeName] = pt2, Y2.nodeName === "text" && delete et2.text.fill, V2.removeChild(ot2);
              }
              for (let ft2 in st2) (X2.isFirefox || X2.isMS || X2.isSafari || Object.hasOwnProperty.call(st2, ft2)) && function(pt2, mt2) {
                if (ut2 = dt2 = false, _2.length) {
                  for (ct2 = _2.length; ct2-- && !dt2; ) dt2 = _2[ct2].test(mt2);
                  ut2 = !dt2;
                }
                for (mt2 === "transform" && pt2 === "none" && (ut2 = true), ct2 = a2.length; ct2-- && !ut2; ) {
                  if (mt2.length > 1e3) throw Error("Input too long");
                  ut2 = a2[ct2].test(mt2) || typeof pt2 == "function";
                }
                !ut2 && (nt2[mt2] !== pt2 || Y2.nodeName === "svg") && et2[Y2.nodeName][mt2] !== pt2 && (g2.indexOf(mt2) === -1 ? gt2[mt2] = pt2 : pt2 && Y2.setAttribute(mt2.replace(/[A-Z]/g, function(yt2) {
                  return "-" + yt2.toLowerCase();
                }), pt2));
              }(st2[ft2], ft2);
              if (b5(Y2, gt2), Y2.nodeName === "svg" && Y2.setAttribute("stroke-width", "1px"), Y2.nodeName === "text") return;
              [].forEach.call(Y2.children || Y2.childNodes, J2);
            }
          }(this.container.querySelector("svg")), V2.parentNode.removeChild(V2), lt2.parentNode.removeChild(lt2);
        }
        function M2(V2) {
          let { scrollablePlotArea: _2 } = this;
          (_2 ? [_2.fixedDiv, _2.scrollingContainer] : [this.container]).forEach(function(et2) {
            V2.appendChild(et2);
          });
        }
        function D2() {
          let V2 = this, _2 = (et2, lt2, ht2) => {
            V2.isDirtyExporting = true, l4(true, V2.options[et2], lt2), i5(ht2, true) && V2.redraw();
          };
          V2.exporting = { update: function(et2, lt2) {
            _2("exporting", et2, lt2);
          } }, q2.compose(V2).navigation.addUpdate((et2, lt2) => {
            _2("navigation", et2, lt2);
          });
        }
        function F2() {
          let V2 = this;
          V2.isPrinting || (u2 = V2, X2.isSafari || V2.beforePrint(), setTimeout(() => {
            o2.focus(), o2.print(), X2.isSafari || setTimeout(() => {
              V2.afterPrint();
            }, 1e3);
          }, 1));
        }
        function $2() {
          let V2 = this, _2 = V2.options.exporting, et2 = _2.buttons, lt2 = V2.isDirtyExporting || !V2.exportSVGElements;
          V2.buttonOffset = 0, V2.isDirtyExporting && V2.destroyExport(), lt2 && _2.enabled !== false && (V2.exportEvents = [], V2.exportingGroup = V2.exportingGroup || V2.renderer.g("exporting-group").attr({ zIndex: 3 }).add(), y2(et2, function(ht2) {
            V2.addButton(ht2);
          }), V2.isDirtyExporting = false);
        }
        function W2(V2, _2) {
          let et2 = V2.indexOf("</svg>") + 6, lt2 = V2.substr(et2);
          return V2 = V2.substr(0, et2), _2 && _2.exporting && _2.exporting.allowHTML && lt2 && (lt2 = '<foreignObject x="0" y="0" width="' + _2.chart.width + '" height="' + _2.chart.height + '"><body xmlns="http://www.w3.org/1999/xhtml">' + lt2.replace(/(<(?:img|br).*?(?=\>))>/g, "$1 />") + "</body></foreignObject>", V2 = V2.replace("</svg>", lt2 + "</svg>")), V2 = V2.replace(/zIndex="[^"]+"/g, "").replace(/symbolName="[^"]+"/g, "").replace(/jQuery\d+="[^"]+"/g, "").replace(/url\(("|&quot;)(.*?)("|&quot;)\;?\)/g, "url($2)").replace(/url\([^#]+#/g, "url(#").replace(/<svg /, '<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (NS\d+\:)?href=/g, " xlink:href=").replace(/\n+/g, " ").replace(/(fill|stroke)="rgba\(([ \d]+,[ \d]+,[ \d]+),([ \d\.]+)\)"/g, '$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g, " ").replace(/&shy;/g, "­");
        }
        n4.compose = function(V2, _2) {
          tt2.compose(_2), Z2.compose(V2);
          let et2 = V2.prototype;
          et2.exportChart || (et2.afterPrint = N2, et2.exportChart = Q2, et2.inlineStyles = w2, et2.print = F2, et2.sanitizeSVG = W2, et2.getChartHTML = v3, et2.getSVG = P2, et2.getSVGForExport = U2, et2.getFilename = S2, et2.moveContainers = M2, et2.beforePrint = k3, et2.contextMenu = R2, et2.addButton = A3, et2.destroyExport = z2, et2.renderExporting = $2, et2.callbacks.push(E2), p2(V2, "init", D2), X2.isSafari && o2.matchMedia("print").addListener(function(lt2) {
            u2 && (lt2.matches ? u2.beforePrint() : u2.afterPrint());
          }), x2.exporting = l4(rt2.exporting, x2.exporting), x2.lang = l4(rt2.lang, x2.lang), x2.navigation = l4(rt2.navigation, x2.navigation));
        };
      }(d3 || (d3 = {})), d3;
    }), at2(s2, "masters/modules/exporting.src.js", [s2["Core/Globals.js"], s2["Extensions/Exporting/Exporting.js"], s2["Core/HttpUtilities.js"]], function(B3, K2, q2) {
      return B3.HttpUtilities = B3.HttpUtilities || q2, B3.ajax = B3.HttpUtilities.ajax, B3.getJSON = B3.HttpUtilities.getJSON, B3.post = B3.HttpUtilities.post, K2.compose(B3.Chart, B3.Renderer), B3;
    });
  });
})(vs);
var il = vs.exports;
const sl = /* @__PURE__ */ ce(il);
var rl = Object.defineProperty, nl = Object.getOwnPropertyDescriptor, Re$1 = (m3, H2, s2, at2) => {
  for (var B3 = at2 > 1 ? void 0 : at2 ? nl(H2, s2) : H2, K2 = m3.length - 1, q2; K2 >= 0; K2--)
    (q2 = m3[K2]) && (B3 = (at2 ? q2(H2, s2, B3) : q2(B3)) || B3);
  return at2 && B3 && rl(H2, s2, B3), B3;
};
function gl(m3) {
  let H2 = class extends m3 {
    constructor() {
      super(...arguments), this.tableId = void 0, this.disableExporting = false;
    }
    get localComponentOptions() {
      var s2, at2;
      return qa.createChartOptions(super.localComponentOptions, {
        data: {
          table: this.tableId
        },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: this.tableId ? H2.exportMenuItemsLimited : H2.exportMenuItemsDefault
            }
          },
          chartOptions: {
            chart: {
              styledMode: false
              // Turned off because the exported images don't know the styles we apply
            }
          },
          enabled: !this.disableExporting,
          sourceHeight: (s2 = this.chartSize) == null ? void 0 : s2.chartHeight,
          sourceWidth: (at2 = this.chartSize) == null ? void 0 : at2.chartWidth
        },
        plotOptions: {
          custom: {
            tableElement: this.getScopedTagName("beacon-table")
          }
        }
      });
    }
    initializeHighcharts(s2) {
      super.initializeHighcharts(s2), sl(s2), el(s2), Qa(s2), s2.addEvent(s2.Chart, "afterViewData", _s);
    }
    willUpdate(s2) {
      var at2, B3;
      (at2 = super.willUpdate) == null || at2.call(this, s2), s2.has("disableExporting") && ((B3 = this.chart) == null || B3.update({
        exporting: {
          enabled: !this.disableExporting
        }
      }));
    }
  };
  return H2.exportMenuItemsDefault = [
    "viewFullscreen",
    "separator",
    "downloadCSV",
    "viewData"
  ], H2.exportMenuItemsLimited = [
    "viewFullscreen",
    "separator",
    "downloadCSV"
  ], Re$1([
    v$c({ attribute: "table-id" })
  ], H2.prototype, "tableId", 2), Re$1([
    v$c({ type: Boolean, attribute: "disable-exporting" })
  ], H2.prototype, "disableExporting", 2), H2 = Re$1([
    f$8("Exporting")
  ], H2), H2;
}
const N = T$7`:root[beacon-tag-name=beacon-donut-chart][scale=mini],:root [beacon-tag-name=beacon-donut-chart][scale=mini],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-donut-chart][scale=mini],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-donut-chart][scale=mini],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-donut-chart][scale=mini],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-donut-chart][scale=mini],[beacon-version="4.2.2"][beacon-tag-name=beacon-donut-chart][scale=mini],[beacon-version="4.2.2"] [beacon-tag-name=beacon-donut-chart][scale=mini]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200)}:root[beacon-tag-name=beacon-donut-chart][scale=normal],:root [beacon-tag-name=beacon-donut-chart][scale=normal],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-donut-chart][scale=normal],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-donut-chart][scale=normal],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-donut-chart][scale=normal],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-donut-chart][scale=normal],[beacon-version="4.2.2"][beacon-tag-name=beacon-donut-chart][scale=normal],[beacon-version="4.2.2"] [beacon-tag-name=beacon-donut-chart][scale=normal]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-400)}:root[beacon-tag-name=beacon-donut-chart][scale=jumbo],:root [beacon-tag-name=beacon-donut-chart][scale=jumbo],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-donut-chart][scale=jumbo],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-donut-chart][scale=jumbo],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-donut-chart][scale=jumbo],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-donut-chart][scale=jumbo],[beacon-version="4.2.2"][beacon-tag-name=beacon-donut-chart][scale=jumbo],[beacon-version="4.2.2"] [beacon-tag-name=beacon-donut-chart][scale=jumbo]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-600)}`, a$2 = {
  beaconTagName: "beacon-donut-chart",
  pieSizePercentage: "80%",
  percentageWidth: 0.64,
  distanceNumber: 4,
  drilldownName: "has-drilldown",
  drilldownActiveName: "is-drilldown",
  monoColorName: "mono-color",
  inactiveDataLabelClass: "data-label--inactive",
  minimumSizeJumbo: 180,
  // @MISSING_SYSTEM_TOKEN was Heritage Token: beaconDonutChartSizeWidthJumbo
  minimumSizeDefault: 160,
  // @MISSING_SYSTEM_TOKEN was Heritage token: beaconDonutChartSizeWidthNormal
  maxLabelIndexSmallBreakpoint: 3,
  maxLabelAngle: 4,
  defaultLabelDistance: 10,
  transparentConnectorClass: "transparent-connector",
  tooltipOrientation: "vertical",
  attributes: {
    metricTotal: "metric-total",
    metricDescription: "metric-description",
    hideChartMetric: "hide-chart-metric",
    tooltipFormat: "tooltip-format",
    startingAngle: "starting-angle",
    labelDistance: "label-distance",
    hideDataLabelConnectors: "hide-data-label-connectors",
    hideDataLabels: "hide-data-labels"
  },
  properties: {
    metricTotal: "metricTotal",
    metricDescription: "metricDescription",
    hideChartMetric: "hideChartMetric",
    tooltipFormat: "tooltipFormat",
    scale: "scale",
    series: "series",
    disableLegend: "disableLegend"
  },
  metricWrapperClass: "metric-wrapper",
  highchartsDataLabelConnectorClass: "highchart-data-label-connector",
  highchartsColorClass: "highcharts-color",
  highchartsDataLabelClass: "highcharts-data-label",
  tooltipID: "chart-custom-tooltip"
}, x$1 = T$7`.metric-wrapper{display:var(--beacon-donut-chart-metric-display, block);inline-size:var(--metric-total-inline-size);overflow:hidden;text-align:center;white-space:initial;word-break:break-word}.metric-wrapper p{margin:0}.metric-wrapper .metric-total{font:var(--donut-chart-metric-total-font, var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-600))}.metric-wrapper .metric-description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-light-headline-100)}:host[scale=mini]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-200)}:host[scale=normal]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-400)}:host[scale=jumbo]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-600)}.highcharts-data-labels{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.highcharts-data-labels text{fill:var(--beacon-system-color-text-standard)}.highcharts-data-label-connector{fill:none;stroke:var(--beacon-reference-palette-grayscale-light-gray-1)}.highcharts-point{stroke:var(--beacon-reference-palette-grayscale-dark-gray-2)}.highcharts-point.highcharts-point-hover{fill-opacity:1}.transparent-connector.highcharts-data-label-connector{stroke:transparent}.deselected .metric-wrapper,.highcharts-legend .highcharts-legend-item .highcharts-point{display:none}.highcharts-custom-circles circle{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini, 1px)}:host([hide-data-label-connectors]) .highcharts-data-label-connector{display:none}.highcharts-pie-series .highcharts-point{stroke:var(--beacon-system-color-background-1)}`;
var j2 = Object.defineProperty, c3 = (e5, t3, i5, o2) => {
  for (var n4 = void 0, r3 = e5.length - 1, l4; r3 >= 0; r3--)
    (l4 = e5[r3]) && (n4 = l4(t3, i5, n4) || n4);
  return n4 && j2(t3, i5, n4), n4;
};
function $$1(e5) {
  return typeof e5.itemHeight == "number";
}
function F$1(e5) {
  return typeof e5.itemHeight == "number";
}
var b$3;
const s$1 = (b$3 = class extends B$5(qa).with(gl) {
  constructor() {
    super(), this.beaconTagName = a$2.beaconTagName, this.internalMetricTotal = "", this.metricTotal = "", this.metricDescription = "", this.scale = o$9.NORMAL, this.hideChartMetric = false, this.labelDistance = 30, this.hideDataLabelConnectors = false, this.hideDataLabels = false, this.staticLegend = true, this._type = te$2.PIE, this.resizeObserver = new ResizeObserver(
      r$6(() => {
        this.chart && (this.updateChartMetricOptions(), this.updateChartHeight());
      }, 200)
    ), this.updateChartMetricTotal = this.updateChartMetricTotal.bind(this);
  }
  static get styles() {
    return [super.styles, x$1];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, N];
  }
  /** Minimum size for the donut itself to be. */
  get minimumDonutSize() {
    return this.scale === o$9.JUMBO && !this.hideChartMetric ? a$2.minimumSizeJumbo : a$2.minimumSizeDefault;
  }
  /**
   * Setting Pie Chart related Configuration
   */
  get localComponentOptions() {
    const e5 = this;
    return qa.createChartOptions(super.localComponentOptions, {
      chart: {
        events: {
          render() {
            const t3 = this.series[0];
            if (t3.center) {
              const [, i5] = t3.center, o2 = this.container.querySelector(
                `.${a$2.metricWrapperClass}`
              );
              if (o2) {
                const n4 = o2.getBoundingClientRect().height;
                if (t3 && t3.options) {
                  const r3 = t3.options, l4 = parseInt(
                    r3.innerSize || "0",
                    10
                  ) / 2;
                  this.subtitle.attr({
                    y: i5 - n4 / 2 + l4 / 2
                  });
                }
              }
            }
            e5.updateChartMetricTotal(this), e5.resizeObserver.observe(e5), b$3.createCustomCircles(this);
          }
        }
      },
      plotOptions: {
        pie: {
          center: ["50%", "50%"],
          borderRadius: 0,
          innerSize: `${a$2.pieSizePercentage}`,
          minSize: this.minimumDonutSize,
          dataLabels: {
            enabled: !this.hideDataLabels,
            padding: 0,
            distance: this.labelDistance,
            formatter: function() {
              return qa.percentageFormatter(
                e5.percentage,
                this.point.y,
                this.total,
                e5.decimal,
                e5.decimalPlaces
              );
            }
          }
        },
        series: {
          states: {
            hover: {
              halo: null
            }
          },
          // Displays the legend in the chart
          showInLegend: true
        }
      },
      /**
       * Renders the chart metric with the subtitle instead,
       * to utilize default centering when the legend isn't rendered.
       */
      subtitle: {
        useHTML: true,
        text: this.renderChartMetric(),
        floating: true,
        verticalAlign: "middle",
        align: "center",
        y: 0
      },
      responsive: {
        rules: [
          {
            // Currently does nothing but can be used to dynamically adjust subtitle's y value, see this highcharts doc page
            // https://www.highcharts.com/docs/chart-concepts/responsive
            condition: {
              callback() {
                return window.innerWidth >= L$5.MEDIUM;
              }
            }
          }
        ]
      },
      tooltip: {
        headerFormat: "",
        pointFormatter() {
          const t3 = qa.percentageFormatter(
            e5.percentage,
            this.options.y,
            this.total,
            e5.decimal,
            e5.decimalPlaces
          );
          return qa.tooltipPointHTML(this, this.name, t3 || "");
        }
      }
    });
  }
  /*
   * Metric width to be calculated as 64% of pie chart
   **/
  get MetricTotalInlineSize() {
    if (this.chart) {
      const e5 = this.chart.series[0].center[2];
      if (this.metricWrapper)
        return e5 * 0.64;
    }
    return 120;
  }
  /**
   * Non Lit Templated HTML render method used to render the chartMetric as the chart option's subtitle text.
   */
  renderChartMetric() {
    return this.internalMetricTotal && !this.hideChartMetric ? `
      <div class="${a$2.metricWrapperClass}" style="inline-size: ${this.MetricTotalInlineSize}px">
      <p class="${a$2.attributes.metricTotal}" aria-describedby="${a$2.attributes.metricDescription}">
      ${this.internalMetricTotal}
    </p>
    <p class="${a$2.attributes.metricDescription}" id="${a$2.attributes.metricDescription}">
      ${this.metricDescription}
    </p></div>` : "";
  }
  /**
   * Overrides how color order is calculated, since donut charts only have one series,
   * you need the length of the data in that series for calculating the color-order
   */
  calculateSeriesLength(e5) {
    var t3;
    return (t3 = e5.series[0]) == null ? void 0 : t3.data.length;
  }
  /**
   * Updates the chart metric total value on chart load and redraw events,
   * as well as willUpdate. Extracted from the metric rendering method.
   * @param chart
   */
  updateChartMetricTotal(e5) {
    if (this.metricTotal) {
      this.internalMetricTotal = this.metricTotal;
      return;
    }
    const t3 = e5.series[0].total;
    t3 && (this.internalMetricTotal = t3.toFixed(0));
  }
  /**
   * Used to update the metric chart options in willUpdate
   * when this.metricTotal is updated
   */
  updateChartMetricOptions() {
    this.updateChart({
      subtitle: {
        useHTML: true,
        text: this.renderChartMetric(),
        verticalAlign: "middle",
        align: "center"
      }
    });
  }
  /**
   * This method changes the height of the chart based on the legend layout
   */
  updateChartHeight() {
    if (this.chart) {
      if (this.legendLayout.direction === "vertical" || window.innerWidth < L$5.MEDIUM) {
        let e5 = 20;
        if (this.chart.legend.allItems.length > 0) {
          const n4 = this.chart.legend.allItems[0];
          (n4 instanceof Qt$1.Point && F$1(n4) || n4 instanceof Qt$1.Series && $$1(n4)) && (e5 = n4.itemHeight);
        }
        const t3 = this.chart.legend.allItems.length, i5 = e5 * t3, o2 = _i.HEIGHT + i5;
        this.chart.update({
          chart: {
            height: o2
          }
        });
      } else
        this.chart.update({
          chart: {
            height: _i.HEIGHT
          }
        });
      this.updateChartMetricOptions();
    }
  }
  /**
   * This method is to create custom circles (outer and inner) for the donut chart, so that we can apply border to both of them to meet design requirements
   */
  static createCustomCircles(e5) {
    var t3, i5, o2, n4, r3, l4;
    e5.customCircles && (e5.customCircles.destroy(), e5.customCircles = void 0);
    const y2 = e5.renderer, M2 = e5.plotLeft + (e5 == null ? void 0 : e5.plotWidth) / 2, D2 = e5.plotTop + (e5 == null ? void 0 : e5.plotHeight) / 2, w2 = [
      (o2 = (i5 = (t3 = e5.series[0]) == null ? void 0 : t3.data[0]) == null ? void 0 : i5.shapeArgs) == null ? void 0 : o2.r,
      (l4 = (r3 = (n4 = e5.series[0]) == null ? void 0 : n4.data[0]) == null ? void 0 : r3.shapeArgs) == null ? void 0 : l4.innerR
    ];
    e5.customCircles = e5.renderer.g("custom-circles").add(), w2.forEach((L2) => {
      var u2;
      y2.circle(M2, D2, L2).attr({
        fill: "none"
      }).add(e5.customCircles), (u2 = e5.customCircles) == null || u2.attr({
        zIndex: 10
        // Adjust this value as needed
      }).add();
    });
  }
  /**
   * On Chart Load called on load event callback. Adds Metric Text and discription after chart load.
   * @param chart Highcharts.Chart
   */
  onChartLoad(e5) {
    this.chart && (this.updateChartMetricTotal(e5), this.updateChartMetricOptions());
  }
  /**
   * On Resizes updates the center text element of the chart.
   * @param chart Highcharts.Chart
   */
  onChartRedraw() {
    this.chart && this.updateChartMetricTotal(this.chart);
  }
  willUpdate(e5) {
    var t3;
    (t3 = super.willUpdate) == null || t3.call(this, e5);
    const i5 = this.hideLegendMetric, o2 = this.type, n4 = this.decimal, r3 = this.decimalPlaces;
    e5.has(a$2.properties.metricTotal) && this.updateChartMetricOptions(), e5.has(a$2.properties.metricDescription) && this.updateChartMetricOptions(), e5.has(a$2.properties.series) && this.chart && this.onChartLoad(this.chart), (e5.has(a$2.properties.disableLegend) || e5.has("hideChartMetric")) && this.chart && this.updateChartMetricOptions(), e5.has("legendLayout") && this.updateChart({
      legend: {
        labelFormatter() {
          return qa.legendItemHTML(
            this,
            i5,
            false,
            o2,
            n4,
            r3
          );
        }
      }
    }), e5.has("labelDistance") && this.updateChart({
      plotOptions: {
        pie: {
          dataLabels: {
            distance: this.labelDistance
          }
        }
      }
    }), e5.has("hideDataLabels") && this.updateChart({
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: !this.hideDataLabels
          }
        }
      }
    });
  }
}, b$3.tagName = a$2.beaconTagName, b$3);
c3([
  it()
], s$1.prototype, "internalMetricTotal");
c3([
  v$c({ attribute: a$2.attributes.metricTotal })
], s$1.prototype, "metricTotal");
c3([
  v$c({ attribute: a$2.attributes.metricDescription })
], s$1.prototype, "metricDescription");
c3([
  v$c({ reflect: true })
], s$1.prototype, "scale");
c3([
  v$c({ attribute: a$2.attributes.hideChartMetric, type: Boolean })
], s$1.prototype, "hideChartMetric");
c3([
  h$9(`.${a$2.metricWrapperClass}`)
], s$1.prototype, "metricWrapper");
c3([
  v$c({ type: Number, attribute: a$2.attributes.labelDistance })
], s$1.prototype, "labelDistance");
c3([
  v$c({
    attribute: a$2.attributes.hideDataLabelConnectors,
    type: Boolean
  })
], s$1.prototype, "hideDataLabelConnectors");
c3([
  v$c({ attribute: a$2.attributes.hideDataLabels, type: Boolean })
], s$1.prototype, "hideDataLabels");
let m$1 = s$1;
const q = (e5) => (Se$3(e5, m$1), Dt$3({
  tagName: e5 ? e5 + "-" + m$1.tagName : m$1.tagName,
  elementClass: m$1,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var re = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], A$1 = /* @__PURE__ */ re.join(","), ae = typeof Element > "u", S$1 = ae ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, C2 = !ae && Element.prototype.getRootNode ? function(e5) {
  var t3;
  return e5 == null || (t3 = e5.getRootNode) === null || t3 === void 0 ? void 0 : t3.call(e5);
} : function(e5) {
  return e5 == null ? void 0 : e5.ownerDocument;
}, G = function e(t3, n4) {
  var i5;
  n4 === void 0 && (n4 = true);
  var u2 = t3 == null || (i5 = t3.getAttribute) === null || i5 === void 0 ? void 0 : i5.call(t3, "inert"), a2 = u2 === "" || u2 === "true", s2 = a2 || n4 && t3 && e(t3.parentNode);
  return s2;
}, de = function(e5) {
  var t3, n4 = e5 == null || (t3 = e5.getAttribute) === null || t3 === void 0 ? void 0 : t3.call(e5, "contenteditable");
  return n4 === "" || n4 === "true";
}, oe = function(e5, t3, n4) {
  if (G(e5))
    return [];
  var i5 = Array.prototype.slice.apply(e5.querySelectorAll(A$1));
  return t3 && S$1.call(e5, A$1) && i5.unshift(e5), i5 = i5.filter(n4), i5;
}, ie$1 = function e2(t3, n4, i5) {
  for (var u2 = [], a2 = Array.from(t3); a2.length; ) {
    var s2 = a2.shift();
    if (!G(s2, false))
      if (s2.tagName === "SLOT") {
        var c4 = s2.assignedElements(), m3 = c4.length ? c4 : s2.children, h2 = e2(m3, true, i5);
        i5.flatten ? u2.push.apply(u2, h2) : u2.push({
          scopeParent: s2,
          candidates: h2
        });
      } else {
        var g2 = S$1.call(s2, A$1);
        g2 && i5.filter(s2) && (n4 || !t3.includes(s2)) && u2.push(s2);
        var w2 = s2.shadowRoot || // check for an undisclosed shadow
        typeof i5.getShadowRoot == "function" && i5.getShadowRoot(s2), j3 = !G(w2, false) && (!i5.shadowRootFilter || i5.shadowRootFilter(s2));
        if (w2 && j3) {
          var N2 = e2(w2 === true ? s2.children : w2.children, true, i5);
          i5.flatten ? u2.push.apply(u2, N2) : u2.push({
            scopeParent: s2,
            candidates: N2
          });
        } else
          a2.unshift.apply(a2, s2.children);
      }
  }
  return u2;
}, ue$1 = function(e5) {
  return !isNaN(parseInt(e5.getAttribute("tabindex"), 10));
}, O$1 = function(e5) {
  if (!e5)
    throw new Error("No node provided");
  return e5.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e5.tagName) || de(e5)) && !ue$1(e5) ? 0 : e5.tabIndex;
}, be = function(e5, t3) {
  var n4 = O$1(e5);
  return n4 < 0 && t3 && !ue$1(e5) ? 0 : n4;
}, pe = function(e5, t3) {
  return e5.tabIndex === t3.tabIndex ? e5.documentOrder - t3.documentOrder : e5.tabIndex - t3.tabIndex;
}, le = function(e5) {
  return e5.tagName === "INPUT";
}, ve = function(e5) {
  return le(e5) && e5.type === "hidden";
}, me = function(e5) {
  var t3 = e5.tagName === "DETAILS" && Array.prototype.slice.apply(e5.children).some(function(n4) {
    return n4.tagName === "SUMMARY";
  });
  return t3;
}, he = function(e5, t3) {
  for (var n4 = 0; n4 < e5.length; n4++)
    if (e5[n4].checked && e5[n4].form === t3)
      return e5[n4];
}, ye = function(e5) {
  if (!e5.name)
    return true;
  var t3 = e5.form || C2(e5), n4 = function(a2) {
    return t3.querySelectorAll('input[type="radio"][name="' + a2 + '"]');
  }, i5;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i5 = n4(window.CSS.escape(e5.name));
  else
    try {
      i5 = n4(e5.name);
    } catch (a2) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a2.message), false;
    }
  var u2 = he(i5, e5.form);
  return !u2 || u2 === e5;
}, ge = function(e5) {
  return le(e5) && e5.type === "radio";
}, we = function(e5) {
  return ge(e5) && !ye(e5);
}, Ne2 = function(e5) {
  var t3, n4 = e5 && C2(e5), i5 = (t3 = n4) === null || t3 === void 0 ? void 0 : t3.host, u2 = false;
  if (n4 && n4 !== e5) {
    var a2, s2, c4;
    for (u2 = !!((a2 = i5) !== null && a2 !== void 0 && (s2 = a2.ownerDocument) !== null && s2 !== void 0 && s2.contains(i5) || e5 != null && (c4 = e5.ownerDocument) !== null && c4 !== void 0 && c4.contains(e5)); !u2 && i5; ) {
      var m3, h2, g2;
      n4 = C2(i5), i5 = (m3 = n4) === null || m3 === void 0 ? void 0 : m3.host, u2 = !!((h2 = i5) !== null && h2 !== void 0 && (g2 = h2.ownerDocument) !== null && g2 !== void 0 && g2.contains(i5));
    }
  }
  return u2;
}, J = function(e5) {
  var t3 = e5.getBoundingClientRect(), n4 = t3.width, i5 = t3.height;
  return n4 === 0 && i5 === 0;
}, Ee = function(e5, t3) {
  var n4 = t3.displayCheck, i5 = t3.getShadowRoot;
  if (getComputedStyle(e5).visibility === "hidden")
    return true;
  var u2 = S$1.call(e5, "details>summary:first-of-type"), a2 = u2 ? e5.parentElement : e5;
  if (S$1.call(a2, "details:not([open]) *"))
    return true;
  if (!n4 || n4 === "full" || n4 === "legacy-full") {
    if (typeof i5 == "function") {
      for (var s2 = e5; e5; ) {
        var c4 = e5.parentElement, m3 = C2(e5);
        if (c4 && !c4.shadowRoot && i5(c4) === true)
          return J(e5);
        e5.assignedSlot ? e5 = e5.assignedSlot : !c4 && m3 !== e5.ownerDocument ? e5 = m3.host : e5 = c4;
      }
      e5 = s2;
    }
    if (Ne2(e5))
      return !e5.getClientRects().length;
    if (n4 !== "legacy-full")
      return true;
  } else if (n4 === "non-zero-area")
    return J(e5);
  return false;
}, Oe = function(e5) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e5.tagName))
    for (var t3 = e5.parentElement; t3; ) {
      if (t3.tagName === "FIELDSET" && t3.disabled) {
        for (var n4 = 0; n4 < t3.children.length; n4++) {
          var i5 = t3.children.item(n4);
          if (i5.tagName === "LEGEND")
            return S$1.call(t3, "fieldset[disabled] *") ? true : !i5.contains(e5);
        }
        return true;
      }
      t3 = t3.parentElement;
    }
  return false;
}, L = function(e5, t3) {
  return !(t3.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  G(t3) || ve(t3) || Ee(t3, e5) || // For a details element with a summary, the summary element gets the focus
  me(t3) || Oe(t3));
}, $ = function(e5, t3) {
  return !(we(t3) || O$1(t3) < 0 || !L(e5, t3));
}, Se = function(e5) {
  var t3 = parseInt(e5.getAttribute("tabindex"), 10);
  return !!(isNaN(t3) || t3 >= 0);
}, Fe = function e3(t3) {
  var n4 = [], i5 = [];
  return t3.forEach(function(u2, a2) {
    var s2 = !!u2.scopeParent, c4 = s2 ? u2.scopeParent : u2, m3 = be(c4, s2), h2 = s2 ? e3(u2.candidates) : c4;
    m3 === 0 ? s2 ? n4.push.apply(n4, h2) : n4.push(c4) : i5.push({
      documentOrder: a2,
      tabIndex: m3,
      item: u2,
      isScope: s2,
      content: h2
    });
  }), i5.sort(pe).reduce(function(u2, a2) {
    return a2.isScope ? u2.push.apply(u2, a2.content) : u2.push(a2.content), u2;
  }, []).concat(n4);
}, Te2 = function(e5, t3) {
  t3 = t3 || {};
  var n4;
  return t3.getShadowRoot ? n4 = ie$1([e5], t3.includeContainer, {
    filter: $.bind(null, t3),
    flatten: false,
    getShadowRoot: t3.getShadowRoot,
    shadowRootFilter: Se
  }) : n4 = oe(e5, t3.includeContainer, $.bind(null, t3)), Fe(n4);
}, De = function(e5, t3) {
  t3 = t3 || {};
  var n4;
  return t3.getShadowRoot ? n4 = ie$1([e5], t3.includeContainer, {
    filter: L.bind(null, t3),
    flatten: true,
    getShadowRoot: t3.getShadowRoot
  }) : n4 = oe(e5, t3.includeContainer, L.bind(null, t3)), n4;
}, T = function(e5, t3) {
  if (t3 = t3 || {}, !e5)
    throw new Error("No node provided");
  return S$1.call(e5, A$1) === false ? false : $(t3, e5);
}, Re2 = /* @__PURE__ */ re.concat("iframe").join(","), M$1 = function(e5, t3) {
  if (t3 = t3 || {}, !e5)
    throw new Error("No node provided");
  return S$1.call(e5, Re2) === false ? false : L(t3, e5);
};
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Q(e5, t3) {
  var n4 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var i5 = Object.getOwnPropertySymbols(e5);
    t3 && (i5 = i5.filter(function(u2) {
      return Object.getOwnPropertyDescriptor(e5, u2).enumerable;
    })), n4.push.apply(n4, i5);
  }
  return n4;
}
function _$1(e5) {
  for (var t3 = 1; t3 < arguments.length; t3++) {
    var n4 = arguments[t3] != null ? arguments[t3] : {};
    t3 % 2 ? Q(Object(n4), true).forEach(function(i5) {
      ke2(e5, i5, n4[i5]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(n4)) : Q(Object(n4)).forEach(function(i5) {
      Object.defineProperty(e5, i5, Object.getOwnPropertyDescriptor(n4, i5));
    });
  }
  return e5;
}
function ke2(e5, t3, n4) {
  return t3 = xe2(t3), t3 in e5 ? Object.defineProperty(e5, t3, {
    value: n4,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e5[t3] = n4, e5;
}
function Pe(e5, t3) {
  if (typeof e5 != "object" || e5 === null) return e5;
  var n4 = e5[Symbol.toPrimitive];
  if (n4 !== void 0) {
    var i5 = n4.call(e5, t3 || "default");
    if (typeof i5 != "object") return i5;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t3 === "string" ? String : Number)(e5);
}
function xe2(e5) {
  var t3 = Pe(e5, "string");
  return typeof t3 == "symbol" ? t3 : String(t3);
}
var ee$1 = {
  activateTrap: function(e5, t3) {
    if (e5.length > 0) {
      var n4 = e5[e5.length - 1];
      n4 !== t3 && n4.pause();
    }
    var i5 = e5.indexOf(t3);
    i5 === -1 || e5.splice(i5, 1), e5.push(t3);
  },
  deactivateTrap: function(e5, t3) {
    var n4 = e5.indexOf(t3);
    n4 !== -1 && e5.splice(n4, 1), e5.length > 0 && e5[e5.length - 1].unpause();
  }
}, Ie = function(e5) {
  return e5.tagName && e5.tagName.toLowerCase() === "input" && typeof e5.select == "function";
}, Ae = function(e5) {
  return (e5 == null ? void 0 : e5.key) === "Escape" || (e5 == null ? void 0 : e5.key) === "Esc" || (e5 == null ? void 0 : e5.keyCode) === 27;
}, P$1 = function(e5) {
  return (e5 == null ? void 0 : e5.key) === "Tab" || (e5 == null ? void 0 : e5.keyCode) === 9;
}, Ce2 = function(e5) {
  return P$1(e5) && !e5.shiftKey;
}, Ge = function(e5) {
  return P$1(e5) && e5.shiftKey;
}, te$1 = function(e5) {
  return setTimeout(e5, 0);
}, ne = function(e5, t3) {
  var n4 = -1;
  return e5.every(function(i5, u2) {
    return t3(i5) ? (n4 = u2, false) : true;
  }), n4;
}, k$2 = function(e5) {
  for (var t3 = arguments.length, n4 = new Array(t3 > 1 ? t3 - 1 : 0), i5 = 1; i5 < t3; i5++)
    n4[i5 - 1] = arguments[i5];
  return typeof e5 == "function" ? e5.apply(void 0, n4) : e5;
}, I2 = function(e5) {
  return e5.target.shadowRoot && typeof e5.composedPath == "function" ? e5.composedPath()[0] : e5.target;
}, Le2 = [], je = function(e5, t3) {
  var n4 = (t3 == null ? void 0 : t3.document) || document, i5 = (t3 == null ? void 0 : t3.trapStack) || Le2, u2 = _$1({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true,
    isKeyForward: Ce2,
    isKeyBackward: Ge
  }, t3), a2 = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s2, c4 = function(o2, r3, l4) {
    return o2 && o2[r3] !== void 0 ? o2[r3] : u2[l4 || r3];
  }, m3 = function(o2, r3) {
    var l4 = typeof (r3 == null ? void 0 : r3.composedPath) == "function" ? r3.composedPath() : void 0;
    return a2.containerGroups.findIndex(function(d3) {
      var f2 = d3.container, b5 = d3.tabbableNodes;
      return f2.contains(o2) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (l4 == null ? void 0 : l4.includes(f2)) || b5.find(function(p2) {
        return p2 === o2;
      });
    });
  }, h2 = function(o2) {
    var r3 = u2[o2];
    if (typeof r3 == "function") {
      for (var l4 = arguments.length, d3 = new Array(l4 > 1 ? l4 - 1 : 0), f2 = 1; f2 < l4; f2++)
        d3[f2 - 1] = arguments[f2];
      r3 = r3.apply(void 0, d3);
    }
    if (r3 === true && (r3 = void 0), !r3) {
      if (r3 === void 0 || r3 === false)
        return r3;
      throw new Error("`".concat(o2, "` was specified but was not a node, or did not return a node"));
    }
    var b5 = r3;
    if (typeof r3 == "string" && (b5 = n4.querySelector(r3), !b5))
      throw new Error("`".concat(o2, "` as selector refers to no known node"));
    return b5;
  }, g2 = function() {
    var o2 = h2("initialFocus");
    if (o2 === false)
      return false;
    if (o2 === void 0 || !M$1(o2, u2.tabbableOptions))
      if (m3(n4.activeElement) >= 0)
        o2 = n4.activeElement;
      else {
        var r3 = a2.tabbableGroups[0], l4 = r3 && r3.firstTabbableNode;
        o2 = l4 || h2("fallbackFocus");
      }
    if (!o2)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return o2;
  }, w2 = function() {
    if (a2.containerGroups = a2.containers.map(function(o2) {
      var r3 = Te2(o2, u2.tabbableOptions), l4 = De(o2, u2.tabbableOptions), d3 = r3.length > 0 ? r3[0] : void 0, f2 = r3.length > 0 ? r3[r3.length - 1] : void 0, b5 = l4.find(function(v3) {
        return T(v3);
      }), p2 = l4.slice().reverse().find(function(v3) {
        return T(v3);
      }), y2 = !!r3.find(function(v3) {
        return O$1(v3) > 0;
      });
      return {
        container: o2,
        tabbableNodes: r3,
        focusableNodes: l4,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: y2,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: d3,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: f2,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: b5,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: p2,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(v3) {
          var F2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, R2 = r3.indexOf(v3);
          return R2 < 0 ? F2 ? l4.slice(l4.indexOf(v3) + 1).find(function(E2) {
            return T(E2);
          }) : l4.slice(0, l4.indexOf(v3)).reverse().find(function(E2) {
            return T(E2);
          }) : r3[R2 + (F2 ? 1 : -1)];
        }
      };
    }), a2.tabbableGroups = a2.containerGroups.filter(function(o2) {
      return o2.tabbableNodes.length > 0;
    }), a2.tabbableGroups.length <= 0 && !h2("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a2.containerGroups.find(function(o2) {
      return o2.posTabIndexesFound;
    }) && a2.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, j3 = function o2(r3) {
    var l4 = r3.activeElement;
    if (l4)
      return l4.shadowRoot && l4.shadowRoot.activeElement !== null ? o2(l4.shadowRoot) : l4;
  }, N2 = function o2(r3) {
    if (r3 !== false && r3 !== j3(document)) {
      if (!r3 || !r3.focus) {
        o2(g2());
        return;
      }
      r3.focus({
        preventScroll: !!u2.preventScroll
      }), a2.mostRecentlyFocusedNode = r3, Ie(r3) && r3.select();
    }
  }, q2 = function(o2) {
    var r3 = h2("setReturnFocus", o2);
    return r3 || (r3 === false ? false : o2);
  }, Y2 = function(o2) {
    var r3 = o2.target, l4 = o2.event, d3 = o2.isBackward, f2 = d3 === void 0 ? false : d3;
    r3 = r3 || I2(l4), w2();
    var b5 = null;
    if (a2.tabbableGroups.length > 0) {
      var p2 = m3(r3, l4), y2 = p2 >= 0 ? a2.containerGroups[p2] : void 0;
      if (p2 < 0)
        f2 ? b5 = a2.tabbableGroups[a2.tabbableGroups.length - 1].lastTabbableNode : b5 = a2.tabbableGroups[0].firstTabbableNode;
      else if (f2) {
        var v3 = ne(a2.tabbableGroups, function(K2) {
          var U2 = K2.firstTabbableNode;
          return r3 === U2;
        });
        if (v3 < 0 && (y2.container === r3 || M$1(r3, u2.tabbableOptions) && !T(r3, u2.tabbableOptions) && !y2.nextTabbableNode(r3, false)) && (v3 = p2), v3 >= 0) {
          var F2 = v3 === 0 ? a2.tabbableGroups.length - 1 : v3 - 1, R2 = a2.tabbableGroups[F2];
          b5 = O$1(r3) >= 0 ? R2.lastTabbableNode : R2.lastDomTabbableNode;
        } else P$1(l4) || (b5 = y2.nextTabbableNode(r3, false));
      } else {
        var E2 = ne(a2.tabbableGroups, function(K2) {
          var U2 = K2.lastTabbableNode;
          return r3 === U2;
        });
        if (E2 < 0 && (y2.container === r3 || M$1(r3, u2.tabbableOptions) && !T(r3, u2.tabbableOptions) && !y2.nextTabbableNode(r3)) && (E2 = p2), E2 >= 0) {
          var fe2 = E2 === a2.tabbableGroups.length - 1 ? 0 : E2 + 1, H2 = a2.tabbableGroups[fe2];
          b5 = O$1(r3) >= 0 ? H2.firstTabbableNode : H2.firstDomTabbableNode;
        } else P$1(l4) || (b5 = y2.nextTabbableNode(r3));
      }
    } else
      b5 = h2("fallbackFocus");
    return b5;
  }, x2 = function(o2) {
    var r3 = I2(o2);
    if (!(m3(r3, o2) >= 0)) {
      if (k$2(u2.clickOutsideDeactivates, o2)) {
        s2.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: u2.returnFocusOnDeactivate
        });
        return;
      }
      k$2(u2.allowOutsideClick, o2) || o2.preventDefault();
    }
  }, z2 = function(o2) {
    var r3 = I2(o2), l4 = m3(r3, o2) >= 0;
    if (l4 || r3 instanceof Document)
      l4 && (a2.mostRecentlyFocusedNode = r3);
    else {
      o2.stopImmediatePropagation();
      var d3, f2 = true;
      if (a2.mostRecentlyFocusedNode)
        if (O$1(a2.mostRecentlyFocusedNode) > 0) {
          var b5 = m3(a2.mostRecentlyFocusedNode), p2 = a2.containerGroups[b5].tabbableNodes;
          if (p2.length > 0) {
            var y2 = p2.findIndex(function(v3) {
              return v3 === a2.mostRecentlyFocusedNode;
            });
            y2 >= 0 && (u2.isKeyForward(a2.recentNavEvent) ? y2 + 1 < p2.length && (d3 = p2[y2 + 1], f2 = false) : y2 - 1 >= 0 && (d3 = p2[y2 - 1], f2 = false));
          }
        } else
          a2.containerGroups.some(function(v3) {
            return v3.tabbableNodes.some(function(F2) {
              return O$1(F2) > 0;
            });
          }) || (f2 = false);
      else
        f2 = false;
      f2 && (d3 = Y2({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a2.mostRecentlyFocusedNode,
        isBackward: u2.isKeyBackward(a2.recentNavEvent)
      })), N2(d3 || a2.mostRecentlyFocusedNode || g2());
    }
    a2.recentNavEvent = void 0;
  }, se2 = function(o2) {
    var r3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    a2.recentNavEvent = o2;
    var l4 = Y2({
      event: o2,
      isBackward: r3
    });
    l4 && (P$1(o2) && o2.preventDefault(), N2(l4));
  }, V2 = function(o2) {
    if (Ae(o2) && k$2(u2.escapeDeactivates, o2) !== false) {
      o2.preventDefault(), s2.deactivate();
      return;
    }
    (u2.isKeyForward(o2) || u2.isKeyBackward(o2)) && se2(o2, u2.isKeyBackward(o2));
  }, X2 = function(o2) {
    var r3 = I2(o2);
    m3(r3, o2) >= 0 || k$2(u2.clickOutsideDeactivates, o2) || k$2(u2.allowOutsideClick, o2) || (o2.preventDefault(), o2.stopImmediatePropagation());
  }, W2 = function() {
    if (a2.active)
      return ee$1.activateTrap(i5, s2), a2.delayInitialFocusTimer = u2.delayInitialFocus ? te$1(function() {
        N2(g2());
      }) : N2(g2()), n4.addEventListener("focusin", z2, true), n4.addEventListener("mousedown", x2, {
        capture: true,
        passive: false
      }), n4.addEventListener("touchstart", x2, {
        capture: true,
        passive: false
      }), n4.addEventListener("click", X2, {
        capture: true,
        passive: false
      }), n4.addEventListener("keydown", V2, {
        capture: true,
        passive: false
      }), s2;
  }, Z2 = function() {
    if (a2.active)
      return n4.removeEventListener("focusin", z2, true), n4.removeEventListener("mousedown", x2, true), n4.removeEventListener("touchstart", x2, true), n4.removeEventListener("click", X2, true), n4.removeEventListener("keydown", V2, true), s2;
  }, ce2 = function(o2) {
    var r3 = o2.some(function(l4) {
      var d3 = Array.from(l4.removedNodes);
      return d3.some(function(f2) {
        return f2 === a2.mostRecentlyFocusedNode;
      });
    });
    r3 && N2(g2());
  }, B3 = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(ce2) : void 0, D2 = function() {
    B3 && (B3.disconnect(), a2.active && !a2.paused && a2.containers.map(function(o2) {
      B3.observe(o2, {
        subtree: true,
        childList: true
      });
    }));
  };
  return s2 = {
    get active() {
      return a2.active;
    },
    get paused() {
      return a2.paused;
    },
    activate: function(o2) {
      if (a2.active)
        return this;
      var r3 = c4(o2, "onActivate"), l4 = c4(o2, "onPostActivate"), d3 = c4(o2, "checkCanFocusTrap");
      d3 || w2(), a2.active = true, a2.paused = false, a2.nodeFocusedBeforeActivation = n4.activeElement, r3 == null || r3();
      var f2 = function() {
        d3 && w2(), W2(), D2(), l4 == null || l4();
      };
      return d3 ? (d3(a2.containers.concat()).then(f2, f2), this) : (f2(), this);
    },
    deactivate: function(o2) {
      if (!a2.active)
        return this;
      var r3 = _$1({
        onDeactivate: u2.onDeactivate,
        onPostDeactivate: u2.onPostDeactivate,
        checkCanReturnFocus: u2.checkCanReturnFocus
      }, o2);
      clearTimeout(a2.delayInitialFocusTimer), a2.delayInitialFocusTimer = void 0, Z2(), a2.active = false, a2.paused = false, D2(), ee$1.deactivateTrap(i5, s2);
      var l4 = c4(r3, "onDeactivate"), d3 = c4(r3, "onPostDeactivate"), f2 = c4(r3, "checkCanReturnFocus"), b5 = c4(r3, "returnFocus", "returnFocusOnDeactivate");
      l4 == null || l4();
      var p2 = function() {
        te$1(function() {
          b5 && N2(q2(a2.nodeFocusedBeforeActivation)), d3 == null || d3();
        });
      };
      return b5 && f2 ? (f2(q2(a2.nodeFocusedBeforeActivation)).then(p2, p2), this) : (p2(), this);
    },
    pause: function(o2) {
      if (a2.paused || !a2.active)
        return this;
      var r3 = c4(o2, "onPause"), l4 = c4(o2, "onPostPause");
      return a2.paused = true, r3 == null || r3(), Z2(), D2(), l4 == null || l4(), this;
    },
    unpause: function(o2) {
      if (!a2.paused || !a2.active)
        return this;
      var r3 = c4(o2, "onUnpause"), l4 = c4(o2, "onPostUnpause");
      return a2.paused = false, r3 == null || r3(), w2(), W2(), D2(), l4 == null || l4(), this;
    },
    updateContainerElements: function(o2) {
      var r3 = [].concat(o2).filter(Boolean);
      return a2.containers = r3.map(function(l4) {
        return typeof l4 == "string" ? n4.querySelector(l4) : l4;
      }), a2.active && w2(), D2(), this;
    }
  }, s2.updateContainerElements(e5), s2;
};
var h$1 = Object.defineProperty, B2 = Object.getOwnPropertyDescriptor, y$1 = (p2, e5, o2, s2) => {
  for (var t3 = s2 > 1 ? void 0 : s2 ? B2(e5, o2) : e5, r3 = p2.length - 1, n4; r3 >= 0; r3--)
    (n4 = p2[r3]) && (t3 = (s2 ? n4(e5, o2, t3) : n4(t3)) || t3);
  return s2 && t3 && h$1(e5, o2, t3), t3;
};
function O2(p2) {
  let e5 = class extends p2 {
    constructor() {
      super(...arguments), this.opensBy = "";
    }
    get opensByElements() {
      if (this.opensBy)
        return e$4(this, "_opensByElements", () => {
          const o2 = this.opensBy.split(" "), s2 = /* @__PURE__ */ new Map();
          return o2.forEach((t3) => {
            const r3 = this.getClosestHost();
            r3 ? Array.from(
              r3.shadowRoot.querySelectorAll(t3)
            ).forEach(
              (n4) => s2.set(n4, true)
            ) : Array.from(document.querySelectorAll(t3)).forEach(
              (n4) => s2.set(n4, true)
            );
          }), s2;
        });
    }
    /** @abstract */
    runOpensBySetup() {
    }
    /** @abstract */
    runOpensByClean() {
    }
    setupOpensByElements() {
      this.opensByElements && this.opensByElements.size > 0 && this.runOpensBySetup();
    }
    cleanOpensByElements() {
      this.opensByElements && this.opensByElements.size > 0 && this.runOpensByClean();
    }
  };
  return y$1([
    v$c({ attribute: "opens-by" })
  ], e5.prototype, "opensBy", 2), y$1([
    d$e
  ], e5.prototype, "setupOpensByElements", 1), y$1([
    y$7
  ], e5.prototype, "cleanOpensByElements", 1), e5 = y$1([
    f$8("OpensBy")
  ], e5), e5;
}
function S(o2) {
  return typeof o2 == "function" && o2.length === 1;
}
const A2 = T$7`:host(:not([focus-override])) .non-modal-dialog-background-wrapper+dialog:focus-visible{position:fixed;z-index:2}dialog{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);background-color:var(--beacon-system-color-background-1);border:0;color:unset;inline-size:var(--beacon-modal-override-width, var(--default-width, 100%));max-inline-size:var(--beacon-modal-override-max-width, var(--max-width));min-inline-size:var(--min-width);padding:0}dialog::backdrop{background-color:var(--beacon-system-color-background-blanket)}.block-size-wrapper{block-size:var(--beacon-modal-override-height, auto)}.non-modal-dialog-background-wrapper+dialog{position:fixed;z-index:2}.non-modal-dialog-background-wrapper{background-color:var(--beacon-system-color-background-blanket);block-size:100%;inline-size:100%;top:0;right:0;bottom:0;left:0;position:fixed;z-index:1}.wrapper{block-size:100%;display:grid;grid-template-rows:auto 1fr auto}.header{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);display:flex;justify-content:var(--header-justification, end);padding:var(--beacon-system-space-cell-contained)}.body{overflow-y:auto;scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable}.action-zone{display:flex;gap:var(--beacon-system-space-micro-jumbo);justify-content:end}.footer{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding:var(--beacon-system-space-cell-contained)}`;
var v2 = (o2) => {
  throw TypeError(o2);
}, w = (o2, e5, t3) => e5.has(o2) || v2("Cannot " + t3), _ = (o2, e5, t3) => (w(o2, e5, "read from private field"), t3 ? t3.call(o2) : e5.get(o2)), D = (o2, e5, t3) => e5.has(o2) ? v2("Cannot add the same private member more than once") : e5 instanceof WeakSet ? e5.add(o2) : e5.set(o2, t3), b$2 = (o2, e5, t3, r3) => (w(o2, e5, "write to private field"), e5.set(o2, t3), t3), F = Object.defineProperty, P = Object.getOwnPropertyDescriptor, a$1 = (o2, e5, t3, r3) => {
  for (var i5 = r3 > 1 ? void 0 : r3 ? P(e5, t3) : e5, c4 = o2.length - 1, l4; c4 >= 0; c4--)
    (l4 = o2[c4]) && (i5 = (r3 ? l4(e5, t3, i5) : l4(i5)) || i5);
  return r3 && i5 && F(e5, t3, i5), i5;
}, n$1;
const k$1 = class k extends B$5(Bt$3).with(O2) {
  constructor() {
    super(...arguments), D(this, n$1), this._passthroughs = new m$e(this), this.closeOnClickOut = false, this.persist = false, b$2(this, n$1, false);
  }
  static get styles() {
    return [super.styles, A2];
  }
  get open() {
    return _(this, n$1);
  }
  set open(e5) {
    b$2(this, n$1, e5), this.dialog && (this.open ? this.openModal() : this.closeModal());
  }
  handleEvent(e5) {
    const t3 = this[`handle${e5.type}`];
    S(t3) && t3.bind(this)(e5);
  }
  /**
   * External click handler used for the handleEvent method.
   *
   * @see handleEvent
   * @see setupOpensByListeners
   */
  handleclick({ target: e5 }) {
    var t3;
    e5 instanceof HTMLElement && (t3 = this.opensByElements) != null && t3.has(e5) && this.show();
  }
  show() {
    this.open = true;
  }
  close() {
    this.open = false;
  }
  activateFocusTrap() {
    this.focusTrapObject && this.focusTrapObject.activate();
  }
  /*
   * TODO: Remove the OneTrust workaround.
   * We have worked with the Enterprise team to use dialog.show() instead of dialog.showModal() so that
   * they can have a separate modal pop above our modal. This is all a wacky workaround, so we will prefer
   * to find a different solution in the future. This change has resulted in the below if statement, as well
   * as the activateFocusTrap() method, and assorted CSS changes. For specific changes, look to MR 1900 in Beacon Foundation:
   * https://gitlab.awstrp.net/ui-kit/foundation/-/merge_requests/1900
   */
  openModal() {
    this.anyComputedZIndex ? this.dialog.show() : (this.dialog.showModal(), this.activateFocusTrap()), n$7(), L$6(this, g$a.OPEN);
  }
  closeModal() {
    this.focusTrapObject && this.focusTrapObject.deactivate(), this.dialog.close(), c$5(), L$6(this, g$a.CLOSE);
  }
  renderCloseButton() {
    return this.persist ? tt$1`` : kt$1`
      <${this.getScopedTag("beacon-icon-button")} class="close-button" variant="tertiary" @click=${this.close} id="${e$6(this._passthroughs.attributes.get("id"))}">
        <svg
          class="icon--close"
          slot="icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z"
            fill="#0063AD"
          />
        </svg>
        <slot name="close-button-text">Close</slot>
      </${this.getScopedTag("beacon-icon-button")}>
    `;
  }
  handleDialogClick(e5) {
    this.persist || !this.closeOnClickOut || e5.composedPath().includes(this.contentWrapper) || this.close();
  }
  runOpensBySetup() {
    this.opensByElements.forEach(
      (e5, t3) => t3.addEventListener(
        "click",
        this
      )
    );
  }
  runOpensByClean() {
    this.opensByElements.forEach(
      (e5, t3) => t3.removeEventListener(
        "click",
        this
      )
    );
  }
  setupAnalyticsAttributes() {
    this.dataset.metricsLocation = "PU";
  }
  initializeAnyComputedZIndex() {
    this.anyComputedZIndex = window.getComputedStyle(this).getPropertyValue("z-index") !== "auto";
  }
  openModalOnLoad() {
    this.open && this.openModal();
  }
  initializeFocusTrap() {
    window.__beaconTrapStack || (window.__beaconTrapStack = []), this.focusTrapObject = je(this, {
      /** This global var enables multiple layers of focusTraps to determine which focusTrap takes precendence.
       * focus-trap will dynamically pause lower focusTrap layers in the stack.
       * https://github.com/focus-trap/focus-trap/blob/master/docs/js/global-trap-stack.js#L13
       * */
      trapStack: window.__beaconTrapStack,
      fallbackFocus: this.dialog,
      // focusTrap needs a fallbackFocus node if there are no focusable nodes found in the host element
      tabbableOptions: {
        getShadowRoot: true
        // option that allows focusTrap to penetrate closed shadowRoot's and grab focusable nodes
      },
      // this is where escape key properly sets properties
      escapeDeactivates: () => (this.close(), true)
    });
  }
  removeOpensByListeners() {
    this.opensByElements && this.opensByElements.size > 0 && this.opensByElements.forEach(
      (e5, t3) => t3.removeEventListener(
        "click",
        this
      )
    );
  }
  closeWhenDisconnected() {
    this.open && (this.focusTrapObject && this.focusTrapObject.deactivate(), c$5());
  }
};
n$1 = /* @__PURE__ */ new WeakMap(), k$1.nestedComponents = ["beacon-icon-button"];
let s = k$1;
a$1([
  v$c({ attribute: "close-on-click-out", type: Boolean })
], s.prototype, "closeOnClickOut", 2);
a$1([
  v$c({ type: Boolean })
], s.prototype, "persist", 2);
a$1([
  v$c({ type: Boolean, reflect: true })
], s.prototype, "open", 1);
a$1([
  h$9("dialog")
], s.prototype, "dialog", 2);
a$1([
  h$9(".wrapper")
], s.prototype, "contentWrapper", 2);
a$1([
  it()
], s.prototype, "anyComputedZIndex", 2);
a$1([
  u$2
], s.prototype, "setupAnalyticsAttributes", 1);
a$1([
  u$2
], s.prototype, "initializeAnyComputedZIndex", 1);
a$1([
  d$e
], s.prototype, "openModalOnLoad", 1);
a$1([
  d$e
], s.prototype, "initializeFocusTrap", 1);
a$1([
  y$7
], s.prototype, "removeOpensByListeners", 1);
a$1([
  y$7
], s.prototype, "closeWhenDisconnected", 1);
class h extends i$4 {
  constructor(e5) {
    if (super(e5), this.observing = false, this.tabindex = -1, e5.type !== T$5.ATTRIBUTE || e5.name !== "tabindex")
      throw new Error(
        "The `scrollableRegion` directive must be used in the `tabindex` attribute"
      );
    this.part = e5, this.resizeObserver = this.setupResizeObserver();
  }
  setupResizeObserver() {
    if (!this.resizeObserver)
      return new ResizeObserver((e5) => {
        for (const t3 of e5) {
          const {
            target: { scrollHeight: r3, clientHeight: s2 }
          } = t3;
          this.tabindex = Number(r3) > Number(s2) ? 0 : -1, this.render();
        }
      });
  }
  render() {
    this.part && this.part.name === "tabindex" && (this.part.element.tabIndex = this.tabindex);
  }
  update(e5) {
    this.resizeObserver && !this.observing && this.resizeObserver.observe(e5.element);
  }
}
const d$1 = _$4(h);
const m2 = {
  beaconTagName: "beacon-modal"
}, x = T$7`[beacon-tag-name=beacon-modal] :where([slot=logo] :where(img,svg)){block-size:inherit;inline-size:inherit}`, k2 = T$7`:host{--header-justification: space-between;--modal-max-block-size: calc(100dvh - 2 * var(--beacon-system-space-gutter))}dialog{--max-width: calc(100% - 2 * var(--beacon-system-space-gutter));--min-width: none;border-radius:var(--beacon-system-radius-corner-standard);box-shadow:var(--beacon-system-color-shadow-high);max-block-size:var(--modal-max-block-size)}@media (width >= 640px){dialog{--default-width: 100%}}.persist .header{padding:0}.persist .logo-slot{padding:var(--beacon-system-space-cell-contained)}.normal{inset-block-end:var(--beacon-system-space-gutter);inset-block-start:initial}@media (width >= 640px){.normal{--max-width: 23.625rem;--min-width: 17.625rem;top:0;right:0;bottom:0;left:0}}@media (width >= 960px){.normal{--max-width: 45.5rem;--min-width: 26.5rem}}:is(.jumbo,.maxi){--max-width: 100%;--min-width: 100%;top:0;right:0;bottom:0;left:0}@media (width < 640px){:is(.jumbo,.maxi){block-size:100dvh;margin-block:0;max-block-size:none}:is(.jumbo,.maxi) .wrapper{block-size:100dvh;max-block-size:100dvh}}@media (width >= 640px){.jumbo{--max-width: 36rem;--min-width: none}}@media (width >= 960px){.jumbo{--max-width: 44rem}}@media (width >= 1280px){.jumbo{--max-width: 57rem}}@media (width >= 640px){.maxi{--max-width: calc(100% - 2 * var(--beacon-system-space-gutter));--min-width: calc(100% - 2 * var(--beacon-system-space-gutter))}}.wrapper{max-block-size:var(--modal-max-block-size)}@media (width >= 1216px){.wrapper.maxi{grid-template-areas:"panel header" "panel content" "panel footer";grid-template-columns:4fr 8fr}.wrapper.maxi .body{display:contents}.wrapper.maxi .header{grid-area:header}.wrapper.maxi .panel{grid-area:panel}.wrapper.maxi .content{grid-area:content}.wrapper.maxi .footer{grid-area:footer}.wrapper.maxi .content,.wrapper.maxi .panel{overflow-y:auto;scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable}}.content{padding-block:var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-jumbo)}.panel{background-color:var(--beacon-system-color-background-2);padding:var(--beacon-system-space-organism-jumbo)}.close-button{margin-inline-start:auto}::slotted([slot=logo]){block-size:100%;inline-size:100%;max-block-size:var(--beacon-reference-space-10);max-inline-size:var(--beacon-reference-space-10)}`;
var y = Object.defineProperty, f = (e5, o2, c4, z2) => {
  for (var a2 = void 0, i5 = e5.length - 1, d3; i5 >= 0; i5--)
    (d3 = e5[i5]) && (a2 = d3(o2, c4, a2) || a2);
  return a2 && y(o2, c4, a2), a2;
};
const b$1 = class b3 extends s {
  constructor() {
    super(...arguments), this.beaconTagName = m2.beaconTagName, this.scale = "normal";
  }
  static get styles() {
    return [super.styles, k2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, x];
  }
  /**
   * @todo 4.0.0 Rename to something other than `additional-content`
   */
  renderSidePanel() {
    return this.scale !== "maxi" ? tt$1`` : tt$1`
      <div class="panel" tabindex=${d$1()}>
        <slot
          name="additional-content"
          ${f$7({ useParent: true })}></slot>
      </div>
    `;
  }
  render() {
    const o2 = {
      persist: this.persist
    };
    return o2[this.scale] = true, tt$1`
      ${this.anyComputedZIndex && this.open ? tt$1`<div class="non-modal-dialog-background-wrapper"></div>` : ""}
      <dialog
        @click=${this.handleDialogClick}
        class="${f$6(o2)}">
        <div class="block-size-wrapper">
          <div class="wrapper ${this.scale}">
            <div class="header">
              <div class="logo-slot">
                <slot
                  name="logo"
                  aria-hidden="true"
                  ${f$7({ useParent: true })}></slot>
              </div>
              ${this.renderCloseButton()}
            </div>
            <div class="body" tabindex=${d$1()}>
              <div class="content" tabindex=${d$1()}>
                <slot ${f$7({ container: ".body" })}></slot>
              </div>
              ${this.renderSidePanel()}
            </div>
            <div class="footer">
              <div class="action-zone">
                <slot
                  name="action-zone"
                  ${f$7({ container: ".footer" })}></slot>
              </div>
            </div>
          </div>
        </div>
      </dialog>
    `;
  }
};
b$1.tagName = m2.beaconTagName;
let n3 = b$1;
f([
  v$c()
], n3.prototype, "scale");
const M = (e5) => (Se$3(e5, n3), Dt$3({
  tagName: e5 ? e5 + "-" + n3.tagName : n3.tagName,
  elementClass: n3,
  react: React,
  events: {
    onBeaconEventOpen: "beacon-event-open",
    onBeaconEventClose: "beacon-event-close",
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
var vt$1 = { exports: {} };
(function(dt2) {
  (function(st2) {
    dt2.exports ? (st2.default = st2, dt2.exports = st2) : st2(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(st2) {
    var f2 = st2 ? st2._modules : {};
    function $2(D2, N2, F2, Y2) {
      D2.hasOwnProperty(N2) || (D2[N2] = Y2.apply(null, F2), typeof CustomEvent == "function" && st2.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: N2, module: D2[N2] } })));
    }
    $2(f2, "Series/DataModifyComposition.js", [f2["Core/Axis/Axis.js"], f2["Core/Series/Point.js"], f2["Core/Series/Series.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2) {
      var Z2;
      let { tooltipFormatter: _2 } = N2.prototype, { addEvent: W2, arrayMax: I3, arrayMin: X2, correctFloat: V2, defined: A3, isArray: k3, isNumber: S2, isString: H2, pick: m3 } = Y2;
      return function(E2) {
        function B3(a2, o2, e5) {
          !this.isXAxis && (this.series.forEach(function(r3) {
            a2 === "compare" && typeof o2 != "boolean" ? r3.setCompare(o2, false) : a2 !== "cumulative" || H2(o2) || r3.setCumulative(o2, false);
          }), m3(e5, true) && this.chart.redraw());
        }
        function g2(a2) {
          let o2 = this, { numberFormatter: e5 } = o2.series.chart, r3 = function(t3) {
            a2 = a2.replace("{point." + t3 + "}", (o2[t3] > 0 && t3 === "change" ? "+" : "") + e5(o2[t3], m3(o2.series.tooltipOptions.changeDecimals, 2)));
          };
          return A3(o2.change) && r3("change"), A3(o2.cumulativeSum) && r3("cumulativeSum"), _2.apply(this, [a2]);
        }
        function w2() {
          let a2, o2 = this.options.compare;
          (o2 === "percent" || o2 === "value" || this.options.cumulative) && (a2 = new n4(this), o2 === "percent" || o2 === "value" ? a2.initCompare(o2) : a2.initCumulative()), this.dataModify = a2;
        }
        function v3(a2) {
          let o2 = a2.dataExtremes, e5 = o2.activeYData;
          if (this.dataModify && o2) {
            let r3;
            this.options.compare ? r3 = [this.dataModify.modifyValue(o2.dataMin), this.dataModify.modifyValue(o2.dataMax)] : this.options.cumulative && k3(e5) && e5.length >= 2 && (r3 = n4.getCumulativeExtremes(e5)), r3 && (o2.dataMin = X2(r3), o2.dataMax = I3(r3));
          }
        }
        function x2(a2, o2) {
          this.options.compare = this.userOptions.compare = a2, this.update({}, m3(o2, true)), this.dataModify && (a2 === "value" || a2 === "percent") ? this.dataModify.initCompare(a2) : this.points.forEach((e5) => {
            delete e5.change;
          });
        }
        function G2() {
          if (this.xAxis && this.processedYData && this.dataModify) {
            let a2 = this.processedXData, o2 = this.processedYData, e5 = o2.length, r3 = this.options.compareStart === true ? 0 : 1, t3 = -1, i5;
            for (this.pointArrayMap && (t3 = this.pointArrayMap.indexOf(this.options.pointValKey || this.pointValKey || "y")), i5 = 0; i5 < e5 - r3; i5++) {
              let s2 = o2[i5] && t3 > -1 ? o2[i5][t3] : o2[i5];
              if (S2(s2) && s2 !== 0 && a2[i5 + r3] >= (this.xAxis.min || 0)) {
                this.dataModify.compareValue = s2;
                break;
              }
            }
          }
        }
        function u2(a2, o2) {
          this.setModifier("compare", a2, o2);
        }
        function p2(a2, o2) {
          a2 = m3(a2, false), this.options.cumulative = this.userOptions.cumulative = a2, this.update({}, m3(o2, true)), this.dataModify ? this.dataModify.initCumulative() : this.points.forEach((e5) => {
            delete e5.cumulativeSum;
          });
        }
        function C3(a2, o2) {
          this.setModifier("cumulative", a2, o2);
        }
        E2.compose = function(a2, o2, e5) {
          let r3 = o2.prototype, t3 = e5.prototype, i5 = a2.prototype;
          return i5.setCompare || (i5.setCompare = x2, i5.setCumulative = p2, W2(a2, "afterInit", w2), W2(a2, "afterGetExtremes", v3), W2(a2, "afterProcessData", G2)), r3.setCompare || (r3.setCompare = u2, r3.setModifier = B3, r3.setCumulative = C3, t3.tooltipFormatter = g2), a2;
        };
        class n4 {
          constructor(o2) {
            this.series = o2;
          }
          modifyValue() {
            return 0;
          }
          static getCumulativeExtremes(o2) {
            let e5 = 1 / 0, r3 = -1 / 0;
            return o2.reduce((t3, i5) => {
              let s2 = t3 + i5;
              return e5 = Math.min(e5, s2, t3), r3 = Math.max(r3, s2, t3), s2;
            }), [e5, r3];
          }
          initCompare(o2) {
            this.modifyValue = function(e5, r3) {
              e5 === null && (e5 = 0);
              let t3 = this.compareValue;
              if (e5 !== void 0 && t3 !== void 0) {
                if (o2 === "value" ? e5 -= t3 : e5 = e5 / t3 * 100 - (this.series.options.compareBase === 100 ? 0 : 100), r3 !== void 0) {
                  let i5 = this.series.points[r3];
                  i5 && (i5.change = e5);
                }
                return e5;
              }
              return 0;
            };
          }
          initCumulative() {
            this.modifyValue = function(o2, e5) {
              if (o2 === null && (o2 = 0), o2 !== void 0 && e5 !== void 0) {
                let r3 = e5 > 0 ? this.series.points[e5 - 1] : null;
                r3 && r3.cumulativeSum && (o2 = V2(r3.cumulativeSum + o2));
                let t3 = this.series.points[e5], i5 = t3.series.options.cumulativeStart, s2 = t3.x <= this.series.xAxis.max && t3.x >= this.series.xAxis.min;
                return t3 && (!i5 || s2 ? t3.cumulativeSum = o2 : t3.cumulativeSum = void 0), o2;
              }
              return 0;
            };
          }
        }
        E2.Additions = n4;
      }(Z2 || (Z2 = {})), Z2;
    }), $2(f2, "Stock/Navigator/ChartNavigatorComposition.js", [f2["Core/Globals.js"], f2["Core/Utilities.js"]], function(D2, N2) {
      let F2, { isTouchDevice: Y2 } = D2, { addEvent: Z2, merge: _2, pick: W2 } = N2, I3 = [];
      function X2() {
        this.navigator && this.navigator.setBaseSeries(null, false);
      }
      function V2() {
        var E2;
        let B3, g2, w2, v3 = this.legend, x2 = this.navigator;
        if (x2) {
          B3 = v3 && v3.options, g2 = x2.xAxis, w2 = x2.yAxis;
          let { scrollbarHeight: G2, scrollButtonSize: u2 } = x2;
          this.inverted ? (x2.left = x2.opposite ? this.chartWidth - G2 - x2.height : this.spacing[3] + G2, x2.top = this.plotTop + u2) : (x2.left = W2(g2.left, this.plotLeft + u2), x2.top = x2.navigatorOptions.top || this.chartHeight - x2.height - G2 - (((E2 = this.scrollbar) == null ? void 0 : E2.options.margin) || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (B3 && B3.verticalAlign === "bottom" && B3.layout !== "proximate" && B3.enabled && !B3.floating ? v3.legendHeight + W2(B3.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), g2 && w2 && (this.inverted ? g2.options.left = w2.options.left = x2.left : g2.options.top = w2.options.top = x2.top, g2.setAxisSize(), w2.setAxisSize());
        }
      }
      function A3(E2) {
        !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new F2(this), W2(E2.redraw, true) && this.redraw(E2.animation));
      }
      function k3() {
        let E2 = this.options;
        (E2.navigator.enabled || E2.scrollbar.enabled) && (this.scroller = this.navigator = new F2(this));
      }
      function S2() {
        let E2 = this.options, B3 = E2.navigator, g2 = E2.rangeSelector;
        if ((B3 && B3.enabled || g2 && g2.enabled) && (!Y2 && this.zooming.type === "x" || Y2 && this.zooming.pinchType === "x")) return false;
      }
      function H2(E2) {
        let B3 = E2.navigator;
        if (B3 && E2.xAxis[0]) {
          let g2 = E2.xAxis[0].getExtremes();
          B3.render(g2.min, g2.max);
        }
      }
      function m3(E2) {
        let B3 = E2.options.navigator || {}, g2 = E2.options.scrollbar || {};
        !this.navigator && !this.scroller && (B3.enabled || g2.enabled) && (_2(true, this.options.navigator, B3), _2(true, this.options.scrollbar, g2), delete E2.options.navigator, delete E2.options.scrollbar);
      }
      return { compose: function(E2, B3) {
        if (N2.pushUnique(I3, E2)) {
          let g2 = E2.prototype;
          F2 = B3, g2.callbacks.push(H2), Z2(E2, "afterAddSeries", X2), Z2(E2, "afterSetChartSize", V2), Z2(E2, "afterUpdate", A3), Z2(E2, "beforeRender", k3), Z2(E2, "beforeShowResetZoom", S2), Z2(E2, "update", m3);
        }
      } };
    }), $2(f2, "Core/Axis/NavigatorAxisComposition.js", [f2["Core/Globals.js"], f2["Core/Utilities.js"]], function(D2, N2) {
      let { isTouchDevice: F2 } = D2, { addEvent: Y2, correctFloat: Z2, defined: _2, isNumber: W2, pick: I3 } = N2;
      function X2() {
        this.navigatorAxis || (this.navigatorAxis = new A3(this));
      }
      function V2(k3) {
        let S2, H2 = this.chart, m3 = H2.options, E2 = m3.navigator, B3 = this.navigatorAxis, g2 = H2.zooming.pinchType, w2 = m3.rangeSelector, v3 = H2.zooming.type;
        if (this.isXAxis && (E2 != null && E2.enabled || w2 != null && w2.enabled)) {
          if (v3 === "y" && k3.trigger === "zoom") S2 = false;
          else if ((k3.trigger === "zoom" && v3 === "xy" || F2 && g2 === "xy") && this.options.range) {
            let x2 = B3.previousZoom;
            _2(k3.min) ? B3.previousZoom = [this.min, this.max] : x2 && (k3.min = x2[0], k3.max = x2[1], B3.previousZoom = void 0);
          }
        }
        S2 !== void 0 && k3.preventDefault();
      }
      class A3 {
        static compose(S2) {
          S2.keepProps.includes("navigatorAxis") || (S2.keepProps.push("navigatorAxis"), Y2(S2, "init", X2), Y2(S2, "setExtremes", V2));
        }
        constructor(S2) {
          this.axis = S2;
        }
        destroy() {
          this.axis = void 0;
        }
        toFixedRange(S2, H2, m3, E2) {
          let B3 = this.axis, g2 = (B3.pointRange || 0) / 2, w2 = I3(m3, B3.translate(S2, true, !B3.horiz)), v3 = I3(E2, B3.translate(H2, true, !B3.horiz));
          return _2(m3) || (w2 = Z2(w2 + g2)), _2(E2) || (v3 = Z2(v3 - g2)), W2(w2) && W2(v3) || (w2 = v3 = void 0), { min: w2, max: v3 };
        }
      }
      return A3;
    }), $2(f2, "Stock/Navigator/NavigatorDefaults.js", [f2["Core/Color/Color.js"], f2["Core/Series/SeriesRegistry.js"]], function(D2, N2) {
      let { parse: F2 } = D2, { seriesTypes: Y2 } = N2;
      return { height: 40, margin: 25, maskInside: true, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: true, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: F2("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: Y2.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: false }, dataGrouping: { approximation: "average", enabled: true, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: false, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: false }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: false }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: false, endOnTick: false, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: false }, crosshair: false, title: { text: null }, tickLength: 0, tickWidth: 0 } };
    }), $2(f2, "Stock/Navigator/NavigatorSymbols.js", [f2["Core/Renderer/SVG/Symbols.js"], f2["Core/Utilities.js"]], function(D2, N2) {
      let { relativeLength: F2 } = N2;
      return { "navigator-handle": function(Y2, Z2, _2, W2, I3 = {}) {
        let X2 = I3.width ? I3.width / 2 : _2, V2 = F2(I3.borderRadius || 0, Math.min(2 * X2, W2));
        return [["M", -1.5, (W2 = I3.height || W2) / 2 - 3.5], ["L", -1.5, W2 / 2 + 4.5], ["M", 0.5, W2 / 2 - 3.5], ["L", 0.5, W2 / 2 + 4.5], ...D2.rect(-X2 - 1, 0.5, 2 * X2 + 1, W2, { r: V2 })];
      } };
    }), $2(f2, "Stock/Utilities/StockUtilities.js", [f2["Core/Utilities.js"]], function(D2) {
      let { defined: N2 } = D2;
      return { setFixedRange: function(F2) {
        let Y2 = this.xAxis[0];
        N2(Y2.dataMax) && N2(Y2.dataMin) && F2 ? this.fixedRange = Math.min(F2, Y2.dataMax - Y2.dataMin) : this.fixedRange = F2;
      } };
    }), $2(f2, "Stock/Navigator/NavigatorComposition.js", [f2["Core/Defaults.js"], f2["Core/Globals.js"], f2["Core/Axis/NavigatorAxisComposition.js"], f2["Stock/Navigator/NavigatorDefaults.js"], f2["Stock/Navigator/NavigatorSymbols.js"], f2["Core/Renderer/RendererRegistry.js"], f2["Stock/Utilities/StockUtilities.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2, Z2, _2, W2, I3) {
      let { setOptions: X2 } = D2, { composed: V2 } = N2, { getRendererType: A3 } = _2, { setFixedRange: k3 } = W2, { addEvent: S2, extend: H2, pushUnique: m3 } = I3;
      function E2() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, false);
      }
      return { compose: function(B3, g2, w2) {
        F2.compose(g2), m3(V2, "Navigator") && (B3.prototype.setFixedRange = k3, H2(A3().prototype.symbols, Z2), S2(w2, "afterUpdate", E2), X2({ navigator: Y2 }));
      } };
    }), $2(f2, "Core/Axis/ScrollbarAxis.js", [f2["Core/Globals.js"], f2["Core/Utilities.js"]], function(D2, N2) {
      var F2;
      let { composed: Y2 } = D2, { addEvent: Z2, defined: _2, pick: W2, pushUnique: I3 } = N2;
      return function(X2) {
        let V2;
        function A3(m3) {
          let E2 = W2(m3.options && m3.options.min, m3.min), B3 = W2(m3.options && m3.options.max, m3.max);
          return { axisMin: E2, axisMax: B3, scrollMin: _2(m3.dataMin) ? Math.min(E2, m3.min, m3.dataMin, W2(m3.threshold, 1 / 0)) : E2, scrollMax: _2(m3.dataMax) ? Math.max(B3, m3.max, m3.dataMax, W2(m3.threshold, -1 / 0)) : B3 };
        }
        function k3() {
          let m3 = this.scrollbar, E2 = m3 && !m3.options.opposite, B3 = this.horiz ? 2 : E2 ? 3 : 1;
          m3 && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[B3] += m3.size + (m3.options.margin || 0));
        }
        function S2() {
          let m3 = this;
          m3.options && m3.options.scrollbar && m3.options.scrollbar.enabled && (m3.options.scrollbar.vertical = !m3.horiz, m3.options.startOnTick = m3.options.endOnTick = false, m3.scrollbar = new V2(m3.chart.renderer, m3.options.scrollbar, m3.chart), Z2(m3.scrollbar, "changed", function(E2) {
            let B3, g2, { axisMin: w2, axisMax: v3, scrollMin: x2, scrollMax: G2 } = A3(m3), u2 = G2 - x2;
            if (_2(w2) && _2(v3))
              if (m3.horiz && !m3.reversed || !m3.horiz && m3.reversed ? (B3 = x2 + u2 * this.to, g2 = x2 + u2 * this.from) : (B3 = x2 + u2 * (1 - this.from), g2 = x2 + u2 * (1 - this.to)), this.shouldUpdateExtremes(E2.DOMType)) {
                let p2 = E2.DOMType !== "mousemove" && E2.DOMType !== "touchmove" && void 0;
                m3.setExtremes(g2, B3, true, p2, E2);
              } else this.setRange(this.from, this.to);
          }));
        }
        function H2() {
          let m3, E2, B3, { scrollMin: g2, scrollMax: w2 } = A3(this), v3 = this.scrollbar, x2 = this.axisTitleMargin + (this.titleOffset || 0), G2 = this.chart.scrollbarsOffsets, u2 = this.options.margin || 0;
          if (v3 && G2) {
            if (this.horiz) this.opposite || (G2[1] += x2), v3.position(this.left, this.top + this.height + 2 + G2[1] - (this.opposite ? u2 : 0), this.width, this.height), this.opposite || (G2[1] += u2), m3 = 1;
            else {
              let p2;
              this.opposite && (G2[0] += x2), p2 = v3.options.opposite ? this.left + this.width + 2 + G2[0] - (this.opposite ? 0 : u2) : this.opposite ? 0 : u2, v3.position(p2, this.top, this.width, this.height), this.opposite && (G2[0] += u2), m3 = 0;
            }
            if (G2[m3] += v3.size + (v3.options.margin || 0), isNaN(g2) || isNaN(w2) || !_2(this.min) || !_2(this.max) || this.dataMin === this.dataMax) v3.setRange(0, 1);
            else if (this.min === this.max) {
              let p2 = this.pointRange / (this.dataMax + 1);
              E2 = p2 * this.min, B3 = p2 * (this.max + 1), v3.setRange(E2, B3);
            } else E2 = (this.min - g2) / (w2 - g2), B3 = (this.max - g2) / (w2 - g2), this.horiz && !this.reversed || !this.horiz && this.reversed ? v3.setRange(E2, B3) : v3.setRange(1 - B3, 1 - E2);
          }
        }
        X2.compose = function(m3, E2) {
          I3(Y2, "Axis.Scrollbar") && (V2 = E2, Z2(m3, "afterGetOffset", k3), Z2(m3, "afterInit", S2), Z2(m3, "afterRender", H2));
        };
      }(F2 || (F2 = {})), F2;
    }), $2(f2, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
      return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: false, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: true, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
    }), $2(f2, "Stock/Scrollbar/Scrollbar.js", [f2["Core/Defaults.js"], f2["Core/Globals.js"], f2["Core/Axis/ScrollbarAxis.js"], f2["Stock/Scrollbar/ScrollbarDefaults.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2, Z2) {
      let { defaultOptions: _2 } = D2, { addEvent: W2, correctFloat: I3, crisp: X2, defined: V2, destroyObjectProperties: A3, fireEvent: k3, merge: S2, pick: H2, removeEvent: m3 } = Z2;
      class E2 {
        static compose(g2) {
          F2.compose(g2, E2);
        }
        static swapXY(g2, w2) {
          return w2 && g2.forEach((v3) => {
            let x2, G2 = v3.length;
            for (let u2 = 0; u2 < G2; u2 += 2) typeof (x2 = v3[u2 + 1]) == "number" && (v3[u2 + 1] = v3[u2 + 2], v3[u2 + 2] = x2);
          }), g2;
        }
        constructor(g2, w2, v3) {
          this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(g2, w2, v3);
        }
        addEvents() {
          let g2 = this.options.inverted ? [1, 0] : [0, 1], w2 = this.scrollbarButtons, v3 = this.scrollbarGroup.element, x2 = this.track.element, G2 = this.mouseDownHandler.bind(this), u2 = this.mouseMoveHandler.bind(this), p2 = this.mouseUpHandler.bind(this), C3 = [[w2[g2[0]].element, "click", this.buttonToMinClick.bind(this)], [w2[g2[1]].element, "click", this.buttonToMaxClick.bind(this)], [x2, "click", this.trackClick.bind(this)], [v3, "mousedown", G2], [v3.ownerDocument, "mousemove", u2], [v3.ownerDocument, "mouseup", p2], [v3, "touchstart", G2], [v3.ownerDocument, "touchmove", u2], [v3.ownerDocument, "touchend", p2]];
          C3.forEach(function(n4) {
            W2.apply(null, n4);
          }), this._events = C3;
        }
        buttonToMaxClick(g2) {
          let w2 = (this.to - this.from) * H2(this.options.step, 0.2);
          this.updatePosition(this.from + w2, this.to + w2), k3(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: g2 });
        }
        buttonToMinClick(g2) {
          let w2 = I3(this.to - this.from) * H2(this.options.step, 0.2);
          this.updatePosition(I3(this.from - w2), I3(this.to - w2)), k3(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: g2 });
        }
        cursorToScrollbarPosition(g2) {
          let w2 = this.options, v3 = w2.minWidth > this.calculatedWidth ? w2.minWidth : 0;
          return { chartX: (g2.chartX - this.x - this.xOffset) / (this.barWidth - v3), chartY: (g2.chartY - this.y - this.yOffset) / (this.barWidth - v3) };
        }
        destroy() {
          let g2 = this, w2 = g2.chart.scroller;
          g2.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(v3) {
            g2[v3] && g2[v3].destroy && (g2[v3] = g2[v3].destroy());
          }), w2 && g2 === w2.scrollbar && (w2.scrollbar = null, A3(w2.scrollbarButtons));
        }
        drawScrollbarButton(g2) {
          let w2 = this.renderer, v3 = this.scrollbarButtons, x2 = this.options, G2 = this.size, u2 = w2.g().add(this.group);
          if (v3.push(u2), x2.buttonsEnabled) {
            let p2 = w2.rect().addClass("highcharts-scrollbar-button").add(u2);
            this.chart.styledMode || p2.attr({ stroke: x2.buttonBorderColor, "stroke-width": x2.buttonBorderWidth, fill: x2.buttonBackgroundColor }), p2.attr(p2.crisp({ x: -0.5, y: -0.5, width: G2, height: G2, r: x2.buttonBorderRadius }, p2.strokeWidth()));
            let C3 = w2.path(E2.swapXY([["M", G2 / 2 + (g2 ? -1 : 1), G2 / 2 - 3], ["L", G2 / 2 + (g2 ? -1 : 1), G2 / 2 + 3], ["L", G2 / 2 + (g2 ? 2 : -2), G2 / 2]], x2.vertical)).addClass("highcharts-scrollbar-arrow").add(v3[g2]);
            this.chart.styledMode || C3.attr({ fill: x2.buttonArrowColor });
          }
        }
        init(g2, w2, v3) {
          this.scrollbarButtons = [], this.renderer = g2, this.userOptions = w2, this.options = S2(Y2, _2.scrollbar, w2), this.options.margin = H2(this.options.margin, 10), this.chart = v3, this.size = H2(this.options.size, this.options.height), w2.enabled && (this.render(), this.addEvents());
        }
        mouseDownHandler(g2) {
          var w2;
          let v3 = ((w2 = this.chart.pointer) == null ? void 0 : w2.normalize(g2)) || g2, x2 = this.cursorToScrollbarPosition(v3);
          this.chartX = x2.chartX, this.chartY = x2.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = true;
        }
        mouseMoveHandler(g2) {
          var w2;
          let v3, x2 = ((w2 = this.chart.pointer) == null ? void 0 : w2.normalize(g2)) || g2, G2 = this.options.vertical ? "chartY" : "chartX", u2 = this.initPositions || [];
          this.grabbedCenter && (!g2.touches || g2.touches[0][G2] !== 0) && (v3 = this.cursorToScrollbarPosition(x2)[G2] - this[G2], this.hasDragged = true, this.updatePosition(u2[0] + v3, u2[1] + v3), this.hasDragged && k3(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: g2.type, DOMEvent: g2 }));
        }
        mouseUpHandler(g2) {
          this.hasDragged && k3(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: g2.type, DOMEvent: g2 }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }
        position(g2, w2, v3, x2) {
          let { buttonsEnabled: G2, margin: u2 = 0, vertical: p2 } = this.options, C3 = this.rendered ? "animate" : "attr", n4 = x2, a2 = 0;
          this.group.show(), this.x = g2, this.y = w2 + this.trackBorderWidth, this.width = v3, this.height = x2, this.xOffset = n4, this.yOffset = a2, p2 ? (this.width = this.yOffset = v3 = a2 = this.size, this.xOffset = n4 = 0, this.yOffset = a2 = G2 ? this.size : 0, this.barWidth = x2 - (G2 ? 2 * v3 : 0), this.x = g2 += u2) : (this.height = x2 = this.size, this.xOffset = n4 = G2 ? this.size : 0, this.barWidth = v3 - (G2 ? 2 * x2 : 0), this.y = this.y + u2), this.group[C3]({ translateX: g2, translateY: this.y }), this.track[C3]({ width: v3, height: x2 }), this.scrollbarButtons[1][C3]({ translateX: p2 ? 0 : v3 - n4, translateY: p2 ? x2 - a2 : 0 });
        }
        removeEvents() {
          this._events.forEach(function(g2) {
            m3.apply(null, g2);
          }), this._events.length = 0;
        }
        render() {
          let g2 = this.renderer, w2 = this.options, v3 = this.size, x2 = this.chart.styledMode, G2 = g2.g("scrollbar").attr({ zIndex: w2.zIndex }).hide().add();
          this.group = G2, this.track = g2.rect().addClass("highcharts-scrollbar-track").attr({ r: w2.trackBorderRadius || 0, height: v3, width: v3 }).add(G2), x2 || this.track.attr({ fill: w2.trackBackgroundColor, stroke: w2.trackBorderColor, "stroke-width": w2.trackBorderWidth });
          let u2 = this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({ x: -X2(0, u2), y: -X2(0, u2) }), this.scrollbarGroup = g2.g().add(G2), this.scrollbar = g2.rect().addClass("highcharts-scrollbar-thumb").attr({ height: v3 - u2, width: v3 - u2, r: w2.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = g2.path(E2.swapXY([["M", -3, v3 / 4], ["L", -3, 2 * v3 / 3], ["M", 0, v3 / 4], ["L", 0, 2 * v3 / 3], ["M", 3, v3 / 4], ["L", 3, 2 * v3 / 3]], w2.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), x2 || (this.scrollbar.attr({ fill: w2.barBackgroundColor, stroke: w2.barBorderColor, "stroke-width": w2.barBorderWidth }), this.scrollbarRifles.attr({ stroke: w2.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-X2(0, this.scrollbarStrokeWidth), -X2(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }
        setRange(g2, w2) {
          let v3, x2, G2 = this.options, u2 = G2.vertical, p2 = G2.minWidth, C3 = this.barWidth, n4 = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (!V2(C3)) return;
          let a2 = C3 * Math.min(w2, 1);
          v3 = Math.ceil(C3 * (g2 = Math.max(g2, 0))), this.calculatedWidth = x2 = I3(a2 - v3), x2 < p2 && (v3 = (C3 - p2 + x2) * g2, x2 = p2);
          let o2 = Math.floor(v3 + this.xOffset + this.yOffset), e5 = x2 / 2 - 0.5;
          this.from = g2, this.to = w2, u2 ? (this.scrollbarGroup[n4]({ translateY: o2 }), this.scrollbar[n4]({ height: x2 }), this.scrollbarRifles[n4]({ translateY: e5 }), this.scrollbarTop = o2, this.scrollbarLeft = 0) : (this.scrollbarGroup[n4]({ translateX: o2 }), this.scrollbar[n4]({ width: x2 }), this.scrollbarRifles[n4]({ translateX: e5 }), this.scrollbarLeft = o2, this.scrollbarTop = 0), x2 <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), G2.showFull === false && (g2 <= 0 && w2 >= 1 ? this.group.hide() : this.group.show()), this.rendered = true;
        }
        shouldUpdateExtremes(g2) {
          return H2(this.options.liveRedraw, N2.svg && !N2.isTouchDevice && !this.chart.boosted) || g2 === "mouseup" || g2 === "touchend" || !V2(g2);
        }
        trackClick(g2) {
          var w2;
          let v3 = ((w2 = this.chart.pointer) == null ? void 0 : w2.normalize(g2)) || g2, x2 = this.to - this.from, G2 = this.y + this.scrollbarTop, u2 = this.x + this.scrollbarLeft;
          this.options.vertical && v3.chartY > G2 || !this.options.vertical && v3.chartX > u2 ? this.updatePosition(this.from + x2, this.to + x2) : this.updatePosition(this.from - x2, this.to - x2), k3(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: g2 });
        }
        update(g2) {
          this.destroy(), this.init(this.chart.renderer, S2(true, this.options, g2), this.chart);
        }
        updatePosition(g2, w2) {
          w2 > 1 && (g2 = I3(1 - I3(w2 - g2)), w2 = 1), g2 < 0 && (w2 = I3(w2 - g2), g2 = 0), this.from = g2, this.to = w2;
        }
      }
      return E2.defaultOptions = Y2, _2.scrollbar = S2(true, E2.defaultOptions, _2.scrollbar), E2;
    }), $2(f2, "Stock/Navigator/Navigator.js", [f2["Core/Axis/Axis.js"], f2["Stock/Navigator/ChartNavigatorComposition.js"], f2["Core/Defaults.js"], f2["Core/Globals.js"], f2["Core/Axis/NavigatorAxisComposition.js"], f2["Stock/Navigator/NavigatorComposition.js"], f2["Stock/Scrollbar/Scrollbar.js"], f2["Core/Renderer/SVG/SVGRenderer.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2, Z2, _2, W2, I3, X2) {
      let { defaultOptions: V2 } = F2, { isTouchDevice: A3 } = Y2, { prototype: { symbols: k3 } } = I3, { addEvent: S2, clamp: H2, correctFloat: m3, defined: E2, destroyObjectProperties: B3, erase: g2, extend: w2, find: v3, fireEvent: x2, isArray: G2, isNumber: u2, merge: p2, pick: C3, removeEvent: n4, splat: a2 } = X2;
      function o2(r3, ...t3) {
        let i5 = [].filter.call(t3, u2);
        if (i5.length) return Math[r3].apply(0, i5);
      }
      class e5 {
        static compose(t3, i5, s2) {
          N2.compose(t3, e5), _2.compose(t3, i5, s2);
        }
        constructor(t3) {
          this.isDirty = false, this.scrollbarHeight = 0, this.init(t3);
        }
        drawHandle(t3, i5, s2, l4) {
          let h2 = this.navigatorOptions.handles.height;
          this.handles[i5][l4](s2 ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(t3, 10) + 0.5 - h2) } : { translateX: Math.round(this.left + parseInt(t3, 10)), translateY: Math.round(this.top + this.height / 2 - h2 / 2 - 1) });
        }
        drawOutline(t3, i5, s2, l4) {
          let h2 = this.navigatorOptions.maskInside, d3 = this.outline.strokeWidth(), c4 = d3 / 2, b5 = d3 % 2 / 2, y2 = this.scrollButtonSize, M2 = this.size, P2 = this.top, j3 = this.height, L2 = P2 - c4, T2 = P2 + j3, O3 = this.left, R2, z2;
          s2 ? (R2 = P2 + i5 + b5, i5 = P2 + t3 + b5, z2 = [["M", O3 + j3, P2 - y2 - b5], ["L", O3 + j3, R2], ["L", O3, R2], ["M", O3, i5], ["L", O3 + j3, i5], ["L", O3 + j3, P2 + M2 + y2]], h2 && z2.push(["M", O3 + j3, R2 - c4], ["L", O3 + j3, i5 + c4])) : (O3 -= y2, t3 += O3 + y2 - b5, i5 += O3 + y2 - b5, z2 = [["M", O3, L2], ["L", t3, L2], ["L", t3, T2], ["M", i5, T2], ["L", i5, L2], ["L", O3 + M2 + 2 * y2, L2]], h2 && z2.push(["M", t3 - c4, L2], ["L", i5 + c4, L2])), this.outline[l4]({ d: z2 });
        }
        drawMasks(t3, i5, s2, l4) {
          let h2, d3, c4, b5, y2 = this.left, M2 = this.top, P2 = this.height;
          s2 ? (c4 = [y2, y2, y2], b5 = [M2, M2 + t3, M2 + i5], d3 = [P2, P2, P2], h2 = [t3, i5 - t3, this.size - i5]) : (c4 = [y2, y2 + t3, y2 + i5], b5 = [M2, M2, M2], d3 = [t3, i5 - t3, this.size - i5], h2 = [P2, P2, P2]), this.shades.forEach((j3, L2) => {
            j3[l4]({ x: c4[L2], y: b5[L2], width: d3[L2], height: h2[L2] });
          });
        }
        renderElements() {
          var t3, i5;
          let s2 = this, l4 = s2.navigatorOptions, h2 = l4.maskInside, d3 = s2.chart, c4 = d3.inverted, b5 = d3.renderer, y2 = { cursor: c4 ? "ns-resize" : "ew-resize" }, M2 = (t3 = s2.navigatorGroup) != null ? t3 : s2.navigatorGroup = b5.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add();
          if ([!h2, h2, !h2].forEach((P2, j3) => {
            var L2;
            let T2 = (L2 = s2.shades[j3]) != null ? L2 : s2.shades[j3] = b5.rect().addClass("highcharts-navigator-mask" + (j3 === 1 ? "-inside" : "-outside")).add(M2);
            d3.styledMode || (T2.attr({ fill: P2 ? l4.maskFill : "rgba(0,0,0,0)" }), j3 === 1 && T2.css(y2));
          }), s2.outline || (s2.outline = b5.path().addClass("highcharts-navigator-outline").add(M2)), d3.styledMode || s2.outline.attr({ "stroke-width": l4.outlineWidth, stroke: l4.outlineColor }), (i5 = l4.handles) == null ? void 0 : i5.enabled) {
            let P2 = l4.handles, { height: j3, width: L2 } = P2;
            [0, 1].forEach((T2) => {
              var O3;
              let R2 = P2.symbols[T2];
              if (s2.handles[T2] && s2.handles[T2].symbolUrl === R2) {
                if (!s2.handles[T2].isImg && s2.handles[T2].symbolName !== R2) {
                  let z2 = k3[R2].call(k3, -L2 / 2 - 1, 0, L2, j3);
                  s2.handles[T2].attr({ d: z2 }), s2.handles[T2].symbolName = R2;
                }
              } else (O3 = s2.handles[T2]) == null || O3.destroy(), s2.handles[T2] = b5.symbol(R2, -L2 / 2 - 1, 0, L2, j3, P2), s2.handles[T2].attr({ zIndex: 7 - T2 }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][T2]).add(M2), s2.addMouseEvents();
              d3.inverted && s2.handles[T2].attr({ rotation: 90, rotationOriginX: Math.floor(-L2 / 2), rotationOriginY: (j3 + L2) / 2 }), d3.styledMode || s2.handles[T2].attr({ fill: P2.backgroundColor, stroke: P2.borderColor, "stroke-width": P2.lineWidth, width: P2.width, height: P2.height, x: -L2 / 2 - 1, y: 0 }).css(y2);
            });
          }
        }
        update(t3, i5 = false) {
          var s2, l4;
          let h2 = this.chart, d3 = h2.options.chart.inverted !== ((s2 = h2.scrollbar) == null ? void 0 : s2.options.vertical);
          if (p2(true, h2.options.navigator, t3), this.navigatorOptions = h2.options.navigator || {}, this.setOpposite(), E2(t3.enabled) || d3) return this.destroy(), this.navigatorEnabled = t3.enabled || this.navigatorEnabled, this.init(h2);
          if (this.navigatorEnabled && (this.isDirty = true, t3.adaptToUpdatedData === false && this.baseSeries.forEach((c4) => {
            n4(c4, "updatedData", this.updatedDataHandler);
          }, this), t3.adaptToUpdatedData && this.baseSeries.forEach((c4) => {
            c4.eventsToUnbind.push(S2(c4, "updatedData", this.updatedDataHandler));
          }, this), (t3.series || t3.baseSeries) && this.setBaseSeries(void 0, false), t3.height || t3.xAxis || t3.yAxis)) {
            this.height = (l4 = t3.height) != null ? l4 : this.height;
            let c4 = this.getXAxisOffsets();
            this.xAxis.update({ ...t3.xAxis, offsets: c4, [h2.inverted ? "width" : "height"]: this.height, [h2.inverted ? "height" : "width"]: void 0 }, false), this.yAxis.update({ ...t3.yAxis, [h2.inverted ? "width" : "height"]: this.height }, false);
          }
          i5 && h2.redraw();
        }
        render(t3, i5, s2, l4) {
          let h2 = this.chart, d3 = this.xAxis, c4 = d3.pointRange || 0, b5 = d3.navigatorAxis.fake ? h2.xAxis[0] : d3, y2 = this.navigatorEnabled, M2 = this.rendered, P2 = h2.inverted, j3 = h2.xAxis[0].minRange, L2 = h2.xAxis[0].options.maxRange, T2 = this.scrollButtonSize, O3, R2, z2, U2 = this.scrollbarHeight, Q2, K2;
          if (this.hasDragged && !E2(s2)) return;
          if (this.isDirty && this.renderElements(), t3 = m3(t3 - c4 / 2), i5 = m3(i5 + c4 / 2), !u2(t3) || !u2(i5)) {
            if (!M2) return;
            s2 = 0, l4 = C3(d3.width, b5.width);
          }
          this.left = C3(d3.left, h2.plotLeft + T2 + (P2 ? h2.plotWidth : 0));
          let q2 = this.size = Q2 = C3(d3.len, (P2 ? h2.plotHeight : h2.plotWidth) - 2 * T2);
          O3 = P2 ? U2 : Q2 + 2 * T2, s2 = C3(s2, d3.toPixels(t3, true)), l4 = C3(l4, d3.toPixels(i5, true)), u2(s2) && Math.abs(s2) !== 1 / 0 || (s2 = 0, l4 = O3);
          let tt2 = d3.toValue(s2, true), J2 = d3.toValue(l4, true), et2 = Math.abs(m3(J2 - tt2));
          et2 < j3 ? this.grabbedLeft ? s2 = d3.toPixels(J2 - j3 - c4, true) : this.grabbedRight && (l4 = d3.toPixels(tt2 + j3 + c4, true)) : E2(L2) && m3(et2 - c4) > L2 && (this.grabbedLeft ? s2 = d3.toPixels(J2 - L2 - c4, true) : this.grabbedRight && (l4 = d3.toPixels(tt2 + L2 + c4, true))), this.zoomedMax = H2(Math.max(s2, l4), 0, q2), this.zoomedMin = H2(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(s2, l4), 0, q2), this.range = this.zoomedMax - this.zoomedMin, q2 = Math.round(this.zoomedMax);
          let ot2 = Math.round(this.zoomedMin);
          y2 && (this.navigatorGroup.attr({ visibility: "inherit" }), K2 = M2 && !this.hasDragged ? "animate" : "attr", this.drawMasks(ot2, q2, P2, K2), this.drawOutline(ot2, q2, P2, K2), this.navigatorOptions.handles.enabled && (this.drawHandle(ot2, 0, P2, K2), this.drawHandle(q2, 1, P2, K2))), this.scrollbar && (P2 ? (z2 = this.top - T2, R2 = this.left - U2 + (y2 || !b5.opposite ? 0 : (b5.titleOffset || 0) + b5.axisTitleMargin), U2 = Q2 + 2 * T2) : (z2 = this.top + (y2 ? this.height : -U2), R2 = this.left - T2), this.scrollbar.position(R2, z2, O3, U2), this.scrollbar.setRange(this.zoomedMin / (Q2 || 1), this.zoomedMax / (Q2 || 1))), this.rendered = true, this.isDirty = false, x2(this, "afterRender");
        }
        addMouseEvents() {
          let t3 = this, i5 = t3.chart, s2 = i5.container, l4 = [], h2, d3;
          t3.mouseMoveHandler = h2 = function(c4) {
            t3.onMouseMove(c4);
          }, t3.mouseUpHandler = d3 = function(c4) {
            t3.onMouseUp(c4);
          }, (l4 = t3.getPartsEvents("mousedown")).push(S2(i5.renderTo, "mousemove", h2), S2(s2.ownerDocument, "mouseup", d3), S2(i5.renderTo, "touchmove", h2), S2(s2.ownerDocument, "touchend", d3)), l4.concat(t3.getPartsEvents("touchstart")), t3.eventsToUnbind = l4, t3.series && t3.series[0] && l4.push(S2(t3.series[0].xAxis, "foundExtremes", function() {
            i5.navigator.modifyNavigatorAxisExtremes();
          }));
        }
        getPartsEvents(t3) {
          let i5 = this, s2 = [];
          return ["shades", "handles"].forEach(function(l4) {
            i5[l4].forEach(function(h2, d3) {
              s2.push(S2(h2.element, t3, function(c4) {
                i5[l4 + "Mousedown"](c4, d3);
              }));
            });
          }), s2;
        }
        shadesMousedown(t3, i5) {
          var s2;
          t3 = ((s2 = this.chart.pointer) == null ? void 0 : s2.normalize(t3)) || t3;
          let l4 = this.chart, h2 = this.xAxis, d3 = this.zoomedMin, c4 = this.size, b5 = this.range, y2 = this.left, M2 = t3.chartX, P2, j3, L2, T2;
          l4.inverted && (M2 = t3.chartY, y2 = this.top), i5 === 1 ? (this.grabbedCenter = M2, this.fixedWidth = b5, this.dragOffset = M2 - d3) : (T2 = M2 - y2 - b5 / 2, i5 === 0 ? T2 = Math.max(0, T2) : i5 === 2 && T2 + b5 >= c4 && (T2 = c4 - b5, this.reversedExtremes ? (T2 -= b5, j3 = this.getUnionExtremes().dataMin) : P2 = this.getUnionExtremes().dataMax), T2 !== d3 && (this.fixedWidth = b5, E2((L2 = h2.navigatorAxis.toFixedRange(T2, T2 + b5, j3, P2)).min) && x2(this, "setRange", { min: Math.min(L2.min, L2.max), max: Math.max(L2.min, L2.max), redraw: true, eventArguments: { trigger: "navigator" } })));
        }
        handlesMousedown(t3, i5) {
          var s2;
          t3 = ((s2 = this.chart.pointer) == null ? void 0 : s2.normalize(t3)) || t3;
          let l4 = this.chart, h2 = l4.xAxis[0], d3 = this.reversedExtremes;
          i5 === 0 ? (this.grabbedLeft = true, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = d3 ? h2.min : h2.max) : (this.grabbedRight = true, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = d3 ? h2.max : h2.min), l4.setFixedRange(void 0);
        }
        onMouseMove(t3) {
          var i5;
          let s2 = this, l4 = s2.chart, h2 = s2.navigatorSize, d3 = s2.range, c4 = s2.dragOffset, b5 = l4.inverted, y2 = s2.left, M2;
          (!t3.touches || t3.touches[0].pageX !== 0) && (M2 = (t3 = ((i5 = l4.pointer) == null ? void 0 : i5.normalize(t3)) || t3).chartX, b5 && (y2 = s2.top, M2 = t3.chartY), s2.grabbedLeft ? (s2.hasDragged = true, s2.render(0, 0, M2 - y2, s2.otherHandlePos)) : s2.grabbedRight ? (s2.hasDragged = true, s2.render(0, 0, s2.otherHandlePos, M2 - y2)) : s2.grabbedCenter && (s2.hasDragged = true, M2 < c4 ? M2 = c4 : M2 > h2 + c4 - d3 && (M2 = h2 + c4 - d3), s2.render(0, 0, M2 - c4, M2 - c4 + d3)), s2.hasDragged && s2.scrollbar && C3(s2.scrollbar.options.liveRedraw, !A3 && !this.chart.boosted) && (t3.DOMType = t3.type, setTimeout(function() {
            s2.onMouseUp(t3);
          }, 0)));
        }
        onMouseUp(t3) {
          let i5, s2, l4, h2, d3, c4, b5 = this.chart, y2 = this.xAxis, M2 = this.scrollbar, P2 = t3.DOMEvent || t3, j3 = b5.inverted, L2 = this.rendered && !this.hasDragged ? "animate" : "attr";
          (this.hasDragged && (!M2 || !M2.hasDragged) || t3.trigger === "scrollbar") && (l4 = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? h2 = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (d3 = this.fixedExtreme), this.zoomedMax === this.size && (d3 = this.reversedExtremes ? l4.dataMin : l4.dataMax), this.zoomedMin === 0 && (h2 = this.reversedExtremes ? l4.dataMax : l4.dataMin), E2((c4 = y2.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, h2, d3)).min) && x2(this, "setRange", { min: Math.min(c4.min, c4.max), max: Math.max(c4.min, c4.max), redraw: true, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: P2 } })), t3.DOMType !== "mousemove" && t3.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && u2(this.zoomedMin) && u2(this.zoomedMax) && (s2 = Math.round(this.zoomedMin), i5 = Math.round(this.zoomedMax), this.shades && this.drawMasks(s2, i5, j3, L2), this.outline && this.drawOutline(s2, i5, j3, L2), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(s2, 0, j3, L2), this.drawHandle(i5, 1, j3, L2)));
        }
        removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function(t3) {
            t3();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }
        removeBaseSeriesEvents() {
          let t3 = this.baseSeries || [];
          this.navigatorEnabled && t3[0] && (this.navigatorOptions.adaptToUpdatedData !== false && t3.forEach(function(i5) {
            n4(i5, "updatedData", this.updatedDataHandler);
          }, this), t3[0].xAxis && n4(t3[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }
        getXAxisOffsets() {
          return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
        }
        init(t3) {
          var i5;
          let s2 = t3.options, l4 = s2.navigator || {}, h2 = l4.enabled, d3 = s2.scrollbar || {}, c4 = d3.enabled, b5 = h2 && l4.height || 0, y2 = c4 && d3.height || 0, M2 = d3.buttonsEnabled && y2 || 0;
          this.handles = [], this.shades = [], this.chart = t3, this.setBaseSeries(), this.height = b5, this.scrollbarHeight = y2, this.scrollButtonSize = M2, this.scrollbarEnabled = c4, this.navigatorEnabled = h2, this.navigatorOptions = l4, this.scrollbarOptions = d3, this.setOpposite();
          let P2 = this, j3 = P2.baseSeries, L2 = t3.xAxis.length, T2 = t3.yAxis.length, O3 = j3 && j3[0] && j3[0].xAxis || t3.xAxis[0] || { options: {} };
          if (t3.isDirtyBox = true, P2.navigatorEnabled) {
            let R2 = this.getXAxisOffsets();
            P2.xAxis = new D2(t3, p2({ breaks: O3.options.breaks, ordinal: O3.options.ordinal, overscroll: O3.options.overscroll }, l4.xAxis, { type: "datetime", yAxis: (i5 = l4.yAxis) == null ? void 0 : i5.id, index: L2, isInternal: true, offset: 0, keepOrdinalPadding: true, startOnTick: false, endOnTick: false, minPadding: O3.options.ordinal ? 0 : O3.options.minPadding, maxPadding: O3.options.ordinal ? 0 : O3.options.maxPadding, zoomEnabled: false }, t3.inverted ? { offsets: R2, width: b5 } : { offsets: R2, height: b5 }), "xAxis"), P2.yAxis = new D2(t3, p2(l4.yAxis, { alignTicks: false, offset: 0, index: T2, isInternal: true, reversed: C3(l4.yAxis && l4.yAxis.reversed, t3.yAxis[0] && t3.yAxis[0].reversed, false), zoomEnabled: false }, t3.inverted ? { width: b5 } : { height: b5 }), "yAxis"), j3 || l4.series.data ? P2.updateNavigatorSeries(false) : t3.series.length === 0 && (P2.unbindRedraw = S2(t3, "beforeRedraw", function() {
              t3.series.length > 0 && !P2.series && (P2.setBaseSeries(), P2.unbindRedraw());
            })), P2.reversedExtremes = t3.inverted && !P2.xAxis.reversed || !t3.inverted && P2.xAxis.reversed, P2.renderElements(), P2.addMouseEvents();
          } else P2.xAxis = { chart: t3, navigatorAxis: { fake: true }, translate: function(R2, z2) {
            let U2 = t3.xAxis[0], Q2 = U2.getExtremes(), K2 = U2.len - 2 * M2, q2 = o2("min", U2.options.min, Q2.dataMin), tt2 = o2("max", U2.options.max, Q2.dataMax) - q2;
            return z2 ? R2 * tt2 / K2 + q2 : K2 * (R2 - q2) / tt2;
          }, toPixels: function(R2) {
            return this.translate(R2);
          }, toValue: function(R2) {
            return this.translate(R2, true);
          } }, P2.xAxis.navigatorAxis.axis = P2.xAxis, P2.xAxis.navigatorAxis.toFixedRange = Z2.prototype.toFixedRange.bind(P2.xAxis.navigatorAxis);
          if (t3.options.scrollbar.enabled) {
            let R2 = p2(t3.options.scrollbar, { vertical: t3.inverted });
            !u2(R2.margin) && P2.navigatorEnabled && (R2.margin = t3.inverted ? -3 : 3), t3.scrollbar = P2.scrollbar = new W2(t3.renderer, R2, t3), S2(P2.scrollbar, "changed", function(z2) {
              let U2 = P2.size, Q2 = U2 * this.to, K2 = U2 * this.from;
              P2.hasDragged = P2.scrollbar.hasDragged, P2.render(0, 0, K2, Q2), this.shouldUpdateExtremes(z2.DOMType) && setTimeout(function() {
                P2.onMouseUp(z2);
              });
            });
          }
          P2.addBaseSeriesEvents(), P2.addChartEvents();
        }
        setOpposite() {
          let t3 = this.navigatorOptions, i5 = this.navigatorEnabled, s2 = this.chart;
          this.opposite = C3(t3.opposite, !!(!i5 && s2.inverted));
        }
        getUnionExtremes(t3) {
          let i5, s2 = this.chart.xAxis[0], l4 = this.xAxis, h2 = l4.options, d3 = s2.options;
          return t3 && s2.dataMin === null || (i5 = { dataMin: C3(h2 && h2.min, o2("min", d3.min, s2.dataMin, l4.dataMin, l4.min)), dataMax: C3(h2 && h2.max, o2("max", d3.max, s2.dataMax, l4.dataMax, l4.max)) }), i5;
        }
        setBaseSeries(t3, i5) {
          let s2 = this.chart, l4 = this.baseSeries = [];
          t3 = t3 || s2.options && s2.options.navigator.baseSeries || (s2.series.length ? v3(s2.series, (h2) => !h2.options.isInternal).index : 0), (s2.series || []).forEach((h2, d3) => {
            !h2.options.isInternal && (h2.options.showInNavigator || (d3 === t3 || h2.options.id === t3) && h2.options.showInNavigator !== false) && l4.push(h2);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(true, i5);
        }
        updateNavigatorSeries(t3, i5) {
          var s2, l4;
          let h2 = this, d3 = h2.chart, c4 = h2.baseSeries, b5 = { enableMouseTracking: false, index: null, linkedTo: null, group: "nav", padXAxis: false, xAxis: (s2 = this.navigatorOptions.xAxis) == null ? void 0 : s2.id, yAxis: (l4 = this.navigatorOptions.yAxis) == null ? void 0 : l4.id, showInLegend: false, stacking: void 0, isInternal: true, states: { inactive: { opacity: 1 } } }, y2 = h2.series = (h2.series || []).filter((T2) => {
            let O3 = T2.baseSeries;
            return !(0 > c4.indexOf(O3)) || (O3 && (n4(O3, "updatedData", h2.updatedDataHandler), delete O3.navigatorSeries), T2.chart && T2.destroy(), false);
          }), M2, P2, j3 = h2.navigatorOptions.series, L2;
          c4 && c4.length && c4.forEach((T2) => {
            let O3 = T2.navigatorSeries, R2 = w2({ color: T2.color, visible: T2.visible }, G2(j3) ? V2.navigator.series : j3);
            if (O3 && h2.navigatorOptions.adaptToUpdatedData === false) return;
            b5.name = "Navigator " + c4.length, L2 = (M2 = T2.options || {}).navigatorOptions || {}, R2.dataLabels = a2(R2.dataLabels), (P2 = p2(M2, b5, R2, L2)).pointRange = C3(R2.pointRange, L2.pointRange, V2.plotOptions[P2.type || "line"].pointRange);
            let z2 = L2.data || R2.data;
            h2.hasNavigatorData = h2.hasNavigatorData || !!z2, P2.data = z2 || M2.data && M2.data.slice(0), O3 && O3.options ? O3.update(P2, i5) : (T2.navigatorSeries = d3.initSeries(P2), d3.setSortedData(), T2.navigatorSeries.baseSeries = T2, y2.push(T2.navigatorSeries));
          }), (j3.data && !(c4 && c4.length) || G2(j3)) && (h2.hasNavigatorData = false, (j3 = a2(j3)).forEach((T2, O3) => {
            b5.name = "Navigator " + (y2.length + 1), (P2 = p2(V2.navigator.series, { color: d3.series[O3] && !d3.series[O3].options.isInternal && d3.series[O3].color || d3.options.colors[O3] || d3.options.colors[0] }, b5, T2)).data = T2.data, P2.data && (h2.hasNavigatorData = true, y2.push(d3.initSeries(P2)));
          })), t3 && this.addBaseSeriesEvents();
        }
        addBaseSeriesEvents() {
          let t3 = this, i5 = t3.baseSeries || [];
          i5[0] && i5[0].xAxis && i5[0].eventsToUnbind.push(S2(i5[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), i5.forEach((s2) => {
            s2.eventsToUnbind.push(S2(s2, "show", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(true, false);
            })), s2.eventsToUnbind.push(S2(s2, "hide", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(false, false);
            })), this.navigatorOptions.adaptToUpdatedData !== false && s2.xAxis && s2.eventsToUnbind.push(S2(s2, "updatedData", this.updatedDataHandler)), s2.eventsToUnbind.push(S2(s2, "remove", function() {
              g2(i5, s2), this.navigatorSeries && (g2(t3.series, this.navigatorSeries), E2(this.navigatorSeries.options) && this.navigatorSeries.remove(false), delete this.navigatorSeries);
            }));
          });
        }
        getBaseSeriesMin(t3) {
          return this.baseSeries.reduce(function(i5, s2) {
            return Math.min(i5, s2.xData && s2.xData.length ? s2.xData[0] : i5);
          }, t3);
        }
        modifyNavigatorAxisExtremes() {
          let t3 = this.xAxis;
          if (t3.getExtremes !== void 0) {
            let i5 = this.getUnionExtremes(true);
            i5 && (i5.dataMin !== t3.min || i5.dataMax !== t3.max) && (t3.min = i5.dataMin, t3.max = i5.dataMax);
          }
        }
        modifyBaseAxisExtremes() {
          var t3;
          let i5, s2, l4 = this.chart.navigator, h2 = this.getExtremes(), d3 = h2.min, c4 = h2.max, b5 = h2.dataMin, y2 = h2.dataMax, M2 = c4 - d3, P2 = l4.stickToMin, j3 = l4.stickToMax, L2 = C3((t3 = this.ordinal) == null ? void 0 : t3.convertOverscroll(this.options.overscroll), 0), T2 = l4.series && l4.series[0], O3 = !!this.setExtremes;
          !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (P2 && (i5 = (s2 = b5) + M2), j3 && (i5 = y2 + L2, P2 || (s2 = Math.max(b5, i5 - M2, l4.getBaseSeriesMin(T2 && T2.xData ? T2.xData[0] : -Number.MAX_VALUE)))), O3 && (P2 || j3) && u2(s2) && (this.min = this.userMin = s2, this.max = this.userMax = i5)), l4.stickToMin = l4.stickToMax = null;
        }
        updatedDataHandler() {
          let t3 = this.chart.navigator, i5 = this.navigatorSeries, s2 = t3.reversedExtremes ? Math.round(t3.zoomedMin) === 0 : Math.round(t3.zoomedMax) >= Math.round(t3.size);
          t3.stickToMax = C3(this.chart.options.navigator && this.chart.options.navigator.stickToMax, s2), t3.stickToMin = t3.shouldStickToMin(this, t3), i5 && !t3.hasNavigatorData && (i5.options.pointStart = this.xData[0], i5.setData(this.options.data, false, null, false));
        }
        shouldStickToMin(t3, i5) {
          let s2 = i5.getBaseSeriesMin(t3.xData[0]), l4 = t3.xAxis, h2 = l4.max, d3 = l4.min, c4 = l4.options.range;
          return !!(u2(h2) && u2(d3)) && (c4 && h2 - s2 > 0 ? h2 - s2 < c4 : d3 <= s2);
        }
        addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(S2(this.chart, "redraw", function() {
            let t3 = this.navigator, i5 = t3 && (t3.baseSeries && t3.baseSeries[0] && t3.baseSeries[0].xAxis || this.xAxis[0]);
            i5 && t3.render(i5.min, i5.max);
          }), S2(this.chart, "getMargins", function() {
            let t3 = this.navigator, i5 = t3.opposite ? "plotTop" : "marginBottom";
            this.inverted && (i5 = t3.opposite ? "marginRight" : "plotLeft"), this[i5] = (this[i5] || 0) + (t3.navigatorEnabled || !this.inverted ? t3.height + t3.scrollbarHeight : 0) + t3.navigatorOptions.margin;
          }), S2(e5, "setRange", function(t3) {
            this.chart.xAxis[0].setExtremes(t3.min, t3.max, t3.redraw, t3.animation, t3.eventArguments);
          }));
        }
        destroy() {
          this.removeEvents(), this.xAxis && (g2(this.chart.xAxis, this.xAxis), g2(this.chart.axes, this.xAxis)), this.yAxis && (g2(this.chart.yAxis, this.yAxis), g2(this.chart.axes, this.yAxis)), (this.series || []).forEach((t3) => {
            t3.destroy && t3.destroy();
          }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((t3) => {
            this[t3] && this[t3].destroy && this[t3].destroy(), this[t3] = null;
          }), [this.handles].forEach((t3) => {
            B3(t3);
          }), this.navigatorEnabled = false;
        }
      }
      return e5;
    }), $2(f2, "Core/Axis/OrdinalAxis.js", [f2["Core/Axis/Axis.js"], f2["Core/Globals.js"], f2["Core/Series/Series.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2) {
      var Z2;
      let { addEvent: _2, correctFloat: W2, css: I3, defined: X2, error: V2, isNumber: A3, pick: k3, timeUnits: S2, isString: H2 } = Y2;
      return function(m3) {
        function E2(o2, e5, r3, t3, i5 = [], s2 = 0, l4) {
          let h2 = {}, d3 = this.options.tickPixelInterval, c4 = this.chart.time, b5 = [], y2, M2, P2, j3, L2, T2 = 0, O3 = [], R2 = -Number.MAX_VALUE;
          if (!this.options.ordinal && !this.options.breaks || !i5 || i5.length < 3 || e5 === void 0) return c4.getTimeTicks.apply(c4, arguments);
          let z2 = i5.length;
          for (y2 = 0; y2 < z2; y2++) {
            if (L2 = y2 && i5[y2 - 1] > r3, i5[y2] < e5 && (T2 = y2), y2 === z2 - 1 || i5[y2 + 1] - i5[y2] > 5 * s2 || L2) {
              if (i5[y2] > R2) {
                for (M2 = c4.getTimeTicks(o2, i5[T2], i5[y2], t3); M2.length && M2[0] <= R2; ) M2.shift();
                M2.length && (R2 = M2[M2.length - 1]), b5.push(O3.length), O3 = O3.concat(M2);
              }
              T2 = y2 + 1;
            }
            if (L2) break;
          }
          if (M2) {
            if (j3 = M2.info, l4 && j3.unitRange <= S2.hour) {
              for (T2 = 1, y2 = O3.length - 1; T2 < y2; T2++) c4.dateFormat("%d", O3[T2]) !== c4.dateFormat("%d", O3[T2 - 1]) && (h2[O3[T2]] = "day", P2 = true);
              P2 && (h2[O3[0]] = "day"), j3.higherRanks = h2;
            }
            j3.segmentStarts = b5, O3.info = j3;
          } else V2(12, false, this.chart);
          if (l4 && X2(d3)) {
            let U2 = O3.length, Q2 = [], K2 = [], q2, tt2, J2, et2, ot2, it2 = U2;
            for (; it2--; ) tt2 = this.translate(O3[it2]), J2 && (K2[it2] = J2 - tt2), Q2[it2] = J2 = tt2;
            for (K2.sort((lt2, nt2) => lt2 - nt2), (et2 = K2[Math.floor(K2.length / 2)]) < 0.6 * d3 && (et2 = null), it2 = O3[U2 - 1] > r3 ? U2 - 1 : U2, J2 = void 0; it2--; ) ot2 = Math.abs(J2 - (tt2 = Q2[it2])), J2 && ot2 < 0.8 * d3 && (et2 === null || ot2 < 0.8 * et2) ? (h2[O3[it2]] && !h2[O3[it2 + 1]] ? (q2 = it2 + 1, J2 = tt2) : q2 = it2, O3.splice(q2, 1)) : J2 = tt2;
          }
          return O3;
        }
        function B3(o2) {
          let e5 = this.ordinal.positions;
          if (!e5) return o2;
          let r3 = e5.length - 1, t3;
          return o2 < 0 ? o2 = e5[0] : o2 > r3 ? o2 = e5[r3] : (r3 = Math.floor(o2), t3 = o2 - r3), t3 !== void 0 && e5[r3] !== void 0 ? e5[r3] + (t3 ? t3 * (e5[r3 + 1] - e5[r3]) : 0) : o2;
        }
        function g2(o2) {
          let e5 = this.ordinal, r3 = this.old ? this.old.min : this.min, t3 = this.old ? this.old.transA : this.transA, i5 = e5.getExtendedPositions();
          if (i5 && i5.length) {
            let s2 = W2((o2 - r3) * t3 + this.minPixelPadding), l4 = W2(e5.getIndexOfPoint(s2, i5)), h2 = W2(l4 % 1);
            if (l4 >= 0 && l4 <= i5.length - 1) {
              let d3 = i5[Math.floor(l4)], c4 = i5[Math.ceil(l4)];
              return i5[Math.floor(l4)] + h2 * (c4 - d3);
            }
          }
          return o2;
        }
        function w2(o2, e5) {
          let r3 = m3.Additions.findIndexOf(o2, e5, true);
          if (o2[r3] === e5) return r3;
          let t3 = (e5 - o2[r3]) / (o2[r3 + 1] - o2[r3]);
          return r3 + t3;
        }
        function v3() {
          this.ordinal || (this.ordinal = new m3.Additions(this));
        }
        function x2() {
          let { eventArgs: o2, options: e5 } = this;
          if (this.isXAxis && X2(e5.overscroll) && e5.overscroll !== 0 && A3(this.max) && A3(this.min) && (this.options.ordinal && !this.ordinal.originalOrdinalRange && this.ordinal.getExtendedPositions(false), this.max === this.dataMax && ((o2 == null ? void 0 : o2.trigger) !== "pan" || this.isInternal) && (o2 == null ? void 0 : o2.trigger) !== "navigator")) {
            let r3 = this.ordinal.convertOverscroll(e5.overscroll);
            this.max += r3, !this.isInternal && X2(this.userMin) && (o2 == null ? void 0 : o2.trigger) !== "mousewheel" && (this.min += r3);
          }
        }
        function G2() {
          this.horiz && !this.isDirty && (this.isDirty = this.isOrdinal && this.chart.navigator && !this.chart.navigator.adaptToUpdatedData);
        }
        function u2() {
          this.ordinal && (this.ordinal.beforeSetTickPositions(), this.tickInterval = this.ordinal.postProcessTickInterval(this.tickInterval));
        }
        function p2(o2) {
          let e5 = this.xAxis[0], r3 = e5.ordinal.convertOverscroll(e5.options.overscroll), t3 = o2.originalEvent.chartX, i5 = this.options.chart.panning, s2 = false;
          if (i5 && i5.type !== "y" && e5.options.ordinal && e5.series.length && (!o2.touches || o2.touches.length <= 1)) {
            let l4, h2, d3 = this.mouseDownX, c4 = e5.getExtremes(), b5 = c4.dataMin, y2 = c4.dataMax, M2 = c4.min, P2 = c4.max, j3 = this.hoverPoints, L2 = e5.closestPointRange || e5.ordinal && e5.ordinal.overscrollPointsRange, T2 = Math.round((d3 - t3) / (e5.translationSlope * (e5.ordinal.slope || L2))), O3 = e5.ordinal.getExtendedPositions(), R2 = { ordinal: { positions: O3, extendedOrdinalPositions: O3 } }, z2 = e5.index2val, U2 = e5.val2lin;
            if (M2 <= b5 && T2 < 0 || P2 + r3 >= y2 && T2 > 0) return;
            R2.ordinal.positions ? Math.abs(T2) > 1 && (j3 && j3.forEach(function(Q2) {
              Q2.setState();
            }), y2 > (h2 = R2.ordinal.positions)[h2.length - 1] && h2.push(y2), this.setFixedRange(P2 - M2), (l4 = e5.navigatorAxis.toFixedRange(void 0, void 0, z2.apply(R2, [U2.apply(R2, [M2, true]) + T2]), z2.apply(R2, [U2.apply(R2, [P2, true]) + T2]))).min >= Math.min(c4.dataMin, M2) && l4.max <= Math.max(y2, P2) + r3 && e5.setExtremes(l4.min, l4.max, true, false, { trigger: "pan" }), this.mouseDownX = t3, I3(this.container, { cursor: "move" })) : s2 = true;
          } else s2 = true;
          s2 || i5 && /y/.test(i5.type) ? r3 && (e5.max = e5.dataMax + r3) : o2.preventDefault();
        }
        function C3() {
          let o2 = this.xAxis;
          o2 && o2.options.ordinal && (delete o2.ordinal.index, delete o2.ordinal.originalOrdinalRange);
        }
        function n4(o2, e5) {
          let r3, t3 = this.ordinal, i5 = t3.positions, s2 = t3.slope, l4;
          if (!i5) return o2;
          let h2 = i5.length;
          if (i5[0] <= o2 && i5[h2 - 1] >= o2) r3 = w2(i5, o2);
          else {
            if (!((l4 = t3.getExtendedPositions && t3.getExtendedPositions()) && l4.length)) return o2;
            let d3 = l4.length;
            s2 || (s2 = (l4[d3 - 1] - l4[0]) / d3);
            let c4 = w2(l4, i5[0]);
            if (o2 >= l4[0] && o2 <= l4[d3 - 1]) r3 = w2(l4, o2) - c4;
            else {
              if (!e5) return o2;
              r3 = o2 < l4[0] ? -c4 - (l4[0] - o2) / s2 : (o2 - l4[d3 - 1]) / s2 + d3 - c4;
            }
          }
          return e5 ? r3 : s2 * (r3 || 0) + t3.offset;
        }
        m3.compose = function(o2, e5, r3) {
          let t3 = o2.prototype;
          return t3.ordinal2lin || (t3.getTimeTicks = E2, t3.index2val = B3, t3.lin2val = g2, t3.val2lin = n4, t3.ordinal2lin = t3.val2lin, _2(o2, "afterInit", v3), _2(o2, "foundExtremes", x2), _2(o2, "afterSetScale", G2), _2(o2, "initialAxisTranslation", u2), _2(r3, "pan", p2), _2(r3, "touchpan", p2), _2(e5, "updatedData", C3)), o2;
        };
        class a2 {
          constructor(e5) {
            this.index = {}, this.axis = e5;
          }
          beforeSetTickPositions() {
            var e5;
            let r3 = this.axis, t3 = r3.ordinal, i5 = r3.getExtremes(), s2 = i5.min, l4 = i5.max, h2 = (e5 = r3.brokenAxis) == null ? void 0 : e5.hasBreaks, d3 = r3.options.ordinal, c4, b5, y2, M2, P2, j3, L2, T2 = [], O3 = Number.MAX_VALUE, R2 = false, z2 = false, U2 = false;
            if (d3 || h2) {
              let Q2 = 0;
              if (r3.series.forEach(function(K2, q2) {
                if (b5 = [], q2 > 0 && K2.options.id !== "highcharts-navigator-series" && K2.processedXData.length > 1 && (z2 = Q2 !== K2.processedXData[1] - K2.processedXData[0]), Q2 = K2.processedXData[1] - K2.processedXData[0], K2.boosted && (U2 = K2.boosted), K2.reserveSpace() && (K2.takeOrdinalPosition !== false || h2) && (c4 = (T2 = T2.concat(K2.processedXData)).length, T2.sort(function(tt2, J2) {
                  return tt2 - J2;
                }), O3 = Math.min(O3, k3(K2.closestPointRange, O3)), c4)) {
                  for (q2 = 0; q2 < c4 - 1; ) T2[q2] !== T2[q2 + 1] && b5.push(T2[q2 + 1]), q2++;
                  b5[0] !== T2[0] && b5.unshift(T2[0]), T2 = b5;
                }
              }), r3.ordinal.originalOrdinalRange || (r3.ordinal.originalOrdinalRange = (T2.length - 1) * O3), z2 && U2 && (T2.pop(), T2.shift()), (c4 = T2.length) > 2) {
                for (y2 = T2[1] - T2[0], L2 = c4 - 1; L2-- && !R2; ) T2[L2 + 1] - T2[L2] !== y2 && (R2 = true);
                !r3.options.keepOrdinalPadding && (T2[0] - s2 > y2 || l4 - T2[T2.length - 1] > y2) && (R2 = true);
              } else r3.options.overscroll && (c4 === 2 ? O3 = T2[1] - T2[0] : c4 === 1 ? (O3 = r3.ordinal.convertOverscroll(r3.options.overscroll), T2 = [T2[0], T2[0] + O3]) : O3 = t3.overscrollPointsRange);
              R2 || r3.forceOrdinal ? (r3.options.overscroll && (t3.overscrollPointsRange = O3, T2 = T2.concat(t3.getOverscrollPositions())), t3.positions = T2, M2 = r3.ordinal2lin(Math.max(s2, T2[0]), true), P2 = Math.max(r3.ordinal2lin(Math.min(l4, T2[T2.length - 1]), true), 1), t3.slope = j3 = (l4 - s2) / (P2 - M2), t3.offset = s2 - M2 * j3) : (t3.overscrollPointsRange = k3(r3.closestPointRange, t3.overscrollPointsRange), t3.positions = r3.ordinal.slope = t3.offset = void 0);
            }
            r3.isOrdinal = d3 && R2, t3.groupIntervalFactor = null;
          }
          static findIndexOf(e5, r3, t3) {
            let i5 = 0, s2 = e5.length - 1, l4;
            for (; i5 < s2; ) e5[l4 = Math.ceil((i5 + s2) / 2)] <= r3 ? i5 = l4 : s2 = l4 - 1;
            return e5[i5] === r3 || t3 ? i5 : -1;
          }
          getExtendedPositions(e5 = true) {
            var r3;
            let t3 = this, i5 = t3.axis, s2 = i5.constructor.prototype, l4 = i5.chart, h2 = (r3 = i5.series[0]) == null ? void 0 : r3.currentDataGrouping, d3 = h2 ? h2.count + h2.unitName : "raw", c4 = e5 ? i5.ordinal.convertOverscroll(i5.options.overscroll) : 0, b5 = i5.getExtremes(), y2, M2, P2 = t3.index;
            return P2 || (P2 = t3.index = {}), P2[d3] || ((y2 = { series: [], chart: l4, forceOrdinal: false, getExtremes: function() {
              return { min: b5.dataMin, max: b5.dataMax + c4 };
            }, applyGrouping: s2.applyGrouping, getGroupPixelWidth: s2.getGroupPixelWidth, getTimeTicks: s2.getTimeTicks, options: { ordinal: true }, ordinal: { getGroupIntervalFactor: this.getGroupIntervalFactor }, ordinal2lin: s2.ordinal2lin, getIndexOfPoint: s2.getIndexOfPoint, val2lin: s2.val2lin }).ordinal.axis = y2, i5.series.forEach(function(j3) {
              var L2, T2, O3;
              M2 = { xAxis: y2, xData: j3.xData.slice(), chart: l4, groupPixelWidth: j3.groupPixelWidth, destroyGroupedData: N2.noop, getProcessedData: F2.prototype.getProcessedData, applyGrouping: F2.prototype.applyGrouping, reserveSpace: F2.prototype.reserveSpace, visible: j3.visible }, e5 && (M2.xData = M2.xData.concat(t3.getOverscrollPositions())), M2.options = { dataGrouping: h2 ? { firstAnchor: (L2 = j3.options.dataGrouping) == null ? void 0 : L2.firstAnchor, anchor: (T2 = j3.options.dataGrouping) == null ? void 0 : T2.anchor, lastAnchor: (O3 = j3.options.dataGrouping) == null ? void 0 : O3.firstAnchor, enabled: true, forced: true, approximation: "open", units: [[h2.unitName, [h2.count]]] } : { enabled: false } }, y2.series.push(M2), j3.processData.apply(M2);
            }), y2.applyGrouping({ hasExtremesChanged: true }), (M2 == null ? void 0 : M2.closestPointRange) !== (M2 == null ? void 0 : M2.basePointRange) && M2.currentDataGrouping && (y2.forceOrdinal = true), i5.ordinal.beforeSetTickPositions.apply({ axis: y2 }), !i5.ordinal.originalOrdinalRange && y2.ordinal.originalOrdinalRange && (i5.ordinal.originalOrdinalRange = y2.ordinal.originalOrdinalRange), P2[d3] = y2.ordinal.positions), P2[d3];
          }
          getGroupIntervalFactor(e5, r3, t3) {
            let i5 = t3.processedXData, s2 = i5.length, l4 = [], h2, d3, c4 = this.groupIntervalFactor;
            if (!c4) {
              for (d3 = 0; d3 < s2 - 1; d3++) l4[d3] = i5[d3 + 1] - i5[d3];
              l4.sort(function(b5, y2) {
                return b5 - y2;
              }), h2 = l4[Math.floor(s2 / 2)], e5 = Math.max(e5, i5[0]), r3 = Math.min(r3, i5[s2 - 1]), this.groupIntervalFactor = c4 = s2 * h2 / (r3 - e5);
            }
            return c4;
          }
          getIndexOfPoint(e5, r3) {
            let t3, i5 = this.axis, s2 = 0, l4 = function(c4) {
              let { min: b5, max: y2 } = i5;
              return !!(X2(b5) && X2(y2)) && c4.points.some((M2) => M2.x >= b5 && M2.x <= y2);
            };
            i5.series.forEach((c4) => {
              var b5;
              let y2 = (b5 = c4.points) == null ? void 0 : b5[0];
              X2(y2 == null ? void 0 : y2.plotX) && (y2.plotX < t3 || !X2(t3)) && l4(c4) && (t3 = y2.plotX, s2 = y2.x);
            }), t3 != null || (t3 = i5.minPixelPadding);
            let h2 = i5.translationSlope * (this.slope || i5.closestPointRange || this.overscrollPointsRange), d3 = W2((e5 - t3) / h2);
            return a2.findIndexOf(r3, s2, true) + d3;
          }
          getOverscrollPositions() {
            let e5 = this.axis, r3 = this.convertOverscroll(e5.options.overscroll), t3 = this.overscrollPointsRange, i5 = [], s2 = e5.dataMax;
            if (X2(t3)) for (; s2 <= e5.dataMax + r3; ) i5.push(s2 += t3);
            return i5;
          }
          postProcessTickInterval(e5) {
            let r3 = this.axis, t3 = this.slope;
            return t3 ? r3.options.breaks ? r3.closestPointRange || e5 : e5 / (t3 / r3.closestPointRange) : e5;
          }
          convertOverscroll(e5 = 0) {
            let r3 = this, t3 = r3.axis, i5 = function(s2) {
              return k3(r3.originalOrdinalRange, X2(t3.dataMax) && X2(t3.dataMin) ? t3.dataMax - t3.dataMin : 0) * s2;
            };
            if (H2(e5)) {
              let s2 = parseInt(e5, 10);
              if (/%$/.test(e5)) return i5(s2 / 100);
              if (/px/.test(e5)) {
                let l4 = Math.min(s2, 0.9 * t3.len) / t3.len;
                return i5(l4 / (1 - l4));
              }
              return 0;
            }
            return e5;
          }
        }
        m3.Additions = a2;
      }(Z2 || (Z2 = {})), Z2;
    }), $2(f2, "Stock/RangeSelector/RangeSelectorDefaults.js", [], function() {
      return { lang: { rangeSelectorZoom: "Zoom", rangeSelectorFrom: "", rangeSelectorTo: "→" }, rangeSelector: { allButtonsEnabled: false, buttons: void 0, buttonSpacing: 5, dropdown: "responsive", enabled: void 0, verticalAlign: "top", buttonTheme: { width: 28, height: 18, padding: 2, zIndex: 7 }, floating: false, x: 0, y: 0, height: void 0, inputBoxBorderColor: "none", inputBoxHeight: 17, inputBoxWidth: void 0, inputDateFormat: "%e %b %Y", inputDateParser: void 0, inputEditDateFormat: "%Y-%m-%d", inputEnabled: true, inputPosition: { align: "right", x: 0, y: 0 }, inputSpacing: 5, selected: void 0, buttonPosition: { align: "left", x: 0, y: 0 }, inputStyle: { color: "#334eff", cursor: "pointer", fontSize: "0.8em" }, labelStyle: { color: "#666666", fontSize: "0.8em" } } };
    }), $2(f2, "Stock/RangeSelector/RangeSelectorComposition.js", [f2["Core/Defaults.js"], f2["Core/Globals.js"], f2["Stock/RangeSelector/RangeSelectorDefaults.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2) {
      let Z2, { defaultOptions: _2 } = D2, { composed: W2 } = N2, { addEvent: I3, defined: X2, extend: V2, isNumber: A3, merge: k3, pick: S2, pushUnique: H2 } = Y2, m3 = [];
      function E2() {
        let u2, p2, C3 = this.range, n4 = C3.type, a2 = this.max, o2 = this.chart.time, e5 = function(t3, i5) {
          let s2 = n4 === "year" ? "FullYear" : "Month", l4 = new o2.Date(t3), h2 = o2.get(s2, l4);
          return o2.set(s2, l4, h2 + i5), h2 === o2.get(s2, l4) && o2.set("Date", l4, 0), l4.getTime() - t3;
        };
        A3(C3) ? (u2 = a2 - C3, p2 = C3) : C3 && (u2 = a2 + e5(a2, -(C3.count || 1)), this.chart && this.chart.setFixedRange(a2 - u2));
        let r3 = S2(this.dataMin, Number.MIN_VALUE);
        return A3(u2) || (u2 = r3), u2 <= r3 && (u2 = r3, p2 === void 0 && (p2 = e5(u2, C3.count)), this.newMax = Math.min(u2 + p2, S2(this.dataMax, Number.MAX_VALUE))), A3(a2) ? !A3(C3) && C3 && C3._offsetMin && (u2 += C3._offsetMin) : u2 = void 0, u2;
      }
      function B3() {
        this.options.rangeSelector && this.options.rangeSelector.enabled && (this.rangeSelector = new Z2(this));
      }
      function g2() {
        let u2 = this.rangeSelector;
        if (u2) {
          A3(u2.deferredYTDClick) && (u2.clickButton(u2.deferredYTDClick), delete u2.deferredYTDClick);
          let p2 = u2.options.verticalAlign;
          u2.options.floating || (p2 === "bottom" ? this.extraBottomMargin = true : p2 === "middle" || (this.extraTopMargin = true));
        }
      }
      function w2() {
        let u2, p2 = this.rangeSelector;
        if (!p2) return;
        let C3 = this.xAxis[0].getExtremes(), n4 = this.legend, a2 = p2 && p2.options.verticalAlign;
        A3(C3.min) && p2.render(C3.min, C3.max), n4.display && a2 === "top" && a2 === n4.options.verticalAlign && (u2 = k3(this.spacingBox), n4.options.layout === "vertical" ? u2.y = this.plotTop : u2.y += p2.getHeight(), n4.group.placed = false, n4.align(u2));
      }
      function v3() {
        for (let u2 = 0, p2 = m3.length; u2 < p2; ++u2) {
          let C3 = m3[u2];
          if (C3[0] === this) {
            C3[1].forEach((n4) => n4()), m3.splice(u2, 1);
            return;
          }
        }
      }
      function x2() {
        let u2 = this.rangeSelector;
        if (u2) {
          let p2 = u2.getHeight();
          this.extraTopMargin && (this.plotTop += p2), this.extraBottomMargin && (this.marginBottom += p2);
        }
      }
      function G2(u2) {
        let p2 = u2.options.rangeSelector, C3 = this.extraBottomMargin, n4 = this.extraTopMargin, a2 = this.rangeSelector;
        if (p2 && p2.enabled && !X2(a2) && this.options.rangeSelector && (this.options.rangeSelector.enabled = true, this.rangeSelector = a2 = new Z2(this)), this.extraBottomMargin = false, this.extraTopMargin = false, a2) {
          let o2 = p2 && p2.verticalAlign || a2.options && a2.options.verticalAlign;
          a2.options.floating || (o2 === "bottom" ? this.extraBottomMargin = true : o2 === "middle" || (this.extraTopMargin = true)), (this.extraBottomMargin !== C3 || this.extraTopMargin !== n4) && (this.isDirtyBox = true);
        }
      }
      return { compose: function(u2, p2, C3) {
        if (Z2 = C3, H2(W2, "RangeSelector")) {
          let n4 = p2.prototype;
          u2.prototype.minFromRange = E2, I3(p2, "afterGetContainer", B3), I3(p2, "beforeRender", g2), I3(p2, "destroy", v3), I3(p2, "getMargins", x2), I3(p2, "redraw", w2), I3(p2, "update", G2), n4.callbacks.push(w2), V2(_2, { rangeSelector: F2.rangeSelector }), V2(_2.lang, F2.lang);
        }
      } };
    }), $2(f2, "Stock/RangeSelector/RangeSelector.js", [f2["Core/Axis/Axis.js"], f2["Core/Defaults.js"], f2["Core/Globals.js"], f2["Stock/RangeSelector/RangeSelectorComposition.js"], f2["Core/Renderer/SVG/SVGElement.js"], f2["Core/Utilities.js"], f2["Core/Axis/OrdinalAxis.js"]], function(D2, N2, F2, Y2, Z2, _2, W2) {
      let { defaultOptions: I3 } = N2, { addEvent: X2, createElement: V2, css: A3, defined: k3, destroyObjectProperties: S2, discardElement: H2, extend: m3, fireEvent: E2, isNumber: B3, merge: g2, objectEach: w2, pad: v3, pick: x2, pInt: G2, splat: u2 } = _2;
      class p2 {
        static compose(n4, a2) {
          Y2.compose(n4, a2, p2);
        }
        constructor(n4) {
          this.buttonOptions = p2.prototype.defaultButtons, this.initialButtonGroupWidth = 0, this.init(n4);
        }
        clickButton(n4, a2) {
          let o2 = this.chart, e5 = this.buttonOptions[n4], r3 = o2.xAxis[0], t3 = o2.scroller && o2.scroller.getUnionExtremes() || r3 || {}, i5 = e5.type, s2 = e5.dataGrouping, l4 = t3.dataMin, h2 = t3.dataMax, d3, c4 = r3 && Math.round(Math.min(r3.max, x2(h2, r3.max))), b5, y2 = e5._range, M2, P2, j3, L2 = true;
          if (l4 !== null && h2 !== null) {
            if (this.setSelected(n4), s2 && (this.forcedDataGrouping = true, D2.prototype.setDataGrouping.call(r3 || { chart: this.chart }, s2, false), this.frozenStates = e5.preserveDataGrouping), i5 === "month" || i5 === "year") r3 ? (P2 = { range: e5, max: c4, chart: o2, dataMin: l4, dataMax: h2 }, d3 = r3.minFromRange.call(P2), B3(P2.newMax) && (c4 = P2.newMax), L2 = false) : y2 = e5;
            else if (y2) c4 = Math.min((d3 = Math.max(c4 - y2, l4)) + y2, h2), L2 = false;
            else if (i5 === "ytd")
              if (r3) (h2 === void 0 || l4 === void 0) && (l4 = Number.MAX_VALUE, h2 = Number.MIN_VALUE, o2.series.forEach((T2) => {
                let O3 = T2.xData;
                O3 && (l4 = Math.min(O3[0], l4), h2 = Math.max(O3[O3.length - 1], h2));
              }), a2 = false), d3 = M2 = (j3 = this.getYTDExtremes(h2, l4, o2.time.useUTC)).min, c4 = j3.max;
              else {
                this.deferredYTDClick = n4;
                return;
              }
            else i5 === "all" && r3 && (o2.navigator && o2.navigator.baseSeries[0] && (o2.navigator.baseSeries[0].xAxis.options.range = void 0), d3 = l4, c4 = h2);
            if (L2 && e5._offsetMin && k3(d3) && (d3 += e5._offsetMin), e5._offsetMax && k3(c4) && (c4 += e5._offsetMax), this.dropdown && (this.dropdown.selectedIndex = n4 + 1), r3) r3.setExtremes(d3, c4, x2(a2, true), void 0, { trigger: "rangeSelectorButton", rangeSelectorButton: e5 }), o2.setFixedRange(e5._range);
            else {
              b5 = u2(o2.options.xAxis)[0];
              let T2 = X2(o2, "afterGetAxes", function() {
                let O3 = o2.xAxis[0];
                O3.range = O3.options.range = y2, O3.min = O3.options.min = M2;
              });
              X2(o2, "load", function() {
                let O3 = o2.xAxis[0];
                o2.setFixedRange(e5._range), O3.options.range = b5.range, O3.options.min = b5.min, T2();
              });
            }
            E2(this, "afterBtnClick");
          }
        }
        setSelected(n4) {
          this.selected = this.options.selected = n4;
        }
        init(n4) {
          let a2 = this, o2 = n4.options.rangeSelector, e5 = o2.buttons || a2.defaultButtons.slice(), r3 = o2.selected, t3 = function() {
            let i5 = a2.minInput, s2 = a2.maxInput;
            i5 && i5.blur && E2(i5, "blur"), s2 && s2.blur && E2(s2, "blur");
          };
          a2.chart = n4, a2.options = o2, a2.buttons = [], a2.buttonOptions = e5, this.eventsToUnbind = [], this.eventsToUnbind.push(X2(n4.container, "mousedown", t3)), this.eventsToUnbind.push(X2(n4, "resize", t3)), e5.forEach(a2.computeButtonRange), r3 !== void 0 && e5[r3] && this.clickButton(r3, false), this.eventsToUnbind.push(X2(n4, "load", function() {
            n4.xAxis && n4.xAxis[0] && X2(n4.xAxis[0], "setExtremes", function(i5) {
              B3(this.max) && B3(this.min) && this.max - this.min !== n4.fixedRange && i5.trigger !== "rangeSelectorButton" && i5.trigger !== "updatedData" && a2.forcedDataGrouping && !a2.frozenStates && this.setDataGrouping(false, false);
            });
          })), this.createElements();
        }
        updateButtonStates() {
          let n4 = this, a2 = this.chart, o2 = this.dropdown, e5 = this.dropdownLabel, r3 = a2.xAxis[0], t3 = Math.round(r3.max - r3.min), i5 = !r3.hasVisibleSeries, s2 = 24 * 36e5, l4 = a2.scroller && a2.scroller.getUnionExtremes() || r3, h2 = l4.dataMin, d3 = l4.dataMax, c4 = n4.getYTDExtremes(d3, h2, a2.time.useUTC), b5 = c4.min, y2 = c4.max, M2 = n4.selected, P2 = n4.options.allButtonsEnabled, j3 = Array(n4.buttonOptions.length).fill(0), L2 = B3(M2), T2 = n4.buttons, O3 = false, R2 = null;
          n4.buttonOptions.forEach((z2, U2) => {
            var Q2;
            let K2 = z2._range, q2 = z2.type, tt2 = z2.count || 1, J2 = z2._offsetMax - z2._offsetMin, et2 = U2 === M2, ot2 = K2 > d3 - h2, it2 = K2 < r3.minRange, lt2 = false, nt2 = K2 === t3;
            if (et2 && ot2 && (O3 = true), r3.isOrdinal && ((Q2 = r3.ordinal) == null ? void 0 : Q2.positions) && K2 && t3 < K2) {
              let rt2 = r3.ordinal.positions, at2 = W2.Additions.findIndexOf(rt2, r3.min, true), pt2 = Math.min(W2.Additions.findIndexOf(rt2, r3.max, true) + 1, rt2.length - 1);
              rt2[pt2] - rt2[at2] > K2 && (nt2 = true);
            } else (q2 === "month" || q2 === "year") && t3 + 36e5 >= { month: 28, year: 365 }[q2] * s2 * tt2 - J2 && t3 - 36e5 <= { month: 31, year: 366 }[q2] * s2 * tt2 + J2 ? nt2 = true : q2 === "ytd" ? (nt2 = y2 - b5 + J2 === t3, lt2 = !et2) : q2 === "all" && (nt2 = r3.max - r3.min >= d3 - h2);
            let ut2 = !P2 && !(O3 && q2 === "all") && (ot2 || it2 || i5), ht2 = O3 && q2 === "all" || !lt2 && nt2 || et2 && n4.frozenStates;
            ut2 ? j3[U2] = 3 : ht2 && (!L2 || U2 === M2) && (R2 = U2);
          }), R2 !== null ? (j3[R2] = 2, n4.setSelected(R2)) : (n4.setSelected(), e5 && (e5.setState(0), e5.attr({ text: (I3.lang.rangeSelectorZoom || "") + " ▾" })));
          for (let z2 = 0; z2 < j3.length; z2++) {
            let U2 = j3[z2], Q2 = T2[z2];
            if (Q2.state !== U2 && (Q2.setState(U2), o2)) {
              o2.options[z2 + 1].disabled = U2 === 3, U2 === 2 && (e5 && (e5.setState(2), e5.attr({ text: n4.buttonOptions[z2].text + " ▾" })), o2.selectedIndex = z2 + 1);
              let K2 = e5.getBBox();
              A3(o2, { width: `${K2.width}px`, height: `${K2.height}px` });
            }
          }
        }
        computeButtonRange(n4) {
          let a2 = n4.type, o2 = n4.count || 1, e5 = { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5 };
          e5[a2] ? n4._range = e5[a2] * o2 : (a2 === "month" || a2 === "year") && (n4._range = 24 * { month: 30, year: 365 }[a2] * 36e5 * o2), n4._offsetMin = x2(n4.offsetMin, 0), n4._offsetMax = x2(n4.offsetMax, 0), n4._range += n4._offsetMax - n4._offsetMin;
        }
        getInputValue(n4) {
          let a2 = n4 === "min" ? this.minInput : this.maxInput, o2 = this.chart.options.rangeSelector, e5 = this.chart.time;
          return a2 ? (a2.type === "text" && o2.inputDateParser || this.defaultInputDateParser)(a2.value, e5.useUTC, e5) : 0;
        }
        setInputValue(n4, a2) {
          let o2 = this.options, e5 = this.chart.time, r3 = n4 === "min" ? this.minInput : this.maxInput, t3 = n4 === "min" ? this.minDateBox : this.maxDateBox;
          if (r3) {
            let i5 = r3.getAttribute("data-hc-time"), s2 = k3(i5) ? Number(i5) : void 0;
            if (k3(a2)) {
              let l4 = s2;
              k3(l4) && r3.setAttribute("data-hc-time-previous", l4), r3.setAttribute("data-hc-time", a2), s2 = a2;
            }
            r3.value = e5.dateFormat(this.inputTypeFormats[r3.type] || o2.inputEditDateFormat, s2), t3 && t3.attr({ text: e5.dateFormat(o2.inputDateFormat, s2) });
          }
        }
        setInputExtremes(n4, a2, o2) {
          let e5 = n4 === "min" ? this.minInput : this.maxInput;
          if (e5) {
            let r3 = this.inputTypeFormats[e5.type], t3 = this.chart.time;
            if (r3) {
              let i5 = t3.dateFormat(r3, a2);
              e5.min !== i5 && (e5.min = i5);
              let s2 = t3.dateFormat(r3, o2);
              e5.max !== s2 && (e5.max = s2);
            }
          }
        }
        showInput(n4) {
          let a2 = n4 === "min" ? this.minDateBox : this.maxDateBox, o2 = n4 === "min" ? this.minInput : this.maxInput;
          if (o2 && a2 && this.inputGroup) {
            let e5 = o2.type === "text", { translateX: r3 = 0, translateY: t3 = 0 } = this.inputGroup, { x: i5 = 0, width: s2 = 0, height: l4 = 0 } = a2, { inputBoxWidth: h2 } = this.options;
            A3(o2, { width: e5 ? s2 + (h2 ? -2 : 20) + "px" : "auto", height: l4 - 2 + "px", border: "2px solid silver" }), e5 && h2 ? A3(o2, { left: r3 + i5 + "px", top: t3 + "px" }) : A3(o2, { left: Math.min(Math.round(i5 + r3 - (o2.offsetWidth - s2) / 2), this.chart.chartWidth - o2.offsetWidth) + "px", top: t3 - (o2.offsetHeight - l4) / 2 + "px" });
          }
        }
        hideInput(n4) {
          let a2 = n4 === "min" ? this.minInput : this.maxInput;
          a2 && A3(a2, { top: "-9999em", border: 0, width: "1px", height: "1px" });
        }
        defaultInputDateParser(n4, a2, o2) {
          let e5 = n4.split("/").join("-").split(" ").join("T");
          if (e5.indexOf("T") === -1 && (e5 += "T00:00"), a2) e5 += "Z";
          else {
            let t3;
            if (F2.isSafari && !((t3 = e5).length > 6 && (t3.lastIndexOf("-") === t3.length - 6 || t3.lastIndexOf("+") === t3.length - 6))) {
              let i5 = new Date(e5).getTimezoneOffset() / 60;
              e5 += i5 <= 0 ? `+${v3(-i5)}:00` : `-${v3(i5)}:00`;
            }
          }
          let r3 = Date.parse(e5);
          if (!B3(r3)) {
            let t3 = n4.split("-");
            r3 = Date.UTC(G2(t3[0]), G2(t3[1]) - 1, G2(t3[2]));
          }
          return o2 && a2 && B3(r3) && (r3 += o2.getTimezoneOffset(r3)), r3;
        }
        drawInput(n4) {
          let { chart: a2, div: o2, inputGroup: e5 } = this, r3 = this, t3 = a2.renderer.style || {}, i5 = a2.renderer, s2 = a2.options.rangeSelector, l4 = I3.lang, h2 = n4 === "min";
          function d3(j3) {
            var L2;
            let { maxInput: T2, minInput: O3 } = r3, R2 = a2.xAxis[0], z2 = ((L2 = a2.scroller) == null ? void 0 : L2.getUnionExtremes()) || R2, U2 = z2.dataMin, Q2 = z2.dataMax, K2 = a2.xAxis[0].getExtremes()[j3], q2 = r3.getInputValue(j3);
            B3(q2) && q2 !== K2 && (h2 && T2 && B3(U2) ? q2 > Number(T2.getAttribute("data-hc-time")) ? q2 = void 0 : q2 < U2 && (q2 = U2) : O3 && B3(Q2) && (q2 < Number(O3.getAttribute("data-hc-time")) ? q2 = void 0 : q2 > Q2 && (q2 = Q2)), q2 !== void 0 && R2.setExtremes(h2 ? q2 : R2.min, h2 ? R2.max : q2, void 0, void 0, { trigger: "rangeSelectorInput" }));
          }
          let c4 = l4[h2 ? "rangeSelectorFrom" : "rangeSelectorTo"] || "", b5 = i5.label(c4, 0).addClass("highcharts-range-label").attr({ padding: c4 ? 2 : 0, height: c4 ? s2.inputBoxHeight : 0 }).add(e5), y2 = i5.label("", 0).addClass("highcharts-range-input").attr({ padding: 2, width: s2.inputBoxWidth, height: s2.inputBoxHeight, "text-align": "center" }).on("click", function() {
            r3.showInput(n4), r3[n4 + "Input"].focus();
          });
          a2.styledMode || y2.attr({ stroke: s2.inputBoxBorderColor, "stroke-width": 1 }), y2.add(e5);
          let M2 = V2("input", { name: n4, className: "highcharts-range-selector" }, void 0, o2);
          M2.setAttribute("type", function(j3) {
            if (j3.indexOf("%L") !== -1) return "text";
            let L2 = ["a", "A", "d", "e", "w", "b", "B", "m", "o", "y", "Y"].some((O3) => j3.indexOf("%" + O3) !== -1), T2 = ["H", "k", "I", "l", "M", "S"].some((O3) => j3.indexOf("%" + O3) !== -1);
            return L2 && T2 ? "datetime-local" : L2 ? "date" : T2 ? "time" : "text";
          }(s2.inputDateFormat || "%e %b %Y")), a2.styledMode || (b5.css(g2(t3, s2.labelStyle)), y2.css(g2({ color: "#333333" }, t3, s2.inputStyle)), A3(M2, m3({ position: "absolute", border: 0, boxShadow: "0 0 15px rgba(0,0,0,0.3)", width: "1px", height: "1px", padding: 0, textAlign: "center", fontSize: t3.fontSize, fontFamily: t3.fontFamily, top: "-9999em" }, s2.inputStyle))), M2.onfocus = () => {
            r3.showInput(n4);
          }, M2.onblur = () => {
            M2 === F2.doc.activeElement && d3(n4), r3.hideInput(n4), r3.setInputValue(n4), M2.blur();
          };
          let P2 = false;
          return M2.onchange = () => {
            P2 || (d3(n4), r3.hideInput(n4), M2.blur());
          }, M2.onkeypress = (j3) => {
            j3.keyCode === 13 && d3(n4);
          }, M2.onkeydown = (j3) => {
            P2 = true, (j3.key === "ArrowUp" || j3.key === "ArrowDown" || j3.key === "Tab") && d3(n4);
          }, M2.onkeyup = () => {
            P2 = false;
          }, { dateBox: y2, input: M2, label: b5 };
        }
        getPosition() {
          let n4 = this.chart, a2 = n4.options.rangeSelector, o2 = a2.verticalAlign === "top" ? n4.plotTop - n4.axisOffset[0] : 0;
          return { buttonTop: o2 + a2.buttonPosition.y, inputTop: o2 + a2.inputPosition.y - 10 };
        }
        getYTDExtremes(n4, a2, o2) {
          let e5 = this.chart.time, r3 = new e5.Date(n4), t3 = e5.get("FullYear", r3), i5 = Math.max(a2, o2 ? e5.Date.UTC(t3, 0, 1) : +new e5.Date(t3, 0, 1)), s2 = r3.getTime();
          return { max: Math.min(n4 || s2, s2), min: i5 };
        }
        createElements() {
          var n4;
          let a2 = this.chart, o2 = a2.renderer, e5 = a2.container, r3 = a2.options, t3 = r3.rangeSelector, i5 = t3.inputEnabled, s2 = x2((n4 = r3.chart.style) == null ? void 0 : n4.zIndex, 0) + 1;
          if (t3.enabled !== false && (this.group = o2.g("range-selector-group").attr({ zIndex: 7 }).add(), this.div = V2("div", void 0, { position: "relative", height: 0, zIndex: s2 }), this.buttonOptions.length && this.renderButtons(), e5.parentNode && e5.parentNode.insertBefore(this.div, e5), i5)) {
            this.inputGroup = o2.g("input-group").add(this.group);
            let l4 = this.drawInput("min");
            this.minDateBox = l4.dateBox, this.minLabel = l4.label, this.minInput = l4.input;
            let h2 = this.drawInput("max");
            this.maxDateBox = h2.dateBox, this.maxLabel = h2.label, this.maxInput = h2.input;
          }
        }
        render(n4, a2) {
          let o2 = this.chart, e5 = o2.options.rangeSelector, r3 = e5.inputEnabled;
          if (e5.enabled !== false) {
            if (r3) {
              this.setInputValue("min", n4), this.setInputValue("max", a2);
              let t3 = o2.scroller && o2.scroller.getUnionExtremes() || o2.xAxis[0] || {};
              if (k3(t3.dataMin) && k3(t3.dataMax)) {
                let i5 = o2.xAxis[0].minRange || 0;
                this.setInputExtremes("min", t3.dataMin, Math.min(t3.dataMax, this.getInputValue("max")) - i5), this.setInputExtremes("max", Math.max(t3.dataMin, this.getInputValue("min")) + i5, t3.dataMax);
              }
              if (this.inputGroup) {
                let i5 = 0;
                [this.minLabel, this.minDateBox, this.maxLabel, this.maxDateBox].forEach((s2) => {
                  if (s2) {
                    let { width: l4 } = s2.getBBox();
                    l4 && (s2.attr({ x: i5 }), i5 += l4 + e5.inputSpacing);
                  }
                });
              }
            }
            this.alignElements(), this.updateButtonStates();
          }
        }
        renderButtons() {
          var n4;
          let { buttons: a2, chart: o2, options: e5 } = this, r3 = I3.lang, t3 = o2.renderer, i5 = g2(e5.buttonTheme), s2 = i5 && i5.states, l4 = i5.width || 28;
          delete i5.width, delete i5.states, this.buttonGroup = t3.g("range-selector-buttons").add(this.group);
          let h2 = this.dropdown = V2("select", void 0, { position: "absolute", padding: 0, border: 0, cursor: "pointer", opacity: 1e-4 }, this.div), d3 = (n4 = o2.userOptions.rangeSelector) == null ? void 0 : n4.buttonTheme;
          this.dropdownLabel = t3.button("", 0, 0, () => {
          }, g2(i5, { "stroke-width": x2(i5["stroke-width"], 0), width: "auto", paddingLeft: x2(e5.buttonTheme.paddingLeft, d3 == null ? void 0 : d3.padding, 8), paddingRight: x2(e5.buttonTheme.paddingRight, d3 == null ? void 0 : d3.padding, 8) }), s2 && s2.hover, s2 && s2.select, s2 && s2.disabled).hide().add(this.group), X2(h2, "touchstart", () => {
            h2.style.fontSize = "16px";
          });
          let c4 = F2.isMS ? "mouseover" : "mouseenter", b5 = F2.isMS ? "mouseout" : "mouseleave";
          X2(h2, c4, () => {
            E2(this.dropdownLabel.element, c4);
          }), X2(h2, b5, () => {
            E2(this.dropdownLabel.element, b5);
          }), X2(h2, "change", () => {
            E2(this.buttons[h2.selectedIndex - 1].element, "click");
          }), this.zoomText = t3.label(r3.rangeSelectorZoom || "", 0).attr({ padding: e5.buttonTheme.padding, height: e5.buttonTheme.height, paddingLeft: 0, paddingRight: 0 }).add(this.buttonGroup), this.chart.styledMode || (this.zoomText.css(e5.labelStyle), i5["stroke-width"] = x2(i5["stroke-width"], 0)), V2("option", { textContent: this.zoomText.textStr, disabled: true }, void 0, h2), this.buttonOptions.forEach((y2, M2) => {
            V2("option", { textContent: y2.title || y2.text }, void 0, h2), a2[M2] = t3.button(y2.text, 0, 0, (P2) => {
              let j3, L2 = y2.events && y2.events.click;
              L2 && (j3 = L2.call(y2, P2)), j3 !== false && this.clickButton(M2), this.isActive = true;
            }, i5, s2 && s2.hover, s2 && s2.select, s2 && s2.disabled).attr({ "text-align": "center", width: l4 }).add(this.buttonGroup), y2.title && a2[M2].attr("title", y2.title);
          });
        }
        alignElements() {
          var n4;
          let { buttonGroup: a2, buttons: o2, chart: e5, group: r3, inputGroup: t3, options: i5, zoomText: s2 } = this, l4 = e5.options, h2 = l4.exporting && l4.exporting.enabled !== false && l4.navigation && l4.navigation.buttonOptions, { buttonPosition: d3, inputPosition: c4, verticalAlign: b5 } = i5, y2 = (P2, j3) => h2 && this.titleCollision(e5) && b5 === "top" && j3.align === "right" && j3.y - P2.getBBox().height - 12 < (h2.y || 0) + (h2.height || 0) + e5.spacing[0] ? -40 : 0, M2 = e5.plotLeft;
          if (r3 && d3 && c4) {
            let P2 = d3.x - e5.spacing[3];
            if (a2) {
              if (this.positionButtons(), !this.initialButtonGroupWidth) {
                let K2 = 0;
                s2 && (K2 += s2.getBBox().width + 5), o2.forEach((q2, tt2) => {
                  K2 += q2.width || 0, tt2 !== o2.length - 1 && (K2 += i5.buttonSpacing);
                }), this.initialButtonGroupWidth = K2;
              }
              M2 -= e5.spacing[3];
              let Q2 = y2(a2, d3);
              this.alignButtonGroup(Q2), (n4 = this.buttonGroup) != null && n4.translateY && this.dropdownLabel.attr({ y: this.buttonGroup.translateY }), r3.placed = a2.placed = e5.hasLoaded;
            }
            let j3 = 0;
            t3 && (j3 = y2(t3, c4), c4.align === "left" ? P2 = M2 : c4.align === "right" && (P2 = -Math.max(e5.axisOffset[1], -j3)), t3.align({ y: c4.y, width: t3.getBBox().width, align: c4.align, x: c4.x + P2 - 2 }, true, e5.spacingBox), t3.placed = e5.hasLoaded), this.handleCollision(j3), r3.align({ verticalAlign: b5 }, true, e5.spacingBox);
            let L2 = r3.alignAttr.translateY, T2 = r3.getBBox().height + 20, O3 = 0;
            if (b5 === "bottom") {
              let Q2 = e5.legend && e5.legend.options;
              O3 = L2 - (T2 = T2 + (Q2 && Q2.verticalAlign === "bottom" && Q2.enabled && !Q2.floating ? e5.legend.legendHeight + x2(Q2.margin, 10) : 0) - 20) - (i5.floating ? 0 : i5.y) - (e5.titleOffset ? e5.titleOffset[2] : 0) - 10;
            }
            b5 === "top" ? (i5.floating && (O3 = 0), e5.titleOffset && e5.titleOffset[0] && (O3 = e5.titleOffset[0]), O3 += e5.margin[0] - e5.spacing[0] || 0) : b5 === "middle" && (c4.y === d3.y ? O3 = L2 : (c4.y || d3.y) && (c4.y < 0 || d3.y < 0 ? O3 -= Math.min(c4.y, d3.y) : O3 = L2 - T2)), r3.translate(i5.x, i5.y + Math.floor(O3));
            let { minInput: R2, maxInput: z2, dropdown: U2 } = this;
            i5.inputEnabled && R2 && z2 && (R2.style.marginTop = r3.translateY + "px", z2.style.marginTop = r3.translateY + "px"), U2 && (U2.style.marginTop = r3.translateY + "px");
          }
        }
        alignButtonGroup(n4, a2) {
          let { chart: o2, options: e5, buttonGroup: r3 } = this, { buttonPosition: t3 } = e5, i5 = o2.plotLeft - o2.spacing[3], s2 = t3.x - o2.spacing[3];
          t3.align === "right" ? s2 += n4 - i5 : t3.align === "center" && (s2 -= i5 / 2), r3 && r3.align({ y: t3.y, width: x2(a2, this.initialButtonGroupWidth), align: t3.align, x: s2 }, true, o2.spacingBox);
        }
        positionButtons() {
          let { buttons: n4, chart: a2, options: o2, zoomText: e5 } = this, r3 = a2.hasLoaded ? "animate" : "attr", { buttonPosition: t3 } = o2, i5 = a2.plotLeft, s2 = i5;
          e5 && e5.visibility !== "hidden" && (e5[r3]({ x: x2(i5 + t3.x, i5) }), s2 += t3.x + e5.getBBox().width + 5);
          for (let l4 = 0, h2 = this.buttonOptions.length; l4 < h2; ++l4) n4[l4].visibility !== "hidden" ? (n4[l4][r3]({ x: s2 }), s2 += (n4[l4].width || 0) + o2.buttonSpacing) : n4[l4][r3]({ x: i5 });
        }
        handleCollision(n4) {
          let { chart: a2, buttonGroup: o2, inputGroup: e5 } = this, { buttonPosition: r3, dropdown: t3, inputPosition: i5 } = this.options, s2 = () => {
            let d3 = 0;
            return this.buttons.forEach((c4) => {
              let b5 = c4.getBBox();
              b5.width > d3 && (d3 = b5.width);
            }), d3;
          }, l4 = (d3) => {
            if (e5 != null && e5.alignOptions && o2) {
              let c4 = e5.alignAttr.translateX + e5.alignOptions.x - n4 + e5.getBBox().x + 2, b5 = e5.alignOptions.width || 0, y2 = o2.alignAttr.translateX + o2.getBBox().x;
              return y2 + d3 > c4 && c4 + b5 > y2 && r3.y < i5.y + e5.getBBox().height;
            }
            return false;
          }, h2 = () => {
            e5 && o2 && e5.attr({ translateX: e5.alignAttr.translateX + (a2.axisOffset[1] >= -n4 ? 0 : -n4), translateY: e5.alignAttr.translateY + o2.getBBox().height + 10 });
          };
          if (o2) {
            if (t3 === "always") {
              this.collapseButtons(), l4(s2()) && h2();
              return;
            }
            t3 === "never" && this.expandButtons();
          }
          e5 && o2 ? i5.align === r3.align || l4(this.initialButtonGroupWidth + 20) ? t3 === "responsive" ? (this.collapseButtons(), l4(s2()) && h2()) : h2() : t3 === "responsive" && this.expandButtons() : o2 && t3 === "responsive" && (this.initialButtonGroupWidth > a2.plotWidth ? this.collapseButtons() : this.expandButtons());
        }
        collapseButtons() {
          let { buttons: n4, zoomText: a2 } = this;
          this.isCollapsed !== true && (this.isCollapsed = true, a2.hide(), n4.forEach((o2) => void o2.hide()), this.showDropdown());
        }
        expandButtons() {
          let { buttons: n4, zoomText: a2 } = this;
          this.isCollapsed !== false && (this.isCollapsed = false, this.hideDropdown(), a2.show(), n4.forEach((o2) => void o2.show()), this.positionButtons());
        }
        showDropdown() {
          let { buttonGroup: n4, chart: a2, dropdownLabel: o2, dropdown: e5 } = this;
          if (n4 && e5) {
            let { translateX: r3 = 0, translateY: t3 = 0 } = n4, i5 = a2.plotLeft + r3;
            o2.attr({ x: i5, y: t3 }).show(), A3(e5, { left: i5 + "px", top: t3 + "px", visibility: "inherit" }), this.hasVisibleDropdown = true;
          }
        }
        hideDropdown() {
          let { dropdown: n4 } = this;
          n4 && (this.dropdownLabel.hide(), A3(n4, { visibility: "hidden", width: "1px", height: "1px" }), this.hasVisibleDropdown = false);
        }
        getHeight() {
          let n4 = this.options, a2 = this.group, o2 = n4.inputPosition, e5 = n4.buttonPosition, r3 = n4.y, t3 = e5.y, i5 = o2.y, s2 = 0;
          if (n4.height) return n4.height;
          this.alignElements(), s2 = a2 ? a2.getBBox(true).height + 13 + r3 : 0;
          let l4 = Math.min(i5, t3);
          return (i5 < 0 && t3 < 0 || i5 > 0 && t3 > 0) && (s2 += Math.abs(l4)), s2;
        }
        titleCollision(n4) {
          return !(n4.options.title.text || n4.options.subtitle.text);
        }
        update(n4, a2 = true) {
          let o2 = this.chart;
          g2(true, o2.options.rangeSelector, n4), this.destroy(), this.init(o2), a2 && this.render();
        }
        destroy() {
          let n4 = this, a2 = n4.minInput, o2 = n4.maxInput;
          n4.eventsToUnbind && (n4.eventsToUnbind.forEach((e5) => e5()), n4.eventsToUnbind = void 0), S2(n4.buttons), a2 && (a2.onfocus = a2.onblur = a2.onchange = null), o2 && (o2.onfocus = o2.onblur = o2.onchange = null), w2(n4, function(e5, r3) {
            e5 && r3 !== "chart" && (e5 instanceof Z2 ? e5.destroy() : e5 instanceof window.HTMLElement && H2(e5)), e5 !== p2.prototype[r3] && (n4[r3] = null);
          }, this);
        }
      }
      return m3(p2.prototype, { defaultButtons: [{ type: "month", count: 1, text: "1m", title: "View 1 month" }, { type: "month", count: 3, text: "3m", title: "View 3 months" }, { type: "month", count: 6, text: "6m", title: "View 6 months" }, { type: "ytd", text: "YTD", title: "View year to date" }, { type: "year", count: 1, text: "1y", title: "View 1 year" }, { type: "all", text: "All", title: "View all" }], inputTypeFormats: { "datetime-local": "%Y-%m-%dT%H:%M:%S", date: "%Y-%m-%d", time: "%H:%M:%S" } }), p2;
    }), $2(f2, "Core/Chart/StockChart.js", [f2["Core/Chart/Chart.js"], f2["Core/Templating.js"], f2["Core/Defaults.js"], f2["Stock/Navigator/NavigatorDefaults.js"], f2["Stock/RangeSelector/RangeSelectorDefaults.js"], f2["Stock/Scrollbar/ScrollbarDefaults.js"], f2["Stock/Utilities/StockUtilities.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2, Z2, _2, W2, I3) {
      let { format: X2 } = N2, { getOptions: V2 } = F2, { setFixedRange: A3 } = W2, { addEvent: k3, clamp: S2, crisp: H2, defined: m3, extend: E2, find: B3, isNumber: g2, isString: w2, merge: v3, pick: x2, splat: G2 } = I3;
      function u2(n4, a2, o2) {
        var e5, r3, t3, i5;
        return n4 === "xAxis" ? { minPadding: 0, maxPadding: 0, overscroll: 0, ordinal: true } : n4 === "yAxis" ? { labels: { y: -2 }, opposite: (r3 = (e5 = o2.opposite) != null ? e5 : a2.opposite) != null ? r3 : true, showLastLabel: !!(a2.categories || a2.type === "category"), title: { text: ((t3 = o2.title) == null ? void 0 : t3.text) !== "Values" ? (i5 = o2.title) == null ? void 0 : i5.text : null } } : {};
      }
      function p2(n4, a2) {
        if (n4 === "xAxis") {
          let o2 = x2(a2.navigator && a2.navigator.enabled, Y2.enabled, true), e5 = { type: "datetime", categories: void 0 };
          return o2 && (e5.startOnTick = false, e5.endOnTick = false), e5;
        }
        return {};
      }
      class C3 extends D2 {
        init(a2, o2) {
          let e5 = V2(), r3 = a2.xAxis, t3 = a2.yAxis, i5 = x2(a2.navigator && a2.navigator.enabled, Y2.enabled, true);
          a2.xAxis = a2.yAxis = void 0;
          let s2 = v3({ chart: { panning: { enabled: true, type: "x" }, zooming: { pinchType: "x", mouseWheel: { type: "x" } } }, navigator: { enabled: i5 }, scrollbar: { enabled: x2(_2.enabled, true) }, rangeSelector: { enabled: x2(Z2.rangeSelector.enabled, true) }, title: { text: null }, tooltip: { split: x2(e5.tooltip && e5.tooltip.split, true), crosshairs: true }, legend: { enabled: false } }, a2, { isStock: true });
          a2.xAxis = r3, a2.yAxis = t3, s2.xAxis = G2(a2.xAxis || {}).map((l4) => v3(u2("xAxis", l4, e5.xAxis), l4, p2("xAxis", a2))), s2.yAxis = G2(a2.yAxis || {}).map((l4) => v3(u2("yAxis", l4, e5.yAxis), l4)), super.init(s2, o2);
        }
        createAxis(a2, o2) {
          return o2.axis = v3(u2(a2, o2.axis, V2()[a2]), o2.axis, p2(a2, this.userOptions)), super.createAxis(a2, o2);
        }
      }
      return k3(D2, "update", function(n4) {
        let a2 = n4.options;
        "scrollbar" in a2 && this.navigator && (v3(true, this.options.scrollbar, a2.scrollbar), this.navigator.update({ enabled: !!this.navigator.navigatorEnabled }), delete a2.scrollbar);
      }), function(n4) {
        function a2(h2) {
          if (!this.crosshair || !this.crosshair.label || !this.crosshair.label.enabled || !this.cross || !g2(this.min) || !g2(this.max)) return;
          let d3 = this.chart, c4 = this.logarithmic, b5 = this.crosshair.label, y2 = this.horiz, M2 = this.opposite, P2 = this.left, j3 = this.top, L2 = this.width, T2 = this.options.tickPosition === "inside", O3 = this.crosshair.snap !== false, R2 = h2.e || this.cross && this.cross.e, z2 = h2.point, U2 = this.crossLabel, Q2, K2, q2 = b5.format, tt2 = "", J2, et2 = 0, ot2 = this.min, it2 = this.max;
          c4 && (ot2 = c4.lin2log(this.min), it2 = c4.lin2log(this.max));
          let lt2 = y2 ? "center" : M2 ? this.labelAlign === "right" ? "right" : "left" : this.labelAlign === "left" ? "left" : "center";
          U2 || (U2 = this.crossLabel = d3.renderer.label("", 0, void 0, b5.shape || "callout").addClass("highcharts-crosshair-label highcharts-color-" + (z2 && z2.series ? z2.series.colorIndex : this.series[0] && this.series[0].colorIndex)).attr({ align: b5.align || lt2, padding: x2(b5.padding, 8), r: x2(b5.borderRadius, 3), zIndex: 2 }).add(this.labelGroup), d3.styledMode || U2.attr({ fill: b5.backgroundColor || z2 && z2.series && z2.series.color || "#666666", stroke: b5.borderColor || "", "stroke-width": b5.borderWidth || 0 }).css(E2({ color: "#ffffff", fontWeight: "normal", fontSize: "0.7em", textAlign: "center" }, b5.style || {}))), y2 ? (Q2 = O3 ? (z2.plotX || 0) + P2 : R2.chartX, K2 = j3 + (M2 ? 0 : this.height)) : (Q2 = P2 + this.offset + (M2 ? L2 : 0), K2 = O3 ? (z2.plotY || 0) + j3 : R2.chartY), q2 || b5.formatter || (this.dateTime && (tt2 = "%b %d, %Y"), q2 = "{value" + (tt2 ? ":" + tt2 : "") + "}");
          let nt2 = O3 ? this.isXAxis ? z2.x : z2.y : this.toValue(y2 ? R2.chartX : R2.chartY), ut2 = z2 && z2.series ? z2.series.isPointInside(z2) : g2(nt2) && nt2 > ot2 && nt2 < it2, ht2 = "";
          q2 ? ht2 = X2(q2, { value: nt2 }, d3) : b5.formatter && g2(nt2) && (ht2 = b5.formatter.call(this, nt2)), U2.attr({ text: ht2, x: Q2, y: K2, visibility: ut2 ? "inherit" : "hidden" });
          let rt2 = U2.getBBox();
          !g2(U2.x) || y2 || M2 || (Q2 = U2.x - rt2.width / 2), g2(U2.y) && (y2 ? (T2 && !M2 || !T2 && M2) && (K2 = U2.y - rt2.height) : K2 = U2.y - rt2.height / 2), J2 = y2 ? { left: P2, right: P2 + this.width } : { left: this.labelAlign === "left" ? P2 : 0, right: this.labelAlign === "right" ? P2 + this.width : d3.chartWidth };
          let at2 = U2.translateX || 0;
          at2 < J2.left && (et2 = J2.left - at2), at2 + rt2.width >= J2.right && (et2 = -(at2 + rt2.width - J2.right)), U2.attr({ x: Q2 + et2, y: K2, anchorX: y2 ? Q2 : this.opposite ? 0 : d3.chartWidth, anchorY: y2 ? this.opposite ? d3.chartHeight : 0 : K2 + rt2.height / 2 });
        }
        function o2() {
          this.crossLabel && (this.crossLabel = this.crossLabel.hide());
        }
        function e5(h2) {
          let d3 = this.chart, c4 = this.options, b5 = d3._labelPanes = d3._labelPanes || {}, y2 = c4.labels;
          if (d3.options.isStock && this.coll === "yAxis") {
            let M2 = c4.top + "," + c4.height;
            !b5[M2] && y2.enabled && (y2.distance === 15 && this.side === 1 && (y2.distance = 0), y2.align === void 0 && (y2.align = "right"), b5[M2] = this, h2.align = "right", h2.preventDefault());
          }
        }
        function r3() {
          let h2 = this.chart, d3 = this.options && this.options.top + "," + this.options.height;
          d3 && h2._labelPanes && h2._labelPanes[d3] === this && delete h2._labelPanes[d3];
        }
        function t3(h2) {
          let d3 = this, c4 = d3.isLinked && !d3.series && d3.linkedParent ? d3.linkedParent.series : d3.series, b5 = d3.chart, y2 = b5.renderer, M2 = d3.left, P2 = d3.top, j3 = [], L2 = h2.translatedValue, T2 = h2.value, O3 = h2.force, R2, z2, U2, Q2, K2 = [], q2, tt2;
          if (b5.options.isStock && h2.acrossPanes !== false && d3.coll === "xAxis" || d3.coll === "yAxis") {
            for (let J2 of (h2.preventDefault(), K2 = ((et2) => {
              let ot2 = et2 === "xAxis" ? "yAxis" : "xAxis", it2 = d3.options[ot2];
              return g2(it2) ? [b5[ot2][it2]] : w2(it2) ? [b5.get(it2)] : c4.map((lt2) => lt2[ot2]);
            })(d3.coll), d3.isXAxis ? b5.yAxis : b5.xAxis)) if (!J2.options.isInternal) {
              let et2 = J2.isXAxis ? "yAxis" : "xAxis";
              d3 === (m3(J2.options[et2]) ? b5[et2][J2.options[et2]] : b5[et2][0]) && K2.push(J2);
            }
            for (let J2 of (q2 = K2.length ? [] : [d3.isXAxis ? b5.yAxis[0] : b5.xAxis[0]], K2)) q2.indexOf(J2) !== -1 || B3(q2, (et2) => et2.pos === J2.pos && et2.len === J2.len) || q2.push(J2);
            if (g2(tt2 = x2(L2, d3.translate(T2 || 0, void 0, void 0, h2.old))))
              if (d3.horiz) for (let J2 of q2) {
                let et2;
                Q2 = (z2 = J2.pos) + J2.len, R2 = U2 = Math.round(tt2 + d3.transB), O3 !== "pass" && (R2 < M2 || R2 > M2 + d3.width) && (O3 ? R2 = U2 = S2(R2, M2, M2 + d3.width) : et2 = true), et2 || j3.push(["M", R2, z2], ["L", U2, Q2]);
              }
              else for (let J2 of q2) {
                let et2;
                U2 = (R2 = J2.pos) + J2.len, z2 = Q2 = Math.round(P2 + d3.height - tt2), O3 !== "pass" && (z2 < P2 || z2 > P2 + d3.height) && (O3 ? z2 = Q2 = S2(z2, P2, P2 + d3.height) : et2 = true), et2 || j3.push(["M", R2, z2], ["L", U2, Q2]);
              }
            h2.path = j3.length > 0 ? y2.crispPolyLine(j3, h2.lineWidth || 1) : void 0;
          }
        }
        function i5(h2) {
          if (this.chart.options.isStock) {
            let d3;
            this.is("column") || this.is("columnrange") ? d3 = { borderWidth: 0, shadow: false } : this.is("scatter") || this.is("sma") || (d3 = { marker: { enabled: false, radius: 2 } }), d3 && (h2.plotOptions[this.type] = v3(h2.plotOptions[this.type], d3));
          }
        }
        function s2() {
          let h2 = this.chart, d3 = this.options.dataGrouping;
          return this.allowDG !== false && d3 && x2(d3.enabled, h2.options.isStock);
        }
        function l4(h2, d3) {
          for (let c4 = 0; c4 < h2.length; c4 += 2) {
            let b5 = h2[c4], y2 = h2[c4 + 1];
            m3(b5[1]) && b5[1] === y2[1] && (b5[1] = y2[1] = H2(b5[1], d3)), m3(b5[2]) && b5[2] === y2[2] && (b5[2] = y2[2] = H2(b5[2], d3));
          }
          return h2;
        }
        n4.compose = function(h2, d3, c4, b5) {
          let y2 = c4.prototype;
          y2.forceCropping || (k3(d3, "afterDrawCrosshair", a2), k3(d3, "afterHideCrosshair", o2), k3(d3, "autoLabelAlign", e5), k3(d3, "destroy", r3), k3(d3, "getPlotLinePath", t3), h2.prototype.setFixedRange = A3, y2.forceCropping = s2, k3(c4, "setOptions", i5), b5.prototype.crispPolyLine = l4);
        }, n4.stockChart = function(h2, d3, c4) {
          return new n4(h2, d3, c4);
        };
      }(C3), C3;
    }), $2(f2, "Series/HLC/HLCPoint.js", [f2["Core/Series/SeriesRegistry.js"]], function(D2) {
      let { column: { prototype: { pointClass: N2 } } } = D2.seriesTypes;
      return class extends N2 {
      };
    }), $2(f2, "Series/HLC/HLCSeriesDefaults.js", [], function() {
      return { lineWidth: 1, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' }, threshold: null, states: { hover: { lineWidth: 3 } }, stickyTracking: true };
    }), $2(f2, "Series/HLC/HLCSeries.js", [f2["Series/HLC/HLCPoint.js"], f2["Series/HLC/HLCSeriesDefaults.js"], f2["Core/Series/SeriesRegistry.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2) {
      let { column: Z2 } = F2.seriesTypes, { crisp: _2, extend: W2, merge: I3 } = Y2;
      class X2 extends Z2 {
        extendStem(A3, k3, S2) {
          let H2 = A3[0], m3 = A3[1];
          typeof H2[2] == "number" && (H2[2] = Math.max(S2 + k3, H2[2])), typeof m3[2] == "number" && (m3[2] = Math.min(S2 - k3, m3[2]));
        }
        getPointPath(A3, k3) {
          let S2 = k3.strokeWidth(), H2 = A3.series, m3 = _2(A3.plotX || 0, S2), E2 = Math.round(A3.shapeArgs.width / 2), B3 = [["M", m3, Math.round(A3.yBottom)], ["L", m3, Math.round(A3.plotHigh)]];
          if (A3.close !== null) {
            let g2 = _2(A3.plotClose, S2);
            B3.push(["M", m3, g2], ["L", m3 + E2, g2]), H2.extendStem(B3, S2 / 2, g2);
          }
          return B3;
        }
        drawSinglePoint(A3) {
          let k3 = A3.series, S2 = k3.chart, H2, m3 = A3.graphic;
          A3.plotY !== void 0 && (m3 || (A3.graphic = m3 = S2.renderer.path().add(k3.group)), S2.styledMode || m3.attr(k3.pointAttribs(A3, A3.selected && "select")), H2 = k3.getPointPath(A3, m3), m3[m3 ? "animate" : "attr"]({ d: H2 }).addClass(A3.getClassName(), true));
        }
        drawPoints() {
          this.points.forEach(this.drawSinglePoint);
        }
        init() {
          super.init.apply(this, arguments), this.options.stacking = void 0;
        }
        pointAttribs(A3, k3) {
          let S2 = super.pointAttribs.call(this, A3, k3);
          return delete S2.fill, S2;
        }
        toYData(A3) {
          return [A3.high, A3.low, A3.close];
        }
        translate() {
          let A3 = this, k3 = A3.yAxis, S2 = this.pointArrayMap && this.pointArrayMap.slice() || [], H2 = S2.map((m3) => `plot${m3.charAt(0).toUpperCase() + m3.slice(1)}`);
          H2.push("yBottom"), S2.push("low"), super.translate.apply(A3), A3.points.forEach(function(m3) {
            S2.forEach(function(E2, B3) {
              let g2 = m3[E2];
              g2 !== null && (A3.dataModify && (g2 = A3.dataModify.modifyValue(g2)), m3[H2[B3]] = k3.toPixels(g2, true));
            }), m3.tooltipPos[1] = m3.plotHigh + k3.pos - A3.chart.plotTop;
          });
        }
      }
      return X2.defaultOptions = I3(Z2.defaultOptions, N2), W2(X2.prototype, { pointClass: D2, animate: null, directTouch: false, pointArrayMap: ["high", "low", "close"], pointAttrToOptions: { stroke: "color", "stroke-width": "lineWidth" }, pointValKey: "close" }), F2.registerSeriesType("hlc", X2), X2;
    }), $2(f2, "Series/OHLC/OHLCPoint.js", [f2["Core/Series/SeriesRegistry.js"]], function(D2) {
      let { seriesTypes: { hlc: N2 } } = D2;
      class F2 extends N2.prototype.pointClass {
        getClassName() {
          return super.getClassName.call(this) + (this.open < this.close ? " highcharts-point-up" : " highcharts-point-down");
        }
        resolveUpColor() {
          this.open < this.close && !this.options.color && this.series.options.upColor && (this.color = this.series.options.upColor);
        }
        resolveColor() {
          super.resolveColor(), this.series.is("heikinashi") || this.resolveUpColor();
        }
        getZone() {
          let Z2 = super.getZone();
          return this.resolveUpColor(), Z2;
        }
        applyOptions() {
          return super.applyOptions.apply(this, arguments), this.resolveColor && this.resolveColor(), this;
        }
      }
      return F2;
    }), $2(f2, "Series/OHLC/OHLCSeriesDefaults.js", [], function() {
      return { tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' } };
    }), $2(f2, "Series/OHLC/OHLCSeries.js", [f2["Core/Globals.js"], f2["Series/OHLC/OHLCPoint.js"], f2["Series/OHLC/OHLCSeriesDefaults.js"], f2["Core/Series/SeriesRegistry.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2, Z2) {
      let { composed: _2 } = D2, { hlc: W2 } = Y2.seriesTypes, { addEvent: I3, crisp: X2, extend: V2, merge: A3, pushUnique: k3 } = Z2;
      function S2(E2) {
        let B3 = E2.options, g2 = B3.dataGrouping;
        g2 && B3.useOhlcData && B3.id !== "highcharts-navigator-series" && (g2.approximation = "ohlc");
      }
      function H2(E2) {
        let B3 = E2.options;
        B3.useOhlcData && B3.id !== "highcharts-navigator-series" && V2(this, { pointValKey: m3.prototype.pointValKey, pointArrayMap: m3.prototype.pointArrayMap, toYData: m3.prototype.toYData });
      }
      class m3 extends W2 {
        static compose(B3, ...g2) {
          k3(_2, "OHLCSeries") && (I3(B3, "afterSetOptions", S2), I3(B3, "init", H2));
        }
        getPointPath(B3, g2) {
          let w2 = super.getPointPath(B3, g2), v3 = g2.strokeWidth(), x2 = X2(B3.plotX || 0, v3), G2 = Math.round(B3.shapeArgs.width / 2);
          if (B3.open !== null) {
            let u2 = X2(B3.plotOpen, v3);
            w2.push(["M", x2, u2], ["L", x2 - G2, u2]), super.extendStem(w2, v3 / 2, u2);
          }
          return w2;
        }
        pointAttribs(B3, g2) {
          let w2 = super.pointAttribs.call(this, B3, g2), v3 = this.options;
          return delete w2.fill, !B3.options.color && v3.upColor && B3.open < B3.close && (w2.stroke = v3.upColor), w2;
        }
        toYData(B3) {
          return [B3.open, B3.high, B3.low, B3.close];
        }
      }
      return m3.defaultOptions = A3(W2.defaultOptions, F2), V2(m3.prototype, { pointClass: N2, pointArrayMap: ["open", "high", "low", "close"] }), Y2.registerSeriesType("ohlc", m3), m3;
    }), $2(f2, "Series/Candlestick/CandlestickSeriesDefaults.js", [], function() {
      return { states: { hover: { lineWidth: 2 } }, threshold: null, lineColor: "#000000", lineWidth: 1, upColor: "#ffffff", stickyTracking: true };
    }), $2(f2, "Series/Candlestick/CandlestickSeries.js", [f2["Series/Candlestick/CandlestickSeriesDefaults.js"], f2["Core/Series/SeriesRegistry.js"], f2["Core/Utilities.js"]], function(D2, N2, F2) {
      let { column: Y2, ohlc: Z2 } = N2.seriesTypes, { crisp: _2, merge: W2 } = F2;
      class I3 extends Z2 {
        pointAttribs(V2, A3) {
          let k3 = Y2.prototype.pointAttribs.call(this, V2, A3), S2 = this.options, H2 = V2.open < V2.close, m3 = S2.lineColor || this.color, E2 = V2.color || this.color;
          if (k3["stroke-width"] = S2.lineWidth, k3.fill = V2.options.color || H2 && S2.upColor || E2, k3.stroke = V2.options.lineColor || H2 && S2.upLineColor || m3, A3) {
            let B3 = S2.states[A3];
            k3.fill = B3.color || k3.fill, k3.stroke = B3.lineColor || k3.stroke, k3["stroke-width"] = B3.lineWidth || k3["stroke-width"];
          }
          return k3;
        }
        drawPoints() {
          let V2 = this.points, A3 = this.chart, k3 = this.yAxis.reversed;
          for (let S2 of V2) {
            let H2 = S2.graphic, m3, E2, B3, g2, w2, v3, x2, G2, u2, p2 = !H2;
            if (S2.plotY !== void 0) {
              H2 || (S2.graphic = H2 = A3.renderer.path().add(this.group)), this.chart.styledMode || H2.attr(this.pointAttribs(S2, S2.selected && "select")).shadow(this.options.shadow);
              let C3 = H2.strokeWidth();
              x2 = _2(S2.plotX || 0, C3), B3 = Math.min(m3 = S2.plotOpen, E2 = S2.plotClose), g2 = Math.max(m3, E2), u2 = Math.round(S2.shapeArgs.width / 2), w2 = k3 ? g2 !== S2.yBottom : Math.round(B3) !== Math.round(S2.plotHigh || 0), v3 = k3 ? Math.round(B3) !== Math.round(S2.plotHigh || 0) : g2 !== S2.yBottom, B3 = _2(B3, C3), g2 = _2(g2, C3), (G2 = []).push(["M", x2 - u2, g2], ["L", x2 - u2, B3], ["L", x2 + u2, B3], ["L", x2 + u2, g2], ["Z"], ["M", x2, B3], ["L", x2, w2 ? Math.round(k3 ? S2.yBottom : S2.plotHigh) : B3], ["M", x2, g2], ["L", x2, v3 ? Math.round(k3 ? S2.plotHigh : S2.yBottom) : g2]), H2[p2 ? "attr" : "animate"]({ d: G2 }).addClass(S2.getClassName(), true);
            }
          }
        }
      }
      return I3.defaultOptions = W2(Z2.defaultOptions, { tooltip: Z2.defaultOptions.tooltip }, D2), N2.registerSeriesType("candlestick", I3), I3;
    }), $2(f2, "Series/Flags/FlagsPoint.js", [f2["Core/Series/SeriesRegistry.js"], f2["Core/Utilities.js"]], function(D2, N2) {
      let { column: { prototype: { pointClass: F2 } } } = D2.seriesTypes, { isNumber: Y2 } = N2;
      return class extends F2 {
        constructor() {
          super(...arguments), this.ttBelow = false;
        }
        isValid() {
          return Y2(this.y) || this.y === void 0;
        }
        hasNewShapeType() {
          let Z2 = this.options.shape || this.series.options.shape;
          return this.graphic && Z2 && Z2 !== this.graphic.symbolKey;
        }
      };
    }), $2(f2, "Series/Flags/FlagsSeriesDefaults.js", [], function() {
      return { borderRadius: 0, pointRange: 0, allowOverlapX: false, shape: "flag", stackDistance: 12, textAlign: "center", tooltip: { pointFormat: "{point.text}" }, threshold: null, y: -30, fillColor: "#ffffff", lineWidth: 1, states: { hover: { lineColor: "#000000", fillColor: "#ccd3ff" } }, style: { fontSize: "0.7em", fontWeight: "bold" } };
    }), $2(f2, "Series/Flags/FlagsSymbols.js", [f2["Core/Renderer/RendererRegistry.js"]], function(D2) {
      var N2;
      return function(F2) {
        let Y2 = [];
        function Z2(W2, I3, X2, V2, A3) {
          let k3 = A3 && A3.anchorX || W2, S2 = A3 && A3.anchorY || I3, H2 = this.circle(k3 - 1, S2 - 1, 2, 2);
          return H2.push(["M", k3, S2], ["L", W2, I3 + V2], ["L", W2, I3], ["L", W2 + X2, I3], ["L", W2 + X2, I3 + V2], ["L", W2, I3 + V2], ["Z"]), H2;
        }
        function _2(W2, I3) {
          W2[I3 + "pin"] = function(X2, V2, A3, k3, S2) {
            let H2, m3 = S2 && S2.anchorX, E2 = S2 && S2.anchorY;
            if (I3 === "circle" && k3 > A3 && (X2 -= Math.round((k3 - A3) / 2), A3 = k3), H2 = W2[I3](X2, V2, A3, k3, S2), m3 && E2) {
              let B3 = m3;
              if (I3 === "circle") B3 = X2 + A3 / 2;
              else {
                let w2 = H2[0], v3 = H2[1];
                w2[0] === "M" && v3[0] === "L" && (B3 = (w2[1] + v3[1]) / 2);
              }
              let g2 = V2 > E2 ? V2 : V2 + k3;
              H2.push(["M", B3, g2], ["L", m3, E2]), H2 = H2.concat(W2.circle(m3 - 1, E2 - 1, 2, 2));
            }
            return H2;
          };
        }
        F2.compose = function(W2) {
          if (Y2.indexOf(W2) === -1) {
            Y2.push(W2);
            let X2 = W2.prototype.symbols;
            X2.flag = Z2, _2(X2, "circle"), _2(X2, "square");
          }
          let I3 = D2.getRendererType();
          Y2.indexOf(I3) && Y2.push(I3);
        };
      }(N2 || (N2 = {})), N2;
    }), $2(f2, "Series/OnSeriesComposition.js", [f2["Series/Column/ColumnSeries.js"], f2["Core/Globals.js"], f2["Core/Series/Series.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2) {
      var Z2;
      let { composed: _2 } = N2, { prototype: W2 } = D2, { prototype: I3 } = F2, { defined: X2, pushUnique: V2, stableSort: A3 } = Y2;
      return function(k3) {
        function S2(m3) {
          return I3.getPlotBox.call(this.options.onSeries && this.chart.get(this.options.onSeries) || this, m3);
        }
        function H2() {
          var m3, E2;
          W2.translate.apply(this);
          let B3 = this, g2 = B3.options, w2 = B3.chart, v3 = B3.points, x2 = g2.onSeries, G2 = x2 && w2.get(x2), u2 = G2 && G2.options.step, p2 = G2 && G2.points, C3 = w2.inverted, n4 = B3.xAxis, a2 = B3.yAxis, o2 = v3.length - 1, e5, r3, t3 = g2.onKey || "y", i5 = p2 && p2.length, s2 = 0, l4, h2, d3, c4, b5;
          if (G2 && G2.visible && i5) {
            for (s2 = (G2.pointXOffset || 0) + (G2.barW || 0) / 2, c4 = G2.currentDataGrouping, h2 = p2[i5 - 1].x + (c4 ? c4.totalRange : 0), A3(v3, (y2, M2) => y2.x - M2.x), t3 = "plot" + t3[0].toUpperCase() + t3.substr(1); i5-- && v3[o2]; ) if (l4 = p2[i5], (e5 = v3[o2]).y = l4.y, l4.x <= e5.x && l4[t3] !== void 0) {
              if (e5.x <= h2 && (e5.plotY = l4[t3], l4.x < e5.x && !u2 && (d3 = p2[i5 + 1]) && d3[t3] !== void 0))
                if (X2(e5.plotX) && G2.is("spline")) {
                  let y2 = [l4.plotX || 0, l4.plotY || 0], M2 = [d3.plotX || 0, d3.plotY || 0], P2 = ((m3 = l4.controlPoints) == null ? void 0 : m3.high) || y2, j3 = ((E2 = d3.controlPoints) == null ? void 0 : E2.low) || M2, L2 = (z2, U2) => Math.pow(1 - z2, 3) * y2[U2] + 3 * (1 - z2) * (1 - z2) * z2 * P2[U2] + 3 * (1 - z2) * z2 * z2 * j3[U2] + z2 * z2 * z2 * M2[U2], T2 = 0, O3 = 1, R2;
                  for (let z2 = 0; z2 < 100; z2++) {
                    let U2 = (T2 + O3) / 2, Q2 = L2(U2, 0);
                    if (Q2 === null) break;
                    if (0.25 > Math.abs(Q2 - e5.plotX)) {
                      R2 = U2;
                      break;
                    }
                    Q2 < e5.plotX ? T2 = U2 : O3 = U2;
                  }
                  X2(R2) && (e5.plotY = L2(R2, 1), e5.y = a2.toValue(e5.plotY, true));
                } else b5 = (e5.x - l4.x) / (d3.x - l4.x), e5.plotY += b5 * (d3[t3] - l4[t3]), e5.y += b5 * (d3.y - l4.y);
              if (o2--, i5++, o2 < 0) break;
            }
          }
          v3.forEach((y2, M2) => {
            let P2;
            y2.plotX += s2, (y2.plotY === void 0 || C3) && (y2.plotX >= 0 && y2.plotX <= n4.len ? C3 ? (y2.plotY = n4.translate(y2.x, 0, 1, 0, 1), y2.plotX = X2(y2.y) ? a2.translate(y2.y, 0, 0, 0, 1) : 0) : y2.plotY = (n4.opposite ? 0 : B3.yAxis.len) + n4.offset : y2.shapeArgs = {}), (r3 = v3[M2 - 1]) && r3.plotX === y2.plotX && (r3.stackIndex === void 0 && (r3.stackIndex = 0), P2 = r3.stackIndex + 1), y2.stackIndex = P2;
          }), this.onSeries = G2;
        }
        k3.compose = function(m3) {
          if (V2(_2, "OnSeries")) {
            let E2 = m3.prototype;
            E2.getPlotBox = S2, E2.translate = H2;
          }
          return m3;
        }, k3.getPlotBox = S2, k3.translate = H2;
      }(Z2 || (Z2 = {})), Z2;
    }), $2(f2, "Series/Flags/FlagsSeries.js", [f2["Series/Flags/FlagsPoint.js"], f2["Series/Flags/FlagsSeriesDefaults.js"], f2["Series/Flags/FlagsSymbols.js"], f2["Core/Globals.js"], f2["Series/OnSeriesComposition.js"], f2["Core/Renderer/RendererUtilities.js"], f2["Core/Series/SeriesRegistry.js"], f2["Core/Renderer/SVG/SVGElement.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2, Z2, _2, W2, I3, X2) {
      let { noop: V2 } = Y2, { distribute: A3 } = _2, { series: k3, seriesTypes: { column: S2 } } = W2, { addEvent: H2, defined: m3, extend: E2, isNumber: B3, merge: g2, objectEach: w2, wrap: v3 } = X2;
      class x2 extends S2 {
        animate(u2) {
          u2 && this.setClip();
        }
        drawPoints() {
          var u2, p2;
          let C3, n4, a2, o2, e5, r3, t3, i5, s2, l4, h2, d3 = this.points, c4 = this.chart, b5 = c4.renderer, y2 = c4.inverted, M2 = this.options, P2 = M2.y, j3 = this.yAxis, L2 = {}, T2 = [], O3 = B3(M2.borderRadius) ? M2.borderRadius : 0;
          for (o2 = d3.length; o2--; ) e5 = d3[o2], l4 = (y2 ? e5.plotY : e5.plotX) > this.xAxis.len, C3 = e5.plotX, t3 = e5.stackIndex, a2 = e5.options.shape || M2.shape, (n4 = e5.plotY) !== void 0 && (n4 = e5.plotY + P2 - (t3 !== void 0 && t3 * M2.stackDistance)), e5.anchorX = t3 ? void 0 : e5.plotX, i5 = t3 ? void 0 : e5.plotY, h2 = a2 !== "flag", r3 = e5.graphic, n4 !== void 0 && C3 >= 0 && !l4 ? (r3 && e5.hasNewShapeType() && (r3 = r3.destroy()), r3 || (r3 = e5.graphic = b5.label("", 0, void 0, a2, void 0, void 0, M2.useHTML).addClass("highcharts-point").add(this.markerGroup), e5.graphic.div && (e5.graphic.div.point = e5), r3.isNew = true), r3.attr({ align: h2 ? "center" : "left", width: M2.width, height: M2.height, "text-align": M2.textAlign, r: O3 }), c4.styledMode || r3.attr(this.pointAttribs(e5)).css(g2(M2.style, e5.style)).shadow(M2.shadow), C3 > 0 && (C3 -= r3.strokeWidth() % 2), s2 = { y: n4, anchorY: i5 }, M2.allowOverlapX && (s2.x = C3, s2.anchorX = e5.anchorX), r3.attr({ text: (p2 = (u2 = e5.options.title) != null ? u2 : M2.title) != null ? p2 : "A" })[r3.isNew ? "attr" : "animate"](s2), M2.allowOverlapX || (L2[e5.plotX] ? L2[e5.plotX].size = Math.max(L2[e5.plotX].size, r3.width || 0) : L2[e5.plotX] = { align: h2 ? 0.5 : 0, size: r3.width || 0, target: C3, anchorX: C3 }), e5.tooltipPos = [C3, n4 + j3.pos - c4.plotTop]) : r3 && (e5.graphic = r3.destroy());
          if (!M2.allowOverlapX) {
            let R2 = 100;
            for (let z2 of (w2(L2, function(U2) {
              U2.plotX = U2.anchorX, T2.push(U2), R2 = Math.max(U2.size, R2);
            }), A3(T2, y2 ? j3.len : this.xAxis.len, R2), d3)) {
              let U2 = z2.plotX, Q2 = z2.graphic, K2 = Q2 && L2[U2];
              K2 && Q2 && (m3(K2.pos) ? Q2[Q2.isNew ? "attr" : "animate"]({ x: K2.pos + (K2.align || 0) * K2.size, anchorX: z2.anchorX }).show().isNew = false : Q2.hide().isNew = true);
            }
          }
          M2.useHTML && this.markerGroup && v3(this.markerGroup, "on", function(R2) {
            return I3.prototype.on.apply(R2.apply(this, [].slice.call(arguments, 1)), [].slice.call(arguments, 1));
          });
        }
        drawTracker() {
          let u2 = this.points;
          for (let p2 of (super.drawTracker(), u2)) {
            let C3 = p2.graphic;
            C3 && (p2.unbindMouseOver && p2.unbindMouseOver(), p2.unbindMouseOver = H2(C3.element, "mouseover", function() {
              for (let n4 of (p2.stackIndex > 0 && !p2.raised && (p2._y = C3.y, C3.attr({ y: p2._y - 8 }), p2.raised = true), u2)) n4 !== p2 && n4.raised && n4.graphic && (n4.graphic.attr({ y: n4._y }), n4.raised = false);
            }));
          }
        }
        pointAttribs(u2, p2) {
          let C3 = this.options, n4 = u2 && u2.color || this.color, a2 = C3.lineColor, o2 = u2 && u2.lineWidth, e5 = u2 && u2.fillColor || C3.fillColor;
          return p2 && (e5 = C3.states[p2].fillColor, a2 = C3.states[p2].lineColor, o2 = C3.states[p2].lineWidth), { fill: e5 || n4, stroke: a2 || n4, "stroke-width": o2 || C3.lineWidth || 0 };
        }
        setClip() {
          k3.prototype.setClip.apply(this, arguments), this.options.clip !== false && this.sharedClipKey && this.markerGroup && this.markerGroup.clip(this.chart.sharedClips[this.sharedClipKey]);
        }
      }
      return x2.compose = F2.compose, x2.defaultOptions = g2(S2.defaultOptions, N2), Z2.compose(x2), E2(x2.prototype, { allowDG: false, forceCrop: true, invertible: false, noSharedTooltip: true, pointClass: D2, sorted: false, takeOrdinalPosition: false, trackerGroups: ["markerGroup"], buildKDTree: V2, init: k3.prototype.init }), W2.registerSeriesType("flags", x2), x2;
    }), $2(f2, "Core/Axis/BrokenAxis.js", [f2["Core/Axis/Stacking/StackItem.js"], f2["Core/Utilities.js"]], function(D2, N2) {
      var F2;
      let { addEvent: Y2, find: Z2, fireEvent: _2, isArray: W2, isNumber: I3, pick: X2 } = N2;
      return function(V2) {
        function A3() {
          this.brokenAxis !== void 0 && this.brokenAxis.setBreaks(this.options.breaks, false);
        }
        function k3() {
          var v3;
          (v3 = this.brokenAxis) != null && v3.hasBreaks && (this.options.ordinal = false);
        }
        function S2() {
          let v3 = this.brokenAxis;
          if (v3 != null && v3.hasBreaks) {
            let x2 = this.tickPositions, G2 = this.tickPositions.info, u2 = [];
            for (let p2 = 0; p2 < x2.length; p2++) v3.isInAnyBreak(x2[p2]) || u2.push(x2[p2]);
            this.tickPositions = u2, this.tickPositions.info = G2;
          }
        }
        function H2() {
          this.brokenAxis || (this.brokenAxis = new w2(this));
        }
        function m3() {
          var v3, x2;
          let { isDirty: G2, options: { connectNulls: u2 }, points: p2, xAxis: C3, yAxis: n4 } = this;
          if (G2) {
            let a2 = p2.length;
            for (; a2--; ) {
              let o2 = p2[a2], e5 = !(o2.y === null && u2 === false) && (((v3 = C3 == null ? void 0 : C3.brokenAxis) == null ? void 0 : v3.isInAnyBreak(o2.x, true)) || ((x2 = n4 == null ? void 0 : n4.brokenAxis) == null ? void 0 : x2.isInAnyBreak(o2.y, true)));
              o2.visible = !e5 && o2.options.visible !== false;
            }
          }
        }
        function E2() {
          this.drawBreaks(this.xAxis, ["x"]), this.drawBreaks(this.yAxis, X2(this.pointArrayMap, ["y"]));
        }
        function B3(v3, x2) {
          var G2;
          let u2, p2, C3, n4 = this, a2 = n4.points;
          if ((G2 = v3 == null ? void 0 : v3.brokenAxis) != null && G2.hasBreaks) {
            let o2 = v3.brokenAxis;
            x2.forEach(function(e5) {
              var r3, t3;
              u2 = (o2 == null ? void 0 : o2.breakArray) || [], p2 = v3.isXAxis ? v3.min : X2(n4.options.threshold, v3.min);
              let i5 = (t3 = (r3 = v3 == null ? void 0 : v3.options) == null ? void 0 : r3.breaks) == null ? void 0 : t3.filter(function(s2) {
                let l4 = true;
                for (let h2 = 0; h2 < u2.length; h2++) {
                  let d3 = u2[h2];
                  if (d3.from === s2.from && d3.to === s2.to) {
                    l4 = false;
                    break;
                  }
                }
                return l4;
              });
              a2.forEach(function(s2) {
                C3 = X2(s2["stack" + e5.toUpperCase()], s2[e5]), u2.forEach(function(l4) {
                  if (I3(p2) && I3(C3)) {
                    let h2 = "";
                    p2 < l4.from && C3 > l4.to || p2 > l4.from && C3 < l4.from ? h2 = "pointBreak" : (p2 < l4.from && C3 > l4.from && C3 < l4.to || p2 > l4.from && C3 > l4.to && C3 < l4.from) && (h2 = "pointInBreak"), h2 && _2(v3, h2, { point: s2, brk: l4 });
                  }
                }), i5 == null || i5.forEach(function(l4) {
                  _2(v3, "pointOutsideOfBreak", { point: s2, brk: l4 });
                });
              });
            });
          }
        }
        function g2() {
          let v3 = this.currentDataGrouping, x2 = v3 == null ? void 0 : v3.gapSize, G2 = this.points.slice(), u2 = this.yAxis, p2 = this.options.gapSize, C3 = G2.length - 1;
          if (p2 && C3 > 0) {
            let n4, a2;
            for (this.options.gapUnit !== "value" && (p2 *= this.basePointRange), x2 && x2 > p2 && x2 >= this.basePointRange && (p2 = x2); C3--; ) if (a2 && a2.visible !== false || (a2 = G2[C3 + 1]), n4 = G2[C3], a2.visible !== false && n4.visible !== false) {
              if (a2.x - n4.x > p2) {
                let o2 = (n4.x + a2.x) / 2;
                G2.splice(C3 + 1, 0, { isNull: true, x: o2 }), u2.stacking && this.options.stacking && ((u2.stacking.stacks[this.stackKey][o2] = new D2(u2, u2.options.stackLabels, false, o2, this.stack)).total = 0);
              }
              a2 = n4;
            }
          }
          return this.getGraphPath(G2);
        }
        V2.compose = function(v3, x2) {
          if (!v3.keepProps.includes("brokenAxis")) {
            v3.keepProps.push("brokenAxis"), Y2(v3, "init", H2), Y2(v3, "afterInit", A3), Y2(v3, "afterSetTickPositions", S2), Y2(v3, "afterSetOptions", k3);
            let G2 = x2.prototype;
            G2.drawBreaks = B3, G2.gappedPath = g2, Y2(x2, "afterGeneratePoints", m3), Y2(x2, "afterRender", E2);
          }
          return v3;
        };
        class w2 {
          static isInBreak(x2, G2) {
            let u2 = x2.repeat || 1 / 0, p2 = x2.from, C3 = x2.to - x2.from, n4 = G2 >= p2 ? (G2 - p2) % u2 : u2 - (p2 - G2) % u2;
            return x2.inclusive ? n4 <= C3 : n4 < C3 && n4 !== 0;
          }
          static lin2Val(x2) {
            let G2 = this.brokenAxis, u2 = G2 && G2.breakArray;
            if (!u2 || !I3(x2)) return x2;
            let p2 = x2, C3, n4;
            for (n4 = 0; n4 < u2.length && !((C3 = u2[n4]).from >= p2); n4++) (C3.to < p2 || w2.isInBreak(C3, p2)) && (p2 += C3.len);
            return p2;
          }
          static val2Lin(x2) {
            let G2 = this.brokenAxis, u2 = G2 && G2.breakArray;
            if (!u2 || !I3(x2)) return x2;
            let p2 = x2, C3, n4;
            for (n4 = 0; n4 < u2.length; n4++) if ((C3 = u2[n4]).to <= x2) p2 -= C3.len;
            else {
              if (C3.from >= x2) break;
              if (w2.isInBreak(C3, x2)) {
                p2 -= x2 - C3.from;
                break;
              }
            }
            return p2;
          }
          constructor(x2) {
            this.hasBreaks = false, this.axis = x2;
          }
          findBreakAt(x2, G2) {
            return Z2(G2, function(u2) {
              return u2.from < x2 && x2 < u2.to;
            });
          }
          isInAnyBreak(x2, G2) {
            let u2 = this.axis, p2 = u2.options.breaks || [], C3 = p2.length, n4, a2, o2;
            if (C3 && I3(x2)) {
              for (; C3--; ) w2.isInBreak(p2[C3], x2) && (n4 = true, a2 || (a2 = X2(p2[C3].showPoints, !u2.isXAxis)));
              o2 = n4 && G2 ? n4 && !a2 : n4;
            }
            return o2;
          }
          setBreaks(x2, G2) {
            let u2 = this, p2 = u2.axis, C3 = W2(x2) && !!x2.length && !!Object.keys(x2[0]).length;
            p2.isDirty = u2.hasBreaks !== C3, u2.hasBreaks = C3, x2 !== p2.options.breaks && (p2.options.breaks = p2.userOptions.breaks = x2), p2.forceRedraw = true, p2.series.forEach(function(n4) {
              n4.isDirty = true;
            }), C3 || p2.val2lin !== w2.val2Lin || (delete p2.val2lin, delete p2.lin2val), C3 && (p2.userOptions.ordinal = false, p2.lin2val = w2.lin2Val, p2.val2lin = w2.val2Lin, p2.setExtremes = function(n4, a2, o2, e5, r3) {
              if (u2.hasBreaks) {
                let t3, i5 = this.options.breaks || [];
                for (; t3 = u2.findBreakAt(n4, i5); ) n4 = t3.to;
                for (; t3 = u2.findBreakAt(a2, i5); ) a2 = t3.from;
                a2 < n4 && (a2 = n4);
              }
              p2.constructor.prototype.setExtremes.call(this, n4, a2, o2, e5, r3);
            }, p2.setAxisTranslation = function() {
              if (p2.constructor.prototype.setAxisTranslation.call(this), u2.unitLength = void 0, u2.hasBreaks) {
                let n4 = p2.options.breaks || [], a2 = [], o2 = [], e5 = X2(p2.pointRangePadding, 0), r3 = 0, t3, i5, s2 = p2.userMin || p2.min, l4 = p2.userMax || p2.max, h2, d3;
                n4.forEach(function(c4) {
                  i5 = c4.repeat || 1 / 0, I3(s2) && I3(l4) && (w2.isInBreak(c4, s2) && (s2 += c4.to % i5 - s2 % i5), w2.isInBreak(c4, l4) && (l4 -= l4 % i5 - c4.from % i5));
                }), n4.forEach(function(c4) {
                  if (h2 = c4.from, i5 = c4.repeat || 1 / 0, I3(s2) && I3(l4)) {
                    for (; h2 - i5 > s2; ) h2 -= i5;
                    for (; h2 < s2; ) h2 += i5;
                    for (d3 = h2; d3 < l4; d3 += i5) a2.push({ value: d3, move: "in" }), a2.push({ value: d3 + c4.to - c4.from, move: "out", size: c4.breakSize });
                  }
                }), a2.sort(function(c4, b5) {
                  return c4.value === b5.value ? (c4.move === "in" ? 0 : 1) - (b5.move === "in" ? 0 : 1) : c4.value - b5.value;
                }), t3 = 0, h2 = s2, a2.forEach(function(c4) {
                  (t3 += c4.move === "in" ? 1 : -1) === 1 && c4.move === "in" && (h2 = c4.value), t3 === 0 && I3(h2) && (o2.push({ from: h2, to: c4.value, len: c4.value - h2 - (c4.size || 0) }), r3 += c4.value - h2 - (c4.size || 0));
                }), u2.breakArray = o2, I3(s2) && I3(l4) && I3(p2.min) && (u2.unitLength = l4 - s2 - r3 + e5, _2(p2, "afterBreaks"), p2.staticScale ? p2.transA = p2.staticScale : u2.unitLength && (p2.transA *= (l4 - p2.min + e5) / u2.unitLength), e5 && (p2.minPixelPadding = p2.transA * (p2.minPointOffset || 0)), p2.min = s2, p2.max = l4);
              }
            }), X2(G2, true) && p2.chart.redraw();
          }
        }
        V2.Additions = w2;
      }(F2 || (F2 = {})), F2;
    }), $2(f2, "masters/modules/broken-axis.src.js", [f2["Core/Globals.js"], f2["Core/Axis/BrokenAxis.js"]], function(D2, N2) {
      return D2.BrokenAxis = D2.BrokenAxis || N2, D2.BrokenAxis.compose(D2.Axis, D2.Series), D2;
    }), $2(f2, "Extensions/DataGrouping/ApproximationRegistry.js", [], function() {
      return {};
    }), $2(f2, "Extensions/DataGrouping/ApproximationDefaults.js", [f2["Extensions/DataGrouping/ApproximationRegistry.js"], f2["Core/Utilities.js"]], function(D2, N2) {
      let { arrayMax: F2, arrayMin: Y2, correctFloat: Z2, extend: _2, isNumber: W2 } = N2;
      function I3(A3) {
        let k3 = A3.length, S2 = X2(A3);
        return W2(S2) && k3 && (S2 = Z2(S2 / k3)), S2;
      }
      function X2(A3) {
        let k3 = A3.length, S2;
        if (!k3 && A3.hasNulls) S2 = null;
        else if (k3) for (S2 = 0; k3--; ) S2 += A3[k3];
        return S2;
      }
      let V2 = { average: I3, averages: function() {
        let A3 = [];
        return [].forEach.call(arguments, function(k3) {
          A3.push(I3(k3));
        }), A3[0] === void 0 ? void 0 : A3;
      }, close: function(A3) {
        return A3.length ? A3[A3.length - 1] : A3.hasNulls ? null : void 0;
      }, high: function(A3) {
        return A3.length ? F2(A3) : A3.hasNulls ? null : void 0;
      }, hlc: function(A3, k3, S2) {
        if (A3 = D2.high(A3), k3 = D2.low(k3), S2 = D2.close(S2), W2(A3) || W2(k3) || W2(S2)) return [A3, k3, S2];
      }, low: function(A3) {
        return A3.length ? Y2(A3) : A3.hasNulls ? null : void 0;
      }, ohlc: function(A3, k3, S2, H2) {
        if (A3 = D2.open(A3), k3 = D2.high(k3), S2 = D2.low(S2), H2 = D2.close(H2), W2(A3) || W2(k3) || W2(S2) || W2(H2)) return [A3, k3, S2, H2];
      }, open: function(A3) {
        return A3.length ? A3[0] : A3.hasNulls ? null : void 0;
      }, range: function(A3, k3) {
        return A3 = D2.low(A3), k3 = D2.high(k3), W2(A3) || W2(k3) ? [A3, k3] : A3 === null && k3 === null ? null : void 0;
      }, sum: X2 };
      return _2(D2, V2), V2;
    }), $2(f2, "Extensions/DataGrouping/DataGroupingDefaults.js", [], function() {
      return { common: { groupPixelWidth: 2, dateTimeLabelFormats: { millisecond: ["%A, %e %b, %H:%M:%S.%L", "%A, %e %b, %H:%M:%S.%L", "-%H:%M:%S.%L"], second: ["%A, %e %b, %H:%M:%S", "%A, %e %b, %H:%M:%S", "-%H:%M:%S"], minute: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], hour: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], day: ["%A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], week: ["Week from %A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], month: ["%B %Y", "%B", "-%B %Y"], year: ["%Y", "%Y", "-%Y"] } }, seriesSpecific: { line: {}, spline: {}, area: {}, areaspline: {}, arearange: {}, column: { groupPixelWidth: 10 }, columnrange: { groupPixelWidth: 10 }, candlestick: { groupPixelWidth: 10 }, ohlc: { groupPixelWidth: 5 }, hlc: { groupPixelWidth: 5 }, heikinashi: { groupPixelWidth: 10 } }, units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1]], ["week", [1]], ["month", [1, 3, 6]], ["year", null]] };
    }), $2(f2, "Extensions/DataGrouping/DataGroupingAxisComposition.js", [f2["Extensions/DataGrouping/DataGroupingDefaults.js"], f2["Core/Utilities.js"]], function(D2, N2) {
      let F2, { addEvent: Y2, extend: Z2, merge: _2, pick: W2 } = N2;
      function I3(k3) {
        let S2 = this, H2 = S2.series;
        H2.forEach(function(m3) {
          m3.groupPixelWidth = void 0;
        }), H2.forEach(function(m3) {
          m3.groupPixelWidth = S2.getGroupPixelWidth && S2.getGroupPixelWidth(), m3.groupPixelWidth && (m3.hasProcessed = true), m3.applyGrouping(!!k3.hasExtremesChanged);
        });
      }
      function X2() {
        let k3 = this.series, S2 = k3.length, H2 = 0, m3 = false, E2, B3;
        for (; S2--; ) (B3 = k3[S2].options.dataGrouping) && (H2 = Math.max(H2, W2(B3.groupPixelWidth, D2.common.groupPixelWidth)), E2 = (k3[S2].processedXData || k3[S2].data).length, (k3[S2].groupPixelWidth || E2 > this.chart.plotSizeX / H2 || E2 && B3.forced) && (m3 = true));
        return m3 ? H2 : 0;
      }
      function V2() {
        this.series.forEach(function(k3) {
          k3.hasProcessed = false;
        });
      }
      function A3(k3, S2) {
        let H2;
        if (S2 = W2(S2, true), k3 || (k3 = { forced: false, units: null }), this instanceof F2) for (H2 = this.series.length; H2--; ) this.series[H2].update({ dataGrouping: k3 }, false);
        else this.chart.options.series.forEach(function(m3) {
          m3.dataGrouping = typeof k3 == "boolean" ? k3 : _2(k3, m3.dataGrouping);
        });
        this.ordinal && (this.ordinal.slope = void 0), S2 && this.chart.redraw();
      }
      return { compose: function(k3) {
        F2 = k3;
        let S2 = k3.prototype;
        S2.applyGrouping || (Y2(k3, "afterSetScale", V2), Y2(k3, "postProcessData", I3), Z2(S2, { applyGrouping: I3, getGroupPixelWidth: X2, setDataGrouping: A3 }));
      } };
    }), $2(f2, "Extensions/DataGrouping/DataGroupingSeriesComposition.js", [f2["Extensions/DataGrouping/ApproximationRegistry.js"], f2["Extensions/DataGrouping/DataGroupingDefaults.js"], f2["Core/Axis/DateTimeAxis.js"], f2["Core/Defaults.js"], f2["Core/Series/SeriesRegistry.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2, Z2, _2) {
      let { series: { prototype: W2 } } = Z2, { addEvent: I3, defined: X2, error: V2, extend: A3, isNumber: k3, merge: S2, pick: H2 } = _2, m3 = W2.generatePoints;
      function E2(G2) {
        var u2;
        let p2, C3, n4 = this.chart, a2 = this.options.dataGrouping, o2 = this.allowDG !== false && a2 && H2(a2.enabled, n4.options.isStock), e5 = this.reserveSpace(), r3 = this.currentDataGrouping, t3, i5, s2 = false;
        o2 && !this.requireSorting && (this.requireSorting = s2 = true);
        let l4 = !!(this.isCartesian && !this.isDirty && !this.xAxis.isDirty && !this.yAxis.isDirty && !G2) || !o2;
        if (s2 && (this.requireSorting = false), l4) return;
        this.destroyGroupedData();
        let h2 = a2.groupAll ? this.xData : this.processedXData, d3 = a2.groupAll ? this.yData : this.processedYData, c4 = n4.plotSizeX, b5 = this.xAxis, y2 = b5.options.ordinal, M2 = this.groupPixelWidth;
        if (M2 && h2 && h2.length && c4) {
          C3 = true, this.isDirty = true, this.points = null;
          let P2 = b5.getExtremes(), j3 = P2.min, L2 = P2.max, T2 = y2 && b5.ordinal && b5.ordinal.getGroupIntervalFactor(j3, L2, this) || 1, O3 = M2 * (L2 - j3) / c4 * T2, R2 = b5.getTimeTicks(F2.Additions.prototype.normalizeTimeTickInterval(O3, a2.units || N2.units), Math.min(j3, h2[0]), Math.max(L2, h2[h2.length - 1]), b5.options.startOfWeek, h2, this.closestPointRange), z2 = W2.groupData.apply(this, [h2, d3, R2, a2.approximation]), U2 = z2.groupedXData, Q2 = z2.groupedYData, K2 = 0;
          for (a2 && a2.smoothed && U2.length && (a2.firstAnchor = "firstPoint", a2.anchor = "middle", a2.lastAnchor = "lastPoint", V2(32, false, n4, { "dataGrouping.smoothed": "use dataGrouping.anchor" })), p2 = 1; p2 < R2.length; p2++) R2.info.segmentStarts && R2.info.segmentStarts.indexOf(p2) !== -1 || (K2 = Math.max(R2[p2] - R2[p2 - 1], K2));
          (t3 = R2.info).gapSize = K2, this.closestPointRange = R2.info.totalRange, this.groupMap = z2.groupMap, this.currentDataGrouping = t3, function(q2, tt2, J2) {
            let et2 = q2.options.dataGrouping, ot2 = q2.currentDataGrouping && q2.currentDataGrouping.gapSize;
            if (!(et2 && q2.xData && ot2 && q2.groupMap)) return;
            let it2 = tt2.length - 1, lt2 = et2.anchor, nt2 = et2.firstAnchor, ut2 = et2.lastAnchor, ht2 = tt2.length - 1, rt2 = 0;
            if (nt2 && q2.xData[0] >= tt2[0]) {
              let at2;
              rt2++;
              let pt2 = q2.groupMap[0].start, xt2 = q2.groupMap[0].length;
              k3(pt2) && k3(xt2) && (at2 = pt2 + (xt2 - 1)), tt2[0] = { start: tt2[0], middle: tt2[0] + 0.5 * ot2, end: tt2[0] + ot2, firstPoint: q2.xData[0], lastPoint: at2 && q2.xData[at2] }[nt2];
            }
            if (it2 > 0 && ut2 && ot2 && tt2[it2] >= J2 - ot2) {
              ht2--;
              let at2 = q2.groupMap[q2.groupMap.length - 1].start;
              tt2[it2] = { start: tt2[it2], middle: tt2[it2] + 0.5 * ot2, end: tt2[it2] + ot2, firstPoint: at2 && q2.xData[at2], lastPoint: q2.xData[q2.xData.length - 1] }[ut2];
            }
            if (lt2 && lt2 !== "start") {
              let at2 = ot2 * { middle: 0.5, end: 1 }[lt2];
              for (; ht2 >= rt2; ) tt2[ht2] += at2, ht2--;
            }
          }(this, U2, L2), e5 && (X2((u2 = U2)[0]) && k3(b5.min) && k3(b5.dataMin) && u2[0] < b5.min && ((!X2(b5.options.min) && b5.min <= b5.dataMin || b5.min === b5.dataMin) && (b5.min = Math.min(u2[0], b5.min)), b5.dataMin = Math.min(u2[0], b5.dataMin)), X2(u2[u2.length - 1]) && k3(b5.max) && k3(b5.dataMax) && u2[u2.length - 1] > b5.max && ((!X2(b5.options.max) && k3(b5.dataMax) && b5.max >= b5.dataMax || b5.max === b5.dataMax) && (b5.max = Math.max(u2[u2.length - 1], b5.max)), b5.dataMax = Math.max(u2[u2.length - 1], b5.dataMax))), a2.groupAll && (this.allGroupedData = Q2, U2 = (i5 = this.cropData(U2, Q2, b5.min, b5.max)).xData, Q2 = i5.yData, this.cropStart = i5.start), this.processedXData = U2, this.processedYData = Q2;
        } else this.groupMap = null, this.currentDataGrouping = void 0;
        this.hasGroupedData = C3, this.preventGraphAnimation = (r3 && r3.totalRange) !== (t3 && t3.totalRange);
      }
      function B3() {
        this.groupedData && (this.groupedData.forEach(function(G2, u2) {
          G2 && (this.groupedData[u2] = G2.destroy ? G2.destroy() : null);
        }, this), this.groupedData.length = 0, delete this.allGroupedData);
      }
      function g2() {
        m3.apply(this), this.destroyGroupedData(), this.groupedData = this.hasGroupedData ? this.points : null;
      }
      function w2() {
        return this.is("arearange") ? "range" : this.is("ohlc") ? "ohlc" : this.is("hlc") ? "hlc" : this.is("column") || this.options.cumulative ? "sum" : "average";
      }
      function v3(G2, u2, p2, C3) {
        let n4 = this, a2 = n4.data, o2 = n4.options && n4.options.data, e5 = [], r3 = [], t3 = [], i5 = G2.length, s2 = !!u2, l4 = [], h2 = n4.pointArrayMap, d3 = h2 && h2.length, c4 = ["x"].concat(h2 || ["y"]), b5 = this.options.dataGrouping && this.options.dataGrouping.groupAll, y2, M2, P2, j3 = 0, L2 = 0, T2 = typeof C3 == "function" ? C3 : C3 && D2[C3] ? D2[C3] : D2[n4.getDGApproximation && n4.getDGApproximation() || "average"];
        if (d3) {
          let R2 = h2.length;
          for (; R2--; ) l4.push([]);
        } else l4.push([]);
        let O3 = d3 || 1;
        for (let R2 = 0; R2 <= i5; R2++) if (!(G2[R2] < p2[0])) {
          for (; p2[j3 + 1] !== void 0 && G2[R2] >= p2[j3 + 1] || R2 === i5; ) {
            y2 = p2[j3], n4.dataGroupInfo = { start: b5 ? L2 : n4.cropStart + L2, length: l4[0].length, groupStart: y2 }, P2 = T2.apply(n4, l4), n4.pointClass && !X2(n4.dataGroupInfo.options) && (n4.dataGroupInfo.options = S2(n4.pointClass.prototype.optionsToObject.call({ series: n4 }, n4.options.data[n4.cropStart + L2])), c4.forEach(function(z2) {
              delete n4.dataGroupInfo.options[z2];
            })), P2 !== void 0 && (e5.push(y2), r3.push(P2), t3.push(n4.dataGroupInfo)), L2 = R2;
            for (let z2 = 0; z2 < O3; z2++) l4[z2].length = 0, l4[z2].hasNulls = false;
            if (j3 += 1, R2 === i5) break;
          }
          if (R2 === i5) break;
          if (h2) {
            let z2, U2 = n4.options.dataGrouping && n4.options.dataGrouping.groupAll ? R2 : n4.cropStart + R2, Q2 = a2 && a2[U2] || n4.pointClass.prototype.applyOptions.apply({ series: n4 }, [o2[U2]]);
            for (let K2 = 0; K2 < d3; K2++) k3(z2 = Q2[h2[K2]]) ? l4[K2].push(z2) : z2 === null && (l4[K2].hasNulls = true);
          } else k3(M2 = s2 ? u2[R2] : null) ? l4[0].push(M2) : M2 === null && (l4[0].hasNulls = true);
        }
        return { groupedXData: e5, groupedYData: r3, groupMap: t3 };
      }
      function x2(G2) {
        let u2 = G2.options, p2 = this.type, C3 = this.chart.options.plotOptions, n4 = this.useCommonDataGrouping && N2.common, a2 = N2.seriesSpecific, o2 = Y2.defaultOptions.plotOptions[p2].dataGrouping;
        if (C3 && (a2[p2] || n4)) {
          let e5 = this.chart.rangeSelector;
          o2 || (o2 = S2(N2.common, a2[p2])), u2.dataGrouping = S2(n4, o2, C3.series && C3.series.dataGrouping, C3[p2].dataGrouping, this.userOptions.dataGrouping, !u2.isInternal && e5 && k3(e5.selected) && e5.buttonOptions[e5.selected].dataGrouping);
        }
      }
      return { compose: function(G2) {
        let u2 = G2.prototype;
        u2.applyGrouping || (I3(G2.prototype.pointClass, "update", function() {
          if (this.dataGroup) return V2(24, false, this.series.chart), false;
        }), I3(G2, "afterSetOptions", x2), I3(G2, "destroy", B3), A3(u2, { applyGrouping: E2, destroyGroupedData: B3, generatePoints: g2, getDGApproximation: w2, groupData: v3 }));
      }, groupData: v3 };
    }), $2(f2, "Extensions/DataGrouping/DataGrouping.js", [f2["Extensions/DataGrouping/DataGroupingAxisComposition.js"], f2["Extensions/DataGrouping/DataGroupingDefaults.js"], f2["Extensions/DataGrouping/DataGroupingSeriesComposition.js"], f2["Core/Templating.js"], f2["Core/Globals.js"], f2["Core/Utilities.js"]], function(D2, N2, F2, Y2, Z2, _2) {
      let { format: W2 } = Y2, { composed: I3 } = Z2, { addEvent: X2, extend: V2, isNumber: A3, pick: k3, pushUnique: S2 } = _2;
      function H2(m3) {
        var E2;
        let B3 = this.chart, g2 = B3.time, w2 = m3.labelConfig, v3 = w2.series, x2 = w2.point, G2 = v3.options, u2 = v3.tooltipOptions, p2 = G2.dataGrouping, C3 = v3.xAxis, n4 = u2.xDateFormat, a2, o2, e5, r3, t3, i5 = u2[m3.isFooter ? "footerFormat" : "headerFormat"];
        if (C3 && C3.options.type === "datetime" && p2 && A3(w2.key)) {
          o2 = v3.currentDataGrouping, e5 = p2.dateTimeLabelFormats || N2.common.dateTimeLabelFormats, o2 ? (r3 = e5[o2.unitName], o2.count === 1 ? n4 = r3[0] : (n4 = r3[1], a2 = r3[2])) : !n4 && e5 && C3.dateTime && (n4 = C3.dateTime.getXDateFormat(w2.x, u2.dateTimeLabelFormats));
          let s2 = k3((E2 = v3.groupMap) == null ? void 0 : E2[x2.index].groupStart, w2.key), l4 = s2 + (o2 == null ? void 0 : o2.totalRange) - 1;
          t3 = g2.dateFormat(n4, s2), a2 && (t3 += g2.dateFormat(a2, l4)), v3.chart.styledMode && (i5 = this.styledModeFormat(i5)), m3.text = W2(i5, { point: V2(w2.point, { key: t3 }), series: v3 }, B3), m3.preventDefault();
        }
      }
      return { compose: function(m3, E2, B3) {
        D2.compose(m3), F2.compose(E2), B3 && S2(I3, "DataGrouping") && X2(B3, "headerFormatter", H2);
      }, groupData: F2.groupData };
    }), $2(f2, "masters/modules/datagrouping.src.js", [f2["Core/Globals.js"], f2["Extensions/DataGrouping/ApproximationDefaults.js"], f2["Extensions/DataGrouping/ApproximationRegistry.js"], f2["Extensions/DataGrouping/DataGrouping.js"]], function(D2, N2, F2, Y2) {
      return D2.dataGrouping = D2.dataGrouping || {}, D2.dataGrouping.approximationDefaults = D2.dataGrouping.approximationDefaults || N2, D2.dataGrouping.approximations = D2.dataGrouping.approximations || F2, Y2.compose(D2.Axis, D2.Series, D2.Tooltip), D2;
    }), $2(f2, "Extensions/Annotations/NavigationBindingsUtilities.js", [f2["Core/Utilities.js"]], function(D2) {
      let { defined: N2, isNumber: F2, pick: Y2 } = D2, Z2 = { backgroundColor: "string", borderColor: "string", borderRadius: "string", color: "string", fill: "string", fontSize: "string", labels: "string", name: "string", stroke: "string", title: "string" };
      return { annotationsFieldsTypes: Z2, getAssignedAxis: function(_2) {
        return _2.filter((W2) => {
          let I3 = W2.axis.getExtremes(), X2 = I3.min, V2 = I3.max, A3 = Y2(W2.axis.minPointOffset, 0);
          return F2(X2) && F2(V2) && W2.value >= X2 - A3 && W2.value <= V2 + A3 && !W2.axis.options.isInternal;
        })[0];
      }, getFieldType: function(_2, W2) {
        let I3 = Z2[_2], X2 = typeof W2;
        return N2(I3) && (X2 = I3), { string: "text", number: "number", boolean: "checkbox" }[X2];
      } };
    }), $2(f2, "Extensions/MouseWheelZoom/MouseWheelZoom.js", [f2["Core/Utilities.js"], f2["Extensions/Annotations/NavigationBindingsUtilities.js"]], function(D2, N2) {
      let F2, { addEvent: Y2, isObject: Z2, pick: _2, defined: W2, merge: I3 } = D2, { getAssignedAxis: X2 } = N2, V2 = [], A3 = { enabled: true, sensitivity: 1.1 }, k3 = (m3) => (Z2(m3) || (m3 = { enabled: m3 != null ? m3 : true }), I3(A3, m3)), S2 = function(m3, E2, B3, g2, w2, v3, x2) {
        let G2 = _2(x2.type, m3.zooming.type, ""), u2 = [];
        G2 === "x" ? u2 = B3 : G2 === "y" ? u2 = g2 : G2 === "xy" && (u2 = m3.axes);
        let p2 = m3.transform({ axes: u2, to: { x: w2 - 5, y: v3 - 5, width: 10, height: 10 }, from: { x: w2 - 5 * E2, y: v3 - 5 * E2, width: 10 * E2, height: 10 * E2 }, trigger: "mousewheel" });
        return p2 && (W2(F2) && clearTimeout(F2), F2 = setTimeout(() => {
          var C3;
          (C3 = m3.pointer) == null || C3.drop();
        }, 400)), p2;
      };
      function H2() {
        let m3 = k3(this.zooming.mouseWheel);
        m3.enabled && Y2(this.container, "wheel", (E2) => {
          var B3, g2;
          E2 = ((B3 = this.pointer) == null ? void 0 : B3.normalize(E2)) || E2;
          let { pointer: w2 } = this, v3 = w2 && !w2.inClass(E2.target, "highcharts-no-mousewheel");
          if (this.isInsidePlot(E2.chartX - this.plotLeft, E2.chartY - this.plotTop) && v3) {
            let x2 = m3.sensitivity || 1.1, G2 = E2.detail || (E2.deltaY || 0) / 120, u2 = X2(w2.getCoordinates(E2).xAxis), p2 = X2(w2.getCoordinates(E2).yAxis);
            S2(this, Math.pow(x2, G2), u2 ? [u2.axis] : this.xAxis, p2 ? [p2.axis] : this.yAxis, E2.chartX, E2.chartY, m3) && ((g2 = E2.preventDefault) == null || g2.call(E2));
          }
        });
      }
      return { compose: function(m3) {
        V2.indexOf(m3) === -1 && (V2.push(m3), Y2(m3, "afterGetContainer", H2));
      } };
    }), $2(f2, "masters/modules/mouse-wheel-zoom.src.js", [f2["Core/Globals.js"], f2["Extensions/MouseWheelZoom/MouseWheelZoom.js"]], function(D2, N2) {
      return D2.MouseWheelZoom = D2.MouseWheelZoom || N2, D2.MouseWheelZoom.compose(D2.Chart), D2;
    }), $2(f2, "masters/modules/stock.src.js", [f2["Core/Globals.js"], f2["Series/DataModifyComposition.js"], f2["Stock/Navigator/Navigator.js"], f2["Core/Axis/OrdinalAxis.js"], f2["Stock/RangeSelector/RangeSelector.js"], f2["Stock/Scrollbar/Scrollbar.js"], f2["Core/Chart/StockChart.js"], f2["Series/OHLC/OHLCSeries.js"], f2["Series/Flags/FlagsSeries.js"]], function(D2, N2, F2, Y2, Z2, _2, W2, I3, X2) {
      return D2.Navigator = D2.Navigator || F2, D2.OrdinalAxis = D2.OrdinalAxis || Y2, D2.RangeSelector = D2.RangeSelector || Z2, D2.Scrollbar = D2.Scrollbar || _2, D2.stockChart = D2.stockChart || W2.stockChart, D2.StockChart = D2.StockChart || D2.stockChart, D2.extend(D2.StockChart, W2), N2.compose(D2.Series, D2.Axis, D2.Point), X2.compose(D2.Renderer), I3.compose(D2.Series), D2.Navigator.compose(D2.Chart, D2.Axis, D2.Series), D2.OrdinalAxis.compose(D2.Axis, D2.Series, D2.Chart), D2.RangeSelector.compose(D2.Axis, D2.Chart), D2.Scrollbar.compose(D2.Axis), D2.StockChart.compose(D2.Chart, D2.Axis, D2.Series, D2.SVGRenderer), D2;
    });
  });
})(vt$1);
var Dt$1 = vt$1.exports;
const bt = /* @__PURE__ */ ce(Dt$1), wt$1 = T$7`.highcharts-navigator-handle,.highcharts-navigator-mask-inside,.highcharts-navigator-series{fill:var(--beacon-system-color-background-primary)}.highcharts-navigator-handle:hover{fill:var(--beacon-system-color-background-primary-hover)}.highcharts-navigator-mask-inside{fill:var(--beacon-system-color-background-secondary-hover);fill-opacity:1;stroke:var(--beacon-system-color-background-primary);stroke-width:var(--beacon-system-width-border-normal)}.highcharts-navigator-mask-outside{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-navigator-series{stroke:var(--beacon-system-color-data-viz-standard-1)}.highcharts-scrollbar-thumb{--thumb-color: var(--beacon-component-scrollbar-color-background-thumb);fill:var(--thumb-color);stroke:var(--thumb-color)}.highcharts-scrollbar-thumb:hover{--thumb-color: var(--beacon-component-scrollbar-color-background-thumb-hover)}.highcharts-scrollbar-track{--track-color: var(--beacon-component-scrollbar-color-background-track);fill:var(--track-color);stroke:var(--track-color)}.highcharts-range-input,.highcharts-navigator-outline{stroke:none}.highcharts-navigator-series .highcharts-area{fill-opacity:.08}`;
var Et = Object.defineProperty, Bt$1 = Object.getOwnPropertyDescriptor, gt$2 = (dt2, st2, f2, $2) => {
  for (var D2 = $2 > 1 ? void 0 : $2 ? Bt$1(st2, f2) : st2, N2 = dt2.length - 1, F2; N2 >= 0; N2--)
    (F2 = dt2[N2]) && (D2 = ($2 ? F2(st2, f2, D2) : F2(D2)) || D2);
  return $2 && D2 && Et(st2, f2, D2), D2;
};
function jt$1(dt2) {
  let st2 = class extends dt2 {
    constructor() {
      super(...arguments), this.navigator = false, this.stockChart = false, this.hideNavigator = false;
    }
    static get navigatorStyles() {
      return wt$1;
    }
    /**
     * SVG path of the left handle at non-small breakpoints
     */
    static leftHandlePath(f2, $2, D2, N2) {
      return [
        "M",
        0,
        0,
        "H",
        16,
        "V",
        N2,
        "H",
        0,
        "V",
        $2,
        "Z",
        "M",
        9,
        N2 / 2 + 4,
        "l",
        -4,
        -4,
        4,
        -4,
        "v",
        8,
        "Z"
      ];
    }
    /**
     * SVG path of the right handle at non-small breakpoints
     */
    static rightHandlePath(f2, $2, D2, N2) {
      return [
        "M",
        -16,
        0,
        "H",
        0,
        "V",
        N2,
        "H",
        -16,
        "V",
        $2,
        "Z",
        "M",
        -9,
        N2 / 2 + 4,
        "l",
        4,
        -4,
        -4,
        -4,
        "v",
        8,
        "Z"
      ];
    }
    get localComponentOptions() {
      return qa.createChartOptions(super.localComponentOptions, {
        navigator: {
          enabled: (this.navigator || this.stockChart) && !this.hideNavigator,
          handles: st2.handleOptionsDefault
        },
        responsive: {
          rules: [
            {
              condition: {
                minWidth: parseInt(C$6, 10)
              },
              chartOptions: {
                navigator: {
                  height: 44,
                  handles: {
                    height: 44
                  }
                }
              }
            },
            {
              condition: {
                minWidth: parseInt(c$8, 10)
              },
              chartOptions: {
                navigator: {
                  height: 56,
                  handles: {
                    height: 56
                  }
                }
              }
            },
            {
              condition: {
                minWidth: parseInt(n$9, 10)
              },
              chartOptions: {
                navigator: {
                  height: 64,
                  handles: {
                    height: 64
                  }
                }
              }
            }
          ]
        },
        plotOptions: {
          series: {
            marker: {
              enabled: this.navigator ? false : !this.disableMarkers
            }
          }
        }
      });
    }
    initializeHighcharts(f2) {
      super.initializeHighcharts(f2), bt(mi), f2.SVGRenderer.prototype.symbols.righthandle = st2.rightHandlePath, f2.SVGRenderer.prototype.symbols.lefthandle = st2.leftHandlePath;
    }
    createChart() {
      const f2 = qa.createChartOptions(
        this.chartOptions,
        this.localComponentOptions,
        this.filteredOptions
      );
      return this.navigator || this.stockChart ? (bt(mi), mi.stockChart(this.chartContainer, f2)) : mi.chart(this.chartContainer, f2);
    }
    willUpdate(f2) {
      var $2;
      super.willUpdate(f2), f2.has("disableMarkers") && !this.navigator && (($2 = this.chart) == null || $2.update({
        plotOptions: {
          series: { marker: { enabled: !this.disableMarkers } }
        }
      }));
    }
  };
  return st2.handleHeight = 40, st2.handleOptionsDefault = {
    height: st2.handleHeight,
    lineWidth: 0,
    symbols: ["lefthandle", "righthandle"],
    width: 16
  }, gt$2([
    v$c({ type: Boolean })
  ], st2.prototype, "navigator", 2), gt$2([
    v$c({ type: Boolean, attribute: "stock-chart" })
  ], st2.prototype, "stockChart", 2), gt$2([
    v$c({ type: Boolean, attribute: "hide-navigator" })
  ], st2.prototype, "hideNavigator", 2), st2 = gt$2([
    f$8("Navigator")
  ], st2), st2;
}
var Xt = { exports: {} };
(function(w2) {
  (function(J2) {
    w2.exports ? (J2.default = J2, w2.exports = J2) : J2(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(J2) {
    var e5 = J2 ? J2._modules : {};
    function tt2(a2, p2, c4, m3) {
      a2.hasOwnProperty(p2) || (a2[p2] = m3.apply(null, c4), typeof CustomEvent == "function" && J2.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: p2, module: a2[p2] } })));
    }
    tt2(e5, "Extensions/Pane/PaneComposition.js", [e5["Core/Utilities.js"]], function(a2) {
      let { addEvent: p2, correctFloat: c4, defined: m3, pick: N2 } = a2;
      function T2(x2) {
        let u2, l4 = this;
        return x2 && l4.pane.forEach((g2) => {
          v3(x2.chartX - l4.plotLeft, x2.chartY - l4.plotTop, g2.center) && (u2 = g2);
        }), u2;
      }
      function v3(x2, u2, l4, g2, t3) {
        let i5 = true, r3 = l4[0], o2 = l4[1], n4 = Math.sqrt(Math.pow(x2 - r3, 2) + Math.pow(u2 - o2, 2));
        if (m3(g2) && m3(t3)) {
          let h2 = Math.atan2(c4(u2 - o2, 8), c4(x2 - r3, 8));
          t3 !== g2 && (i5 = g2 > t3 ? h2 >= g2 && h2 <= Math.PI || h2 <= t3 && h2 >= -Math.PI : h2 >= g2 && h2 <= c4(t3, 8));
        }
        return n4 <= Math.ceil(l4[2] / 2) && i5;
      }
      function D2(x2) {
        this.polar && (x2.options.inverted && ([x2.x, x2.y] = [x2.y, x2.x]), x2.isInsidePlot = this.pane.some((u2) => v3(x2.x, x2.y, u2.center, u2.axis && u2.axis.normalizedStartAngleRad, u2.axis && u2.axis.normalizedEndAngleRad)));
      }
      function j3(x2) {
        let u2 = this.chart;
        x2.hoverPoint && x2.hoverPoint.plotX && x2.hoverPoint.plotY && u2.hoverPane && !v3(x2.hoverPoint.plotX, x2.hoverPoint.plotY, u2.hoverPane.center) && (x2.hoverPoint = void 0);
      }
      function B3(x2) {
        let u2 = this.chart;
        u2.polar ? (u2.hoverPane = u2.getHoverPane(x2), x2.filter = function(l4) {
          return l4.visible && !(!x2.shared && l4.directTouch) && N2(l4.options.enableMouseTracking, true) && (!u2.hoverPane || l4.xAxis.pane === u2.hoverPane);
        }) : u2.hoverPane = void 0;
      }
      return { compose: function(x2, u2) {
        let l4 = x2.prototype;
        l4.getHoverPane || (l4.collectionsWithUpdate.push("pane"), l4.getHoverPane = T2, p2(x2, "afterIsInsidePlot", D2), p2(u2, "afterGetHoverData", j3), p2(u2, "beforeGetHoverData", B3));
      } };
    }), tt2(e5, "Extensions/Pane/PaneDefaults.js", [], function() {
      return { pane: { center: ["50%", "50%"], size: "85%", innerSize: "0%", startAngle: 0 }, background: { shape: "circle", borderRadius: 0, borderWidth: 1, borderColor: "#cccccc", backgroundColor: { linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, stops: [[0, "#ffffff"], [1, "#e6e6e6"]] }, from: -Number.MAX_VALUE, innerRadius: 0, to: Number.MAX_VALUE, outerRadius: "105%" } };
    }), tt2(e5, "Extensions/Pane/Pane.js", [e5["Series/CenteredUtilities.js"], e5["Extensions/Pane/PaneComposition.js"], e5["Extensions/Pane/PaneDefaults.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3) {
      let { extend: N2, merge: T2, splat: v3 } = m3;
      class D2 {
        constructor(B3, x2) {
          this.coll = "pane", this.init(B3, x2);
        }
        init(B3, x2) {
          this.chart = x2, this.background = [], x2.pane.push(this), this.setOptions(B3);
        }
        setOptions(B3) {
          this.options = B3 = T2(c4.pane, this.chart.angular ? { background: {} } : void 0, B3);
        }
        render() {
          let B3 = this.options, x2 = this.chart.renderer;
          this.group || (this.group = x2.g("pane-group").attr({ zIndex: B3.zIndex || 0 }).add()), this.updateCenter();
          let u2 = this.options.background;
          if (u2) {
            let l4 = Math.max((u2 = v3(u2)).length, this.background.length || 0);
            for (let g2 = 0; g2 < l4; g2++) u2[g2] && this.axis ? this.renderBackground(T2(c4.background, u2[g2]), g2) : this.background[g2] && (this.background[g2] = this.background[g2].destroy(), this.background.splice(g2, 1));
          }
        }
        renderBackground(B3, x2) {
          let u2 = { class: "highcharts-pane " + (B3.className || "") }, l4 = "animate";
          this.chart.styledMode || N2(u2, { fill: B3.backgroundColor, stroke: B3.borderColor, "stroke-width": B3.borderWidth }), this.background[x2] || (this.background[x2] = this.chart.renderer.path().add(this.group), l4 = "attr"), this.background[x2][l4]({ d: this.axis.getPlotBandPath(B3.from, B3.to, B3) }).attr(u2);
        }
        updateCenter(B3) {
          this.center = (B3 || this.axis || {}).center = a2.getCenter.call(this);
        }
        update(B3, x2) {
          T2(true, this.options, B3), this.setOptions(this.options), this.render(), this.chart.axes.forEach(function(u2) {
            u2.pane === this && (u2.pane = null, u2.update({}, x2));
          }, this);
        }
      }
      return D2.compose = p2.compose, D2;
    }), tt2(e5, "Series/AreaRange/AreaRangePoint.js", [e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"]], function(a2, p2) {
      let { area: { prototype: { pointClass: c4, pointClass: { prototype: m3 } } } } = a2.seriesTypes, { defined: N2, isNumber: T2 } = p2;
      return class extends c4 {
        setState() {
          let v3 = this.state, D2 = this.series, j3 = D2.chart.polar;
          N2(this.plotHigh) || (this.plotHigh = D2.yAxis.toPixels(this.high, true)), N2(this.plotLow) || (this.plotLow = this.plotY = D2.yAxis.toPixels(this.low, true)), D2.lowerStateMarkerGraphic = D2.stateMarkerGraphic, D2.stateMarkerGraphic = D2.upperStateMarkerGraphic, this.graphic = this.graphics && this.graphics[1], this.plotY = this.plotHigh, j3 && T2(this.plotHighX) && (this.plotX = this.plotHighX), m3.setState.apply(this, arguments), this.state = v3, this.plotY = this.plotLow, this.graphic = this.graphics && this.graphics[0], j3 && T2(this.plotLowX) && (this.plotX = this.plotLowX), D2.upperStateMarkerGraphic = D2.stateMarkerGraphic, D2.stateMarkerGraphic = D2.lowerStateMarkerGraphic, D2.lowerStateMarkerGraphic = void 0;
          let B3 = D2.modifyMarkerSettings();
          m3.setState.apply(this, arguments), D2.restoreMarkerSettings(B3);
        }
        haloPath() {
          let v3 = this.series.chart.polar, D2 = [];
          return this.plotY = this.plotLow, v3 && T2(this.plotLowX) && (this.plotX = this.plotLowX), this.isInside && (D2 = m3.haloPath.apply(this, arguments)), this.plotY = this.plotHigh, v3 && T2(this.plotHighX) && (this.plotX = this.plotHighX), this.isTopInside && (D2 = D2.concat(m3.haloPath.apply(this, arguments))), D2;
        }
        isValid() {
          return T2(this.low) && T2(this.high);
        }
      };
    }), tt2(e5, "Series/AreaRange/AreaRangeSeries.js", [e5["Series/AreaRange/AreaRangePoint.js"], e5["Core/Globals.js"], e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3) {
      let { noop: N2 } = p2, { area: T2, area: { prototype: v3 }, column: { prototype: D2 } } = c4.seriesTypes, { addEvent: j3, defined: B3, extend: x2, isArray: u2, isNumber: l4, pick: g2, merge: t3 } = m3;
      class i5 extends T2 {
        toYData(o2) {
          return [o2.low, o2.high];
        }
        highToXY(o2) {
          let n4 = this.chart, h2 = this.xAxis.postTranslate(o2.rectPlotX || 0, this.yAxis.len - (o2.plotHigh || 0));
          o2.plotHighX = h2.x - n4.plotLeft, o2.plotHigh = h2.y - n4.plotTop, o2.plotLowX = o2.plotX;
        }
        getGraphPath(o2) {
          let n4 = [], h2 = [], y2 = v3.getGraphPath, M2 = this.options, z2 = this.chart.polar, S2 = z2 && M2.connectEnds !== false, L2 = M2.connectNulls, R2, P2, H2, E2 = M2.step;
          for (R2 = (o2 = o2 || this.points).length; R2--; ) {
            P2 = o2[R2];
            let I3 = z2 ? { plotX: P2.rectPlotX, plotY: P2.yBottom, doCurve: false } : { plotX: P2.plotX, plotY: P2.plotY, doCurve: false };
            P2.isNull || S2 || L2 || o2[R2 + 1] && !o2[R2 + 1].isNull || h2.push(I3), H2 = { polarPlotY: P2.polarPlotY, rectPlotX: P2.rectPlotX, yBottom: P2.yBottom, plotX: g2(P2.plotHighX, P2.plotX), plotY: P2.plotHigh, isNull: P2.isNull }, h2.push(H2), n4.push(H2), P2.isNull || S2 || L2 || o2[R2 - 1] && !o2[R2 - 1].isNull || h2.push(I3);
          }
          let s2 = y2.call(this, o2);
          E2 && (E2 === true && (E2 = "left"), M2.step = { left: "right", center: "center", right: "left" }[E2]);
          let d3 = y2.call(this, n4), b5 = y2.call(this, h2);
          M2.step = E2;
          let A3 = [].concat(s2, d3);
          return !this.chart.polar && b5[0] && b5[0][0] === "M" && (b5[0] = ["L", b5[0][1], b5[0][2]]), this.graphPath = A3, this.areaPath = s2.concat(b5), A3.isArea = true, A3.xMap = s2.xMap, this.areaPath.xMap = s2.xMap, A3;
        }
        drawDataLabels() {
          var o2, n4;
          let h2, y2, M2, z2, S2, L2 = this.points, R2 = L2.length, P2 = [], H2 = this.options.dataLabels, E2 = this.chart.inverted;
          if (H2) {
            if (u2(H2) ? (z2 = H2[0] || { enabled: false }, S2 = H2[1] || { enabled: false }) : ((z2 = x2({}, H2)).x = H2.xHigh, z2.y = H2.yHigh, (S2 = x2({}, H2)).x = H2.xLow, S2.y = H2.yLow), z2.enabled || ((o2 = this.hasDataLabels) == null ? void 0 : o2.call(this))) {
              for (h2 = R2; h2--; ) if (y2 = L2[h2]) {
                let { plotHigh: s2 = 0, plotLow: d3 = 0 } = y2;
                M2 = z2.inside ? s2 < d3 : s2 > d3, y2.y = y2.high, y2._plotY = y2.plotY, y2.plotY = s2, P2[h2] = y2.dataLabel, y2.dataLabel = y2.dataLabelUpper, y2.below = M2, E2 ? z2.align || (z2.align = M2 ? "right" : "left") : z2.verticalAlign || (z2.verticalAlign = M2 ? "top" : "bottom");
              }
              for (this.options.dataLabels = z2, v3.drawDataLabels && v3.drawDataLabels.apply(this, arguments), h2 = R2; h2--; ) (y2 = L2[h2]) && (y2.dataLabelUpper = y2.dataLabel, y2.dataLabel = P2[h2], delete y2.dataLabels, y2.y = y2.low, y2.plotY = y2._plotY);
            }
            if (S2.enabled || (n4 = this.hasDataLabels) != null && n4.call(this)) {
              for (h2 = R2; h2--; ) if (y2 = L2[h2]) {
                let { plotHigh: s2 = 0, plotLow: d3 = 0 } = y2;
                M2 = S2.inside ? s2 < d3 : s2 > d3, y2.below = !M2, E2 ? S2.align || (S2.align = M2 ? "left" : "right") : S2.verticalAlign || (S2.verticalAlign = M2 ? "bottom" : "top");
              }
              this.options.dataLabels = S2, v3.drawDataLabels && v3.drawDataLabels.apply(this, arguments);
            }
            if (z2.enabled) for (h2 = R2; h2--; ) (y2 = L2[h2]) && (y2.dataLabels = [y2.dataLabelUpper, y2.dataLabel].filter(function(s2) {
              return !!s2;
            }));
            this.options.dataLabels = H2;
          }
        }
        alignDataLabel() {
          D2.alignDataLabel.apply(this, arguments);
        }
        modifyMarkerSettings() {
          let o2 = { marker: this.options.marker, symbol: this.symbol };
          if (this.options.lowMarker) {
            let { options: { marker: n4, lowMarker: h2 } } = this;
            this.options.marker = t3(n4, h2), h2.symbol && (this.symbol = h2.symbol);
          }
          return o2;
        }
        restoreMarkerSettings(o2) {
          this.options.marker = o2.marker, this.symbol = o2.symbol;
        }
        drawPoints() {
          let o2, n4, h2 = this.points.length, y2 = this.modifyMarkerSettings();
          for (v3.drawPoints.apply(this, arguments), this.restoreMarkerSettings(y2), o2 = 0; o2 < h2; ) (n4 = this.points[o2]).graphics = n4.graphics || [], n4.origProps = { plotY: n4.plotY, plotX: n4.plotX, isInside: n4.isInside, negative: n4.negative, zone: n4.zone, y: n4.y }, (n4.graphic || n4.graphics[0]) && (n4.graphics[0] = n4.graphic), n4.graphic = n4.graphics[1], n4.plotY = n4.plotHigh, B3(n4.plotHighX) && (n4.plotX = n4.plotHighX), n4.y = g2(n4.high, n4.origProps.y), n4.negative = n4.y < (this.options.threshold || 0), this.zones.length && (n4.zone = n4.getZone()), this.chart.polar || (n4.isInside = n4.isTopInside = n4.plotY !== void 0 && n4.plotY >= 0 && n4.plotY <= this.yAxis.len && n4.plotX >= 0 && n4.plotX <= this.xAxis.len), o2++;
          for (v3.drawPoints.apply(this, arguments), o2 = 0; o2 < h2; ) (n4 = this.points[o2]).graphics = n4.graphics || [], (n4.graphic || n4.graphics[1]) && (n4.graphics[1] = n4.graphic), n4.graphic = n4.graphics[0], n4.origProps && (x2(n4, n4.origProps), delete n4.origProps), o2++;
        }
        hasMarkerChanged(o2, n4) {
          let h2 = o2.lowMarker, y2 = n4.lowMarker || {};
          return h2 && (h2.enabled === false || y2.symbol !== h2.symbol || y2.height !== h2.height || y2.width !== h2.width) || super.hasMarkerChanged(o2, n4);
        }
      }
      return i5.defaultOptions = t3(T2.defaultOptions, { lineWidth: 1, threshold: null, tooltip: { pointFormat: '<span style="color:{series.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>' }, trackByArea: true, dataLabels: { align: void 0, verticalAlign: void 0, xLow: 0, xHigh: 0, yLow: 0, yHigh: 0 } }), j3(i5, "afterTranslate", function() {
        this.pointArrayMap.join(",") === "low,high" && this.points.forEach((r3) => {
          let o2 = r3.high, n4 = r3.plotY;
          r3.isNull ? r3.plotY = void 0 : (r3.plotLow = n4, r3.plotHigh = l4(o2) ? this.yAxis.translate(this.dataModify ? this.dataModify.modifyValue(o2) : o2, false, true, void 0, true) : void 0, this.dataModify && (r3.yBottom = r3.plotHigh));
        });
      }, { order: 0 }), j3(i5, "afterTranslate", function() {
        this.points.forEach((r3) => {
          if (this.chart.polar) this.highToXY(r3), r3.plotLow = r3.plotY, r3.tooltipPos = [((r3.plotHighX || 0) + (r3.plotLowX || 0)) / 2, ((r3.plotHigh || 0) + (r3.plotLow || 0)) / 2];
          else {
            let o2 = r3.pos(false, r3.plotLow), n4 = r3.pos(false, r3.plotHigh);
            o2 && n4 && (o2[0] = (o2[0] + n4[0]) / 2, o2[1] = (o2[1] + n4[1]) / 2), r3.tooltipPos = o2;
          }
        });
      }, { order: 3 }), x2(i5.prototype, { deferTranslatePolar: true, pointArrayMap: ["low", "high"], pointClass: a2, pointValKey: "low", setStackedPoints: N2 }), c4.registerSeriesType("arearange", i5), i5;
    }), tt2(e5, "Series/AreaSplineRange/AreaSplineRangeSeries.js", [e5["Series/AreaRange/AreaRangeSeries.js"], e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"]], function(a2, p2, c4) {
      let { spline: { prototype: m3 } } = p2.seriesTypes, { merge: N2, extend: T2 } = c4;
      class v3 extends a2 {
      }
      return v3.defaultOptions = N2(a2.defaultOptions), T2(v3.prototype, { getPointSpline: m3.getPointSpline }), p2.registerSeriesType("areasplinerange", v3), v3;
    }), tt2(e5, "Series/BoxPlot/BoxPlotSeriesDefaults.js", [], function() {
      return { threshold: null, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b>{series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>' }, whiskerLength: "50%", fillColor: "#ffffff", lineWidth: 1, medianWidth: 2, whiskerWidth: 2 };
    }), tt2(e5, "Series/BoxPlot/BoxPlotSeries.js", [e5["Series/BoxPlot/BoxPlotSeriesDefaults.js"], e5["Series/Column/ColumnSeries.js"], e5["Core/Globals.js"], e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3, N2) {
      let { noop: T2 } = c4, { crisp: v3, extend: D2, merge: j3, pick: B3 } = N2;
      class x2 extends p2 {
        pointAttribs() {
          return {};
        }
        translate() {
          let l4 = this.yAxis, g2 = this.pointArrayMap;
          super.translate.apply(this), this.points.forEach(function(t3) {
            g2.forEach(function(i5) {
              t3[i5] !== null && (t3[i5 + "Plot"] = l4.translate(t3[i5], 0, 1, 0, 1));
            }), t3.plotHigh = t3.highPlot;
          });
        }
        drawPoints() {
          let l4, g2, t3, i5, r3, o2, n4, h2, y2, M2, z2, S2, L2, R2 = this.points, P2 = this.options, H2 = this.chart, E2 = H2.renderer, s2 = this.doQuartiles !== false, d3 = this.options.whiskerLength;
          for (let b5 of R2) {
            let A3 = (h2 = b5.graphic) ? "animate" : "attr", I3 = b5.shapeArgs, C3 = {}, $2 = {}, F2 = {}, rt2 = {}, O3 = b5.color || this.color;
            if (b5.plotY !== void 0) {
              let f2;
              y2 = I3.width, z2 = (M2 = I3.x) + y2, S2 = y2 / 2, l4 = s2 ? b5.q1Plot : b5.lowPlot, g2 = s2 ? b5.q3Plot : b5.lowPlot, t3 = b5.highPlot, i5 = b5.lowPlot, h2 || (b5.graphic = h2 = E2.g("point").add(this.group), b5.stem = E2.path().addClass("highcharts-boxplot-stem").add(h2), d3 && (b5.whiskers = E2.path().addClass("highcharts-boxplot-whisker").add(h2)), s2 && (b5.box = E2.path(n4).addClass("highcharts-boxplot-box").add(h2)), b5.medianShape = E2.path(o2).addClass("highcharts-boxplot-median").add(h2)), H2.styledMode || ($2.stroke = b5.stemColor || P2.stemColor || O3, $2["stroke-width"] = B3(b5.stemWidth, P2.stemWidth, P2.lineWidth), $2.dashstyle = b5.stemDashStyle || P2.stemDashStyle || P2.dashStyle, b5.stem.attr($2), d3 && (F2.stroke = b5.whiskerColor || P2.whiskerColor || O3, F2["stroke-width"] = B3(b5.whiskerWidth, P2.whiskerWidth, P2.lineWidth), F2.dashstyle = b5.whiskerDashStyle || P2.whiskerDashStyle || P2.dashStyle, b5.whiskers.attr(F2)), s2 && (C3.fill = b5.fillColor || P2.fillColor || O3, C3.stroke = P2.lineColor || O3, C3["stroke-width"] = P2.lineWidth || 0, C3.dashstyle = b5.boxDashStyle || P2.boxDashStyle || P2.dashStyle, b5.box.attr(C3)), rt2.stroke = b5.medianColor || P2.medianColor || O3, rt2["stroke-width"] = B3(b5.medianWidth, P2.medianWidth, P2.lineWidth), rt2.dashstyle = b5.medianDashStyle || P2.medianDashStyle || P2.dashStyle, b5.medianShape.attr(rt2));
              let Y2 = v3((b5.plotX || 0) + (this.pointXOffset || 0) + (this.barW || 0) / 2, b5.stem.strokeWidth());
              if (f2 = [["M", Y2, g2], ["L", Y2, t3], ["M", Y2, l4], ["L", Y2, i5]], b5.stem[A3]({ d: f2 }), s2) {
                let X2 = b5.box.strokeWidth();
                l4 = v3(l4, X2), g2 = v3(g2, X2), f2 = [["M", M2 = v3(M2, X2), g2], ["L", M2, l4], ["L", z2 = v3(z2, X2), l4], ["L", z2, g2], ["L", M2, g2], ["Z"]], b5.box[A3]({ d: f2 });
              }
              if (d3) {
                let X2 = b5.whiskers.strokeWidth();
                t3 = v3(b5.highPlot, X2), i5 = v3(b5.lowPlot, X2), f2 = [["M", v3(Y2 - (L2 = typeof d3 == "string" && /%$/.test(d3) ? S2 * parseFloat(d3) / 100 : Number(d3) / 2)), t3], ["L", v3(Y2 + L2), t3], ["M", v3(Y2 - L2), i5], ["L", v3(Y2 + L2), i5]], b5.whiskers[A3]({ d: f2 });
              }
              f2 = [["M", M2, r3 = v3(b5.medianPlot, b5.medianShape.strokeWidth())], ["L", z2, r3]], b5.medianShape[A3]({ d: f2 });
            }
          }
        }
        toYData(l4) {
          return [l4.low, l4.q1, l4.median, l4.q3, l4.high];
        }
      }
      return x2.defaultOptions = j3(p2.defaultOptions, a2), D2(x2.prototype, { pointArrayMap: ["low", "q1", "median", "q3", "high"], pointValKey: "high", drawDataLabels: T2, setStackedPoints: T2 }), m3.registerSeriesType("boxplot", x2), x2;
    }), tt2(e5, "Series/Bubble/BubbleLegendDefaults.js", [], function() {
      return { borderColor: void 0, borderWidth: 2, className: void 0, color: void 0, connectorClassName: void 0, connectorColor: void 0, connectorDistance: 60, connectorWidth: 1, enabled: false, labels: { className: void 0, allowOverlap: false, format: "", formatter: void 0, align: "right", style: { fontSize: "0.9em", color: "#000000" }, x: 0, y: 0 }, maxSize: 60, minSize: 10, legendIndex: 0, ranges: { value: void 0, borderColor: void 0, color: void 0, connectorColor: void 0 }, sizeBy: "area", sizeByAbsoluteValue: false, zIndex: 1, zThreshold: 0 };
    }), tt2(e5, "Series/Bubble/BubbleLegendItem.js", [e5["Core/Color/Color.js"], e5["Core/Templating.js"], e5["Core/Globals.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3) {
      let { parse: N2 } = a2, { noop: T2 } = c4, { arrayMax: v3, arrayMin: D2, isNumber: j3, merge: B3, pick: x2, stableSort: u2 } = m3;
      return class {
        constructor(l4, g2) {
          this.setState = T2, this.init(l4, g2);
        }
        init(l4, g2) {
          this.options = l4, this.visible = true, this.chart = g2.chart, this.legend = g2;
        }
        addToLegend(l4) {
          l4.splice(this.options.legendIndex, 0, this);
        }
        drawLegendSymbol(l4) {
          let g2, t3 = x2(l4.options.itemDistance, 20), i5 = this.legendItem || {}, r3 = this.options, o2 = r3.ranges, n4 = r3.connectorDistance;
          if (!o2 || !o2.length || !j3(o2[0].value)) {
            l4.options.bubbleLegend.autoRanges = true;
            return;
          }
          u2(o2, function(z2, S2) {
            return S2.value - z2.value;
          }), this.ranges = o2, this.setOptions(), this.render();
          let h2 = this.getMaxLabelSize(), y2 = this.ranges[0].radius, M2 = 2 * y2;
          g2 = (g2 = n4 - y2 + h2.width) > 0 ? g2 : 0, this.maxLabel = h2, this.movementX = r3.labels.align === "left" ? g2 : 0, i5.labelWidth = M2 + g2 + t3, i5.labelHeight = M2 + h2.height / 2;
        }
        setOptions() {
          let l4 = this.ranges, g2 = this.options, t3 = this.chart.series[g2.seriesIndex], i5 = this.legend.baseline, r3 = { zIndex: g2.zIndex, "stroke-width": g2.borderWidth }, o2 = { zIndex: g2.zIndex, "stroke-width": g2.connectorWidth }, n4 = { align: this.legend.options.rtl || g2.labels.align === "left" ? "right" : "left", zIndex: g2.zIndex }, h2 = t3.options.marker.fillOpacity, y2 = this.chart.styledMode;
          l4.forEach(function(M2, z2) {
            y2 || (r3.stroke = x2(M2.borderColor, g2.borderColor, t3.color), r3.fill = x2(M2.color, g2.color, h2 !== 1 ? N2(t3.color).setOpacity(h2).get("rgba") : t3.color), o2.stroke = x2(M2.connectorColor, g2.connectorColor, t3.color)), l4[z2].radius = this.getRangeRadius(M2.value), l4[z2] = B3(l4[z2], { center: l4[0].radius - l4[z2].radius + i5 }), y2 || B3(true, l4[z2], { bubbleAttribs: B3(r3), connectorAttribs: B3(o2), labelAttribs: n4 });
          }, this);
        }
        getRangeRadius(l4) {
          let g2 = this.options, t3 = this.options.seriesIndex, i5 = this.chart.series[t3], r3 = g2.ranges[0].value, o2 = g2.ranges[g2.ranges.length - 1].value, n4 = g2.minSize, h2 = g2.maxSize;
          return i5.getRadius.call(this, o2, r3, n4, h2, l4);
        }
        render() {
          let l4 = this.legendItem || {}, g2 = this.chart.renderer, t3 = this.options.zThreshold;
          for (let i5 of (this.symbols || (this.symbols = { connectors: [], bubbleItems: [], labels: [] }), l4.symbol = g2.g("bubble-legend"), l4.label = g2.g("bubble-legend-item").css(this.legend.itemStyle || {}), l4.symbol.translateX = 0, l4.symbol.translateY = 0, l4.symbol.add(l4.label), l4.label.add(l4.group), this.ranges)) i5.value >= t3 && this.renderRange(i5);
          this.hideOverlappingLabels();
        }
        renderRange(l4) {
          let g2 = this.ranges[0], t3 = this.legend, i5 = this.options, r3 = i5.labels, o2 = this.chart, n4 = o2.series[i5.seriesIndex], h2 = o2.renderer, y2 = this.symbols, M2 = y2.labels, z2 = l4.center, S2 = Math.abs(l4.radius), L2 = i5.connectorDistance || 0, R2 = r3.align, P2 = t3.options.rtl, H2 = i5.borderWidth, E2 = i5.connectorWidth, s2 = g2.radius || 0, d3 = z2 - S2 - H2 / 2 + E2 / 2, b5 = (d3 % 1 ? 1 : 0.5) - (E2 % 2 ? 0 : 0.5), A3 = h2.styledMode, I3 = P2 || R2 === "left" ? -L2 : L2;
          R2 === "center" && (I3 = 0, i5.connectorDistance = 0, l4.labelAttribs.align = "center"), y2.bubbleItems.push(h2.circle(s2, z2 + b5, S2).attr(A3 ? {} : l4.bubbleAttribs).addClass((A3 ? "highcharts-color-" + n4.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (i5.className || "")).add(this.legendItem.symbol)), y2.connectors.push(h2.path(h2.crispLine([["M", s2, d3], ["L", s2 + I3, d3]], i5.connectorWidth)).attr(A3 ? {} : l4.connectorAttribs).addClass((A3 ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (i5.connectorClassName || "")).add(this.legendItem.symbol));
          let C3 = h2.text(this.formatLabel(l4)).attr(A3 ? {} : l4.labelAttribs).css(A3 ? {} : r3.style).addClass("highcharts-bubble-legend-labels " + (i5.labels.className || "")).add(this.legendItem.symbol), $2 = { x: s2 + I3 + i5.labels.x, y: d3 + i5.labels.y + 0.4 * C3.getBBox().height };
          C3.attr($2), M2.push(C3), C3.placed = true, C3.alignAttr = $2;
        }
        getMaxLabelSize() {
          let l4, g2;
          return this.symbols.labels.forEach(function(t3) {
            g2 = t3.getBBox(true), l4 = l4 ? g2.width > l4.width ? g2 : l4 : g2;
          }), l4 || {};
        }
        formatLabel(l4) {
          let g2 = this.options, t3 = g2.labels.formatter, i5 = g2.labels.format, { numberFormatter: r3 } = this.chart;
          return i5 ? p2.format(i5, l4) : t3 ? t3.call(l4) : r3(l4.value, 1);
        }
        hideOverlappingLabels() {
          let l4 = this.chart, g2 = this.options.labels.allowOverlap, t3 = this.symbols;
          !g2 && t3 && (l4.hideOverlappingLabels(t3.labels), t3.labels.forEach(function(i5, r3) {
            i5.newOpacity ? i5.newOpacity !== i5.oldOpacity && t3.connectors[r3].show() : t3.connectors[r3].hide();
          }));
        }
        getRanges() {
          let l4 = this.legend.bubbleLegend, g2 = l4.chart.series, t3 = l4.options.ranges, i5, r3, o2 = Number.MAX_VALUE, n4 = -Number.MAX_VALUE;
          return g2.forEach(function(h2) {
            h2.isBubble && !h2.ignoreSeries && (r3 = h2.zData.filter(j3)).length && (o2 = x2(h2.options.zMin, Math.min(o2, Math.max(D2(r3), h2.options.displayNegative === false ? h2.options.zThreshold : -Number.MAX_VALUE))), n4 = x2(h2.options.zMax, Math.max(n4, v3(r3))));
          }), i5 = o2 === n4 ? [{ value: n4 }] : [{ value: o2 }, { value: (o2 + n4) / 2 }, { value: n4, autoRanges: true }], t3.length && t3[0].radius && i5.reverse(), i5.forEach(function(h2, y2) {
            t3 && t3[y2] && (i5[y2] = B3(t3[y2], h2));
          }), i5;
        }
        predictBubbleSizes() {
          let l4 = this.chart, g2 = l4.legend.options, t3 = g2.floating, i5 = g2.layout === "horizontal", r3 = i5 ? l4.legend.lastLineHeight : 0, o2 = l4.plotSizeX, n4 = l4.plotSizeY, h2 = l4.series[this.options.seriesIndex], y2 = h2.getPxExtremes(), M2 = Math.ceil(y2.minPxSize), z2 = Math.ceil(y2.maxPxSize), S2 = Math.min(n4, o2), L2, R2 = h2.options.maxSize;
          return t3 || !/%$/.test(R2) ? L2 = z2 : (L2 = (S2 + r3) * (R2 = parseFloat(R2)) / 100 / (R2 / 100 + 1), (i5 && n4 - L2 >= o2 || !i5 && o2 - L2 >= n4) && (L2 = z2)), [M2, Math.ceil(L2)];
        }
        updateRanges(l4, g2) {
          let t3 = this.legend.options.bubbleLegend;
          t3.minSize = l4, t3.maxSize = g2, t3.ranges = this.getRanges();
        }
        correctSizes() {
          let l4 = this.legend, g2 = this.chart.series[this.options.seriesIndex].getPxExtremes();
          Math.abs(Math.ceil(g2.maxPxSize) - this.options.maxSize) > 1 && (this.updateRanges(this.options.minSize, g2.maxPxSize), l4.render());
        }
      };
    }), tt2(e5, "Series/Bubble/BubbleLegendComposition.js", [e5["Series/Bubble/BubbleLegendDefaults.js"], e5["Series/Bubble/BubbleLegendItem.js"], e5["Core/Defaults.js"], e5["Core/Globals.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3, N2) {
      let { setOptions: T2 } = c4, { composed: v3 } = m3, { addEvent: D2, objectEach: j3, pushUnique: B3, wrap: x2 } = N2;
      function u2(o2, n4, h2) {
        let y2, M2, z2, S2 = this.legend, L2 = l4(this) >= 0;
        S2 && S2.options.enabled && S2.bubbleLegend && S2.options.bubbleLegend.autoRanges && L2 ? (y2 = S2.bubbleLegend.options, M2 = S2.bubbleLegend.predictBubbleSizes(), S2.bubbleLegend.updateRanges(M2[0], M2[1]), y2.placed || (S2.group.placed = false, S2.allItems.forEach((R2) => {
          (z2 = R2.legendItem || {}).group && (z2.group.translateY = void 0);
        })), S2.render(), y2.placed || (this.getMargins(), this.axes.forEach(function(R2) {
          R2.visible && R2.render(), y2.placed || (R2.setScale(), R2.updateNames(), j3(R2.ticks, function(P2) {
            P2.isNew = true, P2.isNewLabel = true;
          }));
        }), this.getMargins()), y2.placed = true, o2.call(this, n4, h2), S2.bubbleLegend.correctSizes(), r3(S2, g2(S2))) : (o2.call(this, n4, h2), S2 && S2.options.enabled && S2.bubbleLegend && (S2.render(), r3(S2, g2(S2))));
      }
      function l4(o2) {
        let n4 = o2.series, h2 = 0;
        for (; h2 < n4.length; ) {
          if (n4[h2] && n4[h2].isBubble && n4[h2].visible && n4[h2].zData.length) return h2;
          h2++;
        }
        return -1;
      }
      function g2(o2) {
        let n4 = o2.allItems, h2 = [], y2 = n4.length, M2, z2, S2, L2 = 0, R2 = 0;
        for (L2 = 0; L2 < y2; L2++) if (z2 = n4[L2].legendItem || {}, S2 = (n4[L2 + 1] || {}).legendItem || {}, z2.labelHeight && (n4[L2].itemHeight = z2.labelHeight), n4[L2] === n4[y2 - 1] || z2.y !== S2.y) {
          for (h2.push({ height: 0 }), M2 = h2[h2.length - 1]; R2 <= L2; R2++) n4[R2].itemHeight > M2.height && (M2.height = n4[R2].itemHeight);
          M2.step = L2;
        }
        return h2;
      }
      function t3(o2) {
        let n4 = this.bubbleLegend, h2 = this.options, y2 = h2.bubbleLegend, M2 = l4(this.chart);
        n4 && n4.ranges && n4.ranges.length && (y2.ranges.length && (y2.autoRanges = !!y2.ranges[0].autoRanges), this.destroyItem(n4)), M2 >= 0 && h2.enabled && y2.enabled && (y2.seriesIndex = M2, this.bubbleLegend = new p2(y2, this), this.bubbleLegend.addToLegend(o2.allItems));
      }
      function i5(o2) {
        let n4;
        if (o2.defaultPrevented) return false;
        let h2 = o2.legendItem, y2 = this.chart, M2 = h2.visible;
        this && this.bubbleLegend && (h2.visible = !M2, h2.ignoreSeries = M2, n4 = l4(y2) >= 0, this.bubbleLegend.visible !== n4 && (this.update({ bubbleLegend: { enabled: n4 } }), this.bubbleLegend.visible = n4), h2.visible = M2);
      }
      function r3(o2, n4) {
        let h2 = o2.allItems, y2 = o2.options.rtl, M2, z2, S2, L2, R2 = 0;
        h2.forEach((P2, H2) => {
          (L2 = P2.legendItem || {}).group && (M2 = L2.group.translateX || 0, z2 = L2.y || 0, ((S2 = P2.movementX) || y2 && P2.ranges) && (S2 = y2 ? M2 - P2.options.maxSize / 2 : M2 + S2, L2.group.attr({ translateX: S2 })), H2 > n4[R2].step && R2++, L2.group.attr({ translateY: Math.round(z2 + n4[R2].height / 2) }), L2.y = z2 + n4[R2].height / 2);
        });
      }
      return { compose: function(o2, n4) {
        B3(v3, "Series.BubbleLegend") && (T2({ legend: { bubbleLegend: a2 } }), x2(o2.prototype, "drawChartBox", u2), D2(n4, "afterGetAllItems", t3), D2(n4, "itemClick", i5));
      } };
    }), tt2(e5, "Series/Bubble/BubblePoint.js", [e5["Core/Series/Point.js"], e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"]], function(a2, p2, c4) {
      let { seriesTypes: { scatter: { prototype: { pointClass: m3 } } } } = p2, { extend: N2 } = c4;
      class T2 extends m3 {
        haloPath(D2) {
          let j3 = (D2 && this.marker && this.marker.radius || 0) + D2;
          if (this.series.chart.inverted) {
            let B3 = this.pos() || [0, 0], { xAxis: x2, yAxis: u2, chart: l4 } = this.series;
            return l4.renderer.symbols.circle(x2.len - B3[1] - j3, u2.len - B3[0] - j3, 2 * j3, 2 * j3);
          }
          return a2.prototype.haloPath.call(this, j3);
        }
      }
      return N2(T2.prototype, { ttBelow: false }), T2;
    }), tt2(e5, "Series/Bubble/BubbleSeries.js", [e5["Series/Bubble/BubbleLegendComposition.js"], e5["Series/Bubble/BubblePoint.js"], e5["Core/Color/Color.js"], e5["Core/Globals.js"], e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3, N2, T2) {
      let { parse: v3 } = c4, { composed: D2, noop: j3 } = m3, { series: B3, seriesTypes: { column: { prototype: x2 }, scatter: u2 } } = N2, { addEvent: l4, arrayMax: g2, arrayMin: t3, clamp: i5, extend: r3, isNumber: o2, merge: n4, pick: h2, pushUnique: y2 } = T2;
      function M2() {
        let S2 = this.len, { coll: L2, isXAxis: R2, min: P2 } = this, H2 = R2 ? "xData" : "yData", E2 = (this.max || 0) - (P2 || 0), s2 = 0, d3 = S2, b5 = S2 / E2, A3;
        (L2 === "xAxis" || L2 === "yAxis") && (this.series.forEach((I3) => {
          if (I3.bubblePadding && I3.reserveSpace()) {
            this.allowZoomOutside = true, A3 = true;
            let C3 = I3[H2];
            if (R2 && ((I3.onPoint || I3).getRadii(0, 0, I3), I3.onPoint && (I3.radii = I3.onPoint.radii)), E2 > 0) {
              let $2 = C3.length;
              for (; $2--; ) if (o2(C3[$2]) && this.dataMin <= C3[$2] && C3[$2] <= this.max) {
                let F2 = I3.radii && I3.radii[$2] || 0;
                s2 = Math.min((C3[$2] - P2) * b5 - F2, s2), d3 = Math.max((C3[$2] - P2) * b5 + F2, d3);
              }
            }
          }
        }), A3 && E2 > 0 && !this.logarithmic && (d3 -= S2, b5 *= (S2 + Math.max(0, s2) - Math.min(d3, S2)) / S2, [["min", "userMin", s2], ["max", "userMax", d3]].forEach((I3) => {
          h2(this.options[I3[0]], this[I3[1]]) === void 0 && (this[I3[0]] += I3[2] / b5);
        })));
      }
      class z2 extends u2 {
        static compose(L2, R2, P2) {
          a2.compose(R2, P2), y2(D2, "Series.Bubble") && l4(L2, "foundExtremes", M2);
        }
        animate(L2) {
          !L2 && this.points.length < this.options.animationLimit && this.points.forEach(function(R2) {
            let { graphic: P2, plotX: H2 = 0, plotY: E2 = 0 } = R2;
            P2 && P2.width && (this.hasRendered || P2.attr({ x: H2, y: E2, width: 1, height: 1 }), P2.animate(this.markerAttribs(R2), this.options.animation));
          }, this);
        }
        getRadii() {
          let L2 = this.zData, R2 = this.yData, P2 = [], H2, E2, s2, d3 = this.chart.bubbleZExtremes, { minPxSize: b5, maxPxSize: A3 } = this.getPxExtremes();
          if (!d3) {
            let I3, C3 = Number.MAX_VALUE, $2 = -Number.MAX_VALUE;
            this.chart.series.forEach((F2) => {
              if (F2.bubblePadding && F2.reserveSpace()) {
                let rt2 = (F2.onPoint || F2).getZExtremes();
                rt2 && (C3 = Math.min(h2(C3, rt2.zMin), rt2.zMin), $2 = Math.max(h2($2, rt2.zMax), rt2.zMax), I3 = true);
              }
            }), I3 ? (d3 = { zMin: C3, zMax: $2 }, this.chart.bubbleZExtremes = d3) : d3 = { zMin: 0, zMax: 0 };
          }
          for (E2 = 0, H2 = L2.length; E2 < H2; E2++) s2 = L2[E2], P2.push(this.getRadius(d3.zMin, d3.zMax, b5, A3, s2, R2 && R2[E2]));
          this.radii = P2;
        }
        getRadius(L2, R2, P2, H2, E2, s2) {
          let d3 = this.options, b5 = d3.sizeBy !== "width", A3 = d3.zThreshold, I3 = R2 - L2, C3 = 0.5;
          if (s2 === null || E2 === null) return null;
          if (o2(E2)) {
            if (d3.sizeByAbsoluteValue && (E2 = Math.abs(E2 - A3), R2 = I3 = Math.max(R2 - A3, Math.abs(L2 - A3)), L2 = 0), E2 < L2) return P2 / 2 - 1;
            I3 > 0 && (C3 = (E2 - L2) / I3);
          }
          return b5 && C3 >= 0 && (C3 = Math.sqrt(C3)), Math.ceil(P2 + C3 * (H2 - P2)) / 2;
        }
        hasData() {
          return !!this.processedXData.length;
        }
        markerAttribs(L2, R2) {
          let P2 = super.markerAttribs(L2, R2), { height: H2 = 0, width: E2 = 0 } = P2;
          return this.chart.inverted ? r3(P2, { x: (L2.plotX || 0) - E2 / 2, y: (L2.plotY || 0) - H2 / 2 }) : P2;
        }
        pointAttribs(L2, R2) {
          let P2 = this.options.marker.fillOpacity, H2 = B3.prototype.pointAttribs.call(this, L2, R2);
          return P2 !== 1 && (H2.fill = v3(H2.fill).setOpacity(P2).get("rgba")), H2;
        }
        translate() {
          super.translate.call(this), this.getRadii(), this.translateBubble();
        }
        translateBubble() {
          let { data: L2, options: R2, radii: P2 } = this, { minPxSize: H2 } = this.getPxExtremes(), E2 = L2.length;
          for (; E2--; ) {
            let s2 = L2[E2], d3 = P2 ? P2[E2] : 0;
            this.zoneAxis === "z" && (s2.negative = (s2.z || 0) < (R2.zThreshold || 0)), o2(d3) && d3 >= H2 / 2 ? (s2.marker = r3(s2.marker, { radius: d3, width: 2 * d3, height: 2 * d3 }), s2.dlBox = { x: s2.plotX - d3, y: s2.plotY - d3, width: 2 * d3, height: 2 * d3 }) : (s2.shapeArgs = s2.plotY = s2.dlBox = void 0, s2.isInside = false);
          }
        }
        getPxExtremes() {
          let L2 = Math.min(this.chart.plotWidth, this.chart.plotHeight), R2 = (E2) => {
            let s2;
            return typeof E2 == "string" && (s2 = /%$/.test(E2), E2 = parseInt(E2, 10)), s2 ? L2 * E2 / 100 : E2;
          }, P2 = R2(h2(this.options.minSize, 8)), H2 = Math.max(R2(h2(this.options.maxSize, "20%")), P2);
          return { minPxSize: P2, maxPxSize: H2 };
        }
        getZExtremes() {
          let L2 = this.options, R2 = (this.zData || []).filter(o2);
          if (R2.length) {
            let P2 = h2(L2.zMin, i5(t3(R2), L2.displayNegative === false ? L2.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)), H2 = h2(L2.zMax, g2(R2));
            if (o2(P2) && o2(H2)) return { zMin: P2, zMax: H2 };
          }
        }
      }
      return z2.defaultOptions = n4(u2.defaultOptions, { dataLabels: { formatter: function() {
        let { numberFormatter: S2 } = this.series.chart, { z: L2 } = this.point;
        return o2(L2) ? S2(L2, -1) : "";
      }, inside: true, verticalAlign: "middle" }, animationLimit: 250, marker: { lineColor: null, lineWidth: 1, fillOpacity: 0.5, radius: null, states: { hover: { radiusPlus: 0 } }, symbol: "circle" }, minSize: 8, maxSize: "20%", softThreshold: false, states: { hover: { halo: { size: 5 } } }, tooltip: { pointFormat: "({point.x}, {point.y}), Size: {point.z}" }, turboThreshold: 0, zThreshold: 0, zoneAxis: "z" }), r3(z2.prototype, { alignDataLabel: x2.alignDataLabel, applyZones: j3, bubblePadding: true, isBubble: true, pointArrayMap: ["y", "z"], pointClass: p2, parallelArrays: ["x", "y", "z"], trackerGroups: ["group", "dataLabelsGroup"], specialGroup: "group", zoneAxis: "z" }), l4(z2, "updatedData", (S2) => {
        delete S2.target.chart.bubbleZExtremes;
      }), l4(z2, "remove", (S2) => {
        delete S2.target.chart.bubbleZExtremes;
      }), N2.registerSeriesType("bubble", z2), z2;
    }), tt2(e5, "Series/ColumnRange/ColumnRangePoint.js", [e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"]], function(a2, p2) {
      let { seriesTypes: { column: { prototype: { pointClass: { prototype: c4 } } }, arearange: { prototype: { pointClass: m3 } } } } = a2, { extend: N2, isNumber: T2 } = p2;
      class v3 extends m3 {
        isValid() {
          return T2(this.low);
        }
      }
      return N2(v3.prototype, { setState: c4.setState }), v3;
    }), tt2(e5, "Series/ColumnRange/ColumnRangeSeries.js", [e5["Series/ColumnRange/ColumnRangePoint.js"], e5["Core/Globals.js"], e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3) {
      let { noop: N2 } = p2, { seriesTypes: { arearange: T2, column: v3, column: { prototype: D2 } } } = c4, { addEvent: j3, clamp: B3, extend: x2, isNumber: u2, merge: l4, pick: g2 } = m3;
      class t3 extends T2 {
        setOptions() {
          return l4(true, arguments[0], { stacking: void 0 }), T2.prototype.setOptions.apply(this, arguments);
        }
        translate() {
          return D2.translate.apply(this);
        }
        pointAttribs() {
          return D2.pointAttribs.apply(this, arguments);
        }
        translate3dPoints() {
          return D2.translate3dPoints.apply(this, arguments);
        }
        translate3dShapes() {
          return D2.translate3dShapes.apply(this, arguments);
        }
        afterColumnTranslate() {
          let r3, o2, n4, h2, y2 = this.yAxis, M2 = this.xAxis, z2 = M2.startAngleRad, S2 = this.chart, L2 = this.xAxis.isRadial, R2 = Math.max(S2.chartWidth, S2.chartHeight) + 999;
          this.points.forEach((P2) => {
            let H2 = P2.shapeArgs || {}, E2 = this.options.minPointLength, s2 = P2.plotY, d3 = y2.translate(P2.high, 0, 1, 0, 1);
            if (u2(d3) && u2(s2))
              if (P2.plotHigh = B3(d3, -R2, R2), P2.plotLow = B3(s2, -R2, R2), h2 = P2.plotHigh, Math.abs(r3 = g2(P2.rectPlotY, P2.plotY) - P2.plotHigh) < E2 ? (o2 = E2 - r3, r3 += o2, h2 -= o2 / 2) : r3 < 0 && (r3 *= -1, h2 -= r3), L2 && this.polar) n4 = P2.barX + z2, P2.shapeType = "arc", P2.shapeArgs = this.polar.arc(h2 + r3, h2, n4, n4 + P2.pointWidth);
              else {
                H2.height = r3, H2.y = h2;
                let { x: b5 = 0, width: A3 = 0 } = H2;
                P2.shapeArgs = l4(P2.shapeArgs, this.crispCol(b5, h2, A3, r3)), P2.tooltipPos = S2.inverted ? [y2.len + y2.pos - S2.plotLeft - h2 - r3 / 2, M2.len + M2.pos - S2.plotTop - b5 - A3 / 2, r3] : [M2.left - S2.plotLeft + b5 + A3 / 2, y2.pos - S2.plotTop + h2 + r3 / 2, r3];
              }
          });
        }
      }
      return t3.defaultOptions = l4(v3.defaultOptions, T2.defaultOptions, { borderRadius: { where: "all" }, pointRange: null, legendSymbol: "rectangle", marker: null, states: { hover: { halo: false } } }), j3(t3, "afterColumnTranslate", function() {
        t3.prototype.afterColumnTranslate.apply(this);
      }, { order: 5 }), x2(t3.prototype, { directTouch: true, pointClass: a2, trackerGroups: ["group", "dataLabelsGroup"], adjustForMissingColumns: D2.adjustForMissingColumns, animate: D2.animate, crispCol: D2.crispCol, drawGraph: N2, drawPoints: D2.drawPoints, getSymbol: N2, drawTracker: D2.drawTracker, getColumnMetrics: D2.getColumnMetrics }), c4.registerSeriesType("columnrange", t3), t3;
    }), tt2(e5, "Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js", [], function() {
      return {};
    }), tt2(e5, "Series/ColumnPyramid/ColumnPyramidSeries.js", [e5["Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js"], e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"]], function(a2, p2, c4) {
      let { column: m3 } = p2.seriesTypes, { clamp: N2, merge: T2, pick: v3 } = c4;
      class D2 extends m3 {
        translate() {
          let B3 = this.chart, x2 = this.options, u2 = this.dense = this.closestPointRange * this.xAxis.transA < 2, l4 = this.borderWidth = v3(x2.borderWidth, u2 ? 0 : 1), g2 = this.yAxis, t3 = x2.threshold, i5 = v3(x2.minPointLength, 5), r3 = this.getColumnMetrics(), o2 = r3.width, n4 = this.pointXOffset = r3.offset, h2 = this.translatedThreshold = g2.getThreshold(t3), y2 = this.barW = Math.max(o2, 1 + 2 * l4);
          for (let M2 of (B3.inverted && (h2 -= 0.5), x2.pointPadding && (y2 = Math.ceil(y2)), super.translate(), this.points)) {
            let z2 = v3(M2.yBottom, h2), S2 = 999 + Math.abs(z2), L2 = N2(M2.plotY, -S2, g2.len + S2), R2 = y2 / 2, P2 = Math.min(L2, z2), H2 = Math.max(L2, z2) - P2, E2 = M2.plotX + n4, s2, d3, b5, A3, I3, C3, $2, F2, rt2, O3, f2;
            x2.centerInCategory && (E2 = this.adjustForMissingColumns(E2, o2, M2, r3)), M2.barX = E2, M2.pointWidth = o2, M2.tooltipPos = B3.inverted ? [g2.len + g2.pos - B3.plotLeft - L2, this.xAxis.len - E2 - R2, H2] : [E2 + R2, L2 + g2.pos - B3.plotTop, H2], s2 = t3 + (M2.total || M2.y), x2.stacking === "percent" && (s2 = t3 + (M2.y < 0) ? -100 : 100);
            let Y2 = g2.toPixels(s2, true);
            b5 = (d3 = B3.plotHeight - Y2 - (B3.plotHeight - h2)) ? R2 * (P2 - Y2) / d3 : 0, A3 = d3 ? R2 * (P2 + H2 - Y2) / d3 : 0, C3 = E2 - b5 + R2, $2 = E2 + b5 + R2, F2 = E2 + A3 + R2, rt2 = E2 - A3 + R2, O3 = P2 - i5, f2 = P2 + H2, M2.y < 0 && (O3 = P2, f2 = P2 + H2 + i5), B3.inverted && (I3 = g2.width - P2, d3 = Y2 - (g2.width - h2), b5 = R2 * (Y2 - I3) / d3, A3 = R2 * (Y2 - (I3 - H2)) / d3, $2 = (C3 = E2 + R2 + b5) - 2 * b5, F2 = E2 - A3 + R2, rt2 = E2 + A3 + R2, O3 = P2, f2 = P2 + H2 - i5, M2.y < 0 && (f2 = P2 + H2 + i5)), M2.shapeType = "path", M2.shapeArgs = { x: C3, y: O3, width: $2 - C3, height: H2, d: [["M", C3, O3], ["L", $2, O3], ["L", F2, f2], ["L", rt2, f2], ["Z"]] };
          }
        }
      }
      return D2.defaultOptions = T2(m3.defaultOptions, a2), p2.registerSeriesType("columnpyramid", D2), D2;
    }), tt2(e5, "Series/ErrorBar/ErrorBarSeriesDefaults.js", [], function() {
      return { color: "#000000", grouping: false, linkedTo: ":previous", tooltip: { pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>' }, whiskerWidth: null };
    }), tt2(e5, "Series/ErrorBar/ErrorBarSeries.js", [e5["Series/BoxPlot/BoxPlotSeries.js"], e5["Series/Column/ColumnSeries.js"], e5["Series/ErrorBar/ErrorBarSeriesDefaults.js"], e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3, N2) {
      let { arearange: T2 } = m3.seriesTypes, { addEvent: v3, merge: D2, extend: j3 } = N2;
      class B3 extends a2 {
        getColumnMetrics() {
          return this.linkedParent && this.linkedParent.columnMetrics || p2.prototype.getColumnMetrics.call(this);
        }
        drawDataLabels() {
          let u2 = this.pointValKey;
          if (T2) for (let l4 of (T2.prototype.drawDataLabels.call(this), this.points)) l4.y = l4[u2];
        }
        toYData(u2) {
          return [u2.low, u2.high];
        }
      }
      return B3.defaultOptions = D2(a2.defaultOptions, c4), v3(B3, "afterTranslate", function() {
        for (let x2 of this.points) x2.plotLow = x2.plotY;
      }, { order: 0 }), j3(B3.prototype, { pointArrayMap: ["low", "high"], pointValKey: "high", doQuartiles: false }), m3.registerSeriesType("errorbar", B3), B3;
    }), tt2(e5, "Series/Gauge/GaugePoint.js", [e5["Core/Series/SeriesRegistry.js"]], function(a2) {
      let { series: { prototype: { pointClass: p2 } } } = a2;
      return class extends p2 {
        setState(c4) {
          this.state = c4;
        }
      };
    }), tt2(e5, "Series/Gauge/GaugeSeries.js", [e5["Series/Gauge/GaugePoint.js"], e5["Core/Globals.js"], e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3) {
      let { noop: N2 } = p2, { series: T2, seriesTypes: { column: v3 } } = c4, { clamp: D2, isNumber: j3, extend: B3, merge: x2, pick: u2, pInt: l4, defined: g2 } = m3;
      class t3 extends T2 {
        translate() {
          let r3 = this.yAxis, o2 = this.options, n4 = r3.center;
          this.generatePoints(), this.points.forEach((h2) => {
            let y2 = x2(o2.dial, h2.dial), M2 = l4(y2.radius) * n4[2] / 200, z2 = l4(y2.baseLength) * M2 / 100, S2 = l4(y2.rearLength) * M2 / 100, L2 = y2.baseWidth, R2 = y2.topWidth, P2 = o2.overshoot, H2 = r3.startAngleRad + r3.translate(h2.y, void 0, void 0, void 0, true);
            (j3(P2) || o2.wrap === false) && (P2 = j3(P2) ? P2 / 180 * Math.PI : 0, H2 = D2(H2, r3.startAngleRad - P2, r3.endAngleRad + P2)), H2 = 180 * H2 / Math.PI, h2.shapeType = "path";
            let E2 = y2.path || [["M", -S2, -L2 / 2], ["L", z2, -L2 / 2], ["L", M2, -R2 / 2], ["L", M2, R2 / 2], ["L", z2, L2 / 2], ["L", -S2, L2 / 2], ["Z"]];
            h2.shapeArgs = { d: E2, translateX: n4[0], translateY: n4[1], rotation: H2 }, h2.plotX = n4[0], h2.plotY = n4[1], g2(h2.y) && r3.max - r3.min && (h2.percentage = (h2.y - r3.min) / (r3.max - r3.min) * 100);
          });
        }
        drawPoints() {
          let r3 = this, o2 = r3.chart, n4 = r3.yAxis.center, h2 = r3.pivot, y2 = r3.options, M2 = y2.pivot, z2 = o2.renderer;
          r3.points.forEach((S2) => {
            let L2 = S2.graphic, R2 = S2.shapeArgs, P2 = R2.d, H2 = x2(y2.dial, S2.dial);
            L2 ? (L2.animate(R2), R2.d = P2) : S2.graphic = z2[S2.shapeType](R2).addClass("highcharts-dial").add(r3.group), o2.styledMode || S2.graphic[L2 ? "animate" : "attr"]({ stroke: H2.borderColor, "stroke-width": H2.borderWidth, fill: H2.backgroundColor });
          }), h2 ? h2.animate({ translateX: n4[0], translateY: n4[1] }) : M2 && (r3.pivot = z2.circle(0, 0, M2.radius).attr({ zIndex: 2 }).addClass("highcharts-pivot").translate(n4[0], n4[1]).add(r3.group), o2.styledMode || r3.pivot.attr({ fill: M2.backgroundColor, stroke: M2.borderColor, "stroke-width": M2.borderWidth }));
        }
        animate(r3) {
          let o2 = this;
          r3 || o2.points.forEach((n4) => {
            let h2 = n4.graphic;
            h2 && (h2.attr({ rotation: 180 * o2.yAxis.startAngleRad / Math.PI }), h2.animate({ rotation: n4.shapeArgs.rotation }, o2.options.animation));
          });
        }
        render() {
          this.group = this.plotGroup("group", "series", this.visible ? "inherit" : "hidden", this.options.zIndex, this.chart.seriesGroup), T2.prototype.render.call(this), this.group.clip(this.chart.clipRect);
        }
        setData(r3, o2) {
          T2.prototype.setData.call(this, r3, false), this.processData(), this.generatePoints(), u2(o2, true) && this.chart.redraw();
        }
        hasData() {
          return !!this.points.length;
        }
      }
      return t3.defaultOptions = x2(T2.defaultOptions, { dataLabels: { borderColor: "#cccccc", borderRadius: 3, borderWidth: 1, crop: false, defer: false, enabled: true, verticalAlign: "top", y: 15, zIndex: 2 }, dial: { backgroundColor: "#000000", baseLength: "70%", baseWidth: 3, borderColor: "#cccccc", borderWidth: 0, radius: "80%", rearLength: "10%", topWidth: 1 }, pivot: { radius: 5, borderWidth: 0, borderColor: "#cccccc", backgroundColor: "#000000" }, tooltip: { headerFormat: "" }, showInLegend: false }), B3(t3.prototype, { angular: true, directTouch: true, drawGraph: N2, drawTracker: v3.prototype.drawTracker, fixedBox: true, forceDL: true, noSharedTooltip: true, pointClass: a2, trackerGroups: ["group", "dataLabelsGroup"] }), c4.registerSeriesType("gauge", t3), t3;
    }), tt2(e5, "Series/DragNodesComposition.js", [e5["Core/Globals.js"], e5["Core/Utilities.js"]], function(a2, p2) {
      let { composed: c4 } = a2, { addEvent: m3, pushUnique: N2 } = p2;
      function T2() {
        let v3, D2, j3, B3 = this;
        B3.container && (v3 = m3(B3.container, "mousedown", (x2) => {
          let u2 = B3.hoverPoint;
          u2 && u2.series && u2.series.hasDraggableNodes && u2.series.options.draggable && (u2.series.onMouseDown(u2, x2), D2 = m3(B3.container, "mousemove", (l4) => u2 && u2.series && u2.series.onMouseMove(u2, l4)), j3 = m3(B3.container.ownerDocument, "mouseup", (l4) => (D2(), j3(), u2 && u2.series && u2.series.onMouseUp(u2, l4))));
        })), m3(B3, "destroy", function() {
          v3();
        });
      }
      return { compose: function(v3) {
        N2(c4, "DragNodes") && m3(v3, "load", T2);
      }, onMouseDown: function(v3, D2) {
        var j3;
        let B3 = ((j3 = this.chart.pointer) == null ? void 0 : j3.normalize(D2)) || D2;
        v3.fixedPosition = { chartX: B3.chartX, chartY: B3.chartY, plotX: v3.plotX, plotY: v3.plotY }, v3.inDragMode = true;
      }, onMouseMove: function(v3, D2) {
        var j3;
        if (v3.fixedPosition && v3.inDragMode) {
          let B3, x2, u2 = this.chart, l4 = ((j3 = u2.pointer) == null ? void 0 : j3.normalize(D2)) || D2, g2 = v3.fixedPosition.chartX - l4.chartX, t3 = v3.fixedPosition.chartY - l4.chartY, i5 = u2.graphLayoutsLookup;
          (Math.abs(g2) > 5 || Math.abs(t3) > 5) && (B3 = v3.fixedPosition.plotX - g2, x2 = v3.fixedPosition.plotY - t3, u2.isInsidePlot(B3, x2) && (v3.plotX = B3, v3.plotY = x2, v3.hasDragged = true, this.redrawHalo(v3), i5.forEach((r3) => {
            r3.restartSimulation();
          })));
        }
      }, onMouseUp: function(v3) {
        v3.fixedPosition && (v3.hasDragged && (this.layout.enableSimulation ? this.layout.start() : this.chart.redraw()), v3.inDragMode = v3.hasDragged = false, this.options.fixedDraggable || delete v3.fixedPosition);
      }, redrawHalo: function(v3) {
        v3 && this.halo && this.halo.attr({ d: v3.haloPath(this.options.states.hover.halo.size) });
      } };
    }), tt2(e5, "Series/GraphLayoutComposition.js", [e5["Core/Animation/AnimationUtilities.js"], e5["Core/Globals.js"], e5["Core/Utilities.js"]], function(a2, p2, c4) {
      let { setAnimation: m3 } = a2, { composed: N2 } = p2, { addEvent: T2, pushUnique: v3 } = c4;
      function D2() {
        this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((u2) => {
          u2.updateSimulation();
        }), this.redraw());
      }
      function j3() {
        this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((u2) => {
          u2.updateSimulation(false);
        }), this.redraw());
      }
      function B3() {
        this.graphLayoutsLookup && this.graphLayoutsLookup.forEach((u2) => {
          u2.stop();
        });
      }
      function x2() {
        let u2, l4 = false, g2 = (t3) => {
          t3.maxIterations-- && isFinite(t3.temperature) && !t3.isStable() && !t3.enableSimulation && (t3.beforeStep && t3.beforeStep(), t3.step(), u2 = false, l4 = true);
        };
        if (this.graphLayoutsLookup) {
          for (m3(false, this), this.graphLayoutsLookup.forEach((t3) => t3.start()); !u2; ) u2 = true, this.graphLayoutsLookup.forEach(g2);
          l4 && this.series.forEach((t3) => {
            t3 && t3.layout && t3.render();
          });
        }
      }
      return { compose: function(u2) {
        v3(N2, "GraphLayout") && (T2(u2, "afterPrint", D2), T2(u2, "beforePrint", j3), T2(u2, "predraw", B3), T2(u2, "render", x2));
      }, integrations: {}, layouts: {} };
    }), tt2(e5, "Series/PackedBubble/PackedBubblePoint.js", [e5["Core/Chart/Chart.js"], e5["Core/Series/Point.js"], e5["Core/Series/SeriesRegistry.js"]], function(a2, p2, c4) {
      let { seriesTypes: { bubble: { prototype: { pointClass: m3 } } } } = c4;
      return class extends m3 {
        destroy() {
          var N2;
          return (N2 = this.series) != null && N2.layout && this.series.layout.removeElementFromCollection(this, this.series.layout.nodes), p2.prototype.destroy.apply(this, arguments);
        }
        firePointEvent() {
          let N2 = this.series.options;
          if (this.isParentNode && N2.parentNode) {
            let T2 = N2.allowPointSelect;
            N2.allowPointSelect = N2.parentNode.allowPointSelect, p2.prototype.firePointEvent.apply(this, arguments), N2.allowPointSelect = T2;
          } else p2.prototype.firePointEvent.apply(this, arguments);
        }
        select() {
          let N2 = this.series.chart;
          this.isParentNode ? (N2.getSelectedPoints = N2.getSelectedParentNodes, p2.prototype.select.apply(this, arguments), N2.getSelectedPoints = a2.prototype.getSelectedPoints) : p2.prototype.select.apply(this, arguments);
        }
      };
    }), tt2(e5, "Series/PackedBubble/PackedBubbleSeriesDefaults.js", [e5["Core/Utilities.js"]], function(a2) {
      let { isNumber: p2 } = a2;
      return { minSize: "10%", maxSize: "50%", sizeBy: "area", zoneAxis: "y", crisp: false, tooltip: { pointFormat: "Value: {point.value}" }, draggable: true, useSimulation: true, parentNode: { allowPointSelect: false }, dataLabels: { formatter: function() {
        let { numberFormatter: c4 } = this.series.chart, { value: m3 } = this.point;
        return p2(m3) ? c4(m3, -1) : "";
      }, parentNodeFormatter: function() {
        return this.name;
      }, parentNodeTextPath: { enabled: true }, padding: 0, style: { transition: "opacity 2000ms" } }, layoutAlgorithm: { initialPositions: "circle", initialPositionRadius: 20, bubblePadding: 5, parentNodeLimit: false, seriesInteraction: true, dragBetweenSeries: false, parentNodeOptions: { maxIterations: 400, gravitationalConstant: 0.03, maxSpeed: 50, initialPositionRadius: 100, seriesInteraction: true, marker: { fillColor: null, fillOpacity: 1, lineWidth: null, lineColor: null, symbol: "circle" } }, enableSimulation: true, type: "packedbubble", integration: "packedbubble", maxIterations: 1e3, splitSeries: false, maxSpeed: 5, gravitationalConstant: 0.01, friction: -0.981 } };
    }), tt2(e5, "Series/Networkgraph/VerletIntegration.js", [], function() {
      return { attractive: function(a2, p2, c4) {
        let m3 = a2.getMass(), N2 = -c4.x * p2 * this.diffTemperature, T2 = -c4.y * p2 * this.diffTemperature;
        a2.fromNode.fixedPosition || (a2.fromNode.plotX -= N2 * m3.fromNode / a2.fromNode.degree, a2.fromNode.plotY -= T2 * m3.fromNode / a2.fromNode.degree), a2.toNode.fixedPosition || (a2.toNode.plotX += N2 * m3.toNode / a2.toNode.degree, a2.toNode.plotY += T2 * m3.toNode / a2.toNode.degree);
      }, attractiveForceFunction: function(a2, p2) {
        return (p2 - a2) / a2;
      }, barycenter: function() {
        let a2 = this.options.gravitationalConstant || 0, p2 = (this.barycenter.xFactor - (this.box.left + this.box.width) / 2) * a2, c4 = (this.barycenter.yFactor - (this.box.top + this.box.height) / 2) * a2;
        this.nodes.forEach(function(m3) {
          m3.fixedPosition || (m3.plotX -= p2 / m3.mass / m3.degree, m3.plotY -= c4 / m3.mass / m3.degree);
        });
      }, getK: function(a2) {
        return Math.pow(a2.box.width * a2.box.height / a2.nodes.length, 0.5);
      }, integrate: function(a2, p2) {
        let c4 = -a2.options.friction, m3 = a2.options.maxSpeed, N2 = p2.prevX, T2 = p2.prevY, v3 = (p2.plotX + p2.dispX - N2) * c4, D2 = (p2.plotY + p2.dispY - T2) * c4, j3 = Math.abs, B3 = j3(v3) / (v3 || 1), x2 = j3(D2) / (D2 || 1), u2 = B3 * Math.min(m3, Math.abs(v3)), l4 = x2 * Math.min(m3, Math.abs(D2));
        p2.prevX = p2.plotX + p2.dispX, p2.prevY = p2.plotY + p2.dispY, p2.plotX += u2, p2.plotY += l4, p2.temperature = a2.vectorLength({ x: u2, y: l4 });
      }, repulsive: function(a2, p2, c4) {
        let m3 = p2 * this.diffTemperature / a2.mass / a2.degree;
        a2.fixedPosition || (a2.plotX += c4.x * m3, a2.plotY += c4.y * m3);
      }, repulsiveForceFunction: function(a2, p2) {
        return (p2 - a2) / a2 * (p2 > a2 ? 1 : 0);
      } };
    }), tt2(e5, "Series/PackedBubble/PackedBubbleIntegration.js", [e5["Core/Globals.js"], e5["Series/Networkgraph/VerletIntegration.js"]], function(a2, p2) {
      let { noop: c4 } = a2;
      return { barycenter: function() {
        let m3, N2, T2 = this.options.gravitationalConstant, v3 = this.box, D2 = this.nodes;
        for (let j3 of D2) this.options.splitSeries && !j3.isParentNode ? (m3 = j3.series.parentNode.plotX, N2 = j3.series.parentNode.plotY) : (m3 = v3.width / 2, N2 = v3.height / 2), j3.fixedPosition || (j3.plotX -= (j3.plotX - m3) * T2 / (j3.mass * Math.sqrt(D2.length)), j3.plotY -= (j3.plotY - N2) * T2 / (j3.mass * Math.sqrt(D2.length)));
      }, getK: c4, integrate: p2.integrate, repulsive: function(m3, N2, T2, v3) {
        let D2 = N2 * this.diffTemperature / m3.mass / m3.degree, j3 = T2.x * D2, B3 = T2.y * D2;
        m3.fixedPosition || (m3.plotX += j3, m3.plotY += B3), v3.fixedPosition || (v3.plotX -= j3, v3.plotY -= B3);
      }, repulsiveForceFunction: function(m3, N2, T2, v3) {
        return Math.min(m3, (T2.marker.radius + v3.marker.radius) / 2);
      } };
    }), tt2(e5, "Series/Networkgraph/EulerIntegration.js", [], function() {
      return { attractive: function(a2, p2, c4, m3) {
        let N2 = a2.getMass(), T2 = c4.x / m3 * p2, v3 = c4.y / m3 * p2;
        a2.fromNode.fixedPosition || (a2.fromNode.dispX -= T2 * N2.fromNode / a2.fromNode.degree, a2.fromNode.dispY -= v3 * N2.fromNode / a2.fromNode.degree), a2.toNode.fixedPosition || (a2.toNode.dispX += T2 * N2.toNode / a2.toNode.degree, a2.toNode.dispY += v3 * N2.toNode / a2.toNode.degree);
      }, attractiveForceFunction: function(a2, p2) {
        return a2 * a2 / p2;
      }, barycenter: function() {
        let a2 = this.options.gravitationalConstant, p2 = this.barycenter.xFactor, c4 = this.barycenter.yFactor;
        this.nodes.forEach(function(m3) {
          if (!m3.fixedPosition) {
            let N2 = m3.getDegree(), T2 = N2 * (1 + N2 / 2);
            m3.dispX += (p2 - m3.plotX) * a2 * T2 / m3.degree, m3.dispY += (c4 - m3.plotY) * a2 * T2 / m3.degree;
          }
        });
      }, getK: function(a2) {
        return Math.pow(a2.box.width * a2.box.height / a2.nodes.length, 0.3);
      }, integrate: function(a2, p2) {
        p2.dispX += p2.dispX * a2.options.friction, p2.dispY += p2.dispY * a2.options.friction;
        let c4 = p2.temperature = a2.vectorLength({ x: p2.dispX, y: p2.dispY });
        c4 !== 0 && (p2.plotX += p2.dispX / c4 * Math.min(Math.abs(p2.dispX), a2.temperature), p2.plotY += p2.dispY / c4 * Math.min(Math.abs(p2.dispY), a2.temperature));
      }, repulsive: function(a2, p2, c4, m3) {
        a2.dispX += c4.x / m3 * p2 / a2.degree, a2.dispY += c4.y / m3 * p2 / a2.degree;
      }, repulsiveForceFunction: function(a2, p2) {
        return p2 * p2 / a2;
      } };
    }), tt2(e5, "Series/Networkgraph/QuadTreeNode.js", [], function() {
      class a2 {
        constructor(c4) {
          this.body = false, this.isEmpty = false, this.isInternal = false, this.nodes = [], this.box = c4, this.boxSize = Math.min(c4.width, c4.height);
        }
        divideBox() {
          let c4 = this.box.width / 2, m3 = this.box.height / 2;
          this.nodes[0] = new a2({ left: this.box.left, top: this.box.top, width: c4, height: m3 }), this.nodes[1] = new a2({ left: this.box.left + c4, top: this.box.top, width: c4, height: m3 }), this.nodes[2] = new a2({ left: this.box.left + c4, top: this.box.top + m3, width: c4, height: m3 }), this.nodes[3] = new a2({ left: this.box.left, top: this.box.top + m3, width: c4, height: m3 });
        }
        getBoxPosition(c4) {
          let m3 = c4.plotX < this.box.left + this.box.width / 2, N2 = c4.plotY < this.box.top + this.box.height / 2;
          return m3 ? N2 ? 0 : 3 : N2 ? 1 : 2;
        }
        insert(c4, m3) {
          let N2;
          this.isInternal ? this.nodes[this.getBoxPosition(c4)].insert(c4, m3 - 1) : (this.isEmpty = false, this.body ? m3 ? (this.isInternal = true, this.divideBox(), this.body !== true && (this.nodes[this.getBoxPosition(this.body)].insert(this.body, m3 - 1), this.body = true), this.nodes[this.getBoxPosition(c4)].insert(c4, m3 - 1)) : ((N2 = new a2({ top: c4.plotX || NaN, left: c4.plotY || NaN, width: 0.1, height: 0.1 })).body = c4, N2.isInternal = false, this.nodes.push(N2)) : (this.isInternal = false, this.body = c4));
        }
        updateMassAndCenter() {
          let c4 = 0, m3 = 0, N2 = 0;
          if (this.isInternal) {
            for (let T2 of this.nodes) T2.isEmpty || (c4 += T2.mass, m3 += T2.plotX * T2.mass, N2 += T2.plotY * T2.mass);
            m3 /= c4, N2 /= c4;
          } else this.body && (c4 = this.body.mass, m3 = this.body.plotX, N2 = this.body.plotY);
          this.mass = c4, this.plotX = m3, this.plotY = N2;
        }
      }
      return a2;
    }), tt2(e5, "Series/Networkgraph/QuadTree.js", [e5["Series/Networkgraph/QuadTreeNode.js"]], function(a2) {
      return class {
        constructor(p2, c4, m3, N2) {
          this.box = { left: p2, top: c4, width: m3, height: N2 }, this.maxDepth = 25, this.root = new a2(this.box), this.root.isInternal = true, this.root.isRoot = true, this.root.divideBox();
        }
        calculateMassAndCenter() {
          this.visitNodeRecursive(null, null, function(p2) {
            p2.updateMassAndCenter();
          });
        }
        insertNodes(p2) {
          for (let c4 of p2) this.root.insert(c4, this.maxDepth);
        }
        visitNodeRecursive(p2, c4, m3) {
          let N2;
          if (p2 || (p2 = this.root), p2 === this.root && c4 && (N2 = c4(p2)), N2 !== false) {
            for (let T2 of p2.nodes) {
              if (T2.isInternal) {
                if (c4 && (N2 = c4(T2)), N2 === false) continue;
                this.visitNodeRecursive(T2, c4, m3);
              } else T2.body && c4 && c4(T2.body);
              m3 && m3(T2);
            }
            p2 === this.root && m3 && m3(p2);
          }
        }
      };
    }), tt2(e5, "Series/Networkgraph/ReingoldFruchtermanLayout.js", [e5["Series/Networkgraph/EulerIntegration.js"], e5["Core/Globals.js"], e5["Series/GraphLayoutComposition.js"], e5["Series/Networkgraph/QuadTree.js"], e5["Core/Utilities.js"], e5["Series/Networkgraph/VerletIntegration.js"]], function(a2, p2, c4, m3, N2, T2) {
      let { win: v3 } = p2, { clamp: D2, defined: j3, isFunction: B3, fireEvent: x2, pick: u2 } = N2;
      class l4 {
        constructor() {
          this.box = {}, this.currentStep = 0, this.initialRendering = true, this.links = [], this.nodes = [], this.series = [], this.simulation = false;
        }
        static compose(t3) {
          c4.compose(t3), c4.integrations.euler = a2, c4.integrations.verlet = T2, c4.layouts["reingold-fruchterman"] = l4;
        }
        init(t3) {
          this.options = t3, this.nodes = [], this.links = [], this.series = [], this.box = { x: 0, y: 0, width: 0, height: 0 }, this.setInitialRendering(true), this.integration = c4.integrations[t3.integration], this.enableSimulation = t3.enableSimulation, this.attractiveForce = u2(t3.attractiveForce, this.integration.attractiveForceFunction), this.repulsiveForce = u2(t3.repulsiveForce, this.integration.repulsiveForceFunction), this.approximation = t3.approximation;
        }
        updateSimulation(t3) {
          this.enableSimulation = u2(t3, this.options.enableSimulation);
        }
        start() {
          let t3 = this.series, i5 = this.options;
          this.currentStep = 0, this.forces = t3[0] && t3[0].forces || [], this.chart = t3[0] && t3[0].chart, this.initialRendering && (this.initPositions(), t3.forEach(function(r3) {
            r3.finishedAnimating = true, r3.render();
          })), this.setK(), this.resetSimulation(i5), this.enableSimulation && this.step();
        }
        step() {
          let t3 = this.series;
          for (let i5 of (this.currentStep++, this.approximation === "barnes-hut" && (this.createQuadTree(), this.quadTree.calculateMassAndCenter()), this.forces || [])) this[i5 + "Forces"](this.temperature);
          if (this.applyLimits(), this.temperature = this.coolDown(this.startTemperature, this.diffTemperature, this.currentStep), this.prevSystemTemperature = this.systemTemperature, this.systemTemperature = this.getSystemTemperature(), this.enableSimulation) {
            for (let i5 of t3) i5.chart && i5.render();
            this.maxIterations-- && isFinite(this.temperature) && !this.isStable() ? (this.simulation && v3.cancelAnimationFrame(this.simulation), this.simulation = v3.requestAnimationFrame(() => this.step())) : (this.simulation = false, this.series.forEach((i5) => {
              x2(i5, "afterSimulation");
            }));
          }
        }
        stop() {
          this.simulation && v3.cancelAnimationFrame(this.simulation);
        }
        setArea(t3, i5, r3, o2) {
          this.box = { left: t3, top: i5, width: r3, height: o2 };
        }
        setK() {
          this.k = this.options.linkLength || this.integration.getK(this);
        }
        addElementsToCollection(t3, i5) {
          for (let r3 of t3) i5.indexOf(r3) === -1 && i5.push(r3);
        }
        removeElementFromCollection(t3, i5) {
          let r3 = i5.indexOf(t3);
          r3 !== -1 && i5.splice(r3, 1);
        }
        clear() {
          this.nodes.length = 0, this.links.length = 0, this.series.length = 0, this.resetSimulation();
        }
        resetSimulation() {
          this.forcedStop = false, this.systemTemperature = 0, this.setMaxIterations(), this.setTemperature(), this.setDiffTemperature();
        }
        restartSimulation() {
          this.simulation ? this.resetSimulation() : (this.setInitialRendering(false), this.enableSimulation ? this.start() : this.setMaxIterations(1), this.chart && this.chart.redraw(), this.setInitialRendering(true));
        }
        setMaxIterations(t3) {
          this.maxIterations = u2(t3, this.options.maxIterations);
        }
        setTemperature() {
          this.temperature = this.startTemperature = Math.sqrt(this.nodes.length);
        }
        setDiffTemperature() {
          this.diffTemperature = this.startTemperature / (this.options.maxIterations + 1);
        }
        setInitialRendering(t3) {
          this.initialRendering = t3;
        }
        createQuadTree() {
          this.quadTree = new m3(this.box.left, this.box.top, this.box.width, this.box.height), this.quadTree.insertNodes(this.nodes);
        }
        initPositions() {
          let t3 = this.options.initialPositions;
          if (B3(t3)) for (let i5 of (t3.call(this), this.nodes)) j3(i5.prevX) || (i5.prevX = i5.plotX), j3(i5.prevY) || (i5.prevY = i5.plotY), i5.dispX = 0, i5.dispY = 0;
          else t3 === "circle" ? this.setCircularPositions() : this.setRandomPositions();
        }
        setCircularPositions() {
          let t3, i5 = this.box, r3 = this.nodes, o2 = 2 * Math.PI / (r3.length + 1), n4 = r3.filter(function(S2) {
            return S2.linksTo.length === 0;
          }), h2 = {}, y2 = this.options.initialPositionRadius, M2 = (S2) => {
            for (let L2 of S2.linksFrom || []) h2[L2.toNode.id] || (h2[L2.toNode.id] = true, z2.push(L2.toNode), M2(L2.toNode));
          }, z2 = [];
          for (let S2 of n4) z2.push(S2), M2(S2);
          if (z2.length) for (let S2 of r3) z2.indexOf(S2) === -1 && z2.push(S2);
          else z2 = r3;
          for (let S2 = 0, L2 = z2.length; S2 < L2; ++S2) (t3 = z2[S2]).plotX = t3.prevX = u2(t3.plotX, i5.width / 2 + y2 * Math.cos(S2 * o2)), t3.plotY = t3.prevY = u2(t3.plotY, i5.height / 2 + y2 * Math.sin(S2 * o2)), t3.dispX = 0, t3.dispY = 0;
        }
        setRandomPositions() {
          let t3, i5 = this.box, r3 = this.nodes, o2 = r3.length + 1, n4 = (h2) => {
            let y2 = h2 * h2 / Math.PI;
            return y2 - Math.floor(y2);
          };
          for (let h2 = 0, y2 = r3.length; h2 < y2; ++h2) (t3 = r3[h2]).plotX = t3.prevX = u2(t3.plotX, i5.width * n4(h2)), t3.plotY = t3.prevY = u2(t3.plotY, i5.height * n4(o2 + h2)), t3.dispX = 0, t3.dispY = 0;
        }
        force(t3, ...i5) {
          this.integration[t3].apply(this, i5);
        }
        barycenterForces() {
          this.getBarycenter(), this.force("barycenter");
        }
        getBarycenter() {
          let t3 = 0, i5 = 0, r3 = 0;
          for (let o2 of this.nodes) i5 += o2.plotX * o2.mass, r3 += o2.plotY * o2.mass, t3 += o2.mass;
          return this.barycenter = { x: i5, y: r3, xFactor: i5 / t3, yFactor: r3 / t3 }, this.barycenter;
        }
        barnesHutApproximation(t3, i5) {
          let r3, o2, n4 = this.getDistXY(t3, i5), h2 = this.vectorLength(n4);
          return t3 !== i5 && h2 !== 0 && (i5.isInternal ? i5.boxSize / h2 < this.options.theta && h2 !== 0 ? (o2 = this.repulsiveForce(h2, this.k), this.force("repulsive", t3, o2 * i5.mass, n4, h2), r3 = false) : r3 = true : (o2 = this.repulsiveForce(h2, this.k), this.force("repulsive", t3, o2 * i5.mass, n4, h2))), r3;
        }
        repulsiveForces() {
          if (this.approximation === "barnes-hut") for (let t3 of this.nodes) this.quadTree.visitNodeRecursive(null, (i5) => this.barnesHutApproximation(t3, i5));
          else {
            let t3, i5, r3;
            for (let o2 of this.nodes) for (let n4 of this.nodes) o2 === n4 || o2.fixedPosition || (r3 = this.getDistXY(o2, n4), (i5 = this.vectorLength(r3)) !== 0 && (t3 = this.repulsiveForce(i5, this.k), this.force("repulsive", o2, t3 * n4.mass, r3, i5)));
          }
        }
        attractiveForces() {
          let t3, i5, r3;
          for (let o2 of this.links) o2.fromNode && o2.toNode && (t3 = this.getDistXY(o2.fromNode, o2.toNode), (i5 = this.vectorLength(t3)) !== 0 && (r3 = this.attractiveForce(i5, this.k), this.force("attractive", o2, r3, t3, i5)));
        }
        applyLimits() {
          for (let t3 of this.nodes) t3.fixedPosition || (this.integration.integrate(this, t3), this.applyLimitBox(t3, this.box), t3.dispX = 0, t3.dispY = 0);
        }
        applyLimitBox(t3, i5) {
          let r3 = t3.radius;
          t3.plotX = D2(t3.plotX, i5.left + r3, i5.width - r3), t3.plotY = D2(t3.plotY, i5.top + r3, i5.height - r3);
        }
        coolDown(t3, i5, r3) {
          return t3 - i5 * r3;
        }
        isStable() {
          return 1e-5 > Math.abs(this.systemTemperature - this.prevSystemTemperature) || this.temperature <= 0;
        }
        getSystemTemperature() {
          let t3 = 0;
          for (let i5 of this.nodes) t3 += i5.temperature;
          return t3;
        }
        vectorLength(t3) {
          return Math.sqrt(t3.x * t3.x + t3.y * t3.y);
        }
        getDistR(t3, i5) {
          let r3 = this.getDistXY(t3, i5);
          return this.vectorLength(r3);
        }
        getDistXY(t3, i5) {
          let r3 = t3.plotX - i5.plotX, o2 = t3.plotY - i5.plotY;
          return { x: r3, y: o2, absX: Math.abs(r3), absY: Math.abs(o2) };
        }
      }
      return l4;
    }), tt2(e5, "Series/PackedBubble/PackedBubbleLayout.js", [e5["Series/GraphLayoutComposition.js"], e5["Series/PackedBubble/PackedBubbleIntegration.js"], e5["Series/Networkgraph/ReingoldFruchtermanLayout.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3) {
      let { addEvent: N2, pick: T2 } = m3;
      function v3() {
        let B3 = this.series, x2 = [];
        return B3.forEach((u2) => {
          u2.parentNode && u2.parentNode.selected && x2.push(u2.parentNode);
        }), x2;
      }
      function D2() {
        this.allDataPoints && delete this.allDataPoints;
      }
      class j3 extends c4 {
        constructor() {
          super(...arguments), this.index = NaN, this.nodes = [], this.series = [];
        }
        static compose(x2) {
          c4.compose(x2), a2.integrations.packedbubble = p2, a2.layouts.packedbubble = j3;
          let u2 = x2.prototype;
          u2.getSelectedParentNodes || (N2(x2, "beforeRedraw", D2), u2.getSelectedParentNodes = v3);
        }
        beforeStep() {
          this.options.marker && this.series.forEach((x2) => {
            x2 && x2.calculateParentRadius();
          });
        }
        isStable() {
          let x2 = Math.abs(this.prevSystemTemperature - this.systemTemperature);
          return 1 > Math.abs(10 * this.systemTemperature / Math.sqrt(this.nodes.length)) && x2 < 1e-5 || this.temperature <= 0;
        }
        setCircularPositions() {
          let x2 = this.box, u2 = this.nodes, l4 = 2 * Math.PI / (u2.length + 1), g2 = this.options.initialPositionRadius, t3, i5, r3 = 0;
          for (let o2 of u2) this.options.splitSeries && !o2.isParentNode ? (t3 = o2.series.parentNode.plotX, i5 = o2.series.parentNode.plotY) : (t3 = x2.width / 2, i5 = x2.height / 2), o2.plotX = o2.prevX = T2(o2.plotX, t3 + g2 * Math.cos(o2.index || r3 * l4)), o2.plotY = o2.prevY = T2(o2.plotY, i5 + g2 * Math.sin(o2.index || r3 * l4)), o2.dispX = 0, o2.dispY = 0, r3++;
        }
        repulsiveForces() {
          let x2, u2, l4, g2 = this, t3 = g2.options.bubblePadding, i5 = g2.nodes;
          i5.forEach((r3) => {
            r3.degree = r3.mass, r3.neighbours = 0, i5.forEach((o2) => {
              x2 = 0, r3 !== o2 && !r3.fixedPosition && (g2.options.seriesInteraction || r3.series === o2.series) && (l4 = g2.getDistXY(r3, o2), (u2 = g2.vectorLength(l4) - (r3.marker.radius + o2.marker.radius + t3)) < 0 && (r3.degree += 0.01, r3.neighbours++, x2 = g2.repulsiveForce(-u2 / Math.sqrt(r3.neighbours), g2.k, r3, o2)), g2.force("repulsive", r3, x2 * o2.mass, l4, o2, u2));
            });
          });
        }
        applyLimitBox(x2, u2) {
          let l4, g2;
          this.options.splitSeries && !x2.isParentNode && this.options.parentNodeLimit && (l4 = this.getDistXY(x2, x2.series.parentNode), (g2 = x2.series.parentNodeRadius - x2.marker.radius - this.vectorLength(l4)) < 0 && g2 > -2 * x2.marker.radius && (x2.plotX -= 0.01 * l4.x, x2.plotY -= 0.01 * l4.y)), super.applyLimitBox(x2, u2);
        }
      }
      return a2.layouts.packedbubble = j3, j3;
    }), tt2(e5, "Series/SimulationSeriesUtilities.js", [e5["Core/Utilities.js"], e5["Core/Animation/AnimationUtilities.js"]], function(a2, p2) {
      let { merge: c4, syncTimeout: m3 } = a2, { animObject: N2 } = p2;
      return { initDataLabels: function() {
        let T2 = this.options.dataLabels;
        if (!this.dataLabelsGroup) {
          let v3 = this.initDataLabelsGroup();
          return !this.chart.styledMode && T2 != null && T2.style && v3.css(T2.style), v3.attr({ opacity: 0 }), this.visible && v3.show(), v3;
        }
        return this.dataLabelsGroup.attr(c4({ opacity: 1 }, this.getPlotBox("data-labels"))), this.dataLabelsGroup;
      }, initDataLabelsDefer: function() {
        var T2;
        let v3 = this.options.dataLabels;
        v3 != null && v3.defer && (T2 = this.options.layoutAlgorithm) != null && T2.enableSimulation ? m3(() => {
          this.deferDataLabels = false;
        }, v3 ? N2(v3.animation).defer : 0) : this.deferDataLabels = false;
      } };
    }), tt2(e5, "Extensions/TextPath.js", [e5["Core/Globals.js"], e5["Core/Utilities.js"]], function(a2, p2) {
      let { deg2rad: c4 } = a2, { addEvent: m3, merge: N2, uniqueKey: T2, defined: v3, extend: D2 } = p2;
      function j3(u2, l4) {
        l4 = N2(true, { enabled: true, attributes: { dy: -5, startOffset: "50%", textAnchor: "middle" } }, l4);
        let g2 = this.renderer.url, t3 = this.text || this, i5 = t3.textPath, { attributes: r3, enabled: o2 } = l4;
        if (u2 = u2 || i5 && i5.path, i5 && i5.undo(), u2 && o2) {
          let n4 = m3(t3, "afterModifyTree", (h2) => {
            if (u2 && o2) {
              let y2 = u2.attr("id");
              y2 || u2.attr("id", y2 = T2());
              let M2 = { x: 0, y: 0 };
              v3(r3.dx) && (M2.dx = r3.dx, delete r3.dx), v3(r3.dy) && (M2.dy = r3.dy, delete r3.dy), t3.attr(M2), this.attr({ transform: "" }), this.box && (this.box = this.box.destroy());
              let z2 = h2.nodes.slice(0);
              h2.nodes.length = 0, h2.nodes[0] = { tagName: "textPath", attributes: D2(r3, { "text-anchor": r3.textAnchor, href: `${g2}#${y2}` }), children: z2 };
            }
          });
          t3.textPath = { path: u2, undo: n4 };
        } else t3.attr({ dx: 0, dy: 0 }), delete t3.textPath;
        return this.added && (t3.textCache = "", this.renderer.buildText(t3)), this;
      }
      function B3(u2) {
        var l4;
        let g2 = u2.bBox, t3 = (l4 = this.element) == null ? void 0 : l4.querySelector("textPath");
        if (t3) {
          let i5 = [], { b: r3, h: o2 } = this.renderer.fontMetrics(this.element), n4 = o2 - r3, h2 = RegExp('(<tspan>|<tspan(?!\\sclass="highcharts-br")[^>]*>|<\\/tspan>)', "g"), y2 = t3.innerHTML.replace(h2, "").split(/<tspan class="highcharts-br"[^>]*>/), M2 = y2.length, z2 = (S2, L2) => {
            let { x: R2, y: P2 } = L2, H2 = (t3.getRotationOfChar(S2) - 90) * c4, E2 = Math.cos(H2), s2 = Math.sin(H2);
            return [[R2 - n4 * E2, P2 - n4 * s2], [R2 + r3 * E2, P2 + r3 * s2]];
          };
          for (let S2 = 0, L2 = 0; L2 < M2; L2++) {
            let R2 = y2[L2].length;
            for (let P2 = 0; P2 < R2; P2 += 5) try {
              let H2 = S2 + P2 + L2, [E2, s2] = z2(H2, t3.getStartPositionOfChar(H2));
              P2 === 0 ? (i5.push(s2), i5.push(E2)) : (L2 === 0 && i5.unshift(s2), L2 === M2 - 1 && i5.push(E2));
            } catch {
              break;
            }
            S2 += R2 - 1;
            try {
              let P2 = S2 + L2, H2 = t3.getEndPositionOfChar(P2), [E2, s2] = z2(P2, H2);
              i5.unshift(s2), i5.unshift(E2);
            } catch {
              break;
            }
          }
          i5.length && i5.push(i5[0].slice()), g2.polygon = i5;
        }
        return g2;
      }
      function x2(u2) {
        var l4;
        let g2 = u2.labelOptions, t3 = u2.point, i5 = g2[t3.formatPrefix + "TextPath"] || g2.textPath;
        i5 && !g2.useHTML && (this.setTextPath(((l4 = t3.getDataLabelPath) == null ? void 0 : l4.call(t3, this)) || t3.graphic, i5), t3.dataLabelPath && !i5.enabled && (t3.dataLabelPath = t3.dataLabelPath.destroy()));
      }
      return { compose: function(u2) {
        m3(u2, "afterGetBBox", B3), m3(u2, "beforeAddingDataLabel", x2);
        let l4 = u2.prototype;
        l4.setTextPath || (l4.setTextPath = j3);
      } };
    }), tt2(e5, "Series/PackedBubble/PackedBubbleSeries.js", [e5["Core/Color/Color.js"], e5["Series/DragNodesComposition.js"], e5["Series/GraphLayoutComposition.js"], e5["Core/Globals.js"], e5["Series/PackedBubble/PackedBubblePoint.js"], e5["Series/PackedBubble/PackedBubbleSeriesDefaults.js"], e5["Series/PackedBubble/PackedBubbleLayout.js"], e5["Core/Series/SeriesRegistry.js"], e5["Series/SimulationSeriesUtilities.js"], e5["Core/Utilities.js"], e5["Core/Renderer/SVG/SVGElement.js"], e5["Extensions/TextPath.js"]], function(a2, p2, c4, m3, N2, T2, v3, D2, j3, B3, x2, u2) {
      let { parse: l4 } = a2, { noop: g2 } = m3, { series: { prototype: t3 }, seriesTypes: { bubble: i5 } } = D2, { initDataLabels: r3, initDataLabelsDefer: o2 } = j3, { addEvent: n4, clamp: h2, defined: y2, extend: M2, fireEvent: z2, isArray: S2, isNumber: L2, merge: R2, pick: P2 } = B3;
      u2.compose(x2);
      class H2 extends i5 {
        constructor() {
          super(...arguments), this.parentNodeMass = 0, this.deferDataLabels = true;
        }
        static compose(s2, d3, b5) {
          i5.compose(s2, d3, b5), p2.compose(d3), v3.compose(d3);
        }
        accumulateAllPoints() {
          let s2, d3 = this.chart, b5 = [];
          for (let A3 of d3.series) if (A3.is("packedbubble") && A3.reserveSpace()) {
            s2 = A3.yData || [];
            for (let I3 = 0; I3 < s2.length; I3++) b5.push([null, null, s2[I3], A3.index, I3, { id: I3, marker: { radius: 0 } }]);
          }
          return b5;
        }
        addLayout() {
          let s2 = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, d3 = s2.type || "packedbubble", b5 = this.chart.options.chart, A3 = this.chart.graphLayoutsStorage, I3 = this.chart.graphLayoutsLookup, C3;
          A3 || (this.chart.graphLayoutsStorage = A3 = {}, this.chart.graphLayoutsLookup = I3 = []), (C3 = A3[d3]) || (s2.enableSimulation = y2(b5.forExport) ? !b5.forExport : s2.enableSimulation, A3[d3] = C3 = new c4.layouts[d3](), C3.init(s2), I3.splice(C3.index, 0, C3)), this.layout = C3, this.points.forEach(($2) => {
            $2.mass = 2, $2.degree = 1, $2.collisionNmb = 1;
          }), C3.setArea(0, 0, this.chart.plotWidth, this.chart.plotHeight), C3.addElementsToCollection([this], C3.series), C3.addElementsToCollection(this.points, C3.nodes);
        }
        addSeriesLayout() {
          let s2 = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, d3 = s2.type || "packedbubble", b5 = this.chart.graphLayoutsStorage, A3 = this.chart.graphLayoutsLookup, I3 = R2(s2, s2.parentNodeOptions, { enableSimulation: this.layout.options.enableSimulation }), C3 = b5[d3 + "-series"];
          C3 || (b5[d3 + "-series"] = C3 = new c4.layouts[d3](), C3.init(I3), A3.splice(C3.index, 0, C3)), this.parentNodeLayout = C3, this.createParentNodes();
        }
        calculateParentRadius() {
          let s2 = this.seriesBox();
          this.parentNodeRadius = h2(Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20, 20, s2 ? Math.max(Math.sqrt(Math.pow(s2.width, 2) + Math.pow(s2.height, 2)) / 2 + 20, 20) : Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20), this.parentNode && (this.parentNode.marker.radius = this.parentNode.radius = this.parentNodeRadius);
        }
        calculateZExtremes() {
          let s2 = this.chart.series, d3 = this.options.zMin, b5 = this.options.zMax, A3 = 1 / 0, I3 = -1 / 0;
          return d3 && b5 ? [d3, b5] : (s2.forEach((C3) => {
            C3.yData.forEach(($2) => {
              y2($2) && ($2 > I3 && (I3 = $2), $2 < A3 && (A3 = $2));
            });
          }), [d3 = P2(d3, A3), b5 = P2(b5, I3)]);
        }
        checkOverlap(s2, d3) {
          let b5 = s2[0] - d3[0], A3 = s2[1] - d3[1];
          return Math.sqrt(b5 * b5 + A3 * A3) - Math.abs(s2[2] + d3[2]) < -1e-3;
        }
        createParentNodes() {
          let s2 = this.pointClass, d3 = this.chart, b5 = this.parentNodeLayout, A3 = this.layout.options, I3, C3 = this.parentNode, $2 = { radius: this.parentNodeRadius, lineColor: this.color, fillColor: l4(this.color).brighten(0.4).get() };
          A3.parentNodeOptions && ($2 = R2(A3.parentNodeOptions.marker || {}, $2)), this.parentNodeMass = 0, this.points.forEach((F2) => {
            this.parentNodeMass += Math.PI * Math.pow(F2.marker.radius, 2);
          }), this.calculateParentRadius(), b5.nodes.forEach((F2) => {
            F2.seriesIndex === this.index && (I3 = true);
          }), b5.setArea(0, 0, d3.plotWidth, d3.plotHeight), I3 || (C3 || (C3 = new s2(this, { mass: this.parentNodeRadius / 2, marker: $2, dataLabels: { inside: false }, states: { normal: { marker: $2 }, hover: { marker: $2 } }, dataLabelOnNull: true, degree: this.parentNodeRadius, isParentNode: true, seriesIndex: this.index })), this.parentNode && (C3.plotX = this.parentNode.plotX, C3.plotY = this.parentNode.plotY), this.parentNode = C3, b5.addElementsToCollection([this], b5.series), b5.addElementsToCollection([C3], b5.nodes));
        }
        deferLayout() {
          let s2 = this.options.layoutAlgorithm;
          this.visible && (this.addLayout(), s2.splitSeries && this.addSeriesLayout());
        }
        destroy() {
          this.chart.graphLayoutsLookup && this.chart.graphLayoutsLookup.forEach((s2) => {
            s2.removeElementFromCollection(this, s2.series);
          }, this), this.parentNode && this.parentNodeLayout && (this.parentNodeLayout.removeElementFromCollection(this.parentNode, this.parentNodeLayout.nodes), this.parentNode.dataLabel && (this.parentNode.dataLabel = this.parentNode.dataLabel.destroy())), t3.destroy.apply(this, arguments);
        }
        drawDataLabels() {
          !this.deferDataLabels && (t3.drawDataLabels.call(this, this.points), this.parentNode && (this.parentNode.formatPrefix = "parentNode", t3.drawDataLabels.call(this, [this.parentNode])));
        }
        drawGraph() {
          var s2;
          if (!this.layout || !this.layout.options.splitSeries) return;
          let d3 = this.chart, b5 = this.layout.options.parentNodeOptions.marker, A3 = { fill: b5.fillColor || l4(this.color).brighten(0.4).get(), opacity: b5.fillOpacity, stroke: b5.lineColor || this.color, "stroke-width": P2(b5.lineWidth, this.options.lineWidth) }, I3 = {};
          this.parentNodesGroup = this.plotGroup("parentNodesGroup", "parentNode", this.visible ? "inherit" : "hidden", 0.1, d3.seriesGroup), (s2 = this.group) == null || s2.attr({ zIndex: 2 }), this.calculateParentRadius(), this.parentNode && y2(this.parentNode.plotX) && y2(this.parentNode.plotY) && y2(this.parentNodeRadius) && (I3 = R2({ x: this.parentNode.plotX - this.parentNodeRadius, y: this.parentNode.plotY - this.parentNodeRadius, width: 2 * this.parentNodeRadius, height: 2 * this.parentNodeRadius }, A3), this.parentNode.graphic || (this.graph = this.parentNode.graphic = d3.renderer.symbol(A3.symbol).add(this.parentNodesGroup)), this.parentNode.graphic.attr(I3));
        }
        drawTracker() {
          let s2, d3 = this.parentNode;
          super.drawTracker(), d3 && (s2 = S2(d3.dataLabels) ? d3.dataLabels : d3.dataLabel ? [d3.dataLabel] : [], d3.graphic && (d3.graphic.element.point = d3), s2.forEach((b5) => {
            (b5.div || b5.element).point = d3;
          }));
        }
        getPointRadius() {
          let s2, d3, b5, A3, I3 = this.chart, C3 = I3.plotWidth, $2 = I3.plotHeight, F2 = this.options, rt2 = F2.useSimulation, O3 = Math.min(C3, $2), f2 = {}, Y2 = [], X2 = I3.allDataPoints || [], V2 = X2.length;
          ["minSize", "maxSize"].forEach((_2) => {
            let k3 = parseInt(F2[_2], 10), W2 = /%$/.test(F2[_2]);
            f2[_2] = W2 ? O3 * k3 / 100 : k3 * Math.sqrt(V2);
          }), I3.minRadius = s2 = f2.minSize / Math.sqrt(V2), I3.maxRadius = d3 = f2.maxSize / Math.sqrt(V2);
          let q2 = rt2 ? this.calculateZExtremes() : [s2, d3];
          X2.forEach((_2, k3) => {
            b5 = rt2 ? h2(_2[2], q2[0], q2[1]) : _2[2], (A3 = this.getRadius(q2[0], q2[1], s2, d3, b5)) === 0 && (A3 = null), X2[k3][2] = A3, Y2.push(A3);
          }), this.radii = Y2;
        }
        init() {
          return t3.init.apply(this, arguments), o2.call(this), this.eventsToUnbind.push(n4(this, "updatedData", function() {
            this.chart.series.forEach((s2) => {
              s2.type === this.type && (s2.isDirty = true);
            }, this);
          })), this;
        }
        onMouseUp(s2) {
          if (s2.fixedPosition && !s2.removed) {
            let d3, b5 = this.layout, A3 = this.parentNodeLayout;
            A3 && b5.options.dragBetweenSeries && A3.nodes.forEach((I3) => {
              s2 && s2.marker && I3 !== s2.series.parentNode && (d3 = b5.getDistXY(s2, I3), b5.vectorLength(d3) - I3.marker.radius - s2.marker.radius < 0 && (I3.series.addPoint(R2(s2.options, { plotX: s2.plotX, plotY: s2.plotY }), false), b5.removeElementFromCollection(s2, b5.nodes), s2.remove()));
            }), p2.onMouseUp.apply(this, arguments);
          }
        }
        placeBubbles(s2) {
          let d3 = this.checkOverlap, b5 = this.positionBubble, A3 = [], I3 = 1, C3 = 0, $2 = 0, F2, rt2 = [], O3, f2 = s2.sort((Y2, X2) => X2[2] - Y2[2]);
          if (f2.length) {
            if (A3.push([[0, 0, f2[0][2], f2[0][3], f2[0][4]]]), f2.length > 1) for (A3.push([[0, 0 - f2[1][2] - f2[0][2], f2[1][2], f2[1][3], f2[1][4]]]), O3 = 2; O3 < f2.length; O3++) f2[O3][2] = f2[O3][2] || 1, d3(F2 = b5(A3[I3][C3], A3[I3 - 1][$2], f2[O3]), A3[I3][0]) ? (A3.push([]), $2 = 0, A3[I3 + 1].push(b5(A3[I3][C3], A3[I3][0], f2[O3])), I3++, C3 = 0) : I3 > 1 && A3[I3 - 1][$2 + 1] && d3(F2, A3[I3 - 1][$2 + 1]) ? ($2++, A3[I3].push(b5(A3[I3][C3], A3[I3 - 1][$2], f2[O3])), C3++) : (C3++, A3[I3].push(F2));
            this.chart.stages = A3, this.chart.rawPositions = [].concat.apply([], A3), this.resizeRadius(), rt2 = this.chart.rawPositions;
          }
          return rt2;
        }
        pointAttribs(s2, d3) {
          let b5 = this.options, A3 = s2 && s2.isParentNode, I3 = b5.marker;
          A3 && b5.layoutAlgorithm && b5.layoutAlgorithm.parentNodeOptions && (I3 = b5.layoutAlgorithm.parentNodeOptions.marker);
          let C3 = I3.fillOpacity, $2 = t3.pointAttribs.call(this, s2, d3);
          return C3 !== 1 && ($2["fill-opacity"] = C3), $2;
        }
        positionBubble(s2, d3, b5) {
          let A3 = Math.asin, I3 = Math.acos, C3 = Math.pow, $2 = Math.abs, F2 = (0, Math.sqrt)(C3(s2[0] - d3[0], 2) + C3(s2[1] - d3[1], 2)), rt2 = I3((C3(F2, 2) + C3(b5[2] + d3[2], 2) - C3(b5[2] + s2[2], 2)) / (2 * (b5[2] + d3[2]) * F2)), O3 = A3($2(s2[0] - d3[0]) / F2), f2 = (s2[1] - d3[1] < 0 ? 0 : Math.PI) + rt2 + O3 * ((s2[0] - d3[0]) * (s2[1] - d3[1]) < 0 ? 1 : -1), Y2 = Math.cos(f2), X2 = Math.sin(f2);
          return [d3[0] + (d3[2] + b5[2]) * X2, d3[1] - (d3[2] + b5[2]) * Y2, b5[2], b5[3], b5[4]];
        }
        render() {
          let s2 = [];
          t3.render.apply(this, arguments), !this.options.dataLabels.allowOverlap && (this.data.forEach((d3) => {
            S2(d3.dataLabels) && d3.dataLabels.forEach((b5) => {
              s2.push(b5);
            });
          }), this.options.useSimulation && this.chart.hideOverlappingLabels(s2));
        }
        resizeRadius() {
          let s2, d3, b5, A3, I3, C3 = this.chart, $2 = C3.rawPositions, F2 = Math.min, rt2 = Math.max, O3 = C3.plotLeft, f2 = C3.plotTop, Y2 = C3.plotHeight, X2 = C3.plotWidth;
          for (let k3 of (s2 = b5 = Number.POSITIVE_INFINITY, d3 = A3 = Number.NEGATIVE_INFINITY, $2)) I3 = k3[2], s2 = F2(s2, k3[0] - I3), d3 = rt2(d3, k3[0] + I3), b5 = F2(b5, k3[1] - I3), A3 = rt2(A3, k3[1] + I3);
          let V2 = [d3 - s2, A3 - b5], q2 = [(X2 - O3) / V2[0], (Y2 - f2) / V2[1]], _2 = F2.apply([], q2);
          if (Math.abs(_2 - 1) > 1e-10) {
            for (let k3 of $2) k3[2] *= _2;
            this.placeBubbles($2);
          } else C3.diffY = Y2 / 2 + f2 - b5 - (A3 - b5) / 2, C3.diffX = X2 / 2 + O3 - s2 - (d3 - s2) / 2;
        }
        seriesBox() {
          let s2, d3 = this.chart, b5 = this.data, A3 = Math.max, I3 = Math.min, C3 = [d3.plotLeft, d3.plotLeft + d3.plotWidth, d3.plotTop, d3.plotTop + d3.plotHeight];
          return b5.forEach(($2) => {
            y2($2.plotX) && y2($2.plotY) && $2.marker.radius && (s2 = $2.marker.radius, C3[0] = I3(C3[0], $2.plotX - s2), C3[1] = A3(C3[1], $2.plotX + s2), C3[2] = I3(C3[2], $2.plotY - s2), C3[3] = A3(C3[3], $2.plotY + s2));
          }), L2(C3.width / C3.height) ? C3 : null;
        }
        setVisible() {
          let s2 = this;
          t3.setVisible.apply(s2, arguments), s2.parentNodeLayout && s2.graph ? s2.visible ? (s2.graph.show(), s2.parentNode.dataLabel && s2.parentNode.dataLabel.show()) : (s2.graph.hide(), s2.parentNodeLayout.removeElementFromCollection(s2.parentNode, s2.parentNodeLayout.nodes), s2.parentNode.dataLabel && s2.parentNode.dataLabel.hide()) : s2.layout && (s2.visible ? s2.layout.addElementsToCollection(s2.points, s2.layout.nodes) : s2.points.forEach((d3) => {
            s2.layout.removeElementFromCollection(d3, s2.layout.nodes);
          }));
        }
        translate() {
          let s2, d3, b5, A3 = this.chart, I3 = this.data, C3 = this.index, $2 = this.options.useSimulation;
          for (let F2 of (this.processedXData = this.xData, this.generatePoints(), y2(A3.allDataPoints) || (A3.allDataPoints = this.accumulateAllPoints(), this.getPointRadius()), $2 ? b5 = A3.allDataPoints : (b5 = this.placeBubbles(A3.allDataPoints), this.options.draggable = false), b5)) F2[3] === C3 && (s2 = I3[F2[4]], d3 = P2(F2[2], void 0), $2 || (s2.plotX = F2[0] - A3.plotLeft + A3.diffX, s2.plotY = F2[1] - A3.plotTop + A3.diffY), L2(d3) && (s2.marker = M2(s2.marker, { radius: d3, width: 2 * d3, height: 2 * d3 }), s2.radius = d3));
          $2 && this.deferLayout(), z2(this, "afterTranslate");
        }
      }
      return H2.defaultOptions = R2(i5.defaultOptions, T2), M2(H2.prototype, { pointClass: N2, axisTypes: [], directTouch: true, forces: ["barycenter", "repulsive"], hasDraggableNodes: true, invertible: false, isCartesian: false, noSharedTooltip: true, pointArrayMap: ["value"], pointValKey: "value", requireSorting: false, trackerGroups: ["group", "dataLabelsGroup", "parentNodesGroup"], initDataLabels: r3, alignDataLabel: t3.alignDataLabel, indexateNodes: g2, onMouseDown: p2.onMouseDown, onMouseMove: p2.onMouseMove, redrawHalo: p2.redrawHalo, searchPoint: g2 }), D2.registerSeriesType("packedbubble", H2), H2;
    }), tt2(e5, "Series/Polygon/PolygonSeriesDefaults.js", [], function() {
      return { marker: { enabled: false, states: { hover: { enabled: false } } }, stickyTracking: false, tooltip: { followPointer: true, pointFormat: "" }, trackByArea: true, legendSymbol: "rectangle" };
    }), tt2(e5, "Series/Polygon/PolygonSeries.js", [e5["Core/Globals.js"], e5["Series/Polygon/PolygonSeriesDefaults.js"], e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3) {
      let { noop: N2 } = a2, { area: T2, line: v3, scatter: D2 } = c4.seriesTypes, { extend: j3, merge: B3 } = m3;
      class x2 extends D2 {
        getGraphPath() {
          let l4 = v3.prototype.getGraphPath.call(this), g2 = l4.length + 1;
          for (; g2--; ) (g2 === l4.length || l4[g2][0] === "M") && g2 > 0 && l4.splice(g2, 0, ["Z"]);
          return this.areaPath = l4, l4;
        }
        drawGraph() {
          this.options.fillColor = this.color, T2.prototype.drawGraph.call(this);
        }
      }
      return x2.defaultOptions = B3(D2.defaultOptions, p2), j3(x2.prototype, { type: "polygon", drawTracker: v3.prototype.drawTracker, setStackedPoints: N2 }), c4.registerSeriesType("polygon", x2), x2;
    }), tt2(e5, "Core/Axis/RadialAxisDefaults.js", [], function() {
      return { circular: { gridLineWidth: 1, labels: { align: void 0, x: 0, y: void 0, style: { textOverflow: "none" } }, maxPadding: 0, minPadding: 0, showLastLabel: false, tickLength: 0 }, radial: { gridLineInterpolation: "circle", gridLineWidth: 1, labels: { align: "right", padding: 5, x: -3, y: -2 }, showLastLabel: false, title: { x: 4, text: null, rotation: 90 } }, radialGauge: { endOnTick: false, gridLineWidth: 0, labels: { align: "center", distance: -25, x: 0, y: void 0 }, lineWidth: 1, minorGridLineWidth: 0, minorTickInterval: "auto", minorTickLength: 10, minorTickPosition: "inside", minorTickWidth: 1, startOnTick: false, tickLength: 10, tickPixelInterval: 100, tickPosition: "inside", tickWidth: 2, title: { rotation: 0, text: "" }, zIndex: 2 } };
    }), tt2(e5, "Core/Axis/RadialAxis.js", [e5["Core/Axis/RadialAxisDefaults.js"], e5["Core/Defaults.js"], e5["Core/Globals.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3) {
      var N2;
      let { defaultOptions: T2 } = p2, { composed: v3, noop: D2 } = c4, { addEvent: j3, correctFloat: B3, defined: x2, extend: u2, fireEvent: l4, isObject: g2, merge: t3, pick: i5, pushUnique: r3, relativeLength: o2, wrap: n4 } = m3;
      return function(h2) {
        function y2() {
          this.autoConnect = this.isCircular && i5(this.userMax, this.options.max) === void 0 && B3(this.endAngleRad - this.startAngleRad) === B3(2 * Math.PI), !this.isCircular && this.chart.inverted && this.max++, this.autoConnect && (this.max += this.categories && 1 || this.pointRange || this.closestPointRange || 0);
        }
        function M2() {
          return () => {
            if (this.isRadial && this.tickPositions && this.options.labels && this.options.labels.allowOverlap !== true) return this.tickPositions.map((k3) => this.ticks[k3] && this.ticks[k3].label).filter((k3) => !!k3);
          };
        }
        function z2() {
          return D2;
        }
        function S2(k3, W2, G2) {
          let Z2 = this.pane.center, Q2 = k3.value, U2, K2, it2;
          return this.isCircular ? (x2(Q2) ? k3.point && (k3.point.shapeArgs || {}).start && (Q2 = this.chart.inverted ? this.translate(k3.point.rectPlotY, true) : k3.point.x) : (K2 = k3.chartX || 0, it2 = k3.chartY || 0, Q2 = this.translate(Math.atan2(it2 - G2, K2 - W2) - this.startAngleRad, true)), K2 = (U2 = this.getPosition(Q2)).x, it2 = U2.y) : (x2(Q2) || (K2 = k3.chartX, it2 = k3.chartY), x2(K2) && x2(it2) && (G2 = Z2[1] + this.chart.plotTop, Q2 = this.translate(Math.min(Math.sqrt(Math.pow(K2 - W2, 2) + Math.pow(it2 - G2, 2)), Z2[2] / 2) - Z2[3] / 2, true))), [Q2, K2 || 0, it2 || 0];
        }
        function L2(k3, W2, G2) {
          let Z2 = this.pane.center, Q2 = this.chart, U2 = this.left || 0, K2 = this.top || 0, it2, et2 = i5(W2, Z2[2] / 2 - this.offset), st2;
          return G2 === void 0 && (G2 = this.horiz ? 0 : this.center && -this.center[3] / 2), G2 && (et2 += G2), this.isCircular || W2 !== void 0 ? ((st2 = this.chart.renderer.symbols.arc(U2 + Z2[0], K2 + Z2[1], et2, et2, { start: this.startAngleRad, end: this.endAngleRad, open: true, innerR: 0 })).xBounds = [U2 + Z2[0]], st2.yBounds = [K2 + Z2[1] - et2]) : (it2 = this.postTranslate(this.angleRad, et2), st2 = [["M", this.center[0] + Q2.plotLeft, this.center[1] + Q2.plotTop], ["L", it2.x, it2.y]]), st2;
        }
        function R2() {
          this.constructor.prototype.getOffset.call(this), this.chart.axisOffset[this.side] = 0;
        }
        function P2(k3, W2, G2) {
          let Z2 = this.chart, Q2 = (ct2) => {
            if (typeof ct2 == "string") {
              let kt2 = parseInt(ct2, 10);
              return nt2.test(ct2) && (kt2 = kt2 * it2 / 100), kt2;
            }
            return ct2;
          }, U2 = this.center, K2 = this.startAngleRad, it2 = U2[2] / 2, et2 = Math.min(this.offset, 0), st2 = this.left || 0, ot2 = this.top || 0, nt2 = /%$/, dt2 = this.isCircular, at2, lt2, ht2, pt2, bt2, yt2, xt2 = i5(Q2(G2.outerRadius), it2), Pt2 = Q2(G2.innerRadius), St2 = i5(Q2(G2.thickness), 10);
          if (this.options.gridLineInterpolation === "polygon") yt2 = this.getPlotLinePath({ value: k3 }).concat(this.getPlotLinePath({ value: W2, reverse: true }));
          else {
            k3 = Math.max(k3, this.min), W2 = Math.min(W2, this.max);
            let ct2 = this.translate(k3), kt2 = this.translate(W2);
            dt2 || (xt2 = ct2 || 0, Pt2 = kt2 || 0), G2.shape !== "circle" && dt2 ? (at2 = K2 + (ct2 || 0), lt2 = K2 + (kt2 || 0)) : (at2 = -Math.PI / 2, lt2 = 1.5 * Math.PI, bt2 = true), xt2 -= et2, St2 -= et2, yt2 = Z2.renderer.symbols.arc(st2 + U2[0], ot2 + U2[1], xt2, xt2, { start: Math.min(at2, lt2), end: Math.max(at2, lt2), innerR: i5(Pt2, xt2 - St2), open: bt2, borderRadius: G2.borderRadius }), dt2 && (ht2 = (lt2 + at2) / 2, pt2 = st2 + U2[0] + U2[2] / 2 * Math.cos(ht2), yt2.xBounds = ht2 > -Math.PI / 2 && ht2 < Math.PI / 2 ? [pt2, Z2.plotWidth] : [0, pt2], yt2.yBounds = [ot2 + U2[1] + U2[2] / 2 * Math.sin(ht2)], yt2.yBounds[0] += ht2 > -Math.PI && ht2 < 0 || ht2 > Math.PI ? -10 : 10);
          }
          return yt2;
        }
        function H2(k3) {
          let W2 = this.pane.center, G2 = this.chart, Z2 = G2.inverted, Q2 = k3.reverse, U2 = this.pane.options.background ? this.pane.options.background[0] || this.pane.options.background : {}, K2 = U2.innerRadius || "0%", it2 = U2.outerRadius || "100%", et2 = W2[0] + G2.plotLeft, st2 = W2[1] + G2.plotTop, ot2 = this.height, nt2 = k3.isCrosshair, dt2 = W2[3] / 2, at2 = k3.value, lt2, ht2, pt2, bt2, yt2, xt2, Pt2, St2, ct2, kt2 = this.getPosition(at2), Lt2 = kt2.x, At2 = kt2.y;
          if (nt2 && (at2 = (St2 = this.getCrosshairPosition(k3, et2, st2))[0], Lt2 = St2[1], At2 = St2[2]), this.isCircular) ht2 = Math.sqrt(Math.pow(Lt2 - et2, 2) + Math.pow(At2 - st2, 2)), pt2 = typeof K2 == "string" ? o2(K2, 1) : K2 / ht2, bt2 = typeof it2 == "string" ? o2(it2, 1) : it2 / ht2, W2 && dt2 && (pt2 < (lt2 = dt2 / ht2) && (pt2 = lt2), bt2 < lt2 && (bt2 = lt2)), ct2 = [["M", et2 + pt2 * (Lt2 - et2), st2 - pt2 * (st2 - At2)], ["L", Lt2 - (1 - bt2) * (Lt2 - et2), At2 + (1 - bt2) * (st2 - At2)]];
          else if ((at2 = this.translate(at2)) && (at2 < 0 || at2 > ot2) && (at2 = 0), this.options.gridLineInterpolation === "circle") ct2 = this.getLinePath(0, at2, dt2);
          else if (ct2 = [], G2[Z2 ? "yAxis" : "xAxis"].forEach((Ct2) => {
            Ct2.pane === this.pane && (yt2 = Ct2);
          }), yt2) {
            Pt2 = yt2.tickPositions, yt2.autoConnect && (Pt2 = Pt2.concat([Pt2[0]])), Q2 && (Pt2 = Pt2.slice().reverse()), at2 && (at2 += dt2);
            for (let Ct2 = 0; Ct2 < Pt2.length; Ct2++) xt2 = yt2.getPosition(Pt2[Ct2], at2), ct2.push(Ct2 ? ["L", xt2.x, xt2.y] : ["M", xt2.x, xt2.y]);
          }
          return ct2;
        }
        function E2(k3, W2) {
          let G2 = this.translate(k3);
          return this.postTranslate(this.isCircular ? G2 : this.angleRad, i5(this.isCircular ? W2 : G2 < 0 ? 0 : G2, this.center[2] / 2) - this.offset);
        }
        function s2() {
          let k3 = this.center, W2 = this.chart, G2 = this.options.title;
          return { x: W2.plotLeft + k3[0] + (G2.x || 0), y: W2.plotTop + k3[1] - { high: 0.5, middle: 0.25, low: 0 }[G2.align] * k3[2] + (G2.y || 0) };
        }
        function d3(k3) {
          k3.beforeSetTickPositions = y2, k3.createLabelCollector = M2, k3.getCrosshairPosition = S2, k3.getLinePath = L2, k3.getOffset = R2, k3.getPlotBandPath = P2, k3.getPlotLinePath = H2, k3.getPosition = E2, k3.getTitlePosition = s2, k3.postTranslate = f2, k3.setAxisSize = X2, k3.setAxisTranslation = V2, k3.setOptions = q2;
        }
        function b5() {
          let k3 = this.chart, W2 = this.options, G2 = k3.angular && this.isXAxis, Z2 = this.pane, Q2 = Z2 && Z2.options;
          if (!G2 && Z2 && (k3.angular || k3.polar)) {
            let U2 = 2 * Math.PI, K2 = (i5(Q2.startAngle, 0) - 90) * Math.PI / 180, it2 = (i5(Q2.endAngle, i5(Q2.startAngle, 0) + 360) - 90) * Math.PI / 180;
            this.angleRad = (W2.angle || 0) * Math.PI / 180, this.startAngleRad = K2, this.endAngleRad = it2, this.offset = W2.offset || 0;
            let et2 = (K2 % U2 + U2) % U2, st2 = (it2 % U2 + U2) % U2;
            et2 > Math.PI && (et2 -= U2), st2 > Math.PI && (st2 -= U2), this.normalizedStartAngleRad = et2, this.normalizedEndAngleRad = st2;
          }
        }
        function A3(k3) {
          this.isRadial && (k3.align = void 0, k3.preventDefault());
        }
        function I3() {
          if (this.chart && this.chart.labelCollectors) {
            let k3 = this.labelCollector ? this.chart.labelCollectors.indexOf(this.labelCollector) : -1;
            k3 >= 0 && this.chart.labelCollectors.splice(k3, 1);
          }
        }
        function C3(k3) {
          let W2, G2 = this.chart, Z2 = G2.angular, Q2 = G2.polar, U2 = this.isXAxis, K2 = this.coll, it2 = k3.userOptions.pane || 0, et2 = this.pane = G2.pane && G2.pane[it2];
          if (K2 === "colorAxis") {
            this.isRadial = false;
            return;
          }
          Z2 ? (Z2 && U2 ? (this.isHidden = true, this.createLabelCollector = z2, this.getOffset = D2, this.redraw = Y2, this.render = Y2, this.setScale = D2, this.setCategories = D2, this.setTitle = D2) : d3(this), W2 = !U2) : Q2 && (d3(this), W2 = this.horiz), Z2 || Q2 ? (this.isRadial = true, this.labelCollector || (this.labelCollector = this.createLabelCollector()), this.labelCollector && G2.labelCollectors.push(this.labelCollector)) : this.isRadial = false, et2 && W2 && (et2.axis = this), this.isCircular = W2;
        }
        function $2() {
          this.isRadial && this.beforeSetTickPositions();
        }
        function F2(k3) {
          let W2 = this.label;
          if (!W2) return;
          let G2 = this.axis, Z2 = W2.getBBox(), Q2 = G2.options.labels, U2 = (G2.translate(this.pos) + G2.startAngleRad + Math.PI / 2) / Math.PI * 180 % 360, K2 = Math.round(U2), it2 = x2(Q2.y) ? 0 : -(0.3 * Z2.height), et2 = Q2.y, st2, ot2 = 20, nt2 = Q2.align, dt2 = "end", at2 = K2 < 0 ? K2 + 360 : K2, lt2 = at2, ht2 = 0, pt2 = 0;
          G2.isRadial && (st2 = G2.getPosition(this.pos, G2.center[2] / 2 + o2(i5(Q2.distance, -25), G2.center[2] / 2, -G2.center[2] / 2)), Q2.rotation === "auto" ? W2.attr({ rotation: U2 }) : x2(et2) || (et2 = G2.chart.renderer.fontMetrics(W2).b - Z2.height / 2), x2(nt2) || (G2.isCircular ? (Z2.width > G2.len * G2.tickInterval / (G2.max - G2.min) && (ot2 = 0), nt2 = U2 > ot2 && U2 < 180 - ot2 ? "left" : U2 > 180 + ot2 && U2 < 360 - ot2 ? "right" : "center") : nt2 = "center", W2.attr({ align: nt2 })), nt2 === "auto" && G2.tickPositions.length === 2 && G2.isCircular && (at2 > 90 && at2 < 180 ? at2 = 180 - at2 : at2 > 270 && at2 <= 360 && (at2 = 540 - at2), lt2 > 180 && lt2 <= 360 && (lt2 = 360 - lt2), (G2.pane.options.startAngle === K2 || G2.pane.options.startAngle === K2 + 360 || G2.pane.options.startAngle === K2 - 360) && (dt2 = "start"), nt2 = K2 >= -90 && K2 <= 90 || K2 >= -360 && K2 <= -270 || K2 >= 270 && K2 <= 360 ? dt2 === "start" ? "right" : "left" : dt2 === "start" ? "left" : "right", lt2 > 70 && lt2 < 110 && (nt2 = "center"), at2 < 15 || at2 >= 180 && at2 < 195 ? ht2 = 0.3 * Z2.height : at2 >= 15 && at2 <= 35 ? ht2 = dt2 === "start" ? 0 : 0.75 * Z2.height : at2 >= 195 && at2 <= 215 ? ht2 = dt2 === "start" ? 0.75 * Z2.height : 0 : at2 > 35 && at2 <= 90 ? ht2 = dt2 === "start" ? -(0.25 * Z2.height) : Z2.height : at2 > 215 && at2 <= 270 && (ht2 = dt2 === "start" ? Z2.height : -(0.25 * Z2.height)), lt2 < 15 ? pt2 = dt2 === "start" ? -(0.15 * Z2.height) : 0.15 * Z2.height : lt2 > 165 && lt2 <= 180 && (pt2 = dt2 === "start" ? 0.15 * Z2.height : -(0.15 * Z2.height)), W2.attr({ align: nt2 }), W2.translate(pt2, ht2 + it2)), k3.pos.x = st2.x + (Q2.x || 0), k3.pos.y = st2.y + (et2 || 0));
        }
        function rt2(k3) {
          this.axis.getPosition && u2(k3.pos, this.axis.getPosition(this.pos));
        }
        function O3({ options: k3 }) {
          k3.xAxis && t3(true, h2.radialDefaultOptions.circular, k3.xAxis), k3.yAxis && t3(true, h2.radialDefaultOptions.radialGauge, k3.yAxis);
        }
        function f2(k3, W2) {
          let G2 = this.chart, Z2 = this.center;
          return k3 = this.startAngleRad + k3, { x: G2.plotLeft + Z2[0] + Math.cos(k3) * W2, y: G2.plotTop + Z2[1] + Math.sin(k3) * W2 };
        }
        function Y2() {
          this.isDirty = false;
        }
        function X2() {
          let k3, W2;
          this.constructor.prototype.setAxisSize.call(this), this.isRadial && (this.pane.updateCenter(this), k3 = this.center = this.pane.center.slice(), this.isCircular ? this.sector = this.endAngleRad - this.startAngleRad : (W2 = this.postTranslate(this.angleRad, k3[3] / 2), k3[0] = W2.x - this.chart.plotLeft, k3[1] = W2.y - this.chart.plotTop), this.len = this.width = this.height = (k3[2] - k3[3]) * i5(this.sector, 1) / 2);
        }
        function V2() {
          this.constructor.prototype.setAxisTranslation.call(this), this.center && (this.isCircular ? this.transA = (this.endAngleRad - this.startAngleRad) / (this.max - this.min || 1) : this.transA = (this.center[2] - this.center[3]) / 2 / (this.max - this.min || 1), this.isXAxis ? this.minPixelPadding = this.transA * this.minPointOffset : this.minPixelPadding = 0);
        }
        function q2(k3) {
          let { coll: W2 } = this, { angular: G2, inverted: Z2, polar: Q2 } = this.chart, U2 = {};
          G2 ? this.isXAxis || (U2 = t3(T2.yAxis, h2.radialDefaultOptions.radialGauge)) : Q2 && (U2 = this.horiz ? t3(T2.xAxis, h2.radialDefaultOptions.circular) : t3(W2 === "xAxis" ? T2.xAxis : T2.yAxis, h2.radialDefaultOptions.radial)), Z2 && W2 === "yAxis" && (U2.stackLabels = g2(T2.yAxis, true) ? T2.yAxis.stackLabels : {}, U2.reversedStacks = true);
          let K2 = this.options = t3(U2, k3);
          K2.plotBands || (K2.plotBands = []), l4(this, "afterSetOptions");
        }
        function _2(k3, W2, G2, Z2, Q2, U2, K2) {
          let it2, et2 = this.axis;
          return et2.isRadial ? ["M", W2, G2, "L", (it2 = et2.getPosition(this.pos, et2.center[2] / 2 + Z2)).x, it2.y] : k3.call(this, W2, G2, Z2, Q2, U2, K2);
        }
        h2.radialDefaultOptions = t3(a2), h2.compose = function(k3, W2) {
          return r3(v3, "Axis.Radial") && (j3(k3, "afterInit", b5), j3(k3, "autoLabelAlign", A3), j3(k3, "destroy", I3), j3(k3, "init", C3), j3(k3, "initialAxisTranslation", $2), j3(W2, "afterGetLabelPosition", F2), j3(W2, "afterGetPosition", rt2), j3(c4, "setOptions", O3), n4(W2.prototype, "getMarkPath", _2)), k3;
        };
      }(N2 || (N2 = {})), N2;
    }), tt2(e5, "Series/PolarComposition.js", [e5["Core/Animation/AnimationUtilities.js"], e5["Core/Globals.js"], e5["Core/Series/Series.js"], e5["Extensions/Pane/Pane.js"], e5["Core/Axis/RadialAxis.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3, N2, T2) {
      let { animObject: v3 } = a2, { composed: D2 } = p2, { addEvent: j3, defined: B3, find: x2, isNumber: u2, merge: l4, pick: g2, pushUnique: t3, relativeLength: i5, splat: r3, uniqueKey: o2, wrap: n4 } = T2;
      function h2() {
        (this.pane || []).forEach((O3) => {
          O3.render();
        });
      }
      function y2(O3) {
        let f2 = O3.args[0].xAxis, Y2 = O3.args[0].yAxis, X2 = O3.args[0].chart;
        f2 && Y2 && (Y2.gridLineInterpolation === "polygon" ? (f2.startOnTick = true, f2.endOnTick = true) : f2.gridLineInterpolation === "polygon" && X2.inverted && (Y2.startOnTick = true, Y2.endOnTick = true));
      }
      function M2() {
        this.pane || (this.pane = []), this.options.pane = r3(this.options.pane), this.options.pane.forEach((O3) => {
          new m3(O3, this);
        }, this);
      }
      function z2(O3) {
        let f2 = O3.args.marker, Y2 = this.chart.xAxis[0], X2 = this.chart.yAxis[0], V2 = this.chart.inverted, q2 = V2 ? X2 : Y2, _2 = V2 ? Y2 : X2;
        if (this.chart.polar) {
          O3.preventDefault();
          let k3 = (f2.attr ? f2.attr("start") : f2.start) - q2.startAngleRad, W2 = f2.attr ? f2.attr("r") : f2.r, G2 = (f2.attr ? f2.attr("end") : f2.end) - q2.startAngleRad, Z2 = f2.attr ? f2.attr("innerR") : f2.innerR;
          O3.result.x = k3 + q2.pos, O3.result.width = G2 - k3, O3.result.y = _2.len + _2.pos - W2, O3.result.height = W2 - Z2;
        }
      }
      function S2(O3) {
        let f2 = this.chart;
        if (f2.polar && f2.hoverPane && f2.hoverPane.axis) {
          O3.preventDefault();
          let Y2 = f2.hoverPane.center, X2 = f2.mouseDownX || 0, V2 = f2.mouseDownY || 0, q2 = O3.args.chartY, _2 = O3.args.chartX, k3 = 2 * Math.PI, W2 = f2.hoverPane.axis.startAngleRad, G2 = f2.hoverPane.axis.endAngleRad, Z2 = f2.inverted ? f2.xAxis[0] : f2.yAxis[0], Q2 = {}, U2 = "arc";
          if (Q2.x = Y2[0] + f2.plotLeft, Q2.y = Y2[1] + f2.plotTop, this.zoomHor) {
            let K2 = W2 > 0 ? G2 - W2 : Math.abs(W2) + Math.abs(G2), it2 = Math.atan2(V2 - f2.plotTop - Y2[1], X2 - f2.plotLeft - Y2[0]) - W2, et2 = Math.atan2(q2 - f2.plotTop - Y2[1], _2 - f2.plotLeft - Y2[0]) - W2;
            Q2.r = Y2[2] / 2, Q2.innerR = Y2[3] / 2, it2 <= 0 && (it2 += k3), et2 <= 0 && (et2 += k3), et2 < it2 && (et2 = [it2, it2 = et2][0]), K2 < k3 && W2 + et2 > G2 + (k3 - K2) / 2 && (et2 = it2, it2 = W2 <= 0 ? W2 : 0);
            let st2 = Q2.start = Math.max(it2 + W2, W2), ot2 = Q2.end = Math.min(et2 + W2, G2);
            if (Z2.options.gridLineInterpolation === "polygon") {
              let nt2 = f2.hoverPane.axis, dt2 = st2 - nt2.startAngleRad + nt2.pos, at2 = Z2.getPlotLinePath({ value: Z2.max }), lt2 = nt2.toValue(dt2), ht2 = nt2.toValue(dt2 + (ot2 - st2));
              if (lt2 < nt2.getExtremes().min) {
                let { min: pt2, max: bt2 } = nt2.getExtremes();
                lt2 = bt2 - (pt2 - lt2);
              }
              if (ht2 < nt2.getExtremes().min) {
                let { min: pt2, max: bt2 } = nt2.getExtremes();
                ht2 = bt2 - (pt2 - ht2);
              }
              ht2 < lt2 && (ht2 = [lt2, lt2 = ht2][0]), (at2 = H2(at2, lt2, ht2, nt2)).push(["L", Y2[0] + f2.plotLeft, f2.plotTop + Y2[1]]), Q2.d = at2, U2 = "path";
            }
          }
          if (this.zoomVert) {
            let K2 = f2.inverted ? f2.xAxis[0] : f2.yAxis[0], it2 = Math.sqrt(Math.pow(X2 - f2.plotLeft - Y2[0], 2) + Math.pow(V2 - f2.plotTop - Y2[1], 2)), et2 = Math.sqrt(Math.pow(_2 - f2.plotLeft - Y2[0], 2) + Math.pow(q2 - f2.plotTop - Y2[1], 2));
            if (et2 < it2 && (it2 = [et2, et2 = it2][0]), et2 > Y2[2] / 2 && (et2 = Y2[2] / 2), it2 < Y2[3] / 2 && (it2 = Y2[3] / 2), this.zoomHor || (Q2.start = W2, Q2.end = G2), Q2.r = et2, Q2.innerR = it2, K2.options.gridLineInterpolation === "polygon") {
              let st2 = K2.toValue(K2.len + K2.pos - it2), ot2 = K2.toValue(K2.len + K2.pos - et2), nt2 = K2.getPlotLinePath({ value: ot2 }).concat(K2.getPlotLinePath({ value: st2, reverse: true }));
              Q2.d = nt2, U2 = "path";
            }
          }
          if (this.zoomHor && this.zoomVert && Z2.options.gridLineInterpolation === "polygon") {
            let K2 = f2.hoverPane.axis, it2 = Q2.start || 0, et2 = Q2.end || 0, st2 = it2 - K2.startAngleRad + K2.pos, ot2 = K2.toValue(st2), nt2 = K2.toValue(st2 + (et2 - it2));
            if (Q2.d instanceof Array) {
              let dt2 = Q2.d.slice(0, Q2.d.length / 2), at2 = Q2.d.slice(Q2.d.length / 2, Q2.d.length);
              at2 = [...at2].reverse();
              let lt2 = f2.hoverPane.axis;
              dt2 = H2(dt2, ot2, nt2, lt2), (at2 = H2(at2, ot2, nt2, lt2)) && (at2[0][0] = "L"), at2 = [...at2].reverse(), Q2.d = dt2.concat(at2), U2 = "path";
            }
          }
          O3.attrs = Q2, O3.shapeType = U2;
        }
      }
      function L2() {
        let O3 = this.chart;
        O3.polar && (this.polar = new rt2(this), O3.inverted && (this.isRadialSeries = true, this.is("column") && (this.isRadialBar = true)));
      }
      function R2() {
        if (this.chart.polar && this.xAxis) {
          let { xAxis: O3, yAxis: f2 } = this, Y2 = this.chart;
          this.kdByAngle = Y2.tooltip && Y2.tooltip.shared, this.kdByAngle || Y2.inverted ? this.searchPoint = P2 : this.options.findNearestPointBy = "xy";
          let X2 = this.points, V2 = X2.length;
          for (; V2--; ) this.is("column") || this.is("columnrange") || this.polar.toXY(X2[V2]), Y2.hasParallelCoordinates || this.yAxis.reversed || (g2(X2[V2].y, Number.MIN_VALUE) < f2.min || X2[V2].x < O3.min || X2[V2].x > O3.max ? (X2[V2].isNull = true, X2[V2].plotY = NaN) : X2[V2].isNull = X2[V2].isValid && !X2[V2].isValid());
          this.hasClipCircleSetter || (this.hasClipCircleSetter = !!this.eventsToUnbind.push(j3(this, "afterRender", function() {
            let q2;
            Y2.polar && this.options.clip !== false && (q2 = this.yAxis.pane.center, this.clipCircle ? this.clipCircle.animate({ x: q2[0], y: q2[1], r: q2[2] / 2, innerR: q2[3] / 2 }) : this.clipCircle = function(_2, k3, W2, G2, Z2) {
              let Q2 = o2(), U2 = _2.createElement("clipPath").attr({ id: Q2 }).add(_2.defs), K2 = Z2 ? _2.arc(k3, W2, G2, Z2, 0, 2 * Math.PI).add(U2) : _2.circle(k3, W2, G2).add(U2);
              return K2.id = Q2, K2.clipPath = U2, K2;
            }(Y2.renderer, q2[0], q2[1], q2[2] / 2, q2[3] / 2), this.group.clip(this.clipCircle), this.setClip = p2.noop);
          })));
        }
      }
      function P2(O3) {
        let f2 = this.chart, Y2 = this.xAxis, X2 = this.yAxis, V2 = Y2.pane && Y2.pane.center, q2 = O3.chartX - (V2 && V2[0] || 0) - f2.plotLeft, _2 = O3.chartY - (V2 && V2[1] || 0) - f2.plotTop, k3 = f2.inverted ? { clientX: O3.chartX - X2.pos, plotY: O3.chartY - Y2.pos } : { clientX: 180 + -180 / Math.PI * Math.atan2(q2, _2) };
        return this.searchKDTree(k3);
      }
      function H2(O3, f2, Y2, X2) {
        let V2 = X2.tickInterval, q2 = X2.tickPositions, _2 = x2(q2, (W2) => W2 >= Y2), k3 = x2([...q2].reverse(), (W2) => W2 <= f2);
        return B3(_2) || (_2 = q2[q2.length - 1]), B3(k3) || (k3 = q2[0], _2 += V2, O3[0][0] = "L", O3.unshift(O3[O3.length - 3])), (O3 = O3.slice(q2.indexOf(k3), q2.indexOf(_2) + 1))[0][0] = "M", O3;
      }
      function E2(O3, f2) {
        return x2(this.pane || [], (Y2) => Y2.options.id === f2) || O3.call(this, f2);
      }
      function s2(O3, f2, Y2, X2, V2, q2) {
        let _2, k3, W2, G2 = this.chart, Z2 = g2(X2.inside, !!this.options.stacking);
        if (G2.polar) {
          if (_2 = f2.rectPlotX / Math.PI * 180, G2.inverted) this.forceDL = G2.isInsidePlot(f2.plotX, f2.plotY), Z2 && f2.shapeArgs ? (k3 = f2.shapeArgs, V2 = l4(V2, { x: (W2 = this.yAxis.postTranslate(((k3.start || 0) + (k3.end || 0)) / 2 - this.xAxis.startAngleRad, f2.barX + f2.pointWidth / 2)).x - G2.plotLeft, y: W2.y - G2.plotTop })) : f2.tooltipPos && (V2 = l4(V2, { x: f2.tooltipPos[0], y: f2.tooltipPos[1] })), X2.align = g2(X2.align, "center"), X2.verticalAlign = g2(X2.verticalAlign, "middle");
          else {
            var Q2;
            let U2, K2;
            (Q2 = X2).align === null && (U2 = _2 > 20 && _2 < 160 ? "left" : _2 > 200 && _2 < 340 ? "right" : "center", Q2.align = U2), Q2.verticalAlign === null && (K2 = _2 < 45 || _2 > 315 ? "bottom" : _2 > 135 && _2 < 225 ? "top" : "middle", Q2.verticalAlign = K2), X2 = Q2;
          }
          c4.prototype.alignDataLabel.call(this, f2, Y2, X2, V2, q2), this.isRadialBar && f2.shapeArgs && f2.shapeArgs.start === f2.shapeArgs.end ? Y2.hide() : Y2.show();
        } else O3.call(this, f2, Y2, X2, V2, q2);
      }
      function d3() {
        let O3 = this.options, f2 = O3.stacking, Y2 = this.chart, X2 = this.xAxis, V2 = this.yAxis, q2 = V2.reversed, _2 = V2.center, k3 = X2.startAngleRad, W2 = X2.endAngleRad - k3, G2 = O3.threshold, Z2 = 0, Q2, U2, K2, it2, et2, st2 = 0, ot2 = 0, nt2, dt2, at2, lt2, ht2, pt2, bt2, yt2;
        if (X2.isRadial) for (K2 = (Q2 = this.points).length, it2 = V2.translate(V2.min), et2 = V2.translate(V2.max), G2 = O3.threshold || 0, Y2.inverted && u2(G2) && B3(Z2 = V2.translate(G2)) && (Z2 < 0 ? Z2 = 0 : Z2 > W2 && (Z2 = W2), this.translatedThreshold = Z2 + k3); K2--; ) {
          if (pt2 = (U2 = Q2[K2]).barX, dt2 = U2.x, at2 = U2.y, U2.shapeType = "arc", Y2.inverted) {
            U2.plotY = V2.translate(at2), f2 && V2.stacking ? (ht2 = V2.stacking.stacks[(at2 < 0 ? "-" : "") + this.stackKey], this.visible && ht2 && ht2[dt2] && !U2.isNull && (lt2 = ht2[dt2].points[this.getStackIndicator(void 0, dt2, this.index).key], st2 = V2.translate(lt2[0]), ot2 = V2.translate(lt2[1]), B3(st2) && (st2 = T2.clamp(st2, 0, W2)))) : (st2 = Z2, ot2 = U2.plotY), st2 > ot2 && (ot2 = [st2, st2 = ot2][0]), q2 ? ot2 > it2 ? ot2 = it2 : st2 < et2 ? st2 = et2 : (st2 > it2 || ot2 < et2) && (st2 = ot2 = W2) : st2 < it2 ? st2 = it2 : ot2 > et2 ? ot2 = et2 : (ot2 < it2 || st2 > et2) && (st2 = ot2 = 0), V2.min > V2.max && (st2 = ot2 = q2 ? W2 : 0), st2 += k3, ot2 += k3, _2 && (U2.barX = pt2 += _2[3] / 2), bt2 = Math.max(pt2, 0), yt2 = Math.max(pt2 + U2.pointWidth, 0);
            let xt2 = O3.borderRadius, Pt2 = i5((typeof xt2 == "object" ? xt2.radius : xt2) || 0, yt2 - bt2);
            U2.shapeArgs = { x: _2[0], y: _2[1], r: yt2, innerR: bt2, start: st2, end: ot2, borderRadius: Pt2 }, U2.opacity = st2 === ot2 ? 0 : void 0, U2.plotY = (B3(this.translatedThreshold) && (st2 < this.translatedThreshold ? st2 : ot2)) - k3;
          } else st2 = pt2 + k3, U2.shapeArgs = this.polar.arc(U2.yBottom, U2.plotY, st2, st2 + U2.pointWidth), U2.shapeArgs.borderRadius = 0;
          this.polar.toXY(U2), Y2.inverted ? (nt2 = V2.postTranslate(U2.rectPlotY, pt2 + U2.pointWidth / 2), U2.tooltipPos = [nt2.x - Y2.plotLeft, nt2.y - Y2.plotTop]) : U2.tooltipPos = [U2.plotX, U2.plotY], _2 && (U2.ttBelow = U2.plotY > _2[1]);
        }
      }
      function b5(O3, f2) {
        let Y2, X2, V2 = this;
        if (this.chart.polar) {
          f2 = f2 || this.points;
          for (let _2 = 0; _2 < f2.length; _2++) if (!f2[_2].isNull) {
            Y2 = _2;
            break;
          }
          this.options.connectEnds !== false && Y2 !== void 0 && (this.connectEnds = true, f2.splice(f2.length, 0, f2[Y2]), X2 = true), f2.forEach((_2) => {
            _2.polarPlotY === void 0 && V2.polar.toXY(_2);
          });
        }
        let q2 = O3.apply(this, [].slice.call(arguments, 1));
        return X2 && f2.pop(), q2;
      }
      function A3(O3, f2) {
        let Y2 = this.chart, X2 = { xAxis: [], yAxis: [] };
        return Y2.polar ? Y2.axes.forEach((V2) => {
          if (V2.coll === "colorAxis") return;
          let q2 = V2.isXAxis, _2 = V2.center, k3 = f2.chartX - _2[0] - Y2.plotLeft, W2 = f2.chartY - _2[1] - Y2.plotTop;
          X2[q2 ? "xAxis" : "yAxis"].push({ axis: V2, value: V2.translate(q2 ? Math.PI - Math.atan2(k3, W2) : Math.sqrt(Math.pow(k3, 2) + Math.pow(W2, 2)), true) });
        }) : X2 = O3.call(this, f2), X2;
      }
      function I3(O3, f2) {
        this.chart.polar || O3.call(this, f2);
      }
      function C3(O3, f2) {
        let Y2 = this, X2 = this.chart, V2 = this.group, q2 = this.markerGroup, _2 = this.xAxis && this.xAxis.center, k3 = X2.plotLeft, W2 = X2.plotTop, G2 = this.options.animation, Z2, Q2, U2, K2, it2, et2;
        X2.polar ? Y2.isRadialBar ? f2 || (Y2.startAngleRad = g2(Y2.translatedThreshold, Y2.xAxis.startAngleRad), p2.seriesTypes.pie.prototype.animate.call(Y2, f2)) : (G2 = v3(G2), Y2.is("column") ? f2 || (Q2 = _2[3] / 2, Y2.points.forEach((st2) => {
          U2 = st2.graphic, it2 = (K2 = st2.shapeArgs) && K2.r, et2 = K2 && K2.innerR, U2 && K2 && (U2.attr({ r: Q2, innerR: Q2 }), U2.animate({ r: it2, innerR: et2 }, Y2.options.animation));
        })) : f2 ? (Z2 = { translateX: _2[0] + k3, translateY: _2[1] + W2, scaleX: 1e-3, scaleY: 1e-3 }, V2.attr(Z2), q2 && q2.attr(Z2)) : (Z2 = { translateX: k3, translateY: W2, scaleX: 1, scaleY: 1 }, V2.animate(Z2, G2), q2 && q2.animate(Z2, G2))) : O3.call(this, f2);
      }
      function $2(O3, f2, Y2, X2) {
        let V2, q2;
        if (this.chart.polar)
          if (X2) {
            let _2 = (q2 = function W2(G2, Z2, Q2, U2) {
              let K2, it2, et2, st2, ot2, nt2, dt2 = U2 ? 1 : 0, at2 = (K2 = Z2 >= 0 && Z2 <= G2.length - 1 ? Z2 : Z2 < 0 ? G2.length - 1 + Z2 : 0) - 1 < 0 ? G2.length - (1 + dt2) : K2 - 1, lt2 = K2 + 1 > G2.length - 1 ? dt2 : K2 + 1, ht2 = G2[at2], pt2 = G2[lt2], bt2 = ht2.plotX, yt2 = ht2.plotY, xt2 = pt2.plotX, Pt2 = pt2.plotY, St2 = G2[K2].plotX, ct2 = G2[K2].plotY;
              it2 = (1.5 * St2 + bt2) / 2.5, et2 = (1.5 * ct2 + yt2) / 2.5, st2 = (1.5 * St2 + xt2) / 2.5, ot2 = (1.5 * ct2 + Pt2) / 2.5;
              let kt2 = Math.sqrt(Math.pow(it2 - St2, 2) + Math.pow(et2 - ct2, 2)), Lt2 = Math.sqrt(Math.pow(st2 - St2, 2) + Math.pow(ot2 - ct2, 2)), At2 = Math.atan2(et2 - ct2, it2 - St2);
              nt2 = Math.PI / 2 + (At2 + Math.atan2(ot2 - ct2, st2 - St2)) / 2, Math.abs(At2 - nt2) > Math.PI / 2 && (nt2 -= Math.PI), it2 = St2 + Math.cos(nt2) * kt2, et2 = ct2 + Math.sin(nt2) * kt2;
              let Ct2 = { rightContX: st2 = St2 + Math.cos(Math.PI + nt2) * Lt2, rightContY: ot2 = ct2 + Math.sin(Math.PI + nt2) * Lt2, leftContX: it2, leftContY: et2, plotX: St2, plotY: ct2 };
              return Q2 && (Ct2.prevPointCont = W2(G2, at2, false, U2)), Ct2;
            }(f2, X2, true, this.connectEnds)).prevPointCont && q2.prevPointCont.rightContX, k3 = q2.prevPointCont && q2.prevPointCont.rightContY;
            V2 = ["C", u2(_2) ? _2 : q2.plotX, u2(k3) ? k3 : q2.plotY, u2(q2.leftContX) ? q2.leftContX : q2.plotX, u2(q2.leftContY) ? q2.leftContY : q2.plotY, q2.plotX, q2.plotY];
          } else V2 = ["M", Y2.plotX, Y2.plotY];
        else V2 = O3.call(this, f2, Y2, X2);
        return V2;
      }
      function F2(O3, f2, Y2 = this.plotY) {
        if (!this.destroyed) {
          let { plotX: X2, series: V2 } = this, { chart: q2 } = V2;
          return q2.polar && u2(X2) && u2(Y2) ? [X2 + (f2 ? q2.plotLeft : 0), Y2 + (f2 ? q2.plotTop : 0)] : O3.call(this, f2, Y2);
        }
      }
      class rt2 {
        static compose(f2, Y2, X2, V2, q2, _2, k3, W2, G2, Z2) {
          if (m3.compose(Y2, X2), N2.compose(f2, q2), t3(D2, "Polar")) {
            let Q2 = Y2.prototype, U2 = _2.prototype, K2 = X2.prototype, it2 = V2.prototype;
            if (j3(Y2, "afterDrawChartBox", h2), j3(Y2, "getAxes", M2), j3(Y2, "init", y2), n4(Q2, "get", E2), n4(K2, "getCoordinates", A3), n4(K2, "pinch", I3), j3(X2, "getSelectionMarkerAttrs", S2), j3(X2, "getSelectionBox", z2), j3(V2, "afterInit", L2), j3(V2, "afterTranslate", R2, { order: 2 }), j3(V2, "afterColumnTranslate", d3, { order: 4 }), n4(it2, "animate", C3), n4(U2, "pos", F2), W2) {
              let et2 = W2.prototype;
              n4(et2, "alignDataLabel", s2), n4(et2, "animate", C3);
            }
            if (G2 && n4(G2.prototype, "getGraphPath", b5), Z2) {
              let et2 = Z2.prototype;
              n4(et2, "getPointSpline", $2), k3 && (k3.prototype.getPointSpline = et2.getPointSpline);
            }
          }
        }
        constructor(f2) {
          this.series = f2;
        }
        arc(f2, Y2, X2, V2) {
          let q2 = this.series, _2 = q2.xAxis.center, k3 = q2.yAxis.len, W2 = _2[3] / 2, G2 = k3 - Y2 + W2, Z2 = k3 - g2(f2, k3) + W2;
          return q2.yAxis.reversed && (G2 < 0 && (G2 = W2), Z2 < 0 && (Z2 = W2)), { x: _2[0], y: _2[1], r: G2, innerR: Z2, start: X2, end: V2 };
        }
        toXY(f2) {
          let Y2 = this.series, X2 = Y2.chart, V2 = Y2.xAxis, q2 = Y2.yAxis, _2 = f2.plotX, k3 = X2.inverted, W2 = f2.y, G2 = f2.plotY, Z2 = k3 ? _2 : q2.len - G2, Q2;
          if (k3 && Y2 && !Y2.isRadialBar && (f2.plotY = G2 = u2(W2) ? q2.translate(W2) : 0), f2.rectPlotX = _2, f2.rectPlotY = G2, q2.center && (Z2 += q2.center[3] / 2), u2(G2)) {
            let U2 = k3 ? q2.postTranslate(G2, Z2) : V2.postTranslate(_2, Z2);
            f2.plotX = f2.polarPlotX = U2.x - X2.plotLeft, f2.plotY = f2.polarPlotY = U2.y - X2.plotTop;
          }
          Y2.kdByAngle ? ((Q2 = (_2 / Math.PI * 180 + V2.pane.options.startAngle) % 360) < 0 && (Q2 += 360), f2.clientX = Q2) : f2.clientX = f2.plotX;
        }
      }
      return rt2;
    }), tt2(e5, "Core/Axis/WaterfallAxis.js", [e5["Core/Globals.js"], e5["Core/Axis/Stacking/StackItem.js"], e5["Core/Utilities.js"]], function(a2, p2, c4) {
      var m3;
      let { composed: N2 } = a2, { addEvent: T2, objectEach: v3, pushUnique: D2 } = c4;
      return function(j3) {
        function B3() {
          let t3 = this.waterfall.stacks;
          t3 && (t3.changed = false, delete t3.alreadyChanged);
        }
        function x2() {
          let t3 = this.options.stackLabels;
          t3 && t3.enabled && this.waterfall.stacks && this.waterfall.renderStackTotals();
        }
        function u2() {
          this.waterfall || (this.waterfall = new g2(this));
        }
        function l4() {
          let t3 = this.axes;
          for (let i5 of this.series) if (i5.options.stacking) {
            for (let r3 of t3) r3.isXAxis || (r3.waterfall.stacks.changed = true);
            break;
          }
        }
        j3.compose = function(t3, i5) {
          D2(N2, "Axis.Waterfall") && (T2(t3, "init", u2), T2(t3, "afterBuildStacks", B3), T2(t3, "afterRender", x2), T2(i5, "beforeRedraw", l4));
        };
        class g2 {
          constructor(i5) {
            this.axis = i5, this.stacks = { changed: false };
          }
          renderStackTotals() {
            let i5 = this.axis, r3 = i5.waterfall.stacks, o2 = i5.stacking && i5.stacking.stackTotalGroup, n4 = new p2(i5, i5.options.stackLabels || {}, false, 0, void 0);
            this.dummyStackItem = n4, o2 && v3(r3, (h2) => {
              v3(h2, (y2, M2) => {
                n4.total = y2.stackTotal, n4.x = +M2, y2.label && (n4.label = y2.label), p2.prototype.render.call(n4, o2), y2.label = n4.label, delete n4.label;
              });
            }), n4.total = null;
          }
        }
        j3.Composition = g2;
      }(m3 || (m3 = {})), m3;
    }), tt2(e5, "Series/Waterfall/WaterfallPoint.js", [e5["Series/Column/ColumnSeries.js"], e5["Core/Series/Point.js"], e5["Core/Utilities.js"]], function(a2, p2, c4) {
      let { isNumber: m3 } = c4;
      class N2 extends a2.prototype.pointClass {
        getClassName() {
          let v3 = p2.prototype.getClassName.call(this);
          return this.isSum ? v3 += " highcharts-sum" : this.isIntermediateSum && (v3 += " highcharts-intermediate-sum"), v3;
        }
        isValid() {
          return m3(this.y) || this.isSum || !!this.isIntermediateSum;
        }
      }
      return N2;
    }), tt2(e5, "Series/Waterfall/WaterfallSeriesDefaults.js", [], function() {
      return { dataLabels: { inside: true }, lineWidth: 1, lineColor: "#333333", dashStyle: "Dot", borderColor: "#333333", states: { hover: { lineWidthPlus: 0 } } };
    }), tt2(e5, "Series/Waterfall/WaterfallSeries.js", [e5["Core/Series/SeriesRegistry.js"], e5["Core/Utilities.js"], e5["Core/Axis/WaterfallAxis.js"], e5["Series/Waterfall/WaterfallPoint.js"], e5["Series/Waterfall/WaterfallSeriesDefaults.js"]], function(a2, p2, c4, m3, N2) {
      let { column: T2, line: v3 } = a2.seriesTypes, { addEvent: D2, arrayMax: j3, arrayMin: B3, correctFloat: x2, crisp: u2, extend: l4, isNumber: g2, merge: t3, objectEach: i5, pick: r3 } = p2;
      function o2(h2, y2) {
        return Object.hasOwnProperty.call(h2, y2);
      }
      class n4 extends T2 {
        generatePoints() {
          T2.prototype.generatePoints.apply(this);
          for (let y2 = 0, M2 = this.points.length; y2 < M2; y2++) {
            let z2 = this.points[y2], S2 = this.processedYData[y2];
            g2(S2) && (z2.isIntermediateSum || z2.isSum) && (z2.y = x2(S2));
          }
        }
        processData(y2) {
          let M2, z2, S2, L2, R2, P2, H2 = this.options, E2 = this.yData, s2 = H2.data, d3 = E2.length, b5 = H2.threshold || 0;
          S2 = z2 = L2 = R2 = 0;
          for (let A3 = 0; A3 < d3; A3++) P2 = E2[A3], M2 = s2 && s2[A3] ? s2[A3] : {}, P2 === "sum" || M2.isSum ? E2[A3] = x2(S2) : P2 === "intermediateSum" || M2.isIntermediateSum ? (E2[A3] = x2(z2), z2 = 0) : (S2 += P2, z2 += P2), L2 = Math.min(S2, L2), R2 = Math.max(S2, R2);
          super.processData.call(this, y2), H2.stacking || (this.dataMin = L2 + b5, this.dataMax = R2);
        }
        toYData(y2) {
          return y2.isSum ? "sum" : y2.isIntermediateSum ? "intermediateSum" : y2.y;
        }
        updateParallelArrays(y2, M2) {
          super.updateParallelArrays.call(this, y2, M2), (this.yData[0] === "sum" || this.yData[0] === "intermediateSum") && (this.yData[0] = null);
        }
        pointAttribs(y2, M2) {
          let z2 = this.options.upColor;
          z2 && !y2.options.color && g2(y2.y) && (y2.color = y2.y > 0 ? z2 : void 0);
          let S2 = T2.prototype.pointAttribs.call(this, y2, M2);
          return delete S2.dashstyle, S2;
        }
        getGraphPath() {
          return [["M", 0, 0]];
        }
        getCrispPath() {
          var y2;
          let M2 = this.data.filter((s2) => g2(s2.y)), z2 = this.yAxis, S2 = M2.length, L2 = ((y2 = this.graph) == null ? void 0 : y2.strokeWidth()) || 0, R2 = this.xAxis.reversed, P2 = this.yAxis.reversed, H2 = this.options.stacking, E2 = [];
          for (let s2 = 1; s2 < S2; s2++) {
            if (!(this.options.connectNulls || g2(this.data[M2[s2].index - 1].y))) continue;
            let d3 = M2[s2].box, b5 = M2[s2 - 1], A3 = b5.y || 0, I3 = M2[s2 - 1].box;
            if (!d3 || !I3) continue;
            let C3 = z2.waterfall.stacks[this.stackKey], $2 = A3 > 0 ? -I3.height : 0;
            if (C3 && I3 && d3) {
              let F2, rt2 = C3[s2 - 1];
              if (H2) {
                let O3 = rt2.connectorThreshold;
                F2 = u2(z2.translate(O3, false, true, false, true) + (P2 ? $2 : 0), L2);
              } else F2 = u2(I3.y + (b5.minPointLengthOffset || 0), L2);
              E2.push(["M", (I3.x || 0) + (R2 ? 0 : I3.width || 0), F2], ["L", (d3.x || 0) + (R2 && d3.width || 0), F2]);
            }
            if (I3 && E2.length && (!H2 && A3 < 0 && !P2 || A3 > 0 && P2)) {
              let F2 = E2[E2.length - 2];
              F2 && typeof F2[2] == "number" && (F2[2] += I3.height || 0);
              let rt2 = E2[E2.length - 1];
              rt2 && typeof rt2[2] == "number" && (rt2[2] += I3.height || 0);
            }
          }
          return E2;
        }
        drawGraph() {
          v3.prototype.drawGraph.call(this), this.graph && this.graph.attr({ d: this.getCrispPath() });
        }
        setStackedPoints(y2) {
          var M2;
          let z2 = this.options, S2 = (M2 = y2.waterfall) == null ? void 0 : M2.stacks, L2 = z2.threshold || 0, R2 = this.stackKey, P2 = this.xData, H2 = P2.length, E2 = L2, s2 = E2, d3, b5 = 0, A3 = 0, I3 = 0, C3, $2, F2, rt2, O3, f2, Y2, X2, V2 = (q2, _2, k3, W2) => {
            if (d3) {
              if (C3) for (; k3 < C3; k3++) d3.stackState[k3] += W2;
              else d3.stackState[0] = q2, C3 = d3.stackState.length;
              d3.stackState.push(d3.stackState[C3 - 1] + _2);
            }
          };
          if (y2.stacking && S2 && this.reserveSpace()) {
            X2 = S2.changed, (Y2 = S2.alreadyChanged) && 0 > Y2.indexOf(R2) && (X2 = true), S2[R2] || (S2[R2] = {});
            let q2 = S2[R2];
            if (q2) for (let _2 = 0; _2 < H2; _2++) (!q2[f2 = P2[_2]] || X2) && (q2[f2] = { negTotal: 0, posTotal: 0, stackTotal: 0, threshold: 0, stateIndex: 0, stackState: [], label: X2 && q2[f2] ? q2[f2].label : void 0 }), d3 = q2[f2], (O3 = this.yData[_2]) >= 0 ? d3.posTotal += O3 : d3.negTotal += O3, rt2 = z2.data[_2], $2 = d3.absolutePos = d3.posTotal, F2 = d3.absoluteNeg = d3.negTotal, d3.stackTotal = $2 + F2, C3 = d3.stackState.length, rt2 && rt2.isIntermediateSum ? (V2(I3, A3, 0, I3), I3 = A3, A3 = L2, E2 ^= s2, s2 ^= E2, E2 ^= s2) : rt2 && rt2.isSum ? (V2(L2, b5, C3, 0), E2 = L2) : (V2(E2, O3, 0, b5), rt2 && (b5 += O3, A3 += O3)), d3.stateIndex++, d3.threshold = E2, E2 += d3.stackTotal;
            S2.changed = false, S2.alreadyChanged || (S2.alreadyChanged = []), S2.alreadyChanged.push(R2);
          }
        }
        getExtremes() {
          let y2, M2, z2, S2 = this.options.stacking;
          return S2 ? (y2 = this.yAxis.waterfall.stacks, M2 = this.stackedYNeg = [], z2 = this.stackedYPos = [], S2 === "overlap" ? i5(y2[this.stackKey], function(L2) {
            M2.push(B3(L2.stackState)), z2.push(j3(L2.stackState));
          }) : i5(y2[this.stackKey], function(L2) {
            M2.push(L2.negTotal + L2.threshold), z2.push(L2.posTotal + L2.threshold);
          }), { dataMin: B3(M2), dataMax: j3(z2) }) : { dataMin: this.dataMin, dataMax: this.dataMax };
        }
      }
      return n4.defaultOptions = t3(T2.defaultOptions, N2), n4.compose = c4.compose, l4(n4.prototype, { pointValKey: "y", showLine: true, pointClass: m3 }), D2(n4, "afterColumnTranslate", function() {
        let { options: h2, points: y2, yAxis: M2 } = this, z2 = r3(h2.minPointLength, 5), S2 = z2 / 2, L2 = h2.threshold || 0, R2 = h2.stacking, P2 = M2.waterfall.stacks[this.stackKey], H2 = L2, E2 = L2, s2, d3, b5, A3;
        for (let I3 = 0; I3 < y2.length; I3++) {
          let C3 = y2[I3], $2 = this.processedYData[I3], F2 = l4({ x: 0, y: 0, width: 0, height: 0 }, C3.shapeArgs || {});
          C3.box = F2;
          let rt2 = [0, $2], O3 = C3.y || 0;
          if (R2) {
            if (P2) {
              let X2 = P2[I3];
              R2 === "overlap" ? (d3 = X2.stackState[X2.stateIndex--], s2 = O3 >= 0 ? d3 : d3 - O3, o2(X2, "absolutePos") && delete X2.absolutePos, o2(X2, "absoluteNeg") && delete X2.absoluteNeg) : (O3 >= 0 ? (d3 = X2.threshold + X2.posTotal, X2.posTotal -= O3, s2 = d3) : (d3 = X2.threshold + X2.negTotal, X2.negTotal -= O3, s2 = d3 - O3), !X2.posTotal && g2(X2.absolutePos) && o2(X2, "absolutePos") && (X2.posTotal = X2.absolutePos, delete X2.absolutePos), !X2.negTotal && g2(X2.absoluteNeg) && o2(X2, "absoluteNeg") && (X2.negTotal = X2.absoluteNeg, delete X2.absoluteNeg)), C3.isSum || (X2.connectorThreshold = X2.threshold + X2.stackTotal), M2.reversed ? (b5 = O3 >= 0 ? s2 - O3 : s2 + O3, A3 = s2) : (b5 = s2, A3 = s2 - O3), C3.below = b5 <= L2, F2.y = M2.translate(b5, false, true, false, true), F2.height = Math.abs(F2.y - M2.translate(A3, false, true, false, true));
              let V2 = M2.waterfall.dummyStackItem;
              V2 && (V2.x = I3, V2.label = P2[I3].label, V2.setOffset(this.pointXOffset || 0, this.barW || 0, this.stackedYNeg[I3], this.stackedYPos[I3], void 0, this.xAxis));
            }
          } else s2 = Math.max(E2, E2 + O3) + rt2[0], F2.y = M2.translate(s2, false, true, false, true), C3.isSum ? (F2.y = M2.translate(rt2[1], false, true, false, true), F2.height = Math.min(M2.translate(rt2[0], false, true, false, true), M2.len) - F2.y, C3.below = rt2[1] <= L2) : C3.isIntermediateSum ? (O3 >= 0 ? (b5 = rt2[1] + H2, A3 = H2) : (b5 = H2, A3 = rt2[1] + H2), M2.reversed && (b5 ^= A3, A3 ^= b5, b5 ^= A3), F2.y = M2.translate(b5, false, true, false, true), F2.height = Math.abs(F2.y - Math.min(M2.translate(A3, false, true, false, true), M2.len)), H2 += rt2[1], C3.below = b5 <= L2) : (F2.height = $2 > 0 ? M2.translate(E2, false, true, false, true) - F2.y : M2.translate(E2, false, true, false, true) - M2.translate(E2 - $2, false, true, false, true), E2 += $2, C3.below = E2 < L2), F2.height < 0 && (F2.y += F2.height, F2.height *= -1);
          C3.plotY = F2.y, C3.yBottom = F2.y + F2.height, F2.height <= z2 && !C3.isNull ? (F2.height = z2, F2.y -= S2, C3.yBottom = F2.y + F2.height, C3.plotY = F2.y, O3 < 0 ? C3.minPointLengthOffset = -S2 : C3.minPointLengthOffset = S2) : (C3.isNull && (F2.width = 0), C3.minPointLengthOffset = 0);
          let f2 = C3.plotY + (C3.negative ? F2.height : 0);
          C3.below && (C3.plotY += F2.height), C3.tooltipPos && (this.chart.inverted ? C3.tooltipPos[0] = M2.len - f2 : C3.tooltipPos[1] = f2), C3.isInside = this.isPointInside(C3);
          let Y2 = u2(C3.yBottom, this.borderWidth);
          F2.y = u2(F2.y, this.borderWidth), F2.height = Y2 - F2.y, t3(true, C3.shapeArgs, F2);
        }
      }, { order: 2 }), a2.registerSeriesType("waterfall", n4), n4;
    }), tt2(e5, "masters/highcharts-more.src.js", [e5["Core/Globals.js"], e5["Core/Series/SeriesRegistry.js"], e5["Extensions/Pane/Pane.js"], e5["Series/Bubble/BubbleSeries.js"], e5["Series/PackedBubble/PackedBubbleSeries.js"], e5["Series/PolarComposition.js"], e5["Core/Axis/RadialAxis.js"], e5["Series/Waterfall/WaterfallSeries.js"]], function(a2, p2, c4, m3, N2, T2, v3, D2) {
      return a2.RadialAxis = v3, m3.compose(a2.Axis, a2.Chart, a2.Legend), N2.compose(a2.Axis, a2.Chart, a2.Legend), c4.compose(a2.Chart, a2.Pointer), T2.compose(a2.Axis, a2.Chart, a2.Pointer, a2.Series, a2.Tick, a2.Point, p2.seriesTypes.areasplinerange, p2.seriesTypes.column, p2.seriesTypes.line, p2.seriesTypes.spline), D2.compose(a2.Axis, a2.Chart), a2;
    });
  });
})(Xt);
var Zt = Xt.exports;
const Kt = /* @__PURE__ */ ce(Zt);
var jt = { exports: {} };
(function(w2) {
  (function(J2) {
    w2.exports ? (J2.default = J2, w2.exports = J2) : J2(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(J2) {
    var e5 = J2 ? J2._modules : {};
    function tt2(a2, p2, c4, m3) {
      a2.hasOwnProperty(p2) || (a2[p2] = m3.apply(null, c4), typeof CustomEvent == "function" && J2.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: p2, module: a2[p2] } })));
    }
    tt2(e5, "Core/Axis/Color/ColorAxisLike.js", [e5["Core/Color/Color.js"], e5["Core/Utilities.js"]], function(a2, p2) {
      var c4, m3;
      let { parse: N2 } = a2, { merge: T2 } = p2;
      return (m3 = c4 || (c4 = {})).initDataClasses = function(v3) {
        let D2 = this.chart, j3 = this.legendItem = this.legendItem || {}, B3 = this.options, x2 = v3.dataClasses || [], u2, l4, g2 = D2.options.chart.colorCount, t3 = 0, i5;
        this.dataClasses = l4 = [], j3.labels = [];
        for (let r3 = 0, o2 = x2.length; r3 < o2; ++r3) u2 = T2(u2 = x2[r3]), l4.push(u2), (D2.styledMode || !u2.color) && (B3.dataClassColor === "category" ? (D2.styledMode || (g2 = (i5 = D2.options.colors || []).length, u2.color = i5[t3]), u2.colorIndex = t3, ++t3 === g2 && (t3 = 0)) : u2.color = N2(B3.minColor).tweenTo(N2(B3.maxColor), o2 < 2 ? 0.5 : r3 / (o2 - 1)));
      }, m3.initStops = function() {
        let v3 = this.options, D2 = this.stops = v3.stops || [[0, v3.minColor || ""], [1, v3.maxColor || ""]];
        for (let j3 = 0, B3 = D2.length; j3 < B3; ++j3) D2[j3].color = N2(D2[j3][1]);
      }, m3.normalizedValue = function(v3) {
        let D2 = this.max || 0, j3 = this.min || 0;
        return this.logarithmic && (v3 = this.logarithmic.log2lin(v3)), 1 - (D2 - v3) / (D2 - j3 || 1);
      }, m3.toColor = function(v3, D2) {
        let j3, B3, x2, u2, l4, g2, t3 = this.dataClasses, i5 = this.stops;
        if (t3) {
          for (g2 = t3.length; g2--; ) if (B3 = (l4 = t3[g2]).from, x2 = l4.to, (B3 === void 0 || v3 >= B3) && (x2 === void 0 || v3 <= x2)) {
            u2 = l4.color, D2 && (D2.dataClass = g2, D2.colorIndex = l4.colorIndex);
            break;
          }
        } else {
          for (j3 = this.normalizedValue(v3), g2 = i5.length; g2-- && !(j3 > i5[g2][0]); ) ;
          B3 = i5[g2] || i5[g2 + 1], j3 = 1 - ((x2 = i5[g2 + 1] || B3)[0] - j3) / (x2[0] - B3[0] || 1), u2 = B3.color.tweenTo(x2.color, j3);
        }
        return u2;
      }, c4;
    }), tt2(e5, "Core/Axis/SolidGaugeAxis.js", [e5["Core/Axis/Color/ColorAxisLike.js"], e5["Core/Utilities.js"]], function(a2, p2) {
      let { extend: c4 } = p2;
      return { init: function(m3) {
        c4(m3, a2);
      } };
    }), tt2(e5, "Series/SolidGauge/SolidGaugeSeriesDefaults.js", [], function() {
      return { colorByPoint: true, dataLabels: { y: 0 } };
    }), tt2(e5, "Series/SolidGauge/SolidGaugeSeries.js", [e5["Extensions/BorderRadius.js"], e5["Core/Series/SeriesRegistry.js"], e5["Core/Axis/SolidGaugeAxis.js"], e5["Series/SolidGauge/SolidGaugeSeriesDefaults.js"], e5["Core/Utilities.js"]], function(a2, p2, c4, m3, N2) {
      let { gauge: T2, pie: v3 } = p2.seriesTypes, { clamp: D2, extend: j3, isNumber: B3, merge: x2, pick: u2, pInt: l4 } = N2;
      class g2 extends T2 {
        translate() {
          let i5 = this.yAxis;
          c4.init(i5), !i5.dataClasses && i5.options.dataClasses && i5.initDataClasses(i5.options), i5.initStops(), T2.prototype.translate.call(this);
        }
        drawPoints() {
          let i5, r3 = this.yAxis, o2 = r3.center, n4 = this.options, h2 = this.chart.renderer, y2 = n4.overshoot, M2 = n4.rounded && n4.borderRadius === void 0, z2 = B3(y2) ? y2 / 180 * Math.PI : 0;
          for (let S2 of (B3(n4.threshold) && (i5 = r3.startAngleRad + r3.translate(n4.threshold, void 0, void 0, void 0, true)), this.thresholdAngleRad = u2(i5, r3.startAngleRad), this.points)) if (!S2.isNull) {
            let L2 = l4(u2(S2.options.radius, n4.radius, 100)) * o2[2] / 200, R2 = l4(u2(S2.options.innerRadius, n4.innerRadius, 60)) * o2[2] / 200, P2 = Math.min(r3.startAngleRad, r3.endAngleRad), H2 = Math.max(r3.startAngleRad, r3.endAngleRad), E2 = S2.graphic, s2 = r3.startAngleRad + r3.translate(S2.y, void 0, void 0, void 0, true), d3, b5, A3 = r3.toColor(S2.y, S2);
            A3 === "none" && (A3 = S2.color || this.color || "none"), A3 !== "none" && (S2.color = A3), s2 = D2(s2, P2 - z2, H2 + z2), n4.wrap === false && (s2 = D2(s2, P2, H2));
            let I3 = M2 ? (L2 - R2) / 2 / L2 : 0, C3 = Math.min(s2, this.thresholdAngleRad) - I3, $2 = Math.max(s2, this.thresholdAngleRad) + I3;
            $2 - C3 > 2 * Math.PI && ($2 = C3 + 2 * Math.PI);
            let F2 = M2 ? "50%" : 0;
            n4.borderRadius && (F2 = a2.optionsToObject(n4.borderRadius).radius), S2.shapeArgs = d3 = { x: o2[0], y: o2[1], r: L2, innerR: R2, start: C3, end: $2, borderRadius: F2 }, S2.startR = L2, E2 ? (b5 = d3.d, E2.animate(j3({ fill: A3 }, d3)), b5 && (d3.d = b5)) : S2.graphic = E2 = h2.arc(d3).attr({ fill: A3, "sweep-flag": 0 }).add(this.group), this.chart.styledMode || (n4.linecap !== "square" && E2.attr({ "stroke-linecap": "round", "stroke-linejoin": "round" }), E2.attr({ stroke: n4.borderColor || "none", "stroke-width": n4.borderWidth || 0 })), E2 && E2.addClass(S2.getClassName(), true);
          }
        }
        animate(i5) {
          i5 || (this.startAngleRad = this.thresholdAngleRad, v3.prototype.animate.call(this, i5));
        }
      }
      return g2.defaultOptions = x2(T2.defaultOptions, m3), p2.registerSeriesType("solidgauge", g2), g2;
    }), tt2(e5, "masters/modules/solid-gauge.src.js", [e5["Core/Globals.js"]], function(a2) {
      return a2;
    });
  });
})(jt);
var _t = jt.exports;
const Jt = /* @__PURE__ */ ce(_t);
var Mt = /* @__PURE__ */ ((w2) => (w2.STANDARD = "standard", w2.TARGET = "target", w2.SUBDIVIDED = "subdivided", w2))(Mt || {}), wt = /* @__PURE__ */ ((w2) => (w2.NORMAL = "normal", w2.TINTED = "tinted", w2.FUNCTIONAL = "functional", w2))(wt || {});
const ut = {
  beaconTagName: "beacon-gauge-chart",
  tooltipID: "chart-custom-tooltip",
  attribute: {
    name: "name",
    value: "value",
    valueSuffix: "value-suffix",
    valuePrefix: "value-prefix",
    metricDescription: "metric-description",
    gaugeTarget: "target",
    targetRange: "target-range",
    gaugeMin: "min",
    gaugeMax: "max",
    metricScale: "metric-scale",
    colorType: "color-type",
    hideMetric: "hide-metric",
    disableSort: "disable-sort",
    gaugeLabels: "gauge-labels",
    subdividedBands: "subdivided-bands",
    labelDistance: "label-distance",
    sections: "sections",
    hideLabels: "hide-labels"
  },
  samples: {
    bands: [
      ["Target A", 5],
      ["Target B", 10],
      ["Target C", 15],
      ["Target D", 20]
    ]
  },
  plotBandThickness: "20%",
  minimumSizeJumbo: 272,
  // Minimum width of gauge chart for jumbo variant
  minimumSizeDefault: 198,
  // Minimum width of gauge chart for mini and normal variant
  margin: 20
  //margin is to make sure the gauge chart is not touching the edge of the container
}, Qt = T$7`.highcharts-grid-line{display:none}.highcharts-yaxis .highcharts-tick{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-dial,.highcharts-pivot,.highcharts-minor-grid-line,.highcharts-plot-lines-10,.hide-grid>.highcharts-grid-line{display:none}.gauge-value,.gauge-background,.gauge-target{cursor:pointer;fill-opacity:1}.gauge-tint-100{fill:var(--beacon-reference-palette-charts-dark-blue-dt-1)}.gauge-tint-legend-100{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-tint-200{fill:var(--beacon-reference-palette-charts-dark-blue-dt-2)}.gauge-tint-legend-200{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-tint-300{fill:var(--beacon-reference-palette-charts-dark-blue-dt-3)}.gauge-tint-legend-300{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-tint-400{fill:var(--beacon-reference-palette-charts-dark-blue-dt-4)}.gauge-tint-legend-400{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-tint-500{fill:var(--beacon-reference-palette-charts-dark-blue-dt-5)}.gauge-tint-legend-500{--beacon-chart-override-drilldown-series-color-0: $color}:host(*){--gauge-chart-functional-color-fill-1: var(--beacon-reference-palette-functional-red-3);--gauge-chart-functional-color-fill-2: #ed6e11;--gauge-chart-functional-color-fill-3: #ffad00;--gauge-chart-functional-color-fill-4: #248647}:host(*) .gauge-functional-100{fill:var(--gauge-chart-functional-color-fill-1)}:host(*) .gauge-functional-legend-100{--beacon-chart-override-drilldown-series-color-0: $color}:host(*) .gauge-functional-200{fill:var(--gauge-chart-functional-color-fill-2)}:host(*) .gauge-functional-legend-200{--beacon-chart-override-drilldown-series-color-0: $color}:host(*) .gauge-functional-300{fill:var(--gauge-chart-functional-color-fill-3)}:host(*) .gauge-functional-legend-300{--beacon-chart-override-drilldown-series-color-0: $color}:host(*) .gauge-functional-400{fill:var(--gauge-chart-functional-color-fill-4)}:host(*) .gauge-functional-legend-400{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-target{fill:var(--beacon-component-scrollbar-color-background-track)}.gauge-background{fill:var(--beacon-system-color-background-1);stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-axis-labels{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.key-fact{text-align:center;transform:translateY(calc(-1 * var(--key-fact-transform)));white-space:normal;word-wrap:break-word}.key-fact.jumbo{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-600);--key-fact-transform: var(--beacon-reference-font-scale-13)}.key-fact.mini{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200);--key-fact-transform: var(--beacon-reference-font-scale-7)}.key-fact.normal{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-400);--key-fact-transform: var(--beacon-reference-font-scale-9)}.key-fact-description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-100);overflow-wrap:break-word;white-space:pre-wrap;word-wrap:break-word}.highcharts-legend .highcharts-legend-item .highcharts-point{display:none}.highcharts-color-0{fill:var(--beacon-system-color-data-viz-0)}`;
var te = Object.defineProperty, mt = (w2, J2, e5, tt2) => {
  for (var a2 = void 0, p2 = w2.length - 1, c4; p2 >= 0; p2--)
    (c4 = w2[p2]) && (a2 = c4(J2, e5, a2) || a2);
  return a2 && te(J2, e5, a2), a2;
};
function ee(w2) {
  return !!Array.isArray(w2.plotLinesAndBands);
}
function ie(w2) {
  return typeof w2.pane == "number";
}
function Dt(w2) {
  return "metricHTML" in w2;
}
function se(w2) {
  return w2.html !== void 0;
}
const { beaconTagName: Bt } = ut;
Kt(mi);
Jt(mi);
var vt;
const gt$1 = (vt = class extends B$5(qa).with(
  gl,
  jt$1
) {
  constructor() {
    super(...arguments), this.beaconTagName = Bt, this.gaugeName = "Standard", this.gaugeValueProp = 0, this.valueSuffix = "", this.valuePrefix = "", this.metricDescription = "", this.gaugeTarget = 0, this.targetRange = 0, this.gaugeMin = 0, this.gaugeMax = 100, this.variant = Mt.STANDARD, this.metricScale = i$6.NORMAL, this.colorType = wt.NORMAL, this.hideMetric = false, this.disableSort = false, this.gaugeLabels = [], this.subdividedBandsProp = [], this.labelDistance = 12, this.sections = 2, this.hideLabels = false, this.staticLegend = true, this.isChartUpdated = false, this.resizeObserver = new ResizeObserver(
      r$6(() => {
        this.chart && (this.isChartUpdated || (this.chart.update({
          chart: {
            marginTop: this.calculateChartMarginTop()
          }
        }), this.isChartUpdated = true), this.setMinimumGaugeSize(this.chart), this.renderMetric(this.chart), vt.renderTicks(this.chart, this.variant), this.chart.redraw(), this.variant === Mt.SUBDIVIDED && vt.plotBandHover(this.chart));
      }, 200)
      // The debounce function delays the execution of the function by 200 milliseconds to avoid excessive computations when the size of the chart changes rapidly
    ), this._type = te$2.GAUGE;
  }
  static get styles() {
    return [super.styles, Qt];
  }
  /**
   * Hover state for plot band for Subdivided variant only
   */
  static plotBandHover(w2) {
    const J2 = w2.yAxis[0];
    ee(J2) && J2.plotLinesAndBands.forEach(function(e5) {
      mi.addEvent(e5.svgElem.element, "mouseover", function() {
        J2.plotLinesAndBands.forEach(function(tt2) {
          tt2 !== e5 && tt2.svgElem.element.classList.contains("gauge-value") && tt2.svgElem.attr({
            opacity: 0.2
          });
        });
      }), mi.addEvent(e5.svgElem.element, "mouseout", function() {
        J2.plotLinesAndBands.forEach(function(tt2) {
          tt2.svgElem.attr({
            opacity: 1
            // Restore the original opacity
          });
        });
      });
    });
  }
  /**
   * Sets the gauge value to the sum of the subdivided bands otherwise returns what is passed via the prop
   */
  get gaugeValue() {
    let w2 = 0;
    return this.variant === Mt.SUBDIVIDED ? w2 = this.subdividedBands.reduce((J2, e5) => J2 + e5[1], 0) : w2 = this.gaugeValueProp, w2 <= this.gaugeMax && w2 >= this.gaugeMin ? w2 : w2 > this.gaugeMax ? (console.error("Gauge value too large"), this.gaugeMax) : (console.error("Gauge value too small"), this.gaugeMin);
  }
  /**
   * Generates the series based on the variant, so that gauge chart can have multiple legends
   */
  generateSeries() {
    return this.variant === Mt.SUBDIVIDED ? this.subdividedBands.map((w2) => ({
      name: w2[0],
      // use the first element of the band array as the name
      type: this.type,
      showInLegend: true,
      data: [w2[1]],
      // assuming band[1] is the band's value
      dataLabels: {
        enabled: false
      }
    })) : [
      {
        name: this.variant.charAt(0).toUpperCase() + this.variant.slice(1),
        type: this.type,
        showInLegend: true,
        data: [this.gaugeValue],
        dataLabels: {
          enabled: false
        }
      }
    ];
  }
  /**
   * Calculates the interval between ticks based on the number of  sections.
   */
  get tickInterval() {
    return (this.gaugeMax - this.gaugeMin) / this.labelSections;
  }
  /**
   * Auto-sorts subdivided bands unless disableSort prop is set
   */
  get subdividedBands() {
    return this.disableSort ? this.subdividedBandsProp : [...this.subdividedBandsProp].sort((w2, J2) => J2[1] - w2[1]);
  }
  /**
   * Returns padded label array for Highcharts API
   */
  get labels() {
    return ["", ...this.gaugeLabels, ""];
  }
  formatLabels(w2) {
    if (this.gaugeLabels.length > 0) {
      const J2 = Math.round(w2.pos / this.tickInterval);
      return this.labels[J2];
    } else
      return Math.round(w2.pos).toString();
  }
  /**
   * When labels are more than 2 digit, then it overlaps the gauge chart.
   * To avoid this, we are setting the text-anchor attribute based on label position.
   * if label is on left side of the chart, then text-anchor will be 'end'
   * if
   */
  static setTextAnchor(w2) {
    var J2;
    const e5 = w2.yAxis[0];
    for (const tt2 in e5.ticks) {
      const a2 = (J2 = e5.ticks[tt2].label) == null ? void 0 : J2.element;
      if (!a2)
        return;
      const p2 = a2.getBBox();
      let c4 = "middle";
      p2.x < w2.plotWidth / 2 ? c4 = "end" : p2.x > w2.plotWidth / 2 && (c4 = "start"), a2.setAttribute("text-anchor", c4);
    }
  }
  /**
   * This method adjusts the minimum size of the gauge chart based on the current chart size.
   * It calculates the chart width (which is the same as the pane size) and sets a minimum pane size.
   * If the size of the pane is less than the minimum size, it adjusts the size of the pane.
   * This ensures that the gauge chart is always displayed at an appropriate size, regardless of the size of the chart container.
   * @param chart - The Highcharts.Chart instance for which the minimum gauge size is to be set.
   */
  setMinimumGaugeSize(w2) {
    const J2 = w2.plotWidth, e5 = this.minimumGaugeSize;
    w2.update({
      pane: {
        size: J2 < e5 ? e5 : "85%"
        // Diameter of the pane
      }
    });
  }
  /**
   * Set plot bands based on variant and band values
   */
  get plotBands() {
    const w2 = [
      vt.plotBandObject(
        this.gaugeMin,
        this.gaugeMax,
        "gauge-background"
      )
    ];
    return this.variant !== Mt.SUBDIVIDED ? w2.push(...this.singleColorMode()) : w2.push(...this.subdividedColorMode()), w2;
  }
  /**
   * Sets a tint based on the relative value of the gauge
   */
  get tintIndex() {
    let w2;
    this.variant === Mt.TARGET && this.gaugeTarget > this.gaugeValue ? w2 = (this.gaugeTarget - this.gaugeMin) / this.sections : w2 = (this.gaugeMax - this.gaugeMin) / this.sections;
    const J2 = Math.ceil((this.gaugeValue - this.gaugeMin) / w2);
    return J2 > 4 ? 4 : J2;
  }
  /**
   * Sets text labels sections when provided
   */
  get labelSections() {
    return this.gaugeLabels.length ? this.gaugeLabels.length + 1 : this.sections;
  }
  /**
   * Queries the plot band SVG element to find the center of the chart
   */
  get chartCenter() {
    var w2;
    const J2 = (w2 = this.shadowRoot) == null ? void 0 : w2.querySelector(
      ".highcharts-plot-bands-0"
    );
    if (!J2)
      return { x: 0, y: 0 };
    const e5 = J2.getBBox();
    return {
      x: e5.x + e5.width / 2,
      y: e5.y + e5.height
    };
  }
  /**
   * This getter method retrieves the width of the gauge chart.
   * It queries the SVG element of the gauge chart and retrieves its bounding box.
   * The width of the bounding box is then returned as the width of the gauge chart.
   * @returns The width of the gauge chart, or 0 if the SVG element of the gauge chart cannot be found.
   */
  get chartWidth() {
    var w2;
    const J2 = (w2 = this.shadowRoot) == null ? void 0 : w2.querySelector(
      ".highcharts-plot-bands-0"
    );
    if (!J2)
      return 0;
    const e5 = J2.getBBox();
    return Math.round(e5.width);
  }
  /**
   * This getter method retrieves the height of the gauge chart.
   * It queries the SVG element of the gauge chart and retrieves its bounding box.
   * The height of the bounding box is then returned as the height of the gauge chart.
   * @returns The height of the gauge chart, or 0 if the SVG element of the gauge chart cannot be found.
   */
  get chartHeight() {
    var w2;
    const J2 = (w2 = this.shadowRoot) == null ? void 0 : w2.querySelector(
      ".highcharts-plot-bands-0"
    );
    if (!J2)
      return 0;
    const e5 = J2.getBBox();
    return Math.round(e5.height);
  }
  /**
   * Formats display string for gauge metric value based on props provided
   */
  metricDisplayValue() {
    if (this.gaugeValue != null) {
      if (this.percentage) {
        const w2 = this.gaugeValue - this.gaugeMin, J2 = this.gaugeMax - this.gaugeMin;
        return (w2 / J2 * 100).toFixed(
          this.decimal ? this.decimalPlaces : 0
        ) + "%";
      }
      return `${this.valuePrefix}${this.gaugeValue.toFixed(this.decimal ? this.decimalPlaces : 0)}${this.valueSuffix}`;
    }
    return "N/A";
  }
  /**
   * Template string of the metric placed in the center of the chart
   */
  metricHTML(w2) {
    return `<div class="key-fact ${this.metricScale}" style="width: ${w2}px">
    <div class="key-fact-main">${this.metricDisplayValue()}</div>
    ${this.metricDescription ? `<div class="key-fact-description">${this.metricDescription}</div>` : ""}
  </div>`;
  }
  /**
   * Gauge specific component Highcharts API options
   */
  get localComponentOptions() {
    const w2 = this.variant, J2 = this;
    return qa.createChartOptions(super.localComponentOptions, {
      chart: {
        plotBorderWidth: 0,
        margin: ut.margin,
        // this margin is to make sure the gauge chart is not touching the edge of the container
        events: {
          load: function() {
            vt.renderTicks(this, w2), vt.setTextAnchor(this), J2.resizeObserver.observe(J2);
          },
          redraw: function() {
            vt.setTextAnchor(this);
          }
        }
      },
      series: this.generateSeries(),
      pane: {
        startAngle: -90,
        endAngle: 90,
        background: void 0,
        center: ["50%", "50%"],
        size: "85%"
        // The 'size' property sets the diameter of the gauge chart as a percentage of the total plot area. Here, it is set to '85%', meaning the gauge chart will occupy 85% of the total plot area.
      },
      yAxis: {
        min: this.gaugeMin,
        max: this.gaugeMax,
        labels: {
          enabled: !this.hideLabels,
          distance: this.labelDistance,
          formatter: this.formatLabels.bind(this)
        },
        plotBands: this.plotBands,
        tickInterval: this.tickInterval,
        tickLength: 0
      }
    });
  }
  /**
   * This function calculates the top margin for the chart. It is specifically designed to handle the positioning of the gauge chart within its container.
   * The function calculates the difference between the current position of the gauge chart and the position of the container.
   * For smaller screens, the function adjusts the top margin to ensure that there is no overlap between the export button and the gauge chart.
   * The calculated margin is then applied to the chart to position it correctly within the container.
   */
  calculateChartMarginTop() {
    var w2, J2, e5, tt2;
    if (this.chart) {
      const a2 = (w2 = this.chart) == null ? void 0 : w2.legend;
      a2 && a2.update({
        x: 0,
        y: 0
      });
      const p2 = (J2 = this.chartContainer) == null ? void 0 : J2.querySelector(
        ".highcharts-plot-bands-0"
      ), c4 = p2 ? p2.getBoundingClientRect().top : 0, m3 = (e5 = this.chartContainer) == null ? void 0 : e5.getBoundingClientRect().top;
      let N2 = 0;
      return ((tt2 = this.chartContainer) == null ? void 0 : tt2.clientWidth) < L$5.MEDIUM && (N2 = c4 - m3 + ut.margin), this.calculateLegendOffset(this.chart), -N2;
    } else
      return 0;
  }
  /**
   * This method calculates the offset required to correctly position the legend in the chart.
   * It is executed with a delay to ensure that all elements in the chart are fully rendered before the calculation.
   * It retrieves the current positions of the legend and the gauge chart, calculates the required offset,
   * and then updates the y property of the legend with the calculated offset.
   * Finally, it calls the `calculateChartBlockSize` function to adjust the size of the chart block based on the new position of the legends.
   * @param chart - The Highcharts.Chart instance for which the legend offset is to be calculated.
   */
  calculateLegendOffset(w2) {
    w2 && setTimeout(() => {
      var J2, e5, tt2;
      const a2 = (e5 = (J2 = w2 == null ? void 0 : w2.legend) == null ? void 0 : J2.group) == null ? void 0 : e5.element, p2 = a2 ? a2.getBoundingClientRect().top : 0, c4 = (tt2 = this.chartContainer) == null ? void 0 : tt2.querySelector(
        ".highcharts-plot-bands-0"
      ), m3 = c4 ? c4.getBoundingClientRect().bottom : 0, N2 = p2 - m3 - ut.margin;
      this.updateChart({
        legend: {
          y: -N2
        }
      }), this.calculateChartBlockSize(w2);
    }, 100);
  }
  /**
   * This method calculates the total height of the chart block and sets it as the block size of the chart.
   * The method first checks if the legend exists in the chart. If it does, it calculates the bottom position of the legends and the top position of the container,
   * and sets the difference as the block size of the chart. If the legend does not exist, it calculates the bottom position of the gauge chart and the top position of the container,
   * adds an offset of 20, and sets this value as the block size of the chart.
   * @param chart - The Highcharts.Chart instance for which the block size is to be calculated.
   */
  calculateChartBlockSize(w2) {
    var J2, e5, tt2, a2, p2;
    if (!w2) return;
    let c4;
    const m3 = ((J2 = this.chartContainer) == null ? void 0 : J2.getBoundingClientRect().top) || 0;
    if ((tt2 = (e5 = w2.legend) == null ? void 0 : e5.group) != null && tt2.element) {
      const N2 = (a2 = this.chartContainer) == null ? void 0 : a2.querySelector(
        ".highcharts-legend-box"
      );
      c4 = (N2 ? N2.getBoundingClientRect().bottom : 0) - m3;
    } else {
      const N2 = (p2 = this.chartContainer) == null ? void 0 : p2.querySelector(
        ".highcharts-plot-bands-0"
      );
      c4 = (N2 ? N2.getBoundingClientRect().bottom : 0) - m3 + ut.margin;
    }
    this.chartContainer.style.blockSize = c4 + "px";
  }
  /**
   * This getter method retrieves the minimum size of the gauge chart.
   * The minimum size is determined based on the metric scale and whether the metric is hidden.
   * If the metric scale is 'JUMBO' and the metric is not hidden, the minimum size is set to the constant 'minimumSizeJumbo'.
   * Otherwise, the minimum size is set to the constant 'minimumSizeDefault'.
   * @returns The minimum size of the gauge chart.
   */
  get minimumGaugeSize() {
    return this.metricScale === i$6.JUMBO && !this.hideMetric ? ut.minimumSizeJumbo : ut.minimumSizeDefault;
  }
  /**
   * Helper function to define gauge plot bands
   *
   * TODO: Add tooltip interaction in this function
   * @param from start of plot band
   * @param to end of plot band
   * @param className CSS class name applied to plot band
   * @param label to name the band
   * @returns object of plot band with tooltip data and positioning logic
   */
  static plotBandObject(w2, J2, e5) {
    return {
      from: w2,
      to: J2,
      className: e5,
      thickness: ut.plotBandThickness
    };
  }
  /**
   * Logic to identify which plot bands are applied based on the gauge
   *
   * @returns plot band array for single color gauge
   */
  singleColorMode() {
    const w2 = [], J2 = (e5) => vt.plotBandObject(
      this.gaugeMin,
      this.gaugeValue,
      e5
    );
    switch (this.variant === Mt.TARGET && (this.targetRange > 0 ? w2.push(
      vt.plotBandObject(
        this.gaugeTarget,
        this.gaugeTarget + this.targetRange,
        "gauge-target"
      )
    ) : w2.push(
      vt.plotBandObject(
        this.gaugeValue,
        this.gaugeTarget,
        "gauge-target"
      )
    )), this.colorType) {
      case wt.NORMAL:
        w2.push(J2("gauge-value highcharts-color-0"));
        break;
      case wt.TINTED:
        w2.push(J2(`gauge-value gauge-tint-${this.tintIndex}00`));
        break;
      case wt.FUNCTIONAL:
        w2.push(
          J2(`gauge-value gauge-functional-${this.tintIndex}00`)
        );
        break;
      default:
        w2.push(J2("gauge-value highcharts-color-0"));
        break;
    }
    return w2;
  }
  /**
   * Logic to identify which plot bands are applied based on the gauge
   *
   * @returns plot band array for subdivided color gauge
   */
  subdividedColorMode() {
    const w2 = [];
    let J2 = this.gaugeMin;
    const e5 = parseFloat(p$6);
    for (const tt2 in this.subdividedBands) {
      const a2 = this.subdividedBands[tt2];
      w2.push(
        vt.plotBandObject(
          J2,
          J2 + a2[1] - e5,
          `subdivided gauge-value highcharts-color-${tt2}`
        )
      ), J2 += a2[1];
    }
    return w2;
  }
  /**
   * Renders the ticks on the gauge chart
   * @param chart
   */
  static renderTicks(w2, J2) {
    var e5, tt2;
    if (w2 && ie(w2)) {
      let a2 = 0;
      const p2 = Array.isArray(w2.pane) ? w2.pane[0] : w2.pane, { center: c4 } = p2;
      c4 && c4.length && (typeof c4[2] == "number" ? a2 = c4[2] / 2 : typeof c4[2] == "string" && (a2 = parseInt(c4[2], 10) / 2));
      let m3 = a2 * 0.2;
      J2 === Mt.SUBDIVIDED && (m3 = 0), w2.update({ yAxis: { tickLength: m3 } });
      const { ticks: N2 } = w2.yAxis[0].ticks, T2 = Object.entries(N2);
      T2.length && ((e5 = T2[0][1]) == null || e5.mark.hide(), (tt2 = T2[T2.length - 1][1]) == null || tt2.mark.hide());
    }
  }
  /**
   * Renders the metric based on the center of the chart
   *
   * @param chart Highcharts chart
   */
  renderMetric(w2) {
    var J2, e5, tt2, a2;
    if (this.hideMetric)
      Dt(w2) && ((a2 = w2.metricHTML) == null || a2.css({
        display: "none"
      }));
    else {
      const { x: p2, y: c4 } = this.chartCenter, m3 = this.metricDescription ? this.metricDescription.length : 0, N2 = (J2 = this.shadowRoot) == null ? void 0 : J2.querySelector(
        ".highcharts-plot-bands-0"
      );
      let T2 = 0;
      const v3 = this.chartWidth * 0.64;
      N2 && (T2 = N2.getBBox().height);
      const D2 = T2 * (this.metricDescription ? 0.05 : 0.07), j3 = (e5 = this.shadowRoot) == null ? void 0 : e5.querySelector(
        ".key-fact-description"
      );
      let B3 = 0, x2 = 0;
      if (j3) {
        const i5 = j3.getBoundingClientRect();
        B3 = i5.width, x2 = i5.height;
      }
      let u2 = 0, l4 = 6;
      m3 >= 28 && (u2 = x2 > 28 ? B3 / m3 : 0, l4 = Math.min(m3, 50));
      const g2 = m3 == 0 ? 0 : 24 + u2, t3 = c4 + D2 - l4 - g2;
      Dt(w2) && w2.metricHTML !== null ? w2.metricHTML.attr({
        text: this.metricHTML(v3),
        x: p2,
        y: t3,
        width: v3
        // Set the width here
      }).css({
        display: "initial"
      }) : se(w2.renderer) && (w2.metricHTML = (tt2 = w2.renderer) == null ? void 0 : tt2.html(this.metricHTML(v3), p2, t3).attr({
        align: "center",
        width: v3
        // Set the width here
      }).add());
    }
  }
  /**
   * Chart redraw lifecycle hook to render metric
   *
   * @param chart Highcharts chart
   */
  onChartRedraw() {
    this.chart && (this.renderMetric(this.chart), vt.renderTicks(this.chart, this.variant), vt.setTextAnchor(this.chart));
  }
  /**
   * Chart load lifecycle hook to render metric
   *
   * @param chart Highcharts chart
   */
  onChartLoad() {
    this.chart && (this.renderMetric(this.chart), vt.renderTicks(this.chart, this.variant));
  }
  willUpdate(w2) {
    var J2;
    (J2 = super.willUpdate) == null || J2.call(this, w2), this.chart && ((w2.has("metricDescription") || w2.has("hideMetric") || w2.has("metricScale") || w2.has("disableLegend") || w2.has("percentage") || w2.has("decimal") || w2.has("valuePrefix") || w2.has("valueSuffix") || w2.has("gaugeValueProp") || w2.has("decimalPlaces")) && this.renderMetric(this.chart), (w2.has("colorType") || w2.has("variant") || w2.has("gaugeTarget") || w2.has("targetRange") || w2.has("gaugeValueProp") || w2.has("sections")) && this.updateChart({
      yAxis: { plotBands: this.plotBands, tickInterval: this.tickInterval }
    }), (w2.has("disableLegend") || w2.has("variant")) && vt.renderTicks(this.chart, this.variant), w2.has("disableSort") && this.updateChart({
      yAxis: { plotBands: this.plotBands },
      series: this.generateSeries()
    }), w2.has("labelDistance") && this.updateChart({
      yAxis: { labels: { distance: this.labelDistance } }
    }), w2.has("labels") && this.updateChart({
      yAxis: { labels: { formatter: this.formatLabels.bind(this) } }
    }), w2.has("hideLabels") && this.updateChart({ yAxis: { labels: { enabled: !this.hideLabels } } }));
  }
}, vt.tagName = Bt, vt);
mt([
  v$c({ attribute: ut.attribute.name })
], gt$1.prototype, "gaugeName");
mt([
  v$c({ attribute: ut.attribute.value, type: Number })
], gt$1.prototype, "gaugeValueProp");
mt([
  v$c({ attribute: ut.attribute.valueSuffix })
], gt$1.prototype, "valueSuffix");
mt([
  v$c({ attribute: ut.attribute.valuePrefix })
], gt$1.prototype, "valuePrefix");
mt([
  v$c({ attribute: ut.attribute.metricDescription })
], gt$1.prototype, "metricDescription");
mt([
  v$c({ attribute: ut.attribute.gaugeTarget, type: Number })
], gt$1.prototype, "gaugeTarget");
mt([
  v$c({ attribute: ut.attribute.targetRange, type: Number })
], gt$1.prototype, "targetRange");
mt([
  v$c({ attribute: ut.attribute.gaugeMin, type: Number })
], gt$1.prototype, "gaugeMin");
mt([
  v$c({ attribute: ut.attribute.gaugeMax, type: Number })
], gt$1.prototype, "gaugeMax");
mt([
  v$c()
], gt$1.prototype, "variant");
mt([
  v$c({ attribute: ut.attribute.metricScale })
], gt$1.prototype, "metricScale");
mt([
  v$c({ attribute: ut.attribute.colorType })
], gt$1.prototype, "colorType");
mt([
  v$c({ type: Boolean, attribute: ut.attribute.hideMetric })
], gt$1.prototype, "hideMetric");
mt([
  v$c({ type: Boolean, attribute: ut.attribute.disableSort })
], gt$1.prototype, "disableSort");
mt([
  v$c({ attribute: ut.attribute.gaugeLabels, type: Object })
], gt$1.prototype, "gaugeLabels");
mt([
  v$c({ attribute: ut.attribute.subdividedBands, type: Object })
], gt$1.prototype, "subdividedBandsProp");
mt([
  v$c({ type: Number, attribute: ut.attribute.labelDistance })
], gt$1.prototype, "labelDistance");
mt([
  v$c({ type: Number, attribute: ut.attribute.sections })
], gt$1.prototype, "sections");
mt([
  v$c({ type: Boolean, attribute: ut.attribute.hideLabels })
], gt$1.prototype, "hideLabels");
let Tt = gt$1;
const ue = (w2) => (Se$3(w2, Tt), Dt$3({
  tagName: w2 ? w2 + "-" + Tt.tagName : Tt.tagName,
  elementClass: Tt,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const t2 = {
  beaconTagName: "beacon-error"
}, d2 = T$7`:host{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);align-items:center;display:grid;gap:var(--beacon-reference-space-3);grid-template-columns:auto 1fr}.error{align-self:start}`, a = class r2 extends Bt$3 {
  constructor() {
    super(...arguments), this.beaconTagName = t2.beaconTagName;
  }
  static get styles() {
    return [super.styles, d2];
  }
  static renderIcon() {
    return tt$1`
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="error"
        role="img"
        aria-label="Error">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.57752 10.9999C1.22025 11.6187 1.22025 12.3811 1.57752 12.9999L5.92282 20.5262C6.28009 21.145 6.94034 21.5262 7.65487 21.5262H16.3455C17.06 21.5262 17.7203 21.145 18.0775 20.5262L22.4228 12.9999C22.7801 12.3811 22.7801 11.6187 22.4228 10.9999L18.0775 3.47363C17.7203 2.85483 17.06 2.47363 16.3455 2.47363H7.65487C6.94034 2.47363 6.28008 2.85483 5.92282 3.47363L1.57752 10.9999ZM11.2502 7.74989C11.2502 7.33568 11.586 6.99989 12.0002 6.99989C12.4144 6.99989 12.7502 7.33568 12.7502 7.74989V12.2499C12.7502 12.6641 12.4144 12.9999 12.0002 12.9999C11.586 12.9999 11.2502 12.6641 11.2502 12.2499V7.74989ZM13.0002 15.9999C13.0002 16.5522 12.5525 16.9999 12.0002 16.9999C11.4479 16.9999 11.0002 16.5522 11.0002 15.9999C11.0002 15.4476 11.4479 14.9999 12.0002 14.9999C12.5525 14.9999 13.0002 15.4476 13.0002 15.9999Z"
          fill="var(--beacon-system-color-icon-error, #DD3636)" />
      </svg>
    `;
  }
  render() {
    return tt$1`
      <slot name="icon">${r2.renderIcon()}</slot>
      <slot></slot>
    `;
  }
};
a.tagName = t2.beaconTagName;
let e4 = a;
const b4 = (n4) => (Se$3(n4, e4), Dt$3({
  tagName: n4 ? n4 + "-" + e4.tagName : e4.tagName,
  elementClass: e4,
  react: React,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
const PROJECT_NAME = "ii-components";
const projectNamePrefix = `${PROJECT_NAME}`;
const IIBeaconControlGroup = W$1(
  projectNamePrefix
);
const IIBeaconControl = ie$3(
  projectNamePrefix
);
const IIBeaconNavigation = r$5(
  projectNamePrefix
);
const IIBeaconNavigationExpanded = s$2(
  projectNamePrefix
);
const IIBeaconButton = F$3(
  projectNamePrefix
);
const IIBeaconFooter = T$3(
  projectNamePrefix
);
const IIBeaconNavigationFooter = v$3(
  projectNamePrefix
);
const IIBeaconSocialLinkContainer = p(
  projectNamePrefix
);
const IIBeaconSocialLink = V$1(
  projectNamePrefix
);
const IIBeaconCountrySelector = D$2(
  projectNamePrefix
);
const IIBeaconRegionSelector = c$1(
  projectNamePrefix
);
const IIBeaconCountry = $$2(
  projectNamePrefix
);
const IIBeaconNavigationButton = r$2(
  projectNamePrefix
);
const IIBeaconNavigationPopover = r$1(
  projectNamePrefix
);
const IIBeaconNavigationToolbelt = r(
  projectNamePrefix
);
const IIBeaconNotification = G$1(
  projectNamePrefix
);
const IIBeaconIconButton = P$2(
  projectNamePrefix
);
const IIBeaconDonutChart = q(
  projectNamePrefix
);
const IIBeaconModal = M(
  projectNamePrefix
);
ue(
  projectNamePrefix
);
const IIBeaconError = b4(
  projectNamePrefix
);
/*! @license DOMPurify 3.1.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.6/LICENSE */
const {
  entries,
  setPrototypeOf,
  isFrozen,
  getPrototypeOf,
  getOwnPropertyDescriptor
} = Object;
let {
  freeze,
  seal,
  create
} = Object;
let {
  apply,
  construct
} = typeof Reflect !== "undefined" && Reflect;
if (!freeze) {
  freeze = function freeze2(x2) {
    return x2;
  };
}
if (!seal) {
  seal = function seal2(x2) {
    return x2;
  };
}
if (!apply) {
  apply = function apply2(fun, thisValue, args) {
    return fun.apply(thisValue, args);
  };
}
if (!construct) {
  construct = function construct2(Func, args) {
    return new Func(...args);
  };
}
const arrayForEach = unapply(Array.prototype.forEach);
const arrayPop = unapply(Array.prototype.pop);
const arrayPush$3 = unapply(Array.prototype.push);
const stringToLowerCase = unapply(String.prototype.toLowerCase);
const stringToString = unapply(String.prototype.toString);
const stringMatch = unapply(String.prototype.match);
const stringReplace = unapply(String.prototype.replace);
const stringIndexOf = unapply(String.prototype.indexOf);
const stringTrim = unapply(String.prototype.trim);
const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
const regExpTest = unapply(RegExp.prototype.test);
const typeErrorCreate = unconstruct(TypeError);
function unapply(func) {
  return function(thisArg) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return apply(func, thisArg, args);
  };
}
function unconstruct(func) {
  return function() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return construct(func, args);
  };
}
function addToSet(set, array) {
  let transformCaseFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : stringToLowerCase;
  if (setPrototypeOf) {
    setPrototypeOf(set, null);
  }
  let l4 = array.length;
  while (l4--) {
    let element = array[l4];
    if (typeof element === "string") {
      const lcElement = transformCaseFunc(element);
      if (lcElement !== element) {
        if (!isFrozen(array)) {
          array[l4] = lcElement;
        }
        element = lcElement;
      }
    }
    set[element] = true;
  }
  return set;
}
function cleanArray(array) {
  for (let index2 = 0; index2 < array.length; index2++) {
    const isPropertyExist = objectHasOwnProperty(array, index2);
    if (!isPropertyExist) {
      array[index2] = null;
    }
  }
  return array;
}
function clone$1(object) {
  const newObject = create(null);
  for (const [property, value] of entries(object)) {
    const isPropertyExist = objectHasOwnProperty(object, property);
    if (isPropertyExist) {
      if (Array.isArray(value)) {
        newObject[property] = cleanArray(value);
      } else if (value && typeof value === "object" && value.constructor === Object) {
        newObject[property] = clone$1(value);
      } else {
        newObject[property] = value;
      }
    }
  }
  return newObject;
}
function lookupGetter(object, prop) {
  while (object !== null) {
    const desc = getOwnPropertyDescriptor(object, prop);
    if (desc) {
      if (desc.get) {
        return unapply(desc.get);
      }
      if (typeof desc.value === "function") {
        return unapply(desc.value);
      }
    }
    object = getPrototypeOf(object);
  }
  function fallbackValue() {
    return null;
  }
  return fallbackValue;
}
const html$1 = freeze(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]);
const svg$1 = freeze(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]);
const svgFilters = freeze(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]);
const svgDisallowed = freeze(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]);
const mathMl$1 = freeze(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]);
const mathMlDisallowed = freeze(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]);
const text = freeze(["#text"]);
const html = freeze(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]);
const svg = freeze(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]);
const mathMl = freeze(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]);
const xml = freeze(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]);
const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm);
const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
const TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/);
const ARIA_ATTR = seal(/^aria-[\-\w]+$/);
const IS_ALLOWED_URI = seal(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
);
const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
const ATTR_WHITESPACE = seal(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
);
const DOCTYPE_NAME = seal(/^html$/i);
const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
var EXPRESSIONS = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR,
  ERB_EXPR,
  TMPLIT_EXPR,
  DATA_ATTR,
  ARIA_ATTR,
  IS_ALLOWED_URI,
  IS_SCRIPT_OR_DATA,
  ATTR_WHITESPACE,
  DOCTYPE_NAME,
  CUSTOM_ELEMENT
});
const NODE_TYPE = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
};
const getGlobal = function getGlobal2() {
  return typeof window === "undefined" ? null : window;
};
const _createTrustedTypesPolicy = function _createTrustedTypesPolicy2(trustedTypes, purifyHostElement) {
  if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") {
    return null;
  }
  let suffix = null;
  const ATTR_NAME = "data-tt-policy-suffix";
  if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
    suffix = purifyHostElement.getAttribute(ATTR_NAME);
  }
  const policyName = "dompurify" + (suffix ? "#" + suffix : "");
  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML(html2) {
        return html2;
      },
      createScriptURL(scriptUrl) {
        return scriptUrl;
      }
    });
  } catch (_2) {
    console.warn("TrustedTypes policy " + policyName + " could not be created.");
    return null;
  }
};
function createDOMPurify() {
  let window2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getGlobal();
  const DOMPurify = (root2) => createDOMPurify(root2);
  DOMPurify.version = "3.1.6";
  DOMPurify.removed = [];
  if (!window2 || !window2.document || window2.document.nodeType !== NODE_TYPE.document) {
    DOMPurify.isSupported = false;
    return DOMPurify;
  }
  let {
    document: document2
  } = window2;
  const originalDocument = document2;
  const currentScript = originalDocument.currentScript;
  const {
    DocumentFragment: DocumentFragment2,
    HTMLTemplateElement,
    Node: Node2,
    Element: Element2,
    NodeFilter: NodeFilter2,
    NamedNodeMap = window2.NamedNodeMap || window2.MozNamedAttrMap,
    HTMLFormElement: HTMLFormElement2,
    DOMParser: DOMParser2,
    trustedTypes
  } = window2;
  const ElementPrototype = Element2.prototype;
  const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
  const remove = lookupGetter(ElementPrototype, "remove");
  const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
  const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
  const getParentNode = lookupGetter(ElementPrototype, "parentNode");
  if (typeof HTMLTemplateElement === "function") {
    const template = document2.createElement("template");
    if (template.content && template.content.ownerDocument) {
      document2 = template.content.ownerDocument;
    }
  }
  let trustedTypesPolicy;
  let emptyHTML = "";
  const {
    implementation,
    createNodeIterator,
    createDocumentFragment,
    getElementsByTagName
  } = document2;
  const {
    importNode
  } = originalDocument;
  let hooks = {};
  DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: MUSTACHE_EXPR2,
    ERB_EXPR: ERB_EXPR2,
    TMPLIT_EXPR: TMPLIT_EXPR2,
    DATA_ATTR: DATA_ATTR2,
    ARIA_ATTR: ARIA_ATTR2,
    IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA2,
    ATTR_WHITESPACE: ATTR_WHITESPACE2,
    CUSTOM_ELEMENT: CUSTOM_ELEMENT2
  } = EXPRESSIONS;
  let {
    IS_ALLOWED_URI: IS_ALLOWED_URI$1
  } = EXPRESSIONS;
  let ALLOWED_TAGS = null;
  const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);
  let ALLOWED_ATTR = null;
  const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg, ...mathMl, ...xml]);
  let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  }));
  let FORBID_TAGS = null;
  let FORBID_ATTR = null;
  let ALLOW_ARIA_ATTR = true;
  let ALLOW_DATA_ATTR = true;
  let ALLOW_UNKNOWN_PROTOCOLS = false;
  let ALLOW_SELF_CLOSE_IN_ATTR = true;
  let SAFE_FOR_TEMPLATES = false;
  let SAFE_FOR_XML = true;
  let WHOLE_DOCUMENT = false;
  let SET_CONFIG = false;
  let FORCE_BODY = false;
  let RETURN_DOM = false;
  let RETURN_DOM_FRAGMENT = false;
  let RETURN_TRUSTED_TYPE = false;
  let SANITIZE_DOM = true;
  let SANITIZE_NAMED_PROPS = false;
  const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
  let KEEP_CONTENT = true;
  let IN_PLACE = false;
  let USE_PROFILES = {};
  let FORBID_CONTENTS = null;
  const DEFAULT_FORBID_CONTENTS = addToSet({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let DATA_URI_TAGS = null;
  const DEFAULT_DATA_URI_TAGS = addToSet({}, ["audio", "video", "img", "source", "image", "track"]);
  let URI_SAFE_ATTRIBUTES = null;
  const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]);
  const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
  const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
  const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
  let NAMESPACE = HTML_NAMESPACE;
  let IS_EMPTY_INPUT = false;
  let ALLOWED_NAMESPACES = null;
  const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
  let PARSER_MEDIA_TYPE = null;
  const SUPPORTED_PARSER_MEDIA_TYPES = ["application/xhtml+xml", "text/html"];
  const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
  let transformCaseFunc = null;
  let CONFIG = null;
  const formElement = document2.createElement("form");
  const isRegexOrFunction = function isRegexOrFunction2(testValue) {
    return testValue instanceof RegExp || testValue instanceof Function;
  };
  const _parseConfig = function _parseConfig2() {
    let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (CONFIG && CONFIG === cfg) {
      return;
    }
    if (!cfg || typeof cfg !== "object") {
      cfg = {};
    }
    cfg = clone$1(cfg);
    PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
    SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
    transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
    ALLOWED_TAGS = objectHasOwnProperty(cfg, "ALLOWED_TAGS") ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = objectHasOwnProperty(cfg, "ALLOWED_ATTR") ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
    ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, "ALLOWED_NAMESPACES") ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
    URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, "ADD_URI_SAFE_ATTR") ? addToSet(
      clone$1(DEFAULT_URI_SAFE_ATTRIBUTES),
      // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR,
      // eslint-disable-line indent
      transformCaseFunc
      // eslint-disable-line indent
    ) : DEFAULT_URI_SAFE_ATTRIBUTES;
    DATA_URI_TAGS = objectHasOwnProperty(cfg, "ADD_DATA_URI_TAGS") ? addToSet(
      clone$1(DEFAULT_DATA_URI_TAGS),
      // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS,
      // eslint-disable-line indent
      transformCaseFunc
      // eslint-disable-line indent
    ) : DEFAULT_DATA_URI_TAGS;
    FORBID_CONTENTS = objectHasOwnProperty(cfg, "FORBID_CONTENTS") ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
    FORBID_TAGS = objectHasOwnProperty(cfg, "FORBID_TAGS") ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
    FORBID_ATTR = objectHasOwnProperty(cfg, "FORBID_ATTR") ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
    USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
    ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
    SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
    RETURN_DOM = cfg.RETURN_DOM || false;
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
    FORCE_BODY = cfg.FORCE_BODY || false;
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
    SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
    IN_PLACE = cfg.IN_PLACE || false;
    IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
    NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
    CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") {
      CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
    }
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }
    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, text);
      ALLOWED_ATTR = [];
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html$1);
        addToSet(ALLOWED_ATTR, html);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg$1);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl$1);
        addToSet(ALLOWED_ATTR, mathMl);
        addToSet(ALLOWED_ATTR, xml);
      }
    }
    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = clone$1(ALLOWED_TAGS);
      }
      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
    }
    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = clone$1(ALLOWED_ATTR);
      }
      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
    }
    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
    }
    if (cfg.FORBID_CONTENTS) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone$1(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
    }
    if (KEEP_CONTENT) {
      ALLOWED_TAGS["#text"] = true;
    }
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ["html", "head", "body"]);
    }
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ["tbody"]);
      delete FORBID_TAGS.tbody;
    }
    if (cfg.TRUSTED_TYPES_POLICY) {
      if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      }
      if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      }
      trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
      emptyHTML = trustedTypesPolicy.createHTML("");
    } else {
      if (trustedTypesPolicy === void 0) {
        trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
      }
      if (trustedTypesPolicy !== null && typeof emptyHTML === "string") {
        emptyHTML = trustedTypesPolicy.createHTML("");
      }
    }
    if (freeze) {
      freeze(cfg);
    }
    CONFIG = cfg;
  };
  const MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ["mi", "mo", "mn", "ms", "mtext"]);
  const HTML_INTEGRATION_POINTS = addToSet({}, ["foreignobject", "annotation-xml"]);
  const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ["title", "style", "font", "a", "script"]);
  const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
  const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
  const _checkValidNamespace = function _checkValidNamespace2(element) {
    let parent = getParentNode(element);
    if (!parent || !parent.tagName) {
      parent = {
        namespaceURI: NAMESPACE,
        tagName: "template"
      };
    }
    const tagName = stringToLowerCase(element.tagName);
    const parentTagName = stringToLowerCase(parent.tagName);
    if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
      return false;
    }
    if (element.namespaceURI === SVG_NAMESPACE) {
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === "svg";
      }
      if (parent.namespaceURI === MATHML_NAMESPACE) {
        return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
      }
      return Boolean(ALL_SVG_TAGS[tagName]);
    }
    if (element.namespaceURI === MATHML_NAMESPACE) {
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === "math";
      }
      if (parent.namespaceURI === SVG_NAMESPACE) {
        return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
      }
      return Boolean(ALL_MATHML_TAGS[tagName]);
    }
    if (element.namespaceURI === HTML_NAMESPACE) {
      if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    }
    if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) {
      return true;
    }
    return false;
  };
  const _forceRemove = function _forceRemove2(node) {
    arrayPush$3(DOMPurify.removed, {
      element: node
    });
    try {
      getParentNode(node).removeChild(node);
    } catch (_2) {
      remove(node);
    }
  };
  const _removeAttribute = function _removeAttribute2(name, node) {
    try {
      arrayPush$3(DOMPurify.removed, {
        attribute: node.getAttributeNode(name),
        from: node
      });
    } catch (_2) {
      arrayPush$3(DOMPurify.removed, {
        attribute: null,
        from: node
      });
    }
    node.removeAttribute(name);
    if (name === "is" && !ALLOWED_ATTR[name]) {
      if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
        try {
          _forceRemove(node);
        } catch (_2) {
        }
      } else {
        try {
          node.setAttribute(name, "");
        } catch (_2) {
        }
      }
    }
  };
  const _initDocument = function _initDocument2(dirty) {
    let doc = null;
    let leadingWhitespace = null;
    if (FORCE_BODY) {
      dirty = "<remove></remove>" + dirty;
    } else {
      const matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }
    if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) {
      dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
    }
    const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    if (NAMESPACE === HTML_NAMESPACE) {
      try {
        doc = new DOMParser2().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_2) {
      }
    }
    if (!doc || !doc.documentElement) {
      doc = implementation.createDocument(NAMESPACE, "template", null);
      try {
        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
      } catch (_2) {
      }
    }
    const body = doc.body || doc.documentElement;
    if (dirty && leadingWhitespace) {
      body.insertBefore(document2.createTextNode(leadingWhitespace), body.childNodes[0] || null);
    }
    if (NAMESPACE === HTML_NAMESPACE) {
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
    }
    return WHOLE_DOCUMENT ? doc.documentElement : body;
  };
  const _createNodeIterator = function _createNodeIterator2(root2) {
    return createNodeIterator.call(
      root2.ownerDocument || root2,
      root2,
      // eslint-disable-next-line no-bitwise
      NodeFilter2.SHOW_ELEMENT | NodeFilter2.SHOW_COMMENT | NodeFilter2.SHOW_TEXT | NodeFilter2.SHOW_PROCESSING_INSTRUCTION | NodeFilter2.SHOW_CDATA_SECTION,
      null
    );
  };
  const _isClobbered = function _isClobbered2(elm) {
    return elm instanceof HTMLFormElement2 && (typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function" || typeof elm.hasChildNodes !== "function");
  };
  const _isNode = function _isNode2(object) {
    return typeof Node2 === "function" && object instanceof Node2;
  };
  const _executeHook = function _executeHook2(entryPoint, currentNode, data) {
    if (!hooks[entryPoint]) {
      return;
    }
    arrayForEach(hooks[entryPoint], (hook) => {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  };
  const _sanitizeElements = function _sanitizeElements2(currentNode) {
    let content = null;
    _executeHook("beforeSanitizeElements", currentNode, null);
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    const tagName = transformCaseFunc(currentNode.nodeName);
    _executeHook("uponSanitizeElement", currentNode, {
      tagName,
      allowedTags: ALLOWED_TAGS
    });
    if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
      _forceRemove(currentNode);
      return true;
    }
    if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
      _forceRemove(currentNode);
      return true;
    }
    if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
      _forceRemove(currentNode);
      return true;
    }
    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
          return false;
        }
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) {
          return false;
        }
      }
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
        const parentNode = getParentNode(currentNode) || currentNode.parentNode;
        const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
        if (childNodes && parentNode) {
          const childCount = childNodes.length;
          for (let i5 = childCount - 1; i5 >= 0; --i5) {
            const childClone = cloneNode(childNodes[i5], true);
            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
            parentNode.insertBefore(childClone, getNextSibling(currentNode));
          }
        }
      }
      _forceRemove(currentNode);
      return true;
    }
    if (currentNode instanceof Element2 && !_checkValidNamespace(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
      content = currentNode.textContent;
      arrayForEach([MUSTACHE_EXPR2, ERB_EXPR2, TMPLIT_EXPR2], (expr) => {
        content = stringReplace(content, expr, " ");
      });
      if (currentNode.textContent !== content) {
        arrayPush$3(DOMPurify.removed, {
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }
    _executeHook("afterSanitizeElements", currentNode, null);
    return false;
  };
  const _isValidAttribute = function _isValidAttribute2(lcTag, lcName, value) {
    if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document2 || value in formElement)) {
      return false;
    }
    if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR2, lcName)) ;
    else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR2, lcName)) ;
    else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))
      ) ;
      else {
        return false;
      }
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
    else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE2, ""))) ;
    else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
    else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA2, stringReplace(value, ATTR_WHITESPACE2, ""))) ;
    else if (value) {
      return false;
    } else ;
    return true;
  };
  const _isBasicCustomElement = function _isBasicCustomElement2(tagName) {
    return tagName !== "annotation-xml" && stringMatch(tagName, CUSTOM_ELEMENT2);
  };
  const _sanitizeAttributes = function _sanitizeAttributes2(currentNode) {
    _executeHook("beforeSanitizeAttributes", currentNode, null);
    const {
      attributes
    } = currentNode;
    if (!attributes) {
      return;
    }
    const hookEvent = {
      attrName: "",
      attrValue: "",
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR
    };
    let l4 = attributes.length;
    while (l4--) {
      const attr = attributes[l4];
      const {
        name,
        namespaceURI,
        value: attrValue
      } = attr;
      const lcName = transformCaseFunc(name);
      let value = name === "value" ? attrValue : stringTrim(attrValue);
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = void 0;
      _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
      value = hookEvent.attrValue;
      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      if (hookEvent.forceKeepAttr) {
        continue;
      }
      _removeAttribute(name, currentNode);
      if (!hookEvent.keepAttr) {
        continue;
      }
      if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      if (SAFE_FOR_TEMPLATES) {
        arrayForEach([MUSTACHE_EXPR2, ERB_EXPR2, TMPLIT_EXPR2], (expr) => {
          value = stringReplace(value, expr, " ");
        });
      }
      const lcTag = transformCaseFunc(currentNode.nodeName);
      if (!_isValidAttribute(lcTag, lcName, value)) {
        continue;
      }
      if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
        _removeAttribute(name, currentNode);
        value = SANITIZE_NAMED_PROPS_PREFIX + value;
      }
      if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function") {
        if (namespaceURI) ;
        else {
          switch (trustedTypes.getAttributeType(lcTag, lcName)) {
            case "TrustedHTML": {
              value = trustedTypesPolicy.createHTML(value);
              break;
            }
            case "TrustedScriptURL": {
              value = trustedTypesPolicy.createScriptURL(value);
              break;
            }
          }
        }
      }
      try {
        if (namespaceURI) {
          currentNode.setAttributeNS(namespaceURI, name, value);
        } else {
          currentNode.setAttribute(name, value);
        }
        if (_isClobbered(currentNode)) {
          _forceRemove(currentNode);
        } else {
          arrayPop(DOMPurify.removed);
        }
      } catch (_2) {
      }
    }
    _executeHook("afterSanitizeAttributes", currentNode, null);
  };
  const _sanitizeShadowDOM = function _sanitizeShadowDOM2(fragment) {
    let shadowNode = null;
    const shadowIterator = _createNodeIterator(fragment);
    _executeHook("beforeSanitizeShadowDOM", fragment, null);
    while (shadowNode = shadowIterator.nextNode()) {
      _executeHook("uponSanitizeShadowNode", shadowNode, null);
      if (_sanitizeElements(shadowNode)) {
        continue;
      }
      if (shadowNode.content instanceof DocumentFragment2) {
        _sanitizeShadowDOM2(shadowNode.content);
      }
      _sanitizeAttributes(shadowNode);
    }
    _executeHook("afterSanitizeShadowDOM", fragment, null);
  };
  DOMPurify.sanitize = function(dirty) {
    let cfg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let body = null;
    let importedNode = null;
    let currentNode = null;
    let returnNode = null;
    IS_EMPTY_INPUT = !dirty;
    if (IS_EMPTY_INPUT) {
      dirty = "<!-->";
    }
    if (typeof dirty !== "string" && !_isNode(dirty)) {
      if (typeof dirty.toString === "function") {
        dirty = dirty.toString();
        if (typeof dirty !== "string") {
          throw typeErrorCreate("dirty is not a string, aborting");
        }
      } else {
        throw typeErrorCreate("toString is not a function");
      }
    }
    if (!DOMPurify.isSupported) {
      return dirty;
    }
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }
    DOMPurify.removed = [];
    if (typeof dirty === "string") {
      IN_PLACE = false;
    }
    if (IN_PLACE) {
      if (dirty.nodeName) {
        const tagName = transformCaseFunc(dirty.nodeName);
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
        }
      }
    } else if (dirty instanceof Node2) {
      body = _initDocument("<!---->");
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") {
        body = importedNode;
      } else if (importedNode.nodeName === "HTML") {
        body = importedNode;
      } else {
        body.appendChild(importedNode);
      }
    } else {
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf("<") === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }
      body = _initDocument(dirty);
      if (!body) {
        return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
      }
    }
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }
    const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
    while (currentNode = nodeIterator.nextNode()) {
      if (_sanitizeElements(currentNode)) {
        continue;
      }
      if (currentNode.content instanceof DocumentFragment2) {
        _sanitizeShadowDOM(currentNode.content);
      }
      _sanitizeAttributes(currentNode);
    }
    if (IN_PLACE) {
      return dirty;
    }
    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);
        while (body.firstChild) {
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }
      if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
        returnNode = importNode.call(originalDocument, returnNode, true);
      }
      return returnNode;
    }
    let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
      serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
    }
    if (SAFE_FOR_TEMPLATES) {
      arrayForEach([MUSTACHE_EXPR2, ERB_EXPR2, TMPLIT_EXPR2], (expr) => {
        serializedHTML = stringReplace(serializedHTML, expr, " ");
      });
    }
    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };
  DOMPurify.setConfig = function() {
    let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _parseConfig(cfg);
    SET_CONFIG = true;
  };
  DOMPurify.clearConfig = function() {
    CONFIG = null;
    SET_CONFIG = false;
  };
  DOMPurify.isValidAttribute = function(tag, attr, value) {
    if (!CONFIG) {
      _parseConfig({});
    }
    const lcTag = transformCaseFunc(tag);
    const lcName = transformCaseFunc(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };
  DOMPurify.addHook = function(entryPoint, hookFunction) {
    if (typeof hookFunction !== "function") {
      return;
    }
    hooks[entryPoint] = hooks[entryPoint] || [];
    arrayPush$3(hooks[entryPoint], hookFunction);
  };
  DOMPurify.removeHook = function(entryPoint) {
    if (hooks[entryPoint]) {
      return arrayPop(hooks[entryPoint]);
    }
  };
  DOMPurify.removeHooks = function(entryPoint) {
    if (hooks[entryPoint]) {
      hooks[entryPoint] = [];
    }
  };
  DOMPurify.removeAllHooks = function() {
    hooks = {};
  };
  return DOMPurify;
}
var purify = createDOMPurify();
const LoadingSpinner = (props) => {
  const { className = "", color = "#05C3DE" } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 200 200",
      fill: "none",
      className: `loading-spinner ${className}`,
      color,
      "aria-labelledby": "loading-spinner-title",
      role: "status",
      "data-testid": "loading-spinner",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("title", { id: "loading-spinner-title", children: "Loading..." }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "spinner-secondHalf", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0%", stopOpacity: "0", stopColor: "currentColor" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "100%", stopOpacity: "0.5", stopColor: "currentColor" })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "spinner-firstHalf", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0%", stopOpacity: "1", stopColor: "currentColor" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "100%", stopOpacity: "0.5", stopColor: "currentColor" })
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { strokeWidth: "8", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              stroke: "url(#spinner-secondHalf)",
              d: "M 4 100 A 96 96 0 0 1 196 100"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              stroke: "url(#spinner-firstHalf)",
              d: "M 196 100 A 96 96 0 0 1 4 100"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              stroke: "currentColor",
              strokeLinecap: "round",
              d: "M 4 100 A 96 96 0 0 1 4 98"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "animateTransform",
          {
            from: "0 0 0",
            to: "360 0 0",
            attributeName: "transform",
            type: "rotate",
            repeatCount: "indefinite",
            dur: "1200ms"
          }
        )
      ]
    }
  );
};
const Shimmer = ({
  className,
  x: x2 = "100%",
  y: y2 = 30,
  shape = "",
  variant = ""
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      "data-testid": "shimmer",
      className: `shimmer ${shape} ${className} ${variant}`,
      style: { width: x2, height: y2 }
    }
  );
};
const Shimmer$1 = Shimmer;
const UtilityCardLoading = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "utility-card-loader-wrapper b-margin--micro--normal", children: /* @__PURE__ */ jsxRuntimeExports.jsx(UtilityCard$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "utility-card-loader-body-wrapper",
      "data-testid": "utility-card-loader",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "utility-card-total-balance-wrapper", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "utility-card-shimmer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Shimmer$1, { x: 181, y: 16, shape: "rect" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "utility-card-shimmer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Shimmer$1, { x: 181, y: 16, shape: "rect" }) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "utility-card-spinner", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSpinner, { className: "utility-card-loader-spinner" }) })
      ]
    }
  ) }) });
};
const OFFER_INTERACTION = "offerInteraction";
const PAGE_OVERLAY = "overlayLoad";
const OFFER_IMPRESSION = "offerImpression";
const eventDispatcher = (eventType, offerId, interactionLabel, overlay) => {
  if (!eventType) {
    console.log("Required: No event type provided");
    return;
  }
  try {
    const detail = {};
    if (offerId) {
      detail.offerId = offerId;
    }
    if (interactionLabel) {
      detail.interactionLabel = interactionLabel;
    }
    if (overlay) {
      detail.overlay = overlay;
    }
    const event = new CustomEvent(eventType, { detail });
    document.body.dispatchEvent(event);
    return event;
  } catch (e5) {
  }
};
const dispatchInteraction = (offerId, interactionLabel) => {
  return eventDispatcher(OFFER_INTERACTION, offerId, interactionLabel);
};
const dispatchOverlayLoad = (overlay) => {
  return eventDispatcher(PAGE_OVERLAY, null, null, overlay);
};
function dispatchOfferImpression(offerId) {
  return eventDispatcher(OFFER_IMPRESSION, offerId);
}
const UtilityCard = ({
  disclosureContent,
  bodyText,
  children,
  className,
  eyeBrow,
  handlePrimaryCTA,
  handleSecondaryCTA,
  isLoading,
  offerId,
  id,
  primaryCTAText,
  secondaryCTAText,
  disclosureCTAText,
  primaryCTALink,
  secondaryCTALink,
  handleDisclosure,
  title,
  redirectDelay = 1e3
}) => {
  const updatedId = id ? id : (Math.random() * 1e8).toFixed(0);
  const modalRef = useRef(null);
  const handleModalClose = () => {
    if (offerId) {
      try {
        dispatchInteraction(offerId, `close-${disclosureCTAText}`);
      } catch {
      }
    }
  };
  const handleRedirectLink = (link) => {
    if (link.indexOf(".troweprice.com") || link.indexOf(".awstrp.net") !== -1) {
      setTimeout(() => window.location.href = link, redirectDelay);
    } else {
      setTimeout(() => window.open(link, "_blank"), redirectDelay);
    }
  };
  return !isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: updatedId, className: `utility-card b-padding--micro--mini ${className ? className : ""}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "utility-card-title-container b-padding--micro--mini", children: [
      eyeBrow && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "eyebrow b-font-weight-bold b-typography-sans-serif--caption--200 b-padding-block-end--micro--mini", children: eyeBrow }),
      title && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "title", className: "title b-typography-serif--headline--100", children: title }),
      bodyText && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "body-text", className: "body-text b-typography-sans-serif--body--200", dangerouslySetInnerHTML: { __html: purify.sanitize(bodyText) } })
    ] }),
    children && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "utility-card-body", children }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "utility-card-footer b-padding--micro--mini b-sm:micro--normal b-md:micro--mini", children: [
      primaryCTAText && (handlePrimaryCTA || primaryCTALink) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "utility-card-button secondary-button", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        IIBeaconButton,
        {
          onBeaconEventClick: () => {
            primaryCTALink ? handleRedirectLink(primaryCTALink) : handlePrimaryCTA();
            if (offerId) {
              try {
                dispatchInteraction(offerId, primaryCTAText);
              } catch (e5) {
              }
            }
          },
          variant: "secondary",
          "data-testid": "primaryUtilityBtn",
          children: primaryCTAText
        }
      ) }),
      secondaryCTAText && (handleSecondaryCTA || secondaryCTALink) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "utility-card-button secondary-button", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        IIBeaconButton,
        {
          onBeaconEventClick: () => {
            secondaryCTALink ? handleRedirectLink(secondaryCTALink) : handleSecondaryCTA();
            if (offerId) {
              try {
                dispatchInteraction(offerId, secondaryCTAText);
              } catch (e5) {
              }
            }
          },
          variant: "secondary",
          "data-testid": "secondaryUtilityBtn",
          children: secondaryCTAText
        }
      ) }),
      disclosureCTAText && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "utility-card-button tertiary-button", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          IIBeaconButton,
          {
            onBeaconEventClick: () => {
              var _a2;
              disclosureContent ? (_a2 = modalRef.current) == null ? void 0 : _a2.show() : handleDisclosure();
              if (offerId) {
                try {
                  dispatchInteraction(offerId, disclosureCTAText);
                } catch (e5) {
                }
              }
            },
            variant: "tertiary",
            "data-testid": "disclosureUtilityBtn",
            children: disclosureCTAText
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          IIBeaconModal,
          {
            ref: modalRef,
            scale: "normal",
            class: `ii-disclosure-content`,
            id: "disclosure-modal",
            "data-testid": "disclosure-modal",
            onBeaconEventOpen: () => {
              if (offerId) {
                try {
                  dispatchInteraction(offerId, `open-${disclosureCTAText}`);
                } catch (e5) {
                }
              }
            },
            onBeaconEventClose: handleModalClose,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                "data-testid": "disclosure-content",
                className: "disclosure-content",
                dangerouslySetInnerHTML: {
                  __html: purify.sanitize(disclosureContent)
                }
              }
            )
          }
        )
      ] })
    ] })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(UtilityCardLoading, {});
};
const UtilityCard$1 = UtilityCard;
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash.exports;
(function(module2, exports2) {
  (function() {
    var undefined$1;
    var VERSION = "4.17.21";
    var LARGE_ARRAY_SIZE2 = 200;
    var CORE_ERROR_TEXT2 = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG2 = 1, CLONE_FLAT_FLAG2 = 2, CLONE_SYMBOLS_FLAG2 = 4;
    var COMPARE_PARTIAL_FLAG2 = 1, COMPARE_UNORDERED_FLAG2 = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY2 = 1 / 0, MAX_SAFE_INTEGER2 = 9007199254740991, MAX_INTEGER2 = 17976931348623157e292, NAN2 = 0 / 0;
    var MAX_ARRAY_LENGTH2 = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH2 - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH2 >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag2 = "[object Arguments]", arrayTag2 = "[object Array]", asyncTag2 = "[object AsyncFunction]", boolTag2 = "[object Boolean]", dateTag2 = "[object Date]", domExcTag2 = "[object DOMException]", errorTag2 = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag2 = "[object Map]", numberTag2 = "[object Number]", nullTag2 = "[object Null]", objectTag2 = "[object Object]", promiseTag2 = "[object Promise]", proxyTag2 = "[object Proxy]", regexpTag2 = "[object RegExp]", setTag2 = "[object Set]", stringTag2 = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag2 = "[object Undefined]", weakMapTag2 = "[object WeakMap]", weakSetTag2 = "[object WeakSet]";
    var arrayBufferTag2 = "[object ArrayBuffer]", dataViewTag2 = "[object DataView]", float32Tag2 = "[object Float32Array]", float64Tag2 = "[object Float64Array]", int8Tag2 = "[object Int8Array]", int16Tag2 = "[object Int16Array]", int32Tag2 = "[object Int32Array]", uint8Tag2 = "[object Uint8Array]", uint8ClampedTag2 = "[object Uint8ClampedArray]", uint16Tag2 = "[object Uint16Array]", uint32Tag2 = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar2.source);
    var reTrimStart2 = /^\s+/;
    var reWhitespace2 = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags2 = /\w*$/;
    var reIsBadHex2 = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary2 = /^0b[01]+$/i;
    var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
    var reIsOctal2 = /^0o[0-7]+$/i;
    var reIsUint2 = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange2 = "\\ud800-\\udfff", rsComboMarksRange2 = "\\u0300-\\u036f", reComboHalfMarksRange2 = "\\ufe20-\\ufe2f", rsComboSymbolsRange2 = "\\u20d0-\\u20ff", rsComboRange2 = rsComboMarksRange2 + reComboHalfMarksRange2 + rsComboSymbolsRange2, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange2 = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['’]", rsAstral2 = "[" + rsAstralRange2 + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo2 = "[" + rsComboRange2 + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange2 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz2 = "\\ud83c[\\udffb-\\udfff]", rsModifier2 = "(?:" + rsCombo2 + "|" + rsFitz2 + ")", rsNonAstral2 = "[^" + rsAstralRange2 + "]", rsRegional2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ2 = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod2 = rsModifier2 + "?", rsOptVar2 = "[" + rsVarRange2 + "]?", rsOptJoin2 = "(?:" + rsZWJ2 + "(?:" + [rsNonAstral2, rsRegional2, rsSurrPair2].join("|") + ")" + rsOptVar2 + reOptMod2 + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq2 = rsOptVar2 + reOptMod2 + rsOptJoin2, rsEmoji = "(?:" + [rsDingbat, rsRegional2, rsSurrPair2].join("|") + ")" + rsSeq2, rsSymbol2 = "(?:" + [rsNonAstral2 + rsCombo2 + "?", rsCombo2, rsRegional2, rsSurrPair2, rsAstral2].join("|") + ")";
    var reApos = RegExp(rsApos, "g");
    var reComboMark = RegExp(rsCombo2, "g");
    var reUnicode2 = RegExp(rsFitz2 + "(?=" + rsFitz2 + ")|" + rsSymbol2 + rsSeq2, "g");
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    var reHasUnicode2 = RegExp("[" + rsZWJ2 + rsAstralRange2 + rsComboRange2 + rsVarRange2 + "]");
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags2 = {};
    typedArrayTags2[float32Tag2] = typedArrayTags2[float64Tag2] = typedArrayTags2[int8Tag2] = typedArrayTags2[int16Tag2] = typedArrayTags2[int32Tag2] = typedArrayTags2[uint8Tag2] = typedArrayTags2[uint8ClampedTag2] = typedArrayTags2[uint16Tag2] = typedArrayTags2[uint32Tag2] = true;
    typedArrayTags2[argsTag2] = typedArrayTags2[arrayTag2] = typedArrayTags2[arrayBufferTag2] = typedArrayTags2[boolTag2] = typedArrayTags2[dataViewTag2] = typedArrayTags2[dateTag2] = typedArrayTags2[errorTag2] = typedArrayTags2[funcTag2] = typedArrayTags2[mapTag2] = typedArrayTags2[numberTag2] = typedArrayTags2[objectTag2] = typedArrayTags2[regexpTag2] = typedArrayTags2[setTag2] = typedArrayTags2[stringTag2] = typedArrayTags2[weakMapTag2] = false;
    var cloneableTags2 = {};
    cloneableTags2[argsTag2] = cloneableTags2[arrayTag2] = cloneableTags2[arrayBufferTag2] = cloneableTags2[dataViewTag2] = cloneableTags2[boolTag2] = cloneableTags2[dateTag2] = cloneableTags2[float32Tag2] = cloneableTags2[float64Tag2] = cloneableTags2[int8Tag2] = cloneableTags2[int16Tag2] = cloneableTags2[int32Tag2] = cloneableTags2[mapTag2] = cloneableTags2[numberTag2] = cloneableTags2[objectTag2] = cloneableTags2[regexpTag2] = cloneableTags2[setTag2] = cloneableTags2[stringTag2] = cloneableTags2[symbolTag2] = cloneableTags2[uint8Tag2] = cloneableTags2[uint8ClampedTag2] = cloneableTags2[uint16Tag2] = cloneableTags2[uint32Tag2] = true;
    cloneableTags2[errorTag2] = cloneableTags2[funcTag2] = cloneableTags2[weakMapTag2] = false;
    var deburredLetters = {
      // Latin-1 Supplement block.
      "À": "A",
      "Á": "A",
      "Â": "A",
      "Ã": "A",
      "Ä": "A",
      "Å": "A",
      "à": "a",
      "á": "a",
      "â": "a",
      "ã": "a",
      "ä": "a",
      "å": "a",
      "Ç": "C",
      "ç": "c",
      "Ð": "D",
      "ð": "d",
      "È": "E",
      "É": "E",
      "Ê": "E",
      "Ë": "E",
      "è": "e",
      "é": "e",
      "ê": "e",
      "ë": "e",
      "Ì": "I",
      "Í": "I",
      "Î": "I",
      "Ï": "I",
      "ì": "i",
      "í": "i",
      "î": "i",
      "ï": "i",
      "Ñ": "N",
      "ñ": "n",
      "Ò": "O",
      "Ó": "O",
      "Ô": "O",
      "Õ": "O",
      "Ö": "O",
      "Ø": "O",
      "ò": "o",
      "ó": "o",
      "ô": "o",
      "õ": "o",
      "ö": "o",
      "ø": "o",
      "Ù": "U",
      "Ú": "U",
      "Û": "U",
      "Ü": "U",
      "ù": "u",
      "ú": "u",
      "û": "u",
      "ü": "u",
      "Ý": "Y",
      "ý": "y",
      "ÿ": "y",
      "Æ": "Ae",
      "æ": "ae",
      "Þ": "Th",
      "þ": "th",
      "ß": "ss",
      // Latin Extended-A block.
      "Ā": "A",
      "Ă": "A",
      "Ą": "A",
      "ā": "a",
      "ă": "a",
      "ą": "a",
      "Ć": "C",
      "Ĉ": "C",
      "Ċ": "C",
      "Č": "C",
      "ć": "c",
      "ĉ": "c",
      "ċ": "c",
      "č": "c",
      "Ď": "D",
      "Đ": "D",
      "ď": "d",
      "đ": "d",
      "Ē": "E",
      "Ĕ": "E",
      "Ė": "E",
      "Ę": "E",
      "Ě": "E",
      "ē": "e",
      "ĕ": "e",
      "ė": "e",
      "ę": "e",
      "ě": "e",
      "Ĝ": "G",
      "Ğ": "G",
      "Ġ": "G",
      "Ģ": "G",
      "ĝ": "g",
      "ğ": "g",
      "ġ": "g",
      "ģ": "g",
      "Ĥ": "H",
      "Ħ": "H",
      "ĥ": "h",
      "ħ": "h",
      "Ĩ": "I",
      "Ī": "I",
      "Ĭ": "I",
      "Į": "I",
      "İ": "I",
      "ĩ": "i",
      "ī": "i",
      "ĭ": "i",
      "į": "i",
      "ı": "i",
      "Ĵ": "J",
      "ĵ": "j",
      "Ķ": "K",
      "ķ": "k",
      "ĸ": "k",
      "Ĺ": "L",
      "Ļ": "L",
      "Ľ": "L",
      "Ŀ": "L",
      "Ł": "L",
      "ĺ": "l",
      "ļ": "l",
      "ľ": "l",
      "ŀ": "l",
      "ł": "l",
      "Ń": "N",
      "Ņ": "N",
      "Ň": "N",
      "Ŋ": "N",
      "ń": "n",
      "ņ": "n",
      "ň": "n",
      "ŋ": "n",
      "Ō": "O",
      "Ŏ": "O",
      "Ő": "O",
      "ō": "o",
      "ŏ": "o",
      "ő": "o",
      "Ŕ": "R",
      "Ŗ": "R",
      "Ř": "R",
      "ŕ": "r",
      "ŗ": "r",
      "ř": "r",
      "Ś": "S",
      "Ŝ": "S",
      "Ş": "S",
      "Š": "S",
      "ś": "s",
      "ŝ": "s",
      "ş": "s",
      "š": "s",
      "Ţ": "T",
      "Ť": "T",
      "Ŧ": "T",
      "ţ": "t",
      "ť": "t",
      "ŧ": "t",
      "Ũ": "U",
      "Ū": "U",
      "Ŭ": "U",
      "Ů": "U",
      "Ű": "U",
      "Ų": "U",
      "ũ": "u",
      "ū": "u",
      "ŭ": "u",
      "ů": "u",
      "ű": "u",
      "ų": "u",
      "Ŵ": "W",
      "ŵ": "w",
      "Ŷ": "Y",
      "ŷ": "y",
      "Ÿ": "Y",
      "Ź": "Z",
      "Ż": "Z",
      "Ž": "Z",
      "ź": "z",
      "ż": "z",
      "ž": "z",
      "Ĳ": "IJ",
      "ĳ": "ij",
      "Œ": "Oe",
      "œ": "oe",
      "ŉ": "'n",
      "ſ": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt2 = parseInt;
    var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
    var freeExports = exports2 && !exports2.nodeType && exports2;
    var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal2.process;
    var nodeUtil2 = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e5) {
      }
    }();
    var nodeIsArrayBuffer2 = nodeUtil2 && nodeUtil2.isArrayBuffer, nodeIsDate2 = nodeUtil2 && nodeUtil2.isDate, nodeIsMap2 = nodeUtil2 && nodeUtil2.isMap, nodeIsRegExp2 = nodeUtil2 && nodeUtil2.isRegExp, nodeIsSet2 = nodeUtil2 && nodeUtil2.isSet, nodeIsTypedArray2 = nodeUtil2 && nodeUtil2.isTypedArray;
    function apply2(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        var value = array[index2];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }
    function arrayEach2(array, iteratee) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (iteratee(array[index2], index2, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;
      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEvery(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (!predicate(array[index2], index2, array)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter2(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array[index2];
        if (predicate(value, index2, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    function arrayIncludesWith(array, value, comparator) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (comparator(value, array[index2])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap2(array, iteratee) {
      var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
      while (++index2 < length) {
        result[index2] = iteratee(array[index2], index2, array);
      }
      return result;
    }
    function arrayPush2(array, values2) {
      var index2 = -1, length = values2.length, offset = array.length;
      while (++index2 < length) {
        array[offset + index2] = values2[index2];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index2 = -1, length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[++index2];
      }
      while (++index2 < length) {
        accumulator = iteratee(accumulator, array[index2], index2, array);
      }
      return accumulator;
    }
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }
    function arraySome2(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (predicate(array[index2], index2, array)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty("length");
    function asciiToArray2(string) {
      return string.split("");
    }
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length) {
        if (predicate(array[index2], index2, array)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index2 = fromIndex - 1, length = array.length;
      while (++index2 < length) {
        if (comparator(array[index2], value)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN2;
    }
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function basePropertyOf(object) {
      return function(key) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index2, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }
    function baseSum(array, iteratee) {
      var result, index2 = -1, length = array.length;
      while (++index2 < length) {
        var current = iteratee(array[index2]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }
      return result;
    }
    function baseTimes2(n4, iteratee) {
      var index2 = -1, result = Array(n4);
      while (++index2 < n4) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseToPairs(object, props) {
      return arrayMap2(props, function(key) {
        return [key, object[key]];
      });
    }
    function baseTrim2(string) {
      return string ? string.slice(0, trimmedEndIndex2(string) + 1).replace(reTrimStart2, "") : string;
    }
    function baseUnary2(func) {
      return function(value) {
        return func(value);
      };
    }
    function baseValues2(object, props) {
      return arrayMap2(props, function(key) {
        return object[key];
      });
    }
    function cacheHas2(cache, key) {
      return cache.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index2 = -1, length = strSymbols.length;
      while (++index2 < length && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index2 = strSymbols.length;
      while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function countHolders(array, placeholder) {
      var length = array.length, result = 0;
      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue2(object, key) {
      return object == null ? undefined$1 : object[key];
    }
    function hasUnicode2(string) {
      return reHasUnicode2.test(string);
    }
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }
    function iteratorToArray2(iterator) {
      var data, result = [];
      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }
    function mapToArray2(map) {
      var index2 = -1, result = Array(map.size);
      map.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    function overArg2(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array, placeholder) {
      var index2 = -1, length = array.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array[index2];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index2] = PLACEHOLDER;
          result[resIndex++] = index2;
        }
      }
      return result;
    }
    function setToArray2(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    function setToPairs(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = [value, value];
      });
      return result;
    }
    function strictIndexOf(array, value, fromIndex) {
      var index2 = fromIndex - 1, length = array.length;
      while (++index2 < length) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array, value, fromIndex) {
      var index2 = fromIndex + 1;
      while (index2--) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return index2;
    }
    function stringSize(string) {
      return hasUnicode2(string) ? unicodeSize(string) : asciiSize(string);
    }
    function stringToArray2(string) {
      return hasUnicode2(string) ? unicodeToArray2(string) : asciiToArray2(string);
    }
    function trimmedEndIndex2(string) {
      var index2 = string.length;
      while (index2-- && reWhitespace2.test(string.charAt(index2))) {
      }
      return index2;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string) {
      var result = reUnicode2.lastIndex = 0;
      while (reUnicode2.test(string)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray2(string) {
      return string.match(reUnicode2) || [];
    }
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root2 : _2.defaults(root2.Object(), context, _2.pick(root2, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto2 = Array2.prototype, funcProto2 = Function2.prototype, objectProto2 = Object2.prototype;
      var coreJsData2 = context["__core-js_shared__"];
      var funcToString2 = funcProto2.toString;
      var hasOwnProperty2 = objectProto2.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey2 = function() {
        var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString2 = objectProto2.toString;
      var objectCtorString2 = funcToString2.call(Object2);
      var oldDash = root2._;
      var reIsNative2 = RegExp2(
        "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      );
      var Buffer = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1, getPrototype2 = overArg2(Object2.getPrototypeOf, Object2), objectCreate2 = Object2.create, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator2 = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag2 = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty2 = function() {
        try {
          var func = getNative2(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e5) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root2.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root2.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root2.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols2 = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1, nativeIsFinite2 = context.isFinite, nativeJoin = arrayProto2.join, nativeKeys2 = overArg2(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto2.reverse;
      var DataView2 = getNative2(context, "DataView"), Map2 = getNative2(context, "Map"), Promise2 = getNative2(context, "Promise"), Set2 = getNative2(context, "Set"), WeakMap2 = getNative2(context, "WeakMap"), nativeCreate2 = getNative2(Object2, "create");
      var metaMap = WeakMap2 && new WeakMap2();
      var realNames = {};
      var dataViewCtorString2 = toSource2(DataView2), mapCtorString2 = toSource2(Map2), promiseCtorString2 = toSource2(Promise2), setCtorString2 = toSource2(Set2), weakMapCtorString2 = toSource2(WeakMap2);
      var symbolProto2 = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf2 = symbolProto2 ? symbolProto2.valueOf : undefined$1, symbolToString2 = symbolProto2 ? symbolProto2.toString : undefined$1;
      function lodash2(value) {
        if (isObjectLike2(value) && !isArray2(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty2.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate2 = /* @__PURE__ */ function() {
        function object() {
        }
        return function(proto) {
          if (!isObject2(proto)) {
            return {};
          }
          if (objectCreate2) {
            return objectCreate2(proto);
          }
          object.prototype = proto;
          var result2 = new object();
          object.prototype = undefined$1;
          return result2;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "escape": reEscape,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "evaluate": reEvaluate,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "interpolate": reInterpolate,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        "variable": "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        "imports": {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate2(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH2;
        this.__views__ = [];
      }
      function lazyClone() {
        var result2 = new LazyWrapper(this.__wrapped__);
        result2.__actions__ = copyArray2(this.__actions__);
        result2.__dir__ = this.__dir__;
        result2.__filtered__ = this.__filtered__;
        result2.__iteratees__ = copyArray2(this.__iteratees__);
        result2.__takeCount__ = this.__takeCount__;
        result2.__views__ = copyArray2(this.__views__);
        return result2;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result2 = new LazyWrapper(this);
          result2.__dir__ = -1;
          result2.__filtered__ = true;
        } else {
          result2 = this.clone();
          result2.__dir__ *= -1;
        }
        return result2;
      }
      function lazyValue() {
        var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index2 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result2 = [];
        outer:
          while (length-- && resIndex < takeCount) {
            index2 += dir;
            var iterIndex = -1, value = array[index2];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value;
          }
        return result2;
      }
      LazyWrapper.prototype = baseCreate2(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash2(entries2) {
        var index2 = -1, length = entries2 == null ? 0 : entries2.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries2[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear2() {
        this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
        this.size = 0;
      }
      function hashDelete2(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function hashGet2(key) {
        var data = this.__data__;
        if (nativeCreate2) {
          var result2 = data[key];
          return result2 === HASH_UNDEFINED2 ? undefined$1 : result2;
        }
        return hasOwnProperty2.call(data, key) ? data[key] : undefined$1;
      }
      function hashHas2(key) {
        var data = this.__data__;
        return nativeCreate2 ? data[key] !== undefined$1 : hasOwnProperty2.call(data, key);
      }
      function hashSet2(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate2 && value === undefined$1 ? HASH_UNDEFINED2 : value;
        return this;
      }
      Hash2.prototype.clear = hashClear2;
      Hash2.prototype["delete"] = hashDelete2;
      Hash2.prototype.get = hashGet2;
      Hash2.prototype.has = hashHas2;
      Hash2.prototype.set = hashSet2;
      function ListCache2(entries2) {
        var index2 = -1, length = entries2 == null ? 0 : entries2.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries2[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear2() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete2(key) {
        var data = this.__data__, index2 = assocIndexOf2(data, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index2 == lastIndex) {
          data.pop();
        } else {
          splice2.call(data, index2, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet2(key) {
        var data = this.__data__, index2 = assocIndexOf2(data, key);
        return index2 < 0 ? undefined$1 : data[index2][1];
      }
      function listCacheHas2(key) {
        return assocIndexOf2(this.__data__, key) > -1;
      }
      function listCacheSet2(key, value) {
        var data = this.__data__, index2 = assocIndexOf2(data, key);
        if (index2 < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index2][1] = value;
        }
        return this;
      }
      ListCache2.prototype.clear = listCacheClear2;
      ListCache2.prototype["delete"] = listCacheDelete2;
      ListCache2.prototype.get = listCacheGet2;
      ListCache2.prototype.has = listCacheHas2;
      ListCache2.prototype.set = listCacheSet2;
      function MapCache2(entries2) {
        var index2 = -1, length = entries2 == null ? 0 : entries2.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries2[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear2() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash2(),
          "map": new (Map2 || ListCache2)(),
          "string": new Hash2()
        };
      }
      function mapCacheDelete2(key) {
        var result2 = getMapData2(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function mapCacheGet2(key) {
        return getMapData2(this, key).get(key);
      }
      function mapCacheHas2(key) {
        return getMapData2(this, key).has(key);
      }
      function mapCacheSet2(key, value) {
        var data = getMapData2(this, key), size2 = data.size;
        data.set(key, value);
        this.size += data.size == size2 ? 0 : 1;
        return this;
      }
      MapCache2.prototype.clear = mapCacheClear2;
      MapCache2.prototype["delete"] = mapCacheDelete2;
      MapCache2.prototype.get = mapCacheGet2;
      MapCache2.prototype.has = mapCacheHas2;
      MapCache2.prototype.set = mapCacheSet2;
      function SetCache2(values3) {
        var index2 = -1, length = values3 == null ? 0 : values3.length;
        this.__data__ = new MapCache2();
        while (++index2 < length) {
          this.add(values3[index2]);
        }
      }
      function setCacheAdd2(value) {
        this.__data__.set(value, HASH_UNDEFINED2);
        return this;
      }
      function setCacheHas2(value) {
        return this.__data__.has(value);
      }
      SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
      SetCache2.prototype.has = setCacheHas2;
      function Stack2(entries2) {
        var data = this.__data__ = new ListCache2(entries2);
        this.size = data.size;
      }
      function stackClear2() {
        this.__data__ = new ListCache2();
        this.size = 0;
      }
      function stackDelete2(key) {
        var data = this.__data__, result2 = data["delete"](key);
        this.size = data.size;
        return result2;
      }
      function stackGet2(key) {
        return this.__data__.get(key);
      }
      function stackHas2(key) {
        return this.__data__.has(key);
      }
      function stackSet2(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache2) {
          var pairs = data.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache2(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      Stack2.prototype.clear = stackClear2;
      Stack2.prototype["delete"] = stackDelete2;
      Stack2.prototype.get = stackGet2;
      Stack2.prototype.has = stackHas2;
      Stack2.prototype.set = stackSet2;
      function arrayLikeKeys2(value, inherited) {
        var isArr = isArray2(value), isArg = !isArr && isArguments2(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes2(value.length, String2) : [], length = result2.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
          (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
          isIndex2(key, length)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }
      function arraySampleSize(array, n4) {
        return shuffleSelf(copyArray2(array), baseClamp2(n4, 0, array.length));
      }
      function arrayShuffle(array) {
        return shuffleSelf(copyArray2(array));
      }
      function assignMergeValue(object, key, value) {
        if (value !== undefined$1 && !eq2(object[key], value) || value === undefined$1 && !(key in object)) {
          baseAssignValue2(object, key, value);
        }
      }
      function assignValue2(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty2.call(object, key) && eq2(objValue, value)) || value === undefined$1 && !(key in object)) {
          baseAssignValue2(object, key, value);
        }
      }
      function assocIndexOf2(array, key) {
        var length = array.length;
        while (length--) {
          if (eq2(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign2(object, source) {
        return object && copyObject2(source, keys2(source), object);
      }
      function baseAssignIn2(object, source) {
        return object && copyObject2(source, keysIn2(source), object);
      }
      function baseAssignValue2(object, key, value) {
        if (key == "__proto__" && defineProperty2) {
          defineProperty2(object, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object[key] = value;
        }
      }
      function baseAt(object, paths) {
        var index2 = -1, length = paths.length, result2 = Array2(length), skip = object == null;
        while (++index2 < length) {
          result2[index2] = skip ? undefined$1 : get(object, paths[index2]);
        }
        return result2;
      }
      function baseClamp2(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$1) {
            number = number <= upper ? number : upper;
          }
          if (lower !== undefined$1) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }
      function baseClone2(value, bitmask, customizer, key, object, stack) {
        var result2, isDeep = bitmask & CLONE_DEEP_FLAG2, isFlat = bitmask & CLONE_FLAT_FLAG2, isFull = bitmask & CLONE_SYMBOLS_FLAG2;
        if (customizer) {
          result2 = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result2 !== undefined$1) {
          return result2;
        }
        if (!isObject2(value)) {
          return value;
        }
        var isArr = isArray2(value);
        if (isArr) {
          result2 = initCloneArray2(value);
          if (!isDeep) {
            return copyArray2(value, result2);
          }
        } else {
          var tag = getTag2(value), isFunc = tag == funcTag2 || tag == genTag2;
          if (isBuffer2(value)) {
            return cloneBuffer2(value, isDeep);
          }
          if (tag == objectTag2 || tag == argsTag2 || isFunc && !object) {
            result2 = isFlat || isFunc ? {} : initCloneObject2(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn2(value, baseAssignIn2(result2, value)) : copySymbols2(value, baseAssign2(result2, value));
            }
          } else {
            if (!cloneableTags2[tag]) {
              return object ? value : {};
            }
            result2 = initCloneByTag2(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack2());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result2);
        if (isSet2(value)) {
          value.forEach(function(subValue) {
            result2.add(baseClone2(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap2(value)) {
          value.forEach(function(subValue, key2) {
            result2.set(key2, baseClone2(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn2 : getAllKeys2 : isFlat ? keysIn2 : keys2;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach2(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue2(result2, key2, baseClone2(subValue, bitmask, customizer, key2, value, stack));
        });
        return result2;
      }
      function baseConforms(source) {
        var props = keys2(source);
        return function(object) {
          return baseConformsTo2(object, source, props);
        };
      }
      function baseConformsTo2(object, source, props) {
        var length = props.length;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (length--) {
          var key = props[length], predicate = source[key], value = object[key];
          if (value === undefined$1 && !(key in object) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array, values3, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values3.length;
        if (!length) {
          return result2;
        }
        if (iteratee2) {
          values3 = arrayMap2(values3, baseUnary2(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values3.length >= LARGE_ARRAY_SIZE2) {
          includes2 = cacheHas2;
          isCommon = false;
          values3 = new SetCache2(values3);
        }
        outer:
          while (++index2 < length) {
            var value = array[index2], computed = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values3[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result2.push(value);
            } else if (!includes2(values3, computed, comparator)) {
              result2.push(value);
            }
          }
        return result2;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result2 = true;
        baseEach(collection, function(value, index2, collection2) {
          result2 = !!predicate(value, index2, collection2);
          return result2;
        });
        return result2;
      }
      function baseExtremum(array, iteratee2, comparator) {
        var index2 = -1, length = array.length;
        while (++index2 < length) {
          var value = array[index2], current = iteratee2(value);
          if (current != null && (computed === undefined$1 ? current === current && !isSymbol2(current) : comparator(current, computed))) {
            var computed = current, result2 = value;
          }
        }
        return result2;
      }
      function baseFill(array, value, start, end) {
        var length = array.length;
        start = toInteger2(start);
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end === undefined$1 || end > length ? length : toInteger2(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength2(end);
        while (start < end) {
          array[start++] = value;
        }
        return array;
      }
      function baseFilter(collection, predicate) {
        var result2 = [];
        baseEach(collection, function(value, index2, collection2) {
          if (predicate(value, index2, collection2)) {
            result2.push(value);
          }
        });
        return result2;
      }
      function baseFlatten(array, depth, predicate, isStrict, result2) {
        var index2 = -1, length = array.length;
        predicate || (predicate = isFlattenable);
        result2 || (result2 = []);
        while (++index2 < length) {
          var value = array[index2];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result2);
            } else {
              arrayPush2(result2, value);
            }
          } else if (!isStrict) {
            result2[result2.length] = value;
          }
        }
        return result2;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object, iteratee2) {
        return object && baseFor(object, iteratee2, keys2);
      }
      function baseForOwnRight(object, iteratee2) {
        return object && baseForRight(object, iteratee2, keys2);
      }
      function baseFunctions(object, props) {
        return arrayFilter2(props, function(key) {
          return isFunction2(object[key]);
        });
      }
      function baseGet(object, path) {
        path = castPath(path, object);
        var index2 = 0, length = path.length;
        while (object != null && index2 < length) {
          object = object[toKey(path[index2++])];
        }
        return index2 && index2 == length ? object : undefined$1;
      }
      function baseGetAllKeys2(object, keysFunc, symbolsFunc) {
        var result2 = keysFunc(object);
        return isArray2(object) ? result2 : arrayPush2(result2, symbolsFunc(object));
      }
      function baseGetTag2(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag2 : nullTag2;
        }
        return symToStringTag2 && symToStringTag2 in Object2(value) ? getRawTag2(value) : objectToString2(value);
      }
      function baseGt2(value, other) {
        return value > other;
      }
      function baseHas(object, key) {
        return object != null && hasOwnProperty2.call(object, key);
      }
      function baseHasIn(object, key) {
        return object != null && key in Object2(object);
      }
      function baseInRange(number, start, end) {
        return number >= nativeMin(start, end) && number < nativeMax(start, end);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee2) {
            array = arrayMap2(array, baseUnary2(iteratee2));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache2(othIndex && array) : undefined$1;
        }
        array = arrays[0];
        var index2 = -1, seen = caches[0];
        outer:
          while (++index2 < length && result2.length < maxLength) {
            var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas2(seen, computed) : includes2(result2, computed, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas2(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseInverter(object, setter, iteratee2, accumulator) {
        baseForOwn(object, function(value, key, object2) {
          setter(accumulator, iteratee2(value), key, object2);
        });
        return accumulator;
      }
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply2(func, object, args);
      }
      function baseIsArguments2(value) {
        return isObjectLike2(value) && baseGetTag2(value) == argsTag2;
      }
      function baseIsArrayBuffer2(value) {
        return isObjectLike2(value) && baseGetTag2(value) == arrayBufferTag2;
      }
      function baseIsDate2(value) {
        return isObjectLike2(value) && baseGetTag2(value) == dateTag2;
      }
      function baseIsEqual2(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike2(value) && !isObjectLike2(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep2(value, other, bitmask, customizer, baseIsEqual2, stack);
      }
      function baseIsEqualDeep2(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag2 : getTag2(object), othTag = othIsArr ? arrayTag2 : getTag2(other);
        objTag = objTag == argsTag2 ? objectTag2 : objTag;
        othTag = othTag == argsTag2 ? objectTag2 : othTag;
        var objIsObj = objTag == objectTag2, othIsObj = othTag == objectTag2, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer2(object)) {
          if (!isBuffer2(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack2());
          return objIsArr || isTypedArray2(object) ? equalArrays2(object, other, bitmask, customizer, equalFunc, stack) : equalByTag2(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG2)) {
          var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack2());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack2());
        return equalObjects2(object, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap2(value) {
        return isObjectLike2(value) && getTag2(value) == mapTag2;
      }
      function baseIsMatch2(object, source, matchData, customizer) {
        var index2 = matchData.length, length = index2, noCustomizer = !customizer;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (index2--) {
          var data = matchData[index2];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index2 < length) {
          data = matchData[index2];
          var key = data[0], objValue = object[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack2();
            if (customizer) {
              var result2 = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result2 === undefined$1 ? baseIsEqual2(srcValue, objValue, COMPARE_PARTIAL_FLAG2 | COMPARE_UNORDERED_FLAG2, customizer, stack) : result2)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative2(value) {
        if (!isObject2(value) || isMasked2(value)) {
          return false;
        }
        var pattern = isFunction2(value) ? reIsNative2 : reIsHostCtor2;
        return pattern.test(toSource2(value));
      }
      function baseIsRegExp2(value) {
        return isObjectLike2(value) && baseGetTag2(value) == regexpTag2;
      }
      function baseIsSet2(value) {
        return isObjectLike2(value) && getTag2(value) == setTag2;
      }
      function baseIsTypedArray2(value) {
        return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags2[baseGetTag2(value)];
      }
      function baseIteratee(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == "object") {
          return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      function baseKeys2(object) {
        if (!isPrototype2(object)) {
          return nativeKeys2(object);
        }
        var result2 = [];
        for (var key in Object2(object)) {
          if (hasOwnProperty2.call(object, key) && key != "constructor") {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseKeysIn2(object) {
        if (!isObject2(object)) {
          return nativeKeysIn2(object);
        }
        var isProto = isPrototype2(object), result2 = [];
        for (var key in object) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseLt2(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee2) {
        var index2 = -1, result2 = isArrayLike2(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value, key, collection2) {
          result2[++index2] = iteratee2(value, key, collection2);
        });
        return result2;
      }
      function baseMatches(source) {
        var matchData = getMatchData2(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source || baseIsMatch2(object, source, matchData);
        };
      }
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable2(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object) {
          var objValue = get(object, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual2(srcValue, objValue, COMPARE_PARTIAL_FLAG2 | COMPARE_UNORDERED_FLAG2);
        };
      }
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function(srcValue, key) {
          stack || (stack = new Stack2());
          if (isObject2(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn2);
      }
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer2(srcValue), isTyped = !isArr && !isBuff && isTypedArray2(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray2(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject2(objValue)) {
              newValue = copyArray2(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer2(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray2(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject2(srcValue) || isArguments2(srcValue)) {
            newValue = objValue;
            if (isArguments2(objValue)) {
              newValue = toPlainObject2(objValue);
            } else if (!isObject2(objValue) || isFunction2(objValue)) {
              newValue = initCloneObject2(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      function baseNth(array, n4) {
        var length = array.length;
        if (!length) {
          return;
        }
        n4 += n4 < 0 ? length : 0;
        return isIndex2(n4, length) ? array[n4] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap2(iteratees, function(iteratee2) {
            if (isArray2(iteratee2)) {
              return function(value) {
                return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity];
        }
        var index2 = -1;
        iteratees = arrayMap2(iteratees, baseUnary2(getIteratee()));
        var result2 = baseMap(collection, function(value, key, collection2) {
          var criteria = arrayMap2(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index2, "value": value };
        });
        return baseSortBy(result2, function(object, other) {
          return compareMultiple(object, other, orders);
        });
      }
      function basePick(object, paths) {
        return basePickBy(object, paths, function(value, path) {
          return hasIn(object, path);
        });
      }
      function basePickBy(object, paths, predicate) {
        var index2 = -1, length = paths.length, result2 = {};
        while (++index2 < length) {
          var path = paths[index2], value = baseGet(object, path);
          if (predicate(value, path)) {
            baseSet(result2, castPath(path, object), value);
          }
        }
        return result2;
      }
      function basePropertyDeep(path) {
        return function(object) {
          return baseGet(object, path);
        };
      }
      function basePullAll(array, values3, iteratee2, comparator) {
        var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length = values3.length, seen = array;
        if (array === values3) {
          values3 = copyArray2(values3);
        }
        if (iteratee2) {
          seen = arrayMap2(array, baseUnary2(iteratee2));
        }
        while (++index2 < length) {
          var fromIndex = 0, value = values3[index2], computed = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice2.call(seen, fromIndex, 1);
            }
            splice2.call(array, fromIndex, 1);
          }
        }
        return array;
      }
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0, lastIndex = length - 1;
        while (length--) {
          var index2 = indexes[length];
          if (length == lastIndex || index2 !== previous) {
            var previous = index2;
            if (isIndex2(index2)) {
              splice2.call(array, index2, 1);
            } else {
              baseUnset(array, index2);
            }
          }
        }
        return array;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start, end, step, fromRight) {
        var index2 = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
        while (length--) {
          result2[fromRight ? length : ++index2] = start;
          start += step;
        }
        return result2;
      }
      function baseRepeat(string, n4) {
        var result2 = "";
        if (!string || n4 < 1 || n4 > MAX_SAFE_INTEGER2) {
          return result2;
        }
        do {
          if (n4 % 2) {
            result2 += string;
          }
          n4 = nativeFloor(n4 / 2);
          if (n4) {
            string += string;
          }
        } while (n4);
        return result2;
      }
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + "");
      }
      function baseSample(collection) {
        return arraySample(values2(collection));
      }
      function baseSampleSize(collection, n4) {
        var array = values2(collection);
        return shuffleSelf(array, baseClamp2(n4, 0, array.length));
      }
      function baseSet(object, path, value, customizer) {
        if (!isObject2(object)) {
          return object;
        }
        path = castPath(path, object);
        var index2 = -1, length = path.length, lastIndex = length - 1, nested = object;
        while (nested != null && ++index2 < length) {
          var key = toKey(path[index2]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject2(objValue) ? objValue : isIndex2(path[index2 + 1]) ? [] : {};
            }
          }
          assignValue2(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      var baseSetData = !metaMap ? identity : function(func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString = !defineProperty2 ? identity : function(func, string) {
        return defineProperty2(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant(string),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values2(collection));
      }
      function baseSlice(array, start, end) {
        var index2 = -1, length = array.length;
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result2 = Array2(length);
        while (++index2 < length) {
          result2[index2] = array[index2 + start];
        }
        return result2;
      }
      function baseSome(collection, predicate) {
        var result2;
        baseEach(collection, function(value, index2, collection2) {
          result2 = predicate(value, index2, collection2);
          return !result2;
        });
        return !!result2;
      }
      function baseSortedIndex(array, value, retHighest) {
        var low = 0, high = array == null ? low : array.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed = array[mid];
            if (computed !== null && !isSymbol2(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }
      function baseSortedIndexBy(array, value, iteratee2, retHighest) {
        var low = 0, high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol2(value), valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined$1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol2(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array, iteratee2) {
        var index2 = -1, length = array.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
          if (!index2 || !eq2(computed, seen)) {
            var seen = computed;
            result2[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result2;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN2;
        }
        return +value;
      }
      function baseToString2(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray2(value)) {
          return arrayMap2(value, baseToString2) + "";
        }
        if (isSymbol2(value)) {
          return symbolToString2 ? symbolToString2.call(value) : "";
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY2 ? "-0" : result2;
      }
      function baseUniq(array, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE2) {
          var set2 = iteratee2 ? null : createSet(array);
          if (set2) {
            return setToArray2(set2);
          }
          isCommon = false;
          includes2 = cacheHas2;
          seen = new SetCache2();
        } else {
          seen = iteratee2 ? [] : result2;
        }
        outer:
          while (++index2 < length) {
            var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed);
              }
              result2.push(value);
            } else if (!includes2(seen, computed, comparator)) {
              if (seen !== result2) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length, index2 = fromRight ? length : -1;
        while ((fromRight ? index2-- : ++index2 < length) && predicate(array[index2], index2, array)) {
        }
        return isDrop ? baseSlice(array, fromRight ? 0 : index2, fromRight ? index2 + 1 : length) : baseSlice(array, fromRight ? index2 + 1 : 0, fromRight ? length : index2);
      }
      function baseWrapperValue(value, actions2) {
        var result2 = value;
        if (result2 instanceof LazyWrapper) {
          result2 = result2.value();
        }
        return arrayReduce(actions2, function(result3, action) {
          return action.func.apply(action.thisArg, arrayPush2([result3], action.args));
        }, result2);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index2 = -1, result2 = Array2(length);
        while (++index2 < length) {
          var array = arrays[index2], othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index2) {
              result2[index2] = baseDifference(result2[index2] || array, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values3, assignFunc) {
        var index2 = -1, length = props.length, valsLength = values3.length, result2 = {};
        while (++index2 < length) {
          var value = index2 < valsLength ? values3[index2] : undefined$1;
          assignFunc(result2, props[index2], value);
        }
        return result2;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject2(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == "function" ? value : identity;
      }
      function castPath(value, object) {
        if (isArray2(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString2(value));
      }
      var castRest = baseRest;
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }
      var clearTimeout2 = ctxClearTimeout || function(id) {
        return root2.clearTimeout(id);
      };
      function cloneBuffer2(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result2);
        return result2;
      }
      function cloneArrayBuffer2(arrayBuffer) {
        var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
        return result2;
      }
      function cloneDataView2(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer2(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp2(regexp) {
        var result2 = new regexp.constructor(regexp.source, reFlags2.exec(regexp));
        result2.lastIndex = regexp.lastIndex;
        return result2;
      }
      function cloneSymbol2(symbol) {
        return symbolValueOf2 ? Object2(symbolValueOf2.call(symbol)) : {};
      }
      function cloneTypedArray2(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer2(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol2(value);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol2(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while (++index2 < length) {
          var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
          if (result2) {
            if (index2 >= ordersLength) {
              return result2;
            }
            var order = orders[index2];
            return result2 * (order == "desc" ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result2[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result2[leftIndex++] = args[argsIndex++];
        }
        return result2;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result2[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result2[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result2;
      }
      function copyArray2(source, array) {
        var index2 = -1, length = source.length;
        array || (array = Array2(length));
        while (++index2 < length) {
          array[index2] = source[index2];
        }
        return array;
      }
      function copyObject2(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index2 = -1, length = props.length;
        while (++index2 < length) {
          var key = props[index2];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue2(object, key, newValue);
          } else {
            assignValue2(object, key, newValue);
          }
        }
        return object;
      }
      function copySymbols2(source, object) {
        return copyObject2(source, getSymbols2(source), object);
      }
      function copySymbolsIn2(source, object) {
        return copyObject2(source, getSymbolsIn2(source), object);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined$1, guard = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object = Object2(object);
          while (++index2 < length) {
            var source = sources[index2];
            if (source) {
              assigner(object, source, index2, customizer);
            }
          }
          return object;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike2(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length = collection.length, index2 = fromRight ? length : -1, iterable = Object2(collection);
          while (fromRight ? index2-- : ++index2 < length) {
            if (iteratee2(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function(object, iteratee2, keysFunc) {
          var index2 = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index2];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn2 = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          return fn2.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function(string) {
          string = toString2(string);
          var strSymbols = hasUnicode2(string) ? stringToArray2(string) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function(string) {
          return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate2(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
          return isObject2(result2) ? result2 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length, placeholder = getHolder(wrapper);
          while (index2--) {
            args[index2] = arguments[index2];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              undefined$1,
              args,
              holders,
              undefined$1,
              undefined$1,
              arity - length
            );
          }
          var fn2 = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          return apply2(fn2, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike2(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys2(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length = funcs.length, index2 = length, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index2--) {
            var func = funcs[index2];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index2 = wrapper ? index2 : length;
          while (++index2 < length) {
            func = funcs[index2];
            var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray2(value)) {
              return wrapper.plant(value).value();
            }
            var index3 = 0, result2 = length ? funcs[index3].apply(this, args) : value;
            while (++index3 < length) {
              result2 = funcs[index3].call(this, result2);
            }
            return result2;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length;
          while (index2--) {
            args[index2] = arguments[index2];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              thisArg,
              args,
              newHolders,
              argPos,
              ary2,
              arity - length
            );
          }
          var thisBinding = isBind ? thisArg : this, fn2 = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length) {
            args.length = ary2;
          }
          if (this && this !== root2 && this instanceof wrapper) {
            fn2 = Ctor || createCtor(fn2);
          }
          return fn2.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object, iteratee2) {
          return baseInverter(object, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result2;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result2 = value;
          }
          if (other !== undefined$1) {
            if (result2 === undefined$1) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString2(value);
              other = baseToString2(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result2 = operator(value, other);
          }
          return result2;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap2(iteratees, baseUnary2(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply2(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? " " : baseToString2(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode2(chars) ? castSlice(stringToArray2(result2), 0, length).join("") : result2.slice(0, length);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn2 = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply2(fn2, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start, end, step) {
          if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }
          start = toFinite2(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite2(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite2(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      function createRelationalOperation2(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber2(value);
            other = toNumber2(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result2 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result2, newData);
        }
        result2.placeholder = placeholder;
        return setWrapToString(result2, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number, precision) {
          number = toNumber2(number);
          precision = precision == null ? 0 : nativeMin(toInteger2(precision), 292);
          if (precision && nativeIsFinite2(number)) {
            var pair = (toString2(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString2(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number);
        };
      }
      var createSet = !(Set2 && 1 / setToArray2(new Set2([, -0]))[1] == INFINITY2) ? noop : function(values3) {
        return new Set2(values3);
      };
      function createToPairs(keysFunc) {
        return function(object) {
          var tag = getTag2(object);
          if (tag == mapTag2) {
            return mapToArray2(object);
          }
          if (tag == setTag2) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax(toInteger2(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger2(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result2 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result2 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result2 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result2 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result2, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq2(objValue, objectProto2[key]) && !hasOwnProperty2.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject2(objValue) && isObject2(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject2(value) ? undefined$1 : value;
      }
      function equalArrays2(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG2 ? new SetCache2() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);
        while (++index2 < arrLength) {
          var arrValue = array[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result2 = false;
            break;
          }
          if (seen) {
            if (!arraySome2(other, function(othValue2, othIndex) {
              if (!cacheHas2(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result2 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result2 = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result2;
      }
      function equalByTag2(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag2:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag2:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag2:
          case dateTag2:
          case numberTag2:
            return eq2(+object, +other);
          case errorTag2:
            return object.name == other.name && object.message == other.message;
          case regexpTag2:
          case stringTag2:
            return object == other + "";
          case mapTag2:
            var convert = mapToArray2;
          case setTag2:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
            convert || (convert = setToArray2);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG2;
            stack.set(object, other);
            var result2 = equalArrays2(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result2;
          case symbolTag2:
            if (symbolValueOf2) {
              return symbolValueOf2.call(object) == symbolValueOf2.call(other);
            }
        }
        return false;
      }
      function equalObjects2(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, objProps = getAllKeys2(object), objLength = objProps.length, othProps = getAllKeys2(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result2 = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result2 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result2 && !skipCtor) {
          var objCtor = object.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result2 = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result2;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + "");
      }
      function getAllKeys2(object) {
        return baseGetAllKeys2(object, keys2, getSymbols2);
      }
      function getAllKeysIn2(object) {
        return baseGetAllKeys2(object, keysIn2, getSymbolsIn2);
      }
      var getData = !metaMap ? noop : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty2.call(realNames, result2) ? array.length : 0;
        while (length--) {
          var data = array[length], otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result2;
      }
      function getHolder(func) {
        var object = hasOwnProperty2.call(lodash2, "placeholder") ? lodash2 : func;
        return object.placeholder;
      }
      function getIteratee() {
        var result2 = lodash2.iteratee || iteratee;
        result2 = result2 === iteratee ? baseIteratee : result2;
        return arguments.length ? result2(arguments[0], arguments[1]) : result2;
      }
      function getMapData2(map2, key) {
        var data = map2.__data__;
        return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      function getMatchData2(object) {
        var result2 = keys2(object), length = result2.length;
        while (length--) {
          var key = result2[length], value = object[key];
          result2[length] = [key, value, isStrictComparable2(value)];
        }
        return result2;
      }
      function getNative2(object, key) {
        var value = getValue2(object, key);
        return baseIsNative2(value) ? value : undefined$1;
      }
      function getRawTag2(value) {
        var isOwn = hasOwnProperty2.call(value, symToStringTag2), tag = value[symToStringTag2];
        try {
          value[symToStringTag2] = undefined$1;
          var unmasked = true;
        } catch (e5) {
        }
        var result2 = nativeObjectToString2.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag2] = tag;
          } else {
            delete value[symToStringTag2];
          }
        }
        return result2;
      }
      var getSymbols2 = !nativeGetSymbols2 ? stubArray2 : function(object) {
        if (object == null) {
          return [];
        }
        object = Object2(object);
        return arrayFilter2(nativeGetSymbols2(object), function(symbol) {
          return propertyIsEnumerable2.call(object, symbol);
        });
      };
      var getSymbolsIn2 = !nativeGetSymbols2 ? stubArray2 : function(object) {
        var result2 = [];
        while (object) {
          arrayPush2(result2, getSymbols2(object));
          object = getPrototype2(object);
        }
        return result2;
      };
      var getTag2 = baseGetTag2;
      if (DataView2 && getTag2(new DataView2(new ArrayBuffer(1))) != dataViewTag2 || Map2 && getTag2(new Map2()) != mapTag2 || Promise2 && getTag2(Promise2.resolve()) != promiseTag2 || Set2 && getTag2(new Set2()) != setTag2 || WeakMap2 && getTag2(new WeakMap2()) != weakMapTag2) {
        getTag2 = function(value) {
          var result2 = baseGetTag2(value), Ctor = result2 == objectTag2 ? value.constructor : undefined$1, ctorString = Ctor ? toSource2(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString2:
                return dataViewTag2;
              case mapCtorString2:
                return mapTag2;
              case promiseCtorString2:
                return promiseTag2;
              case setCtorString2:
                return setTag2;
              case weakMapCtorString2:
                return weakMapTag2;
            }
          }
          return result2;
        };
      }
      function getView(start, end, transforms) {
        var index2 = -1, length = transforms.length;
        while (++index2 < length) {
          var data = transforms[index2], size2 = data.size;
          switch (data.type) {
            case "drop":
              start += size2;
              break;
            case "dropRight":
              end -= size2;
              break;
            case "take":
              end = nativeMin(end, start + size2);
              break;
            case "takeRight":
              start = nativeMax(start, end - size2);
              break;
          }
        }
        return { "start": start, "end": end };
      }
      function getWrapDetails(source) {
        var match = source.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index2 = -1, length = path.length, result2 = false;
        while (++index2 < length) {
          var key = toKey(path[index2]);
          if (!(result2 = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result2 || ++index2 != length) {
          return result2;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength2(length) && isIndex2(key, length) && (isArray2(object) || isArguments2(object));
      }
      function initCloneArray2(array) {
        var length = array.length, result2 = new array.constructor(length);
        if (length && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
          result2.index = array.index;
          result2.input = array.input;
        }
        return result2;
      }
      function initCloneObject2(object) {
        return typeof object.constructor == "function" && !isPrototype2(object) ? baseCreate2(getPrototype2(object)) : {};
      }
      function initCloneByTag2(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag2:
            return cloneArrayBuffer2(object);
          case boolTag2:
          case dateTag2:
            return new Ctor(+object);
          case dataViewTag2:
            return cloneDataView2(object, isDeep);
          case float32Tag2:
          case float64Tag2:
          case int8Tag2:
          case int16Tag2:
          case int32Tag2:
          case uint8Tag2:
          case uint8ClampedTag2:
          case uint16Tag2:
          case uint32Tag2:
            return cloneTypedArray2(object, isDeep);
          case mapTag2:
            return new Ctor();
          case numberTag2:
          case stringTag2:
            return new Ctor(object);
          case regexpTag2:
            return cloneRegExp2(object);
          case setTag2:
            return new Ctor();
          case symbolTag2:
            return cloneSymbol2(object);
        }
      }
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length > 2 ? ", " : " ");
        return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value) {
        return isArray2(value) || isArguments2(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex2(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER2 : length;
        return !!length && (type == "number" || type != "symbol" && reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length);
      }
      function isIterateeCall(value, index2, object) {
        if (!isObject2(object)) {
          return false;
        }
        var type = typeof index2;
        if (type == "number" ? isArrayLike2(object) && isIndex2(index2, object.length) : type == "string" && index2 in object) {
          return eq2(object[index2], value);
        }
        return false;
      }
      function isKey(value, object) {
        if (isArray2(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol2(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
      }
      function isKeyable2(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked2(func) {
        return !!maskSrcKey2 && maskSrcKey2 in func;
      }
      var isMaskable2 = coreJsData2 ? isFunction2 : stubFalse2;
      function isPrototype2(value) {
        var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
        return value === proto;
      }
      function isStrictComparable2(value) {
        return value === value && !isObject2(value);
      }
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object));
        };
      }
      function memoizeCapped(func) {
        var result2 = memoize(func, function(key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result2.cache;
        return result2;
      }
      function mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) {
          data[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }
        if (data[9] == null) {
          data[9] = source[9];
        }
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn2(object) {
        var result2 = [];
        if (object != null) {
          for (var key in Object2(object)) {
            result2.push(key);
          }
        }
        return result2;
      }
      function objectToString2(value) {
        return nativeObjectToString2.call(value);
      }
      function overRest(func, start, transform2) {
        start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments, index2 = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
          while (++index2 < length) {
            array[index2] = args[start + index2];
          }
          index2 = -1;
          var otherArgs = Array2(start + 1);
          while (++index2 < start) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start] = transform2(array);
          return apply2(func, this, otherArgs);
        };
      }
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }
      function reorder(array, indexes) {
        var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray2(array);
        while (length--) {
          var index2 = indexes[length];
          array[length] = isIndex2(index2, arrLength) ? oldArray[index2] : undefined$1;
        }
        return array;
      }
      function safeGet(object, key) {
        if (key === "constructor" && typeof object[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object[key];
      }
      var setData = shortOut(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root2.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + "";
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array, size2) {
        var index2 = -1, length = array.length, lastIndex = length - 1;
        size2 = size2 === undefined$1 ? length : size2;
        while (++index2 < size2) {
          var rand = baseRandom(index2, lastIndex), value = array[rand];
          array[rand] = array[index2];
          array[index2] = value;
        }
        array.length = size2;
        return array;
      }
      var stringToPath = memoizeCapped(function(string) {
        var result2 = [];
        if (string.charCodeAt(0) === 46) {
          result2.push("");
        }
        string.replace(rePropName, function(match, number, quote, subString) {
          result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
        });
        return result2;
      });
      function toKey(value) {
        if (typeof value == "string" || isSymbol2(value)) {
          return value;
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY2 ? "-0" : result2;
      }
      function toSource2(func) {
        if (func != null) {
          try {
            return funcToString2.call(func);
          } catch (e5) {
          }
          try {
            return func + "";
          } catch (e5) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach2(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result2.__actions__ = copyArray2(wrapper.__actions__);
        result2.__index__ = wrapper.__index__;
        result2.__values__ = wrapper.__values__;
        return result2;
      }
      function chunk(array, size2, guard) {
        if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined$1) {
          size2 = 1;
        } else {
          size2 = nativeMax(toInteger2(size2), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size2 < 1) {
          return [];
        }
        var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
        while (index2 < length) {
          result2[resIndex++] = baseSlice(array, index2, index2 += size2);
        }
        return result2;
      }
      function compact(array) {
        var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array[index2];
          if (value) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array2(length - 1), array = arguments[0], index2 = length;
        while (index2--) {
          args[index2 - 1] = arguments[index2];
        }
        return arrayPush2(isArray2(array) ? copyArray2(array) : [array], baseFlatten(args, 1));
      }
      var difference = baseRest(function(array, values3) {
        return isArrayLikeObject2(array) ? baseDifference(array, baseFlatten(values3, 1, isArrayLikeObject2, true)) : [];
      });
      var differenceBy = baseRest(function(array, values3) {
        var iteratee2 = last(values3);
        if (isArrayLikeObject2(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject2(array) ? baseDifference(array, baseFlatten(values3, 1, isArrayLikeObject2, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest(function(array, values3) {
        var comparator = last(values3);
        if (isArrayLikeObject2(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject2(array) ? baseDifference(array, baseFlatten(values3, 1, isArrayLikeObject2, true), undefined$1, comparator) : [];
      });
      function drop(array, n4, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n4 = guard || n4 === undefined$1 ? 1 : toInteger2(n4);
        return baseSlice(array, n4 < 0 ? 0 : n4, length);
      }
      function dropRight(array, n4, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n4 = guard || n4 === undefined$1 ? 1 : toInteger2(n4);
        n4 = length - n4;
        return baseSlice(array, 0, n4 < 0 ? 0 : n4);
      }
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }
      function fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
          start = 0;
          end = length;
        }
        return baseFill(array, value, start, end);
      }
      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length + index2, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2);
      }
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = length - 1;
        if (fromIndex !== undefined$1) {
          index2 = toInteger2(fromIndex);
          index2 = fromIndex < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2, true);
      }
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY2) : [];
      }
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger2(depth);
        return baseFlatten(array, depth);
      }
      function fromPairs(pairs) {
        var index2 = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
        while (++index2 < length) {
          var pair = pairs[index2];
          result2[pair[0]] = pair[1];
        }
        return result2;
      }
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }
      function indexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length + index2, 0);
        }
        return baseIndexOf(array, value, index2);
      }
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap2(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap2(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap2(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join(array, separator) {
        return array == null ? "" : nativeJoin.call(array, separator);
      }
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }
      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = length;
        if (fromIndex !== undefined$1) {
          index2 = toInteger2(fromIndex);
          index2 = index2 < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return value === value ? strictLastIndexOf(array, value, index2) : baseFindIndex(array, baseIsNaN, index2, true);
      }
      function nth(array, n4) {
        return array && array.length ? baseNth(array, toInteger2(n4)) : undefined$1;
      }
      var pull = baseRest(pullAll);
      function pullAll(array, values3) {
        return array && array.length && values3 && values3.length ? basePullAll(array, values3) : array;
      }
      function pullAllBy(array, values3, iteratee2) {
        return array && array.length && values3 && values3.length ? basePullAll(array, values3, getIteratee(iteratee2, 2)) : array;
      }
      function pullAllWith(array, values3, comparator) {
        return array && array.length && values3 && values3.length ? basePullAll(array, values3, undefined$1, comparator) : array;
      }
      var pullAt = flatRest(function(array, indexes) {
        var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
        basePullAt(array, arrayMap2(indexes, function(index2) {
          return isIndex2(index2, length) ? +index2 : index2;
        }).sort(compareAscending));
        return result2;
      });
      function remove(array, predicate) {
        var result2 = [];
        if (!(array && array.length)) {
          return result2;
        }
        var index2 = -1, indexes = [], length = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index2 < length) {
          var value = array[index2];
          if (predicate(value, index2, array)) {
            result2.push(value);
            indexes.push(index2);
          }
        }
        basePullAt(array, indexes);
        return result2;
      }
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }
      function slice(array, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger2(start);
          end = end === undefined$1 ? length : toInteger2(end);
        }
        return baseSlice(array, start, end);
      }
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }
      function sortedIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index2 = baseSortedIndex(array, value);
          if (index2 < length && eq2(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }
      function sortedLastIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index2 = baseSortedIndex(array, value, true) - 1;
          if (eq2(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }
      function sortedUniqBy(array, iteratee2) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }
      function take(array, n4, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n4 = guard || n4 === undefined$1 ? 1 : toInteger2(n4);
        return baseSlice(array, 0, n4 < 0 ? 0 : n4);
      }
      function takeRight(array, n4, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n4 = guard || n4 === undefined$1 ? 1 : toInteger2(n4);
        n4 = length - n4;
        return baseSlice(array, n4 < 0 ? 0 : n4, length);
      }
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject2, true));
      });
      var unionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject2(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject2, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject2, true), undefined$1, comparator);
      });
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      function uniqBy(array, iteratee2) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter2(array, function(group) {
          if (isArrayLikeObject2(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes2(length, function(index2) {
          return arrayMap2(array, baseProperty(index2));
        });
      }
      function unzipWith(array, iteratee2) {
        if (!(array && array.length)) {
          return [];
        }
        var result2 = unzip(array);
        if (iteratee2 == null) {
          return result2;
        }
        return arrayMap2(result2, function(group) {
          return apply2(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest(function(array, values3) {
        return isArrayLikeObject2(array) ? baseDifference(array, values3) : [];
      });
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter2(arrays, isArrayLikeObject2));
      });
      var xorBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject2(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter2(arrays, isArrayLikeObject2), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter2(arrays, isArrayLikeObject2), undefined$1, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props, values3) {
        return baseZipObject(props || [], values3 || [], assignValue2);
      }
      function zipObjectDeep(props, values3) {
        return baseZipObject(props || [], values3 || [], baseSet);
      }
      var zipWith = baseRest(function(arrays) {
        var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value) {
        var result2 = lodash2(value);
        result2.__chain__ = true;
        return result2;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function(paths) {
        var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
          return baseAt(object, paths);
        };
        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex2(start)) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray2(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result2, parent2 = this;
        while (parent2 instanceof baseLodash) {
          var clone3 = wrapperClone(parent2);
          clone3.__index__ = 0;
          clone3.__values__ = undefined$1;
          if (result2) {
            previous.__wrapped__ = clone3;
          } else {
            result2 = clone3;
          }
          var previous = clone3;
          parent2 = parent2.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result2;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          ++result2[key];
        } else {
          baseAssignValue2(result2, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray2(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter2 : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find = createFind(findIndex);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), INFINITY2);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger2(depth);
        return baseFlatten(map(collection, iteratee2), depth);
      }
      function forEach(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEach2 : baseEach;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          result2[key].push(value);
        } else {
          baseAssignValue2(result2, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike2(collection) ? collection : values2(collection);
        fromIndex = fromIndex && !guard ? toInteger2(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString2(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest(function(collection, path, args) {
        var index2 = -1, isFunc = typeof path == "function", result2 = isArrayLike2(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value) {
          result2[++index2] = isFunc ? apply2(path, value, args) : baseInvoke(value, path, args);
        });
        return result2;
      });
      var keyBy = createAggregator(function(result2, value, key) {
        baseAssignValue2(result2, key, value);
      });
      function map(collection, iteratee2) {
        var func = isArray2(collection) ? arrayMap2 : baseMap;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray2(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray2(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function(result2, value, key) {
        result2[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter2 : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray2(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n4, guard) {
        if (guard ? isIterateeCall(collection, n4, guard) : n4 === undefined$1) {
          n4 = 1;
        } else {
          n4 = toInteger2(n4);
        }
        var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n4);
      }
      function shuffle(collection) {
        var func = isArray2(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike2(collection)) {
          return isString2(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag2(collection);
        if (tag == mapTag2 || tag == setTag2) {
          return collection.size;
        }
        return baseKeys2(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray2(collection) ? arraySome2 : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now = ctxNow || function() {
        return root2.Date.now();
      };
      function after(n4, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n4 = toInteger2(n4);
        return function() {
          if (--n4 < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n4, guard) {
        n4 = guard ? undefined$1 : n4;
        n4 = func && n4 == null ? func.length : n4;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n4);
      }
      function before(n4, func) {
        var result2;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n4 = toInteger2(n4);
        return function() {
          if (--n4 > 0) {
            result2 = func.apply(this, arguments);
          }
          if (n4 <= 1) {
            func = undefined$1;
          }
          return result2;
        };
      }
      var bind = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function(object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curry.placeholder;
        return result2;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curryRight.placeholder;
        return result2;
      }
      function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        wait = toNumber2(wait) || 0;
        if (isObject2(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax(toNumber2(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result2 = func.apply(thisArg, args);
          return result2;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result2;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result2;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result2 : trailingEdge(now());
        }
        function debounced() {
          var time = now(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result2;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber2(wait) || 0, args);
      });
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result2 = func.apply(this, args);
          memoized.cache = cache.set(key, result2) || cache;
          return result2;
        };
        memoized.cache = new (memoize.Cache || MapCache2)();
        return memoized;
      }
      memoize.Cache = MapCache2;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap2(transforms[0], baseUnary2(getIteratee())) : arrayMap2(baseFlatten(transforms, 1), baseUnary2(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index2 = -1, length = nativeMin(args.length, funcsLength);
          while (++index2 < length) {
            args[index2] = transforms[index2].call(this, args[index2]);
          }
          return apply2(func, this, args);
        });
      });
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start === undefined$1 ? start : toInteger2(start);
        return baseRest(func, start);
      }
      function spread(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start == null ? 0 : nativeMax(toInteger2(start), 0);
        return baseRest(function(args) {
          var array = args[start], otherArgs = castSlice(args, 0, start);
          if (array) {
            arrayPush2(otherArgs, array);
          }
          return apply2(func, this, otherArgs);
        });
      }
      function throttle(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        if (isObject2(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray2() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray2(value) ? value : [value];
      }
      function clone2(value) {
        return baseClone2(value, CLONE_SYMBOLS_FLAG2);
      }
      function cloneWith2(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone2(value, CLONE_SYMBOLS_FLAG2, customizer);
      }
      function cloneDeep2(value) {
        return baseClone2(value, CLONE_DEEP_FLAG2 | CLONE_SYMBOLS_FLAG2);
      }
      function cloneDeepWith2(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone2(value, CLONE_DEEP_FLAG2 | CLONE_SYMBOLS_FLAG2, customizer);
      }
      function conformsTo2(object, source) {
        return source == null || baseConformsTo2(object, source, keys2(source));
      }
      function eq2(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt2 = createRelationalOperation2(baseGt2);
      var gte2 = createRelationalOperation2(function(value, other) {
        return value >= other;
      });
      var isArguments2 = baseIsArguments2(/* @__PURE__ */ function() {
        return arguments;
      }()) ? baseIsArguments2 : function(value) {
        return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
      };
      var isArray2 = Array2.isArray;
      var isArrayBuffer2 = nodeIsArrayBuffer2 ? baseUnary2(nodeIsArrayBuffer2) : baseIsArrayBuffer2;
      function isArrayLike2(value) {
        return value != null && isLength2(value.length) && !isFunction2(value);
      }
      function isArrayLikeObject2(value) {
        return isObjectLike2(value) && isArrayLike2(value);
      }
      function isBoolean2(value) {
        return value === true || value === false || isObjectLike2(value) && baseGetTag2(value) == boolTag2;
      }
      var isBuffer2 = nativeIsBuffer || stubFalse2;
      var isDate2 = nodeIsDate2 ? baseUnary2(nodeIsDate2) : baseIsDate2;
      function isElement2(value) {
        return isObjectLike2(value) && value.nodeType === 1 && !isPlainObject2(value);
      }
      function isEmpty2(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike2(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer2(value) || isTypedArray2(value) || isArguments2(value))) {
          return !value.length;
        }
        var tag = getTag2(value);
        if (tag == mapTag2 || tag == setTag2) {
          return !value.size;
        }
        if (isPrototype2(value)) {
          return !baseKeys2(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty2.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual2(value, other) {
        return baseIsEqual2(value, other);
      }
      function isEqualWith2(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result2 = customizer ? customizer(value, other) : undefined$1;
        return result2 === undefined$1 ? baseIsEqual2(value, other, undefined$1, customizer) : !!result2;
      }
      function isError2(value) {
        if (!isObjectLike2(value)) {
          return false;
        }
        var tag = baseGetTag2(value);
        return tag == errorTag2 || tag == domExcTag2 || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject2(value);
      }
      function isFinite2(value) {
        return typeof value == "number" && nativeIsFinite2(value);
      }
      function isFunction2(value) {
        if (!isObject2(value)) {
          return false;
        }
        var tag = baseGetTag2(value);
        return tag == funcTag2 || tag == genTag2 || tag == asyncTag2 || tag == proxyTag2;
      }
      function isInteger2(value) {
        return typeof value == "number" && value == toInteger2(value);
      }
      function isLength2(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
      }
      function isObject2(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike2(value) {
        return value != null && typeof value == "object";
      }
      var isMap2 = nodeIsMap2 ? baseUnary2(nodeIsMap2) : baseIsMap2;
      function isMatch2(object, source) {
        return object === source || baseIsMatch2(object, source, getMatchData2(source));
      }
      function isMatchWith2(object, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch2(object, source, getMatchData2(source), customizer);
      }
      function isNaN2(value) {
        return isNumber2(value) && value != +value;
      }
      function isNative2(value) {
        if (isMaskable2(value)) {
          throw new Error2(CORE_ERROR_TEXT2);
        }
        return baseIsNative2(value);
      }
      function isNull2(value) {
        return value === null;
      }
      function isNil2(value) {
        return value == null;
      }
      function isNumber2(value) {
        return typeof value == "number" || isObjectLike2(value) && baseGetTag2(value) == numberTag2;
      }
      function isPlainObject2(value) {
        if (!isObjectLike2(value) || baseGetTag2(value) != objectTag2) {
          return false;
        }
        var proto = getPrototype2(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString2.call(Ctor) == objectCtorString2;
      }
      var isRegExp2 = nodeIsRegExp2 ? baseUnary2(nodeIsRegExp2) : baseIsRegExp2;
      function isSafeInteger2(value) {
        return isInteger2(value) && value >= -MAX_SAFE_INTEGER2 && value <= MAX_SAFE_INTEGER2;
      }
      var isSet2 = nodeIsSet2 ? baseUnary2(nodeIsSet2) : baseIsSet2;
      function isString2(value) {
        return typeof value == "string" || !isArray2(value) && isObjectLike2(value) && baseGetTag2(value) == stringTag2;
      }
      function isSymbol2(value) {
        return typeof value == "symbol" || isObjectLike2(value) && baseGetTag2(value) == symbolTag2;
      }
      var isTypedArray2 = nodeIsTypedArray2 ? baseUnary2(nodeIsTypedArray2) : baseIsTypedArray2;
      function isUndefined2(value) {
        return value === undefined$1;
      }
      function isWeakMap2(value) {
        return isObjectLike2(value) && getTag2(value) == weakMapTag2;
      }
      function isWeakSet2(value) {
        return isObjectLike2(value) && baseGetTag2(value) == weakSetTag2;
      }
      var lt2 = createRelationalOperation2(baseLt2);
      var lte2 = createRelationalOperation2(function(value, other) {
        return value <= other;
      });
      function toArray2(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike2(value)) {
          return isString2(value) ? stringToArray2(value) : copyArray2(value);
        }
        if (symIterator2 && value[symIterator2]) {
          return iteratorToArray2(value[symIterator2]());
        }
        var tag = getTag2(value), func = tag == mapTag2 ? mapToArray2 : tag == setTag2 ? setToArray2 : values2;
        return func(value);
      }
      function toFinite2(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber2(value);
        if (value === INFINITY2 || value === -INFINITY2) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER2;
        }
        return value === value ? value : 0;
      }
      function toInteger2(value) {
        var result2 = toFinite2(value), remainder = result2 % 1;
        return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
      }
      function toLength2(value) {
        return value ? baseClamp2(toInteger2(value), 0, MAX_ARRAY_LENGTH2) : 0;
      }
      function toNumber2(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN2;
        }
        if (isObject2(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject2(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim2(value);
        var isBinary = reIsBinary2.test(value);
        return isBinary || reIsOctal2.test(value) ? freeParseInt2(value.slice(2), isBinary ? 2 : 8) : reIsBadHex2.test(value) ? NAN2 : +value;
      }
      function toPlainObject2(value) {
        return copyObject2(value, keysIn2(value));
      }
      function toSafeInteger2(value) {
        return value ? baseClamp2(toInteger2(value), -MAX_SAFE_INTEGER2, MAX_SAFE_INTEGER2) : value === 0 ? value : 0;
      }
      function toString2(value) {
        return value == null ? "" : baseToString2(value);
      }
      var assign = createAssigner(function(object, source) {
        if (isPrototype2(source) || isArrayLike2(source)) {
          copyObject2(source, keys2(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty2.call(source, key)) {
            assignValue2(object, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner(function(object, source) {
        copyObject2(source, keysIn2(source), object);
      });
      var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject2(source, keysIn2(source), object, customizer);
      });
      var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject2(source, keys2(source), object, customizer);
      });
      var at2 = flatRest(baseAt);
      function create2(prototype, properties) {
        var result2 = baseCreate2(prototype);
        return properties == null ? result2 : baseAssign2(result2, properties);
      }
      var defaults = baseRest(function(object, sources) {
        object = Object2(object);
        var index2 = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }
        while (++index2 < length) {
          var source = sources[index2];
          var props = keysIn2(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined$1 || eq2(value, objectProto2[key]) && !hasOwnProperty2.call(object, key)) {
              object[key] = source[key];
            }
          }
        }
        return object;
      });
      var defaultsDeep = baseRest(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply2(mergeWith, undefined$1, args);
      });
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object, iteratee2) {
        return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn2);
      }
      function forInRight(object, iteratee2) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn2);
      }
      function forOwn(object, iteratee2) {
        return object && baseForOwn(object, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object, iteratee2) {
        return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
      }
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys2(object));
      }
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn2(object));
      }
      function get(object, path, defaultValue) {
        var result2 = object == null ? undefined$1 : baseGet(object, path);
        return result2 === undefined$1 ? defaultValue : result2;
      }
      function has2(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }
      var invert = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString2.call(value);
        }
        result2[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString2.call(value);
        }
        if (hasOwnProperty2.call(result2, value)) {
          result2[value].push(key);
        } else {
          result2[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys2(object) {
        return isArrayLike2(object) ? arrayLikeKeys2(object) : baseKeys2(object);
      }
      function keysIn2(object) {
        return isArrayLike2(object) ? arrayLikeKeys2(object, true) : baseKeysIn2(object);
      }
      function mapKeys(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue2(result2, iteratee2(value, key, object2), value);
        });
        return result2;
      }
      function mapValues(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue2(result2, key, iteratee2(value, key, object2));
        });
        return result2;
      }
      var merge = createAssigner(function(object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });
      var omit = flatRest(function(object, paths) {
        var result2 = {};
        if (object == null) {
          return result2;
        }
        var isDeep = false;
        paths = arrayMap2(paths, function(path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject2(object, getAllKeysIn2(object), result2);
        if (isDeep) {
          result2 = baseClone2(result2, CLONE_DEEP_FLAG2 | CLONE_FLAT_FLAG2 | CLONE_SYMBOLS_FLAG2, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result2, paths[length]);
        }
        return result2;
      });
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function(object, paths) {
        return object == null ? {} : basePick(object, paths);
      });
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap2(getAllKeysIn2(object), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function(value, path) {
          return predicate(value, path[0]);
        });
      }
      function result(object, path, defaultValue) {
        path = castPath(path, object);
        var index2 = -1, length = path.length;
        if (!length) {
          length = 1;
          object = undefined$1;
        }
        while (++index2 < length) {
          var value = object == null ? undefined$1 : object[toKey(path[index2])];
          if (value === undefined$1) {
            index2 = length;
            value = defaultValue;
          }
          object = isFunction2(value) ? value.call(object) : value;
        }
        return object;
      }
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value, customizer);
      }
      var toPairs = createToPairs(keys2);
      var toPairsIn = createToPairs(keysIn2);
      function transform(object, iteratee2, accumulator) {
        var isArr = isArray2(object), isArrLike = isArr || isBuffer2(object) || isTypedArray2(object);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject2(object)) {
            accumulator = isFunction2(Ctor) ? baseCreate2(getPrototype2(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach2 : baseForOwn)(object, function(value, index2, object2) {
          return iteratee2(accumulator, value, index2, object2);
        });
        return accumulator;
      }
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }
      function update(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }
      function values2(object) {
        return object == null ? [] : baseValues2(object, keys2(object));
      }
      function valuesIn(object) {
        return object == null ? [] : baseValues2(object, keysIn2(object));
      }
      function clamp(number, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber2(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber2(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp2(toNumber2(number), lower, upper);
      }
      function inRange(number, start, end) {
        start = toFinite2(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite2(end);
        }
        number = toNumber2(number);
        return baseInRange(number, start, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite2(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite2(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function(result2, word, index2) {
        word = word.toLowerCase();
        return result2 + (index2 ? capitalize(word) : word);
      });
      function capitalize(string) {
        return upperFirst(toString2(string).toLowerCase());
      }
      function deburr(string) {
        string = toString2(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      function endsWith(string, target, position) {
        string = toString2(string);
        target = baseToString2(target);
        var length = string.length;
        position = position === undefined$1 ? length : baseClamp2(toInteger2(position), 0, length);
        var end = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end) == target;
      }
      function escape(string) {
        string = toString2(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }
      function escapeRegExp(string) {
        string = toString2(string);
        return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar2, "\\$&") : string;
      }
      var kebabCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string, length, chars) {
        string = toString2(string);
        length = toInteger2(length);
        var strLength = length ? stringSize(string) : 0;
        if (!length || strLength >= length) {
          return string;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string, length, chars) {
        string = toString2(string);
        length = toInteger2(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
      }
      function padStart(string, length, chars) {
        string = toString2(string);
        length = toInteger2(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
      }
      function parseInt2(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString2(string).replace(reTrimStart2, ""), radix || 0);
      }
      function repeat(string, n4, guard) {
        if (guard ? isIterateeCall(string, n4, guard) : n4 === undefined$1) {
          n4 = 1;
        } else {
          n4 = toInteger2(n4);
        }
        return baseRepeat(toString2(string), n4);
      }
      function replace() {
        var args = arguments, string = toString2(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "_" : "") + word.toLowerCase();
      });
      function split(string, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH2 : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString2(string);
        if (string && (typeof separator == "string" || separator != null && !isRegExp2(separator))) {
          separator = baseToString2(separator);
          if (!separator && hasUnicode2(string)) {
            return castSlice(stringToArray2(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }
      var startCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + upperFirst(word);
      });
      function startsWith(string, target, position) {
        string = toString2(string);
        position = position == null ? 0 : baseClamp2(toInteger2(position), 0, string.length);
        target = baseToString2(target);
        return string.slice(position, position + target.length) == target;
      }
      function template(string, options, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }
        string = toString2(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys2(imports), importsValues = baseValues2(imports, importsKeys);
        var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
        var reDelimiters = RegExp2(
          (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
          "g"
        );
        var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string.slice(index2, offset).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index2 = offset + match.length;
          return match;
        });
        source += "';\n";
        var variable = hasOwnProperty2.call(options, "variable") && options.variable;
        if (!variable) {
          source = "with (obj) {\n" + source + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
        var result2 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
        });
        result2.source = source;
        if (isError2(result2)) {
          throw result2;
        }
        return result2;
      }
      function toLower(value) {
        return toString2(value).toLowerCase();
      }
      function toUpper(value) {
        return toString2(value).toUpperCase();
      }
      function trim(string, chars, guard) {
        string = toString2(string);
        if (string && (guard || chars === undefined$1)) {
          return baseTrim2(string);
        }
        if (!string || !(chars = baseToString2(chars))) {
          return string;
        }
        var strSymbols = stringToArray2(string), chrSymbols = stringToArray2(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join("");
      }
      function trimEnd(string, chars, guard) {
        string = toString2(string);
        if (string && (guard || chars === undefined$1)) {
          return string.slice(0, trimmedEndIndex2(string) + 1);
        }
        if (!string || !(chars = baseToString2(chars))) {
          return string;
        }
        var strSymbols = stringToArray2(string), end = charsEndIndex(strSymbols, stringToArray2(chars)) + 1;
        return castSlice(strSymbols, 0, end).join("");
      }
      function trimStart(string, chars, guard) {
        string = toString2(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart2, "");
        }
        if (!string || !(chars = baseToString2(chars))) {
          return string;
        }
        var strSymbols = stringToArray2(string), start = charsStartIndex(strSymbols, stringToArray2(chars));
        return castSlice(strSymbols, start).join("");
      }
      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject2(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length = "length" in options ? toInteger2(options.length) : length;
          omission = "omission" in options ? baseToString2(options.omission) : omission;
        }
        string = toString2(string);
        var strLength = string.length;
        if (hasUnicode2(string)) {
          var strSymbols = stringToArray2(string);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
        if (separator === undefined$1) {
          return result2 + omission;
        }
        if (strSymbols) {
          end += result2.length - end;
        }
        if (isRegExp2(separator)) {
          if (string.slice(end).search(separator)) {
            var match, substring = result2;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString2(reFlags2.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match = separator.exec(substring)) {
              var newEnd = match.index;
            }
            result2 = result2.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string.indexOf(baseToString2(separator), end) != end) {
          var index2 = result2.lastIndexOf(separator);
          if (index2 > -1) {
            result2 = result2.slice(0, index2);
          }
        }
        return result2 + omission;
      }
      function unescape2(string) {
        string = toString2(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }
      var upperCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words(string, pattern, guard) {
        string = toString2(string);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }
      var attempt = baseRest(function(func, args) {
        try {
          return apply2(func, undefined$1, args);
        } catch (e5) {
          return isError2(e5) ? e5 : new Error2(e5);
        }
      });
      var bindAll = flatRest(function(object, methodNames) {
        arrayEach2(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue2(object, key, bind(object[key], object));
        });
        return object;
      });
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap2(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function(args) {
          var index2 = -1;
          while (++index2 < length) {
            var pair = pairs[index2];
            if (apply2(pair[0], this, args)) {
              return apply2(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone2(source, CLONE_DEEP_FLAG2));
      }
      function constant(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == "function" ? func : baseClone2(func, CLONE_DEEP_FLAG2));
      }
      function matches(source) {
        return baseMatches(baseClone2(source, CLONE_DEEP_FLAG2));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone2(srcValue, CLONE_DEEP_FLAG2));
      }
      var method = baseRest(function(path, args) {
        return function(object) {
          return baseInvoke(object, path, args);
        };
      });
      var methodOf = baseRest(function(object, args) {
        return function(path) {
          return baseInvoke(object, path, args);
        };
      });
      function mixin(object, source, options) {
        var props = keys2(source), methodNames = baseFunctions(source, props);
        if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys2(source));
        }
        var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction2(object);
        arrayEach2(methodNames, function(methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result2 = object(this.__wrapped__), actions2 = result2.__actions__ = copyArray2(this.__actions__);
                actions2.push({ "func": func, "args": arguments, "thisArg": object });
                result2.__chain__ = chainAll;
                return result2;
              }
              return func.apply(object, arrayPush2([this.value()], arguments));
            };
          }
        });
        return object;
      }
      function noConflict() {
        if (root2._ === this) {
          root2._ = oldDash;
        }
        return this;
      }
      function noop() {
      }
      function nthArg(n4) {
        n4 = toInteger2(n4);
        return baseRest(function(args) {
          return baseNth(args, n4);
        });
      }
      var over = createOver(arrayMap2);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome2);
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      function propertyOf(object) {
        return function(path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray2() {
        return [];
      }
      function stubFalse2() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n4, iteratee2) {
        n4 = toInteger2(n4);
        if (n4 < 1 || n4 > MAX_SAFE_INTEGER2) {
          return [];
        }
        var index2 = MAX_ARRAY_LENGTH2, length = nativeMin(n4, MAX_ARRAY_LENGTH2);
        iteratee2 = getIteratee(iteratee2);
        n4 -= MAX_ARRAY_LENGTH2;
        var result2 = baseTimes2(length, iteratee2);
        while (++index2 < n4) {
          iteratee2(index2);
        }
        return result2;
      }
      function toPath(value) {
        if (isArray2(value)) {
          return arrayMap2(value, toKey);
        }
        return isSymbol2(value) ? [value] : copyArray2(stringToPath(toString2(value)));
      }
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString2(prefix) + id;
      }
      var add = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt2) : undefined$1;
      }
      function maxBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt2) : undefined$1;
      }
      function mean(array) {
        return baseMean(array, identity);
      }
      function meanBy(array, iteratee2) {
        return baseMean(array, getIteratee(iteratee2, 2));
      }
      function min(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt2) : undefined$1;
      }
      function minBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt2) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round = createRound("round");
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }
      function sumBy(array, iteratee2) {
        return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at2;
      lodash2.before = before;
      lodash2.bind = bind;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray2;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant;
      lodash2.countBy = countBy;
      lodash2.create = create2;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce;
      lodash2.defaults = defaults;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip;
      lodash2.flow = flow;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys2;
      lodash2.keysIn = keysIn2;
      lodash2.map = map;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues;
      lodash2.matches = matches;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize;
      lodash2.merge = merge;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick;
      lodash2.pickBy = pickBy;
      lodash2.property = property;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove;
      lodash2.rest = rest;
      lodash2.reverse = reverse;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split;
      lodash2.spread = spread;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle;
      lodash2.thru = thru;
      lodash2.toArray = toArray2;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject2;
      lodash2.transform = transform;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update;
      lodash2.updateWith = updateWith;
      lodash2.values = values2;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words;
      lodash2.wrap = wrap;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp;
      lodash2.clone = clone2;
      lodash2.cloneDeep = cloneDeep2;
      lodash2.cloneDeepWith = cloneDeepWith2;
      lodash2.cloneWith = cloneWith2;
      lodash2.conformsTo = conformsTo2;
      lodash2.deburr = deburr;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith;
      lodash2.eq = eq2;
      lodash2.escape = escape;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find;
      lodash2.findIndex = findIndex;
      lodash2.findKey = findKey;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get;
      lodash2.gt = gt2;
      lodash2.gte = gte2;
      lodash2.has = has2;
      lodash2.hasIn = hasIn;
      lodash2.head = head;
      lodash2.identity = identity;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments2;
      lodash2.isArray = isArray2;
      lodash2.isArrayBuffer = isArrayBuffer2;
      lodash2.isArrayLike = isArrayLike2;
      lodash2.isArrayLikeObject = isArrayLikeObject2;
      lodash2.isBoolean = isBoolean2;
      lodash2.isBuffer = isBuffer2;
      lodash2.isDate = isDate2;
      lodash2.isElement = isElement2;
      lodash2.isEmpty = isEmpty2;
      lodash2.isEqual = isEqual2;
      lodash2.isEqualWith = isEqualWith2;
      lodash2.isError = isError2;
      lodash2.isFinite = isFinite2;
      lodash2.isFunction = isFunction2;
      lodash2.isInteger = isInteger2;
      lodash2.isLength = isLength2;
      lodash2.isMap = isMap2;
      lodash2.isMatch = isMatch2;
      lodash2.isMatchWith = isMatchWith2;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative2;
      lodash2.isNil = isNil2;
      lodash2.isNull = isNull2;
      lodash2.isNumber = isNumber2;
      lodash2.isObject = isObject2;
      lodash2.isObjectLike = isObjectLike2;
      lodash2.isPlainObject = isPlainObject2;
      lodash2.isRegExp = isRegExp2;
      lodash2.isSafeInteger = isSafeInteger2;
      lodash2.isSet = isSet2;
      lodash2.isString = isString2;
      lodash2.isSymbol = isSymbol2;
      lodash2.isTypedArray = isTypedArray2;
      lodash2.isUndefined = isUndefined2;
      lodash2.isWeakMap = isWeakMap2;
      lodash2.isWeakSet = isWeakSet2;
      lodash2.join = join;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt2;
      lodash2.lte = lte2;
      lodash2.max = max;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray2;
      lodash2.stubFalse = stubFalse2;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop;
      lodash2.now = now;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat;
      lodash2.replace = replace;
      lodash2.result = result;
      lodash2.round = round;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite2;
      lodash2.toInteger = toInteger2;
      lodash2.toLength = toLength2;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber2;
      lodash2.toSafeInteger = toSafeInteger2;
      lodash2.toString = toString2;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape2;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source = {};
        baseForOwn(lodash2, function(func, methodName) {
          if (!hasOwnProperty2.call(lodash2.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), { "chain": false });
      lodash2.VERSION = VERSION;
      arrayEach2(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach2(["drop", "take"], function(methodName, index2) {
        LazyWrapper.prototype[methodName] = function(n4) {
          n4 = n4 === undefined$1 ? 1 : nativeMax(toInteger2(n4), 0);
          var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
          if (result2.__filtered__) {
            result2.__takeCount__ = nativeMin(n4, result2.__takeCount__);
          } else {
            result2.__views__.push({
              "size": nativeMin(n4, MAX_ARRAY_LENGTH2),
              "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
            });
          }
          return result2;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n4) {
          return this.reverse()[methodName](n4).reverse();
        };
      });
      arrayEach2(["filter", "map", "takeWhile"], function(methodName, index2) {
        var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result2 = this.clone();
          result2.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result2.__filtered__ = result2.__filtered__ || isFilter;
          return result2;
        };
      });
      arrayEach2(["head", "last"], function(methodName, index2) {
        var takeName = "take" + (index2 ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach2(["initial", "tail"], function(methodName, index2) {
        var dropName = "drop" + (index2 ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start, end) {
        start = toInteger2(start);
        var result2 = this;
        if (result2.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result2);
        }
        if (start < 0) {
          result2 = result2.takeRight(-start);
        } else if (start) {
          result2 = result2.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger2(end);
          result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
        }
        return result2;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH2);
      };
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value);
          var interceptor = function(value2) {
            var result3 = lodashFunc.apply(lodash2, arrayPush2([value2], args));
            return isTaker && chainAll ? result3[0] : result3;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result2 = func.apply(value, args);
            result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result2, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result2 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
        };
      });
      arrayEach2(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto2[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray2(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func.apply(isArray2(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty2.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator2) {
        lodash2.prototype[symIterator2] = wrapperToIterator;
      }
      return lodash2;
    };
    var _2 = runInContext();
    if (freeModule) {
      (freeModule.exports = _2)._ = _2;
      freeExports._ = _2;
    } else {
      root2._ = _2;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var lodashExports = lodash.exports;
const MUTUAL_FUND = "MUTUAL_FUND";
const BROKERAGE = "BROKERAGE";
const MARYLAND_529 = "MARYLAND_529";
const TRAC_PLAN = "TRAC_PLAN";
const OMNI_PLAN = "OMNI_PLAN";
const ALASKA_529 = "ALASKA_529";
const NATIONAL_529 = "NATIONAL_529";
const ACTIVE_PLUS = "ACTIVE_PLUS";
const RETIREMENT_ADVISORY = "RETIREMENT_ADVISORY";
const RETAIL = "RETAIL";
const PRODUCTS = {
  [MUTUAL_FUND]: 10,
  [BROKERAGE]: 20,
  [MARYLAND_529]: 40,
  [TRAC_PLAN]: 50,
  [OMNI_PLAN]: 60,
  [ALASKA_529]: 70,
  [NATIONAL_529]: 80,
  [ACTIVE_PLUS]: 110,
  [RETIREMENT_ADVISORY]: 120
};
const PRODUCT_CLASS = {
  [RETAIL]: RETAIL,
  [ALASKA_529]: ALASKA_529,
  [NATIONAL_529]: NATIONAL_529,
  [MARYLAND_529]: MARYLAND_529
};
const MD_CLASS = "md529";
const AK_CLASS = "alaska529";
const NAT_CLASS = "na529";
const RETAIL_CLASS = "retail";
const RETAIL_CLASS_WITH_ACTIVE_PLUS = "retailwApp";
const RETAIL_CLASS_WITH_BROKERAGE = "retailwBrk";
const getProductClass = (productClass) => {
  return productClass === MARYLAND_529 ? MD_CLASS : productClass === NATIONAL_529 ? NAT_CLASS : productClass === ALASKA_529 ? AK_CLASS : productClass === RETAIL ? RETAIL_CLASS : productClass === ACTIVE_PLUS ? RETAIL_CLASS_WITH_ACTIVE_PLUS : RETAIL_CLASS_WITH_BROKERAGE;
};
const BROKERAGE_ADVANTAGE_SERVICE_ID = 62;
const collegeSavingsProducts = [
  PRODUCTS.ALASKA_529,
  PRODUCTS.MARYLAND_529,
  PRODUCTS.NATIONAL_529
];
const workplaceProducts = [
  PRODUCTS.OMNI_PLAN,
  PRODUCTS.TRAC_PLAN
];
const retailProducts = [
  PRODUCTS.MUTUAL_FUND,
  PRODUCTS.BROKERAGE,
  PRODUCTS.ACTIVE_PLUS,
  PRODUCTS.RETIREMENT_ADVISORY,
  ...collegeSavingsProducts
];
const bankRetailProducts = [
  PRODUCTS.MUTUAL_FUND,
  PRODUCTS.ACTIVE_PLUS,
  PRODUCTS.RETIREMENT_ADVISORY,
  ...collegeSavingsProducts
];
const URLS = {
  LOGOUT: "https://www.troweprice.com/usis/login/logout",
  POSTLOGOUT: "https://www.troweprice.com/usis/my-accounts/post-logout",
  IDENTITY: "https://www.api.public/my-accounts/api/my-accounts/identity"
};
const ONE_MINUTE_IN_MS = 6e4;
const canViewContactInformation = (accounts) => {
  const products = accounts && accounts.length ? getProducts(accounts) : [];
  return products && products.length ? products.some((p2) => retailProducts.includes(p2)) : false;
};
const canViewTrustedContacts = (accounts) => {
  const products = accounts && accounts.length ? getProducts(accounts) : [];
  const hasRpsAnd529Only = products.every((p2) => collegeSavingsProducts.includes(p2) || workplaceProducts.includes(p2));
  return products && products.length ? !collegeSavingsOnly(products) && !workplaceOnly(products) && !hasRpsAnd529Only : false;
};
const canViewPortfolioOptimizerLink = (accounts) => {
  const products = accounts && accounts.length ? getProducts(accounts) : [];
  return products && products.length ? !collegeSavingsOnly(products) : false;
};
const canViewPaperlessPreferences = (accounts) => {
  const products = accounts && accounts.length ? getProducts(accounts) : [];
  return products && products.length ? !workplaceOnly(products) : false;
};
const canViewFinancialPreferences = (accounts) => {
  const products = accounts && accounts.length ? getProducts(accounts) : [];
  return products && products.length ? !workplaceOnly(products) : false;
};
const canViewBeneficiaries = (accounts) => {
  const products = accounts && accounts.length ? getProducts(accounts) : [];
  const hasRpsAnd529Only = products.every((p2) => collegeSavingsProducts.includes(p2) || workplaceProducts.includes(p2));
  return products && products.length ? !collegeSavingsOnly(products) && !workplaceOnly(products) && !hasRpsAnd529Only : false;
};
const canViewBanking = (accounts) => {
  const products = accounts && accounts.length ? getProducts(accounts) : [];
  return products && products.length ? products.some((p2) => bankRetailProducts.includes(p2)) : false;
};
const canViewAccountRegistration = (accounts) => {
  const products = accounts && accounts.length ? getProducts(accounts) : [];
  return products && products.length ? !collegeSavingsOnly(products) && !workplaceOnly(products) : false;
};
const canViewAutomaticTransactions = (accounts) => {
  return accounts && accounts.length ? !hasAllEntries(accounts, "productType", PRODUCTS.ACTIVE_PLUS) && !brokerageAdvantageOnly(accounts) : false;
};
const canViewCostBasis = (accounts) => {
  const products = accounts && accounts.length ? getProducts(accounts) : [];
  return products && products.length ? accounts && !collegeSavingsOnly(products) && !brokerageAdvantageOnly(accounts) && !hasAllEntries(accounts, "productType", PRODUCTS.ACTIVE_PLUS) && !hasAllEntries(accounts, "retirementAccount") && !hasAllEntries(accounts, "accountTypeId", 9) && !hasAllEntries(accounts, "moneyMarket") : false;
};
const canViewDivCap = (accounts) => {
  const products = accounts && accounts.length ? getProducts(accounts) : [];
  return products && products.length ? products.some((p2) => p2 === PRODUCTS.MUTUAL_FUND || p2 === PRODUCTS.BROKERAGE) : false;
};
const canViewGrantViewAccess = (accounts) => {
  const products = accounts && accounts.length ? getProducts(accounts) : [];
  return accounts && accounts.length ? !workplaceOnly(products) && !hasAllEntries(accounts, "productType", PRODUCTS.RETIREMENT_ADVISORY) : false;
};
const canViewAlertsAndNotifications = (accounts) => {
  const products = accounts && accounts.length ? getProducts(accounts) : [];
  return products && products.length ? !collegeSavingsOnly(products) && !workplaceOnly(products) : false;
};
const canViewDocumentDelivery = (accounts) => {
  return accounts && accounts.length ? !hasAllEntries(accounts, "isViewOnly") : false;
};
const canViewSubscriptions = (accounts) => {
  return accounts && accounts.length ? hasAllEntries(accounts, "productType", PRODUCTS.TRAC_PLAN) || !hasAllEntries(accounts, "isViewOnly") : false;
};
const hasEntry = (obj, prop, value) => {
  return value && prop ? obj[prop] === value : prop ? obj[prop] : false;
};
const hasAllEntries = (array, prop, value) => {
  return array && array.length ? array.every((obj) => hasEntry(obj, prop, value)) : false;
};
const collegeSavingsOnly = (products) => {
  return products.every((p2) => collegeSavingsProducts.includes(p2));
};
const workplaceOnly = (products) => {
  return products.every((p2) => workplaceProducts.includes(p2));
};
const brokerageAdvantageOnly = (accounts) => {
  return accounts.every((a2) => a2.serviceIds && a2.serviceIds.every((serviceId) => serviceId === BROKERAGE_ADVANTAGE_SERVICE_ID));
};
const TRP_ENVIRONMENTS = {
  SANDBOX: "SANDBOX",
  DEVELOPMENT: "DEV",
  STAGING: "STAGE",
  PRODUCTION: "PROD"
};
const environmentByOrigin = (origin) => {
  switch (true) {
    case /localhost/i.test(origin):
      return TRP_ENVIRONMENTS.SANDBOX;
    case /www3dev|dev|www4dev/i.test(origin):
      return TRP_ENVIRONMENTS.DEVELOPMENT;
    case /www3qual|stage|www4qual/i.test(origin):
      return TRP_ENVIRONMENTS.STAGING;
    default:
      return TRP_ENVIRONMENTS.PRODUCTION;
  }
};
const isInternalByOrigin = (origin) => origin.indexOf(".awstrp.net") !== -1;
const isDevelopmentEnvironment = (env) => env === TRP_ENVIRONMENTS.DEVELOPMENT || env === TRP_ENVIRONMENTS.SANDBOX;
const isStagingEnvironment = (env) => env === TRP_ENVIRONMENTS.STAGING;
const isLowerEnvironment = () => {
  const env = environmentByOrigin(getOrigin());
  return isStagingEnvironment(env) || isDevelopmentEnvironment(env);
};
const replaceLink = (link, updatedDomain) => {
  if (!(typeof link === "string")) {
    throw new Error("Must pass a string");
  }
  return link.replace(/www.troweprice.com|troweprice.com/g, updatedDomain);
};
const rewriteOriginByEnvironment = (origin, link, router = false) => {
  const linkOrigin = new URL(link).origin;
  const linkPath = link.split(linkOrigin).pop();
  if (router) {
    return `${origin}${linkPath}`;
  }
  const env = environmentByOrigin(origin);
  const isInternal = isInternalByOrigin(origin);
  switch (true) {
    case /www3/i.test(linkOrigin):
      if (isDevelopmentEnvironment(env)) {
        return typeof link == "string" && link.replace(/www3/g, "www3dev");
      }
      if (isStagingEnvironment(env)) {
        return typeof link == "string" && link.replace(/www3/g, "www3qual");
      }
      return link;
    case /www.troweprice|troweprice.com/i.test(linkOrigin):
      if (isDevelopmentEnvironment(env) && isInternal) {
        return replaceLink(link, "wwwdev.awstrp.net");
      }
      if (isDevelopmentEnvironment(env) && !isInternal) {
        return replaceLink(link, "wwwdev.troweprice.com");
      }
      if (isStagingEnvironment(env) && !isInternal) {
        return replaceLink(link, "wwwstage.troweprice.com");
      }
      if (isStagingEnvironment(env) && isInternal) {
        return replaceLink(link, "wwwstage.awstrp.net");
      }
      if (isInternal) {
        return replaceLink(link, "www.awstrp.net");
      }
      return link;
    case /www4/i.test(linkOrigin):
      if (isDevelopmentEnvironment(env)) {
        return typeof link == "string" && link.replace(/www4/g, "www4dev");
      }
      if (isStagingEnvironment(env)) {
        return typeof link == "string" && link.replace(/www4/g, "www4qual");
      }
      return link;
    default:
      return link;
  }
};
const rewriteApiOriginByEnvironment = (origin, link, router = false) => {
  const linkOrigin = new URL(link).origin;
  const linkPath = link.split(linkOrigin).pop();
  if (router) {
    return `${origin}${linkPath}`;
  }
  const env = environmentByOrigin(origin);
  const isInternal = isInternalByOrigin(origin);
  if (isDevelopmentEnvironment(env)) {
    const rewrite = typeof link == "string" && link.replace(/public/g, "dev");
    if (isInternal) {
      return rewrite.replace(/.troweprice.com/g, ".awstrp.net");
    }
    return rewrite;
  }
  if (isStagingEnvironment(env)) {
    const rewrite = typeof link == "string" && link.replace(/public/g, "confidence");
    if (isInternal) {
      return rewrite.replace(/.troweprice.com/g, ".awstrp.net");
    }
    return rewrite;
  }
  return link;
};
const getOrigin = () => {
  if (window && window.location && window.location.origin) {
    return window.location.origin;
  }
  if (document && document.location && document.location.origin) {
    return document.location.origin;
  }
  if (window && window.origin) {
    return window.origin;
  }
};
const trpEnvironmentAware = (link, router = false) => {
  const origin = getOrigin();
  return rewriteOriginByEnvironment(origin, link, router);
};
const trpApiEnvironmentAware = (link, router = false) => {
  const origin = getOrigin();
  return rewriteApiOriginByEnvironment(origin, link, router);
};
const getRelativePath = () => {
  if (!window && window.location) {
    return;
  }
  return window.location.pathname;
};
const getCurrentRoute = (url) => {
  return `/${url.split("/").pop()}`;
};
const urlMatch = (a2, b5) => {
  return a2 === b5;
};
const urlComparator = (url1, url2) => {
  const rel1 = getRelativePath();
  const rel2 = getRelativePath();
  return urlMatch(rel1, rel2);
};
const getURL = () => {
  if (window && window.document) {
    return window.document.URL;
  }
};
const getProducts = (accounts) => {
  if (!accounts) {
    return [];
  }
  const products = accounts.map((a2) => a2["product"] || a2["productType"]);
  return [...new Set(products)];
};
const aliasMapper = (raw) => {
  const DASHBOARD_ALIASES = {
    alias: "dashboard",
    synonyms: [
      "my-accounts",
      "/",
      "dashboard"
    ]
  };
  const ACTIVITY_ALIASES = {
    alias: "activity",
    synonyms: [
      "activity",
      "transactions"
    ]
  };
  const ALIAS_LIST = [
    ACTIVITY_ALIASES,
    DASHBOARD_ALIASES
  ];
  const alias = ALIAS_LIST.filter((rule) => {
    const { synonyms } = rule;
    return synonyms.some((s2) => s2 === raw);
  }).pop();
  return alias ? alias.alias : raw;
};
const getEntryPoint = () => {
  const relPath = getRelativePath();
  const regExp = new RegExp(/\//);
  let entryPoint = relPath.split(regExp).filter((a2) => a2.length).pop();
  return aliasMapper(entryPoint);
};
const getPathNameFromRouter = (providedRouter) => {
  if (providedRouter && providedRouter.location && providedRouter.location.pathname) {
    const relPath = providedRouter.location.pathname;
    const regExp = new RegExp(/\//);
    let entryPoint = relPath.split(regExp).filter((a2) => a2.length).pop();
    return aliasMapper(entryPoint);
  }
  return getEntryPoint();
};
const accountAccessUrlRegex = new RegExp("^https?://www(dev|stage)?.troweprice.com(?:/usis/my-accounts/|/usis/my-accounts-beta/version-1/).*");
const isAccountAccess = (url) => {
  return accountAccessUrlRegex.test(url);
};
const usd = (number) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  });
  return formatter.format(number);
};
function convertToMillis(timeInMinutes) {
  return timeInMinutes * ONE_MINUTE_IN_MS;
}
const hexToRGB = (hex) => {
  let result = /^#?([A-F\d]{2})([A-F\d]{2})([A-F\d]{2})$/i.exec(hex);
  const rgb = result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
  if (rgb) {
    return "rgb(" + rgb.r + "," + rgb.g + "," + rgb.b + ")";
  }
};
const generateHeaders = (url, apiKey, consumerId = "ii-component-library") => {
  const headers = {
    "apiKey": apiKey,
    "X-Trp-Requested-With": "my-accounts",
    "trp-request-consumer-initial": consumerId
  };
  if (url.indexOf("awstrp.net") !== -1) {
    headers["import-oauth"] = true;
  }
  return headers;
};
function updateDataState(value, newValue) {
  value = newValue;
  return value;
}
function useDataState(value) {
  return [value, updateDataState];
}
function useData(url, apiKey, consumerId = "ii-component-library", method, requestBody) {
  const [status, setStatus] = useDataState("idle");
  const [data, setData] = useDataState(null);
  const options = {
    credentials: "include",
    method
  };
  if (requestBody) {
    options.body = JSON.stringify(requestBody);
  }
  options.headers = generateHeaders(url, apiKey, consumerId);
  const fetchData = async () => {
    setStatus(status, "requested");
    try {
      const response = await fetch(url, options);
      const data2 = await response.json();
      setData(setData, data2);
      setStatus(status, "received");
    } catch (e5) {
      console.error(e5);
      setStatus(status, "error");
      setData(setData, null);
    }
  };
  fetchData();
  return {
    status,
    data
  };
}
const ADVISORY = "Advisory";
const GENERAL_INVESTMENTS = "General Investments";
const INDIVIDUAL_RETIREMENT = "Individual Retirement";
const EXTERNAL = "External";
const WORKPLACE = "Workplace";
const envPlaceholder = "ENV";
const domainPlaceholder = "DOMAIN";
const API_URL = `https://api.${envPlaceholder}.${domainPlaceholder}/port-alloc-svc/api/portfolio/allocation/selection`;
const standardGroups = {
  [ADVISORY]: ADVISORY,
  [GENERAL_INVESTMENTS]: GENERAL_INVESTMENTS,
  [INDIVIDUAL_RETIREMENT]: INDIVIDUAL_RETIREMENT,
  [WORKPLACE]: WORKPLACE,
  [EXTERNAL]: EXTERNAL
};
const getServiceUrl = (apiUrl = API_URL) => {
  const origin = getOrigin();
  const env = environmentByOrigin(origin);
  const isInternal = isInternalByOrigin(origin);
  const domain = isInternal ? "awstrp.net" : "troweprice.com";
  let apiEnv = "";
  if (isDevelopmentEnvironment(env)) {
    apiEnv = "dev";
  } else if (isStagingEnvironment(env)) {
    apiEnv = isInternal ? "stage" : "confidence";
  } else {
    apiEnv = isInternal ? "prod" : "public";
  }
  return apiUrl.replace(envPlaceholder, apiEnv).replace(domainPlaceholder, domain);
};
const createRequest = (url, apiKey, accountIds) => ({
  body: JSON.stringify({
    accounts: accountIds.map((accountId) => ({ accountId })),
    levels: [1, 3]
  }),
  credentials: "include",
  method: "POST",
  headers: {
    ...generateHeaders(url, apiKey),
    "Content-Type": "application/json"
  }
});
const Spinner = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "spinner", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", {})
  ] });
};
const DisclosureModal = ({ isModalOpen, setIsModalOpen }) => {
  const modalRef = useRef(null);
  useEffect(() => {
    var _a2;
    isModalOpen && ((_a2 = modalRef.current) == null ? void 0 : _a2.show());
  }, [isModalOpen]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    IIBeaconModal,
    {
      ref: modalRef,
      scale: "normal",
      id: "portfolio-disclosure-modal",
      onBeaconEventClose: () => setIsModalOpen(false),
      closeOnClickOut: true,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "b-typography-serif--headline--200 b-font-weight-bold", children: "Important Information" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "b-typography-sans-serif--body--200 b-font-weight-light", children: [
          "Your asset allocation only includes personal investing mutual fund accounts, brokerage accounts, ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "b-typography-sans-serif--body--200 b-font-weight-light no-wrap", children: "T. Rowe" }),
          " Price Retirement Advisory Service™ accounts, and ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "b-typography-sans-serif--body--200 b-font-weight-light no-wrap", children: "T. Rowe" }),
          " Price ActivePlus Portfolios® program accounts that are currently open and have a balance. Assets in workplace retirement accounts and external investment accounts are not included. To arrive at the allocation, we use Morningstar® data to determine the asset category of each holding and then translate the Morningstar® category into one or more sub-asset class categories.",
          /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
          "Mutual funds, ETFs, and other investment products are generally classified into asset classes based on their primary objective. When these investments consist of multiple asset classes, we may classify the fund by the percentage of holdings in each asset class. Cash includes money market investments (e.g., money market mutual funds), but not cash and cash equivalents (e.g., Certificates of Deposit). If an investment does not have a Morningstar® classification or if the classification does not correspond with one or more of the sub-asset classes, the holding may be “unclassified” and be placed in the “Other” category. Allocation calculations are based on the prior market day's closing price.",
          /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
          "Allocations are rounded to the nearest hundredth of a percent. As a result, the sum of the broad asset classes (e.g., Stock, Bonds) may not add up to 100%. Additionally, the sum of the sub-asset classes (e.g., Large-Cap Stock, International Stock) may not add up to the value of the associated broad asset class."
        ] })
      ]
    }
  );
};
const LAYOUT$1 = "column";
const sortByPercentage = (a2, b5) => {
  return b5[1] - a2[1];
};
const formatAllocationToChartDataSeries = (allocations) => {
  const series = allocations.map((securityData) => {
    var _a2;
    return [securityData.name, Number(((_a2 = securityData.percentage) == null ? void 0 : _a2.toFixed(2)) || 0)];
  });
  return series.sort(sortByPercentage);
};
const PortfolioAllocation = ({ customGroups = [], hideAccountTypeFilter = false, apiKey = "" }) => {
  const [
    allocations,
    accountTypeOptions,
    selectedGroupId,
    setSelectedGroupId,
    isError2,
    isLoading
  ] = usePortfolioAllocationData(customGroups, apiKey);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const allocationChartRef = useRef(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "allocation-container", children: [
    isError2 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "title-text b-typography-sans-serif--headline--300", children: " Asset Allocation" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "error-text", children: " We are having technical difficulties." })
    ] }),
    isLoading && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "title-text b-typography-sans-serif--headline--300", children: " Asset Allocation" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "spinner-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, {}) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "loading-text", children: "Gathering Data" })
    ] }),
    !isError2 && !isLoading && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "beacon-on-light", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "title", children: "Asset Allocation" }),
      !hideAccountTypeFilter && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "filter-container", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconControl, { className: "account-select-control", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("label", { slot: "label", htmlFor: "portfolio-allocation-dropdown", children: "Current Asset Allocation" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "select",
          {
            id: "portfolio-allocation-dropdown",
            value: selectedGroupId || "",
            onChange: ({ target: { value } }) => setSelectedGroupId(value),
            "data-testid": "dropdown",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "", disabled: true, children: "Select" }, "default"),
              accountTypeOptions.map((option, i5) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: option.value, children: option.label }, i5))
            ]
          }
        )
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "content", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        IIBeaconDonutChart,
        {
          series: [{
            data: formatAllocationToChartDataSeries(allocations)
          }],
          hideChartMetric: true,
          hideDataLabels: true,
          className: "asset-chart",
          "legend-layout": LAYOUT$1,
          options: {
            plotOptions: { item: { marker: { enabled: true, symbol: "circle" } } },
            exporting: {
              enabled: false
            },
            legend: {
              enabled: true
              // labelFormatter: function () {
              //   console.log('this', this);
              //   return this.name + ': ' + '<b>'+this.y+'%' + '</b>';
              // },
            },
            tooltip: {
              enabled: true
              // format: '{point.name}: <b>{point.y}%</b>'
            }
          },
          percentage: true,
          decimal: true,
          ref: allocationChartRef
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "portfolio-allocation--footer", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "footer-text b-typography-sans-serif--caption--200", onClick: () => {
          setIsModalOpen(true);
        }, children: "Important Information" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DisclosureModal, { isModalOpen, setIsModalOpen })
      ] })
    ] })
  ] });
};
PortfolioAllocation.propTypes = {
  accounts: propTypesExports.arrayOf(
    propTypesExports.shape({
      accountId: propTypesExports.string,
      agreementTypeId: propTypesExports.number,
      agreementTypeName: propTypesExports.string,
      external: propTypesExports.bool,
      productTypeId: propTypesExports.number,
      productTypeName: propTypesExports.string,
      retirement: propTypesExports.bool,
      workplace: propTypesExports.bool
    })
  ),
  customGroups: propTypesExports.arrayOf(
    propTypesExports.shape({
      groupName: propTypesExports.string.isRequired,
      groupId: propTypesExports.string.isRequired,
      accountIds: propTypesExports.arrayOf(propTypesExports.string.isRequired).isRequired
    })
  ),
  hideAccountTypeFilter: propTypesExports.bool,
  apiKey: propTypesExports.string.isRequired
};
const PortfolioAllocation$1 = PortfolioAllocation;
const mockAETData = {
  "totalMarketValue": 884190739703e-2,
  "asOfDate": "2024-01-04T05:00:00.000+00:00",
  "multiAsset": false,
  "category": {
    "level": "ASSET_CLASS",
    "allocations": [
      {
        "name": "Bond",
        "percentage": 49.622299999999996,
        "amount": 38815745807237e-4,
        "displayOrder": 2,
        "primaryColor": "#209D7D",
        "subCategory": {
          "level": "SUB_ASSET_CLASS",
          "allocations": [
            {
              "name": "Global/Other Bond",
              "percentage": 25.3322,
              "amount": 2239852804362e-3,
              "displayOrder": 7,
              "primaryColor": "#166A54"
            },
            {
              "name": "Conservative Bond",
              "percentage": 0.0851,
              "amount": 75287542276e-4,
              "displayOrder": 8,
              "primaryColor": "#197B62"
            },
            {
              "name": "U.S. Investment Grade Bond",
              "percentage": 18.4824,
              "amount": 16341930221341e-4,
              "displayOrder": 5,
              "primaryColor": "#125947"
            }
          ]
        }
      },
      {
        "name": "Cash",
        "percentage": 6.4779,
        "amount": 5727691572785e-4,
        "displayOrder": 3,
        "primaryColor": "#9E7DCF",
        "subCategory": {
          "level": "SUB_ASSET_CLASS",
          "allocations": [
            {
              "name": "Cash",
              "percentage": 6.4779,
              "amount": 5727691572785e-4,
              "displayOrder": 9,
              "primaryColor": "#9E7DCF"
            }
          ]
        }
      },
      {
        "name": "Stock",
        "percentage": 43.899699999999996,
        "amount": 43875636590278e-4,
        "displayOrder": 1,
        "primaryColor": "#0096D6",
        "subCategory": {
          "level": "SUB_ASSET_CLASS",
          "allocations": [
            {
              "name": "International Stock",
              "percentage": 28.2211,
              "amount": 24952842241074e-4,
              "displayOrder": 3,
              "primaryColor": "#0072A3"
            },
            {
              "name": "Small/Mid-Cap Stock",
              "percentage": 7.7985,
              "amount": 6895403720718e-4,
              "displayOrder": 2,
              "primaryColor": "#00608A"
            },
            {
              "name": "Large-Cap Stock",
              "percentage": 2.001,
              "amount": 1769257243486e-4,
              "displayOrder": 1,
              "primaryColor": "#004E70"
            },
            {
              "name": "U.S. Sector/Other Stock",
              "percentage": 11.6017,
              "amount": 10258133385e-1,
              "displayOrder": 4,
              "primaryColor": "#0084BD"
            }
          ]
        }
      },
      {
        "name": "Other Investments",
        "percentage": 0,
        "amount": 0,
        "displayOrder": 4,
        "primaryColor": "#D36990"
      }
    ]
  },
  "errors": {
    "missingAgreementIDs": [
      "1500051720",
      "1500051724"
    ],
    "assetClassificationErrors": {
      "notFound": [],
      "noMapping": []
    }
  }
};
const usePortfolioAllocationData = (customGroups, apiKey, mock = (window == null ? void 0 : window.origin.indexOf("localhost")) >= 0) => {
  const [accountGroups, setAccountGroups] = useState(new Map(customGroups || []));
  const [accountTypeOptions, setAccountTypeOptions] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [allocations, setAllocations] = useState([]);
  const [isError2, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const formatSubAssetAllocation = (assetAllocation) => {
    var _a2;
    const subAssetAllocations = ((_a2 = assetAllocation == null ? void 0 : assetAllocation.subCategory) == null ? void 0 : _a2.allocations) || [];
    if (subAssetAllocations.length > 0) {
      const uniqueSubAllocation = subAssetAllocations.reduce((subAllocationMap, subAllocation) => {
        if (subAllocationMap[subAllocation.name]) {
          subAllocationMap[subAllocation.name].percentage += subAllocation.percentage;
          subAllocationMap[subAllocation.name].amount += subAllocation.amount;
        } else {
          subAllocationMap[subAllocation.name] = subAllocation;
        }
        return subAllocationMap;
      }, {});
      assetAllocation.subCategory.allocations = Object.values(uniqueSubAllocation);
      assetAllocation.subCategory.allocations.sort((a2, b5) => a2.displayOrder - b5.displayOrder);
    }
    return assetAllocation;
  };
  useEffect(() => {
    var _a2;
    const accountTypeOptionsCopy = [];
    const accountTypes = Object.keys(standardGroups);
    if (accountTypes) {
      accountTypes.forEach((standardGroup) => {
        if (accountGroups.has(standardGroup)) {
          accountTypeOptionsCopy.push({ label: standardGroup, value: standardGroup });
        }
      });
    }
    const accountGroupsCopy = /* @__PURE__ */ new Map();
    if (customGroups && lodashExports.isArray(customGroups)) {
      customGroups.forEach((customGroup) => {
        if (customGroup && !accountGroupsCopy.has(customGroup.groupId)) {
          if ((customGroup == null ? void 0 : customGroup.accountIds) && customGroup.accountIds.length > 0) {
            accountGroupsCopy.set(customGroup.groupId, customGroup.accountIds);
          }
          if ((customGroup == null ? void 0 : customGroup.agreementIds) && customGroup.agreementIds.length > 0) {
            accountGroupsCopy.set(customGroup.groupId, customGroup.agreementIds);
          }
        }
        if (accountTypeOptionsCopy.findIndex((option) => option.value === customGroup.groupId) === -1) {
          accountTypeOptionsCopy.push({ label: customGroup.groupName, value: customGroup.groupId });
        }
      });
    }
    if (accountGroupsCopy.get("all")) {
      setSelectedGroupId("all");
    } else {
      if (accountGroupsCopy.get("0")) {
        setSelectedGroupId("0");
      } else {
        if (customGroups && customGroups.length > 0) {
          setSelectedGroupId((_a2 = customGroups[0]) == null ? void 0 : _a2.name);
        }
      }
    }
    setAccountGroups(accountGroupsCopy);
    setAccountTypeOptions(accountTypeOptionsCopy);
  }, [customGroups]);
  useEffect(() => {
    if (selectedGroupId) {
      const fetchData = async () => {
        var _a2, _b;
        try {
          setIsError(false);
          setIsLoading(true);
          const url = getServiceUrl();
          const req = createRequest(url, apiKey, Array.from(new Set(accountGroups.get(selectedGroupId))));
          const response = mock ? { status: 200 } : await fetch(url, req);
          if (response.status !== 200) {
            throw new Error("Bad Response");
          }
          const data = mock ? mockAETData : await response.json();
          const assetAllocations = ((_b = (_a2 = data == null ? void 0 : data.category) == null ? void 0 : _a2.allocations) == null ? void 0 : _b.sort((a2, b5) => a2.displayOrder - b5.displayOrder)) || [];
          const formattedAllocations = assetAllocations.map(formatSubAssetAllocation);
          setAllocations(formattedAllocations);
        } catch (e5) {
          console.error(e5);
          setAllocations([]);
          setIsError(true);
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [selectedGroupId]);
  return [
    allocations,
    accountTypeOptions,
    selectedGroupId,
    setSelectedGroupId,
    isError2,
    isLoading
  ];
};
const LAYOUT = "column";
const formatAssetAllocationToChartDataSeries = (allocations) => {
  const nameMapping = {
    "Stock": "Stocks",
    "Bond": "Bonds",
    "Other Investments": "Other"
  };
  return allocations.map((securityData) => {
    var _a2;
    const name = nameMapping[securityData.name] || securityData.name;
    return [name, Number(((_a2 = securityData.percentage) == null ? void 0 : _a2.toFixed(2)) || 0)];
  });
};
const AssetAllocation = ({
  groups = [],
  eyebrow = "",
  titleText = "",
  bodyText = "",
  primaryCTAText = "",
  handlePrimaryCTA = () => {
  },
  secondaryCTAText = "",
  handleSecondaryCTA = () => {
  },
  disclosureCTAText = "",
  disclosureContent = "",
  apiKey = "",
  className = "",
  offerId
}) => {
  const [
    allocations,
    accountTypeOptions,
    selectedGroupId,
    setSelectedGroupId,
    isError2,
    isLoading
  ] = usePortfolioAllocationData(groups, apiKey);
  const allocationChartRef = useRef();
  const errorMessage = "We were unable to retrieve your asset allocation";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "beacon-on-light", children: [
    !isError2 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
      UtilityCard$1,
      {
        id: "asset-allocation-util-card",
        eyeBrow: eyebrow,
        title: titleText,
        bodyText,
        primaryCTAText,
        handlePrimaryCTA,
        secondaryCTAText,
        handleSecondaryCTA,
        disclosureCTAText,
        disclosureContent,
        className: `ii-asset-allocation ${className}`,
        isLoading,
        errorMessage: isError2 ? errorMessage : null,
        offerId,
        children: [
          accountTypeOptions && /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconControl, { className: "account-select", "data-testid": "account-select", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("label", { slot: "label", htmlFor: "account-select", children: "Current Asset Allocation" }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "select",
              {
                id: "account-select",
                value: selectedGroupId || "",
                onChange: ({ target: { value } }) => {
                  setSelectedGroupId(value);
                },
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "", disabled: true, defaultValue: "", children: "Select" }, "default"),
                  accountTypeOptions.map((option, i5) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: option.value, children: option.label }, i5))
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            IIBeaconDonutChart,
            {
              series: [{
                data: formatAssetAllocationToChartDataSeries(allocations)
              }],
              hideChartMetric: true,
              hideDataLabels: true,
              "legend-layout": LAYOUT,
              className: "asset-chart",
              "data-testid": "asset-chart",
              options: {
                exporting: {
                  enabled: false
                },
                legend: {
                  enabled: true
                  // labelFormatter: function () {
                  //   console.log('this', this);
                  //   return this.name + ': ' + '<b>'+this.y+'%' + '</b>';
                  // },
                },
                tooltip: {
                  // format: '{point.name}: <b>{point.y}%</b>'
                }
              },
              percentage: true,
              decimal: true,
              ref: allocationChartRef
            }
          ) })
        ]
      }
    ),
    isError2 && /* @__PURE__ */ jsxRuntimeExports.jsx(
      UtilityCard$1,
      {
        id: "error-card",
        eyeBrow: eyebrow,
        title: titleText,
        bodyText,
        className: `ii-asset-allocation ${className}`,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IIBeaconError,
          {
            className: "asset-allocation-error",
            "data-testid": "assetAllocationError",
            children: errorMessage
          }
        )
      }
    )
  ] }) });
};
AssetAllocation.propTypes = {
  groups: propTypesExports.arrayOf(
    propTypesExports.shape({
      groupName: propTypesExports.string,
      groupId: propTypesExports.string,
      accountIds: propTypesExports.arrayOf(propTypesExports.string)
    })
  ),
  primaryCTAText: propTypesExports.string,
  handlePrimaryCTA: propTypesExports.func,
  secondaryCTAText: propTypesExports.string,
  handleSecondaryCTA: propTypesExports.func,
  disclosureCTAText: propTypesExports.string,
  disclosureContent: propTypesExports.string,
  apiKey: propTypesExports.string,
  offerId: propTypesExports.string
};
const AssetAllocation$1 = AssetAllocation;
const Alaska529Logo = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    width: "147",
    viewBox: "0 0 346 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M262.161 24.8838C258.807 22.7243 254.161 21.7754 248.326 22.0535L249.793 10.1869H268.896V1.19431H241.847L237.986 32.4804C237.986 32.4804 240.173 32.0551 243.908 31.5097C244.23 31.4661 245.937 31.1771 248.587 31.0407C252.476 30.8335 255.568 31.3352 257.291 32.4422C260.481 34.4982 262.052 37.8029 261.719 41.7566C261.447 44.9905 260.165 49.1351 255.584 50.5039C251.172 51.8291 246.788 50.2694 243.974 48.797L238.886 56.2518C241.918 57.9423 246.695 59.9819 252.165 59.9819C254.095 59.9819 256.113 59.7256 258.169 59.1093C265.308 56.9662 269.987 50.7602 270.679 42.5038C271.295 35.1908 268.187 28.7667 262.161 24.8838Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M304.43 53.3396H275.004V58.8039H304.43V53.3396Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M142.917 26.4708C140.817 24.8566 135.746 22.7406 129.992 21.0883C123.683 19.2723 120.793 17.2818 120.329 14.4351C120.1 13.0227 120.149 10.9613 121.703 9.12898C123.737 6.73494 127.658 5.4643 133.046 5.4643C138.254 5.4643 142.437 7.78745 143.73 8.59455V2.41585C141.161 1.24337 137.42 0 133.046 0C124.152 0 119.707 3.03754 117.537 5.58973C115.268 8.26189 114.341 11.7139 114.936 15.3186C116.157 22.7897 124.79 25.2765 128.482 26.3399C134.044 27.9377 138.276 29.7973 139.585 30.8062C142.437 32.9985 142.868 36.336 141.815 38.5064C140.507 41.2167 138.445 42.2692 133.346 42.8528C128.247 43.4417 122.123 41.713 115.077 37.7375L118.268 45.4049C122.996 47.4118 127.386 48.4261 131.399 48.4261C132.272 48.4261 133.128 48.377 133.963 48.2843C138.669 47.7445 143.926 46.6865 146.729 40.8895C149.085 36.036 147.476 29.9718 142.917 26.4708Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M68.3146 39.1663C65.5389 38.3155 62.3159 37.8247 59.0439 37.7866C55.7555 37.7484 52.2926 38.2555 49.3259 39.1335L51.4364 44.2052C53.7486 43.5835 56.4426 43.229 58.9784 43.2509C61.5252 43.2836 64.0446 43.6435 66.1987 44.2434L68.3146 39.1663Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M50.3675 27.7305V1.19431H44.8978V28.5049L47.1609 33.9419C50.8474 33.0312 54.6539 32.5513 58.504 32.5513C62.2723 32.5513 66.575 33.1185 70.4305 34.0892L72.421 28.9412C69.8143 28.2486 64.5409 27.087 58.504 27.087C55.7664 27.0816 53.0506 27.3161 50.3675 27.7305Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M12.8973 42.7764L26.0018 11.2885L34.4818 31.6624C26.1436 34.28 18.8088 38.092 12.8973 42.7764ZM27.7251 1.19431H24.284L0.245422 58.8039H6.33686L6.81131 57.6642C12.2592 48.4261 22.9479 40.9114 36.5923 36.7286L45.7376 58.8039H51.8291L27.7251 1.19431Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M83.0879 31.6624L91.5679 11.2885L104.672 42.7764C98.7664 38.092 91.4261 34.28 83.0879 31.6624ZM93.2857 1.19431H89.8501L65.7515 58.8039H71.843L80.9774 36.7286C94.6436 40.9168 105.349 48.4479 110.786 57.7133L111.238 58.8039H117.33L93.2857 1.19431Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M198.007 42.7764L211.112 11.2885L219.592 31.6624C211.248 34.28 203.913 38.092 198.007 42.7764ZM212.83 1.19431H209.388L185.323 58.8039H191.414L191.818 57.8332C197.233 48.5188 207.971 40.9386 221.697 36.7341L230.858 58.8094H236.95L212.83 1.19431Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M147.138 49.3041C144.122 51.1038 138.156 53.8414 131.17 53.6396C126.977 53.5142 123.432 52.5871 120.335 51.4364L123.067 57.9914C125.472 58.5858 128.1 59.0166 131.012 59.1039C131.323 59.1148 131.629 59.1202 131.929 59.1202C138.014 59.1202 143.348 57.3315 147.138 55.4992V49.3041Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M184.09 16.6329C177.911 25.3583 170.342 30.8226 158.525 34.9726V1.19431H153.039V58.8039H158.525V40.7423C161.573 39.7334 164.398 38.6427 167.016 37.4485L175.91 58.8039H181.98L171.891 34.9454C178.713 31.0571 184.03 26.1708 188.551 19.7904C194.277 11.703 196.48 5.11529 197.331 1.19431H191.703C190.814 4.60268 188.775 10.0124 184.09 16.6329Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M327.16 27.8723C322.443 27.8723 318.598 23.6459 318.598 18.4434C318.598 13.2408 322.437 9.01445 327.16 9.01445C331.882 9.01445 335.722 13.2408 335.722 18.4434C335.722 23.6459 331.882 27.8723 327.16 27.8723ZM345.063 18.4761L345.052 18.307C344.834 15.3458 343.705 11.8284 342.702 9.887L342.691 9.89245C339.752 4.03551 333.895 0.0327148 327.16 0.0327148C317.486 0.0327148 309.611 8.29461 309.611 18.4488C309.611 28.603 317.48 36.8649 327.16 36.8649C330.094 36.8649 332.859 36.1015 335.291 34.7599C334.315 38.8336 332.433 41.8112 329.194 44.7015C326.304 47.2755 323.152 48.8624 319.83 49.4132C317.982 49.7186 316.297 49.8386 313.821 49.8386V58.8257C316.788 58.8257 318.952 58.6676 321.297 58.2804C326.26 57.4624 331.059 55.0847 335.182 51.4091C341.579 45.7049 344.534 39.1117 345.063 29.3665C345.074 29.0502 345.451 21.999 345.063 18.4761Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M292.378 30.4136C293.18 30.0918 293.949 29.781 294.663 29.4647C301.333 26.5144 305.57 21.3391 306.006 15.6185C306.323 11.4521 305.003 7.43843 302.385 4.61357C300.427 2.50856 296.768 0 290.399 0C281.69 0 274.867 5.9551 274.867 13.5571H283.855C283.855 11.3594 286.358 8.98719 290.399 8.98719C292.907 8.98719 294.723 9.5707 295.787 10.7214C297.134 12.1774 297.084 14.3152 297.041 14.9368C296.866 17.2654 294.56 19.6813 291.026 21.241C290.404 21.5191 289.728 21.7863 289.03 22.0699C285.409 23.5205 280.904 25.331 278.118 29.3174C274.906 33.9037 274.976 38.9536 275.009 41.3204V48.1098H304.436V39.1226H284.04C284.144 37.623 284.476 35.9106 285.48 34.4709C286.734 32.6767 289.728 31.4715 292.378 30.4136Z",
          fill: "white"
        }
      )
    ]
  }
);
const Maryland529Logo = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    width: "200",
    viewBox: "0 0 200 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M27.2334 0.326551L18.5431 16.5045L14.3901 0.326551H8.38094L0 26.0539H5.51229L11.334 8.17209H11.4089L15.9369 26.0539H18.5431L28.0958 8.65893H28.1802L28.9677 26.0539H34.255L33.0456 0.326551H27.2334Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M50.9512 26.0539H45.8514L46.0764 24.4717C44.4171 25.7918 42.9078 26.4003 41.1266 26.4003C37.6486 26.4003 35.1174 23.3483 35.1174 19.0416C35.1174 14.0609 38.2861 8.63085 47.5482 8.63085C49.7044 8.63085 51.2137 8.78064 53.323 9.20194L50.9512 26.0539ZM47.7076 12.9281C41.3609 12.2915 40.4141 17.1879 40.4141 19.3038C40.4141 21.3728 41.3609 22.5899 42.9078 22.5899C44.0796 22.5899 45.4014 22.0656 46.5733 21.0826L47.7076 12.9281Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M60.6258 11.374L60.7008 11.4489C62.2852 9.4828 63.607 8.62148 64.8538 8.62148C65.8756 8.62148 66.7381 9.14576 67.9099 10.5033L65.5288 15.2218C64.6569 13.9392 63.9445 13.3775 63.1101 13.3775C61.9008 13.3775 60.579 14.735 60.0165 15.8678L58.5822 26.0539H53.4824L55.901 8.93043H61.0008L60.6258 11.374Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M73.2441 34.7233C70.413 34.7233 68.1068 33.628 66.26 30.4635L69.7755 28.4975C70.6098 29.8175 72.0817 30.8755 73.291 30.8755C75.8596 30.8755 77.144 29.4431 77.669 24.013C75.2503 25.8573 74.0035 26.391 72.1567 26.391C68.0037 26.391 66.7194 23.4887 67.4318 18.5454L68.8287 8.93042H73.816L72.3817 19.0416C72.1567 20.7362 72.4192 22.5525 73.9285 22.5525C75.4003 22.5525 76.7596 21.4945 78.3064 19.9498L79.9282 8.93979H84.9156L82.4219 25.979C81.6251 31.3342 79.2064 34.7233 73.2441 34.7233Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M90.7653 18.5829C90.5403 20.2774 90.6153 22.281 93.334 22.6929L91.8622 26.391C84.803 26.1663 85.253 21.7473 85.628 19.1446L88.3092 0.326549H93.409L90.7653 18.5829Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M109.158 26.0539H104.059L104.284 24.4717C102.624 25.7918 101.115 26.4003 99.3338 26.4003C95.8558 26.4003 93.3246 23.3483 93.3246 19.0416C93.3246 14.0609 96.4933 8.63085 105.755 8.63085C107.912 8.63085 109.421 8.78064 111.53 9.20194L109.158 26.0539ZM105.915 12.9281C99.5682 12.2915 98.6213 17.1879 98.6213 19.3038C98.6213 21.3728 99.5682 22.5899 101.115 22.5899C102.287 22.5899 103.609 22.0656 104.78 21.0826L105.915 12.9281Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M119.171 10.8497C121.252 9.26747 122.949 8.62148 125.02 8.62148C128.986 8.62148 130.045 11.9451 129.548 15.4465L128.076 26.0446H122.977L124.411 15.821C124.636 14.1639 124.261 12.3851 122.902 12.3851C121.73 12.3851 120.333 13.1809 118.599 15.0252L117.052 26.0352H111.952L114.371 8.93043H119.471L119.171 10.8497Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M146.891 25.8292C144.698 26.2037 142.888 26.391 140.995 26.391C134.911 26.391 131.058 23.2265 131.058 18.1709C131.058 13.5366 134.536 8.63084 141.707 8.63084C142.579 8.63084 143.479 8.74319 144.201 8.81808L145.382 0.326549H150.482L146.891 25.8292ZM143.573 13.1528C138.698 12.5536 136.354 15.381 136.354 18.2084C136.354 20.6987 138.089 22.2435 140.929 22.2435C141.417 22.2435 141.801 22.1686 142.326 22.0563L143.573 13.1528Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M165.698 5.5883H158.919L158.318 9.82641C163.538 10.389 165.36 13.7551 165.36 17.4213C165.36 22.7845 161.426 26.4507 155.633 26.4507C153.06 26.4507 150.901 25.8131 148.929 24.5192L150.441 19.7185C152.563 21.1531 153.812 21.65 155.548 21.65C158.121 21.65 159.98 20.0654 159.98 17.8338C159.98 15.4897 158.083 14.0552 155.06 14.0552C154.112 14.0552 153.164 14.1302 152.15 14.2802L154.497 0.33754H166.458L165.698 5.5883Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M179.066 26.1132H164.231V25.288C172.785 14.027 175.395 9.93894 175.395 7.36982C175.395 5.89773 174.221 4.80069 172.634 4.80069C171.273 4.80069 169.874 5.41016 167.142 7.14478L167.865 1.96904C169.639 0.609465 171.423 0 173.62 0C178.127 0 180.775 3.17859 180.775 6.88225C180.775 10.7359 178.502 13.877 173.357 20.8624H179.789L179.066 26.1132Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M190.341 15.9867L190.266 15.9117C189.243 16.2867 188.604 16.3993 187.806 16.3993C184.398 16.3993 181.938 13.6426 181.938 9.78892C181.938 5.36328 184.971 0 191.252 0C196.059 0 199.082 3.14108 199.082 8.0918C199.082 10.8109 198.096 13.5395 195.862 16.8962L189.768 26.1225H183.788L190.341 15.9867ZM191.064 4.8007C189.092 4.8007 187.318 7.03227 187.318 9.45137C187.318 10.961 188.341 11.9455 189.89 11.9455C192.538 11.9455 193.712 9.26385 193.712 7.55735C193.712 5.97274 192.576 4.8007 191.064 4.8007Z",
          fill: "white"
        }
      )
    ]
  }
);
const National529Logo = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    width: "250",
    viewBox: "0 0 430 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M11.73 3.84311H7.93V14.8047H3.8V3.84311H0V0H11.73V3.84311Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M14.66 10.5249H10.78V14.8156H14.66V10.5249Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M28.14 0C29.75 0 30.64 0.196522 31.46 0.709664C32.66 1.463 33.35 2.79499 33.35 4.37808C33.35 5.9721 32.58 7.36959 31.36 7.97008C32.8 8.61423 33.25 9.72786 33.47 13.2107C33.55 14.0514 33.63 14.5208 33.73 14.6737L33.81 14.8047H29.68C29.62 14.63 29.6 14.5208 29.54 14.226C29.52 14.095 29.5 14.0732 29.46 13.5382L29.38 12.5884C29.26 11.0817 29.14 10.6559 28.73 10.1646C28.38 9.78245 27.85 9.58593 27.1 9.58593H25.35V14.8047H21.22V0H28.14ZM25.35 6.4634H27.61C28.77 6.4634 29.34 5.95026 29.34 4.9349C29.34 3.90861 28.71 3.45006 27.39 3.45006H25.36V6.4634H25.35Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M45.54 9.41124C45.54 12.763 43.32 15.0886 40.13 15.0886C36.96 15.0886 34.74 12.7849 34.74 9.47675C34.74 6.08128 36.95 3.78851 40.25 3.78851C43.34 3.79943 45.54 6.12495 45.54 9.41124ZM38.51 9.45491C38.51 11.2345 39.06 12.1407 40.16 12.1407C41.26 12.1407 41.79 11.2564 41.79 9.43307C41.79 8.54872 41.71 8.03558 41.48 7.58795C41.22 7.0748 40.69 6.74727 40.14 6.74727C39.03 6.74727 38.51 7.6207 38.51 9.45491Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M59.62 14.8047H55.78L54.94 11.3C54.59 9.81519 54.51 9.28022 54.31 7.43509C54.09 9.28022 53.98 9.85887 53.68 11.3L52.89 14.8047H49.05L45.94 4.08329H49.84L50.55 7.09663C50.92 8.67973 51.04 9.35664 51.28 11.3328C51.57 9.20379 51.69 8.55963 52.01 6.91103L52.58 4.07237H56.08L56.73 7.20581C57.14 9.22563 57.16 9.40031 57.4 11.2891C57.62 9.44399 57.72 8.90901 58.09 7.29316L58.82 4.07237H62.7L59.62 14.8047Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M73.71 11.5839C73.55 12.2062 73.22 12.8067 72.71 13.3854C71.75 14.5208 70.39 15.0995 68.62 15.0995C65.28 15.0995 63.07 12.8831 63.07 9.55316C63.07 6.20136 65.33 3.79942 68.48 3.79942C70.72 3.79942 72.5 4.93489 73.34 6.91103C73.73 7.81721 73.91 8.88717 73.91 10.3283H66.67C66.75 11.7258 67.42 12.4792 68.63 12.4792C69.36 12.4792 69.81 12.2171 70.19 11.5948H73.71V11.5839ZM70.23 8.25393C70.15 7.05296 69.54 6.4088 68.52 6.4088C67.5 6.4088 66.89 7.00929 66.69 8.25393H70.23V8.25393Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M87.13 0C89.33 0 90.36 0.218358 91.3 0.884351C92.56 1.79054 93.25 3.3518 93.25 5.2406C93.25 6.68176 92.8 7.94824 91.93 8.88718C91.06 9.84796 89.92 10.241 88.15 10.241H85.57V14.8156H81.44V0H87.13ZM85.56 6.76911H87.55C88.71 6.76911 89.24 6.29964 89.24 5.21876C89.24 4.15972 88.63 3.59199 87.47 3.59199H85.56V6.76911Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M102.35 7.5661C101.72 7.32591 101.39 7.2604 100.97 7.2604C100.14 7.2604 99.4 7.64253 99 8.26485C98.74 8.69065 98.61 9.22563 98.61 9.94621V14.8047H94.85V4.08329H98.47V5.75373C99.12 4.42174 100.03 3.79942 101.3 3.79942C101.6 3.79942 101.89 3.84309 102.36 3.95227V7.5661H102.35Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M107.53 2.86049H103.77V0H107.53V2.86049ZM107.53 14.8047H103.77V4.0833H107.53V14.8047Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M119.7 10.503C119.31 13.4072 117.42 15.0995 114.53 15.0995C111.36 15.0995 109.18 12.8395 109.18 9.53133C109.18 6.11402 111.36 3.79942 114.55 3.79942C117.4 3.79942 119.43 5.53537 119.61 8.13383H116C115.88 7.29316 115.35 6.75818 114.62 6.75818C113.52 6.75818 112.95 7.74079 112.95 9.575C112.95 11.2454 113.52 12.1516 114.58 12.1516C115.43 12.1516 115.92 11.6166 116.1 10.503H119.7Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M131.5 11.5839C131.34 12.2062 131.01 12.8067 130.5 13.3854C129.55 14.5208 128.18 15.0995 126.42 15.0995C123.09 15.0995 120.87 12.8831 120.87 9.55316C120.87 6.20136 123.13 3.79942 126.28 3.79942C128.52 3.79942 130.31 4.93489 131.14 6.91103C131.53 7.81721 131.71 8.88717 131.71 10.3283H124.47C124.55 11.7258 125.22 12.4792 126.42 12.4792C127.15 12.4792 127.6 12.2171 127.98 11.5948H131.5V11.5839ZM128.02 8.25393C127.94 7.05296 127.33 6.4088 126.31 6.4088C125.29 6.4088 124.69 7.00929 124.48 8.25393H128.02V8.25393Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M23.83 41.8156C23.28 48.8468 18.7 53.6288 12.42 53.6288C5.15003 53.6288 0.340027 47.6349 0.340027 38.6713C0.340027 29.6531 5.28003 23.5827 12.62 23.5827C18.23 23.5827 22.81 27.5132 23.4 32.852H21.82C20.91 28.1027 17.28 25.0894 12.5 25.0894C6.22003 25.0894 1.95003 30.5702 1.95003 38.6276C1.95003 46.7396 6.14003 52.1221 12.42 52.1221C17.83 52.1221 21.58 48.2026 22.25 41.8156H23.83V41.8156Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M52.27 38.8023C52.27 47.6458 47.21 53.6397 39.67 53.6397C32.24 53.6397 27.23 47.6021 27.23 38.6385C27.23 29.5875 32.28 23.5936 39.87 23.5936C47.13 23.5827 52.27 29.8714 52.27 38.8023ZM28.85 38.5839C28.85 46.6522 33.23 52.1221 39.71 52.1221C46.23 52.1221 50.65 46.7287 50.65 38.7586C50.65 30.7339 46.19 25.0894 39.87 25.0894C33.27 25.0894 28.85 30.4719 28.85 38.5839Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M72.49 52.9846H55.86V24.2269H57.49V51.478H72.49V52.9846Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M93.03 52.9846H76.4V24.2269H78.02V51.478H93.03V52.9846Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M114.68 25.7335H98.56V37.241H113.73V38.7586H98.56V51.478H114.87V52.9846H96.94V24.2269H114.68V25.7335Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M141.81 52.9846H140.62L140.46 45.9972C139 50.8666 135.33 53.6288 130.35 53.6288C122.92 53.6288 117.91 47.6785 117.91 38.9224C117.91 29.7841 122.92 23.5718 130.35 23.5718C136.08 23.5718 140.46 27.3712 141.37 33.1031H139.83C138.92 28.2774 135.13 25.0784 130.35 25.0784C123.79 25.0784 119.53 30.5592 119.53 38.9224C119.53 46.816 123.87 52.1221 130.39 52.1221C136.35 52.1221 140.38 47.5912 140.38 40.9531V40.44H130.66V38.9333H141.8V52.9846H141.81Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M164.33 25.7335H148.21V37.241H163.38V38.7586H148.21V51.478H164.52V52.9846H146.59V24.2269H164.33V25.7335Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M195.13 32.4153C194.97 30.3081 194.5 28.9215 193.63 27.797C192.25 26.072 189.8 25.1221 186.84 25.1221C182.22 25.1221 179.46 27.3603 179.46 31.1597C179.46 33.3979 180.37 34.8718 182.34 35.778C183.6 36.3785 183.72 36.4221 188.74 37.6777C192.33 38.5839 193.48 39.0206 194.78 39.8722C196.48 41.0404 197.38 42.9838 197.38 45.3967C197.38 50.5281 193.67 53.5851 187.47 53.5851C183.44 53.5851 180.36 52.2095 178.66 49.6983C177.56 48.017 177.08 46.2046 177.04 43.4424H178.58C178.66 49.0978 181.74 52.0675 187.55 52.0675C192.72 52.0675 195.77 49.611 195.77 45.4731C195.77 43.3987 194.82 41.761 193.08 40.8112C191.9 40.2107 191.06 39.905 186.96 38.9114C182.89 37.8742 181.59 37.4048 180.25 36.4549C178.71 35.374 177.84 33.4743 177.84 31.1925C177.84 26.4869 181.28 23.6045 186.93 23.6045C190.52 23.6045 193.37 24.8164 195.03 26.9672C196.1 28.3866 196.57 29.9478 196.73 32.4044H195.13V32.4153Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M222.43 52.9846H220.69L217.37 43.759H204.65L201.33 52.9846H199.59L210.25 24.2269H211.95L222.43 52.9846ZM212.04 28.9216C212 28.8342 211.8 28.1901 211.41 26.9345L211.29 26.5851C211.25 26.4978 211.21 26.2357 211.09 25.8973C210.7 27.1092 210.26 28.3538 210.1 28.7905L205.16 42.2414H216.85L212.04 28.9216Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M232.82 52.9846H230.92L220.97 24.2269H222.71L230.61 47.2527C231.01 48.3773 231.28 49.2835 231.68 50.6155C231.76 50.9212 231.84 51.1723 231.92 51.4343C232.19 50.3097 232.31 49.9276 233.18 47.3401L241 24.2269H242.62L232.82 52.9846Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M247.99 24.2269H246.37V52.9846H247.99V24.2269Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M274.61 52.9846H272.76L257.99 30.2208C257.52 29.4019 257.04 28.5831 256.57 27.8079C256.37 27.4586 256.1 26.9891 255.7 26.2576C255.74 26.9017 255.78 28.3757 255.82 30.6575V52.9956H254.2V24.2269H256.13L270.55 46.6086C271.54 48.2026 272.44 49.7093 273.12 50.9211C273.04 49.5455 273 47.1326 273 45.4076V24.2269H274.62V52.9846H274.61Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M302.49 52.9846H301.3L301.14 45.9972C299.68 50.8666 296.01 53.6288 291.03 53.6288C283.6 53.6288 278.59 47.6785 278.59 38.9224C278.59 29.7841 283.61 23.5718 291.03 23.5718C296.76 23.5718 301.14 27.3712 302.05 33.1031H300.51C299.6 28.2774 295.81 25.0784 291.03 25.0784C284.47 25.0784 280.21 30.5592 280.21 38.9224C280.21 46.816 284.56 52.1221 291.07 52.1221C297.03 52.1221 301.06 47.5912 301.06 40.9531V40.44H291.34V38.9333H302.48V52.9846H302.49Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M324.33 32.4153C324.17 30.3081 323.7 28.9215 322.83 27.797C321.45 26.072 319 25.1221 316.04 25.1221C311.42 25.1221 308.65 27.3603 308.65 31.1597C308.65 33.3979 309.56 34.8718 311.54 35.778C312.8 36.3785 312.92 36.4221 317.94 37.6777C321.53 38.5839 322.68 39.0206 323.98 39.8722C325.68 41.0404 326.59 42.9838 326.59 45.3967C326.59 50.5281 322.88 53.5851 316.68 53.5851C312.65 53.5851 309.57 52.2095 307.88 49.6983C306.77 48.017 306.3 46.2046 306.26 43.4424H307.8C307.88 49.0978 310.96 52.0675 316.77 52.0675C321.94 52.0675 324.99 49.611 324.99 45.4731C324.99 43.3987 324.04 41.761 322.3 40.8112C321.12 40.2107 320.28 39.905 316.18 38.9114C312.11 37.8742 310.81 37.4048 309.46 36.4549C307.92 35.374 307.05 33.4743 307.05 31.1925C307.05 26.4869 310.49 23.6045 316.13 23.6045C319.72 23.6045 322.57 24.8164 324.23 26.9672C325.3 28.3866 325.77 29.9478 325.93 32.4044H324.33V32.4153Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M351.83 24.2269C354.59 24.2269 356.1 24.5762 357.48 25.5588C359.38 26.9345 360.44 29.3146 360.44 32.1533C360.44 37.1973 357.4 40.2216 352.26 40.2216H343.18V52.9846H341.56V24.2269H351.83ZM343.18 38.7149H351.35C353.8 38.7149 354.87 38.4966 356.05 37.7651C357.87 36.5968 358.82 34.708 358.82 32.2406C358.82 29.8714 357.99 27.9717 356.45 26.8472C355.3 25.9846 354.16 25.7226 351.55 25.7226H343.18V38.7149Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M380.62 52.9846H363.99V24.2269H365.61V51.478H380.62V52.9846Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M406.06 52.9846H404.32L401 43.759H388.28L384.96 52.9846H383.22L393.88 24.2269H395.58L406.06 52.9846ZM395.67 28.9216C395.63 28.8342 395.43 28.1901 395.04 26.9345L394.92 26.5851C394.88 26.4978 394.84 26.2357 394.72 25.8973C394.33 27.1092 393.89 28.3538 393.73 28.7905L388.8 42.2523H400.49L395.67 28.9216Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M429.28 52.9846H427.42L412.65 30.2208C412.18 29.4019 411.7 28.5831 411.23 27.8079C411.03 27.4586 410.75 26.9891 410.36 26.2576C410.4 26.9017 410.44 28.3757 410.48 30.6575V52.9956H408.86V24.2269H410.79L425.21 46.6086C426.2 48.2026 427.11 49.7093 427.78 50.9211C427.7 49.5455 427.66 47.1326 427.66 45.4076V24.2269H429.28V52.9846Z",
          fill: "white"
        }
      )
    ]
  }
);
const defaultView = {
  hasMutualFunds: false,
  hasAlaska529Only: false,
  hasMaryland529Only: false,
  hasNational529Only: false,
  has529Only: false,
  hasRASOnly: false,
  hasWorkplaceOnly: false,
  hasActivePlus: false,
  hasBrokerage: false,
  isAdvicePlanningClient: false,
  isRetirementAdvisoryServiceClient: false,
  productClass: PRODUCT_CLASS.RETAIL,
  active: "dashboard",
  messageCount: 0
};
const ViewContext = createContext();
const viewReducer = (view = defaultView, action) => {
  switch (action.type) {
    case "UPDATE_VIEW":
      return {
        ...view,
        ...action.payload
      };
    default:
      return view;
  }
};
const initView = (providedRouter) => {
  let view = {};
  if (providedRouter) {
    view["active"] = getPathNameFromRouter(providedRouter);
  } else {
    view["active"] = getEntryPoint();
  }
  return view;
};
function ViewProvider({ children, providedRouter }) {
  const { Provider: Provider2 } = ViewContext;
  const initialActive = initView(providedRouter);
  const [view, dispatch] = useReducer(viewReducer, { ...defaultView, ...initialActive });
  useEffect(() => {
    updateView(dispatch, initView(providedRouter));
  }, [, providedRouter]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Provider2, { value: { view, dispatch }, children });
}
function updateView(dispatch, payload) {
  dispatch({
    type: "UPDATE_VIEW",
    payload
  });
}
function updateActive(dispatch, activeState) {
  dispatch({
    type: "UPDATE_VIEW",
    payload: {
      active: lodashExports.toLower(activeState)
    }
  });
}
function useView() {
  const context = useContext(ViewContext);
  if (context === void 0) {
    throw new Error("useView must be used within a ViewProvider");
  }
  return context;
}
const Wordmark = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    width: "145",
    height: "22",
    viewBox: "0 0 145 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M141.575 4.56824V5.14567H142.043C142.226 5.14567 142.342 5.12401 142.393 5.08292C142.455 5.03362 142.485 4.95668 142.485 4.85135C142.485 4.74378 142.453 4.66759 142.389 4.62053C142.339 4.58617 142.225 4.56824 142.046 4.56824H141.575ZM140.939 4.01994H142.146C142.363 4.01994 142.521 4.03563 142.621 4.0685C142.776 4.11556 142.899 4.2052 142.989 4.33742C143.077 4.46366 143.121 4.61754 143.121 4.79981C143.121 4.97834 143.082 5.12326 143.003 5.23307C142.967 5.28387 142.905 5.34064 142.818 5.40339C142.908 5.45792 142.97 5.52141 143.003 5.59611C143.034 5.66857 143.056 5.83067 143.067 6.08167C143.079 6.31772 143.094 6.46264 143.11 6.51866C143.122 6.56796 143.173 6.62249 143.264 6.683H142.507C142.459 6.55974 142.433 6.41035 142.429 6.23555C142.421 5.99352 142.406 5.84785 142.382 5.7993C142.355 5.74028 142.312 5.70368 142.25 5.68725C142.202 5.6753 142.128 5.67007 142.029 5.67007H141.575V6.683H140.939V4.01994ZM141.975 3.31701C141.408 3.31701 140.922 3.51646 140.518 3.91461C140.121 4.30455 139.922 4.77665 139.922 5.33392C139.922 5.8979 140.124 6.37897 140.525 6.77787C140.925 7.17602 141.407 7.37547 141.971 7.37547C142.54 7.37547 143.026 7.17453 143.428 6.77414C143.618 6.5829 143.766 6.36478 143.871 6.12051C143.975 5.87101 144.028 5.61778 144.028 5.3623C144.028 4.77665 143.829 4.29334 143.431 3.91088C143.02 3.51497 142.534 3.31701 141.975 3.31701ZM141.971 2.84491C142.676 2.84491 143.279 3.08993 143.781 3.57921C144.279 4.06402 144.528 4.66162 144.528 5.37201C144.528 5.82021 144.403 6.24451 144.153 6.64789C143.9 7.05127 143.561 7.35978 143.135 7.57417C142.771 7.75644 142.384 7.84757 141.975 7.84757C141.494 7.84757 141.049 7.72357 140.64 7.47706C140.233 7.23204 139.919 6.89888 139.7 6.47683C139.515 6.12051 139.422 5.74178 139.422 5.34064C139.422 4.87003 139.547 4.43453 139.797 4.03339C140.042 3.63972 140.381 3.33494 140.814 3.11831C141.177 2.93679 141.562 2.84491 141.971 2.84491Z",
          fill: "#FFFFFE"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M120.884 20.9303C123.362 20.9303 124.9 19.6783 125.339 19.3295L125.239 18.4084C124.846 18.6512 123.632 19.251 122.461 19.251C119.508 19.251 117.742 16.7142 117.742 13.5133C117.742 10.9339 118.459 8.37247 120.683 8.37247C122.377 8.37247 123.091 9.55496 123.413 11.8699H124.35L125.026 7.72407C124.861 7.67551 123.316 7.12273 120.909 7.12273C116.871 7.12273 114.058 9.298 114.058 13.8286C114.058 17.5053 116.128 20.9303 120.884 20.9303ZM129.747 12.4444H134.679C134.679 10.9182 134.299 8.37247 132.212 8.37247C130.043 8.37247 129.747 11.0647 129.747 12.4444ZM134.054 19.251C135.368 19.251 136.444 18.6168 136.785 18.4084L136.887 19.3295C136.388 19.7553 134.989 20.934 132.279 20.934C127.812 20.934 126.008 17.6383 126.008 14.0273C126.008 11.7474 126.695 7.12273 132.27 7.12273C137.21 7.12273 138.037 11.4964 138.14 12.977L137.383 13.6657H129.678C129.678 16.8778 131.195 19.251 134.054 19.251ZM73.7234 12.4444H78.6493C78.6493 10.9182 78.2762 8.37247 76.1871 8.37247C74.0232 8.37247 73.7234 11.0647 73.7234 12.4444ZM78.029 19.251C79.3414 19.251 80.4126 18.6168 80.7621 18.4084L80.8621 19.3295C80.363 19.7553 78.9606 20.934 76.2558 20.934C71.7868 20.934 69.9793 17.6383 69.9793 14.0273C69.9793 11.7474 70.6637 7.12273 76.2375 7.12273C81.1817 7.12273 82.0142 11.4964 82.1134 12.977L81.3603 13.6657H73.6516C73.6516 16.8778 75.1677 19.251 78.029 19.251ZM102.306 9.53181V7.04953L99.4146 7.83163C99.6855 7.39763 100.012 6.44446 100.012 5.35085C100.012 2.60562 98.3777 0.90918 94.6427 0.90918H84.2223L84.5413 1.79213C85.5736 1.98411 86.2878 2.00055 86.2878 2.64073V18.7393C86.2878 19.3758 85.5736 19.3915 84.5413 19.5849L84.2223 20.4649H92.2965L91.9844 19.5849C90.9467 19.3915 90.2326 19.3758 90.2326 18.7393V2.72364C90.2326 2.40916 90.3195 2.24855 90.6614 2.24855C91.0513 2.24855 91.9478 2.24855 92.3591 2.24855C95.2852 2.24855 95.9261 3.6193 95.9261 5.87001C95.9261 8.4875 94.4566 9.96134 91.9211 9.96134C91.6823 9.96134 91.3404 9.96134 91.1176 9.96134L91.8433 11.0878C92.0195 11.1117 92.5803 11.1909 93.2052 11.1909C95.4561 11.1909 97.6925 9.76487 98.2769 9.23824C98.6317 9.31592 98.8713 9.56841 98.8713 10.1563V18.7393C98.8713 19.3758 98.1511 19.3915 97.1164 19.5849L96.8005 20.4649H104.376L104.061 19.5849C103.028 19.3915 102.31 19.3758 102.31 18.7393L102.309 10.907C102.578 10.5276 103.048 9.83509 103.962 9.83509C104.788 9.83509 105.183 10.5679 105.374 11.8699H106.308L107.081 7.11974C104.898 7.03608 103.245 8.33138 102.306 9.53181ZM40.6561 20.9729C39.4719 20.9729 38.9088 20.3342 38.5052 19.6365C38.5052 19.6365 33.8425 11.796 32.5736 10.5126C34.0126 10.1309 36.9258 9.10153 36.9258 5.24776C36.9258 2.57051 35.2235 0.90918 31.5542 0.90918H21.1399L21.4535 1.79213C22.4912 1.98411 23.2054 2.00055 23.2054 2.64073V18.7393C23.2054 19.3758 22.4912 19.3915 21.4535 19.5849L21.1399 20.4649H29.2102L28.8966 19.5849C27.862 19.3915 27.1448 19.3758 27.1448 18.7393V2.71468C27.1448 2.38824 27.2485 2.24855 27.572 2.24855C27.9696 2.24855 29.121 2.24855 29.3697 2.24855C32.2096 2.24855 32.8429 3.63498 32.8429 5.88719C32.8429 8.6862 31.1864 9.96134 28.7692 9.96134C28.6014 9.96134 28.2519 9.96134 28.0321 9.96134C29.8 12.6057 30.8751 14.9491 32.6003 17.713C34.9435 21.4674 36.3276 22 38.7272 22C39.871 22 40.3784 21.8192 40.7576 21.7348L40.6561 20.9729ZM48.2717 14.0198C48.2717 10.1944 47.5858 8.37247 45.5432 8.37247C43.1603 8.37247 42.8208 11.0333 42.8208 14.0198C42.8208 18.0782 43.6143 19.6806 45.5432 19.6806C47.5133 19.6806 48.2717 17.9647 48.2717 14.0198ZM38.9714 14.0198C38.9371 10.2743 41.0826 7.12273 45.5432 7.12273C49.8252 7.12273 52.1211 10.0181 52.1211 14.0198C52.1211 17.8549 49.9595 20.934 45.5432 20.934C41.1284 20.934 38.9714 17.8893 38.9714 14.0198ZM16.822 20.621C17.8483 20.621 18.6876 19.8038 18.6876 18.7939C18.6876 17.7847 17.8483 16.9689 16.822 16.9689C15.7828 16.9689 14.9511 17.7847 14.9511 18.7939C14.9511 19.8038 15.7828 20.621 16.822 20.621ZM110.394 6.15387C111.436 6.15387 112.277 5.32769 112.277 4.31177C112.277 3.2951 111.436 2.46892 110.394 2.46892C109.354 2.46892 108.51 3.2951 108.51 4.31177C108.51 5.32769 109.354 6.15387 110.394 6.15387ZM56.4534 20.4649H58.5975L60.9918 12.7902L63.4884 20.4649H65.7179L68.6425 9.63489C68.9431 8.66006 69.6023 8.61374 70.4325 8.46883L70.7461 7.58811H65.3348L65.6507 8.46883C66.3863 8.60702 66.7487 8.6862 66.7487 9.04327C66.7487 9.22778 66.709 9.43619 66.6419 9.6969C66.1528 11.6832 65.3089 15.0611 65.3089 15.0611L63.0283 7.58811H60.7904L58.4388 15.0096C57.7391 12.2554 57.6964 11.979 57.353 10.5746C57.2401 10.095 57.1188 9.63116 57.1188 9.32788C57.1188 8.88416 57.3568 8.63018 58.2938 8.46883L58.6127 7.58811H51.3405L51.6587 8.46883C52.3729 8.59059 53.1244 8.66155 53.2724 9.15308L56.4534 20.4649ZM12.2913 20.4649L11.9739 19.5849C10.94 19.3915 10.2258 19.3758 10.2258 18.7393V2.67061H13.5419C14.9801 2.67061 15.077 3.81949 15.5417 5.9477H16.5115L16.2917 0.90918H0.217463L0 5.9477H0.965205C1.42835 3.81949 1.52678 2.67061 2.96353 2.67061H6.28565V18.7393C6.28565 19.3758 5.56537 19.3915 4.53455 19.5849L4.21944 20.4649H12.2913ZM112.054 18.9298C112.235 19.4654 113.096 19.4303 113.635 19.5849C113.831 19.9323 113.812 19.8673 114.017 20.4649H106.832C107.116 20.0055 107.101 19.9189 107.291 19.5849C107.805 19.3429 108.502 19.3631 108.613 18.7102V7.70614C109.717 7.50221 110.908 7.38717 112.058 7.18996L112.054 18.9298Z",
          fill: "#FFFFFE"
        }
      )
    ]
  }
);
const brandingLogo = {
  [PRODUCT_CLASS.ALASKA_529]: {
    component: /* @__PURE__ */ jsxRuntimeExports.jsx(Alaska529Logo, { className: "wordmark" }),
    link: "https://www.alaska529plan.com/home.html"
  },
  [PRODUCT_CLASS.MARYLAND_529]: {
    component: /* @__PURE__ */ jsxRuntimeExports.jsx(Maryland529Logo, { className: "wordmark" }),
    link: "https://maryland529.com/"
  },
  [PRODUCT_CLASS.NATIONAL_529]: {
    component: /* @__PURE__ */ jsxRuntimeExports.jsx(National529Logo, { className: "wordmark" }),
    link: trpEnvironmentAware("https://www.troweprice.com/personal-investing/troweprice-529/index.html")
  },
  [PRODUCT_CLASS.RETAIL]: {
    component: /* @__PURE__ */ jsxRuntimeExports.jsx(Wordmark, { className: "wordmark" }),
    link: trpEnvironmentAware("https://www.troweprice.com/personal-investing/index.html")
  }
};
const Branding = () => {
  const viewContext = useView();
  const { view: { productClass } } = viewContext;
  const brand = brandingLogo[productClass];
  const { component, link } = brand;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "a",
    {
      className: `branding ${productClass}`,
      href: link,
      children: component
    }
  );
};
const Branding$1 = Branding;
const CardTitle = ({ title }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "card-title", children: title });
const CardBody = ({ children }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "card-body", children });
const CardContainer = ({ id = "", children }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    id,
    className: "card-container",
    children
  }
);
const CardFooter = ({ footer }) => footer ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "card-footer", children: footer }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
const Card = ({ id, title, footer, children }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  CardContainer,
  {
    id,
    style: { width: "320px" },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardTitle, { title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardBody, { children }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardFooter, { footer })
    ]
  }
);
const Card$1 = Card;
const ClientOptIn = ({
  options,
  defaultValue = true,
  setToggleCookie = true,
  tagHeading = "Explore Your New Dashboard!",
  tagSubHeading = "We’re always listening as we further enhance your experience to help you make confident investment decisions.",
  isInternal = false
}) => {
  if (!options || options.length < 2) {
    throw new Error("ClientOptIn requires an array of at least two options");
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "application-toggle beacon-on-light", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "client-opt-in-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx(NotificationBanner$1, { title: tagHeading, bodyText: tagSubHeading, rightContent: /* @__PURE__ */ jsxRuntimeExports.jsx(
    OptIn$1,
    {
      setToggleCookie,
      isInternal,
      defaultValue,
      options,
      onCookieValue: "client-portal",
      offCookieValue: "aam-dashboard"
    }
  ), children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "application-toggle beacon-on-light" }) }) }) });
};
const ClientOptIn$1 = ClientOptIn;
const ComponentMapper = ({
  componentList,
  orientation = "horizontal",
  hideIndexList = [],
  className = ""
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      "data-testid": "component-mapper",
      className: `component-mapper ${orientation} ${className}`,
      children: componentList.map((item, index2) => {
        if (hideIndexList.length > 0) {
          if (lodashExports.includes(hideIndexList, index2 + 1)) {
            return;
          }
        }
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: item }, index2);
      })
    }
  );
};
ComponentMapper.propTypes = {
  componentList: propTypesExports.arrayOf(propTypesExports.node).isRequired,
  orientation: propTypesExports.oneOf(["horizontal", "vertical"]),
  hideIndexList: propTypesExports.arrayOf(propTypesExports.number),
  className: propTypesExports.string
};
const ComponentMapper$1 = ComponentMapper;
const FlagIcon = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    width: "14",
    height: "11",
    viewBox: "0 0 14 11",
    fill: "none",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "rect",
        {
          width: "14",
          height: "11",
          fill: "url(#pattern0)"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "pattern",
          {
            id: "pattern0",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "use",
              {
                href: "#image0",
                transform: "scale(0.0714286 0.0909091)"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "image",
          {
            id: "image0",
            width: "14",
            height: "11",
            href: "data:image/png;base64,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"
          }
        )
      ] })
    ]
  }
);
const ClickOffSensor = ({ children, handleClickoff, className }) => {
  const node = useRef();
  const handleDocumentClick = (e5) => {
    if (node.current.contains(e5.target)) {
      return;
    }
    handleClickoff();
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleDocumentClick);
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: node,
      className,
      children
    }
  );
};
ClickOffSensor.propType = {
  children: propTypesExports.element,
  handleClickoff: propTypesExports.func.isRequired,
  className: propTypesExports.string
};
const ClickOffSensor$1 = ClickOffSensor;
const DownArrow = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    className,
    width: "8",
    height: "4",
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: "M8 0L4 4L0 0H8Z",
        fill: "#D8D8D8"
      }
    )
  }
);
const SimpleDropdown = ({ items, displayItem }) => {
  const [on2, setToggle] = useState(false);
  const [selected, setSelectedItem] = useState(displayItem);
  const handleClick = (e5) => setSelectedItem(e5.target.innerText);
  const dropDownItems = items.map(
    (item, i5) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "li",
      {
        onClick: handleClick,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("a", { href: item.url, children: [
          " ",
          item.title
        ] })
      },
      i5
    )
  );
  const carotClassName = classnames(
    "chevron",
    { "chevron-open": on2 }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ClickOffSensor$1,
    {
      handleClickoff: () => setToggle(false),
      className: "ii-simple-dropdown b-typography-sans-serif--caption--200",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Button$1,
          {
            className: "ii-simple-dropdown-button" + (on2 ? "-open" : ""),
            handleClick: () => setToggle(!on2),
            slim: true,
            children: [
              selected,
              /* @__PURE__ */ jsxRuntimeExports.jsx(DownArrow, { className: carotClassName })
            ]
          }
        ),
        on2 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ii-simple-dropdown-list", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ii-dropdown-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { children: dropDownItems }) }) })
      ]
    }
  );
};
const SimpleDropdown$1 = SimpleDropdown;
SimpleDropdown.propTypes = {
  items: propTypesExports.arrayOf(propTypesExports.shape({
    url: propTypesExports.string,
    title: propTypesExports.string
  })).isRequired,
  displayItem: propTypesExports.string.isRequired
};
const partnerLinks = [{
  title: "TRowePrice.com",
  url: trpEnvironmentAware("https://www.troweprice.com/corporate/en/home.html")
}, {
  title: "Personal Investing",
  url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/index.html")
}, {
  title: "Workplace Retirement",
  url: trpEnvironmentAware("https://www.troweprice.com/workplace/en/participant/home.html")
}, {
  title: "Institutional Investors/Consultants",
  url: trpEnvironmentAware("https://www.troweprice.com/institutional/us/en/home.html")
}, {
  title: "Financial Advisor/Intermediary",
  url: trpEnvironmentAware("https://www4.troweprice.com/gis/fai/us/en/home.html")
}, {
  title: "Recordkeeping Sponsor/Consultant",
  url: trpEnvironmentAware("https://www3.troweprice.com/usrps/marketing/index.html")
}];
const ContextualNavigation = ({ isVisible, isLoading }) => {
  const viewContext = useView();
  const { view: { productClass } } = viewContext;
  const showContextualNav = productClass === "RETAIL" && isVisible;
  if (!showContextualNav) {
    return null;
  }
  return isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "contextual-navigation-skeleton" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "contextual-navigation",
      "data-metrics-location": "HDR",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "container", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "contextual-navigation-country-flag", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FlagIcon, { className: "flag" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "contextual-navigation-country b-typography-sans-serif--caption--300", children: "United States" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SimpleDropdown$1,
          {
            items: partnerLinks,
            displayItem: "Personal Investing"
          }
        )
      ] })
    }
  );
};
const ContextualNavigation$1 = ContextualNavigation;
const Link = ({
  active,
  children,
  href = "",
  onClick,
  className,
  target
}) => {
  const classNames = classnames({
    active
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "a",
    {
      href,
      target,
      className: `ii-component-link ${className} ${classNames}`,
      onClick,
      children: children && children
    }
  );
};
Link.propTypes = {
  children: propTypesExports.node,
  href: propTypesExports.string,
  onClick: propTypesExports.func
};
const Link$1 = Link;
const AboutUs = ({ className }) => {
  const viewContext = useView();
  const { view: { productClass, has529Only } } = viewContext;
  const aboutUsLink = {
    [PRODUCT_CLASS.ALASKA_529]: "https://www.alaska529plan.com/why-alaska-529.html",
    [PRODUCT_CLASS.MARYLAND_529]: "https://maryland529.com/About-Us",
    [PRODUCT_CLASS.NATIONAL_529]: trpEnvironmentAware("https://www.troweprice.com/personal-investing/troweprice-529/index.html"),
    [PRODUCT_CLASS.RETAIL]: trpEnvironmentAware("https://www.troweprice.com/personal-investing/products-and-services/college-savings-plans.html")
  };
  return has529Only ? /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link$1,
    {
      href: aboutUsLink[productClass],
      className,
      children: "About Us"
    }
  ) }) : null;
};
const SearchIcon = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    className,
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M7.61536 12.4615C10.2918 12.4615 12.4615 10.2918 12.4615 7.61538C12.4615 4.93893 10.2918 2.76923 7.61536 2.76923C4.93891 2.76923 2.76922 4.93893 2.76922 7.61538C2.76922 10.2918 4.93891 12.4615 7.61536 12.4615ZM13.8901 11.932L17.5945 15.6363C18.1352 16.177 18.1352 17.0537 17.5945 17.5945C17.0537 18.1352 16.1769 18.1352 15.6362 17.5945L11.932 13.8901C10.7051 14.7357 9.21805 15.2308 7.61536 15.2308C3.40951 15.2308 0 11.8212 0 7.61538C0 3.40952 3.40951 0 7.61536 0C11.8212 0 15.2307 3.40952 15.2307 7.61538C15.2307 9.21807 14.7356 10.7051 13.8901 11.932Z" })
  }
);
const rePhraseRules = {
  "Turbo Tax": "turbotax",
  "mrd": "rmd",
  "401k": "401(k)",
  "1099r": "1099-R",
  "1099div": "1099-DIV",
  "1099b": "1099-B",
  "T Rowe Price": "T. Rowe Price",
  "TRowePrice": "T. Rowe Price",
  "TRP": "T. Rowe Price",
  "TRowPrice": "T. Rowe Price",
  "T Row Price": "T. Rowe Price",
  "FAQ": "Frequently Asked Questions",
  "FAQs": "Frequently Asked Questions",
  "FAQâ€™s": "Frequently Asked Questions",
  "forms": "form",
  "cds": "certificates of deposit",
  "cdâ€™s": "certificates of deposit",
  "ownership change form": "change ownership form",
  "403b": "403(b)",
  "Validate": "Verify"
};
const searchSuggestions = [
  "Tax Planning Center",
  "2017 TurboTax Offer",
  "TurboTax FAQs",
  "mutual fund tax information",
  "my 2017 tax forms",
  "account services form",
  "IRA distribution form",
  "ownership change form",
  "beneficiaries transfer on death form",
  "additional investment",
  "additional investment form",
  "mutual fund new account form",
  "mutual fund transfer form",
  "IRA beneficiary form",
  "all service forms",
  "what is my rmd?",
  "rmd calculator",
  "take my rmd",
  "what is a required minimum distribution?",
  "required minimum distribution calculator",
  "take my required minimum distribution",
  "take a withdrawal",
  "research index funds",
  "buy index funds",
  "T. Rowe Price Capital Appreciation Fund (PRWCX)",
  "T. Rowe Price Health Sciences Fund (PRHSX)",
  "T. Rowe Price Blue Chip Growth Fund (TRBCX)",
  "exchange traded funds (etfs)",
  "social security calculator",
  "social security benefits evaluator",
  "401(k) log in",
  "401(k) rollover",
  "roth 401(k)",
  "Morningstar",
  "Morningstar Portfolio Manager",
  "what is a roth ira?",
  "what is a roth ira conversion?",
  "convert to roth ira",
  "quicken downloading / exporting",
  "frequently asked questions",
  "529 college savings plan",
  "Maryland 529 Plan",
  "Alaska 529 Plan",
  "college savings planner tool",
  "T. Rowe Price Global Technology Fund (PRGTX)",
  "change/add beneficiary",
  "rollover ira",
  "rollover check",
  "rollover form",
  "direct rollover",
  "60 day / indirect rollover",
  "account service fee",
  "brokerage services",
  "brokerage commission fee schedule",
  "brokerage important disclosures",
  "fees and minimums",
  "T. Rowe Price Communications & Technology Fund (PRMTX)",
  "ira withdrawals",
  "401(k) loans",
  "withdrawal",
  "distributions",
  "T. Rowe Price Mid-Cap Growth Fund (RPMGX)",
  "T. Rowe Price Growth Stock Fund (PRGFX)",
  "T. Rowe Price Equity Index 500 Fund (PREIX)",
  "Can you take a loan from an ira?",
  "loan payoff",
  "what is cost basis?",
  "find my cost basis",
  "T. Rowe Price Retirement Balanced Fund (TRRIX)",
  "T. Rowe Price International Value Equity Fund (TRIGX)",
  "T. Rowe Price Spectrum Income Fund (RPSIX)",
  "T. Rowe Price High Yield Fund (PRHYX)",
  "T. Rowe Price Value Fund (TRVLX)",
  "go paperless",
  "sign up for paperless statements",
  "T. Rowe Price New Horizons Fund (PRNHX)",
  "T. Rowe Price Personal Strategy Income Fund (PRSIX)",
  "T. Rowe Price Small-Cap Value Fund (PRSVX)",
  "dividend distributions",
  "T. Rowe Price Dividend Growth Fund (PRDGX)",
  "T. Rowe Price Equity Income Fund (PRFDX)",
  "change password",
  "forgot password",
  "T. Rowe Price Balanced Fund (RPBAX)",
  "T. Rowe Price New Income Fund (PRCIX)",
  "careers at T. Rowe Price",
  "T. Rowe Price QM U.S. Small-Cap Growth Equity Fund (PRDSX)",
  "T. Rowe Price QM U.S. Value Equity (TQMVX)",
  "T. Rowe Price QM U.S. Small & Mid-Cap Core Equity (TQSMX)",
  "buy gold",
  "gold funds",
  "T. Rowe Price Tax-Free High Yield Fund (PRFHX)",
  "T. Rowe Price Small-Cap Stock Fund (OTCFX)",
  "retirement income calculator",
  "1099-R",
  "1099-DIV",
  "1099-B",
  "futurepath",
  "T. Rowe Price New Era Fund (PRNEX)",
  "deposit",
  "deposit slip",
  "certificates of deposit",
  "T. Rowe Price European Stock Fund (PRESX)",
  "T. Rowe Price Global Multi-Sector Bond Fund (PRSNX)",
  "money market funds",
  "T. Rowe Price Science & Technology Fund (PRSCX)",
  "T. Rowe Price Mid-Cap Value Fund (TRMCX)",
  "T. Rowe Price Emerging Markets Bond Fund (PREMX)",
  "year-end distributions",
  "2017 distributions",
  "distribution calculator",
  "capital gains distributions",
  "what is a premature distribution?",
  "T. Rowe Price Total Equity Market Index Fund (POMIX)",
  "T. Rowe Price International Discovery Fund (PRIDX)",
  "transfer on death (TOD)",
  "electronic funds transfer (eft)",
  "wire transfer",
  "transfer an IRA",
  "real estate investment trust (REIT)",
  "T. Rowe Price Extended Equity Market Index Fund (PEXMX)",
  "bank verification",
  "verify bank account",
  "Stable Value Fund",
  "Retirement Funds",
  "Target Funds",
  "T. Rowe Price Retirement 2005 Fund (TRRFX)",
  "T. Rowe Price Target 2005 Fund (TRARX)",
  "T. Rowe Price Retirement 2010 Fund (TRRAX)",
  "T. Rowe Price Target 2010 Fund (TRROX)",
  "T. Rowe Price Retirement 2015 Fund (TRRGX)",
  "T. Rowe Price Target 2015 Fund (TRRTX)",
  "T. Rowe Price Retirement 2020 Fund (TRRBX)",
  "T. Rowe Price Target 2020 Fund (TRRUX)",
  "T. Rowe Price Retirement 2025 Fund (TRRHX)",
  "T. Rowe Price Target 2025 Fund (TRRVX)",
  "T. Rowe Price Retirement 2030 Fund (TRRCX)",
  "T. Rowe Price Target 2030 Fund (TRRWX)",
  "T. Rowe Price Retirement 2035 Fund (TRRJX)",
  "T. Rowe Price Target 2035 Fund (RPGRX)",
  "T. Rowe Price Retirement 2040 Fund (TRRDX)",
  "T. Rowe Price Target 2040 Fund (TRHRX)",
  "T. Rowe Price Retirement 2045 Fund (TRRKX)",
  "T. Rowe Price Target 2045 Fund (RPTFX)",
  "T. Rowe Price Retirement 2050 Fund (TRRMX)",
  "T. Rowe Price Target 2050 Fund (TRFOX)",
  "T. Rowe Price Retirement 2055 Fund (TRRNX)",
  "T. Rowe Price Target 2055 Fund (TRFFX)",
  "T. Rowe Price Retirement 2060 Fund (TRRLX)",
  "T. Rowe Price Target 2060 Fund (TRTFX)",
  "T. Rowe Price Personal Strategy Growth Fund (TRSGX)",
  "T. Rowe Price Emerging Markets Stock Fund (PRMSX)",
  "sep ira",
  "T. Rowe Price Personal Strategy Balanced Fund (TRPBX)",
  "T. Rowe Price Short-Term Bond Fund (PRWBX)",
  "T. Rowe Price Spectrum Growth Fund (PRSGX)",
  "advisory checkup",
  "real estate",
  "T. Rowe Price Real Estate Fund (TRREX)",
  "T. Rowe Price New America Growth Fund (PRWAX)",
  "view my statements",
  "year-end statements",
  "monthly statements",
  "T. Rowe Price Tax-Free Income Fund (PRTAX)",
  "inherited ira distribution",
  "inherited ira process",
  "T. Rowe Price New Asia Fund (PRASX)",
  "T. Rowe Price Diversified Mid-Cap Growth Fund (PRDMX)",
  "T. Rowe Price Latin America Fund (PRLAX)",
  "uniform gifts to minors (ugma)",
  "uniform transfers to minors (utma)",
  "mutual fund prospectus/fact sheet",
  "T. Rowe Price mutual funds",
  "T. Rowe Price Intermediate Tax Free High Yield Fund (PRIHX)",
  "T. Rowe Price Global Allocation Fund (RPGAX)",
  "T. Rowe Price offices",
  "T. Rowe Price locations",
  "household recognition program",
  "add a power of attorney (POA)",
  "what is my account number?",
  "what is my investor number?",
  "T. Rowe Price Floating Rate Fund (PRFRX)",
  "T. Rowe Price Government Money Fund (PRRXX)",
  "what is an expense ratio?",
  "T. Rowe Price Spectrum International Fund (PSILX)",
  "T. Rowe Price U.S. Equity Research Fund (PRCOX)",
  "T. Rowe Price Large-Cap Growth Fund (RPGEX)",
  "T. Rowe Price Growth & Income Fund (PRGIX)",
  "T. Rowe Price International Stock Fund (PRITX)",
  "precious metals",
  "bond funds",
  "T. Rowe Price International Concentrated Equity Fund (PRCNX)",
  "T. Rowe Price Africa & Middle East Fund (TRAMX)",
  "form 5498",
  "ira rmd",
  "open an ira",
  "open a roth ira",
  "open a traditional ira",
  "open a non-retirement account",
  "open other type of account",
  "traditional IRA vs. roth ira",
  "security measures",
  "online security",
  "Global High Income Bond Fund (RPIHX)",
  "unclaimed/abandoned property",
  "contribute to my IRA",
  "fixed income center",
  "T. Rowe Price Global Unconstrained Bond Fund (RPIEX)",
  "glossary",
  "T. Rowe Price Tax-Free Short-Intermediate Fund (PRFSX)",
  "403(b) Plans",
  "Contact T. Rowe Price",
  "Investment Planning 101",
  "Investment Basics",
  "small business retirement plans",
  "T. Rowe Price Emerging Markets Value Stock Fund (PRIJX)",
  "T. Rowe Price Limited Duration Inflation Focused Bond Fund (TRBFX)",
  "Morningstar 4- and 5-Star Rated Funds",
  "Wall Street Journal",
  "T. Rowe Price Report",
  "T. Rowe Price QM Global Equity Fund (TQGEX)",
  "T. Rowe Price Investor Magazine",
  "Customer Service",
  "T. Rowe Price phone number",
  "T. Rowe Price Global Consumer Fund (PGLOX)",
  "T. Rowe Price Cash Reserves Fund (TSCXX)",
  "T. Rowe Price Total Return Fund (PTTFX)",
  "Dynamic Global Bond Fund (PRIEX)",
  "T. Rowe Price U.S. High Yield Fund (TUHYX)",
  "T. Rowe Price Retirement Income 2020 Fund (TRLAX)",
  "T. Rowe Price International Bond Fund (USD Hedged) (TNIBX)",
  "T. Rowe Price Multi-Strategy Total Return Fund (TMSRX)"
];
const searchResultsUrl = trpEnvironmentAware("https://www3.troweprice.com/usis/personal-investing/search-results.html");
const SEARCH_RESULT_SIZE = 10;
const Autocomplete = ({ searchSuggestions: searchSuggestions2, rePhraseRules: rePhraseRules2, placeholder = "Search" }) => {
  const [openSearchBox, setSearchBoxToggle] = useState(false);
  const [options, setOptions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [userInput, setUserInput] = useState("");
  const onChange = (e5) => {
    const userInput2 = e5.currentTarget.value;
    let rephraseUserInput;
    if (Object.keys(rePhraseRules2).includes(userInput2)) {
      Object.keys(rePhraseRules2).forEach(function(key) {
        if (key.toLowerCase() === userInput2.toLowerCase()) {
          rephraseUserInput = rePhraseRules2[key];
        }
      });
    }
    const options2 = searchSuggestions2.filter(
      (optionName) => {
        return rephraseUserInput ? optionName.toLowerCase().indexOf(rephraseUserInput.toLowerCase()) > -1 : optionName.toLowerCase().indexOf(userInput2.toLowerCase()) > -1;
      }
    );
    setOptions(options2);
    setShowOptions(true);
    setUserInput(e5.currentTarget.value);
  };
  const handleClick = (e5) => {
    setOptions([]);
    setShowOptions(false);
    setUserInput(e5.target);
    const submitField = document.getElementById("search-input");
    if (submitField) {
      submitField.value = e5.target.innerText;
    }
    document.getElementById("search").submit();
  };
  const getSearchOptionsList = () => {
    let optionList = [];
    if (openSearchBox && showOptions && userInput) {
      if (options.length) {
        optionList = /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "suggestions-box", children: options.slice(0, SEARCH_RESULT_SIZE).map((option) => {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            "li",
            {
              "data-metrics-type": "SRCH",
              onClick: handleClick,
              children: option
            },
            option
          );
        }) });
      }
    }
    return optionList;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ClickOffSensor$1,
    {
      className: "global-search",
      handleClickoff: () => setSearchBoxToggle(false),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "form",
        {
          method: "get",
          action: searchResultsUrl,
          id: "search",
          autoComplete: "off",
          onClick: () => setSearchBoxToggle(true),
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "search-container", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  className: "search-box" + (openSearchBox ? "-open" : ""),
                  onChange,
                  type: "search",
                  id: "search-input",
                  placeholder,
                  name: "q"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(SearchIcon, { className: "search-icon" })
            ] }),
            getSearchOptionsList()
          ]
        }
      )
    }
  );
};
Autocomplete.propTypes = {
  searchSuggestions: propTypesExports.arrayOf(propTypesExports.string).isRequired,
  rePhraseRules: propTypesExports.shape({ string: propTypesExports.string }),
  placeholder: propTypesExports.string
};
const GlobalSearch = ({ search }) => {
  const { placeholder } = search;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Autocomplete,
    {
      searchSuggestions,
      rePhraseRules,
      placeholder
    }
  );
};
GlobalSearch.propTypes = {
  search: propTypesExports.shape({
    placeholder: propTypesExports.string
  })
};
const GlobalSearch$1 = GlobalSearch;
const If = ({
  test,
  component: ChildComponent,
  ...childComponentProps
}) => !test ? null : ChildComponent && /* @__PURE__ */ jsxRuntimeExports.jsx(ChildComponent, { ...childComponentProps });
If.propTypes = {
  test: propTypesExports.bool.isRequired,
  component: propTypesExports.func.isRequired
};
const If$1 = If;
const AccountsContext = React__default.createContext([]);
const generateAccountsView = (accounts) => {
  let accountView = {};
  if (!accounts) {
    return accountView;
  }
  const filteredAccounts = accounts.filter((a2) => !a2.purgedAccount);
  const products = getProducts(filteredAccounts);
  const retailProducts2 = products.filter((p2) => p2 !== PRODUCTS.OMNI_PLAN && p2 !== PRODUCTS.TRAC_PLAN);
  if (products && products.length <= 0) {
    return accountView;
  }
  if (products.some((p2) => p2 === PRODUCTS.MUTUAL_FUND)) {
    accountView["hasMutualFunds"] = true;
  }
  if (products.some((p2) => p2 === PRODUCTS.BROKERAGE)) {
    accountView["hasBrokerage"] = true;
  }
  if (products.some((p2) => p2 === PRODUCTS.ACTIVE_PLUS)) {
    accountView["hasActivePlus"] = true;
  }
  if (products.some((p2) => p2 === PRODUCTS.RETIREMENT_ADVISORY)) {
    accountView["hasRetirementAdvisory"] = true;
  }
  if (retailProducts2.length > 0 && (retailProducts2.some((p2) => p2 === PRODUCTS.MARYLAND_529) || retailProducts2.some((p2) => p2 === PRODUCTS.NATIONAL_529) || retailProducts2.some((p2) => p2 === PRODUCTS.ALASKA_529))) {
    accountView["hasCollegeSavings"] = true;
  }
  if (retailProducts2.length > 0 && retailProducts2.every((p2) => p2 === PRODUCTS.ALASKA_529 || p2 === PRODUCTS.MARYLAND_529 || p2 === PRODUCTS.NATIONAL_529)) {
    accountView["has529Only"] = true;
  }
  if (products.length > 0 && products.every((p2) => p2 === PRODUCTS.RETIREMENT_ADVISORY)) {
    accountView["hasRASOnly"] = true;
  }
  if (retailProducts2.length > 0 && retailProducts2.every((p2) => p2 === PRODUCTS.NATIONAL_529)) {
    accountView["hasNational529Only"] = true;
    accountView["productClass"] = PRODUCT_CLASS.NATIONAL_529;
  }
  if (retailProducts2.length > 0 && retailProducts2.every((p2) => p2 === PRODUCTS.MARYLAND_529)) {
    accountView["hasMaryland529Only"] = true;
    accountView["productClass"] = PRODUCT_CLASS.MARYLAND_529;
  }
  if (retailProducts2.length > 0 && retailProducts2.every((p2) => p2 === PRODUCTS.ALASKA_529)) {
    accountView["hasAlaska529Only"] = true;
    accountView["productClass"] = PRODUCT_CLASS.ALASKA_529;
  }
  if (!retailProducts2.length && products.every((p2) => p2 === PRODUCTS.OMNI_PLAN || p2 === PRODUCTS.TRAC_PLAN)) {
    accountView["hasWorkplaceOnly"] = true;
    accountView["productClass"] = "RETAIL";
  }
  return accountView;
};
function AccountsProvider({ children, accounts }) {
  const viewContext = useView();
  useEffect(() => {
    const { dispatch } = viewContext;
    const accountsView = generateAccountsView(accounts);
    updateView(dispatch, accountsView);
  }, [accounts]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AccountsContext.Provider, { value: accounts, children });
}
const Logout = ({
  className,
  logoutUrl,
  products,
  RouterLink
}) => {
  const logoutPath = logoutUrl || trpEnvironmentAware(`https://www.troweprice.com/usis/login/logout?sdurl=https://www.troweprice.com/usis/my-accounts/post-logout?productTypes=${products}`);
  if (RouterLink && isAccountAccess(logoutPath)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      RouterLink,
      {
        className,
        to: getCurrentRoute(logoutPath),
        children: "Log Out"
      },
      "linked-logout"
    ) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link$1,
    {
      className,
      href: logoutPath,
      children: "Log Out"
    }
  ) });
};
Logout.propTypes = {
  className: propTypesExports.string,
  logoutUrl: propTypesExports.string
};
const Login = ({ className, loginUrl = trpEnvironmentAware("https://www.troweprice.com/usis/login/?pdurl=/clx-tk/token-exchange/redirect/default?sdurl=https%3A%2F%2Fwwwstage.troweprice.com%2Fusis%2Fmy-accounts%2F") }) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  Link$1,
  {
    className,
    href: loginUrl,
    children: "Log In"
  }
) });
Login.propTypes = {
  className: propTypesExports.string,
  loginUrl: propTypesExports.string
};
const Auth = ({ loginUrl, logoutUrl, RouterLink }) => {
  const viewContext = useView();
  const accounts = useContext(AccountsContext);
  const { view: {
    isAuthenticated
  }, dispatch } = viewContext;
  const products = getProducts(accounts);
  return isAuthenticated ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Logout,
    {
      onClick: () => {
        updateActive(dispatch, "logout");
      },
      logoutUrl,
      products,
      RouterLink,
      className: "ii-component-link links"
    },
    "logout"
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    Login,
    {
      loginUrl,
      className: "ii-component-link links",
      onClick: () => {
        updateActive(dispatch, "login");
      }
    },
    "login"
  );
};
const OpenAnAccount = ({ className }) => {
  const viewContext = useView();
  const { view: { productClass } } = viewContext;
  const openAnAccountLink = {
    [PRODUCT_CLASS.ALASKA_529]: trpEnvironmentAware("http://www.troweprice.com/usis/nasu/start/college-savings/alaska"),
    [PRODUCT_CLASS.MARYLAND_529]: trpEnvironmentAware("https://www.troweprice.com/usis/nasu/start/college-savings/maryland"),
    [PRODUCT_CLASS.NATIONAL_529]: trpEnvironmentAware("https://www.troweprice.com/usis/nasu/start/college-savings/national"),
    [PRODUCT_CLASS.RETAIL]: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/fund-research/account-finder")
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link$1,
    {
      className,
      href: openAnAccountLink[productClass],
      children: "Open an Account"
    }
  ) });
};
const DropdownModal = ({ children, footer }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ii-dropdown-modal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ii-dropdown-content", children }),
    footer && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ii-dropdown-footer", children: footer })
  ] });
};
DropdownModal.propTypes = {
  children: propTypesExports.element.isRequired,
  footer: propTypesExports.oneOfType([propTypesExports.string, propTypesExports.element])
};
const DropdownModal$1 = DropdownModal;
const CustomerContext = React__default.createContext([]);
const generateCustomerView = (customer) => {
  let customerView = {};
  if (!customer) {
    return customerView;
  }
  const { isAdvicePlanningClient, isRetirementAdvisoryServiceClient, messageCount, isRMDEligible, isRMDPreEligible, relationshipManager } = customer;
  if (isAdvicePlanningClient) {
    customerView["isAdvicePlanningClient"] = true;
  }
  if (isRetirementAdvisoryServiceClient) {
    customerView["isRetirementAdvisoryServiceClient"] = true;
  }
  if (messageCount) {
    customerView["messageCount"] = messageCount || 0;
  }
  if (isRMDEligible) {
    customerView["isRMDEligible"] = true;
  }
  if (isRMDPreEligible) {
    customerView["isRMDPreEligible"] = true;
  }
  if (relationshipManager) {
    customerView["relationshipManager"] = customer == null ? void 0 : customer.relationshipManager;
  }
  return customerView;
};
function CustomerProvider({ children, customer }) {
  const viewContext = useView();
  useEffect(() => {
    const { dispatch } = viewContext;
    updateView(dispatch, generateCustomerView(customer));
  }, [customer]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CustomerContext.Provider, { value: customer, children });
}
const CardBackground = ({ className, height = 106, width = 365 }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    className,
    width,
    height,
    viewBox: `0 0 ${width} ${height}`,
    fill: "none"
  }
);
const CloseIcon = ({ className, fill = "#959FA6" }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    className,
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.15325 0.0305195L0.0311688 1.0987L4.89351 5.85974L0 10.6208L1.15325 11.75L6.01558 6.95844L10.8779 11.7195L12 10.6208L7.10649 5.89026L12 1.0987L10.8468 0L5.98442 4.76104L1.15325 0.0305195Z",
        fill
      }
    )
  }
);
const MessageIcon = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "message" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M21,5H3A2,2,0,0,0,1,7V18a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V7A2,2,0,0,0,21,5Zm0,1a.76.76,0,0,1,.16,0L12,13.36,2.84,6A.76.76,0,0,1,3,6Zm1,12a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a1.07,1.07,0,0,1,.06-.31l9.63,7.7a.49.49,0,0,0,.62,0l9.63-7.7A1.07,1.07,0,0,1,22,7Z" })
    ]
  }
);
const PhoneIcon = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M6.1666 5.02905C6.74311 4.45254 6.74311 3.51385 6.1666 2.93733L4.59965 1.37038C4.02314 0.793863 3.08444 0.793863 2.50793 1.37038L1.65054 2.22777C0.90402 2.98167 0.785762 4.1421 1.36967 5.02166C3.86792 8.79859 7.20137 12.1321 10.9783 14.6303C11.8579 15.2142 13.0257 15.0959 13.7648 14.3494L14.6222 13.492C15.1987 12.9155 15.1987 11.9768 14.6222 11.4003L13.0552 9.83337C12.4787 9.25685 11.54 9.25685 10.9635 9.83337L10.4387 10.3581C8.71658 8.94642 7.04615 7.276 5.63442 5.55383L6.1666 5.02905Z",
          stroke: "#006894",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M9.50007 0.956531C12.5601 0.956531 15.0435 3.43999 15.0435 6.49997",
          stroke: "#006894",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M9.50007 3.91299C10.9266 3.91299 12.087 5.07342 12.087 6.49993",
          stroke: "#006894",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
const NobodyProfile = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    fill: "none",
    viewBox: "0 0 72 72",
    xmlSpace: "preserve",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "rect",
        {
          fill: "#DDDDDD",
          width: "72",
          height: "72"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fill: "#A8A8A8",
          d: "M0,72c0,0,2.24-14.57,4.5-19.16c2.62-5.32,9.4-4.99,14.05-6.66c6.39-2.29,9.94-4.97,10.18-6.42\n	c0.24-1.45-0.36-4.24-1.09-6.06s-2.06-4.61-3.39-6.3c-1.33-1.7-1.33-4.97-1.21-6.55c0.12-1.58,0.12-9.33,4.49-12.73\n	s7.39-4.36,11.03-4.12s2.18,1.58,4.36,2.3c2.18,0.73,5.7,1.94,6.67,4.49c0.97,2.55,0.48,8.61,0.73,9.58\n	c0.24,0.97,0.73,1.33,0.73,3.03c0,1.7-0.48,3.15-1.82,5.09c-1.33,1.94-3.64,7.76-3.27,10.3c0.36,2.55,5.94,6.42,9.33,7.76\n	c3.39,1.33,10.67,2.55,12.73,6.79S72,72,72,72H0z"
        }
      )
    ]
  }
);
const RelationshipManagerCard$1 = ({ onCloseCard }) => {
  const { relationshipManager } = useContext(CustomerContext);
  const {
    headshot,
    person,
    location,
    phone,
    email
  } = relationshipManager;
  const { displayName } = person;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rm-card b-typography-sans-serif--caption--200", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          className: "rm-card-close-button",
          onClick: () => onCloseCard(),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, {})
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardBackground, { className: "rm-card-heading" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rm-card-profile-picture", children: headshot ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        className: "rm-headshot",
        src: headshot
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(NobodyProfile, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rm-details", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rm-details-manager-info", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "b-typography-sans-serif--body-loose--100", children: displayName }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "b-typography-sans-serif--body-loose--100", children: location ? location : "" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rm-contact b-typography-sans-serif--body--100", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneIcon, { className: "rm-phone-icon" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Toll Free: " }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              className: "rm-contact-phone",
              href: `tel:+${phone}`,
              children: phone ? `${phone}` : "Not Available"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(MessageIcon, { className: "rm-email-icon" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              className: "rm-contact-email",
              href: `mailTo: ${email}`,
              children: email ? email : "Not Available"
            }
          )
        ] })
      ] })
    ] })
  ] });
};
RelationshipManagerCard$1.propTypes = {
  headshot: propTypesExports.string,
  person: propTypesExports.shape({
    displayName: propTypesExports.string
  }),
  location: propTypesExports.string,
  phone: propTypesExports.string,
  email: propTypesExports.string
};
const RelationshipManagerCard$2 = RelationshipManagerCard$1;
const RelationshipManager = ({ isMobile = false }) => {
  const { relationshipManager } = useContext(CustomerContext) || {};
  const { profile } = relationshipManager || "";
  const [on2, setToggle] = useState(false);
  return relationshipManager && !isMobile ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ClickOffSensor$1,
    {
      className: "relationship-manager",
      handleClickoff: () => setToggle(false),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$1,
          {
            className: "relationship-manager-button b-typography-sans-serif--caption--200" + (on2 ? " open" : " closed"),
            handleClick: () => setToggle(!on2),
            primary: true,
            children: "Account Team"
          }
        ),
        on2 && /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownModal$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(RelationshipManagerCard$2, { onCloseCard: () => setToggle(false) }) })
      ]
    }
  ) : relationshipManager && isMobile ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "additional-mobile-link-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link$1,
    {
      className: "icon-links",
      href: lodashExports.toLower(profile)
    }
  ) }) : null;
};
const RelationshipManager$1 = RelationshipManager;
const Trusty$2 = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    width: "50",
    height: "50",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M38.8997 39.9995V39.474C39.1266 35.0479 37.4037 32.2029 32.3738 30.5207L37.7121 27.6018V1.27954H0.945679V32.8295L8.67305 31.9157C8.67305 31.9157 7.06612 32.899 10.6034 37.5312C11.2618 38.2851 11.5119 39.9995 11.5119 39.9995",
          fill: "#FFFFFE"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 0L0.0005565 39.9994H11.512C11.512 39.9994 11.2618 38.285 10.6034 37.5311C8.70029 35.3489 9.1507 32.2628 9.55618 32.7294C10.4675 33.78 11.2458 33.8367 11.2458 33.8367C11.2458 33.8367 9.69651 30.9478 9.69651 28.6411C9.69651 21.1278 12.4777 18.3133 12.4777 18.3133C12.4777 18.3133 12.704 15.2817 12.3169 15.205C11.4277 15.0294 10.2878 14.2683 10.2878 13.2772C8.2632 13.2772 6.9791 14.6922 7.07173 16.7806C7.10501 17.5033 7.61699 17.9822 8.1922 17.9822C8.88168 17.9822 9.13406 17.5406 9.13406 16.9267C9.13406 16.5533 9.32987 16.1956 9.88345 16.1956C10.1125 16.1956 10.5591 16.2906 10.5591 17.6206C10.5591 18.95 9.96498 20.8861 7.394 20.8861C5.57628 20.8861 3.18059 19.5383 3.18059 15.0222C3.18059 10.6156 6.92473 7.35167 10.9595 7.15611C10.6611 7.22945 10.3422 7.32833 9.9966 7.58611C9.18897 8.18889 8.6476 8.89611 8.6476 8.89611C8.6476 8.89611 9.01647 8.91556 9.27828 8.96667C9.60499 9.03055 9.96554 8.89555 10.1708 8.66722C10.3605 8.45611 10.6179 8.19333 10.9285 7.92611C11.7339 7.23222 12.8166 7.21722 13.5383 7.31111C13.7995 7.35611 14.053 7.41111 14.3021 7.47889C13.926 7.57833 13.2482 7.58333 12.3635 8.23333C11.552 8.83055 10.9468 9.54333 10.9468 9.54333C10.9468 9.54333 11.2014 9.68445 11.3528 9.77167C11.5924 9.90945 12.0423 9.825 12.3141 9.56222C12.5421 9.34278 12.8233 9.06555 13.1544 8.82944C14.7187 7.71278 15.9495 8.16555 16.4637 8.45889C16.5486 8.515 16.6335 8.575 16.7172 8.63555C16.4393 8.66611 15.5507 8.8 14.626 9.31611C13.7457 9.80722 12.841 10.8061 12.841 10.8061C12.841 10.8061 13.0846 11 13.2188 11.1072C13.4484 11.2894 13.8983 11.2483 14.2 10.9606C14.4718 10.7017 14.8207 10.3917 15.1785 10.1522C16.2934 9.40444 17.4427 9.35666 17.6053 9.35389C17.8776 9.61889 17.9775 9.84945 18.2393 9.84945C18.5244 9.84945 18.723 9.63055 18.9559 9.32944C19.0963 9.31333 19.717 9.28944 20.7637 9.90778C21.1719 10.1489 21.3733 10.3267 21.5391 10.465C21.8963 10.7639 22.1665 10.7022 22.3262 10.5439C22.4471 10.4233 22.6335 10.2089 22.6335 10.2089C22.6335 10.2089 22.0921 9.52222 21.1974 9.05611C20.3826 8.63111 19.7769 8.61722 19.5605 8.62944C19.6676 8.53 19.7813 8.43445 19.9017 8.34556C20.3005 8.11222 21.0599 7.91333 22.2386 8.56111C22.5769 8.74667 22.806 8.94111 22.9641 9.11056C23.151 9.31056 23.5099 9.36333 23.688 9.225C23.9104 9.05222 24.0868 8.99111 24.0868 8.99111C24.0868 8.99111 23.6103 8.29445 22.709 7.84334C22.3179 7.64722 21.9357 7.57611 21.6695 7.55056C22.1859 7.435 22.7217 7.40167 23.242 7.47222C25.5445 7.78278 26.234 10.3383 26.0909 12.5694C25.8496 16.3056 25.9772 17.2078 26.8769 17.2122C27.395 17.215 27.6385 16.7739 27.6995 16.3806C27.7727 15.9067 27.9114 15.5333 28.2165 15.5333C28.846 15.5333 28.993 16.1383 28.993 16.5333C28.993 19.0261 27.39 19.5289 26.0149 19.5289C24.6387 19.5289 23.5831 18.4594 23.2126 16.6128C23.095 16.0244 23.0041 15.4367 23.0041 15.4367C23.0041 15.4367 22.7938 15.4717 22.4333 15.6517C22.0788 15.8294 21.7183 16.06 21.7183 16.06C21.7183 16.06 22.1077 16.9739 22.1914 17.2356C22.2763 17.4972 22.091 18.7233 22.091 18.7233C22.091 18.7233 24.3331 21.8678 24.3331 26.7861C24.3331 31.4467 22.6075 35.7083 21.4249 37.2928C21.7654 37.2033 22.2292 37.0244 22.4 36.8561C23.5083 35.7706 23.79 35.5611 24.9566 35.4572C25.6982 33.5139 25.9583 31.1167 25.2134 25.6817C29.4512 28.6567 29.5799 31.1467 28.9781 33.8678C31.6367 32.5067 30.1473 29.8261 30.1473 29.8261C30.1473 29.8261 31.1092 30.4878 32.1941 30.9322C37.1253 32.9544 38.8998 35.6167 38.8998 39.4739V39.9994H39.9376V0H0Z",
          fill: "#33B8C9"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.8683 18.6695C20.6431 18.645 20.6376 18.6339 20.6365 18.0728C20.6365 17.6339 20.87 17.6267 21.2827 17.7461C21.3287 17.4684 21.4646 16.6567 21.1329 16.6567C20.8839 16.6567 20.6925 16.8511 20.3652 16.8511C19.9819 16.8511 19.2331 16.5906 18.9746 16.5906C18.4876 16.5906 18.7383 17.4461 18.7383 17.785C19.7074 17.6578 20.1101 17.515 20.1101 17.9689C20.1101 18.7278 20.2349 18.6072 19.0135 18.7139C18.3811 18.7678 18.0217 18.8011 17.6439 18.81C17.6439 18.81 17.2867 17.3811 17.4747 17.0956C17.7887 16.6167 18.1526 16.1411 18.5392 15.7084C18.7672 15.4522 18.7672 15.4522 18.6512 15.0984C18.4932 14.6217 17.8763 12.7356 17.8763 12.7356C17.6922 12.1439 18.0716 11.57 18.2746 11.2889C18.3839 11.1378 18.3051 11.0756 18.192 11.1306C17.5846 11.4245 16.6172 12.0534 16.6549 12.8978C16.6843 13.57 16.3986 13.4667 15.8906 13.3489C15.4817 13.2556 15.0069 13.1706 14.5604 13.2478C13.8865 13.3645 13.4738 13.8539 13.5642 14.3239C13.6435 14.7422 14.0068 15.1206 15.0696 15.1206C16.0986 15.1206 16.2095 14.4934 16.6699 15.3206C17.0626 16.0228 17.3904 16.2345 16.8352 16.79C15.4568 18.1717 15.4085 17.7228 15.4085 19.1267C15.4085 20.6072 16.9733 21.7711 17.8253 21.5006C18.2724 21.3595 19.6014 21.0695 19.9154 20.8406C19.9625 20.8056 19.9531 20.6911 19.8882 20.69C19.5864 20.6867 18.4233 20.6922 18.3328 20.27C18.2419 19.8478 18.1742 19.5345 18.1742 19.5345C18.6335 19.4628 19.1815 19.3478 20.2277 19.3595C20.8916 19.3667 21.3809 19.4322 21.3809 19.4322C21.3809 19.4322 21.484 19.1533 21.484 18.7678C21.3814 18.7461 21.1851 18.7011 20.8683 18.6695Z",
          fill: "#33B8C9"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.04 14.701C21.4549 14.9171 21.8204 14.9093 22.2503 14.7632C23.0136 14.5032 23.1029 13.6243 22.2653 13.4799C21.613 13.3671 21.4038 13.7071 21.0061 13.3354C20.7277 13.0765 20.5496 12.8993 20.356 12.7116C20.27 12.6299 20.1857 12.5649 20.1436 12.5804C20.1003 12.596 20.082 12.6477 20.1369 12.7793C20.1941 12.9143 20.8247 14.5882 21.04 14.701Z",
          fill: "#33B8C9"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M33.5202 24.4805C34.5575 24.4805 35.4272 25.301 35.4272 26.3771C35.4272 27.471 34.5575 28.2916 33.5202 28.2916C32.4768 28.2916 31.6021 27.471 31.6021 26.3771C31.6021 25.301 32.4768 24.4805 33.5202 24.4805Z",
          fill: "#FFFFFE"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M34.0956 27.4968L33.4887 26.5396H33.1232V27.4968H32.7771V25.2696H33.638C34.1666 25.2696 34.4151 25.479 34.4151 25.9073C34.4151 26.3107 34.1616 26.4785 33.8304 26.5135L34.4667 27.4968H34.0956ZM33.5204 24.7612C32.6306 24.7612 31.9473 25.4635 31.9473 26.3773C31.9473 27.309 32.6306 28.0118 33.5204 28.0118C34.4001 28.0118 35.0824 27.309 35.0824 26.3773C35.0824 25.4635 34.4001 24.7612 33.5204 24.7612Z",
          fill: "#33B8C9"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M34.07 25.892C34.07 25.5959 33.8154 25.5498 33.5808 25.5498H33.1232V26.2598H33.4837C33.7899 26.2598 34.07 26.2426 34.07 25.892Z",
          fill: "#33B8C9"
        }
      )
    ]
  }
);
const Trusty = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "trusty", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Trusty$2, {}) });
const Trusty$1 = Trusty;
const HamburgerIcon = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    className,
    width: "24",
    height: "16",
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M0 16H24V13.3333H0V16ZM0 9.33333H24V6.66667H0V9.33333ZM0 0V2.66667H24V0H0Z" })
  }
);
const ArrowIcon = ({ className, onClick }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    className,
    onClick,
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: "M14 6.125H3.35125L8.2425 1.23375L7 0L0 7L7 14L8.23375 12.7663L3.35125 7.875H14V6.125Z",
        fill: "#B4BABF"
      }
    )
  }
);
const MessageIconBeacon = () => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "24", height: "16", viewBox: "0 0 24 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", slot: "icon", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 14.5V1.5H22.5V14.5H1.5ZM0 1C0 0.447715 0.447715 0 1 0H23C23.5523 0 24 0.447715 24 1V15C24 15.5523 23.5523 16 23 16H1C0.447716 16 0 15.5523 0 15V1ZM4.45 4.4C4.11863 4.15147 3.64853 4.21863 3.4 4.55C3.15147 4.88137 3.21863 5.35147 3.55 5.6L11.55 11.6C11.8167 11.8 12.1833 11.8 12.45 11.6L20.45 5.6C20.7814 5.35147 20.8485 4.88137 20.6 4.55C20.3515 4.21863 19.8814 4.15147 19.55 4.4L12 10.0625L4.45 4.4Z", fill: "currentColor" }) });
const MessageCenter = ({ className, RouterLink, beacon = false }) => {
  const viewContext = useView();
  const { view: { productClass, messageCount, active }, dispatch } = viewContext;
  const messageCenterUrl = trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/message-center", true);
  const label = "Messages";
  const containerClassName = classnames(
    "ii-nav-message-center-container",
    className
  );
  const badgeClassName = classnames(
    "badge",
    "b-typography-sans-serif--caption--200",
    "b-flow-space--micro--mini",
    {
      "hide-badge": messageCount <= 0
    },
    { [`${productClass}-badge`]: productClass === PRODUCT_CLASS.ALASKA_529 || productClass === PRODUCT_CLASS.MARYLAND_529 }
  );
  const linkClassName = classnames(
    "message-center-button-link",
    "b-typography-sans-serif--caption--200",
    {
      active: active === lodashExports.toLower(label)
    }
  );
  return RouterLink ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    "span",
    {
      className: containerClassName,
      onClick: () => updateActive(dispatch, label),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        RouterLink,
        {
          className: linkClassName,
          "aria-label": "Message Center",
          active: active === lodashExports.toLower(label),
          to: getCurrentRoute(messageCenterUrl),
          children: [
            beacon ? /* @__PURE__ */ jsxRuntimeExports.jsx(MessageIconBeacon, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(MessageIcon, { className: "message-center" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: badgeClassName, children: messageCount }),
            !beacon
          ]
        }
      )
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: containerClassName, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "a",
    {
      className: linkClassName,
      "aria-label": "Message Center",
      href: messageCenterUrl,
      children: [
        beacon ? /* @__PURE__ */ jsxRuntimeExports.jsx(MessageIconBeacon, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(MessageIcon, { className: "message-center" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: badgeClassName, children: messageCount }),
        !beacon
      ]
    }
  ) });
};
const MessageCenter$1 = MessageCenter;
const MobileCloseIcon = ({ className, onClick }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    onClick,
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.7446 30.3936C7.67026 30.3936 1.10049 23.8309 1.10049 15.7496C1.10049 7.72245 7.67026 1.1055 15.7446 1.1055C23.8194 1.1055 30.3886 7.72245 30.3886 15.7496C30.3886 23.8309 23.8194 30.3936 15.7446 30.3936ZM15.7446 0.020752C7.07202 0.020752 0.0157471 7.0716 0.0157471 15.7496C0.0157471 24.4275 7.07202 31.4784 15.7446 31.4784C24.4176 31.4784 31.4734 24.4275 31.4734 15.7496C31.4734 7.0716 24.4176 0.020752 15.7446 0.020752Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.5114 15.7495L21.5517 10.7055C21.7638 10.5428 21.7638 10.1631 21.5517 9.94616C21.3402 9.72921 20.9969 9.72921 20.7848 9.94616L15.7445 14.9902L10.7043 9.94616C10.4927 9.72921 10.1494 9.72921 9.93735 9.94616C9.72582 10.1631 9.72582 10.5428 9.93735 10.7055L14.9776 15.7495L9.39497 21.336C9.18345 21.5529 9.18345 21.9326 9.39497 22.0953C9.50128 22.2038 9.63958 22.258 9.77843 22.258C9.91728 22.258 10.0561 22.2038 10.1619 22.0953L15.7445 16.5631L21.3272 22.0953C21.4335 22.2038 21.5718 22.258 21.7106 22.258C21.8495 22.258 21.9883 22.2038 22.0941 22.0953C22.3062 21.9326 22.3062 21.5529 22.0941 21.336L16.5114 15.7495Z",
          fill: "white"
        }
      )
    ]
  }
);
const MobileHeader = ({
  external = false,
  href = "",
  text: text2 = "BACK",
  onClose,
  onBackButton
}) => {
  return external ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ii-header", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "public-link-group", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ArrowIcon,
        {
          className: "back-arrow",
          onClick: onClose
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Link$1,
        {
          href,
          className: "public-link",
          children: text2 && text2
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      MobileCloseIcon,
      {
        className: "close-button",
        onClick: onClose
      }
    )
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ii-header", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Button$1,
      {
        className: "back-link b-typography-sans-serif--caption--200",
        handleClick: onBackButton,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowIcon, { className: "back-arrow" }),
          text2 && text2
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      MobileCloseIcon,
      {
        className: "close-button",
        onClick: onClose
      }
    )
  ] });
};
MobileHeader.propTypes = {
  href: propTypesExports.string,
  external: propTypesExports.bool,
  text: propTypesExports.string.isRequired,
  onClose: propTypesExports.func.isRequired,
  onBackButton: propTypesExports.func
};
const MobileButtons = ({ loginUrl, logoutUrl, openAnAccountClass, RouterLink }) => {
  const openAnAccountClasses = classnames(
    "open-an-account",
    { [`${openAnAccountClass}-button`]: openAnAccountClass === PRODUCTS.ALASKA_529 || openAnAccountClass === PRODUCTS.MARYLAND_529 }
  );
  const viewContext = useView();
  const {
    view: {
      isAuthenticated
    }
  } = viewContext;
  const accounts = useContext(AccountsContext);
  const products = getProducts(accounts);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mobile-buttons b-typography-sans-serif--caption--300", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(OpenAnAccount, { className: openAnAccountClasses }),
    isAuthenticated ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      Logout,
      {
        className: "logout",
        products,
        logoutUrl,
        RouterLink
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
      Login,
      {
        className: "login",
        loginUrl
      }
    )
  ] });
};
const adviceUrl = trpEnvironmentAware("https://www.troweprice.com/usis/advice/fps");
const PlanningService = ({ containerClassName, className }) => {
  const viewContext = useView();
  const { view: { isAdvicePlanningClient, isRetirementAdvisoryServiceClient } } = viewContext;
  return isAdvicePlanningClient && !isRetirementAdvisoryServiceClient ? /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: containerClassName, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link$1,
    {
      className,
      href: adviceUrl,
      children: "Planning Service"
    }
  ) }) : null;
};
const Slider = ({ children, trigger, stack, stackactions }) => {
  const [id, setId] = useState(null);
  const generateId = () => {
    const random = Math.random();
    setId(random);
  };
  useEffect(() => {
    if (id == null) {
      generateId();
    }
  }, []);
  const pushToStack = (id2) => {
    const { push } = stackactions;
    try {
      push(id2);
    } catch (e5) {
      if (e5 === "Already Exists") {
        generateId();
        pushToStack(id2);
      } else {
        return;
      }
    }
  };
  const overlayClassname = classnames(
    "mobile-overlay",
    {
      open: stack && stack.some((x2) => x2 === id)
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "trigger-container",
        onClick: () => pushToStack(id),
        children: trigger && trigger
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: overlayClassname, children: Children.map(children, (child) => {
      return React__default.cloneElement(child, {
        ...child.props,
        stack,
        stackactions
      });
    }) })
  ] });
};
Slider.propTypes = {
  children: propTypesExports.node.isRequired,
  trigger: propTypesExports.node.isRequired,
  stack: propTypesExports.array.isRequired,
  stackactions: propTypesExports.shape({
    pop: propTypesExports.func.isRequired,
    push: propTypesExports.func.isRequired,
    isStackEmpty: propTypesExports.func.isRequired,
    peek: propTypesExports.func.isRequired,
    emptyStack: propTypesExports.func.isRequired
  })
};
const Slider$1 = Slider;
const generateRetirementAdvisoryServiceLinks$1 = () => {
  return [
    {
      text: "Add",
      subText: "using money from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/advisory/add", false)
    },
    {
      text: "Withdraw",
      subText: "and receive the proceeds",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/advisory/withdraw", false),
      modal: null
    },
    {
      text: "Automatic Transactions",
      subText: "from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/automatic", false)
    },
    {
      text: "Transfer Accounts",
      subText: "to your managed portfolio",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/advice/checkout/transfer/", false)
    }
  ];
};
const generateActivePlusPortfoliosLinks$1 = () => {
  return [
    {
      text: "Add",
      subText: "using money from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/advisory/add", false)
    },
    {
      text: "Withdraw",
      subText: "and receive the proceeds",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/app/withdraw", false)
    },
    {
      text: "Automatic Transactions",
      subText: "from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/automatic", false)
    },
    {
      text: "Other Transactions",
      subText: "within your account",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/landing", false)
    }
  ];
};
const generateAdvisoryAccountsLinks$1 = () => {
  return [
    {
      text: "Add",
      subText: "using money from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/advisory/add", false)
    },
    {
      text: "Withdraw",
      subText: "and receive the proceeds",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/app/withdraw", false)
    },
    {
      text: "Automatic Transactions",
      subText: "from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/automatic", false)
    },
    {
      text: "Other Transactions",
      subText: "within your account",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/landing", false)
    }
  ];
};
const generateMutualFundLinks$1 = () => {
  return [
    {
      text: "Buy",
      subText: "using money from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/buy?productType=MutualFund", false)
    },
    {
      text: "Sell",
      subText: "and receive the proceeds",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/sell?productType=MutualFund", false)
    },
    {
      text: "Exchange",
      subText: "between mutual funds",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/exchange", false)
    },
    {
      text: "Automatic Transactions",
      subText: "in and out of your mutual funds",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/automatic", false)
    }
  ];
};
const generateCollegeSavingsLinks$1 = () => {
  return [
    {
      text: "Contribute",
      subText: "using savings from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/college/contribute", false)
    },
    {
      text: "Distribute",
      subText: "for educational expenses",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/college/distribute", false)
    },
    {
      text: "Exchange",
      subText: "between portfolios",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/college/exchange", false)
    },
    {
      text: "Automatic Monthly Contributions",
      subText: "from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/automatic", false)
    }
  ];
};
const BROKERAGE_LINKS$1 = [
  {
    text: "Trade Stocks & ETFs",
    subText: "within your brokerage account",
    link: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/external-authorization?vendor=PERSHING&selectedAccountId=undefined&target=TRADING", true)
  },
  {
    text: "Trade Mutual Funds",
    subText: "within your brokerage account",
    link: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/external-authorization?vendor=PERSHING&selectedAccountId=undefined&target=MF_TRADING", true)
  },
  {
    text: "Trade Options",
    subText: "if your account is approved",
    link: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/external-authorization?vendor=PERSHING&selectedAccountId=undefined&target=OPT_TRADING", true)
  },
  {
    text: "Withdraw from Sweep Account",
    subText: "and receive the proceeds",
    link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/sell?productType=MutualFund"),
    type: "SWEEP"
  }
];
const BROKERAGE_TRADING_ENABLED_LINKS = [
  {
    text: "Trade Stocks & ETFs",
    subText: "within your brokerage account",
    link: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/brokerage?selectedAccountId=undefined&target=TRADING", true)
  },
  {
    text: "Trade Mutual Funds",
    subText: "within your brokerage account",
    link: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/brokerage?selectedAccountId=undefined&target=MF_TRADING", true)
  },
  {
    text: "Trade Options",
    subText: "if your account is approved",
    link: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/brokerage?selectedAccountId=undefined&target=TRADING", true)
  },
  {
    text: "Withdraw from Sweep Account",
    subText: "and receive the proceeds",
    link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/sell?productType=MutualFund"),
    type: "SWEEP",
    customerWebViewEnabledLink: true
  }
];
const getSweepAccountIds$1 = (accounts) => accounts.reduce((sweepAccounts, account) => {
  if (account.sweepAccount) {
    sweepAccounts.push(account.accountId);
  }
  return sweepAccounts;
}, []);
const brokerageLinkDestination$1 = (linkInfo, accounts, isCustomerWebView, customerWebViewEnabledLink = false) => {
  if (isCustomerWebView && !customerWebViewEnabledLink) {
    return null;
  }
  if (linkInfo.type && linkInfo.type === "SWEEP") {
    const sweepAccounts = getSweepAccountIds$1(accounts);
    const sweepAccountId = sweepAccounts.length ? `?selectedAgreementIDs=${sweepAccounts}` : "";
    return linkInfo.link + sweepAccountId;
  }
  return linkInfo.link;
};
const appendUberId$1 = (uberId, link) => {
  return uberId ? link && link.indexOf("?") === -1 ? `${link}?uid=${uberId}` : `${link}&uid=${uberId}` : link;
};
const rasLinkDestination$1 = (linkInfo) => {
  if (linkInfo.modal) {
    return linkInfo.modal;
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { href: linkInfo.link, children: linkInfo.text });
  }
};
const generateLinks$2 = (view, brokerageTradingEnabled) => {
  const {
    hasRetirementAdvisory,
    hasActivePlus,
    hasMutualFunds,
    hasCollegeSavings,
    hasBrokerage: hasBrokerage2,
    productClass
  } = view;
  let obj = {};
  if (hasRetirementAdvisory || hasActivePlus) {
    if (hasRetirementAdvisory && !hasActivePlus) {
      obj["Retirement Advisory Service"] = generateRetirementAdvisoryServiceLinks$1();
    } else if (!hasRetirementAdvisory && hasActivePlus) {
      obj["ActivePlus Portfolios"] = generateActivePlusPortfoliosLinks$1();
    } else {
      obj["Advisory Accounts"] = generateAdvisoryAccountsLinks$1();
    }
  }
  if (hasMutualFunds) {
    obj["Mutual Funds"] = generateMutualFundLinks$1();
  }
  if (hasBrokerage2 && !brokerageTradingEnabled) {
    obj["Brokerage"] = BROKERAGE_LINKS$1;
  }
  if (brokerageTradingEnabled && hasBrokerage2) {
    obj["Brokerage"] = BROKERAGE_TRADING_ENABLED_LINKS;
  }
  if (hasCollegeSavings) {
    if (productClass === PRODUCT_CLASS.ALASKA_529) {
      obj["529 Plans"] = generateCollegeSavingsLinks$1();
    } else {
      obj["529 College Savings Plans"] = generateCollegeSavingsLinks$1();
    }
  }
  return obj;
};
const LinkGroups$1 = ({ brokerageTradingEnabled, isMobile = false, RouterLink }) => {
  const viewContext = useView();
  const { view } = viewContext;
  const customer = useContext(CustomerContext);
  const accounts = useContext(AccountsContext);
  const {
    customerWebViewEnabled
  } = view;
  const uberId = customerWebViewEnabled ? customer.uberId : "";
  const links = generateLinks$2(view, brokerageTradingEnabled);
  const alwaysOpen = Object.keys(links).length <= 2 && isMobile || !isMobile;
  const getbrokerageLinkClassName = (customerWebViewEnabledLink) => {
    return classnames(
      {
        "disabled": customerWebViewEnabled && !customerWebViewEnabledLink
      }
    );
  };
  return lodashExports.map(
    links,
    (label, key) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "ii-link-group",
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Accordion$1,
          {
            title: key,
            className: "ii-link-group-label",
            alwaysOpen,
            showCaret: !alwaysOpen,
            addDivider: isMobile,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-divider" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { children: lodashExports.map(
                links[key],
                (linkInfo, i5) => {
                  const {
                    link,
                    subText,
                    text: text2,
                    type,
                    customerWebViewEnabledLink
                  } = linkInfo;
                  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    "li",
                    {
                      className: "ii-link",
                      children: [
                        key === "Brokerage" && !RouterLink && /* @__PURE__ */ jsxRuntimeExports.jsx(
                          Link$1,
                          {
                            className: getbrokerageLinkClassName(customerWebViewEnabledLink),
                            href: brokerageLinkDestination$1(linkInfo, accounts, customerWebViewEnabled, customerWebViewEnabledLink),
                            target: type && type === "SWEEP" || brokerageTradingEnabled ? "_self" : "_blank",
                            children: text2
                          }
                        ),
                        key === "Brokerage" && RouterLink && /* @__PURE__ */ jsxRuntimeExports.jsx(
                          RouterLink,
                          {
                            className: getbrokerageLinkClassName(customerWebViewEnabledLink),
                            to: getCurrentRoute(brokerageLinkDestination$1(linkInfo, accounts, customerWebViewEnabled, customerWebViewEnabledLink)),
                            children: text2
                          }
                        ),
                        key === "ActivePlus Portfolios" && /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { href: appendUberId$1(uberId, link), children: text2 }),
                        key === "Retirement Advisory Service" && rasLinkDestination$1(linkInfo),
                        key !== "Brokerage" && key !== "ActivePlus Portfolios" && key !== "Retirement Advisory Service" && /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { href: link, children: text2 }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ii-additional-link-subtext b-typography-sans-serif--body--100 ii-additional-link-spacing", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ii-additional-link-subtext", children: subText }) })
                      ]
                    },
                    key + "-" + i5
                  );
                }
              ) })
            ]
          }
        )
      },
      key
    )
  );
};
const TransactionsMenu$1 = ({ isMobile, brokerageTradingEnabled, RouterLink }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ii-transactions-menu", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    LinkGroups$1,
    {
      brokerageTradingEnabled,
      isMobile,
      RouterLink
    }
  ) });
};
const TransactionsMenu$2 = TransactionsMenu$1;
const LinkGenerator = ({
  className,
  label,
  url,
  dispatch,
  active,
  RouterLink,
  idx,
  nestedUrl,
  clickHandler
}) => {
  return RouterLink && isAccountAccess(url) && url.indexOf("dashboard") === -1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    RouterLink,
    {
      className,
      to: `${nestedUrl ? nestedUrl + getCurrentRoute(url) : getCurrentRoute(url)}`,
      onClick: () => {
        updateActive(dispatch, label);
        clickHandler ? clickHandler() : lodashExports.noop;
      },
      active,
      children: label
    },
    `${idx}-${label}`
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link$1,
    {
      className,
      onClick: () => {
        updateActive(dispatch, label);
        clickHandler ? clickHandler() : lodashExports.noop;
      },
      active,
      href: url,
      children: label
    },
    `${idx}-${label}`
  );
};
const goTuitionLabel = () => "GoTuition<sup>&reg;</sup> Gifting Portal";
const moreDropDownLinks = {
  [PRODUCT_CLASS.RETAIL]: {
    dailyClosingPrices: {
      label: "Daily Closing Prices",
      url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/fund-research/daily-prices")
    },
    mfResearchTool: {
      label: "Mutual Fund Research Tool",
      url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/fund-research/")
    },
    historicalPerformance: {
      label: "Historical Performance",
      url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/fund-research/historical-performance")
    },
    morningStarManager: {
      label: "Morningstar Portfolio Manager",
      url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/resources/tools/morningstar-portfolio-manager.html")
    },
    retirementIncomeCalculator: {
      label: "Retirement Income Calculator",
      url: trpEnvironmentAware("https://www.troweprice.com/usis/advice/tools/retirement-income-calculator")
    },
    watchlist: {
      label: "Watchlist",
      url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/fund-research/watchlist")
    },
    analysisNews: {
      label: "Analysis & News",
      url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/resources/research-and-analysis/index.html")
    }
  },
  [PRODUCT_CLASS.MARYLAND_529]: {
    ourPlans: {
      label: "Why Maryland 529?",
      url: "https://maryland529.com/WhyMD529"
    },
    toolsAndResources: {
      label: "Account Holder Resources",
      url: "https://maryland529.com/Account-Holders/Maryland-College-Investment-Plan"
    },
    investmentOptions: {
      label: "Investment Options",
      url: "https://maryland529.com/Investment-Plan/Investment-Options"
    },
    goTuition: {
      label: goTuitionLabel(),
      url: trpEnvironmentAware("https://www.troweprice.com/usis/go-tuition-profile/maryland-529/dashboard")
    }
  },
  [PRODUCT_CLASS.ALASKA_529]: {
    ourPlan: {
      label: "Why Alaska 529",
      url: "https://www.alaska529plan.com/why-alaska-529.html"
    },
    toolsAndResources: {
      label: "Account Holder Tools",
      url: "https://www.alaska529plan.com/account-holder.html"
    },
    investmentOptions: {
      label: "Investment Options",
      url: "https://www.alaska529plan.com/investment-options.html"
    },
    goTuition: {
      label: goTuitionLabel(),
      url: trpEnvironmentAware("https://www.troweprice.com/usis/go-tuition-profile/alaska-529/dashboard")
    }
  },
  [PRODUCT_CLASS.NATIONAL_529]: {
    ourPlan: {
      label: "Benefits of a 529",
      url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/troweprice-529/benefits-of-a-529.html")
    },
    toolsAndResources: {
      label: "Account Holder Tools",
      url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/troweprice-529/account-holders.html")
    },
    investmentOptions: {
      label: "Investment Options",
      url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/troweprice-529/investment-options.html")
    },
    goTuition: {
      label: goTuitionLabel(),
      url: trpEnvironmentAware("https://www.troweprice.com/usis/go-tuition-profile/national-529/dashboard")
    }
  }
};
const generateComponentList$2 = (links, dispatch) => {
  if (!links) {
    return [];
  }
  return lodashExports.map(links, (link) => {
    const { label, url } = link || {};
    return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "ii-more-dropdown-link-item", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link$1,
      {
        className: "ii-more-links b-typography-sans-serif--caption--200",
        href: url,
        target: "_blank",
        onClick: () => updateActive(dispatch, label),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { "__html": label } })
      }
    ) });
  });
};
const MoreLinksDropdown = ({ offSetSpacing = null }) => {
  const [on2, setToggle] = useState(false);
  const viewContext = useView();
  const { view: { productClass }, dispatch } = viewContext;
  const links = moreDropDownLinks[productClass];
  const componentList = generateComponentList$2(links, dispatch);
  const containerClassName = classnames(
    "ii-links-container",
    {
      "small-offset": offSetSpacing === "small"
    },
    {
      "medium-offset": offSetSpacing === "medium"
    },
    {
      "large-offset": offSetSpacing === "large"
    }
  );
  const caretClassname = classnames(
    "toggle-arrow",
    { "toggle-open": on2 }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ClickOffSensor$1,
    {
      handleClickoff: () => setToggle(false),
      className: "ii-more-dropdown",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "a",
          {
            className: `ii-toggle-button b-typography-sans-serif--caption--300 ${on2 && "open"}`,
            onClick: () => {
              setToggle(!on2);
              updateActive(dispatch, "more");
            },
            children: [
              productClass === PRODUCT_CLASS.RETAIL ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: " Research " }) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: " More " }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronDown, { className: caretClassname })
            ]
          }
        ),
        on2 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${containerClassName}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "links-list", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ComponentMapper$1,
          {
            componentList,
            orientation: "vertical"
          }
        ) }) })
      ]
    }
  );
};
MoreLinksDropdown.propTypes = {
  offSetSpacing: propTypesExports.string
};
const MoreLinksDropdown$1 = MoreLinksDropdown;
const ProfileIcon = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "profile" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM4.65,20.17a32.08,32.08,0,0,1,4-1.64L10.18,18a.51.51,0,0,0,.32-.47V15a.51.51,0,0,0-.33-.47C10.12,14.51,9,14.07,9,12a.48.48,0,0,0-.48-.49A.76.76,0,0,1,8.38,11a.88.88,0,0,1,.12-.5A.5.5,0,0,0,9,10a2.23,2.23,0,0,0-.12-.54c-.13-.49-.55-2-.17-2.39.14-.15.45-.13.69-.08A.5.5,0,0,0,10,6.62C10.15,6,11.31,5.5,12.75,5.5s2.6.47,2.76,1.12a5.76,5.76,0,0,1-.37,2.8A1.9,1.9,0,0,0,15,10a.48.48,0,0,0,.48.49.76.76,0,0,1,.14.51.88.88,0,0,1-.12.5.5.5,0,0,0-.5.5c0,2.07-1.12,2.51-1.16,2.53a.49.49,0,0,0-.34.47v2.5a.5.5,0,0,0,.32.47l1.62.59a32.65,32.65,0,0,1,3.92,1.6,11,11,0,0,1-14.71,0Zm15.46-.74a27.9,27.9,0,0,0-4.33-1.81l-1.28-.47V15.31A3.47,3.47,0,0,0,16,12.37,1.53,1.53,0,0,0,16.62,11a1.6,1.6,0,0,0-.52-1.29,6.58,6.58,0,0,0,.39-3.33C16.14,5,14.26,4.5,12.75,4.5c-1.34,0-3,.39-3.57,1.46A1.51,1.51,0,0,0,8,6.39c-.75.81-.31,2.42-.06,3.31A1.58,1.58,0,0,0,7.38,11,1.53,1.53,0,0,0,8,12.37,3.47,3.47,0,0,0,9.5,15.31v1.84l-1.18.44A29.18,29.18,0,0,0,3.9,19.44,11,11,0,1,1,23,12,10.91,10.91,0,0,1,20.11,19.43Z" })
    ]
  }
);
const profile529OnlyLinks = (productClass) => {
  return {
    contactInfo: {
      label: "Update Contact Information",
      url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/contact-information", true)
    },
    bankAccounts: {
      label: "Bank Accounts",
      url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts", true)
    },
    docDelivery: {
      label: "Paperless Preferences",
      url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/document-delivery", true)
    },
    changePassword: {
      label: "Change Your Password",
      url: trpEnvironmentAware("https://www.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile?productType=" + productClass, false)
    },
    mfaPreferences: {
      label: "Multi-Factor Authentication Preferences",
      url: trpEnvironmentAware("https://www.troweprice.com/usis/login/update/mfa/profile?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile?productType=" + productClass, false)
    }
  };
};
const profileRetailLinks = {
  contactInfo: {
    label: "Update Contact Information",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/contact-information", true)
  },
  beneficiaryOnFile: {
    label: "Beneficiaries",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/beneficiaries", true)
  },
  bankAccounts: {
    label: "Bank Accounts",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts", true)
  },
  trustedContacts: {
    label: "Trusted Contacts",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/trusted-contacts", true)
  },
  docDelivery: {
    label: "Paperless Preferences",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/document-delivery", true)
  },
  divCapGains: {
    label: "Dividend & Capital Gains Distributions",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/dividends-and-capital-gains", true)
  },
  changePassword: {
    label: "Change Your Password",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile", false)
  },
  mfaPreferences: {
    label: "Multi-Factor Authentication Preferences",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/login/update/mfa/profile?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile", false)
  }
};
const beaconProfileRetailLinks = (accounts, canViewCheckwriting = false) => {
  return {
    people: {
      label: "People",
      show: true,
      links: {
        contactInfo: {
          label: "Contact Information",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/contact-information", true),
          show: canViewContactInformation(accounts),
          deepLink: "/profile"
        },
        summitHouseholdBenefits: {
          label: "Summit Household & Benefits",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/program-benefits", true),
          show: true
        },
        trustedContacts: {
          label: "Trusted Contacts",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/trusted-contacts", true),
          show: canViewTrustedContacts(accounts),
          deepLink: "/profile"
        },
        beneficiaryOnFile: {
          label: "Beneficiaries",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/beneficiaries", true),
          show: canViewBeneficiaries(accounts),
          deepLink: "/profile"
        }
      }
    },
    financialPreferences: {
      label: "Financial Preferences",
      show: canViewFinancialPreferences(accounts),
      links: {
        bankAccounts: {
          label: "Bank Accounts",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts", true),
          show: canViewBanking(accounts),
          deepLink: "/profile"
        },
        accountRegistration: {
          label: "Account Registration",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/account-registration", true),
          show: canViewAccountRegistration(accounts),
          deepLink: "/profile"
        },
        automaticTransactions: {
          label: "Automatic Transactions",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/automatic", true),
          show: canViewAutomaticTransactions(accounts)
        },
        checkwriting: {
          label: "Checkwriting",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/checkwriting", true),
          show: canViewCheckwriting,
          deepLink: "/profile"
        },
        costBasisMethod: {
          label: "Cost Basis Method",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/cost-basis", true),
          show: canViewCostBasis(accounts),
          deepLink: "/profile"
        },
        customizeAccountView: {
          label: "Customize Account View",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/customize-account-view", true),
          show: true,
          deepLink: "/profile"
        },
        dividendsCapitalGains: {
          label: "Dividends & Capital Gains",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/dividends-and-capital-gains", true),
          show: canViewDivCap(accounts),
          deepLink: "/profile"
        }
      }
    },
    securityPreferences: {
      label: "Security Preferences",
      show: true,
      links: {
        username: {
          label: "User Name",
          url: `https://www.troweprice.com/usis/login/update/username?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile?productType=retail`,
          show: true
        },
        password: {
          label: "Password",
          url: `https://www.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile?productType=retail`,
          show: true
        },
        securityQuestions: {
          label: "Security Questions",
          url: `https://www.troweprice.com/usis/login/update/kba?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile?productType=retail`,
          show: true
        },
        multiFactor: {
          label: "Multi-Factor Authentication",
          url: `https://www.troweprice.com/usis/login/update?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile?productType=retail`,
          show: true
        },
        managePasskey: {
          label: "Manage Passkey",
          url: `https://www.troweprice.com/usis/login/update/passkeys?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile`,
          show: true
        },
        viewAccess: {
          label: "Grant View Access",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/grant-view-access", true),
          show: canViewGrantViewAccess(accounts),
          deepLink: "/profile"
        },
        alertsNotifications: {
          label: "Alerts & Notifications",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/alerts-and-notifications", true),
          show: canViewAlertsAndNotifications(accounts),
          deepLink: "/profile"
        }
      }
    },
    communications: {
      show: true,
      label: "Communications",
      links: {
        paperlessPreferences: {
          label: "Paperless Preferences",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/document-delivery", true),
          show: canViewPaperlessPreferences(accounts),
          deepLink: "/profile"
        },
        Subscriptions: {
          label: "Subscriptions",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile/subscriptions", true),
          show: canViewSubscriptions(accounts),
          deepLink: "/profile"
        }
      }
    }
  };
};
const profileRetailLinksRAS = lodashExports.omit(profileRetailLinks, "divCapGains");
const profileTracOnlyLinks = lodashExports.omit(profileRetailLinks, ["contactInfo", "beneficiaryOnFile", "bankAccounts", "trustedContacts", "docDelivery", "divCapGains"]);
const fullProfileLink$1 = trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile", true);
const generateComponentList$1 = (links, dispatch, RouterLink, setToggle) => {
  if (!links) {
    return [];
  }
  return lodashExports.map(links, (link, i5) => {
    const { label, url } = link || {};
    return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "ii-profile-dropdown-link-item", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      LinkGenerator,
      {
        className: "ii-profile-links b-typography-sans-serif--caption--100",
        label,
        url,
        dispatch,
        active: false,
        clickHandler: setToggle,
        RouterLink,
        nestedUrl: "/profile",
        idx: i5
      }
    ) });
  });
};
const getProfileDropdownLinks = () => {
  const viewContext = useView();
  const { view: { productClass, hasWorkplaceOnly, hasRASOnly } } = viewContext;
  const linkProductClass = getProductClass(productClass);
  let links = profile529OnlyLinks(linkProductClass);
  if (hasRASOnly) {
    links = profileRetailLinksRAS;
  } else if (hasWorkplaceOnly) {
    links = profileTracOnlyLinks;
  } else if (productClass === "RETAIL") {
    links = profileRetailLinks;
  }
  return links;
};
const ProfileDropdown = ({ RouterLink, setToggle }) => {
  const viewContext = useView();
  const { dispatch } = viewContext;
  const profileLinks = getProfileDropdownLinks();
  const componentList = generateComponentList$1(profileLinks, dispatch, RouterLink, setToggle);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ii-profile-links-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "links-list", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      ComponentMapper$1,
      {
        componentList,
        orientation: "vertical"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "profile-links-footer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      LinkGenerator,
      {
        className: "ii-profile-links view-profile",
        label: "View Full Profile",
        url: fullProfileLink$1,
        dispatch,
        active: false,
        clickHandler: setToggle,
        RouterLink,
        idx: "view-full-profile"
      }
    ) })
  ] });
};
const Profile$1 = ({ RouterLink, className, beacon = false }) => {
  const viewContext = useView();
  const { dispatch } = viewContext;
  const [on2, setToggle] = useState(false);
  return beacon ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      slot: "icon",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 10.75C13.5188 10.75 14.75 9.51878 14.75 8C14.75 6.48122 13.5188 5.25 12 5.25C10.4812 5.25 9.25 6.48122 9.25 8C9.25 9.51878 10.4812 10.75 12 10.75ZM12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12ZM8 13.375C7.79816 13.375 7.60874 13.4725 7.49142 13.6367L4.99142 17.1367C4.79079 17.4176 4.85584 17.808 5.13673 18.0086C5.41761 18.2092 5.80795 18.1442 6.00858 17.8633L8.32164 14.625H15.6784L17.9914 17.8633C18.192 18.1442 18.5824 18.2092 18.8633 18.0086C19.1442 17.808 19.2092 17.4176 19.0086 17.1367L16.5086 13.6367C16.3913 13.4725 16.2018 13.375 16 13.375H8Z"
        }
      )
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ClickOffSensor$1,
    {
      handleClickoff: () => setToggle(false),
      className: `ii-profile-dropdown ${className} ${on2 && "open"}`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "a",
          {
            className: `ii-profile-button b-typography-sans-serif--caption--100 ${on2 && "open"}`,
            onClick: () => {
              setToggle(!on2);
              updateActive(dispatch, "profile");
            },
            children: [
              beacon ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "currentColor",
                  slot: "icon",
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "path",
                    {
                      fillRule: "evenodd",
                      clipRule: "evenodd",
                      d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 10.75C13.5188 10.75 14.75 9.51878 14.75 8C14.75 6.48122 13.5188 5.25 12 5.25C10.4812 5.25 9.25 6.48122 9.25 8C9.25 9.51878 10.4812 10.75 12 10.75ZM12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12ZM8 13.375C7.79816 13.375 7.60874 13.4725 7.49142 13.6367L4.99142 17.1367C4.79079 17.4176 4.85584 17.808 5.13673 18.0086C5.41761 18.2092 5.80795 18.1442 6.00858 17.8633L8.32164 14.625H15.6784L17.9914 17.8633C18.192 18.1442 18.5824 18.2092 18.8633 18.0086C19.1442 17.808 19.2092 17.4176 19.0086 17.1367L16.5086 13.6367C16.3913 13.4725 16.2018 13.375 16 13.375H8Z"
                    }
                  )
                }
              ) : /* @__PURE__ */ jsxRuntimeExports.jsx(ProfileIcon, { className: "profile-image" }),
              !beacon
            ]
          }
        ),
        on2 && /* @__PURE__ */ jsxRuntimeExports.jsx(
          ProfileDropdown,
          {
            RouterLink,
            setToggle: () => setToggle(!on2)
          }
        )
      ]
    }
  );
};
const Profile$2 = Profile$1;
const QuestionIcon = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    width: "31",
    height: "31",
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M11.1304 12.6432C11.1269 10.2481 12.974 8.25708 15.3626 8.08117C17.7512 7.90526 19.87 9.60423 20.2174 11.974C20.5648 14.3437 19.0228 16.5794 16.6842 17.0964C16.1155 17.2086 15.7031 17.7038 15.6957 18.2834V19.6383",
          stroke: "#3B4B59",
          strokeWidth: "1.75",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M15.6957 22.6867C15.8638 22.6867 16.0001 22.823 16.0001 22.9911C16.0001 23.1591 15.8638 23.2954 15.6957 23.2954C15.5276 23.2954 15.3914 23.1591 15.3914 22.9911C15.3914 22.823 15.5276 22.6867 15.6957 22.6867",
          stroke: "#3B4B59",
          strokeWidth: "1.75",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.6957 29.3933C23.4277 29.3933 29.6957 23.1253 29.6957 15.3933C29.6957 7.66132 23.4277 1.39331 15.6957 1.39331C7.96369 1.39331 1.69568 7.66132 1.69568 15.3933C1.69568 23.1253 7.96369 29.3933 15.6957 29.3933Z",
          stroke: "#3B4B59",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
const QuestionIconBeacon = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    slot: "icon",
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Help" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M8.85749 9.83922C8.85472 7.95738 10.306 6.39298 12.1828 6.25476C14.0595 6.11654 15.7243 7.45145 15.9973 9.3134C16.2702 11.1753 15.0586 12.9319 13.2211 13.3382C12.7743 13.4263 12.4503 13.8154 12.4444 14.2708V15.3354",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M12.4445 17.7305C12.5765 17.7305 12.6836 17.8376 12.6836 17.9697C12.6836 18.1017 12.5765 18.2088 12.4445 18.2088C12.3124 18.2088 12.2053 18.1017 12.2053 17.9697C12.2053 17.8376 12.3124 17.7305 12.4445 17.7305",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.4445 23C18.5196 23 23.4445 18.0751 23.4445 12C23.4445 5.92487 18.5196 1 12.4445 1C6.36933 1 1.44446 5.92487 1.44446 12C1.44446 18.0751 6.36933 23 12.4445 23Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
const helpLinks = {
  helpCenter: {
    label: "Help Center",
    url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/index.html")
  },
  forms: {
    label: "Forms",
    url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/forms.html")
  },
  siteMap: {
    label: "Site Map",
    url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/sitemap.html")
  },
  contactUs: {
    label: "Contact Us",
    url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/contact/index.html")
  }
};
const generateComponentList = (links, dispatch) => {
  if (!links) {
    return [];
  }
  return lodashExports.map(links, (link) => {
    const { label, url } = link || {};
    return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "ii-help-dropdown-link-item", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link$1,
      {
        className: "ii-help-links b-typography-sans-serif--caption--200",
        href: url,
        onClick: () => updateActive(dispatch, label),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { "__html": label } })
      }
    ) });
  });
};
const HelpDropdown = () => {
  const viewContext = useView();
  const { dispatch } = viewContext;
  const componentList = generateComponentList(helpLinks, dispatch);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ii-help-links-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "links-list", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    ComponentMapper$1,
    {
      componentList,
      orientation: "vertical"
    }
  ) }) });
};
const BarSeparator$1 = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bar-separator" });
const HelpMenu = ({ className, beaconStyle = false }) => {
  const viewContext = useView();
  const { dispatch, view } = viewContext;
  const { productClass } = view;
  const [on2, setToggle] = useState(false);
  return productClass === "RETAIL" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "help-menu-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(BarSeparator$1, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ClickOffSensor$1,
      {
        handleClickoff: () => setToggle(false),
        className: `ii-help-menu-dropdown ${className} ${on2 && "open"}`,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "a",
            {
              className: `ii-help-menu-button b-typography-sans-serif--caption--100 ${on2 && "open"}`,
              onClick: () => {
                setToggle(!on2);
                updateActive(dispatch, "help menu");
              },
              children: [
                beaconStyle ? /* @__PURE__ */ jsxRuntimeExports.jsx(QuestionIconBeacon, { className: "help-image" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(QuestionIcon, { className: "help-image" }),
                !beaconStyle && "Help"
              ]
            }
          ),
          on2 && /* @__PURE__ */ jsxRuntimeExports.jsx(HelpDropdown, {})
        ]
      }
    )
  ] }) : null;
};
const Transactions = ({ brokerageTradingEnabled, RouterLink }) => {
  const viewContext = useView();
  const { view: { productClass, isRMDEligible }, dispatch } = viewContext;
  const [on2, setToggle] = useState(false);
  const openAnAccountUrl = {
    ["ALASKA_529"]: trpEnvironmentAware("http://www.troweprice.com/usis/nasu/start/college-savings/alaska"),
    ["MARYLAND_529"]: trpEnvironmentAware("https://www.troweprice.com/usis/nasu/start/college-savings/maryland"),
    ["NATIONAL_529"]: trpEnvironmentAware("https://www.troweprice.com/usis/nasu/start/college-savings/national"),
    ["RETAIL"]: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/fund-research/account-finder")
  };
  const RMDUrl2 = trpEnvironmentAware("https://www.troweprice.com/usis/rmd-tool");
  const allTransactionTypesUrl2 = trpEnvironmentAware("https://www.troweprice.com/usis/transactions/landing", false);
  const Footer = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ii-transactions-footer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: openAnAccountUrl[productClass], children: "Open an Account" }) }),
    isRMDEligible && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: RMDUrl2, children: "Manage My Required Minimum Distribution (RMD)" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: allTransactionTypesUrl2, children: "View All Transaction Types" }) })
  ] });
  const caretClassName = classnames(
    "ii-chevron",
    { "ii-chevron-open": on2 }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ClickOffSensor$1,
    {
      className: "ii-transactions-modal",
      handleClickoff: () => setToggle(false),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Button$1,
          {
            className: "ii-transactions-modal-toggle-modal-button b-typography-sans-serif--caption--200" + (on2 ? "open" : ""),
            handleClick: () => {
              updateActive(dispatch, "transactions");
              setToggle(!on2);
            },
            primary: true,
            children: [
              "Transactions",
              /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronDown, { className: caretClassName })
            ]
          }
        ),
        on2 && /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownModal$1, { footer: /* @__PURE__ */ jsxRuntimeExports.jsx(Footer, {}), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TransactionsMenu$2,
          {
            addDivider: false,
            brokerageTradingEnabled,
            RouterLink
          }
        ) })
      ]
    }
  );
};
const Transactions$1 = Transactions;
const setCookie = (name, value, exdays, isInternal) => {
  const d3 = /* @__PURE__ */ new Date();
  if (exdays) {
    d3.setTime(d3.getTime() + exdays * 24 * 60 * 60 * 1e3);
  }
  const expiration = exdays ? "expires=" + d3.toUTCString() : "";
  let domain;
  if (isInternal) {
    domain = ".awstrp.net";
  } else {
    domain = window.location.host.indexOf("localhost") > -1 ? "localhost" : ".troweprice.com";
  }
  document.cookie = name + "=" + value + ";" + expiration + ";domain=" + domain + ";path=/";
};
const getCookie = (name) => {
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");
  let value = "";
  cookieArray.forEach((cookie) => {
    const pairs = cookie.split("=");
    if (name.toString().toLowerCase().trim() === pairs[0].toString().toLowerCase().trim()) {
      [value] = pairs.slice(1);
    }
  });
  return value;
};
const removeBrowserCookie = (name) => {
  if (document && document.cookie && name) {
    const domain = window.location.host.indexOf("localhost") > -1 ? "localhost" : ".troweprice.com";
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; domain=${domain}; path=/`;
  }
};
const mainMenuLinks = {
  dashboard: {
    label: "Dashboard",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/dashboard", getCookie("client-portal") != "true")
  },
  accounts: {
    label: "Accounts",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/accounts", true)
  },
  activity: {
    label: "Activity",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/transactions", true)
  },
  performance: {
    label: "Performance",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/performance", true)
  },
  statements: {
    label: "Statements",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/statements", true)
  },
  taxes: {
    label: "Taxes",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/taxes", true)
  },
  rmd: {
    label: "RMD",
    url: trpEnvironmentAware("https://www.troweprice.com/usis/rmd-tool", true)
  }
};
const BarSeparator = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bar-separator" });
const generateNavigationLinks$1 = (dispatch, view, RouterLink) => {
  const { active, isRMDEligible, isRMDPreEligible } = view;
  let navigationLinks = mainMenuLinks;
  if (!isRMDEligible && !isRMDPreEligible) {
    navigationLinks = lodashExports.omit(navigationLinks, "rmd");
  }
  return Object.entries(navigationLinks).map((menuItem, i5) => {
    const [linkKey, item] = menuItem;
    const { url, label } = item;
    const isActive = lodashExports.toLower(active) === lodashExports.toLower(linkKey);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      LinkGenerator,
      {
        className: `links b-typography-sans-serif--caption--300 ${isActive ? "active" : ""}`,
        label,
        url,
        dispatch,
        active: isActive,
        RouterLink,
        idx: i5
      },
      i5
    );
  });
};
const MainMenu = ({ RouterLink, brokerageTradingEnabled, isVisible, isLoading }) => {
  const viewContext = useView();
  const { dispatch, view } = viewContext;
  const navigationLinks = generateNavigationLinks$1(dispatch, view, RouterLink);
  if (!isVisible) {
    return null;
  }
  return isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "main-menu-skeleton" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "main-menu",
      "data-metrics-location": "TN",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "main-menu-container", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "navigation-links", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ComponentMapper$1,
            {
              componentList: navigationLinks,
              orientation: "horizontal"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(MoreLinksDropdown$1, { offSetSpacing: "medium" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "main-menu-transactions", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Transactions$1,
            {
              RouterLink,
              brokerageTradingEnabled
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(MessageCenter$1, { RouterLink }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(BarSeparator, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Profile$2, { RouterLink }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(HelpMenu, {})
        ] })
      ] })
    }
  );
};
const MainMenu$1 = MainMenu;
const generateLinks$1 = (links) => {
  return lodashExports.map(links, (link) => {
    const { label, url } = link;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link$1,
      {
        className: "ii-mobile-links b-typography-sans-serif--caption--100",
        href: url,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: label } })
      }
    );
  });
};
const generateNavigationLinks = (dispatch, active, RouterLink, activeClass, stackactions) => {
  let navigationLinks = mainMenuLinks;
  const viewContext = useView();
  const { view: { isRMDPreEligible, isRMDEligible } } = viewContext;
  if (!isRMDEligible && !isRMDPreEligible) {
    navigationLinks = lodashExports.omit(navigationLinks, "rmd");
  }
  return lodashExports.map(navigationLinks, (link, i5) => {
    const { label, url } = link;
    const { emptyStack } = stackactions;
    const isActive = active === lodashExports.toLower(label);
    const linkClasses = classnames(
      "mobile-links",
      "b-typography-sans-serif--caption--300",
      { "active": isActive },
      { [`${activeClass}-link`]: activeClass === PRODUCT_CLASS.ALASKA_529 || activeClass === PRODUCT_CLASS.MARYLAND_529 }
    );
    return RouterLink && isAccountAccess(url) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        className: linkClasses,
        onClick: () => {
          updateActive(dispatch, label);
          emptyStack();
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          RouterLink,
          {
            active: isActive,
            to: getCurrentRoute(url),
            children: label
          },
          `${i5}-${label}`
        )
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link$1,
      {
        className: linkClasses,
        onClick: () => {
          updateActive(dispatch, label);
          emptyStack();
        },
        active: isActive,
        href: url,
        children: label
      },
      `${i5}-${label}`
    );
  });
};
const headerTextAndLinks = {
  [PRODUCT_CLASS.ALASKA_529]: {
    headerText: "ALASKA 529 HOME",
    headerLink: "https://www.alaska529plan.com/"
  },
  [PRODUCT_CLASS.MARYLAND_529]: {
    headerText: "MARYLAND 529 HOME",
    headerLink: "https://maryland529.com/"
  },
  [PRODUCT_CLASS.NATIONAL_529]: {
    headerText: "T. ROWE PRICE COLLEGE SAVINGS PLAN HOME",
    headerLink: trpEnvironmentAware("https://www.troweprice.com/personal-investing/troweprice-529/index.html")
  },
  [PRODUCT_CLASS.RETAIL]: {
    headerText: "PERSONAL INVESTING HOME",
    headerLink: trpEnvironmentAware("https://www.troweprice.com/personal-investing/index.html")
  }
};
const fullProfileLink = trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile", true);
const moreTrigger = (productClass) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Button$1, { className: "ii-action-button b-typography-sans-serif--caption--300", children: [
  productClass === PRODUCT_CLASS.RETAIL ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: " Research " }) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: " More " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "arrow", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowIcon, { className: "button-arrow" }) })
] });
const transactionsTrigger = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(Button$1, { className: "ii-action-button transactions", children: [
  "Transactions",
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "arrow", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowIcon, { className: "button-arrow" }) })
] });
const profileTrigger = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(Button$1, { className: "ii-action-button", children: [
  "Profile",
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "arrow", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowIcon, { className: "button-arrow" }) })
] });
const helpTrigger = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(Button$1, { className: "ii-action-button", children: [
  "Help",
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "arrow", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowIcon, { className: "button-arrow" }) })
] });
const Profile = ({ onClose, stack, stackactions }) => {
  const { pop } = stackactions;
  const profileLinks = generateLinks$1(getProfileDropdownLinks());
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Slider$1,
    {
      trigger: profileTrigger(),
      stack,
      stackactions,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          MobileHeader,
          {
            onClose,
            onBackButton: pop
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          ComponentMapper$1,
          {
            componentList: profileLinks,
            orientation: "vertical"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link$1,
          {
            className: "ii-profile-button",
            href: fullProfileLink,
            onClick: onClose,
            children: "View Full Profile"
          }
        )
      ]
    }
  );
};
const Help$1 = ({ showHelp, onClose, stack, stackactions }) => {
  const { pop } = stackactions;
  const helpMenuLinks = generateLinks$1(helpLinks);
  return showHelp ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Slider$1,
    {
      trigger: helpTrigger(),
      stack,
      stackactions,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          MobileHeader,
          {
            onClose,
            onBackButton: pop
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          ComponentMapper$1,
          {
            componentList: helpMenuLinks,
            orientation: "vertical"
          }
        )
      ]
    }
  ) : null;
};
const coreComponentList$1 = ({ onClose, stack, stackactions, showHelp }) => [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    MessageCenter$1,
    {
      className: "additional-mobile-link-container"
    },
    "mobile-message-center"
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Profile,
    {
      onClose,
      stack,
      stackactions
    },
    "mobile-profile"
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Help$1,
    {
      onClose,
      stack,
      stackactions,
      showHelp
    },
    "mobile-help"
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    RelationshipManager$1,
    {
      className: "icon",
      isMobile: true
    },
    "relationship-manager-mobile"
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    PlanningService,
    {
      containerClassName: "additional-mobile-link-container",
      className: "icon-links b-typography-sans-serif--caption--300"
    },
    "financial-planning"
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    AboutUs,
    {
      className: "icon-links additional-mobile-link-container"
    },
    "about-us"
  )
];
const allTransactionTypesUrl = trpEnvironmentAware("https://www.troweprice.com/usis/transactions/landing");
const RMDUrl = trpEnvironmentAware("https://www.troweprice.com/usis/rmd-tool");
const MobileMenu = ({ loginUrl, logoutUrl, stack, stackactions, RouterLink, isMainMenuVisible, brokerageTradingEnabled }) => {
  const viewContext = useView();
  const {
    view: {
      productClass,
      active,
      isAuthenticated,
      isRMDEligible
    },
    dispatch
  } = viewContext;
  const navigationLinks = generateNavigationLinks(dispatch, active, RouterLink, productClass, stackactions);
  const moreLinks = generateLinks$1(moreDropDownLinks[productClass]);
  const { pop, emptyStack } = stackactions;
  const { headerText, headerLink } = headerTextAndLinks[productClass];
  const showHelp = productClass === PRODUCT_CLASS.RETAIL;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mobile-menu", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      MobileHeader,
      {
        external: true,
        href: headerLink,
        text: headerText,
        onClose: emptyStack
      }
    ),
    isMainMenuVisible && isAuthenticated && /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ComponentMapper$1,
        {
          componentList: navigationLinks,
          orientation: "vertical"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Slider$1,
        {
          trigger: moreTrigger(productClass),
          stack,
          stackactions,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              MobileHeader,
              {
                onClose: emptyStack,
                onBackButton: pop
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              ComponentMapper$1,
              {
                componentList: moreLinks,
                orientation: "vertical"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Slider$1,
        {
          trigger: transactionsTrigger(),
          stack,
          stackactions,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              MobileHeader,
              {
                onClose: emptyStack,
                onBackButton: pop
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              TransactionsMenu$2,
              {
                isMobile: true,
                brokerageTradingEnabled
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "view-all-transactions-container b-typography-sans-serif--caption--300", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Link$1,
                {
                  className: "view-all-transactions",
                  href: allTransactionTypesUrl,
                  children: "View All Transaction Types"
                }
              ),
              isRMDEligible && /* @__PURE__ */ jsxRuntimeExports.jsx(
                Link$1,
                {
                  className: "rmd",
                  href: RMDUrl,
                  children: "Manage My Required Minimum Distribution (RMD)"
                }
              )
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "additional-mobile-links", children: isAuthenticated && /* @__PURE__ */ jsxRuntimeExports.jsx(
      ComponentMapper$1,
      {
        componentList: coreComponentList$1({ onClose: emptyStack, stack, stackactions, showHelp }),
        orientation: "vertical",
        className: "additional-mobile-links-items"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      MobileButtons,
      {
        loginUrl,
        logoutUrl,
        openAnAccountClass: productClass,
        RouterLink
      }
    )
  ] });
};
const MobileMenu$1 = MobileMenu;
const Help = ({ className }) => {
  const viewContext = useView();
  const { view: { productClass }, dispatch } = viewContext;
  const helpLinks2 = {
    [PRODUCT_CLASS.ALASKA_529]: "https://www.alaska529plan.com/about-us/contact-us.html",
    [PRODUCT_CLASS.NATIONAL_529]: trpEnvironmentAware("https://www.troweprice.com/personal-investing/troweprice-529/contact-us.html"),
    [PRODUCT_CLASS.MARYLAND_529]: "https://maryland529.com/About-Us/Contact-Us",
    [PRODUCT_CLASS.RETAIL]: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help.html")
  };
  const label = "Help";
  return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link$1,
    {
      className,
      href: helpLinks2[productClass],
      onClick: () => updateActive(dispatch, label),
      children: label
    }
  ) });
};
const coreComponentList = (dispatch, loginUrl, logoutUrl, RouterLink) => [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    OpenAnAccount,
    {
      onClick: () => {
        updateActive(dispatch, "open_an_account");
      },
      className: "links b-typography-sans-serif--caption--200"
    },
    "openAnAccount"
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    RelationshipManager$1,
    {
      onClick: () => {
        updateActive(dispatch, "relationship_manager");
      }
    },
    "relationshipManager"
  ),
  /* TODO -- uncomment below to re-enable Personal Service Link on NavBar */
  // <PlanningService onClick={ () => { updateActive(dispatch, 'planning_service'); } }
  //                  key='planningService'
  //                  className='links'/>,
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    AboutUs,
    {
      onClick: () => {
        updateActive(dispatch, "about_us");
      },
      className: "links"
    },
    "aboutUs"
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Help,
    {
      className: "links"
    },
    "help"
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Auth,
    {
      loginUrl,
      logoutUrl,
      RouterLink
    },
    "auth"
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    GlobalSearch$1,
    {
      search: { placeholder: "Search" }
    },
    "search"
  )
];
const CoreNavigation = ({
  loginUrl,
  logoutUrl,
  stack,
  stackactions,
  RouterLink,
  isMainMenuVisible,
  isLoading,
  showHelp,
  includedLinks = ["aboutUs", "auth", "openAnAccount", "search", "help", "relationshipManager"],
  brokerageTradingEnabled
}) => {
  const viewContext = useView();
  const { view: { productClass }, dispatch } = viewContext;
  const isRetail = productClass === PRODUCT_CLASS.RETAIL;
  let coreItems = coreComponentList(dispatch, loginUrl, logoutUrl, RouterLink);
  if (isRetail && !lodashExports.isNil(includedLinks)) {
    coreItems = coreItems.filter(
      (item) => includedLinks.some(
        (l4) => l4 === item.key
      )
    );
    if (!showHelp) {
      coreItems = coreItems.filter((item) => item.key !== "help");
    }
  }
  if (!isRetail) {
    coreItems = coreItems.filter((item) => item.key != "search");
  }
  return isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "core-navigation-skeleton" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "core-navigation",
      "data-metrics-location": "HDR",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "container", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Slider$1,
          {
            trigger: /* @__PURE__ */ jsxRuntimeExports.jsx(HamburgerIcon, { className: "hamburger" }),
            stack,
            stackactions,
            RouterLink,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              MobileMenu$1,
              {
                loginUrl,
                logoutUrl,
                isMainMenuVisible,
                RouterLink,
                brokerageTradingEnabled
              }
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Branding$1, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "core-links", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ComponentMapper$1,
          {
            componentList: coreItems,
            orientation: "horizontal"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          If$1,
          {
            test: isRetail,
            component: Trusty$1
          }
        )
      ] })
    }
  );
};
const CoreNavigation$1 = CoreNavigation;
const getIsStaging = (document2) => {
  if (!document2) {
    return false;
  }
  return document2.cookie.indexOf("stageval") > 0 || document2.cookie.indexOf("stagelocal") > 0;
};
const isAccountAccessApplication = (window2) => {
  if (!window2) {
    return false;
  }
  return window2 && window2.location && window2.location.pathname.indexOf("/usis/my-accounts/") !== -1;
};
const isNextEnvironmentEligible = (document2, window2) => {
  return isLowerEnvironment() && isAccountAccessApplication(window2) && !getIsStaging(document2);
};
const isPrimaryEnvironmentEligible = (document2, window2) => {
  return isLowerEnvironment() && isAccountAccessApplication(window2) && getIsStaging(document2);
};
const EnvironmentIndicator = ({ customerWebViewEnabled, version }) => {
  const isStaging = getIsStaging(document);
  const isNextEligible = isNextEnvironmentEligible(document, window);
  const isPrimaryEligible = isPrimaryEnvironmentEligible(document, window);
  const [showVersion, setShowVersion] = useState(false);
  useEffect(() => {
    document.addEventListener("keyup", (e5) => {
      if (e5 && e5.shiftKey && e5.ctrlKey && e5.key === "?") {
        const indicatorEl = document.getElementById("staging-indicator");
        if (indicatorEl.classList.contains("flip")) {
          indicatorEl.classList.remove("flip");
          setShowVersion(false);
        } else {
          indicatorEl.classList.add("flip");
          setShowVersion(true);
        }
      }
    });
    if (isNextEligible) {
      document.addEventListener("keyup", (e5) => {
        if (e5 && e5.shiftKey && e5.ctrlKey && e5.key === "?") {
          const indicatorEl = document.getElementById("next-indicator");
          if (indicatorEl.classList.contains("flip")) {
            indicatorEl.classList.remove("flip");
            setShowVersion(false);
          } else {
            indicatorEl.classList.add("flip");
            setShowVersion(true);
          }
        }
      });
    }
  }, []);
  const navigateToNext = () => {
    setCookie("stageval", true, 1);
    if (window && window.location) {
      window.location.reload();
    }
  };
  const navigateToPrimary = () => {
    removeBrowserCookie("stageval");
    if (window && window.location) {
      window.location.reload();
    }
  };
  let indicatorClassnames = customerWebViewEnabled ? "cwv" : "";
  indicatorClassnames += isStaging ? "stage" : "";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      "data-testid": "indicator",
      className: `indicator-wrapper b-typography-sans-serif--caption--200 ${indicatorClassnames}`,
      children: [
        customerWebViewEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "customer-web-view-bar", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "customer-web-view", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Customer Web View" }) }) }),
        isStaging && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "staging-indicator", children: !showVersion ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "staging front", children: "Staging" }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "version-indicator back", children: [
          "Version: ",
          showVersion && version ? version : ""
        ] }) }),
        isNextEligible && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            onClick: navigateToNext,
            id: "next-indicator",
            children: !showVersion ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "next front", children: "Next" }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "version-indicator back", children: [
              "Version: ",
              showVersion && version ? version : ""
            ] })
          }
        ),
        isPrimaryEligible && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            onClick: navigateToPrimary,
            id: "back-to-primary-indicator",
            children: !showVersion ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "primary front", children: "Primary" }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "version-indicator back", children: [
              "Version: ",
              showVersion && version ? version : ""
            ] })
          }
        )
      ]
    }
  );
};
const EnvironmentIndicator$1 = EnvironmentIndicator;
const CrossIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    slot: "icon",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z",
        fill: "#0063AD"
      }
    )
  }
);
const Banner = ({ title, bodyText, CTAText, handleDismiss, handleCTAClick, isDismissible, dismissCTAText = "dismiss", offerId, imageLink, isCustomerWebView = false, id }) => {
  useEffect(() => {
    const externalLinks = document.querySelectorAll('.ii-banner-container a[target="_blank"], .ii-banner-container a[href]');
    const handleClick = (e5) => {
      if (offerId) {
        try {
          dispatchInteraction(offerId, e5.target.textContent);
        } catch (e22) {
        }
      }
    };
    externalLinks.forEach((link) => {
      link.addEventListener("click", handleClick);
    });
    return () => {
      externalLinks.forEach((link) => {
        link.removeEventListener("click", handleClick);
      });
    };
  }, []);
  const updatedId = id ? id : (Math.random() * 1e8).toFixed(0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: updatedId, className: `ii-banner-container b-container beacon`, "data-testid": offerId, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "banner-content-container b-grid", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "banner-body b-padding-block--micro--normal", children: [
      imageLink && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: imageLink, className: "image", "data-testid": "image", alt: "banner image" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "line", "data-testid": "line", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "title", className: "title b-typography-sans-serif--body--200", dangerouslySetInnerHTML: { __html: purify.sanitize(title) } }),
        bodyText && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            "data-testid": "body-text",
            className: "body-text b-typography-sans-serif--body--100",
            dangerouslySetInnerHTML: {
              __html: purify.sanitize(bodyText)
            }
          }
        )
      ] }),
      handleCTAClick && CTAText && /* @__PURE__ */ jsxRuntimeExports.jsx(
        IIBeaconButton,
        {
          "data-testId": "cta-button",
          disabled: isCustomerWebView,
          variant: "secondary",
          className: "cta-button",
          onBeaconEventClick: () => {
            if (!isCustomerWebView) {
              handleCTAClick();
              if (offerId) {
                try {
                  dispatchInteraction(offerId, CTAText);
                } catch (e5) {
                }
              }
            }
          },
          children: CTAText
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "dismiss-container", children: (isDismissible || handleDismiss) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "dismiss-button", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      IIBeaconIconButton,
      {
        variant: "tertiary",
        onBeaconEventClick: () => {
          if (!isCustomerWebView) {
            handleDismiss();
            if (offerId) {
              try {
                dispatchInteraction(offerId, dismissCTAText);
              } catch (e5) {
              }
            }
          }
        },
        disabled: isCustomerWebView,
        "data-testId": "dismiss-button",
        "aria-label": "dismiss",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(CrossIcon, { slot: "icon" })
      }
    ) }) })
  ] }) });
};
const Banner$1 = Banner;
const DropdownOption = ({
  title,
  onClick,
  index: index2,
  className,
  selected,
  footer = false,
  chevron,
  selectedIcon
}) => {
  const RightIcon = chevron;
  const LeftIcon = selectedIcon;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "option-container",
      onClick,
      value: index2,
      id: `option-${index2 < 0 ? "base" : footer ? "footer" : index2}`,
      children: [
        LeftIcon,
        /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: classnames("option", className, { "selected": selected }), children: title }),
        RightIcon && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "icon-container", children: RightIcon })
      ]
    }
  );
};
const Check = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "check" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M6 12.5185L10.7895 17L19 6",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
const addPrefix = (word = "", prefix = "") => {
  if (word.length === 0) return "";
  return word.startsWith(prefix) ? word : prefix + word;
};
const buildSelector = (id = "", className = "") => {
  const classSelector = addPrefix(className, ".");
  const idSelector = addPrefix(id, "#");
  return classSelector + idSelector;
};
const selectElement = (id, className) => {
  const idSelector = addPrefix(id, "#");
  const classSelector = addPrefix(className, ".");
  return document.querySelector(idSelector + classSelector);
};
const setCustomProperties = (variables, rootId, className) => {
  if (!variables || Object.keys(variables).length === 0) return;
  const root2 = selectElement(rootId, className);
  Object.entries(variables).forEach(([attr = "", value = ""]) => {
    if (attr && value && root2) {
      const withPrefix = addPrefix(attr);
      root2.style.setProperty(withPrefix, value);
    }
  });
};
const CustomPropertyContext = createContext(null);
const providerIdPrefix = "custom-property-provider";
const defaultProviderClassName = "custom-property-provider";
const CustomPropertyProvider = ({
  theme = {},
  id = "",
  className = "",
  children
}) => {
  const providerClassName = className ? className : defaultProviderClassName;
  const providerId = id ? id : lodashExports.uniqueId(providerIdPrefix);
  useEffect(() => {
    setCustomProperties(theme, providerId, providerClassName);
  }, [theme, providerId, providerClassName]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CustomPropertyContext.Provider, { value: { rootSelector: buildSelector(providerId, providerClassName) }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: providerClassName,
      id: providerId,
      children
    }
  ) });
};
const withProvider = (Component2) => ({
  theme = {},
  ...props
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  CustomPropertyProvider,
  {
    className: "dropdown-properties",
    theme,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, { ...props })
  }
);
const Dropdown = ({
  selected,
  options = [],
  onChange,
  renderTitle = (item) => item,
  className,
  id,
  label,
  footer,
  chevron = ChevronDown,
  selectedIcon = Check
}) => {
  const Chevron = chevron;
  const Check2 = selectedIcon;
  const [expanded, setExpanded] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  useEffect(() => {
    const index2 = options.findIndex((option) => option.id === (selected == null ? void 0 : selected.id));
    setSelectedIndex(Math.max(index2, 0));
  }, [selected]);
  const toggle = () => setExpanded((prev) => !prev);
  const close = () => setExpanded(false);
  const handleClick = (e5) => {
    const index2 = Number(e5.currentTarget.getAttribute("value"));
    const current = options[index2];
    close();
    onChange(current, index2);
  };
  const handleFooterClick = () => {
    if (window && window.location && window.location.href && footer.link) {
      window.location.href = footer.link;
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: classnames("dropdown-container", className),
      id,
      children: [
        label && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "label", children: label }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: "dropdown",
            tabIndex: 0,
            "data-testid": "dropdown",
            onBlur: close,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                DropdownOption,
                {
                  index: -1,
                  className: "selection",
                  title: renderTitle(selected, selectedIndex),
                  onClick: toggle,
                  chevron: /* @__PURE__ */ jsxRuntimeExports.jsx(Chevron, { className: "chevron " + (expanded && "rotated") })
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `options ${expanded ? "active" : "inactive"}`, children: [
                options.map((option, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                  DropdownOption,
                  {
                    title: renderTitle(option, index2),
                    index: index2,
                    selected: selectedIndex === index2,
                    onClick: handleClick,
                    selectedIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(Check2, { className: classnames("check", { "selected": selectedIndex === index2 }) })
                  },
                  index2
                )),
                footer && footer.link && footer.title && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  DropdownOption,
                  {
                    className: "dropdown-footer",
                    title: footer.title,
                    onClick: handleFooterClick,
                    footer: true
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
};
const Dropdown$1 = withProvider(Dropdown);
const Prospectus = ({ products, productType }) => {
  products && products.some(
    (p2) => p2 === productType.BROKERAGE
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
    "Download a",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        id: "footer-brokerage-download-prospectus-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/funds/mutual-funds/prospectuses-reports.html"),
        children: "mutual fund prospectus"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      " ",
      "or",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          id: "footer-brokerage-download-etf-link",
          href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/funds/etfs/prospectuses-reports.html"),
          children: "ETF prospectus"
        }
      ),
      "."
    ] })
  ] });
};
const BrokerageDisclaimer = ({ products, productType }) => {
  const hasBrokerage2 = products && products.find((p2) => p2 === productType.BROKERAGE);
  return hasBrokerage2 ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: "brokerage-copy-text", children: [
    "Brokerage accounts are offered by",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe Price" }),
    " Investment Services, Inc., member FINRA/SIPC, and are carried by Pershing LLC, a BNY Mellon Company, member NYSE/FINRA/SIPC, which acts as a clearing broker for",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe Price" }),
    " Investment Services, Inc. ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe Price" }),
    " Investment Services, Inc., does not provide investment advice or recommendations. ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        target: "_blank",
        rel: "noreferrer",
        href: "https://brokerage-nxi.troweprice.com/nxi/disclosure/copyrightTerms/copyrights#copy",
        id: "copyright-terms-of-usechild",
        children: "Click here"
      }
    ),
    " ",
    "for Pershing's terms of use."
  ] }) : null;
};
const ActivePlusPortfolioContent = ({ products, productType }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: "active-plus-portfolio-copy-footer", children: [
      "The funds referred to in this website are offered and sold only to persons residing in the United States and are offered by prospectus only. The prospectuses include investment objectives, risks, fees, expenses, and other information that you should read and consider carefully before investing. ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price Investment Services, Inc., distributor, ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price mutual funds and ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price ETFs."
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "prospectus-links", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Prospectus,
      {
        products,
        productType
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(BrokerageDisclaimer, { products, productType }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: "footer-active-plus-portfolios-disclaimer", children: [
      "The",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: " T. Rowe Price" }),
      " ActivePlus Portfolios",
      /* @__PURE__ */ jsxRuntimeExports.jsx("sup", { children: "®" }),
      " program is a discretionary managed account program and the",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: " T. Rowe Price" }),
      " Retirement Advisory Service",
      /* @__PURE__ */ jsxRuntimeExports.jsx("sup", { children: "TM" }),
      " is a nondiscretionary financial planning and retirement income planning service and a discretionary managed account program provided by ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price Advisory Services, Inc., a registered investment adviser under the Investment",
      " ",
      "Advisers Act of 1940.  Brokerage accounts for these programs are provided by ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price Investment Services, Inc., member FINRA/SIPC, and are carried by Pershing LLC, a BNY Mellon company, member NYSE/FINRA/SIPC, which acts as a clearing broker for ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price Investment Services, Inc.  ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price Advisory Services, Inc. and T. Rowe Price Investment Services, Inc. are affiliated companies."
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: "footer-etf-disclaimer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "ETFs are bought and sold at market prices, not net asset value." }),
      " Investors generally incur the cost of the spread between the prices at which shares are bought and sold and may incur additional transaction costs."
    ] })
  ] });
};
const ActivePlusPortfolioCopyrightContent = ({ products }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: "footer-mutual-fund-copy-right-text-2", children: [
    "©",
    (/* @__PURE__ */ new Date()).getFullYear(),
    " T. Rowe Price. All Rights Reserved. ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. ROWE PRICE" }),
    ", INVEST WITH CONFIDENCE, and the Bighorn Sheep design are, collectively and/or apart, trademarks of ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
    " Price Group, Inc. All other trademarks shown are the property of their respective owners. Use does not imply endorsement, sponsorship, or affiliation of ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
    " Price with any of the trademark owners."
  ] }) });
};
const BrokerageContent = ({ products, productType }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: "footer-brokerage-copy", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: "footer-brokerage-prospectus-copy", children: [
      "The funds referred to in this website are offered and sold only to persons residing in the United States and are offered by prospectus only. The prospectuses include investment objectives, risks, fees, expenses, and other information that you should read and consider carefully before investing. ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price Investment Services, Inc., distributor, ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price mutual funds and ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price ETFs."
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "prospectus-links", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Prospectus,
      {
        products,
        productType
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { id: "footer-brokerage-copy-right-text-1", children: "This website does not provide investment advice or recommendations. Nothing in this website shall be considered a solicitation to buy or an offer to sell a security, or any other product or service, to any person in any jurisdiction where such offer, solicitation, purchase, or sale would be unlawful under the laws of such jurisdiction." }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: "footer-brokerage-copy-right-text-2", children: [
      "Brokerage accounts are offered by",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe Price" }),
      " Investment Services, Inc., member FINRA/SIPC, and are carried by Pershing LLC, a BNY Mellon Company, member NYSE/FINRA/SIPC, which acts as a clearing broker for",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe Price" }),
      " Investment Services, Inc. ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe Price" }),
      " Investment Services, Inc., does not provide investment advice or recommendations. ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          target: "_blank",
          rel: "noreferrer",
          href: "https://brokerage-nxi.troweprice.com/nxi/disclosure/copyrightTerms/copyrights#copy",
          id: "copyright-terms-of-usechild",
          children: "Click here"
        }
      ),
      " ",
      "for Pershing's terms of use."
    ] })
  ] });
};
const BrokerageCopyrightContent = ({ products }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "footer-brokerage-copy", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: "footer-mutual-fund-copy-right-text-2", children: [
    "©",
    (/* @__PURE__ */ new Date()).getFullYear(),
    " T. Rowe Price. All Rights Reserved. ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. ROWE PRICE" }),
    ", INVEST WITH CONFIDENCE, and the Bighorn Sheep design are, collectively and/or apart, trademarks of ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
    " Price Group, Inc. All other trademarks shown are the property of their respective owners. Use does not imply endorsement, sponsorship, or affiliation of ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
    " Price with any of the trademark owners."
  ] }) });
};
const MutualFundContent = ({ products, productType }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: "footer-mutual-fund-without-529-id", children: [
      "The funds referred to in this website are offered and sold only to persons residing in the United States and are offered by prospectus only. The prospectuses include investment objectives, risks, fees, expenses, and other information that you should read and consider carefully before investing. ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price Investment Services, Inc., distributor, ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price mutual funds and ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
      " Price ETFs."
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "prospectus-links", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Prospectus,
      {
        products,
        productType
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { id: "footer-mutual-fund-copy-right-text-1", children: "This website does not provide investment advice or recommendations. Nothing in this website shall be considered a solicitation to buy or an offer to sell a security, or any other product or service, to any person in any jurisdiction where such offer, solicitation, purchase, or sale would be unlawful under the laws of such jurisdiction." })
  ] });
};
const MutualFundCopyrightContent = ({ products }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: "footer-mutual-fund-copy-right-text-2", children: [
    "©",
    (/* @__PURE__ */ new Date()).getFullYear(),
    " T. Rowe Price. All Rights Reserved. ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. ROWE PRICE" }),
    ", INVEST WITH CONFIDENCE, and the Bighorn Sheep design are, collectively and/or apart, trademarks of ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
    " Price Group, Inc. All other trademarks shown are the property of their respective owners. Use does not imply endorsement, sponsorship, or affiliation of ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe" }),
    " Price with any of the trademark owners."
  ] }) });
};
const CollegeContent = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {});
};
const CollegeCopyrightContent = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: "footer-no-brokerage-529-Copyright", children: [
    "© ",
    (/* @__PURE__ */ new Date()).getFullYear(),
    ",",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe Price" }),
    " Investment Services, Inc., Distributor and Agent. Units in Trust are serviced by",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe Price" }),
    " Services, Inc. All rights reserved."
  ] }) });
};
const Mixed529Content = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { id: "footer-mixed-529-copy-right-text-1", children: "This website does not provide investment advice or recommendations. Nothing in this website shall be considered a solicitation to buy or an offer to sell a security, or any other product or service, to any person in any jurisdiction where such offer, solicitation, purchase, or sale would be unlawful under the laws of such jurisdiction." }) });
};
const Mixed529CopyrightContent = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: "footer-mixed-529-copy-right-text-2", children: [
    "© ",
    (/* @__PURE__ */ new Date()).getFullYear(),
    ".",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe Price" }),
    " Investment Services, Inc., Distributor. All rights reserved.",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe Price" }),
    ", Invest with Confidence, and the bighorn sheep design are all registered trademarks of ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-nowrap", children: "T. Rowe Price" }),
    " Group, Inc. All other trademarks are the property of their respective owners."
  ] }) });
};
const PRODUCT_TYPE = {
  ACTIVE_PLUS_PORTFOLIOS: "APP",
  BROKERAGE: "Brokerage",
  MUTUAL_FUND: "MutualFund",
  NAT529: "NAT529",
  MD529: "MD529",
  AK529: "AK529",
  RAS: "RAS"
};
const createProductContentMap = (products) => {
  return {
    [PRODUCT_TYPE.ACTIVE_PLUS_PORTFOLIOS]: /* @__PURE__ */ jsxRuntimeExports.jsx(
      ActivePlusPortfolioContent,
      {
        products,
        productType: PRODUCT_TYPE
      }
    ),
    [PRODUCT_TYPE.RAS]: /* @__PURE__ */ jsxRuntimeExports.jsx(
      ActivePlusPortfolioContent,
      {
        products,
        productType: PRODUCT_TYPE
      }
    ),
    [PRODUCT_TYPE.BROKERAGE]: /* @__PURE__ */ jsxRuntimeExports.jsx(
      BrokerageContent,
      {
        products,
        productType: PRODUCT_TYPE
      }
    ),
    [PRODUCT_TYPE.MUTUAL_FUND]: /* @__PURE__ */ jsxRuntimeExports.jsx(
      MutualFundContent,
      {
        products,
        productType: PRODUCT_TYPE
      }
    ),
    [PRODUCT_TYPE.NAT529]: /* @__PURE__ */ jsxRuntimeExports.jsx(CollegeContent, {}),
    [PRODUCT_TYPE.MD529]: /* @__PURE__ */ jsxRuntimeExports.jsx(CollegeContent, {}),
    [PRODUCT_TYPE.AK529]: /* @__PURE__ */ jsxRuntimeExports.jsx(CollegeContent, {}),
    MIXED: /* @__PURE__ */ jsxRuntimeExports.jsx(Mixed529Content, {})
  };
};
const createProductCopyrightContentMap = (products) => {
  return {
    [PRODUCT_TYPE.ACTIVE_PLUS_PORTFOLIOS]: /* @__PURE__ */ jsxRuntimeExports.jsx(ActivePlusPortfolioCopyrightContent, { products }),
    [PRODUCT_TYPE.RAS]: /* @__PURE__ */ jsxRuntimeExports.jsx(ActivePlusPortfolioCopyrightContent, { products }),
    [PRODUCT_TYPE.BROKERAGE]: /* @__PURE__ */ jsxRuntimeExports.jsx(BrokerageCopyrightContent, { products }),
    [PRODUCT_TYPE.MUTUAL_FUND]: /* @__PURE__ */ jsxRuntimeExports.jsx(MutualFundCopyrightContent, { products }),
    [PRODUCT_TYPE.NAT529]: /* @__PURE__ */ jsxRuntimeExports.jsx(CollegeCopyrightContent, {}),
    [PRODUCT_TYPE.MD529]: /* @__PURE__ */ jsxRuntimeExports.jsx(CollegeCopyrightContent, {}),
    [PRODUCT_TYPE.AK529]: /* @__PURE__ */ jsxRuntimeExports.jsx(CollegeCopyrightContent, {}),
    MIXED: /* @__PURE__ */ jsxRuntimeExports.jsx(Mixed529CopyrightContent, {})
  };
};
var isArray$8 = Array.isArray;
var isArray_1 = isArray$8;
var isArray$7 = isArray_1;
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray$7(value) ? value : [value];
}
var castArray_1 = castArray;
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$3(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$3;
var eq$2 = eq_1;
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data = this.__data__, index2 = assocIndexOf$3(data, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data = this.__data__, index2 = assocIndexOf$2(data, key);
  return index2 < 0 ? void 0 : data[index2][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries2) {
  var index2 = -1, length = entries2 == null ? 0 : entries2.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries2[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var ListCache$3 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$3();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$9 = freeGlobal || freeSelf || Function("return this")();
var _root = root$9;
var root$8 = _root;
var Symbol$7 = root$8.Symbol;
var _Symbol = Symbol$7;
var Symbol$6 = _Symbol;
var objectProto$g = Object.prototype;
var hasOwnProperty$d = objectProto$g.hasOwnProperty;
var nativeObjectToString$1 = objectProto$g.toString;
var symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$d.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e5) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$f = Object.prototype;
var nativeObjectToString = objectProto$f.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$5 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$5 ? Symbol$5.toStringTag : void 0;
function baseGetTag$e(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$e;
function isObject$7(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$7;
var baseGetTag$d = _baseGetTag, isObject$6 = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$3(value) {
  if (!isObject$6(value)) {
    return false;
  }
  var tag = baseGetTag$d(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$3;
var root$7 = _root;
var coreJsData$2 = root$7["__core-js_shared__"];
var _coreJsData = coreJsData$2;
var coreJsData$1 = _coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e5) {
    }
    try {
      return func + "";
    } catch (e5) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$2 = isFunction_1, isMasked = _isMasked, isObject$5 = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$e = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$c = objectProto$e.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$c).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$2(value) {
  if (!isObject$5(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$2;
function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}
var _getValue = getValue$1;
var baseIsNative$1 = _baseIsNative, getValue = _getValue;
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative$1(value) ? value : void 0;
}
var _getNative = getNative$7;
var getNative$6 = _getNative, root$6 = _root;
var Map$4 = getNative$6(root$6, "Map");
var _Map = Map$4;
var getNative$5 = _getNative;
var nativeCreate$4 = getNative$5(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$d = Object.prototype;
var hasOwnProperty$b = objectProto$d.hasOwnProperty;
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$b.call(data, key) ? data[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$c = Object.prototype;
var hasOwnProperty$a = objectProto$c.hasOwnProperty;
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$a.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries2) {
  var index2 = -1, length = entries2 == null ? 0 : entries2.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries2[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
var Hash = _Hash, ListCache$2 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$2)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$2(entries2) {
  var index2 = -1, length = entries2 == null ? 0 : entries2.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries2[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$2.prototype.clear = mapCacheClear;
MapCache$2.prototype["delete"] = mapCacheDelete;
MapCache$2.prototype.get = mapCacheGet;
MapCache$2.prototype.has = mapCacheHas;
MapCache$2.prototype.set = mapCacheSet;
var _MapCache = MapCache$2;
var ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache;
var LARGE_ARRAY_SIZE = 200;
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$5(entries2) {
  var data = this.__data__ = new ListCache(entries2);
  this.size = data.size;
}
Stack$5.prototype.clear = stackClear;
Stack$5.prototype["delete"] = stackDelete;
Stack$5.prototype.get = stackGet;
Stack$5.prototype.has = stackHas;
Stack$5.prototype.set = stackSet;
var _Stack = Stack$5;
function arrayEach$1(array, iteratee) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (iteratee(array[index2], index2, array) === false) {
      break;
    }
  }
  return array;
}
var _arrayEach = arrayEach$1;
var getNative$4 = _getNative;
var defineProperty$1 = function() {
  try {
    var func = getNative$4(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e5) {
  }
}();
var _defineProperty = defineProperty$1;
var defineProperty = _defineProperty;
function baseAssignValue$2(object, key, value) {
  if (key == "__proto__" && defineProperty) {
    defineProperty(object, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object[key] = value;
  }
}
var _baseAssignValue = baseAssignValue$2;
var baseAssignValue$1 = _baseAssignValue, eq$1 = eq_1;
var objectProto$b = Object.prototype;
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$9.call(object, key) && eq$1(objValue, value)) || value === void 0 && !(key in object)) {
    baseAssignValue$1(object, key, value);
  }
}
var _assignValue = assignValue$2;
var assignValue$1 = _assignValue, baseAssignValue = _baseAssignValue;
function copyObject$5(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index2 = -1, length = props.length;
  while (++index2 < length) {
    var key = props[index2];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}
var _copyObject = copyObject$5;
function baseTimes$1(n4, iteratee) {
  var index2 = -1, result = Array(n4);
  while (++index2 < n4) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var _baseTimes = baseTimes$1;
function isObjectLike$j(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$j;
var baseGetTag$c = _baseGetTag, isObjectLike$i = isObjectLike_1;
var argsTag$3 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$i(value) && baseGetTag$c(value) == argsTag$3;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$h = isObjectLike_1;
var objectProto$a = Object.prototype;
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable;
var isArguments$2 = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$h(value) && hasOwnProperty$8.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
var isArguments_1 = isArguments$2;
var isBuffer$4 = { exports: {} };
function stubFalse$1() {
  return false;
}
var stubFalse_1 = stubFalse$1;
isBuffer$4.exports;
(function(module2, exports2) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports2 && !exports2.nodeType && exports2;
  var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module2.exports = isBuffer2;
})(isBuffer$4, isBuffer$4.exports);
var isBufferExports = isBuffer$4.exports;
var MAX_SAFE_INTEGER$3 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$1(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$3 : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var _isIndex = isIndex$1;
var MAX_SAFE_INTEGER$2 = 9007199254740991;
function isLength$2(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}
var isLength_1 = isLength$2;
var baseGetTag$b = _baseGetTag, isLength$1 = isLength_1, isObjectLike$g = isObjectLike_1;
var argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$4 = "[object Boolean]", dateTag$4 = "[object Date]", errorTag$3 = "[object Error]", funcTag$1 = "[object Function]", mapTag$7 = "[object Map]", numberTag$4 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$4 = "[object RegExp]", setTag$7 = "[object Set]", stringTag$4 = "[object String]", weakMapTag$3 = "[object WeakMap]";
var arrayBufferTag$4 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$4] = typedArrayTags[boolTag$4] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$4] = typedArrayTags[errorTag$3] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$7] = typedArrayTags[numberTag$4] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$4] = typedArrayTags[setTag$7] = typedArrayTags[stringTag$4] = typedArrayTags[weakMapTag$3] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$g(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag$b(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$6(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$6;
var _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(module2, exports2) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports2 && !exports2.nodeType && exports2;
  var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e5) {
    }
  }();
  module2.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports;
var baseIsTypedArray = _baseIsTypedArray, baseUnary$5 = _baseUnary, nodeUtil$5 = _nodeUtilExports;
var nodeIsTypedArray = nodeUtil$5 && nodeUtil$5.isTypedArray;
var isTypedArray$3 = nodeIsTypedArray ? baseUnary$5(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$3;
var baseTimes = _baseTimes, isArguments$1 = isArguments_1, isArray$6 = isArray_1, isBuffer$3 = isBufferExports, isIndex = _isIndex, isTypedArray$2 = isTypedArray_1;
var objectProto$9 = Object.prototype;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$6(value), isArg = !isArr && isArguments$1(value), isBuff = !isArr && !isArg && isBuffer$3(value), isType = !isArr && !isArg && !isBuff && isTypedArray$2(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$2;
var objectProto$8 = Object.prototype;
function isPrototype$4(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$8;
  return value === proto;
}
var _isPrototype = isPrototype$4;
function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$2;
var overArg$1 = _overArg;
var nativeKeys$1 = overArg$1(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype$3 = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$7 = Object.prototype;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
function baseKeys$2(object) {
  if (!isPrototype$3(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$6.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$2;
var isFunction$1 = isFunction_1, isLength = isLength_1;
function isArrayLike$5(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}
var isArrayLike_1 = isArrayLike$5;
var arrayLikeKeys$1 = _arrayLikeKeys, baseKeys$1 = _baseKeys, isArrayLike$4 = isArrayLike_1;
function keys$6(object) {
  return isArrayLike$4(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}
var keys_1 = keys$6;
var copyObject$4 = _copyObject, keys$5 = keys_1;
function baseAssign$1(object, source) {
  return object && copyObject$4(source, keys$5(source), object);
}
var _baseAssign = baseAssign$1;
function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
var _nativeKeysIn = nativeKeysIn$1;
var isObject$4 = isObject_1, isPrototype$2 = _isPrototype, nativeKeysIn = _nativeKeysIn;
var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function baseKeysIn$1(object) {
  if (!isObject$4(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$2(object), result = [];
  for (var key in object) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$5.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
var _baseKeysIn = baseKeysIn$1;
var arrayLikeKeys = _arrayLikeKeys, baseKeysIn = _baseKeysIn, isArrayLike$3 = isArrayLike_1;
function keysIn$4(object) {
  return isArrayLike$3(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
var keysIn_1 = keysIn$4;
var copyObject$3 = _copyObject, keysIn$3 = keysIn_1;
function baseAssignIn$1(object, source) {
  return object && copyObject$3(source, keysIn$3(source), object);
}
var _baseAssignIn = baseAssignIn$1;
var _cloneBuffer = { exports: {} };
_cloneBuffer.exports;
(function(module2, exports2) {
  var root2 = _root;
  var freeExports = exports2 && !exports2.nodeType && exports2;
  var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? root2.Buffer : void 0, allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0;
  function cloneBuffer2(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  module2.exports = cloneBuffer2;
})(_cloneBuffer, _cloneBuffer.exports);
var _cloneBufferExports = _cloneBuffer.exports;
function copyArray$2(source, array) {
  var index2 = -1, length = source.length;
  array || (array = Array(length));
  while (++index2 < length) {
    array[index2] = source[index2];
  }
  return array;
}
var _copyArray = copyArray$2;
function arrayFilter$1(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index2 < length) {
    var value = array[index2];
    if (predicate(value, index2, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;
function stubArray$2() {
  return [];
}
var stubArray_1 = stubArray$2;
var arrayFilter = _arrayFilter, stubArray$1 = stubArray_1;
var objectProto$5 = Object.prototype;
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols$3;
var copyObject$2 = _copyObject, getSymbols$2 = _getSymbols;
function copySymbols$1(source, object) {
  return copyObject$2(source, getSymbols$2(source), object);
}
var _copySymbols = copySymbols$1;
function arrayPush$2(array, values2) {
  var index2 = -1, length = values2.length, offset = array.length;
  while (++index2 < length) {
    array[offset + index2] = values2[index2];
  }
  return array;
}
var _arrayPush = arrayPush$2;
var overArg = _overArg;
var getPrototype$3 = overArg(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$3;
var arrayPush$1 = _arrayPush, getPrototype$2 = _getPrototype, getSymbols$1 = _getSymbols, stubArray = stubArray_1;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush$1(result, getSymbols$1(object));
    object = getPrototype$2(object);
  }
  return result;
};
var _getSymbolsIn = getSymbolsIn$2;
var copyObject$1 = _copyObject, getSymbolsIn$1 = _getSymbolsIn;
function copySymbolsIn$1(source, object) {
  return copyObject$1(source, getSymbolsIn$1(source), object);
}
var _copySymbolsIn = copySymbolsIn$1;
var arrayPush = _arrayPush, isArray$5 = isArray_1;
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$5(object) ? result : arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$2;
var baseGetAllKeys$1 = _baseGetAllKeys, getSymbols = _getSymbols, keys$4 = keys_1;
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$4, getSymbols);
}
var _getAllKeys = getAllKeys$2;
var baseGetAllKeys = _baseGetAllKeys, getSymbolsIn = _getSymbolsIn, keysIn$2 = keysIn_1;
function getAllKeysIn$1(object) {
  return baseGetAllKeys(object, keysIn$2, getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn$1;
var getNative$3 = _getNative, root$5 = _root;
var DataView$1 = getNative$3(root$5, "DataView");
var _DataView = DataView$1;
var getNative$2 = _getNative, root$4 = _root;
var Promise$2 = getNative$2(root$4, "Promise");
var _Promise = Promise$2;
var getNative$1 = _getNative, root$3 = _root;
var Set$2 = getNative$1(root$3, "Set");
var _Set = Set$2;
var getNative = _getNative, root$2 = _root;
var WeakMap$2 = getNative(root$2, "WeakMap");
var _WeakMap = WeakMap$2;
var DataView = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap$1 = _WeakMap, baseGetTag$a = _baseGetTag, toSource = _toSource;
var mapTag$6 = "[object Map]", objectTag$3 = "[object Object]", promiseTag = "[object Promise]", setTag$6 = "[object Set]", weakMapTag$2 = "[object WeakMap]";
var dataViewTag$3 = "[object DataView]";
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1);
var getTag$7 = baseGetTag$a;
if (DataView && getTag$7(new DataView(new ArrayBuffer(1))) != dataViewTag$3 || Map$1 && getTag$7(new Map$1()) != mapTag$6 || Promise$1 && getTag$7(Promise$1.resolve()) != promiseTag || Set$1 && getTag$7(new Set$1()) != setTag$6 || WeakMap$1 && getTag$7(new WeakMap$1()) != weakMapTag$2) {
  getTag$7 = function(value) {
    var result = baseGetTag$a(value), Ctor = result == objectTag$3 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$3;
        case mapCtorString:
          return mapTag$6;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$6;
        case weakMapCtorString:
          return weakMapTag$2;
      }
    }
    return result;
  };
}
var _getTag = getTag$7;
var objectProto$4 = Object.prototype;
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
function initCloneArray$1(array) {
  var length = array.length, result = new array.constructor(length);
  if (length && typeof array[0] == "string" && hasOwnProperty$4.call(array, "index")) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}
var _initCloneArray = initCloneArray$1;
var root$1 = _root;
var Uint8Array$2 = root$1.Uint8Array;
var _Uint8Array = Uint8Array$2;
var Uint8Array$1 = _Uint8Array;
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}
var _cloneArrayBuffer = cloneArrayBuffer$3;
var cloneArrayBuffer$2 = _cloneArrayBuffer;
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var _cloneDataView = cloneDataView$1;
var reFlags = /\w*$/;
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
var _cloneRegExp = cloneRegExp$1;
var Symbol$4 = _Symbol;
var symbolProto$2 = Symbol$4 ? Symbol$4.prototype : void 0, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function cloneSymbol$1(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}
var _cloneSymbol = cloneSymbol$1;
var cloneArrayBuffer$1 = _cloneArrayBuffer;
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var _cloneTypedArray = cloneTypedArray$1;
var cloneArrayBuffer = _cloneArrayBuffer, cloneDataView = _cloneDataView, cloneRegExp = _cloneRegExp, cloneSymbol = _cloneSymbol, cloneTypedArray = _cloneTypedArray;
var boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", symbolTag$3 = "[object Symbol]";
var arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$3:
      return cloneArrayBuffer(object);
    case boolTag$3:
    case dateTag$3:
      return new Ctor(+object);
    case dataViewTag$2:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$5:
      return new Ctor();
    case numberTag$3:
    case stringTag$3:
      return new Ctor(object);
    case regexpTag$3:
      return cloneRegExp(object);
    case setTag$5:
      return new Ctor();
    case symbolTag$3:
      return cloneSymbol(object);
  }
}
var _initCloneByTag = initCloneByTag$1;
var isObject$3 = isObject_1;
var objectCreate = Object.create;
var baseCreate$1 = /* @__PURE__ */ function() {
  function object() {
  }
  return function(proto) {
    if (!isObject$3(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = void 0;
    return result;
  };
}();
var _baseCreate = baseCreate$1;
var baseCreate = _baseCreate, getPrototype$1 = _getPrototype, isPrototype$1 = _isPrototype;
function initCloneObject$1(object) {
  return typeof object.constructor == "function" && !isPrototype$1(object) ? baseCreate(getPrototype$1(object)) : {};
}
var _initCloneObject = initCloneObject$1;
var getTag$6 = _getTag, isObjectLike$f = isObjectLike_1;
var mapTag$4 = "[object Map]";
function baseIsMap$1(value) {
  return isObjectLike$f(value) && getTag$6(value) == mapTag$4;
}
var _baseIsMap = baseIsMap$1;
var baseIsMap = _baseIsMap, baseUnary$4 = _baseUnary, nodeUtil$4 = _nodeUtilExports;
var nodeIsMap = nodeUtil$4 && nodeUtil$4.isMap;
var isMap$1 = nodeIsMap ? baseUnary$4(nodeIsMap) : baseIsMap;
var isMap_1 = isMap$1;
var getTag$5 = _getTag, isObjectLike$e = isObjectLike_1;
var setTag$4 = "[object Set]";
function baseIsSet$1(value) {
  return isObjectLike$e(value) && getTag$5(value) == setTag$4;
}
var _baseIsSet = baseIsSet$1;
var baseIsSet = _baseIsSet, baseUnary$3 = _baseUnary, nodeUtil$3 = _nodeUtilExports;
var nodeIsSet = nodeUtil$3 && nodeUtil$3.isSet;
var isSet$1 = nodeIsSet ? baseUnary$3(nodeIsSet) : baseIsSet;
var isSet_1 = isSet$1;
var Stack$4 = _Stack, arrayEach = _arrayEach, assignValue = _assignValue, baseAssign = _baseAssign, baseAssignIn = _baseAssignIn, cloneBuffer = _cloneBufferExports, copyArray$1 = _copyArray, copySymbols = _copySymbols, copySymbolsIn = _copySymbolsIn, getAllKeys$1 = _getAllKeys, getAllKeysIn = _getAllKeysIn, getTag$4 = _getTag, initCloneArray = _initCloneArray, initCloneByTag = _initCloneByTag, initCloneObject = _initCloneObject, isArray$4 = isArray_1, isBuffer$2 = isBufferExports, isMap = isMap_1, isObject$2 = isObject_1, isSet = isSet_1, keys$3 = keys_1, keysIn$1 = keysIn_1;
var CLONE_DEEP_FLAG$2 = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$4 = 4;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", errorTag$2 = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag$3 = "[object Map]", numberTag$2 = "[object Number]", objectTag$2 = "[object Object]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$2 = "[object String]", symbolTag$2 = "[object Symbol]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$3] = cloneableTags[numberTag$2] = cloneableTags[objectTag$2] = cloneableTags[regexpTag$2] = cloneableTags[setTag$3] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$2] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag$2] = cloneableTags[funcTag] = cloneableTags[weakMapTag$1] = false;
function baseClone$4(value, bitmask, customizer, key, object, stack) {
  var result, isDeep = bitmask & CLONE_DEEP_FLAG$2, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG$4;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== void 0) {
    return result;
  }
  if (!isObject$2(value)) {
    return value;
  }
  var isArr = isArray$4(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray$1(value, result);
    }
  } else {
    var tag = getTag$4(value), isFunc = tag == funcTag || tag == genTag;
    if (isBuffer$2(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$2 || tag == argsTag$1 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack$4());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$4(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key2) {
      result.set(key2, baseClone$4(subValue, bitmask, customizer, key2, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys$1 : isFlat ? keysIn$1 : keys$3;
  var props = isArr ? void 0 : keysFunc(value);
  arrayEach(props || value, function(subValue, key2) {
    if (props) {
      key2 = subValue;
      subValue = value[key2];
    }
    assignValue(result, key2, baseClone$4(subValue, bitmask, customizer, key2, value, stack));
  });
  return result;
}
var _baseClone = baseClone$4;
var baseClone$3 = _baseClone;
var CLONE_SYMBOLS_FLAG$3 = 4;
function clone(value) {
  return baseClone$3(value, CLONE_SYMBOLS_FLAG$3);
}
var clone_1 = clone;
var baseClone$2 = _baseClone;
var CLONE_DEEP_FLAG$1 = 1, CLONE_SYMBOLS_FLAG$2 = 4;
function cloneDeep(value) {
  return baseClone$2(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$2);
}
var cloneDeep_1 = cloneDeep;
var baseClone$1 = _baseClone;
var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG$1 = 4;
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == "function" ? customizer : void 0;
  return baseClone$1(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG$1, customizer);
}
var cloneDeepWith_1 = cloneDeepWith;
var baseClone = _baseClone;
var CLONE_SYMBOLS_FLAG = 4;
function cloneWith(value, customizer) {
  customizer = typeof customizer == "function" ? customizer : void 0;
  return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
}
var cloneWith_1 = cloneWith;
function baseConformsTo$1(object, source, props) {
  var length = props.length;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (length--) {
    var key = props[length], predicate = source[key], value = object[key];
    if (value === void 0 && !(key in object) || !predicate(value)) {
      return false;
    }
  }
  return true;
}
var _baseConformsTo = baseConformsTo$1;
var baseConformsTo = _baseConformsTo, keys$2 = keys_1;
function conformsTo(object, source) {
  return source == null || baseConformsTo(object, source, keys$2(source));
}
var conformsTo_1 = conformsTo;
function baseGt$1(value, other) {
  return value > other;
}
var _baseGt = baseGt$1;
var reWhitespace = /\s/;
function trimmedEndIndex$1(string) {
  var index2 = string.length;
  while (index2-- && reWhitespace.test(string.charAt(index2))) {
  }
  return index2;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var _baseTrim = baseTrim$1;
var baseGetTag$9 = _baseGetTag, isObjectLike$d = isObjectLike_1;
var symbolTag$1 = "[object Symbol]";
function isSymbol$2(value) {
  return typeof value == "symbol" || isObjectLike$d(value) && baseGetTag$9(value) == symbolTag$1;
}
var isSymbol_1 = isSymbol$2;
var baseTrim = _baseTrim, isObject$1 = isObject_1, isSymbol$1 = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$2(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$1(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$2;
var toNumber$1 = toNumber_1;
function createRelationalOperation$4(operator) {
  return function(value, other) {
    if (!(typeof value == "string" && typeof other == "string")) {
      value = toNumber$1(value);
      other = toNumber$1(other);
    }
    return operator(value, other);
  };
}
var _createRelationalOperation = createRelationalOperation$4;
var baseGt = _baseGt, createRelationalOperation$3 = _createRelationalOperation;
var gt = createRelationalOperation$3(baseGt);
var gt_1 = gt;
var createRelationalOperation$2 = _createRelationalOperation;
var gte = createRelationalOperation$2(function(value, other) {
  return value >= other;
});
var gte_1 = gte;
var baseGetTag$8 = _baseGetTag, isObjectLike$c = isObjectLike_1;
var arrayBufferTag$1 = "[object ArrayBuffer]";
function baseIsArrayBuffer$1(value) {
  return isObjectLike$c(value) && baseGetTag$8(value) == arrayBufferTag$1;
}
var _baseIsArrayBuffer = baseIsArrayBuffer$1;
var baseIsArrayBuffer = _baseIsArrayBuffer, baseUnary$2 = _baseUnary, nodeUtil$2 = _nodeUtilExports;
var nodeIsArrayBuffer = nodeUtil$2 && nodeUtil$2.isArrayBuffer;
var isArrayBuffer = nodeIsArrayBuffer ? baseUnary$2(nodeIsArrayBuffer) : baseIsArrayBuffer;
var isArrayBuffer_1 = isArrayBuffer;
var isArrayLike$2 = isArrayLike_1, isObjectLike$b = isObjectLike_1;
function isArrayLikeObject(value) {
  return isObjectLike$b(value) && isArrayLike$2(value);
}
var isArrayLikeObject_1 = isArrayLikeObject;
var baseGetTag$7 = _baseGetTag, isObjectLike$a = isObjectLike_1;
var boolTag$1 = "[object Boolean]";
function isBoolean(value) {
  return value === true || value === false || isObjectLike$a(value) && baseGetTag$7(value) == boolTag$1;
}
var isBoolean_1 = isBoolean;
var baseGetTag$6 = _baseGetTag, isObjectLike$9 = isObjectLike_1;
var dateTag$1 = "[object Date]";
function baseIsDate$1(value) {
  return isObjectLike$9(value) && baseGetTag$6(value) == dateTag$1;
}
var _baseIsDate = baseIsDate$1;
var baseIsDate = _baseIsDate, baseUnary$1 = _baseUnary, nodeUtil$1 = _nodeUtilExports;
var nodeIsDate = nodeUtil$1 && nodeUtil$1.isDate;
var isDate = nodeIsDate ? baseUnary$1(nodeIsDate) : baseIsDate;
var isDate_1 = isDate;
var baseGetTag$5 = _baseGetTag, getPrototype = _getPrototype, isObjectLike$8 = isObjectLike_1;
var objectTag$1 = "[object Object]";
var funcProto = Function.prototype, objectProto$3 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
var objectCtorString = funcToString.call(Object);
function isPlainObject$2(value) {
  if (!isObjectLike$8(value) || baseGetTag$5(value) != objectTag$1) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$3.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
var isPlainObject_1 = isPlainObject$2;
var isObjectLike$7 = isObjectLike_1, isPlainObject$1 = isPlainObject_1;
function isElement(value) {
  return isObjectLike$7(value) && value.nodeType === 1 && !isPlainObject$1(value);
}
var isElement_1 = isElement;
var baseKeys = _baseKeys, getTag$3 = _getTag, isArguments = isArguments_1, isArray$3 = isArray_1, isArrayLike$1 = isArrayLike_1, isBuffer$1 = isBufferExports, isPrototype = _isPrototype, isTypedArray$1 = isTypedArray_1;
var mapTag$2 = "[object Map]", setTag$2 = "[object Set]";
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike$1(value) && (isArray$3(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer$1(value) || isTypedArray$1(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag$3(value);
  if (tag == mapTag$2 || tag == setTag$2) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$2.call(value, key)) {
      return false;
    }
  }
  return true;
}
var isEmpty_1 = isEmpty;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$1(values2) {
  var index2 = -1, length = values2 == null ? 0 : values2.length;
  this.__data__ = new MapCache();
  while (++index2 < length) {
    this.add(values2[index2]);
  }
}
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;
function arraySome$1(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (predicate(array[index2], index2, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
function cacheHas$1(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$1;
var SetCache = _SetCache, arraySome = _arraySome, cacheHas = _cacheHas;
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$2 ? new SetCache() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index2 < arrLength) {
    var arrValue = array[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result;
}
var _equalArrays = equalArrays$2;
function mapToArray$2(map) {
  var index2 = -1, result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$2;
function setToArray$2(set) {
  var index2 = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var _setToArray = setToArray$2;
var Symbol$3 = _Symbol, Uint8Array = _Uint8Array, eq = eq_1, equalArrays$1 = _equalArrays, mapToArray$1 = _mapToArray, setToArray$1 = _setToArray;
var COMPARE_PARTIAL_FLAG$3 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag$1 = "[object Error]", mapTag$1 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$1 = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : void 0, symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag$1:
      return eq(+object, +other);
    case errorTag$1:
      return object.name == other.name && object.message == other.message;
    case regexpTag$1:
    case stringTag$1:
      return object == other + "";
    case mapTag$1:
      var convert = mapToArray$1;
    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3;
      convert || (convert = setToArray$1);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
var getAllKeys = _getAllKeys;
var COMPARE_PARTIAL_FLAG$2 = 1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result;
}
var _equalObjects = equalObjects$1;
var Stack$3 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag$2 = _getTag, isArray$2 = isArray_1, isBuffer = isBufferExports, isTypedArray = isTypedArray_1;
var COMPARE_PARTIAL_FLAG$1 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$2(object), othIsArr = isArray$2(other), objTag = objIsArr ? arrayTag : getTag$2(object), othTag = othIsArr ? arrayTag : getTag$2(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$3());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$1)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$3());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$3());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike$6 = isObjectLike_1;
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike$6(value) && !isObjectLike$6(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}
var _baseIsEqual = baseIsEqual$3;
var baseIsEqual$2 = _baseIsEqual;
function isEqual(value, other) {
  return baseIsEqual$2(value, other);
}
var isEqual_1 = isEqual;
var baseIsEqual$1 = _baseIsEqual;
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == "function" ? customizer : void 0;
  var result = customizer ? customizer(value, other) : void 0;
  return result === void 0 ? baseIsEqual$1(value, other, void 0, customizer) : !!result;
}
var isEqualWith_1 = isEqualWith;
var baseGetTag$4 = _baseGetTag, isObjectLike$5 = isObjectLike_1, isPlainObject = isPlainObject_1;
var domExcTag = "[object DOMException]", errorTag = "[object Error]";
function isError(value) {
  if (!isObjectLike$5(value)) {
    return false;
  }
  var tag = baseGetTag$4(value);
  return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
}
var isError_1 = isError;
var root = _root;
var nativeIsFinite = root.isFinite;
function isFinite$1(value) {
  return typeof value == "number" && nativeIsFinite(value);
}
var _isFinite = isFinite$1;
var toNumber = toNumber_1;
var INFINITY$1 = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY$1 || value === -INFINITY$1) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
var toFinite_1 = toFinite$1;
var toFinite = toFinite_1;
function toInteger$3(value) {
  var result = toFinite(value), remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
var toInteger_1 = toInteger$3;
var toInteger$2 = toInteger_1;
function isInteger$1(value) {
  return typeof value == "number" && value == toInteger$2(value);
}
var isInteger_1 = isInteger$1;
var Stack$2 = _Stack, baseIsEqual = _baseIsEqual;
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseIsMatch$2(object, source, matchData, customizer) {
  var index2 = matchData.length, length = index2, noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index2--) {
    var data = matchData[index2];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index2 < length) {
    data = matchData[index2];
    var key = data[0], objValue = object[key], srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === void 0 && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$2();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$2;
var isObject = isObject_1;
function isStrictComparable$1(value) {
  return value === value && !isObject(value);
}
var _isStrictComparable = isStrictComparable$1;
var isStrictComparable = _isStrictComparable, keys$1 = keys_1;
function getMatchData$2(object) {
  var result = keys$1(object), length = result.length;
  while (length--) {
    var key = result[length], value = object[key];
    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}
var _getMatchData = getMatchData$2;
var baseIsMatch$1 = _baseIsMatch, getMatchData$1 = _getMatchData;
function isMatch(object, source) {
  return object === source || baseIsMatch$1(object, source, getMatchData$1(source));
}
var isMatch_1 = isMatch;
var baseIsMatch = _baseIsMatch, getMatchData = _getMatchData;
function isMatchWith(object, source, customizer) {
  customizer = typeof customizer == "function" ? customizer : void 0;
  return baseIsMatch(object, source, getMatchData(source), customizer);
}
var isMatchWith_1 = isMatchWith;
var baseGetTag$3 = _baseGetTag, isObjectLike$4 = isObjectLike_1;
var numberTag = "[object Number]";
function isNumber$1(value) {
  return typeof value == "number" || isObjectLike$4(value) && baseGetTag$3(value) == numberTag;
}
var isNumber_1 = isNumber$1;
var isNumber = isNumber_1;
function isNaN$1(value) {
  return isNumber(value) && value != +value;
}
var _isNaN = isNaN$1;
var coreJsData = _coreJsData, isFunction = isFunction_1, stubFalse = stubFalse_1;
var isMaskable$1 = coreJsData ? isFunction : stubFalse;
var _isMaskable = isMaskable$1;
var baseIsNative = _baseIsNative, isMaskable = _isMaskable;
var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.";
function isNative(value) {
  if (isMaskable(value)) {
    throw new Error(CORE_ERROR_TEXT);
  }
  return baseIsNative(value);
}
var isNative_1 = isNative;
function isNil(value) {
  return value == null;
}
var isNil_1 = isNil;
function isNull(value) {
  return value === null;
}
var isNull_1 = isNull;
var baseGetTag$2 = _baseGetTag, isObjectLike$3 = isObjectLike_1;
var regexpTag = "[object RegExp]";
function baseIsRegExp$1(value) {
  return isObjectLike$3(value) && baseGetTag$2(value) == regexpTag;
}
var _baseIsRegExp = baseIsRegExp$1;
var baseIsRegExp = _baseIsRegExp, baseUnary = _baseUnary, nodeUtil = _nodeUtilExports;
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
var isRegExp_1 = isRegExp;
var isInteger = isInteger_1;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
function isSafeInteger(value) {
  return isInteger(value) && value >= -MAX_SAFE_INTEGER$1 && value <= MAX_SAFE_INTEGER$1;
}
var isSafeInteger_1 = isSafeInteger;
var baseGetTag$1 = _baseGetTag, isArray$1 = isArray_1, isObjectLike$2 = isObjectLike_1;
var stringTag = "[object String]";
function isString$1(value) {
  return typeof value == "string" || !isArray$1(value) && isObjectLike$2(value) && baseGetTag$1(value) == stringTag;
}
var isString_1 = isString$1;
function isUndefined(value) {
  return value === void 0;
}
var isUndefined_1 = isUndefined;
var getTag$1 = _getTag, isObjectLike$1 = isObjectLike_1;
var weakMapTag = "[object WeakMap]";
function isWeakMap(value) {
  return isObjectLike$1(value) && getTag$1(value) == weakMapTag;
}
var isWeakMap_1 = isWeakMap;
var baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1;
var weakSetTag = "[object WeakSet]";
function isWeakSet(value) {
  return isObjectLike(value) && baseGetTag(value) == weakSetTag;
}
var isWeakSet_1 = isWeakSet;
function baseLt$1(value, other) {
  return value < other;
}
var _baseLt = baseLt$1;
var baseLt = _baseLt, createRelationalOperation$1 = _createRelationalOperation;
var lt = createRelationalOperation$1(baseLt);
var lt_1 = lt;
var createRelationalOperation = _createRelationalOperation;
var lte = createRelationalOperation(function(value, other) {
  return value <= other;
});
var lte_1 = lte;
function iteratorToArray$1(iterator) {
  var data, result = [];
  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}
var _iteratorToArray = iteratorToArray$1;
function asciiToArray$1(string) {
  return string.split("");
}
var _asciiToArray = asciiToArray$1;
var rsAstralRange$1 = "\\ud800-\\udfff", rsComboMarksRange$1 = "\\u0300-\\u036f", reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$1 = "\\u20d0-\\u20ff", rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1, rsVarRange$1 = "\\ufe0e\\ufe0f";
var rsZWJ$1 = "\\u200d";
var reHasUnicode = RegExp("[" + rsZWJ$1 + rsAstralRange$1 + rsComboRange$1 + rsVarRange$1 + "]");
function hasUnicode$1(string) {
  return reHasUnicode.test(string);
}
var _hasUnicode = hasUnicode$1;
var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
var rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsZWJ = "\\u200d";
var reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}
var _unicodeToArray = unicodeToArray$1;
var asciiToArray = _asciiToArray, hasUnicode = _hasUnicode, unicodeToArray = _unicodeToArray;
function stringToArray$1(string) {
  return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
var _stringToArray = stringToArray$1;
function arrayMap$2(array, iteratee) {
  var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
  while (++index2 < length) {
    result[index2] = iteratee(array[index2], index2, array);
  }
  return result;
}
var _arrayMap = arrayMap$2;
var arrayMap$1 = _arrayMap;
function baseValues$1(object, props) {
  return arrayMap$1(props, function(key) {
    return object[key];
  });
}
var _baseValues = baseValues$1;
var baseValues = _baseValues, keys = keys_1;
function values$1(object) {
  return object == null ? [] : baseValues(object, keys(object));
}
var values_1 = values$1;
var Symbol$2 = _Symbol, copyArray = _copyArray, getTag = _getTag, isArrayLike = isArrayLike_1, isString = isString_1, iteratorToArray = _iteratorToArray, mapToArray = _mapToArray, setToArray = _setToArray, stringToArray = _stringToArray, values = values_1;
var mapTag = "[object Map]", setTag = "[object Set]";
var symIterator = Symbol$2 ? Symbol$2.iterator : void 0;
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
  return func(value);
}
var toArray_1 = toArray;
function baseClamp$2(number, lower, upper) {
  if (number === number) {
    if (upper !== void 0) {
      number = number <= upper ? number : upper;
    }
    if (lower !== void 0) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}
var _baseClamp = baseClamp$2;
var baseClamp$1 = _baseClamp, toInteger$1 = toInteger_1;
var MAX_ARRAY_LENGTH = 4294967295;
function toLength(value) {
  return value ? baseClamp$1(toInteger$1(value), 0, MAX_ARRAY_LENGTH) : 0;
}
var toLength_1 = toLength;
var copyObject = _copyObject, keysIn = keysIn_1;
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}
var toPlainObject_1 = toPlainObject;
var baseClamp = _baseClamp, toInteger = toInteger_1;
var MAX_SAFE_INTEGER = 9007199254740991;
function toSafeInteger(value) {
  return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
}
var toSafeInteger_1 = toSafeInteger;
var Symbol$1 = _Symbol, arrayMap = _arrayMap, isArray = isArray_1, isSymbol = isSymbol_1;
var INFINITY = 1 / 0;
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString$1(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray(value)) {
    return arrayMap(value, baseToString$1) + "";
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
var _baseToString = baseToString$1;
var baseToString = _baseToString;
function toString(value) {
  return value == null ? "" : baseToString(value);
}
var toString_1 = toString;
var lang = {
  "castArray": castArray_1,
  "clone": clone_1,
  "cloneDeep": cloneDeep_1,
  "cloneDeepWith": cloneDeepWith_1,
  "cloneWith": cloneWith_1,
  "conformsTo": conformsTo_1,
  "eq": eq_1,
  "gt": gt_1,
  "gte": gte_1,
  "isArguments": isArguments_1,
  "isArray": isArray_1,
  "isArrayBuffer": isArrayBuffer_1,
  "isArrayLike": isArrayLike_1,
  "isArrayLikeObject": isArrayLikeObject_1,
  "isBoolean": isBoolean_1,
  "isBuffer": isBufferExports,
  "isDate": isDate_1,
  "isElement": isElement_1,
  "isEmpty": isEmpty_1,
  "isEqual": isEqual_1,
  "isEqualWith": isEqualWith_1,
  "isError": isError_1,
  "isFinite": _isFinite,
  "isFunction": isFunction_1,
  "isInteger": isInteger_1,
  "isLength": isLength_1,
  "isMap": isMap_1,
  "isMatch": isMatch_1,
  "isMatchWith": isMatchWith_1,
  "isNaN": _isNaN,
  "isNative": isNative_1,
  "isNil": isNil_1,
  "isNull": isNull_1,
  "isNumber": isNumber_1,
  "isObject": isObject_1,
  "isObjectLike": isObjectLike_1,
  "isPlainObject": isPlainObject_1,
  "isRegExp": isRegExp_1,
  "isSafeInteger": isSafeInteger_1,
  "isSet": isSet_1,
  "isString": isString_1,
  "isSymbol": isSymbol_1,
  "isTypedArray": isTypedArray_1,
  "isUndefined": isUndefined_1,
  "isWeakMap": isWeakMap_1,
  "isWeakSet": isWeakSet_1,
  "lt": lt_1,
  "lte": lte_1,
  "toArray": toArray_1,
  "toFinite": toFinite_1,
  "toInteger": toInteger_1,
  "toLength": toLength_1,
  "toNumber": toNumber_1,
  "toPlainObject": toPlainObject_1,
  "toSafeInteger": toSafeInteger_1,
  "toString": toString_1
};
const LinkList$2 = ({
  className = "",
  linkClassName = "",
  linkClassFn = () => "",
  links = [],
  target = "_self"
}) => {
  if (!links || lang.isEmpty(links)) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `link-list ${className}`, children: links == null ? void 0 : links.map((link, i5) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        className: `link-list-link ${linkClassName} ${link && link.className ? link.className : ""} ${linkClassFn(link)} ${link.id}`,
        href: link.href,
        id: link.id ? link.id : `${link.label}-${i5}`,
        title: link.label,
        target: link.target || target,
        children: link.label || ""
      },
      i5
    );
  }) });
};
const TRPFaceBookBlue = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.86133 0.737305C1.30904 0.737305 0.861328 1.18502 0.861328 1.7373V19.1388C0.861328 19.691 1.30904 20.1388 1.86133 20.1388H9.97725V20.1388H13.3944V20.1388H19.309C19.8613 20.1388 20.309 19.691 20.309 19.1388V1.7373C20.309 1.18502 19.8613 0.737305 19.309 0.737305H1.86133ZM13.3944 20.1388V11.9462H16.0987L16.3018 9.58799H13.3944V7.74697C13.3944 7.11343 14.0292 6.88631 14.7384 6.88631C15.4472 6.88631 16.2068 7.08261 16.2068 7.08261L16.6625 4.66834C16.6625 4.66834 15.6942 4.37512 13.3944 4.37512C11.9828 4.37512 11.1624 4.85525 10.5643 5.5616C9.99699 6.22865 9.97725 7.3057 9.97725 8.00423V9.58799H8.15411V11.9462H9.97725V20.1388H13.3944Z",
        fill: "#05C3DE"
      }
    )
  }
);
const TRPFaceBookGrey = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.42969 0.737305C0.877403 0.737305 0.429688 1.18502 0.429688 1.7373V19.1388C0.429688 19.691 0.877403 20.1388 1.42969 20.1388H9.54561V20.1388H12.9628V20.1388H18.8774C19.4297 20.1388 19.8774 19.691 19.8774 19.1388V1.7373C19.8774 1.18502 19.4297 0.737305 18.8774 0.737305H1.42969ZM12.9628 20.1388V11.9462H15.667L15.8701 9.58799H12.9628V7.74697C12.9628 7.11343 13.5976 6.88631 14.3068 6.88631C15.0155 6.88631 15.7752 7.08261 15.7752 7.08261L16.2309 4.66834C16.2309 4.66834 15.2626 4.37512 12.9628 4.37512C11.5511 4.37512 10.7307 4.85525 10.1327 5.5616C9.56535 6.22865 9.54561 7.3057 9.54561 8.00423V9.58799H7.72247V11.9462H9.54561V20.1388H12.9628Z",
        fill: "#888888"
      }
    )
  }
);
const TRPLinkedInBlue = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "21",
    height: "20",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.86133 0.232422C1.30904 0.232422 0.861328 0.680136 0.861328 1.23242V18.6339C0.861328 19.1862 1.30904 19.6339 1.86133 19.6339H19.309C19.8613 19.6339 20.309 19.1862 20.309 18.6339V1.23242C20.309 0.680137 19.8613 0.232422 19.309 0.232422H1.86133ZM6.87485 8.38025H4.24976V16.6024H6.87485V8.38025ZM5.48394 7.34387H5.46487C4.51552 7.34387 3.89972 6.71206 3.89972 5.91169C3.89972 5.09536 4.53402 4.4765 5.50244 4.4765C6.47028 4.4765 7.06568 5.09386 7.08475 5.90944C7.08475 6.71018 6.47028 7.34387 5.48394 7.34387ZM14.3203 16.6024H17.2702V12.0169C17.2702 9.46306 15.8178 8.27661 13.9694 8.27661C12.4786 8.27661 11.5451 9.08437 11.3723 9.65016V8.35602H8.45001C8.48802 9.04335 8.45001 16.6024 8.45001 16.6024H11.3723V12.1403C11.3723 12.111 11.3721 12.0818 11.372 12.0526C11.3708 11.8343 11.3696 11.6229 11.436 11.4663C11.6372 10.9701 12.0683 10.4559 12.8444 10.4559C13.8595 10.4559 14.3203 11.2181 14.3203 12.3351V16.6024Z",
        fill: "#05C3DE"
      }
    )
  }
);
const TRPLinkedInGrey = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.42969 0.232422C0.877403 0.232422 0.429688 0.680136 0.429688 1.23242V18.6339C0.429688 19.1862 0.877403 19.6339 1.42969 19.6339H18.8774C19.4297 19.6339 19.8774 19.1862 19.8774 18.6339V1.23242C19.8774 0.680137 19.4297 0.232422 18.8774 0.232422H1.42969ZM6.44321 8.38025H3.81812V16.6024H6.44321V8.38025ZM5.0523 7.34387H5.03323C4.08388 7.34387 3.46808 6.71206 3.46808 5.91169C3.46808 5.09536 4.10238 4.4765 5.0708 4.4765C6.03864 4.4765 6.63404 5.09386 6.65311 5.90944C6.65311 6.71018 6.03864 7.34387 5.0523 7.34387ZM13.8887 16.6024H16.8386V12.0169C16.8386 9.46306 15.3861 8.27661 13.5378 8.27661C12.0469 8.27661 11.1135 9.08437 10.9407 9.65016V8.35602H8.01837C8.05638 9.04335 8.01837 16.6024 8.01837 16.6024H10.9407V12.1403C10.9407 12.111 10.9405 12.0818 10.9403 12.0526C10.9391 11.8343 10.938 11.6229 11.0044 11.4663C11.2056 10.9701 11.6366 10.4559 12.4128 10.4559C13.4279 10.4559 13.8887 11.2181 13.8887 12.3351V16.6024Z",
        fill: "#888888"
      }
    )
  }
);
const TRPTwitterBlue = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "25",
    height: "21",
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: "M17.0109 0.902344C14.3257 0.902344 12.1489 3.07393 12.1489 5.75271C12.1222 6.15836 12.1467 6.56576 12.2218 6.96531C8.2643 6.75732 4.58251 4.87892 2.09685 1.79966C1.66414 2.53535 1.43354 3.37187 1.42834 4.22485C1.33665 5.84372 2.08486 7.39609 3.40958 8.33554C2.5747 8.24853 1.75631 8.04442 0.978609 7.72924V7.78987C1.05005 10.1759 2.77312 12.1923 5.12341 12.6402C4.72883 12.7562 4.31925 12.8134 3.90793 12.81C3.61407 12.8116 3.32082 12.7832 3.03278 12.7251C3.71561 14.7289 5.60309 16.0753 7.72455 16.0719C5.9926 17.4326 3.85167 18.1716 1.64713 18.1697C1.24085 18.1704 0.834918 18.1461 0.431641 18.0969C2.6754 19.5375 5.28724 20.3036 7.95549 20.3038C11.6695 20.3331 15.2402 18.8751 17.8676 16.2561C20.495 13.6372 21.9597 10.0764 21.9336 6.37114C21.9336 6.15287 21.9336 5.94673 21.9336 5.74059C22.8879 5.04601 23.711 4.18792 24.3645 3.20627C23.4685 3.60343 22.518 3.86499 21.5446 3.98233C22.5746 3.36586 23.3438 2.39581 23.7082 1.254C22.744 1.83335 21.6875 2.24349 20.5844 2.46659C19.6644 1.47022 18.3687 0.903052 17.0109 0.902344",
        fill: "#05C3DE"
      }
    )
  }
);
const TRPTwitterGrey = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "24",
    height: "21",
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: "M16.5792 0.902344C13.894 0.902344 11.7173 3.07393 11.7173 5.75271C11.6905 6.15836 11.7151 6.56576 11.7902 6.96531C7.83266 6.75732 4.15087 4.87892 1.66521 1.79966C1.2325 2.53535 1.0019 3.37187 0.996697 4.22485C0.905012 5.84372 1.65322 7.39609 2.97794 8.33554C2.14306 8.24853 1.32467 8.04442 0.546968 7.72924V7.78987C0.618405 10.1759 2.34147 12.1923 4.69177 12.6402C4.29718 12.7562 3.88761 12.8134 3.47629 12.81C3.18243 12.8116 2.88918 12.7832 2.60114 12.7251C3.28396 14.7289 5.17145 16.0753 7.29291 16.0719C5.56096 17.4326 3.42003 18.1716 1.21548 18.1697C0.809209 18.1704 0.403277 18.1461 0 18.0969C2.24376 19.5375 4.8556 20.3036 7.52385 20.3038C11.2379 20.3331 14.8085 18.8751 17.436 16.2561C20.0634 13.6372 21.5281 10.0764 21.5019 6.37114C21.5019 6.15287 21.5019 5.94673 21.5019 5.74059C22.4562 5.04601 23.2793 4.18792 23.9329 3.20627C23.0368 3.60343 22.0864 3.86499 21.113 3.98233C22.1429 3.36586 22.9122 2.39581 23.2765 1.254C22.3124 1.83335 21.2558 2.24349 20.1527 2.46659C19.2328 1.47022 17.9371 0.903052 16.5792 0.902344",
        fill: "#888888"
      }
    )
  }
);
const TRPYoutubeBlue$1 = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "25",
    height: "18",
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.4702 0.145544H12.058L12.4279 0.134766C12.4279 0.134766 17.5224 0.156323 20.8835 0.404231C21.8001 0.428967 22.6716 0.815361 23.3145 1.48209C23.8514 2.19297 24.2137 3.0245 24.3714 3.90728C24.5875 5.21472 24.7041 6.53724 24.7202 7.86302V9.70617C24.7042 11.0319 24.5876 12.3545 24.3714 13.6619C24.2016 14.5408 23.8404 15.3696 23.3145 16.0871C22.6833 16.7583 21.8163 17.1461 20.9046 17.165C17.5013 17.4236 12.4491 17.4236 12.4491 17.4236C12.4491 17.4236 6.20255 17.359 4.27891 17.1757C3.29615 17.1541 2.35409 16.7714 1.62599 16.0979C1.11479 15.3835 0.787708 14.5496 0.674737 13.6727C0.5241 12.3595 0.44295 11.039 0.431641 9.71694V7.86302C0.437111 6.54854 0.511202 5.23528 0.653599 3.92883C0.765738 3.04845 1.09282 2.21086 1.60485 1.49287C2.238 0.82457 3.10371 0.437358 4.01468 0.415009C7.4286 0.145544 12.4702 0.145544 12.4702 0.145544ZM16.434 8.54204L9.9444 5.0929V12.002L16.434 8.54204Z",
        fill: "#05C3DE"
      }
    )
  }
);
const TRPYoutubeBlue = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "25",
    height: "18",
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0386 0.145544H11.6264L11.9963 0.134766C11.9963 0.134766 17.0908 0.156323 20.4518 0.404231C21.3685 0.428967 22.2399 0.815361 22.8828 1.48209C23.4197 2.19297 23.7821 3.0245 23.9398 3.90728C24.1558 5.21472 24.2724 6.53724 24.2885 7.86302V9.70617C24.2725 11.0319 24.1559 12.3545 23.9398 13.6619C23.7699 14.5408 23.4087 15.3696 22.8828 16.0871C22.2517 16.7583 21.3847 17.1461 20.473 17.165C17.0696 17.4236 12.0174 17.4236 12.0174 17.4236C12.0174 17.4236 5.77091 17.359 3.84727 17.1757C2.86451 17.1541 1.92245 16.7714 1.19435 16.0979C0.683153 15.3835 0.356068 14.5496 0.243097 13.6727C0.0924594 12.3595 0.0113096 11.039 0 9.71694V7.86302C0.00547023 6.54854 0.0795611 5.23528 0.221958 3.92883C0.334098 3.04845 0.661178 2.21086 1.17321 1.49287C1.80636 0.82457 2.67207 0.437358 3.58304 0.415009C6.99696 0.145544 12.0386 0.145544 12.0386 0.145544ZM16.0024 8.54204L9.51276 5.0929V12.002L16.0024 8.54204Z",
        fill: "#888888"
      }
    )
  }
);
const LinkListSocial = ({
  className = "",
  linkClassName = "",
  linkClassFn = () => "",
  links = [],
  target = "_self"
}) => {
  const [isHoveringFaceBook, setIsHoveringFaceBook] = useState(false);
  const [isHoveringYouTube, setIsHoveringYouTube] = useState(false);
  const [isHoveringLinkedin, setIsHoveringLinkedin] = useState(false);
  const [isHoveringTwitter, setIsHoveringTwitter] = useState(false);
  const isMouseOverFaceBook = () => {
    setIsHoveringFaceBook(true);
  };
  const mouseIsntOverFaceBook = () => {
    setIsHoveringFaceBook(false);
  };
  const isMouseOverTwitter = () => {
    setIsHoveringTwitter(true);
  };
  const mouseIsntOverTwitter = () => {
    setIsHoveringTwitter(false);
  };
  const isMouseOverYouTube = () => {
    setIsHoveringYouTube(true);
  };
  const mouseIsntOverYouTube = () => {
    setIsHoveringYouTube(false);
  };
  const isMouseOverLinkedin = () => {
    setIsHoveringLinkedin(true);
  };
  const mouseIsntOverLinkedin = () => {
    setIsHoveringLinkedin(false);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `link-list ${className}`, children: links == null ? void 0 : links.map((link, i5) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "social",
      children: [
        i5 === 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            onMouseOver: isMouseOverFaceBook,
            onMouseOut: mouseIsntOverFaceBook,
            className: "facebook",
            children: [
              !isHoveringFaceBook && /* @__PURE__ */ jsxRuntimeExports.jsx(TRPFaceBookGrey, {}),
              isHoveringFaceBook && /* @__PURE__ */ jsxRuntimeExports.jsx(TRPFaceBookBlue, {}),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "a",
                {
                  className: `link-list-link ${linkClassName} ${link.className} ${linkClassFn(link)}`,
                  href: link.href,
                  id: link.id ? link.id : `${link.label}-${i5}`,
                  title: link.label,
                  target: link.target || target,
                  children: link.label || ""
                },
                i5
              )
            ]
          }
        ),
        i5 === 1 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            onMouseOver: isMouseOverTwitter,
            onMouseOut: mouseIsntOverTwitter,
            className: "facebook",
            children: [
              !isHoveringTwitter && /* @__PURE__ */ jsxRuntimeExports.jsx(TRPTwitterGrey, {}),
              isHoveringTwitter && /* @__PURE__ */ jsxRuntimeExports.jsx(TRPTwitterBlue, {}),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "a",
                {
                  className: `link-list-link ${linkClassName} ${link.className} ${linkClassFn(link)}`,
                  href: link.href,
                  title: link.label,
                  target: link.target || target,
                  children: link.label || ""
                },
                i5
              )
            ]
          }
        ),
        i5 === 2 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            onMouseOver: isMouseOverYouTube,
            onMouseOut: mouseIsntOverYouTube,
            className: "facebook",
            children: [
              !isHoveringYouTube && /* @__PURE__ */ jsxRuntimeExports.jsx(TRPYoutubeBlue, {}),
              isHoveringYouTube && /* @__PURE__ */ jsxRuntimeExports.jsx(TRPYoutubeBlue$1, {}),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "a",
                {
                  className: `link-list-link ${linkClassName} ${link.className} ${linkClassFn(link)}`,
                  href: link.href,
                  title: link.label,
                  target: link.target || target,
                  children: link.label || ""
                },
                i5
              )
            ]
          }
        ),
        i5 === 3 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            onMouseOver: isMouseOverLinkedin,
            onMouseOut: mouseIsntOverLinkedin,
            className: "facebook",
            children: [
              !isHoveringLinkedin && /* @__PURE__ */ jsxRuntimeExports.jsx(TRPLinkedInGrey, {}),
              isHoveringLinkedin && /* @__PURE__ */ jsxRuntimeExports.jsx(TRPLinkedInBlue, {}),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "a",
                {
                  className: `link-list-link ${linkClassName} ${link.className} ${linkClassFn(link)}`,
                  href: link.href,
                  title: link.label,
                  target: link.target || target,
                  children: link.label || ""
                },
                i5
              )
            ]
          }
        )
      ]
    },
    `social-${i5}`
  )) });
};
const TRPInvestWithConfidence = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    width: "339",
    height: "14",
    viewBox: "0 0 339 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M65.5048 4.08817C65.4077 2.88702 64.5828 2.19035 63.0787 2.19035C61.5745 2.19035 61.0165 2.74288 61.0165 3.63174C60.9981 4.00384 61.196 4.35367 61.526 4.5326C62.3469 4.88701 63.2055 5.1489 64.0855 5.31335C65.1367 5.49038 66.1473 5.85244 67.0696 6.38237C68.0421 6.95544 68.6301 8.00055 68.6102 9.121C68.6102 11.6434 66.6208 13.1929 63.3941 13.1929C59.9611 13.1929 57.9839 11.5713 57.9111 8.71261H60.6647C60.6337 9.27285 60.8303 9.8221 61.2106 10.2381C61.8213 10.822 62.6574 11.1155 63.5032 11.0428C64.9225 11.0428 65.8202 10.4062 65.8202 9.39726C65.8202 8.83272 65.5412 8.47238 64.8497 8.19611C64.0547 7.90957 63.2448 7.66499 62.4236 7.46341C61.3479 7.25681 60.33 6.82249 59.4395 6.19019C58.7766 5.56941 58.4257 4.68965 58.4812 3.78789C58.4812 1.49369 60.4221 0.0162697 63.3334 0.0162697C64.9046 -0.111021 66.4423 0.514125 67.4699 1.69788C67.9667 2.37389 68.2266 3.19224 68.2099 4.02812L65.5048 4.08817ZM17.3586 12.9045H20.1244L20.088 0.364441H17.4314V5.57744C17.4314 5.94403 17.4562 6.57012 17.4822 7.22515L17.4822 7.22525L17.4822 7.22534C17.5107 7.94383 17.5406 8.69711 17.5406 9.18089C17.0413 8.19243 16.4906 7.23022 15.8909 6.29813L12.2517 0.364441H9.43744V12.9165H12.094V7.57135C12.094 6.27411 12.0576 4.90479 11.9848 4.06399C12.4492 5.04569 12.9844 5.99304 13.5861 6.89871L17.3586 12.9045ZM0 12.9045H2.74149V0.364456H0V12.9045ZM32.9461 12.9045H29.7922L25.6557 0.364441H28.5428L30.1925 5.44531C30.6906 7.0222 31.0957 8.62644 31.4056 10.2499C31.7247 8.62846 32.1296 7.02472 32.6186 5.44531L34.2684 0.364441H37.1554L32.9461 12.9045ZM45.4406 2.68266H52.1609V0.364441H42.687V12.9165H52.3064V10.5983H45.4406V7.53532H51.6271V5.37324H45.4406V2.68266ZM80.6193 2.68266H84.4646L84.4161 0.364441H73.996V2.68266H77.8657V12.9045H80.6193V2.68266ZM111.891 12.9045H109.174L107.755 7.53536C107.476 6.33421 107.209 4.90484 106.954 3.36737C106.809 4.48444 106.445 6.37025 106.154 7.47531L104.832 12.9045H102.017L98.645 0.36449H101.411L102.624 5.62553C102.994 7.13561 103.261 8.6685 103.424 10.2139C103.612 8.67661 103.896 7.15225 104.274 5.64956L105.681 0.36449H108.301L109.623 5.52944C110.003 7.07218 110.287 8.63665 110.472 10.2139C110.67 8.59794 110.957 6.99397 111.333 5.40933L112.547 0.352478H115.3L111.891 12.9045ZM121.693 12.9045H124.447V0.364441H121.693V12.9045ZM141.126 2.68266H137.281V12.9045H134.527V2.68266H130.718V0.364441H141.138L141.126 2.68266ZM154.761 12.9045H157.514L157.466 0.364441H154.712V5.16905H149.532V0.364441H146.779V12.9165H149.569V7.46325H154.761V12.9045ZM183.886 8.09997C183.843 9.53569 183.213 10.8925 182.14 11.8595C181.068 12.8265 179.645 13.3207 178.197 13.2289C174.558 13.2289 172.132 10.5984 172.132 6.65858C172.132 2.7188 174.679 0.076271 178.318 0.076271C181.062 -0.0966606 183.466 1.87846 183.801 4.58059H181.072C180.861 3.22927 179.635 2.26654 178.258 2.37047C176.208 2.37047 174.898 4.05208 174.898 6.67059C174.898 9.28911 176.183 10.8866 178.221 10.8866C179.871 10.8866 180.878 9.90169 181.108 8.03991L183.886 8.09997ZM195.374 13.2289C199.085 13.2289 201.584 10.5744 201.584 6.67062L201.572 6.6466C201.572 2.75486 199.073 0.0762939 195.446 0.0762939C191.662 0.0762939 189.114 2.74285 189.114 6.67062C189.114 10.5984 191.662 13.2289 195.374 13.2289ZM191.88 6.66971C191.88 9.31224 193.227 10.9698 195.374 10.9698C197.521 10.9698 198.77 9.30023 198.77 6.6577C198.77 4.01517 197.448 2.39362 195.386 2.39362C193.324 2.39362 191.892 3.97913 191.892 6.63368L191.88 6.66971ZM215.438 12.9405H218.204L218.143 0.364441H215.486V5.57744C215.486 5.94388 215.514 6.56959 215.543 7.22432L215.543 7.22525L215.543 7.22601C215.574 7.9443 215.608 8.69726 215.608 9.18089C215.107 8.19298 214.557 7.23082 213.958 6.29813L210.319 0.364441H207.517V12.9885H210.173V7.64342C210.173 6.34617 210.137 4.97686 210.052 4.13606C210.522 5.10298 211.057 6.03792 211.653 6.93474L215.438 12.9405ZM234.119 2.68266H227.981V5.60146H233.33V7.76353H227.981V12.9165H225.227V0.364441H234.119V2.68266ZM240.366 12.9045H243.119V0.364441H240.366V12.9045ZM255.771 0.364446C257.308 0.246671 258.83 0.734474 260.005 1.72175C261.305 2.97864 261.995 4.72969 261.897 6.52636C262.02 8.35645 261.375 10.1557 260.114 11.4991C258.968 12.5848 257.397 13.1163 255.82 12.9525H250.664V0.364446H255.771ZM255.541 10.5864H253.418L253.431 2.63477H255.456C257.882 2.63477 259.095 3.96805 259.095 6.51449C259.179 7.65781 258.824 8.79022 258.101 9.68553C257.44 10.3702 256.49 10.7044 255.541 10.5864ZM277.267 2.68266H270.51V5.37324H276.696V7.53532H270.51V10.5983H277.376V12.9165H267.756V0.364441H277.242L277.267 2.68266ZM292.005 12.9045H294.771V0.364441H292.09V5.57744C292.09 5.94349 292.118 6.56826 292.146 7.22222V7.22255L292.147 7.22525L292.147 7.22763L292.147 7.22875C292.178 7.94621 292.211 8.69788 292.211 9.1809C291.707 8.19275 291.152 7.23059 290.55 6.29813L286.91 0.364441H284.096V12.9525H286.753V7.60739C286.753 6.31014 286.716 4.94083 286.631 4.10002C287.102 5.06447 287.633 5.99915 288.22 6.89871L292.005 12.9045ZM312.324 8.09997C312.281 9.53792 311.649 10.8967 310.574 11.8641C309.498 12.8314 308.072 13.3241 306.622 13.2289C302.983 13.2289 300.557 10.5984 300.557 6.65859C300.557 2.71881 303.032 0.076271 306.695 0.076271C309.439 -0.0966607 311.843 1.87846 312.178 4.58059H309.449C309.237 3.22927 308.011 2.26654 306.634 2.37047C304.584 2.37047 303.286 4.05209 303.286 6.6706C303.286 9.28911 304.56 10.8866 306.622 10.8866C308.272 10.8866 309.279 9.9017 309.509 8.03991L312.324 8.09997ZM320.767 2.70669H327.499L327.39 0.364441H317.904V12.9165H327.523V10.5983H320.767V7.53532H326.941V5.37324H320.767V2.70669Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M337.616 1.10924C337.002 0.483784 336.156 0.136223 335.275 0.148316C334.142 0.160407 333.094 0.744881 332.497 1.6978C331.904 2.66681 331.858 3.87035 332.376 4.88086C332.915 5.92364 333.98 6.59873 335.162 6.64844C336.344 6.69815 337.462 6.11482 338.089 5.12109C338.406 4.62066 338.574 4.04208 338.574 3.45148C338.597 2.57298 338.25 1.72477 337.616 1.10924ZM333.396 1.54139C333.886 1.03453 334.567 0.751814 335.276 0.760638C335.988 0.752792 336.673 1.03508 337.168 1.54139C337.681 2.03979 337.958 2.72844 337.933 3.4392C337.929 3.7777 337.859 4.1123 337.726 4.42415C337.593 4.74176 337.399 5.03121 337.156 5.27696C336.665 5.7797 335.989 6.06354 335.282 6.06354C334.576 6.06354 333.899 5.7797 333.408 5.27696C332.9 4.7794 332.62 4.09826 332.632 3.39116C332.618 2.69668 332.895 2.02748 333.396 1.54139ZM333.941 1.67318H335.494C335.702 1.6625 335.91 1.68274 336.112 1.73324C336.306 1.79063 336.474 1.91397 336.585 2.08157C336.703 2.25966 336.762 2.46941 336.755 2.68215C336.763 2.88199 336.708 3.07935 336.597 3.24669C336.53 3.33594 336.448 3.41313 336.355 3.47491C336.461 3.53089 336.546 3.61937 336.597 3.72715C336.654 3.93464 336.683 4.14875 336.682 4.36376C336.665 4.55557 336.665 4.7485 336.682 4.94031C336.682 5.00037 336.755 5.07244 336.876 5.15652H336.015C335.95 4.96698 335.917 4.7681 335.918 4.56796C335.927 4.37386 335.906 4.17958 335.857 3.9914C335.826 3.92 335.764 3.86682 335.688 3.84727H335.397H334.802V5.16853H333.977L333.941 1.67318ZM334.766 3.14997V2.39355H335.385C335.535 2.38058 335.685 2.40537 335.822 2.46559C335.91 2.53988 335.956 2.65206 335.944 2.76576C335.954 2.87916 335.909 2.99046 335.822 3.06593C335.685 3.13786 335.528 3.16714 335.373 3.14997H334.766Z",
          fill: "white"
        }
      )
    ]
  }
);
const ProductFooter = ({ products, minimal, content, isMobileParam }) => {
  const hasMD529Only = products.length > 0 && products.every((p2) => p2 === PRODUCT_TYPE.MD529);
  const hasAK529Only = products.length > 0 && products.every((p2) => p2 === PRODUCT_TYPE.AK529);
  const hasNat529Only = products.length > 0 && products.every((p2) => p2 === PRODUCT_TYPE.NAT529);
  const PRODUCT_LINKS = {};
  PRODUCT_LINKS[PRODUCT_TYPE.ACTIVE_PLUS_PORTFOLIOS] = {
    order: 1
  };
  PRODUCT_LINKS[PRODUCT_TYPE.RAS] = {
    order: 2
  };
  PRODUCT_LINKS[PRODUCT_TYPE.BROKERAGE] = {
    order: 3
  };
  PRODUCT_LINKS[PRODUCT_TYPE.MUTUAL_FUND] = {
    order: 4
  };
  PRODUCT_LINKS[PRODUCT_TYPE.NAT529] = {
    order: 5,
    contactUs: {
      id: "footer-nav-nat-contact-us",
      label: "Contact Us",
      href: "https://www.troweprice.com/personal-investing/troweprice-529/contact-us.html"
    },
    privacyPolicy: {
      label: "T. Rowe Price College Savings Plan Privacy Policy",
      id: "footer-nav-nat529-privacy-policy-link",
      href: "https://www.troweprice.com/personal-investing/troweprice-529/privacy-policy.html"
    }
  };
  PRODUCT_LINKS[PRODUCT_TYPE.MD529] = {
    order: 6,
    contactUs: {
      id: "nav-md-contact-us",
      label: "Contact Us",
      href: "https://maryland529.com/About-Us/Contact-Us",
      target: "_blank"
    },
    privacyPolicy: {
      id: "nav-md-privacy-policy",
      label: "MD529 Privacy Policy",
      href: "https://maryland529.com/Privacy-Statement",
      target: "_blank"
    }
  };
  PRODUCT_LINKS[PRODUCT_TYPE.AK529] = {
    order: 7,
    contactUs: {
      id: "nav-ak-contact-us",
      label: "Contact Us",
      target: "_blank",
      href: "https://www.alaska529plan.com/about-us/contact-us.html"
    },
    privacyPolicy: {
      id: "nav-ak-privacy-policy",
      label: "Alaska 529 Privacy Policy",
      target: "_blank",
      href: "https://www.alaska529plan.com/privacy-statement.html"
    }
  };
  const NAV_MODEL = {
    socialLinks: [
      {
        label: "Facebook",
        id: "facebook-link",
        icon: "icon-fb",
        href: "https://www.facebook.com/troweprice"
      },
      {
        label: "Twitter",
        id: "twitter-link",
        icon: "icon-tw",
        href: "https://twitter.com/troweprice"
      },
      {
        label: "YouTube",
        id: "youtube-link",
        icon: "icon-yt",
        href: "https://www.youtube.com/trowepricegroup"
      },
      {
        label: "LinkedIn",
        id: "linkedin-link",
        icon: "icon-ln",
        href: "https://www.linkedin.com/company/157329?trk=tyah"
      }
    ],
    corpLinks: [
      {
        label: "Company Overview",
        id: "company-overview-link",
        href: trpEnvironmentAware("https://www.troweprice.com/corporate/en/what-we-do.html")
      },
      {
        label: "Responsibility",
        id: "corporate-responsibility-link",
        href: trpEnvironmentAware("https://www.troweprice.com/corporate/en/what-sets-us-apart/corporate-responsibility.html")
      },
      {
        label: "Careers",
        id: "careers-link",
        href: trpEnvironmentAware("https://www.troweprice.com/corporate/en/careers.html")
      },
      {
        label: "Investor Relations",
        id: "investor-relations-link",
        href: "https://troweprice.gcs-web.com/"
      },
      {
        label: "Newsroom",
        id: "newsroom-link",
        href: trpEnvironmentAware("https://www.troweprice.com/corporate/en/press.html")
      }
    ],
    legalLinks: [
      {
        label: "Site Map",
        id: "site-map-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/sitemap.html")
      },
      {
        label: "U.S. & Canada Privacy Notice",
        id: "generic-privacy-policy-link",
        href: !(hasNat529Only || hasMD529Only || hasAK529Only) ? trpEnvironmentAware("https://www.troweprice.com/enterprise/legal/us/en/privacy-notices.html") : trpEnvironmentAware("https://www.troweprice.com/privacy")
      },
      {
        label: "Terms of Use",
        id: "terms-of-use-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/terms-of-use.html")
      },
      {
        label: "Security Measures",
        id: "security-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/policies-and-security/security.html")
      },
      {
        label: "Legal Information",
        id: "legal-info-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/policies-and-security/legal-information.html")
      },
      {
        label: "Customer Agreement",
        id: "customer-agreement-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/policies-and-security/customer-agreement.html")
      },
      {
        label: "Mobile Solutions",
        id: "mobile-solutions-link",
        href: trpEnvironmentAware("https://www.troweprice.com/corporate/en/mobile-solutions.html")
      },
      {
        label: "Contact Us",
        id: "generic-contact-us-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/contact-us.html")
      }
    ],
    feedback: {
      label: "[+] Feedback",
      id: "feedback-plus-link",
      link: ""
    },
    footerContent: "",
    otherPrivacyPolicies: []
  };
  function getFooterModel(products2) {
    const links = Object.assign({}, NAV_MODEL, PRODUCT_LINKS);
    const hasMD529 = products2.indexOf(PRODUCT_TYPE.MD529) >= 0;
    const hasAK529 = products2.indexOf(PRODUCT_TYPE.AK529) >= 0;
    const hasNAT529 = products2.indexOf(PRODUCT_TYPE.NAT529) >= 0;
    const trpContactUs = NAV_MODEL.legalLinks.find((l4) => l4.id === "generic-contact-us-link");
    if (hasNAT529) {
      if (PRODUCT_LINKS[PRODUCT_TYPE.NAT529].privacyPolicy) {
        links.otherPrivacyPolicies.push(
          PRODUCT_LINKS[PRODUCT_TYPE.NAT529].privacyPolicy
        );
      }
      links.contactUs = PRODUCT_LINKS[PRODUCT_TYPE.NAT529].contactUs || trpContactUs;
    }
    if (hasMD529) {
      if (PRODUCT_LINKS[PRODUCT_TYPE.MD529].privacyPolicy) {
        links.otherPrivacyPolicies.push(
          PRODUCT_LINKS[PRODUCT_TYPE.MD529].privacyPolicy
        );
      }
      links.contactUs = PRODUCT_LINKS[PRODUCT_TYPE.MD529].contactUs || trpContactUs;
    }
    if (hasAK529) {
      if (PRODUCT_LINKS[PRODUCT_TYPE.AK529].privacyPolicy) {
        links.otherPrivacyPolicies.push(
          PRODUCT_LINKS[PRODUCT_TYPE.AK529].privacyPolicy
        );
      }
      links.contactUs = PRODUCT_LINKS[PRODUCT_TYPE.AK529].contactUs || trpContactUs;
    }
    if (hasMD529 && (hasAK529 || hasNAT529) || hasAK529 && hasNAT529) {
      links.contactUs = trpContactUs;
    }
    return links;
  }
  function getProductContent(products2, footerModel2) {
    const productSpecs = products2.map(
      (product2) => Object.assign({ name: product2 }, footerModel2[product2])
    );
    const highestOrder = Math.min.apply(
      null,
      productSpecs.map((spec) => spec.order)
    );
    const product = productSpecs.find((spec) => spec.order === highestOrder);
    if (!product) {
      return "";
    }
    const productContentMap = hasNat529Only || hasAK529Only ? createProductCopyrightContentMap(products2) : createProductContentMap(products2);
    const content2 = productSpecs.length > 1 && highestOrder > 4 ? productContentMap["MIXED"] : productContentMap[product.name];
    return content2 ? content2 : "";
  }
  const footerModel = getFooterModel(products || []);
  const { contactUs } = footerModel;
  const otherPrivacyPolicies = [...new Set(footerModel.otherPrivacyPolicies)];
  if (minimal) {
    otherPrivacyPolicies.label = "Privacy Policy";
  }
  return isMobileParam ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      id: "footer-site",
      className: `product-footer-site ${minimal ? "product-footer-minimal" : ""} ${hasMD529Only ? "college-theme md529" : hasAK529Only ? "college-theme ak529" : hasNat529Only ? "college-theme nat529" : "default"}`,
      "data-metrics-location": "FTR",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "product-footer-top-wrapper", children: [
          !minimal && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "product-footer-tag-line", children: /* @__PURE__ */ jsxRuntimeExports.jsx(TRPInvestWithConfidence, {}) }),
          !minimal && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "product-footer-mission", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "product-footer-mission-title", children: "Our Mission Is Simple." }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Help clients around the world achieve their long-term investment goals." })
          ] }),
          minimal ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "product-footer-links minimal", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              LinkList$2,
              {
                className: "product-footer-corp",
                linkClassName: "product-footer-link e2e-footer-privacy-policies-link",
                target: "_blank",
                links: otherPrivacyPolicies
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              LinkList$2,
              {
                className: "product-footer-corp",
                linkClassName: "product-footer-link e2e-footer-contact-us-link",
                target: "_blank",
                links: contactUs ? [contactUs] : []
              }
            )
          ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "product-footer-links", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              LinkListSocial,
              {
                className: "product-footer-social-media",
                linkClassName: "product-footer-link",
                linkClassFn: (link) => `product-footer-icon ${link.icon}`,
                target: "_blank",
                links: footerModel.socialLinks
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              LinkList$2,
              {
                className: "product-footer-corp",
                linkClassName: "product-footer-link",
                links: footerModel.corpLinks.concat(otherPrivacyPolicies)
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              LinkList$2,
              {
                className: "product-footer-corp",
                linkClassName: "product-footer-link",
                links: footerModel.legalLinks
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: `e2e-footer-disclaimer product-footer-disclaimer ${minimal && "minimal-footer-disclaimer"}`,
            children: [
              !(hasNat529Only || hasMD529Only || hasAK529Only) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "privacy-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  tabIndex: "0",
                  className: "product-footer-link ot-sdk-show-settings",
                  children: "Do Not Sell or Share My Personal Information"
                }
              ) }),
              content || getProductContent(products, footerModel)
            ]
          }
        )
      ]
    }
  );
};
const FooterContainer = ({
  productTypes,
  isLoading = false,
  isMobileParam = false
}) => {
  if (isLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Shimmer$1,
      {
        x: "100%",
        y: 200,
        shape: "rect"
      }
    ) });
  }
  if (!productTypes) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ProductFooter,
      {
        products: [],
        content: /* @__PURE__ */ jsxRuntimeExports.jsx(MutualFundContent, { products: [] }),
        isMobileParam
      }
    );
  }
  function getProducts2(productTypes2) {
    const products2 = [];
    Object.keys(productTypes2).forEach((productType) => {
      if (productTypes2[productType]) {
        const product = productType.replace(/has/, "");
        products2.push(product);
      }
    });
    return products2;
  }
  let content = null;
  const products = getProducts2(productTypes);
  const hasGeneral = products.some(
    (p2) => [
      PRODUCT_TYPE.ACTIVE_PLUS_PORTFOLIOS,
      PRODUCT_TYPE.BROKERAGE,
      PRODUCT_TYPE.MUTUAL_FUND,
      PRODUCT_TYPE.RAS
    ].indexOf(p2) >= 0
  ) || products.length > 1 && products.every((p2) => p2 === PRODUCT_TYPE.MD529 || p2 === PRODUCT_TYPE.AK529 || p2 === PRODUCT_TYPE.NAT529);
  if (!products || !products.length) {
    const contentMap = createProductContentMap([PRODUCT_TYPE.MUTUAL_FUND]);
    content = contentMap[PRODUCT_TYPE.MUTUAL_FUND];
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: !hasGeneral ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    ProductFooter,
    {
      products,
      minimal: "true",
      content,
      isMobileParam
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    ProductFooter,
    {
      products,
      content,
      isMobileParam
    }
  ) });
};
const FooterContainer$1 = FooterContainer;
const LinkList = ({ links }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "link-list", children: [
    " ",
    links.map((link, i5) => {
      const { title, href, label } = link;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Link$1,
        {
          title,
          href,
          children: label
        },
        i5
      );
    })
  ] });
};
const LinkList$1 = LinkList;
LinkList.propTypes = {
  links: propTypesExports.arrayOf(propTypesExports.shape({
    title: propTypesExports.string,
    href: propTypesExports.string.isRequired,
    label: propTypesExports.string
  })).isRequired
};
const LoadingBar = ({ x: x2, y: y2, className, barColor = "#05C3DE", backgroundColor, loadTime = 3, benchmarkPercentage = 100, persistVisible }) => {
  const [progress, setProgress] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const backgroundRGB = hexToRGB(backgroundColor);
  const loadColor = hexToRGB(barColor);
  useEffect(() => {
    let updatedProgress = 0;
    const interval = setInterval(() => {
      const incrementor = Math.floor(benchmarkPercentage / loadTime);
      updatedProgress += incrementor;
      if (updatedProgress >= benchmarkPercentage) {
        clearInterval(interval);
      }
      setProgress(updatedProgress);
    }, 500);
    if (updatedProgress >= benchmarkPercentage) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!persistVisible) {
        setIsActive(false);
        clearTimeout(timeout);
      }
    }, loadTime * 1e3);
    return clearTimeout(timeout);
  }, []);
  const containerStyle = {
    width: (x2 ? x2 : 100) + "%",
    height: y2
  };
  if (backgroundRGB) {
    containerStyle.backgroundColor = backgroundRGB;
  }
  const fillerStyle = {
    width: progress + "%",
    height: y2,
    maxWidth: benchmarkPercentage + "%",
    backgroundColor: loadColor
  };
  return isActive && /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: `loading-bar-container ${className}`,
      style: containerStyle,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: "filler",
          style: fillerStyle
        }
      )
    }
  );
};
LoadingBar.propTypes = {
  loadingBarCustomData: propTypesExports.object
};
const LoadingBar$1 = LoadingBar;
const INFO = {
  type: "inline",
  variant: "standard"
};
const NotificationBanner = ({
  type = INFO.type,
  variant = INFO.variant,
  title,
  bodyText,
  CTAText,
  handleDismiss,
  handleCTAClick,
  isDismissible = false,
  dismissCTAText = "dismiss",
  mode = "beacon-on-light",
  theme = "",
  offerId,
  imageLink,
  isCustomerWebView = false,
  id,
  rightContent
}) => {
  const bannerRef = useRef({});
  const dispatchDismiss = () => {
    console.log("attempting to handle dismiss");
    if (!isCustomerWebView) {
      if (handleDismiss) {
        handleDismiss();
      }
      if (offerId) {
        try {
          dispatchInteraction(offerId, dismissCTAText);
        } catch (error) {
        }
      }
    }
  };
  const handleClick = (e5) => {
    if (offerId) {
      try {
        dispatchInteraction(offerId, e5.target.textContent);
      } catch (error) {
      }
    }
  };
  useEffect(() => {
    const externalLinks = document.querySelectorAll('.ii-banner-container a[target="_blank"], .ii-banner-container a[href]');
    externalLinks.forEach((link) => {
      link.addEventListener("click", handleClick);
    });
    if (bannerRef && bannerRef.current) {
      bannerRef.current.addEventListener("beacon-event-dismiss", dispatchDismiss);
    }
    return () => {
      externalLinks.forEach((link) => {
        link.removeEventListener("click", handleClick);
      });
      if (bannerRef && bannerRef.current) {
        bannerRef.current.removeEventListener("beacon-event-dismiss", dispatchDismiss);
      }
    };
  }, []);
  const updatedId = id ? id : (Math.random() * 1e8).toFixed(0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: updatedId, className: `ii-notification-banner-container ${mode} ${theme}`, "data-testid": offerId, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNotification, { ref: bannerRef, type, variant, dismissable: isDismissible, children: [
    !CTAText && rightContent ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "title", children: [
      title,
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "right-zone", children: rightContent })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: title }),
    imageLink && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: imageLink, slot: "icon", className: "image", "data-testid": "image", alt: "banner image" }),
    bodyText && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        "data-testid": "body-text",
        slot: "description",
        className: "body-text",
        dangerouslySetInnerHTML: { __html: purify.sanitize(bodyText) }
      }
    ),
    handleCTAClick && CTAText && /* @__PURE__ */ jsxRuntimeExports.jsx(
      IIBeaconButton,
      {
        "data-testId": "cta-button",
        slot: "action-zone",
        disabled: isCustomerWebView,
        variant: "secondary",
        className: "cta-button",
        handleClick: () => {
          if (!isCustomerWebView) {
            handleCTAClick();
            if (offerId) {
              try {
                dispatchInteraction(offerId, CTAText);
              } catch (e5) {
              }
            }
          }
        },
        children: CTAText
      }
    )
  ] }) });
};
const NotificationBanner$1 = NotificationBanner;
const Background = ({ onClose, children }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: onClose, className: "modal-background", children });
const CloseButton = ({ onClick }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "close-button-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick, className: "close-button", children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, { fill: "#086EA1" }) }) });
const ModalWrapper = ({ width, onClose, children }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    className: "modal-wrapper b-topography-sans-serif--body--200",
    "data-testid": "beacon-modal",
    style: { width },
    onClick: (e5) => e5.stopPropagation(),
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CloseButton, { onClick: onClose }),
      children
    ]
  }
);
const ModalHeader = ({ title }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-header", children: title });
const ModalContent = ({ children }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-content", children });
const BeaconModal = ({ width, open, title, onClose, children }) => {
  return open ? /* @__PURE__ */ jsxRuntimeExports.jsx(Background, { onClose, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalWrapper, { width, onClose, children: [
    title && /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { title }),
    children && /* @__PURE__ */ jsxRuntimeExports.jsx(ModalContent, { children })
  ] }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};
const BeaconModal$1 = BeaconModal;
const OptIn = ({
  defaultValue = false,
  setToggleCookie = true,
  options,
  onCookieValue = "client-portal",
  offCookieValue = "aam-dashboard",
  isInternal = false
}) => {
  function toggleSwitch(event) {
    const toggleOnLabel = document.querySelector(".opt-on");
    const toggleOffLabel = document.querySelector(".opt-off");
    if (event.target.checked) {
      toggleOnLabel.innerText = "On";
      const actionCallback = options.find((opt) => opt.value === onCookieValue);
      if (actionCallback && actionCallback.action) {
        actionCallback.action();
      }
      if (setToggleCookie) {
        setCookie(onCookieValue, "true", null, isInternal);
        setCookie(offCookieValue, "false", null, isInternal);
      }
    } else {
      toggleOffLabel.innerText = "Off";
      const actionCallback = options.find((opt) => opt.value === offCookieValue);
      if (actionCallback && actionCallback.action) {
        actionCallback.action();
      }
      if (setToggleCookie) {
        setCookie(onCookieValue, "false", null, isInternal);
        setCookie(offCookieValue, "true", null, isInternal);
      }
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "optin-root", className: "opt-in-container beacon-on-light", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconControlGroup, { ariaDisabled: "false", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconControl, { inline: true, toggleSwitch: true, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("label", { slot: "switch-on-label", htmlFor: "optin", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "opt-on", children: "On" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("label", { slot: "switch-off-label", htmlFor: "optin", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "opt-off", children: "Off" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "checkbox", name: "options", id: "optin", defaultChecked: defaultValue, onChange: toggleSwitch })
  ] }) }) });
};
const OptIn$1 = OptIn;
const LinkModal = ({ linkContent, heading, children }) => {
  const [on2, setToggle] = useState(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { onClick: (event) => {
      event.preventDefault();
      setToggle(true);
    }, children: linkContent }),
    on2 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "iic-modal-infoContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "iic-modal-infoPopupContainer b-typography-sans-serif--caption--300", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ClickOffSensor$1,
      {
        handleClickoff: () => setToggle(false),
        className: "iic-modal-iiInfoPopup",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "iic-modal-infoHeaderContainer", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "iic-modal-infoHeading b-typography-sans-serif--headline--200 b-font-weight-bold", children: heading }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                className: "iic-modal-closeButtonContainer",
                onClick: () => setToggle(false),
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, { className: "iic-modal-closeButtonIcon" })
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "iic-modal-infoBodyContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "iic-modal-infoBody b-typography-sans-serif--caption--300", children }) })
        ]
      }
    ) }) })
  ] });
};
const RasWithdrawModal = ({ isMobile = false, linkContent = "Withdraw" }) => {
  const heading = "Withdrawals cannot currently be performed online.";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    LinkModal,
    {
      linkContent,
      heading,
      children: [
        "Please call",
        isMobile ? /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "tel:(877) 455-2225", children: " (877) 455-2225 " }) : " (877) 455-2225 ",
        "or your advisor to withdraw money from Retirement Advisory Service."
      ]
    }
  );
};
const RasWithdrawModal$1 = RasWithdrawModal;
const PreRMD = ({ rmdEligibleAge }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "pre-rmd", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "header", children: "Your T. Rowe Price Required Minimum Distribution is coming up" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "subheader", children: [
      "Starting the year you turn ",
      rmdEligibleAge,
      " years old, you will need to start taking money out of your RMD eligible IRA(s)."
    ] })
  ] });
};
PreRMD.propTypes = {
  rmdEligibleAge: PropTypes.number
};
const RMDSuccessIcon = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    width: "75",
    height: "75",
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M52.4173 25.8545L29.2923 47.1462L21.584 39.542",
          stroke: "#248647",
          strokeWidth: "4",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M37.0003 71.4793C56.5834 71.4793 72.4587 55.8186 72.4587 36.5002C72.4587 17.1817 56.5834 1.521 37.0003 1.521C17.4172 1.521 1.54199 17.1817 1.54199 36.5002C1.54199 55.8186 17.4172 71.4793 37.0003 71.4793Z",
          stroke: "#248647",
          strokeWidth: "4",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
const RMDGauge = ({ children, percentFilled, radius = 120, stroke = 20, rmdYear, setupRequired, isAutoRMDOn, isPending }) => {
  const circumference = Math.PI * (radius * 2);
  const percentFill = (100 - percentFilled * 0.75) / 100 * circumference;
  const fulfilled = percentFilled === 100;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rmd-gauge", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "speedometer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "svg",
      {
        width: "320",
        role: "img",
        alt: "Percentage graph describing current distributions as a portion of total RMD",
        height: "320",
        className: "parent-circle",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Percentage Circle Graph" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "circle",
            {
              className: "circle-background",
              style: {
                strokeWidth: stroke,
                strokeDasharray: circumference,
                strokeDashoffset: circumference / 4,
                r: radius
              },
              cx: "166",
              cy: "175"
            }
          ),
          percentFill > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "circle",
            {
              className: "circle-percent",
              cx: "166",
              cy: "175",
              style: {
                strokeWidth: stroke,
                stroke: "#00608a",
                strokeDasharray: circumference,
                strokeDashoffset: percentFill,
                r: radius
              }
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `inner-msg ${fulfilled ? "success" : ""}`, children: [
      fulfilled && !isPending && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rmd-success", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(RMDSuccessIcon, { className: "success-icon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "subheader", children: [
          "You have ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "fulfilled", children: "fulfilled" }),
          " your ",
          rmdYear,
          " RMD"
        ] })
      ] }),
      (percentFilled < 100 && !setupRequired && !isPending || isAutoRMDOn && !isPending && percentFilled < 100) && /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "percent-header", children: [
          percentFilled,
          "%"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "subheader fulfilled", children: "Fulfilled" })
      ] }),
      children
    ] })
  ] }) });
};
RMDGauge.propTypes = {
  percentFilled: PropTypes.number,
  radius: PropTypes.number
};
const RMDBalance = ({ balance, rmdYear = (/* @__PURE__ */ new Date()).getFullYear(), total = false }) => {
  const heading = total ? `Your ${rmdYear} RMD Amount: ` : `Remaining ${rmdYear} RMD: `;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "balance-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "balance-header", children: heading }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "balance", children: usd(balance) })
  ] });
};
const RMDSetup = ({ includeBalance, isAutoRMDOn, percentTaken, title, totalRMD, rmdYear, setupRequired }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rmd-setup", children: [
    title && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "title", children: title }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      RMDGauge,
      {
        percentFilled: percentTaken,
        setupRequired,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "header", children: "Set up an Auto-RMD" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "subheader", children: "It's quick, easy & recalculates each year" })
        ]
      }
    ),
    includeBalance && !isAutoRMDOn && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RMDBalance,
      {
        balance: totalRMD,
        total: true,
        rmdYear
      }
    )
  ] });
};
const RMDDistributionAmount = ({ amount, rmdYear = (/* @__PURE__ */ new Date()).getFullYear() }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "distribution-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "distribution-header", children: [
      "Remaining ",
      rmdYear,
      " RMD: "
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "distribution-amount", children: usd(amount) })
  ] });
};
const RMDComplete = ({ rmdYear, includeBalance, isAutoRMDOn, percentTaken, title, totalRemainingYear }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rmd-complete", children: [
    title && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "title", children: title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      RMDGauge,
      {
        isAutoRMDOn,
        percentFilled: percentTaken,
        rmdYear
      }
    ),
    includeBalance && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RMDDistributionAmount,
      {
        amount: totalRemainingYear,
        rmdYear
      }
    )
  ] });
};
const RMDRemaining = ({
  includeBalance,
  isAutoRMDOn,
  includeCTAs = false,
  percentTaken,
  rmdYear,
  rmdAsOfDate = (/* @__PURE__ */ new Date()).toDateString(),
  title,
  totalRemainingYear
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rmd-remaining", children: [
    title && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "title", children: title }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(RMDGauge, { percentFilled: percentTaken, children: [
      rmdAsOfDate && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rmd-as-of-date", children: [
        "as of ",
        rmdAsOfDate
      ] }),
      !isAutoRMDOn && includeCTAs && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          id: "enable-auto-RMD",
          className: "enable-button",
          onClick: () => {
          },
          children: "Enable Auto-RMD"
        }
      )
    ] }),
    includeBalance && !isAutoRMDOn && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RMDDistributionAmount,
      {
        amount: totalRemainingYear,
        rmdYear
      }
    )
  ] });
};
RMDRemaining.propTypes = {};
const RMDProcessing = ({ title, isAutoRMDOn, isPending, rmdRemaining, rmdYear, finalMonth, finalDate, percentTaken }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `rmd-processing ${percentTaken > 0 ? "distributions" : ""}`, children: [
    title && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "title", children: title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      RMDGauge,
      {
        percentFilled: percentTaken,
        isPending,
        rmdYear,
        isAutoRMDOn,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "status", children: [
          isAutoRMDOn && isPending && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "pending-status", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "header", children: "Auto-RMD:" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "banner", children: "Status Pending" })
          ] }),
          isAutoRMDOn && isPending && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "auto-rmd", children: !isPending && rmdRemaining && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rmd-remaining-status", children: [
            "Auto-RMD: ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "status-header", children: "On" })
          ] }) })
        ] })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pending-message", children: "Your Auto-RMD is being processed, please allow up to 5 business days" })
  ] });
};
const RMDAuto = ({
  finalDate,
  finalMonth,
  includeBalance,
  isAutoRMDOn,
  isPending,
  percentTaken,
  rmdYear,
  rmdAsOfDate = (/* @__PURE__ */ new Date()).toDateString(),
  title,
  rmdRemaining
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rmd-auto", children: [
    title && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "title", children: title }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      RMDGauge,
      {
        percentFilled: percentTaken,
        rmdYear,
        isAutoRMDOn,
        isPending,
        children: [
          rmdAsOfDate && percentTaken < 100 && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rmd-as-of-date", children: [
            "as of ",
            rmdAsOfDate
          ] }),
          !includeBalance && !isAutoRMDOn && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              id: "enable-auto-RMD",
              className: "enable-button",
              onClick: () => {
              },
              children: "Enable Auto-RMD"
            }
          )
        ]
      }
    ),
    includeBalance && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RMDBalance,
      {
        balance: rmdRemaining,
        rmdYear
      }
    ),
    isAutoRMDOn && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "auto-rmd", children: !isPending && !includeBalance && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rmd-remaining-status", children: [
      "Auto-RMD: ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "status-header", children: "On" })
    ] }) })
  ] });
};
const wholePercent = (percent) => {
  let percentDistributed = Math.floor(percent * 100);
  if (percentDistributed < 0) {
    return 0;
  }
  if (percent > 0 && percent < 0.01) {
    return 1;
  }
  if (percentDistributed > 100) {
    return 100;
  }
  return percentDistributed;
};
const RMDTile = ({
  apiKey,
  loggedInBpId,
  title,
  includePreRMD = true,
  rmdAsOfDate,
  rmdSummaryData
}) => {
  const formattedAsOfDate = new Date(rmdAsOfDate).toLocaleDateString("en-US");
  let data;
  if (!rmdSummaryData) {
    data = useData(trpApiEnvironmentAware("https://api.public.troweprice.com/rmd-service-auto/api/rmd-summary-plus"), apiKey, "GET");
  } else {
    data = rmdSummaryData;
  }
  const {
    systematicActivityRMDs,
    rmdSummary,
    showDashboard
  } = data;
  const {
    preRMDEligible,
    actualDistributionTotal,
    distributedAmountRMD,
    rmdYear,
    rmdEligibleAge = 73,
    totalRemainingYear,
    totalRMD
  } = rmdSummary;
  if (!showDashboard) {
    return null;
  }
  const ELIGIBLE_AGREEMENT_TYPES = [6, 8, 17, 18, 13, 14, 19, 20, 21, 22, 31, 39];
  const systematicRMDs = systematicActivityRMDs || [];
  const rmdEligibilityFilter = (r3) => {
    if (!r3 || !r3.sourceAgreement) {
      return false;
    }
    const owners = r3.sourceAgreement.agreementParties.filter((ap) => ap.role === "OWNR");
    const bpIdMatchFound = owners.some((pty) => parseInt(pty.entity.entityKey.IDMBusinessPartyID) === parseInt(loggedInBpId));
    return bpIdMatchFound && ELIGIBLE_AGREEMENT_TYPES.some((agrType) => parseInt(r3.sourceAgreement.agreementTypeID) === agrType);
  };
  const existingRMDs = systematicRMDs.filter(rmdEligibilityFilter);
  const hasRMD = Boolean(existingRMDs.length > 0);
  const isPending = Boolean(existingRMDs && existingRMDs.length > 0 && existingRMDs.some((rmd) => rmd.pending));
  const modelRMD = existingRMDs && existingRMDs.length > 0 ? existingRMDs[0] : null;
  const modelTransferDays = modelRMD && modelRMD.transferDays ? modelRMD.transferDays : [];
  const finalDate = modelTransferDays[modelTransferDays.length - 1];
  const allMonths = modelRMD == null ? void 0 : modelRMD.transfers.map((transfer) => {
    return transfer.month;
  });
  const finalMonth = allMonths == null ? void 0 : allMonths[(allMonths == null ? void 0 : allMonths.length) - 1];
  const isAutoRMDPending = isPending;
  const percentTaken = distributedAmountRMD / totalRMD || 0;
  const setupRequired = !hasRMD && actualDistributionTotal === 0;
  const hasExistingRmd = hasRMD && actualDistributionTotal !== 0;
  const hasRmdRemaining = actualDistributionTotal !== 0 && actualDistributionTotal < totalRMD;
  const metRmdThreshold = actualDistributionTotal >= totalRMD;
  const isPreRMD = includePreRMD && preRMDEligible;
  const isSetupRequired = !preRMDEligible && setupRequired;
  const isTraditionalDistribution = !preRMDEligible && !hasExistingRmd && hasRmdRemaining;
  const hasCompletedRMD = !preRMDEligible && !hasExistingRmd && metRmdThreshold;
  const isRMDPending = !preRMDEligible && hasRMD && isAutoRMDPending;
  const hasAutoRMD = !preRMDEligible && hasRMD && !isAutoRMDPending;
  const wholePercentTaken = wholePercent(percentTaken);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ii-rmd-tile", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "content", children: [
    isPreRMD && /* @__PURE__ */ jsxRuntimeExports.jsx(PreRMD, { rmdEligibleAge }),
    isSetupRequired && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RMDSetup,
      {
        title,
        rmdYear,
        percentTaken: wholePercentTaken,
        isAutoRMDOn: hasRMD,
        totalRMD,
        setupRequired,
        includeBalance: !hasRMD
      }
    ),
    isTraditionalDistribution && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RMDRemaining,
      {
        isPending: isAutoRMDPending,
        includeBalance: !hasRMD,
        rmdYear,
        percentTaken: wholePercentTaken,
        finalDate,
        isAutoRMDOn: hasRMD,
        rmdAsOfDate: formattedAsOfDate,
        finalMonth,
        title,
        totalRemainingYear,
        totalRMD
      }
    ),
    hasCompletedRMD && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RMDComplete,
      {
        rmdYear,
        isAutoRMDOn: hasRMD,
        percentTaken: wholePercentTaken,
        isPending: isAutoRMDPending,
        totalRemainingYear,
        title,
        includeBalance: !hasRMD,
        totalRMD
      }
    ),
    isRMDPending && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RMDProcessing,
      {
        isPending: isAutoRMDPending,
        rmdYear,
        hasRmdRemaining,
        isAutoRMDOn: hasRMD,
        percentTaken: wholePercentTaken,
        rmdAsOfDate: formattedAsOfDate,
        finalMonth,
        finalDate,
        title,
        totalRMD
      }
    ),
    hasAutoRMD && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RMDAuto,
      {
        isPending: isAutoRMDPending,
        rmdYear,
        hasRmdRemaining,
        percentTaken: wholePercentTaken,
        isAutoRMDOn: hasRMD,
        rmdAsOfDate: formattedAsOfDate,
        includeBalance: wholePercentTaken >= 100,
        finalMonth,
        finalDate,
        title,
        rmdRemaining: totalRemainingYear,
        totalRMD
      }
    )
  ] }) });
};
RMDTile.propTypes = {
  includePreRMD: PropTypes.bool
};
const RMDTile$1 = RMDTile;
const AuthenticationContext = React__default.createContext([]);
const generateAuthenticationView = (authentication) => {
  let authView = {};
  const {
    authorization: { isAuthenticated = false, isCustomerWebView }
  } = authentication || {};
  if (isCustomerWebView) {
    authView["customerWebViewEnabled"] = true;
  }
  if (isAuthenticated) {
    authView["isAuthenticated"] = true;
  }
  return authView;
};
function AuthenticationProvider({ children, authentication }) {
  const viewContext = useView();
  useEffect(() => {
    const { dispatch } = viewContext;
    updateView(dispatch, generateAuthenticationView(authentication));
  }, [authentication]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AuthenticationContext.Provider, { value: authentication, children });
}
const THEME_VARS = {
  PRIMARY: "--primary-color",
  SECONDARY: "--secondary-color",
  ALT_ONE: "--alt-one",
  ALT_TWO: "--alt-two",
  ALT_THREE: "--alt-three",
  PRIMARY_INVERSE: "--primary-inverse",
  SECONDARY_INVERSE: "--secondary-inverse"
};
const THEMES = {
  [PRODUCT_CLASS.ALASKA_529]: {
    [THEME_VARS.PRIMARY]: "#00496A",
    [THEME_VARS.SECONDARY]: "#E27865",
    [THEME_VARS.ALT_ONE]: "#92BF55",
    [THEME_VARS.ALT_TWO]: "#00AEC7",
    [THEME_VARS.ALT_THREE]: "#520F9A",
    [THEME_VARS.PRIMARY_INVERSE]: "#FFF",
    [THEME_VARS.SECONDARY_INVERSE]: "#111"
  },
  [PRODUCT_CLASS.MARYLAND_529]: {
    [THEME_VARS.PRIMARY]: "#14377D",
    [THEME_VARS.SECONDARY]: "#F7921E",
    [THEME_VARS.ALT_ONE]: "#05C3DE",
    [THEME_VARS.ALT_TWO]: "#3B3B3B",
    [THEME_VARS.ALT_THREE]: "#EFEFEF",
    [THEME_VARS.PRIMARY_INVERSE]: "#FFF",
    [THEME_VARS.SECONDARY_INVERSE]: "#111"
  },
  [PRODUCT_CLASS.NATIONAL_529]: {
    [THEME_VARS.PRIMARY]: "#054C70",
    [THEME_VARS.SECONDARY]: "#05C3DE",
    [THEME_VARS.ALT_ONE]: "#3B3B3B",
    [THEME_VARS.ALT_TWO]: "#EFEFEF",
    [THEME_VARS.ALT_THREE]: "#CCC",
    [THEME_VARS.PRIMARY_INVERSE]: "#FFF",
    [THEME_VARS.SECONDARY_INVERSE]: "#111"
  },
  [PRODUCT_CLASS.RETAIL]: {
    [THEME_VARS.PRIMARY]: "#006894",
    [THEME_VARS.SECONDARY]: "#05C3DE",
    [THEME_VARS.ALT_ONE]: "#3B3B3B",
    [THEME_VARS.ALT_TWO]: "#EFEFEF",
    [THEME_VARS.ALT_THREE]: "#CCC",
    [THEME_VARS.PRIMARY_INVERSE]: "#FFF",
    [THEME_VARS.SECONDARY_INVERSE]: "#111"
  }
};
const ThemeContext = React__default.createContext();
const ThemeDispatchContext = React__default.createContext();
function themeReducer(state, action) {
  switch (action.theme) {
    case PRODUCT_CLASS.MARYLAND_529: {
      return {
        theme: PRODUCT_CLASS.MARYLAND_529
      };
    }
    case PRODUCT_CLASS.ALASKA_529: {
      return {
        theme: PRODUCT_CLASS.ALASKA_529
      };
    }
    case PRODUCT_CLASS.NATIONAL_529: {
      return {
        theme: PRODUCT_CLASS.NATIONAL_529
      };
    }
    default: {
      return {
        theme: PRODUCT_CLASS.RETAIL
      };
    }
  }
}
function ThemeProvider({ children }) {
  const [state, dispatch] = useReducer(themeReducer, { theme: PRODUCT_CLASS.RETAIL });
  const { view: { productClass } } = useView();
  useEffect(() => {
    setTheme(productClass, dispatch);
  }, [productClass]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext.Provider, { value: state, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeDispatchContext.Provider, { value: dispatch, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "theme-provider", children }) }) });
}
function applyTheme(name) {
  if (!name) {
    return;
  }
  const theme = THEMES[name];
  if (!theme) {
    return;
  }
  const themeRoot = document.getElementById("theme-provider");
  const themeVars = Object.values(THEME_VARS);
  themeVars.forEach((variableUpdate) => {
    const updatedVar = THEMES[name][variableUpdate];
    if (updatedVar) {
      themeRoot.style.setProperty(variableUpdate, updatedVar);
    }
  });
}
function setTheme(name, dispatch) {
  applyTheme(name);
  if (dispatch === void 0) {
    throw new Error("Error with theme dispatch");
  }
  return dispatch({ theme: name });
}
const TransactionsMenuBeaconLoader = () => {
  const ShimmerList = () => new Array(5).fill(
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "item-loading", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Shimmer$1,
      {
        x: 181,
        y: 16,
        variant: "darker"
      }
    ) })
  );
  return new Array(3).fill(
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      IIBeaconNavigationExpanded,
      {
        "split-columns": "false",
        className: "ii-transactions-menu-loader",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "header-loading", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Shimmer$1,
            {
              x: 181,
              y: 24,
              variant: "darker"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ShimmerList, {})
        ]
      }
    )
  );
};
const generateRetirementAdvisoryServiceLinks = () => {
  return [
    {
      text: "Add",
      subText: "using money from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/advisory/add", false)
    },
    {
      text: "Withdraw",
      subText: "and receive the proceeds",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/advisory/withdraw", false),
      modal: null
    },
    {
      text: "Automatic Transactions",
      subText: "from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/automatic", false)
    },
    {
      text: "Transfer Accounts",
      subText: "to your managed portfolio",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/advice/checkout/transfer/", false)
    }
  ];
};
const generateActivePlusPortfoliosLinks = () => {
  return [
    {
      text: "Add",
      subText: "using money from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/advisory/add", false)
    },
    {
      text: "Withdraw",
      subText: "and receive the proceeds",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/app/withdraw", false)
    },
    {
      text: "Automatic Transactions",
      subText: "from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/automatic", false)
    },
    {
      text: "Other Transactions",
      subText: "within your account",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/landing", false)
    }
  ];
};
const generateAdvisoryAccountsLinks = () => {
  return [
    {
      text: "Add",
      subText: "using money from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/advisory/add", false)
    },
    {
      text: "Withdraw",
      subText: "and receive the proceeds",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/app/withdraw", false)
    },
    {
      text: "Automatic Transactions",
      subText: "from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/automatic", false)
    },
    {
      text: "Other Transactions",
      subText: "within your account",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/landing", false)
    }
  ];
};
const generateMutualFundLinks = () => {
  return [
    {
      text: "Buy",
      subText: "using money from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/buy?productType=MutualFund", false)
    },
    {
      text: "Sell",
      subText: "and receive the proceeds",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/sell?productType=MutualFund", false)
    },
    {
      text: "Exchange",
      subText: "between mutual funds",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/exchange", false)
    },
    {
      text: "Automatic Transactions",
      subText: "in and out of your mutual funds",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/automatic", false)
    }
  ];
};
const generateCollegeSavingsLinks = () => {
  return [
    {
      text: "Contribute",
      subText: "using savings from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/college/contribute", false)
    },
    {
      text: "Distribute",
      subText: "for educational expenses",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/college/distribute", false)
    },
    {
      text: "Exchange",
      subText: "between portfolios",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/college/exchange", false)
    },
    {
      text: "Automatic Monthly Contributions",
      subText: "from your bank",
      link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/automatic", false)
    }
  ];
};
const generateAccountLinks = () => {
  return [
    {
      text: "Open",
      subText: "a new account",
      link: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/fund-research/account-finder", false)
    },
    {
      text: "Transfer",
      subText: "accounts to T.Rowe Price",
      link: trpEnvironmentAware("https://www.troweprice.com/personal-investing/account-finder/transfers.html", false)
    },
    {
      text: "Rollover",
      subText: "eligible 401(k) assets",
      link: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/nasu/mutual-fund/retirement/rollover", false)
    }
  ];
};
const BROKERAGE_LINKS = [
  {
    text: "Trade Stocks & ETFs",
    subText: "within your brokerage account",
    link: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/external-authorization?vendor=PERSHING&selectedAccountId=undefined&target=TRADING", true)
  },
  {
    text: "Trade Mutual Funds",
    subText: "within your brokerage account",
    link: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/external-authorization?vendor=PERSHING&selectedAccountId=undefined&target=MF_TRADING", true)
  },
  {
    text: "Trade Options",
    subText: "if your account is approved",
    link: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/external-authorization?vendor=PERSHING&selectedAccountId=undefined&target=OPT_TRADING", true)
  },
  {
    text: "Withdraw from Sweep Account",
    subText: "and receive the proceeds",
    link: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/sell?productType=MutualFund"),
    type: "SWEEP",
    customerWebViewEnabledLink: true
  }
];
const getSweepAccountIds = (accounts) => accounts.reduce((sweepAccounts, account) => {
  if (account.sweepAccount) {
    sweepAccounts.push(account.accountId);
  }
  return sweepAccounts;
}, []);
const brokerageLinkDestination = (linkInfo, accounts, isCustomerWebView, customerWebViewEnabledLink = false) => {
  if (isCustomerWebView && !customerWebViewEnabledLink) {
    return null;
  }
  if (linkInfo.type && linkInfo.type === "SWEEP") {
    const sweepAccounts = getSweepAccountIds(accounts);
    const sweepAccountId = sweepAccounts.length ? `?selectedAgreementIDs=${sweepAccounts}` : "";
    return linkInfo.link + sweepAccountId;
  }
  return linkInfo.link;
};
const appendUberId = (uberId, link) => {
  return uberId ? link && link.indexOf("?") === -1 ? `${link}?uid=${uberId}` : `${link}&uid=${uberId}` : link;
};
const rasLinkDestination = (linkInfo) => {
  if (linkInfo.modal) {
    return linkInfo.modal;
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { href: linkInfo.link, children: linkInfo.text });
  }
};
const generateLinks = (view) => {
  const {
    hasRetirementAdvisory,
    hasActivePlus,
    hasMutualFunds,
    hasCollegeSavings,
    hasBrokerage: hasBrokerage2,
    productClass
  } = view;
  let obj = {};
  if (hasRetirementAdvisory || hasActivePlus) {
    if (hasRetirementAdvisory && !hasActivePlus) {
      obj["Retirement Advisory Service"] = generateRetirementAdvisoryServiceLinks();
    } else if (!hasRetirementAdvisory && hasActivePlus) {
      obj["ActivePlus Portfolios"] = generateActivePlusPortfoliosLinks();
    } else {
      obj["Advisory Accounts"] = generateAdvisoryAccountsLinks();
    }
  }
  if (hasMutualFunds) {
    obj["Mutual Funds"] = generateMutualFundLinks();
  }
  if (hasBrokerage2) {
    obj["Brokerage"] = BROKERAGE_LINKS;
  }
  if (hasCollegeSavings) {
    if (productClass === PRODUCT_CLASS.ALASKA_529) {
      obj["529 Plans"] = generateCollegeSavingsLinks();
    } else {
      obj["529 College Savings Plans"] = generateCollegeSavingsLinks();
    }
  }
  obj["Account"] = generateAccountLinks();
  return obj;
};
const LinkGroups = (props) => {
  const { isLoading } = props;
  const viewContext = useView();
  const { view } = viewContext;
  const customer = useContext(CustomerContext);
  const accounts = useContext(AccountsContext);
  const {
    customerWebViewEnabled
  } = view;
  const uberId = customerWebViewEnabled ? customer.uberId : "";
  const links = generateLinks(view);
  const getbrokerageLinkClassName = (customerWebViewEnabledLink) => {
    return classnames(
      {
        "disabled-nav-link": customerWebViewEnabled && !customerWebViewEnabledLink
      }
    );
  };
  if (isLoading) return /* @__PURE__ */ jsxRuntimeExports.jsx(TransactionsMenuBeaconLoader, {});
  return lodashExports.map(
    links,
    (label, key) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      IIBeaconNavigationExpanded,
      {
        "split-columns": "false",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { slot: "title", children: key }),
          lodashExports.map(
            links[key],
            (linkInfo, i5) => {
              const {
                link,
                subText,
                text: text2,
                customerWebViewEnabledLink
              } = linkInfo;
              return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
                key === "Brokerage" && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "a",
                  {
                    className: getbrokerageLinkClassName(customerWebViewEnabledLink),
                    href: brokerageLinkDestination(linkInfo, accounts, customerWebViewEnabled, customerWebViewEnabledLink),
                    target: "_self",
                    children: text2
                  }
                ),
                key === "ActivePlus Portfolios" && /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: appendUberId(uberId, link), children: text2 }),
                key === "Retirement Advisory Service" && rasLinkDestination(linkInfo),
                key !== "Brokerage" && key !== "ActivePlus Portfolios" && key !== "Retirement Advisory Service" && /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: link, children: text2 }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ii-additional-link-subtext ii-additional-link-spacing", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ii-additional-link-subtext", children: subText }) })
              ] }, `${i5}-${key}`);
            }
          )
        ]
      },
      key
    )
  );
};
const TransactionsMenu = (props) => {
  const { isLoading = false } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationExpanded, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { slot: "title", children: "Most Common Transactions" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        slot: "primary-link",
        href: trpEnvironmentAware("https://www.troweprice.com/usis/transactions/landing"),
        children: "View All Transactions"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(LinkGroups, { isLoading })
  ] });
};
const RelationshipManagerCard = ({ onCloseCard }) => {
  const { relationshipManager } = useContext(CustomerContext);
  const {
    person,
    location,
    phone,
    email
  } = relationshipManager;
  const { displayName } = person;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rm-card-beacon", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { slot: "title", children: displayName }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { slot: "description", children: location }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneIcon, { className: "rm-phone-icon" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Toll Free: " }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          className: "rm-contact-phone",
          href: `tel:+${phone}`,
          children: phone ? `${phone}` : "Not Available"
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { slot: "primary-link", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "a",
      {
        className: "rm-contact-email",
        href: `mailTo: ${email}`,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(MessageIcon, { className: "rm-email-icon" }),
          email ? email : "Not Available"
        ]
      }
    ) })
  ] }) });
};
RelationshipManagerCard.propTypes = {
  headshot: propTypesExports.string,
  person: propTypesExports.shape({
    displayName: propTypesExports.string
  }),
  location: propTypesExports.string,
  phone: propTypesExports.string,
  email: propTypesExports.string
};
const QuestionIconSmall = ({ className }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M6.60938 7.55928C6.60753 6.30471 7.57505 5.26178 8.82622 5.16964C10.0774 5.07749 11.1873 5.96743 11.3692 7.20873C11.5512 8.45002 10.7435 9.62107 9.51848 9.89191C9.2206 9.95068 9.00459 10.2101 9.00068 10.5137V11.2234",
          stroke: "white",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M9.00024 12.8203C9.08829 12.8203 9.15966 12.8917 9.15966 12.9797C9.15966 13.0678 9.08829 13.1392 9.00024 13.1392C8.9122 13.1392 8.84082 13.0678 8.84082 12.9797C8.84082 12.8917 8.9122 12.8203 9.00024 12.8203",
          stroke: "white",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.00033 16.3332C13.0504 16.3332 16.3337 13.0499 16.3337 8.99984C16.3337 4.94975 13.0504 1.6665 9.00033 1.6665C4.95024 1.6665 1.66699 4.94975 1.66699 8.99984C1.66699 13.0499 4.95024 16.3332 9.00033 16.3332Z",
          stroke: "white",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
const ProfileBeacon = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      slot: "icon",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 10.75C13.5188 10.75 14.75 9.51878 14.75 8C14.75 6.48122 13.5188 5.25 12 5.25C10.4812 5.25 9.25 6.48122 9.25 8C9.25 9.51878 10.4812 10.75 12 10.75ZM12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12ZM8 13.375C7.79816 13.375 7.60874 13.4725 7.49142 13.6367L4.99142 17.1367C4.79079 17.4176 4.85584 17.808 5.13673 18.0086C5.41761 18.2092 5.80795 18.1442 6.00858 17.8633L8.32164 14.625H15.6784L17.9914 17.8633C18.192 18.1442 18.5824 18.2092 18.8633 18.0086C19.1442 17.808 19.2092 17.4176 19.0086 17.1367L16.5086 13.6367C16.3913 13.4725 16.2018 13.375 16 13.375H8Z"
        }
      )
    }
  );
};
const MessageCenterBeacon = ({ className, RouterLink }) => {
  const viewContext = useView();
  const { view: { productClass, messageCount, active }, dispatch } = viewContext;
  const messageCenterUrl = trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/message-center", true);
  const label = "Messages";
  const containerClassName = classnames(
    "ii-nav-message-center-container-beacon",
    className
  );
  const badgeClassName = classnames(
    "badge",
    "b-typography-sans-serif--caption--100",
    {
      "hide-badge": messageCount <= 0
    },
    { [`${productClass}-badge`]: productClass === PRODUCT_CLASS.ALASKA_529 || productClass === PRODUCT_CLASS.MARYLAND_529 }
  );
  const linkClassName = classnames(
    "message-center-button-link",
    "b-typography-sans-serif--caption--100",
    {
      active: active === lodashExports.toLower(label)
    }
  );
  return RouterLink ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
    RouterLink,
    {
      className: `${containerClassName} ${linkClassName}`,
      "aria-label": "Message Center",
      active: active === lodashExports.toLower(label),
      to: getCurrentRoute(messageCenterUrl),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(MessageIconBeacon, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: badgeClassName, children: messageCount })
      ]
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "a",
    {
      className: `${containerClassName} ${linkClassName}`,
      href: messageCenterUrl,
      "aria-label": "Message Center",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(MessageIconBeacon, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: badgeClassName, children: messageCount })
      ]
    }
  );
};
const SupportCard = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "sp-card-beacon", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { slot: "title", className: "b-typography-sans-serif--body--200 b-font-weight-bold ", children: "Support" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { slot: "description", className: "b-typography-sans-serif--body--100 b-font-weight-light", children: "Call us at 1-800-922-9945 for help logging in." }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "b-typography-sans-serif--body--100 b-font-weight-light", children: "Mon-Fri 8am - 8pm ET" })
  ] });
};
const hasBrokerage = (accounts) => {
  if (!accounts || (accounts == null ? void 0 : accounts.length) <= 0) {
    return false;
  }
  return accounts.some((a2) => a2.productTypeId === 20 || a2.productType === 20);
};
const beaconResearchLinks = (accounts, isFixedIncomeEnabled) => {
  return {
    fundResearch: {
      label: "Explore Our Investments",
      links: {
        allMutualfunds: {
          label: "All Mutual Funds",
          url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/fund-research"),
          show: true
        },
        allETFs: {
          label: "All ETFs",
          url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/fund-research/etf"),
          show: true
        },
        historicalPerformance: {
          label: "Historical Performance",
          url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/fund-research/historical-performance"),
          show: true
        },
        dailyClosingPrices: {
          label: "Daily Closing Prices",
          url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/fund-research/daily-prices"),
          show: true
        },
        watchlist: {
          label: "Watchlist",
          url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/tools/fund-research/watchlist"),
          show: true
        }
      }
    },
    marketInsights: {
      label: "Market Insights & Tools",
      links: {
        analysisNews: {
          label: "Quotes & News",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/research/market-summary"),
          show: true,
          deepLink: "/research"
        },
        fixedIncomeResearch: {
          label: "Fixed Income Research",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/research/fixed-income"),
          show: isFixedIncomeEnabled && hasBrokerage(accounts),
          deepLink: "/research"
        },
        morningstarPortfolioManager: {
          label: "Morningstar Portfolio Manager",
          url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/resources/tools/morningstar-portfolio-manager.html"),
          show: true
        },
        retirementIncomeCalculator: {
          label: "Retirement Income Calculator",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/advice/tools/retirement-income-calculator", true),
          show: true
        },
        socialSecurityOptimizer: {
          label: "Social Security Optimizer",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/advice/tools/social-security-optimizer"),
          show: true
        },
        portfolioOptimizer: {
          label: "Portfolio Optimizer",
          url: trpEnvironmentAware("https://www.troweprice.com/usis/advice/port-alloc/"),
          show: canViewPortfolioOptimizerLink(accounts)
        }
      }
    },
    fromOurExperts: {
      label: "From Our Experts",
      links: {
        globalMarketWeeklyUpdate: {
          label: "Global Markets Weekly Update",
          url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/resources/insights/global-markets-weekly-update.html"),
          show: true
        },
        allInvestingInsights: {
          label: "All Investing Insights",
          url: trpEnvironmentAware("https://www.troweprice.com/personal-investing/resources/insights/index.html"),
          show: true
        }
      }
    }
  };
};
const handleKeyDown = (event, searchString, apiKey, sendSearchSignals) => {
  {
    if (event.key === "Enter") {
      window.location.assign(trpEnvironmentAware(`https://www.troweprice.com/personal-investing/search-results.html?q=${searchString}`));
    }
  }
};
const doSearch = (searchString, apiKey, sendSearchSignals) => {
  {
    window.location.assign(trpEnvironmentAware(`https://www.troweprice.com/personal-investing/search-results.html?q=${searchString}`));
  }
};
const isCurrentPage = (page) => {
  return window.location.pathname === page;
};
const customNavItem = (label, link, pageName = [], RouterLink) => RouterLink && isAccountAccess(link) && link.indexOf("/dashboard") === -1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
  RouterLink,
  {
    to: getCurrentRoute(link),
    "aria-current": pageName.some((currPage) => isCurrentPage(currPage)) ? "page" : true,
    children: label
  },
  `main-${label}`
) : /* @__PURE__ */ jsxRuntimeExports.jsx("a", { "aria-current": pageName.some((currPage) => isCurrentPage(currPage)) ? "page" : true, href: trpEnvironmentAware(link), className: "links", children: label });
const ToolBelt = ({
  accounts,
  isFixedIncomeEnabled,
  isLoading,
  adoptNewLoading,
  RouterLink
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationButton, { opens: "research", children: "Research" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationToolbelt, { "opens-by": "research", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationExpanded, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { slot: "title", children: "Research" }),
      Object.values(beaconResearchLinks(accounts, isFixedIncomeEnabled)).map((section, j3) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationExpanded, { "split-columns": "false", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { slot: "title", children: section.label }),
          Object.values(section.links).map(
            (linkObj, i5) => {
              return linkObj.show ? /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                LinkGenerator,
                {
                  className: "link-no-underline",
                  label: linkObj.label,
                  url: linkObj.url,
                  dispatch: () => {
                  },
                  active: false,
                  clickHandler: () => {
                  },
                  RouterLink,
                  nestedUrl: linkObj.deepLink ? linkObj.deepLink : "",
                  idx: i5
                },
                i5
              ) }, i5) : null;
            }
          )
        ] }, j3);
      })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationButton, { opens: "transactions", id: "transactions-dropdown-button", children: "Transactions" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationToolbelt, { "opens-by": "transactions", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TransactionsMenu,
      {
        slot: "nav-expanded",
        isLoading: isLoading && adoptNewLoading
      }
    ) })
  ] });
};
const ProfileMenu = ({ accounts, canViewCheckwriting, RouterLink }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationButton, { opens: "profile", "beacon-aria-label": "Profile", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ProfileBeacon, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationToolbelt, { "opens-by": "profile", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationExpanded, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { slot: "title", children: "Profile & Settings" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: trpEnvironmentAware("https://www.troweprice.com/usis/my-accounts/profile"), slot: "primary-link", children: "View Full Profile & Settings" }),
      Object.values(beaconProfileRetailLinks(accounts, canViewCheckwriting)).map((section, j3) => {
        return section.show ? /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationExpanded, { "split-columns": "false", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { slot: "title", children: section.label }),
          Object.values(section.links).map(
            (linkObj, i5) => {
              return linkObj.show ? /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                LinkGenerator,
                {
                  className: "link-no-underline",
                  label: linkObj.label,
                  url: linkObj.url,
                  dispatch: () => {
                  },
                  active: false,
                  clickHandler: () => {
                  },
                  RouterLink,
                  nestedUrl: linkObj.deepLink ? linkObj.deepLink : "",
                  idx: i5
                },
                i5
              ) }, i5) : null;
            }
          )
        ] }, j3) : null;
      })
    ] }) })
  ] });
};
const OptionalRelationshipManager = ({ user }) => (user == null ? void 0 : user.relationshipManager) ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationButton, { opens: "relationshipManager", slot: "local-zone", children: "Account Team" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationPopover, { "opens-by": "relationshipManager", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationExpanded, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(RelationshipManagerCard, { onCloseCard: () => {
  } }) }) })
] }) : null;
const SupportPopover = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationButton, { opens: "supportPopover", slot: "local-zone", children: "Support" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationPopover, { "opens-by": "supportPopover", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationExpanded, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SupportCard, {}) }) })
] });
const NavSearch = ({ searchString, updateSearchString, apiKey, sendSearchSignals }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationButton, { slot: "global-zone", "header-zone": "", opens: "search", "beacon-aria-label": "Search", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "svg",
      {
        width: "18",
        height: "16",
        viewBox: "0 0 18 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        slot: "icon",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.25 7C2.25 4.1005 4.6005 1.75 7.5 1.75C10.3995 1.75 12.75 4.1005 12.75\n             7C12.75 9.8995 10.3995 12.25 7.5 12.25C4.6005 12.25 2.25 9.8995\n             2.25 7ZM7.5 0.25C3.77208 0.25 0.75 3.27208 0.75 7C0.75 10.7279\n              3.77208 13.75 7.5 13.75C9.24288 13.75 10.8315 13.0894 12.0291\n              12.005C12.0369 12.0136 12.045 12.022 12.0533 12.0303L15.8033\n              15.7803C16.0962 16.0732 16.5711 16.0732 16.864 15.7803C17.1569\n              15.4874 17.1569 15.0125 16.864 14.7197L13.1139 10.9697C13.0838\n              10.9395 13.0517 10.9125 13.0181 10.8885C13.7941 9.7893 14.25\n              8.44789 14.25 7C14.25 3.27208 11.2279 0.25 7.5 0.25Z"
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationToolbelt, { slot: "global-zone", "opens-by": "search", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationExpanded, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "expanded__search searchLabel", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconControl, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { htmlFor: "search-input-field", slot: "label", children: "Search" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            name: "Search",
            id: "search-input-field",
            onKeyDown: (e5) => handleKeyDown(e5, searchString),
            onInput: (event) => {
              updateSearchString(event.target.value);
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        IIBeaconButton,
        {
          id: "search-button",
          onBeaconClick: () => doSearch(searchString),
          children: "Search"
        }
      )
    ] }) }) })
  ] });
};
const SecureNavigationBeacon = ({
  authentication = {},
  data = {
    apiKey: "",
    isLoading: false,
    showLoadingBar: false,
    adoptNewLoading: false,
    sendSearchSignals: false,
    loadingBarCustomData: {}
  },
  providedRouter,
  theme = "beacon-on-darker"
}) => {
  const [searchString, updateSearchString] = useState("");
  const {
    authorization: {
      isCustomerWebView,
      isAuthenticated
    },
    logoutUrl,
    loginUrl,
    user
  } = authentication;
  const {
    apiKey,
    accounts,
    canViewCheckwriting = false,
    version,
    isFixedIncomeEnabled = false,
    isLoading,
    showMainMenu = true,
    showPersonalInvesting = true,
    showRelationshipManager = true,
    showHelpMenu = true,
    showSupportPopover = false,
    showNavSearch = true,
    adoptNewLoading,
    showMyProfile = true,
    sendSearchSignals
  } = data;
  const {
    Link: RouterLink
  } = providedRouter || {};
  const {
    isRMDEligible,
    isRMDPreEligible
  } = user;
  const products = getProducts(accounts);
  const logoutPath = logoutUrl || trpEnvironmentAware(`https://www.troweprice.com/usis/login/logout?sdurl=https://www.troweprice.com/usis/my-accounts/post-logout?productTypes=${products}`);
  const loginPath = loginUrl || trpEnvironmentAware("https://www.troweprice.com/usis/login/?pdurl=/clx-tk/token-exchange/redirect/default?sdurl=https%3A%2F%2Fwwwstage.troweprice.com%2Fusis%2Fmy-accounts%2F");
  return isLoading && !adoptNewLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "shimmer beacon-skeleton" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    ViewProvider,
    {
      accounts,
      user,
      authentication,
      providedRouter,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(AuthenticationProvider, { authentication, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CustomerProvider, { customer: user, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AccountsProvider, { accounts, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          EnvironmentIndicator$1,
          {
            customerWebViewEnabled: isCustomerWebView,
            version
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${theme} secure-navigation-beacon`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigation, { "wordmark-href": "https://www.troweprice.com/personal-investing/index.html", id: "beacon-navigation", children: [
          showPersonalInvesting && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationButton, { opens: "site-selector", slot: "site-selector", children: "Personal Investing" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationPopover, { "opens-by": "site-selector", slot: "site-selector", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationExpanded, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { slot: "title", children: "Choose a site" }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationExpanded, { "split-columns": "false", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "/corporate/us/en/corporate.html", children: "Corporate" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://www.troweprice.com/personal-investing/index.html", "selected-site": "", children: "Personal Investing" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://www.troweprice.com/workplace/en/login.html", children: "Workplace Retirement" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "/financial-intermediary/us/en/home.html", children: "Financial Advisors/Intermediaries" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "/institutional/us/en/home.html", children: "Institutional Investors/Consultants" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://www.troweprice.com/retirement-plan-services/en/home.html", children: "Recordkeeping Sponsors/Consultants" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("a", { target: "_blank", href: "https://www.trowepricecharitable.org/", children: "Charitable" })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationExpanded, { "country-selector": "" })
            ] }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationToolbelt, { slot: "site-selector", "opens-by": "country-selector", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationExpanded, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { slot: "title", children: "Localization Settings" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationExpanded, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconCountrySelector, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { slot: "title", children: "Current Selection" }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconRegionSelector, { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { slot: "title", children: "Americas" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { slot: "item-count", children: "(1 item)" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconCountry, { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { slot: "title", children: "United States" }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "selected-language": "", lang: "en-US", children: "English" })
                  ] })
                ] })
              ] }) })
            ] }) })
          ] }),
          isAuthenticated && showRelationshipManager && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { slot: "local-zone", children: /* @__PURE__ */ jsxRuntimeExports.jsx(OptionalRelationshipManager, { user }) }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { slot: "global-zone", children: [
            isAuthenticated && showMainMenu && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(MessageCenterBeacon, { RouterLink }) }),
            showHelpMenu && /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationButton, { opens: "help", "beacon-aria-label": "Help", children: /* @__PURE__ */ jsxRuntimeExports.jsx(QuestionIconBeacon, { className: "help-image" }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconNavigationToolbelt, { "opens-by": "help", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationExpanded, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { slot: "title", children: "Help" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("a", { slot: "primary-link", href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/index.html"), children: "Help Center" }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationExpanded, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/forms.html"), children: "Forms" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/sitemap.html"), children: "Site Map" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/contact/index.html"), children: "Contact Us" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/technical-support.html"), children: "Technical Support" })
              ] })
            ] }) }),
            showSupportPopover && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { slot: "local-zone", className: "sp-card-container", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(QuestionIconSmall, { className: "help-image" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(SupportPopover, {})
            ] }) }),
            isAuthenticated && showMyProfile && /* @__PURE__ */ jsxRuntimeExports.jsx(
              ProfileMenu,
              {
                accounts,
                canViewCheckwriting,
                RouterLink
              }
            )
          ] }),
          showNavSearch && /* @__PURE__ */ jsxRuntimeExports.jsx(
            NavSearch,
            {
              apiKey,
              searchString,
              sendSearchSignals,
              updateSearchString
            }
          ),
          isAuthenticated ? RouterLink && isAccountAccess(logoutPath) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            RouterLink,
            {
              slot: "action-zone",
              className: "log-out-link",
              to: getCurrentRoute(logoutPath),
              children: "Log Out"
            },
            "log-out-link"
          ) : /* @__PURE__ */ jsxRuntimeExports.jsx("a", { slot: "action-zone", className: "log-out-link", href: logoutPath, children: "Log Out" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("a", { slot: "action-zone", className: "log-out-link", href: loginPath, children: "Log In" }),
          isAuthenticated && showMainMenu && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            customNavItem("Dashboard", "https://www.troweprice.com/usis/my-accounts/dashboard", ["/usis/my-accounts/dashboard", "/usis/my-accounts/", "/usis/my-accounts"], RouterLink),
            customNavItem("Accounts", "https://www.troweprice.com/usis/my-accounts/accounts", ["/usis/my-accounts/accounts", "/iframe.html"], RouterLink),
            customNavItem("Activity", "https://www.troweprice.com/usis/my-accounts/transactions", ["/usis/my-accounts/transactions"], RouterLink),
            customNavItem("Performance", "https://www.troweprice.com/usis/my-accounts/performance", ["/usis/my-accounts/performance"], RouterLink),
            customNavItem("Statements", "https://www.troweprice.com/usis/my-accounts/statements", ["/usis/my-accounts/statements"], RouterLink),
            customNavItem("Taxes", "https://www.troweprice.com/usis/my-accounts/taxes", ["/usis/my-accounts/taxes", RouterLink]),
            isRMDEligible || isRMDPreEligible ? /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: customNavItem("RMD", "https://www.troweprice.com/usis/rmd-tool", ["/usis/rmd-tool"]) }) : null,
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              ToolBelt,
              {
                accounts,
                isLoading,
                adoptNewLoading,
                isFixedIncomeEnabled,
                RouterLink
              }
            )
          ] })
        ] }) })
      ] }) }) }) })
    }
  );
};
SecureNavigationBeacon.propTypes = {
  data: propTypesExports.object
};
const SecureNavigationBeacon$1 = SecureNavigationBeacon;
const Toggle = ({ initial = false, children }) => {
  const [on2, setOn] = useState(initial);
  const toggleProps = {
    on: on2,
    toggle: () => setOn(!on2),
    setOn: () => setOn(true),
    setOff: () => setOn(false)
  };
  return children(toggleProps);
};
Toggle.propTypes = {
  on: PropTypes.bool
};
const ToggleRP = Toggle;
const Provider = {
  ThemeProvider,
  ViewProvider,
  AccountsProvider,
  AuthenticationProvider,
  CustomerProvider
};
const index = {
  ClickOffSensor: ClickOffSensor$1,
  Provider,
  ToggleRP,
  Products: PRODUCTS
};
const renewServerSession = async (url, apiKey, consumerId = "ii-component-library", method, requestBody) => {
  const options = {
    credentials: "include",
    method
  };
  options.headers = generateHeaders(url, apiKey, consumerId);
  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      return Promise.reject(response);
    }
    const data = await response.json();
    return Promise.resolve({ data });
  } catch (e5) {
    console.error(e5);
    return Promise.reject(e5);
  }
};
const SESSION_TIMEOUT = {
  IDLE_MINUTES_ALLOWED: 13,
  MINUTES_TO_RECOVER_ALLOWED: 2
};
const DEFAULT_ACTIVITY_EVENTS = [
  "click",
  "keydown",
  "DOMMouseScroll",
  "mousewheel",
  "mousedown",
  "touchstart",
  "touchmove",
  "focus"
];
const SessionTimeout = ({
  logoutURL,
  idleSessionTimeAllowed = SESSION_TIMEOUT.IDLE_MINUTES_ALLOWED,
  userSessionRecoveryTimeAllowed = SESSION_TIMEOUT.MINUTES_TO_RECOVER_ALLOWED,
  theme = "beacon-on-light",
  open = false,
  apiKey = "no-api-key-provided",
  keepAliveUrl = trpApiEnvironmentAware(URLS.IDENTITY),
  activityEvents = DEFAULT_ACTIVITY_EVENTS
}) => {
  let idleTimer = null;
  let recoveryTimer = null;
  const logoutPath = logoutURL || trpEnvironmentAware(URLS.LOGOUT);
  const idleTimeAllowed = convertToMillis(idleSessionTimeAllowed);
  const userRecoveryTimeAllowed = convertToMillis(userSessionRecoveryTimeAllowed);
  useEffect(() => {
    activityEvents.forEach((eventName) => window.addEventListener(eventName, acknowledgeUserActivity));
    startSession();
    return () => activityEvents.forEach((eventName) => window.removeEventListener(eventName, acknowledgeUserActivity));
  }, []);
  let idleExpiration = null;
  const handleOpen = () => {
    const modal = document.querySelector("#session-timeout-modal");
    if (modal !== null) {
      modal.show();
    }
  };
  const resetIdle = () => clearTimeout(idleTimer);
  const resetRecovery = () => clearTimeout(recoveryTimer);
  const setIdle = () => {
    idleExpiration = (/* @__PURE__ */ new Date()).getTime() + idleTimeAllowed;
    idleTimer = setTimeout(startUserSessionRecovery, idleTimeAllowed);
  };
  const setRecovery = () => {
    recoveryTimer = setTimeout(sessionHasTimedOut, userRecoveryTimeAllowed);
  };
  function startUserSessionRecovery() {
    if (recoveryTimer) {
      resetRecovery();
    }
    setRecovery();
    handleOpen();
  }
  function logOutuser() {
    window.location.href = logoutPath;
  }
  function sessionHasTimedOut() {
    logOutuser();
  }
  function acknowledgeUserActivity() {
    const currentTime = (/* @__PURE__ */ new Date()).getTime();
    if (currentTime > idleExpiration - 18e3) {
      renewSession();
    }
    resetIdle();
    setIdle();
  }
  function renewSession() {
    const apiCall = renewServerSession(trpApiEnvironmentAware(keepAliveUrl), apiKey, "ii-component-library", "GET");
    apiCall.then(() => {
      resetRecovery();
    }).catch(() => {
      console.log(`endpoint ${keepAliveUrl} could not be reached`);
    });
  }
  function startSession() {
    setIdle();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    IIBeaconModal,
    {
      scale: "jumbo",
      open,
      class: `${theme} ii-session-timeout`,
      id: "session-timeout-modal",
      "data-testid": "session-timeout-modal",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "title b-typography-serif--headline--200", children: "Session Timeout" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "body b-typography-sans-serif--body--200 b-padding-block--micro--mini", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "You’re being timed out due to inactivity. Please choose to stay signed in or to log out. Otherwise, you will be logged off automatically." }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            slot: "action-zone",
            className: "b-flex b-align-end action-zone-space",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                IIBeaconButton,
                {
                  onBeaconEventClick: () => logOutuser(),
                  disabled: false,
                  variant: "tertiary",
                  "data-testid": "session-timer-modal-log-out-button",
                  children: "Log Out"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                IIBeaconButton,
                {
                  onBeaconEventClick: () => {
                    const modal = document.getElementById("session-timeout-modal");
                    renewSession();
                    if (modal !== null) {
                      modal.close();
                    }
                  },
                  disabled: false,
                  variant: "primary",
                  "data-testid": "session-timer-modal-refresh-timer-button",
                  children: "Stay Logged In"
                }
              )
            ]
          }
        )
      ]
    }
  );
};
const SessionTimeout$1 = SessionTimeout;
const Stack = (Component2) => ({ ...props }) => {
  const [stack, updateStack] = useState([]);
  const push = (id) => {
    if (!id && !isStackEmpty && stack.some((x2) => x2 === id)) {
      throw new Error("Already Exists");
    }
    let newArray = stack.concat(id);
    updateStack(newArray);
  };
  const isStackEmpty = () => {
    return stack.length === 0;
  };
  const peek = () => {
    return stack[stack.length - 1];
  };
  const pop = () => {
    let newArray = lodashExports.clone(stack);
    newArray.pop();
    updateStack(newArray);
  };
  const emptyStack = () => {
    updateStack([]);
  };
  const stackactions = {
    pop,
    push,
    peek,
    isStackEmpty,
    emptyStack
  };
  const propsWithStack = {
    ...props,
    stack,
    stackactions
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, { ...propsWithStack });
};
const Stack$1 = Stack;
const SuccessIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { id: "Success", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        id: "icon",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.6081 9.43895C16.8506 9.10309 16.7748 8.6343 16.439 8.39187C16.1031 8.14944 15.6343 8.22519 15.3919 8.56105L10.8463 14.8586L8.52152 12.6092C8.22385 12.3211 7.74904 12.3289 7.46101 12.6266C7.17298 12.9243 7.1808 13.3991 7.47848 13.6871L10.4258 16.539C10.5823 16.6903 10.7967 16.7663 11.0135 16.7471C11.2303 16.7279 11.4281 16.6154 11.5555 16.439L16.6081 9.43895Z",
        fill: "#248647"
      }
    ) })
  }
);
const FailureIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.57654 10.9999C1.21928 11.6187 1.21928 12.3811 1.57654 12.9999L5.92184 20.5262C6.27911 21.145 6.93936 21.5262 7.65389 21.5262H16.3445C17.059 21.5262 17.7193 21.145 18.0765 20.5262L22.4218 12.9999C22.7791 12.3811 22.7791 11.6187 22.4218 10.9999L18.0765 3.47363C17.7193 2.85483 17.059 2.47363 16.3445 2.47363H7.65389C6.93936 2.47363 6.27911 2.85483 5.92184 3.47363L1.57654 10.9999ZM11.2492 7.74989C11.2492 7.33568 11.585 6.99989 11.9992 6.99989C12.4134 6.99989 12.7492 7.33568 12.7492 7.74989V12.2499C12.7492 12.6641 12.4134 12.9999 11.9992 12.9999C11.585 12.9999 11.2492 12.6641 11.2492 12.2499V7.74989ZM12.9992 15.9999C12.9992 16.5522 12.5515 16.9999 11.9992 16.9999C11.4469 16.9999 10.9992 16.5522 10.9992 15.9999C10.9992 15.4476 11.4469 14.9999 11.9992 14.9999C12.5515 14.9999 12.9992 15.4476 12.9992 15.9999Z",
        fill: "#DD3636"
      }
    )
  }
);
const WarningIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M10.0652 3C10.835 1.66667 12.7595 1.66667 13.5293 3L21.3235 16.5C22.0933 17.8333 21.131 19.5 19.5914 19.5H4.00298C2.46338 19.5 1.50113 17.8333 2.27093 16.5L10.0652 3Z",
          fill: "#FFC42D"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 7C11.5858 7 11.25 7.33579 11.25 7.75V12.25C11.25 12.6642 11.5858 13 12 13C12.4142 13 12.75 12.6642 12.75 12.25V7.75C12.75 7.33579 12.4142 7 12 7ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
          fill: "#061937"
        }
      )
    ]
  }
);
const InfoIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { id: "Information", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        id: "icon",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.75 16.25C12.75 16.6642 12.4142 17 12 17C11.5858 17 11.25 16.6642 11.25 16.25V11.75C11.25 11.3358 11.5858 11 12 11C12.4142 11 12.75 11.3358 12.75 11.75V16.25ZM11 8C11 7.44771 11.4477 7 12 7C12.5523 7 13 7.44771 13 8C13 8.55229 12.5523 9 12 9C11.4477 9 11 8.55229 11 8Z",
        fill: "#0063AD"
      }
    ) })
  }
);
const ToastBody = ({
  id,
  title,
  description,
  toastType,
  autoCloseDuration,
  handleDismiss,
  CTAText,
  handleCTAClick
}) => {
  const iconMap = {
    success: /* @__PURE__ */ jsxRuntimeExports.jsx(SuccessIcon, {}),
    failure: /* @__PURE__ */ jsxRuntimeExports.jsx(FailureIcon, {}),
    warning: /* @__PURE__ */ jsxRuntimeExports.jsx(WarningIcon, {}),
    info: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoIcon, {})
  };
  const toastIcon = iconMap[toastType] || null;
  if (!CTAText) {
    setTimeout(() => {
      handleDismiss(id);
    }, autoCloseDuration * 1e3);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `ii-toast toast-${toastType}`, role: "alert", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `toast-wrapper`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "toast-details", children: [
      toastIcon && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "toast-icon", children: toastIcon }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "toast-title b-typography-serif-headline--300 b-font-weight-bold", children: title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "toast-description b-typography-sans-serif--body--100", children: description }),
      CTAText && /* @__PURE__ */ jsxRuntimeExports.jsx(
        IIBeaconButton,
        {
          id: "toast-cta-button",
          variant: "secondary",
          scale: "mini",
          className: "toast-cta-button",
          onBeaconEventClick: handleCTAClick,
          "data-testid": "toast-cta-button",
          children: CTAText
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      IIBeaconIconButton,
      {
        variant: "tertiary",
        className: "toast-dismiss-button",
        "data-testid": "toast-dismiss-button",
        onBeaconEventClick: handleDismiss,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(CrossIcon, {})
      }
    )
  ] }) });
};
ToastBody.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  toastType: PropTypes.oneOf(["success", "failure", "warning", "info"]).isRequired,
  autoCloseDuration: PropTypes.number.isRequired,
  handleDismiss: PropTypes.func.isRequired,
  CTAText: PropTypes.string,
  handleCTAClick: PropTypes.func
};
const actions = {
  UPDATE_TOAST: "UPDATE_TOAST",
  DELETE_TOAST: "DELETE_TOAST"
};
function manageToastReducer(state, action) {
  if (action.type === actions.DELETE_TOAST) {
    return state.filter((toast) => toast.id !== action.id);
  }
  if (action.type === actions.UPDATE_TOAST) {
    return action.data;
  }
  throw Error("Unknown action.");
}
const Toast = ({
  data,
  position = "top-center",
  autoCloseDuration,
  handleDismiss,
  domNodeForPortal = document.body
}) => {
  const [toasts, dispatch] = useReducer(manageToastReducer, []);
  const removeToast = (id) => {
    dispatch({ type: actions.DELETE_TOAST, id });
  };
  useEffect(() => {
    dispatch({ type: actions.UPDATE_TOAST, data });
  }, [data]);
  return toasts.length > 0 && createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `ii-toast-list ${position}`, "aria-live": "assertive", children: toasts.map((toast) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      ToastBody,
      {
        id: toast.id,
        title: toast.title,
        description: toast.description,
        toastType: toast.type,
        autoCloseDuration,
        handleDismiss: () => {
          removeToast(toast.id);
          handleDismiss(toast.id);
        },
        CTAText: toast.CTAText,
        handleCTAClick: toast.handleCTAClick
      },
      toast.id
    )) }),
    domNodeForPortal
  );
};
Toast.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      type: PropTypes.oneOf(["success", "failure", "warning", "info"]).isRequired,
      CTAText: PropTypes.string,
      handleCTAClick: PropTypes.func
    })
  ),
  position: PropTypes.string,
  autoCloseDuration: PropTypes.number.isRequired,
  handleDismiss: PropTypes.func.isRequired,
  CTAText: PropTypes.string,
  handleCTAClick: PropTypes.func,
  domNodeForPortal: PropTypes.instanceOf(Element)
};
const Toast$1 = Toast;
function withRouter(WrappedComponent, providedRouter) {
  return class HocRouter extends Component {
    constructor(props) {
      super(props);
      this.state = {
        Router: providedRouter
      };
    }
    render() {
      return providedRouter ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        WrappedComponent,
        {
          Router: this.state.Router,
          Link: this.state.Router.Link,
          ...this.props
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(WrappedComponent, { ...this.props });
    }
  };
}
const FooterBeacon = ({
  productTypes,
  isLoading = false,
  isMobileParam = false,
  theme = "beacon-on-darker"
}) => {
  if (isLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Shimmer$1,
      {
        x: "100%",
        y: 200,
        shape: "rect"
      }
    ) });
  }
  if (!productTypes) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ProductFooter,
      {
        products: [],
        content: /* @__PURE__ */ jsxRuntimeExports.jsx(MutualFundContent, { products: [] }),
        isMobileParam
      }
    );
  }
  function getProducts2(productTypes2) {
    const products2 = [];
    Object.keys(productTypes2).forEach((productType) => {
      if (productTypes2[productType]) {
        const product = productType.replace(/has/, "");
        products2.push(product);
      }
    });
    return products2;
  }
  let content = null;
  let contentCopyright = null;
  const products = getProducts2(productTypes);
  const hasGeneral = products.some(
    (p2) => [
      PRODUCT_TYPE.ACTIVE_PLUS_PORTFOLIOS,
      PRODUCT_TYPE.BROKERAGE,
      PRODUCT_TYPE.MUTUAL_FUND,
      PRODUCT_TYPE.RAS
    ].indexOf(p2) >= 0
  ) || products.length > 1 && products.every((p2) => p2 === PRODUCT_TYPE.MD529 || p2 === PRODUCT_TYPE.AK529 || p2 === PRODUCT_TYPE.NAT529);
  if (!products || !products.length) {
    const contentMap = createProductContentMap([PRODUCT_TYPE.MUTUAL_FUND]);
    const contentMapCopyright = createProductCopyrightContentMap([PRODUCT_TYPE.MUTUAL_FUND]);
    content = contentMap[PRODUCT_TYPE.MUTUAL_FUND];
    contentCopyright = contentMapCopyright[PRODUCT_TYPE.MUTUAL_FUND];
  }
  const hasMD529Only = products.length > 0 && products.every((p2) => p2 === PRODUCT_TYPE.MD529);
  const hasAK529Only = products.length > 0 && products.every((p2) => p2 === PRODUCT_TYPE.AK529);
  const hasNat529Only = products.length > 0 && products.every((p2) => p2 === PRODUCT_TYPE.NAT529);
  const PRODUCT_LINKS = {};
  PRODUCT_LINKS[PRODUCT_TYPE.ACTIVE_PLUS_PORTFOLIOS] = {
    order: 1
  };
  PRODUCT_LINKS[PRODUCT_TYPE.RAS] = {
    order: 2
  };
  PRODUCT_LINKS[PRODUCT_TYPE.BROKERAGE] = {
    order: 3
  };
  PRODUCT_LINKS[PRODUCT_TYPE.MUTUAL_FUND] = {
    order: 4
  };
  PRODUCT_LINKS[PRODUCT_TYPE.NAT529] = {
    order: 5,
    contactUs: {
      id: "footer-nav-nat-contact-us",
      label: "Contact Us",
      href: "https://www.troweprice.com/personal-investing/troweprice-529/contact-us.html"
    },
    privacyPolicy: {
      label: "T. Rowe Price College Savings Plan Privacy Policy",
      id: "footer-nav-nat529-privacy-policy-link",
      href: "https://www.troweprice.com/personal-investing/troweprice-529/privacy-policy.html"
    }
  };
  PRODUCT_LINKS[PRODUCT_TYPE.MD529] = {
    order: 6,
    contactUs: {
      id: "nav-md-contact-us",
      label: "Contact Us",
      href: "https://maryland529.com/About-Us/Contact-Us",
      target: "_blank"
    },
    privacyPolicy: {
      id: "nav-md-privacy-policy",
      label: "MD529 Privacy Policy",
      href: "https://maryland529.com/Privacy-Statement",
      target: "_blank"
    }
  };
  PRODUCT_LINKS[PRODUCT_TYPE.AK529] = {
    order: 7,
    contactUs: {
      id: "nav-ak-contact-us",
      label: "Contact Us",
      target: "_blank",
      href: "https://www.alaska529plan.com/about-us/contact-us.html"
    },
    privacyPolicy: {
      id: "nav-ak-privacy-policy",
      label: "Alaska 529 Privacy Policy",
      target: "_blank",
      href: "https://www.alaska529plan.com/privacy-statement.html"
    }
  };
  const NAV_MODEL = {
    socialLinks: [
      {
        label: "Facebook",
        id: "facebook-link",
        icon: "icon-fb",
        href: "https://www.facebook.com/troweprice"
      },
      {
        label: "Twitter",
        id: "twitter-link",
        icon: "icon-tw",
        href: "https://twitter.com/troweprice"
      },
      {
        label: "YouTube",
        id: "youtube-link",
        icon: "icon-yt",
        href: "https://www.youtube.com/trowepricegroup"
      },
      {
        label: "LinkedIn",
        id: "linkedin-link",
        icon: "icon-ln",
        href: "https://www.linkedin.com/company/157329?trk=tyah"
      }
    ],
    corpLinks: [
      {
        label: "Company Overview",
        id: "company-overview-link",
        href: trpEnvironmentAware("https://www.troweprice.com/corporate/en/what-we-do.html")
      },
      {
        label: "Careers",
        id: "careers-link",
        href: trpEnvironmentAware("https://www.troweprice.com/corporate/en/careers.html")
      },
      {
        label: "Newsroom",
        id: "newsroom-link",
        href: trpEnvironmentAware("https://www.troweprice.com/corporate/en/press.html")
      },
      {
        label: "Investor Relations",
        id: "investor-relations-link",
        href: "https://troweprice.gcs-web.com/"
      },
      {
        label: "Responsibility",
        id: "corporate-responsibility-link",
        href: trpEnvironmentAware("https://www.troweprice.com/corporate/en/what-sets-us-apart/corporate-responsibility.html")
      }
    ],
    legalLinks: [
      {
        label: "U.S. & Canada Privacy Notice",
        id: "generic-privacy-policy-link",
        href: !(hasNat529Only || hasMD529Only || hasAK529Only) ? trpEnvironmentAware("https://www.troweprice.com/enterprise/legal/us/en/privacy-notices.html") : trpEnvironmentAware("https://www.troweprice.com/privacy")
      },
      {
        label: "Terms of Use",
        id: "terms-of-use-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/terms-of-use.html")
      },
      {
        label: "Security Measures",
        id: "security-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/policies-and-security/security.html")
      },
      {
        label: "Legal Information",
        id: "legal-info-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/policies-and-security/legal-information.html")
      },
      {
        label: "Form CRS",
        id: "form-CRS-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/about/form-crs.html")
      },
      {
        label: "Accessibility Statement",
        id: "Accessibility-Statement-link",
        target: "_blank",
        href: trpEnvironmentAware("https://www.troweprice.com/en/us/accessibility")
      }
    ],
    personalInvestingLinks: [
      {
        label: "Site Map",
        id: "site-map-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/sitemap.html")
      },
      {
        label: "Mobile App",
        id: "mobile-solutions-link",
        href: trpEnvironmentAware("https://www.troweprice.com/corporate/en/mobile-solutions.html")
      },
      {
        label: "Contact Us",
        id: "generic-contact-us-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/contact-us.html")
      },
      {
        label: "Customer Agreement",
        id: "customer-agreement-link",
        href: trpEnvironmentAware("https://www.troweprice.com/personal-investing/help/policies-and-security/customer-agreement.html")
      },
      {
        label: "Glossary",
        id: "Glossary-link",
        target: "_blank",
        href: trpEnvironmentAware("https://www.troweprice.com/en/us/glossary")
      },
      {
        label: "Market Data Disclosure",
        id: "Market-Data-Disclosure-link",
        target: "_blank",
        href: trpEnvironmentAware("https://www.troweprice.com/en/us/market-data-disclosures")
      }
    ],
    feedback: {
      label: "[+] Feedback",
      id: "feedback-plus-link",
      link: ""
    },
    footerContent: "",
    otherPrivacyPolicies: []
  };
  function getFooterModel(products2) {
    const links = Object.assign({}, NAV_MODEL, PRODUCT_LINKS);
    const hasMD529 = products2.indexOf(PRODUCT_TYPE.MD529) >= 0;
    const hasAK529 = products2.indexOf(PRODUCT_TYPE.AK529) >= 0;
    const hasNAT529 = products2.indexOf(PRODUCT_TYPE.NAT529) >= 0;
    const trpContactUs = NAV_MODEL.legalLinks.find((l4) => l4.id === "generic-contact-us-link");
    if (hasNAT529) {
      if (PRODUCT_LINKS[PRODUCT_TYPE.NAT529].privacyPolicy) {
        links.otherPrivacyPolicies.push(
          PRODUCT_LINKS[PRODUCT_TYPE.NAT529].privacyPolicy
        );
      }
      links.contactUs = PRODUCT_LINKS[PRODUCT_TYPE.NAT529].contactUs || trpContactUs;
    }
    if (hasMD529) {
      if (PRODUCT_LINKS[PRODUCT_TYPE.MD529].privacyPolicy) {
        links.otherPrivacyPolicies.push(
          PRODUCT_LINKS[PRODUCT_TYPE.MD529].privacyPolicy
        );
      }
      links.contactUs = PRODUCT_LINKS[PRODUCT_TYPE.MD529].contactUs || trpContactUs;
    }
    if (hasAK529) {
      if (PRODUCT_LINKS[PRODUCT_TYPE.AK529].privacyPolicy) {
        links.otherPrivacyPolicies.push(
          PRODUCT_LINKS[PRODUCT_TYPE.AK529].privacyPolicy
        );
      }
      links.contactUs = PRODUCT_LINKS[PRODUCT_TYPE.AK529].contactUs || trpContactUs;
    }
    if (hasMD529 && (hasAK529 || hasNAT529) || hasAK529 && hasNAT529) {
      links.contactUs = trpContactUs;
    }
    return links;
  }
  function getProductContent(products2, footerModel2) {
    const productSpecs = products2.map(
      (product2) => Object.assign({ name: product2 }, footerModel2[product2])
    );
    const highestOrder = Math.min.apply(
      null,
      productSpecs.map((spec) => spec.order)
    );
    const product = productSpecs.find((spec) => spec.order === highestOrder);
    if (!product) {
      return "";
    }
    const productContentMap = createProductContentMap(products2);
    const content2 = productSpecs.length > 1 && highestOrder > 4 ? productContentMap["MIXED"] : productContentMap[product.name];
    return content2 ? content2 : "";
  }
  function getProductCopyrightContent(products2, footerModel2) {
    const productSpecs = products2.map(
      (product2) => Object.assign({ name: product2 }, footerModel2[product2])
    );
    const highestOrder = Math.min.apply(
      null,
      productSpecs.map((spec) => spec.order)
    );
    const product = productSpecs.find((spec) => spec.order === highestOrder);
    if (!product) {
      return "";
    }
    const productContentMap = createProductCopyrightContentMap(products2);
    const content2 = productSpecs.length > 1 && highestOrder > 4 ? productContentMap["MIXED"] : productContentMap[product.name];
    return content2 ? content2 : "";
  }
  const footerModel = getFooterModel(products || []);
  const { contactUs } = footerModel;
  const otherPrivacyPolicies = [...new Set(footerModel.otherPrivacyPolicies)];
  if (!hasGeneral) {
    otherPrivacyPolicies.label = "Privacy Policy";
  }
  const linkGroup1 = footerModel.corpLinks;
  const linkGroup2 = !hasGeneral ? contactUs ? [contactUs] : [] : footerModel.legalLinks.concat(otherPrivacyPolicies);
  const linkGroup3 = !hasGeneral ? [] : footerModel.personalInvestingLinks;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${theme}`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconFooter, { children: [
    hasGeneral ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { slot: "trademark", children: [
      "Invest With Confidence",
      /* @__PURE__ */ jsxRuntimeExports.jsx("sup", { children: "®" })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}),
    hasGeneral ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { slot: "mission", children: "We're driven by our purpose: To identify and actively invest in opportunities to help people thrive in an evolving world." }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationFooter, { slot: "links", children: [
      hasGeneral && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { slot: "title", children: "Company" }),
      linkGroup1 == null ? void 0 : linkGroup1.map(
        (link, i5) => {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: link.href,
              "data-id": link.id ? link.id : `${link.label}-${i5}`,
              title: link.label,
              target: link.target || "_self",
              children: link.label || ""
            },
            i5
          );
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationFooter, { slot: "links", children: [
      hasGeneral && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { slot: "title", children: "Privacy & Legal" }),
      linkGroup2 == null ? void 0 : linkGroup2.map(
        (link, i5) => {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: link.href,
              "data-id": link.id ? link.id : `${link.label}-${i5}`,
              title: link.label,
              target: link.target || "_self",
              children: link.label || ""
            },
            i5
          );
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconNavigationFooter, { slot: "links", children: [
      hasGeneral && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { slot: "title", children: "Personal Investing" }),
      linkGroup3 == null ? void 0 : linkGroup3.map(
        (link, i5) => {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: link.href,
              "data-id": link.id ? link.id : `${link.label}-${i5}`,
              title: link.label,
              target: link.target || "_self",
              children: link.label || ""
            },
            i5
          );
        }
      )
    ] }),
    hasGeneral ? /* @__PURE__ */ jsxRuntimeExports.jsxs(IIBeaconSocialLinkContainer, { slot: "socials", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { slot: "text", children: "Find us on:" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconSocialLink, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://www.facebook.com/troweprice", children: "Facebook" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconSocialLink, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://twitter.com/troweprice", children: "X" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconSocialLink, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://www.youtube.com/trowepricegroup", children: "YouTube" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconSocialLink, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://www.linkedin.com/company/157329?trk=tyah", children: "LinkedIn" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(IIBeaconSocialLink, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://www.instagram.com/t._rowe_price/", children: "Instagram" }) })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { slot: "disclaimer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "privacy-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "#", className: "ot-sdk-show-settings", children: "Do Not Sell or Share My Personal Information" }) }),
      content || getProductContent(products, footerModel)
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { slot: "copyright", children: contentCopyright || getProductCopyrightContent(products, footerModel) })
  ] }) });
};
const FooterBeacon$1 = FooterBeacon;
const UtilityCardWrapper = ({ children, className }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `utility-card-wrapper ${className ? className : ""}`, children });
};
const UtilityCardWrapper$1 = UtilityCardWrapper;
export {
  Accordion$1 as Accordion,
  AccountsProvider,
  AssetAllocation$1 as AssetAllocation,
  AuthenticationProvider,
  Banner$1 as Banner,
  BeaconModal$1 as BeaconModal,
  Branding$1 as Branding,
  Button$1 as Button,
  Card$1 as Card,
  ClickOffSensor$1 as ClickOffSensor,
  ClientOptIn$1 as ClientOptIn,
  ComponentMapper$1 as ComponentMapper,
  ContextualNavigation$1 as ContextualNavigation,
  CoreNavigation$1 as CoreNavigation,
  CustomerProvider,
  Dropdown$1 as Dropdown,
  DropdownModal$1 as DropdownModal,
  EnvironmentIndicator$1 as EnvironmentIndicator,
  FooterBeacon$1 as FooterBeacon,
  FooterContainer$1 as FooterContainer,
  GlobalSearch$1 as GlobalSearch,
  If$1 as If,
  Link$1 as Link,
  LinkList$1 as LinkList,
  LoadingBar$1 as LoadingBar,
  MainMenu$1 as MainMenu,
  MessageCenter$1 as MessageCenter,
  MobileMenu$1 as MobileMenu,
  MoreLinksDropdown$1 as MoreLinksDropdown,
  NotificationBanner$1 as NotificationBanner,
  OptIn$1 as OptIn,
  PortfolioAllocation$1 as PortfolioAllocation,
  PRODUCTS as Products,
  Profile$2 as Profile,
  RMDTile$1 as RMDTile,
  RasWithdrawModal$1 as RasWithdrawModal,
  RelationshipManager$1 as RelationshipManager,
  RelationshipManagerCard$2 as RelationshipManagerCard,
  SecureNavigationBeacon$1 as SecureNavigationBeacon,
  SessionTimeout$1 as SessionTimeout,
  index as Shared,
  Shimmer$1 as Shimmer,
  SimpleDropdown$1 as SimpleDropdown,
  Slider$1 as Slider,
  Stack$1 as Stack,
  ThemeProvider,
  Toast$1 as Toast,
  ToggleRP,
  Transactions$1 as Transactions,
  TransactionsMenu$2 as TransactionsMenu,
  Trusty$1 as Trusty,
  UtilityCard$1 as UtilityCard,
  UtilityCardWrapper$1 as UtilityCardWrapper,
  ViewProvider,
  canViewAccountRegistration,
  canViewAlertsAndNotifications,
  canViewAutomaticTransactions,
  canViewBanking,
  canViewBeneficiaries,
  canViewContactInformation,
  canViewCostBasis,
  canViewDivCap,
  canViewDocumentDelivery,
  canViewGrantViewAccess,
  canViewSubscriptions,
  canViewTrustedContacts,
  dispatchInteraction,
  dispatchOfferImpression,
  dispatchOverlayLoad,
  getCurrentRoute,
  getEntryPoint,
  getProducts,
  getRelativePath,
  getURL,
  urlComparator,
  useData,
  withRouter
};
